(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["bundle.js"] = factory();
	else
		root["bundle.js"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 6);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = newInterval;
var t0 = new Date,
    t1 = new Date;

function newInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = new Date(+date)), date;
  }

  interval.floor = interval;

  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function(date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function(start, stop, step) {
    var range = [];
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(new Date(+start)); while (offseti(start, step), floori(start), start < stop)
    return range;
  };

  interval.filter = function(test) {
    return newInterval(function(date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };

  if (count) {
    interval.count = function(start, end) {
      t0.setTime(+start), t1.setTime(+end);
      floori(t0), floori(t1);
      return Math.floor(count(t0, t1));
    };

    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? function(d) { return field(d) % step === 0; }
              : function(d) { return interval.count(0, d) % step === 0; });
    };
  }

  return interval;
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_bisect__ = __webpack_require__(30);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bisect", function() { return __WEBPACK_IMPORTED_MODULE_0__src_bisect__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bisectRight", function() { return __WEBPACK_IMPORTED_MODULE_0__src_bisect__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bisectLeft", function() { return __WEBPACK_IMPORTED_MODULE_0__src_bisect__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_ascending__ = __webpack_require__(5);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ascending", function() { return __WEBPACK_IMPORTED_MODULE_1__src_ascending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_bisector__ = __webpack_require__(31);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bisector", function() { return __WEBPACK_IMPORTED_MODULE_2__src_bisector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_cross__ = __webpack_require__(73);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cross", function() { return __WEBPACK_IMPORTED_MODULE_3__src_cross__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_descending__ = __webpack_require__(74);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "descending", function() { return __WEBPACK_IMPORTED_MODULE_4__src_descending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_deviation__ = __webpack_require__(32);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "deviation", function() { return __WEBPACK_IMPORTED_MODULE_5__src_deviation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_extent__ = __webpack_require__(33);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "extent", function() { return __WEBPACK_IMPORTED_MODULE_6__src_extent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_histogram__ = __webpack_require__(75);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "histogram", function() { return __WEBPACK_IMPORTED_MODULE_7__src_histogram__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_threshold_freedmanDiaconis__ = __webpack_require__(85);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "thresholdFreedmanDiaconis", function() { return __WEBPACK_IMPORTED_MODULE_8__src_threshold_freedmanDiaconis__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_threshold_scott__ = __webpack_require__(86);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "thresholdScott", function() { return __WEBPACK_IMPORTED_MODULE_9__src_threshold_scott__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_threshold_sturges__ = __webpack_require__(37);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "thresholdSturges", function() { return __WEBPACK_IMPORTED_MODULE_10__src_threshold_sturges__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_max__ = __webpack_require__(77);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "max", function() { return __WEBPACK_IMPORTED_MODULE_11__src_max__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_mean__ = __webpack_require__(78);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "mean", function() { return __WEBPACK_IMPORTED_MODULE_12__src_mean__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_median__ = __webpack_require__(79);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "median", function() { return __WEBPACK_IMPORTED_MODULE_13__src_median__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_merge__ = __webpack_require__(80);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "merge", function() { return __WEBPACK_IMPORTED_MODULE_14__src_merge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_min__ = __webpack_require__(34);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "min", function() { return __WEBPACK_IMPORTED_MODULE_15__src_min__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_pairs__ = __webpack_require__(35);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pairs", function() { return __WEBPACK_IMPORTED_MODULE_16__src_pairs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_permute__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "permute", function() { return __WEBPACK_IMPORTED_MODULE_17__src_permute__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_quantile__ = __webpack_require__(17);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "quantile", function() { return __WEBPACK_IMPORTED_MODULE_18__src_quantile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_range__ = __webpack_require__(36);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "range", function() { return __WEBPACK_IMPORTED_MODULE_19__src_range__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_scan__ = __webpack_require__(82);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scan", function() { return __WEBPACK_IMPORTED_MODULE_20__src_scan__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_shuffle__ = __webpack_require__(83);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "shuffle", function() { return __WEBPACK_IMPORTED_MODULE_21__src_shuffle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_sum__ = __webpack_require__(84);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "sum", function() { return __WEBPACK_IMPORTED_MODULE_22__src_sum__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_ticks__ = __webpack_require__(38);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ticks", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "tickIncrement", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "tickStep", function() { return __WEBPACK_IMPORTED_MODULE_23__src_ticks__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_transpose__ = __webpack_require__(39);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "transpose", function() { return __WEBPACK_IMPORTED_MODULE_24__src_transpose__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_variance__ = __webpack_require__(40);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "variance", function() { return __WEBPACK_IMPORTED_MODULE_25__src_variance__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_zip__ = __webpack_require__(87);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "zip", function() { return __WEBPACK_IMPORTED_MODULE_26__src_zip__["a"]; });





























/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return durationSecond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return durationMinute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return durationHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return durationDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return durationWeek; });
var durationSecond = 1e3;
var durationMinute = 6e4;
var durationHour = 36e5;
var durationDay = 864e5;
var durationWeek = 6048e5;


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_color__ = __webpack_require__(19);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__src_color__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_lab__ = __webpack_require__(94);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__src_lab__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_lab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_cubehelix__ = __webpack_require__(93);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_cubehelix__["a"]; });





/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
var array = Array.prototype;

var map = array.map;
var slice = array.slice;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
});


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.map = exports.p5Instance = undefined;

var _p = __webpack_require__(67);

var _p2 = _interopRequireDefault(_p);

var _mappa = __webpack_require__(65);

var _mappa2 = _interopRequireDefault(_mappa);

var _countryOptions = __webpack_require__(27);

var _private = __webpack_require__(66);

var _private2 = _interopRequireDefault(_private);

var _gui = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { controller } from './controller'; // Uncomment this for dat.gui interfce
/*
Visualize and listen to Trade data
c.valenzuela
https://github.com/cvalenzuela
cvalenzuelab.com
2017
*/
var options = {
  lat: 0,
  lng: 0,
  zoom: 1.5,
  renderWorldCopies: false,
  minZoom: 1,
  maxZoom: 5.5,
  maxBounds: [[-180, -75], [180, 85]],
  pitch: 2,
  //style: 'http://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png' // debug leaflet
  //style: 'mapbox://styles/cvalenzuela/cj463ywav008a2spldmk3n40c' // original black
  style: 'mapbox://styles/cvalenzuela/cj65qb6616hoj2rr822iwpwx5' // Terminal
  //style: 'mapbox://styles/cvalenzuela/cj5n001zq3wwp2smux7pdrpkq' // decimal
};
var mappa = new _mappa2.default('Mapboxgl', _private2.default);

var width = window.innerWidth;
var height = window.innerHeight;
var canvas = void 0,
    map = void 0;
var bearing = 0;
var moveMap = false;
var reachFullRotation = false;
var animateBtn = document.getElementById('animateMapButton');

// View/Hide the overlay
document.getElementById('start').addEventListener("click", function () {
  var overlays = document.getElementsByClassName('overlay');
  for (var i = 0; i < overlays.length; i++) {
    overlays[i].style.display = 'none';
  }
}, false);
document.getElementById('getinfo').addEventListener("click", function () {
  var overlays = document.getElementsByClassName('overlay');
  document.getElementById('start').innerHTML = 'Resume';
  for (var i = 0; i < overlays.length; i++) {
    overlays[i].style.display = 'block';
  }
}, false);

var sketch = function sketch(p) {

  p.setup = function () {
    canvas = p.createCanvas(width, height);
    exports.map = map = mappa.tileMap(options);
    map.overlay(canvas);
    p.noStroke();
    p.smooth();
  };

  p.draw = function () {
    p.clear();
    for (var country in _countryOptions.allCountries) {
      _countryOptions.allCountries[country].system.run(); // run as long as there are countries
      if (_countryOptions.allCountries[country].system.ended) {
        delete _countryOptions.allCountries[country]; // erase a country once it has ended
      }
    }
    if (moveMap) {
      bearing > 350 && (reachFullRotation = true);
      bearing < 3 && (reachFullRotation = false);
      reachFullRotation ? bearing -= 0.01 : bearing += 0.01;
      map.map.easeTo({
        bearing: bearing,
        zoom: 1.4
      });
    }
  };

  p.windowResized = function () {
    // p.resizeCanvas(p.windowWidth, p.windowHeight);
    // map.resizeMap(canvas);
  };
};

var animateMap = function animateMap() {
  moveMap = !moveMap;
  if (moveMap) {
    animateBtn.innerHTML = 'Stop Map Movement';
  } else {
    map.map.flyTo({
      bearing: 0,
      zoom: 2,
      speed: 0.6
    });
    animateBtn.innerHTML = 'Animate Map';
  }
};

var p5Instance = new _p2.default(sketch);
window.showCountriesBtn = _gui.showCountriesBtn;
window.showTradeBtn = _gui.showTradeBtn;
window.startCountry = _gui.startCountry;
window.clearAll = _gui.clearAll;
window.showHideUI = (0, _gui.showHideUI)();
window.showAboutMobile = (0, _gui.showAboutMobile)();
window.animateMap = animateMap;
exports.p5Instance = p5Instance;
exports.map = map;

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x === null ? NaN : +x;
});


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_value__ = __webpack_require__(23);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_value__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_array__ = __webpack_require__(48);
/* unused harmony reexport interpolateArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_basis__ = __webpack_require__(22);
/* unused harmony reexport interpolateBasis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_basisClosed__ = __webpack_require__(49);
/* unused harmony reexport interpolateBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_date__ = __webpack_require__(51);
/* unused harmony reexport interpolateDate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_number__ = __webpack_require__(14);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__src_number__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_object__ = __webpack_require__(52);
/* unused harmony reexport interpolateObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_round__ = __webpack_require__(109);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__src_round__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_string__ = __webpack_require__(54);
/* unused harmony reexport interpolateString */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_transform_index__ = __webpack_require__(111);
/* unused harmony reexport interpolateTransformCss */
/* unused harmony reexport interpolateTransformSvg */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_zoom__ = __webpack_require__(113);
/* unused harmony reexport interpolateZoom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_rgb__ = __webpack_require__(53);
/* unused harmony reexport interpolateRgb */
/* unused harmony reexport interpolateRgbBasis */
/* unused harmony reexport interpolateRgbBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_hsl__ = __webpack_require__(106);
/* unused harmony reexport interpolateHsl */
/* unused harmony reexport interpolateHslLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_lab__ = __webpack_require__(107);
/* unused harmony reexport interpolateLab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_hcl__ = __webpack_require__(105);
/* unused harmony reexport interpolateHcl */
/* unused harmony reexport interpolateHclLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__ = __webpack_require__(104);
/* unused harmony reexport interpolateCubehelix */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_quantize__ = __webpack_require__(108);
/* unused harmony reexport quantize */



















/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = hue;
/* harmony export (immutable) */ __webpack_exports__["c"] = gamma;
/* harmony export (immutable) */ __webpack_exports__["a"] = nogamma;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(50);


function linear(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(s) {
  return s.match(/.{6}/g).map(function(x) {
    return "#" + x;
  });
});


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = linearish;
/* harmony export (immutable) */ __webpack_exports__["a"] = linear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tickFormat__ = __webpack_require__(129);





function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["ticks"])(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__tickFormat__["a" /* default */])(domain(), count, specifier);
  };

  scale.nice = function(count) {
    if (count == null) count = 10;

    var d = domain(),
        i0 = 0,
        i1 = d.length - 1,
        start = d[i0],
        stop = d[i1],
        step;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }

    step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickIncrement"])(start, stop, count);

    if (step > 0) {
      start = Math.floor(start / step) * step;
      stop = Math.ceil(stop / step) * step;
      step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickIncrement"])(start, stop, count);
    } else if (step < 0) {
      start = Math.ceil(start * step) / step;
      stop = Math.floor(stop * step) / step;
      step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickIncrement"])(start, stop, count);
    }

    if (step > 0) {
      d[i0] = Math.floor(start / step) * step;
      d[i1] = Math.ceil(stop / step) * step;
      domain(d);
    } else if (step < 0) {
      d[i0] = Math.ceil(start * step) / step;
      d[i1] = Math.floor(stop * step) / step;
      domain(d);
    }

    return scale;
  };

  return scale;
}

function linear() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__continuous__["b" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["a" /* interpolateNumber */]);

  scale.copy = function() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__continuous__["c" /* copy */])(scale, linear());
  };

  return linearish(scale);
}


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIndexFromAllExportsSorted = exports.getIndexFromAllImportsSorted = exports.colorPallet = exports.showName = exports.scale = exports.removeDiv = exports.randomColor = undefined;

var _d3Scale = __webpack_require__(114);

var _d3Collection = __webpack_require__(41);

var _d3Array = __webpack_require__(1);

// Array of all valid imports 
var getIndexFromAllImportsSorted = function getIndexFromAllImportsSorted(value) {
  var importsdata = [115575, 135452, 206846, 240048, 254890, 256343, 258015, 273058, 315816, 354294, 359582, 363455, 373881, 433511, 643302, 698855, 703106, 719311, 733596, 775565, 887806, 903867, 922548, 943923, 1106003, 1182200, 1206554, 1285143, 1551276, 1612054, 1751044, 1753843, 2010815, 2042222, 2202892, 2332305, 2348912, 2365591, 2523604, 2527967, 2568900, 2944279, 3251496, 3335030, 3352942, 3456276, 3695405, 3822080, 4608654, 4672319, 4880172, 4890229, 5797234, 6262796, 6494658, 6537940, 6551772, 7592518, 7795819, 7816092, 9629220, 9924870, 10132272, 11325527, 11864893, 12263074, 12312120, 13053552, 13417763, 14371361, 15184408, 16270655, 16983771, 17513549, 17995214, 19055990, 19367722, 20463505, 21799634, 22946461, 23480356, 23672002, 24636851, 25360468, 29897750, 33682409, 38980044, 39411243, 46465799, 48679150, 71015377, 89967449, 95812509, 127876390, 131022454, 146750268, 159335700, 165120909, 178251019, 725643630];
  return importsdata.indexOf(value);
};

// Array of all valid Exports 
// Util functions

var getIndexFromAllExportsSorted = function getIndexFromAllExportsSorted(value) {
  var exportsdata = [21908, 24247, 62943, 67271, 144494, 152108, 187439, 241237, 280318, 313154, 399963, 432138, 514636, 528755, 543799, 559253, 588806, 677279, 691619, 693235, 714049, 731849, 910106, 912986, 928481, 983877, 1001378, 1109238, 1109451, 1242506, 1278309, 1295663, 1307448, 1341518, 1359558, 1422079, 1452236, 1495691, 1554773, 1572666, 1655957, 1716317, 1875314, 1880394, 1881384, 1955692, 2315102, 2586668, 3147813, 3257175, 3382898, 3707052, 3737086, 3934095, 4150242, 4750393, 5152639, 5361020, 5558230, 5709373, 6089012, 6442151, 6561714, 6631023, 6995289, 7008191, 7315501, 7510261, 8375042, 8622289, 8784352, 8925455, 9212639, 10479762, 10767888, 14513177, 15023573, 15052057, 15370257, 15479973, 16475968, 17688750, 18169111, 28291261, 30845810, 31560662, 31651161, 32786214, 34348901, 35435891, 35972517, 55677472, 66852995, 70470251, 104591912, 115658053, 117297187, 145144906, 185286390, 684312269];
  return exportsdata.indexOf(value);
};

// Random Color
var randomColor = function randomColor() {
  var color = [];
  for (var i = 0; i < 4; i++) {
    color.push(Math.floor(Math.random() * 255) + 0);
  }
  return color;
};

var colorPallet = function colorPallet() {
  var index = 0;
  var hexColors = ["#1F313F", "#1C515C", "#16736F", "#309577", "#62B773", "#A2D56A", "#EEEF63"];
  var rgbColors = [[99, 171, 207, 1], [60, 190, 205, 1], [47, 206, 191, 1], [82, 220, 169, 1], [131, 230, 142, 1], [183, 236, 116, 1], [238, 239, 99, 1]];
  return function () {
    index < rgbColors.length ? index++ : index = 1;
    return rgbColors[index - 1];
  };
};

// Remove all p tags
var removeDiv = function removeDiv() {
  var elements = document.getElementsByTagName("p");
  while (elements[0]) {
    elements[0].parentNode.removeChild(elements[0]);
  }
};

// Scale
var scale = (0, _d3Scale.scaleLinear)().domain([0, 319, 1489, 4425, 10647, 22530, 43175.5, 79201.5, 141410, 250945, 445064, 783802, 1388819, 2480681, 4575155, 8698149.75, 17303957, 37358074, 95410812, 353652138.8, 2249660890432]).range([2, 2.8284271247461903, 3.4641016151377544, 4, 4, 5.656854249492381, 6.928203230275509, 8, 8, 11.313708498984761, 13.856406460551018, 16, 16, 22.627416997969522, 27.712812921102035, 32, 32, 45.254833995939045, 55.42562584220407, 64]);

// Style elements
var showName = function showName(value, id, position, color, origin) {
  if (!document.getElementById(id)) {
    var el = document.createElement("p");
    el.id = id;
    el.innerHTML = value;
    el.style.left = position.x + 'px';
    el.style.top = position.y + 'px';
    el.style.zIndex = '20';
    if (origin) {
      el.style.background = 'rgb(' + color[0] + ',' + color[1] + ',' + color[2] + ')';
    } else {
      el.style.color = 'rgb(' + color[0] + ',' + color[1] + ',' + color[2] + ')';
    }
    origin ? el.className += 'origin' : el.className += 'partner';
    document.body.appendChild(el);
  }
  if (document.getElementById(id)) {
    var _el = document.getElementById(id);
    _el.style.left = position.x + 'px';
    _el.style.top = position.y + 'px';
    if (origin) {
      _el.style.background = 'rgb(' + color[0] + ',' + color[1] + ',' + color[2] + ')';
    } else {
      _el.style.color = 'rgb(' + color[0] + ',' + color[1] + ',' + color[2] + ')';
    }
  }
};

exports.randomColor = randomColor;
exports.removeDiv = removeDiv;
exports.scale = scale;
exports.showName = showName;
exports.colorPallet = colorPallet;
exports.getIndexFromAllImportsSorted = getIndexFromAllImportsSorted;
exports.getIndexFromAllExportsSorted = getIndexFromAllExportsSorted;

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(21);


/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(Math.abs(x)), x ? x[1] : NaN;
});


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return a + b * t;
  };
});


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = deinterpolateLinear;
/* harmony export (immutable) */ __webpack_exports__["c"] = copy;
/* harmony export (immutable) */ __webpack_exports__["a"] = continuous;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(56);






var unit = [0, 1];

function deinterpolateLinear(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(b);
}

function deinterpolateClamp(deinterpolate) {
  return function(a, b) {
    var d = deinterpolate(a = +a, b = +b);
    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
  };
}

function reinterpolateClamp(reinterpolate) {
  return function(a, b) {
    var r = reinterpolate(a = +a, b = +b);
    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
  };
}

function bimap(domain, range, deinterpolate, reinterpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range, deinterpolate, reinterpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = deinterpolate(domain[i], domain[i + 1]);
    r[i] = reinterpolate(range[i], range[i + 1]);
  }

  return function(x) {
    var i = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["bisect"])(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp());
}

// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
function continuous(deinterpolate, reinterpolate) {
  var domain = unit,
      range = unit,
      interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["b" /* interpolate */],
      clamp = false,
      piecewise,
      output,
      input;

  function rescale() {
    piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return (output || (output = piecewise(domain, range, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate)))(+x);
  }

  scale.invert = function(y) {
    return (input || (input = piecewise(range, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_2__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["c" /* interpolateRound */], rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, rescale()) : clamp;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };

  return rescale();
}


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTempo = exports.releaseLowMono = exports.setCurrentInstrument = exports.soundTypes = exports.playSound = undefined;

var _tone = __webpack_require__(63);

var Tone = _interopRequireWildcard(_tone);

var _index = __webpack_require__(6);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Sound from tone.js
// To change if sounds are played randomly or always the same sound, go to file Country.js

// TODO: select the LowMono only once in the loop

var mobile = __webpack_require__(62);
var StartAudioContext = __webpack_require__(149);

// Bmp
Tone.Transport.bpm.value = 108;
Tone.Transport.start();

var lowMonoIsTaken = false;

// Filter
// Docs: https://tonejs.github.io/docs/#Filter
var frequencyIncrease = 250; // This is the increment to frequency everytime a new country is added.
var filter = new Tone.Filter({
  type: "lowpass",
  frequency: 350,
  rolloff: -48,
  Q: 1,
  gain: 0
}).toMaster();

if (mobile()) {
  StartAudioContext(filter.context, '#playButton');
}

// Freeverb
// Docs: https://tonejs.github.io/docs/#Freeverb
var roomSizeIncrease = 0.1; // This is the increment to roomSize everytime a new country is added.
var dampeningIncrease = 250; // This is the increment to dampening everytime a new country is added.
var wetIncrease = 0.1; // This is the increment to wet everytime a new country is added.
// var freeverb = new Tone.Freeverb({
//   roomSize: 0.1,
//   dampening: 10,
//   wet: 0.2
// }).toMaster();

var instrumentOrder = 1;

// This will run everytime a new country is added
var setCurrentInstrument = function setCurrentInstrument(value) {
  // console.log(value);
  // let randomArray = ['HiMono', 'HiPoly', 'mono', 'newDrum', 'poly', 'LowMono']; 
  // return randomArray[Math.floor(Math.random()*6)]
  switch (value) {
    case 1:
      return 'HiMono';
    case 2:
      return 'HiPoly';
    case 3:
      return 'mono';
    case 4:
      return 'newDrum';
    case 5:
      return 'poly';
    case 6:
      return 'LowMono';
    default:
      return 'mono';
      break;
  }

  // if (reset) {
  //   instrumentOrder = 1;
  //   // filter.frequency.input.value = 350; // Increase for frequency in filter
  //   // freeverb.dampening.input.value = 10; // Increase for dampening in freeverb
  //   // freeverb.roomSize.input.value = 0.1;  // Increase for roomSize in freeverb
  // } else {
  //   // This is just for debug
  //   // console.log("===============")
  //   // console.log('filter frequency: ', filter.frequency.input.value);
  //   // console.log('freeverb room Size', freeverb.roomSize.input.value);
  //   // console.log('freeverb dampening', freeverb.dampening.input.value);

  //   // Increase the variables for filter or freeverb
  //   filter.frequency.input.value += frequencyIncrease; // Increase for frequency in filter

  //   // freeverb.dampening.input.value += dampeningIncrease; // Increase for dampening in freeverb
  //   // freeverb.roomSize.input.value > 0.8 ? roomSizeIncrease = 0 : roomSizeIncrease = 0.1; // Logic so roomSize doesn't go over 0.8
  //   // freeverb.roomSize.input.value += roomSizeIncrease;  // Increase for roomSize in freeverb

  //   // Each country gets a different sound based on the position it was clicked.
  // switch (instrumentOrder) {
  //   case 1:
  //     instrumentOrder++;
  //     return 'mono'
  //   case 2:
  //     instrumentOrder++;
  //     return 'poly'
  //   case 3:
  //     instrumentOrder++;
  //     return 'newDrum'
  //   case 4:
  //     instrumentOrder++;
  //     return 'HiMono'
  //   case 5:
  //     if (lowMonoIsTaken) {
  //       instrumentOrder = instrumentOrder + 2;
  //       return 'HiPoly'
  //     } else {
  //       instrumentOrder++;
  //       lowMonoIsTaken = true;
  //       return 'LowMono'
  //     }
  //   case 6:
  //     instrumentOrder++;
  //     return 'HiPoly'
  //   default:
  //     instrumentOrder = 2;
  //     return 'mono'
  //     break;
  // }
  // }
};

var releaseLowMono = function releaseLowMono() {
  lowMonoIsTaken = false;
};

// The mp3 files are loaded here.
var createSoundGroup = function createSoundGroup(size, group, volume) {
  var arr = [];

  // This loads all files in the folder /mp3. The name should match the pattern: Tradeflow_1mono_1.mp3
  for (var i = 1; i <= size; i++) {
    arr.push(new Tone.Player({
      "url": "./mp3/Tradeflow_" + group + "_" + i + ".mp3",
      "loop": false,
      "volume": volume || -4
    }).connect(filter)); // To take the filter or freeverb off, just remove the .connect(filter) or .connect(freeverb)
  }
  return arr;
};

// This actually loads all the files, no need to change anything here.
var soundTypes = {
  mono: {
    sounds: createSoundGroup(5, '1mono', -10),
    tempo: '6n',
    loop: '1n'
  },
  poly: {
    sounds: createSoundGroup(7, '2poly', -15),
    tempo: '2n',
    loop: '1n'
  },
  newDrum: {
    sounds: createSoundGroup(8, '3newDrum'),
    tempo: '4n',
    loop: '1n'
  },
  HiMono: {
    sounds: createSoundGroup(8, '4HiMono'),
    tempo: '3n',
    loop: '1n'
  },
  LowMono: {
    sounds: createSoundGroup(3, '5LowMono', -25),
    tempo: '1n',
    loop: '1n'
  },
  HiPoly: {
    sounds: createSoundGroup(7, '6HiPoly'),
    tempo: '5n',
    loop: '1n'
  }
};

var currentTempo = 1;

var getTempo = function getTempo() {
  switch (currentTempo) {
    case 1:
      currentTempo++;
      return 1;
    case 2:
      currentTempo++;
      return 2;
    case 3:
      currentTempo++;
      return 3;
    case 4:
      currentTempo++;
      return 4;
    case 5:
      currentTempo++;
      return 5;
    case 6:
      currentTempo = 1;
      return 6;
    default:
      currentTempo = 2;
      return 'mono';
      break;
  }
};

var playSound = function playSound(soundType) {
  soundType.start();
};

exports.playSound = playSound;
exports.soundTypes = soundTypes;
exports.setCurrentInstrument = setCurrentInstrument;
exports.releaseLowMono = releaseLowMono;
exports.getTempo = getTempo;

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(7);


/* harmony default export */ __webpack_exports__["a"] = (function(values, p, valueof) {
  if (valueof == null) valueof = __WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */];
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = +valueof(values[i0], i0, values),
      value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
});


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefix; });
var prefix = "$";

function Map() {}

Map.prototype = map.prototype = {
  constructor: Map,
  has: function(key) {
    return (prefix + key) in this;
  },
  get: function(key) {
    return this[prefix + key];
  },
  set: function(key, value) {
    this[prefix + key] = value;
    return this;
  },
  remove: function(key) {
    var property = prefix + key;
    return property in this && delete this[property];
  },
  clear: function() {
    for (var property in this) if (property[0] === prefix) delete this[property];
  },
  keys: function() {
    var keys = [];
    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
    return keys;
  },
  values: function() {
    var values = [];
    for (var property in this) if (property[0] === prefix) values.push(this[property]);
    return values;
  },
  entries: function() {
    var entries = [];
    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
    return entries;
  },
  size: function() {
    var size = 0;
    for (var property in this) if (property[0] === prefix) ++size;
    return size;
  },
  empty: function() {
    for (var property in this) if (property[0] === prefix) return false;
    return true;
  },
  each: function(f) {
    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
  }
};

function map(object, f) {
  var map = new Map;

  // Copy constructor.
  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });

  // Index array by numeric index or specified key function.
  else if (Array.isArray(object)) {
    var i = -1,
        n = object.length,
        o;

    if (f == null) while (++i < n) map.set(i, object[i]);
    else while (++i < n) map.set(f(o = object[i], i, object), o);
  }

  // Convert object to map.
  else if (object) for (var key in object) map.set(key, object[key]);

  return map;
}

/* harmony default export */ __webpack_exports__["a"] = (map);


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = Color;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return darker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return brighter; });
/* harmony export (immutable) */ __webpack_exports__["h"] = color;
/* harmony export (immutable) */ __webpack_exports__["b"] = rgbConvert;
/* harmony export (immutable) */ __webpack_exports__["g"] = rgb;
/* harmony export (immutable) */ __webpack_exports__["a"] = Rgb;
/* unused harmony export hslConvert */
/* harmony export (immutable) */ __webpack_exports__["f"] = hsl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(20);


function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex3 = /^#([0-9a-f]{3})$/,
    reHex6 = /^#([0-9a-f]{6})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Color, color, {
  displayable: function() {
    return this.rgb().displayable();
  },
  toString: function() {
    return this.rgb() + "";
  }
});

function color(format) {
  var m;
  format = (format + "").trim().toLowerCase();
  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format])
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Rgb, rgb, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (0 <= this.r && this.r <= 255)
        && (0 <= this.g && this.g <= 255)
        && (0 <= this.b && this.b <= 255)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  toString: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(")
        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hsl, hsl, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extend;
/* harmony default export */ __webpack_exports__["a"] = (function(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
});

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimal(1.23) returns ["123", 0].
/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
});


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = basis;
function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1, t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
      + (4 - 6 * t2 + 3 * t3) * v1
      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
      + t3 * v3) / 6;
}

/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  var n = values.length - 1;
  return function(t) {
    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rgb__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__date__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__object__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__string__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constant__ = __webpack_require__(50);









/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__constant__["a" /* default */])(b)
      : (t === "number" ? __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]
      : t === "string" ? ((c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* color */])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]) : __WEBPACK_IMPORTED_MODULE_6__string__["a" /* default */])
      : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* color */] ? __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]
      : b instanceof Date ? __WEBPACK_IMPORTED_MODULE_3__date__["a" /* default */]
      : Array.isArray(b) ? __WEBPACK_IMPORTED_MODULE_2__array__["a" /* default */]
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? __WEBPACK_IMPORTED_MODULE_5__object__["a" /* default */]
      : __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */])(a, b);
});


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return timeFormat; });
/* unused harmony export timeParse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return utcFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcParse; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__(61);


var locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;

defaultLocale({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale(definition) {
  locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* default */])(definition);
  timeFormat = locale.format;
  timeParse = locale.parse;
  utcFormat = locale.utcFormat;
  utcParse = locale.utcParse;
  return locale;
}


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_interval__ = __webpack_require__(0);
/* unused harmony reexport timeInterval */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_millisecond__ = __webpack_require__(135);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_1__src_millisecond__["a"]; });
/* unused harmony reexport timeMilliseconds */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__src_millisecond__["a"]; });
/* unused harmony reexport utcMilliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_second__ = __webpack_require__(138);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_2__src_second__["a"]; });
/* unused harmony reexport timeSeconds */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__src_second__["a"]; });
/* unused harmony reexport utcSeconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_minute__ = __webpack_require__(136);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_3__src_minute__["a"]; });
/* unused harmony reexport timeMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_hour__ = __webpack_require__(134);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_4__src_hour__["a"]; });
/* unused harmony reexport timeHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_day__ = __webpack_require__(133);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_5__src_day__["a"]; });
/* unused harmony reexport timeDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_week__ = __webpack_require__(145);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["a"]; });
/* unused harmony reexport timeWeeks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["a"]; });
/* unused harmony reexport timeSundays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_6__src_week__["b"]; });
/* unused harmony reexport timeMondays */
/* unused harmony reexport timeTuesday */
/* unused harmony reexport timeTuesdays */
/* unused harmony reexport timeWednesday */
/* unused harmony reexport timeWednesdays */
/* unused harmony reexport timeThursday */
/* unused harmony reexport timeThursdays */
/* unused harmony reexport timeFriday */
/* unused harmony reexport timeFridays */
/* unused harmony reexport timeSaturday */
/* unused harmony reexport timeSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_month__ = __webpack_require__(137);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_7__src_month__["a"]; });
/* unused harmony reexport timeMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_year__ = __webpack_require__(146);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_8__src_year__["a"]; });
/* unused harmony reexport timeYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_utcMinute__ = __webpack_require__(141);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_9__src_utcMinute__["a"]; });
/* unused harmony reexport utcMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_utcHour__ = __webpack_require__(140);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_10__src_utcHour__["a"]; });
/* unused harmony reexport utcHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_utcDay__ = __webpack_require__(139);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_11__src_utcDay__["a"]; });
/* unused harmony reexport utcDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__ = __webpack_require__(143);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["a"]; });
/* unused harmony reexport utcWeeks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["a"]; });
/* unused harmony reexport utcSundays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_12__src_utcWeek__["b"]; });
/* unused harmony reexport utcMondays */
/* unused harmony reexport utcTuesday */
/* unused harmony reexport utcTuesdays */
/* unused harmony reexport utcWednesday */
/* unused harmony reexport utcWednesdays */
/* unused harmony reexport utcThursday */
/* unused harmony reexport utcThursdays */
/* unused harmony reexport utcFriday */
/* unused harmony reexport utcFridays */
/* unused harmony reexport utcSaturday */
/* unused harmony reexport utcSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_utcMonth__ = __webpack_require__(142);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_13__src_utcMonth__["a"]; });
/* unused harmony reexport utcMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_utcYear__ = __webpack_require__(144);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_14__src_utcYear__["a"]; });
/* unused harmony reexport utcYears */































/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.countryOptions = exports.allCountries = undefined;

var _index = __webpack_require__(6);

var _Country = __webpack_require__(68);

var _utils = __webpack_require__(12);

var _sounds = __webpack_require__(16);

// All the countries are store in this object
// Hierarchy is: 1) allCountries contains an array of all the Country instances.
// 2) A Country instance has a Particle System. 3) A Particle System has an
// array of particles to display.

var allCountries = new Object();

// Object as middleware to control new Countries creation with the GUI
var countryOptions = {
  Country: null,
  CountryInstance: null,
  Elt: null,
  "Trade Type": null,
  CountryAndTrade: function CountryAndTrade() {
    return this.Country + this["Trade Type"];
  },
  Start: function Start() {
    if (!allCountries[this.CountryAndTrade()]) {
      this.CountryInstance = new _Country.Country([this.Country, this["Trade Type"], this.Elt]);
      allCountries[this.CountryAndTrade()] = this.CountryInstance;
    }
  },
  "Clear All": function ClearAll() {
    (0, _sounds.setCurrentInstrument)(true); // return to the first sound
    for (var country in allCountries) {
      allCountries[country].Stop();
    };
    (0, _utils.removeDiv)();
    exports.allCountries = allCountries = []; // Erase all countries
    _index.p5Instance.ellipse(1, 1, 1, 1); // bug? if not the screen freezes
  },
  UpdateColor: function UpdateColor(value) {
    if (allCountries[this.CountryAndTrade()]) {
      this.CountryInstance.Color = value; // All the next particles that will be created
      allCountries[this.CountryAndTrade()].particles.forEach(function (p) {
        p.color = value; // change the current ones
      });
    }
  },
  UpdateOpacity: function UpdateOpacity(value) {
    if (allCountries[this.CountryAndTrade()]) {
      this.CountryInstance = allCountries[this.CountryAndTrade()];
      this.CountryInstance.Opacity = value; // All the new particles that will be created
      allCountries[this.CountryAndTrade()].particles.forEach(function (p) {
        p.opacity = value; // change the current ones
      });
    }
  }
};

exports.allCountries = allCountries;
exports.countryOptions = countryOptions;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Timeline

var timeline = document.getElementById('timeline');
var importsTimeline = document.getElementById('importsTimeline');
var exportsTimeline = document.getElementById('exportsTimeline');

// Add a country to the timeline
var addCountryToTimeline = function addCountryToTimeline(country, tradeType, c) {
  var countryDiv = document.createElement('div');
  countryDiv.id = 'timeline' + country + tradeType;
  countryDiv.className = 'countryInTimeline';
  countryDiv.innerText = country;
  countryDiv.style.background = 'rgba(' + c[0] + ', ' + c[1] + ', ' + c[2] + ', ' + c[3] + ')';
  if (tradeType == 'exports') {
    exportsTimeline.appendChild(countryDiv);
  } else {
    importsTimeline.appendChild(countryDiv);
  }
};

// Remove a country from the timeline
var removeCountryFromTimeline = function removeCountryFromTimeline(country, tradeType) {
  var countryDiv = document.getElementById('timeline' + country + tradeType);
  if (tradeType == 'exports') {
    exportsTimeline.removeChild(countryDiv);
  } else {
    importsTimeline.removeChild(countryDiv);
  }
};

// Remove all countries from timelien
var removeAllCountriesFromTimeline = function removeAllCountriesFromTimeline() {
  var elements = document.getElementsByClassName('countryInTimeline');
  while (elements.length > 0) {
    elements[0].parentNode.removeChild(elements[0]);
  }
};

exports.addCountryToTimeline = addCountryToTimeline;
exports.removeCountryFromTimeline = removeCountryFromTimeline;
exports.removeAllCountriesFromTimeline = removeAllCountriesFromTimeline;

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
var array = Array.prototype;

var slice = array.slice;
var map = array.map;


/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bisectRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return bisectLeft; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisector__ = __webpack_require__(31);



var ascendingBisect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__bisector__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]);
var bisectRight = ascendingBisect.right;
var bisectLeft = ascendingBisect.left;
/* harmony default export */ __webpack_exports__["a"] = (bisectRight);


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(5);


/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  if (compare.length === 1) compare = ascendingComparator(compare);
  return {
    left: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) < 0) lo = mid + 1;
        else hi = mid;
      }
      return lo;
    },
    right: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) > 0) hi = mid;
        else lo = mid + 1;
      }
      return lo;
    }
  };
});

function ascendingComparator(f) {
  return function(d, x) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */])(f(d), x);
  };
}


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__variance__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = (function(array, f) {
  var v = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__variance__["a" /* default */])(array, f);
  return v ? Math.sqrt(v) : v;
});


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  return [min, max];
});


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  return min;
});


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = pair;
/* harmony default export */ __webpack_exports__["a"] = (function(array, f) {
  if (f == null) f = pair;
  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
  while (i < n) pairs[i] = f(p, p = array[++i]);
  return pairs;
});

function pair(a, b) {
  return [a, b];
}


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
});


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
});


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = tickIncrement;
/* harmony export (immutable) */ __webpack_exports__["c"] = tickStep;
var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, count) {
  var reverse = stop < start,
      i = -1,
      n,
      ticks,
      step;

  if (reverse) n = start, start = stop, stop = n;

  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    start = Math.ceil(start / step);
    stop = Math.floor(stop / step);
    ticks = new Array(n = Math.ceil(stop - start + 1));
    while (++i < n) ticks[i] = (start + i) * step;
  } else {
    start = Math.floor(start * step);
    stop = Math.ceil(stop * step);
    ticks = new Array(n = Math.ceil(start - stop + 1));
    while (++i < n) ticks[i] = (start - i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
});

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__min__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = (function(matrix) {
  if (!(n = matrix.length)) return [];
  for (var i = -1, m = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__min__["a" /* default */])(matrix, length), transpose = new Array(m); ++i < m;) {
    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
      row[j] = matrix[j][i];
    }
  }
  return transpose;
});

function length(d) {
  return d.length;
}


/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(7);


/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      m = 0,
      i = -1,
      mean = 0,
      value,
      delta,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  if (m > 1) return sum / (m - 1);
});


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_nest__ = __webpack_require__(90);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "nest", function() { return __WEBPACK_IMPORTED_MODULE_0__src_nest__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_set__ = __webpack_require__(91);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "set", function() { return __WEBPACK_IMPORTED_MODULE_1__src_set__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_map__ = __webpack_require__(18);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "map", function() { return __WEBPACK_IMPORTED_MODULE_2__src_map__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_keys__ = __webpack_require__(89);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "keys", function() { return __WEBPACK_IMPORTED_MODULE_3__src_keys__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_values__ = __webpack_require__(92);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "values", function() { return __WEBPACK_IMPORTED_MODULE_4__src_values__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_entries__ = __webpack_require__(88);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "entries", function() { return __WEBPACK_IMPORTED_MODULE_5__src_entries__["a"]; });








/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deg2rad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return rad2deg; });
var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__ = __webpack_require__(95);
/* unused harmony reexport formatDefaultLocale */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_locale__ = __webpack_require__(47);
/* unused harmony reexport formatLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_formatSpecifier__ = __webpack_require__(45);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_formatSpecifier__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_precisionFixed__ = __webpack_require__(101);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__src_precisionFixed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_precisionPrefix__ = __webpack_require__(102);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__src_precisionPrefix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_precisionRound__ = __webpack_require__(103);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__src_precisionRound__["a"]; });








/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefixExponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(21);


var prefixExponent;

/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, Math.max(0, p + i - 1))[0]; // less than 1y!
});


/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatSpecifier;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatTypes__ = __webpack_require__(46);


// [[fill]align][sign][symbol][0][width][,][.precision][type]
var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  return new FormatSpecifier(specifier);
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);

  var match,
      fill = match[1] || " ",
      align = match[2] || ">",
      sign = match[3] || "-",
      symbol = match[4] || "",
      zero = !!match[5],
      width = match[6] && +match[6],
      comma = !!match[7],
      precision = match[8] && +match[8].slice(1),
      type = match[9] || "";

  // The "n" type is an alias for ",g".
  if (type === "n") comma = true, type = "g";

  // Map invalid types to the default format.
  else if (!__WEBPACK_IMPORTED_MODULE_0__formatTypes__["a" /* default */][type]) type = "";

  // If zero fill is specified, padding goes after sign and before digits.
  if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

  this.fill = fill;
  this.align = align;
  this.sign = sign;
  this.symbol = symbol;
  this.zero = zero;
  this.width = width;
  this.comma = comma;
  this.precision = precision;
  this.type = type;
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width == null ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
      + this.type;
};


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDefault__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatRounded__ = __webpack_require__(99);




/* harmony default export */ __webpack_exports__["a"] = ({
  "": __WEBPACK_IMPORTED_MODULE_0__formatDefault__["a" /* default */],
  "%": function(x, p) { return (x * 100).toFixed(p); },
  "b": function(x) { return Math.round(x).toString(2); },
  "c": function(x) { return x + ""; },
  "d": function(x) { return Math.round(x).toString(10); },
  "e": function(x, p) { return x.toExponential(p); },
  "f": function(x, p) { return x.toFixed(p); },
  "g": function(x, p) { return x.toPrecision(p); },
  "o": function(x) { return Math.round(x).toString(8); },
  "p": function(x, p) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__formatRounded__["a" /* default */])(x * 100, p); },
  "r": __WEBPACK_IMPORTED_MODULE_2__formatRounded__["a" /* default */],
  "s": __WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto__["a" /* default */],
  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
  "x": function(x) { return Math.round(x).toString(16); }
});


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatGroup__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatNumerals__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__formatSpecifier__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__formatTypes__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__formatPrefixAuto__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__identity__ = __webpack_require__(100);








var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];

/* harmony default export */ __webpack_exports__["a"] = (function(locale) {
  var group = locale.grouping && locale.thousands ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__formatGroup__["a" /* default */])(locale.grouping, locale.thousands) : __WEBPACK_IMPORTED_MODULE_6__identity__["a" /* default */],
      currency = locale.currency,
      decimal = locale.decimal,
      numerals = locale.numerals ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__formatNumerals__["a" /* default */])(locale.numerals) : __WEBPACK_IMPORTED_MODULE_6__identity__["a" /* default */],
      percent = locale.percent || "%";

  function newFormat(specifier) {
    specifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier__["a" /* default */])(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        type = specifier.type;

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = __WEBPACK_IMPORTED_MODULE_4__formatTypes__["a" /* default */][type],
        maybeSuffix = !type || /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision == null ? (type ? 6 : 12)
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Perform the initial formatting.
        var valueNegative = value < 0;
        value = formatType(Math.abs(value), precision);

        // If a negative value rounds to zero during formatting, treat as positive.
        if (valueNegative && +value === 0) valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = valueSuffix + (type === "s" ? prefixes[8 + __WEBPACK_IMPORTED_MODULE_5__formatPrefixAuto__["b" /* prefixExponent */] / 3] : "") + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier__["a" /* default */])(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
});


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(23);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(nb),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
});


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  var n = values.length;
  return function(t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__basis__["b" /* basis */])((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var d = new Date;
  return a = +a, b -= a, function(t) {
    return d.setTime(a + b * t), d;
  };
});


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(23);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
});


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export rgbBasis */
/* unused harmony export rgbBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basisClosed__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__color__ = __webpack_require__(9);





/* harmony default export */ __webpack_exports__["a"] = ((function rgbGamma(y) {
  var color = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__color__["c" /* gamma */])(y);

  function rgb(start, end) {
    var r = color((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* rgb */])(start)).r, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* rgb */])(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1));

function rgbSpline(spline) {
  return function(colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i, color;
    for (i = 0; i < n; ++i) {
      color = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* rgb */])(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function(t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}

var rgbBasis = rgbSpline(__WEBPACK_IMPORTED_MODULE_1__basis__["a" /* default */]);
var rgbBasisClosed = rgbSpline(__WEBPACK_IMPORTED_MODULE_2__basisClosed__["a" /* default */]);


/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(14);


var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
});


/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
});


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return +x;
});


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return implicit; });
/* harmony export (immutable) */ __webpack_exports__["a"] = ordinal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_collection__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(4);



var implicit = {name: "implicit"};

function ordinal(range) {
  var index = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["map"])(),
      domain = [],
      unknown = implicit;

  range = range == null ? [] : __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(range);

  function scale(d) {
    var key = d + "", i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["map"])();
    var i = -1, n = _.length, d, key;
    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return scale;
}


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = calendar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_time_format__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__array__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__continuous__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nice__ = __webpack_require__(55);








var durationSecond = 1000,
    durationMinute = durationSecond * 60,
    durationHour = durationMinute * 60,
    durationDay = durationHour * 24,
    durationWeek = durationDay * 7,
    durationMonth = durationDay * 30,
    durationYear = durationDay * 365;

function date(t) {
  return new Date(t);
}

function number(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__continuous__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__continuous__["b" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["a" /* interpolateNumber */]),
      invert = scale.invert,
      domain = scale.domain;

  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  var tickIntervals = [
    [second,  1,      durationSecond],
    [second,  5,  5 * durationSecond],
    [second, 15, 15 * durationSecond],
    [second, 30, 30 * durationSecond],
    [minute,  1,      durationMinute],
    [minute,  5,  5 * durationMinute],
    [minute, 15, 15 * durationMinute],
    [minute, 30, 30 * durationMinute],
    [  hour,  1,      durationHour  ],
    [  hour,  3,  3 * durationHour  ],
    [  hour,  6,  6 * durationHour  ],
    [  hour, 12, 12 * durationHour  ],
    [   day,  1,      durationDay   ],
    [   day,  2,  2 * durationDay   ],
    [  week,  1,      durationWeek  ],
    [ month,  1,      durationMonth ],
    [ month,  3,  3 * durationMonth ],
    [  year,  1,      durationYear  ]
  ];

  function tickFormat(date) {
    return (second(date) < date ? formatMillisecond
        : minute(date) < date ? formatSecond
        : hour(date) < date ? formatMinute
        : day(date) < date ? formatHour
        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
        : year(date) < date ? formatMonth
        : formatYear)(date);
  }

  function tickInterval(interval, start, stop, step) {
    if (interval == null) interval = 10;

    // If a desired tick count is specified, pick a reasonable tick interval
    // based on the extent of the domain and a rough estimate of tick size.
    // Otherwise, assume interval is already a time interval and use it.
    if (typeof interval === "number") {
      var target = Math.abs(stop - start) / interval,
          i = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["bisector"])(function(i) { return i[2]; }).right(tickIntervals, target);
      if (i === tickIntervals.length) {
        step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickStep"])(start / durationYear, stop / durationYear, interval);
        interval = year;
      } else if (i) {
        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        step = i[1];
        interval = i[0];
      } else {
        step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickStep"])(start, stop, interval);
        interval = millisecond;
      }
    }

    return step == null ? interval : interval.every(step);
  }

  scale.invert = function(y) {
    return new Date(invert(y));
  };

  scale.domain = function(_) {
    return arguments.length ? domain(__WEBPACK_IMPORTED_MODULE_4__array__["a" /* map */].call(_, number)) : domain().map(date);
  };

  scale.ticks = function(interval, step) {
    var d = domain(),
        t0 = d[0],
        t1 = d[d.length - 1],
        r = t1 < t0,
        t;
    if (r) t = t0, t0 = t1, t1 = t;
    t = tickInterval(interval, t0, t1, step);
    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
    return r ? t.reverse() : t;
  };

  scale.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function(interval, step) {
    var d = domain();
    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
        ? domain(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__nice__["a" /* default */])(d, interval))
        : scale;
  };

  scale.copy = function() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__continuous__["c" /* copy */])(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
  };

  return scale;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return calendar(__WEBPACK_IMPORTED_MODULE_2_d3_time__["j" /* timeYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["o" /* timeMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["p" /* timeWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["i" /* timeDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["q" /* timeHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["r" /* timeMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["s" /* timeSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["t" /* timeMillisecond */], __WEBPACK_IMPORTED_MODULE_3_d3_time_format__["b" /* timeFormat */]).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
});


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__ = __webpack_require__(25);
/* unused harmony reexport timeFormatDefaultLocale */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["c"]; });
/* unused harmony reexport timeParse */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_defaultLocale__["a"]; });
/* unused harmony reexport utcParse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_locale__ = __webpack_require__(61);
/* unused harmony reexport timeFormatLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_isoFormat__ = __webpack_require__(60);
/* unused harmony reexport isoFormat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_isoParse__ = __webpack_require__(132);
/* unused harmony reexport isoParse */






/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isoSpecifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultLocale__ = __webpack_require__(25);


var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";

function formatIsoNative(date) {
  return date.toISOString();
}

var formatIso = Date.prototype.toISOString
    ? formatIsoNative
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__defaultLocale__["a" /* utcFormat */])(isoSpecifier);

/* unused harmony default export */ var _unused_webpack_default_export = (formatIso);


/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_time__ = __webpack_require__(26);


function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newYear(y) {
  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "S": formatSeconds,
    "U": formatWeekNumberSunday,
    "w": formatWeekdayNumber,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "S": formatUTCSeconds,
    "U": formatUTCWeekNumberSunday,
    "w": formatUTCWeekdayNumber,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "S": parseSeconds,
    "U": parseWeekNumberSunday,
    "w": parseWeekdayNumber,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, newDate) {
    return function(string) {
      var d = newYear(1900),
          i = parseSpecifier(d, specifier, string += "", 0);
      if (i != string.length) return null;

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "W" in d ? 1 : 0;
        var day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return newDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", localDate);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier, utcDate);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads = {"-": "", "_": " ", "0": "0"},
    numberRe = /^\s*\d+/, // note: ignores next directive
    percentRe = /^%/,
    requoteRe = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;

function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  var map = {}, i = -1, n = names.length;
  while (++i < n) map[names[i].toLowerCase()] = i;
  return map;
}

function parseWeekdayNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?:\:?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* timeDay */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["j" /* timeYear */])(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}

function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}

function formatWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeSunday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["j" /* timeYear */])(d), d), p, 2);
}

function formatWeekdayNumber(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* timeMonday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["j" /* timeYear */])(d), d), p, 2);
}

function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad(z / 60 | 0, "0", 2)
      + pad(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["d" /* utcDay */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* utcYear */])(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["m" /* utcSunday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* utcYear */])(d), d), p, 2);
}

function formatUTCWeekdayNumber(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["n" /* utcMonday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* utcYear */])(d), d), p, 2);
}

function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}


/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports = isMobile;

function isMobile (ua) {
  if (!ua && typeof navigator != 'undefined') ua = navigator.userAgent;
  if (ua && ua.headers && typeof ua.headers['user-agent'] == 'string') {
    ua = ua.headers['user-agent'];
  }
  if (typeof ua != 'string') return false;

  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(ua) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(ua.substr(0,4));
}



/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory){

	//UMD
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return factory();
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module === "object") {
		module.exports = factory();
 	} else {
		root.Tone = factory();
	}

}(this, function(){

	"use strict";
	
	var Tone;
	//constructs the main Tone object
	function Main(func){
		Tone = func();
	}
	//invokes each of the modules with the main Tone object as the argument
	function Module(func){
		func(Tone);
	}	/**
	 *  Tone.js
	 *  @author Yotam Mann
	 *  @license http://opensource.org/licenses/MIT MIT License
	 *  @copyright 2014-2017 Yotam Mann
	 */
	Main(function () {
	    
	    ///////////////////////////////////////////////////////////////////////////
	    //	TONE
	    ///////////////////////////////////////////////////////////////////////////
	    /**
		 *  @class  Tone is the base class of all other classes. It provides 
		 *          a lot of methods and functionality to all classes that extend
		 *          it. 
		 *  
		 *  @constructor
		 *  @alias Tone
		 *  @param {number} [inputs=1] the number of input nodes
		 *  @param {number} [outputs=1] the number of output nodes
		 */
	    var Tone = function (inputs, outputs) {
	        /**
			 *  the input node(s)
			 *  @type {GainNode|Array}
			 */
	        if (this.isUndef(inputs) || inputs === 1) {
	            this.input = this.context.createGain();
	        } else if (inputs > 1) {
	            this.input = new Array(inputs);
	        }
	        /**
			 *  the output node(s)
			 *  @type {GainNode|Array}
			 */
	        if (this.isUndef(outputs) || outputs === 1) {
	            this.output = this.context.createGain();
	        } else if (outputs > 1) {
	            this.output = new Array(inputs);
	        }
	    };
	    /**
		 *  Set the parameters at once. Either pass in an
		 *  object mapping parameters to values, or to set a
		 *  single parameter, by passing in a string and value.
		 *  The last argument is an optional ramp time which 
		 *  will ramp any signal values to their destination value
		 *  over the duration of the rampTime.
		 *  @param {Object|string} params
		 *  @param {number=} value
		 *  @param {Time=} rampTime
		 *  @returns {Tone} this
		 *  @example
		 * //set values using an object
		 * filter.set({
		 * 	"frequency" : 300,
		 * 	"type" : highpass
		 * });
		 *  @example
		 * filter.set("type", "highpass");
		 *  @example
		 * //ramp to the value 220 over 3 seconds. 
		 * oscillator.set({
		 * 	"frequency" : 220
		 * }, 3);
		 */
	    Tone.prototype.set = function (params, value, rampTime) {
	        if (this.isObject(params)) {
	            rampTime = value;
	        } else if (this.isString(params)) {
	            var tmpObj = {};
	            tmpObj[params] = value;
	            params = tmpObj;
	        }
	        paramLoop:
	            for (var attr in params) {
	                value = params[attr];
	                var parent = this;
	                if (attr.indexOf('.') !== -1) {
	                    var attrSplit = attr.split('.');
	                    for (var i = 0; i < attrSplit.length - 1; i++) {
	                        parent = parent[attrSplit[i]];
	                        if (parent instanceof Tone) {
	                            attrSplit.splice(0, i + 1);
	                            var innerParam = attrSplit.join('.');
	                            parent.set(innerParam, value);
	                            continue paramLoop;
	                        }
	                    }
	                    attr = attrSplit[attrSplit.length - 1];
	                }
	                var param = parent[attr];
	                if (this.isUndef(param)) {
	                    continue;
	                }
	                if (Tone.Signal && param instanceof Tone.Signal || Tone.Param && param instanceof Tone.Param) {
	                    if (param.value !== value) {
	                        if (this.isUndef(rampTime)) {
	                            param.value = value;
	                        } else {
	                            param.rampTo(value, rampTime);
	                        }
	                    }
	                } else if (param instanceof AudioParam) {
	                    if (param.value !== value) {
	                        param.value = value;
	                    }
	                } else if (param instanceof Tone) {
	                    param.set(value);
	                } else if (param !== value) {
	                    parent[attr] = value;
	                }
	            }
	        return this;
	    };
	    /**
		 *  Get the object's attributes. Given no arguments get
		 *  will return all available object properties and their corresponding
		 *  values. Pass in a single attribute to retrieve or an array
		 *  of attributes. The attribute strings can also include a "."
		 *  to access deeper properties.
		 *  @example
		 * osc.get();
		 * //returns {"type" : "sine", "frequency" : 440, ...etc}
		 *  @example
		 * osc.get("type");
		 * //returns { "type" : "sine"}
		 * @example
		 * //use dot notation to access deep properties
		 * synth.get(["envelope.attack", "envelope.release"]);
		 * //returns {"envelope" : {"attack" : 0.2, "release" : 0.4}}
		 *  @param {Array=|string|undefined} params the parameters to get, otherwise will return 
		 *  					                  all available.
		 *  @returns {Object}
		 */
	    Tone.prototype.get = function (params) {
	        if (this.isUndef(params)) {
	            params = this._collectDefaults(this.constructor);
	        } else if (this.isString(params)) {
	            params = [params];
	        }
	        var ret = {};
	        for (var i = 0; i < params.length; i++) {
	            var attr = params[i];
	            var parent = this;
	            var subRet = ret;
	            if (attr.indexOf('.') !== -1) {
	                var attrSplit = attr.split('.');
	                for (var j = 0; j < attrSplit.length - 1; j++) {
	                    var subAttr = attrSplit[j];
	                    subRet[subAttr] = subRet[subAttr] || {};
	                    subRet = subRet[subAttr];
	                    parent = parent[subAttr];
	                }
	                attr = attrSplit[attrSplit.length - 1];
	            }
	            var param = parent[attr];
	            if (this.isObject(params[attr])) {
	                subRet[attr] = param.get();
	            } else if (Tone.Signal && param instanceof Tone.Signal) {
	                subRet[attr] = param.value;
	            } else if (Tone.Param && param instanceof Tone.Param) {
	                subRet[attr] = param.value;
	            } else if (param instanceof AudioParam) {
	                subRet[attr] = param.value;
	            } else if (param instanceof Tone) {
	                subRet[attr] = param.get();
	            } else if (!this.isFunction(param) && !this.isUndef(param)) {
	                subRet[attr] = param;
	            }
	        }
	        return ret;
	    };
	    /**
		 *  collect all of the default attributes in one
		 *  @private
		 *  @param {function} constr the constructor to find the defaults from
		 *  @return {Array} all of the attributes which belong to the class
		 */
	    Tone.prototype._collectDefaults = function (constr) {
	        var ret = [];
	        if (!this.isUndef(constr.defaults)) {
	            ret = Object.keys(constr.defaults);
	        }
	        if (!this.isUndef(constr._super)) {
	            var superDefs = this._collectDefaults(constr._super);
	            //filter out repeats
	            for (var i = 0; i < superDefs.length; i++) {
	                if (ret.indexOf(superDefs[i]) === -1) {
	                    ret.push(superDefs[i]);
	                }
	            }
	        }
	        return ret;
	    };
	    /**
		 *  @returns {string} returns the name of the class as a string
		 */
	    Tone.prototype.toString = function () {
	        for (var className in Tone) {
	            var isLetter = className[0].match(/^[A-Z]$/);
	            var sameConstructor = Tone[className] === this.constructor;
	            if (this.isFunction(Tone[className]) && isLetter && sameConstructor) {
	                return className;
	            }
	        }
	        return 'Tone';
	    };
	    ///////////////////////////////////////////////////////////////////////////
	    //	CLASS VARS
	    ///////////////////////////////////////////////////////////////////////////
	    /**
		 *  The number of inputs feeding into the AudioNode. 
		 *  For source nodes, this will be 0.
		 *  @memberOf Tone#
		 *  @name numberOfInputs
		 *  @readOnly
		 */
	    Object.defineProperty(Tone.prototype, 'numberOfInputs', {
	        get: function () {
	            if (this.input) {
	                if (this.isArray(this.input)) {
	                    return this.input.length;
	                } else {
	                    return 1;
	                }
	            } else {
	                return 0;
	            }
	        }
	    });
	    /**
		 *  The number of outputs coming out of the AudioNode. 
		 *  For source nodes, this will be 0.
		 *  @memberOf Tone#
		 *  @name numberOfInputs
		 *  @readOnly
		 */
	    Object.defineProperty(Tone.prototype, 'numberOfOutputs', {
	        get: function () {
	            if (this.output) {
	                if (this.isArray(this.output)) {
	                    return this.output.length;
	                } else {
	                    return 1;
	                }
	            } else {
	                return 0;
	            }
	        }
	    });
	    ///////////////////////////////////////////////////////////////////////////
	    //	CONNECTIONS
	    ///////////////////////////////////////////////////////////////////////////
	    /**
		 *  disconnect and dispose
		 *  @returns {Tone} this
		 */
	    Tone.prototype.dispose = function () {
	        if (!this.isUndef(this.input)) {
	            if (this.input instanceof AudioNode) {
	                this.input.disconnect();
	            }
	            this.input = null;
	        }
	        if (!this.isUndef(this.output)) {
	            if (this.output instanceof AudioNode) {
	                this.output.disconnect();
	            }
	            this.output = null;
	        }
	        return this;
	    };
	    /**
		 *  connect the output of a ToneNode to an AudioParam, AudioNode, or ToneNode
		 *  @param  {Tone | AudioParam | AudioNode} unit 
		 *  @param {number} [outputNum=0] optionally which output to connect from
		 *  @param {number} [inputNum=0] optionally which input to connect to
		 *  @returns {Tone} this
		 */
	    Tone.prototype.connect = function (unit, outputNum, inputNum) {
	        if (Array.isArray(this.output)) {
	            outputNum = this.defaultArg(outputNum, 0);
	            this.output[outputNum].connect(unit, 0, inputNum);
	        } else {
	            this.output.connect(unit, outputNum, inputNum);
	        }
	        return this;
	    };
	    /**
		 *  disconnect the output
		 *  @param {Number|AudioNode} output Either the output index to disconnect
		 *                                   if the output is an array, or the
		 *                                   node to disconnect from.
		 *  @returns {Tone} this
		 */
	    Tone.prototype.disconnect = function (destination, outputNum, inputNum) {
	        if (this.isArray(this.output)) {
	            if (this.isNumber(destination)) {
	                this.output[destination].disconnect();
	            } else {
	                outputNum = this.defaultArg(outputNum, 0);
	                this.output[outputNum].disconnect(destination, 0, inputNum);
	            }
	        } else {
	            this.output.disconnect.apply(this.output, arguments);
	        }
	    };
	    /**
		 *  connect together all of the arguments in series
		 *  @param {...AudioParam|Tone|AudioNode} nodes
		 *  @returns {Tone} this
		 */
	    Tone.prototype.connectSeries = function () {
	        if (arguments.length > 1) {
	            var currentUnit = arguments[0];
	            for (var i = 1; i < arguments.length; i++) {
	                var toUnit = arguments[i];
	                currentUnit.connect(toUnit);
	                currentUnit = toUnit;
	            }
	        }
	        return this;
	    };
	    /**
		 *  Connect the output of this node to the rest of the nodes in series.
		 *  @example
		 *  //connect a node to an effect, panVol and then to the master output
		 *  node.chain(effect, panVol, Tone.Master);
		 *  @param {...AudioParam|Tone|AudioNode} nodes
		 *  @returns {Tone} this
		 */
	    Tone.prototype.chain = function () {
	        if (arguments.length > 0) {
	            var currentUnit = this;
	            for (var i = 0; i < arguments.length; i++) {
	                var toUnit = arguments[i];
	                currentUnit.connect(toUnit);
	                currentUnit = toUnit;
	            }
	        }
	        return this;
	    };
	    /**
		 *  connect the output of this node to the rest of the nodes in parallel.
		 *  @param {...AudioParam|Tone|AudioNode} nodes
		 *  @returns {Tone} this
		 */
	    Tone.prototype.fan = function () {
	        if (arguments.length > 0) {
	            for (var i = 0; i < arguments.length; i++) {
	                this.connect(arguments[i]);
	            }
	        }
	        return this;
	    };
	    //give native nodes chain and fan methods
	    AudioNode.prototype.chain = Tone.prototype.chain;
	    AudioNode.prototype.fan = Tone.prototype.fan;
	    ///////////////////////////////////////////////////////////////////////////
	    //	UTILITIES / HELPERS / MATHS
	    ///////////////////////////////////////////////////////////////////////////
	    /**
		 *  If the `given` parameter is undefined, use the `fallback`. 
		 *  If both `given` and `fallback` are object literals, it will
		 *  return a deep copy which includes all of the parameters from both 
		 *  objects. If a parameter is undefined in given, it will return
		 *  the fallback property. 
		 *  <br><br>
		 *  WARNING: if object is self referential, it will go into an an 
		 *  infinite recursive loop.
		 *  
		 *  @param  {*} given    
		 *  @param  {*} fallback 
		 *  @return {*}          
		 */
	    Tone.prototype.defaultArg = function (given, fallback) {
	        if (this.isObject(given) && this.isObject(fallback)) {
	            var ret = {};
	            //make a deep copy of the given object
	            for (var givenProp in given) {
	                ret[givenProp] = this.defaultArg(fallback[givenProp], given[givenProp]);
	            }
	            for (var fallbackProp in fallback) {
	                ret[fallbackProp] = this.defaultArg(given[fallbackProp], fallback[fallbackProp]);
	            }
	            return ret;
	        } else {
	            return this.isUndef(given) ? fallback : given;
	        }
	    };
	    /**
		 *  returns the args as an options object with given arguments
		 *  mapped to the names provided. 
		 *
		 *  if the args given is an array containing only one object, it is assumed
		 *  that that's already the options object and will just return it. 
		 *  
		 *  @param  {Array} values  the 'arguments' object of the function
		 *  @param  {Array} keys the names of the arguments as they
		 *                                 should appear in the options object
		 *  @param {Object=} defaults optional defaults to mixin to the returned 
		 *                            options object                              
		 *  @return {Object}       the options object with the names mapped to the arguments
		 */
	    Tone.prototype.optionsObject = function (values, keys, defaults) {
	        var options = {};
	        if (values.length === 1 && this.isObject(values[0])) {
	            options = values[0];
	        } else {
	            for (var i = 0; i < keys.length; i++) {
	                options[keys[i]] = values[i];
	            }
	        }
	        if (!this.isUndef(defaults)) {
	            return this.defaultArg(options, defaults);
	        } else {
	            return options;
	        }
	    };
	    ///////////////////////////////////////////////////////////////////////////
	    // TYPE CHECKING
	    ///////////////////////////////////////////////////////////////////////////
	    /**
		 *  test if the arg is undefined
		 *  @param {*} arg the argument to test
		 *  @returns {boolean} true if the arg is undefined
		 *  @function
		 */
	    Tone.prototype.isUndef = function (val) {
	        return typeof val === 'undefined';
	    };
	    /**
		 *  test if the arg is a function
		 *  @param {*} arg the argument to test
		 *  @returns {boolean} true if the arg is a function
		 *  @function
		 */
	    Tone.prototype.isFunction = function (val) {
	        return typeof val === 'function';
	    };
	    /**
		 *  Test if the argument is a number.
		 *  @param {*} arg the argument to test
		 *  @returns {boolean} true if the arg is a number
		 */
	    Tone.prototype.isNumber = function (arg) {
	        return typeof arg === 'number';
	    };
	    /**
		 *  Test if the given argument is an object literal (i.e. `{}`);
		 *  @param {*} arg the argument to test
		 *  @returns {boolean} true if the arg is an object literal.
		 */
	    Tone.prototype.isObject = function (arg) {
	        return Object.prototype.toString.call(arg) === '[object Object]' && arg.constructor === Object;
	    };
	    /**
		 *  Test if the argument is a boolean.
		 *  @param {*} arg the argument to test
		 *  @returns {boolean} true if the arg is a boolean
		 */
	    Tone.prototype.isBoolean = function (arg) {
	        return typeof arg === 'boolean';
	    };
	    /**
		 *  Test if the argument is an Array
		 *  @param {*} arg the argument to test
		 *  @returns {boolean} true if the arg is an array
		 */
	    Tone.prototype.isArray = function (arg) {
	        return Array.isArray(arg);
	    };
	    /**
		 *  Test if the argument is a string.
		 *  @param {*} arg the argument to test
		 *  @returns {boolean} true if the arg is a string
		 */
	    Tone.prototype.isString = function (arg) {
	        return typeof arg === 'string';
	    };
	    /**
		 *  An empty function.
		 *  @static
		 */
	    Tone.noOp = function () {
	    };
	    /**
		 *  Make the property not writable. Internal use only. 
		 *  @private
		 *  @param  {string}  property  the property to make not writable
		 */
	    Tone.prototype._readOnly = function (property) {
	        if (Array.isArray(property)) {
	            for (var i = 0; i < property.length; i++) {
	                this._readOnly(property[i]);
	            }
	        } else {
	            Object.defineProperty(this, property, {
	                writable: false,
	                enumerable: true
	            });
	        }
	    };
	    /**
		 *  Make an attribute writeable. Interal use only. 
		 *  @private
		 *  @param  {string}  property  the property to make writable
		 */
	    Tone.prototype._writable = function (property) {
	        if (Array.isArray(property)) {
	            for (var i = 0; i < property.length; i++) {
	                this._writable(property[i]);
	            }
	        } else {
	            Object.defineProperty(this, property, { writable: true });
	        }
	    };
	    /**
		 * Possible play states. 
		 * @enum {string}
		 */
	    Tone.State = {
	        Started: 'started',
	        Stopped: 'stopped',
	        Paused: 'paused'
	    };
	    ///////////////////////////////////////////////////////////////////////////
	    // CONVERSIONS
	    ///////////////////////////////////////////////////////////////////////////
	    /**
		 *  Equal power gain scale. Good for cross-fading.
		 *  @param  {NormalRange} percent (0-1)
		 *  @return {Number}         output gain (0-1)
		 */
	    Tone.prototype.equalPowerScale = function (percent) {
	        var piFactor = 0.5 * Math.PI;
	        return Math.sin(percent * piFactor);
	    };
	    /**
		 *  Convert decibels into gain.
		 *  @param  {Decibels} db
		 *  @return {Number}   
		 */
	    Tone.prototype.dbToGain = function (db) {
	        return Math.pow(2, db / 6);
	    };
	    /**
		 *  Convert gain to decibels.
		 *  @param  {Number} gain (0-1)
		 *  @return {Decibels}   
		 */
	    Tone.prototype.gainToDb = function (gain) {
	        return 20 * (Math.log(gain) / Math.LN10);
	    };
	    /**
		 *  Convert an interval (in semitones) to a frequency ratio.
		 *  @param  {Interval} interval the number of semitones above the base note
		 *  @return {number}          the frequency ratio
		 *  @example
		 * tone.intervalToFrequencyRatio(0); // 1
		 * tone.intervalToFrequencyRatio(12); // 2
		 * tone.intervalToFrequencyRatio(-12); // 0.5
		 */
	    Tone.prototype.intervalToFrequencyRatio = function (interval) {
	        return Math.pow(2, interval / 12);
	    };
	    ///////////////////////////////////////////////////////////////////////////
	    //	TIMING
	    ///////////////////////////////////////////////////////////////////////////
	    /**
		 *  Return the current time of the AudioContext clock.
		 *  @return {Number} the currentTime from the AudioContext
		 */
	    Tone.prototype.now = function () {
	        return Tone.context.now();
	    };
	    /**
		 *  Return the current time of the AudioContext clock.
		 *  @return {Number} the currentTime from the AudioContext
		 *  @static
		 */
	    Tone.now = function () {
	        return Tone.context.now();
	    };
	    ///////////////////////////////////////////////////////////////////////////
	    //	INHERITANCE
	    ///////////////////////////////////////////////////////////////////////////
	    /**
		 *  have a child inherit all of Tone's (or a parent's) prototype
		 *  to inherit the parent's properties, make sure to call 
		 *  Parent.call(this) in the child's constructor
		 *
		 *  based on closure library's inherit function
		 *
		 *  @static
		 *  @param  {function} 	child  
		 *  @param  {function=} parent (optional) parent to inherit from
		 *                             if no parent is supplied, the child
		 *                             will inherit from Tone
		 */
	    Tone.extend = function (child, parent) {
	        if (Tone.prototype.isUndef(parent)) {
	            parent = Tone;
	        }
	        function TempConstructor() {
	        }
	        TempConstructor.prototype = parent.prototype;
	        child.prototype = new TempConstructor();
	        /** @override */
	        child.prototype.constructor = child;
	        child._super = parent;
	    };
	    ///////////////////////////////////////////////////////////////////////////
	    //	CONTEXT
	    ///////////////////////////////////////////////////////////////////////////
	    /**
		 *  The private audio context shared by all Tone Nodes. 
		 *  @private
		 *  @type {Tone.Context|undefined}
		 */
	    var audioContext;
	    /**
		 *  A static pointer to the audio context accessible as Tone.context. 
		 *  @type {Tone.Context}
		 *  @name context
		 *  @memberOf Tone
		 */
	    Object.defineProperty(Tone, 'context', {
	        get: function () {
	            return audioContext;
	        },
	        set: function (context) {
	            if (Tone.Context && context instanceof Tone.Context) {
	                audioContext = context;
	            } else {
	                audioContext = new Tone.Context(context);
	            }
	            //initialize the new audio context
	            if (Tone.Context) {
	                Tone.Context.emit('init', audioContext);
	            }
	        }
	    });
	    /**
		 *  The AudioContext
		 *  @type {Tone.Context}
		 *  @name context
		 *  @memberOf Tone#
		 *  @readOnly
		 */
	    Object.defineProperty(Tone.prototype, 'context', {
	        get: function () {
	            return Tone.context;
	        }
	    });
	    /**
		 *  Tone automatically creates a context on init, but if you are working
		 *  with other libraries which also create an AudioContext, it can be
		 *  useful to set your own. If you are going to set your own context, 
		 *  be sure to do it at the start of your code, before creating any objects.
		 *  @static
		 *  @param {AudioContext} ctx The new audio context to set
		 */
	    Tone.setContext = function (ctx) {
	        Tone.context = ctx;
	    };
	    /**
		 *  The number of seconds of 1 processing block (128 samples)
		 *  @type {Number}
		 *  @name blockTime
		 *  @memberOf Tone#
		 *  @readOnly
		 */
	    Object.defineProperty(Tone.prototype, 'blockTime', {
	        get: function () {
	            return 128 / this.context.sampleRate;
	        }
	    });
	    /**
		 *  The duration in seconds of one sample.
		 *  @type {Number}
		 *  @name sampleTime
		 *  @memberOf Tone#
		 *  @readOnly
		 */
	    Object.defineProperty(Tone.prototype, 'sampleTime', {
	        get: function () {
	            return 1 / this.context.sampleRate;
	        }
	    });
	    /**
		 *  Whether or not all the technologies that Tone.js relies on are supported by the current browser. 
		 *  @type {Boolean}
		 *  @name supported
		 *  @memberOf Tone
		 *  @readOnly
		 */
	    Object.defineProperty(Tone, 'supported', {
	        get: function () {
	            var hasAudioContext = window.hasOwnProperty('AudioContext') || window.hasOwnProperty('webkitAudioContext');
	            var hasPromises = window.hasOwnProperty('Promise');
	            var hasWorkers = window.hasOwnProperty('Worker');
	            return hasAudioContext && hasPromises && hasWorkers;
	        }
	    });
	    Tone.version = 'r10';
	    // allow optional silencing of this log
	    if (!window.TONE_SILENCE_VERSION_LOGGING) {
	        console.log('%c * Tone.js ' + Tone.version + ' * ', 'background: #000; color: #fff');
	    }
	    return Tone;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  Base class for all Signals. Used Internally. 
		 *
		 *  @constructor
		 *  @extends {Tone}
		 */
	    Tone.SignalBase = function () {
	    };
	    Tone.extend(Tone.SignalBase);
	    /**
		 *  When signals connect to other signals or AudioParams, 
		 *  they take over the output value of that signal or AudioParam. 
		 *  For all other nodes, the behavior is the same as a default <code>connect</code>. 
		 *
		 *  @override
		 *  @param {AudioParam|AudioNode|Tone.Signal|Tone} node 
		 *  @param {number} [outputNumber=0] The output number to connect from.
		 *  @param {number} [inputNumber=0] The input number to connect to.
		 *  @returns {Tone.SignalBase} this
		 */
	    Tone.SignalBase.prototype.connect = function (node, outputNumber, inputNumber) {
	        //zero it out so that the signal can have full control
	        if (Tone.Signal && Tone.Signal === node.constructor || Tone.Param && Tone.Param === node.constructor || Tone.TimelineSignal && Tone.TimelineSignal === node.constructor) {
	            //cancel changes
	            node._param.cancelScheduledValues(0);
	            //reset the value
	            node._param.value = 0;
	            //mark the value as overridden
	            node.overridden = true;
	        } else if (node instanceof AudioParam) {
	            node.cancelScheduledValues(0);
	            node.value = 0;
	        }
	        Tone.prototype.connect.call(this, node, outputNumber, inputNumber);
	        return this;
	    };
	    return Tone.SignalBase;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Wraps the native Web Audio API 
		 *         [WaveShaperNode](http://webaudio.github.io/web-audio-api/#the-waveshapernode-interface).
		 *
		 *  @extends {Tone.SignalBase}
		 *  @constructor
		 *  @param {function|Array|Number} mapping The function used to define the values. 
		 *                                    The mapping function should take two arguments: 
		 *                                    the first is the value at the current position 
		 *                                    and the second is the array position. 
		 *                                    If the argument is an array, that array will be
		 *                                    set as the wave shaping function. The input
		 *                                    signal is an AudioRange [-1, 1] value and the output
		 *                                    signal can take on any numerical values. 
		 *                                    
		 *  @param {Number} [bufferLen=1024] The length of the WaveShaperNode buffer.
		 *  @example
		 * var timesTwo = new Tone.WaveShaper(function(val){
		 * 	return val * 2;
		 * }, 2048);
		 *  @example
		 * //a waveshaper can also be constructed with an array of values
		 * var invert = new Tone.WaveShaper([1, -1]);
		 */
	    Tone.WaveShaper = function (mapping, bufferLen) {
	        /**
			 *  the waveshaper
			 *  @type {WaveShaperNode}
			 *  @private
			 */
	        this._shaper = this.input = this.output = this.context.createWaveShaper();
	        /**
			 *  the waveshapers curve
			 *  @type {Float32Array}
			 *  @private
			 */
	        this._curve = null;
	        if (Array.isArray(mapping)) {
	            this.curve = mapping;
	        } else if (isFinite(mapping) || this.isUndef(mapping)) {
	            this._curve = new Float32Array(this.defaultArg(mapping, 1024));
	        } else if (this.isFunction(mapping)) {
	            this._curve = new Float32Array(this.defaultArg(bufferLen, 1024));
	            this.setMap(mapping);
	        }
	    };
	    Tone.extend(Tone.WaveShaper, Tone.SignalBase);
	    /**
		 *  Uses a mapping function to set the value of the curve. 
		 *  @param {function} mapping The function used to define the values. 
		 *                            The mapping function take two arguments: 
		 *                            the first is the value at the current position 
		 *                            which goes from -1 to 1 over the number of elements
		 *                            in the curve array. The second argument is the array position. 
		 *  @returns {Tone.WaveShaper} this
		 *  @example
		 * //map the input signal from [-1, 1] to [0, 10]
		 * shaper.setMap(function(val, index){
		 * 	return (val + 1) * 5;
		 * })
		 */
	    Tone.WaveShaper.prototype.setMap = function (mapping) {
	        for (var i = 0, len = this._curve.length; i < len; i++) {
	            var normalized = i / (len - 1) * 2 - 1;
	            this._curve[i] = mapping(normalized, i);
	        }
	        this._shaper.curve = this._curve;
	        return this;
	    };
	    /**
		 * The array to set as the waveshaper curve. For linear curves
		 * array length does not make much difference, but for complex curves
		 * longer arrays will provide smoother interpolation. 
		 * @memberOf Tone.WaveShaper#
		 * @type {Array}
		 * @name curve
		 */
	    Object.defineProperty(Tone.WaveShaper.prototype, 'curve', {
	        get: function () {
	            return this._shaper.curve;
	        },
	        set: function (mapping) {
	            this._curve = new Float32Array(mapping);
	            this._shaper.curve = this._curve;
	        }
	    });
	    /**
		 * Specifies what type of oversampling (if any) should be used when 
		 * applying the shaping curve. Can either be "none", "2x" or "4x". 
		 * @memberOf Tone.WaveShaper#
		 * @type {string}
		 * @name oversample
		 */
	    Object.defineProperty(Tone.WaveShaper.prototype, 'oversample', {
	        get: function () {
	            return this._shaper.oversample;
	        },
	        set: function (oversampling) {
	            if ([
	                    'none',
	                    '2x',
	                    '4x'
	                ].indexOf(oversampling) !== -1) {
	                this._shaper.oversample = oversampling;
	            } else {
	                throw new RangeError('Tone.WaveShaper: oversampling must be either \'none\', \'2x\', or \'4x\'');
	            }
	        }
	    });
	    /**
		 *  Clean up.
		 *  @returns {Tone.WaveShaper} this
		 */
	    Tone.WaveShaper.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._shaper.disconnect();
	        this._shaper = null;
	        this._curve = null;
	        return this;
	    };
	    return Tone.WaveShaper;
	});
	Module(function (Tone) {
	    /**
		 *  @class Tone.TimeBase is a flexible encoding of time
		 *         which can be evaluated to and from a string.
		 *         Parsing code modified from https://code.google.com/p/tapdigit/
		 *         Copyright 2011 2012 Ariya Hidayat, New BSD License
		 *  @extends {Tone}
		 *  @param  {Time}  val    The time value as a number or string
		 *  @param  {String=}  units  Unit values
		 *  @example
		 * Tone.TimeBase(4, "n")
		 * Tone.TimeBase(2, "t")
		 * Tone.TimeBase("2t").add("1m")
		 * Tone.TimeBase("2t + 1m");
		 */
	    Tone.TimeBase = function (val, units) {
	        //allows it to be constructed with or without 'new'
	        if (this instanceof Tone.TimeBase) {
	            /**
				 *  Any expressions parsed from the Time
				 *  @type  {Array}
				 *  @private
				 */
	            this._expr = this._noOp;
	            if (val instanceof Tone.TimeBase) {
	                this.copy(val);
	            } else if (!this.isUndef(units) || this.isNumber(val)) {
	                //default units
	                units = this.defaultArg(units, this._defaultUnits);
	                var method = this._primaryExpressions[units].method;
	                this._expr = method.bind(this, val);
	            } else if (this.isString(val)) {
	                this.set(val);
	            } else if (this.isUndef(val)) {
	                //default expression
	                this._expr = this._defaultExpr();
	            }
	        } else {
	            return new Tone.TimeBase(val, units);
	        }
	    };
	    Tone.extend(Tone.TimeBase);
	    /**
		 *  Repalce the current time value with the value
		 *  given by the expression string.
		 *  @param  {String}  exprString
		 *  @return {Tone.TimeBase} this
		 */
	    Tone.TimeBase.prototype.set = function (exprString) {
	        this._expr = this._parseExprString(exprString);
	        return this;
	    };
	    /**
		 *  Return a clone of the TimeBase object.
		 *  @return  {Tone.TimeBase} The new cloned Tone.TimeBase
		 */
	    Tone.TimeBase.prototype.clone = function () {
	        var instance = new this.constructor();
	        instance.copy(this);
	        return instance;
	    };
	    /**
		 *  Copies the value of time to this Time
		 *  @param {Tone.TimeBase} time
		 *  @return  {TimeBase}
		 */
	    Tone.TimeBase.prototype.copy = function (time) {
	        var val = time._expr();
	        return this.set(val);
	    };
	    ///////////////////////////////////////////////////////////////////////////
	    //	ABSTRACT SYNTAX TREE PARSER
	    ///////////////////////////////////////////////////////////////////////////
	    /**
		 *  All the primary expressions.
		 *  @private
		 *  @type  {Object}
		 */
	    Tone.TimeBase.prototype._primaryExpressions = {
	        'n': {
	            regexp: /^(\d+)n/i,
	            method: function (value) {
	                value = parseInt(value);
	                if (value === 1) {
	                    return this._beatsToUnits(this._timeSignature());
	                } else {
	                    return this._beatsToUnits(4 / value);
	                }
	            }
	        },
	        't': {
	            regexp: /^(\d+)t/i,
	            method: function (value) {
	                value = parseInt(value);
	                return this._beatsToUnits(8 / (parseInt(value) * 3));
	            }
	        },
	        'm': {
	            regexp: /^(\d+)m/i,
	            method: function (value) {
	                return this._beatsToUnits(parseInt(value) * this._timeSignature());
	            }
	        },
	        'i': {
	            regexp: /^(\d+)i/i,
	            method: function (value) {
	                return this._ticksToUnits(parseInt(value));
	            }
	        },
	        'hz': {
	            regexp: /^(\d+(?:\.\d+)?)hz/i,
	            method: function (value) {
	                return this._frequencyToUnits(parseFloat(value));
	            }
	        },
	        'tr': {
	            regexp: /^(\d+(?:\.\d+)?):(\d+(?:\.\d+)?):?(\d+(?:\.\d+)?)?/,
	            method: function (m, q, s) {
	                var total = 0;
	                if (m && m !== '0') {
	                    total += this._beatsToUnits(this._timeSignature() * parseFloat(m));
	                }
	                if (q && q !== '0') {
	                    total += this._beatsToUnits(parseFloat(q));
	                }
	                if (s && s !== '0') {
	                    total += this._beatsToUnits(parseFloat(s) / 4);
	                }
	                return total;
	            }
	        },
	        's': {
	            regexp: /^(\d+(?:\.\d+)?s)/,
	            method: function (value) {
	                return this._secondsToUnits(parseFloat(value));
	            }
	        },
	        'samples': {
	            regexp: /^(\d+)samples/,
	            method: function (value) {
	                return parseInt(value) / this.context.sampleRate;
	            }
	        },
	        'default': {
	            regexp: /^(\d+(?:\.\d+)?)/,
	            method: function (value) {
	                return this._primaryExpressions[this._defaultUnits].method.call(this, value);
	            }
	        }
	    };
	    /**
		 *  All the binary expressions that TimeBase can accept.
		 *  @private
		 *  @type  {Object}
		 */
	    Tone.TimeBase.prototype._binaryExpressions = {
	        '+': {
	            regexp: /^\+/,
	            precedence: 2,
	            method: function (lh, rh) {
	                return lh() + rh();
	            }
	        },
	        '-': {
	            regexp: /^\-/,
	            precedence: 2,
	            method: function (lh, rh) {
	                return lh() - rh();
	            }
	        },
	        '*': {
	            regexp: /^\*/,
	            precedence: 1,
	            method: function (lh, rh) {
	                return lh() * rh();
	            }
	        },
	        '/': {
	            regexp: /^\//,
	            precedence: 1,
	            method: function (lh, rh) {
	                return lh() / rh();
	            }
	        }
	    };
	    /**
		 *  All the unary expressions.
		 *  @private
		 *  @type  {Object}
		 */
	    Tone.TimeBase.prototype._unaryExpressions = {
	        'neg': {
	            regexp: /^\-/,
	            method: function (lh) {
	                return -lh();
	            }
	        }
	    };
	    /**
		 *  Syntactic glue which holds expressions together
		 *  @private
		 *  @type  {Object}
		 */
	    Tone.TimeBase.prototype._syntaxGlue = {
	        '(': { regexp: /^\(/ },
	        ')': { regexp: /^\)/ }
	    };
	    /**
		 *  tokenize the expression based on the Expressions object
		 *  @param   {string} expr 
		 *  @return  {Object}      returns two methods on the tokenized list, next and peek
		 *  @private
		 */
	    Tone.TimeBase.prototype._tokenize = function (expr) {
	        var position = -1;
	        var tokens = [];
	        while (expr.length > 0) {
	            expr = expr.trim();
	            var token = getNextToken(expr, this);
	            tokens.push(token);
	            expr = expr.substr(token.value.length);
	        }
	        function getNextToken(expr, context) {
	            var expressions = [
	                '_binaryExpressions',
	                '_unaryExpressions',
	                '_primaryExpressions',
	                '_syntaxGlue'
	            ];
	            for (var i = 0; i < expressions.length; i++) {
	                var group = context[expressions[i]];
	                for (var opName in group) {
	                    var op = group[opName];
	                    var reg = op.regexp;
	                    var match = expr.match(reg);
	                    if (match !== null) {
	                        return {
	                            method: op.method,
	                            precedence: op.precedence,
	                            regexp: op.regexp,
	                            value: match[0]
	                        };
	                    }
	                }
	            }
	            throw new SyntaxError('Tone.TimeBase: Unexpected token ' + expr);
	        }
	        return {
	            next: function () {
	                return tokens[++position];
	            },
	            peek: function () {
	                return tokens[position + 1];
	            }
	        };
	    };
	    /**
		 *  Given a token, find the value within the groupName
		 *  @param {Object} token
		 *  @param {String} groupName
		 *  @param {Number} precedence
		 *  @private
		 */
	    Tone.TimeBase.prototype._matchGroup = function (token, group, prec) {
	        var ret = false;
	        if (!this.isUndef(token)) {
	            for (var opName in group) {
	                var op = group[opName];
	                if (op.regexp.test(token.value)) {
	                    if (!this.isUndef(prec)) {
	                        if (op.precedence === prec) {
	                            return op;
	                        }
	                    } else {
	                        return op;
	                    }
	                }
	            }
	        }
	        return ret;
	    };
	    /**
		 *  Match a binary expression given the token and the precedence
		 *  @param {Lexer} lexer
		 *  @param {Number} precedence
		 *  @private
		 */
	    Tone.TimeBase.prototype._parseBinary = function (lexer, precedence) {
	        if (this.isUndef(precedence)) {
	            precedence = 2;
	        }
	        var expr;
	        if (precedence < 0) {
	            expr = this._parseUnary(lexer);
	        } else {
	            expr = this._parseBinary(lexer, precedence - 1);
	        }
	        var token = lexer.peek();
	        while (token && this._matchGroup(token, this._binaryExpressions, precedence)) {
	            token = lexer.next();
	            expr = token.method.bind(this, expr, this._parseBinary(lexer, precedence - 1));
	            token = lexer.peek();
	        }
	        return expr;
	    };
	    /**
		 *  Match a unary expression.
		 *  @param {Lexer} lexer
		 *  @private
		 */
	    Tone.TimeBase.prototype._parseUnary = function (lexer) {
	        var token, expr;
	        token = lexer.peek();
	        var op = this._matchGroup(token, this._unaryExpressions);
	        if (op) {
	            token = lexer.next();
	            expr = this._parseUnary(lexer);
	            return op.method.bind(this, expr);
	        }
	        return this._parsePrimary(lexer);
	    };
	    /**
		 *  Match a primary expression (a value).
		 *  @param {Lexer} lexer
		 *  @private
		 */
	    Tone.TimeBase.prototype._parsePrimary = function (lexer) {
	        var token, expr;
	        token = lexer.peek();
	        if (this.isUndef(token)) {
	            throw new SyntaxError('Tone.TimeBase: Unexpected end of expression');
	        }
	        if (this._matchGroup(token, this._primaryExpressions)) {
	            token = lexer.next();
	            var matching = token.value.match(token.regexp);
	            return token.method.bind(this, matching[1], matching[2], matching[3]);
	        }
	        if (token && token.value === '(') {
	            lexer.next();
	            expr = this._parseBinary(lexer);
	            token = lexer.next();
	            if (!(token && token.value === ')')) {
	                throw new SyntaxError('Expected )');
	            }
	            return expr;
	        }
	        throw new SyntaxError('Tone.TimeBase: Cannot process token ' + token.value);
	    };
	    /**
		 *  Recursively parse the string expression into a syntax tree.
		 *  @param   {string} expr 
		 *  @return  {Function} the bound method to be evaluated later
		 *  @private
		 */
	    Tone.TimeBase.prototype._parseExprString = function (exprString) {
	        if (!this.isString(exprString)) {
	            exprString = exprString.toString();
	        }
	        var lexer = this._tokenize(exprString);
	        var tree = this._parseBinary(lexer);
	        return tree;
	    };
	    ///////////////////////////////////////////////////////////////////////////
	    //	DEFAULTS
	    ///////////////////////////////////////////////////////////////////////////
	    /**
		 *  The initial expression value
		 *  @return  {Number}  The initial value 0
		 *  @private
		 */
	    Tone.TimeBase.prototype._noOp = function () {
	        return 0;
	    };
	    /**
		 *  The default expression value if no arguments are given
		 *  @private
		 */
	    Tone.TimeBase.prototype._defaultExpr = function () {
	        return this._noOp;
	    };
	    /**
		 *  The default units if none are given.
		 *  @private
		 */
	    Tone.TimeBase.prototype._defaultUnits = 's';
	    ///////////////////////////////////////////////////////////////////////////
	    //	UNIT CONVERSIONS
	    ///////////////////////////////////////////////////////////////////////////
	    /**
		 *  Returns the value of a frequency in the current units
		 *  @param {Frequency} freq
		 *  @return  {Number}
		 *  @private
		 */
	    Tone.TimeBase.prototype._frequencyToUnits = function (freq) {
	        return 1 / freq;
	    };
	    /**
		 *  Return the value of the beats in the current units
		 *  @param {Number} beats
		 *  @return  {Number}
		 *  @private
		 */
	    Tone.TimeBase.prototype._beatsToUnits = function (beats) {
	        return 60 / Tone.Transport.bpm.value * beats;
	    };
	    /**
		 *  Returns the value of a second in the current units
		 *  @param {Seconds} seconds
		 *  @return  {Number}
		 *  @private
		 */
	    Tone.TimeBase.prototype._secondsToUnits = function (seconds) {
	        return seconds;
	    };
	    /**
		 *  Returns the value of a tick in the current time units
		 *  @param {Ticks} ticks
		 *  @return  {Number}
		 *  @private
		 */
	    Tone.TimeBase.prototype._ticksToUnits = function (ticks) {
	        return ticks * (this._beatsToUnits(1) / Tone.Transport.PPQ);
	    };
	    /**
		 *  Return the time signature.
		 *  @return  {Number}
		 *  @private
		 */
	    Tone.TimeBase.prototype._timeSignature = function () {
	        return Tone.Transport.timeSignature;
	    };
	    ///////////////////////////////////////////////////////////////////////////
	    //	EXPRESSIONS
	    ///////////////////////////////////////////////////////////////////////////
	    /**
		 *  Push an expression onto the expression list
		 *  @param  {Time}  val
		 *  @param  {String}  type
		 *  @param  {String}  units
		 *  @return  {Tone.TimeBase} 
		 *  @private
		 */
	    Tone.TimeBase.prototype._pushExpr = function (val, name, units) {
	        //create the expression
	        if (!(val instanceof Tone.TimeBase)) {
	            val = new this.constructor(val, units);
	        }
	        this._expr = this._binaryExpressions[name].method.bind(this, this._expr, val._expr);
	        return this;
	    };
	    /**
		 *  Add to the current value.
		 *  @param  {Time}  val    The value to add
		 *  @param  {String=}  units  Optional units to use with the value.
		 *  @return  {Tone.TimeBase}  this
		 *  @example
		 * Tone.TimeBase("2m").add("1m"); //"3m"
		 */
	    Tone.TimeBase.prototype.add = function (val, units) {
	        return this._pushExpr(val, '+', units);
	    };
	    /**
		 *  Subtract the value from the current time.
		 *  @param  {Time}  val    The value to subtract
		 *  @param  {String=}  units  Optional units to use with the value.
		 *  @return  {Tone.TimeBase}  this
		 *  @example
		 * Tone.TimeBase("2m").sub("1m"); //"1m"
		 */
	    Tone.TimeBase.prototype.sub = function (val, units) {
	        return this._pushExpr(val, '-', units);
	    };
	    /**
		 *  Multiply the current value by the given time.
		 *  @param  {Time}  val    The value to multiply
		 *  @param  {String=}  units  Optional units to use with the value.
		 *  @return  {Tone.TimeBase}  this
		 *  @example
		 * Tone.TimeBase("2m").mult("2"); //"4m"
		 */
	    Tone.TimeBase.prototype.mult = function (val, units) {
	        return this._pushExpr(val, '*', units);
	    };
	    /**
		 *  Divide the current value by the given time.
		 *  @param  {Time}  val    The value to divide by
		 *  @param  {String=}  units  Optional units to use with the value.
		 *  @return  {Tone.TimeBase}  this
		 *  @example
		 * Tone.TimeBase("2m").div(2); //"1m"
		 */
	    Tone.TimeBase.prototype.div = function (val, units) {
	        return this._pushExpr(val, '/', units);
	    };
	    /**
		 *  Evaluate the time value. Returns the time
		 *  in seconds.
		 *  @return  {Seconds} 
		 */
	    Tone.TimeBase.prototype.valueOf = function () {
	        return this._expr();
	    };
	    /**
		 *  Clean up
		 *  @return {Tone.TimeBase} this
		 */
	    Tone.TimeBase.prototype.dispose = function () {
	        this._expr = null;
	    };
	    return Tone.TimeBase;
	});
	Module(function (Tone) {
	    /**
		 *  @class Tone.Time is a primitive type for encoding Time values. 
		 *         Eventually all time values are evaluated to seconds
		 *         using the `eval` method. Tone.Time can be constructed
		 *         with or without the `new` keyword. Tone.Time can be passed
		 *         into the parameter of any method which takes time as an argument. 
		 *  @constructor
		 *  @extends {Tone.TimeBase}
		 *  @param  {String|Number}  val    The time value.
		 *  @param  {String=}  units  The units of the value.
		 *  @example
		 * var t = Tone.Time("4n");//encodes a quarter note
		 * t.mult(4); // multiply that value by 4
		 * t.toNotation(); //returns "1m"
		 */
	    Tone.Time = function (val, units) {
	        if (this instanceof Tone.Time) {
	            /**
				 *  If the current clock time should
				 *  be added to the output
				 *  @type  {Boolean}
				 *  @private
				 */
	            this._plusNow = false;
	            Tone.TimeBase.call(this, val, units);
	        } else {
	            return new Tone.Time(val, units);
	        }
	    };
	    Tone.extend(Tone.Time, Tone.TimeBase);
	    //clone the expressions so that 
	    //we can add more without modifying the original
	    Tone.Time.prototype._unaryExpressions = Object.create(Tone.TimeBase.prototype._unaryExpressions);
	    /*
		 *  Adds an additional unary expression
		 *  which quantizes values to the next subdivision
		 *  @type {Object}
		 *  @private
		 */
	    Tone.Time.prototype._unaryExpressions.quantize = {
	        regexp: /^@/,
	        method: function (rh) {
	            return Tone.Transport.nextSubdivision(rh());
	        }
	    };
	    /*
		 *  Adds an additional unary expression
		 *  which adds the current clock time.
		 *  @type {Object}
		 *  @private
		 */
	    Tone.Time.prototype._unaryExpressions.now = {
	        regexp: /^\+/,
	        method: function (lh) {
	            this._plusNow = true;
	            return lh();
	        }
	    };
	    /**
		 *  Quantize the time by the given subdivision. Optionally add a
		 *  percentage which will move the time value towards the ideal
		 *  quantized value by that percentage. 
		 *  @param  {Number|Time}  val    The subdivision to quantize to
		 *  @param  {NormalRange}  [percent=1]  Move the time value
		 *                                   towards the quantized value by
		 *                                   a percentage.
		 *  @return  {Tone.Time}  this
		 *  @example
		 * Tone.Time(21).quantize(2) //returns 22
		 * Tone.Time(0.6).quantize("4n", 0.5) //returns 0.55
		 */
	    Tone.Time.prototype.quantize = function (subdiv, percent) {
	        percent = this.defaultArg(percent, 1);
	        this._expr = function (expr, subdivision, percent) {
	            expr = expr();
	            subdivision = subdivision.toSeconds();
	            var multiple = Math.round(expr / subdivision);
	            var ideal = multiple * subdivision;
	            var diff = ideal - expr;
	            return expr + diff * percent;
	        }.bind(this, this._expr, new this.constructor(subdiv), percent);
	        return this;
	    };
	    /**
		 *  Adds the clock time to the time expression at the 
		 *  moment of evaluation. 
		 *  @return  {Tone.Time}  this
		 */
	    Tone.Time.prototype.addNow = function () {
	        this._plusNow = true;
	        return this;
	    };
	    /**
		 *  @override
		 *  Override the default value return when no arguments are passed in.
		 *  The default value is 'now'
		 *  @private
		 */
	    Tone.Time.prototype._defaultExpr = function () {
	        this._plusNow = true;
	        return this._noOp;
	    };
	    /**
		 *  Copies the value of time to this Time
		 *  @param {Tone.Time} time
		 *  @return  {Time}
		 */
	    Tone.Time.prototype.copy = function (time) {
	        Tone.TimeBase.prototype.copy.call(this, time);
	        this._plusNow = time._plusNow;
	        return this;
	    };
	    //CONVERSIONS//////////////////////////////////////////////////////////////
	    /**
		 *  Convert a Time to Notation. Values will be thresholded to the nearest 128th note. 
		 *  @return {Notation} 
		 *  @example
		 * //if the Transport is at 120bpm:
		 * Tone.Time(2).toNotation();//returns "1m"
		 */
	    Tone.Time.prototype.toNotation = function () {
	        var time = this.toSeconds();
	        var testNotations = [
	            '1m',
	            '2n',
	            '4n',
	            '8n',
	            '16n',
	            '32n',
	            '64n',
	            '128n'
	        ];
	        var retNotation = this._toNotationHelper(time, testNotations);
	        //try the same thing but with tripelets
	        var testTripletNotations = [
	            '1m',
	            '2n',
	            '2t',
	            '4n',
	            '4t',
	            '8n',
	            '8t',
	            '16n',
	            '16t',
	            '32n',
	            '32t',
	            '64n',
	            '64t',
	            '128n'
	        ];
	        var retTripletNotation = this._toNotationHelper(time, testTripletNotations);
	        //choose the simpler expression of the two
	        if (retTripletNotation.split('+').length < retNotation.split('+').length) {
	            return retTripletNotation;
	        } else {
	            return retNotation;
	        }
	    };
	    /**
		 *  Helper method for Tone.toNotation
		 *  @param {Number} units 
		 *  @param {Array} testNotations
		 *  @return {String}
		 *  @private
		 */
	    Tone.Time.prototype._toNotationHelper = function (units, testNotations) {
	        //the threshold is the last value in the array
	        var threshold = this._notationToUnits(testNotations[testNotations.length - 1]);
	        var retNotation = '';
	        for (var i = 0; i < testNotations.length; i++) {
	            var notationTime = this._notationToUnits(testNotations[i]);
	            //account for floating point errors (i.e. round up if the value is 0.999999)
	            var multiple = units / notationTime;
	            var floatingPointError = 0.000001;
	            if (1 - multiple % 1 < floatingPointError) {
	                multiple += floatingPointError;
	            }
	            multiple = Math.floor(multiple);
	            if (multiple > 0) {
	                if (multiple === 1) {
	                    retNotation += testNotations[i];
	                } else {
	                    retNotation += multiple.toString() + '*' + testNotations[i];
	                }
	                units -= multiple * notationTime;
	                if (units < threshold) {
	                    break;
	                } else {
	                    retNotation += ' + ';
	                }
	            }
	        }
	        if (retNotation === '') {
	            retNotation = '0';
	        }
	        return retNotation;
	    };
	    /**
		 *  Convert a notation value to the current units
		 *  @param  {Notation}  notation 
		 *  @return  {Number} 
		 *  @private
		 */
	    Tone.Time.prototype._notationToUnits = function (notation) {
	        var primaryExprs = this._primaryExpressions;
	        var notationExprs = [
	            primaryExprs.n,
	            primaryExprs.t,
	            primaryExprs.m
	        ];
	        for (var i = 0; i < notationExprs.length; i++) {
	            var expr = notationExprs[i];
	            var match = notation.match(expr.regexp);
	            if (match) {
	                return expr.method.call(this, match[1]);
	            }
	        }
	    };
	    /**
		 *  Return the time encoded as Bars:Beats:Sixteenths.
		 *  @return  {BarsBeatsSixteenths}
		 */
	    Tone.Time.prototype.toBarsBeatsSixteenths = function () {
	        var quarterTime = this._beatsToUnits(1);
	        var quarters = this.toSeconds() / quarterTime;
	        var measures = Math.floor(quarters / this._timeSignature());
	        var sixteenths = quarters % 1 * 4;
	        quarters = Math.floor(quarters) % this._timeSignature();
	        sixteenths = sixteenths.toString();
	        if (sixteenths.length > 3) {
	            sixteenths = parseFloat(sixteenths).toFixed(3);
	        }
	        var progress = [
	            measures,
	            quarters,
	            sixteenths
	        ];
	        return progress.join(':');
	    };
	    /**
		 *  Return the time in ticks.
		 *  @return  {Ticks}
		 */
	    Tone.Time.prototype.toTicks = function () {
	        var quarterTime = this._beatsToUnits(1);
	        var quarters = this.valueOf() / quarterTime;
	        return Math.floor(quarters * Tone.Transport.PPQ);
	    };
	    /**
		 *  Return the time in samples
		 *  @return  {Samples}  
		 */
	    Tone.Time.prototype.toSamples = function () {
	        return this.toSeconds() * this.context.sampleRate;
	    };
	    /**
		 *  Return the time as a frequency value
		 *  @return  {Frequency} 
		 *  @example
		 * Tone.Time(2).toFrequency(); //0.5
		 */
	    Tone.Time.prototype.toFrequency = function () {
	        return 1 / this.toSeconds();
	    };
	    /**
		 *  Return the time in seconds.
		 *  @return  {Seconds} 
		 */
	    Tone.Time.prototype.toSeconds = function () {
	        return this.valueOf();
	    };
	    /**
		 *  Return the time in milliseconds.
		 *  @return  {Milliseconds} 
		 */
	    Tone.Time.prototype.toMilliseconds = function () {
	        return this.toSeconds() * 1000;
	    };
	    /**
		 *  Return the time in seconds.
		 *  @return  {Seconds} 
		 */
	    Tone.Time.prototype.valueOf = function () {
	        var val = this._expr();
	        return val + (this._plusNow ? this.now() : 0);
	    };
	    return Tone.Time;
	});
	Module(function (Tone) {
	    /**
		 *  @class Tone.Frequency is a primitive type for encoding Frequency values. 
		 *         Eventually all time values are evaluated to hertz
		 *         using the `eval` method. 
		 *  @constructor
		 *  @extends {Tone.TimeBase}
		 *  @param  {String|Number}  val    The time value.
		 *  @param  {String=}  units  The units of the value.
		 *  @example
		 * Tone.Frequency("C3") // 261
		 * Tone.Frequency(38, "midi") //
		 * Tone.Frequency("C3").transpose(4);
		 */
	    Tone.Frequency = function (val, units) {
	        if (this instanceof Tone.Frequency) {
	            Tone.TimeBase.call(this, val, units);
	        } else {
	            return new Tone.Frequency(val, units);
	        }
	    };
	    Tone.extend(Tone.Frequency, Tone.TimeBase);
	    ///////////////////////////////////////////////////////////////////////////
	    //	AUGMENT BASE EXPRESSIONS
	    ///////////////////////////////////////////////////////////////////////////
	    //clone the expressions so that 
	    //we can add more without modifying the original
	    Tone.Frequency.prototype._primaryExpressions = Object.create(Tone.TimeBase.prototype._primaryExpressions);
	    /*
		 *  midi type primary expression
		 *  @type {Object}
		 *  @private
		 */
	    Tone.Frequency.prototype._primaryExpressions.midi = {
	        regexp: /^(\d+(?:\.\d+)?midi)/,
	        method: function (value) {
	            return this.midiToFrequency(value);
	        }
	    };
	    /*
		 *  note type primary expression
		 *  @type {Object}
		 *  @private
		 */
	    Tone.Frequency.prototype._primaryExpressions.note = {
	        regexp: /^([a-g]{1}(?:b|#|x|bb)?)(-?[0-9]+)/i,
	        method: function (pitch, octave) {
	            var index = noteToScaleIndex[pitch.toLowerCase()];
	            var noteNumber = index + (parseInt(octave) + 1) * 12;
	            return this.midiToFrequency(noteNumber);
	        }
	    };
	    /*
		 *  BeatsBarsSixteenths type primary expression
		 *  @type {Object}
		 *  @private
		 */
	    Tone.Frequency.prototype._primaryExpressions.tr = {
	        regexp: /^(\d+(?:\.\d+)?):(\d+(?:\.\d+)?):?(\d+(?:\.\d+)?)?/,
	        method: function (m, q, s) {
	            var total = 1;
	            if (m && m !== '0') {
	                total *= this._beatsToUnits(this._timeSignature() * parseFloat(m));
	            }
	            if (q && q !== '0') {
	                total *= this._beatsToUnits(parseFloat(q));
	            }
	            if (s && s !== '0') {
	                total *= this._beatsToUnits(parseFloat(s) / 4);
	            }
	            return total;
	        }
	    };
	    ///////////////////////////////////////////////////////////////////////////
	    //	EXPRESSIONS
	    ///////////////////////////////////////////////////////////////////////////
	    /**
		 *  Transposes the frequency by the given number of semitones.
		 *  @param  {Interval}  interval
		 *  @return  {Tone.Frequency} this
		 *  @example
		 * Tone.Frequency("A4").transpose(3); //"C5"
		 */
	    Tone.Frequency.prototype.transpose = function (interval) {
	        this._expr = function (expr, interval) {
	            var val = expr();
	            return val * this.intervalToFrequencyRatio(interval);
	        }.bind(this, this._expr, interval);
	        return this;
	    };
	    /**
		 *  Takes an array of semitone intervals and returns
		 *  an array of frequencies transposed by those intervals.
		 *  @param  {Array}  intervals
		 *  @return  {Tone.Frequency} this
		 *  @example
		 * Tone.Frequency("A4").harmonize([0, 3, 7]); //["A4", "C5", "E5"]
		 */
	    Tone.Frequency.prototype.harmonize = function (intervals) {
	        this._expr = function (expr, intervals) {
	            var val = expr();
	            var ret = [];
	            for (var i = 0; i < intervals.length; i++) {
	                ret[i] = val * this.intervalToFrequencyRatio(intervals[i]);
	            }
	            return ret;
	        }.bind(this, this._expr, intervals);
	        return this;
	    };
	    ///////////////////////////////////////////////////////////////////////////
	    //	UNIT CONVERSIONS
	    ///////////////////////////////////////////////////////////////////////////
	    /**
		 *  Return the value of the frequency as a MIDI note
		 *  @return  {MIDI}
		 *  @example
		 * Tone.Frequency("C4").toMidi(); //60
		 */
	    Tone.Frequency.prototype.toMidi = function () {
	        return this.frequencyToMidi(this.valueOf());
	    };
	    /**
		 *  Return the value of the frequency in Scientific Pitch Notation
		 *  @return  {Note}
		 *  @example
		 * Tone.Frequency(69, "midi").toNote(); //"A4"
		 */
	    Tone.Frequency.prototype.toNote = function () {
	        var freq = this.valueOf();
	        var log = Math.log(freq / Tone.Frequency.A4) / Math.LN2;
	        var noteNumber = Math.round(12 * log) + 57;
	        var octave = Math.floor(noteNumber / 12);
	        if (octave < 0) {
	            noteNumber += -12 * octave;
	        }
	        var noteName = scaleIndexToNote[noteNumber % 12];
	        return noteName + octave.toString();
	    };
	    /**
		 *  Return the duration of one cycle in seconds.
		 *  @return  {Seconds}
		 */
	    Tone.Frequency.prototype.toSeconds = function () {
	        return 1 / this.valueOf();
	    };
	    /**
		 *  Return the value in Hertz
		 *  @return  {Frequency}
		 */
	    Tone.Frequency.prototype.toFrequency = function () {
	        return this.valueOf();
	    };
	    /**
		 *  Return the duration of one cycle in ticks
		 *  @return  {Ticks}
		 */
	    Tone.Frequency.prototype.toTicks = function () {
	        var quarterTime = this._beatsToUnits(1);
	        var quarters = this.valueOf() / quarterTime;
	        return Math.floor(quarters * Tone.Transport.PPQ);
	    };
	    ///////////////////////////////////////////////////////////////////////////
	    //	UNIT CONVERSIONS HELPERS
	    ///////////////////////////////////////////////////////////////////////////
	    /**
		 *  Returns the value of a frequency in the current units
		 *  @param {Frequency} freq
		 *  @return  {Number}
		 *  @private
		 */
	    Tone.Frequency.prototype._frequencyToUnits = function (freq) {
	        return freq;
	    };
	    /**
		 *  Returns the value of a tick in the current time units
		 *  @param {Ticks} ticks
		 *  @return  {Number}
		 *  @private
		 */
	    Tone.Frequency.prototype._ticksToUnits = function (ticks) {
	        return 1 / (ticks * 60 / (Tone.Transport.bpm.value * Tone.Transport.PPQ));
	    };
	    /**
		 *  Return the value of the beats in the current units
		 *  @param {Number} beats
		 *  @return  {Number}
		 *  @private
		 */
	    Tone.Frequency.prototype._beatsToUnits = function (beats) {
	        return 1 / Tone.TimeBase.prototype._beatsToUnits.call(this, beats);
	    };
	    /**
		 *  Returns the value of a second in the current units
		 *  @param {Seconds} seconds
		 *  @return  {Number}
		 *  @private
		 */
	    Tone.Frequency.prototype._secondsToUnits = function (seconds) {
	        return 1 / seconds;
	    };
	    /**
		 *  The default units if none are given.
		 *  @private
		 */
	    Tone.Frequency.prototype._defaultUnits = 'hz';
	    ///////////////////////////////////////////////////////////////////////////
	    //	FREQUENCY CONVERSIONS
	    ///////////////////////////////////////////////////////////////////////////
	    /**
		 *  Note to scale index
		 *  @type  {Object}
		 */
	    var noteToScaleIndex = {
	        'cbb': -2,
	        'cb': -1,
	        'c': 0,
	        'c#': 1,
	        'cx': 2,
	        'dbb': 0,
	        'db': 1,
	        'd': 2,
	        'd#': 3,
	        'dx': 4,
	        'ebb': 2,
	        'eb': 3,
	        'e': 4,
	        'e#': 5,
	        'ex': 6,
	        'fbb': 3,
	        'fb': 4,
	        'f': 5,
	        'f#': 6,
	        'fx': 7,
	        'gbb': 5,
	        'gb': 6,
	        'g': 7,
	        'g#': 8,
	        'gx': 9,
	        'abb': 7,
	        'ab': 8,
	        'a': 9,
	        'a#': 10,
	        'ax': 11,
	        'bbb': 9,
	        'bb': 10,
	        'b': 11,
	        'b#': 12,
	        'bx': 13
	    };
	    /**
		 *  scale index to note (sharps)
		 *  @type  {Array}
		 */
	    var scaleIndexToNote = [
	        'C',
	        'C#',
	        'D',
	        'D#',
	        'E',
	        'F',
	        'F#',
	        'G',
	        'G#',
	        'A',
	        'A#',
	        'B'
	    ];
	    /**
		 *  The [concert pitch](https://en.wikipedia.org/wiki/Concert_pitch)
		 *  A4's values in Hertz. 
		 *  @type {Frequency}
		 *  @static
		 */
	    Tone.Frequency.A4 = 440;
	    /**
		 *  Convert a MIDI note to frequency value. 
		 *  @param  {MIDI} midi The midi number to convert.
		 *  @return {Frequency} the corresponding frequency value
		 *  @example
		 * tone.midiToFrequency(69); // returns 440
		 */
	    Tone.Frequency.prototype.midiToFrequency = function (midi) {
	        return Tone.Frequency.A4 * Math.pow(2, (midi - 69) / 12);
	    };
	    /**
		 *  Convert a frequency value to a MIDI note.
		 *  @param {Frequency} frequency The value to frequency value to convert.
		 *  @returns  {MIDI}
		 *  @example
		 * tone.midiToFrequency(440); // returns 69
		 */
	    Tone.Frequency.prototype.frequencyToMidi = function (frequency) {
	        return 69 + 12 * Math.log(frequency / Tone.Frequency.A4) / Math.LN2;
	    };
	    return Tone.Frequency;
	});
	Module(function (Tone) {
	    /**
		 *  @class Tone.TransportTime is a the time along the Transport's
		 *         timeline. It is similar to Tone.Time, but instead of evaluating
		 *         against the AudioContext's clock, it is evaluated against
		 *         the Transport's position. See [TransportTime wiki](https://github.com/Tonejs/Tone.js/wiki/TransportTime).
		 *  @constructor
		 *  @param  {Time}  val    The time value as a number or string
		 *  @param  {String=}  units  Unit values
		 *  @extends {Tone.Time}
		 */
	    Tone.TransportTime = function (val, units) {
	        if (this instanceof Tone.TransportTime) {
	            Tone.Time.call(this, val, units);
	        } else {
	            return new Tone.TransportTime(val, units);
	        }
	    };
	    Tone.extend(Tone.TransportTime, Tone.Time);
	    //clone the expressions so that 
	    //we can add more without modifying the original
	    Tone.TransportTime.prototype._unaryExpressions = Object.create(Tone.Time.prototype._unaryExpressions);
	    /**
		 *  Adds an additional unary expression
		 *  which quantizes values to the next subdivision
		 *  @type {Object}
		 *  @private
		 */
	    Tone.TransportTime.prototype._unaryExpressions.quantize = {
	        regexp: /^@/,
	        method: function (rh) {
	            var subdivision = this._secondsToTicks(rh());
	            var multiple = Math.ceil(Tone.Transport.ticks / subdivision);
	            return this._ticksToUnits(multiple * subdivision);
	        }
	    };
	    /**
		 *  Convert seconds into ticks
		 *  @param {Seconds} seconds
		 *  @return  {Ticks}
		 *  @private
		 */
	    Tone.TransportTime.prototype._secondsToTicks = function (seconds) {
	        var quarterTime = this._beatsToUnits(1);
	        var quarters = seconds / quarterTime;
	        return Math.round(quarters * Tone.Transport.PPQ);
	    };
	    /**
		 *  Evaluate the time expression. Returns values in ticks
		 *  @return {Ticks}
		 */
	    Tone.TransportTime.prototype.valueOf = function () {
	        var val = this._secondsToTicks(this._expr());
	        return val + (this._plusNow ? Tone.Transport.ticks : 0);
	    };
	    /**
		 *  Return the time in ticks.
		 *  @return  {Ticks}
		 */
	    Tone.TransportTime.prototype.toTicks = function () {
	        return this.valueOf();
	    };
	    /**
		 *  Return the time in seconds.
		 *  @return  {Seconds}
		 */
	    Tone.TransportTime.prototype.toSeconds = function () {
	        var val = this._expr();
	        return val + (this._plusNow ? Tone.Transport.seconds : 0);
	    };
	    /**
		 *  Return the time as a frequency value
		 *  @return  {Frequency} 
		 */
	    Tone.TransportTime.prototype.toFrequency = function () {
	        return 1 / this.toSeconds();
	    };
	    return Tone.TransportTime;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Tone.Emitter gives classes which extend it
		 *         the ability to listen for and emit events. 
		 *         Inspiration and reference from Jerome Etienne's [MicroEvent](https://github.com/jeromeetienne/microevent.js).
		 *         MIT (c) 2011 Jerome Etienne.
		 *         
		 *  @extends {Tone}
		 */
	    Tone.Emitter = function () {
	        /**
			 *  Contains all of the events.
			 *  @private
			 *  @type  {Object}
			 */
	        this._events = {};
	    };
	    Tone.extend(Tone.Emitter);
	    /**
		 *  Bind a callback to a specific event.
		 *  @param  {String}    event     The name of the event to listen for.
		 *  @param  {Function}  callback  The callback to invoke when the
		 *                                event is emitted
		 *  @return  {Tone.Emitter}    this
		 */
	    Tone.Emitter.prototype.on = function (event, callback) {
	        //split the event
	        var events = event.split(/\W+/);
	        for (var i = 0; i < events.length; i++) {
	            var eventName = events[i];
	            if (!this._events.hasOwnProperty(eventName)) {
	                this._events[eventName] = [];
	            }
	            this._events[eventName].push(callback);
	        }
	        return this;
	    };
	    /**
		 *  Remove the event listener.
		 *  @param  {String}    event     The event to stop listening to.
		 *  @param  {Function=}  callback  The callback which was bound to 
		 *                                the event with Tone.Emitter.on.
		 *                                If no callback is given, all callbacks
		 *                                events are removed.
		 *  @return  {Tone.Emitter}    this
		 */
	    Tone.Emitter.prototype.off = function (event, callback) {
	        var events = event.split(/\W+/);
	        for (var ev = 0; ev < events.length; ev++) {
	            event = events[ev];
	            if (this._events.hasOwnProperty(event)) {
	                if (Tone.prototype.isUndef(callback)) {
	                    this._events[event] = [];
	                } else {
	                    var eventList = this._events[event];
	                    for (var i = 0; i < eventList.length; i++) {
	                        if (eventList[i] === callback) {
	                            eventList.splice(i, 1);
	                        }
	                    }
	                }
	            }
	        }
	        return this;
	    };
	    /**
		 *  Invoke all of the callbacks bound to the event
		 *  with any arguments passed in. 
		 *  @param  {String}  event  The name of the event.
		 *  @param {*...} args The arguments to pass to the functions listening.
		 *  @return  {Tone.Emitter}  this
		 */
	    Tone.Emitter.prototype.emit = function (event) {
	        if (this._events) {
	            var args = Array.apply(null, arguments).slice(1);
	            if (this._events.hasOwnProperty(event)) {
	                var eventList = this._events[event];
	                for (var i = 0, len = eventList.length; i < len; i++) {
	                    eventList[i].apply(this, args);
	                }
	            }
	        }
	        return this;
	    };
	    /**
		 *  Add Emitter functions (on/off/emit) to the object
		 *  @param  {Object|Function}  object  The object or class to extend.
		 */
	    Tone.Emitter.mixin = function (object) {
	        var functions = [
	            'on',
	            'off',
	            'emit'
	        ];
	        object._events = {};
	        for (var i = 0; i < functions.length; i++) {
	            var func = functions[i];
	            var emitterFunc = Tone.Emitter.prototype[func];
	            object[func] = emitterFunc;
	        }
	    };
	    /**
		 *  Clean up
		 *  @return  {Tone.Emitter}  this
		 */
	    Tone.Emitter.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._events = null;
	        return this;
	    };
	    return Tone.Emitter;
	});
	Module(function (Tone) {
	    /**
		 *  shim
		 *  @private
		 */
	    if (!window.hasOwnProperty('AudioContext') && window.hasOwnProperty('webkitAudioContext')) {
	        window.AudioContext = window.webkitAudioContext;
	    }
	    /**
		 *  @class Wrapper around the native AudioContext.
		 *  @extends {Tone.Emitter}
		 *  @param {AudioContext=} context optionally pass in a context
		 */
	    Tone.Context = function (context) {
	        Tone.Emitter.call(this);
	        if (!context) {
	            context = new window.AudioContext();
	        }
	        this._context = context;
	        // extend all of the methods
	        for (var prop in this._context) {
	            this._defineProperty(this._context, prop);
	        }
	        ///////////////////////////////////////////////////////////////////////
	        // WORKER
	        ///////////////////////////////////////////////////////////////////////
	        /**
			 *  The default latency hint
			 *  @type  {String}
			 *  @private
			 */
	        this._latencyHint = 'interactive';
	        /**
			 *  The amount of time events are scheduled
			 *  into the future
			 *  @type  {Number}
			 *  @private
			 */
	        this._lookAhead = 0.1;
	        /**
			 *  How often the update look runs
			 *  @type  {Number}
			 *  @private
			 */
	        this._updateInterval = this._lookAhead / 3;
	        /**
			 *  A reference to the actual computed update interval
			 *  @type  {Number}
			 *  @private
			 */
	        this._computedUpdateInterval = 0;
	        /**
			 *  The web worker which is used to update Tone.Clock
			 *  @private
			 *  @type  {WebWorker}
			 */
	        this._worker = this._createWorker();
	        /**
			 *  An object containing all of the constants AudioBufferSourceNodes
			 *  @type  {Object}
			 *  @private
			 */
	        this._constants = {};
	    };
	    Tone.extend(Tone.Context, Tone.Emitter);
	    Tone.Emitter.mixin(Tone.Context);
	    /**
		 *  Define a property on this Tone.Context. 
		 *  This is used to extend the native AudioContext
		 *  @param  {AudioContext}  context
		 *  @param  {String}  prop 
		 *  @private
		 */
	    Tone.Context.prototype._defineProperty = function (context, prop) {
	        if (this.isUndef(this[prop])) {
	            Object.defineProperty(this, prop, {
	                get: function () {
	                    if (typeof context[prop] === 'function') {
	                        return context[prop].bind(context);
	                    } else {
	                        return context[prop];
	                    }
	                },
	                set: function (val) {
	                    context[prop] = val;
	                }
	            });
	        }
	    };
	    /**
		 *  The current audio context time
		 *  @return  {Number}
		 */
	    Tone.Context.prototype.now = function () {
	        return this._context.currentTime;
	    };
	    /**
		 *  Generate a web worker
		 *  @return  {WebWorker}
		 *  @private
		 */
	    Tone.Context.prototype._createWorker = function () {
	        //URL Shim
	        window.URL = window.URL || window.webkitURL;
	        var blob = new Blob([//the initial timeout time
	            'var timeoutTime = ' + (this._updateInterval * 1000).toFixed(1) + ';' + //onmessage callback
	            'self.onmessage = function(msg){' + '\ttimeoutTime = parseInt(msg.data);' + '};' + //the tick function which posts a message
	            //and schedules a new tick
	            'function tick(){' + '\tsetTimeout(tick, timeoutTime);' + '\tself.postMessage(\'tick\');' + '}' + //call tick initially
	            'tick();']);
	        var blobUrl = URL.createObjectURL(blob);
	        var worker = new Worker(blobUrl);
	        worker.addEventListener('message', function () {
	            // tick the clock
	            this.emit('tick');
	        }.bind(this));
	        //lag compensation
	        worker.addEventListener('message', function () {
	            var now = this.now();
	            if (this.isNumber(this._lastUpdate)) {
	                var diff = now - this._lastUpdate;
	                this._computedUpdateInterval = Math.max(diff, this._computedUpdateInterval * 0.97);
	            }
	            this._lastUpdate = now;
	        }.bind(this));
	        return worker;
	    };
	    /**
		 *  Generate a looped buffer at some constant value.
		 *  @param  {Number}  val
		 *  @return  {BufferSourceNode}
		 */
	    Tone.Context.prototype.getConstant = function (val) {
	        if (this._constants[val]) {
	            return this._constants[val];
	        } else {
	            var buffer = this._context.createBuffer(1, 128, this._context.sampleRate);
	            var arr = buffer.getChannelData(0);
	            for (var i = 0; i < arr.length; i++) {
	                arr[i] = val;
	            }
	            var constant = this._context.createBufferSource();
	            constant.channelCount = 1;
	            constant.channelCountMode = 'explicit';
	            constant.buffer = buffer;
	            constant.loop = true;
	            constant.start(0);
	            this._constants[val] = constant;
	            return constant;
	        }
	    };
	    /**
		 *  This is the time that the clock is falling behind
		 *  the scheduled update interval. The Context automatically
		 *  adjusts for the lag and schedules further in advance.
		 *  @type {Number}
		 *  @memberOf Tone.Context
		 *  @name lag
		 *  @static
		 *  @readOnly
		 */
	    Object.defineProperty(Tone.Context.prototype, 'lag', {
	        get: function () {
	            var diff = this._computedUpdateInterval - this._updateInterval;
	            diff = Math.max(diff, 0);
	            return diff;
	        }
	    });
	    /**
		 *  The amount of time in advance that events are scheduled.
		 *  The lookAhead will adjust slightly in response to the 
		 *  measured update time to try to avoid clicks.
		 *  @type {Number}
		 *  @memberOf Tone.Context
		 *  @name lookAhead
		 *  @static
		 */
	    Object.defineProperty(Tone.Context.prototype, 'lookAhead', {
	        get: function () {
	            return this._lookAhead;
	        },
	        set: function (lA) {
	            this._lookAhead = lA;
	        }
	    });
	    /**
		 *  How often the Web Worker callback is invoked.
		 *  This number corresponds to how responsive the scheduling
		 *  can be. Context.updateInterval + Context.lookAhead gives you the
		 *  total latency between scheduling an event and hearing it.
		 *  @type {Number}
		 *  @memberOf Tone.Context
		 *  @name updateInterval
		 *  @static
		 */
	    Object.defineProperty(Tone.Context.prototype, 'updateInterval', {
	        get: function () {
	            return this._updateInterval;
	        },
	        set: function (interval) {
	            this._updateInterval = Math.max(interval, Tone.prototype.blockTime);
	            this._worker.postMessage(Math.max(interval * 1000, 1));
	        }
	    });
	    /**
		 *  The type of playback, which affects tradeoffs between audio 
		 *  output latency and responsiveness. 
		 *  
		 *  In addition to setting the value in seconds, the latencyHint also
		 *  accepts the strings "interactive" (prioritizes low latency), 
		 *  "playback" (prioritizes sustained playback), "balanced" (balances
		 *  latency and performance), and "fastest" (lowest latency, might glitch more often). 
		 *  @type {String|Seconds}
		 *  @memberOf Tone.Context#
		 *  @name latencyHint
		 *  @static
		 *  @example
		 * //set the lookAhead to 0.3 seconds
		 * Tone.context.latencyHint = 0.3;
		 */
	    Object.defineProperty(Tone.Context.prototype, 'latencyHint', {
	        get: function () {
	            return this._latencyHint;
	        },
	        set: function (hint) {
	            var lookAhead = hint;
	            this._latencyHint = hint;
	            if (this.isString(hint)) {
	                switch (hint) {
	                case 'interactive':
	                    lookAhead = 0.1;
	                    this._context.latencyHint = hint;
	                    break;
	                case 'playback':
	                    lookAhead = 0.8;
	                    this._context.latencyHint = hint;
	                    break;
	                case 'balanced':
	                    lookAhead = 0.25;
	                    this._context.latencyHint = hint;
	                    break;
	                case 'fastest':
	                    lookAhead = 0.01;
	                    break;
	                }
	            }
	            this.lookAhead = lookAhead;
	            this.updateInterval = lookAhead / 3;
	        }
	    });
	    /**
		 *  Shim all connect/disconnect and some deprecated methods which are still in
		 *  some older implementations.
		 *  @private
		 */
	    function shimConnect() {
	        var nativeConnect = AudioNode.prototype.connect;
	        var nativeDisconnect = AudioNode.prototype.disconnect;
	        //replace the old connect method
	        function toneConnect(B, outNum, inNum) {
	            if (B.input) {
	                if (Array.isArray(B.input)) {
	                    if (Tone.prototype.isUndef(inNum)) {
	                        inNum = 0;
	                    }
	                    this.connect(B.input[inNum]);
	                } else {
	                    this.connect(B.input, outNum, inNum);
	                }
	            } else {
	                try {
	                    if (B instanceof AudioNode) {
	                        nativeConnect.call(this, B, outNum, inNum);
	                    } else {
	                        nativeConnect.call(this, B, outNum);
	                    }
	                } catch (e) {
	                    throw new Error('error connecting to node: ' + B + '\n' + e);
	                }
	            }
	        }
	        //replace the old disconnect method
	        function toneDisconnect(B, outNum, inNum) {
	            if (B && B.input && Array.isArray(B.input)) {
	                if (Tone.prototype.isUndef(inNum)) {
	                    inNum = 0;
	                }
	                this.disconnect(B.input[inNum], outNum, inNum);
	            } else if (B && B.input) {
	                this.disconnect(B.input, outNum, inNum);
	            } else {
	                try {
	                    nativeDisconnect.apply(this, arguments);
	                } catch (e) {
	                    throw new Error('error disconnecting node: ' + B + '\n' + e);
	                }
	            }
	        }
	        if (AudioNode.prototype.connect !== toneConnect) {
	            AudioNode.prototype.connect = toneConnect;
	            AudioNode.prototype.disconnect = toneDisconnect;
	        }
	    }
	    // set the audio context initially
	    if (Tone.supported) {
	        shimConnect();
	        Tone.context = new Tone.Context();
	    } else {
	        console.warn('This browser does not support Tone.js');
	    }
	    return Tone.Context;
	});
	Module(function (Tone) {
	    ///////////////////////////////////////////////////////////////////////////
	    //	TYPES
	    ///////////////////////////////////////////////////////////////////////////
	    /**
		 * Units which a value can take on.
		 * @enum {String}
		 */
	    Tone.Type = {
	        /** 
			 *  Default units
			 *  @typedef {Default}
			 */
	        Default: 'number',
	        /**
			 *  Time can be described in a number of ways. Read more [Time](https://github.com/Tonejs/Tone.js/wiki/Time).
			 *
			 *  <ul>
			 *  <li>Numbers, which will be taken literally as the time (in seconds).</li>
			 *  <li>Notation, ("4n", "8t") describes time in BPM and time signature relative values.</li>
			 *  <li>TransportTime, ("4:3:2") will also provide tempo and time signature relative times 
			 *  in the form BARS:QUARTERS:SIXTEENTHS.</li>
			 *  <li>Frequency, ("8hz") is converted to the length of the cycle in seconds.</li>
			 *  <li>Now-Relative, ("+1") prefix any of the above with "+" and it will be interpreted as 
			 *  "the current time plus whatever expression follows".</li>
			 *  <li>Expressions, ("3:0 + 2 - (1m / 7)") any of the above can also be combined 
			 *  into a mathematical expression which will be evaluated to compute the desired time.</li>
			 *  <li>No Argument, for methods which accept time, no argument will be interpreted as 
			 *  "now" (i.e. the currentTime).</li>
			 *  </ul>
			 *  
			 *  @typedef {Time}
			 */
	        Time: 'time',
	        /**
			 *  Frequency can be described similar to time, except ultimately the
			 *  values are converted to frequency instead of seconds. A number
			 *  is taken literally as the value in hertz. Additionally any of the 
			 *  Time encodings can be used. Note names in the form
			 *  of NOTE OCTAVE (i.e. C4) are also accepted and converted to their
			 *  frequency value. 
			 *  @typedef {Frequency}
			 */
	        Frequency: 'frequency',
	        /**
			 *  TransportTime describes a position along the Transport's timeline. It is
			 *  similar to Time in that it uses all the same encodings, but TransportTime specifically
			 *  pertains to the Transport's timeline, which is startable, stoppable, loopable, and seekable. 
			 *  [Read more](https://github.com/Tonejs/Tone.js/wiki/TransportTime)
			 *  @typedef {TransportTime}
			 */
	        TransportTime: 'transportTime',
	        /** 
			 *  Ticks are the basic subunit of the Transport. They are
			 *  the smallest unit of time that the Transport supports.
			 *  @typedef {Ticks}
			 */
	        Ticks: 'ticks',
	        /** 
			 *  Normal values are within the range [0, 1].
			 *  @typedef {NormalRange}
			 */
	        NormalRange: 'normalRange',
	        /** 
			 *  AudioRange values are between [-1, 1].
			 *  @typedef {AudioRange}
			 */
	        AudioRange: 'audioRange',
	        /** 
			 *  Decibels are a logarithmic unit of measurement which is useful for volume
			 *  because of the logarithmic way that we perceive loudness. 0 decibels 
			 *  means no change in volume. -10db is approximately half as loud and 10db 
			 *  is twice is loud. 
			 *  @typedef {Decibels}
			 */
	        Decibels: 'db',
	        /** 
			 *  Half-step note increments, i.e. 12 is an octave above the root. and 1 is a half-step up.
			 *  @typedef {Interval}
			 */
	        Interval: 'interval',
	        /** 
			 *  Beats per minute. 
			 *  @typedef {BPM}
			 */
	        BPM: 'bpm',
	        /** 
			 *  The value must be greater than or equal to 0.
			 *  @typedef {Positive}
			 */
	        Positive: 'positive',
	        /** 
			 *  A cent is a hundredth of a semitone. 
			 *  @typedef {Cents}
			 */
	        Cents: 'cents',
	        /** 
			 *  Angle between 0 and 360. 
			 *  @typedef {Degrees}
			 */
	        Degrees: 'degrees',
	        /** 
			 *  A number representing a midi note.
			 *  @typedef {MIDI}
			 */
	        MIDI: 'midi',
	        /** 
			 *  A colon-separated representation of time in the form of
			 *  Bars:Beats:Sixteenths. 
			 *  @typedef {BarsBeatsSixteenths}
			 */
	        BarsBeatsSixteenths: 'barsBeatsSixteenths',
	        /** 
			 *  Sampling is the reduction of a continuous signal to a discrete signal.
			 *  Audio is typically sampled 44100 times per second. 
			 *  @typedef {Samples}
			 */
	        Samples: 'samples',
	        /** 
			 *  Hertz are a frequency representation defined as one cycle per second.
			 *  @typedef {Hertz}
			 */
	        Hertz: 'hertz',
	        /** 
			 *  A frequency represented by a letter name, 
			 *  accidental and octave. This system is known as
			 *  [Scientific Pitch Notation](https://en.wikipedia.org/wiki/Scientific_pitch_notation).
			 *  @typedef {Note}
			 */
	        Note: 'note',
	        /** 
			 *  One millisecond is a thousandth of a second. 
			 *  @typedef {Milliseconds}
			 */
	        Milliseconds: 'milliseconds',
	        /** 
			 *  Seconds are the time unit of the AudioContext. In the end, 
			 *  all values need to be evaluated to seconds. 
			 *  @typedef {Seconds}
			 */
	        Seconds: 'seconds',
	        /** 
			 *  A string representing a duration relative to a measure. 
			 *  <ul>
			 *  	<li>"4n" = quarter note</li>
			 *   	<li>"2m" = two measures</li>
			 *    	<li>"8t" = eighth-note triplet</li>
			 *  </ul>
			 *  @typedef {Notation}
			 */
	        Notation: 'notation'
	    };
	    ///////////////////////////////////////////////////////////////////////////
	    // AUGMENT TONE's PROTOTYPE
	    ///////////////////////////////////////////////////////////////////////////
	    /**
		 *  Convert Time into seconds.
		 *  
		 *  Unlike the method which it overrides, this takes into account 
		 *  transporttime and musical notation.
		 *
		 *  Time : 1.40
		 *  Notation: 4n|1m|2t
		 *  Now Relative: +3n
		 *  Math: 3n+16n or even complicated expressions ((3n*2)/6 + 1)
		 *
		 *  @param  {Time} time 
		 *  @return {Seconds} 
		 */
	    Tone.prototype.toSeconds = function (time) {
	        if (this.isNumber(time)) {
	            return time;
	        } else if (this.isUndef(time)) {
	            return this.now();
	        } else if (this.isString(time)) {
	            return new Tone.Time(time).toSeconds();
	        } else if (time instanceof Tone.TimeBase) {
	            return time.toSeconds();
	        }
	    };
	    /**
		 *  Convert a frequency representation into a number.
		 *  @param  {Frequency} freq 
		 *  @return {Hertz}      the frequency in hertz
		 */
	    Tone.prototype.toFrequency = function (freq) {
	        if (this.isNumber(freq)) {
	            return freq;
	        } else if (this.isString(freq) || this.isUndef(freq)) {
	            return new Tone.Frequency(freq).valueOf();
	        } else if (freq instanceof Tone.TimeBase) {
	            return freq.toFrequency();
	        }
	    };
	    /**
		 *  Convert a time representation into ticks.
		 *  @param  {Time} time
		 *  @return {Ticks}  the time in ticks
		 */
	    Tone.prototype.toTicks = function (time) {
	        if (this.isNumber(time) || this.isString(time)) {
	            return new Tone.TransportTime(time).toTicks();
	        } else if (this.isUndef(time)) {
	            return Tone.Transport.ticks;
	        } else if (time instanceof Tone.TimeBase) {
	            return time.toTicks();
	        }
	    };
	    return Tone;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Tone.Param wraps the native Web Audio's AudioParam to provide
		 *         additional unit conversion functionality. It also
		 *         serves as a base-class for classes which have a single,
		 *         automatable parameter. 
		 *  @extends {Tone}
		 *  @param  {AudioParam}  param  The parameter to wrap.
		 *  @param  {Tone.Type} units The units of the audio param.
		 *  @param  {Boolean} convert If the param should be converted.
		 */
	    Tone.Param = function () {
	        var options = this.optionsObject(arguments, [
	            'param',
	            'units',
	            'convert'
	        ], Tone.Param.defaults);
	        /**
			 *  The native parameter to control
			 *  @type  {AudioParam}
			 *  @private
			 */
	        this._param = this.input = options.param;
	        /**
			 *  The units of the parameter
			 *  @type {Tone.Type}
			 */
	        this.units = options.units;
	        /**
			 *  If the value should be converted or not
			 *  @type {Boolean}
			 */
	        this.convert = options.convert;
	        /**
			 *  True if the signal value is being overridden by 
			 *  a connected signal.
			 *  @readOnly
			 *  @type  {boolean}
			 *  @private
			 */
	        this.overridden = false;
	        /**
			 *  If there is an LFO, this is where it is held.
			 *  @type  {Tone.LFO}
			 *  @private
			 */
	        this._lfo = null;
	        if (this.isObject(options.lfo)) {
	            this.value = options.lfo;
	        } else if (!this.isUndef(options.value)) {
	            this.value = options.value;
	        }
	    };
	    Tone.extend(Tone.Param);
	    /**
		 *  Defaults
		 *  @type  {Object}
		 *  @const
		 */
	    Tone.Param.defaults = {
	        'units': Tone.Type.Default,
	        'convert': true,
	        'param': undefined
	    };
	    /**
		 * The current value of the parameter. 
		 * @memberOf Tone.Param#
		 * @type {Number}
		 * @name value
		 */
	    Object.defineProperty(Tone.Param.prototype, 'value', {
	        get: function () {
	            return this._toUnits(this._param.value);
	        },
	        set: function (value) {
	            if (this.isObject(value)) {
	                //throw an error if the LFO needs to be included
	                if (this.isUndef(Tone.LFO)) {
	                    throw new Error('Include \'Tone.LFO\' to use an LFO as a Param value.');
	                }
	                //remove the old one
	                if (this._lfo) {
	                    this._lfo.dispose();
	                }
	                this._lfo = new Tone.LFO(value).start();
	                this._lfo.connect(this.input);
	            } else {
	                var convertedVal = this._fromUnits(value);
	                this._param.cancelScheduledValues(0);
	                this._param.value = convertedVal;
	            }
	        }
	    });
	    /**
		 *  Convert the given value from the type specified by Tone.Param.units
		 *  into the destination value (such as Gain or Frequency).
		 *  @private
		 *  @param  {*} val the value to convert
		 *  @return {number}     the number which the value should be set to
		 */
	    Tone.Param.prototype._fromUnits = function (val) {
	        if (this.convert || this.isUndef(this.convert)) {
	            switch (this.units) {
	            case Tone.Type.Time:
	                return this.toSeconds(val);
	            case Tone.Type.Frequency:
	                return this.toFrequency(val);
	            case Tone.Type.Decibels:
	                return this.dbToGain(val);
	            case Tone.Type.NormalRange:
	                return Math.min(Math.max(val, 0), 1);
	            case Tone.Type.AudioRange:
	                return Math.min(Math.max(val, -1), 1);
	            case Tone.Type.Positive:
	                return Math.max(val, 0);
	            default:
	                return val;
	            }
	        } else {
	            return val;
	        }
	    };
	    /**
		 * Convert the parameters value into the units specified by Tone.Param.units.
		 * @private
		 * @param  {number} val the value to convert
		 * @return {number}
		 */
	    Tone.Param.prototype._toUnits = function (val) {
	        if (this.convert || this.isUndef(this.convert)) {
	            switch (this.units) {
	            case Tone.Type.Decibels:
	                return this.gainToDb(val);
	            default:
	                return val;
	            }
	        } else {
	            return val;
	        }
	    };
	    /**
		 *  the minimum output value
		 *  @type {Number}
		 *  @private
		 */
	    Tone.Param.prototype._minOutput = 0.00001;
	    /**
		 *  Schedules a parameter value change at the given time.
		 *  @param {*}	value The value to set the signal.
		 *  @param {Time}  time The time when the change should occur.
		 *  @returns {Tone.Param} this
		 *  @example
		 * //set the frequency to "G4" in exactly 1 second from now. 
		 * freq.setValueAtTime("G4", "+1");
		 */
	    Tone.Param.prototype.setValueAtTime = function (value, time) {
	        value = this._fromUnits(value);
	        time = this.toSeconds(time);
	        if (time <= this.now() + this.blockTime) {
	            this._param.value = value;
	        } else {
	            this._param.setValueAtTime(value, time);
	        }
	        return this;
	    };
	    /**
		 *  Creates a schedule point with the current value at the current time.
		 *  This is useful for creating an automation anchor point in order to 
		 *  schedule changes from the current value. 
		 *
		 *  @param {number=} now (Optionally) pass the now value in. 
		 *  @returns {Tone.Param} this
		 */
	    Tone.Param.prototype.setRampPoint = function (now) {
	        now = this.defaultArg(now, this.now());
	        var currentVal = this._param.value;
	        // exponentialRampToValueAt cannot ever ramp from or to 0
	        // More info: https://bugzilla.mozilla.org/show_bug.cgi?id=1125600#c2
	        if (currentVal === 0) {
	            currentVal = this._minOutput;
	        }
	        this._param.setValueAtTime(currentVal, now);
	        return this;
	    };
	    /**
		 *  Schedules a linear continuous change in parameter value from the 
		 *  previous scheduled parameter value to the given value.
		 *  
		 *  @param  {number} value   
		 *  @param  {Time} endTime 
		 *  @returns {Tone.Param} this
		 */
	    Tone.Param.prototype.linearRampToValueAtTime = function (value, endTime) {
	        value = this._fromUnits(value);
	        this._param.linearRampToValueAtTime(value, this.toSeconds(endTime));
	        return this;
	    };
	    /**
		 *  Schedules an exponential continuous change in parameter value from 
		 *  the previous scheduled parameter value to the given value.
		 *  
		 *  @param  {number} value   
		 *  @param  {Time} endTime 
		 *  @returns {Tone.Param} this
		 */
	    Tone.Param.prototype.exponentialRampToValueAtTime = function (value, endTime) {
	        value = this._fromUnits(value);
	        value = Math.max(this._minOutput, value);
	        this._param.exponentialRampToValueAtTime(value, this.toSeconds(endTime));
	        return this;
	    };
	    /**
		 *  Schedules an exponential continuous change in parameter value from 
		 *  the current time and current value to the given value over the 
		 *  duration of the rampTime.
		 *  
		 *  @param  {number} value   The value to ramp to.
		 *  @param  {Time} rampTime the time that it takes the 
		 *                               value to ramp from it's current value
		 *  @param {Time}	[startTime=now] 	When the ramp should start. 
		 *  @returns {Tone.Param} this
		 *  @example
		 * //exponentially ramp to the value 2 over 4 seconds. 
		 * signal.exponentialRampToValue(2, 4);
		 */
	    Tone.Param.prototype.exponentialRampToValue = function (value, rampTime, startTime) {
	        startTime = this.toSeconds(startTime);
	        this.setRampPoint(startTime);
	        this.exponentialRampToValueAtTime(value, startTime + this.toSeconds(rampTime));
	        return this;
	    };
	    /**
		 *  Schedules an linear continuous change in parameter value from 
		 *  the current time and current value to the given value over the 
		 *  duration of the rampTime.
		 *  
		 *  @param  {number} value   The value to ramp to.
		 *  @param  {Time} rampTime the time that it takes the 
		 *                               value to ramp from it's current value
		 *  @param {Time}	[startTime=now] 	When the ramp should start. 
		 *  @returns {Tone.Param} this
		 *  @example
		 * //linearly ramp to the value 4 over 3 seconds. 
		 * signal.linearRampToValue(4, 3);
		 */
	    Tone.Param.prototype.linearRampToValue = function (value, rampTime, startTime) {
	        startTime = this.toSeconds(startTime);
	        this.setRampPoint(startTime);
	        this.linearRampToValueAtTime(value, startTime + this.toSeconds(rampTime));
	        return this;
	    };
	    /**
		 *  Start exponentially approaching the target value at the given time with
		 *  a rate having the given time constant.
		 *  @param {number} value        
		 *  @param {Time} startTime    
		 *  @param {number} timeConstant 
		 *  @returns {Tone.Param} this 
		 */
	    Tone.Param.prototype.setTargetAtTime = function (value, startTime, timeConstant) {
	        value = this._fromUnits(value);
	        // The value will never be able to approach without timeConstant > 0.
	        // http://www.w3.org/TR/webaudio/#dfn-setTargetAtTime, where the equation
	        // is described. 0 results in a division by 0.
	        value = Math.max(this._minOutput, value);
	        timeConstant = Math.max(this._minOutput, timeConstant);
	        this._param.setTargetAtTime(value, this.toSeconds(startTime), timeConstant);
	        return this;
	    };
	    /**
		 *  Sets an array of arbitrary parameter values starting at the given time
		 *  for the given duration.
		 *  	
		 *  @param {Array} values    
		 *  @param {Time} startTime 
		 *  @param {Time} duration  
		 *  @returns {Tone.Param} this
		 */
	    Tone.Param.prototype.setValueCurveAtTime = function (values, startTime, duration) {
	        for (var i = 0; i < values.length; i++) {
	            values[i] = this._fromUnits(values[i]);
	        }
	        this._param.setValueCurveAtTime(values, this.toSeconds(startTime), this.toSeconds(duration));
	        return this;
	    };
	    /**
		 *  Cancels all scheduled parameter changes with times greater than or 
		 *  equal to startTime.
		 *  
		 *  @param  {Time} startTime
		 *  @returns {Tone.Param} this
		 */
	    Tone.Param.prototype.cancelScheduledValues = function (startTime) {
	        this._param.cancelScheduledValues(this.toSeconds(startTime));
	        return this;
	    };
	    /**
		 *  Ramps to the given value over the duration of the rampTime. 
		 *  Automatically selects the best ramp type (exponential or linear)
		 *  depending on the `units` of the signal
		 *  
		 *  @param  {number} value   
		 *  @param  {Time} rampTime 	The time that it takes the 
		 *                              value to ramp from it's current value
		 *  @param {Time}	[startTime=now] 	When the ramp should start. 
		 *  @returns {Tone.Param} this
		 *  @example
		 * //ramp to the value either linearly or exponentially 
		 * //depending on the "units" value of the signal
		 * signal.rampTo(0, 10);
		 *  @example
		 * //schedule it to ramp starting at a specific time
		 * signal.rampTo(0, 10, 5)
		 */
	    Tone.Param.prototype.rampTo = function (value, rampTime, startTime) {
	        rampTime = this.defaultArg(rampTime, 0);
	        if (this.units === Tone.Type.Frequency || this.units === Tone.Type.BPM || this.units === Tone.Type.Decibels) {
	            this.exponentialRampToValue(value, rampTime, startTime);
	        } else {
	            this.linearRampToValue(value, rampTime, startTime);
	        }
	        return this;
	    };
	    /**
		 *  The LFO created by the signal instance. If none
		 *  was created, this is null.
		 *  @type {Tone.LFO}
		 *  @readOnly
		 *  @memberOf Tone.Param#
		 *  @name lfo
		 */
	    Object.defineProperty(Tone.Param.prototype, 'lfo', {
	        get: function () {
	            return this._lfo;
	        }
	    });
	    /**
		 *  Clean up
		 *  @returns {Tone.Param} this
		 */
	    Tone.Param.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._param = null;
	        if (this._lfo) {
	            this._lfo.dispose();
	            this._lfo = null;
	        }
	        return this;
	    };
	    return Tone.Param;
	});
	Module(function (Tone) {
	    
	    /**
		 *  createGain shim
		 *  @private
		 */
	    if (window.GainNode && !AudioContext.prototype.createGain) {
	        AudioContext.prototype.createGain = AudioContext.prototype.createGainNode;
	    }
	    /**
		 *  @class A thin wrapper around the Native Web Audio GainNode.
		 *         The GainNode is a basic building block of the Web Audio
		 *         API and is useful for routing audio and adjusting gains. 
		 *  @extends {Tone}
		 *  @param  {Number=}  gain  The initial gain of the GainNode
		 *  @param {Tone.Type=} units The units of the gain parameter. 
		 */
	    Tone.Gain = function () {
	        var options = this.optionsObject(arguments, [
	            'gain',
	            'units'
	        ], Tone.Gain.defaults);
	        /**
			 *  The GainNode
			 *  @type  {GainNode}
			 *  @private
			 */
	        this.input = this.output = this._gainNode = this.context.createGain();
	        /**
			 *  The gain parameter of the gain node.
			 *  @type {Tone.Param}
			 *  @signal
			 */
	        this.gain = new Tone.Param({
	            'param': this._gainNode.gain,
	            'units': options.units,
	            'value': options.gain,
	            'convert': options.convert
	        });
	        this._readOnly('gain');
	    };
	    Tone.extend(Tone.Gain);
	    /**
		 *  The defaults
		 *  @const
		 *  @type  {Object}
		 */
	    Tone.Gain.defaults = {
	        'gain': 1,
	        'convert': true
	    };
	    /**
		 *  Clean up.
		 *  @return  {Tone.Gain}  this
		 */
	    Tone.Gain.prototype.dispose = function () {
	        Tone.Param.prototype.dispose.call(this);
	        this._gainNode.disconnect();
	        this._gainNode = null;
	        this._writable('gain');
	        this.gain.dispose();
	        this.gain = null;
	    };
	    //STATIC///////////////////////////////////////////////////////////////////
	    /**
		 *  Create input and outputs for this object.
		 *  @param  {Number}  input   The number of inputs
		 *  @param  {Number=}  outputs  The number of outputs
		 *  @return  {Tone}  this
		 *  @internal
		 */
	    Tone.prototype.createInsOuts = function (inputs, outputs) {
	        if (inputs === 1) {
	            this.input = new Tone.Gain();
	        } else if (inputs > 1) {
	            this.input = new Array(inputs);
	        }
	        if (outputs === 1) {
	            this.output = new Tone.Gain();
	        } else if (outputs > 1) {
	            this.output = new Array(inputs);
	        }
	    };
	    ///////////////////////////////////////////////////////////////////////////
	    return Tone.Gain;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  A signal is an audio-rate value. Tone.Signal is a core component of the library.
		 *          Unlike a number, Signals can be scheduled with sample-level accuracy. Tone.Signal
		 *          has all of the methods available to native Web Audio 
		 *          [AudioParam](http://webaudio.github.io/web-audio-api/#the-audioparam-interface)
		 *          as well as additional conveniences. Read more about working with signals 
		 *          [here](https://github.com/Tonejs/Tone.js/wiki/Signals).
		 *
		 *  @constructor
		 *  @extends {Tone.Param}
		 *  @param {Number|AudioParam} [value] Initial value of the signal. If an AudioParam
		 *                                     is passed in, that parameter will be wrapped
		 *                                     and controlled by the Signal. 
		 *  @param {string} [units=Number] unit The units the signal is in. 
		 *  @example
		 * var signal = new Tone.Signal(10);
		 */
	    Tone.Signal = function () {
	        var options = this.optionsObject(arguments, [
	            'value',
	            'units'
	        ], Tone.Signal.defaults);
	        /**
			 * The node where the constant signal value is scaled.
			 * @type {GainNode}
			 * @private
			 */
	        this.output = this._gain = this.context.createGain();
	        options.param = this._gain.gain;
	        Tone.Param.call(this, options);
	        /**
			 * The node where the value is set.
			 * @type {Tone.Param}
			 * @private
			 */
	        this.input = this._param = this._gain.gain;
	        //connect the const output to the node output
	        this.context.getConstant(1).chain(this._gain);
	    };
	    Tone.extend(Tone.Signal, Tone.Param);
	    /**
		 *  The default values
		 *  @type  {Object}
		 *  @static
		 *  @const
		 */
	    Tone.Signal.defaults = {
	        'value': 0,
	        'units': Tone.Type.Default,
	        'convert': true
	    };
	    /**
		 *  When signals connect to other signals or AudioParams, 
		 *  they take over the output value of that signal or AudioParam. 
		 *  For all other nodes, the behavior is the same as a default <code>connect</code>. 
		 *
		 *  @override
		 *  @param {AudioParam|AudioNode|Tone.Signal|Tone} node 
		 *  @param {number} [outputNumber=0] The output number to connect from.
		 *  @param {number} [inputNumber=0] The input number to connect to.
		 *  @returns {Tone.SignalBase} this
		 *  @method
		 */
	    Tone.Signal.prototype.connect = Tone.SignalBase.prototype.connect;
	    /**
		 *  dispose and disconnect
		 *  @returns {Tone.Signal} this
		 */
	    Tone.Signal.prototype.dispose = function () {
	        Tone.Param.prototype.dispose.call(this);
	        this._param = null;
	        this._gain.disconnect();
	        this._gain = null;
	        return this;
	    };
	    return Tone.Signal;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class A Timeline class for scheduling and maintaining state
		 *         along a timeline. All events must have a "time" property. 
		 *         Internally, events are stored in time order for fast 
		 *         retrieval.
		 *  @extends {Tone}
		 *  @param {Positive} [memory=Infinity] The number of previous events that are retained.
		 */
	    Tone.Timeline = function () {
	        var options = this.optionsObject(arguments, ['memory'], Tone.Timeline.defaults);
	        /**
			 *  The array of scheduled timeline events
			 *  @type  {Array}
			 *  @private
			 */
	        this._timeline = [];
	        /**
			 *  An array of items to remove from the list. 
			 *  @type {Array}
			 *  @private
			 */
	        this._toRemove = [];
	        /**
			 *  Flag if the tieline is mid iteration
			 *  @private
			 *  @type {Boolean}
			 */
	        this._iterating = false;
	        /**
			 *  The memory of the timeline, i.e.
			 *  how many events in the past it will retain
			 *  @type {Positive}
			 */
	        this.memory = options.memory;
	    };
	    Tone.extend(Tone.Timeline);
	    /**
		 *  the default parameters
		 *  @static
		 *  @const
		 */
	    Tone.Timeline.defaults = { 'memory': Infinity };
	    /**
		 *  The number of items in the timeline.
		 *  @type {Number}
		 *  @memberOf Tone.Timeline#
		 *  @name length
		 *  @readOnly
		 */
	    Object.defineProperty(Tone.Timeline.prototype, 'length', {
	        get: function () {
	            return this._timeline.length;
	        }
	    });
	    /**
		 *  Insert an event object onto the timeline. Events must have a "time" attribute.
		 *  @param  {Object}  event  The event object to insert into the 
		 *                           timeline. 
		 *  @returns {Tone.Timeline} this
		 */
	    Tone.Timeline.prototype.add = function (event) {
	        //the event needs to have a time attribute
	        if (this.isUndef(event.time)) {
	            throw new Error('Tone.Timeline: events must have a time attribute');
	        }
	        if (this._timeline.length) {
	            var index = this._search(event.time);
	            this._timeline.splice(index + 1, 0, event);
	        } else {
	            this._timeline.push(event);
	        }
	        //if the length is more than the memory, remove the previous ones
	        if (this.length > this.memory) {
	            var diff = this.length - this.memory;
	            this._timeline.splice(0, diff);
	        }
	        return this;
	    };
	    /**
		 *  Remove an event from the timeline.
		 *  @param  {Object}  event  The event object to remove from the list.
		 *  @returns {Tone.Timeline} this
		 */
	    Tone.Timeline.prototype.remove = function (event) {
	        if (this._iterating) {
	            this._toRemove.push(event);
	        } else {
	            var index = this._timeline.indexOf(event);
	            if (index !== -1) {
	                this._timeline.splice(index, 1);
	            }
	        }
	        return this;
	    };
	    /**
		 *  Get the nearest event whose time is less than or equal to the given time.
		 *  @param  {Number}  time  The time to query.
		 *  @returns {Object} The event object set after that time.
		 */
	    Tone.Timeline.prototype.get = function (time) {
	        var index = this._search(time);
	        if (index !== -1) {
	            return this._timeline[index];
	        } else {
	            return null;
	        }
	    };
	    /**
		 *  Return the first event in the timeline without removing it
		 *  @returns {Object} The first event object
		 */
	    Tone.Timeline.prototype.peek = function () {
	        return this._timeline[0];
	    };
	    /**
		 *  Return the first event in the timeline and remove it
		 *  @returns {Object} The first event object
		 */
	    Tone.Timeline.prototype.shift = function () {
	        return this._timeline.shift();
	    };
	    /**
		 *  Get the event which is scheduled after the given time.
		 *  @param  {Number}  time  The time to query.
		 *  @returns {Object} The event object after the given time
		 */
	    Tone.Timeline.prototype.getAfter = function (time) {
	        var index = this._search(time);
	        if (index + 1 < this._timeline.length) {
	            return this._timeline[index + 1];
	        } else {
	            return null;
	        }
	    };
	    /**
		 *  Get the event before the event at the given time.
		 *  @param  {Number}  time  The time to query.
		 *  @returns {Object} The event object before the given time
		 */
	    Tone.Timeline.prototype.getBefore = function (time) {
	        var len = this._timeline.length;
	        //if it's after the last item, return the last item
	        if (len > 0 && this._timeline[len - 1].time < time) {
	            return this._timeline[len - 1];
	        }
	        var index = this._search(time);
	        if (index - 1 >= 0) {
	            return this._timeline[index - 1];
	        } else {
	            return null;
	        }
	    };
	    /**
		 *  Cancel events after the given time
		 *  @param  {Number}  time  The time to query.
		 *  @returns {Tone.Timeline} this
		 */
	    Tone.Timeline.prototype.cancel = function (after) {
	        if (this._timeline.length > 1) {
	            var index = this._search(after);
	            if (index >= 0) {
	                if (this._timeline[index].time === after) {
	                    //get the first item with that time
	                    for (var i = index; i >= 0; i--) {
	                        if (this._timeline[i].time === after) {
	                            index = i;
	                        } else {
	                            break;
	                        }
	                    }
	                    this._timeline = this._timeline.slice(0, index);
	                } else {
	                    this._timeline = this._timeline.slice(0, index + 1);
	                }
	            } else {
	                this._timeline = [];
	            }
	        } else if (this._timeline.length === 1) {
	            //the first item's time
	            if (this._timeline[0].time >= after) {
	                this._timeline = [];
	            }
	        }
	        return this;
	    };
	    /**
		 *  Cancel events before or equal to the given time.
		 *  @param  {Number}  time  The time to cancel before.
		 *  @returns {Tone.Timeline} this
		 */
	    Tone.Timeline.prototype.cancelBefore = function (time) {
	        if (this._timeline.length) {
	            var index = this._search(time);
	            if (index >= 0) {
	                this._timeline = this._timeline.slice(index + 1);
	            }
	        }
	        return this;
	    };
	    /**
		 *  Does a binary serach on the timeline array and returns the 
		 *  nearest event index whose time is after or equal to the given time.
		 *  If a time is searched before the first index in the timeline, -1 is returned.
		 *  If the time is after the end, the index of the last item is returned.
		 *  @param  {Number}  time  
		 *  @return  {Number} the index in the timeline array 
		 *  @private
		 */
	    Tone.Timeline.prototype._search = function (time) {
	        var beginning = 0;
	        var len = this._timeline.length;
	        var end = len;
	        if (len > 0 && this._timeline[len - 1].time <= time) {
	            return len - 1;
	        }
	        while (beginning < end) {
	            // calculate the midpoint for roughly equal partition
	            var midPoint = Math.floor(beginning + (end - beginning) / 2);
	            var event = this._timeline[midPoint];
	            var nextEvent = this._timeline[midPoint + 1];
	            if (event.time === time) {
	                //choose the last one that has the same time
	                for (var i = midPoint; i < this._timeline.length; i++) {
	                    var testEvent = this._timeline[i];
	                    if (testEvent.time === time) {
	                        midPoint = i;
	                    }
	                }
	                return midPoint;
	            } else if (event.time < time && nextEvent.time > time) {
	                return midPoint;
	            } else if (event.time > time) {
	                //search lower
	                end = midPoint;
	            } else if (event.time < time) {
	                //search upper
	                beginning = midPoint + 1;
	            }
	        }
	        return -1;
	    };
	    /**
		 *  Internal iterator. Applies extra safety checks for 
		 *  removing items from the array. 
		 *  @param  {Function}  callback 
		 *  @param  {Number=}    lowerBound     
		 *  @param  {Number=}    upperBound    
		 *  @private
		 */
	    Tone.Timeline.prototype._iterate = function (callback, lowerBound, upperBound) {
	        this._iterating = true;
	        lowerBound = this.defaultArg(lowerBound, 0);
	        upperBound = this.defaultArg(upperBound, this._timeline.length - 1);
	        for (var i = lowerBound; i <= upperBound; i++) {
	            callback(this._timeline[i]);
	        }
	        this._iterating = false;
	        if (this._toRemove.length > 0) {
	            for (var j = 0; j < this._toRemove.length; j++) {
	                var index = this._timeline.indexOf(this._toRemove[j]);
	                if (index !== -1) {
	                    this._timeline.splice(index, 1);
	                }
	            }
	            this._toRemove = [];
	        }
	    };
	    /**
		 *  Iterate over everything in the array
		 *  @param  {Function}  callback The callback to invoke with every item
		 *  @returns {Tone.Timeline} this
		 */
	    Tone.Timeline.prototype.forEach = function (callback) {
	        this._iterate(callback);
	        return this;
	    };
	    /**
		 *  Iterate over everything in the array at or before the given time.
		 *  @param  {Number}  time The time to check if items are before
		 *  @param  {Function}  callback The callback to invoke with every item
		 *  @returns {Tone.Timeline} this
		 */
	    Tone.Timeline.prototype.forEachBefore = function (time, callback) {
	        //iterate over the items in reverse so that removing an item doesn't break things
	        var upperBound = this._search(time);
	        if (upperBound !== -1) {
	            this._iterate(callback, 0, upperBound);
	        }
	        return this;
	    };
	    /**
		 *  Iterate over everything in the array after the given time.
		 *  @param  {Number}  time The time to check if items are before
		 *  @param  {Function}  callback The callback to invoke with every item
		 *  @returns {Tone.Timeline} this
		 */
	    Tone.Timeline.prototype.forEachAfter = function (time, callback) {
	        //iterate over the items in reverse so that removing an item doesn't break things
	        var lowerBound = this._search(time);
	        this._iterate(callback, lowerBound + 1);
	        return this;
	    };
	    /**
		 *  Iterate over everything in the array at or after the given time. Similar to 
		 *  forEachAfter, but includes the item(s) at the given time.
		 *  @param  {Number}  time The time to check if items are before
		 *  @param  {Function}  callback The callback to invoke with every item
		 *  @returns {Tone.Timeline} this
		 */
	    Tone.Timeline.prototype.forEachFrom = function (time, callback) {
	        //iterate over the items in reverse so that removing an item doesn't break things
	        var lowerBound = this._search(time);
	        //work backwards until the event time is less than time
	        while (lowerBound >= 0 && this._timeline[lowerBound].time >= time) {
	            lowerBound--;
	        }
	        this._iterate(callback, lowerBound + 1);
	        return this;
	    };
	    /**
		 *  Iterate over everything in the array at the given time
		 *  @param  {Number}  time The time to check if items are before
		 *  @param  {Function}  callback The callback to invoke with every item
		 *  @returns {Tone.Timeline} this
		 */
	    Tone.Timeline.prototype.forEachAtTime = function (time, callback) {
	        //iterate over the items in reverse so that removing an item doesn't break things
	        var upperBound = this._search(time);
	        if (upperBound !== -1) {
	            this._iterate(function (event) {
	                if (event.time === time) {
	                    callback(event);
	                }
	            }, 0, upperBound);
	        }
	        return this;
	    };
	    /**
		 *  Clean up.
		 *  @return  {Tone.Timeline}  this
		 */
	    Tone.Timeline.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._timeline = null;
	        this._toRemove = null;
	    };
	    return Tone.Timeline;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class A signal which adds the method getValueAtTime. 
		 *         Code and inspiration from https://github.com/jsantell/web-audio-automation-timeline
		 *  @extends {Tone.Param}
		 *  @param {Number=} value The initial value of the signal
		 *  @param {String=} units The conversion units of the signal.
		 */
	    Tone.TimelineSignal = function () {
	        var options = this.optionsObject(arguments, [
	            'value',
	            'units'
	        ], Tone.Signal.defaults);
	        /**
			 *  The scheduled events
			 *  @type {Tone.Timeline}
			 *  @private
			 */
	        this._events = new Tone.Timeline(10);
	        //constructors
	        Tone.Signal.apply(this, options);
	        options.param = this._param;
	        Tone.Param.call(this, options);
	        /**
			 *  The initial scheduled value
			 *  @type {Number}
			 *  @private
			 */
	        this._initial = this._fromUnits(this._param.value);
	    };
	    Tone.extend(Tone.TimelineSignal, Tone.Param);
	    /**
		 *  The event types of a schedulable signal.
		 *  @enum {String}
		 *  @private
		 */
	    Tone.TimelineSignal.Type = {
	        Linear: 'linear',
	        Exponential: 'exponential',
	        Target: 'target',
	        Curve: 'curve',
	        Set: 'set'
	    };
	    /**
		 * The current value of the signal. 
		 * @memberOf Tone.TimelineSignal#
		 * @type {Number}
		 * @name value
		 */
	    Object.defineProperty(Tone.TimelineSignal.prototype, 'value', {
	        get: function () {
	            var now = this.now();
	            var val = this.getValueAtTime(now);
	            return this._toUnits(val);
	        },
	        set: function (value) {
	            var convertedVal = this._fromUnits(value);
	            this._initial = convertedVal;
	            this.cancelScheduledValues();
	            this._param.value = convertedVal;
	        }
	    });
	    ///////////////////////////////////////////////////////////////////////////
	    //	SCHEDULING
	    ///////////////////////////////////////////////////////////////////////////
	    /**
		 *  Schedules a parameter value change at the given time.
		 *  @param {*}	value The value to set the signal.
		 *  @param {Time}  time The time when the change should occur.
		 *  @returns {Tone.TimelineSignal} this
		 *  @example
		 * //set the frequency to "G4" in exactly 1 second from now. 
		 * freq.setValueAtTime("G4", "+1");
		 */
	    Tone.TimelineSignal.prototype.setValueAtTime = function (value, startTime) {
	        value = this._fromUnits(value);
	        startTime = this.toSeconds(startTime);
	        this._events.add({
	            'type': Tone.TimelineSignal.Type.Set,
	            'value': value,
	            'time': startTime
	        });
	        //invoke the original event
	        this._param.setValueAtTime(value, startTime);
	        return this;
	    };
	    /**
		 *  Schedules a linear continuous change in parameter value from the 
		 *  previous scheduled parameter value to the given value.
		 *  
		 *  @param  {number} value   
		 *  @param  {Time} endTime 
		 *  @returns {Tone.TimelineSignal} this
		 */
	    Tone.TimelineSignal.prototype.linearRampToValueAtTime = function (value, endTime) {
	        value = this._fromUnits(value);
	        endTime = this.toSeconds(endTime);
	        this._events.add({
	            'type': Tone.TimelineSignal.Type.Linear,
	            'value': value,
	            'time': endTime
	        });
	        this._param.linearRampToValueAtTime(value, endTime);
	        return this;
	    };
	    /**
		 *  Schedules an exponential continuous change in parameter value from 
		 *  the previous scheduled parameter value to the given value.
		 *  
		 *  @param  {number} value   
		 *  @param  {Time} endTime 
		 *  @returns {Tone.TimelineSignal} this
		 */
	    Tone.TimelineSignal.prototype.exponentialRampToValueAtTime = function (value, endTime) {
	        //get the previous event and make sure it's not starting from 0
	        endTime = this.toSeconds(endTime);
	        var beforeEvent = this._searchBefore(endTime);
	        if (beforeEvent && beforeEvent.value === 0) {
	            //reschedule that event
	            this.setValueAtTime(this._minOutput, beforeEvent.time);
	        }
	        value = this._fromUnits(value);
	        var setValue = Math.max(value, this._minOutput);
	        this._events.add({
	            'type': Tone.TimelineSignal.Type.Exponential,
	            'value': setValue,
	            'time': endTime
	        });
	        //if the ramped to value is 0, make it go to the min output, and then set to 0.
	        if (value < this._minOutput) {
	            this._param.exponentialRampToValueAtTime(this._minOutput, endTime - this.sampleTime);
	            this.setValueAtTime(0, endTime);
	        } else {
	            this._param.exponentialRampToValueAtTime(value, endTime);
	        }
	        return this;
	    };
	    /**
		 *  Start exponentially approaching the target value at the given time with
		 *  a rate having the given time constant.
		 *  @param {number} value        
		 *  @param {Time} startTime    
		 *  @param {number} timeConstant 
		 *  @returns {Tone.TimelineSignal} this 
		 */
	    Tone.TimelineSignal.prototype.setTargetAtTime = function (value, startTime, timeConstant) {
	        value = this._fromUnits(value);
	        value = Math.max(this._minOutput, value);
	        timeConstant = Math.max(this._minOutput, timeConstant);
	        startTime = this.toSeconds(startTime);
	        this._events.add({
	            'type': Tone.TimelineSignal.Type.Target,
	            'value': value,
	            'time': startTime,
	            'constant': timeConstant
	        });
	        this._param.setTargetAtTime(value, startTime, timeConstant);
	        return this;
	    };
	    /**
		 *  Set an array of arbitrary values starting at the given time for the given duration.
		 *  @param {Float32Array} values        
		 *  @param {Time} startTime    
		 *  @param {Time} duration
		 *  @param {NormalRange} [scaling=1] If the values in the curve should be scaled by some value
		 *  @returns {Tone.TimelineSignal} this 
		 */
	    Tone.TimelineSignal.prototype.setValueCurveAtTime = function (values, startTime, duration, scaling) {
	        scaling = this.defaultArg(scaling, 1);
	        //copy the array
	        var floats = new Array(values.length);
	        for (var i = 0; i < floats.length; i++) {
	            floats[i] = this._fromUnits(values[i]) * scaling;
	        }
	        startTime = this.toSeconds(startTime);
	        duration = this.toSeconds(duration);
	        this._events.add({
	            'type': Tone.TimelineSignal.Type.Curve,
	            'value': floats,
	            'time': startTime,
	            'duration': duration
	        });
	        //set the first value
	        this._param.setValueAtTime(floats[0], startTime);
	        //schedule a lienar ramp for each of the segments
	        for (var j = 1; j < floats.length; j++) {
	            var segmentTime = startTime + j / (floats.length - 1) * duration;
	            this._param.linearRampToValueAtTime(floats[j], segmentTime);
	        }
	        return this;
	    };
	    /**
		 *  Cancels all scheduled parameter changes with times greater than or 
		 *  equal to startTime.
		 *  
		 *  @param  {Time} startTime
		 *  @returns {Tone.TimelineSignal} this
		 */
	    Tone.TimelineSignal.prototype.cancelScheduledValues = function (after) {
	        after = this.toSeconds(after);
	        this._events.cancel(after);
	        this._param.cancelScheduledValues(after);
	        return this;
	    };
	    /**
		 *  Sets the computed value at the given time. This provides
		 *  a point from which a linear or exponential curve
		 *  can be scheduled after. Will cancel events after 
		 *  the given time and shorten the currently scheduled
		 *  linear or exponential ramp so that it ends at `time` .
		 *  This is to avoid discontinuities and clicks in envelopes. 
		 *  @param {Time} time When to set the ramp point
		 *  @returns {Tone.TimelineSignal} this
		 */
	    Tone.TimelineSignal.prototype.setRampPoint = function (time) {
	        time = this.toSeconds(time);
	        //get the value at the given time
	        var val = this._toUnits(this.getValueAtTime(time));
	        //if there is an event at the given time
	        //and that even is not a "set"
	        var before = this._searchBefore(time);
	        if (before && before.time === time) {
	            //remove everything after
	            this.cancelScheduledValues(time + this.sampleTime);
	        } else if (before && before.type === Tone.TimelineSignal.Type.Curve && before.time + before.duration > time) {
	            //if the curve is still playing
	            //cancel the curve
	            this.cancelScheduledValues(time);
	            this.linearRampToValueAtTime(val, time);
	        } else {
	            //reschedule the next event to end at the given time
	            var after = this._searchAfter(time);
	            if (after) {
	                //cancel the next event(s)
	                this.cancelScheduledValues(time);
	                if (after.type === Tone.TimelineSignal.Type.Linear) {
	                    this.linearRampToValueAtTime(val, time);
	                } else if (after.type === Tone.TimelineSignal.Type.Exponential) {
	                    this.exponentialRampToValueAtTime(val, time);
	                }
	            }
	            this.setValueAtTime(val, time);
	        }
	        return this;
	    };
	    /**
		 *  Do a linear ramp to the given value between the start and finish times.
		 *  @param {Number} value The value to ramp to.
		 *  @param {Time} start The beginning anchor point to do the linear ramp
		 *  @param {Time} finish The ending anchor point by which the value of
		 *                       the signal will equal the given value.
		 *  @returns {Tone.TimelineSignal} this
		 */
	    Tone.TimelineSignal.prototype.linearRampToValueBetween = function (value, start, finish) {
	        this.setRampPoint(start);
	        this.linearRampToValueAtTime(value, finish);
	        return this;
	    };
	    /**
		 *  Do a exponential ramp to the given value between the start and finish times.
		 *  @param {Number} value The value to ramp to.
		 *  @param {Time} start The beginning anchor point to do the exponential ramp
		 *  @param {Time} finish The ending anchor point by which the value of
		 *                       the signal will equal the given value.
		 *  @returns {Tone.TimelineSignal} this
		 */
	    Tone.TimelineSignal.prototype.exponentialRampToValueBetween = function (value, start, finish) {
	        this.setRampPoint(start);
	        this.exponentialRampToValueAtTime(value, finish);
	        return this;
	    };
	    ///////////////////////////////////////////////////////////////////////////
	    //	GETTING SCHEDULED VALUES
	    ///////////////////////////////////////////////////////////////////////////
	    /**
		 *  Returns the value before or equal to the given time
		 *  @param  {Number}  time  The time to query
		 *  @return  {Object}  The event at or before the given time.
		 *  @private
		 */
	    Tone.TimelineSignal.prototype._searchBefore = function (time) {
	        return this._events.get(time);
	    };
	    /**
		 *  The event after the given time
		 *  @param  {Number}  time  The time to query.
		 *  @return  {Object}  The next event after the given time
		 *  @private
		 */
	    Tone.TimelineSignal.prototype._searchAfter = function (time) {
	        return this._events.getAfter(time);
	    };
	    /**
		 *  Get the scheduled value at the given time. This will
		 *  return the unconverted (raw) value.
		 *  @param  {Number}  time  The time in seconds.
		 *  @return  {Number}  The scheduled value at the given time.
		 */
	    Tone.TimelineSignal.prototype.getValueAtTime = function (time) {
	        time = this.toSeconds(time);
	        var after = this._searchAfter(time);
	        var before = this._searchBefore(time);
	        var value = this._initial;
	        //if it was set by
	        if (before === null) {
	            value = this._initial;
	        } else if (before.type === Tone.TimelineSignal.Type.Target) {
	            var previous = this._events.getBefore(before.time);
	            var previouVal;
	            if (previous === null) {
	                previouVal = this._initial;
	            } else {
	                previouVal = previous.value;
	            }
	            value = this._exponentialApproach(before.time, previouVal, before.value, before.constant, time);
	        } else if (before.type === Tone.TimelineSignal.Type.Curve) {
	            value = this._curveInterpolate(before.time, before.value, before.duration, time);
	        } else if (after === null) {
	            value = before.value;
	        } else if (after.type === Tone.TimelineSignal.Type.Linear) {
	            value = this._linearInterpolate(before.time, before.value, after.time, after.value, time);
	        } else if (after.type === Tone.TimelineSignal.Type.Exponential) {
	            value = this._exponentialInterpolate(before.time, before.value, after.time, after.value, time);
	        } else {
	            value = before.value;
	        }
	        return value;
	    };
	    /**
		 *  When signals connect to other signals or AudioParams, 
		 *  they take over the output value of that signal or AudioParam. 
		 *  For all other nodes, the behavior is the same as a default <code>connect</code>. 
		 *
		 *  @override
		 *  @param {AudioParam|AudioNode|Tone.Signal|Tone} node 
		 *  @param {number} [outputNumber=0] The output number to connect from.
		 *  @param {number} [inputNumber=0] The input number to connect to.
		 *  @returns {Tone.TimelineSignal} this
		 *  @method
		 */
	    Tone.TimelineSignal.prototype.connect = Tone.SignalBase.prototype.connect;
	    ///////////////////////////////////////////////////////////////////////////
	    //	AUTOMATION CURVE CALCULATIONS
	    //	MIT License, copyright (c) 2014 Jordan Santell
	    ///////////////////////////////////////////////////////////////////////////
	    /**
		 *  Calculates the the value along the curve produced by setTargetAtTime
		 *  @private
		 */
	    Tone.TimelineSignal.prototype._exponentialApproach = function (t0, v0, v1, timeConstant, t) {
	        return v1 + (v0 - v1) * Math.exp(-(t - t0) / timeConstant);
	    };
	    /**
		 *  Calculates the the value along the curve produced by linearRampToValueAtTime
		 *  @private
		 */
	    Tone.TimelineSignal.prototype._linearInterpolate = function (t0, v0, t1, v1, t) {
	        return v0 + (v1 - v0) * ((t - t0) / (t1 - t0));
	    };
	    /**
		 *  Calculates the the value along the curve produced by exponentialRampToValueAtTime
		 *  @private
		 */
	    Tone.TimelineSignal.prototype._exponentialInterpolate = function (t0, v0, t1, v1, t) {
	        v0 = Math.max(this._minOutput, v0);
	        return v0 * Math.pow(v1 / v0, (t - t0) / (t1 - t0));
	    };
	    /**
		 *  Calculates the the value along the curve produced by setValueCurveAtTime
		 *  @private
		 */
	    Tone.TimelineSignal.prototype._curveInterpolate = function (start, curve, duration, time) {
	        var len = curve.length;
	        // If time is after duration, return the last curve value
	        if (time >= start + duration) {
	            return curve[len - 1];
	        } else if (time <= start) {
	            return curve[0];
	        } else {
	            var progress = (time - start) / duration;
	            var lowerIndex = Math.floor((len - 1) * progress);
	            var upperIndex = Math.ceil((len - 1) * progress);
	            var lowerVal = curve[lowerIndex];
	            var upperVal = curve[upperIndex];
	            if (upperIndex === lowerIndex) {
	                return lowerVal;
	            } else {
	                return this._linearInterpolate(lowerIndex, lowerVal, upperIndex, upperVal, progress * (len - 1));
	            }
	        }
	    };
	    /**
		 *  Clean up.
		 *  @return {Tone.TimelineSignal} this
		 */
	    Tone.TimelineSignal.prototype.dispose = function () {
	        Tone.Signal.prototype.dispose.call(this);
	        Tone.Param.prototype.dispose.call(this);
	        this._events.dispose();
	        this._events = null;
	    };
	    return Tone.TimelineSignal;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Pow applies an exponent to the incoming signal. The incoming signal
		 *         must be AudioRange.
		 *
		 *  @extends {Tone.SignalBase}
		 *  @constructor
		 *  @param {Positive} exp The exponent to apply to the incoming signal, must be at least 2. 
		 *  @example
		 * var pow = new Tone.Pow(2);
		 * var sig = new Tone.Signal(0.5).connect(pow);
		 * //output of pow is 0.25. 
		 */
	    Tone.Pow = function (exp) {
	        /**
			 * the exponent
			 * @private
			 * @type {number}
			 */
	        this._exp = this.defaultArg(exp, 1);
	        /**
			 *  @type {WaveShaperNode}
			 *  @private
			 */
	        this._expScaler = this.input = this.output = new Tone.WaveShaper(this._expFunc(this._exp), 8192);
	    };
	    Tone.extend(Tone.Pow, Tone.SignalBase);
	    /**
		 * The value of the exponent.
		 * @memberOf Tone.Pow#
		 * @type {number}
		 * @name value
		 */
	    Object.defineProperty(Tone.Pow.prototype, 'value', {
	        get: function () {
	            return this._exp;
	        },
	        set: function (exp) {
	            this._exp = exp;
	            this._expScaler.setMap(this._expFunc(this._exp));
	        }
	    });
	    /**
		 *  the function which maps the waveshaper
		 *  @param   {number} exp
		 *  @return {function}
		 *  @private
		 */
	    Tone.Pow.prototype._expFunc = function (exp) {
	        return function (val) {
	            return Math.pow(Math.abs(val), exp);
	        };
	    };
	    /**
		 *  Clean up.
		 *  @returns {Tone.Pow} this
		 */
	    Tone.Pow.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._expScaler.dispose();
	        this._expScaler = null;
	        return this;
	    };
	    return Tone.Pow;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  Tone.Envelope is an [ADSR](https://en.wikipedia.org/wiki/Synthesizer#ADSR_envelope)
		 *          envelope generator. Tone.Envelope outputs a signal which 
		 *          can be connected to an AudioParam or Tone.Signal. 
		 *          <img src="https://upload.wikimedia.org/wikipedia/commons/e/ea/ADSR_parameter.svg">
		 *
		 *  @constructor
		 *  @extends {Tone}
		 *  @param {Time} [attack] The amount of time it takes for the envelope to go from 
		 *                         0 to it's maximum value. 
		 *  @param {Time} [decay]	The period of time after the attack that it takes for the envelope
		 *                       	to fall to the sustain value. 
		 *  @param {NormalRange} [sustain]	The percent of the maximum value that the envelope rests at until
		 *                                	the release is triggered. 
		 *  @param {Time} [release]	The amount of time after the release is triggered it takes to reach 0. 
		 *  @example
		 * //an amplitude envelope
		 * var gainNode = Tone.context.createGain();
		 * var env = new Tone.Envelope({
		 * 	"attack" : 0.1,
		 * 	"decay" : 0.2,
		 * 	"sustain" : 1,
		 * 	"release" : 0.8,
		 * });
		 * env.connect(gainNode.gain);
		 */
	    Tone.Envelope = function () {
	        //get all of the defaults
	        var options = this.optionsObject(arguments, [
	            'attack',
	            'decay',
	            'sustain',
	            'release'
	        ], Tone.Envelope.defaults);
	        /** 
			 *  When triggerAttack is called, the attack time is the amount of
			 *  time it takes for the envelope to reach it's maximum value. 
			 *  @type {Time}
			 */
	        this.attack = options.attack;
	        /**
			 *  After the attack portion of the envelope, the value will fall
			 *  over the duration of the decay time to it's sustain value. 
			 *  @type {Time}
			 */
	        this.decay = options.decay;
	        /**
			 * 	The sustain value is the value 
			 * 	which the envelope rests at after triggerAttack is
			 * 	called, but before triggerRelease is invoked. 
			 *  @type {NormalRange}
			 */
	        this.sustain = options.sustain;
	        /**
			 *  After triggerRelease is called, the envelope's
			 *  value will fall to it's miminum value over the
			 *  duration of the release time. 
			 *  @type {Time}
			 */
	        this.release = options.release;
	        /**
			 *  the next time the envelope is at standby
			 *  @type {number}
			 *  @private
			 */
	        this._attackCurve = 'linear';
	        /**
			 *  the next time the envelope is at standby
			 *  @type {number}
			 *  @private
			 */
	        this._releaseCurve = 'exponential';
	        /**
			 *  the signal
			 *  @type {Tone.TimelineSignal}
			 *  @private
			 */
	        this._sig = this.output = new Tone.TimelineSignal();
	        this._sig.setValueAtTime(0, 0);
	        //set the attackCurve initially
	        this.attackCurve = options.attackCurve;
	        this.releaseCurve = options.releaseCurve;
	    };
	    Tone.extend(Tone.Envelope);
	    /**
		 *  the default parameters
		 *  @static
		 *  @const
		 */
	    Tone.Envelope.defaults = {
	        'attack': 0.01,
	        'decay': 0.1,
	        'sustain': 0.5,
	        'release': 1,
	        'attackCurve': 'linear',
	        'releaseCurve': 'exponential'
	    };
	    /**
		 * Read the current value of the envelope. Useful for 
		 * syncronizing visual output to the envelope. 
		 * @memberOf Tone.Envelope#
		 * @type {Number}
		 * @name value
		 * @readOnly
		 */
	    Object.defineProperty(Tone.Envelope.prototype, 'value', {
	        get: function () {
	            return this.getValueAtTime(this.now());
	        }
	    });
	    /**
		 * The shape of the attack. 
		 * Can be any of these strings:
		 * <ul>
		 *   <li>linear</li>
		 *   <li>exponential</li>
		 *   <li>sine</li>
		 *   <li>cosine</li>
		 *   <li>bounce</li>
		 *   <li>ripple</li>
		 *   <li>step</li>
		 * </ul>
		 * Can also be an array which describes the curve. Values
		 * in the array are evenly subdivided and linearly
		 * interpolated over the duration of the attack. 
		 * @memberOf Tone.Envelope#
		 * @type {String|Array}
		 * @name attackCurve
		 * @example
		 * env.attackCurve = "linear";
		 * @example
		 * //can also be an array
		 * env.attackCurve = [0, 0.2, 0.3, 0.4, 1]
		 */
	    Object.defineProperty(Tone.Envelope.prototype, 'attackCurve', {
	        get: function () {
	            if (this.isString(this._attackCurve)) {
	                return this._attackCurve;
	            } else if (this.isArray(this._attackCurve)) {
	                //look up the name in the curves array
	                for (var type in Tone.Envelope.Type) {
	                    if (Tone.Envelope.Type[type].In === this._attackCurve) {
	                        return type;
	                    }
	                }
	                //otherwise just return the array
	                return this._attackCurve;
	            }
	        },
	        set: function (curve) {
	            //check if it's a valid type
	            if (Tone.Envelope.Type.hasOwnProperty(curve)) {
	                var curveDef = Tone.Envelope.Type[curve];
	                if (this.isObject(curveDef)) {
	                    this._attackCurve = curveDef.In;
	                } else {
	                    this._attackCurve = curveDef;
	                }
	            } else if (this.isArray(curve)) {
	                this._attackCurve = curve;
	            } else {
	                throw new Error('Tone.Envelope: invalid curve: ' + curve);
	            }
	        }
	    });
	    /**
		 * The shape of the release. See the attack curve types. 
		 * @memberOf Tone.Envelope#
		 * @type {String|Array}
		 * @name releaseCurve
		 * @example
		 * env.releaseCurve = "linear";
		 */
	    Object.defineProperty(Tone.Envelope.prototype, 'releaseCurve', {
	        get: function () {
	            if (this.isString(this._releaseCurve)) {
	                return this._releaseCurve;
	            } else if (this.isArray(this._releaseCurve)) {
	                //look up the name in the curves array
	                for (var type in Tone.Envelope.Type) {
	                    if (Tone.Envelope.Type[type].Out === this._releaseCurve) {
	                        return type;
	                    }
	                }
	                //otherwise just return the array
	                return this._releaseCurve;
	            }
	        },
	        set: function (curve) {
	            //check if it's a valid type
	            if (Tone.Envelope.Type.hasOwnProperty(curve)) {
	                var curveDef = Tone.Envelope.Type[curve];
	                if (this.isObject(curveDef)) {
	                    this._releaseCurve = curveDef.Out;
	                } else {
	                    this._releaseCurve = curveDef;
	                }
	            } else if (this.isArray(curve)) {
	                this._releaseCurve = curve;
	            } else {
	                throw new Error('Tone.Envelope: invalid curve: ' + curve);
	            }
	        }
	    });
	    /**
		 *  Trigger the attack/decay portion of the ADSR envelope. 
		 *  @param  {Time} [time=now] When the attack should start.
		 *  @param {NormalRange} [velocity=1] The velocity of the envelope scales the vales.
		 *                               number between 0-1
		 *  @returns {Tone.Envelope} this
		 *  @example
		 *  //trigger the attack 0.5 seconds from now with a velocity of 0.2
		 *  env.triggerAttack("+0.5", 0.2);
		 */
	    Tone.Envelope.prototype.triggerAttack = function (time, velocity) {
	        time = this.toSeconds(time);
	        var originalAttack = this.toSeconds(this.attack);
	        var attack = originalAttack;
	        var decay = this.toSeconds(this.decay);
	        velocity = this.defaultArg(velocity, 1);
	        //check if it's not a complete attack
	        var currentValue = this.getValueAtTime(time);
	        if (currentValue > 0) {
	            //subtract the current value from the attack time
	            var attackRate = 1 / attack;
	            var remainingDistance = 1 - currentValue;
	            //the attack is now the remaining time
	            attack = remainingDistance / attackRate;
	        }
	        //attack
	        if (this._attackCurve === 'linear') {
	            this._sig.linearRampToValue(velocity, attack, time);
	        } else if (this._attackCurve === 'exponential') {
	            this._sig.exponentialRampToValue(velocity, attack, time);
	        } else if (attack > 0) {
	            this._sig.setRampPoint(time);
	            var curve = this._attackCurve;
	            //take only a portion of the curve
	            if (attack < originalAttack) {
	                var percentComplete = 1 - attack / originalAttack;
	                var sliceIndex = Math.floor(percentComplete * this._attackCurve.length);
	                curve = this._attackCurve.slice(sliceIndex);
	                //the first index is the current value
	                curve[0] = currentValue;
	            }
	            this._sig.setValueCurveAtTime(curve, time, attack, velocity);
	        }
	        //decay
	        this._sig.exponentialRampToValue(velocity * this.sustain, decay, attack + time);
	        return this;
	    };
	    /**
		 *  Triggers the release of the envelope.
		 *  @param  {Time} [time=now] When the release portion of the envelope should start. 
		 *  @returns {Tone.Envelope} this
		 *  @example
		 *  //trigger release immediately
		 *  env.triggerRelease();
		 */
	    Tone.Envelope.prototype.triggerRelease = function (time) {
	        time = this.toSeconds(time);
	        var currentValue = this.getValueAtTime(time);
	        if (currentValue > 0) {
	            var release = this.toSeconds(this.release);
	            if (this._releaseCurve === 'linear') {
	                this._sig.linearRampToValue(0, release, time);
	            } else if (this._releaseCurve === 'exponential') {
	                this._sig.exponentialRampToValue(0, release, time);
	            } else {
	                var curve = this._releaseCurve;
	                if (this.isArray(curve)) {
	                    this._sig.setRampPoint(time);
	                    this._sig.setValueCurveAtTime(curve, time, release, currentValue);
	                }
	            }
	        }
	        return this;
	    };
	    /**
		 *  Get the scheduled value at the given time. This will
		 *  return the unconverted (raw) value.
		 *  @param  {Number}  time  The time in seconds.
		 *  @return  {Number}  The scheduled value at the given time.
		 */
	    Tone.Envelope.prototype.getValueAtTime = function (time) {
	        return this._sig.getValueAtTime(time);
	    };
	    /**
		 *  triggerAttackRelease is shorthand for triggerAttack, then waiting
		 *  some duration, then triggerRelease. 
		 *  @param {Time} duration The duration of the sustain.
		 *  @param {Time} [time=now] When the attack should be triggered.
		 *  @param {number} [velocity=1] The velocity of the envelope. 
		 *  @returns {Tone.Envelope} this
		 *  @example
		 * //trigger the attack and then the release after 0.6 seconds.
		 * env.triggerAttackRelease(0.6);
		 */
	    Tone.Envelope.prototype.triggerAttackRelease = function (duration, time, velocity) {
	        time = this.toSeconds(time);
	        this.triggerAttack(time, velocity);
	        this.triggerRelease(time + this.toSeconds(duration));
	        return this;
	    };
	    /**
		 *  Cancels all scheduled envelope changes after the given time.
		 *  @param  {Time} after
		 *  @returns {Tone.Envelope} this
		 */
	    Tone.Envelope.prototype.cancel = function (after) {
	        this._sig.cancelScheduledValues(after);
	        return this;
	    };
	    /**
		 *  Borrows the connect method from Tone.Signal. 
		 *  @function
		 *  @private
		 */
	    Tone.Envelope.prototype.connect = Tone.Signal.prototype.connect;
	    /**
	 	 *  Generate some complex envelope curves. 
	 	 */
	    (function _createCurves() {
	        var curveLen = 128;
	        var i, k;
	        //cosine curve
	        var cosineCurve = [];
	        for (i = 0; i < curveLen; i++) {
	            cosineCurve[i] = Math.sin(i / (curveLen - 1) * (Math.PI / 2));
	        }
	        //ripple curve
	        var rippleCurve = [];
	        var rippleCurveFreq = 6.4;
	        for (i = 0; i < curveLen - 1; i++) {
	            k = i / (curveLen - 1);
	            var sineWave = Math.sin(k * (Math.PI * 2) * rippleCurveFreq - Math.PI / 2) + 1;
	            rippleCurve[i] = sineWave / 10 + k * 0.83;
	        }
	        rippleCurve[curveLen - 1] = 1;
	        //stairs curve
	        var stairsCurve = [];
	        var steps = 5;
	        for (i = 0; i < curveLen; i++) {
	            stairsCurve[i] = Math.ceil(i / (curveLen - 1) * steps) / steps;
	        }
	        //in-out easing curve
	        var sineCurve = [];
	        for (i = 0; i < curveLen; i++) {
	            k = i / (curveLen - 1);
	            sineCurve[i] = 0.5 * (1 - Math.cos(Math.PI * k));
	        }
	        //a bounce curve
	        var bounceCurve = [];
	        for (i = 0; i < curveLen; i++) {
	            k = i / (curveLen - 1);
	            var freq = Math.pow(k, 3) * 4 + 0.2;
	            var val = Math.cos(freq * Math.PI * 2 * k);
	            bounceCurve[i] = Math.abs(val * (1 - k));
	        }
	        /**
			 *  Invert a value curve to make it work for the release
			 *  @private
			 */
	        function invertCurve(curve) {
	            var out = new Array(curve.length);
	            for (var j = 0; j < curve.length; j++) {
	                out[j] = 1 - curve[j];
	            }
	            return out;
	        }
	        /**
			 *  reverse the curve
			 *  @private
			 */
	        function reverseCurve(curve) {
	            return curve.slice(0).reverse();
	        }
	        /**
			 *  attack and release curve arrays
			 *  @type  {Object}
			 *  @private
			 */
	        Tone.Envelope.Type = {
	            'linear': 'linear',
	            'exponential': 'exponential',
	            'bounce': {
	                In: invertCurve(bounceCurve),
	                Out: bounceCurve
	            },
	            'cosine': {
	                In: cosineCurve,
	                Out: reverseCurve(cosineCurve)
	            },
	            'step': {
	                In: stairsCurve,
	                Out: invertCurve(stairsCurve)
	            },
	            'ripple': {
	                In: rippleCurve,
	                Out: invertCurve(rippleCurve)
	            },
	            'sine': {
	                In: sineCurve,
	                Out: invertCurve(sineCurve)
	            }
	        };
	    }());
	    /**
		 *  Disconnect and dispose.
		 *  @returns {Tone.Envelope} this
		 */
	    Tone.Envelope.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._sig.dispose();
	        this._sig = null;
	        this._attackCurve = null;
	        this._releaseCurve = null;
	        return this;
	    };
	    return Tone.Envelope;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  Tone.AmplitudeEnvelope is a Tone.Envelope connected to a gain node. 
		 *          Unlike Tone.Envelope, which outputs the envelope's value, Tone.AmplitudeEnvelope accepts
		 *          an audio signal as the input and will apply the envelope to the amplitude
		 *          of the signal. Read more about ADSR Envelopes on [Wikipedia](https://en.wikipedia.org/wiki/Synthesizer#ADSR_envelope).
		 *  
		 *  @constructor
		 *  @extends {Tone.Envelope}
		 *  @param {Time|Object} [attack] The amount of time it takes for the envelope to go from 
		 *                               0 to it's maximum value. 
		 *  @param {Time} [decay]	The period of time after the attack that it takes for the envelope
		 *                       	to fall to the sustain value. 
		 *  @param {NormalRange} [sustain]	The percent of the maximum value that the envelope rests at until
		 *                                	the release is triggered. 
		 *  @param {Time} [release]	The amount of time after the release is triggered it takes to reach 0. 
		 *  @example
		 * var ampEnv = new Tone.AmplitudeEnvelope({
		 * 	"attack": 0.1,
		 * 	"decay": 0.2,
		 * 	"sustain": 1.0,
		 * 	"release": 0.8
		 * }).toMaster();
		 * //create an oscillator and connect it
		 * var osc = new Tone.Oscillator().connect(ampEnv).start();
		 * //trigger the envelopes attack and release "8t" apart
		 * ampEnv.triggerAttackRelease("8t");
		 */
	    Tone.AmplitudeEnvelope = function () {
	        Tone.Envelope.apply(this, arguments);
	        /**
			 *  the input node
			 *  @type {GainNode}
			 *  @private
			 */
	        this.input = this.output = new Tone.Gain();
	        this._sig.connect(this.output.gain);
	    };
	    Tone.extend(Tone.AmplitudeEnvelope, Tone.Envelope);
	    /**
		 *  Clean up
		 *  @return  {Tone.AmplitudeEnvelope}  this
		 */
	    Tone.AmplitudeEnvelope.prototype.dispose = function () {
	        this.input.dispose();
	        this.input = null;
	        Tone.Envelope.prototype.dispose.call(this);
	        return this;
	    };
	    return Tone.AmplitudeEnvelope;
	});
	Module(function (Tone) {
	    
	    /**
		 *  AnalyserNode.getFloatTimeDomainData polyfill
		 *  @private
		 */
	    if (window.AnalyserNode && !AnalyserNode.prototype.getFloatTimeDomainData) {
	        //referenced https://github.com/mohayonao/get-float-time-domain-data 
	        AnalyserNode.prototype.getFloatTimeDomainData = function (array) {
	            var uint8 = new Uint8Array(array.length);
	            this.getByteTimeDomainData(uint8);
	            for (var i = 0; i < uint8.length; i++) {
	                array[i] = (uint8[i] - 128) / 128;
	            }
	        };
	    }
	    /**
		 *  @class  Wrapper around the native Web Audio's 
		 *          [AnalyserNode](http://webaudio.github.io/web-audio-api/#idl-def-AnalyserNode).
		 *          Extracts FFT or Waveform data from the incoming signal.
		 *  @extends {Tone}
		 *  @param {String=} type The return type of the analysis, either "fft", or "waveform". 
		 *  @param {Number=} size The size of the FFT. Value must be a power of 
		 *                       two in the range 32 to 32768.
		 */
	    Tone.Analyser = function () {
	        var options = this.optionsObject(arguments, [
	            'type',
	            'size'
	        ], Tone.Analyser.defaults);
	        /**
			 *  The analyser node.
			 *  @private
			 *  @type {AnalyserNode}
			 */
	        this._analyser = this.input = this.output = this.context.createAnalyser();
	        /**
			 *  The analysis type
			 *  @type {String}
			 *  @private
			 */
	        this._type = options.type;
	        /**
			 *  The return type of the analysis
			 *  @type {String}
			 *  @private
			 */
	        this._returnType = options.returnType;
	        /**
			 *  The buffer that the FFT data is written to
			 *  @type {TypedArray}
			 *  @private
			 */
	        this._buffer = null;
	        //set the values initially
	        this.size = options.size;
	        this.type = options.type;
	        this.returnType = options.returnType;
	        this.minDecibels = options.minDecibels;
	        this.maxDecibels = options.maxDecibels;
	    };
	    Tone.extend(Tone.Analyser);
	    /**
		 *  The default values.
		 *  @type {Object}
		 *  @const
		 */
	    Tone.Analyser.defaults = {
	        'size': 1024,
	        'returnType': 'byte',
	        'type': 'fft',
	        'smoothing': 0.8,
	        'maxDecibels': -30,
	        'minDecibels': -100
	    };
	    /**
		 *  Possible return types of Tone.Analyser.analyse()
		 *  @enum {String}
		 */
	    Tone.Analyser.Type = {
	        Waveform: 'waveform',
	        FFT: 'fft'
	    };
	    /**
		 *  Possible return types of Tone.Analyser.analyse(). 
		 *  byte values are between [0,255]. float values are between 
		 *  [-1, 1] when the type is set to "waveform" and between 
		 *  [minDecibels,maxDecibels] when the type is "fft".
		 *  @enum {String}
		 */
	    Tone.Analyser.ReturnType = {
	        Byte: 'byte',
	        Float: 'float'
	    };
	    /**
		 *  Run the analysis given the current settings and return the 
		 *  result as a TypedArray. 
		 *  @returns {TypedArray}
		 */
	    Tone.Analyser.prototype.analyse = function () {
	        if (this._type === Tone.Analyser.Type.FFT) {
	            if (this._returnType === Tone.Analyser.ReturnType.Byte) {
	                this._analyser.getByteFrequencyData(this._buffer);
	            } else {
	                this._analyser.getFloatFrequencyData(this._buffer);
	            }
	        } else if (this._type === Tone.Analyser.Type.Waveform) {
	            if (this._returnType === Tone.Analyser.ReturnType.Byte) {
	                this._analyser.getByteTimeDomainData(this._buffer);
	            } else {
	                this._analyser.getFloatTimeDomainData(this._buffer);
	            }
	        }
	        return this._buffer;
	    };
	    /**
		 *  The size of analysis. This must be a power of two in the range 32 to 32768.
		 *  @memberOf Tone.Analyser#
		 *  @type {Number}
		 *  @name size
		 */
	    Object.defineProperty(Tone.Analyser.prototype, 'size', {
	        get: function () {
	            return this._analyser.frequencyBinCount;
	        },
	        set: function (size) {
	            this._analyser.fftSize = size * 2;
	            this.type = this._type;
	        }
	    });
	    /**
		 *  The return type of Tone.Analyser.analyse(), either "byte" or "float". 
		 *  When the type is set to "byte" the range of values returned in the array
		 *  are between 0-255. "float" values are between 
		 *  [-1, 1] when the type is set to "waveform" and between 
		 *  [minDecibels,maxDecibels] when the type is "fft".
		 *  @memberOf Tone.Analyser#
		 *  @type {String}
		 *  @name type
		 */
	    Object.defineProperty(Tone.Analyser.prototype, 'returnType', {
	        get: function () {
	            return this._returnType;
	        },
	        set: function (type) {
	            if (type === Tone.Analyser.ReturnType.Byte) {
	                this._buffer = new Uint8Array(this._analyser.frequencyBinCount);
	            } else if (type === Tone.Analyser.ReturnType.Float) {
	                this._buffer = new Float32Array(this._analyser.frequencyBinCount);
	            } else {
	                throw new TypeError('Tone.Analayser: invalid return type: ' + type);
	            }
	            this._returnType = type;
	        }
	    });
	    /**
		 *  The analysis function returned by Tone.Analyser.analyse(), either "fft" or "waveform". 
		 *  @memberOf Tone.Analyser#
		 *  @type {String}
		 *  @name type
		 */
	    Object.defineProperty(Tone.Analyser.prototype, 'type', {
	        get: function () {
	            return this._type;
	        },
	        set: function (type) {
	            if (type !== Tone.Analyser.Type.Waveform && type !== Tone.Analyser.Type.FFT) {
	                throw new TypeError('Tone.Analyser: invalid type: ' + type);
	            }
	            this._type = type;
	        }
	    });
	    /**
		 *  0 represents no time averaging with the last analysis frame.
		 *  @memberOf Tone.Analyser#
		 *  @type {NormalRange}
		 *  @name smoothing
		 */
	    Object.defineProperty(Tone.Analyser.prototype, 'smoothing', {
	        get: function () {
	            return this._analyser.smoothingTimeConstant;
	        },
	        set: function (val) {
	            this._analyser.smoothingTimeConstant = val;
	        }
	    });
	    /**
		 *  The smallest decibel value which is analysed by the FFT. 
		 *  @memberOf Tone.Analyser#
		 *  @type {Decibels}
		 *  @name minDecibels
		 */
	    Object.defineProperty(Tone.Analyser.prototype, 'minDecibels', {
	        get: function () {
	            return this._analyser.minDecibels;
	        },
	        set: function (val) {
	            this._analyser.minDecibels = val;
	        }
	    });
	    /**
		 *  The largest decibel value which is analysed by the FFT. 
		 *  @memberOf Tone.Analyser#
		 *  @type {Decibels}
		 *  @name maxDecibels
		 */
	    Object.defineProperty(Tone.Analyser.prototype, 'maxDecibels', {
	        get: function () {
	            return this._analyser.maxDecibels;
	        },
	        set: function (val) {
	            this._analyser.maxDecibels = val;
	        }
	    });
	    /**
		 *  Clean up.
		 *  @return  {Tone.Analyser}  this
		 */
	    Tone.Analyser.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._analyser.disconnect();
	        this._analyser = null;
	        this._buffer = null;
	    };
	    return Tone.Analyser;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Tone.Compressor is a thin wrapper around the Web Audio 
		 *         [DynamicsCompressorNode](http://webaudio.github.io/web-audio-api/#the-dynamicscompressornode-interface).
		 *         Compression reduces the volume of loud sounds or amplifies quiet sounds 
		 *         by narrowing or "compressing" an audio signal's dynamic range. 
		 *         Read more on [Wikipedia](https://en.wikipedia.org/wiki/Dynamic_range_compression).
		 *
		 *  @extends {Tone}
		 *  @constructor
		 *  @param {Decibels|Object} [threshold] The value above which the compression starts to be applied.
		 *  @param {Positive} [ratio] The gain reduction ratio.
		 *  @example
		 * var comp = new Tone.Compressor(-30, 3);
		 */
	    Tone.Compressor = function () {
	        var options = this.optionsObject(arguments, [
	            'threshold',
	            'ratio'
	        ], Tone.Compressor.defaults);
	        /**
			 *  the compressor node
			 *  @type {DynamicsCompressorNode}
			 *  @private
			 */
	        this._compressor = this.input = this.output = this.context.createDynamicsCompressor();
	        /**
			 *  the threshold vaue
			 *  @type {Decibels}
			 *  @signal
			 */
	        this.threshold = new Tone.Param({
	            'param': this._compressor.threshold,
	            'units': Tone.Type.Decibels,
	            'convert': false
	        });
	        /**
			 *  The attack parameter
			 *  @type {Time}
			 *  @signal
			 */
	        this.attack = new Tone.Param(this._compressor.attack, Tone.Type.Time);
	        /**
			 *  The release parameter
			 *  @type {Time}
			 *  @signal
			 */
	        this.release = new Tone.Param(this._compressor.release, Tone.Type.Time);
	        /**
			 *  The knee parameter
			 *  @type {Decibels}
			 *  @signal
			 */
	        this.knee = new Tone.Param({
	            'param': this._compressor.knee,
	            'units': Tone.Type.Decibels,
	            'convert': false
	        });
	        /**
			 *  The ratio value
			 *  @type {Number}
			 *  @signal
			 */
	        this.ratio = new Tone.Param({
	            'param': this._compressor.ratio,
	            'convert': false
	        });
	        //set the defaults
	        this._readOnly([
	            'knee',
	            'release',
	            'attack',
	            'ratio',
	            'threshold'
	        ]);
	        this.set(options);
	    };
	    Tone.extend(Tone.Compressor);
	    /**
		 *  @static
		 *  @const
		 *  @type {Object}
		 */
	    Tone.Compressor.defaults = {
	        'ratio': 12,
	        'threshold': -24,
	        'release': 0.25,
	        'attack': 0.003,
	        'knee': 30
	    };
	    /**
		 *  clean up
		 *  @returns {Tone.Compressor} this
		 */
	    Tone.Compressor.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._writable([
	            'knee',
	            'release',
	            'attack',
	            'ratio',
	            'threshold'
	        ]);
	        this._compressor.disconnect();
	        this._compressor = null;
	        this.attack.dispose();
	        this.attack = null;
	        this.release.dispose();
	        this.release = null;
	        this.threshold.dispose();
	        this.threshold = null;
	        this.ratio.dispose();
	        this.ratio = null;
	        this.knee.dispose();
	        this.knee = null;
	        return this;
	    };
	    return Tone.Compressor;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Add a signal and a number or two signals. When no value is
		 *         passed into the constructor, Tone.Add will sum <code>input[0]</code>
		 *         and <code>input[1]</code>. If a value is passed into the constructor, 
		 *         the it will be added to the input.
		 *  
		 *  @constructor
		 *  @extends {Tone.Signal}
		 *  @param {number=} value If no value is provided, Tone.Add will sum the first
		 *                         and second inputs. 
		 *  @example
		 * var signal = new Tone.Signal(2);
		 * var add = new Tone.Add(2);
		 * signal.connect(add);
		 * //the output of add equals 4
		 *  @example
		 * //if constructed with no arguments
		 * //it will add the first and second inputs
		 * var add = new Tone.Add();
		 * var sig0 = new Tone.Signal(3).connect(add, 0, 0);
		 * var sig1 = new Tone.Signal(4).connect(add, 0, 1);
		 * //the output of add equals 7. 
		 */
	    Tone.Add = function (value) {
	        this.createInsOuts(2, 0);
	        /**
			 *  the summing node
			 *  @type {GainNode}
			 *  @private
			 */
	        this._sum = this.input[0] = this.input[1] = this.output = new Tone.Gain();
	        /**
			 *  @private
			 *  @type {Tone.Signal}
			 */
	        this._param = this.input[1] = new Tone.Signal(value);
	        this._param.connect(this._sum);
	    };
	    Tone.extend(Tone.Add, Tone.Signal);
	    /**
		 *  Clean up.
		 *  @returns {Tone.Add} this
		 */
	    Tone.Add.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._sum.dispose();
	        this._sum = null;
	        this._param.dispose();
	        this._param = null;
	        return this;
	    };
	    return Tone.Add;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  Multiply two incoming signals. Or, if a number is given in the constructor, 
		 *          multiplies the incoming signal by that value. 
		 *
		 *  @constructor
		 *  @extends {Tone.Signal}
		 *  @param {number=} value Constant value to multiple. If no value is provided,
		 *                         it will return the product of the first and second inputs
		 *  @example
		 * var mult = new Tone.Multiply();
		 * var sigA = new Tone.Signal(3);
		 * var sigB = new Tone.Signal(4);
		 * sigA.connect(mult, 0, 0);
		 * sigB.connect(mult, 0, 1);
		 * //output of mult is 12.
		 *  @example
		 * var mult = new Tone.Multiply(10);
		 * var sig = new Tone.Signal(2).connect(mult);
		 * //the output of mult is 20. 
		 */
	    Tone.Multiply = function (value) {
	        this.createInsOuts(2, 0);
	        /**
			 *  the input node is the same as the output node
			 *  it is also the GainNode which handles the scaling of incoming signal
			 *  
			 *  @type {GainNode}
			 *  @private
			 */
	        this._mult = this.input[0] = this.output = new Tone.Gain();
	        /**
			 *  the scaling parameter
			 *  @type {AudioParam}
			 *  @private
			 */
	        this._param = this.input[1] = this.output.gain;
	        this._param.value = this.defaultArg(value, 0);
	    };
	    Tone.extend(Tone.Multiply, Tone.Signal);
	    /**
		 *  clean up
		 *  @returns {Tone.Multiply} this
		 */
	    Tone.Multiply.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._mult.dispose();
	        this._mult = null;
	        this._param = null;
	        return this;
	    };
	    return Tone.Multiply;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Negate the incoming signal. i.e. an input signal of 10 will output -10
		 *
		 *  @constructor
		 *  @extends {Tone.SignalBase}
		 *  @example
		 * var neg = new Tone.Negate();
		 * var sig = new Tone.Signal(-2).connect(neg);
		 * //output of neg is positive 2. 
		 */
	    Tone.Negate = function () {
	        /**
			 *  negation is done by multiplying by -1
			 *  @type {Tone.Multiply}
			 *  @private
			 */
	        this._multiply = this.input = this.output = new Tone.Multiply(-1);
	    };
	    Tone.extend(Tone.Negate, Tone.SignalBase);
	    /**
		 *  clean up
		 *  @returns {Tone.Negate} this
		 */
	    Tone.Negate.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._multiply.dispose();
	        this._multiply = null;
	        return this;
	    };
	    return Tone.Negate;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Subtract the signal connected to <code>input[1]</code> from the signal connected 
		 *         to <code>input[0]</code>. If an argument is provided in the constructor, the 
		 *         signals <code>.value</code> will be subtracted from the incoming signal.
		 *
		 *  @extends {Tone.Signal}
		 *  @constructor
		 *  @param {number=} value The value to subtract from the incoming signal. If the value
		 *                         is omitted, it will subtract the second signal from the first.
		 *  @example
		 * var sub = new Tone.Subtract(1);
		 * var sig = new Tone.Signal(4).connect(sub);
		 * //the output of sub is 3. 
		 *  @example
		 * var sub = new Tone.Subtract();
		 * var sigA = new Tone.Signal(10);
		 * var sigB = new Tone.Signal(2.5);
		 * sigA.connect(sub, 0, 0);
		 * sigB.connect(sub, 0, 1);
		 * //output of sub is 7.5
		 */
	    Tone.Subtract = function (value) {
	        this.createInsOuts(2, 0);
	        /**
			 *  the summing node
			 *  @type {GainNode}
			 *  @private
			 */
	        this._sum = this.input[0] = this.output = new Tone.Gain();
	        /**
			 *  negate the input of the second input before connecting it
			 *  to the summing node.
			 *  @type {Tone.Negate}
			 *  @private
			 */
	        this._neg = new Tone.Negate();
	        /**
			 *  the node where the value is set
			 *  @private
			 *  @type {Tone.Signal}
			 */
	        this._param = this.input[1] = new Tone.Signal(value);
	        this._param.chain(this._neg, this._sum);
	    };
	    Tone.extend(Tone.Subtract, Tone.Signal);
	    /**
		 *  Clean up.
		 *  @returns {Tone.SignalBase} this
		 */
	    Tone.Subtract.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._neg.dispose();
	        this._neg = null;
	        this._sum.disconnect();
	        this._sum = null;
	        this._param.dispose();
	        this._param = null;
	        return this;
	    };
	    return Tone.Subtract;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  GreaterThanZero outputs 1 when the input is strictly greater than zero
		 *  
		 *  @constructor
		 *  @extends {Tone.SignalBase}
		 *  @example
		 * var gt0 = new Tone.GreaterThanZero();
		 * var sig = new Tone.Signal(0.01).connect(gt0);
		 * //the output of gt0 is 1. 
		 * sig.value = 0;
		 * //the output of gt0 is 0. 
		 */
	    Tone.GreaterThanZero = function () {
	        /**
			 *  @type {Tone.WaveShaper}
			 *  @private
			 */
	        this._thresh = this.output = new Tone.WaveShaper(function (val) {
	            if (val <= 0) {
	                return 0;
	            } else {
	                return 1;
	            }
	        }, 127);
	        /**
			 *  scale the first thresholded signal by a large value.
			 *  this will help with values which are very close to 0
			 *  @type {Tone.Multiply}
			 *  @private
			 */
	        this._scale = this.input = new Tone.Multiply(10000);
	        //connections
	        this._scale.connect(this._thresh);
	    };
	    Tone.extend(Tone.GreaterThanZero, Tone.SignalBase);
	    /**
		 *  dispose method
		 *  @returns {Tone.GreaterThanZero} this
		 */
	    Tone.GreaterThanZero.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._scale.dispose();
	        this._scale = null;
	        this._thresh.dispose();
	        this._thresh = null;
	        return this;
	    };
	    return Tone.GreaterThanZero;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  Output 1 if the signal is greater than the value, otherwise outputs 0.
		 *          can compare two signals or a signal and a number. 
		 *  
		 *  @constructor
		 *  @extends {Tone.Signal}
		 *  @param {number} [value=0] the value to compare to the incoming signal
		 *  @example
		 * var gt = new Tone.GreaterThan(2);
		 * var sig = new Tone.Signal(4).connect(gt);
		 * //output of gt is equal 1. 
		 */
	    Tone.GreaterThan = function (value) {
	        this.createInsOuts(2, 0);
	        /**
			 *  subtract the amount from the incoming signal
			 *  @type {Tone.Subtract}
			 *  @private
			 */
	        this._param = this.input[0] = new Tone.Subtract(value);
	        this.input[1] = this._param.input[1];
	        /**
			 *  compare that amount to zero
			 *  @type {Tone.GreaterThanZero}
			 *  @private
			 */
	        this._gtz = this.output = new Tone.GreaterThanZero();
	        //connect
	        this._param.connect(this._gtz);
	    };
	    Tone.extend(Tone.GreaterThan, Tone.Signal);
	    /**
		 *  dispose method
		 *  @returns {Tone.GreaterThan} this
		 */
	    Tone.GreaterThan.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._param.dispose();
	        this._param = null;
	        this._gtz.dispose();
	        this._gtz = null;
	        return this;
	    };
	    return Tone.GreaterThan;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Return the absolute value of an incoming signal. 
		 *  
		 *  @constructor
		 *  @extends {Tone.SignalBase}
		 *  @example
		 * var signal = new Tone.Signal(-1);
		 * var abs = new Tone.Abs();
		 * signal.connect(abs);
		 * //the output of abs is 1. 
		 */
	    Tone.Abs = function () {
	        /**
			 *  @type {Tone.LessThan}
			 *  @private
			 */
	        this._abs = this.input = this.output = new Tone.WaveShaper(function (val) {
	            if (val === 0) {
	                return 0;
	            } else {
	                return Math.abs(val);
	            }
	        }, 127);
	    };
	    Tone.extend(Tone.Abs, Tone.SignalBase);
	    /**
		 *  dispose method
		 *  @returns {Tone.Abs} this
		 */
	    Tone.Abs.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._abs.dispose();
	        this._abs = null;
	        return this;
	    };
	    return Tone.Abs;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Signal-rate modulo operator. Only works in AudioRange [-1, 1] and for modulus
		 *         values in the NormalRange. 
		 *
		 *  @constructor
		 *  @extends {Tone.SignalBase}
		 *  @param {NormalRange} modulus The modulus to apply.
		 *  @example
		 * var mod = new Tone.Modulo(0.2)
		 * var sig = new Tone.Signal(0.5).connect(mod);
		 * //mod outputs 0.1
		 */
	    Tone.Modulo = function (modulus) {
	        this.createInsOuts(1, 0);
	        /**
			 *  A waveshaper gets the integer multiple of 
			 *  the input signal and the modulus.
			 *  @private
			 *  @type {Tone.WaveShaper}
			 */
	        this._shaper = new Tone.WaveShaper(Math.pow(2, 16));
	        /**
			 *  the integer multiple is multiplied by the modulus
			 *  @type  {Tone.Multiply}
			 *  @private
			 */
	        this._multiply = new Tone.Multiply();
	        /**
			 *  and subtracted from the input signal
			 *  @type  {Tone.Subtract}
			 *  @private
			 */
	        this._subtract = this.output = new Tone.Subtract();
	        /**
			 *  the modulus signal
			 *  @type  {Tone.Signal}
			 *  @private
			 */
	        this._modSignal = new Tone.Signal(modulus);
	        //connections
	        this.input.fan(this._shaper, this._subtract);
	        this._modSignal.connect(this._multiply, 0, 0);
	        this._shaper.connect(this._multiply, 0, 1);
	        this._multiply.connect(this._subtract, 0, 1);
	        this._setWaveShaper(modulus);
	    };
	    Tone.extend(Tone.Modulo, Tone.SignalBase);
	    /**
		 *  @param  {number}  mod  the modulus to apply
		 *  @private
		 */
	    Tone.Modulo.prototype._setWaveShaper = function (mod) {
	        this._shaper.setMap(function (val) {
	            var multiple = Math.floor((val + 0.0001) / mod);
	            return multiple;
	        });
	    };
	    /**
		 * The modulus value.
		 * @memberOf Tone.Modulo#
		 * @type {NormalRange}
		 * @name value
		 */
	    Object.defineProperty(Tone.Modulo.prototype, 'value', {
	        get: function () {
	            return this._modSignal.value;
	        },
	        set: function (mod) {
	            this._modSignal.value = mod;
	            this._setWaveShaper(mod);
	        }
	    });
	    /**
		 * clean up
		 *  @returns {Tone.Modulo} this
		 */
	    Tone.Modulo.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._shaper.dispose();
	        this._shaper = null;
	        this._multiply.dispose();
	        this._multiply = null;
	        this._subtract.dispose();
	        this._subtract = null;
	        this._modSignal.dispose();
	        this._modSignal = null;
	        return this;
	    };
	    return Tone.Modulo;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class AudioToGain converts an input in AudioRange [-1,1] to NormalRange [0,1]. 
		 *         See Tone.GainToAudio.
		 *
		 *  @extends {Tone.SignalBase}
		 *  @constructor
		 *  @example
		 *  var a2g = new Tone.AudioToGain();
		 */
	    Tone.AudioToGain = function () {
	        /**
			 *  @type {WaveShaperNode}
			 *  @private
			 */
	        this._norm = this.input = this.output = new Tone.WaveShaper(function (x) {
	            return (x + 1) / 2;
	        });
	    };
	    Tone.extend(Tone.AudioToGain, Tone.SignalBase);
	    /**
		 *  clean up
		 *  @returns {Tone.AudioToGain} this
		 */
	    Tone.AudioToGain.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._norm.dispose();
	        this._norm = null;
	        return this;
	    };
	    return Tone.AudioToGain;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Evaluate an expression at audio rate. <br><br>
		 *         Parsing code modified from https://code.google.com/p/tapdigit/
		 *         Copyright 2011 2012 Ariya Hidayat, New BSD License
		 *
		 *  @extends {Tone.SignalBase}
		 *  @constructor
		 *  @param {string} expr the expression to generate
		 *  @example
		 * //adds the signals from input[0] and input[1].
		 * var expr = new Tone.Expr("$0 + $1");
		 */
	    Tone.Expr = function () {
	        var expr = this._replacements(Array.prototype.slice.call(arguments));
	        var inputCount = this._parseInputs(expr);
	        /**
			 *  hold onto all of the nodes for disposal
			 *  @type {Array}
			 *  @private
			 */
	        this._nodes = [];
	        /**
			 *  The inputs. The length is determined by the expression. 
			 *  @type {Array}
			 */
	        this.input = new Array(inputCount);
	        //create a gain for each input
	        for (var i = 0; i < inputCount; i++) {
	            this.input[i] = this.context.createGain();
	        }
	        //parse the syntax tree
	        var tree = this._parseTree(expr);
	        //evaluate the results
	        var result;
	        try {
	            result = this._eval(tree);
	        } catch (e) {
	            this._disposeNodes();
	            throw new Error('Tone.Expr: Could evaluate expression: ' + expr);
	        }
	        /**
			 *  The output node is the result of the expression
			 *  @type {Tone}
			 */
	        this.output = result;
	    };
	    Tone.extend(Tone.Expr, Tone.SignalBase);
	    //some helpers to cut down the amount of code
	    function applyBinary(Constructor, args, self) {
	        var op = new Constructor();
	        self._eval(args[0]).connect(op, 0, 0);
	        self._eval(args[1]).connect(op, 0, 1);
	        return op;
	    }
	    function applyUnary(Constructor, args, self) {
	        var op = new Constructor();
	        self._eval(args[0]).connect(op, 0, 0);
	        return op;
	    }
	    function getNumber(arg) {
	        return arg ? parseFloat(arg) : undefined;
	    }
	    function literalNumber(arg) {
	        return arg && arg.args ? parseFloat(arg.args) : undefined;
	    }
	    /*
		 *  the Expressions that Tone.Expr can parse.
		 *
		 *  each expression belongs to a group and contains a regexp 
		 *  for selecting the operator as well as that operators method
		 *  
		 *  @type {Object}
		 *  @private
		 */
	    Tone.Expr._Expressions = {
	        //values
	        'value': {
	            'signal': {
	                regexp: /^\d+\.\d+|^\d+/,
	                method: function (arg) {
	                    var sig = new Tone.Signal(getNumber(arg));
	                    return sig;
	                }
	            },
	            'input': {
	                regexp: /^\$\d/,
	                method: function (arg, self) {
	                    return self.input[getNumber(arg.substr(1))];
	                }
	            }
	        },
	        //syntactic glue
	        'glue': {
	            '(': { regexp: /^\(/ },
	            ')': { regexp: /^\)/ },
	            ',': { regexp: /^,/ }
	        },
	        //functions
	        'func': {
	            'abs': {
	                regexp: /^abs/,
	                method: applyUnary.bind(this, Tone.Abs)
	            },
	            'mod': {
	                regexp: /^mod/,
	                method: function (args, self) {
	                    var modulus = literalNumber(args[1]);
	                    var op = new Tone.Modulo(modulus);
	                    self._eval(args[0]).connect(op);
	                    return op;
	                }
	            },
	            'pow': {
	                regexp: /^pow/,
	                method: function (args, self) {
	                    var exp = literalNumber(args[1]);
	                    var op = new Tone.Pow(exp);
	                    self._eval(args[0]).connect(op);
	                    return op;
	                }
	            },
	            'a2g': {
	                regexp: /^a2g/,
	                method: function (args, self) {
	                    var op = new Tone.AudioToGain();
	                    self._eval(args[0]).connect(op);
	                    return op;
	                }
	            }
	        },
	        //binary expressions
	        'binary': {
	            '+': {
	                regexp: /^\+/,
	                precedence: 1,
	                method: applyBinary.bind(this, Tone.Add)
	            },
	            '-': {
	                regexp: /^\-/,
	                precedence: 1,
	                method: function (args, self) {
	                    //both unary and binary op
	                    if (args.length === 1) {
	                        return applyUnary(Tone.Negate, args, self);
	                    } else {
	                        return applyBinary(Tone.Subtract, args, self);
	                    }
	                }
	            },
	            '*': {
	                regexp: /^\*/,
	                precedence: 0,
	                method: applyBinary.bind(this, Tone.Multiply)
	            }
	        },
	        //unary expressions
	        'unary': {
	            '-': {
	                regexp: /^\-/,
	                method: applyUnary.bind(this, Tone.Negate)
	            },
	            '!': {
	                regexp: /^\!/,
	                method: applyUnary.bind(this, Tone.NOT)
	            }
	        }
	    };
	    /**
		 *  @param   {string} expr the expression string
		 *  @return  {number}      the input count
		 *  @private
		 */
	    Tone.Expr.prototype._parseInputs = function (expr) {
	        var inputArray = expr.match(/\$\d/g);
	        var inputMax = 0;
	        if (inputArray !== null) {
	            for (var i = 0; i < inputArray.length; i++) {
	                var inputNum = parseInt(inputArray[i].substr(1)) + 1;
	                inputMax = Math.max(inputMax, inputNum);
	            }
	        }
	        return inputMax;
	    };
	    /**
		 *  @param   {Array} args 	an array of arguments
		 *  @return  {string} the results of the replacements being replaced
		 *  @private
		 */
	    Tone.Expr.prototype._replacements = function (args) {
	        var expr = args.shift();
	        for (var i = 0; i < args.length; i++) {
	            expr = expr.replace(/\%/i, args[i]);
	        }
	        return expr;
	    };
	    /**
		 *  tokenize the expression based on the Expressions object
		 *  @param   {string} expr 
		 *  @return  {Object}      returns two methods on the tokenized list, next and peek
		 *  @private
		 */
	    Tone.Expr.prototype._tokenize = function (expr) {
	        var position = -1;
	        var tokens = [];
	        while (expr.length > 0) {
	            expr = expr.trim();
	            var token = getNextToken(expr);
	            tokens.push(token);
	            expr = expr.substr(token.value.length);
	        }
	        function getNextToken(expr) {
	            for (var type in Tone.Expr._Expressions) {
	                var group = Tone.Expr._Expressions[type];
	                for (var opName in group) {
	                    var op = group[opName];
	                    var reg = op.regexp;
	                    var match = expr.match(reg);
	                    if (match !== null) {
	                        return {
	                            type: type,
	                            value: match[0],
	                            method: op.method
	                        };
	                    }
	                }
	            }
	            throw new SyntaxError('Tone.Expr: Unexpected token ' + expr);
	        }
	        return {
	            next: function () {
	                return tokens[++position];
	            },
	            peek: function () {
	                return tokens[position + 1];
	            }
	        };
	    };
	    /**
		 *  recursively parse the string expression into a syntax tree
		 *  
		 *  @param   {string} expr 
		 *  @return  {Object}
		 *  @private
		 */
	    Tone.Expr.prototype._parseTree = function (expr) {
	        var lexer = this._tokenize(expr);
	        var isUndef = this.isUndef.bind(this);
	        function matchSyntax(token, syn) {
	            return !isUndef(token) && token.type === 'glue' && token.value === syn;
	        }
	        function matchGroup(token, groupName, prec) {
	            var ret = false;
	            var group = Tone.Expr._Expressions[groupName];
	            if (!isUndef(token)) {
	                for (var opName in group) {
	                    var op = group[opName];
	                    if (op.regexp.test(token.value)) {
	                        if (!isUndef(prec)) {
	                            if (op.precedence === prec) {
	                                return true;
	                            }
	                        } else {
	                            return true;
	                        }
	                    }
	                }
	            }
	            return ret;
	        }
	        function parseExpression(precedence) {
	            if (isUndef(precedence)) {
	                precedence = 5;
	            }
	            var expr;
	            if (precedence < 0) {
	                expr = parseUnary();
	            } else {
	                expr = parseExpression(precedence - 1);
	            }
	            var token = lexer.peek();
	            while (matchGroup(token, 'binary', precedence)) {
	                token = lexer.next();
	                expr = {
	                    operator: token.value,
	                    method: token.method,
	                    args: [
	                        expr,
	                        parseExpression(precedence - 1)
	                    ]
	                };
	                token = lexer.peek();
	            }
	            return expr;
	        }
	        function parseUnary() {
	            var token, expr;
	            token = lexer.peek();
	            if (matchGroup(token, 'unary')) {
	                token = lexer.next();
	                expr = parseUnary();
	                return {
	                    operator: token.value,
	                    method: token.method,
	                    args: [expr]
	                };
	            }
	            return parsePrimary();
	        }
	        function parsePrimary() {
	            var token, expr;
	            token = lexer.peek();
	            if (isUndef(token)) {
	                throw new SyntaxError('Tone.Expr: Unexpected termination of expression');
	            }
	            if (token.type === 'func') {
	                token = lexer.next();
	                return parseFunctionCall(token);
	            }
	            if (token.type === 'value') {
	                token = lexer.next();
	                return {
	                    method: token.method,
	                    args: token.value
	                };
	            }
	            if (matchSyntax(token, '(')) {
	                lexer.next();
	                expr = parseExpression();
	                token = lexer.next();
	                if (!matchSyntax(token, ')')) {
	                    throw new SyntaxError('Expected )');
	                }
	                return expr;
	            }
	            throw new SyntaxError('Tone.Expr: Parse error, cannot process token ' + token.value);
	        }
	        function parseFunctionCall(func) {
	            var token, args = [];
	            token = lexer.next();
	            if (!matchSyntax(token, '(')) {
	                throw new SyntaxError('Tone.Expr: Expected ( in a function call "' + func.value + '"');
	            }
	            token = lexer.peek();
	            if (!matchSyntax(token, ')')) {
	                args = parseArgumentList();
	            }
	            token = lexer.next();
	            if (!matchSyntax(token, ')')) {
	                throw new SyntaxError('Tone.Expr: Expected ) in a function call "' + func.value + '"');
	            }
	            return {
	                method: func.method,
	                args: args,
	                name: name
	            };
	        }
	        function parseArgumentList() {
	            var token, expr, args = [];
	            while (true) {
	                expr = parseExpression();
	                if (isUndef(expr)) {
	                    // TODO maybe throw exception?
	                    break;
	                }
	                args.push(expr);
	                token = lexer.peek();
	                if (!matchSyntax(token, ',')) {
	                    break;
	                }
	                lexer.next();
	            }
	            return args;
	        }
	        return parseExpression();
	    };
	    /**
		 *  recursively evaluate the expression tree
		 *  @param   {Object} tree 
		 *  @return  {AudioNode}      the resulting audio node from the expression
		 *  @private
		 */
	    Tone.Expr.prototype._eval = function (tree) {
	        if (!this.isUndef(tree)) {
	            var node = tree.method(tree.args, this);
	            this._nodes.push(node);
	            return node;
	        }
	    };
	    /**
		 *  dispose all the nodes
		 *  @private
		 */
	    Tone.Expr.prototype._disposeNodes = function () {
	        for (var i = 0; i < this._nodes.length; i++) {
	            var node = this._nodes[i];
	            if (this.isFunction(node.dispose)) {
	                node.dispose();
	            } else if (this.isFunction(node.disconnect)) {
	                node.disconnect();
	            }
	            node = null;
	            this._nodes[i] = null;
	        }
	        this._nodes = null;
	    };
	    /**
		 *  clean up
		 */
	    Tone.Expr.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._disposeNodes();
	    };
	    return Tone.Expr;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Convert an incoming signal between 0, 1 to an equal power gain scale.
		 *
		 *  @extends {Tone.SignalBase}
		 *  @constructor
		 *  @example
		 * var eqPowGain = new Tone.EqualPowerGain();
		 */
	    Tone.EqualPowerGain = function () {
	        /**
			 *  @type {Tone.WaveShaper}
			 *  @private
			 */
	        this._eqPower = this.input = this.output = new Tone.WaveShaper(function (val) {
	            if (Math.abs(val) < 0.001) {
	                //should output 0 when input is 0
	                return 0;
	            } else {
	                return this.equalPowerScale(val);
	            }
	        }.bind(this), 4096);
	    };
	    Tone.extend(Tone.EqualPowerGain, Tone.SignalBase);
	    /**
		 *  clean up
		 *  @returns {Tone.EqualPowerGain} this
		 */
	    Tone.EqualPowerGain.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._eqPower.dispose();
	        this._eqPower = null;
	        return this;
	    };
	    return Tone.EqualPowerGain;
	});
	Module(function (Tone) {
	    
	    /**
		 * @class  Tone.Crossfade provides equal power fading between two inputs. 
		 *         More on crossfading technique [here](https://en.wikipedia.org/wiki/Fade_(audio_engineering)#Crossfading).
		 *
		 * @constructor
		 * @extends {Tone}
		 * @param {NormalRange} [initialFade=0.5]
		 * @example
		 * var crossFade = new Tone.CrossFade(0.5);
		 * //connect effect A to crossfade from
		 * //effect output 0 to crossfade input 0
		 * effectA.connect(crossFade, 0, 0);
		 * //connect effect B to crossfade from
		 * //effect output 0 to crossfade input 1
		 * effectB.connect(crossFade, 0, 1);
		 * crossFade.fade.value = 0;
		 * // ^ only effectA is output
		 * crossFade.fade.value = 1;
		 * // ^ only effectB is output
		 * crossFade.fade.value = 0.5;
		 * // ^ the two signals are mixed equally. 
		 */
	    Tone.CrossFade = function (initialFade) {
	        this.createInsOuts(2, 1);
	        /**
			 *  Alias for <code>input[0]</code>. 
			 *  @type {Tone.Gain}
			 */
	        this.a = this.input[0] = new Tone.Gain();
	        /**
			 *  Alias for <code>input[1]</code>. 
			 *  @type {Tone.Gain}
			 */
	        this.b = this.input[1] = new Tone.Gain();
	        /**
			 * 	The mix between the two inputs. A fade value of 0
			 * 	will output 100% <code>input[0]</code> and 
			 * 	a value of 1 will output 100% <code>input[1]</code>. 
			 *  @type {NormalRange}
			 *  @signal
			 */
	        this.fade = new Tone.Signal(this.defaultArg(initialFade, 0.5), Tone.Type.NormalRange);
	        /**
			 *  equal power gain cross fade
			 *  @private
			 *  @type {Tone.EqualPowerGain}
			 */
	        this._equalPowerA = new Tone.EqualPowerGain();
	        /**
			 *  equal power gain cross fade
			 *  @private
			 *  @type {Tone.EqualPowerGain}
			 */
	        this._equalPowerB = new Tone.EqualPowerGain();
	        /**
			 *  invert the incoming signal
			 *  @private
			 *  @type {Tone}
			 */
	        this._invert = new Tone.Expr('1 - $0');
	        //connections
	        this.a.connect(this.output);
	        this.b.connect(this.output);
	        this.fade.chain(this._equalPowerB, this.b.gain);
	        this.fade.chain(this._invert, this._equalPowerA, this.a.gain);
	        this._readOnly('fade');
	    };
	    Tone.extend(Tone.CrossFade);
	    /**
		 *  clean up
		 *  @returns {Tone.CrossFade} this
		 */
	    Tone.CrossFade.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._writable('fade');
	        this._equalPowerA.dispose();
	        this._equalPowerA = null;
	        this._equalPowerB.dispose();
	        this._equalPowerB = null;
	        this.fade.dispose();
	        this.fade = null;
	        this._invert.dispose();
	        this._invert = null;
	        this.a.dispose();
	        this.a = null;
	        this.b.dispose();
	        this.b = null;
	        return this;
	    };
	    return Tone.CrossFade;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  Tone.Filter is a filter which allows for all of the same native methods
		 *          as the [BiquadFilterNode](http://webaudio.github.io/web-audio-api/#the-biquadfilternode-interface). 
		 *          Tone.Filter has the added ability to set the filter rolloff at -12 
		 *          (default), -24 and -48. 
		 *
		 *  @constructor
		 *  @extends {Tone}
		 *  @param {Frequency|Object} [frequency] The cutoff frequency of the filter.
		 *  @param {string=} type The type of filter.
		 *  @param {number=} rolloff The drop in decibels per octave after the cutoff frequency.
		 *                            3 choices: -12, -24, and -48
		 *  @example
		 *  var filter = new Tone.Filter(200, "highpass");
		 */
	    Tone.Filter = function () {
	        this.createInsOuts(1, 1);
	        var options = this.optionsObject(arguments, [
	            'frequency',
	            'type',
	            'rolloff'
	        ], Tone.Filter.defaults);
	        /**
			 *  the filter(s)
			 *  @type {Array}
			 *  @private
			 */
	        this._filters = [];
	        /**
			 *  The cutoff frequency of the filter. 
			 *  @type {Frequency}
			 *  @signal
			 */
	        this.frequency = new Tone.Signal(options.frequency, Tone.Type.Frequency);
	        /**
			 *  The detune parameter
			 *  @type {Cents}
			 *  @signal
			 */
	        this.detune = new Tone.Signal(0, Tone.Type.Cents);
	        /**
			 *  The gain of the filter, only used in certain filter types
			 *  @type {Number}
			 *  @signal
			 */
	        this.gain = new Tone.Signal({
	            'value': options.gain,
	            'convert': false
	        });
	        /**
			 *  The Q or Quality of the filter
			 *  @type {Positive}
			 *  @signal
			 */
	        this.Q = new Tone.Signal(options.Q);
	        /**
			 *  the type of the filter
			 *  @type {string}
			 *  @private
			 */
	        this._type = options.type;
	        /**
			 *  the rolloff value of the filter
			 *  @type {number}
			 *  @private
			 */
	        this._rolloff = options.rolloff;
	        //set the rolloff;
	        this.rolloff = options.rolloff;
	        this._readOnly([
	            'detune',
	            'frequency',
	            'gain',
	            'Q'
	        ]);
	    };
	    Tone.extend(Tone.Filter);
	    /**
		 *  the default parameters
		 *
		 *  @static
		 *  @type {Object}
		 */
	    Tone.Filter.defaults = {
	        'type': 'lowpass',
	        'frequency': 350,
	        'rolloff': -12,
	        'Q': 1,
	        'gain': 0
	    };
	    /**
		 * The type of the filter. Types: "lowpass", "highpass", 
		 * "bandpass", "lowshelf", "highshelf", "notch", "allpass", or "peaking". 
		 * @memberOf Tone.Filter#
		 * @type {string}
		 * @name type
		 */
	    Object.defineProperty(Tone.Filter.prototype, 'type', {
	        get: function () {
	            return this._type;
	        },
	        set: function (type) {
	            var types = [
	                'lowpass',
	                'highpass',
	                'bandpass',
	                'lowshelf',
	                'highshelf',
	                'notch',
	                'allpass',
	                'peaking'
	            ];
	            if (types.indexOf(type) === -1) {
	                throw new TypeError('Tone.Filter: invalid type ' + type);
	            }
	            this._type = type;
	            for (var i = 0; i < this._filters.length; i++) {
	                this._filters[i].type = type;
	            }
	        }
	    });
	    /**
		 * The rolloff of the filter which is the drop in db
		 * per octave. Implemented internally by cascading filters.
		 * Only accepts the values -12, -24, -48 and -96.
		 * @memberOf Tone.Filter#
		 * @type {number}
		 * @name rolloff
		 */
	    Object.defineProperty(Tone.Filter.prototype, 'rolloff', {
	        get: function () {
	            return this._rolloff;
	        },
	        set: function (rolloff) {
	            rolloff = parseInt(rolloff, 10);
	            var possibilities = [
	                -12,
	                -24,
	                -48,
	                -96
	            ];
	            var cascadingCount = possibilities.indexOf(rolloff);
	            //check the rolloff is valid
	            if (cascadingCount === -1) {
	                throw new RangeError('Tone.Filter: rolloff can only be -12, -24, -48 or -96');
	            }
	            cascadingCount += 1;
	            this._rolloff = rolloff;
	            //first disconnect the filters and throw them away
	            this.input.disconnect();
	            for (var i = 0; i < this._filters.length; i++) {
	                this._filters[i].disconnect();
	                this._filters[i] = null;
	            }
	            this._filters = new Array(cascadingCount);
	            for (var count = 0; count < cascadingCount; count++) {
	                var filter = this.context.createBiquadFilter();
	                filter.type = this._type;
	                this.frequency.connect(filter.frequency);
	                this.detune.connect(filter.detune);
	                this.Q.connect(filter.Q);
	                this.gain.connect(filter.gain);
	                this._filters[count] = filter;
	            }
	            //connect them up
	            var connectionChain = [this.input].concat(this._filters).concat([this.output]);
	            this.connectSeries.apply(this, connectionChain);
	        }
	    });
	    /**
		 *  Clean up. 
		 *  @return {Tone.Filter} this
		 */
	    Tone.Filter.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        for (var i = 0; i < this._filters.length; i++) {
	            this._filters[i].disconnect();
	            this._filters[i] = null;
	        }
	        this._filters = null;
	        this._writable([
	            'detune',
	            'frequency',
	            'gain',
	            'Q'
	        ]);
	        this.frequency.dispose();
	        this.Q.dispose();
	        this.frequency = null;
	        this.Q = null;
	        this.detune.dispose();
	        this.detune = null;
	        this.gain.dispose();
	        this.gain = null;
	        return this;
	    };
	    return Tone.Filter;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Split the incoming signal into three bands (low, mid, high)
		 *         with two crossover frequency controls. 
		 *
		 *  @extends {Tone}
		 *  @constructor
		 *  @param {Frequency|Object} [lowFrequency] the low/mid crossover frequency
		 *  @param {Frequency} [highFrequency] the mid/high crossover frequency
		 */
	    Tone.MultibandSplit = function () {
	        var options = this.optionsObject(arguments, [
	            'lowFrequency',
	            'highFrequency'
	        ], Tone.MultibandSplit.defaults);
	        /**
			 *  the input
			 *  @type {Tone.Gain}
			 *  @private
			 */
	        this.input = new Tone.Gain();
	        /**
			 *  the outputs
			 *  @type {Array}
			 *  @private
			 */
	        this.output = new Array(3);
	        /**
			 *  The low band. Alias for <code>output[0]</code>
			 *  @type {Tone.Filter}
			 */
	        this.low = this.output[0] = new Tone.Filter(0, 'lowpass');
	        /**
			 *  the lower filter of the mid band
			 *  @type {Tone.Filter}
			 *  @private
			 */
	        this._lowMidFilter = new Tone.Filter(0, 'highpass');
	        /**
			 *  The mid band output. Alias for <code>output[1]</code>
			 *  @type {Tone.Filter}
			 */
	        this.mid = this.output[1] = new Tone.Filter(0, 'lowpass');
	        /**
			 *  The high band output. Alias for <code>output[2]</code>
			 *  @type {Tone.Filter}
			 */
	        this.high = this.output[2] = new Tone.Filter(0, 'highpass');
	        /**
			 *  The low/mid crossover frequency.
			 *  @type {Frequency}
			 *  @signal
			 */
	        this.lowFrequency = new Tone.Signal(options.lowFrequency, Tone.Type.Frequency);
	        /**
			 *  The mid/high crossover frequency.
			 *  @type {Frequency}
			 *  @signal
			 */
	        this.highFrequency = new Tone.Signal(options.highFrequency, Tone.Type.Frequency);
	        /**
			 *  The quality of all the filters
			 *  @type {Number}
			 *  @signal
			 */
	        this.Q = new Tone.Signal(options.Q);
	        this.input.fan(this.low, this.high);
	        this.input.chain(this._lowMidFilter, this.mid);
	        //the frequency control signal
	        this.lowFrequency.connect(this.low.frequency);
	        this.lowFrequency.connect(this._lowMidFilter.frequency);
	        this.highFrequency.connect(this.mid.frequency);
	        this.highFrequency.connect(this.high.frequency);
	        //the Q value
	        this.Q.connect(this.low.Q);
	        this.Q.connect(this._lowMidFilter.Q);
	        this.Q.connect(this.mid.Q);
	        this.Q.connect(this.high.Q);
	        this._readOnly([
	            'high',
	            'mid',
	            'low',
	            'highFrequency',
	            'lowFrequency'
	        ]);
	    };
	    Tone.extend(Tone.MultibandSplit);
	    /**
		 *  @private
		 *  @static
		 *  @type {Object}
		 */
	    Tone.MultibandSplit.defaults = {
	        'lowFrequency': 400,
	        'highFrequency': 2500,
	        'Q': 1
	    };
	    /**
		 *  Clean up.
		 *  @returns {Tone.MultibandSplit} this
		 */
	    Tone.MultibandSplit.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._writable([
	            'high',
	            'mid',
	            'low',
	            'highFrequency',
	            'lowFrequency'
	        ]);
	        this.low.dispose();
	        this.low = null;
	        this._lowMidFilter.dispose();
	        this._lowMidFilter = null;
	        this.mid.dispose();
	        this.mid = null;
	        this.high.dispose();
	        this.high = null;
	        this.lowFrequency.dispose();
	        this.lowFrequency = null;
	        this.highFrequency.dispose();
	        this.highFrequency = null;
	        this.Q.dispose();
	        this.Q = null;
	        return this;
	    };
	    return Tone.MultibandSplit;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Tone.EQ3 is a three band EQ with control over low, mid, and high gain as
		 *         well as the low and high crossover frequencies.
		 *
		 *  @constructor
		 *  @extends {Tone}
		 *  
		 *  @param {Decibels|Object} [lowLevel] The gain applied to the lows.
		 *  @param {Decibels} [midLevel] The gain applied to the mid.
		 *  @param {Decibels} [highLevel] The gain applied to the high.
		 *  @example
		 * var eq = new Tone.EQ3(-10, 3, -20);
		 */
	    Tone.EQ3 = function () {
	        var options = this.optionsObject(arguments, [
	            'low',
	            'mid',
	            'high'
	        ], Tone.EQ3.defaults);
	        /**
			 *  the output node
			 *  @type {GainNode}
			 *  @private
			 */
	        this.output = new Tone.Gain();
	        /**
			 *  the multiband split
			 *  @type {Tone.MultibandSplit}
			 *  @private
			 */
	        this._multibandSplit = this.input = new Tone.MultibandSplit({
	            'lowFrequency': options.lowFrequency,
	            'highFrequency': options.highFrequency
	        });
	        /**
			 *  The gain for the lower signals
			 *  @type  {Tone.Gain}
			 *  @private
			 */
	        this._lowGain = new Tone.Gain(options.low, Tone.Type.Decibels);
	        /**
			 *  The gain for the mid signals
			 *  @type  {Tone.Gain}
			 *  @private
			 */
	        this._midGain = new Tone.Gain(options.mid, Tone.Type.Decibels);
	        /**
			 * The gain in decibels of the high part
			 * @type {Tone.Gain}
			 * @private
			 */
	        this._highGain = new Tone.Gain(options.high, Tone.Type.Decibels);
	        /**
			 * The gain in decibels of the low part
			 * @type {Decibels}
			 * @signal
			 */
	        this.low = this._lowGain.gain;
	        /**
			 * The gain in decibels of the mid part
			 * @type {Decibels}
			 * @signal
			 */
	        this.mid = this._midGain.gain;
	        /**
			 * The gain in decibels of the high part
			 * @type {Decibels}
			 * @signal
			 */
	        this.high = this._highGain.gain;
	        /**
			 *  The Q value for all of the filters. 
			 *  @type {Positive}
			 *  @signal
			 */
	        this.Q = this._multibandSplit.Q;
	        /**
			 *  The low/mid crossover frequency. 
			 *  @type {Frequency}
			 *  @signal
			 */
	        this.lowFrequency = this._multibandSplit.lowFrequency;
	        /**
			 *  The mid/high crossover frequency. 
			 *  @type {Frequency}
			 *  @signal
			 */
	        this.highFrequency = this._multibandSplit.highFrequency;
	        //the frequency bands
	        this._multibandSplit.low.chain(this._lowGain, this.output);
	        this._multibandSplit.mid.chain(this._midGain, this.output);
	        this._multibandSplit.high.chain(this._highGain, this.output);
	        this._readOnly([
	            'low',
	            'mid',
	            'high',
	            'lowFrequency',
	            'highFrequency'
	        ]);
	    };
	    Tone.extend(Tone.EQ3);
	    /**
		 *  the default values
		 */
	    Tone.EQ3.defaults = {
	        'low': 0,
	        'mid': 0,
	        'high': 0,
	        'lowFrequency': 400,
	        'highFrequency': 2500
	    };
	    /**
		 *  clean up
		 *  @returns {Tone.EQ3} this
		 */
	    Tone.EQ3.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._writable([
	            'low',
	            'mid',
	            'high',
	            'lowFrequency',
	            'highFrequency'
	        ]);
	        this._multibandSplit.dispose();
	        this._multibandSplit = null;
	        this.lowFrequency = null;
	        this.highFrequency = null;
	        this._lowGain.dispose();
	        this._lowGain = null;
	        this._midGain.dispose();
	        this._midGain = null;
	        this._highGain.dispose();
	        this._highGain = null;
	        this.low = null;
	        this.mid = null;
	        this.high = null;
	        this.Q = null;
	        return this;
	    };
	    return Tone.EQ3;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  Performs a linear scaling on an input signal.
		 *          Scales a NormalRange input to between
		 *          outputMin and outputMax.
		 *
		 *  @constructor
		 *  @extends {Tone.SignalBase}
		 *  @param {number} [outputMin=0] The output value when the input is 0. 
		 *  @param {number} [outputMax=1]	The output value when the input is 1. 
		 *  @example
		 * var scale = new Tone.Scale(50, 100);
		 * var signal = new Tone.Signal(0.5).connect(scale);
		 * //the output of scale equals 75
		 */
	    Tone.Scale = function (outputMin, outputMax) {
	        /** 
			 *  @private
			 *  @type {number}
			 */
	        this._outputMin = this.defaultArg(outputMin, 0);
	        /** 
			 *  @private
			 *  @type {number}
			 */
	        this._outputMax = this.defaultArg(outputMax, 1);
	        /** 
			 *  @private
			 *  @type {Tone.Multiply}
			 *  @private
			 */
	        this._scale = this.input = new Tone.Multiply(1);
	        /** 
			 *  @private
			 *  @type {Tone.Add}
			 *  @private
			 */
	        this._add = this.output = new Tone.Add(0);
	        this._scale.connect(this._add);
	        this._setRange();
	    };
	    Tone.extend(Tone.Scale, Tone.SignalBase);
	    /**
		 * The minimum output value. This number is output when 
		 * the value input value is 0. 
		 * @memberOf Tone.Scale#
		 * @type {number}
		 * @name min
		 */
	    Object.defineProperty(Tone.Scale.prototype, 'min', {
	        get: function () {
	            return this._outputMin;
	        },
	        set: function (min) {
	            this._outputMin = min;
	            this._setRange();
	        }
	    });
	    /**
		 * The maximum output value. This number is output when 
		 * the value input value is 1. 
		 * @memberOf Tone.Scale#
		 * @type {number}
		 * @name max
		 */
	    Object.defineProperty(Tone.Scale.prototype, 'max', {
	        get: function () {
	            return this._outputMax;
	        },
	        set: function (max) {
	            this._outputMax = max;
	            this._setRange();
	        }
	    });
	    /**
		 *  set the values
		 *  @private
		 */
	    Tone.Scale.prototype._setRange = function () {
	        this._add.value = this._outputMin;
	        this._scale.value = this._outputMax - this._outputMin;
	    };
	    /**
		 *  Clean up.
		 *  @returns {Tone.Scale} this
		 */
	    Tone.Scale.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._add.dispose();
	        this._add = null;
	        this._scale.dispose();
	        this._scale = null;
	        return this;
	    };
	    return Tone.Scale;
	});
	Module(function (Tone) {
	    /**
		 *  @class  Performs an exponential scaling on an input signal.
		 *          Scales a NormalRange value [0,1] exponentially
		 *          to the output range of outputMin to outputMax.
		 *
		 *  @constructor
		 *  @extends {Tone.SignalBase}
		 *  @param {number} [outputMin=0] The output value when the input is 0. 
		 *  @param {number} [outputMax=1]	The output value when the input is 1. 
		 *  @param {number} [exponent=2] The exponent which scales the incoming signal.
		 *  @example
		 * var scaleExp = new Tone.ScaleExp(0, 100, 2);
		 * var signal = new Tone.Signal(0.5).connect(scaleExp);
		 */
	    Tone.ScaleExp = function (outputMin, outputMax, exponent) {
	        /**
			 *  scale the input to the output range
			 *  @type {Tone.Scale}
			 *  @private
			 */
	        this._scale = this.output = new Tone.Scale(outputMin, outputMax);
	        /**
			 *  @private
			 *  @type {Tone.Pow}
			 *  @private
			 */
	        this._exp = this.input = new Tone.Pow(this.defaultArg(exponent, 2));
	        this._exp.connect(this._scale);
	    };
	    Tone.extend(Tone.ScaleExp, Tone.SignalBase);
	    /**
		 * Instead of interpolating linearly between the <code>min</code> and 
		 * <code>max</code> values, setting the exponent will interpolate between
		 * the two values with an exponential curve. 
		 * @memberOf Tone.ScaleExp#
		 * @type {number}
		 * @name exponent
		 */
	    Object.defineProperty(Tone.ScaleExp.prototype, 'exponent', {
	        get: function () {
	            return this._exp.value;
	        },
	        set: function (exp) {
	            this._exp.value = exp;
	        }
	    });
	    /**
		 * The minimum output value. This number is output when 
		 * the value input value is 0. 
		 * @memberOf Tone.ScaleExp#
		 * @type {number}
		 * @name min
		 */
	    Object.defineProperty(Tone.ScaleExp.prototype, 'min', {
	        get: function () {
	            return this._scale.min;
	        },
	        set: function (min) {
	            this._scale.min = min;
	        }
	    });
	    /**
		 * The maximum output value. This number is output when 
		 * the value input value is 1. 
		 * @memberOf Tone.ScaleExp#
		 * @type {number}
		 * @name max
		 */
	    Object.defineProperty(Tone.ScaleExp.prototype, 'max', {
	        get: function () {
	            return this._scale.max;
	        },
	        set: function (max) {
	            this._scale.max = max;
	        }
	    });
	    /**
		 *  Clean up.
		 *  @returns {Tone.ScaleExp} this
		 */
	    Tone.ScaleExp.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._scale.dispose();
	        this._scale = null;
	        this._exp.dispose();
	        this._exp = null;
	        return this;
	    };
	    return Tone.ScaleExp;
	});
	Module(function (Tone) {
	    
	    /**
		 *  createDelay shim
		 *  @private
		 */
	    if (window.DelayNode && !AudioContext.prototype.createDelay) {
	        AudioContext.prototype.createDelay = AudioContext.prototype.createDelayNode;
	    }
	    /**
		 *  @class Wrapper around Web Audio's native [DelayNode](http://webaudio.github.io/web-audio-api/#the-delaynode-interface). 
		 *  @extends {Tone}
		 *  @param {Time=} delayTime The delay applied to the incoming signal.
		 *  @param {Time=} maxDelay The maximum delay time. 
		 */
	    Tone.Delay = function () {
	        var options = this.optionsObject(arguments, [
	            'delayTime',
	            'maxDelay'
	        ], Tone.Delay.defaults);
	        /**
			 *  The native delay node
			 *  @type {DelayNode}
			 *  @private
			 */
	        this._delayNode = this.input = this.output = this.context.createDelay(this.toSeconds(options.maxDelay));
	        /**
			 *  The amount of time the incoming signal is
			 *  delayed. 
			 *  @type {Tone.Param}
			 *  @signal
			 */
	        this.delayTime = new Tone.Param({
	            'param': this._delayNode.delayTime,
	            'units': Tone.Type.Time,
	            'value': options.delayTime
	        });
	        this._readOnly('delayTime');
	    };
	    Tone.extend(Tone.Delay);
	    /**
		 *  The defaults
		 *  @const
		 *  @type  {Object}
		 */
	    Tone.Delay.defaults = {
	        'maxDelay': 1,
	        'delayTime': 0
	    };
	    /**
		 *  Clean up.
		 *  @return  {Tone.Delay}  this
		 */
	    Tone.Delay.prototype.dispose = function () {
	        Tone.Param.prototype.dispose.call(this);
	        this._delayNode.disconnect();
	        this._delayNode = null;
	        this._writable('delayTime');
	        this.delayTime = null;
	        return this;
	    };
	    return Tone.Delay;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Comb filters are basic building blocks for physical modeling. Read more
		 *         about comb filters on [CCRMA's website](https://ccrma.stanford.edu/~jos/pasp/Feedback_Comb_Filters.html).
		 *
		 *  @extends {Tone}
		 *  @constructor
		 *  @param {Time|Object} [delayTime] The delay time of the filter. 
		 *  @param {NormalRange=} resonance The amount of feedback the filter has. 
		 */
	    Tone.FeedbackCombFilter = function () {
	        var options = this.optionsObject(arguments, [
	            'delayTime',
	            'resonance'
	        ], Tone.FeedbackCombFilter.defaults);
	        /**
			 *  the delay node
			 *  @type {DelayNode}
			 *  @private
			 */
	        this._delay = this.input = this.output = new Tone.Delay(options.delayTime);
	        /**
			 *  The amount of delay of the comb filter. 
			 *  @type {Time}
			 *  @signal
			 */
	        this.delayTime = this._delay.delayTime;
	        /**
			 *  the feedback node
			 *  @type {GainNode}
			 *  @private
			 */
	        this._feedback = new Tone.Gain(options.resonance, Tone.Type.NormalRange);
	        /**
			 *  The amount of feedback of the delayed signal. 
			 *  @type {NormalRange}
			 *  @signal
			 */
	        this.resonance = this._feedback.gain;
	        this._delay.chain(this._feedback, this._delay);
	        this._readOnly([
	            'resonance',
	            'delayTime'
	        ]);
	    };
	    Tone.extend(Tone.FeedbackCombFilter);
	    /**
		 *  the default parameters
		 *  @static
		 *  @const
		 *  @type {Object}
		 */
	    Tone.FeedbackCombFilter.defaults = {
	        'delayTime': 0.1,
	        'resonance': 0.5
	    };
	    /**
		 *  clean up
		 *  @returns {Tone.FeedbackCombFilter} this
		 */
	    Tone.FeedbackCombFilter.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._writable([
	            'resonance',
	            'delayTime'
	        ]);
	        this._delay.dispose();
	        this._delay = null;
	        this.delayTime = null;
	        this._feedback.dispose();
	        this._feedback = null;
	        this.resonance = null;
	        return this;
	    };
	    return Tone.FeedbackCombFilter;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  Tone.Follower is a  crude envelope follower which will follow 
		 *          the amplitude of an incoming signal. 
		 *          Take care with small (< 0.02) attack or decay values 
		 *          as follower has some ripple which is exaggerated
		 *          at these values. Read more about envelope followers (also known 
		 *          as envelope detectors) on [Wikipedia](https://en.wikipedia.org/wiki/Envelope_detector).
		 *  
		 *  @constructor
		 *  @extends {Tone}
		 *  @param {Time|Object} [attack] The rate at which the follower rises.
		 *  @param {Time=} release The rate at which the folower falls. 
		 *  @example
		 * var follower = new Tone.Follower(0.2, 0.4);
		 */
	    Tone.Follower = function () {
	        this.createInsOuts(1, 1);
	        var options = this.optionsObject(arguments, [
	            'attack',
	            'release'
	        ], Tone.Follower.defaults);
	        /**
			 *  @type {Tone.Abs}
			 *  @private
			 */
	        this._abs = new Tone.Abs();
	        /**
			 *  the lowpass filter which smooths the input
			 *  @type {BiquadFilterNode}
			 *  @private
			 */
	        this._filter = this.context.createBiquadFilter();
	        this._filter.type = 'lowpass';
	        this._filter.frequency.value = 0;
	        this._filter.Q.value = -100;
	        /**
			 *  @type {WaveShaperNode}
			 *  @private
			 */
	        this._frequencyValues = new Tone.WaveShaper();
	        /**
			 *  @type {Tone.Subtract}
			 *  @private
			 */
	        this._sub = new Tone.Subtract();
	        /**
			 *  @type {Tone.Delay}
			 *  @private
			 */
	        this._delay = new Tone.Delay(this.blockTime);
	        /**
			 *  this keeps it far from 0, even for very small differences
			 *  @type {Tone.Multiply}
			 *  @private
			 */
	        this._mult = new Tone.Multiply(10000);
	        /**
			 *  @private
			 *  @type {number}
			 */
	        this._attack = options.attack;
	        /**
			 *  @private
			 *  @type {number}
			 */
	        this._release = options.release;
	        //the smoothed signal to get the values
	        this.input.chain(this._abs, this._filter, this.output);
	        //the difference path
	        this._abs.connect(this._sub, 0, 1);
	        this._filter.chain(this._delay, this._sub);
	        //threshold the difference and use the thresh to set the frequency
	        this._sub.chain(this._mult, this._frequencyValues, this._filter.frequency);
	        //set the attack and release values in the table
	        this._setAttackRelease(this._attack, this._release);
	    };
	    Tone.extend(Tone.Follower);
	    /**
		 *  @static
		 *  @type {Object}
		 */
	    Tone.Follower.defaults = {
	        'attack': 0.05,
	        'release': 0.5
	    };
	    /**
		 *  sets the attack and release times in the wave shaper
		 *  @param   {Time} attack  
		 *  @param   {Time} release 
		 *  @private
		 */
	    Tone.Follower.prototype._setAttackRelease = function (attack, release) {
	        var minTime = this.blockTime;
	        attack = Tone.Time(attack).toFrequency();
	        release = Tone.Time(release).toFrequency();
	        attack = Math.max(attack, minTime);
	        release = Math.max(release, minTime);
	        this._frequencyValues.setMap(function (val) {
	            if (val <= 0) {
	                return attack;
	            } else {
	                return release;
	            }
	        });
	    };
	    /**
		 * The attack time.
		 * @memberOf Tone.Follower#
		 * @type {Time}
		 * @name attack
		 */
	    Object.defineProperty(Tone.Follower.prototype, 'attack', {
	        get: function () {
	            return this._attack;
	        },
	        set: function (attack) {
	            this._attack = attack;
	            this._setAttackRelease(this._attack, this._release);
	        }
	    });
	    /**
		 * The release time.
		 * @memberOf Tone.Follower#
		 * @type {Time}
		 * @name release
		 */
	    Object.defineProperty(Tone.Follower.prototype, 'release', {
	        get: function () {
	            return this._release;
	        },
	        set: function (release) {
	            this._release = release;
	            this._setAttackRelease(this._attack, this._release);
	        }
	    });
	    /**
		 *  Borrows the connect method from Signal so that the output can be used
		 *  as a Tone.Signal control signal.
		 *  @function
		 */
	    Tone.Follower.prototype.connect = Tone.Signal.prototype.connect;
	    /**
		 *  dispose
		 *  @returns {Tone.Follower} this
		 */
	    Tone.Follower.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._filter.disconnect();
	        this._filter = null;
	        this._frequencyValues.disconnect();
	        this._frequencyValues = null;
	        this._delay.dispose();
	        this._delay = null;
	        this._sub.disconnect();
	        this._sub = null;
	        this._abs.dispose();
	        this._abs = null;
	        this._mult.dispose();
	        this._mult = null;
	        this._curve = null;
	        return this;
	    };
	    return Tone.Follower;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Tone.ScaledEnvelop is an envelope which can be scaled 
		 *         to any range. It's useful for applying an envelope 
		 *         to a frequency or any other non-NormalRange signal 
		 *         parameter. 
		 *
		 *  @extends {Tone.Envelope}
		 *  @constructor
		 *  @param {Time|Object} [attack]	the attack time in seconds
		 *  @param {Time} [decay]	the decay time in seconds
		 *  @param {number} [sustain] 	a percentage (0-1) of the full amplitude
		 *  @param {Time} [release]	the release time in seconds
		 *  @example
		 *  var scaledEnv = new Tone.ScaledEnvelope({
		 *  	"attack" : 0.2,
		 *  	"min" : 200,
		 *  	"max" : 2000
		 *  });
		 *  scaledEnv.connect(oscillator.frequency);
		 */
	    Tone.ScaledEnvelope = function () {
	        //get all of the defaults
	        var options = this.optionsObject(arguments, [
	            'attack',
	            'decay',
	            'sustain',
	            'release'
	        ], Tone.Envelope.defaults);
	        Tone.Envelope.call(this, options);
	        options = this.defaultArg(options, Tone.ScaledEnvelope.defaults);
	        /** 
			 *  scale the incoming signal by an exponent
			 *  @type {Tone.Pow}
			 *  @private
			 */
	        this._exp = this.output = new Tone.Pow(options.exponent);
	        /**
			 *  scale the signal to the desired range
			 *  @type {Tone.Multiply}
			 *  @private
			 */
	        this._scale = this.output = new Tone.Scale(options.min, options.max);
	        this._sig.chain(this._exp, this._scale);
	    };
	    Tone.extend(Tone.ScaledEnvelope, Tone.Envelope);
	    /**
		 *  the default parameters
		 *  @static
		 */
	    Tone.ScaledEnvelope.defaults = {
	        'min': 0,
	        'max': 1,
	        'exponent': 1
	    };
	    /**
		 * The envelope's min output value. This is the value which it
		 * starts at. 
		 * @memberOf Tone.ScaledEnvelope#
		 * @type {number}
		 * @name min
		 */
	    Object.defineProperty(Tone.ScaledEnvelope.prototype, 'min', {
	        get: function () {
	            return this._scale.min;
	        },
	        set: function (min) {
	            this._scale.min = min;
	        }
	    });
	    /**
		 * The envelope's max output value. In other words, the value
		 * at the peak of the attack portion of the envelope. 
		 * @memberOf Tone.ScaledEnvelope#
		 * @type {number}
		 * @name max
		 */
	    Object.defineProperty(Tone.ScaledEnvelope.prototype, 'max', {
	        get: function () {
	            return this._scale.max;
	        },
	        set: function (max) {
	            this._scale.max = max;
	        }
	    });
	    /**
		 * The envelope's exponent value. 
		 * @memberOf Tone.ScaledEnvelope#
		 * @type {number}
		 * @name exponent
		 */
	    Object.defineProperty(Tone.ScaledEnvelope.prototype, 'exponent', {
	        get: function () {
	            return this._exp.value;
	        },
	        set: function (exp) {
	            this._exp.value = exp;
	        }
	    });
	    /**
		 *  clean up
		 *  @returns {Tone.ScaledEnvelope} this
		 */
	    Tone.ScaledEnvelope.prototype.dispose = function () {
	        Tone.Envelope.prototype.dispose.call(this);
	        this._scale.dispose();
	        this._scale = null;
	        this._exp.dispose();
	        this._exp = null;
	        return this;
	    };
	    return Tone.ScaledEnvelope;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Tone.FrequencyEnvelope is a Tone.ScaledEnvelope, but instead of `min` and `max`
		 *         it's got a `baseFrequency` and `octaves` parameter. 
		 *
		 *  @extends {Tone.Envelope}
		 *  @constructor
		 *  @param {Time|Object} [attack]	the attack time in seconds
		 *  @param {Time} [decay]	the decay time in seconds
		 *  @param {number} [sustain] 	a percentage (0-1) of the full amplitude
		 *  @param {Time} [release]	the release time in seconds
		 *  @example
		 *  var env = new Tone.FrequencyEnvelope({
		 *  	"attack" : 0.2,
		 *  	"baseFrequency" : "C2",
		 *  	"octaves" : 4
		 *  });
		 *  scaledEnv.connect(oscillator.frequency);
		 */
	    Tone.FrequencyEnvelope = function () {
	        var options = this.optionsObject(arguments, [
	            'attack',
	            'decay',
	            'sustain',
	            'release'
	        ], Tone.Envelope.defaults);
	        Tone.ScaledEnvelope.call(this, options);
	        options = this.defaultArg(options, Tone.FrequencyEnvelope.defaults);
	        /**
			 *  Stores the octave value
			 *  @type {Positive}
			 *  @private
			 */
	        this._octaves = options.octaves;
	        //setup
	        this.baseFrequency = options.baseFrequency;
	        this.octaves = options.octaves;
	    };
	    Tone.extend(Tone.FrequencyEnvelope, Tone.Envelope);
	    /**
		 *  the default parameters
		 *  @static
		 */
	    Tone.FrequencyEnvelope.defaults = {
	        'baseFrequency': 200,
	        'octaves': 4,
	        'exponent': 2
	    };
	    /**
		 * The envelope's mininum output value. This is the value which it
		 * starts at. 
		 * @memberOf Tone.FrequencyEnvelope#
		 * @type {Frequency}
		 * @name baseFrequency
		 */
	    Object.defineProperty(Tone.FrequencyEnvelope.prototype, 'baseFrequency', {
	        get: function () {
	            return this._scale.min;
	        },
	        set: function (min) {
	            this._scale.min = this.toFrequency(min);
	            //also update the octaves
	            this.octaves = this._octaves;
	        }
	    });
	    /**
		 * The number of octaves above the baseFrequency that the
		 * envelope will scale to.
		 * @memberOf Tone.FrequencyEnvelope#
		 * @type {Positive}
		 * @name octaves
		 */
	    Object.defineProperty(Tone.FrequencyEnvelope.prototype, 'octaves', {
	        get: function () {
	            return this._octaves;
	        },
	        set: function (octaves) {
	            this._octaves = octaves;
	            this._scale.max = this.baseFrequency * Math.pow(2, octaves);
	        }
	    });
	    /**
		 * The envelope's exponent value. 
		 * @memberOf Tone.FrequencyEnvelope#
		 * @type {number}
		 * @name exponent
		 */
	    Object.defineProperty(Tone.FrequencyEnvelope.prototype, 'exponent', {
	        get: function () {
	            return this._exp.value;
	        },
	        set: function (exp) {
	            this._exp.value = exp;
	        }
	    });
	    /**
		 *  clean up
		 *  @returns {Tone.FrequencyEnvelope} this
		 */
	    Tone.FrequencyEnvelope.prototype.dispose = function () {
	        Tone.ScaledEnvelope.prototype.dispose.call(this);
	        return this;
	    };
	    return Tone.FrequencyEnvelope;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  Tone.Gate only passes a signal through when the incoming 
		 *          signal exceeds a specified threshold. To do this, Gate uses 
		 *          a Tone.Follower to follow the amplitude of the incoming signal. 
		 *          A common implementation of this class is a [Noise Gate](https://en.wikipedia.org/wiki/Noise_gate).
		 *  
		 *  @constructor
		 *  @extends {Tone}
		 *  @param {Decibels|Object} [threshold] The threshold above which the gate will open. 
		 *  @param {Time=} attack The follower's attack time
		 *  @param {Time=} release The follower's release time
		 *  @example
		 * var gate = new Tone.Gate(-30, 0.2, 0.3).toMaster();
		 * var mic = new Tone.UserMedia().connect(gate);
		 * //the gate will only pass through the incoming 
		 * //signal when it's louder than -30db
		 */
	    Tone.Gate = function () {
	        this.createInsOuts(1, 1);
	        var options = this.optionsObject(arguments, [
	            'threshold',
	            'attack',
	            'release'
	        ], Tone.Gate.defaults);
	        /**
			 *  @type {Tone.Follower}
			 *  @private
			 */
	        this._follower = new Tone.Follower(options.attack, options.release);
	        /**
			 *  @type {Tone.GreaterThan}
			 *  @private
			 */
	        this._gt = new Tone.GreaterThan(this.dbToGain(options.threshold));
	        //the connections
	        this.input.connect(this.output);
	        //the control signal
	        this.input.chain(this._gt, this._follower, this.output.gain);
	    };
	    Tone.extend(Tone.Gate);
	    /**
		 *  @const
		 *  @static
		 *  @type {Object}
		 */
	    Tone.Gate.defaults = {
	        'attack': 0.1,
	        'release': 0.1,
	        'threshold': -40
	    };
	    /**
		 * The threshold of the gate in decibels
		 * @memberOf Tone.Gate#
		 * @type {Decibels}
		 * @name threshold
		 */
	    Object.defineProperty(Tone.Gate.prototype, 'threshold', {
	        get: function () {
	            return this.gainToDb(this._gt.value);
	        },
	        set: function (thresh) {
	            this._gt.value = this.dbToGain(thresh);
	        }
	    });
	    /**
		 * The attack speed of the gate
		 * @memberOf Tone.Gate#
		 * @type {Time}
		 * @name attack
		 */
	    Object.defineProperty(Tone.Gate.prototype, 'attack', {
	        get: function () {
	            return this._follower.attack;
	        },
	        set: function (attackTime) {
	            this._follower.attack = attackTime;
	        }
	    });
	    /**
		 * The release speed of the gate
		 * @memberOf Tone.Gate#
		 * @type {Time}
		 * @name release
		 */
	    Object.defineProperty(Tone.Gate.prototype, 'release', {
	        get: function () {
	            return this._follower.release;
	        },
	        set: function (releaseTime) {
	            this._follower.release = releaseTime;
	        }
	    });
	    /**
		 *  Clean up. 
		 *  @returns {Tone.Gate} this
		 */
	    Tone.Gate.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._follower.dispose();
	        this._gt.dispose();
	        this._follower = null;
	        this._gt = null;
	        return this;
	    };
	    return Tone.Gate;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  A Timeline State. Provides the methods: <code>setStateAtTime("state", time)</code>
		 *          and <code>getValueAtTime(time)</code>.
		 *
		 *  @extends {Tone.Timeline}
		 *  @param {String} initial The initial state of the TimelineState. 
		 *                          Defaults to <code>undefined</code>
		 */
	    Tone.TimelineState = function (initial) {
	        Tone.Timeline.call(this);
	        /**
			 *  The initial state
			 *  @private
			 *  @type {String}
			 */
	        this._initial = initial;
	    };
	    Tone.extend(Tone.TimelineState, Tone.Timeline);
	    /**
		 *  Returns the scheduled state scheduled before or at
		 *  the given time.
		 *  @param  {Number}  time  The time to query.
		 *  @return  {String}  The name of the state input in setStateAtTime.
		 */
	    Tone.TimelineState.prototype.getValueAtTime = function (time) {
	        var event = this.get(time);
	        if (event !== null) {
	            return event.state;
	        } else {
	            return this._initial;
	        }
	    };
	    /**
		 *  Returns the scheduled state scheduled before or at
		 *  the given time.
		 *  @param  {String}  state The name of the state to set.
		 *  @param  {Number}  time  The time to query.
		 */
	    Tone.TimelineState.prototype.setStateAtTime = function (state, time) {
	        this.add({
	            'state': state,
	            'time': time
	        });
	    };
	    return Tone.TimelineState;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  A sample accurate clock which provides a callback at the given rate. 
		 *          While the callback is not sample-accurate (it is still susceptible to
		 *          loose JS timing), the time passed in as the argument to the callback
		 *          is precise. For most applications, it is better to use Tone.Transport
		 *          instead of the Clock by itself since you can synchronize multiple callbacks.
		 *
		 * 	@constructor
		 *  @extends {Tone.Emitter}
		 * 	@param {function} callback The callback to be invoked with the time of the audio event
		 * 	@param {Frequency} frequency The rate of the callback
		 * 	@example
		 * //the callback will be invoked approximately once a second
		 * //and will print the time exactly once a second apart.
		 * var clock = new Tone.Clock(function(time){
		 * 	console.log(time);
		 * }, 1);
		 */
	    Tone.Clock = function () {
	        Tone.Emitter.call(this);
	        var options = this.optionsObject(arguments, [
	            'callback',
	            'frequency'
	        ], Tone.Clock.defaults);
	        /**
			 *  The callback function to invoke at the scheduled tick.
			 *  @type  {Function}
			 */
	        this.callback = options.callback;
	        /**
			 *  The next time the callback is scheduled.
			 *  @type {Number}
			 *  @private
			 */
	        this._nextTick = 0;
	        /**
			 *  The last state of the clock.
			 *  @type  {State}
			 *  @private
			 */
	        this._lastState = Tone.State.Stopped;
	        /**
			 *  The rate the callback function should be invoked. 
			 *  @type  {BPM}
			 *  @signal
			 */
	        this.frequency = new Tone.TimelineSignal(options.frequency, Tone.Type.Frequency);
	        this._readOnly('frequency');
	        /**
			 *  The number of times the callback was invoked. Starts counting at 0
			 *  and increments after the callback was invoked. 
			 *  @type {Ticks}
			 *  @readOnly
			 */
	        this.ticks = 0;
	        /**
			 *  The state timeline
			 *  @type {Tone.TimelineState}
			 *  @private
			 */
	        this._state = new Tone.TimelineState(Tone.State.Stopped);
	        /**
			 *  The loop function bound to its context. 
			 *  This is necessary to remove the event in the end.
			 *  @type {Function}
			 *  @private
			 */
	        this._boundLoop = this._loop.bind(this);
	        //bind a callback to the worker thread
	        this.context.on('tick', this._boundLoop);
	    };
	    Tone.extend(Tone.Clock, Tone.Emitter);
	    /**
		 *  The defaults
		 *  @const
		 *  @type  {Object}
		 */
	    Tone.Clock.defaults = {
	        'callback': Tone.noOp,
	        'frequency': 1,
	        'lookAhead': 'auto'
	    };
	    /**
		 *  Returns the playback state of the source, either "started", "stopped" or "paused".
		 *  @type {Tone.State}
		 *  @readOnly
		 *  @memberOf Tone.Clock#
		 *  @name state
		 */
	    Object.defineProperty(Tone.Clock.prototype, 'state', {
	        get: function () {
	            return this._state.getValueAtTime(this.now());
	        }
	    });
	    /**
		 *  Start the clock at the given time. Optionally pass in an offset
		 *  of where to start the tick counter from.
		 *  @param  {Time}  time    The time the clock should start
		 *  @param  {Ticks=}  offset  Where the tick counter starts counting from.
		 *  @return  {Tone.Clock}  this
		 */
	    Tone.Clock.prototype.start = function (time, offset) {
	        time = this.toSeconds(time);
	        if (this._state.getValueAtTime(time) !== Tone.State.Started) {
	            this._state.add({
	                'state': Tone.State.Started,
	                'time': time,
	                'offset': offset
	            });
	        }
	        return this;
	    };
	    /**
		 *  Stop the clock. Stopping the clock resets the tick counter to 0.
		 *  @param {Time} [time=now] The time when the clock should stop.
		 *  @returns {Tone.Clock} this
		 *  @example
		 * clock.stop();
		 */
	    Tone.Clock.prototype.stop = function (time) {
	        time = this.toSeconds(time);
	        this._state.cancel(time);
	        this._state.setStateAtTime(Tone.State.Stopped, time);
	        return this;
	    };
	    /**
		 *  Pause the clock. Pausing does not reset the tick counter.
		 *  @param {Time} [time=now] The time when the clock should stop.
		 *  @returns {Tone.Clock} this
		 */
	    Tone.Clock.prototype.pause = function (time) {
	        time = this.toSeconds(time);
	        if (this._state.getValueAtTime(time) === Tone.State.Started) {
	            this._state.setStateAtTime(Tone.State.Paused, time);
	        }
	        return this;
	    };
	    /**
		 *  The scheduling loop.
		 *  @param  {Number}  time  The current page time starting from 0
		 *                          when the page was loaded.
		 *  @private
		 */
	    Tone.Clock.prototype._loop = function () {
	        //get the frequency value to compute the value of the next loop
	        var now = this.now();
	        //if it's started
	        var lookAhead = this.context.lookAhead;
	        var updateInterval = this.context.updateInterval;
	        var lagCompensation = this.context.lag * 2;
	        var loopInterval = now + lookAhead + updateInterval + lagCompensation;
	        while (loopInterval > this._nextTick && this._state) {
	            var currentState = this._state.getValueAtTime(this._nextTick);
	            if (currentState !== this._lastState) {
	                this._lastState = currentState;
	                var event = this._state.get(this._nextTick);
	                // emit an event
	                if (currentState === Tone.State.Started) {
	                    //correct the time
	                    this._nextTick = event.time;
	                    if (!this.isUndef(event.offset)) {
	                        this.ticks = event.offset;
	                    }
	                    this.emit('start', event.time, this.ticks);
	                } else if (currentState === Tone.State.Stopped) {
	                    this.ticks = 0;
	                    this.emit('stop', event.time);
	                } else if (currentState === Tone.State.Paused) {
	                    this.emit('pause', event.time);
	                }
	            }
	            var tickTime = this._nextTick;
	            if (this.frequency) {
	                this._nextTick += 1 / this.frequency.getValueAtTime(this._nextTick);
	                if (currentState === Tone.State.Started) {
	                    this.callback(tickTime);
	                    this.ticks++;
	                }
	            }
	        }
	    };
	    /**
		 *  Returns the scheduled state at the given time.
		 *  @param  {Time}  time  The time to query.
		 *  @return  {String}  The name of the state input in setStateAtTime.
		 *  @example
		 * clock.start("+0.1");
		 * clock.getStateAtTime("+0.1"); //returns "started"
		 */
	    Tone.Clock.prototype.getStateAtTime = function (time) {
	        time = this.toSeconds(time);
	        return this._state.getValueAtTime(time);
	    };
	    /**
		 *  Clean up
		 *  @returns {Tone.Clock} this
		 */
	    Tone.Clock.prototype.dispose = function () {
	        Tone.Emitter.prototype.dispose.call(this);
	        this.context.off('tick', this._boundLoop);
	        this._writable('frequency');
	        this.frequency.dispose();
	        this.frequency = null;
	        this._boundLoop = null;
	        this._nextTick = Infinity;
	        this.callback = null;
	        this._state.dispose();
	        this._state = null;
	    };
	    return Tone.Clock;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Similar to Tone.Timeline, but all events represent
		 *         intervals with both "time" and "duration" times. The 
		 *         events are placed in a tree structure optimized
		 *         for querying an intersection point with the timeline
		 *         events. Internally uses an [Interval Tree](https://en.wikipedia.org/wiki/Interval_tree)
		 *         to represent the data.
		 *  @extends {Tone}
		 */
	    Tone.IntervalTimeline = function () {
	        /**
			 *  The root node of the inteval tree
			 *  @type  {IntervalNode}
			 *  @private
			 */
	        this._root = null;
	        /**
			 *  Keep track of the length of the timeline.
			 *  @type  {Number}
			 *  @private
			 */
	        this._length = 0;
	    };
	    Tone.extend(Tone.IntervalTimeline);
	    /**
		 *  The event to add to the timeline. All events must 
		 *  have a time and duration value
		 *  @param  {Object}  event  The event to add to the timeline
		 *  @return  {Tone.IntervalTimeline}  this
		 */
	    Tone.IntervalTimeline.prototype.add = function (event) {
	        if (this.isUndef(event.time) || this.isUndef(event.duration)) {
	            throw new Error('Tone.IntervalTimeline: events must have time and duration parameters');
	        }
	        var node = new IntervalNode(event.time, event.time + event.duration, event);
	        if (this._root === null) {
	            this._root = node;
	        } else {
	            this._root.insert(node);
	        }
	        this._length++;
	        // Restructure tree to be balanced
	        while (node !== null) {
	            node.updateHeight();
	            node.updateMax();
	            this._rebalance(node);
	            node = node.parent;
	        }
	        return this;
	    };
	    /**
		 *  Remove an event from the timeline.
		 *  @param  {Object}  event  The event to remove from the timeline
		 *  @return  {Tone.IntervalTimeline}  this
		 */
	    Tone.IntervalTimeline.prototype.remove = function (event) {
	        if (this._root !== null) {
	            var results = [];
	            this._root.search(event.time, results);
	            for (var i = 0; i < results.length; i++) {
	                var node = results[i];
	                if (node.event === event) {
	                    this._removeNode(node);
	                    this._length--;
	                    break;
	                }
	            }
	        }
	        return this;
	    };
	    /**
		 *  The number of items in the timeline.
		 *  @type {Number}
		 *  @memberOf Tone.IntervalTimeline#
		 *  @name length
		 *  @readOnly
		 */
	    Object.defineProperty(Tone.IntervalTimeline.prototype, 'length', {
	        get: function () {
	            return this._length;
	        }
	    });
	    /**
		 *  Remove events whose time time is after the given time
		 *  @param  {Number}  time  The time to query.
		 *  @returns {Tone.IntervalTimeline} this
		 */
	    Tone.IntervalTimeline.prototype.cancel = function (after) {
	        this.forEachAfter(after, function (event) {
	            this.remove(event);
	        }.bind(this));
	        return this;
	    };
	    /**
		 *  Set the root node as the given node
		 *  @param {IntervalNode} node
		 *  @private
		 */
	    Tone.IntervalTimeline.prototype._setRoot = function (node) {
	        this._root = node;
	        if (this._root !== null) {
	            this._root.parent = null;
	        }
	    };
	    /**
		 *  Replace the references to the node in the node's parent
		 *  with the replacement node.
		 *  @param  {IntervalNode}  node        
		 *  @param  {IntervalNode}  replacement 
		 *  @private
		 */
	    Tone.IntervalTimeline.prototype._replaceNodeInParent = function (node, replacement) {
	        if (node.parent !== null) {
	            if (node.isLeftChild()) {
	                node.parent.left = replacement;
	            } else {
	                node.parent.right = replacement;
	            }
	            this._rebalance(node.parent);
	        } else {
	            this._setRoot(replacement);
	        }
	    };
	    /**
		 *  Remove the node from the tree and replace it with 
		 *  a successor which follows the schema.
		 *  @param  {IntervalNode}  node
		 *  @private
		 */
	    Tone.IntervalTimeline.prototype._removeNode = function (node) {
	        if (node.left === null && node.right === null) {
	            this._replaceNodeInParent(node, null);
	        } else if (node.right === null) {
	            this._replaceNodeInParent(node, node.left);
	        } else if (node.left === null) {
	            this._replaceNodeInParent(node, node.right);
	        } else {
	            var balance = node.getBalance();
	            var replacement, temp;
	            if (balance > 0) {
	                if (node.left.right === null) {
	                    replacement = node.left;
	                    replacement.right = node.right;
	                    temp = replacement;
	                } else {
	                    replacement = node.left.right;
	                    while (replacement.right !== null) {
	                        replacement = replacement.right;
	                    }
	                    replacement.parent.right = replacement.left;
	                    temp = replacement.parent;
	                    replacement.left = node.left;
	                    replacement.right = node.right;
	                }
	            } else {
	                if (node.right.left === null) {
	                    replacement = node.right;
	                    replacement.left = node.left;
	                    temp = replacement;
	                } else {
	                    replacement = node.right.left;
	                    while (replacement.left !== null) {
	                        replacement = replacement.left;
	                    }
	                    replacement.parent = replacement.parent;
	                    replacement.parent.left = replacement.right;
	                    temp = replacement.parent;
	                    replacement.left = node.left;
	                    replacement.right = node.right;
	                }
	            }
	            if (node.parent !== null) {
	                if (node.isLeftChild()) {
	                    node.parent.left = replacement;
	                } else {
	                    node.parent.right = replacement;
	                }
	            } else {
	                this._setRoot(replacement);
	            }
	            // this._replaceNodeInParent(node, replacement);
	            this._rebalance(temp);
	        }
	        node.dispose();
	    };
	    /**
		 *  Rotate the tree to the left
		 *  @param  {IntervalNode}  node
		 *  @private
		 */
	    Tone.IntervalTimeline.prototype._rotateLeft = function (node) {
	        var parent = node.parent;
	        var isLeftChild = node.isLeftChild();
	        // Make node.right the new root of this sub tree (instead of node)
	        var pivotNode = node.right;
	        node.right = pivotNode.left;
	        pivotNode.left = node;
	        if (parent !== null) {
	            if (isLeftChild) {
	                parent.left = pivotNode;
	            } else {
	                parent.right = pivotNode;
	            }
	        } else {
	            this._setRoot(pivotNode);
	        }
	    };
	    /**
		 *  Rotate the tree to the right
		 *  @param  {IntervalNode}  node
		 *  @private
		 */
	    Tone.IntervalTimeline.prototype._rotateRight = function (node) {
	        var parent = node.parent;
	        var isLeftChild = node.isLeftChild();
	        // Make node.left the new root of this sub tree (instead of node)
	        var pivotNode = node.left;
	        node.left = pivotNode.right;
	        pivotNode.right = node;
	        if (parent !== null) {
	            if (isLeftChild) {
	                parent.left = pivotNode;
	            } else {
	                parent.right = pivotNode;
	            }
	        } else {
	            this._setRoot(pivotNode);
	        }
	    };
	    /**
		 *  Balance the BST
		 *  @param  {IntervalNode}  node
		 *  @private
		 */
	    Tone.IntervalTimeline.prototype._rebalance = function (node) {
	        var balance = node.getBalance();
	        if (balance > 1) {
	            if (node.left.getBalance() < 0) {
	                this._rotateLeft(node.left);
	            } else {
	                this._rotateRight(node);
	            }
	        } else if (balance < -1) {
	            if (node.right.getBalance() > 0) {
	                this._rotateRight(node.right);
	            } else {
	                this._rotateLeft(node);
	            }
	        }
	    };
	    /**
		 *  Get an event whose time and duration span the give time. Will
		 *  return the match whose "time" value is closest to the given time.
		 *  @param  {Object}  event  The event to add to the timeline
		 *  @return  {Object}  The event which spans the desired time
		 */
	    Tone.IntervalTimeline.prototype.get = function (time) {
	        if (this._root !== null) {
	            var results = [];
	            this._root.search(time, results);
	            if (results.length > 0) {
	                var max = results[0];
	                for (var i = 1; i < results.length; i++) {
	                    if (results[i].low > max.low) {
	                        max = results[i];
	                    }
	                }
	                return max.event;
	            }
	        }
	        return null;
	    };
	    /**
		 *  Iterate over everything in the timeline.
		 *  @param  {Function}  callback The callback to invoke with every item
		 *  @returns {Tone.IntervalTimeline} this
		 */
	    Tone.IntervalTimeline.prototype.forEach = function (callback) {
	        if (this._root !== null) {
	            var allNodes = [];
	            if (this._root !== null) {
	                this._root.traverse(function (node) {
	                    allNodes.push(node);
	                });
	            }
	            for (var i = 0; i < allNodes.length; i++) {
	                var ev = allNodes[i].event;
	                if (ev) {
	                    callback(ev);
	                }
	            }
	        }
	        return this;
	    };
	    /**
		 *  Iterate over everything in the array in which the given time
		 *  overlaps with the time and duration time of the event.
		 *  @param  {Number}  time The time to check if items are overlapping
		 *  @param  {Function}  callback The callback to invoke with every item
		 *  @returns {Tone.IntervalTimeline} this
		 */
	    Tone.IntervalTimeline.prototype.forEachAtTime = function (time, callback) {
	        if (this._root !== null) {
	            var results = [];
	            this._root.search(time, results);
	            for (var i = results.length - 1; i >= 0; i--) {
	                var ev = results[i].event;
	                if (ev) {
	                    callback(ev);
	                }
	            }
	        }
	        return this;
	    };
	    /**
		 *  Iterate over everything in the array in which the time is greater
		 *  than the given time.
		 *  @param  {Number}  time The time to check if items are before
		 *  @param  {Function}  callback The callback to invoke with every item
		 *  @returns {Tone.IntervalTimeline} this
		 */
	    Tone.IntervalTimeline.prototype.forEachAfter = function (time, callback) {
	        if (this._root !== null) {
	            var results = [];
	            this._root.searchAfter(time, results);
	            for (var i = results.length - 1; i >= 0; i--) {
	                var ev = results[i].event;
	                if (ev) {
	                    callback(ev);
	                }
	            }
	        }
	        return this;
	    };
	    /**
		 *  Clean up
		 *  @return  {Tone.IntervalTimeline}  this
		 */
	    Tone.IntervalTimeline.prototype.dispose = function () {
	        var allNodes = [];
	        if (this._root !== null) {
	            this._root.traverse(function (node) {
	                allNodes.push(node);
	            });
	        }
	        for (var i = 0; i < allNodes.length; i++) {
	            allNodes[i].dispose();
	        }
	        allNodes = null;
	        this._root = null;
	        return this;
	    };
	    ///////////////////////////////////////////////////////////////////////////
	    //	INTERVAL NODE HELPER
	    ///////////////////////////////////////////////////////////////////////////
	    /**
		 *  Represents a node in the binary search tree, with the addition
		 *  of a "high" value which keeps track of the highest value of
		 *  its children. 
		 *  References: 
		 *  https://brooknovak.wordpress.com/2013/12/07/augmented-interval-tree-in-c/
		 *  http://www.mif.vu.lt/~valdas/ALGORITMAI/LITERATURA/Cormen/Cormen.pdf
		 *  @param {Number} low
		 *  @param {Number} high
		 *  @private
		 */
	    var IntervalNode = function (low, high, event) {
	        //the event container
	        this.event = event;
	        //the low value
	        this.low = low;
	        //the high value
	        this.high = high;
	        //the high value for this and all child nodes
	        this.max = this.high;
	        //the nodes to the left
	        this._left = null;
	        //the nodes to the right
	        this._right = null;
	        //the parent node
	        this.parent = null;
	        //the number of child nodes
	        this.height = 0;
	    };
	    /** 
		 *  Insert a node into the correct spot in the tree
		 *  @param  {IntervalNode}  node
		 */
	    IntervalNode.prototype.insert = function (node) {
	        if (node.low <= this.low) {
	            if (this.left === null) {
	                this.left = node;
	            } else {
	                this.left.insert(node);
	            }
	        } else {
	            if (this.right === null) {
	                this.right = node;
	            } else {
	                this.right.insert(node);
	            }
	        }
	    };
	    /**
		 *  Search the tree for nodes which overlap 
		 *  with the given point
		 *  @param  {Number}  point  The point to query
		 *  @param  {Array}  results  The array to put the results
		 */
	    IntervalNode.prototype.search = function (point, results) {
	        // If p is to the right of the rightmost point of any interval
	        // in this node and all children, there won't be any matches.
	        if (point > this.max) {
	            return;
	        }
	        // Search left children
	        if (this.left !== null) {
	            this.left.search(point, results);
	        }
	        // Check this node
	        if (this.low <= point && this.high > point) {
	            results.push(this);
	        }
	        // If p is to the left of the time of this interval,
	        // then it can't be in any child to the right.
	        if (this.low > point) {
	            return;
	        }
	        // Search right children
	        if (this.right !== null) {
	            this.right.search(point, results);
	        }
	    };
	    /**
		 *  Search the tree for nodes which are less 
		 *  than the given point
		 *  @param  {Number}  point  The point to query
		 *  @param  {Array}  results  The array to put the results
		 */
	    IntervalNode.prototype.searchAfter = function (point, results) {
	        // Check this node
	        if (this.low >= point) {
	            results.push(this);
	            if (this.left !== null) {
	                this.left.searchAfter(point, results);
	            }
	        }
	        // search the right side
	        if (this.right !== null) {
	            this.right.searchAfter(point, results);
	        }
	    };
	    /**
		 *  Invoke the callback on this element and both it's branches
		 *  @param  {Function}  callback
		 */
	    IntervalNode.prototype.traverse = function (callback) {
	        callback(this);
	        if (this.left !== null) {
	            this.left.traverse(callback);
	        }
	        if (this.right !== null) {
	            this.right.traverse(callback);
	        }
	    };
	    /**
		 *  Update the height of the node
		 */
	    IntervalNode.prototype.updateHeight = function () {
	        if (this.left !== null && this.right !== null) {
	            this.height = Math.max(this.left.height, this.right.height) + 1;
	        } else if (this.right !== null) {
	            this.height = this.right.height + 1;
	        } else if (this.left !== null) {
	            this.height = this.left.height + 1;
	        } else {
	            this.height = 0;
	        }
	    };
	    /**
		 *  Update the height of the node
		 */
	    IntervalNode.prototype.updateMax = function () {
	        this.max = this.high;
	        if (this.left !== null) {
	            this.max = Math.max(this.max, this.left.max);
	        }
	        if (this.right !== null) {
	            this.max = Math.max(this.max, this.right.max);
	        }
	    };
	    /**
		 *  The balance is how the leafs are distributed on the node
		 *  @return  {Number}  Negative numbers are balanced to the right
		 */
	    IntervalNode.prototype.getBalance = function () {
	        var balance = 0;
	        if (this.left !== null && this.right !== null) {
	            balance = this.left.height - this.right.height;
	        } else if (this.left !== null) {
	            balance = this.left.height + 1;
	        } else if (this.right !== null) {
	            balance = -(this.right.height + 1);
	        }
	        return balance;
	    };
	    /**
		 *  @returns {Boolean} true if this node is the left child
		 *  of its parent
		 */
	    IntervalNode.prototype.isLeftChild = function () {
	        return this.parent !== null && this.parent.left === this;
	    };
	    /**
		 *  get/set the left node
		 *  @type {IntervalNode}
		 */
	    Object.defineProperty(IntervalNode.prototype, 'left', {
	        get: function () {
	            return this._left;
	        },
	        set: function (node) {
	            this._left = node;
	            if (node !== null) {
	                node.parent = this;
	            }
	            this.updateHeight();
	            this.updateMax();
	        }
	    });
	    /**
		 *  get/set the right node
		 *  @type {IntervalNode}
		 */
	    Object.defineProperty(IntervalNode.prototype, 'right', {
	        get: function () {
	            return this._right;
	        },
	        set: function (node) {
	            this._right = node;
	            if (node !== null) {
	                node.parent = this;
	            }
	            this.updateHeight();
	            this.updateMax();
	        }
	    });
	    /**
		 *  null out references.
		 */
	    IntervalNode.prototype.dispose = function () {
	        this.parent = null;
	        this._left = null;
	        this._right = null;
	        this.event = null;
	    };
	    ///////////////////////////////////////////////////////////////////////////
	    //	END INTERVAL NODE HELPER
	    ///////////////////////////////////////////////////////////////////////////
	    return Tone.IntervalTimeline;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  Transport for timing musical events.
		 *          Supports tempo curves and time changes. Unlike browser-based timing (setInterval, requestAnimationFrame)
		 *          Tone.Transport timing events pass in the exact time of the scheduled event
		 *          in the argument of the callback function. Pass that time value to the object
		 *          you're scheduling. <br><br>
		 *          A single transport is created for you when the library is initialized. 
		 *          <br><br>
		 *          The transport emits the events: "start", "stop", "pause", and "loop" which are
		 *          called with the time of that event as the argument. 
		 *
		 *  @extends {Tone.Emitter}
		 *  @singleton
		 *  @example
		 * //repeated event every 8th note
		 * Tone.Transport.scheduleRepeat(function(time){
		 * 	//do something with the time
		 * }, "8n");
		 *  @example
		 * //schedule an event on the 16th measure
		 * Tone.Transport.schedule(function(time){
		 * 	//do something with the time
		 * }, "16:0:0");
		 */
	    Tone.Transport = function () {
	        Tone.Emitter.call(this);
	        ///////////////////////////////////////////////////////////////////////
	        //	LOOPING
	        //////////////////////////////////////////////////////////////////////
	        /** 
			 * 	If the transport loops or not.
			 *  @type {boolean}
			 */
	        this.loop = false;
	        /** 
			 * 	The loop start position in ticks
			 *  @type {Ticks}
			 *  @private
			 */
	        this._loopStart = 0;
	        /** 
			 * 	The loop end position in ticks
			 *  @type {Ticks}
			 *  @private
			 */
	        this._loopEnd = 0;
	        ///////////////////////////////////////////////////////////////////////
	        //	CLOCK/TEMPO
	        //////////////////////////////////////////////////////////////////////
	        /**
			 *  Pulses per quarter is the number of ticks per quarter note.
			 *  @private
			 *  @type  {Number}
			 */
	        this._ppq = TransportConstructor.defaults.PPQ;
	        /**
			 *  watches the main oscillator for timing ticks
			 *  initially starts at 120bpm
			 *  @private
			 *  @type {Tone.Clock}
			 */
	        this._clock = new Tone.Clock({
	            'callback': this._processTick.bind(this),
	            'frequency': 0
	        });
	        this._bindClockEvents();
	        /**
			 *  The Beats Per Minute of the Transport. 
			 *  @type {BPM}
			 *  @signal
			 *  @example
			 * Tone.Transport.bpm.value = 80;
			 * //ramp the bpm to 120 over 10 seconds
			 * Tone.Transport.bpm.rampTo(120, 10);
			 */
	        this.bpm = this._clock.frequency;
	        this.bpm._toUnits = this._toUnits.bind(this);
	        this.bpm._fromUnits = this._fromUnits.bind(this);
	        this.bpm.units = Tone.Type.BPM;
	        this.bpm.value = TransportConstructor.defaults.bpm;
	        this._readOnly('bpm');
	        /**
			 *  The time signature, or more accurately the numerator
			 *  of the time signature over a denominator of 4. 
			 *  @type {Number}
			 *  @private
			 */
	        this._timeSignature = TransportConstructor.defaults.timeSignature;
	        ///////////////////////////////////////////////////////////////////////
	        //	TIMELINE EVENTS
	        //////////////////////////////////////////////////////////////////////
	        /**
			 *  All the events in an object to keep track by ID
			 *  @type {Object}
			 *  @private
			 */
	        this._scheduledEvents = {};
	        /**
			 *  The event ID counter
			 *  @type {Number}
			 *  @private
			 */
	        this._eventID = 0;
	        /**
			 * 	The scheduled events.
			 *  @type {Tone.Timeline}
			 *  @private
			 */
	        this._timeline = new Tone.Timeline();
	        /**
			 *  Repeated events
			 *  @type {Array}
			 *  @private
			 */
	        this._repeatedEvents = new Tone.IntervalTimeline();
	        /**
			 *  Events that occur once
			 *  @type {Array}
			 *  @private
			 */
	        this._onceEvents = new Tone.Timeline();
	        /** 
			 *  All of the synced Signals
			 *  @private 
			 *  @type {Array}
			 */
	        this._syncedSignals = [];
	        ///////////////////////////////////////////////////////////////////////
	        //	SWING
	        //////////////////////////////////////////////////////////////////////
	        /**
			 *  The subdivision of the swing
			 *  @type  {Ticks}
			 *  @private
			 */
	        this._swingTicks = TransportConstructor.defaults.PPQ / 2;
	        //8n
	        /**
			 *  The swing amount
			 *  @type {NormalRange}
			 *  @private
			 */
	        this._swingAmount = 0;
	    };
	    Tone.extend(Tone.Transport, Tone.Emitter);
	    /**
		 *  the defaults
		 *  @type {Object}
		 *  @const
		 *  @static
		 */
	    Tone.Transport.defaults = {
	        'bpm': 120,
	        'swing': 0,
	        'swingSubdivision': '8n',
	        'timeSignature': 4,
	        'loopStart': 0,
	        'loopEnd': '4m',
	        'PPQ': 192
	    };
	    ///////////////////////////////////////////////////////////////////////////////
	    //	TICKS
	    ///////////////////////////////////////////////////////////////////////////////
	    /**
		 *  called on every tick
		 *  @param   {number} tickTime clock relative tick time
		 *  @private
		 */
	    Tone.Transport.prototype._processTick = function (tickTime) {
	        var ticks = this._clock.ticks;
	        //handle swing
	        if (this._swingAmount > 0 && ticks % this._ppq !== 0 && //not on a downbeat
	            ticks % (this._swingTicks * 2) !== 0) {
	            //add some swing
	            var progress = ticks % (this._swingTicks * 2) / (this._swingTicks * 2);
	            var amount = Math.sin(progress * Math.PI) * this._swingAmount;
	            tickTime += Tone.Time(this._swingTicks * 2 / 3, 'i') * amount;
	        }
	        //do the loop test
	        if (this.loop) {
	            if (ticks === this._loopEnd) {
	                this.emit('loopEnd', tickTime);
	                this._clock.ticks = this._loopStart;
	                ticks = this._loopStart;
	                this.emit('loopStart', tickTime, this.seconds);
	                this.emit('loop', tickTime);
	            }
	        }
	        //process the single occurrence events
	        this._onceEvents.forEachBefore(ticks, function (event) {
	            event.callback(tickTime);
	            //remove the event
	            delete this._scheduledEvents[event.id.toString()];
	        }.bind(this));
	        //and clear the single occurrence timeline
	        this._onceEvents.cancelBefore(ticks);
	        //fire the next tick events if their time has come
	        this._timeline.forEachAtTime(ticks, function (event) {
	            event.callback(tickTime);
	        });
	        //process the repeated events
	        this._repeatedEvents.forEachAtTime(ticks, function (event) {
	            if ((ticks - event.time) % event.interval === 0) {
	                event.callback(tickTime);
	            }
	        });
	    };
	    ///////////////////////////////////////////////////////////////////////////////
	    //	SCHEDULABLE EVENTS
	    ///////////////////////////////////////////////////////////////////////////////
	    /**
		 *  Schedule an event along the timeline.
		 *  @param {Function} callback The callback to be invoked at the time.
		 *  @param {TransportTime}  time The time to invoke the callback at.
		 *  @return {Number} The id of the event which can be used for canceling the event. 
		 *  @example
		 * //trigger the callback when the Transport reaches the desired time
		 * Tone.Transport.schedule(function(time){
		 * 	envelope.triggerAttack(time);
		 * }, "128i");
		 */
	    Tone.Transport.prototype.schedule = function (callback, time) {
	        var event = {
	            'time': this.toTicks(time),
	            'callback': callback
	        };
	        var id = this._eventID++;
	        this._scheduledEvents[id.toString()] = {
	            'event': event,
	            'timeline': this._timeline
	        };
	        this._timeline.add(event);
	        return id;
	    };
	    /**
		 *  Schedule a repeated event along the timeline. The event will fire
		 *  at the `interval` starting at the `startTime` and for the specified
		 *  `duration`. 
		 *  @param  {Function}  callback   The callback to invoke.
		 *  @param  {Time}    interval   The duration between successive
		 *                               callbacks.
		 *  @param  {TimelinePosition=}    startTime  When along the timeline the events should
		 *                               start being invoked.
		 *  @param {Time} [duration=Infinity] How long the event should repeat. 
		 *  @return  {Number}    The ID of the scheduled event. Use this to cancel
		 *                           the event. 
		 *  @example
		 * //a callback invoked every eighth note after the first measure
		 * Tone.Transport.scheduleRepeat(callback, "8n", "1m");
		 */
	    Tone.Transport.prototype.scheduleRepeat = function (callback, interval, startTime, duration) {
	        if (interval <= 0) {
	            throw new Error('Tone.Transport: repeat events must have an interval larger than 0');
	        }
	        var event = {
	            'time': this.toTicks(startTime),
	            'duration': this.toTicks(this.defaultArg(duration, Infinity)),
	            'interval': this.toTicks(interval),
	            'callback': callback
	        };
	        var id = this._eventID++;
	        this._scheduledEvents[id.toString()] = {
	            'event': event,
	            'timeline': this._repeatedEvents
	        };
	        this._repeatedEvents.add(event);
	        return id;
	    };
	    /**
		 *  Schedule an event that will be removed after it is invoked. 
		 *  Note that if the given time is less than the current transport time, 
		 *  the event will be invoked immediately. 
		 *  @param {Function} callback The callback to invoke once.
		 *  @param {TransportTime} time The time the callback should be invoked.
		 *  @returns {Number} The ID of the scheduled event. 
		 */
	    Tone.Transport.prototype.scheduleOnce = function (callback, time) {
	        var id = this._eventID++;
	        var event = {
	            'time': this.toTicks(time),
	            'callback': callback,
	            'id': id
	        };
	        this._scheduledEvents[id.toString()] = {
	            'event': event,
	            'timeline': this._onceEvents
	        };
	        this._onceEvents.add(event);
	        return id;
	    };
	    /**
		 *  Clear the passed in event id from the timeline
		 *  @param {Number} eventId The id of the event.
		 *  @returns {Tone.Transport} this
		 */
	    Tone.Transport.prototype.clear = function (eventId) {
	        if (this._scheduledEvents.hasOwnProperty(eventId)) {
	            var item = this._scheduledEvents[eventId.toString()];
	            item.timeline.remove(item.event);
	            delete this._scheduledEvents[eventId.toString()];
	        }
	        return this;
	    };
	    /**
		 *  Remove scheduled events from the timeline after
		 *  the given time. Repeated events will be removed
		 *  if their startTime is after the given time
		 *  @param {TransportTime} [after=0] Clear all events after
		 *                          this time. 
		 *  @returns {Tone.Transport} this
		 */
	    Tone.Transport.prototype.cancel = function (after) {
	        after = this.defaultArg(after, 0);
	        after = this.toTicks(after);
	        this._timeline.cancel(after);
	        this._onceEvents.cancel(after);
	        this._repeatedEvents.cancel(after);
	        return this;
	    };
	    ///////////////////////////////////////////////////////////////////////////////
	    //	START/STOP/PAUSE
	    ///////////////////////////////////////////////////////////////////////////////
	    /**
		 *  Bind start/stop/pause events from the clock and emit them.
		 */
	    Tone.Transport.prototype._bindClockEvents = function () {
	        this._clock.on('start', function (time, offset) {
	            offset = Tone.Time(this._clock.ticks, 'i').toSeconds();
	            this.emit('start', time, offset);
	        }.bind(this));
	        this._clock.on('stop', function (time) {
	            this.emit('stop', time);
	        }.bind(this));
	        this._clock.on('pause', function (time) {
	            this.emit('pause', time);
	        }.bind(this));
	    };
	    /**
		 *  Returns the playback state of the source, either "started", "stopped", or "paused"
		 *  @type {Tone.State}
		 *  @readOnly
		 *  @memberOf Tone.Transport#
		 *  @name state
		 */
	    Object.defineProperty(Tone.Transport.prototype, 'state', {
	        get: function () {
	            return this._clock.getStateAtTime(this.now());
	        }
	    });
	    /**
		 *  Start the transport and all sources synced to the transport.
		 *  @param  {Time} [time=now] The time when the transport should start.
		 *  @param  {TransportTime=} offset The timeline offset to start the transport.
		 *  @returns {Tone.Transport} this
		 *  @example
		 * //start the transport in one second starting at beginning of the 5th measure. 
		 * Tone.Transport.start("+1", "4:0:0");
		 */
	    Tone.Transport.prototype.start = function (time, offset) {
	        //start the clock
	        if (!this.isUndef(offset)) {
	            offset = this.toTicks(offset);
	        }
	        this._clock.start(time, offset);
	        return this;
	    };
	    /**
		 *  Stop the transport and all sources synced to the transport.
		 *  @param  {Time} [time=now] The time when the transport should stop. 
		 *  @returns {Tone.Transport} this
		 *  @example
		 * Tone.Transport.stop();
		 */
	    Tone.Transport.prototype.stop = function (time) {
	        this._clock.stop(time);
	        return this;
	    };
	    /**
		 *  Pause the transport and all sources synced to the transport.
		 *  @param  {Time} [time=now]
		 *  @returns {Tone.Transport} this
		 */
	    Tone.Transport.prototype.pause = function (time) {
	        this._clock.pause(time);
	        return this;
	    };
	    ///////////////////////////////////////////////////////////////////////////////
	    //	SETTERS/GETTERS
	    ///////////////////////////////////////////////////////////////////////////////
	    /**
		 *  The time signature as just the numerator over 4. 
		 *  For example 4/4 would be just 4 and 6/8 would be 3.
		 *  @memberOf Tone.Transport#
		 *  @type {Number|Array}
		 *  @name timeSignature
		 *  @example
		 * //common time
		 * Tone.Transport.timeSignature = 4;
		 * // 7/8
		 * Tone.Transport.timeSignature = [7, 8];
		 * //this will be reduced to a single number
		 * Tone.Transport.timeSignature; //returns 3.5
		 */
	    Object.defineProperty(Tone.Transport.prototype, 'timeSignature', {
	        get: function () {
	            return this._timeSignature;
	        },
	        set: function (timeSig) {
	            if (this.isArray(timeSig)) {
	                timeSig = timeSig[0] / timeSig[1] * 4;
	            }
	            this._timeSignature = timeSig;
	        }
	    });
	    /**
		 * When the Tone.Transport.loop = true, this is the starting position of the loop.
		 * @memberOf Tone.Transport#
		 * @type {TransportTime}
		 * @name loopStart
		 */
	    Object.defineProperty(Tone.Transport.prototype, 'loopStart', {
	        get: function () {
	            return Tone.TransportTime(this._loopStart, 'i').toSeconds();
	        },
	        set: function (startPosition) {
	            this._loopStart = this.toTicks(startPosition);
	        }
	    });
	    /**
		 * When the Tone.Transport.loop = true, this is the ending position of the loop.
		 * @memberOf Tone.Transport#
		 * @type {TransportTime}
		 * @name loopEnd
		 */
	    Object.defineProperty(Tone.Transport.prototype, 'loopEnd', {
	        get: function () {
	            return Tone.TransportTime(this._loopEnd, 'i').toSeconds();
	        },
	        set: function (endPosition) {
	            this._loopEnd = this.toTicks(endPosition);
	        }
	    });
	    /**
		 *  Set the loop start and stop at the same time. 
		 *  @param {TransportTime} startPosition 
		 *  @param {TransportTime} endPosition   
		 *  @returns {Tone.Transport} this
		 *  @example
		 * //loop over the first measure
		 * Tone.Transport.setLoopPoints(0, "1m");
		 * Tone.Transport.loop = true;
		 */
	    Tone.Transport.prototype.setLoopPoints = function (startPosition, endPosition) {
	        this.loopStart = startPosition;
	        this.loopEnd = endPosition;
	        return this;
	    };
	    /**
		 *  The swing value. Between 0-1 where 1 equal to 
		 *  the note + half the subdivision.
		 *  @memberOf Tone.Transport#
		 *  @type {NormalRange}
		 *  @name swing
		 */
	    Object.defineProperty(Tone.Transport.prototype, 'swing', {
	        get: function () {
	            return this._swingAmount;
	        },
	        set: function (amount) {
	            //scale the values to a normal range
	            this._swingAmount = amount;
	        }
	    });
	    /**
		 *  Set the subdivision which the swing will be applied to. 
		 *  The default value is an 8th note. Value must be less 
		 *  than a quarter note.
		 *  
		 *  @memberOf Tone.Transport#
		 *  @type {Time}
		 *  @name swingSubdivision
		 */
	    Object.defineProperty(Tone.Transport.prototype, 'swingSubdivision', {
	        get: function () {
	            return Tone.Time(this._swingTicks, 'i').toNotation();
	        },
	        set: function (subdivision) {
	            this._swingTicks = this.toTicks(subdivision);
	        }
	    });
	    /**
		 *  The Transport's position in Bars:Beats:Sixteenths.
		 *  Setting the value will jump to that position right away. 
		 *  @memberOf Tone.Transport#
		 *  @type {BarsBeatsSixteenths}
		 *  @name position
		 */
	    Object.defineProperty(Tone.Transport.prototype, 'position', {
	        get: function () {
	            return Tone.TransportTime(this.ticks, 'i').toBarsBeatsSixteenths();
	        },
	        set: function (progress) {
	            var ticks = this.toTicks(progress);
	            this.ticks = ticks;
	        }
	    });
	    /**
		 *  The Transport's position in seconds
		 *  Setting the value will jump to that position right away. 
		 *  @memberOf Tone.Transport#
		 *  @type {Seconds}
		 *  @name seconds
		 */
	    Object.defineProperty(Tone.Transport.prototype, 'seconds', {
	        get: function () {
	            return Tone.TransportTime(this.ticks, 'i').toSeconds();
	        },
	        set: function (progress) {
	            var ticks = this.toTicks(progress);
	            this.ticks = ticks;
	        }
	    });
	    /**
		 *  The Transport's loop position as a normalized value. Always
		 *  returns 0 if the transport if loop is not true. 
		 *  @memberOf Tone.Transport#
		 *  @name progress
		 *  @type {NormalRange}
		 */
	    Object.defineProperty(Tone.Transport.prototype, 'progress', {
	        get: function () {
	            if (this.loop) {
	                return (this.ticks - this._loopStart) / (this._loopEnd - this._loopStart);
	            } else {
	                return 0;
	            }
	        }
	    });
	    /**
		 *  The transports current tick position.
		 *  
		 *  @memberOf Tone.Transport#
		 *  @type {Ticks}
		 *  @name ticks
		 */
	    Object.defineProperty(Tone.Transport.prototype, 'ticks', {
	        get: function () {
	            return this._clock.ticks;
	        },
	        set: function (t) {
	            if (this._clock.ticks !== t) {
	                var now = this.now();
	                //stop everything synced to the transport
	                if (this.state === Tone.State.Started) {
	                    this.emit('stop', now);
	                    this._clock.ticks = t;
	                    //restart it with the new time
	                    this.emit('start', now, this.seconds);
	                } else {
	                    this._clock.ticks = t;
	                }
	            }
	        }
	    });
	    /**
		 *  Pulses Per Quarter note. This is the smallest resolution
		 *  the Transport timing supports. This should be set once
		 *  on initialization and not set again. Changing this value 
		 *  after other objects have been created can cause problems. 
		 *  
		 *  @memberOf Tone.Transport#
		 *  @type {Number}
		 *  @name PPQ
		 */
	    Object.defineProperty(Tone.Transport.prototype, 'PPQ', {
	        get: function () {
	            return this._ppq;
	        },
	        set: function (ppq) {
	            var bpm = this.bpm.value;
	            this._ppq = ppq;
	            this.bpm.value = bpm;
	        }
	    });
	    /**
		 *  The hint to the type of playback. Affects tradeoffs between audio 
		 *  output latency and responsiveness. 
		 *  
		 *  In addition to setting the value in seconds, the latencyHint also
		 *  accepts the strings "interactive" (prioritizes low latency), 
		 *  "playback" (prioritizes sustained playback), "balanced" (balances
		 *  latency and performance), and "fastest" (lowest latency, might glitch more often). 
		 *  @memberOf Tone.Transport#
		 *  @type {Seconds|String}
		 *  @name latencyHint
		 */
	    Object.defineProperty(Tone.Transport.prototype, 'latencyHint', {
	        get: function () {
	            return Tone.Clock.latencyHint;
	        },
	        set: function (hint) {
	            Tone.Clock.latencyHint = hint;
	        }
	    });
	    /**
		 *  Convert from BPM to frequency (factoring in PPQ)
		 *  @param  {BPM}  bpm The BPM value to convert to frequency
		 *  @return  {Frequency}  The BPM as a frequency with PPQ factored in.
		 *  @private
		 */
	    Tone.Transport.prototype._fromUnits = function (bpm) {
	        return 1 / (60 / bpm / this.PPQ);
	    };
	    /**
		 *  Convert from frequency (with PPQ) into BPM
		 *  @param  {Frequency}  freq The clocks frequency to convert to BPM
		 *  @return  {BPM}  The frequency value as BPM.
		 *  @private
		 */
	    Tone.Transport.prototype._toUnits = function (freq) {
	        return freq / this.PPQ * 60;
	    };
	    ///////////////////////////////////////////////////////////////////////////////
	    //	SYNCING
	    ///////////////////////////////////////////////////////////////////////////////
	    /**
		 *  Returns the time aligned to the next subdivision
		 *  of the Transport. If the Transport is not started,
		 *  it will return 0.
		 *  Note: this will not work precisely during tempo ramps.
		 *  @param  {Time}  subdivision  The subdivision to quantize to
		 *  @return  {Number}  The context time of the next subdivision.
		 *  @example
		 * Tone.Transport.start(); //the transport must be started
		 * Tone.Transport.nextSubdivision("4n");
		 */
	    Tone.Transport.prototype.nextSubdivision = function (subdivision) {
	        subdivision = this.toSeconds(subdivision);
	        //if the transport's not started, return 0
	        var now;
	        if (this.state === Tone.State.Started) {
	            now = this._clock._nextTick;
	        } else {
	            return 0;
	        }
	        var transportPos = Tone.Time(this.ticks, 'i');
	        var remainingTime = subdivision - transportPos % subdivision;
	        if (remainingTime === 0) {
	            remainingTime = subdivision;
	        }
	        return now + remainingTime;
	    };
	    /**
		 *  Attaches the signal to the tempo control signal so that 
		 *  any changes in the tempo will change the signal in the same
		 *  ratio. 
		 *  
		 *  @param  {Tone.Signal} signal 
		 *  @param {number=} ratio Optionally pass in the ratio between
		 *                         the two signals. Otherwise it will be computed
		 *                         based on their current values. 
		 *  @returns {Tone.Transport} this
		 */
	    Tone.Transport.prototype.syncSignal = function (signal, ratio) {
	        if (!ratio) {
	            //get the sync ratio
	            if (signal._param.value !== 0) {
	                ratio = signal._param.value / this.bpm._param.value;
	            } else {
	                ratio = 0;
	            }
	        }
	        var ratioSignal = new Tone.Gain(ratio);
	        this.bpm.chain(ratioSignal, signal._param);
	        this._syncedSignals.push({
	            'ratio': ratioSignal,
	            'signal': signal,
	            'initial': signal._param.value
	        });
	        signal._param.value = 0;
	        return this;
	    };
	    /**
		 *  Unsyncs a previously synced signal from the transport's control. 
		 *  See Tone.Transport.syncSignal.
		 *  @param  {Tone.Signal} signal 
		 *  @returns {Tone.Transport} this
		 */
	    Tone.Transport.prototype.unsyncSignal = function (signal) {
	        for (var i = this._syncedSignals.length - 1; i >= 0; i--) {
	            var syncedSignal = this._syncedSignals[i];
	            if (syncedSignal.signal === signal) {
	                syncedSignal.ratio.dispose();
	                syncedSignal.signal._param.value = syncedSignal.initial;
	                this._syncedSignals.splice(i, 1);
	            }
	        }
	        return this;
	    };
	    /**
		 *  Clean up. 
		 *  @returns {Tone.Transport} this
		 *  @private
		 */
	    Tone.Transport.prototype.dispose = function () {
	        Tone.Emitter.prototype.dispose.call(this);
	        this._clock.dispose();
	        this._clock = null;
	        this._writable('bpm');
	        this.bpm = null;
	        this._timeline.dispose();
	        this._timeline = null;
	        this._onceEvents.dispose();
	        this._onceEvents = null;
	        this._repeatedEvents.dispose();
	        this._repeatedEvents = null;
	        return this;
	    };
	    ///////////////////////////////////////////////////////////////////////////////
	    //	INITIALIZATION
	    ///////////////////////////////////////////////////////////////////////////////
	    var TransportConstructor = Tone.Transport;
	    Tone.Transport = new TransportConstructor();
	    Tone.Context.on('init', function (context) {
	        if (context.Transport instanceof TransportConstructor) {
	            Tone.Transport = context.Transport;
	        } else {
	            Tone.Transport = new TransportConstructor();
	            //store the Transport on the context so it can be retrieved later
	            context.Transport = Tone.Transport;
	        }
	    });
	    return Tone.Transport;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Tone.Volume is a simple volume node, useful for creating a volume fader. 
		 *
		 *  @extends {Tone}
		 *  @constructor
		 *  @param {Decibels} [volume=0] the initial volume
		 *  @example
		 * var vol = new Tone.Volume(-12);
		 * instrument.chain(vol, Tone.Master);
		 */
	    Tone.Volume = function () {
	        var options = this.optionsObject(arguments, ['volume'], Tone.Volume.defaults);
	        /**
			 * the output node
			 * @type {GainNode}
			 * @private
			 */
	        this.output = this.input = new Tone.Gain(options.volume, Tone.Type.Decibels);
	        /**
			 * The unmuted volume
			 * @type {Decibels}
			 * @private
			 */
	        this._unmutedVolume = options.volume;
	        /**
			 *  The volume control in decibels. 
			 *  @type {Decibels}
			 *  @signal
			 */
	        this.volume = this.output.gain;
	        this._readOnly('volume');
	        //set the mute initially
	        this.mute = options.mute;
	    };
	    Tone.extend(Tone.Volume);
	    /**
		 *  Defaults
		 *  @type  {Object}
		 *  @const
		 *  @static
		 */
	    Tone.Volume.defaults = {
	        'volume': 0,
	        'mute': false
	    };
	    /**
		 * Mute the output. 
		 * @memberOf Tone.Volume#
		 * @type {boolean}
		 * @name mute
		 * @example
		 * //mute the output
		 * volume.mute = true;
		 */
	    Object.defineProperty(Tone.Volume.prototype, 'mute', {
	        get: function () {
	            return this.volume.value === -Infinity;
	        },
	        set: function (mute) {
	            if (!this.mute && mute) {
	                this._unmutedVolume = this.volume.value;
	                //maybe it should ramp here?
	                this.volume.value = -Infinity;
	            } else if (this.mute && !mute) {
	                this.volume.value = this._unmutedVolume;
	            }
	        }
	    });
	    /**
		 *  clean up
		 *  @returns {Tone.Volume} this
		 */
	    Tone.Volume.prototype.dispose = function () {
	        this.input.dispose();
	        Tone.prototype.dispose.call(this);
	        this._writable('volume');
	        this.volume.dispose();
	        this.volume = null;
	        return this;
	    };
	    return Tone.Volume;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  A single master output which is connected to the
		 *          AudioDestinationNode (aka your speakers). 
		 *          It provides useful conveniences such as the ability 
		 *          to set the volume and mute the entire application. 
		 *          It also gives you the ability to apply master effects to your application. 
		 *          <br><br>
		 *          Like Tone.Transport, A single Tone.Master is created
		 *          on initialization and you do not need to explicitly construct one.
		 *
		 *  @constructor
		 *  @extends {Tone}
		 *  @singleton
		 *  @example
		 * //the audio will go from the oscillator to the speakers
		 * oscillator.connect(Tone.Master);
		 * //a convenience for connecting to the master output is also provided:
		 * oscillator.toMaster();
		 * //the above two examples are equivalent.
		 */
	    Tone.Master = function () {
	        this.createInsOuts(1, 1);
	        /**
			 *  The private volume node
			 *  @type  {Tone.Volume}
			 *  @private
			 */
	        this._volume = this.output = new Tone.Volume();
	        /**
			 * The volume of the master output.
			 * @type {Decibels}
			 * @signal
			 */
	        this.volume = this._volume.volume;
	        this._readOnly('volume');
	        //connections
	        this.input.chain(this.output, this.context.destination);
	    };
	    Tone.extend(Tone.Master);
	    /**
		 *  @type {Object}
		 *  @const
		 */
	    Tone.Master.defaults = {
	        'volume': 0,
	        'mute': false
	    };
	    /**
		 * Mute the output. 
		 * @memberOf Tone.Master#
		 * @type {boolean}
		 * @name mute
		 * @example
		 * //mute the output
		 * Tone.Master.mute = true;
		 */
	    Object.defineProperty(Tone.Master.prototype, 'mute', {
	        get: function () {
	            return this._volume.mute;
	        },
	        set: function (mute) {
	            this._volume.mute = mute;
	        }
	    });
	    /**
		 *  Add a master effects chain. NOTE: this will disconnect any nodes which were previously 
		 *  chained in the master effects chain. 
		 *  @param {AudioNode|Tone...} args All arguments will be connected in a row
		 *                                  and the Master will be routed through it.
		 *  @return  {Tone.Master}  this
		 *  @example
		 * //some overall compression to keep the levels in check
		 * var masterCompressor = new Tone.Compressor({
		 * 	"threshold" : -6,
		 * 	"ratio" : 3,
		 * 	"attack" : 0.5,
		 * 	"release" : 0.1
		 * });
		 * //give a little boost to the lows
		 * var lowBump = new Tone.Filter(200, "lowshelf");
		 * //route everything through the filter 
		 * //and compressor before going to the speakers
		 * Tone.Master.chain(lowBump, masterCompressor);
		 */
	    Tone.Master.prototype.chain = function () {
	        this.input.disconnect();
	        this.input.chain.apply(this.input, arguments);
	        arguments[arguments.length - 1].connect(this.output);
	    };
	    /**
		 *  Clean up
		 *  @return  {Tone.Master}  this
		 */
	    Tone.Master.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._writable('volume');
	        this._volume.dispose();
	        this._volume = null;
	        this.volume = null;
	    };
	    ///////////////////////////////////////////////////////////////////////////
	    //	AUGMENT TONE's PROTOTYPE
	    ///////////////////////////////////////////////////////////////////////////
	    /**
		 *  Connect 'this' to the master output. Shorthand for this.connect(Tone.Master)
		 *  @returns {Tone} this
		 *  @example
		 * //connect an oscillator to the master output
		 * var osc = new Tone.Oscillator().toMaster();
		 */
	    Tone.prototype.toMaster = function () {
	        this.connect(Tone.Master);
	        return this;
	    };
	    /**
		 *  Also augment AudioNode's prototype to include toMaster
		 *  as a convenience
		 *  @returns {AudioNode} this
		 */
	    AudioNode.prototype.toMaster = function () {
	        this.connect(Tone.Master);
	        return this;
	    };
	    /**
		 *  initialize the module and listen for new audio contexts
		 */
	    var MasterConstructor = Tone.Master;
	    Tone.Master = new MasterConstructor();
	    Tone.Context.on('init', function (context) {
	        // if it already exists, just restore it
	        if (context.Master instanceof MasterConstructor) {
	            Tone.Master = context.Master;
	        } else {
	            Tone.Master = new MasterConstructor();
	        }
	        context.Master = Tone.Master;
	    });
	    return Tone.Master;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  Base class for sources. Sources have start/stop methods
		 *          and the ability to be synced to the 
		 *          start/stop of Tone.Transport. 
		 *
		 *  @constructor
		 *  @extends {Tone}
		 *  @example
		 * //Multiple state change events can be chained together,
		 * //but must be set in the correct order and with ascending times
		 * 
		 * // OK
		 * state.start().stop("+0.2");
		 * // AND
		 * state.start().stop("+0.2").start("+0.4").stop("+0.7")
		 *
		 * // BAD
		 * state.stop("+0.2").start();
		 * // OR
		 * state.start("+0.3").stop("+0.2");
		 * 
		 */
	    Tone.Source = function (options) {
	        // this.createInsOuts(0, 1);
	        options = this.defaultArg(options, Tone.Source.defaults);
	        /**
			 *  The output volume node
			 *  @type  {Tone.Volume}
			 *  @private
			 */
	        this._volume = this.output = new Tone.Volume(options.volume);
	        /**
			 * The volume of the output in decibels.
			 * @type {Decibels}
			 * @signal
			 * @example
			 * source.volume.value = -6;
			 */
	        this.volume = this._volume.volume;
	        this._readOnly('volume');
	        /**
			 * 	Keep track of the scheduled state.
			 *  @type {Tone.TimelineState}
			 *  @private
			 */
	        this._state = new Tone.TimelineState(Tone.State.Stopped);
	        this._state.memory = 10;
	        /**
			 *  The synced `start` callback function from the transport
			 *  @type {Function}
			 *  @private
			 */
	        this._synced = false;
	        /**
			 *  Keep track of all of the scheduled event ids
			 *  @type  {Array}
			 *  @private
			 */
	        this._scheduled = [];
	        //make the output explicitly stereo
	        this._volume.output.output.channelCount = 2;
	        this._volume.output.output.channelCountMode = 'explicit';
	        //mute initially
	        this.mute = options.mute;
	    };
	    Tone.extend(Tone.Source);
	    /**
		 *  The default parameters
		 *  @static
		 *  @const
		 *  @type {Object}
		 */
	    Tone.Source.defaults = {
	        'volume': 0,
	        'mute': false
	    };
	    /**
		 *  Returns the playback state of the source, either "started" or "stopped".
		 *  @type {Tone.State}
		 *  @readOnly
		 *  @memberOf Tone.Source#
		 *  @name state
		 */
	    Object.defineProperty(Tone.Source.prototype, 'state', {
	        get: function () {
	            if (this._synced) {
	                if (Tone.Transport.state === Tone.State.Started) {
	                    return this._state.getValueAtTime(Tone.Transport.seconds);
	                } else {
	                    return Tone.State.Stopped;
	                }
	            } else {
	                return this._state.getValueAtTime(this.now());
	            }
	        }
	    });
	    /**
		 * Mute the output. 
		 * @memberOf Tone.Source#
		 * @type {boolean}
		 * @name mute
		 * @example
		 * //mute the output
		 * source.mute = true;
		 */
	    Object.defineProperty(Tone.Source.prototype, 'mute', {
	        get: function () {
	            return this._volume.mute;
	        },
	        set: function (mute) {
	            this._volume.mute = mute;
	        }
	    });
	    //overwrite these functions
	    Tone.Source.prototype._start = Tone.noOp;
	    Tone.Source.prototype._stop = Tone.noOp;
	    /**
		 *  Start the source at the specified time. If no time is given, 
		 *  start the source now.
		 *  @param  {Time} [time=now] When the source should be started.
		 *  @returns {Tone.Source} this
		 *  @example
		 * source.start("+0.5"); //starts the source 0.5 seconds from now
		 */
	    Tone.Source.prototype.start = function (time, offset, duration) {
	        if (this.isUndef(time) && this._synced) {
	            time = Tone.Transport.seconds;
	        } else {
	            time = this.toSeconds(time);
	        }
	        //if it's started, stop it and restart it
	        if (!this.retrigger && this._state.getValueAtTime(time) === Tone.State.Started) {
	            this.stop(time);
	        }
	        this._state.setStateAtTime(Tone.State.Started, time);
	        if (this._synced) {
	            // add the offset time to the event
	            var event = this._state.get(time);
	            event.offset = this.defaultArg(offset, 0);
	            event.duration = duration;
	            var sched = Tone.Transport.schedule(function (t) {
	                this._start(t, offset, duration);
	            }.bind(this), time);
	            this._scheduled.push(sched);
	        } else {
	            this._start.apply(this, arguments);
	        }
	        return this;
	    };
	    /**
		 *  Stop the source at the specified time. If no time is given, 
		 *  stop the source now.
		 *  @param  {Time} [time=now] When the source should be stopped. 
		 *  @returns {Tone.Source} this
		 *  @example
		 * source.stop(); // stops the source immediately
		 */
	    Tone.Source.prototype.stop = function (time) {
	        if (this.isUndef(time) && this._synced) {
	            time = Tone.Transport.seconds;
	        } else {
	            time = this.toSeconds(time);
	        }
	        this._state.cancel(time);
	        this._state.setStateAtTime(Tone.State.Stopped, time);
	        if (!this._synced) {
	            this._stop.apply(this, arguments);
	        } else {
	            var sched = Tone.Transport.schedule(this._stop.bind(this), time);
	            this._scheduled.push(sched);
	        }
	        return this;
	    };
	    /**
		 *  Sync the source to the Transport so that all subsequent
		 *  calls to `start` and `stop` are synced to the TransportTime
		 *  instead of the AudioContext time. 
		 *
		 *  @returns {Tone.Source} this
		 *  @example
		 * //sync the source so that it plays between 0 and 0.3 on the Transport's timeline
		 * source.sync().start(0).stop(0.3);
		 * //start the transport.
		 * Tone.Transport.start();
		 *
		 *  @example
		 * //start the transport with an offset and the sync'ed sources
		 * //will start in the correct position
		 * source.sync().start(0.1);
		 * //the source will be invoked with an offset of 0.4
		 * Tone.Transport.start("+0.5", 0.5);
		 */
	    Tone.Source.prototype.sync = function () {
	        this._synced = true;
	        Tone.Transport.on('start loopStart', function (time, offset) {
	            if (offset > 0) {
	                // get the playback state at that time
	                var stateEvent = this._state.get(offset);
	                // listen for start events which may occur in the middle of the sync'ed time
	                if (stateEvent && stateEvent.state === Tone.State.Started && stateEvent.time !== offset) {
	                    // get the offset
	                    var startOffset = offset - this.toSeconds(stateEvent.time);
	                    var duration;
	                    if (stateEvent.duration) {
	                        duration = this.toSeconds(stateEvent.duration) - startOffset;
	                    }
	                    this._start(time, this.toSeconds(stateEvent.offset) + startOffset, duration);
	                }
	            }
	        }.bind(this));
	        Tone.Transport.on('stop pause loopEnd', function (time) {
	            if (this._state.getValueAtTime(Tone.Transport.seconds) === Tone.State.Started) {
	                this._stop(time);
	            }
	        }.bind(this));
	        return this;
	    };
	    /**
		 *  Unsync the source to the Transport. See Tone.Source.sync
		 *  @returns {Tone.Source} this
		 */
	    Tone.Source.prototype.unsync = function () {
	        this._synced = false;
	        Tone.Transport.off('start stop pause loopEnd loopStart');
	        // clear all of the scheduled ids
	        for (var i = 0; i < this._scheduled.length; i++) {
	            var id = this._scheduled[i];
	            Tone.Transport.clear(id);
	        }
	        this._scheduled = [];
	        this._state.cancel(0);
	        return this;
	    };
	    /**
		 *	Clean up.
		 *  @return {Tone.Source} this
		 */
	    Tone.Source.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this.unsync();
	        this._scheduled = null;
	        this._writable('volume');
	        this._volume.dispose();
	        this._volume = null;
	        this.volume = null;
	        this._state.dispose();
	        this._state = null;
	    };
	    return Tone.Source;
	});
	Module(function (Tone) {
	    
	    /**
		 *  OscillatorNode shim
		 *  @private
		 */
	    if (window.OscillatorNode && !OscillatorNode.prototype.start) {
	        OscillatorNode.prototype.start = OscillatorNode.prototype.noteOn;
	        OscillatorNode.prototype.stop = OscillatorNode.prototype.noteOff;
	        if (!OscillatorNode.prototype.setPeriodicWave) {
	            OscillatorNode.prototype.setPeriodicWave = OscillatorNode.prototype.setWaveTable;
	        }
	        if (!AudioContext.prototype.createPeriodicWave) {
	            AudioContext.prototype.createPeriodicWave = AudioContext.prototype.createWaveTable;
	        }
	    }
	    /**
		 *  @class Tone.Oscillator supports a number of features including
		 *         phase rotation, multiple oscillator types (see Tone.Oscillator.type), 
		 *         and Transport syncing (see Tone.Oscillator.syncFrequency).
		 *
		 *  @constructor
		 *  @extends {Tone.Source}
		 *  @param {Frequency} [frequency] Starting frequency
		 *  @param {string} [type] The oscillator type. Read more about type below.
		 *  @example
		 * //make and start a 440hz sine tone
		 * var osc = new Tone.Oscillator(440, "sine").toMaster().start();
		 */
	    Tone.Oscillator = function () {
	        var options = this.optionsObject(arguments, [
	            'frequency',
	            'type'
	        ], Tone.Oscillator.defaults);
	        Tone.Source.call(this, options);
	        /**
			 *  the main oscillator
			 *  @type {OscillatorNode}
			 *  @private
			 */
	        this._oscillator = null;
	        /**
			 *  The frequency control.
			 *  @type {Frequency}
			 *  @signal
			 */
	        this.frequency = new Tone.Signal(options.frequency, Tone.Type.Frequency);
	        /**
			 *  The detune control signal.
			 *  @type {Cents}
			 *  @signal
			 */
	        this.detune = new Tone.Signal(options.detune, Tone.Type.Cents);
	        /**
			 *  the periodic wave
			 *  @type {PeriodicWave}
			 *  @private
			 */
	        this._wave = null;
	        /**
			 *  The partials of the oscillator
			 *  @type {Array}
			 *  @private
			 */
	        this._partials = this.defaultArg(options.partials, [1]);
	        /**
			 *  the phase of the oscillator
			 *  between 0 - 360
			 *  @type {number}
			 *  @private
			 */
	        this._phase = options.phase;
	        /**
			 *  the type of the oscillator
			 *  @type {string}
			 *  @private
			 */
	        this._type = null;
	        //setup
	        this.type = options.type;
	        this.phase = this._phase;
	        this._readOnly([
	            'frequency',
	            'detune'
	        ]);
	    };
	    Tone.extend(Tone.Oscillator, Tone.Source);
	    /**
		 *  the default parameters
		 *  @type {Object}
		 */
	    Tone.Oscillator.defaults = {
	        'type': 'sine',
	        'frequency': 440,
	        'detune': 0,
	        'phase': 0,
	        'partials': []
	    };
	    /**
		 *  The Oscillator types
		 *  @enum {String}
		 */
	    Tone.Oscillator.Type = {
	        Sine: 'sine',
	        Triangle: 'triangle',
	        Sawtooth: 'sawtooth',
	        Square: 'square',
	        Custom: 'custom'
	    };
	    /**
		 *  start the oscillator
		 *  @param  {Time} [time=now] 
		 *  @private
		 */
	    Tone.Oscillator.prototype._start = function (time) {
	        //new oscillator with previous values
	        this._oscillator = this.context.createOscillator();
	        this._oscillator.setPeriodicWave(this._wave);
	        //connect the control signal to the oscillator frequency & detune
	        this._oscillator.connect(this.output);
	        this.frequency.connect(this._oscillator.frequency);
	        this.detune.connect(this._oscillator.detune);
	        //start the oscillator
	        this._oscillator.start(this.toSeconds(time));
	    };
	    /**
		 *  stop the oscillator
		 *  @private
		 *  @param  {Time} [time=now] (optional) timing parameter
		 *  @returns {Tone.Oscillator} this
		 */
	    Tone.Oscillator.prototype._stop = function (time) {
	        if (this._oscillator) {
	            this._oscillator.stop(this.toSeconds(time));
	            this._oscillator = null;
	        }
	        return this;
	    };
	    /**
		 *  Sync the signal to the Transport's bpm. Any changes to the transports bpm,
		 *  will also affect the oscillators frequency. 
		 *  @returns {Tone.Oscillator} this
		 *  @example
		 * Tone.Transport.bpm.value = 120;
		 * osc.frequency.value = 440;
		 * //the ration between the bpm and the frequency will be maintained
		 * osc.syncFrequency();
		 * Tone.Transport.bpm.value = 240; 
		 * // the frequency of the oscillator is doubled to 880
		 */
	    Tone.Oscillator.prototype.syncFrequency = function () {
	        Tone.Transport.syncSignal(this.frequency);
	        return this;
	    };
	    /**
		 *  Unsync the oscillator's frequency from the Transport. 
		 *  See Tone.Oscillator.syncFrequency
		 *  @returns {Tone.Oscillator} this
		 */
	    Tone.Oscillator.prototype.unsyncFrequency = function () {
	        Tone.Transport.unsyncSignal(this.frequency);
	        return this;
	    };
	    /**
		 * The type of the oscillator: either sine, square, triangle, or sawtooth. Also capable of
		 * setting the first x number of partials of the oscillator. For example: "sine4" would
		 * set be the first 4 partials of the sine wave and "triangle8" would set the first
		 * 8 partials of the triangle wave.
		 * <br><br> 
		 * Uses PeriodicWave internally even for native types so that it can set the phase. 
		 * PeriodicWave equations are from the 
		 * [Webkit Web Audio implementation](https://code.google.com/p/chromium/codesearch#chromium/src/third_party/WebKit/Source/modules/webaudio/PeriodicWave.cpp&sq=package:chromium).
		 *  
		 * @memberOf Tone.Oscillator#
		 * @type {string}
		 * @name type
		 * @example
		 * //set it to a square wave
		 * osc.type = "square";
		 * @example
		 * //set the first 6 partials of a sawtooth wave
		 * osc.type = "sawtooth6";
		 */
	    Object.defineProperty(Tone.Oscillator.prototype, 'type', {
	        get: function () {
	            return this._type;
	        },
	        set: function (type) {
	            var coefs = this._getRealImaginary(type, this._phase);
	            var periodicWave = this.context.createPeriodicWave(coefs[0], coefs[1]);
	            this._wave = periodicWave;
	            if (this._oscillator !== null) {
	                this._oscillator.setPeriodicWave(this._wave);
	            }
	            this._type = type;
	        }
	    });
	    /**
		 *  Returns the real and imaginary components based 
		 *  on the oscillator type.
		 *  @returns {Array} [real, imaginary]
		 *  @private
		 */
	    Tone.Oscillator.prototype._getRealImaginary = function (type, phase) {
	        var fftSize = 4096;
	        var periodicWaveSize = fftSize / 2;
	        var real = new Float32Array(periodicWaveSize);
	        var imag = new Float32Array(periodicWaveSize);
	        var partialCount = 1;
	        if (type === Tone.Oscillator.Type.Custom) {
	            partialCount = this._partials.length + 1;
	            periodicWaveSize = partialCount;
	        } else {
	            var partial = /^(sine|triangle|square|sawtooth)(\d+)$/.exec(type);
	            if (partial) {
	                partialCount = parseInt(partial[2]) + 1;
	                type = partial[1];
	                partialCount = Math.max(partialCount, 2);
	                periodicWaveSize = partialCount;
	            }
	        }
	        for (var n = 1; n < periodicWaveSize; ++n) {
	            var piFactor = 2 / (n * Math.PI);
	            var b;
	            switch (type) {
	            case Tone.Oscillator.Type.Sine:
	                b = n <= partialCount ? 1 : 0;
	                break;
	            case Tone.Oscillator.Type.Square:
	                b = n & 1 ? 2 * piFactor : 0;
	                break;
	            case Tone.Oscillator.Type.Sawtooth:
	                b = piFactor * (n & 1 ? 1 : -1);
	                break;
	            case Tone.Oscillator.Type.Triangle:
	                if (n & 1) {
	                    b = 2 * (piFactor * piFactor) * (n - 1 >> 1 & 1 ? -1 : 1);
	                } else {
	                    b = 0;
	                }
	                break;
	            case Tone.Oscillator.Type.Custom:
	                b = this._partials[n - 1];
	                break;
	            default:
	                throw new TypeError('Tone.Oscillator: invalid type: ' + type);
	            }
	            if (b !== 0) {
	                real[n] = -b * Math.sin(phase * n);
	                imag[n] = b * Math.cos(phase * n);
	            } else {
	                real[n] = 0;
	                imag[n] = 0;
	            }
	        }
	        return [
	            real,
	            imag
	        ];
	    };
	    /**
		 *  Compute the inverse FFT for a given phase.	
		 *  @param  {Float32Array}  real
		 *  @param  {Float32Array}  imag 
		 *  @param  {NormalRange}  phase 
		 *  @return  {AudioRange}
		 *  @private
		 */
	    Tone.Oscillator.prototype._inverseFFT = function (real, imag, phase) {
	        var sum = 0;
	        var len = real.length;
	        for (var i = 0; i < len; i++) {
	            sum += real[i] * Math.cos(i * phase) + imag[i] * Math.sin(i * phase);
	        }
	        return sum;
	    };
	    /**
		 *  Returns the initial value of the oscillator.
		 *  @return  {AudioRange}
		 *  @private
		 */
	    Tone.Oscillator.prototype._getInitialValue = function () {
	        var coefs = this._getRealImaginary(this._type, 0);
	        var real = coefs[0];
	        var imag = coefs[1];
	        var maxValue = 0;
	        var twoPi = Math.PI * 2;
	        //check for peaks in 8 places
	        for (var i = 0; i < 8; i++) {
	            maxValue = Math.max(this._inverseFFT(real, imag, i / 8 * twoPi), maxValue);
	        }
	        return -this._inverseFFT(real, imag, this._phase) / maxValue;
	    };
	    /**
		 * The partials of the waveform. A partial represents 
		 * the amplitude at a harmonic. The first harmonic is the 
		 * fundamental frequency, the second is the octave and so on
		 * following the harmonic series. 
		 * Setting this value will automatically set the type to "custom". 
		 * The value is an empty array when the type is not "custom". 
		 * @memberOf Tone.Oscillator#
		 * @type {Array}
		 * @name partials
		 * @example
		 * osc.partials = [1, 0.2, 0.01];
		 */
	    Object.defineProperty(Tone.Oscillator.prototype, 'partials', {
	        get: function () {
	            if (this._type !== Tone.Oscillator.Type.Custom) {
	                return [];
	            } else {
	                return this._partials;
	            }
	        },
	        set: function (partials) {
	            this._partials = partials;
	            this.type = Tone.Oscillator.Type.Custom;
	        }
	    });
	    /**
		 * The phase of the oscillator in degrees. 
		 * @memberOf Tone.Oscillator#
		 * @type {Degrees}
		 * @name phase
		 * @example
		 * osc.phase = 180; //flips the phase of the oscillator
		 */
	    Object.defineProperty(Tone.Oscillator.prototype, 'phase', {
	        get: function () {
	            return this._phase * (180 / Math.PI);
	        },
	        set: function (phase) {
	            this._phase = phase * Math.PI / 180;
	            //reset the type
	            this.type = this._type;
	        }
	    });
	    /**
		 *  Dispose and disconnect.
		 *  @return {Tone.Oscillator} this
		 */
	    Tone.Oscillator.prototype.dispose = function () {
	        Tone.Source.prototype.dispose.call(this);
	        if (this._oscillator !== null) {
	            this._oscillator.disconnect();
	            this._oscillator = null;
	        }
	        this._wave = null;
	        this._writable([
	            'frequency',
	            'detune'
	        ]);
	        this.frequency.dispose();
	        this.frequency = null;
	        this.detune.dispose();
	        this.detune = null;
	        this._partials = null;
	        return this;
	    };
	    return Tone.Oscillator;
	});
	Module(function (Tone) {
	    /**
		 *  @class Tone.Zero outputs 0's at audio-rate. The reason this has to be
		 *         it's own class is that many browsers optimize out Tone.Signal
		 *         with a value of 0 and will not process nodes further down the graph. 
		 *  @extends {Tone}
		 */
	    Tone.Zero = function () {
	        /**
			 *  The gain node
			 *  @type  {Tone.Gain}
			 *  @private
			 */
	        this._gain = this.input = this.output = new Tone.Gain();
	        this.context.getConstant(0).connect(this._gain);
	    };
	    Tone.extend(Tone.Zero);
	    /**
		 *  clean up
		 *  @return  {Tone.Zero}  this
		 */
	    Tone.Zero.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._gain.dispose();
	        this._gain = null;
	        return this;
	    };
	    return Tone.Zero;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  LFO stands for low frequency oscillator. Tone.LFO produces an output signal 
		 *          which can be attached to an AudioParam or Tone.Signal 
		 *          in order to modulate that parameter with an oscillator. The LFO can 
		 *          also be synced to the transport to start/stop and change when the tempo changes.
		 *
		 *  @constructor
		 *  @extends {Tone.Oscillator}
		 *  @param {Frequency|Object} [frequency] The frequency of the oscillation. Typically, LFOs will be
		 *                               in the frequency range of 0.1 to 10 hertz. 
		 *  @param {number=} min The minimum output value of the LFO. 
		 *  @param {number=} max The maximum value of the LFO. 
		 *  @example
		 * var lfo = new Tone.LFO("4n", 400, 4000);
		 * lfo.connect(filter.frequency);
		 */
	    Tone.LFO = function () {
	        var options = this.optionsObject(arguments, [
	            'frequency',
	            'min',
	            'max'
	        ], Tone.LFO.defaults);
	        /** 
			 *  The oscillator. 
			 *  @type {Tone.Oscillator}
			 *  @private
			 */
	        this._oscillator = new Tone.Oscillator({
	            'frequency': options.frequency,
	            'type': options.type
	        });
	        /**
			 *  the lfo's frequency
			 *  @type {Frequency}
			 *  @signal
			 */
	        this.frequency = this._oscillator.frequency;
	        /**
			 * The amplitude of the LFO, which controls the output range between
			 * the min and max output. For example if the min is -10 and the max 
			 * is 10, setting the amplitude to 0.5 would make the LFO modulate
			 * between -5 and 5. 
			 * @type {Number}
			 * @signal
			 */
	        this.amplitude = this._oscillator.volume;
	        this.amplitude.units = Tone.Type.NormalRange;
	        this.amplitude.value = options.amplitude;
	        /**
			 *  The signal which is output when the LFO is stopped
			 *  @type  {Tone.Signal}
			 *  @private
			 */
	        this._stoppedSignal = new Tone.Signal(0, Tone.Type.AudioRange);
	        /**
			 *  Just outputs zeros.
			 *  @type {Tone.Zero}
			 *  @private
			 */
	        this._zeros = new Tone.Zero();
	        /**
			 *  The value that the LFO outputs when it's stopped
			 *  @type {AudioRange}
			 *  @private
			 */
	        this._stoppedValue = 0;
	        /**
			 *  @type {Tone.AudioToGain} 
			 *  @private
			 */
	        this._a2g = new Tone.AudioToGain();
	        /**
			 *  @type {Tone.Scale} 
			 *  @private
			 */
	        this._scaler = this.output = new Tone.Scale(options.min, options.max);
	        /**
			 *  the units of the LFO (used for converting)
			 *  @type {Tone.Type} 
			 *  @private
			 */
	        this._units = Tone.Type.Default;
	        this.units = options.units;
	        //connect it up
	        this._oscillator.chain(this._a2g, this._scaler);
	        this._zeros.connect(this._a2g);
	        this._stoppedSignal.connect(this._a2g);
	        this._readOnly([
	            'amplitude',
	            'frequency'
	        ]);
	        this.phase = options.phase;
	    };
	    Tone.extend(Tone.LFO, Tone.Oscillator);
	    /**
		 *  the default parameters
		 *
		 *  @static
		 *  @const
		 *  @type {Object}
		 */
	    Tone.LFO.defaults = {
	        'type': 'sine',
	        'min': 0,
	        'max': 1,
	        'phase': 0,
	        'frequency': '4n',
	        'amplitude': 1,
	        'units': Tone.Type.Default
	    };
	    /**
		 *  Start the LFO. 
		 *  @param  {Time} [time=now] the time the LFO will start
		 *  @returns {Tone.LFO} this
		 */
	    Tone.LFO.prototype.start = function (time) {
	        time = this.toSeconds(time);
	        this._stoppedSignal.setValueAtTime(0, time);
	        this._oscillator.start(time);
	        return this;
	    };
	    /**
		 *  Stop the LFO. 
		 *  @param  {Time} [time=now] the time the LFO will stop
		 *  @returns {Tone.LFO} this
		 */
	    Tone.LFO.prototype.stop = function (time) {
	        time = this.toSeconds(time);
	        this._stoppedSignal.setValueAtTime(this._stoppedValue, time);
	        this._oscillator.stop(time);
	        return this;
	    };
	    /**
		 *  Sync the start/stop/pause to the transport 
		 *  and the frequency to the bpm of the transport
		 *  @returns {Tone.LFO} this
		 *  @example
		 *  lfo.frequency.value = "8n";
		 *  lfo.sync().start(0)
		 *  //the rate of the LFO will always be an eighth note, 
		 *  //even as the tempo changes
		 */
	    Tone.LFO.prototype.sync = function () {
	        this._oscillator.sync();
	        this._oscillator.syncFrequency();
	        return this;
	    };
	    /**
		 *  unsync the LFO from transport control
		 *  @returns {Tone.LFO} this
		 */
	    Tone.LFO.prototype.unsync = function () {
	        this._oscillator.unsync();
	        this._oscillator.unsyncFrequency();
	        return this;
	    };
	    /**
		 * The miniumum output of the LFO.
		 * @memberOf Tone.LFO#
		 * @type {number}
		 * @name min
		 */
	    Object.defineProperty(Tone.LFO.prototype, 'min', {
	        get: function () {
	            return this._toUnits(this._scaler.min);
	        },
	        set: function (min) {
	            min = this._fromUnits(min);
	            this._scaler.min = min;
	        }
	    });
	    /**
		 * The maximum output of the LFO.
		 * @memberOf Tone.LFO#
		 * @type {number}
		 * @name max
		 */
	    Object.defineProperty(Tone.LFO.prototype, 'max', {
	        get: function () {
	            return this._toUnits(this._scaler.max);
	        },
	        set: function (max) {
	            max = this._fromUnits(max);
	            this._scaler.max = max;
	        }
	    });
	    /**
		 * The type of the oscillator: sine, square, sawtooth, triangle. 
		 * @memberOf Tone.LFO#
		 * @type {string}
		 * @name type
		 */
	    Object.defineProperty(Tone.LFO.prototype, 'type', {
	        get: function () {
	            return this._oscillator.type;
	        },
	        set: function (type) {
	            this._oscillator.type = type;
	            this._stoppedValue = this._oscillator._getInitialValue();
	            this._stoppedSignal.value = this._stoppedValue;
	        }
	    });
	    /**
		 * The phase of the LFO.
		 * @memberOf Tone.LFO#
		 * @type {number}
		 * @name phase
		 */
	    Object.defineProperty(Tone.LFO.prototype, 'phase', {
	        get: function () {
	            return this._oscillator.phase;
	        },
	        set: function (phase) {
	            this._oscillator.phase = phase;
	            this._stoppedValue = this._oscillator._getInitialValue();
	            this._stoppedSignal.value = this._stoppedValue;
	        }
	    });
	    /**
		 * The output units of the LFO.
		 * @memberOf Tone.LFO#
		 * @type {Tone.Type}
		 * @name units
		 */
	    Object.defineProperty(Tone.LFO.prototype, 'units', {
	        get: function () {
	            return this._units;
	        },
	        set: function (val) {
	            var currentMin = this.min;
	            var currentMax = this.max;
	            //convert the min and the max
	            this._units = val;
	            this.min = currentMin;
	            this.max = currentMax;
	        }
	    });
	    /**
		 * Mute the output. 
		 * @memberOf Tone.LFO#
		 * @type {Boolean}
		 * @name mute
		 */
	    Object.defineProperty(Tone.LFO.prototype, 'mute', {
	        get: function () {
	            return this._oscillator.mute;
	        },
	        set: function (mute) {
	            this._oscillator.mute = mute;
	        }
	    });
	    /**
		 *  Returns the playback state of the source, either "started" or "stopped".
		 *  @type {Tone.State}
		 *  @readOnly
		 *  @memberOf Tone.LFO#
		 *  @name state
		 */
	    Object.defineProperty(Tone.LFO.prototype, 'state', {
	        get: function () {
	            return this._oscillator.state;
	        }
	    });
	    /**
		 *  Connect the output of the LFO to an AudioParam, AudioNode, or Tone Node. 
		 *  Tone.LFO will automatically convert to the destination units of the 
		 *  will get the units from the connected node.
		 *  @param  {Tone | AudioParam | AudioNode} node 
		 *  @param {number} [outputNum=0] optionally which output to connect from
		 *  @param {number} [inputNum=0] optionally which input to connect to
		 *  @returns {Tone.LFO} this
		 *  @private
		 */
	    Tone.LFO.prototype.connect = function (node) {
	        if (node.constructor === Tone.Signal || node.constructor === Tone.Param || node.constructor === Tone.TimelineSignal) {
	            this.convert = node.convert;
	            this.units = node.units;
	        }
	        Tone.Signal.prototype.connect.apply(this, arguments);
	        return this;
	    };
	    /**
		 *  private method borrowed from Param converts 
		 *  units from their destination value
		 *  @function
		 *  @private
		 */
	    Tone.LFO.prototype._fromUnits = Tone.Param.prototype._fromUnits;
	    /**
		 *  private method borrowed from Param converts 
		 *  units to their destination value
		 *  @function
		 *  @private
		 */
	    Tone.LFO.prototype._toUnits = Tone.Param.prototype._toUnits;
	    /**
		 *  disconnect and dispose
		 *  @returns {Tone.LFO} this
		 */
	    Tone.LFO.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._writable([
	            'amplitude',
	            'frequency'
	        ]);
	        this._oscillator.dispose();
	        this._oscillator = null;
	        this._stoppedSignal.dispose();
	        this._stoppedSignal = null;
	        this._zeros.dispose();
	        this._zeros = null;
	        this._scaler.dispose();
	        this._scaler = null;
	        this._a2g.dispose();
	        this._a2g = null;
	        this.frequency = null;
	        this.amplitude = null;
	        return this;
	    };
	    return Tone.LFO;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Tone.Limiter will limit the loudness of an incoming signal. 
		 *         It is composed of a Tone.Compressor with a fast attack 
		 *         and release. Limiters are commonly used to safeguard against 
		 *         signal clipping. Unlike a compressor, limiters do not provide 
		 *         smooth gain reduction and almost completely prevent 
		 *         additional gain above the threshold.
		 *
		 *  @extends {Tone}
		 *  @constructor
		 *  @param {number} threshold The theshold above which the limiting is applied. 
		 *  @example
		 *  var limiter = new Tone.Limiter(-6);
		 */
	    Tone.Limiter = function () {
	        var options = this.optionsObject(arguments, ['threshold'], Tone.Limiter.defaults);
	        /**
			 *  the compressor
			 *  @private
			 *  @type {Tone.Compressor}
			 */
	        this._compressor = this.input = this.output = new Tone.Compressor({
	            'attack': 0.001,
	            'decay': 0.001,
	            'threshold': options.threshold
	        });
	        /**
			 * The threshold of of the limiter
			 * @type {Decibel}
			 * @signal
			 */
	        this.threshold = this._compressor.threshold;
	        this._readOnly('threshold');
	    };
	    Tone.extend(Tone.Limiter);
	    /**
		 *  The default value
		 *  @type {Object}
		 *  @const
		 *  @static
		 */
	    Tone.Limiter.defaults = { 'threshold': -12 };
	    /**
		 *  Clean up.
		 *  @returns {Tone.Limiter} this
		 */
	    Tone.Limiter.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._compressor.dispose();
	        this._compressor = null;
	        this._writable('threshold');
	        this.threshold = null;
	        return this;
	    };
	    return Tone.Limiter;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Tone.Lowpass is a lowpass feedback comb filter. It is similar to 
		 *         Tone.FeedbackCombFilter, but includes a lowpass filter.
		 *
		 *  @extends {Tone}
		 *  @constructor
		 *  @param {Time|Object} [delayTime] The delay time of the comb filter
		 *  @param {NormalRange=} resonance The resonance (feedback) of the comb filter
		 *  @param {Frequency=} dampening The cutoff of the lowpass filter dampens the
		 *                                signal as it is fedback. 
		 */
	    Tone.LowpassCombFilter = function () {
	        this.createInsOuts(1, 1);
	        var options = this.optionsObject(arguments, [
	            'delayTime',
	            'resonance',
	            'dampening'
	        ], Tone.LowpassCombFilter.defaults);
	        /**
			 *  the delay node
			 *  @type {DelayNode}
			 *  @private
			 */
	        this._delay = this.input = new Tone.Delay(options.delayTime);
	        /**
			 *  The delayTime of the comb filter. 
			 *  @type {Time}
			 *  @signal
			 */
	        this.delayTime = this._delay.delayTime;
	        /**
			 *  the lowpass filter
			 *  @type  {BiquadFilterNode}
			 *  @private
			 */
	        this._lowpass = this.output = this.context.createBiquadFilter();
	        this._lowpass.Q.value = -3.0102999566398125;
	        this._lowpass.type = 'lowpass';
	        /**
			 *  The dampening control of the feedback
			 *  @type {Frequency}
			 *  @signal
			 */
	        this.dampening = new Tone.Param({
	            'param': this._lowpass.frequency,
	            'units': Tone.Type.Frequency,
	            'value': options.dampening
	        });
	        /**
			 *  the feedback gain
			 *  @type {Tone.Gain}
			 *  @private
			 */
	        this._feedback = new Tone.Gain(options.resonance, Tone.Type.NormalRange);
	        /**
			 *  The amount of feedback of the delayed signal. 
			 *  @type {NormalRange}
			 *  @signal
			 */
	        this.resonance = this._feedback.gain;
	        //connections
	        this._delay.chain(this._lowpass, this._feedback, this._delay);
	        this._readOnly([
	            'dampening',
	            'resonance',
	            'delayTime'
	        ]);
	    };
	    Tone.extend(Tone.LowpassCombFilter);
	    /**
		 *  the default parameters
		 *  @static
		 *  @const
		 *  @type {Object}
		 */
	    Tone.LowpassCombFilter.defaults = {
	        'delayTime': 0.1,
	        'resonance': 0.5,
	        'dampening': 3000
	    };
	    /**
		 *  Clean up. 
		 *  @returns {Tone.LowpassCombFilter} this
		 */
	    Tone.LowpassCombFilter.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._writable([
	            'dampening',
	            'resonance',
	            'delayTime'
	        ]);
	        this.dampening.dispose();
	        this.dampening = null;
	        this.resonance.dispose();
	        this.resonance = null;
	        this._delay.dispose();
	        this._delay = null;
	        this.delayTime = null;
	        this._lowpass.disconnect();
	        this._lowpass = null;
	        this._feedback.disconnect();
	        this._feedback = null;
	        return this;
	    };
	    return Tone.LowpassCombFilter;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  Tone.Merge brings two signals into the left and right 
		 *          channels of a single stereo channel.
		 *
		 *  @constructor
		 *  @extends {Tone}
		 *  @example
		 * var merge = new Tone.Merge().toMaster();
		 * //routing a sine tone in the left channel
		 * //and noise in the right channel
		 * var osc = new Tone.Oscillator().connect(merge.left);
		 * var noise = new Tone.Noise().connect(merge.right);
		 * //starting our oscillators
		 * noise.start();
		 * osc.start();
		 */
	    Tone.Merge = function () {
	        this.createInsOuts(2, 0);
	        /**
			 *  The left input channel.
			 *  Alias for <code>input[0]</code>
			 *  @type {GainNode}
			 */
	        this.left = this.input[0] = new Tone.Gain();
	        /**
			 *  The right input channel.
			 *  Alias for <code>input[1]</code>.
			 *  @type {GainNode}
			 */
	        this.right = this.input[1] = new Tone.Gain();
	        /**
			 *  the merger node for the two channels
			 *  @type {ChannelMergerNode}
			 *  @private
			 */
	        this._merger = this.output = this.context.createChannelMerger(2);
	        //connections
	        this.left.connect(this._merger, 0, 0);
	        this.right.connect(this._merger, 0, 1);
	        this.left.channelCount = 1;
	        this.right.channelCount = 1;
	        this.left.channelCountMode = 'explicit';
	        this.right.channelCountMode = 'explicit';
	    };
	    Tone.extend(Tone.Merge);
	    /**
		 *  Clean up.
		 *  @returns {Tone.Merge} this
		 */
	    Tone.Merge.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this.left.dispose();
	        this.left = null;
	        this.right.dispose();
	        this.right = null;
	        this._merger.disconnect();
	        this._merger = null;
	        return this;
	    };
	    return Tone.Merge;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  Tone.Meter gets the [RMS](https://en.wikipedia.org/wiki/Root_mean_square)
		 *          of an input signal with some averaging applied. It can also get the raw 
		 *          value of the input signal.
		 *
		 *  @constructor
		 *  @extends {Tone}
		 *  @param {String} type Either "level" or "signal". 
		 *  @param {Number} smoothing The amount of smoothing applied between frames.
		 *  @example
		 * var meter = new Tone.Meter();
		 * var mic = new Tone.UserMedia().start();
		 * //connect mic to the meter
		 * mic.connect(meter);
		 * //the current level of the mic input
		 * var level = meter.value;
		 */
	    Tone.Meter = function () {
	        var options = this.optionsObject(arguments, [
	            'type',
	            'smoothing'
	        ], Tone.Meter.defaults);
	        /**
			 *  The type of the meter, either "level" or "signal". 
			 *  A "level" meter will return the volume level (rms) of the 
			 *  input signal and a "signal" meter will return
			 *  the signal value of the input. 
			 *  @type  {String}
			 */
	        this.type = options.type;
	        /**
			 *  The analyser node which computes the levels.
			 *  @private
			 *  @type  {Tone.Analyser}
			 */
	        this.input = this.output = this._analyser = new Tone.Analyser('waveform', 512);
	        this._analyser.returnType = 'float';
	        /**
			 *  The amount of carryover between the current and last frame. 
			 *  Only applied meter for "level" type.
			 *  @type  {Number}
			 */
	        this.smoothing = options.smoothing;
	        /**
			 *  The last computed value
			 *  @type {Number}
			 *  @private
			 */
	        this._lastValue = 0;
	    };
	    Tone.extend(Tone.Meter);
	    /**
		 *  @private
		 *  @enum {String}
		 */
	    Tone.Meter.Type = {
	        Level: 'level',
	        Signal: 'signal'
	    };
	    /**
		 *  The defaults
		 *  @type {Object}
		 *  @static
		 *  @const
		 */
	    Tone.Meter.defaults = {
	        'smoothing': 0.8,
	        'type': Tone.Meter.Type.Level
	    };
	    /**
		 * The current value of the meter. A value of 1 is
		 * "unity".
		 * @memberOf Tone.Meter#
		 * @type {Number}
		 * @name value
		 * @readOnly
		 */
	    Object.defineProperty(Tone.Meter.prototype, 'value', {
	        get: function () {
	            var signal = this._analyser.analyse();
	            if (this.type === Tone.Meter.Type.Level) {
	                //rms
	                var sum = 0;
	                for (var i = 0; i < signal.length; i++) {
	                    sum += Math.pow(signal[i], 2);
	                }
	                var rms = Math.sqrt(sum / signal.length);
	                //smooth it
	                rms = Math.max(rms, this._lastValue * this.smoothing);
	                this._lastValue = rms;
	                //scale it
	                var unity = 0.35;
	                var val = rms / unity;
	                //scale the output curve
	                return Math.sqrt(val);
	            } else {
	                return signal[0];
	            }
	        }
	    });
	    /**
		 *  Clean up.
		 *  @returns {Tone.Meter} this
		 */
	    Tone.Meter.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._analyser.dispose();
	        this._analyser = null;
	        return this;
	    };
	    return Tone.Meter;
	});
	Module(function (Tone) {
	    
	    /**
		 *	@class  Tone.Split splits an incoming signal into left and right channels.
		 *	
		 *  @constructor
		 *  @extends {Tone}
		 *  @example
		 * var split = new Tone.Split();
		 * stereoSignal.connect(split);
		 */
	    Tone.Split = function () {
	        this.createInsOuts(0, 2);
	        /** 
			 *  @type {ChannelSplitterNode}
			 *  @private
			 */
	        this._splitter = this.input = this.context.createChannelSplitter(2);
	        /** 
			 *  Left channel output. 
			 *  Alias for <code>output[0]</code>
			 *  @type {Tone.Gain}
			 */
	        this.left = this.output[0] = new Tone.Gain();
	        /**
			 *  Right channel output.
			 *  Alias for <code>output[1]</code>
			 *  @type {Tone.Gain}
			 */
	        this.right = this.output[1] = new Tone.Gain();
	        //connections
	        this._splitter.connect(this.left, 0, 0);
	        this._splitter.connect(this.right, 1, 0);
	    };
	    Tone.extend(Tone.Split);
	    /**
		 *  Clean up. 
		 *  @returns {Tone.Split} this
		 */
	    Tone.Split.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._splitter.disconnect();
	        this.left.dispose();
	        this.left = null;
	        this.right.dispose();
	        this.right = null;
	        this._splitter = null;
	        return this;
	    };
	    return Tone.Split;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Mid/Side processing separates the the 'mid' signal 
		 *         (which comes out of both the left and the right channel) 
		 *         and the 'side' (which only comes out of the the side channels). <br><br>
		 *         <code>
		 *         Mid = (Left+Right)/sqrt(2);   // obtain mid-signal from left and right<br>
		 *         Side = (Left-Right)/sqrt(2);   // obtain side-signal from left and righ<br>
		 *         </code>
		 *
		 *  @extends {Tone}
		 *  @constructor
		 */
	    Tone.MidSideSplit = function () {
	        this.createInsOuts(0, 2);
	        /**
			 *  split the incoming signal into left and right channels
			 *  @type  {Tone.Split}
			 *  @private
			 */
	        this._split = this.input = new Tone.Split();
	        /**
			 *  The mid send. Connect to mid processing. Alias for
			 *  <code>output[0]</code>
			 *  @type {Tone.Expr}
			 */
	        this.mid = this.output[0] = new Tone.Expr('($0 + $1) * $2');
	        /**
			 *  The side output. Connect to side processing. Alias for
			 *  <code>output[1]</code>
			 *  @type {Tone.Expr}
			 */
	        this.side = this.output[1] = new Tone.Expr('($0 - $1) * $2');
	        this._split.connect(this.mid, 0, 0);
	        this._split.connect(this.mid, 1, 1);
	        this._split.connect(this.side, 0, 0);
	        this._split.connect(this.side, 1, 1);
	        this.context.getConstant(Math.SQRT1_2).connect(this.mid, 0, 2);
	        this.context.getConstant(Math.SQRT1_2).connect(this.side, 0, 2);
	    };
	    Tone.extend(Tone.MidSideSplit);
	    /**
		 *  clean up
		 *  @returns {Tone.MidSideSplit} this
		 */
	    Tone.MidSideSplit.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this.mid.dispose();
	        this.mid = null;
	        this.side.dispose();
	        this.side = null;
	        this._split.dispose();
	        this._split = null;
	        return this;
	    };
	    return Tone.MidSideSplit;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Mid/Side processing separates the the 'mid' signal 
		 *         (which comes out of both the left and the right channel) 
		 *         and the 'side' (which only comes out of the the side channels). 
		 *         MidSideMerge merges the mid and side signal after they've been seperated
		 *         by Tone.MidSideSplit.<br><br>
		 *         <code>
		 *         Left = (Mid+Side)/sqrt(2);   // obtain left signal from mid and side<br>
		 *         Right = (Mid-Side)/sqrt(2);   // obtain right signal from mid and side<br>
		 *         </code>
		 *
		 *  @extends {Tone.StereoEffect}
		 *  @constructor
		 */
	    Tone.MidSideMerge = function () {
	        this.createInsOuts(2, 0);
	        /**
			 *  The mid signal input. Alias for
			 *  <code>input[0]</code>
			 *  @type  {Tone.Gain}
			 */
	        this.mid = this.input[0] = new Tone.Gain();
	        /**
			 *  recombine the mid/side into Left
			 *  @type {Tone.Expr}
			 *  @private
			 */
	        this._left = new Tone.Expr('($0 + $1) * $2');
	        /**
			 *  The side signal input. Alias for
			 *  <code>input[1]</code>
			 *  @type  {Tone.Gain}
			 */
	        this.side = this.input[1] = new Tone.Gain();
	        /**
			 *  recombine the mid/side into Right
			 *  @type {Tone.Expr}
			 *  @private
			 */
	        this._right = new Tone.Expr('($0 - $1) * $2');
	        /**
			 *  Merge the left/right signal back into a stereo signal.
			 *  @type {Tone.Merge}
			 *  @private
			 */
	        this._merge = this.output = new Tone.Merge();
	        this.mid.connect(this._left, 0, 0);
	        this.side.connect(this._left, 0, 1);
	        this.mid.connect(this._right, 0, 0);
	        this.side.connect(this._right, 0, 1);
	        this._left.connect(this._merge, 0, 0);
	        this._right.connect(this._merge, 0, 1);
	        this.context.getConstant(Math.SQRT1_2).connect(this._left, 0, 2);
	        this.context.getConstant(Math.SQRT1_2).connect(this._right, 0, 2);
	    };
	    Tone.extend(Tone.MidSideMerge);
	    /**
		 *  clean up
		 *  @returns {Tone.MidSideMerge} this
		 */
	    Tone.MidSideMerge.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this.mid.dispose();
	        this.mid = null;
	        this.side.dispose();
	        this.side = null;
	        this._left.dispose();
	        this._left = null;
	        this._right.dispose();
	        this._right = null;
	        this._merge.dispose();
	        this._merge = null;
	        return this;
	    };
	    return Tone.MidSideMerge;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Tone.MidSideCompressor applies two different compressors to the mid
		 *         and side signal components. See Tone.MidSideSplit. 
		 *
		 *  @extends {Tone}
		 *  @param {Object} options The options that are passed to the mid and side
		 *                          compressors. 
		 *  @constructor
		 */
	    Tone.MidSideCompressor = function (options) {
	        options = this.defaultArg(options, Tone.MidSideCompressor.defaults);
	        /**
			 *  the mid/side split
			 *  @type  {Tone.MidSideSplit}
			 *  @private
			 */
	        this._midSideSplit = this.input = new Tone.MidSideSplit();
	        /**
			 *  the mid/side recombination
			 *  @type  {Tone.MidSideMerge}
			 *  @private
			 */
	        this._midSideMerge = this.output = new Tone.MidSideMerge();
	        /**
			 *  The compressor applied to the mid signal
			 *  @type  {Tone.Compressor}
			 */
	        this.mid = new Tone.Compressor(options.mid);
	        /**
			 *  The compressor applied to the side signal
			 *  @type  {Tone.Compressor}
			 */
	        this.side = new Tone.Compressor(options.side);
	        this._midSideSplit.mid.chain(this.mid, this._midSideMerge.mid);
	        this._midSideSplit.side.chain(this.side, this._midSideMerge.side);
	        this._readOnly([
	            'mid',
	            'side'
	        ]);
	    };
	    Tone.extend(Tone.MidSideCompressor);
	    /**
		 *  @const
		 *  @static
		 *  @type {Object}
		 */
	    Tone.MidSideCompressor.defaults = {
	        'mid': {
	            'ratio': 3,
	            'threshold': -24,
	            'release': 0.03,
	            'attack': 0.02,
	            'knee': 16
	        },
	        'side': {
	            'ratio': 6,
	            'threshold': -30,
	            'release': 0.25,
	            'attack': 0.03,
	            'knee': 10
	        }
	    };
	    /**
		 *  Clean up.
		 *  @returns {Tone.MidSideCompressor} this
		 */
	    Tone.MidSideCompressor.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._writable([
	            'mid',
	            'side'
	        ]);
	        this.mid.dispose();
	        this.mid = null;
	        this.side.dispose();
	        this.side = null;
	        this._midSideSplit.dispose();
	        this._midSideSplit = null;
	        this._midSideMerge.dispose();
	        this._midSideMerge = null;
	        return this;
	    };
	    return Tone.MidSideCompressor;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Tone.Mono coerces the incoming mono or stereo signal into a mono signal
		 *         where both left and right channels have the same value. This can be useful 
		 *         for [stereo imaging](https://en.wikipedia.org/wiki/Stereo_imaging).
		 *
		 *  @extends {Tone}
		 *  @constructor
		 */
	    Tone.Mono = function () {
	        this.createInsOuts(1, 0);
	        /**
			 *  merge the signal
			 *  @type {Tone.Merge}
			 *  @private
			 */
	        this._merge = this.output = new Tone.Merge();
	        this.input.connect(this._merge, 0, 0);
	        this.input.connect(this._merge, 0, 1);
	        this.input.gain.value = this.dbToGain(-10);
	    };
	    Tone.extend(Tone.Mono);
	    /**
		 *  clean up
		 *  @returns {Tone.Mono} this
		 */
	    Tone.Mono.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._merge.dispose();
	        this._merge = null;
	        return this;
	    };
	    return Tone.Mono;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class A compressor with seperate controls over low/mid/high dynamics
		 *
		 *  @extends {Tone}
		 *  @constructor
		 *  @param {Object} options The low/mid/high compressor settings.
		 *  @example
		 *  var multiband = new Tone.MultibandCompressor({
		 *  	"lowFrequency" : 200,
		 *  	"highFrequency" : 1300
		 *  	"low" : {
		 *  		"threshold" : -12
		 *  	}
		 *  })
		 */
	    Tone.MultibandCompressor = function (options) {
	        options = this.defaultArg(arguments, Tone.MultibandCompressor.defaults);
	        /**
			 *  split the incoming signal into high/mid/low
			 *  @type {Tone.MultibandSplit}
			 *  @private
			 */
	        this._splitter = this.input = new Tone.MultibandSplit({
	            'lowFrequency': options.lowFrequency,
	            'highFrequency': options.highFrequency
	        });
	        /**
			 *  low/mid crossover frequency.
			 *  @type {Frequency}
			 *  @signal
			 */
	        this.lowFrequency = this._splitter.lowFrequency;
	        /**
			 *  mid/high crossover frequency.
			 *  @type {Frequency}
			 *  @signal
			 */
	        this.highFrequency = this._splitter.highFrequency;
	        /**
			 *  the output
			 *  @type {Tone.Gain}
			 *  @private
			 */
	        this.output = new Tone.Gain();
	        /**
			 *  The compressor applied to the low frequencies.
			 *  @type {Tone.Compressor}
			 */
	        this.low = new Tone.Compressor(options.low);
	        /**
			 *  The compressor applied to the mid frequencies.
			 *  @type {Tone.Compressor}
			 */
	        this.mid = new Tone.Compressor(options.mid);
	        /**
			 *  The compressor applied to the high frequencies.
			 *  @type {Tone.Compressor}
			 */
	        this.high = new Tone.Compressor(options.high);
	        //connect the compressor
	        this._splitter.low.chain(this.low, this.output);
	        this._splitter.mid.chain(this.mid, this.output);
	        this._splitter.high.chain(this.high, this.output);
	        this._readOnly([
	            'high',
	            'mid',
	            'low',
	            'highFrequency',
	            'lowFrequency'
	        ]);
	    };
	    Tone.extend(Tone.MultibandCompressor);
	    /**
		 *  @const
		 *  @static
		 *  @type {Object}
		 */
	    Tone.MultibandCompressor.defaults = {
	        'low': Tone.Compressor.defaults,
	        'mid': Tone.Compressor.defaults,
	        'high': Tone.Compressor.defaults,
	        'lowFrequency': 250,
	        'highFrequency': 2000
	    };
	    /**
		 *  clean up
		 *  @returns {Tone.MultibandCompressor} this
		 */
	    Tone.MultibandCompressor.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._splitter.dispose();
	        this._writable([
	            'high',
	            'mid',
	            'low',
	            'highFrequency',
	            'lowFrequency'
	        ]);
	        this.low.dispose();
	        this.mid.dispose();
	        this.high.dispose();
	        this._splitter = null;
	        this.low = null;
	        this.mid = null;
	        this.high = null;
	        this.lowFrequency = null;
	        this.highFrequency = null;
	        return this;
	    };
	    return Tone.MultibandCompressor;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  Tone.Panner is an equal power Left/Right Panner and does not
		 *          support 3D. Panner uses the StereoPannerNode when available. 
		 *  
		 *  @constructor
		 *  @extends {Tone}
		 *  @param {NormalRange} [initialPan=0] The initail panner value (defaults to 0 = center)
		 *  @example
		 *  //pan the input signal hard right. 
		 *  var panner = new Tone.Panner(1);
		 */
	    Tone.Panner = function (initialPan) {
	        if (this._hasStereoPanner) {
	            /**
				 *  the panner node
				 *  @type {StereoPannerNode}
				 *  @private
				 */
	            this._panner = this.input = this.output = this.context.createStereoPanner();
	            /**
				 *  The pan control. -1 = hard left, 1 = hard right. 
				 *  @type {NormalRange}
				 *  @signal
				 */
	            this.pan = this._panner.pan;
	        } else {
	            /**
				 *  the dry/wet knob
				 *  @type {Tone.CrossFade}
				 *  @private
				 */
	            this._crossFade = new Tone.CrossFade();
	            /**
				 *  @type {Tone.Merge}
				 *  @private
				 */
	            this._merger = this.output = new Tone.Merge();
	            /**
				 *  @type {Tone.Split}
				 *  @private
				 */
	            this._splitter = this.input = new Tone.Split();
	            /**
				 *  The pan control. -1 = hard left, 1 = hard right. 
				 *  @type {AudioRange}
				 *  @signal
				 */
	            this.pan = new Tone.Signal(0, Tone.Type.AudioRange);
	            /**
				 *  always sends 0
				 *  @type {Tone.Zero}
				 *  @private
				 */
	            this._zero = new Tone.Zero();
	            /**
				 *  The analog to gain conversion
				 *  @type  {Tone.AudioToGain}
				 *  @private
				 */
	            this._a2g = new Tone.AudioToGain();
	            //CONNECTIONS:
	            this._zero.connect(this._a2g);
	            this.pan.chain(this._a2g, this._crossFade.fade);
	            //left channel is a, right channel is b
	            this._splitter.connect(this._crossFade, 0, 0);
	            this._splitter.connect(this._crossFade, 1, 1);
	            //merge it back together
	            this._crossFade.a.connect(this._merger, 0, 0);
	            this._crossFade.b.connect(this._merger, 0, 1);
	        }
	        //initial value
	        this.pan.value = this.defaultArg(initialPan, 0);
	        this._readOnly('pan');
	    };
	    Tone.extend(Tone.Panner);
	    /**
		 *  indicates if the panner is using the new StereoPannerNode internally
		 *  @type  {boolean}
		 *  @private
		 */
	    Tone.Panner.prototype._hasStereoPanner = Tone.prototype.isFunction(Tone.context.createStereoPanner);
	    /**
		 *  Clean up.
		 *  @returns {Tone.Panner} this
		 */
	    Tone.Panner.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._writable('pan');
	        if (this._hasStereoPanner) {
	            this._panner.disconnect();
	            this._panner = null;
	            this.pan = null;
	        } else {
	            this._zero.dispose();
	            this._zero = null;
	            this._crossFade.dispose();
	            this._crossFade = null;
	            this._splitter.dispose();
	            this._splitter = null;
	            this._merger.dispose();
	            this._merger = null;
	            this.pan.dispose();
	            this.pan = null;
	            this._a2g.dispose();
	            this._a2g = null;
	        }
	        return this;
	    };
	    return Tone.Panner;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  A spatialized panner node which supports equalpower or HRTF panning.
		 *          Tries to normalize the API across various browsers. See Tone.Listener
		 *  
		 *  @constructor
		 *  @extends {Tone}
		 *  @param {Number} positionX The initial x position.
		 *  @param {Number} positionY The initial y position.
		 *  @param {Number} positionZ The initial z position.
		 */
	    Tone.Panner3D = function () {
	        var options = this.optionsObject(arguments, [
	            'positionX',
	            'positionY',
	            'positionZ'
	        ], Tone.Panner3D.defaults);
	        /**
			 *  The panner node
			 *  @type {PannerNode}
			 *  @private
			 */
	        this._panner = this.input = this.output = this.context.createPanner();
	        //set some values
	        this._panner.panningModel = options.panningModel;
	        this._panner.maxDistance = options.maxDistance;
	        this._panner.distanceModel = options.distanceModel;
	        this._panner.coneOuterGain = options.coneOuterGain;
	        this._panner.coneOuterAngle = options.coneOuterAngle;
	        this._panner.coneInnerAngle = options.coneInnerAngle;
	        this._panner.refDistance = options.refDistance;
	        this._panner.rolloffFactor = options.rolloffFactor;
	        /**
			 *  Holds the current orientation
			 *  @type  {Array}
			 *  @private
			 */
	        this._orientation = [
	            options.orientationX,
	            options.orientationY,
	            options.orientationZ
	        ];
	        /**
			 *  Holds the current position
			 *  @type  {Array}
			 *  @private
			 */
	        this._position = [
	            options.positionX,
	            options.positionY,
	            options.positionZ
	        ];
	        // set the default position/orientation
	        this.orientationX = options.orientationX;
	        this.orientationY = options.orientationY;
	        this.orientationZ = options.orientationZ;
	        this.positionX = options.positionX;
	        this.positionY = options.positionY;
	        this.positionZ = options.positionZ;
	    };
	    Tone.extend(Tone.Panner3D);
	    /**
		 *  the default parameters
		 *  @static
		 *  @const
		 *  @type {Object}
		 *  Defaults according to the specification
		 */
	    Tone.Panner3D.defaults = {
	        'positionX': 0,
	        'positionY': 0,
	        'positionZ': 0,
	        'orientationX': 0,
	        'orientationY': 0,
	        'orientationZ': 0,
	        'panningModel': 'equalpower',
	        'maxDistance': 10000,
	        'distanceModel': 'inverse',
	        'coneOuterGain': 0,
	        'coneOuterAngle': 360,
	        'coneInnerAngle': 360,
	        'refDistance': 1,
	        'rolloffFactor': 1
	    };
	    /**
		 * The ramp time which is applied to the setTargetAtTime
		 * @type {Number}
		 * @private
		 */
	    Tone.Panner3D.prototype._rampTimeConstant = 0.01;
	    /**
		 *  Sets the position of the source in 3d space.	
		 *  @param  {Number}  x
		 *  @param  {Number}  y
		 *  @param  {Number}  z
		 *  @return {Tone.Panner3D} this
		 */
	    Tone.Panner3D.prototype.setPosition = function (x, y, z) {
	        if (this._panner.positionX) {
	            var now = this.now();
	            this._panner.positionX.setTargetAtTime(x, now, this._rampTimeConstant);
	            this._panner.positionY.setTargetAtTime(y, now, this._rampTimeConstant);
	            this._panner.positionZ.setTargetAtTime(z, now, this._rampTimeConstant);
	        } else {
	            this._panner.setPosition(x, y, z);
	        }
	        this._position = Array.prototype.slice.call(arguments);
	        return this;
	    };
	    /**
		 *  Sets the orientation of the source in 3d space.	
		 *  @param  {Number}  x
		 *  @param  {Number}  y
		 *  @param  {Number}  z
		 *  @return {Tone.Panner3D} this
		 */
	    Tone.Panner3D.prototype.setOrientation = function (x, y, z) {
	        if (this._panner.orientationX) {
	            var now = this.now();
	            this._panner.orientationX.setTargetAtTime(x, now, this._rampTimeConstant);
	            this._panner.orientationY.setTargetAtTime(y, now, this._rampTimeConstant);
	            this._panner.orientationZ.setTargetAtTime(z, now, this._rampTimeConstant);
	        } else {
	            this._panner.setOrientation(x, y, z);
	        }
	        this._orientation = Array.prototype.slice.call(arguments);
	        return this;
	    };
	    /**
		 *  The x position of the panner object.
		 *  @type {Number}
		 *  @memberOf Tone.Panner3D#
		 *  @name positionX
		 */
	    Object.defineProperty(Tone.Panner3D.prototype, 'positionX', {
	        set: function (pos) {
	            this._position[0] = pos;
	            this.setPosition.apply(this, this._position);
	        },
	        get: function () {
	            return this._position[0];
	        }
	    });
	    /**
		 *  The y position of the panner object.
		 *  @type {Number}
		 *  @memberOf Tone.Panner3D#
		 *  @name positionY
		 */
	    Object.defineProperty(Tone.Panner3D.prototype, 'positionY', {
	        set: function (pos) {
	            this._position[1] = pos;
	            this.setPosition.apply(this, this._position);
	        },
	        get: function () {
	            return this._position[1];
	        }
	    });
	    /**
		 *  The z position of the panner object.
		 *  @type {Number}
		 *  @memberOf Tone.Panner3D#
		 *  @name positionZ
		 */
	    Object.defineProperty(Tone.Panner3D.prototype, 'positionZ', {
	        set: function (pos) {
	            this._position[2] = pos;
	            this.setPosition.apply(this, this._position);
	        },
	        get: function () {
	            return this._position[2];
	        }
	    });
	    /**
		 *  The x orientation of the panner object.
		 *  @type {Number}
		 *  @memberOf Tone.Panner3D#
		 *  @name orientationX
		 */
	    Object.defineProperty(Tone.Panner3D.prototype, 'orientationX', {
	        set: function (pos) {
	            this._orientation[0] = pos;
	            this.setOrientation.apply(this, this._orientation);
	        },
	        get: function () {
	            return this._orientation[0];
	        }
	    });
	    /**
		 *  The y orientation of the panner object.
		 *  @type {Number}
		 *  @memberOf Tone.Panner3D#
		 *  @name orientationY
		 */
	    Object.defineProperty(Tone.Panner3D.prototype, 'orientationY', {
	        set: function (pos) {
	            this._orientation[1] = pos;
	            this.setOrientation.apply(this, this._orientation);
	        },
	        get: function () {
	            return this._orientation[1];
	        }
	    });
	    /**
		 *  The z orientation of the panner object.
		 *  @type {Number}
		 *  @memberOf Tone.Panner3D#
		 *  @name orientationZ
		 */
	    Object.defineProperty(Tone.Panner3D.prototype, 'orientationZ', {
	        set: function (pos) {
	            this._orientation[2] = pos;
	            this.setOrientation.apply(this, this._orientation);
	        },
	        get: function () {
	            return this._orientation[2];
	        }
	    });
	    /**
		 *  Proxy a property on the panner to an exposed public propery
		 *  @param  {String}  prop
		 *  @private
		 */
	    Tone.Panner3D._aliasProperty = function (prop) {
	        Object.defineProperty(Tone.Panner3D.prototype, prop, {
	            set: function (val) {
	                this._panner[prop] = val;
	            },
	            get: function () {
	                return this._panner[prop];
	            }
	        });
	    };
	    /**
		 *  The panning model. Either "equalpower" or "HRTF".
		 *  @type {String}
		 *  @memberOf Tone.Panner3D#
		 *  @name panningModel
		 */
	    Tone.Panner3D._aliasProperty('panningModel');
	    /**
		 *  A reference distance for reducing volume as source move further from the listener
		 *  @type {Number}
		 *  @memberOf Tone.Panner3D#
		 *  @name refDistance
		 */
	    Tone.Panner3D._aliasProperty('refDistance');
	    /**
		 *  Describes how quickly the volume is reduced as source moves away from listener.
		 *  @type {Number}
		 *  @memberOf Tone.Panner3D#
		 *  @name rolloffFactor
		 */
	    Tone.Panner3D._aliasProperty('rolloffFactor');
	    /**
		 *  The distance model used by,  "linear", "inverse", or "exponential".
		 *  @type {String}
		 *  @memberOf Tone.Panner3D#
		 *  @name distanceModel
		 */
	    Tone.Panner3D._aliasProperty('distanceModel');
	    /**
		 *  The angle, in degrees, inside of which there will be no volume reduction
		 *  @type {Degrees}
		 *  @memberOf Tone.Panner3D#
		 *  @name coneInnerAngle
		 */
	    Tone.Panner3D._aliasProperty('coneInnerAngle');
	    /**
		 *  The angle, in degrees, outside of which the volume will be reduced 
		 *  to a constant value of coneOuterGain
		 *  @type {Degrees}
		 *  @memberOf Tone.Panner3D#
		 *  @name coneOuterAngle
		 */
	    Tone.Panner3D._aliasProperty('coneOuterAngle');
	    /**
		 *  The gain outside of the coneOuterAngle
		 *  @type {Gain}
		 *  @memberOf Tone.Panner3D#
		 *  @name coneOuterGain
		 */
	    Tone.Panner3D._aliasProperty('coneOuterGain');
	    /**
		 *  The maximum distance between source and listener, 
		 *  after which the volume will not be reduced any further.
		 *  @type {Positive}
		 *  @memberOf Tone.Panner3D#
		 *  @name maxDistance
		 */
	    Tone.Panner3D._aliasProperty('maxDistance');
	    /**
		 *  Clean up.
		 *  @returns {Tone.Panner3D} this
		 */
	    Tone.Panner3D.prototype.dispose = function () {
	        this._panner.disconnect();
	        this._panner = null;
	        this._orientation = null;
	        this._position = null;
	        return this;
	    };
	    return Tone.Panner3D;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Tone.PanVol is a Tone.Panner and Tone.Volume in one.
		 *
		 *  @extends {Tone}
		 *  @constructor
		 *  @param {AudioRange} pan the initial pan
		 *  @param {number} volume The output volume. 
		 *  @example
		 * //pan the incoming signal left and drop the volume
		 * var panVol = new Tone.PanVol(0.25, -12);
		 */
	    Tone.PanVol = function () {
	        var options = this.optionsObject(arguments, [
	            'pan',
	            'volume'
	        ], Tone.PanVol.defaults);
	        /**
			 *  The panning node
			 *  @type {Tone.Panner}
			 *  @private
			 */
	        this._panner = this.input = new Tone.Panner(options.pan);
	        /**
			 *  The L/R panning control.
			 *  @type {AudioRange}
			 *  @signal
			 */
	        this.pan = this._panner.pan;
	        /**
			 *  The volume node
			 *  @type {Tone.Volume}
			 */
	        this._volume = this.output = new Tone.Volume(options.volume);
	        /**
			 *  The volume control in decibels. 
			 *  @type {Decibels}
			 *  @signal
			 */
	        this.volume = this._volume.volume;
	        //connections
	        this._panner.connect(this._volume);
	        this._readOnly([
	            'pan',
	            'volume'
	        ]);
	    };
	    Tone.extend(Tone.PanVol);
	    /**
		 *  The defaults
		 *  @type  {Object}
		 *  @const
		 *  @static
		 */
	    Tone.PanVol.defaults = {
	        'pan': 0.5,
	        'volume': 0
	    };
	    /**
		 *  clean up
		 *  @returns {Tone.PanVol} this
		 */
	    Tone.PanVol.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._writable([
	            'pan',
	            'volume'
	        ]);
	        this._panner.dispose();
	        this._panner = null;
	        this.pan = null;
	        this._volume.dispose();
	        this._volume = null;
	        this.volume = null;
	        return this;
	    };
	    return Tone.PanVol;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Tone.CtrlInterpolate will interpolate between given values based
		 *         on the "index" property. Passing in an array or object literal
		 *         will interpolate each of the parameters. Note (i.e. "C3")
		 *         and Time (i.e. "4n + 2") can be interpolated. All other values are
		 *         assumed to be numbers. 
		 *  @example
		 * var interp = new Tone.CtrlInterpolate([0, 2, 9, 4]);
		 * interp.index = 0.75;
		 * interp.value; //returns 1.5
		 *
		 *  @example
		 * var interp = new Tone.CtrlInterpolate([
		 * 	[2, 4, 5],
		 * 	[9, 3, 2],
		 * ]);
		 * @param {Array} values The array of values to interpolate over
		 * @param {Positive} index The initial interpolation index.
		 * @extends {Tone}
		 */
	    Tone.CtrlInterpolate = function () {
	        var options = this.optionsObject(arguments, [
	            'values',
	            'index'
	        ], Tone.CtrlInterpolate.defaults);
	        /**
			 *  The values to interpolate between
			 *  @type  {Array}
			 */
	        this.values = options.values;
	        /**
			 *  The interpolated index between values. For example: a value of 1.5
			 *  would interpolate equally between the value at index 1
			 *  and the value at index 2. 
			 *  @example
			 * interp.index = 0; 
			 * interp.value; //returns the value at 0
			 * interp.index = 0.5;
			 * interp.value; //returns the value between indices 0 and 1. 
			 *  @type  {Positive}
			 */
	        this.index = options.index;
	    };
	    Tone.extend(Tone.CtrlInterpolate);
	    /**
		 *  The defaults
		 *  @const
		 *  @type  {Object}
		 */
	    Tone.CtrlInterpolate.defaults = {
	        'index': 0,
	        'values': []
	    };
	    /**
		 *  The current interpolated value based on the index
		 *  @readOnly
		 *  @memberOf Tone.CtrlInterpolate#
		 *  @type {*}
		 *  @name value
		 */
	    Object.defineProperty(Tone.CtrlInterpolate.prototype, 'value', {
	        get: function () {
	            var index = this.index;
	            index = Math.min(index, this.values.length - 1);
	            var lowerPosition = Math.floor(index);
	            var lower = this.values[lowerPosition];
	            var upper = this.values[Math.ceil(index)];
	            return this._interpolate(index - lowerPosition, lower, upper);
	        }
	    });
	    /**
		 *  Internal interpolation routine
		 *  @param  {NormalRange}  index  The index between the lower and upper
		 *  @param  {*}  lower 
		 *  @param  {*}  upper 
		 *  @return  {*}  The interpolated value
		 *  @private
		 */
	    Tone.CtrlInterpolate.prototype._interpolate = function (index, lower, upper) {
	        if (this.isArray(lower)) {
	            var retArray = [];
	            for (var i = 0; i < lower.length; i++) {
	                retArray[i] = this._interpolate(index, lower[i], upper[i]);
	            }
	            return retArray;
	        } else if (this.isObject(lower)) {
	            var retObj = {};
	            for (var attr in lower) {
	                retObj[attr] = this._interpolate(index, lower[attr], upper[attr]);
	            }
	            return retObj;
	        } else {
	            lower = this._toNumber(lower);
	            upper = this._toNumber(upper);
	            return (1 - index) * lower + index * upper;
	        }
	    };
	    /**
		 *  Convert from the given type into a number
		 *  @param  {Number|String}  value
		 *  @return  {Number}
		 *  @private
		 */
	    Tone.CtrlInterpolate.prototype._toNumber = function (val) {
	        if (this.isNumber(val)) {
	            return val;
	        } else {
	            //otherwise assume that it's Time...
	            return this.toSeconds(val);
	        }
	    };
	    /**
		 *  Clean up
		 *  @return  {Tone.CtrlInterpolate}  this
		 */
	    Tone.CtrlInterpolate.prototype.dispose = function () {
	        this.values = null;
	    };
	    return Tone.CtrlInterpolate;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Tone.CtrlMarkov represents a Markov Chain where each call
		 *         to Tone.CtrlMarkov.next will move to the next state. If the next
		 *         state choice is an array, the next state is chosen randomly with
		 *         even probability for all of the choices. For a weighted probability
		 *         of the next choices, pass in an object with "state" and "probability" attributes. 
		 *         The probabilities will be normalized and then chosen. If no next options
		 *         are given for the current state, the state will stay there. 
		 *  @extends {Tone}
		 *  @example
		 * var chain = new Tone.CtrlMarkov({
		 * 	"beginning" : ["end", "middle"],
		 * 	"middle" : "end"
		 * });
		 * chain.value = "beginning";
		 * chain.next(); //returns "end" or "middle" with 50% probability
		 *
		 *  @example
		 * var chain = new Tone.CtrlMarkov({
		 * 	"beginning" : [{"value" : "end", "probability" : 0.8}, 
		 * 					{"value" : "middle", "probability" : 0.2}],
		 * 	"middle" : "end"
		 * });
		 * chain.value = "beginning";
		 * chain.next(); //returns "end" with 80% probability or "middle" with 20%.
		 *  @param {Object} values An object with the state names as the keys
		 *                         and the next state(s) as the values. 
		 */
	    Tone.CtrlMarkov = function (values, initial) {
	        /**
			 *  The Markov values with states as the keys
			 *  and next state(s) as the values. 
			 *  @type {Object}
			 */
	        this.values = this.defaultArg(values, {});
	        /**
			 *  The current state of the Markov values. The next
			 *  state will be evaluated and returned when Tone.CtrlMarkov.next
			 *  is invoked.
			 *  @type {String}
			 */
	        this.value = this.defaultArg(initial, Object.keys(this.values)[0]);
	    };
	    Tone.extend(Tone.CtrlMarkov);
	    /**
		 *  Returns the next state of the Markov values. 
		 *  @return  {String}
		 */
	    Tone.CtrlMarkov.prototype.next = function () {
	        if (this.values.hasOwnProperty(this.value)) {
	            var next = this.values[this.value];
	            if (this.isArray(next)) {
	                var distribution = this._getProbDistribution(next);
	                var rand = Math.random();
	                var total = 0;
	                for (var i = 0; i < distribution.length; i++) {
	                    var dist = distribution[i];
	                    if (rand > total && rand < total + dist) {
	                        var chosen = next[i];
	                        if (this.isObject(chosen)) {
	                            this.value = chosen.value;
	                        } else {
	                            this.value = chosen;
	                        }
	                    }
	                    total += dist;
	                }
	            } else {
	                this.value = next;
	            }
	        }
	        return this.value;
	    };
	    /**
		 *  Choose randomly from an array weighted options in the form 
		 *  {"state" : string, "probability" : number} or an array of values
		 *  @param  {Array}  options 
		 *  @return  {Array}  The randomly selected choice
		 *  @private
		 */
	    Tone.CtrlMarkov.prototype._getProbDistribution = function (options) {
	        var distribution = [];
	        var total = 0;
	        var needsNormalizing = false;
	        for (var i = 0; i < options.length; i++) {
	            var option = options[i];
	            if (this.isObject(option)) {
	                needsNormalizing = true;
	                distribution[i] = option.probability;
	            } else {
	                distribution[i] = 1 / options.length;
	            }
	            total += distribution[i];
	        }
	        if (needsNormalizing) {
	            //normalize the values
	            for (var j = 0; j < distribution.length; j++) {
	                distribution[j] = distribution[j] / total;
	            }
	        }
	        return distribution;
	    };
	    /**
		 *  Clean up
		 *  @return  {Tone.CtrlMarkov}  this
		 */
	    Tone.CtrlMarkov.prototype.dispose = function () {
	        this.values = null;
	    };
	    return Tone.CtrlMarkov;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Generate patterns from an array of values.
		 *         Has a number of arpeggiation and randomized
		 *         selection patterns. 
		 *           <ul>
		 *  	        <li>"up" - cycles upward</li>
		 *  			<li>"down" - cycles downward</li>
		 *  			<li>"upDown" - up then and down</li>
		 *  			<li>"downUp" - cycles down then and up</li>
		 *  			<li>"alternateUp" - jump up two and down one</li>
		 *  			<li>"alternateDown" - jump down two and up one</li>
		 *  			<li>"random" - randomly select an index</li>
		 *  			<li>"randomWalk" - randomly moves one index away from the current position</li>
		 *  			<li>"randomOnce" - randomly select an index without repeating until all values have been chosen.</li>
		 *     		</ul>
		 *  @param  {Array}  values   An array of options to choose from.
		 *  @param  {Tone.CtrlPattern.Type=}  type  The name of the pattern.
		 *  @extends {Tone}
		 */
	    Tone.CtrlPattern = function () {
	        var options = this.optionsObject(arguments, [
	            'values',
	            'type'
	        ], Tone.CtrlPattern.defaults);
	        /**
			 *  The array of values to arpeggiate over
			 *  @type {Array}
			 */
	        this.values = options.values;
	        /**
			 *  The current position in the values array
			 *  @type  {Number}
			 */
	        this.index = 0;
	        /**
			 *  The type placeholder
			 *  @type {Tone.CtrlPattern.Type}
			 *  @private
			 */
	        this._type = null;
	        /**
			 *  Shuffled values for the RandomOnce type
			 *  @type {Array}
			 *  @private
			 */
	        this._shuffled = null;
	        /**
			 *  The direction of the movement
			 *  @type {String}
			 *  @private
			 */
	        this._direction = null;
	        this.type = options.type;
	    };
	    Tone.extend(Tone.CtrlPattern);
	    /**
		 *  The Control Patterns
		 *  @type  {Object}
		 *  @static
		 */
	    Tone.CtrlPattern.Type = {
	        Up: 'up',
	        Down: 'down',
	        UpDown: 'upDown',
	        DownUp: 'downUp',
	        AlternateUp: 'alternateUp',
	        AlternateDown: 'alternateDown',
	        Random: 'random',
	        RandomWalk: 'randomWalk',
	        RandomOnce: 'randomOnce'
	    };
	    /**
		 *  The default values. 
		 *  @type  {Object}
		 */
	    Tone.CtrlPattern.defaults = {
	        'type': Tone.CtrlPattern.Type.Up,
	        'values': []
	    };
	    /**
		 *  The value at the current index of the pattern.
		 *  @readOnly
		 *  @memberOf Tone.CtrlPattern#
		 *  @type {*}
		 *  @name value
		 */
	    Object.defineProperty(Tone.CtrlPattern.prototype, 'value', {
	        get: function () {
	            //some safeguards
	            if (this.values.length === 0) {
	                return;
	            } else if (this.values.length === 1) {
	                return this.values[0];
	            }
	            this.index = Math.min(this.index, this.values.length - 1);
	            var val = this.values[this.index];
	            if (this.type === Tone.CtrlPattern.Type.RandomOnce) {
	                if (this.values.length !== this._shuffled.length) {
	                    this._shuffleValues();
	                }
	                val = this.values[this._shuffled[this.index]];
	            }
	            return val;
	        }
	    });
	    /**
		 *  The pattern used to select the next
		 *  item from the values array
		 *  @memberOf Tone.CtrlPattern#
		 *  @type {Tone.CtrlPattern.Type}
		 *  @name type
		 */
	    Object.defineProperty(Tone.CtrlPattern.prototype, 'type', {
	        get: function () {
	            return this._type;
	        },
	        set: function (type) {
	            this._type = type;
	            this._shuffled = null;
	            //the first index
	            if (this._type === Tone.CtrlPattern.Type.Up || this._type === Tone.CtrlPattern.Type.UpDown || this._type === Tone.CtrlPattern.Type.RandomOnce || this._type === Tone.CtrlPattern.Type.AlternateUp) {
	                this.index = 0;
	            } else if (this._type === Tone.CtrlPattern.Type.Down || this._type === Tone.CtrlPattern.Type.DownUp || this._type === Tone.CtrlPattern.Type.AlternateDown) {
	                this.index = this.values.length - 1;
	            }
	            //the direction
	            if (this._type === Tone.CtrlPattern.Type.UpDown || this._type === Tone.CtrlPattern.Type.AlternateUp) {
	                this._direction = Tone.CtrlPattern.Type.Up;
	            } else if (this._type === Tone.CtrlPattern.Type.DownUp || this._type === Tone.CtrlPattern.Type.AlternateDown) {
	                this._direction = Tone.CtrlPattern.Type.Down;
	            }
	            //randoms
	            if (this._type === Tone.CtrlPattern.Type.RandomOnce) {
	                this._shuffleValues();
	            } else if (this._type === Tone.CtrlPattern.Random) {
	                this.index = Math.floor(Math.random() * this.values.length);
	            }
	        }
	    });
	    /**
		 *  Return the next value given the current position
		 *  and pattern.
		 *  @return {*} The next value
		 */
	    Tone.CtrlPattern.prototype.next = function () {
	        var type = this.type;
	        //choose the next index
	        if (type === Tone.CtrlPattern.Type.Up) {
	            this.index++;
	            if (this.index >= this.values.length) {
	                this.index = 0;
	            }
	        } else if (type === Tone.CtrlPattern.Type.Down) {
	            this.index--;
	            if (this.index < 0) {
	                this.index = this.values.length - 1;
	            }
	        } else if (type === Tone.CtrlPattern.Type.UpDown || type === Tone.CtrlPattern.Type.DownUp) {
	            if (this._direction === Tone.CtrlPattern.Type.Up) {
	                this.index++;
	            } else {
	                this.index--;
	            }
	            if (this.index < 0) {
	                this.index = 1;
	                this._direction = Tone.CtrlPattern.Type.Up;
	            } else if (this.index >= this.values.length) {
	                this.index = this.values.length - 2;
	                this._direction = Tone.CtrlPattern.Type.Down;
	            }
	        } else if (type === Tone.CtrlPattern.Type.Random) {
	            this.index = Math.floor(Math.random() * this.values.length);
	        } else if (type === Tone.CtrlPattern.Type.RandomWalk) {
	            if (Math.random() < 0.5) {
	                this.index--;
	                this.index = Math.max(this.index, 0);
	            } else {
	                this.index++;
	                this.index = Math.min(this.index, this.values.length - 1);
	            }
	        } else if (type === Tone.CtrlPattern.Type.RandomOnce) {
	            this.index++;
	            if (this.index >= this.values.length) {
	                this.index = 0;
	                //reshuffle the values for next time
	                this._shuffleValues();
	            }
	        } else if (type === Tone.CtrlPattern.Type.AlternateUp) {
	            if (this._direction === Tone.CtrlPattern.Type.Up) {
	                this.index += 2;
	                this._direction = Tone.CtrlPattern.Type.Down;
	            } else {
	                this.index -= 1;
	                this._direction = Tone.CtrlPattern.Type.Up;
	            }
	            if (this.index >= this.values.length) {
	                this.index = 0;
	                this._direction = Tone.CtrlPattern.Type.Up;
	            }
	        } else if (type === Tone.CtrlPattern.Type.AlternateDown) {
	            if (this._direction === Tone.CtrlPattern.Type.Up) {
	                this.index += 1;
	                this._direction = Tone.CtrlPattern.Type.Down;
	            } else {
	                this.index -= 2;
	                this._direction = Tone.CtrlPattern.Type.Up;
	            }
	            if (this.index < 0) {
	                this.index = this.values.length - 1;
	                this._direction = Tone.CtrlPattern.Type.Down;
	            }
	        }
	        return this.value;
	    };
	    /**
		 *  Shuffles the values and places the results into the _shuffled
		 *  @private
		 */
	    Tone.CtrlPattern.prototype._shuffleValues = function () {
	        var copy = [];
	        this._shuffled = [];
	        for (var i = 0; i < this.values.length; i++) {
	            copy[i] = i;
	        }
	        while (copy.length > 0) {
	            var randVal = copy.splice(Math.floor(copy.length * Math.random()), 1);
	            this._shuffled.push(randVal[0]);
	        }
	    };
	    /**
		 *  Clean up
		 *  @returns {Tone.CtrlPattern} this
		 */
	    Tone.CtrlPattern.prototype.dispose = function () {
	        this._shuffled = null;
	        this.values = null;
	    };
	    return Tone.CtrlPattern;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  Choose a random value.
		 *  @extends {Tone}
		 *  @example
		 * var randomWalk = new Tone.CtrlRandom({
		 * 	"min" : 0,
		 * 	"max" : 10,
		 * 	"integer" : true
		 * });
		 * randomWalk.eval();
		 *
		 *  @param {Number|Time=} min The minimum return value.
		 *  @param {Number|Time=} max The maximum return value.
		 */
	    Tone.CtrlRandom = function () {
	        var options = this.optionsObject(arguments, [
	            'min',
	            'max'
	        ], Tone.CtrlRandom.defaults);
	        /**
			 *  The minimum return value
			 *  @type  {Number|Time}
			 */
	        this.min = options.min;
	        /**
			 *  The maximum return value
			 *  @type  {Number|Time}
			 */
	        this.max = options.max;
	        /**
			 *  If the return value should be an integer
			 *  @type  {Boolean}
			 */
	        this.integer = options.integer;
	    };
	    Tone.extend(Tone.CtrlRandom);
	    /**
		 *  The defaults
		 *  @const
		 *  @type  {Object}
		 */
	    Tone.CtrlRandom.defaults = {
	        'min': 0,
	        'max': 1,
	        'integer': false
	    };
	    /**
		 *  Return a random value between min and max. 
		 *  @readOnly
		 *  @memberOf Tone.CtrlRandom#
		 *  @type {*}
		 *  @name value
		 */
	    Object.defineProperty(Tone.CtrlRandom.prototype, 'value', {
	        get: function () {
	            var min = this.toSeconds(this.min);
	            var max = this.toSeconds(this.max);
	            var rand = Math.random();
	            var val = rand * min + (1 - rand) * max;
	            if (this.integer) {
	                val = Math.floor(val);
	            }
	            return val;
	        }
	    });
	    return Tone.CtrlRandom;
	});
	Module(function (Tone) {
	    
	    /**
		 *  AudioBuffer.copyToChannel polyfill
		 *  @private
		 */
	    if (window.AudioBuffer && !AudioBuffer.prototype.copyToChannel) {
	        AudioBuffer.prototype.copyToChannel = function (src, chanNum, start) {
	            var channel = this.getChannelData(chanNum);
	            start = start || 0;
	            for (var i = 0; i < channel.length; i++) {
	                channel[i + start] = src[i];
	            }
	        };
	        AudioBuffer.prototype.copyFromChannel = function (dest, chanNum, start) {
	            var channel = this.getChannelData(chanNum);
	            start = start || 0;
	            for (var i = 0; i < channel.length; i++) {
	                dest[i] = channel[i + start];
	            }
	        };
	    }
	    /**
		 *  @class  Buffer loading and storage. Tone.Buffer is used internally by all 
		 *          classes that make requests for audio files such as Tone.Player,
		 *          Tone.Sampler and Tone.Convolver.
		 *          <br><br>
		 *          Aside from load callbacks from individual buffers, Tone.Buffer 
		 *  		provides static methods which keep track of the loading progress 
		 *  		of all of the buffers. These methods are Tone.Buffer.on("load" / "progress" / "error")
		 *
		 *  @constructor 
		 *  @extends {Tone}
		 *  @param {AudioBuffer|string} url The url to load, or the audio buffer to set. 
		 *  @param {Function=} onload A callback which is invoked after the buffer is loaded. 
		 *                            It's recommended to use Tone.Buffer.onload instead 
		 *                            since it will give you a callback when ALL buffers are loaded.
		 *  @param {Function=} onerror The callback to invoke if there is an error
		 *  @example
		 * var buffer = new Tone.Buffer("path/to/sound.mp3", function(){
		 * 	//the buffer is now available.
		 * 	var buff = buffer.get();
		 * });
		 */
	    Tone.Buffer = function () {
	        var options = this.optionsObject(arguments, [
	            'url',
	            'onload',
	            'onerror'
	        ], Tone.Buffer.defaults);
	        /**
			 *  stores the loaded AudioBuffer
			 *  @type {AudioBuffer}
			 *  @private
			 */
	        this._buffer = null;
	        /**
			 *  indicates if the buffer should be reversed or not
			 *  @type {Boolean}
			 *  @private
			 */
	        this._reversed = options.reverse;
	        /**
			 *  The XHR
			 *  @type  {XMLHttpRequest}
			 *  @private
			 */
	        this._xhr = null;
	        if (options.url instanceof AudioBuffer || options.url instanceof Tone.Buffer) {
	            this.set(options.url);
	            // invoke the onload callback
	            if (options.onload) {
	                options.onload(this);
	            }
	        } else if (this.isString(options.url)) {
	            this.load(options.url, options.onload, options.onerror);
	        }
	    };
	    Tone.extend(Tone.Buffer);
	    /**
		 *  the default parameters
		 *  @type {Object}
		 */
	    Tone.Buffer.defaults = {
	        'url': undefined,
	        'reverse': false
	    };
	    /**
		 *  Pass in an AudioBuffer or Tone.Buffer to set the value
		 *  of this buffer.
		 *  @param {AudioBuffer|Tone.Buffer} buffer the buffer
		 *  @returns {Tone.Buffer} this
		 */
	    Tone.Buffer.prototype.set = function (buffer) {
	        if (buffer instanceof Tone.Buffer) {
	            this._buffer = buffer.get();
	        } else {
	            this._buffer = buffer;
	        }
	        return this;
	    };
	    /**
		 *  @return {AudioBuffer} The audio buffer stored in the object.
		 */
	    Tone.Buffer.prototype.get = function () {
	        return this._buffer;
	    };
	    /**
		 *  Makes an xhr reqest for the selected url then decodes
		 *  the file as an audio buffer. Invokes
		 *  the callback once the audio buffer loads.
		 *  @param {String} url The url of the buffer to load.
		 *                      filetype support depends on the
		 *                      browser.
		 *  @returns {Promise} returns a Promise which resolves with the Tone.Buffer
		 */
	    Tone.Buffer.prototype.load = function (url, onload, onerror) {
	        var promise = new Promise(function (load, error) {
	            this._xhr = Tone.Buffer.load(url, //success
	            function (buff) {
	                this._xhr = null;
	                this.set(buff);
	                load(this);
	                if (onload) {
	                    onload(this);
	                }
	            }.bind(this), //error
	            function (err) {
	                this._xhr = null;
	                error(err);
	                if (onerror) {
	                    onerror(err);
	                }
	            }.bind(this));
	        }.bind(this));
	        return promise;
	    };
	    /**
		 *  dispose and disconnect
		 *  @returns {Tone.Buffer} this
		 */
	    Tone.Buffer.prototype.dispose = function () {
	        Tone.Emitter.prototype.dispose.call(this);
	        this._buffer = null;
	        if (this._xhr) {
	            Tone.Buffer._currentDownloads--;
	            this._xhr.abort();
	            this._xhr = null;
	        }
	        return this;
	    };
	    /**
		 * If the buffer is loaded or not
		 * @memberOf Tone.Buffer#
		 * @type {Boolean}
		 * @name loaded
		 * @readOnly
		 */
	    Object.defineProperty(Tone.Buffer.prototype, 'loaded', {
	        get: function () {
	            return this.length > 0;
	        }
	    });
	    /**
		 * The duration of the buffer. 
		 * @memberOf Tone.Buffer#
		 * @type {Number}
		 * @name duration
		 * @readOnly
		 */
	    Object.defineProperty(Tone.Buffer.prototype, 'duration', {
	        get: function () {
	            if (this._buffer) {
	                return this._buffer.duration;
	            } else {
	                return 0;
	            }
	        }
	    });
	    /**
		 * The length of the buffer in samples
		 * @memberOf Tone.Buffer#
		 * @type {Number}
		 * @name length
		 * @readOnly
		 */
	    Object.defineProperty(Tone.Buffer.prototype, 'length', {
	        get: function () {
	            if (this._buffer) {
	                return this._buffer.length;
	            } else {
	                return 0;
	            }
	        }
	    });
	    /**
		 * The number of discrete audio channels. Returns 0 if no buffer
		 * is loaded.
		 * @memberOf Tone.Buffer#
		 * @type {Number}
		 * @name numberOfChannels
		 * @readOnly
		 */
	    Object.defineProperty(Tone.Buffer.prototype, 'numberOfChannels', {
	        get: function () {
	            if (this._buffer) {
	                return this._buffer.numberOfChannels;
	            } else {
	                return 0;
	            }
	        }
	    });
	    /**
		 *  Set the audio buffer from the array
		 *  @param {Float32Array} array The array to fill the audio buffer
		 *  @param {Number} [channels=1] The number of channels contained in the array. 
		 *                               If the channel is more than 1, the input array
		 *                               is expected to be a multidimensional array
		 *                               with dimensions equal to the number of channels.
		 *  @return {Tone.Buffer} this
		 */
	    Tone.Buffer.prototype.fromArray = function (array) {
	        var isMultidimensional = array[0].length > 0;
	        var channels = isMultidimensional ? array.length : 1;
	        var len = isMultidimensional ? array[0].length : array.length;
	        var buffer = this.context.createBuffer(channels, len, this.context.sampleRate);
	        if (!isMultidimensional && channels === 1) {
	            array = [array];
	        }
	        for (var c = 0; c < channels; c++) {
	            buffer.copyToChannel(array[c], c);
	        }
	        this._buffer = buffer;
	        return this;
	    };
	    /**
		 * 	Sums muliple channels into 1 channel
		 *  @param {Number=} channel Optionally only copy a single channel from the array.
		 *  @return {Array}
		 */
	    Tone.Buffer.prototype.toMono = function (chanNum) {
	        if (this.isNumber(chanNum)) {
	            this.fromArray(this.toArray(chanNum));
	        } else {
	            var outputArray = new Float32Array(this.length);
	            var numChannels = this.numberOfChannels;
	            for (var channel = 0; channel < numChannels; channel++) {
	                var channelArray = this.toArray(channel);
	                for (var i = 0; i < channelArray.length; i++) {
	                    outputArray[i] += channelArray[i];
	                }
	            }
	            //divide by the number of channels
	            outputArray = outputArray.map(function (sample) {
	                return sample / numChannels;
	            });
	            this.fromArray(outputArray);
	        }
	        return this;
	    };
	    /**
		 * 	Get the buffer as an array. Single channel buffers will return a 1-dimensional 
		 * 	Float32Array, and multichannel buffers will return multidimensional arrays.
		 *  @param {Number=} channel Optionally only copy a single channel from the array.
		 *  @return {Array}
		 */
	    Tone.Buffer.prototype.toArray = function (channel) {
	        if (this.isNumber(channel)) {
	            return this.getChannelData(channel);
	        } else if (this.numberOfChannels === 1) {
	            return this.toArray(0);
	        } else {
	            var ret = [];
	            for (var c = 0; c < this.numberOfChannels; c++) {
	                ret[c] = this.getChannelData(c);
	            }
	            return ret;
	        }
	    };
	    /**
		 *  Returns the Float32Array representing the PCM audio data for the specific channel.
		 *  @param  {Number}  channel  The channel number to return
		 *  @return  {Float32Array}  The audio as a TypedArray
		 */
	    Tone.Buffer.prototype.getChannelData = function (channel) {
	        return this._buffer.getChannelData(channel);
	    };
	    /**
		 *  Cut a subsection of the array and return a buffer of the
		 *  subsection. Does not modify the original buffer
		 *  @param {Time} start The time to start the slice
		 *  @param {Time=} end The end time to slice. If none is given
		 *                     will default to the end of the buffer
		 *  @return {Tone.Buffer} this
		 */
	    Tone.Buffer.prototype.slice = function (start, end) {
	        end = this.defaultArg(end, this.duration);
	        var startSamples = Math.floor(this.context.sampleRate * this.toSeconds(start));
	        var endSamples = Math.floor(this.context.sampleRate * this.toSeconds(end));
	        var replacement = [];
	        for (var i = 0; i < this.numberOfChannels; i++) {
	            replacement[i] = this.toArray(i).slice(startSamples, endSamples);
	        }
	        var retBuffer = new Tone.Buffer().fromArray(replacement);
	        return retBuffer;
	    };
	    /**
		 *  Reverse the buffer.
		 *  @private
		 *  @return {Tone.Buffer} this
		 */
	    Tone.Buffer.prototype._reverse = function () {
	        if (this.loaded) {
	            for (var i = 0; i < this.numberOfChannels; i++) {
	                Array.prototype.reverse.call(this.getChannelData(i));
	            }
	        }
	        return this;
	    };
	    /**
		 * Reverse the buffer.
		 * @memberOf Tone.Buffer#
		 * @type {Boolean}
		 * @name reverse
		 */
	    Object.defineProperty(Tone.Buffer.prototype, 'reverse', {
	        get: function () {
	            return this._reversed;
	        },
	        set: function (rev) {
	            if (this._reversed !== rev) {
	                this._reversed = rev;
	                this._reverse();
	            }
	        }
	    });
	    ///////////////////////////////////////////////////////////////////////////
	    // STATIC METHODS
	    ///////////////////////////////////////////////////////////////////////////
	    //statically inherits Emitter methods
	    Tone.Emitter.mixin(Tone.Buffer);
	    /**
		 *  the static queue for all of the xhr requests
		 *  @type {Array}
		 *  @private
		 */
	    Tone.Buffer._downloadQueue = [];
	    /**
		 *  the total number of downloads
		 *  @type {Number}
		 *  @private
		 */
	    Tone.Buffer._currentDownloads = 0;
	    /**
		 *  A path which is prefixed before every url.
		 *  @type  {String}
		 *  @static
		 */
	    Tone.Buffer.baseUrl = '';
	    /**
		 *  Loads a url using XMLHttpRequest.
		 *  @param {String} url
		 *  @param {Function} onload
		 *  @param {Function} onerror
		 *  @param {Function} onprogress
		 *  @return {XMLHttpRequest}
		 */
	    Tone.Buffer.load = function (url, onload, onerror) {
	        //default
	        onload = onload || Tone.noOp;
	        function onError(e) {
	            if (onerror) {
	                onerror(e);
	                Tone.Buffer.emit('error', e);
	            } else {
	                throw new Error(e);
	            }
	        }
	        function onProgress() {
	            //calculate the progress
	            var totalProgress = 0;
	            for (var i = 0; i < Tone.Buffer._downloadQueue.length; i++) {
	                totalProgress += Tone.Buffer._downloadQueue[i].progress;
	            }
	            Tone.Buffer.emit('progress', totalProgress / Tone.Buffer._downloadQueue.length);
	        }
	        var request = new XMLHttpRequest();
	        request.open('GET', Tone.Buffer.baseUrl + url, true);
	        request.responseType = 'arraybuffer';
	        //start out as 0
	        request.progress = 0;
	        Tone.Buffer._currentDownloads++;
	        Tone.Buffer._downloadQueue.push(request);
	        request.addEventListener('load', function () {
	            if (request.status === 200) {
	                Tone.context.decodeAudioData(request.response, function (buff) {
	                    request.progress = 1;
	                    onProgress();
	                    onload(buff);
	                    Tone.Buffer._currentDownloads--;
	                    if (Tone.Buffer._currentDownloads === 0) {
	                        // clear the downloads
	                        Tone.Buffer._downloadQueue = [];
	                        //emit the event at the end
	                        Tone.Buffer.emit('load');
	                    }
	                }, function () {
	                    onError('Tone.Buffer: could not decode audio data: ' + url);
	                });
	            } else {
	                onError('Tone.Buffer: could not locate file: ' + url);
	            }
	        });
	        request.addEventListener('error', onError);
	        request.addEventListener('progress', function (event) {
	            if (event.lengthComputable) {
	                //only go to 95%, the last 5% is when the audio is decoded
	                request.progress = event.loaded / event.total * 0.95;
	                onProgress();
	            }
	        });
	        request.send();
	        return request;
	    };
	    /**
		 *  Stop all of the downloads in progress
		 *  @return {Tone.Buffer}
		 *  @static
		 */
	    Tone.Buffer.cancelDownloads = function () {
	        Tone.Buffer._downloadQueue.forEach(function (request) {
	            request.abort();
	        });
	        Tone.Buffer._currentDownloads = 0;
	        return Tone.Buffer;
	    };
	    /**
		 *  Checks a url's extension to see if the current browser can play that file type.
		 *  @param {String} url The url/extension to test
		 *  @return {Boolean} If the file extension can be played
		 *  @static
		 *  @example
		 * Tone.Buffer.supportsType("wav"); //returns true
		 * Tone.Buffer.supportsType("path/to/file.wav"); //returns true
		 */
	    Tone.Buffer.supportsType = function (url) {
	        var extension = url.split('.');
	        extension = extension[extension.length - 1];
	        var response = document.createElement('audio').canPlayType('audio/' + extension);
	        return response !== '';
	    };
	    /**
		 *  Returns a Promise which resolves when all of the buffers have loaded
		 *  @return {Promise}
		 */
	    Tone.loaded = function () {
	        var onload, onerror;
	        function removeEvents() {
	            //remove the events when it's resolved
	            Tone.Buffer.off('load', onload);
	            Tone.Buffer.off('error', onerror);
	        }
	        return new Promise(function (success, fail) {
	            onload = function () {
	                success();
	            };
	            onerror = function () {
	                fail();
	            };
	            //add the event listeners
	            Tone.Buffer.on('load', onload);
	            Tone.Buffer.on('error', onerror);
	        }).then(removeEvents).catch(function (e) {
	            removeEvents();
	            throw new Error(e);
	        });
	    };
	    return Tone.Buffer;
	});
	Module(function (Tone) {
	    /**
		 *  @class A data structure for holding multiple buffers.
		 *  
		 *  @param  {Object|Array}    urls      An object literal or array
		 *                                      of urls to load.
		 *  @param  {Function=}  callback  The callback to invoke when
		 *                                 the buffers are loaded. 
		 *  @extends {Tone}
		 *  @example
		 * //load a whole bank of piano samples
		 * var pianoSamples = new Tone.Buffers({
		 * 	"C4" : "path/to/C4.mp3"
		 * 	"C#4" : "path/to/C#4.mp3"
		 * 	"D4" : "path/to/D4.mp3"
		 * 	"D#4" : "path/to/D#4.mp3"
		 * 	...
		 * }, function(){
		 * 	//play one of the samples when they all load
		 * 	player.buffer = pianoSamples.get("C4");
		 * 	player.start();
		 * });
		 * 
		 */
	    Tone.Buffers = function (urls, onload, baseUrl) {
	        /**
			 *  All of the buffers
			 *  @type  {Object}
			 *  @private
			 */
	        this._buffers = {};
	        /**
			 *  A path which is prefixed before every url.
			 *  @type  {String}
			 */
	        this.baseUrl = this.defaultArg(baseUrl, '');
	        urls = this._flattenUrls(urls);
	        this._loadingCount = 0;
	        //add each one
	        for (var key in urls) {
	            this._loadingCount++;
	            this.add(key, urls[key], this._bufferLoaded.bind(this, onload));
	        }
	    };
	    Tone.extend(Tone.Buffers);
	    /**
		 *  True if the buffers object has a buffer by that name.
		 *  @param  {String|Number}  name  The key or index of the 
		 *                                 buffer.
		 *  @return  {Boolean}
		 */
	    Tone.Buffers.prototype.has = function (name) {
	        return this._buffers.hasOwnProperty(name);
	    };
	    /**
		 *  Get a buffer by name. If an array was loaded, 
		 *  then use the array index.
		 *  @param  {String|Number}  name  The key or index of the 
		 *                                 buffer.
		 *  @return  {Tone.Buffer}
		 */
	    Tone.Buffers.prototype.get = function (name) {
	        if (this.has(name)) {
	            return this._buffers[name];
	        } else {
	            throw new Error('Tone.Buffers: no buffer named ' + name);
	        }
	    };
	    /**
		 *  A buffer was loaded. decrement the counter.
		 *  @param  {Function}  callback 
		 *  @private
		 */
	    Tone.Buffers.prototype._bufferLoaded = function (callback) {
	        this._loadingCount--;
	        if (this._loadingCount === 0 && callback) {
	            callback(this);
	        }
	    };
	    /**
		 * If the buffers are loaded or not
		 * @memberOf Tone.Buffers#
		 * @type {Boolean}
		 * @name loaded
		 * @readOnly
		 */
	    Object.defineProperty(Tone.Buffers.prototype, 'loaded', {
	        get: function () {
	            var isLoaded = true;
	            for (var buffName in this._buffers) {
	                var buff = this.get(buffName);
	                isLoaded = isLoaded && buff.loaded;
	            }
	            return isLoaded;
	        }
	    });
	    /**
		 *  Add a buffer by name and url to the Buffers
		 *  @param  {String}    name      A unique name to give
		 *                                the buffer
		 *  @param  {String|Tone.Buffer|Audiobuffer}  url  Either the url of the bufer, 
		 *                                                 or a buffer which will be added
		 *                                                 with the given name.
		 *  @param  {Function=}  callback  The callback to invoke 
		 *                                 when the url is loaded.
		 */
	    Tone.Buffers.prototype.add = function (name, url, callback) {
	        callback = this.defaultArg(callback, Tone.noOp);
	        if (url instanceof Tone.Buffer) {
	            this._buffers[name] = url;
	            callback(this);
	        } else if (url instanceof AudioBuffer) {
	            this._buffers[name] = new Tone.Buffer(url);
	            callback(this);
	        } else if (this.isString(url)) {
	            this._buffers[name] = new Tone.Buffer(this.baseUrl + url, callback);
	        }
	        return this;
	    };
	    /**
		 *  Flatten an object into a single depth object. 
		 *  thanks to https://gist.github.com/penguinboy/762197
		 *  @param   {Object} ob 	
		 *  @return  {Object}    
		 *  @private
		 */
	    Tone.Buffers.prototype._flattenUrls = function (ob) {
	        var toReturn = {};
	        for (var i in ob) {
	            if (!ob.hasOwnProperty(i))
	                continue;
	            if (this.isObject(ob[i])) {
	                var flatObject = this._flattenUrls(ob[i]);
	                for (var x in flatObject) {
	                    if (!flatObject.hasOwnProperty(x))
	                        continue;
	                    toReturn[i + '.' + x] = flatObject[x];
	                }
	            } else {
	                toReturn[i] = ob[i];
	            }
	        }
	        return toReturn;
	    };
	    /**
		 *  Clean up.
		 *  @return  {Tone.Buffers} this
		 */
	    Tone.Buffers.prototype.dispose = function () {
	        for (var name in this._buffers) {
	            this._buffers[name].dispose();
	        }
	        this._buffers = null;
	        return this;
	    };
	    return Tone.Buffers;
	});
	Module(function (Tone) {
	    
	    /**
		 *  buses are another way of routing audio
		 *
		 *  augments Tone.prototype to include send and recieve
		 */
	    /**
		  *  All of the routes
		  *  
		  *  @type {Object}
		  *  @static
		  *  @private
		  */
	    var Buses = {};
	    /**
		 *  Send this signal to the channel name. 
		 *  @param  {string} channelName A named channel to send the signal to.
		 *  @param  {Decibels} amount The amount of the source to send to the bus. 
		 *  @return {GainNode} The gain node which connects this node to the desired channel. 
		 *                     Can be used to adjust the levels of the send.
		 *  @example
		 * source.send("reverb", -12);
		 */
	    Tone.prototype.send = function (channelName, amount) {
	        if (!Buses.hasOwnProperty(channelName)) {
	            Buses[channelName] = this.context.createGain();
	        }
	        amount = this.defaultArg(amount, 0);
	        var sendKnob = new Tone.Gain(amount, Tone.Type.Decibels);
	        this.output.chain(sendKnob, Buses[channelName]);
	        return sendKnob;
	    };
	    /**
		 *  Recieve the input from the desired channelName to the input
		 *
		 *  @param  {string} channelName A named channel to send the signal to.
		 *  @param {AudioNode} [input] If no input is selected, the
		 *                                         input of the current node is
		 *                                         chosen. 
		 *  @returns {Tone} this
		 *  @example
		 * reverbEffect.receive("reverb");
		 */
	    Tone.prototype.receive = function (channelName, input) {
	        if (!Buses.hasOwnProperty(channelName)) {
	            Buses[channelName] = this.context.createGain();
	        }
	        if (this.isUndef(input)) {
	            input = this.input;
	        }
	        Buses[channelName].connect(input);
	        return this;
	    };
	    //remove all the send/receives when a new audio context is passed in
	    Tone.Context.on('init', function (context) {
	        if (context.Buses) {
	            Buses = context.Buses;
	        } else {
	            Buses = {};
	            context.Buses = Buses;
	        }
	    });
	    return Tone;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Tone.Draw is useful for synchronizing visuals and audio events.
		 *         Callbacks from Tone.Transport or any of the Tone.Event classes
		 *         always happen _before_ the scheduled time and are not synchronized
		 *         to the animation frame so they are not good for triggering tightly
		 *         synchronized visuals and sound. Tone.Draw makes it easy to schedule
		 *         callbacks using the AudioContext time and uses requestAnimationFrame.
		 *         
		 *  @singleton
		 *  @extends {Tone}
		 *  @example
		 * Tone.Transport.schedule(function(time){
		 * 	//use the time argument to schedule a callback with Tone.Draw
		 * 	Tone.Draw.schedule(function(){
		 * 		//do drawing or DOM manipulation here
		 * 	}, time)
		 * }, "+0.5")
		 */
	    Tone.Draw = function () {
	        /**
			 *  All of the events.
			 *  @type  {Tone.Timeline}
			 *  @private
			 */
	        this._events = new Tone.Timeline();
	        /**
			 *  The duration after which events are not invoked.
			 *  @type  {Number}
			 *  @default 0.25
			 */
	        this.expiration = 0.25;
	        /**
			 *  The amount of time before the scheduled time 
			 *  that the callback can be invoked. Default is
			 *  half the time of an animation frame (0.008 seconds).
			 *  @type  {Number}
			 *  @default 0.008
			 */
	        this.anticipation = 0.008;
	        /**
			 *  The draw loop
			 *  @type  {Function}
			 *  @private
			 */
	        this._boundDrawLoop = this._drawLoop.bind(this);
	    };
	    Tone.extend(Tone.Draw);
	    /**
		 *  Schedule a function at the given time to be invoked
		 *  on the nearest animation frame.
		 *  @param  {Function}  callback  Callback is invoked at the given time.
		 *  @param  {Time}    time      The time relative to the AudioContext time
		 *                              to invoke the callback.
		 *  @return  {Tone.Draw}    this
		 */
	    Tone.Draw.prototype.schedule = function (callback, time) {
	        this._events.add({
	            callback: callback,
	            time: this.toSeconds(time)
	        });
	        //start the draw loop on the first event
	        if (this._events.length === 1) {
	            requestAnimationFrame(this._boundDrawLoop);
	        }
	        return this;
	    };
	    /**
		 *  Cancel events scheduled after the given time
		 *  @param  {Time=}  after  Time after which scheduled events will 
		 *                          be removed from the scheduling timeline.
		 *  @return  {Tone.Draw}  this
		 */
	    Tone.Draw.prototype.cancel = function (after) {
	        this._events.cancel(this.toSeconds(after));
	        return this;
	    };
	    /**
		 *  The draw loop
		 *  @private
		 */
	    Tone.Draw.prototype._drawLoop = function () {
	        var now = Tone.now();
	        while (this._events.length && this._events.peek().time - this.anticipation <= now) {
	            var event = this._events.shift();
	            if (now - event.time <= this.expiration) {
	                event.callback();
	            }
	        }
	        if (this._events.length > 0) {
	            requestAnimationFrame(this._boundDrawLoop);
	        }
	    };
	    //make a singleton
	    Tone.Draw = new Tone.Draw();
	    return Tone.Draw;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  Both Tone.Panner3D and Tone.Listener have a position in 3D space 
		 *          using a right-handed cartesian coordinate system. 
		 *          The units used in the coordinate system are not defined; 
		 *          these coordinates are independent/invariant of any particular 
		 *          units such as meters or feet. Tone.Panner3D objects have an forward 
		 *          vector representing the direction the sound is projecting. Additionally, 
		 *          they have a sound cone representing how directional the sound is. 
		 *          For example, the sound could be omnidirectional, in which case it would 
		 *          be heard anywhere regardless of its forward, or it can be more directional 
		 *          and heard only if it is facing the listener. Tone.Listener objects 
		 *          (representing a person's ears) have an forward and up vector 
		 *          representing in which direction the person is facing. Because both the 
		 *          source stream and the listener can be moving, they both have a velocity 
		 *          vector representing both the speed and direction of movement. Taken together, 
		 *          these two velocities can be used to generate a doppler shift effect which changes the pitch.
		 *          <br><br>
		 *          Note: the position of the Listener will have no effect on nodes not connected to a Tone.Panner3D
		 *  
		 *  @constructor
		 *  @extends {Tone}
		 *  @singleton
		 *  @param {Number} positionX The initial x position.
		 *  @param {Number} positionY The initial y position.
		 *  @param {Number} positionZ The initial z position.
		 */
	    Tone.Listener = function () {
	        var options = this.optionsObject(arguments, [
	            'positionX',
	            'positionY',
	            'positionZ'
	        ], ListenerConstructor.defaults);
	        /**
			 *  Holds the current forward orientation
			 *  @type  {Array}
			 *  @private
			 */
	        this._orientation = [
	            options.forwardX,
	            options.forwardY,
	            options.forwardZ,
	            options.upX,
	            options.upY,
	            options.upZ
	        ];
	        /**
			 *  Holds the current position
			 *  @type  {Array}
			 *  @private
			 */
	        this._position = [
	            options.positionX,
	            options.positionY,
	            options.positionZ
	        ];
	        // set the default position/forward
	        this.forwardX = options.forwardX;
	        this.forwardY = options.forwardY;
	        this.forwardZ = options.forwardZ;
	        this.upX = options.upX;
	        this.upY = options.upY;
	        this.upZ = options.upZ;
	        this.positionX = options.positionX;
	        this.positionY = options.positionY;
	        this.positionZ = options.positionZ;
	    };
	    Tone.extend(Tone.Listener);
	    /**
		 *  the default parameters
		 *  @static
		 *  @const
		 *  @type {Object}
		 *  Defaults according to the specification
		 */
	    Tone.Listener.defaults = {
	        'positionX': 0,
	        'positionY': 0,
	        'positionZ': 0,
	        'forwardX': 0,
	        'forwardY': 0,
	        'forwardZ': 1,
	        'upX': 0,
	        'upY': 1,
	        'upZ': 0
	    };
	    /**
		 * The ramp time which is applied to the setTargetAtTime
		 * @type {Number}
		 * @private
		 */
	    Tone.Listener.prototype._rampTimeConstant = 0.01;
	    /**
		 *  Sets the position of the listener in 3d space.	
		 *  @param  {Number}  x
		 *  @param  {Number}  y
		 *  @param  {Number}  z
		 *  @return {Tone.Listener} this
		 */
	    Tone.Listener.prototype.setPosition = function (x, y, z) {
	        if (this.context.listener.positionX) {
	            var now = this.now();
	            this.context.listener.positionX.setTargetAtTime(x, now, this._rampTimeConstant);
	            this.context.listener.positionY.setTargetAtTime(y, now, this._rampTimeConstant);
	            this.context.listener.positionZ.setTargetAtTime(z, now, this._rampTimeConstant);
	        } else {
	            this.context.listener.setPosition(x, y, z);
	        }
	        this._position = Array.prototype.slice.call(arguments);
	        return this;
	    };
	    /**
		 *  Sets the orientation of the listener using two vectors, the forward
		 *  vector (which direction the listener is facing) and the up vector 
		 *  (which the up direction of the listener). An up vector
		 *  of 0, 0, 1 is equivalent to the listener standing up in the Z direction. 
		 *  @param  {Number}  x
		 *  @param  {Number}  y
		 *  @param  {Number}  z
		 *  @param  {Number}  upX
		 *  @param  {Number}  upY
		 *  @param  {Number}  upZ
		 *  @return {Tone.Listener} this
		 */
	    Tone.Listener.prototype.setOrientation = function (x, y, z, upX, upY, upZ) {
	        if (this.context.listener.forwardX) {
	            var now = this.now();
	            this.context.listener.forwardX.setTargetAtTime(x, now, this._rampTimeConstant);
	            this.context.listener.forwardY.setTargetAtTime(y, now, this._rampTimeConstant);
	            this.context.listener.forwardZ.setTargetAtTime(z, now, this._rampTimeConstant);
	            this.context.listener.upX.setTargetAtTime(upX, now, this._rampTimeConstant);
	            this.context.listener.upY.setTargetAtTime(upY, now, this._rampTimeConstant);
	            this.context.listener.upZ.setTargetAtTime(upZ, now, this._rampTimeConstant);
	        } else {
	            this.context.listener.setOrientation(x, y, z, upX, upY, upZ);
	        }
	        this._orientation = Array.prototype.slice.call(arguments);
	        return this;
	    };
	    /**
		 *  The x position of the panner object.
		 *  @type {Number}
		 *  @memberOf Tone.Listener#
		 *  @name positionX
		 */
	    Object.defineProperty(Tone.Listener.prototype, 'positionX', {
	        set: function (pos) {
	            this._position[0] = pos;
	            this.setPosition.apply(this, this._position);
	        },
	        get: function () {
	            return this._position[0];
	        }
	    });
	    /**
		 *  The y position of the panner object.
		 *  @type {Number}
		 *  @memberOf Tone.Listener#
		 *  @name positionY
		 */
	    Object.defineProperty(Tone.Listener.prototype, 'positionY', {
	        set: function (pos) {
	            this._position[1] = pos;
	            this.setPosition.apply(this, this._position);
	        },
	        get: function () {
	            return this._position[1];
	        }
	    });
	    /**
		 *  The z position of the panner object.
		 *  @type {Number}
		 *  @memberOf Tone.Listener#
		 *  @name positionZ
		 */
	    Object.defineProperty(Tone.Listener.prototype, 'positionZ', {
	        set: function (pos) {
	            this._position[2] = pos;
	            this.setPosition.apply(this, this._position);
	        },
	        get: function () {
	            return this._position[2];
	        }
	    });
	    /**
		 *  The x coordinate of the listeners front direction. i.e. 
		 *  which way they are facing.
		 *  @type {Number}
		 *  @memberOf Tone.Listener#
		 *  @name forwardX
		 */
	    Object.defineProperty(Tone.Listener.prototype, 'forwardX', {
	        set: function (pos) {
	            this._orientation[0] = pos;
	            this.setOrientation.apply(this, this._orientation);
	        },
	        get: function () {
	            return this._orientation[0];
	        }
	    });
	    /**
		 *  The y coordinate of the listeners front direction. i.e. 
		 *  which way they are facing.
		 *  @type {Number}
		 *  @memberOf Tone.Listener#
		 *  @name forwardY
		 */
	    Object.defineProperty(Tone.Listener.prototype, 'forwardY', {
	        set: function (pos) {
	            this._orientation[1] = pos;
	            this.setOrientation.apply(this, this._orientation);
	        },
	        get: function () {
	            return this._orientation[1];
	        }
	    });
	    /**
		 *  The z coordinate of the listeners front direction. i.e. 
		 *  which way they are facing.
		 *  @type {Number}
		 *  @memberOf Tone.Listener#
		 *  @name forwardZ
		 */
	    Object.defineProperty(Tone.Listener.prototype, 'forwardZ', {
	        set: function (pos) {
	            this._orientation[2] = pos;
	            this.setOrientation.apply(this, this._orientation);
	        },
	        get: function () {
	            return this._orientation[2];
	        }
	    });
	    /**
		 *  The x coordinate of the listener's up direction. i.e.
		 *  the direction the listener is standing in.
		 *  @type {Number}
		 *  @memberOf Tone.Listener#
		 *  @name upX
		 */
	    Object.defineProperty(Tone.Listener.prototype, 'upX', {
	        set: function (pos) {
	            this._orientation[3] = pos;
	            this.setOrientation.apply(this, this._orientation);
	        },
	        get: function () {
	            return this._orientation[3];
	        }
	    });
	    /**
		 *  The y coordinate of the listener's up direction. i.e.
		 *  the direction the listener is standing in.
		 *  @type {Number}
		 *  @memberOf Tone.Listener#
		 *  @name upY
		 */
	    Object.defineProperty(Tone.Listener.prototype, 'upY', {
	        set: function (pos) {
	            this._orientation[4] = pos;
	            this.setOrientation.apply(this, this._orientation);
	        },
	        get: function () {
	            return this._orientation[4];
	        }
	    });
	    /**
		 *  The z coordinate of the listener's up direction. i.e.
		 *  the direction the listener is standing in.
		 *  @type {Number}
		 *  @memberOf Tone.Listener#
		 *  @name upZ
		 */
	    Object.defineProperty(Tone.Listener.prototype, 'upZ', {
	        set: function (pos) {
	            this._orientation[5] = pos;
	            this.setOrientation.apply(this, this._orientation);
	        },
	        get: function () {
	            return this._orientation[5];
	        }
	    });
	    /**
		 *  Clean up.
		 *  @returns {Tone.Listener} this
		 */
	    Tone.Listener.prototype.dispose = function () {
	        this._orientation = null;
	        this._position = null;
	        return this;
	    };
	    //SINGLETON SETUP
	    var ListenerConstructor = Tone.Listener;
	    Tone.Listener = new ListenerConstructor();
	    Tone.Context.on('init', function (context) {
	        if (context.Listener instanceof ListenerConstructor) {
	            //a single listener object
	            Tone.Listener = context.Listener;
	        } else {
	            //make new Listener insides
	            Tone.Listener = new ListenerConstructor();
	        }
	        context.Listener = Tone.Listener;
	    });
	    //END SINGLETON SETUP
	    return Tone.Listener;
	});
	Module(function (Tone) {
	    /**
		 *  shim
		 *  @private
		 */
	    if (!window.hasOwnProperty('OfflineAudioContext') && window.hasOwnProperty('webkitOfflineAudioContext')) {
	        window.OfflineAudioContext = window.webkitOfflineAudioContext;
	    }
	    /**
		 *  @class Wrapper around the OfflineAudioContext
		 *  @extends {Tone.Context
		 *  @param  {Number}  channels  The number of channels to render
		 *  @param  {Number}  duration  The duration to render in samples
		 *  @param {Number} sampleRate the sample rate to render at
		 */
	    Tone.OfflineContext = function (channels, duration, sampleRate) {
	        /**
			 *  The offline context
			 *  @private
			 *  @type  {OfflineAudioContext}
			 */
	        var offlineContext = new OfflineAudioContext(channels, duration * sampleRate, sampleRate);
	        //wrap the methods/members
	        Tone.Context.call(this, offlineContext);
	        /**
			 *  A private reference to the duration
			 *  @private
			 *  @type  {Number}
			 */
	        this._duration = duration;
	        /**
			 *  An artificial clock source
			 *  @type  {Number}
			 *  @private
			 */
	        this._currentTime = 0;
	        //modify the lookAhead and updateInterval to one block
	        this.lookAhead = this.blockTime;
	        this.updateInterval = this.blockTime;
	    };
	    Tone.extend(Tone.OfflineContext, Tone.Context);
	    /**
		 *  Override the now method to point to the internal clock time
		 *  @return  {Number}
		 */
	    Tone.OfflineContext.prototype.now = function () {
	        return this._currentTime;
	    };
	    /**
		 *  Overwrite this method since the worker is not necessary for the offline context
		 *  @private
		 */
	    Tone.OfflineContext.prototype._createWorker = function () {
	        //dummy worker that does nothing
	        return {
	            postMessage: function () {
	            }
	        };
	    };
	    /**
		 *  Render the output of the OfflineContext
		 *  @return  {Promise}
		 */
	    Tone.OfflineContext.prototype.render = function () {
	        while (this._duration - this._currentTime >= 0) {
	            //invoke all the callbacks on that time
	            this.emit('tick');
	            //increment the clock
	            this._currentTime += Tone.prototype.blockTime;
	        }
	        //promise returned is not yet implemented in all browsers
	        return new Promise(function (done) {
	            this._context.oncomplete = function (e) {
	                done(e.renderedBuffer);
	            };
	            this._context.startRendering();
	        }.bind(this));
	    };
	    return Tone.OfflineContext;
	});
	Module(function (Tone) {
	    /**
		 *  Generate a buffer by rendering all of the Tone.js code within the callback using the OfflineAudioContext. 
		 *  The OfflineAudioContext is capable of rendering much faster than real time in many cases. 
		 *  The callback function also passes in an offline instance of Tone.Transport which can be used
		 *  to schedule events along the Transport. 
		 *  @param  {Function}  callback  All Tone.js nodes which are created and scheduled within this callback are recorded into the output Buffer.
		 *  @param  {Time}  duration     the amount of time to record for.
		 *  @return  {Promise}  The promise which is invoked with the Tone.Buffer of the recorded output.
		 *  @example
		 * //render 2 seconds of the oscillator
		 * Tone.Offline(function(){
		 * 	//only nodes created in this callback will be recorded
		 * 	var oscillator = new Tone.Oscillator().toMaster().start(0)
		 * 	//schedule their events
		 * }, 2).then(function(buffer){
		 * 	//do something with the output buffer
		 * })
		 * @example
		 * //can also schedule events along the Transport
		 * //using the passed in Offline Transport
		 * Tone.Offline(function(Transport){
		 * 	var osc = new Tone.Oscillator().toMaster()
		 * 	Transport.schedule(function(time){
		 * 		osc.start(time).stop(time + 0.1)
		 * 	}, 1)
		 * 	Transport.start(0.2)
		 * }, 4).then(function(buffer){
		 * 	//do something with the output buffer
		 * })
		 */
	    Tone.Offline = function (callback, duration) {
	        //set the OfflineAudioContext
	        var sampleRate = Tone.context.sampleRate;
	        var originalContext = Tone.context;
	        var context = new Tone.OfflineContext(2, duration, sampleRate);
	        Tone.context = context;
	        //invoke the callback/scheduling
	        callback(Tone.Transport);
	        //process the audio
	        var rendered = context.render();
	        //return the original AudioContext
	        Tone.context = originalContext;
	        //return the audio
	        return rendered.then(function (buffer) {
	            //wrap it in a Tone.Buffer
	            return new Tone.Buffer(buffer);
	        });
	    };
	    return Tone.Offline;
	});
	Module(function (Tone) {
	    
	    /**
		 * 	@class  Tone.Effect is the base class for effects. Connect the effect between
		 * 	        the effectSend and effectReturn GainNodes, then control the amount of
		 * 	        effect which goes to the output using the wet control.
		 *
		 *  @constructor
		 *  @extends {Tone}
		 *  @param {NormalRange|Object} [wet] The starting wet value. 
		 */
	    Tone.Effect = function () {
	        this.createInsOuts(1, 1);
	        //get all of the defaults
	        var options = this.optionsObject(arguments, ['wet'], Tone.Effect.defaults);
	        /**
			 *  the drywet knob to control the amount of effect
			 *  @type {Tone.CrossFade}
			 *  @private
			 */
	        this._dryWet = new Tone.CrossFade(options.wet);
	        /**
			 *  The wet control is how much of the effected
			 *  will pass through to the output. 1 = 100% effected
			 *  signal, 0 = 100% dry signal. 
			 *  @type {NormalRange}
			 *  @signal
			 */
	        this.wet = this._dryWet.fade;
	        /**
			 *  connect the effectSend to the input of hte effect
			 *  @type {Tone.Gain}
			 *  @private
			 */
	        this.effectSend = new Tone.Gain();
	        /**
			 *  connect the output of the effect to the effectReturn
			 *  @type {Tone.Gain}
			 *  @private
			 */
	        this.effectReturn = new Tone.Gain();
	        //connections
	        this.input.connect(this._dryWet.a);
	        this.input.connect(this.effectSend);
	        this.effectReturn.connect(this._dryWet.b);
	        this._dryWet.connect(this.output);
	        this._readOnly(['wet']);
	    };
	    Tone.extend(Tone.Effect);
	    /**
		 *  @static
		 *  @type {Object}
		 */
	    Tone.Effect.defaults = { 'wet': 1 };
	    /**
		 *  chains the effect in between the effectSend and effectReturn
		 *  @param  {Tone} effect
		 *  @private
		 *  @returns {Tone.Effect} this
		 */
	    Tone.Effect.prototype.connectEffect = function (effect) {
	        this.effectSend.chain(effect, this.effectReturn);
	        return this;
	    };
	    /**
		 *  Clean up. 
		 *  @returns {Tone.Effect} this
		 */
	    Tone.Effect.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._dryWet.dispose();
	        this._dryWet = null;
	        this.effectSend.dispose();
	        this.effectSend = null;
	        this.effectReturn.dispose();
	        this.effectReturn = null;
	        this._writable(['wet']);
	        this.wet = null;
	        return this;
	    };
	    return Tone.Effect;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Tone.AutoFilter is a Tone.Filter with a Tone.LFO connected to the filter cutoff frequency.
		 *         Setting the LFO rate and depth allows for control over the filter modulation rate 
		 *         and depth.
		 *
		 *  @constructor
		 *  @extends {Tone.Effect}
		 *  @param {Time|Object} [frequency] The rate of the LFO.
		 *  @param {Frequency=} baseFrequency The lower value of the LFOs oscillation
	 	 *  @param {Frequency=} octaves The number of octaves above the baseFrequency
		 *  @example
		 * //create an autofilter and start it's LFO
		 * var autoFilter = new Tone.AutoFilter("4n").toMaster().start();
		 * //route an oscillator through the filter and start it
		 * var oscillator = new Tone.Oscillator().connect(autoFilter).start();
		 */
	    Tone.AutoFilter = function () {
	        var options = this.optionsObject(arguments, [
	            'frequency',
	            'baseFrequency',
	            'octaves'
	        ], Tone.AutoFilter.defaults);
	        Tone.Effect.call(this, options);
	        /**
			 *  the lfo which drives the filter cutoff
			 *  @type {Tone.LFO}
			 *  @private
			 */
	        this._lfo = new Tone.LFO({
	            'frequency': options.frequency,
	            'amplitude': options.depth
	        });
	        /**
			 * The range of the filter modulating between the min and max frequency. 
			 * 0 = no modulation. 1 = full modulation.
			 * @type {NormalRange}
			 * @signal
			 */
	        this.depth = this._lfo.amplitude;
	        /**
			 * How fast the filter modulates between min and max. 
			 * @type {Frequency}
			 * @signal
			 */
	        this.frequency = this._lfo.frequency;
	        /**
			 *  The filter node
			 *  @type {Tone.Filter}
			 */
	        this.filter = new Tone.Filter(options.filter);
	        /**
			 *  The octaves placeholder
			 *  @type {Positive}
			 *  @private
			 */
	        this._octaves = 0;
	        //connections
	        this.connectEffect(this.filter);
	        this._lfo.connect(this.filter.frequency);
	        this.type = options.type;
	        this._readOnly([
	            'frequency',
	            'depth'
	        ]);
	        this.octaves = options.octaves;
	        this.baseFrequency = options.baseFrequency;
	    };
	    //extend Effect
	    Tone.extend(Tone.AutoFilter, Tone.Effect);
	    /**
		 *  defaults
		 *  @static
		 *  @type {Object}
		 */
	    Tone.AutoFilter.defaults = {
	        'frequency': 1,
	        'type': 'sine',
	        'depth': 1,
	        'baseFrequency': 200,
	        'octaves': 2.6,
	        'filter': {
	            'type': 'lowpass',
	            'rolloff': -12,
	            'Q': 1
	        }
	    };
	    /**
		 * Start the effect.
		 * @param {Time} [time=now] When the LFO will start. 
		 * @returns {Tone.AutoFilter} this
		 */
	    Tone.AutoFilter.prototype.start = function (time) {
	        this._lfo.start(time);
	        return this;
	    };
	    /**
		 * Stop the effect.
		 * @param {Time} [time=now] When the LFO will stop. 
		 * @returns {Tone.AutoFilter} this
		 */
	    Tone.AutoFilter.prototype.stop = function (time) {
	        this._lfo.stop(time);
	        return this;
	    };
	    /**
		 * Sync the filter to the transport.
		 * @param {Time} [delay=0] Delay time before starting the effect after the
		 *                               Transport has started. 
		 * @returns {Tone.AutoFilter} this
		 */
	    Tone.AutoFilter.prototype.sync = function (delay) {
	        this._lfo.sync(delay);
	        return this;
	    };
	    /**
		 * Unsync the filter from the transport.
		 * @returns {Tone.AutoFilter} this
		 */
	    Tone.AutoFilter.prototype.unsync = function () {
	        this._lfo.unsync();
	        return this;
	    };
	    /**
		 * Type of oscillator attached to the AutoFilter. 
		 * Possible values: "sine", "square", "triangle", "sawtooth".
		 * @memberOf Tone.AutoFilter#
		 * @type {string}
		 * @name type
		 */
	    Object.defineProperty(Tone.AutoFilter.prototype, 'type', {
	        get: function () {
	            return this._lfo.type;
	        },
	        set: function (type) {
	            this._lfo.type = type;
	        }
	    });
	    /**
		 * The minimum value of the filter's cutoff frequency.
		 * @memberOf Tone.AutoFilter#
		 * @type {Frequency}
		 * @name min
		 */
	    Object.defineProperty(Tone.AutoFilter.prototype, 'baseFrequency', {
	        get: function () {
	            return this._lfo.min;
	        },
	        set: function (freq) {
	            this._lfo.min = this.toFrequency(freq);
	            //and set the max
	            this.octaves = this._octaves;
	        }
	    });
	    /**
		 * The maximum value of the filter's cutoff frequency. 
		 * @memberOf Tone.AutoFilter#
		 * @type {Positive}
		 * @name octaves
		 */
	    Object.defineProperty(Tone.AutoFilter.prototype, 'octaves', {
	        get: function () {
	            return this._octaves;
	        },
	        set: function (oct) {
	            this._octaves = oct;
	            this._lfo.max = this.baseFrequency * Math.pow(2, oct);
	        }
	    });
	    /**
		 *  Clean up. 
		 *  @returns {Tone.AutoFilter} this
		 */
	    Tone.AutoFilter.prototype.dispose = function () {
	        Tone.Effect.prototype.dispose.call(this);
	        this._lfo.dispose();
	        this._lfo = null;
	        this.filter.dispose();
	        this.filter = null;
	        this._writable([
	            'frequency',
	            'depth'
	        ]);
	        this.frequency = null;
	        this.depth = null;
	        return this;
	    };
	    return Tone.AutoFilter;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Tone.AutoPanner is a Tone.Panner with an LFO connected to the pan amount. 
		 *         More on using autopanners [here](https://www.ableton.com/en/blog/autopan-chopper-effect-and-more-liveschool/).
		 *
		 *  @constructor
		 *  @extends {Tone.Effect}
		 *  @param {Frequency|Object} [frequency] Rate of left-right oscillation. 
		 *  @example
		 * //create an autopanner and start it's LFO
		 * var autoPanner = new Tone.AutoPanner("4n").toMaster().start();
		 * //route an oscillator through the panner and start it
		 * var oscillator = new Tone.Oscillator().connect(autoPanner).start();
		 */
	    Tone.AutoPanner = function () {
	        var options = this.optionsObject(arguments, ['frequency'], Tone.AutoPanner.defaults);
	        Tone.Effect.call(this, options);
	        /**
			 *  the lfo which drives the panning
			 *  @type {Tone.LFO}
			 *  @private
			 */
	        this._lfo = new Tone.LFO({
	            'frequency': options.frequency,
	            'amplitude': options.depth,
	            'min': -1,
	            'max': 1
	        });
	        /**
			 * The amount of panning between left and right. 
			 * 0 = always center. 1 = full range between left and right. 
			 * @type {NormalRange}
			 * @signal
			 */
	        this.depth = this._lfo.amplitude;
	        /**
			 *  the panner node which does the panning
			 *  @type {Tone.Panner}
			 *  @private
			 */
	        this._panner = new Tone.Panner();
	        /**
			 * How fast the panner modulates between left and right. 
			 * @type {Frequency}
			 * @signal
			 */
	        this.frequency = this._lfo.frequency;
	        //connections
	        this.connectEffect(this._panner);
	        this._lfo.connect(this._panner.pan);
	        this.type = options.type;
	        this._readOnly([
	            'depth',
	            'frequency'
	        ]);
	    };
	    //extend Effect
	    Tone.extend(Tone.AutoPanner, Tone.Effect);
	    /**
		 *  defaults
		 *  @static
		 *  @type {Object}
		 */
	    Tone.AutoPanner.defaults = {
	        'frequency': 1,
	        'type': 'sine',
	        'depth': 1
	    };
	    /**
		 * Start the effect.
		 * @param {Time} [time=now] When the LFO will start. 
		 * @returns {Tone.AutoPanner} this
		 */
	    Tone.AutoPanner.prototype.start = function (time) {
	        this._lfo.start(time);
	        return this;
	    };
	    /**
		 * Stop the effect.
		 * @param {Time} [time=now] When the LFO will stop. 
		 * @returns {Tone.AutoPanner} this
		 */
	    Tone.AutoPanner.prototype.stop = function (time) {
	        this._lfo.stop(time);
	        return this;
	    };
	    /**
		 * Sync the panner to the transport.
		 * @param {Time} [delay=0] Delay time before starting the effect after the
		 *                               Transport has started. 
		 * @returns {Tone.AutoPanner} this
		 */
	    Tone.AutoPanner.prototype.sync = function (delay) {
	        this._lfo.sync(delay);
	        return this;
	    };
	    /**
		 * Unsync the panner from the transport
		 * @returns {Tone.AutoPanner} this
		 */
	    Tone.AutoPanner.prototype.unsync = function () {
	        this._lfo.unsync();
	        return this;
	    };
	    /**
		 * Type of oscillator attached to the AutoFilter. 
		 * Possible values: "sine", "square", "triangle", "sawtooth".
		 * @memberOf Tone.AutoFilter#
		 * @type {string}
		 * @name type
		 */
	    Object.defineProperty(Tone.AutoPanner.prototype, 'type', {
	        get: function () {
	            return this._lfo.type;
	        },
	        set: function (type) {
	            this._lfo.type = type;
	        }
	    });
	    /**
		 *  clean up
		 *  @returns {Tone.AutoPanner} this
		 */
	    Tone.AutoPanner.prototype.dispose = function () {
	        Tone.Effect.prototype.dispose.call(this);
	        this._lfo.dispose();
	        this._lfo = null;
	        this._panner.dispose();
	        this._panner = null;
	        this._writable([
	            'depth',
	            'frequency'
	        ]);
	        this.frequency = null;
	        this.depth = null;
	        return this;
	    };
	    return Tone.AutoPanner;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  Tone.AutoWah connects a Tone.Follower to a bandpass filter (Tone.Filter).
		 *          The frequency of the filter is adjusted proportionally to the 
		 *          incoming signal's amplitude. Inspiration from [Tuna.js](https://github.com/Dinahmoe/tuna).
		 *
		 *  @constructor
		 *  @extends {Tone.Effect}
		 *  @param {Frequency|Object} [baseFrequency] The frequency the filter is set 
		 *                                            to at the low point of the wah
		 *  @param {Positive} [octaves] The number of octaves above the baseFrequency
		 *                                the filter will sweep to when fully open
		 *  @param {Decibels} [sensitivity] The decibel threshold sensitivity for 
		 *                                   the incoming signal. Normal range of -40 to 0. 
		 *  @example
		 * var autoWah = new Tone.AutoWah(50, 6, -30).toMaster();
		 * //initialize the synth and connect to autowah
		 * var synth = new Synth.connect(autoWah);
		 * //Q value influences the effect of the wah - default is 2
		 * autoWah.Q.value = 6;
		 * //more audible on higher notes
		 * synth.triggerAttackRelease("C4", "8n")
		 */
	    Tone.AutoWah = function () {
	        var options = this.optionsObject(arguments, [
	            'baseFrequency',
	            'octaves',
	            'sensitivity'
	        ], Tone.AutoWah.defaults);
	        Tone.Effect.call(this, options);
	        /**
			 *  The envelope follower. Set the attack/release
			 *  timing to adjust how the envelope is followed. 
			 *  @type {Tone.Follower}
			 *  @private
			 */
	        this.follower = new Tone.Follower(options.follower);
	        /**
			 *  scales the follower value to the frequency domain
			 *  @type {Tone}
			 *  @private
			 */
	        this._sweepRange = new Tone.ScaleExp(0, 1, 0.5);
	        /**
			 *  @type {number}
			 *  @private
			 */
	        this._baseFrequency = options.baseFrequency;
	        /**
			 *  @type {number}
			 *  @private
			 */
	        this._octaves = options.octaves;
	        /**
			 *  the input gain to adjust the sensitivity
			 *  @type {Tone.Gain}
			 *  @private
			 */
	        this._inputBoost = new Tone.Gain();
	        /**
			 *  @type {BiquadFilterNode}
			 *  @private
			 */
	        this._bandpass = new Tone.Filter({
	            'rolloff': -48,
	            'frequency': 0,
	            'Q': options.Q
	        });
	        /**
			 *  @type {Tone.Filter}
			 *  @private
			 */
	        this._peaking = new Tone.Filter(0, 'peaking');
	        this._peaking.gain.value = options.gain;
	        /**
			 * The gain of the filter.
			 * @type {Number}
			 * @signal
			 */
	        this.gain = this._peaking.gain;
	        /**
			 * The quality of the filter.
			 * @type {Positive}
			 * @signal
			 */
	        this.Q = this._bandpass.Q;
	        //the control signal path
	        this.effectSend.chain(this._inputBoost, this.follower, this._sweepRange);
	        this._sweepRange.connect(this._bandpass.frequency);
	        this._sweepRange.connect(this._peaking.frequency);
	        //the filtered path
	        this.effectSend.chain(this._bandpass, this._peaking, this.effectReturn);
	        //set the initial value
	        this._setSweepRange();
	        this.sensitivity = options.sensitivity;
	        this._readOnly([
	            'gain',
	            'Q'
	        ]);
	    };
	    Tone.extend(Tone.AutoWah, Tone.Effect);
	    /**
		 *  @static
		 *  @type {Object}
		 */
	    Tone.AutoWah.defaults = {
	        'baseFrequency': 100,
	        'octaves': 6,
	        'sensitivity': 0,
	        'Q': 2,
	        'gain': 2,
	        'follower': {
	            'attack': 0.3,
	            'release': 0.5
	        }
	    };
	    /**
		 * The number of octaves that the filter will sweep above the 
		 * baseFrequency. 
		 * @memberOf Tone.AutoWah#
		 * @type {Number}
		 * @name octaves
		 */
	    Object.defineProperty(Tone.AutoWah.prototype, 'octaves', {
	        get: function () {
	            return this._octaves;
	        },
	        set: function (octaves) {
	            this._octaves = octaves;
	            this._setSweepRange();
	        }
	    });
	    /**
		 * The base frequency from which the sweep will start from.
		 * @memberOf Tone.AutoWah#
		 * @type {Frequency}
		 * @name baseFrequency
		 */
	    Object.defineProperty(Tone.AutoWah.prototype, 'baseFrequency', {
	        get: function () {
	            return this._baseFrequency;
	        },
	        set: function (baseFreq) {
	            this._baseFrequency = baseFreq;
	            this._setSweepRange();
	        }
	    });
	    /**
		 * The sensitivity to control how responsive to the input signal the filter is. 
		 * @memberOf Tone.AutoWah#
		 * @type {Decibels}
		 * @name sensitivity
		 */
	    Object.defineProperty(Tone.AutoWah.prototype, 'sensitivity', {
	        get: function () {
	            return this.gainToDb(1 / this._inputBoost.gain.value);
	        },
	        set: function (sensitivy) {
	            this._inputBoost.gain.value = 1 / this.dbToGain(sensitivy);
	        }
	    });
	    /**
		 *  sets the sweep range of the scaler
		 *  @private
		 */
	    Tone.AutoWah.prototype._setSweepRange = function () {
	        this._sweepRange.min = this._baseFrequency;
	        this._sweepRange.max = Math.min(this._baseFrequency * Math.pow(2, this._octaves), this.context.sampleRate / 2);
	    };
	    /**
		 *  Clean up.
		 *  @returns {Tone.AutoWah} this
		 */
	    Tone.AutoWah.prototype.dispose = function () {
	        Tone.Effect.prototype.dispose.call(this);
	        this.follower.dispose();
	        this.follower = null;
	        this._sweepRange.dispose();
	        this._sweepRange = null;
	        this._bandpass.dispose();
	        this._bandpass = null;
	        this._peaking.dispose();
	        this._peaking = null;
	        this._inputBoost.dispose();
	        this._inputBoost = null;
	        this._writable([
	            'gain',
	            'Q'
	        ]);
	        this.gain = null;
	        this.Q = null;
	        return this;
	    };
	    return Tone.AutoWah;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Tone.Bitcrusher downsamples the incoming signal to a different bitdepth. 
		 *         Lowering the bitdepth of the signal creates distortion. Read more about Bitcrushing
		 *         on [Wikipedia](https://en.wikipedia.org/wiki/Bitcrusher).
		 *
		 *  @constructor
		 *  @extends {Tone.Effect}
		 *  @param {Number} bits The number of bits to downsample the signal. Nominal range
		 *                       of 1 to 8. 
		 *  @example
		 * //initialize crusher and route a synth through it
		 * var crusher = new Tone.BitCrusher(4).toMaster();
		 * var synth = new Tone.MonoSynth().connect(crusher);
		 */
	    Tone.BitCrusher = function () {
	        var options = this.optionsObject(arguments, ['bits'], Tone.BitCrusher.defaults);
	        Tone.Effect.call(this, options);
	        var invStepSize = 1 / Math.pow(2, options.bits - 1);
	        /**
			 *  Subtract the input signal and the modulus of the input signal
			 *  @type {Tone.Subtract}
			 *  @private
			 */
	        this._subtract = new Tone.Subtract();
	        /**
			 *  The mod function
			 *  @type  {Tone.Modulo}
			 *  @private
			 */
	        this._modulo = new Tone.Modulo(invStepSize);
	        /**
			 *  keeps track of the bits
			 *  @type {number}
			 *  @private
			 */
	        this._bits = options.bits;
	        //connect it up
	        this.effectSend.fan(this._subtract, this._modulo);
	        this._modulo.connect(this._subtract, 0, 1);
	        this._subtract.connect(this.effectReturn);
	    };
	    Tone.extend(Tone.BitCrusher, Tone.Effect);
	    /**
		 *  the default values
		 *  @static
		 *  @type {Object}
		 */
	    Tone.BitCrusher.defaults = { 'bits': 4 };
	    /**
		 * The bit depth of the effect. Nominal range of 1-8. 
		 * @memberOf Tone.BitCrusher#
		 * @type {number}
		 * @name bits
		 */
	    Object.defineProperty(Tone.BitCrusher.prototype, 'bits', {
	        get: function () {
	            return this._bits;
	        },
	        set: function (bits) {
	            this._bits = bits;
	            var invStepSize = 1 / Math.pow(2, bits - 1);
	            this._modulo.value = invStepSize;
	        }
	    });
	    /**
		 *  Clean up. 
		 *  @returns {Tone.BitCrusher} this
		 */
	    Tone.BitCrusher.prototype.dispose = function () {
	        Tone.Effect.prototype.dispose.call(this);
	        this._subtract.dispose();
	        this._subtract = null;
	        this._modulo.dispose();
	        this._modulo = null;
	        return this;
	    };
	    return Tone.BitCrusher;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Tone.ChebyShev is a Chebyshev waveshaper, an effect which is good 
		 *         for making different types of distortion sounds.
		 *         Note that odd orders sound very different from even ones, 
		 *         and order = 1 is no change. 
		 *         Read more at [music.columbia.edu](http://music.columbia.edu/cmc/musicandcomputers/chapter4/04_06.php).
		 *
		 *  @extends {Tone.Effect}
		 *  @constructor
		 *  @param {Positive|Object} [order] The order of the chebyshev polynomial. Normal range between 1-100. 
		 *  @example
		 * //create a new cheby
		 * var cheby = new Tone.Chebyshev(50);
		 * //create a monosynth connected to our cheby
		 * synth = new Tone.MonoSynth().connect(cheby);
		 */
	    Tone.Chebyshev = function () {
	        var options = this.optionsObject(arguments, ['order'], Tone.Chebyshev.defaults);
	        Tone.Effect.call(this, options);
	        /**
			 *  @type {WaveShaperNode}
			 *  @private
			 */
	        this._shaper = new Tone.WaveShaper(4096);
	        /**
			 * holds onto the order of the filter
			 * @type {number}
			 * @private
			 */
	        this._order = options.order;
	        this.connectEffect(this._shaper);
	        this.order = options.order;
	        this.oversample = options.oversample;
	    };
	    Tone.extend(Tone.Chebyshev, Tone.Effect);
	    /**
		 *  @static
		 *  @const
		 *  @type {Object}
		 */
	    Tone.Chebyshev.defaults = {
	        'order': 1,
	        'oversample': 'none'
	    };
	    /**
		 *  get the coefficient for that degree
		 *  @param {number} x the x value
		 *  @param   {number} degree 
		 *  @param {Object} memo memoize the computed value. 
		 *                       this speeds up computation greatly. 
		 *  @return  {number}       the coefficient 
		 *  @private
		 */
	    Tone.Chebyshev.prototype._getCoefficient = function (x, degree, memo) {
	        if (memo.hasOwnProperty(degree)) {
	            return memo[degree];
	        } else if (degree === 0) {
	            memo[degree] = 0;
	        } else if (degree === 1) {
	            memo[degree] = x;
	        } else {
	            memo[degree] = 2 * x * this._getCoefficient(x, degree - 1, memo) - this._getCoefficient(x, degree - 2, memo);
	        }
	        return memo[degree];
	    };
	    /**
		 * The order of the Chebyshev polynomial which creates
		 * the equation which is applied to the incoming 
		 * signal through a Tone.WaveShaper. The equations
		 * are in the form:<br>
		 * order 2: 2x^2 + 1<br>
		 * order 3: 4x^3 + 3x <br>
		 * @memberOf Tone.Chebyshev#
		 * @type {Positive}
		 * @name order
		 */
	    Object.defineProperty(Tone.Chebyshev.prototype, 'order', {
	        get: function () {
	            return this._order;
	        },
	        set: function (order) {
	            this._order = order;
	            var curve = new Array(4096);
	            var len = curve.length;
	            for (var i = 0; i < len; ++i) {
	                var x = i * 2 / len - 1;
	                if (x === 0) {
	                    //should output 0 when input is 0
	                    curve[i] = 0;
	                } else {
	                    curve[i] = this._getCoefficient(x, order, {});
	                }
	            }
	            this._shaper.curve = curve;
	        }
	    });
	    /**
		 * The oversampling of the effect. Can either be "none", "2x" or "4x".
		 * @memberOf Tone.Chebyshev#
		 * @type {string}
		 * @name oversample
		 */
	    Object.defineProperty(Tone.Chebyshev.prototype, 'oversample', {
	        get: function () {
	            return this._shaper.oversample;
	        },
	        set: function (oversampling) {
	            this._shaper.oversample = oversampling;
	        }
	    });
	    /**
		 *  Clean up. 
		 *  @returns {Tone.Chebyshev} this
		 */
	    Tone.Chebyshev.prototype.dispose = function () {
	        Tone.Effect.prototype.dispose.call(this);
	        this._shaper.dispose();
	        this._shaper = null;
	        return this;
	    };
	    return Tone.Chebyshev;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Base class for Stereo effects. Provides effectSendL/R and effectReturnL/R. 
		 *
		 *	@constructor
		 *	@extends {Tone.Effect}
		 */
	    Tone.StereoEffect = function () {
	        this.createInsOuts(1, 1);
	        //get the defaults
	        var options = this.optionsObject(arguments, ['wet'], Tone.Effect.defaults);
	        /**
			 *  the drywet knob to control the amount of effect
			 *  @type {Tone.CrossFade}
			 *  @private
			 */
	        this._dryWet = new Tone.CrossFade(options.wet);
	        /**
			 *  The wet control, i.e. how much of the effected
			 *  will pass through to the output. 
			 *  @type {NormalRange}
			 *  @signal
			 */
	        this.wet = this._dryWet.fade;
	        /**
			 *  then split it
			 *  @type {Tone.Split}
			 *  @private
			 */
	        this._split = new Tone.Split();
	        /**
			 *  the effects send LEFT
			 *  @type {GainNode}
			 *  @private
			 */
	        this.effectSendL = this._split.left;
	        /**
			 *  the effects send RIGHT
			 *  @type {GainNode}
			 *  @private
			 */
	        this.effectSendR = this._split.right;
	        /**
			 *  the stereo effect merger
			 *  @type {Tone.Merge}
			 *  @private
			 */
	        this._merge = new Tone.Merge();
	        /**
			 *  the effect return LEFT
			 *  @type {GainNode}
			 *  @private
			 */
	        this.effectReturnL = this._merge.left;
	        /**
			 *  the effect return RIGHT
			 *  @type {GainNode}
			 *  @private
			 */
	        this.effectReturnR = this._merge.right;
	        //connections
	        this.input.connect(this._split);
	        //dry wet connections
	        this.input.connect(this._dryWet, 0, 0);
	        this._merge.connect(this._dryWet, 0, 1);
	        this._dryWet.connect(this.output);
	        this._readOnly(['wet']);
	    };
	    Tone.extend(Tone.StereoEffect, Tone.Effect);
	    /**
		 *  Clean up. 
		 *  @returns {Tone.StereoEffect} this
		 */
	    Tone.StereoEffect.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._dryWet.dispose();
	        this._dryWet = null;
	        this._split.dispose();
	        this._split = null;
	        this._merge.dispose();
	        this._merge = null;
	        this.effectSendL = null;
	        this.effectSendR = null;
	        this.effectReturnL = null;
	        this.effectReturnR = null;
	        this._writable(['wet']);
	        this.wet = null;
	        return this;
	    };
	    return Tone.StereoEffect;
	});
	Module(function (Tone) {
	    
	    /**
		 * 	@class  Tone.FeedbackEffect provides a loop between an 
		 * 	        audio source and its own output. This is a base-class
		 * 	        for feedback effects. 
		 *
		 *  @constructor
		 *  @extends {Tone.Effect}
		 *  @param {NormalRange|Object} [feedback] The initial feedback value.
		 */
	    Tone.FeedbackEffect = function () {
	        var options = this.optionsObject(arguments, ['feedback']);
	        options = this.defaultArg(options, Tone.FeedbackEffect.defaults);
	        Tone.Effect.call(this, options);
	        /**
			 *  the gain which controls the feedback
			 *  @type {Tone.Gain}
			 *  @private
			 */
	        this._feedbackGain = new Tone.Gain(options.feedback, Tone.Type.NormalRange);
	        /**
			 *  The amount of signal which is fed back into the effect input. 
			 *  @type {NormalRange}
			 *  @signal
			 */
	        this.feedback = this._feedbackGain.gain;
	        //the feedback loop
	        this.effectReturn.chain(this._feedbackGain, this.effectSend);
	        this._readOnly(['feedback']);
	    };
	    Tone.extend(Tone.FeedbackEffect, Tone.Effect);
	    /**
		 *  @static
		 *  @type {Object}
		 */
	    Tone.FeedbackEffect.defaults = { 'feedback': 0.125 };
	    /**
		 *  Clean up. 
		 *  @returns {Tone.FeedbackEffect} this
		 */
	    Tone.FeedbackEffect.prototype.dispose = function () {
	        Tone.Effect.prototype.dispose.call(this);
	        this._writable(['feedback']);
	        this._feedbackGain.dispose();
	        this._feedbackGain = null;
	        this.feedback = null;
	        return this;
	    };
	    return Tone.FeedbackEffect;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Just like a stereo feedback effect, but the feedback is routed from left to right
		 *         and right to left instead of on the same channel.
		 *
		 *	@constructor
		 *	@extends {Tone.FeedbackEffect}
		 */
	    Tone.StereoXFeedbackEffect = function () {
	        var options = this.optionsObject(arguments, ['feedback'], Tone.FeedbackEffect.defaults);
	        Tone.StereoEffect.call(this, options);
	        /**
			 *  The amount of feedback from the output
			 *  back into the input of the effect (routed
			 *  across left and right channels).
			 *  @type {NormalRange}
			 *  @signal
			 */
	        this.feedback = new Tone.Signal(options.feedback, Tone.Type.NormalRange);
	        /**
			 *  the left side feeback
			 *  @type {Tone.Gain}
			 *  @private
			 */
	        this._feedbackLR = new Tone.Gain();
	        /**
			 *  the right side feeback
			 *  @type {Tone.Gain}
			 *  @private
			 */
	        this._feedbackRL = new Tone.Gain();
	        //connect it up
	        this.effectReturnL.chain(this._feedbackLR, this.effectSendR);
	        this.effectReturnR.chain(this._feedbackRL, this.effectSendL);
	        this.feedback.fan(this._feedbackLR.gain, this._feedbackRL.gain);
	        this._readOnly(['feedback']);
	    };
	    Tone.extend(Tone.StereoXFeedbackEffect, Tone.FeedbackEffect);
	    /**
		 *  clean up
		 *  @returns {Tone.StereoXFeedbackEffect} this
		 */
	    Tone.StereoXFeedbackEffect.prototype.dispose = function () {
	        Tone.StereoEffect.prototype.dispose.call(this);
	        this._writable(['feedback']);
	        this.feedback.dispose();
	        this.feedback = null;
	        this._feedbackLR.dispose();
	        this._feedbackLR = null;
	        this._feedbackRL.dispose();
	        this._feedbackRL = null;
	        return this;
	    };
	    return Tone.StereoXFeedbackEffect;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Tone.Chorus is a stereo chorus effect with feedback composed of 
		 *         a left and right delay with a Tone.LFO applied to the delayTime of each channel. 
		 *         Inspiration from [Tuna.js](https://github.com/Dinahmoe/tuna/blob/master/tuna.js).
		 *         Read more on the chorus effect on [SoundOnSound](http://www.soundonsound.com/sos/jun04/articles/synthsecrets.htm).
		 *
		 *	@constructor
		 *	@extends {Tone.StereoXFeedbackEffect}
		 *	@param {Frequency|Object} [frequency] The frequency of the LFO.
		 *	@param {Milliseconds} [delayTime] The delay of the chorus effect in ms. 
		 *	@param {NormalRange} [depth] The depth of the chorus.
		 *	@example
		 * var chorus = new Tone.Chorus(4, 2.5, 0.5);
		 * var synth = new Tone.PolySynth(4, Tone.MonoSynth).connect(chorus);
		 * synth.triggerAttackRelease(["C3","E3","G3"], "8n");
		 */
	    Tone.Chorus = function () {
	        var options = this.optionsObject(arguments, [
	            'frequency',
	            'delayTime',
	            'depth'
	        ], Tone.Chorus.defaults);
	        Tone.StereoXFeedbackEffect.call(this, options);
	        /**
			 *  the depth of the chorus
			 *  @type {number}
			 *  @private
			 */
	        this._depth = options.depth;
	        /**
			 *  the delayTime
			 *  @type {number}
			 *  @private
			 */
	        this._delayTime = options.delayTime / 1000;
	        /**
			 *  the lfo which controls the delayTime
			 *  @type {Tone.LFO}
			 *  @private
			 */
	        this._lfoL = new Tone.LFO({
	            'frequency': options.frequency,
	            'min': 0,
	            'max': 1
	        });
	        /**
			 *  another LFO for the right side with a 180 degree phase diff
			 *  @type {Tone.LFO}
			 *  @private
			 */
	        this._lfoR = new Tone.LFO({
	            'frequency': options.frequency,
	            'min': 0,
	            'max': 1,
	            'phase': 180
	        });
	        /**
			 *  delay for left
			 *  @type {Tone.Delay}
			 *  @private
			 */
	        this._delayNodeL = new Tone.Delay();
	        /**
			 *  delay for right
			 *  @type {Tone.Delay}
			 *  @private
			 */
	        this._delayNodeR = new Tone.Delay();
	        /**
			 * The frequency of the LFO which modulates the delayTime. 
			 * @type {Frequency}
			 * @signal
			 */
	        this.frequency = this._lfoL.frequency;
	        //connections
	        this.effectSendL.chain(this._delayNodeL, this.effectReturnL);
	        this.effectSendR.chain(this._delayNodeR, this.effectReturnR);
	        //and pass through to make the detune apparent
	        this.effectSendL.connect(this.effectReturnL);
	        this.effectSendR.connect(this.effectReturnR);
	        //lfo setup
	        this._lfoL.connect(this._delayNodeL.delayTime);
	        this._lfoR.connect(this._delayNodeR.delayTime);
	        //start the lfo
	        this._lfoL.start();
	        this._lfoR.start();
	        //have one LFO frequency control the other
	        this._lfoL.frequency.connect(this._lfoR.frequency);
	        //set the initial values
	        this.depth = this._depth;
	        this.frequency.value = options.frequency;
	        this.type = options.type;
	        this._readOnly(['frequency']);
	        this.spread = options.spread;
	    };
	    Tone.extend(Tone.Chorus, Tone.StereoXFeedbackEffect);
	    /**
		 *  @static
		 *  @type {Object}
		 */
	    Tone.Chorus.defaults = {
	        'frequency': 1.5,
	        'delayTime': 3.5,
	        'depth': 0.7,
	        'feedback': 0.1,
	        'type': 'sine',
	        'spread': 180
	    };
	    /**
		 * The depth of the effect. A depth of 1 makes the delayTime
		 * modulate between 0 and 2*delayTime (centered around the delayTime). 
		 * @memberOf Tone.Chorus#
		 * @type {NormalRange}
		 * @name depth
		 */
	    Object.defineProperty(Tone.Chorus.prototype, 'depth', {
	        get: function () {
	            return this._depth;
	        },
	        set: function (depth) {
	            this._depth = depth;
	            var deviation = this._delayTime * depth;
	            this._lfoL.min = Math.max(this._delayTime - deviation, 0);
	            this._lfoL.max = this._delayTime + deviation;
	            this._lfoR.min = Math.max(this._delayTime - deviation, 0);
	            this._lfoR.max = this._delayTime + deviation;
	        }
	    });
	    /**
		 * The delayTime in milliseconds of the chorus. A larger delayTime
		 * will give a more pronounced effect. Nominal range a delayTime
		 * is between 2 and 20ms. 
		 * @memberOf Tone.Chorus#
		 * @type {Milliseconds}
		 * @name delayTime
		 */
	    Object.defineProperty(Tone.Chorus.prototype, 'delayTime', {
	        get: function () {
	            return this._delayTime * 1000;
	        },
	        set: function (delayTime) {
	            this._delayTime = delayTime / 1000;
	            this.depth = this._depth;
	        }
	    });
	    /**
		 * The oscillator type of the LFO. 
		 * @memberOf Tone.Chorus#
		 * @type {string}
		 * @name type
		 */
	    Object.defineProperty(Tone.Chorus.prototype, 'type', {
	        get: function () {
	            return this._lfoL.type;
	        },
	        set: function (type) {
	            this._lfoL.type = type;
	            this._lfoR.type = type;
	        }
	    });
	    /** 
		 * Amount of stereo spread. When set to 0, both LFO's will be panned centrally.
		 * When set to 180, LFO's will be panned hard left and right respectively.
		 * @memberOf Tone.Chorus#
		 * @type {Degrees}
		 * @name spread
		 */
	    Object.defineProperty(Tone.Chorus.prototype, 'spread', {
	        get: function () {
	            return this._lfoR.phase - this._lfoL.phase;    //180
	        },
	        set: function (spread) {
	            this._lfoL.phase = 90 - spread / 2;
	            this._lfoR.phase = spread / 2 + 90;
	        }
	    });
	    /**
		 *  Clean up. 
		 *  @returns {Tone.Chorus} this
		 */
	    Tone.Chorus.prototype.dispose = function () {
	        Tone.StereoXFeedbackEffect.prototype.dispose.call(this);
	        this._lfoL.dispose();
	        this._lfoL = null;
	        this._lfoR.dispose();
	        this._lfoR = null;
	        this._delayNodeL.dispose();
	        this._delayNodeL = null;
	        this._delayNodeR.dispose();
	        this._delayNodeR = null;
	        this._writable('frequency');
	        this.frequency = null;
	        return this;
	    };
	    return Tone.Chorus;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  Tone.Convolver is a wrapper around the Native Web Audio 
		 *          [ConvolverNode](http://webaudio.github.io/web-audio-api/#the-convolvernode-interface).
		 *          Convolution is useful for reverb and filter emulation. Read more about convolution reverb on
		 *          [Wikipedia](https://en.wikipedia.org/wiki/Convolution_reverb).
		 *  
		 *  @constructor
		 *  @extends {Tone.Effect}
		 *  @param {string|Tone.Buffer|Object} [url] The URL of the impulse response or the Tone.Buffer
		 *                                           contianing the impulse response. 
		 *  @param {Function} onload The callback to invoke when the url is loaded.
		 *  @example
		 * //initializing the convolver with an impulse response
		 * var convolver = new Tone.Convolver("./path/to/ir.wav").toMaster();
		 */
	    Tone.Convolver = function () {
	        var options = this.optionsObject(arguments, [
	            'url',
	            'onload'
	        ], Tone.Convolver.defaults);
	        Tone.Effect.call(this, options);
	        /**
			 *  convolver node
			 *  @type {ConvolverNode}
			 *  @private
			 */
	        this._convolver = this.context.createConvolver();
	        /**
			 *  the convolution buffer
			 *  @type {Tone.Buffer}
			 *  @private
			 */
	        this._buffer = new Tone.Buffer();
	        if (this.isString(options.url)) {
	            this._buffer.load(options.url, function (buffer) {
	                this.buffer = buffer;
	                options.onload();
	            }.bind(this));
	        } else if (options.url) {
	            this.buffer = options.url;
	            options.onload();
	        }
	        this.connectEffect(this._convolver);
	    };
	    Tone.extend(Tone.Convolver, Tone.Effect);
	    /**
		 *  @static
		 *  @const
		 *  @type  {Object}
		 */
	    Tone.Convolver.defaults = { 'onload': Tone.noOp };
	    /**
		 *  The convolver's buffer
		 *  @memberOf Tone.Convolver#
		 *  @type {AudioBuffer}
		 *  @name buffer
		 */
	    Object.defineProperty(Tone.Convolver.prototype, 'buffer', {
	        get: function () {
	            return this._buffer.get();
	        },
	        set: function (buffer) {
	            this._buffer.set(buffer);
	            this._convolver.buffer = this._buffer.get();
	        }
	    });
	    /**
		 *  Load an impulse response url as an audio buffer.
		 *  Decodes the audio asynchronously and invokes
		 *  the callback once the audio buffer loads.
		 *  @param {string} url The url of the buffer to load.
		 *                      filetype support depends on the
		 *                      browser.
		 *  @param  {function=} callback
		 *  @returns {Promise}
		 */
	    Tone.Convolver.prototype.load = function (url, callback) {
	        return this._buffer.load(url, function (buff) {
	            this.buffer = buff;
	            if (callback) {
	                callback();
	            }
	        }.bind(this));
	    };
	    /**
		 *  Clean up. 
		 *  @returns {Tone.Convolver} this
		 */
	    Tone.Convolver.prototype.dispose = function () {
	        Tone.Effect.prototype.dispose.call(this);
	        this._convolver.disconnect();
	        this._convolver = null;
	        this._buffer.dispose();
	        this._buffer = null;
	        return this;
	    };
	    return Tone.Convolver;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Tone.Distortion is a simple distortion effect using Tone.WaveShaper.
		 *         Algorithm from [a stackoverflow answer](http://stackoverflow.com/a/22313408).
		 *
		 *  @extends {Tone.Effect}
		 *  @constructor
		 *  @param {Number|Object} [distortion] The amount of distortion (nominal range of 0-1)
		 *  @example
		 * var dist = new Tone.Distortion(0.8).toMaster();
		 * var fm = new Tone.SimpleFM().connect(dist);
		 * //this sounds good on bass notes
		 * fm.triggerAttackRelease("A1", "8n");
		 */
	    Tone.Distortion = function () {
	        var options = this.optionsObject(arguments, ['distortion'], Tone.Distortion.defaults);
	        Tone.Effect.call(this, options);
	        /**
			 *  @type {Tone.WaveShaper}
			 *  @private
			 */
	        this._shaper = new Tone.WaveShaper(4096);
	        /**
			 * holds the distortion amount
			 * @type {number}
			 * @private
			 */
	        this._distortion = options.distortion;
	        this.connectEffect(this._shaper);
	        this.distortion = options.distortion;
	        this.oversample = options.oversample;
	    };
	    Tone.extend(Tone.Distortion, Tone.Effect);
	    /**
		 *  @static
		 *  @const
		 *  @type {Object}
		 */
	    Tone.Distortion.defaults = {
	        'distortion': 0.4,
	        'oversample': 'none'
	    };
	    /**
		 * The amount of distortion.
		 * @memberOf Tone.Distortion#
		 * @type {NormalRange}
		 * @name distortion
		 */
	    Object.defineProperty(Tone.Distortion.prototype, 'distortion', {
	        get: function () {
	            return this._distortion;
	        },
	        set: function (amount) {
	            this._distortion = amount;
	            var k = amount * 100;
	            var deg = Math.PI / 180;
	            this._shaper.setMap(function (x) {
	                if (Math.abs(x) < 0.001) {
	                    //should output 0 when input is 0
	                    return 0;
	                } else {
	                    return (3 + k) * x * 20 * deg / (Math.PI + k * Math.abs(x));
	                }
	            });
	        }
	    });
	    /**
		 * The oversampling of the effect. Can either be "none", "2x" or "4x".
		 * @memberOf Tone.Distortion#
		 * @type {string}
		 * @name oversample
		 */
	    Object.defineProperty(Tone.Distortion.prototype, 'oversample', {
	        get: function () {
	            return this._shaper.oversample;
	        },
	        set: function (oversampling) {
	            this._shaper.oversample = oversampling;
	        }
	    });
	    /**
		 *  Clean up. 
		 *  @returns {Tone.Distortion} this
		 */
	    Tone.Distortion.prototype.dispose = function () {
	        Tone.Effect.prototype.dispose.call(this);
	        this._shaper.dispose();
	        this._shaper = null;
	        return this;
	    };
	    return Tone.Distortion;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  Tone.FeedbackDelay is a DelayNode in which part of output
		 *          signal is fed back into the delay. 
		 *
		 *  @constructor
		 *  @extends {Tone.FeedbackEffect}
		 *  @param {Time|Object} [delayTime] The delay applied to the incoming signal. 
		 *  @param {NormalRange=} feedback The amount of the effected signal which 
		 *                            is fed back through the delay.
		 *  @example
		 * var feedbackDelay = new Tone.FeedbackDelay("8n", 0.5).toMaster();
		 * var tom = new Tone.DrumSynth({
		 * 	"octaves" : 4,
		 * 	"pitchDecay" : 0.1
		 * }).connect(feedbackDelay);
		 * tom.triggerAttackRelease("A2","32n");
		 */
	    Tone.FeedbackDelay = function () {
	        var options = this.optionsObject(arguments, [
	            'delayTime',
	            'feedback'
	        ], Tone.FeedbackDelay.defaults);
	        Tone.FeedbackEffect.call(this, options);
	        /**
			 *  the delay node
			 *  @type {Tone.Delay}
			 *  @private
			 */
	        this._delayNode = new Tone.Delay(options.delayTime);
	        /**
			 *  The delayTime of the DelayNode. 
			 *  @type {Time}
			 *  @signal
			 */
	        this.delayTime = this._delayNode.delayTime;
	        // connect it up
	        this.connectEffect(this._delayNode);
	        this._readOnly(['delayTime']);
	    };
	    Tone.extend(Tone.FeedbackDelay, Tone.FeedbackEffect);
	    /**
		 *  The default values. 
		 *  @const
		 *  @static
		 *  @type {Object}
		 */
	    Tone.FeedbackDelay.defaults = { 'delayTime': 0.25 };
	    /**
		 *  clean up
		 *  @returns {Tone.FeedbackDelay} this
		 */
	    Tone.FeedbackDelay.prototype.dispose = function () {
	        Tone.FeedbackEffect.prototype.dispose.call(this);
	        this._delayNode.dispose();
	        this._delayNode = null;
	        this._writable(['delayTime']);
	        this.delayTime = null;
	        return this;
	    };
	    return Tone.FeedbackDelay;
	});
	Module(function (Tone) {
	    
	    /**
		 *  an array of comb filter delay values from Freeverb implementation
		 *  @static
		 *  @private
		 *  @type {Array}
		 */
	    var combFilterTunings = [
	        1557 / 44100,
	        1617 / 44100,
	        1491 / 44100,
	        1422 / 44100,
	        1277 / 44100,
	        1356 / 44100,
	        1188 / 44100,
	        1116 / 44100
	    ];
	    /**
		 *  an array of allpass filter frequency values from Freeverb implementation
		 *  @private
		 *  @static
		 *  @type {Array}
		 */
	    var allpassFilterFrequencies = [
	        225,
	        556,
	        441,
	        341
	    ];
	    /**
		 *  @class Tone.Freeverb is a reverb based on [Freeverb](https://ccrma.stanford.edu/~jos/pasp/Freeverb.html).
		 *         Read more on reverb on [SoundOnSound](http://www.soundonsound.com/sos/may00/articles/reverb.htm).
		 *
		 *  @extends {Tone.Effect}
		 *  @constructor
		 *  @param {NormalRange|Object} [roomSize] Correlated to the decay time. 
		 *  @param {Frequency} [dampening] The cutoff frequency of a lowpass filter as part 
		 *                                 of the reverb. 
		 *  @example
		 * var freeverb = new Tone.Freeverb().toMaster();
		 * freeverb.dampening.value = 1000;
		 * //routing synth through the reverb
		 * var synth = new Tone.AMSynth().connect(freeverb);
		 */
	    Tone.Freeverb = function () {
	        var options = this.optionsObject(arguments, [
	            'roomSize',
	            'dampening'
	        ], Tone.Freeverb.defaults);
	        Tone.StereoEffect.call(this, options);
	        /**
			 *  The roomSize value between. A larger roomSize
			 *  will result in a longer decay. 
			 *  @type {NormalRange}
			 *  @signal
			 */
	        this.roomSize = new Tone.Signal(options.roomSize, Tone.Type.NormalRange);
	        /**
			 *  The amount of dampening of the reverberant signal. 
			 *  @type {Frequency}
			 *  @signal
			 */
	        this.dampening = new Tone.Signal(options.dampening, Tone.Type.Frequency);
	        /**
			 *  the comb filters
			 *  @type {Array}
			 *  @private
			 */
	        this._combFilters = [];
	        /**
			 *  the allpass filters on the left
			 *  @type {Array}
			 *  @private
			 */
	        this._allpassFiltersL = [];
	        /**
			 *  the allpass filters on the right
			 *  @type {Array}
			 *  @private
			 */
	        this._allpassFiltersR = [];
	        //make the allpass filters on the right
	        for (var l = 0; l < allpassFilterFrequencies.length; l++) {
	            var allpassL = this.context.createBiquadFilter();
	            allpassL.type = 'allpass';
	            allpassL.frequency.value = allpassFilterFrequencies[l];
	            this._allpassFiltersL.push(allpassL);
	        }
	        //make the allpass filters on the left
	        for (var r = 0; r < allpassFilterFrequencies.length; r++) {
	            var allpassR = this.context.createBiquadFilter();
	            allpassR.type = 'allpass';
	            allpassR.frequency.value = allpassFilterFrequencies[r];
	            this._allpassFiltersR.push(allpassR);
	        }
	        //make the comb filters
	        for (var c = 0; c < combFilterTunings.length; c++) {
	            var lfpf = new Tone.LowpassCombFilter(combFilterTunings[c]);
	            if (c < combFilterTunings.length / 2) {
	                this.effectSendL.chain(lfpf, this._allpassFiltersL[0]);
	            } else {
	                this.effectSendR.chain(lfpf, this._allpassFiltersR[0]);
	            }
	            this.roomSize.connect(lfpf.resonance);
	            this.dampening.connect(lfpf.dampening);
	            this._combFilters.push(lfpf);
	        }
	        //chain the allpass filters togetehr
	        this.connectSeries.apply(this, this._allpassFiltersL);
	        this.connectSeries.apply(this, this._allpassFiltersR);
	        this._allpassFiltersL[this._allpassFiltersL.length - 1].connect(this.effectReturnL);
	        this._allpassFiltersR[this._allpassFiltersR.length - 1].connect(this.effectReturnR);
	        this._readOnly([
	            'roomSize',
	            'dampening'
	        ]);
	    };
	    Tone.extend(Tone.Freeverb, Tone.StereoEffect);
	    /**
		 *  @static
		 *  @type {Object}
		 */
	    Tone.Freeverb.defaults = {
	        'roomSize': 0.7,
	        'dampening': 3000
	    };
	    /**
		 *  Clean up. 
		 *  @returns {Tone.Freeverb} this
		 */
	    Tone.Freeverb.prototype.dispose = function () {
	        Tone.StereoEffect.prototype.dispose.call(this);
	        for (var al = 0; al < this._allpassFiltersL.length; al++) {
	            this._allpassFiltersL[al].disconnect();
	            this._allpassFiltersL[al] = null;
	        }
	        this._allpassFiltersL = null;
	        for (var ar = 0; ar < this._allpassFiltersR.length; ar++) {
	            this._allpassFiltersR[ar].disconnect();
	            this._allpassFiltersR[ar] = null;
	        }
	        this._allpassFiltersR = null;
	        for (var cf = 0; cf < this._combFilters.length; cf++) {
	            this._combFilters[cf].dispose();
	            this._combFilters[cf] = null;
	        }
	        this._combFilters = null;
	        this._writable([
	            'roomSize',
	            'dampening'
	        ]);
	        this.roomSize.dispose();
	        this.roomSize = null;
	        this.dampening.dispose();
	        this.dampening = null;
	        return this;
	    };
	    return Tone.Freeverb;
	});
	Module(function (Tone) {
	    
	    /**
		 *  an array of the comb filter delay time values
		 *  @private
		 *  @static
		 *  @type {Array}
		 */
	    var combFilterDelayTimes = [
	        1687 / 25000,
	        1601 / 25000,
	        2053 / 25000,
	        2251 / 25000
	    ];
	    /**
		 *  the resonances of each of the comb filters
		 *  @private
		 *  @static
		 *  @type {Array}
		 */
	    var combFilterResonances = [
	        0.773,
	        0.802,
	        0.753,
	        0.733
	    ];
	    /**
		 *  the allpass filter frequencies
		 *  @private
		 *  @static
		 *  @type {Array}
		 */
	    var allpassFilterFreqs = [
	        347,
	        113,
	        37
	    ];
	    /**
		 *  @class Tone.JCReverb is a simple [Schroeder Reverberator](https://ccrma.stanford.edu/~jos/pasp/Schroeder_Reverberators.html)
		 *         tuned by John Chowning in 1970.
		 *         It is made up of three allpass filters and four Tone.FeedbackCombFilter. 
		 *         
		 *
		 *  @extends {Tone.Effect}
		 *  @constructor
		 *  @param {NormalRange|Object} [roomSize] Coorelates to the decay time.
		 *  @example
		 * var reverb = new Tone.JCReverb(0.4).connect(Tone.Master);
		 * var delay = new Tone.FeedbackDelay(0.5); 
		 * //connecting the synth to reverb through delay
		 * var synth = new Tone.DuoSynth().chain(delay, reverb);
		 * synth.triggerAttackRelease("A4","8n");
		 */
	    Tone.JCReverb = function () {
	        var options = this.optionsObject(arguments, ['roomSize'], Tone.JCReverb.defaults);
	        Tone.StereoEffect.call(this, options);
	        /**
			 *  room size control values between [0,1]
			 *  @type {NormalRange}
			 *  @signal
			 */
	        this.roomSize = new Tone.Signal(options.roomSize, Tone.Type.NormalRange);
	        /**
			 *  scale the room size
			 *  @type {Tone.Scale}
			 *  @private
			 */
	        this._scaleRoomSize = new Tone.Scale(-0.733, 0.197);
	        /**
			 *  a series of allpass filters
			 *  @type {Array}
			 *  @private
			 */
	        this._allpassFilters = [];
	        /**
			 *  parallel feedback comb filters
			 *  @type {Array}
			 *  @private
			 */
	        this._feedbackCombFilters = [];
	        //make the allpass filters
	        for (var af = 0; af < allpassFilterFreqs.length; af++) {
	            var allpass = this.context.createBiquadFilter();
	            allpass.type = 'allpass';
	            allpass.frequency.value = allpassFilterFreqs[af];
	            this._allpassFilters.push(allpass);
	        }
	        //and the comb filters
	        for (var cf = 0; cf < combFilterDelayTimes.length; cf++) {
	            var fbcf = new Tone.FeedbackCombFilter(combFilterDelayTimes[cf], 0.1);
	            this._scaleRoomSize.connect(fbcf.resonance);
	            fbcf.resonance.value = combFilterResonances[cf];
	            this._allpassFilters[this._allpassFilters.length - 1].connect(fbcf);
	            if (cf < combFilterDelayTimes.length / 2) {
	                fbcf.connect(this.effectReturnL);
	            } else {
	                fbcf.connect(this.effectReturnR);
	            }
	            this._feedbackCombFilters.push(fbcf);
	        }
	        //chain the allpass filters together
	        this.roomSize.connect(this._scaleRoomSize);
	        this.connectSeries.apply(this, this._allpassFilters);
	        this.effectSendL.connect(this._allpassFilters[0]);
	        this.effectSendR.connect(this._allpassFilters[0]);
	        this._readOnly(['roomSize']);
	    };
	    Tone.extend(Tone.JCReverb, Tone.StereoEffect);
	    /**
		 *  the default values
		 *  @static
		 *  @const
		 *  @type {Object}
		 */
	    Tone.JCReverb.defaults = { 'roomSize': 0.5 };
	    /**
		 *  Clean up. 
		 *  @returns {Tone.JCReverb} this
		 */
	    Tone.JCReverb.prototype.dispose = function () {
	        Tone.StereoEffect.prototype.dispose.call(this);
	        for (var apf = 0; apf < this._allpassFilters.length; apf++) {
	            this._allpassFilters[apf].disconnect();
	            this._allpassFilters[apf] = null;
	        }
	        this._allpassFilters = null;
	        for (var fbcf = 0; fbcf < this._feedbackCombFilters.length; fbcf++) {
	            this._feedbackCombFilters[fbcf].dispose();
	            this._feedbackCombFilters[fbcf] = null;
	        }
	        this._feedbackCombFilters = null;
	        this._writable(['roomSize']);
	        this.roomSize.dispose();
	        this.roomSize = null;
	        this._scaleRoomSize.dispose();
	        this._scaleRoomSize = null;
	        return this;
	    };
	    return Tone.JCReverb;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Mid/Side processing separates the the 'mid' signal 
		 *         (which comes out of both the left and the right channel) 
		 *         and the 'side' (which only comes out of the the side channels) 
		 *         and effects them separately before being recombined.
		 *         Applies a Mid/Side seperation and recombination.
		 *         Algorithm found in [kvraudio forums](http://www.kvraudio.com/forum/viewtopic.php?t=212587).
		 *         <br><br>
		 *         This is a base-class for Mid/Side Effects. 
		 *
		 *  @extends {Tone.Effect}
		 *  @constructor
		 */
	    Tone.MidSideEffect = function () {
	        Tone.Effect.apply(this, arguments);
	        /**
			 *  The mid/side split
			 *  @type  {Tone.MidSideSplit}
			 *  @private
			 */
	        this._midSideSplit = new Tone.MidSideSplit();
	        /**
			 *  The mid/side merge
			 *  @type  {Tone.MidSideMerge}
			 *  @private
			 */
	        this._midSideMerge = new Tone.MidSideMerge();
	        /**
			 *  The mid send. Connect to mid processing
			 *  @type {Tone.Expr}
			 *  @private
			 */
	        this.midSend = this._midSideSplit.mid;
	        /**
			 *  The side send. Connect to side processing
			 *  @type {Tone.Expr}
			 *  @private
			 */
	        this.sideSend = this._midSideSplit.side;
	        /**
			 *  The mid return connection
			 *  @type {GainNode}
			 *  @private
			 */
	        this.midReturn = this._midSideMerge.mid;
	        /**
			 *  The side return connection
			 *  @type {GainNode}
			 *  @private
			 */
	        this.sideReturn = this._midSideMerge.side;
	        //the connections
	        this.effectSend.connect(this._midSideSplit);
	        this._midSideMerge.connect(this.effectReturn);
	    };
	    Tone.extend(Tone.MidSideEffect, Tone.Effect);
	    /**
		 *  Clean up. 
		 *  @returns {Tone.MidSideEffect} this
		 */
	    Tone.MidSideEffect.prototype.dispose = function () {
	        Tone.Effect.prototype.dispose.call(this);
	        this._midSideSplit.dispose();
	        this._midSideSplit = null;
	        this._midSideMerge.dispose();
	        this._midSideMerge = null;
	        this.midSend = null;
	        this.sideSend = null;
	        this.midReturn = null;
	        this.sideReturn = null;
	        return this;
	    };
	    return Tone.MidSideEffect;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Tone.Phaser is a phaser effect. Phasers work by changing the phase
		 *         of different frequency components of an incoming signal. Read more on 
		 *         [Wikipedia](https://en.wikipedia.org/wiki/Phaser_(effect)). 
		 *         Inspiration for this phaser comes from [Tuna.js](https://github.com/Dinahmoe/tuna/).
		 *
		 *	@extends {Tone.StereoEffect}
		 *	@constructor
		 *	@param {Frequency|Object} [frequency] The speed of the phasing. 
		 *	@param {number} [octaves] The octaves of the effect. 
		 *	@param {Frequency} [baseFrequency] The base frequency of the filters. 
		 *	@example
		 * var phaser = new Tone.Phaser({
		 * 	"frequency" : 15, 
		 * 	"octaves" : 5, 
		 * 	"baseFrequency" : 1000
		 * }).toMaster();
		 * var synth = new Tone.FMSynth().connect(phaser);
		 * synth.triggerAttackRelease("E3", "2n");
		 */
	    Tone.Phaser = function () {
	        //set the defaults
	        var options = this.optionsObject(arguments, [
	            'frequency',
	            'octaves',
	            'baseFrequency'
	        ], Tone.Phaser.defaults);
	        Tone.StereoEffect.call(this, options);
	        /**
			 *  the lfo which controls the frequency on the left side
			 *  @type {Tone.LFO}
			 *  @private
			 */
	        this._lfoL = new Tone.LFO(options.frequency, 0, 1);
	        /**
			 *  the lfo which controls the frequency on the right side
			 *  @type {Tone.LFO}
			 *  @private
			 */
	        this._lfoR = new Tone.LFO(options.frequency, 0, 1);
	        this._lfoR.phase = 180;
	        /**
			 *  the base modulation frequency
			 *  @type {number}
			 *  @private
			 */
	        this._baseFrequency = options.baseFrequency;
	        /**
			 *  the octaves of the phasing
			 *  @type {number}
			 *  @private
			 */
	        this._octaves = options.octaves;
	        /**
			 *  The quality factor of the filters
			 *  @type {Positive}
			 *  @signal
			 */
	        this.Q = new Tone.Signal(options.Q, Tone.Type.Positive);
	        /**
			 *  the array of filters for the left side
			 *  @type {Array}
			 *  @private
			 */
	        this._filtersL = this._makeFilters(options.stages, this._lfoL, this.Q);
	        /**
			 *  the array of filters for the left side
			 *  @type {Array}
			 *  @private
			 */
	        this._filtersR = this._makeFilters(options.stages, this._lfoR, this.Q);
	        /**
			 * the frequency of the effect
			 * @type {Tone.Signal}
			 */
	        this.frequency = this._lfoL.frequency;
	        this.frequency.value = options.frequency;
	        //connect them up
	        this.effectSendL.connect(this._filtersL[0]);
	        this.effectSendR.connect(this._filtersR[0]);
	        this._filtersL[options.stages - 1].connect(this.effectReturnL);
	        this._filtersR[options.stages - 1].connect(this.effectReturnR);
	        //control the frequency with one LFO
	        this._lfoL.frequency.connect(this._lfoR.frequency);
	        //set the options
	        this.baseFrequency = options.baseFrequency;
	        this.octaves = options.octaves;
	        //start the lfo
	        this._lfoL.start();
	        this._lfoR.start();
	        this._readOnly([
	            'frequency',
	            'Q'
	        ]);
	    };
	    Tone.extend(Tone.Phaser, Tone.StereoEffect);
	    /**
		 *  defaults
		 *  @static
		 *  @type {object}
		 */
	    Tone.Phaser.defaults = {
	        'frequency': 0.5,
	        'octaves': 3,
	        'stages': 10,
	        'Q': 10,
	        'baseFrequency': 350
	    };
	    /**
		 *  @param {number} stages
		 *  @returns {Array} the number of filters all connected together
		 *  @private
		 */
	    Tone.Phaser.prototype._makeFilters = function (stages, connectToFreq, Q) {
	        var filters = new Array(stages);
	        //make all the filters
	        for (var i = 0; i < stages; i++) {
	            var filter = this.context.createBiquadFilter();
	            filter.type = 'allpass';
	            Q.connect(filter.Q);
	            connectToFreq.connect(filter.frequency);
	            filters[i] = filter;
	        }
	        this.connectSeries.apply(this, filters);
	        return filters;
	    };
	    /**
		 * The number of octaves the phase goes above
		 * the baseFrequency
		 * @memberOf Tone.Phaser#
		 * @type {Positive}
		 * @name octaves
		 */
	    Object.defineProperty(Tone.Phaser.prototype, 'octaves', {
	        get: function () {
	            return this._octaves;
	        },
	        set: function (octaves) {
	            this._octaves = octaves;
	            var max = this._baseFrequency * Math.pow(2, octaves);
	            this._lfoL.max = max;
	            this._lfoR.max = max;
	        }
	    });
	    /**
		 * The the base frequency of the filters. 
		 * @memberOf Tone.Phaser#
		 * @type {number}
		 * @name baseFrequency
		 */
	    Object.defineProperty(Tone.Phaser.prototype, 'baseFrequency', {
	        get: function () {
	            return this._baseFrequency;
	        },
	        set: function (freq) {
	            this._baseFrequency = freq;
	            this._lfoL.min = freq;
	            this._lfoR.min = freq;
	            this.octaves = this._octaves;
	        }
	    });
	    /**
		 *  clean up
		 *  @returns {Tone.Phaser} this
		 */
	    Tone.Phaser.prototype.dispose = function () {
	        Tone.StereoEffect.prototype.dispose.call(this);
	        this._writable([
	            'frequency',
	            'Q'
	        ]);
	        this.Q.dispose();
	        this.Q = null;
	        this._lfoL.dispose();
	        this._lfoL = null;
	        this._lfoR.dispose();
	        this._lfoR = null;
	        for (var i = 0; i < this._filtersL.length; i++) {
	            this._filtersL[i].disconnect();
	            this._filtersL[i] = null;
	        }
	        this._filtersL = null;
	        for (var j = 0; j < this._filtersR.length; j++) {
	            this._filtersR[j].disconnect();
	            this._filtersR[j] = null;
	        }
	        this._filtersR = null;
	        this.frequency = null;
	        return this;
	    };
	    return Tone.Phaser;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  Tone.PingPongDelay is a feedback delay effect where the echo is heard
		 *          first in one channel and next in the opposite channel. In a stereo
		 *          system these are the right and left channels.
		 *          PingPongDelay in more simplified terms is two Tone.FeedbackDelays 
		 *          with independent delay values. Each delay is routed to one channel
		 *          (left or right), and the channel triggered second will always 
		 *          trigger at the same interval after the first.
		 *
		 * 	@constructor
		 * 	@extends {Tone.StereoXFeedbackEffect}
		 *  @param {Time|Object} [delayTime] The delayTime between consecutive echos.
		 *  @param {NormalRange=} feedback The amount of the effected signal which 
		 *                                 is fed back through the delay.
		 *  @example
		 * var pingPong = new Tone.PingPongDelay("4n", 0.2).toMaster();
		 * var drum = new Tone.DrumSynth().connect(pingPong);
		 * drum.triggerAttackRelease("C4", "32n");
		 */
	    Tone.PingPongDelay = function () {
	        var options = this.optionsObject(arguments, [
	            'delayTime',
	            'feedback'
	        ], Tone.PingPongDelay.defaults);
	        Tone.StereoXFeedbackEffect.call(this, options);
	        /**
			 *  the delay node on the left side
			 *  @type {Tone.Delay}
			 *  @private
			 */
	        this._leftDelay = new Tone.Delay(0, options.maxDelayTime);
	        /**
			 *  the delay node on the right side
			 *  @type {Tone.Delay}
			 *  @private
			 */
	        this._rightDelay = new Tone.Delay(0, options.maxDelayTime);
	        /**
			 *  the predelay on the right side
			 *  @type {Tone.Delay}
			 *  @private
			 */
	        this._rightPreDelay = new Tone.Delay(0, options.maxDelayTime);
	        /**
			 *  the delay time signal
			 *  @type {Time}
			 *  @signal
			 */
	        this.delayTime = new Tone.Signal(options.delayTime, Tone.Type.Time);
	        //connect it up
	        this.effectSendL.chain(this._leftDelay, this.effectReturnL);
	        this.effectSendR.chain(this._rightPreDelay, this._rightDelay, this.effectReturnR);
	        this.delayTime.fan(this._leftDelay.delayTime, this._rightDelay.delayTime, this._rightPreDelay.delayTime);
	        //rearranged the feedback to be after the rightPreDelay
	        this._feedbackLR.disconnect();
	        this._feedbackLR.connect(this._rightDelay);
	        this._readOnly(['delayTime']);
	    };
	    Tone.extend(Tone.PingPongDelay, Tone.StereoXFeedbackEffect);
	    /**
		 *  @static
		 *  @type {Object}
		 */
	    Tone.PingPongDelay.defaults = {
	        'delayTime': 0.25,
	        'maxDelayTime': 1
	    };
	    /**
		 *  Clean up. 
		 *  @returns {Tone.PingPongDelay} this
		 */
	    Tone.PingPongDelay.prototype.dispose = function () {
	        Tone.StereoXFeedbackEffect.prototype.dispose.call(this);
	        this._leftDelay.dispose();
	        this._leftDelay = null;
	        this._rightDelay.dispose();
	        this._rightDelay = null;
	        this._rightPreDelay.dispose();
	        this._rightPreDelay = null;
	        this._writable(['delayTime']);
	        this.delayTime.dispose();
	        this.delayTime = null;
	        return this;
	    };
	    return Tone.PingPongDelay;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Tone.PitchShift does near-realtime pitch shifting to the incoming signal. 
		 *         The effect is achieved by speeding up or slowing down the delayTime
		 *         of a DelayNode using a sawtooth wave. 
		 *         Algorithm found in [this pdf](http://dsp-book.narod.ru/soundproc.pdf).
		 *         Additional reference by [Miller Pucket](http://msp.ucsd.edu/techniques/v0.11/book-html/node115.html).
		 *         
		 *  @extends {Tone.FeedbackEffect}
		 *  @param {Interval=} pitch The interval to transpose the incoming signal by. 
		 */
	    Tone.PitchShift = function () {
	        var options = this.optionsObject(arguments, ['pitch'], Tone.PitchShift.defaults);
	        Tone.FeedbackEffect.call(this, options);
	        /**
			 *  The pitch signal
			 *  @type  {Tone.Signal}
			 *  @private
			 */
	        this._frequency = new Tone.Signal(0);
	        /**
			 *  Uses two DelayNodes to cover up the jump in
			 *  the sawtooth wave. 
			 *  @type  {DelayNode}
			 *  @private
			 */
	        this._delayA = new Tone.Delay(0, 1);
	        /**
			 *  The first LFO.
			 *  @type  {Tone.LFO}
			 *  @private
			 */
	        this._lfoA = new Tone.LFO({
	            'min': 0,
	            'max': 0.1,
	            'type': 'sawtooth'
	        }).connect(this._delayA.delayTime);
	        /**
			 *  The second DelayNode
			 *  @type  {DelayNode}
			 *  @private
			 */
	        this._delayB = new Tone.Delay(0, 1);
	        /**
			 *  The first LFO.
			 *  @type  {Tone.LFO}
			 *  @private
			 */
	        this._lfoB = new Tone.LFO({
	            'min': 0,
	            'max': 0.1,
	            'type': 'sawtooth',
	            'phase': 180
	        }).connect(this._delayB.delayTime);
	        /**
			 *  Crossfade quickly between the two delay lines
			 *  to cover up the jump in the sawtooth wave
			 *  @type  {Tone.CrossFade}
			 *  @private
			 */
	        this._crossFade = new Tone.CrossFade();
	        /**
			 *  LFO which alternates between the two
			 *  delay lines to cover up the disparity in the
			 *  sawtooth wave. 
			 *  @type  {Tone.LFO}
			 *  @private
			 */
	        this._crossFadeLFO = new Tone.LFO({
	            'min': 0,
	            'max': 1,
	            'type': 'triangle',
	            'phase': 90
	        }).connect(this._crossFade.fade);
	        /**
			 *  The delay node
			 *  @type {Tone.Delay}
			 *  @private
			 */
	        this._feedbackDelay = new Tone.Delay(options.delayTime);
	        /**
			 *  The amount of delay on the input signal
			 *  @type {Time}
			 *  @signal
			 */
	        this.delayTime = this._feedbackDelay.delayTime;
	        this._readOnly('delayTime');
	        /**
			 *  Hold the current pitch
			 *  @type {Number}
			 *  @private
			 */
	        this._pitch = options.pitch;
	        /**
			 *  Hold the current windowSize
			 *  @type {Number}
			 *  @private
			 */
	        this._windowSize = options.windowSize;
	        //connect the two delay lines up
	        this._delayA.connect(this._crossFade.a);
	        this._delayB.connect(this._crossFade.b);
	        //connect the frequency
	        this._frequency.fan(this._lfoA.frequency, this._lfoB.frequency, this._crossFadeLFO.frequency);
	        //route the input
	        this.effectSend.fan(this._delayA, this._delayB);
	        this._crossFade.chain(this._feedbackDelay, this.effectReturn);
	        //start the LFOs at the same time
	        var now = this.now();
	        this._lfoA.start(now);
	        this._lfoB.start(now);
	        this._crossFadeLFO.start(now);
	        //set the initial value
	        this.windowSize = this._windowSize;
	    };
	    Tone.extend(Tone.PitchShift, Tone.FeedbackEffect);
	    /**
		 *  default values
		 *  @static
		 *  @type {Object}
		 *  @const
		 */
	    Tone.PitchShift.defaults = {
	        'pitch': 0,
	        'windowSize': 0.1,
	        'delayTime': 0,
	        'feedback': 0
	    };
	    /**
		 * Repitch the incoming signal by some interval (measured
		 * in semi-tones). 
		 * @memberOf Tone.PitchShift#
		 * @type {Interval}
		 * @name pitch
		 * @example
		 * pitchShift.pitch = -12; //down one octave
		 * pitchShift.pitch = 7; //up a fifth
		 */
	    Object.defineProperty(Tone.PitchShift.prototype, 'pitch', {
	        get: function () {
	            return this._pitch;
	        },
	        set: function (interval) {
	            this._pitch = interval;
	            var factor = 0;
	            if (interval < 0) {
	                this._lfoA.min = 0;
	                this._lfoA.max = this._windowSize;
	                this._lfoB.min = 0;
	                this._lfoB.max = this._windowSize;
	                factor = this.intervalToFrequencyRatio(interval - 1) + 1;
	            } else {
	                this._lfoA.min = this._windowSize;
	                this._lfoA.max = 0;
	                this._lfoB.min = this._windowSize;
	                this._lfoB.max = 0;
	                factor = this.intervalToFrequencyRatio(interval) - 1;
	            }
	            this._frequency.value = factor * (1.2 / this._windowSize);
	        }
	    });
	    /**
		 * The window size corresponds roughly to the sample length in a looping sampler. 
		 * Smaller values are desirable for a less noticeable delay time of the pitch shifted
		 * signal, but larger values will result in smoother pitch shifting for larger intervals. 
		 * A nominal range of 0.03 to 0.1 is recommended. 
		 * @memberOf Tone.PitchShift#
		 * @type {Time}
		 * @name windowSize
		 * @example
		 * pitchShift.windowSize = 0.1;
		 */
	    Object.defineProperty(Tone.PitchShift.prototype, 'windowSize', {
	        get: function () {
	            return this._windowSize;
	        },
	        set: function (size) {
	            this._windowSize = this.toSeconds(size);
	            this.pitch = this._pitch;
	        }
	    });
	    /**
		 *  Clean up.
		 *  @return  {Tone.PitchShift}  this
		 */
	    Tone.PitchShift.prototype.dispose = function () {
	        Tone.FeedbackEffect.prototype.dispose.call(this);
	        this._frequency.dispose();
	        this._frequency = null;
	        this._delayA.disconnect();
	        this._delayA = null;
	        this._delayB.disconnect();
	        this._delayB = null;
	        this._lfoA.dispose();
	        this._lfoA = null;
	        this._lfoB.dispose();
	        this._lfoB = null;
	        this._crossFade.dispose();
	        this._crossFade = null;
	        this._crossFadeLFO.dispose();
	        this._crossFadeLFO = null;
	        this._writable('delayTime');
	        this._feedbackDelay.dispose();
	        this._feedbackDelay = null;
	        this.delayTime = null;
	        return this;
	    };
	    return Tone.PitchShift;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Base class for stereo feedback effects where the effectReturn
		 *         is fed back into the same channel. 
		 *
		 *	@constructor
		 *	@extends {Tone.FeedbackEffect}
		 */
	    Tone.StereoFeedbackEffect = function () {
	        var options = this.optionsObject(arguments, ['feedback'], Tone.FeedbackEffect.defaults);
	        Tone.StereoEffect.call(this, options);
	        /**
			 *  controls the amount of feedback
			 *  @type {NormalRange}
			 *  @signal
			 */
	        this.feedback = new Tone.Signal(options.feedback, Tone.Type.NormalRange);
	        /**
			 *  the left side feeback
			 *  @type {Tone.Gain}
			 *  @private
			 */
	        this._feedbackL = new Tone.Gain();
	        /**
			 *  the right side feeback
			 *  @type {Tone.Gain}
			 *  @private
			 */
	        this._feedbackR = new Tone.Gain();
	        //connect it up
	        this.effectReturnL.chain(this._feedbackL, this.effectSendL);
	        this.effectReturnR.chain(this._feedbackR, this.effectSendR);
	        this.feedback.fan(this._feedbackL.gain, this._feedbackR.gain);
	        this._readOnly(['feedback']);
	    };
	    Tone.extend(Tone.StereoFeedbackEffect, Tone.FeedbackEffect);
	    /**
		 *  clean up
		 *  @returns {Tone.StereoFeedbackEffect} this
		 */
	    Tone.StereoFeedbackEffect.prototype.dispose = function () {
	        Tone.StereoEffect.prototype.dispose.call(this);
	        this._writable(['feedback']);
	        this.feedback.dispose();
	        this.feedback = null;
	        this._feedbackL.dispose();
	        this._feedbackL = null;
	        this._feedbackR.dispose();
	        this._feedbackR = null;
	        return this;
	    };
	    return Tone.StereoFeedbackEffect;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Applies a width factor to the mid/side seperation. 
		 *         0 is all mid and 1 is all side.
		 *         Algorithm found in [kvraudio forums](http://www.kvraudio.com/forum/viewtopic.php?t=212587).
		 *         <br><br>
		 *         <code>
		 *         Mid *= 2*(1-width)<br>
		 *         Side *= 2*width
		 *         </code>
		 *
		 *  @extends {Tone.MidSideEffect}
		 *  @constructor
		 *  @param {NormalRange|Object} [width] The stereo width. A width of 0 is mono and 1 is stereo. 0.5 is no change.
		 */
	    Tone.StereoWidener = function () {
	        var options = this.optionsObject(arguments, ['width'], Tone.StereoWidener.defaults);
	        Tone.MidSideEffect.call(this, options);
	        /**
			 *  The width control. 0 = 100% mid. 1 = 100% side. 0.5 = no change. 
			 *  @type {NormalRange}
			 *  @signal
			 */
	        this.width = new Tone.Signal(options.width, Tone.Type.NormalRange);
	        /**
			 *  Mid multiplier
			 *  @type {Tone.Expr}
			 *  @private
			 */
	        this._midMult = new Tone.Expr('$0 * ($1 * (1 - $2))');
	        /**
			 *  Side multiplier
			 *  @type {Tone.Expr}
			 *  @private
			 */
	        this._sideMult = new Tone.Expr('$0 * ($1 * $2)');
	        /**
			 *  constant output of 2
			 *  @type {Tone}
			 *  @private
			 */
	        this._two = new Tone.Signal(2);
	        //the mid chain
	        this._two.connect(this._midMult, 0, 1);
	        this.width.connect(this._midMult, 0, 2);
	        //the side chain
	        this._two.connect(this._sideMult, 0, 1);
	        this.width.connect(this._sideMult, 0, 2);
	        //connect it to the effect send/return
	        this.midSend.chain(this._midMult, this.midReturn);
	        this.sideSend.chain(this._sideMult, this.sideReturn);
	        this._readOnly(['width']);
	    };
	    Tone.extend(Tone.StereoWidener, Tone.MidSideEffect);
	    /**
		 *  the default values
		 *  @static
		 *  @type {Object}
		 */
	    Tone.StereoWidener.defaults = { 'width': 0.5 };
	    /**
		 *  Clean up. 
		 *  @returns {Tone.StereoWidener} this
		 */
	    Tone.StereoWidener.prototype.dispose = function () {
	        Tone.MidSideEffect.prototype.dispose.call(this);
	        this._writable(['width']);
	        this.width.dispose();
	        this.width = null;
	        this._midMult.dispose();
	        this._midMult = null;
	        this._sideMult.dispose();
	        this._sideMult = null;
	        this._two.dispose();
	        this._two = null;
	        return this;
	    };
	    return Tone.StereoWidener;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Tone.Tremolo modulates the amplitude of an incoming signal using a Tone.LFO.
		 *         The type, frequency, and depth of the LFO is controllable.
		 *
		 *  @extends {Tone.StereoEffect}
		 *  @constructor
		 *  @param {Frequency} [frequency] The rate of the effect.
		 *  @param {NormalRange} [depth] The depth of the effect.
		 *  @example
		 * //create a tremolo and start it's LFO
		 * var tremolo = new Tone.Tremolo(9, 0.75).toMaster().start();
		 * //route an oscillator through the tremolo and start it
		 * var oscillator = new Tone.Oscillator().connect(tremolo).start();
		 */
	    Tone.Tremolo = function () {
	        var options = this.optionsObject(arguments, [
	            'frequency',
	            'depth'
	        ], Tone.Tremolo.defaults);
	        Tone.StereoEffect.call(this, options);
	        /**
			 *  The tremelo LFO in the left channel
			 *  @type  {Tone.LFO}
			 *  @private
			 */
	        this._lfoL = new Tone.LFO({
	            'phase': options.spread,
	            'min': 1,
	            'max': 0
	        });
	        /**
			 *  The tremelo LFO in the left channel
			 *  @type  {Tone.LFO}
			 *  @private
			 */
	        this._lfoR = new Tone.LFO({
	            'phase': options.spread,
	            'min': 1,
	            'max': 0
	        });
	        /**
			 *  Where the gain is multiplied
			 *  @type  {Tone.Gain}
			 *  @private
			 */
	        this._amplitudeL = new Tone.Gain();
	        /**
			 *  Where the gain is multiplied
			 *  @type  {Tone.Gain}
			 *  @private
			 */
	        this._amplitudeR = new Tone.Gain();
	        /**
			 *  The frequency of the tremolo.
			 *  @type  {Frequency}
			 *  @signal
			 */
	        this.frequency = new Tone.Signal(options.frequency, Tone.Type.Frequency);
	        /**
			 *  The depth of the effect. A depth of 0, has no effect
			 *  on the amplitude, and a depth of 1 makes the amplitude
			 *  modulate fully between 0 and 1.
			 *  @type  {NormalRange}
			 *  @signal
			 */
	        this.depth = new Tone.Signal(options.depth, Tone.Type.NormalRange);
	        this._readOnly([
	            'frequency',
	            'depth'
	        ]);
	        this.effectSendL.chain(this._amplitudeL, this.effectReturnL);
	        this.effectSendR.chain(this._amplitudeR, this.effectReturnR);
	        this._lfoL.connect(this._amplitudeL.gain);
	        this._lfoR.connect(this._amplitudeR.gain);
	        this.frequency.fan(this._lfoL.frequency, this._lfoR.frequency);
	        this.depth.fan(this._lfoR.amplitude, this._lfoL.amplitude);
	        this.type = options.type;
	        this.spread = options.spread;
	    };
	    Tone.extend(Tone.Tremolo, Tone.StereoEffect);
	    /**
		 *  @static
		 *  @const
		 *  @type {Object}
		 */
	    Tone.Tremolo.defaults = {
	        'frequency': 10,
	        'type': 'sine',
	        'depth': 0.5,
	        'spread': 180
	    };
	    /**
		 * Start the tremolo.
		 * @param {Time} [time=now] When the tremolo begins.
		 * @returns {Tone.Tremolo} this
		 */
	    Tone.Tremolo.prototype.start = function (time) {
	        this._lfoL.start(time);
	        this._lfoR.start(time);
	        return this;
	    };
	    /**
		 * Stop the tremolo.
		 * @param {Time} [time=now] When the tremolo stops.
		 * @returns {Tone.Tremolo} this
		 */
	    Tone.Tremolo.prototype.stop = function (time) {
	        this._lfoL.stop(time);
	        this._lfoR.stop(time);
	        return this;
	    };
	    /**
		 * Sync the effect to the transport.
		 * @param {Time} [delay=0] Delay time before starting the effect after the
		 *                              Transport has started.
		 * @returns {Tone.AutoFilter} this
		 */
	    Tone.Tremolo.prototype.sync = function (delay) {
	        this._lfoL.sync(delay);
	        this._lfoR.sync(delay);
	        return this;
	    };
	    /**
		 * Unsync the filter from the transport
		 * @returns {Tone.Tremolo} this
		 */
	    Tone.Tremolo.prototype.unsync = function () {
	        this._lfoL.unsync();
	        this._lfoR.unsync();
	        return this;
	    };
	    /**
		 * The Tremolo's oscillator type.
		 * @memberOf Tone.Tremolo#
		 * @type {string}
		 * @name type
		 */
	    Object.defineProperty(Tone.Tremolo.prototype, 'type', {
	        get: function () {
	            return this._lfoL.type;
	        },
	        set: function (type) {
	            this._lfoL.type = type;
	            this._lfoR.type = type;
	        }
	    });
	    /** 
		 * Amount of stereo spread. When set to 0, both LFO's will be panned centrally.
		 * When set to 180, LFO's will be panned hard left and right respectively.
		 * @memberOf Tone.Tremolo#
		 * @type {Degrees}
		 * @name spread
		 */
	    Object.defineProperty(Tone.Tremolo.prototype, 'spread', {
	        get: function () {
	            return this._lfoR.phase - this._lfoL.phase;    //180
	        },
	        set: function (spread) {
	            this._lfoL.phase = 90 - spread / 2;
	            this._lfoR.phase = spread / 2 + 90;
	        }
	    });
	    /**
		 *  clean up
		 *  @returns {Tone.Tremolo} this
		 */
	    Tone.Tremolo.prototype.dispose = function () {
	        Tone.StereoEffect.prototype.dispose.call(this);
	        this._writable([
	            'frequency',
	            'depth'
	        ]);
	        this._lfoL.dispose();
	        this._lfoL = null;
	        this._lfoR.dispose();
	        this._lfoR = null;
	        this._amplitudeL.dispose();
	        this._amplitudeL = null;
	        this._amplitudeR.dispose();
	        this._amplitudeR = null;
	        this.frequency = null;
	        this.depth = null;
	        return this;
	    };
	    return Tone.Tremolo;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class A Vibrato effect composed of a Tone.Delay and a Tone.LFO. The LFO
		 *         modulates the delayTime of the delay, causing the pitch to rise
		 *         and fall. 
		 *  @extends {Tone.Effect}
		 *  @param {Frequency} frequency The frequency of the vibrato.
		 *  @param {NormalRange} depth The amount the pitch is modulated.
		 */
	    Tone.Vibrato = function () {
	        var options = this.optionsObject(arguments, [
	            'frequency',
	            'depth'
	        ], Tone.Vibrato.defaults);
	        Tone.Effect.call(this, options);
	        /**
			 *  The delay node used for the vibrato effect
			 *  @type {Tone.Delay}
			 *  @private
			 */
	        this._delayNode = new Tone.Delay(0, options.maxDelay);
	        /**
			 *  The LFO used to control the vibrato
			 *  @type {Tone.LFO}
			 *  @private
			 */
	        this._lfo = new Tone.LFO({
	            'type': options.type,
	            'min': 0,
	            'max': options.maxDelay,
	            'frequency': options.frequency,
	            'phase': -90    //offse the phase so the resting position is in the center
	        }).start().connect(this._delayNode.delayTime);
	        /**
			 *  The frequency of the vibrato
			 *  @type {Frequency}
			 *  @signal
			 */
	        this.frequency = this._lfo.frequency;
	        /**
			 *  The depth of the vibrato. 
			 *  @type {NormalRange}
			 *  @signal
			 */
	        this.depth = this._lfo.amplitude;
	        this.depth.value = options.depth;
	        this._readOnly([
	            'frequency',
	            'depth'
	        ]);
	        this.effectSend.chain(this._delayNode, this.effectReturn);
	    };
	    Tone.extend(Tone.Vibrato, Tone.Effect);
	    /**
		 *  The defaults
		 *  @type  {Object}
		 *  @const
		 */
	    Tone.Vibrato.defaults = {
	        'maxDelay': 0.005,
	        'frequency': 5,
	        'depth': 0.1,
	        'type': 'sine'
	    };
	    /**
		 * Type of oscillator attached to the Vibrato.
		 * @memberOf Tone.Vibrato#
		 * @type {string}
		 * @name type
		 */
	    Object.defineProperty(Tone.Vibrato.prototype, 'type', {
	        get: function () {
	            return this._lfo.type;
	        },
	        set: function (type) {
	            this._lfo.type = type;
	        }
	    });
	    /**
		 *  Clean up.
		 *  @returns {Tone.Vibrato} this
		 */
	    Tone.Vibrato.prototype.dispose = function () {
	        Tone.Effect.prototype.dispose.call(this);
	        this._delayNode.dispose();
	        this._delayNode = null;
	        this._lfo.dispose();
	        this._lfo = null;
	        this._writable([
	            'frequency',
	            'depth'
	        ]);
	        this.frequency = null;
	        this.depth = null;
	    };
	    return Tone.Vibrato;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  Tone.Event abstracts away Tone.Transport.schedule and provides a schedulable
		 *          callback for a single or repeatable events along the timeline. 
		 *
		 *  @extends {Tone}
		 *  @param {function} callback The callback to invoke at the time. 
		 *  @param {*} value The value or values which should be passed to
		 *                      the callback function on invocation.  
		 *  @example
		 * var chord = new Tone.Event(function(time, chord){
		 * 	//the chord as well as the exact time of the event
		 * 	//are passed in as arguments to the callback function
		 * }, ["D4", "E4", "F4"]);
		 * //start the chord at the beginning of the transport timeline
		 * chord.start();
		 * //loop it every measure for 8 measures
		 * chord.loop = 8;
		 * chord.loopEnd = "1m";
		 */
	    Tone.Event = function () {
	        var options = this.optionsObject(arguments, [
	            'callback',
	            'value'
	        ], Tone.Event.defaults);
	        /**
			 *  Loop value
			 *  @type  {Boolean|Positive}
			 *  @private
			 */
	        this._loop = options.loop;
	        /**
			 *  The callback to invoke. 
			 *  @type  {Function}
			 */
	        this.callback = options.callback;
	        /**
			 *  The value which is passed to the
			 *  callback function.
			 *  @type  {*}
			 *  @private
			 */
	        this.value = options.value;
	        /**
			 *  When the note is scheduled to start.
			 *  @type  {Number}
			 *  @private
			 */
	        this._loopStart = this.toTicks(options.loopStart);
	        /**
			 *  When the note is scheduled to start.
			 *  @type  {Number}
			 *  @private
			 */
	        this._loopEnd = this.toTicks(options.loopEnd);
	        /**
			 *  Tracks the scheduled events
			 *  @type {Tone.TimelineState}
			 *  @private
			 */
	        this._state = new Tone.TimelineState(Tone.State.Stopped);
	        /**
			 *  The playback speed of the note. A speed of 1
			 *  is no change. 
			 *  @private
			 *  @type {Positive}
			 */
	        this._playbackRate = 1;
	        /**
			 *  A delay time from when the event is scheduled to start
			 *  @type {Ticks}
			 *  @private
			 */
	        this._startOffset = 0;
	        /**
			 *  The probability that the callback will be invoked
			 *  at the scheduled time. 
			 *  @type {NormalRange}
			 *  @example
			 * //the callback will be invoked 50% of the time
			 * event.probability = 0.5;
			 */
	        this.probability = options.probability;
	        /**
			 *  If set to true, will apply small (+/-0.02 seconds) random variation
			 *  to the callback time. If the value is given as a time, it will randomize
			 *  by that amount.
			 *  @example
			 * event.humanize = true;
			 *  @type {Boolean|Time}
			 */
	        this.humanize = options.humanize;
	        /**
			 *  If mute is true, the callback won't be
			 *  invoked.
			 *  @type {Boolean}
			 */
	        this.mute = options.mute;
	        //set the initial values
	        this.playbackRate = options.playbackRate;
	    };
	    Tone.extend(Tone.Event);
	    /**
		 *  The default values
		 *  @type  {Object}
		 *  @const
		 */
	    Tone.Event.defaults = {
	        'callback': Tone.noOp,
	        'loop': false,
	        'loopEnd': '1m',
	        'loopStart': 0,
	        'playbackRate': 1,
	        'value': null,
	        'probability': 1,
	        'mute': false,
	        'humanize': false
	    };
	    /**
		 *  Reschedule all of the events along the timeline
		 *  with the updated values.
		 *  @param {Time} after Only reschedules events after the given time.
		 *  @return  {Tone.Event}  this
		 *  @private
		 */
	    Tone.Event.prototype._rescheduleEvents = function (after) {
	        //if no argument is given, schedules all of the events
	        after = this.defaultArg(after, -1);
	        this._state.forEachFrom(after, function (event) {
	            var duration;
	            if (event.state === Tone.State.Started) {
	                if (!this.isUndef(event.id)) {
	                    Tone.Transport.clear(event.id);
	                }
	                var startTick = event.time + Math.round(this.startOffset / this._playbackRate);
	                if (this._loop) {
	                    duration = Infinity;
	                    if (this.isNumber(this._loop)) {
	                        duration = this._loop * this._getLoopDuration();
	                    }
	                    var nextEvent = this._state.getAfter(startTick);
	                    if (nextEvent !== null) {
	                        duration = Math.min(duration, nextEvent.time - startTick);
	                    }
	                    if (duration !== Infinity) {
	                        //schedule a stop since it's finite duration
	                        this._state.setStateAtTime(Tone.State.Stopped, startTick + duration + 1);
	                        duration = Tone.Time(duration, 'i');
	                    }
	                    var interval = Tone.Time(this._getLoopDuration(), 'i');
	                    event.id = Tone.Transport.scheduleRepeat(this._tick.bind(this), interval, Tone.TransportTime(startTick, 'i'), duration);
	                } else {
	                    event.id = Tone.Transport.schedule(this._tick.bind(this), startTick + 'i');
	                }
	            }
	        }.bind(this));
	        return this;
	    };
	    /**
		 *  Returns the playback state of the note, either "started" or "stopped".
		 *  @type {String}
		 *  @readOnly
		 *  @memberOf Tone.Event#
		 *  @name state
		 */
	    Object.defineProperty(Tone.Event.prototype, 'state', {
	        get: function () {
	            return this._state.getValueAtTime(Tone.Transport.ticks);
	        }
	    });
	    /**
		 *  The start from the scheduled start time
		 *  @type {Ticks}
		 *  @memberOf Tone.Event#
		 *  @name startOffset
		 *  @private
		 */
	    Object.defineProperty(Tone.Event.prototype, 'startOffset', {
	        get: function () {
	            return this._startOffset;
	        },
	        set: function (offset) {
	            this._startOffset = offset;
	        }
	    });
	    /**
		 *  Start the note at the given time. 
		 *  @param  {TimelinePosition}  time  When the note should start.
		 *  @return  {Tone.Event}  this
		 */
	    Tone.Event.prototype.start = function (time) {
	        time = this.toTicks(time);
	        if (this._state.getValueAtTime(time) === Tone.State.Stopped) {
	            this._state.add({
	                'state': Tone.State.Started,
	                'time': time,
	                'id': undefined
	            });
	            this._rescheduleEvents(time);
	        }
	        return this;
	    };
	    /**
		 *  Stop the Event at the given time.
		 *  @param  {TimelinePosition}  time  When the note should stop.
		 *  @return  {Tone.Event}  this
		 */
	    Tone.Event.prototype.stop = function (time) {
	        this.cancel(time);
	        time = this.toTicks(time);
	        if (this._state.getValueAtTime(time) === Tone.State.Started) {
	            this._state.setStateAtTime(Tone.State.Stopped, time);
	            var previousEvent = this._state.getBefore(time);
	            var reschedulTime = time;
	            if (previousEvent !== null) {
	                reschedulTime = previousEvent.time;
	            }
	            this._rescheduleEvents(reschedulTime);
	        }
	        return this;
	    };
	    /**
		 *  Cancel all scheduled events greater than or equal to the given time
		 *  @param  {TimelinePosition}  [time=0]  The time after which events will be cancel.
		 *  @return  {Tone.Event}  this
		 */
	    Tone.Event.prototype.cancel = function (time) {
	        time = this.defaultArg(time, -Infinity);
	        time = this.toTicks(time);
	        this._state.forEachFrom(time, function (event) {
	            Tone.Transport.clear(event.id);
	        });
	        this._state.cancel(time);
	        return this;
	    };
	    /**
		 *  The callback function invoker. Also 
		 *  checks if the Event is done playing
		 *  @param  {Number}  time  The time of the event in seconds
		 *  @private
		 */
	    Tone.Event.prototype._tick = function (time) {
	        if (!this.mute && this._state.getValueAtTime(Tone.Transport.ticks) === Tone.State.Started) {
	            if (this.probability < 1 && Math.random() > this.probability) {
	                return;
	            }
	            if (this.humanize) {
	                var variation = 0.02;
	                if (!this.isBoolean(this.humanize)) {
	                    variation = this.toSeconds(this.humanize);
	                }
	                time += (Math.random() * 2 - 1) * variation;
	            }
	            this.callback(time, this.value);
	        }
	    };
	    /**
		 *  Get the duration of the loop.
		 *  @return  {Ticks}
		 *  @private
		 */
	    Tone.Event.prototype._getLoopDuration = function () {
	        return Math.round((this._loopEnd - this._loopStart) / this._playbackRate);
	    };
	    /**
		 *  If the note should loop or not
		 *  between Tone.Event.loopStart and 
		 *  Tone.Event.loopEnd. An integer
		 *  value corresponds to the number of
		 *  loops the Event does after it starts.
		 *  @memberOf Tone.Event#
		 *  @type {Boolean|Positive}
		 *  @name loop
		 */
	    Object.defineProperty(Tone.Event.prototype, 'loop', {
	        get: function () {
	            return this._loop;
	        },
	        set: function (loop) {
	            this._loop = loop;
	            this._rescheduleEvents();
	        }
	    });
	    /**
		 * 	The playback rate of the note. Defaults to 1.
		 *  @memberOf Tone.Event#
		 *  @type {Positive}
		 *  @name playbackRate
		 *  @example
		 * note.loop = true;
		 * //repeat the note twice as fast
		 * note.playbackRate = 2;
		 */
	    Object.defineProperty(Tone.Event.prototype, 'playbackRate', {
	        get: function () {
	            return this._playbackRate;
	        },
	        set: function (rate) {
	            this._playbackRate = rate;
	            this._rescheduleEvents();
	        }
	    });
	    /**
		 *  The loopEnd point is the time the event will loop
		 *  if Tone.Event.loop is true.
		 *  @memberOf Tone.Event#
		 *  @type {TransportTime}
		 *  @name loopEnd
		 */
	    Object.defineProperty(Tone.Event.prototype, 'loopEnd', {
	        get: function () {
	            return Tone.TransportTime(this._loopEnd, 'i').toNotation();
	        },
	        set: function (loopEnd) {
	            this._loopEnd = this.toTicks(loopEnd);
	            if (this._loop) {
	                this._rescheduleEvents();
	            }
	        }
	    });
	    /**
		 *  The time when the loop should start. 
		 *  @memberOf Tone.Event#
		 *  @type {TransportTime}
		 *  @name loopStart
		 */
	    Object.defineProperty(Tone.Event.prototype, 'loopStart', {
	        get: function () {
	            return Tone.TransportTime(this._loopStart, 'i').toNotation();
	        },
	        set: function (loopStart) {
	            this._loopStart = this.toTicks(loopStart);
	            if (this._loop) {
	                this._rescheduleEvents();
	            }
	        }
	    });
	    /**
		 *  The current progress of the loop interval.
		 *  Returns 0 if the event is not started yet or
		 *  it is not set to loop.
		 *  @memberOf Tone.Event#
		 *  @type {NormalRange}
		 *  @name progress
		 *  @readOnly
		 */
	    Object.defineProperty(Tone.Event.prototype, 'progress', {
	        get: function () {
	            if (this._loop) {
	                var ticks = Tone.Transport.ticks;
	                var lastEvent = this._state.get(ticks);
	                if (lastEvent !== null && lastEvent.state === Tone.State.Started) {
	                    var loopDuration = this._getLoopDuration();
	                    var progress = (ticks - lastEvent.time) % loopDuration;
	                    return progress / loopDuration;
	                } else {
	                    return 0;
	                }
	            } else {
	                return 0;
	            }
	        }
	    });
	    /**
		 *  Clean up
		 *  @return  {Tone.Event}  this
		 */
	    Tone.Event.prototype.dispose = function () {
	        this.cancel();
	        this._state.dispose();
	        this._state = null;
	        this.callback = null;
	        this.value = null;
	    };
	    return Tone.Event;
	});
	Module(function (Tone) {
	    /**
		 *  @class Tone.Loop creates a looped callback at the 
		 *         specified interval. The callback can be 
		 *         started, stopped and scheduled along
		 *         the Transport's timeline. 
		 *  @example
		 * var loop = new Tone.Loop(function(time){
		 * 	//triggered every eighth note. 
		 * 	console.log(time);
		 * }, "8n").start(0);
		 * Tone.Transport.start();
		 *  @extends {Tone}
		 *  @param {Function} callback The callback to invoke with the event.
		 *  @param {Time} interval The time between successive callback calls. 
		 */
	    Tone.Loop = function () {
	        var options = this.optionsObject(arguments, [
	            'callback',
	            'interval'
	        ], Tone.Loop.defaults);
	        /**
			 *  The event which produces the callbacks
			 */
	        this._event = new Tone.Event({
	            'callback': this._tick.bind(this),
	            'loop': true,
	            'loopEnd': options.interval,
	            'playbackRate': options.playbackRate,
	            'probability': options.probability
	        });
	        /**
			 *  The callback to invoke with the next event in the pattern
			 *  @type {Function}
			 */
	        this.callback = options.callback;
	        //set the iterations
	        this.iterations = options.iterations;
	    };
	    Tone.extend(Tone.Loop);
	    /**
		 *  The defaults
		 *  @const
		 *  @type  {Object}
		 */
	    Tone.Loop.defaults = {
	        'interval': '4n',
	        'callback': Tone.noOp,
	        'playbackRate': 1,
	        'iterations': Infinity,
	        'probability': true,
	        'mute': false
	    };
	    /**
		 *  Start the loop at the specified time along the Transport's
		 *  timeline.
		 *  @param  {TimelinePosition=}  time  When to start the Loop.
		 *  @return  {Tone.Loop}  this
		 */
	    Tone.Loop.prototype.start = function (time) {
	        this._event.start(time);
	        return this;
	    };
	    /**
		 *  Stop the loop at the given time.
		 *  @param  {TimelinePosition=}  time  When to stop the Arpeggio
		 *  @return  {Tone.Loop}  this
		 */
	    Tone.Loop.prototype.stop = function (time) {
	        this._event.stop(time);
	        return this;
	    };
	    /**
		 *  Cancel all scheduled events greater than or equal to the given time
		 *  @param  {TimelinePosition}  [time=0]  The time after which events will be cancel.
		 *  @return  {Tone.Loop}  this
		 */
	    Tone.Loop.prototype.cancel = function (time) {
	        this._event.cancel(time);
	        return this;
	    };
	    /**
		 *  Internal function called when the notes should be called
		 *  @param  {Number}  time  The time the event occurs
		 *  @private
		 */
	    Tone.Loop.prototype._tick = function (time) {
	        this.callback(time);
	    };
	    /**
		 *  The state of the Loop, either started or stopped.
		 *  @memberOf Tone.Loop#
		 *  @type {String}
		 *  @name state
		 *  @readOnly
		 */
	    Object.defineProperty(Tone.Loop.prototype, 'state', {
	        get: function () {
	            return this._event.state;
	        }
	    });
	    /**
		 *  The progress of the loop as a value between 0-1. 0, when
		 *  the loop is stopped or done iterating. 
		 *  @memberOf Tone.Loop#
		 *  @type {NormalRange}
		 *  @name progress
		 *  @readOnly
		 */
	    Object.defineProperty(Tone.Loop.prototype, 'progress', {
	        get: function () {
	            return this._event.progress;
	        }
	    });
	    /**
		 *  The time between successive callbacks. 
		 *  @example
		 * loop.interval = "8n"; //loop every 8n
		 *  @memberOf Tone.Loop#
		 *  @type {Time}
		 *  @name interval
		 */
	    Object.defineProperty(Tone.Loop.prototype, 'interval', {
	        get: function () {
	            return this._event.loopEnd;
	        },
	        set: function (interval) {
	            this._event.loopEnd = interval;
	        }
	    });
	    /**
		 *  The playback rate of the loop. The normal playback rate is 1 (no change). 
		 *  A `playbackRate` of 2 would be twice as fast. 
		 *  @memberOf Tone.Loop#
		 *  @type {Time}
		 *  @name playbackRate
		 */
	    Object.defineProperty(Tone.Loop.prototype, 'playbackRate', {
	        get: function () {
	            return this._event.playbackRate;
	        },
	        set: function (rate) {
	            this._event.playbackRate = rate;
	        }
	    });
	    /**
		 *  Random variation +/-0.01s to the scheduled time. 
		 *  Or give it a time value which it will randomize by.
		 *  @type {Boolean|Time}
		 *  @memberOf Tone.Loop#
		 *  @name humanize
		 */
	    Object.defineProperty(Tone.Loop.prototype, 'humanize', {
	        get: function () {
	            return this._event.humanize;
	        },
	        set: function (variation) {
	            this._event.humanize = variation;
	        }
	    });
	    /**
		 *  The probably of the callback being invoked.
		 *  @memberOf Tone.Loop#
		 *  @type {NormalRange}
		 *  @name probability
		 */
	    Object.defineProperty(Tone.Loop.prototype, 'probability', {
	        get: function () {
	            return this._event.probability;
	        },
	        set: function (prob) {
	            this._event.probability = prob;
	        }
	    });
	    /**
		 *  Muting the Loop means that no callbacks are invoked.
		 *  @memberOf Tone.Loop#
		 *  @type {Boolean}
		 *  @name mute
		 */
	    Object.defineProperty(Tone.Loop.prototype, 'mute', {
	        get: function () {
	            return this._event.mute;
	        },
	        set: function (mute) {
	            this._event.mute = mute;
	        }
	    });
	    /**
		 *  The number of iterations of the loop. The default
		 *  value is Infinity (loop forever).
		 *  @memberOf Tone.Loop#
		 *  @type {Positive}
		 *  @name iterations
		 */
	    Object.defineProperty(Tone.Loop.prototype, 'iterations', {
	        get: function () {
	            if (this._event.loop === true) {
	                return Infinity;
	            } else {
	                return this._event.loop;
	            }
	            return this._pattern.index;
	        },
	        set: function (iters) {
	            if (iters === Infinity) {
	                this._event.loop = true;
	            } else {
	                this._event.loop = iters;
	            }
	        }
	    });
	    /**
		 *  Clean up
		 *  @return  {Tone.Loop}  this
		 */
	    Tone.Loop.prototype.dispose = function () {
	        this._event.dispose();
	        this._event = null;
	        this.callback = null;
	    };
	    return Tone.Loop;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Tone.Part is a collection Tone.Events which can be
		 *         started/stoped and looped as a single unit.
		 *
		 *  @extends {Tone.Event}
		 *  @param {Function} callback The callback to invoke on each event
		 *  @param {Array} events the array of events
		 *  @example
		 * var part = new Tone.Part(function(time, note){
		 * 	//the notes given as the second element in the array
		 * 	//will be passed in as the second argument
		 * 	synth.triggerAttackRelease(note, "8n", time);
		 * }, [[0, "C2"], ["0:2", "C3"], ["0:3:2", "G2"]]);
		 *  @example
		 * //use an array of objects as long as the object has a "time" attribute
		 * var part = new Tone.Part(function(time, value){
		 * 	//the value is an object which contains both the note and the velocity
		 * 	synth.triggerAttackRelease(value.note, "8n", time, value.velocity);
		 * }, [{"time" : 0, "note" : "C3", "velocity": 0.9}, 
		 * 	   {"time" : "0:2", "note" : "C4", "velocity": 0.5}
		 * ]).start(0);
		 */
	    Tone.Part = function () {
	        var options = this.optionsObject(arguments, [
	            'callback',
	            'events'
	        ], Tone.Part.defaults);
	        /**
			 *  If the part is looping or not
			 *  @type  {Boolean|Positive}
			 *  @private
			 */
	        this._loop = options.loop;
	        /**
			 *  When the note is scheduled to start.
			 *  @type  {Ticks}
			 *  @private
			 */
	        this._loopStart = this.toTicks(options.loopStart);
	        /**
			 *  When the note is scheduled to start.
			 *  @type  {Ticks}
			 *  @private
			 */
	        this._loopEnd = this.toTicks(options.loopEnd);
	        /**
			 *  The playback rate of the part
			 *  @type  {Positive}
			 *  @private
			 */
	        this._playbackRate = options.playbackRate;
	        /**
			 *  private holder of probability value
			 *  @type {NormalRange}
			 *  @private
			 */
	        this._probability = options.probability;
	        /**
			 *  the amount of variation from the
			 *  given time. 
			 *  @type {Boolean|Time}
			 *  @private
			 */
	        this._humanize = options.humanize;
	        /**
			 *  The start offset
			 *  @type {Ticks}
			 *  @private
			 */
	        this._startOffset = 0;
	        /**
			 *  Keeps track of the current state
			 *  @type {Tone.TimelineState}
			 *  @private
			 */
	        this._state = new Tone.TimelineState(Tone.State.Stopped);
	        /**
			 *  An array of Objects. 
			 *  @type  {Array}
			 *  @private
			 */
	        this._events = [];
	        /**
			 *  The callback to invoke at all the scheduled events.
			 *  @type {Function}
			 */
	        this.callback = options.callback;
	        /**
			 *  If mute is true, the callback won't be
			 *  invoked.
			 *  @type {Boolean}
			 */
	        this.mute = options.mute;
	        //add the events
	        var events = this.defaultArg(options.events, []);
	        if (!this.isUndef(options.events)) {
	            for (var i = 0; i < events.length; i++) {
	                if (Array.isArray(events[i])) {
	                    this.add(events[i][0], events[i][1]);
	                } else {
	                    this.add(events[i]);
	                }
	            }
	        }
	    };
	    Tone.extend(Tone.Part, Tone.Event);
	    /**
		 *  The default values
		 *  @type  {Object}
		 *  @const
		 */
	    Tone.Part.defaults = {
	        'callback': Tone.noOp,
	        'loop': false,
	        'loopEnd': '1m',
	        'loopStart': 0,
	        'playbackRate': 1,
	        'probability': 1,
	        'humanize': false,
	        'mute': false
	    };
	    /**
		 *  Start the part at the given time. 
		 *  @param  {TransportTime}  time    When to start the part.
		 *  @param  {Time=}  offset  The offset from the start of the part
		 *                           to begin playing at.
		 *  @return  {Tone.Part}  this
		 */
	    Tone.Part.prototype.start = function (time, offset) {
	        var ticks = this.toTicks(time);
	        if (this._state.getValueAtTime(ticks) !== Tone.State.Started) {
	            if (this._loop) {
	                offset = this.defaultArg(offset, this._loopStart);
	            } else {
	                offset = this.defaultArg(offset, 0);
	            }
	            offset = this.toTicks(offset);
	            this._state.add({
	                'state': Tone.State.Started,
	                'time': ticks,
	                'offset': offset
	            });
	            this._forEach(function (event) {
	                this._startNote(event, ticks, offset);
	            });
	        }
	        return this;
	    };
	    /**
		 *  Start the event in the given event at the correct time given
		 *  the ticks and offset and looping.
		 *  @param  {Tone.Event}  event 
		 *  @param  {Ticks}  ticks
		 *  @param  {Ticks}  offset
		 *  @private
		 */
	    Tone.Part.prototype._startNote = function (event, ticks, offset) {
	        ticks -= offset;
	        if (this._loop) {
	            if (event.startOffset >= this._loopStart && event.startOffset < this._loopEnd) {
	                if (event.startOffset < offset) {
	                    //start it on the next loop
	                    ticks += this._getLoopDuration();
	                }
	                event.start(Tone.TransportTime(ticks, 'i'));
	            } else if (event.startOffset < this._loopStart && event.startOffset >= offset) {
	                event.loop = false;
	                event.start(Tone.TransportTime(ticks, 'i'));
	            }
	        } else {
	            if (event.startOffset >= offset) {
	                event.start(Tone.TransportTime(ticks, 'i'));
	            }
	        }
	    };
	    /**
		 *  The start from the scheduled start time
		 *  @type {Ticks}
		 *  @memberOf Tone.Part#
		 *  @name startOffset
		 *  @private
		 */
	    Object.defineProperty(Tone.Part.prototype, 'startOffset', {
	        get: function () {
	            return this._startOffset;
	        },
	        set: function (offset) {
	            this._startOffset = offset;
	            this._forEach(function (event) {
	                event.startOffset += this._startOffset;
	            });
	        }
	    });
	    /**
		 *  Stop the part at the given time.
		 *  @param  {TimelinePosition}  time  When to stop the part.
		 *  @return  {Tone.Part}  this
		 */
	    Tone.Part.prototype.stop = function (time) {
	        var ticks = this.toTicks(time);
	        this._state.cancel(ticks);
	        this._state.setStateAtTime(Tone.State.Stopped, ticks);
	        this._forEach(function (event) {
	            event.stop(time);
	        });
	        return this;
	    };
	    /**
		 *  Get/Set an Event's value at the given time. 
		 *  If a value is passed in and no event exists at
		 *  the given time, one will be created with that value. 
		 *  If two events are at the same time, the first one will
		 *  be returned.
		 *  @example
		 * part.at("1m"); //returns the part at the first measure
		 *
		 * part.at("2m", "C2"); //set the value at "2m" to C2. 
		 * //if an event didn't exist at that time, it will be created.
		 *  @param {TransportTime} time The time of the event to get or set.
		 *  @param {*=} value If a value is passed in, the value of the
		 *                    event at the given time will be set to it.
		 *  @return {Tone.Event} the event at the time
		 */
	    Tone.Part.prototype.at = function (time, value) {
	        time = Tone.TransportTime(time);
	        var tickTime = Tone.Time(1, 'i').toSeconds();
	        for (var i = 0; i < this._events.length; i++) {
	            var event = this._events[i];
	            if (Math.abs(time.toTicks() - event.startOffset) < tickTime) {
	                if (!this.isUndef(value)) {
	                    event.value = value;
	                }
	                return event;
	            }
	        }
	        //if there was no event at that time, create one
	        if (!this.isUndef(value)) {
	            this.add(time, value);
	            //return the new event
	            return this._events[this._events.length - 1];
	        } else {
	            return null;
	        }
	    };
	    /**
		 *  Add a an event to the part. 
		 *  @param {Time} time The time the note should start.
		 *                            If an object is passed in, it should
		 *                            have a 'time' attribute and the rest
		 *                            of the object will be used as the 'value'.
		 *  @param  {Tone.Event|*}  value 
		 *  @returns {Tone.Part} this
		 *  @example
		 * part.add("1m", "C#+11");
		 */
	    Tone.Part.prototype.add = function (time, value) {
	        //extract the parameters
	        if (time.hasOwnProperty('time')) {
	            value = time;
	            time = value.time;
	        }
	        time = this.toTicks(time);
	        var event;
	        if (value instanceof Tone.Event) {
	            event = value;
	            event.callback = this._tick.bind(this);
	        } else {
	            event = new Tone.Event({
	                'callback': this._tick.bind(this),
	                'value': value
	            });
	        }
	        //the start offset
	        event.startOffset = time;
	        //initialize the values
	        event.set({
	            'loopEnd': this.loopEnd,
	            'loopStart': this.loopStart,
	            'loop': this.loop,
	            'humanize': this.humanize,
	            'playbackRate': this.playbackRate,
	            'probability': this.probability
	        });
	        this._events.push(event);
	        //start the note if it should be played right now
	        this._restartEvent(event);
	        return this;
	    };
	    /**
		 *  Restart the given event
		 *  @param  {Tone.Event}  event 
		 *  @private
		 */
	    Tone.Part.prototype._restartEvent = function (event) {
	        this._state.forEach(function (stateEvent) {
	            if (stateEvent.state === Tone.State.Started) {
	                this._startNote(event, stateEvent.time, stateEvent.offset);
	            } else {
	                //stop the note
	                event.stop(Tone.TransportTime(stateEvent.time, 'i'));
	            }
	        }.bind(this));
	    };
	    /**
		 *  Remove an event from the part. Will recursively iterate
		 *  into nested parts to find the event.
		 *  @param {Time} time The time of the event
		 *  @param {*} value Optionally select only a specific event value
		 *  @return  {Tone.Part}  this
		 */
	    Tone.Part.prototype.remove = function (time, value) {
	        //extract the parameters
	        if (time.hasOwnProperty('time')) {
	            value = time;
	            time = value.time;
	        }
	        time = this.toTicks(time);
	        for (var i = this._events.length - 1; i >= 0; i--) {
	            var event = this._events[i];
	            if (event instanceof Tone.Part) {
	                event.remove(time, value);
	            } else {
	                if (event.startOffset === time) {
	                    if (this.isUndef(value) || !this.isUndef(value) && event.value === value) {
	                        this._events.splice(i, 1);
	                        event.dispose();
	                    }
	                }
	            }
	        }
	        return this;
	    };
	    /**
		 *  Remove all of the notes from the group. 
		 *  @return  {Tone.Part}  this
		 */
	    Tone.Part.prototype.removeAll = function () {
	        this._forEach(function (event) {
	            event.dispose();
	        });
	        this._events = [];
	        return this;
	    };
	    /**
		 *  Cancel scheduled state change events: i.e. "start" and "stop".
		 *  @param {TimelinePosition} after The time after which to cancel the scheduled events.
		 *  @return  {Tone.Part}  this
		 */
	    Tone.Part.prototype.cancel = function (after) {
	        after = this.toTicks(after);
	        this._forEach(function (event) {
	            event.cancel(after);
	        });
	        this._state.cancel(after);
	        return this;
	    };
	    /**
		 *  Iterate over all of the events
		 *  @param {Function} callback
		 *  @param {Object} ctx The context
		 *  @private
		 */
	    Tone.Part.prototype._forEach = function (callback, ctx) {
	        ctx = this.defaultArg(ctx, this);
	        for (var i = this._events.length - 1; i >= 0; i--) {
	            var e = this._events[i];
	            if (e instanceof Tone.Part) {
	                e._forEach(callback, ctx);
	            } else {
	                callback.call(ctx, e);
	            }
	        }
	        return this;
	    };
	    /**
		 *  Set the attribute of all of the events
		 *  @param  {String}  attr  the attribute to set
		 *  @param  {*}  value      The value to set it to
		 *  @private
		 */
	    Tone.Part.prototype._setAll = function (attr, value) {
	        this._forEach(function (event) {
	            event[attr] = value;
	        });
	    };
	    /**
		 *  Internal tick method
		 *  @param  {Number}  time  The time of the event in seconds
		 *  @private
		 */
	    Tone.Part.prototype._tick = function (time, value) {
	        if (!this.mute) {
	            this.callback(time, value);
	        }
	    };
	    /**
		 *  Determine if the event should be currently looping
		 *  given the loop boundries of this Part.
		 *  @param  {Tone.Event}  event  The event to test
		 *  @private
		 */
	    Tone.Part.prototype._testLoopBoundries = function (event) {
	        if (event.startOffset < this._loopStart || event.startOffset >= this._loopEnd) {
	            event.cancel(0);
	        } else {
	            //reschedule it if it's stopped
	            if (event.state === Tone.State.Stopped) {
	                this._restartEvent(event);
	            }
	        }
	    };
	    /**
		 *  The probability of the notes being triggered.
		 *  @memberOf Tone.Part#
		 *  @type {NormalRange}
		 *  @name probability
		 */
	    Object.defineProperty(Tone.Part.prototype, 'probability', {
	        get: function () {
	            return this._probability;
	        },
	        set: function (prob) {
	            this._probability = prob;
	            this._setAll('probability', prob);
	        }
	    });
	    /**
		 *  If set to true, will apply small random variation
		 *  to the callback time. If the value is given as a time, it will randomize
		 *  by that amount.
		 *  @example
		 * event.humanize = true;
		 *  @type {Boolean|Time}
		 *  @name humanize
		 */
	    Object.defineProperty(Tone.Part.prototype, 'humanize', {
	        get: function () {
	            return this._humanize;
	        },
	        set: function (variation) {
	            this._humanize = variation;
	            this._setAll('humanize', variation);
	        }
	    });
	    /**
		 *  If the part should loop or not
		 *  between Tone.Part.loopStart and 
		 *  Tone.Part.loopEnd. An integer
		 *  value corresponds to the number of
		 *  loops the Part does after it starts.
		 *  @memberOf Tone.Part#
		 *  @type {Boolean|Positive}
		 *  @name loop
		 *  @example
		 * //loop the part 8 times
		 * part.loop = 8;
		 */
	    Object.defineProperty(Tone.Part.prototype, 'loop', {
	        get: function () {
	            return this._loop;
	        },
	        set: function (loop) {
	            this._loop = loop;
	            this._forEach(function (event) {
	                event._loopStart = this._loopStart;
	                event._loopEnd = this._loopEnd;
	                event.loop = loop;
	                this._testLoopBoundries(event);
	            });
	        }
	    });
	    /**
		 *  The loopEnd point determines when it will 
		 *  loop if Tone.Part.loop is true.
		 *  @memberOf Tone.Part#
		 *  @type {TransportTime}
		 *  @name loopEnd
		 */
	    Object.defineProperty(Tone.Part.prototype, 'loopEnd', {
	        get: function () {
	            return Tone.TransportTime(this._loopEnd, 'i').toNotation();
	        },
	        set: function (loopEnd) {
	            this._loopEnd = this.toTicks(loopEnd);
	            if (this._loop) {
	                this._forEach(function (event) {
	                    event.loopEnd = loopEnd;
	                    this._testLoopBoundries(event);
	                });
	            }
	        }
	    });
	    /**
		 *  The loopStart point determines when it will 
		 *  loop if Tone.Part.loop is true.
		 *  @memberOf Tone.Part#
		 *  @type {TransportTime}
		 *  @name loopStart
		 */
	    Object.defineProperty(Tone.Part.prototype, 'loopStart', {
	        get: function () {
	            return Tone.TransportTime(this._loopStart, 'i').toNotation();
	        },
	        set: function (loopStart) {
	            this._loopStart = this.toTicks(loopStart);
	            if (this._loop) {
	                this._forEach(function (event) {
	                    event.loopStart = this.loopStart;
	                    this._testLoopBoundries(event);
	                });
	            }
	        }
	    });
	    /**
		 * 	The playback rate of the part
		 *  @memberOf Tone.Part#
		 *  @type {Positive}
		 *  @name playbackRate
		 */
	    Object.defineProperty(Tone.Part.prototype, 'playbackRate', {
	        get: function () {
	            return this._playbackRate;
	        },
	        set: function (rate) {
	            this._playbackRate = rate;
	            this._setAll('playbackRate', rate);
	        }
	    });
	    /**
		 * 	The number of scheduled notes in the part. 
		 *  @memberOf Tone.Part#
		 *  @type {Positive}
		 *  @name length
		 *  @readOnly
		 */
	    Object.defineProperty(Tone.Part.prototype, 'length', {
	        get: function () {
	            return this._events.length;
	        }
	    });
	    /**
		 *  Clean up
		 *  @return  {Tone.Part}  this
		 */
	    Tone.Part.prototype.dispose = function () {
	        this.removeAll();
	        this._state.dispose();
	        this._state = null;
	        this.callback = null;
	        this._events = null;
	        return this;
	    };
	    return Tone.Part;
	});
	Module(function (Tone) {
	    /**
		 *  @class Tone.Pattern arpeggiates between the given notes
		 *         in a number of patterns. See Tone.CtrlPattern for
		 *         a full list of patterns.
		 *  @example
		 * var pattern = new Tone.Pattern(function(time, note){
		 *   //the order of the notes passed in depends on the pattern
		 * }, ["C2", "D4", "E5", "A6"], "upDown");
		 *  @extends {Tone.Loop}
		 *  @param {Function} callback The callback to invoke with the
		 *                             event.
		 *  @param {Array} values The values to arpeggiate over.
		 */
	    Tone.Pattern = function () {
	        var options = this.optionsObject(arguments, [
	            'callback',
	            'values',
	            'pattern'
	        ], Tone.Pattern.defaults);
	        Tone.Loop.call(this, options);
	        /**
			 *  The pattern manager
			 *  @type {Tone.CtrlPattern}
			 *  @private
			 */
	        this._pattern = new Tone.CtrlPattern({
	            'values': options.values,
	            'type': options.pattern,
	            'index': options.index
	        });
	    };
	    Tone.extend(Tone.Pattern, Tone.Loop);
	    /**
		 *  The defaults
		 *  @const
		 *  @type  {Object}
		 */
	    Tone.Pattern.defaults = {
	        'pattern': Tone.CtrlPattern.Type.Up,
	        'values': []
	    };
	    /**
		 *  Internal function called when the notes should be called
		 *  @param  {Number}  time  The time the event occurs
		 *  @private
		 */
	    Tone.Pattern.prototype._tick = function (time) {
	        this.callback(time, this._pattern.value);
	        this._pattern.next();
	    };
	    /**
		 *  The current index in the values array.
		 *  @memberOf Tone.Pattern#
		 *  @type {Positive}
		 *  @name index
		 */
	    Object.defineProperty(Tone.Pattern.prototype, 'index', {
	        get: function () {
	            return this._pattern.index;
	        },
	        set: function (i) {
	            this._pattern.index = i;
	        }
	    });
	    /**
		 *  The array of events.
		 *  @memberOf Tone.Pattern#
		 *  @type {Array}
		 *  @name values
		 */
	    Object.defineProperty(Tone.Pattern.prototype, 'values', {
	        get: function () {
	            return this._pattern.values;
	        },
	        set: function (vals) {
	            this._pattern.values = vals;
	        }
	    });
	    /**
		 *  The current value of the pattern.
		 *  @memberOf Tone.Pattern#
		 *  @type {*}
		 *  @name value
		 *  @readOnly
		 */
	    Object.defineProperty(Tone.Pattern.prototype, 'value', {
	        get: function () {
	            return this._pattern.value;
	        }
	    });
	    /**
		 *  The pattern type. See Tone.CtrlPattern for the full list of patterns.
		 *  @memberOf Tone.Pattern#
		 *  @type {String}
		 *  @name pattern
		 */
	    Object.defineProperty(Tone.Pattern.prototype, 'pattern', {
	        get: function () {
	            return this._pattern.type;
	        },
	        set: function (pattern) {
	            this._pattern.type = pattern;
	        }
	    });
	    /**
		 *  Clean up
		 *  @return  {Tone.Pattern}  this
		 */
	    Tone.Pattern.prototype.dispose = function () {
	        Tone.Loop.prototype.dispose.call(this);
	        this._pattern.dispose();
	        this._pattern = null;
	    };
	    return Tone.Pattern;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class A sequence is an alternate notation of a part. Instead
		 *         of passing in an array of [time, event] pairs, pass
		 *         in an array of events which will be spaced at the
		 *         given subdivision. Sub-arrays will subdivide that beat
		 *         by the number of items are in the array. 
		 *         Sequence notation inspiration from [Tidal](http://yaxu.org/tidal/)
		 *  @param  {Function}  callback  The callback to invoke with every note
		 *  @param  {Array}    events  The sequence
		 *  @param  {Time} subdivision  The subdivision between which events are placed. 
		 *  @extends {Tone.Part}
		 *  @example
		 * var seq = new Tone.Sequence(function(time, note){
		 * 	console.log(note);
		 * //straight quater notes
		 * }, ["C4", "E4", "G4", "A4"], "4n");
		 *  @example
		 * var seq = new Tone.Sequence(function(time, note){
		 * 	console.log(note);
		 * //subdivisions are given as subarrays
		 * }, ["C4", ["E4", "D4", "E4"], "G4", ["A4", "G4"]]);
		 */
	    Tone.Sequence = function () {
	        var options = this.optionsObject(arguments, [
	            'callback',
	            'events',
	            'subdivision'
	        ], Tone.Sequence.defaults);
	        //remove the events
	        var events = options.events;
	        delete options.events;
	        Tone.Part.call(this, options);
	        /**
			 *  The subdivison of each note
			 *  @type  {Ticks}
			 *  @private
			 */
	        this._subdivision = this.toTicks(options.subdivision);
	        //if no time was passed in, the loop end is the end of the cycle
	        if (this.isUndef(options.loopEnd) && !this.isUndef(events)) {
	            this._loopEnd = events.length * this._subdivision;
	        }
	        //defaults to looping
	        this._loop = true;
	        //add all of the events
	        if (!this.isUndef(events)) {
	            for (var i = 0; i < events.length; i++) {
	                this.add(i, events[i]);
	            }
	        }
	    };
	    Tone.extend(Tone.Sequence, Tone.Part);
	    /**
		 *  The default values.
		 *  @type  {Object}
		 */
	    Tone.Sequence.defaults = { 'subdivision': '4n' };
	    /**
		 *  The subdivision of the sequence. This can only be 
		 *  set in the constructor. The subdivision is the 
		 *  interval between successive steps. 
		 *  @type {Time}
		 *  @memberOf Tone.Sequence#
		 *  @name subdivision
		 *  @readOnly
		 */
	    Object.defineProperty(Tone.Sequence.prototype, 'subdivision', {
	        get: function () {
	            return Tone.Time(this._subdivision, 'i').toNotation();
	        }
	    });
	    /**
		 *  Get/Set an index of the sequence. If the index contains a subarray, 
		 *  a Tone.Sequence representing that sub-array will be returned. 
		 *  @example
		 * var sequence = new Tone.Sequence(playNote, ["E4", "C4", "F#4", ["A4", "Bb3"]])
		 * sequence.at(0)// => returns "E4"
		 * //set a value
		 * sequence.at(0, "G3");
		 * //get a nested sequence
		 * sequence.at(3).at(1)// => returns "Bb3"
		 * @param {Positive} index The index to get or set
		 * @param {*} value Optionally pass in the value to set at the given index.
		 */
	    Tone.Sequence.prototype.at = function (index, value) {
	        //if the value is an array, 
	        if (this.isArray(value)) {
	            //remove the current event at that index
	            this.remove(index);
	        }
	        //call the parent's method
	        return Tone.Part.prototype.at.call(this, this._indexTime(index), value);
	    };
	    /**
		 *  Add an event at an index, if there's already something
		 *  at that index, overwrite it. If `value` is an array, 
		 *  it will be parsed as a subsequence.
		 *  @param {Number} index The index to add the event to
		 *  @param {*} value The value to add at that index
		 *  @returns {Tone.Sequence} this
		 */
	    Tone.Sequence.prototype.add = function (index, value) {
	        if (value === null) {
	            return this;
	        }
	        if (this.isArray(value)) {
	            //make a subsequence and add that to the sequence
	            var subSubdivision = Math.round(this._subdivision / value.length);
	            value = new Tone.Sequence(this._tick.bind(this), value, Tone.Time(subSubdivision, 'i'));
	        }
	        Tone.Part.prototype.add.call(this, this._indexTime(index), value);
	        return this;
	    };
	    /**
		 *  Remove a value from the sequence by index
		 *  @param {Number} index The index of the event to remove
		 *  @returns {Tone.Sequence} this
		 */
	    Tone.Sequence.prototype.remove = function (index, value) {
	        Tone.Part.prototype.remove.call(this, this._indexTime(index), value);
	        return this;
	    };
	    /**
		 *  Get the time of the index given the Sequence's subdivision
		 *  @param  {Number}  index 
		 *  @return  {Time}  The time of that index
		 *  @private
		 */
	    Tone.Sequence.prototype._indexTime = function (index) {
	        if (index instanceof Tone.TransportTime) {
	            return index;
	        } else {
	            return Tone.TransportTime(index * this._subdivision + this.startOffset, 'i');
	        }
	    };
	    /**
		 *  Clean up.
		 *  @return {Tone.Sequence} this
		 */
	    Tone.Sequence.prototype.dispose = function () {
	        Tone.Part.prototype.dispose.call(this);
	        return this;
	    };
	    return Tone.Sequence;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Tone.PulseOscillator is a pulse oscillator with control over pulse width,
		 *         also known as the duty cycle. At 50% duty cycle (width = 0.5) the wave is 
		 *         a square and only odd-numbered harmonics are present. At all other widths 
		 *         even-numbered harmonics are present. Read more 
		 *         [here](https://wigglewave.wordpress.com/2014/08/16/pulse-waveforms-and-harmonics/).
		 *
		 *  @constructor
		 *  @extends {Tone.Oscillator}
		 *  @param {Frequency} [frequency] The frequency of the oscillator
		 *  @param {NormalRange} [width] The width of the pulse
		 *  @example
		 * var pulse = new Tone.PulseOscillator("E5", 0.4).toMaster().start();
		 */
	    Tone.PulseOscillator = function () {
	        var options = this.optionsObject(arguments, [
	            'frequency',
	            'width'
	        ], Tone.Oscillator.defaults);
	        Tone.Source.call(this, options);
	        /**
			 *  The width of the pulse. 
			 *  @type {NormalRange}
			 *  @signal
			 */
	        this.width = new Tone.Signal(options.width, Tone.Type.NormalRange);
	        /**
			 *  gate the width amount
			 *  @type {Tone.Gain}
			 *  @private
			 */
	        this._widthGate = new Tone.Gain();
	        /**
			 *  the sawtooth oscillator
			 *  @type {Tone.Oscillator}
			 *  @private
			 */
	        this._sawtooth = new Tone.Oscillator({
	            frequency: options.frequency,
	            detune: options.detune,
	            type: 'sawtooth',
	            phase: options.phase
	        });
	        /**
			 *  The frequency control.
			 *  @type {Frequency}
			 *  @signal
			 */
	        this.frequency = this._sawtooth.frequency;
	        /**
			 *  The detune in cents. 
			 *  @type {Cents}
			 *  @signal
			 */
	        this.detune = this._sawtooth.detune;
	        /**
			 *  Threshold the signal to turn it into a square
			 *  @type {Tone.WaveShaper}
			 *  @private
			 */
	        this._thresh = new Tone.WaveShaper(function (val) {
	            if (val < 0) {
	                return -1;
	            } else {
	                return 1;
	            }
	        });
	        //connections
	        this._sawtooth.chain(this._thresh, this.output);
	        this.width.chain(this._widthGate, this._thresh);
	        this._readOnly([
	            'width',
	            'frequency',
	            'detune'
	        ]);
	    };
	    Tone.extend(Tone.PulseOscillator, Tone.Oscillator);
	    /**
		 *  The default parameters.
		 *  @static
		 *  @const
		 *  @type {Object}
		 */
	    Tone.PulseOscillator.defaults = {
	        'frequency': 440,
	        'detune': 0,
	        'phase': 0,
	        'width': 0.2
	    };
	    /**
		 *  start the oscillator
		 *  @param  {Time} time 
		 *  @private
		 */
	    Tone.PulseOscillator.prototype._start = function (time) {
	        time = this.toSeconds(time);
	        this._sawtooth.start(time);
	        this._widthGate.gain.setValueAtTime(1, time);
	    };
	    /**
		 *  stop the oscillator
		 *  @param  {Time} time 
		 *  @private
		 */
	    Tone.PulseOscillator.prototype._stop = function (time) {
	        time = this.toSeconds(time);
	        this._sawtooth.stop(time);
	        //the width is still connected to the output. 
	        //that needs to be stopped also
	        this._widthGate.gain.setValueAtTime(0, time);
	    };
	    /**
		 * The phase of the oscillator in degrees.
		 * @memberOf Tone.PulseOscillator#
		 * @type {Degrees}
		 * @name phase
		 */
	    Object.defineProperty(Tone.PulseOscillator.prototype, 'phase', {
	        get: function () {
	            return this._sawtooth.phase;
	        },
	        set: function (phase) {
	            this._sawtooth.phase = phase;
	        }
	    });
	    /**
		 * The type of the oscillator. Always returns "pulse".
		 * @readOnly
		 * @memberOf Tone.PulseOscillator#
		 * @type {string}
		 * @name type
		 */
	    Object.defineProperty(Tone.PulseOscillator.prototype, 'type', {
	        get: function () {
	            return 'pulse';
	        }
	    });
	    /**
		 * The partials of the waveform. Cannot set partials for this waveform type
		 * @memberOf Tone.PulseOscillator#
		 * @type {Array}
		 * @name partials
		 * @private
		 */
	    Object.defineProperty(Tone.PulseOscillator.prototype, 'partials', {
	        get: function () {
	            return [];
	        }
	    });
	    /**
		 *  Clean up method.
		 *  @return {Tone.PulseOscillator} this
		 */
	    Tone.PulseOscillator.prototype.dispose = function () {
	        Tone.Source.prototype.dispose.call(this);
	        this._sawtooth.dispose();
	        this._sawtooth = null;
	        this._writable([
	            'width',
	            'frequency',
	            'detune'
	        ]);
	        this.width.dispose();
	        this.width = null;
	        this._widthGate.dispose();
	        this._widthGate = null;
	        this._thresh.dispose();
	        this._thresh = null;
	        this.frequency = null;
	        this.detune = null;
	        return this;
	    };
	    return Tone.PulseOscillator;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Tone.PWMOscillator modulates the width of a Tone.PulseOscillator 
		 *         at the modulationFrequency. This has the effect of continuously
		 *         changing the timbre of the oscillator by altering the harmonics 
		 *         generated.
		 *
		 *  @extends {Tone.Oscillator}
		 *  @constructor
		 *  @param {Frequency} frequency The starting frequency of the oscillator. 
		 *  @param {Frequency} modulationFrequency The modulation frequency of the width of the pulse. 
		 *  @example
		 *  var pwm = new Tone.PWMOscillator("Ab3", 0.3).toMaster().start();
		 */
	    Tone.PWMOscillator = function () {
	        var options = this.optionsObject(arguments, [
	            'frequency',
	            'modulationFrequency'
	        ], Tone.PWMOscillator.defaults);
	        Tone.Source.call(this, options);
	        /**
			 *  the pulse oscillator
			 *  @type {Tone.PulseOscillator}
			 *  @private
			 */
	        this._pulse = new Tone.PulseOscillator(options.modulationFrequency);
	        //change the pulse oscillator type
	        this._pulse._sawtooth.type = 'sine';
	        /**
			 *  the modulator
			 *  @type {Tone.Oscillator}
			 *  @private
			 */
	        this._modulator = new Tone.Oscillator({
	            'frequency': options.frequency,
	            'detune': options.detune,
	            'phase': options.phase
	        });
	        /**
			 *  Scale the oscillator so it doesn't go silent 
			 *  at the extreme values.
			 *  @type {Tone.Multiply}
			 *  @private
			 */
	        this._scale = new Tone.Multiply(2);
	        /**
			 *  The frequency control.
			 *  @type {Frequency}
			 *  @signal
			 */
	        this.frequency = this._modulator.frequency;
	        /**
			 *  The detune of the oscillator.
			 *  @type {Cents}
			 *  @signal
			 */
	        this.detune = this._modulator.detune;
	        /**
			 *  The modulation rate of the oscillator. 
			 *  @type {Frequency}
			 *  @signal
			 */
	        this.modulationFrequency = this._pulse.frequency;
	        //connections
	        this._modulator.chain(this._scale, this._pulse.width);
	        this._pulse.connect(this.output);
	        this._readOnly([
	            'modulationFrequency',
	            'frequency',
	            'detune'
	        ]);
	    };
	    Tone.extend(Tone.PWMOscillator, Tone.Oscillator);
	    /**
		 *  default values
		 *  @static
		 *  @type {Object}
		 *  @const
		 */
	    Tone.PWMOscillator.defaults = {
	        'frequency': 440,
	        'detune': 0,
	        'phase': 0,
	        'modulationFrequency': 0.4
	    };
	    /**
		 *  start the oscillator
		 *  @param  {Time} [time=now]
		 *  @private
		 */
	    Tone.PWMOscillator.prototype._start = function (time) {
	        time = this.toSeconds(time);
	        this._modulator.start(time);
	        this._pulse.start(time);
	    };
	    /**
		 *  stop the oscillator
		 *  @param  {Time} time (optional) timing parameter
		 *  @private
		 */
	    Tone.PWMOscillator.prototype._stop = function (time) {
	        time = this.toSeconds(time);
	        this._modulator.stop(time);
	        this._pulse.stop(time);
	    };
	    /**
		 * The type of the oscillator. Always returns "pwm".
		 * @readOnly
		 * @memberOf Tone.PWMOscillator#
		 * @type {string}
		 * @name type
		 */
	    Object.defineProperty(Tone.PWMOscillator.prototype, 'type', {
	        get: function () {
	            return 'pwm';
	        }
	    });
	    /**
		 * The partials of the waveform. Cannot set partials for this waveform type
		 * @memberOf Tone.PWMOscillator#
		 * @type {Array}
		 * @name partials
		 * @private
		 */
	    Object.defineProperty(Tone.PWMOscillator.prototype, 'partials', {
	        get: function () {
	            return [];
	        }
	    });
	    /**
		 * The phase of the oscillator in degrees.
		 * @memberOf Tone.PWMOscillator#
		 * @type {number}
		 * @name phase
		 */
	    Object.defineProperty(Tone.PWMOscillator.prototype, 'phase', {
	        get: function () {
	            return this._modulator.phase;
	        },
	        set: function (phase) {
	            this._modulator.phase = phase;
	        }
	    });
	    /**
		 *  Clean up.
		 *  @return {Tone.PWMOscillator} this
		 */
	    Tone.PWMOscillator.prototype.dispose = function () {
	        Tone.Source.prototype.dispose.call(this);
	        this._pulse.dispose();
	        this._pulse = null;
	        this._scale.dispose();
	        this._scale = null;
	        this._modulator.dispose();
	        this._modulator = null;
	        this._writable([
	            'modulationFrequency',
	            'frequency',
	            'detune'
	        ]);
	        this.frequency = null;
	        this.detune = null;
	        this.modulationFrequency = null;
	        return this;
	    };
	    return Tone.PWMOscillator;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Tone.FMOscillator 
		 *
		 *  @extends {Tone.Oscillator}
		 *  @constructor
		 *  @param {Frequency} frequency The starting frequency of the oscillator. 
		 *  @param {String} type The type of the carrier oscillator.
		 *  @param {String} modulationType The type of the modulator oscillator.
		 *  @example
		 * //a sine oscillator frequency-modulated by a square wave
		 * var fmOsc = new Tone.FMOscillator("Ab3", "sine", "square").toMaster().start();
		 */
	    Tone.FMOscillator = function () {
	        var options = this.optionsObject(arguments, [
	            'frequency',
	            'type',
	            'modulationType'
	        ], Tone.FMOscillator.defaults);
	        Tone.Source.call(this, options);
	        /**
			 *  The carrier oscillator
			 *  @type {Tone.Oscillator}
			 *  @private
			 */
	        this._carrier = new Tone.Oscillator(options.frequency, options.type);
	        /**
			 *  The oscillator's frequency
			 *  @type {Frequency}
			 *  @signal
			 */
	        this.frequency = new Tone.Signal(options.frequency, Tone.Type.Frequency);
	        /**
			 *  The detune control signal.
			 *  @type {Cents}
			 *  @signal
			 */
	        this.detune = this._carrier.detune;
	        this.detune.value = options.detune;
	        /**
			 *  The modulation index which is in essence the depth or amount of the modulation. In other terms it is the 
			 *  ratio of the frequency of the modulating signal (mf) to the amplitude of the 
			 *  modulating signal (ma) -- as in ma/mf. 
			 *	@type {Positive}
			 *	@signal
			 */
	        this.modulationIndex = new Tone.Multiply(options.modulationIndex);
	        this.modulationIndex.units = Tone.Type.Positive;
	        /**
			 *  The modulating oscillator
			 *  @type  {Tone.Oscillator}
			 *  @private
			 */
	        this._modulator = new Tone.Oscillator(options.frequency, options.modulationType);
	        /**
			 *  Harmonicity is the frequency ratio between the carrier and the modulator oscillators. 
			 *  A harmonicity of 1 gives both oscillators the same frequency. 
			 *  Harmonicity = 2 means a change of an octave. 
			 *  @type {Positive}
			 *  @signal
			 *  @example
			 * //pitch the modulator an octave below carrier
			 * synth.harmonicity.value = 0.5;
			 */
	        this.harmonicity = new Tone.Multiply(options.harmonicity);
	        this.harmonicity.units = Tone.Type.Positive;
	        /**
			 *  the node where the modulation happens
			 *  @type {Tone.Gain}
			 *  @private
			 */
	        this._modulationNode = new Tone.Gain(0);
	        //connections
	        this.frequency.connect(this._carrier.frequency);
	        this.frequency.chain(this.harmonicity, this._modulator.frequency);
	        this.frequency.chain(this.modulationIndex, this._modulationNode);
	        this._modulator.connect(this._modulationNode.gain);
	        this._modulationNode.connect(this._carrier.frequency);
	        this._carrier.connect(this.output);
	        this.detune.connect(this._modulator.detune);
	        this.phase = options.phase;
	        this._readOnly([
	            'modulationIndex',
	            'frequency',
	            'detune',
	            'harmonicity'
	        ]);
	    };
	    Tone.extend(Tone.FMOscillator, Tone.Oscillator);
	    /**
		 *  default values
		 *  @static
		 *  @type {Object}
		 *  @const
		 */
	    Tone.FMOscillator.defaults = {
	        'frequency': 440,
	        'detune': 0,
	        'phase': 0,
	        'modulationIndex': 2,
	        'modulationType': 'square',
	        'harmonicity': 1
	    };
	    /**
		 *  start the oscillator
		 *  @param  {Time} [time=now]
		 *  @private
		 */
	    Tone.FMOscillator.prototype._start = function (time) {
	        time = this.toSeconds(time);
	        this._modulator.start(time);
	        this._carrier.start(time);
	    };
	    /**
		 *  stop the oscillator
		 *  @param  {Time} time (optional) timing parameter
		 *  @private
		 */
	    Tone.FMOscillator.prototype._stop = function (time) {
	        time = this.toSeconds(time);
	        this._modulator.stop(time);
	        this._carrier.stop(time);
	    };
	    /**
		 * The type of the carrier oscillator
		 * @memberOf Tone.FMOscillator#
		 * @type {string}
		 * @name type
		 */
	    Object.defineProperty(Tone.FMOscillator.prototype, 'type', {
	        get: function () {
	            return this._carrier.type;
	        },
	        set: function (type) {
	            this._carrier.type = type;
	        }
	    });
	    /**
		 * The type of the modulator oscillator
		 * @memberOf Tone.FMOscillator#
		 * @type {String}
		 * @name modulationType
		 */
	    Object.defineProperty(Tone.FMOscillator.prototype, 'modulationType', {
	        get: function () {
	            return this._modulator.type;
	        },
	        set: function (type) {
	            this._modulator.type = type;
	        }
	    });
	    /**
		 * The phase of the oscillator in degrees.
		 * @memberOf Tone.FMOscillator#
		 * @type {number}
		 * @name phase
		 */
	    Object.defineProperty(Tone.FMOscillator.prototype, 'phase', {
	        get: function () {
	            return this._carrier.phase;
	        },
	        set: function (phase) {
	            this._carrier.phase = phase;
	            this._modulator.phase = phase;
	        }
	    });
	    /**
		 * The partials of the carrier waveform. A partial represents 
		 * the amplitude at a harmonic. The first harmonic is the 
		 * fundamental frequency, the second is the octave and so on
		 * following the harmonic series. 
		 * Setting this value will automatically set the type to "custom". 
		 * The value is an empty array when the type is not "custom". 
		 * @memberOf Tone.FMOscillator#
		 * @type {Array}
		 * @name partials
		 * @example
		 * osc.partials = [1, 0.2, 0.01];
		 */
	    Object.defineProperty(Tone.FMOscillator.prototype, 'partials', {
	        get: function () {
	            return this._carrier.partials;
	        },
	        set: function (partials) {
	            this._carrier.partials = partials;
	        }
	    });
	    /**
		 *  Clean up.
		 *  @return {Tone.FMOscillator} this
		 */
	    Tone.FMOscillator.prototype.dispose = function () {
	        Tone.Source.prototype.dispose.call(this);
	        this._writable([
	            'modulationIndex',
	            'frequency',
	            'detune',
	            'harmonicity'
	        ]);
	        this.frequency.dispose();
	        this.frequency = null;
	        this.detune = null;
	        this.harmonicity.dispose();
	        this.harmonicity = null;
	        this._carrier.dispose();
	        this._carrier = null;
	        this._modulator.dispose();
	        this._modulator = null;
	        this._modulationNode.dispose();
	        this._modulationNode = null;
	        this.modulationIndex.dispose();
	        this.modulationIndex = null;
	        return this;
	    };
	    return Tone.FMOscillator;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Tone.AMOscillator 
		 *
		 *  @extends {Tone.Oscillator}
		 *  @constructor
		 *  @param {Frequency} frequency The starting frequency of the oscillator. 
		 *  @param {String} type The type of the carrier oscillator.
		 *  @param {String} modulationType The type of the modulator oscillator.
		 *  @example
		 * //a sine oscillator frequency-modulated by a square wave
		 * var fmOsc = new Tone.AMOscillator("Ab3", "sine", "square").toMaster().start();
		 */
	    Tone.AMOscillator = function () {
	        var options = this.optionsObject(arguments, [
	            'frequency',
	            'type',
	            'modulationType'
	        ], Tone.AMOscillator.defaults);
	        Tone.Source.call(this, options);
	        /**
			 *  The carrier oscillator
			 *  @type {Tone.Oscillator}
			 *  @private
			 */
	        this._carrier = new Tone.Oscillator(options.frequency, options.type);
	        /**
			 *  The oscillator's frequency
			 *  @type {Frequency}
			 *  @signal
			 */
	        this.frequency = this._carrier.frequency;
	        /**
			 *  The detune control signal.
			 *  @type {Cents}
			 *  @signal
			 */
	        this.detune = this._carrier.detune;
	        this.detune.value = options.detune;
	        /**
			 *  The modulating oscillator
			 *  @type  {Tone.Oscillator}
			 *  @private
			 */
	        this._modulator = new Tone.Oscillator(options.frequency, options.modulationType);
	        /**
			 *  convert the -1,1 output to 0,1
			 *  @type {Tone.AudioToGain}
			 *  @private
			 */
	        this._modulationScale = new Tone.AudioToGain();
	        /**
			 *  Harmonicity is the frequency ratio between the carrier and the modulator oscillators. 
			 *  A harmonicity of 1 gives both oscillators the same frequency. 
			 *  Harmonicity = 2 means a change of an octave. 
			 *  @type {Positive}
			 *  @signal
			 *  @example
			 * //pitch the modulator an octave below carrier
			 * synth.harmonicity.value = 0.5;
			 */
	        this.harmonicity = new Tone.Multiply(options.harmonicity);
	        this.harmonicity.units = Tone.Type.Positive;
	        /**
			 *  the node where the modulation happens
			 *  @type {Tone.Gain}
			 *  @private
			 */
	        this._modulationNode = new Tone.Gain(0);
	        //connections
	        this.frequency.chain(this.harmonicity, this._modulator.frequency);
	        this.detune.connect(this._modulator.detune);
	        this._modulator.chain(this._modulationScale, this._modulationNode.gain);
	        this._carrier.chain(this._modulationNode, this.output);
	        this.phase = options.phase;
	        this._readOnly([
	            'frequency',
	            'detune',
	            'harmonicity'
	        ]);
	    };
	    Tone.extend(Tone.AMOscillator, Tone.Oscillator);
	    /**
		 *  default values
		 *  @static
		 *  @type {Object}
		 *  @const
		 */
	    Tone.AMOscillator.defaults = {
	        'frequency': 440,
	        'detune': 0,
	        'phase': 0,
	        'modulationType': 'square',
	        'harmonicity': 1
	    };
	    /**
		 *  start the oscillator
		 *  @param  {Time} [time=now]
		 *  @private
		 */
	    Tone.AMOscillator.prototype._start = function (time) {
	        time = this.toSeconds(time);
	        this._modulator.start(time);
	        this._carrier.start(time);
	    };
	    /**
		 *  stop the oscillator
		 *  @param  {Time} time (optional) timing parameter
		 *  @private
		 */
	    Tone.AMOscillator.prototype._stop = function (time) {
	        time = this.toSeconds(time);
	        this._modulator.stop(time);
	        this._carrier.stop(time);
	    };
	    /**
		 * The type of the carrier oscillator
		 * @memberOf Tone.AMOscillator#
		 * @type {string}
		 * @name type
		 */
	    Object.defineProperty(Tone.AMOscillator.prototype, 'type', {
	        get: function () {
	            return this._carrier.type;
	        },
	        set: function (type) {
	            this._carrier.type = type;
	        }
	    });
	    /**
		 * The type of the modulator oscillator
		 * @memberOf Tone.AMOscillator#
		 * @type {string}
		 * @name modulationType
		 */
	    Object.defineProperty(Tone.AMOscillator.prototype, 'modulationType', {
	        get: function () {
	            return this._modulator.type;
	        },
	        set: function (type) {
	            this._modulator.type = type;
	        }
	    });
	    /**
		 * The phase of the oscillator in degrees.
		 * @memberOf Tone.AMOscillator#
		 * @type {number}
		 * @name phase
		 */
	    Object.defineProperty(Tone.AMOscillator.prototype, 'phase', {
	        get: function () {
	            return this._carrier.phase;
	        },
	        set: function (phase) {
	            this._carrier.phase = phase;
	            this._modulator.phase = phase;
	        }
	    });
	    /**
		 * The partials of the carrier waveform. A partial represents 
		 * the amplitude at a harmonic. The first harmonic is the 
		 * fundamental frequency, the second is the octave and so on
		 * following the harmonic series. 
		 * Setting this value will automatically set the type to "custom". 
		 * The value is an empty array when the type is not "custom". 
		 * @memberOf Tone.AMOscillator#
		 * @type {Array}
		 * @name partials
		 * @example
		 * osc.partials = [1, 0.2, 0.01];
		 */
	    Object.defineProperty(Tone.AMOscillator.prototype, 'partials', {
	        get: function () {
	            return this._carrier.partials;
	        },
	        set: function (partials) {
	            this._carrier.partials = partials;
	        }
	    });
	    /**
		 *  Clean up.
		 *  @return {Tone.AMOscillator} this
		 */
	    Tone.AMOscillator.prototype.dispose = function () {
	        Tone.Source.prototype.dispose.call(this);
	        this._writable([
	            'frequency',
	            'detune',
	            'harmonicity'
	        ]);
	        this.frequency = null;
	        this.detune = null;
	        this.harmonicity.dispose();
	        this.harmonicity = null;
	        this._carrier.dispose();
	        this._carrier = null;
	        this._modulator.dispose();
	        this._modulator = null;
	        this._modulationNode.dispose();
	        this._modulationNode = null;
	        this._modulationScale.dispose();
	        this._modulationScale = null;
	        return this;
	    };
	    return Tone.AMOscillator;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Tone.FatOscillator 
		 *
		 *  @extends {Tone.Oscillator}
		 *  @constructor
		 *  @param {Frequency} frequency The starting frequency of the oscillator. 
		 *  @param {String} type The type of the carrier oscillator.
		 *  @param {String} modulationType The type of the modulator oscillator.
		 *  @example
		 * //a sine oscillator frequency-modulated by a square wave
		 * var fmOsc = new Tone.FatOscillator("Ab3", "sine", "square").toMaster().start();
		 */
	    Tone.FatOscillator = function () {
	        var options = this.optionsObject(arguments, [
	            'frequency',
	            'type',
	            'spread'
	        ], Tone.FatOscillator.defaults);
	        Tone.Source.call(this, options);
	        /**
			 *  The oscillator's frequency
			 *  @type {Frequency}
			 *  @signal
			 */
	        this.frequency = new Tone.Signal(options.frequency, Tone.Type.Frequency);
	        /**
			 *  The detune control signal.
			 *  @type {Cents}
			 *  @signal
			 */
	        this.detune = new Tone.Signal(options.detune, Tone.Type.Cents);
	        /**
			 *  The array of oscillators
			 *  @type {Array}
			 *  @private
			 */
	        this._oscillators = [];
	        /**
			 *  The total spread of the oscillators
			 *  @type  {Cents}
			 *  @private
			 */
	        this._spread = options.spread;
	        /**
			 *  The type of the oscillator
			 *  @type {String}
			 *  @private
			 */
	        this._type = options.type;
	        /**
			 *  The phase of the oscillators
			 *  @type {Degrees}
			 *  @private
			 */
	        this._phase = options.phase;
	        /**
			 *  The partials array
			 *  @type {Array}
			 *  @private
			 */
	        this._partials = this.defaultArg(options.partials, []);
	        //set the count initially
	        this.count = options.count;
	        this._readOnly([
	            'frequency',
	            'detune'
	        ]);
	    };
	    Tone.extend(Tone.FatOscillator, Tone.Oscillator);
	    /**
		 *  default values
		 *  @static
		 *  @type {Object}
		 *  @const
		 */
	    Tone.FatOscillator.defaults = {
	        'frequency': 440,
	        'detune': 0,
	        'phase': 0,
	        'spread': 20,
	        'count': 3,
	        'type': 'sawtooth'
	    };
	    /**
		 *  start the oscillator
		 *  @param  {Time} [time=now]
		 *  @private
		 */
	    Tone.FatOscillator.prototype._start = function (time) {
	        time = this.toSeconds(time);
	        this._forEach(function (osc) {
	            osc.start(time);
	        });
	    };
	    /**
		 *  stop the oscillator
		 *  @param  {Time} time (optional) timing parameter
		 *  @private
		 */
	    Tone.FatOscillator.prototype._stop = function (time) {
	        time = this.toSeconds(time);
	        this._forEach(function (osc) {
	            osc.stop(time);
	        });
	    };
	    /**
		 *  Iterate over all of the oscillators
		 *  @param  {Function}  iterator  The iterator function
		 *  @private
		 */
	    Tone.FatOscillator.prototype._forEach = function (iterator) {
	        for (var i = 0; i < this._oscillators.length; i++) {
	            iterator.call(this, this._oscillators[i], i);
	        }
	    };
	    /**
		 * The type of the carrier oscillator
		 * @memberOf Tone.FatOscillator#
		 * @type {string}
		 * @name type
		 */
	    Object.defineProperty(Tone.FatOscillator.prototype, 'type', {
	        get: function () {
	            return this._type;
	        },
	        set: function (type) {
	            this._type = type;
	            this._forEach(function (osc) {
	                osc.type = type;
	            });
	        }
	    });
	    /**
		 * The detune spread between the oscillators. If "count" is
		 * set to 3 oscillators and the "spread" is set to 40,
		 * the three oscillators would be detuned like this: [-20, 0, 20]
		 * for a total detune spread of 40 cents.
		 * @memberOf Tone.FatOscillator#
		 * @type {Cents}
		 * @name spread
		 */
	    Object.defineProperty(Tone.FatOscillator.prototype, 'spread', {
	        get: function () {
	            return this._spread;
	        },
	        set: function (spread) {
	            this._spread = spread;
	            if (this._oscillators.length > 1) {
	                var start = -spread / 2;
	                var step = spread / (this._oscillators.length - 1);
	                this._forEach(function (osc, i) {
	                    osc.detune.value = start + step * i;
	                });
	            }
	        }
	    });
	    /**
		 * The number of detuned oscillators
		 * @memberOf Tone.FatOscillator#
		 * @type {Number}
		 * @name count
		 */
	    Object.defineProperty(Tone.FatOscillator.prototype, 'count', {
	        get: function () {
	            return this._oscillators.length;
	        },
	        set: function (count) {
	            count = Math.max(count, 1);
	            if (this._oscillators.length !== count) {
	                // var partials = this.partials;
	                // var type = this.type;
	                //dispose the previous oscillators
	                this._forEach(function (osc) {
	                    osc.dispose();
	                });
	                this._oscillators = [];
	                for (var i = 0; i < count; i++) {
	                    var osc = new Tone.Oscillator();
	                    if (this.type === Tone.Oscillator.Type.Custom) {
	                        osc.partials = this._partials;
	                    } else {
	                        osc.type = this._type;
	                    }
	                    osc.phase = this._phase;
	                    osc.volume.value = -6 - count;
	                    this.frequency.connect(osc.frequency);
	                    this.detune.connect(osc.detune);
	                    osc.connect(this.output);
	                    this._oscillators[i] = osc;
	                }
	                //set the spread
	                this.spread = this._spread;
	                if (this.state === Tone.State.Started) {
	                    this._forEach(function (osc) {
	                        osc.start();
	                    });
	                }
	            }
	        }
	    });
	    /**
		 * The phase of the oscillator in degrees.
		 * @memberOf Tone.FatOscillator#
		 * @type {Number}
		 * @name phase
		 */
	    Object.defineProperty(Tone.FatOscillator.prototype, 'phase', {
	        get: function () {
	            return this._phase;
	        },
	        set: function (phase) {
	            this._phase = phase;
	            this._forEach(function (osc) {
	                osc.phase = phase;
	            });
	        }
	    });
	    /**
		 * The partials of the carrier waveform. A partial represents 
		 * the amplitude at a harmonic. The first harmonic is the 
		 * fundamental frequency, the second is the octave and so on
		 * following the harmonic series. 
		 * Setting this value will automatically set the type to "custom". 
		 * The value is an empty array when the type is not "custom". 
		 * @memberOf Tone.FatOscillator#
		 * @type {Array}
		 * @name partials
		 * @example
		 * osc.partials = [1, 0.2, 0.01];
		 */
	    Object.defineProperty(Tone.FatOscillator.prototype, 'partials', {
	        get: function () {
	            return this._partials;
	        },
	        set: function (partials) {
	            this._partials = partials;
	            this._type = Tone.Oscillator.Type.Custom;
	            this._forEach(function (osc) {
	                osc.partials = partials;
	            });
	        }
	    });
	    /**
		 *  Clean up.
		 *  @return {Tone.FatOscillator} this
		 */
	    Tone.FatOscillator.prototype.dispose = function () {
	        Tone.Source.prototype.dispose.call(this);
	        this._writable([
	            'frequency',
	            'detune'
	        ]);
	        this.frequency.dispose();
	        this.frequency = null;
	        this.detune.dispose();
	        this.detune = null;
	        this._forEach(function (osc) {
	            osc.dispose();
	        });
	        this._oscillators = null;
	        this._partials = null;
	        return this;
	    };
	    return Tone.FatOscillator;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Tone.OmniOscillator aggregates Tone.Oscillator, Tone.PulseOscillator,
		 *         Tone.PWMOscillator, Tone.FMOscillator, Tone.AMOscillator, and Tone.FatOscillator
		 *         into one class. The oscillator class can be changed by setting the `type`. 
		 *         `omniOsc.type = "pwm"` will set it to the Tone.PWMOscillator. Prefixing
		 *         any of the basic types ("sine", "square4", etc.) with "fm", "am", or "fat"
		 *         will use the FMOscillator, AMOscillator or FatOscillator respectively. 
		 *         For example: `omniOsc.type = "fatsawtooth"` will create set the oscillator
		 *         to a FatOscillator of type "sawtooth". 
		 *
		 *  @extends {Tone.Oscillator}
		 *  @constructor
		 *  @param {Frequency} frequency The initial frequency of the oscillator.
		 *  @param {String} type The type of the oscillator.
		 *  @example
		 *  var omniOsc = new Tone.OmniOscillator("C#4", "pwm");
		 */
	    Tone.OmniOscillator = function () {
	        var options = this.optionsObject(arguments, [
	            'frequency',
	            'type'
	        ], Tone.OmniOscillator.defaults);
	        Tone.Source.call(this, options);
	        /**
			 *  The frequency control.
			 *  @type {Frequency}
			 *  @signal
			 */
	        this.frequency = new Tone.Signal(options.frequency, Tone.Type.Frequency);
	        /**
			 *  The detune control
			 *  @type {Cents}
			 *  @signal
			 */
	        this.detune = new Tone.Signal(options.detune, Tone.Type.Cents);
	        /**
			 *  the type of the oscillator source
			 *  @type {String}
			 *  @private
			 */
	        this._sourceType = undefined;
	        /**
			 *  the oscillator
			 *  @type {Tone.Oscillator}
			 *  @private
			 */
	        this._oscillator = null;
	        //set the oscillator
	        this.type = options.type;
	        this._readOnly([
	            'frequency',
	            'detune'
	        ]);
	        //set the options
	        this.set(options);
	    };
	    Tone.extend(Tone.OmniOscillator, Tone.Oscillator);
	    /**
		 *  default values
		 *  @static
		 *  @type {Object}
		 *  @const
		 */
	    Tone.OmniOscillator.defaults = {
	        'frequency': 440,
	        'detune': 0,
	        'type': 'sine',
	        'phase': 0
	    };
	    /**
		 *  @enum {String}
		 *  @private
		 */
	    var OmniOscType = {
	        Pulse: 'PulseOscillator',
	        PWM: 'PWMOscillator',
	        Osc: 'Oscillator',
	        FM: 'FMOscillator',
	        AM: 'AMOscillator',
	        Fat: 'FatOscillator'
	    };
	    /**
		 *  start the oscillator
		 *  @param {Time} [time=now] the time to start the oscillator
		 *  @private
		 */
	    Tone.OmniOscillator.prototype._start = function (time) {
	        this._oscillator.start(time);
	    };
	    /**
		 *  start the oscillator
		 *  @param {Time} [time=now] the time to start the oscillator
		 *  @private
		 */
	    Tone.OmniOscillator.prototype._stop = function (time) {
	        this._oscillator.stop(time);
	    };
	    /**
		 * The type of the oscillator. Can be any of the basic types: sine, square, triangle, sawtooth. Or
		 * prefix the basic types with "fm", "am", or "fat" to use the FMOscillator, AMOscillator or FatOscillator
		 * types. The oscillator could also be set to "pwm" or "pulse". All of the parameters of the
		 * oscillator's class are accessible when the oscillator is set to that type, but throws an error 
		 * when it's not.
		 * 
		 * @memberOf Tone.OmniOscillator#
		 * @type {String}
		 * @name type
		 * @example
		 * omniOsc.type = "pwm";
		 * //modulationFrequency is parameter which is available
		 * //only when the type is "pwm". 
		 * omniOsc.modulationFrequency.value = 0.5;
		 * @example
		 * //an square wave frequency modulated by a sawtooth
		 * omniOsc.type = "fmsquare";
		 * omniOsc.modulationType = "sawtooth";
		 */
	    Object.defineProperty(Tone.OmniOscillator.prototype, 'type', {
	        get: function () {
	            var prefix = '';
	            if (this._sourceType === OmniOscType.FM) {
	                prefix = 'fm';
	            } else if (this._sourceType === OmniOscType.AM) {
	                prefix = 'am';
	            } else if (this._sourceType === OmniOscType.Fat) {
	                prefix = 'fat';
	            }
	            return prefix + this._oscillator.type;
	        },
	        set: function (type) {
	            if (type.substr(0, 2) === 'fm') {
	                this._createNewOscillator(OmniOscType.FM);
	                this._oscillator.type = type.substr(2);
	            } else if (type.substr(0, 2) === 'am') {
	                this._createNewOscillator(OmniOscType.AM);
	                this._oscillator.type = type.substr(2);
	            } else if (type.substr(0, 3) === 'fat') {
	                this._createNewOscillator(OmniOscType.Fat);
	                this._oscillator.type = type.substr(3);
	            } else if (type === 'pwm') {
	                this._createNewOscillator(OmniOscType.PWM);
	            } else if (type === 'pulse') {
	                this._createNewOscillator(OmniOscType.Pulse);
	            } else {
	                this._createNewOscillator(OmniOscType.Osc);
	                this._oscillator.type = type;
	            }
	        }
	    });
	    /**
		 * The partials of the waveform. A partial represents 
		 * the amplitude at a harmonic. The first harmonic is the 
		 * fundamental frequency, the second is the octave and so on
		 * following the harmonic series. 
		 * Setting this value will automatically set the type to "custom". 
		 * The value is an empty array when the type is not "custom". 
		 * This is not available on "pwm" and "pulse" oscillator types.
		 * @memberOf Tone.OmniOscillator#
		 * @type {Array}
		 * @name partials
		 * @example
		 * osc.partials = [1, 0.2, 0.01];
		 */
	    Object.defineProperty(Tone.OmniOscillator.prototype, 'partials', {
	        get: function () {
	            return this._oscillator.partials;
	        },
	        set: function (partials) {
	            this._oscillator.partials = partials;
	        }
	    });
	    /**
		 *  Set a member/attribute of the oscillator. 
		 *  @param {Object|String} params
		 *  @param {number=} value
		 *  @param {Time=} rampTime
		 *  @returns {Tone.OmniOscillator} this
		 */
	    Tone.OmniOscillator.prototype.set = function (params, value) {
	        //make sure the type is set first
	        if (params === 'type') {
	            this.type = value;
	        } else if (this.isObject(params) && params.hasOwnProperty('type')) {
	            this.type = params.type;
	        }
	        //then set the rest
	        Tone.prototype.set.apply(this, arguments);
	        return this;
	    };
	    /**
		 *  connect the oscillator to the frequency and detune signals
		 *  @private
		 */
	    Tone.OmniOscillator.prototype._createNewOscillator = function (oscType) {
	        if (oscType !== this._sourceType) {
	            this._sourceType = oscType;
	            var OscillatorConstructor = Tone[oscType];
	            //short delay to avoid clicks on the change
	            var now = this.now() + this.blockTime;
	            if (this._oscillator !== null) {
	                var oldOsc = this._oscillator;
	                oldOsc.stop(now);
	                //dispose the old one
	                setTimeout(function () {
	                    oldOsc.dispose();
	                    oldOsc = null;
	                }, this.blockTime * 1000);
	            }
	            this._oscillator = new OscillatorConstructor();
	            this.frequency.connect(this._oscillator.frequency);
	            this.detune.connect(this._oscillator.detune);
	            this._oscillator.connect(this.output);
	            if (this.state === Tone.State.Started) {
	                this._oscillator.start(now);
	            }
	        }
	    };
	    /**
		 * The phase of the oscillator in degrees. 
		 * @memberOf Tone.OmniOscillator#
		 * @type {Degrees}
		 * @name phase
		 */
	    Object.defineProperty(Tone.OmniOscillator.prototype, 'phase', {
	        get: function () {
	            return this._oscillator.phase;
	        },
	        set: function (phase) {
	            this._oscillator.phase = phase;
	        }
	    });
	    /**
		 * The width of the oscillator (only if the oscillator is set to "pulse")
		 * @memberOf Tone.OmniOscillator#
		 * @type {NormalRange}
		 * @signal
		 * @name width
		 * @example
		 * var omniOsc = new Tone.OmniOscillator(440, "pulse");
		 * //can access the width attribute only if type === "pulse"
		 * omniOsc.width.value = 0.2; 
		 */
	    Object.defineProperty(Tone.OmniOscillator.prototype, 'width', {
	        get: function () {
	            if (this._sourceType === OmniOscType.Pulse) {
	                return this._oscillator.width;
	            }
	        }
	    });
	    /**
		 * The number of detuned oscillators
		 * @memberOf Tone.OmniOscillator#
		 * @type {Number}
		 * @name count
		 */
	    Object.defineProperty(Tone.OmniOscillator.prototype, 'count', {
	        get: function () {
	            if (this._sourceType === OmniOscType.Fat) {
	                return this._oscillator.count;
	            }
	        },
	        set: function (count) {
	            if (this._sourceType === OmniOscType.Fat) {
	                this._oscillator.count = count;
	            }
	        }
	    });
	    /**
		 * The detune spread between the oscillators. If "count" is
		 * set to 3 oscillators and the "spread" is set to 40,
		 * the three oscillators would be detuned like this: [-20, 0, 20]
		 * for a total detune spread of 40 cents. See Tone.FatOscillator
		 * for more info.
		 * @memberOf Tone.OmniOscillator#
		 * @type {Cents}
		 * @name spread
		 */
	    Object.defineProperty(Tone.OmniOscillator.prototype, 'spread', {
	        get: function () {
	            if (this._sourceType === OmniOscType.Fat) {
	                return this._oscillator.spread;
	            }
	        },
	        set: function (spread) {
	            if (this._sourceType === OmniOscType.Fat) {
	                this._oscillator.spread = spread;
	            }
	        }
	    });
	    /**
		 * The type of the modulator oscillator. Only if the oscillator
		 * is set to "am" or "fm" types. see. Tone.AMOscillator or Tone.FMOscillator
		 * for more info. 
		 * @memberOf Tone.OmniOscillator#
		 * @type {String}
		 * @name modulationType
		 */
	    Object.defineProperty(Tone.OmniOscillator.prototype, 'modulationType', {
	        get: function () {
	            if (this._sourceType === OmniOscType.FM || this._sourceType === OmniOscType.AM) {
	                return this._oscillator.modulationType;
	            }
	        },
	        set: function (mType) {
	            if (this._sourceType === OmniOscType.FM || this._sourceType === OmniOscType.AM) {
	                this._oscillator.modulationType = mType;
	            }
	        }
	    });
	    /**
		 * The modulation index which is in essence the depth or amount of the modulation. In other terms it is the 
		 * ratio of the frequency of the modulating signal (mf) to the amplitude of the 
		 * modulating signal (ma) -- as in ma/mf. 
		 * See Tone.FMOscillator for more info. 
		 * @type {Positive}
		 * @signal
		 * @name modulationIndex
		 */
	    Object.defineProperty(Tone.OmniOscillator.prototype, 'modulationIndex', {
	        get: function () {
	            if (this._sourceType === OmniOscType.FM) {
	                return this._oscillator.modulationIndex;
	            }
	        }
	    });
	    /**
		 *  Harmonicity is the frequency ratio between the carrier and the modulator oscillators. 
		 *  A harmonicity of 1 gives both oscillators the same frequency. 
		 *  Harmonicity = 2 means a change of an octave. See Tone.AMOscillator or Tone.FMOscillator
		 *  for more info. 
		 *  @memberOf Tone.OmniOscillator#
		 *  @signal
		 *  @type {Positive}
		 *  @name harmonicity
		 */
	    Object.defineProperty(Tone.OmniOscillator.prototype, 'harmonicity', {
	        get: function () {
	            if (this._sourceType === OmniOscType.FM || this._sourceType === OmniOscType.AM) {
	                return this._oscillator.harmonicity;
	            }
	        }
	    });
	    /**
		 * The modulationFrequency Signal of the oscillator 
		 * (only if the oscillator type is set to pwm). See 
		 * Tone.PWMOscillator for more info. 
		 * @memberOf Tone.OmniOscillator#
		 * @type {Frequency}
		 * @signal
		 * @name modulationFrequency
		 * @example
		 * var omniOsc = new Tone.OmniOscillator(440, "pwm");
		 * //can access the modulationFrequency attribute only if type === "pwm"
		 * omniOsc.modulationFrequency.value = 0.2; 
		 */
	    Object.defineProperty(Tone.OmniOscillator.prototype, 'modulationFrequency', {
	        get: function () {
	            if (this._sourceType === OmniOscType.PWM) {
	                return this._oscillator.modulationFrequency;
	            }
	        }
	    });
	    /**
		 *  Clean up.
		 *  @return {Tone.OmniOscillator} this
		 */
	    Tone.OmniOscillator.prototype.dispose = function () {
	        Tone.Source.prototype.dispose.call(this);
	        this._writable([
	            'frequency',
	            'detune'
	        ]);
	        this.detune.dispose();
	        this.detune = null;
	        this.frequency.dispose();
	        this.frequency = null;
	        this._oscillator.dispose();
	        this._oscillator = null;
	        this._sourceType = null;
	        return this;
	    };
	    return Tone.OmniOscillator;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  Base-class for all instruments
		 *  
		 *  @constructor
		 *  @extends {Tone}
		 */
	    Tone.Instrument = function (options) {
	        //get the defaults
	        options = this.defaultArg(options, Tone.Instrument.defaults);
	        /**
			 *  The output and volume triming node
			 *  @type  {Tone.Volume}
			 *  @private
			 */
	        this._volume = this.output = new Tone.Volume(options.volume);
	        /**
			 * The volume of the output in decibels.
			 * @type {Decibels}
			 * @signal
			 * @example
			 * source.volume.value = -6;
			 */
	        this.volume = this._volume.volume;
	        this._readOnly('volume');
	    };
	    Tone.extend(Tone.Instrument);
	    /**
		 *  the default attributes
		 *  @type {object}
		 */
	    Tone.Instrument.defaults = {
	        /** the volume of the output in decibels */
	        'volume': 0
	    };
	    /**
		 *  @abstract
		 *  @param {string|number} note the note to trigger
		 *  @param {Time} [time=now] the time to trigger the ntoe
		 *  @param {number} [velocity=1] the velocity to trigger the note
		 */
	    Tone.Instrument.prototype.triggerAttack = Tone.noOp;
	    /**
		 *  @abstract
		 *  @param {Time} [time=now] when to trigger the release
		 */
	    Tone.Instrument.prototype.triggerRelease = Tone.noOp;
	    /**
		 *  Trigger the attack and then the release after the duration. 
		 *  @param  {Frequency} note     The note to trigger.
		 *  @param  {Time} duration How long the note should be held for before
		 *                          triggering the release. This value must be greater than 0. 
		 *  @param {Time} [time=now]  When the note should be triggered.
		 *  @param  {NormalRange} [velocity=1] The velocity the note should be triggered at.
		 *  @returns {Tone.Instrument} this
		 *  @example
		 * //trigger "C4" for the duration of an 8th note
		 * synth.triggerAttackRelease("C4", "8n");
		 */
	    Tone.Instrument.prototype.triggerAttackRelease = function (note, duration, time, velocity) {
	        if (this.isUndef(time)) {
	            time = this.now() + this.blockTime;
	        } else {
	            time = this.toSeconds(time);
	        }
	        duration = this.toSeconds(duration);
	        this.triggerAttack(note, time, velocity);
	        this.triggerRelease(time + duration);
	        return this;
	    };
	    /**
		 *  clean up
		 *  @returns {Tone.Instrument} this
		 */
	    Tone.Instrument.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._volume.dispose();
	        this._volume = null;
	        this._writable(['volume']);
	        this.volume = null;
	        return this;
	    };
	    return Tone.Instrument;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  This is an abstract base class for other monophonic instruments to 
		 *          extend. IMPORTANT: It does not make any sound on its own and
		 *          shouldn't be directly instantiated.
		 *
		 *  @constructor
		 *  @abstract
		 *  @extends {Tone.Instrument}
		 */
	    Tone.Monophonic = function (options) {
	        //get the defaults
	        options = this.defaultArg(options, Tone.Monophonic.defaults);
	        Tone.Instrument.call(this, options);
	        /**
			 *  The glide time between notes. 
			 *  @type {Time}
			 */
	        this.portamento = options.portamento;
	    };
	    Tone.extend(Tone.Monophonic, Tone.Instrument);
	    /**
		 *  @static
		 *  @const
		 *  @type {Object}
		 */
	    Tone.Monophonic.defaults = { 'portamento': 0 };
	    /**
		 *  Trigger the attack of the note optionally with a given velocity. 
		 *  
		 *  
		 *  @param  {Frequency} note     The note to trigger.
		 *  @param  {Time} [time=now]     When the note should start.
		 *  @param  {number} [velocity=1] velocity The velocity scaler 
		 *                                determines how "loud" the note 
		 *                                will be triggered.
		 *  @returns {Tone.Monophonic} this
		 *  @example
		 * synth.triggerAttack("C4");
		 *  @example
		 * //trigger the note a half second from now at half velocity
		 * synth.triggerAttack("C4", "+0.5", 0.5);
		 */
	    Tone.Monophonic.prototype.triggerAttack = function (note, time, velocity) {
	        if (this.isUndef(time)) {
	            time = this.now() + this.blockTime;
	        } else {
	            time = this.toSeconds(time);
	        }
	        this._triggerEnvelopeAttack(time, velocity);
	        this.setNote(note, time);
	        return this;
	    };
	    /**
		 *  Trigger the release portion of the envelope
		 *  @param  {Time} [time=now] If no time is given, the release happens immediatly
		 *  @returns {Tone.Monophonic} this
		 *  @example
		 * synth.triggerRelease();
		 */
	    Tone.Monophonic.prototype.triggerRelease = function (time) {
	        if (this.isUndef(time)) {
	            time = this.now() + this.blockTime;
	        } else {
	            time = this.toSeconds(time);
	        }
	        this._triggerEnvelopeRelease(time);
	        return this;
	    };
	    /**
		 *  override this method with the actual method
		 *  @abstract
		 *  @private
		 */
	    Tone.Monophonic.prototype._triggerEnvelopeAttack = function () {
	    };
	    /**
		 *  override this method with the actual method
		 *  @abstract
		 *  @private
		 */
	    Tone.Monophonic.prototype._triggerEnvelopeRelease = function () {
	    };
	    /**
		 *  Set the note at the given time. If no time is given, the note
		 *  will set immediately. 
		 *  @param {Frequency} note The note to change to.
		 *  @param  {Time} [time=now] The time when the note should be set. 
		 *  @returns {Tone.Monophonic} this
		 * @example
		 * //change to F#6 in one quarter note from now.
		 * synth.setNote("F#6", "+4n");
		 * @example
		 * //change to Bb4 right now
		 * synth.setNote("Bb4");
		 */
	    Tone.Monophonic.prototype.setNote = function (note, time) {
	        time = this.toSeconds(time);
	        if (this.portamento > 0) {
	            var currentNote = this.frequency.value;
	            this.frequency.setValueAtTime(currentNote, time);
	            var portTime = this.toSeconds(this.portamento);
	            this.frequency.exponentialRampToValueAtTime(note, time + portTime);
	        } else {
	            this.frequency.setValueAtTime(note, time);
	        }
	        return this;
	    };
	    return Tone.Monophonic;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  Tone.Synth is composed simply of a Tone.OmniOscillator
		 *          routed through a Tone.AmplitudeEnvelope. 
		 *          <img src="https://docs.google.com/drawings/d/1-1_0YW2Z1J2EPI36P8fNCMcZG7N1w1GZluPs4og4evo/pub?w=1163&h=231">
		 *
		 *  @constructor
		 *  @extends {Tone.Monophonic}
		 *  @param {Object} [options] the options available for the synth 
		 *                          see defaults below
		 *  @example
		 * var synth = new Tone.Synth().toMaster();
		 * synth.triggerAttackRelease("C4", "8n");
		 */
	    Tone.Synth = function (options) {
	        //get the defaults
	        options = this.defaultArg(options, Tone.Synth.defaults);
	        Tone.Monophonic.call(this, options);
	        /**
			 *  The oscillator.
			 *  @type {Tone.OmniOscillator}
			 */
	        this.oscillator = new Tone.OmniOscillator(options.oscillator);
	        /**
			 *  The frequency control.
			 *  @type {Frequency}
			 *  @signal
			 */
	        this.frequency = this.oscillator.frequency;
	        /**
			 *  The detune control.
			 *  @type {Cents}
			 *  @signal
			 */
	        this.detune = this.oscillator.detune;
	        /**
			 *  The amplitude envelope.
			 *  @type {Tone.AmplitudeEnvelope}
			 */
	        this.envelope = new Tone.AmplitudeEnvelope(options.envelope);
	        //connect the oscillators to the output
	        this.oscillator.chain(this.envelope, this.output);
	        //start the oscillators
	        this.oscillator.start();
	        this._readOnly([
	            'oscillator',
	            'frequency',
	            'detune',
	            'envelope'
	        ]);
	    };
	    Tone.extend(Tone.Synth, Tone.Monophonic);
	    /**
		 *  @const
		 *  @static
		 *  @type {Object}
		 */
	    Tone.Synth.defaults = {
	        'oscillator': { 'type': 'triangle' },
	        'envelope': {
	            'attack': 0.005,
	            'decay': 0.1,
	            'sustain': 0.3,
	            'release': 1
	        }
	    };
	    /**
		 *  start the attack portion of the envelope
		 *  @param {Time} [time=now] the time the attack should start
		 *  @param {number} [velocity=1] the velocity of the note (0-1)
		 *  @returns {Tone.Synth} this
		 *  @private
		 */
	    Tone.Synth.prototype._triggerEnvelopeAttack = function (time, velocity) {
	        //the envelopes
	        this.envelope.triggerAttack(time, velocity);
	        return this;
	    };
	    /**
		 *  start the release portion of the envelope
		 *  @param {Time} [time=now] the time the release should start
		 *  @returns {Tone.Synth} this
		 *  @private
		 */
	    Tone.Synth.prototype._triggerEnvelopeRelease = function (time) {
	        this.envelope.triggerRelease(time);
	        return this;
	    };
	    /**
		 *  clean up
		 *  @returns {Tone.Synth} this
		 */
	    Tone.Synth.prototype.dispose = function () {
	        Tone.Monophonic.prototype.dispose.call(this);
	        this._writable([
	            'oscillator',
	            'frequency',
	            'detune',
	            'envelope'
	        ]);
	        this.oscillator.dispose();
	        this.oscillator = null;
	        this.envelope.dispose();
	        this.envelope = null;
	        this.frequency = null;
	        this.detune = null;
	        return this;
	    };
	    return Tone.Synth;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  AMSynth uses the output of one Tone.Synth to modulate the
		 *          amplitude of another Tone.Synth. The harmonicity (the ratio between
		 *          the two signals) affects the timbre of the output signal greatly.
		 *          Read more about Amplitude Modulation Synthesis on 
		 *          [SoundOnSound](http://www.soundonsound.com/sos/mar00/articles/synthsecrets.htm).
		 *          <img src="https://docs.google.com/drawings/d/1TQu8Ed4iFr1YTLKpB3U1_hur-UwBrh5gdBXc8BxfGKw/pub?w=1009&h=457">
		 *
		 *  @constructor
		 *  @extends {Tone.Monophonic}
		 *  @param {Object} [options] the options available for the synth 
		 *                            see defaults below
		 *  @example
		 * var synth = new Tone.AMSynth().toMaster();
		 * synth.triggerAttackRelease("C4", "4n");
		 */
	    Tone.AMSynth = function (options) {
	        options = this.defaultArg(options, Tone.AMSynth.defaults);
	        Tone.Monophonic.call(this, options);
	        /**
			 *  The carrier voice. 
			 *  @type {Tone.Synth}
			 *  @private
			 */
	        this._carrier = new Tone.Synth();
	        this._carrier.volume.value = -10;
	        /**
			 *  The carrier's oscillator
			 *  @type {Tone.Oscillator}
			 */
	        this.oscillator = this._carrier.oscillator;
	        /**
			 *  The carrier's envelope
			 *  @type {Tone.AmplitudeEnvelope}
			 */
	        this.envelope = this._carrier.envelope.set(options.envelope);
	        /**
			 *  The modulator voice. 
			 *  @type {Tone.Synth}
			 *  @private
			 */
	        this._modulator = new Tone.Synth();
	        this._modulator.volume.value = -10;
	        /**
			 *  The modulator's oscillator which is applied
			 *  to the amplitude of the oscillator
			 *  @type {Tone.Oscillator}
			 */
	        this.modulation = this._modulator.oscillator.set(options.modulation);
	        /**
			 *  The modulator's envelope
			 *  @type {Tone.AmplitudeEnvelope}
			 */
	        this.modulationEnvelope = this._modulator.envelope.set(options.modulationEnvelope);
	        /**
			 *  The frequency.
			 *  @type {Frequency}
			 *  @signal
			 */
	        this.frequency = new Tone.Signal(440, Tone.Type.Frequency);
	        /**
			 *  The detune in cents
			 *  @type {Cents}
			 *  @signal
			 */
	        this.detune = new Tone.Signal(options.detune, Tone.Type.Cents);
	        /**
			 *  Harmonicity is the ratio between the two voices. A harmonicity of
			 *  1 is no change. Harmonicity = 2 means a change of an octave. 
			 *  @type {Positive}
			 *  @signal
			 *  @example
			 * //pitch voice1 an octave below voice0
			 * synth.harmonicity.value = 0.5;
			 */
	        this.harmonicity = new Tone.Multiply(options.harmonicity);
	        this.harmonicity.units = Tone.Type.Positive;
	        /**
			 *  convert the -1,1 output to 0,1
			 *  @type {Tone.AudioToGain}
			 *  @private
			 */
	        this._modulationScale = new Tone.AudioToGain();
	        /**
			 *  the node where the modulation happens
			 *  @type {Tone.Gain}
			 *  @private
			 */
	        this._modulationNode = new Tone.Gain();
	        //control the two voices frequency
	        this.frequency.connect(this._carrier.frequency);
	        this.frequency.chain(this.harmonicity, this._modulator.frequency);
	        this.detune.fan(this._carrier.detune, this._modulator.detune);
	        this._modulator.chain(this._modulationScale, this._modulationNode.gain);
	        this._carrier.chain(this._modulationNode, this.output);
	        this._readOnly([
	            'frequency',
	            'harmonicity',
	            'oscillator',
	            'envelope',
	            'modulation',
	            'modulationEnvelope',
	            'detune'
	        ]);
	    };
	    Tone.extend(Tone.AMSynth, Tone.Monophonic);
	    /**
		 *  @static
		 *  @type {Object}
		 */
	    Tone.AMSynth.defaults = {
	        'harmonicity': 3,
	        'detune': 0,
	        'oscillator': { 'type': 'sine' },
	        'envelope': {
	            'attack': 0.01,
	            'decay': 0.01,
	            'sustain': 1,
	            'release': 0.5
	        },
	        'modulation': { 'type': 'square' },
	        'modulationEnvelope': {
	            'attack': 0.5,
	            'decay': 0,
	            'sustain': 1,
	            'release': 0.5
	        }
	    };
	    /**
		 *  trigger the attack portion of the note
		 *  
		 *  @param  {Time} [time=now] the time the note will occur
		 *  @param {NormalRange} [velocity=1] the velocity of the note
		 *  @private
		 *  @returns {Tone.AMSynth} this
		 */
	    Tone.AMSynth.prototype._triggerEnvelopeAttack = function (time, velocity) {
	        //the port glide
	        time = this.toSeconds(time);
	        //the envelopes
	        this.envelope.triggerAttack(time, velocity);
	        this.modulationEnvelope.triggerAttack(time, velocity);
	        return this;
	    };
	    /**
		 *  trigger the release portion of the note
		 *  
		 *  @param  {Time} [time=now] the time the note will release
		 *  @private
		 *  @returns {Tone.AMSynth} this
		 */
	    Tone.AMSynth.prototype._triggerEnvelopeRelease = function (time) {
	        this.envelope.triggerRelease(time);
	        this.modulationEnvelope.triggerRelease(time);
	        return this;
	    };
	    /**
		 *  clean up
		 *  @returns {Tone.AMSynth} this
		 */
	    Tone.AMSynth.prototype.dispose = function () {
	        Tone.Monophonic.prototype.dispose.call(this);
	        this._writable([
	            'frequency',
	            'harmonicity',
	            'oscillator',
	            'envelope',
	            'modulation',
	            'modulationEnvelope',
	            'detune'
	        ]);
	        this._carrier.dispose();
	        this._carrier = null;
	        this._modulator.dispose();
	        this._modulator = null;
	        this.frequency.dispose();
	        this.frequency = null;
	        this.detune.dispose();
	        this.detune = null;
	        this.harmonicity.dispose();
	        this.harmonicity = null;
	        this._modulationScale.dispose();
	        this._modulationScale = null;
	        this._modulationNode.dispose();
	        this._modulationNode = null;
	        this.oscillator = null;
	        this.envelope = null;
	        this.modulationEnvelope = null;
	        this.modulation = null;
	        return this;
	    };
	    return Tone.AMSynth;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  Tone.MonoSynth is composed of one oscillator, one filter, and two envelopes.
		 *          The amplitude of the Tone.Oscillator and the cutoff frequency of the 
		 *          Tone.Filter are controlled by Tone.Envelopes. 
		 *          <img src="https://docs.google.com/drawings/d/1gaY1DF9_Hzkodqf8JI1Cg2VZfwSElpFQfI94IQwad38/pub?w=924&h=240">
		 *          
		 *  @constructor
		 *  @extends {Tone.Monophonic}
		 *  @param {Object} [options] the options available for the synth 
		 *                          see defaults below
		 *  @example
		 * var synth = new Tone.MonoSynth({
		 * 	"oscillator" : {
		 * 		"type" : "square"
		 *  },
		 *  "envelope" : {
		 *  	"attack" : 0.1
		 *  }
		 * }).toMaster();
		 * synth.triggerAttackRelease("C4", "8n");
		 */
	    Tone.MonoSynth = function (options) {
	        //get the defaults
	        options = this.defaultArg(options, Tone.MonoSynth.defaults);
	        Tone.Monophonic.call(this, options);
	        /**
			 *  The oscillator.
			 *  @type {Tone.OmniOscillator}
			 */
	        this.oscillator = new Tone.OmniOscillator(options.oscillator);
	        /**
			 *  The frequency control.
			 *  @type {Frequency}
			 *  @signal
			 */
	        this.frequency = this.oscillator.frequency;
	        /**
			 *  The detune control.
			 *  @type {Cents}
			 *  @signal
			 */
	        this.detune = this.oscillator.detune;
	        /**
			 *  The filter.
			 *  @type {Tone.Filter}
			 */
	        this.filter = new Tone.Filter(options.filter);
	        /**
			 *  The filter envelope.
			 *  @type {Tone.FrequencyEnvelope}
			 */
	        this.filterEnvelope = new Tone.FrequencyEnvelope(options.filterEnvelope);
	        /**
			 *  The amplitude envelope.
			 *  @type {Tone.AmplitudeEnvelope}
			 */
	        this.envelope = new Tone.AmplitudeEnvelope(options.envelope);
	        //connect the oscillators to the output
	        this.oscillator.chain(this.filter, this.envelope, this.output);
	        //start the oscillators
	        this.oscillator.start();
	        //connect the filter envelope
	        this.filterEnvelope.connect(this.filter.frequency);
	        this._readOnly([
	            'oscillator',
	            'frequency',
	            'detune',
	            'filter',
	            'filterEnvelope',
	            'envelope'
	        ]);
	    };
	    Tone.extend(Tone.MonoSynth, Tone.Monophonic);
	    /**
		 *  @const
		 *  @static
		 *  @type {Object}
		 */
	    Tone.MonoSynth.defaults = {
	        'frequency': 'C4',
	        'detune': 0,
	        'oscillator': { 'type': 'square' },
	        'filter': {
	            'Q': 6,
	            'type': 'lowpass',
	            'rolloff': -24
	        },
	        'envelope': {
	            'attack': 0.005,
	            'decay': 0.1,
	            'sustain': 0.9,
	            'release': 1
	        },
	        'filterEnvelope': {
	            'attack': 0.06,
	            'decay': 0.2,
	            'sustain': 0.5,
	            'release': 2,
	            'baseFrequency': 200,
	            'octaves': 7,
	            'exponent': 2
	        }
	    };
	    /**
		 *  start the attack portion of the envelope
		 *  @param {Time} [time=now] the time the attack should start
		 *  @param {NormalRange} [velocity=1] the velocity of the note (0-1)
		 *  @returns {Tone.MonoSynth} this
		 *  @private
		 */
	    Tone.MonoSynth.prototype._triggerEnvelopeAttack = function (time, velocity) {
	        //the envelopes
	        this.envelope.triggerAttack(time, velocity);
	        this.filterEnvelope.triggerAttack(time);
	        return this;
	    };
	    /**
		 *  start the release portion of the envelope
		 *  @param {Time} [time=now] the time the release should start
		 *  @returns {Tone.MonoSynth} this
		 *  @private
		 */
	    Tone.MonoSynth.prototype._triggerEnvelopeRelease = function (time) {
	        this.envelope.triggerRelease(time);
	        this.filterEnvelope.triggerRelease(time);
	        return this;
	    };
	    /**
		 *  clean up
		 *  @returns {Tone.MonoSynth} this
		 */
	    Tone.MonoSynth.prototype.dispose = function () {
	        Tone.Monophonic.prototype.dispose.call(this);
	        this._writable([
	            'oscillator',
	            'frequency',
	            'detune',
	            'filter',
	            'filterEnvelope',
	            'envelope'
	        ]);
	        this.oscillator.dispose();
	        this.oscillator = null;
	        this.envelope.dispose();
	        this.envelope = null;
	        this.filterEnvelope.dispose();
	        this.filterEnvelope = null;
	        this.filter.dispose();
	        this.filter = null;
	        this.frequency = null;
	        this.detune = null;
	        return this;
	    };
	    return Tone.MonoSynth;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  Tone.DuoSynth is a monophonic synth composed of two 
		 *          MonoSynths run in parallel with control over the 
		 *          frequency ratio between the two voices and vibrato effect.
		 *          <img src="https://docs.google.com/drawings/d/1bL4GXvfRMMlqS7XyBm9CjL9KJPSUKbcdBNpqOlkFLxk/pub?w=1012&h=448">
		 *
		 *  @constructor
		 *  @extends {Tone.Monophonic}
		 *  @param {Object} [options] the options available for the synth 
		 *                          see defaults below
		 *  @example
		 * var duoSynth = new Tone.DuoSynth().toMaster();
		 * duoSynth.triggerAttackRelease("C4", "2n");
		 */
	    Tone.DuoSynth = function (options) {
	        options = this.defaultArg(options, Tone.DuoSynth.defaults);
	        Tone.Monophonic.call(this, options);
	        /**
			 *  the first voice
			 *  @type {Tone.MonoSynth}
			 */
	        this.voice0 = new Tone.MonoSynth(options.voice0);
	        this.voice0.volume.value = -10;
	        /**
			 *  the second voice
			 *  @type {Tone.MonoSynth}
			 */
	        this.voice1 = new Tone.MonoSynth(options.voice1);
	        this.voice1.volume.value = -10;
	        /**
			 *  The vibrato LFO. 
			 *  @type {Tone.LFO}
			 *  @private
			 */
	        this._vibrato = new Tone.LFO(options.vibratoRate, -50, 50);
	        this._vibrato.start();
	        /**
			 * the vibrato frequency
			 * @type {Frequency}
			 * @signal
			 */
	        this.vibratoRate = this._vibrato.frequency;
	        /**
			 *  the vibrato gain
			 *  @type {Tone.Gain}
			 *  @private
			 */
	        this._vibratoGain = new Tone.Gain(options.vibratoAmount, Tone.Type.Positive);
	        /**
			 * The amount of vibrato
			 * @type {Positive}
			 * @signal
			 */
	        this.vibratoAmount = this._vibratoGain.gain;
	        /**
			 *  the frequency control
			 *  @type {Frequency}
			 *  @signal
			 */
	        this.frequency = new Tone.Signal(440, Tone.Type.Frequency);
	        /**
			 *  Harmonicity is the ratio between the two voices. A harmonicity of
			 *  1 is no change. Harmonicity = 2 means a change of an octave. 
			 *  @type {Positive}
			 *  @signal
			 *  @example
			 * //pitch voice1 an octave below voice0
			 * duoSynth.harmonicity.value = 0.5;
			 */
	        this.harmonicity = new Tone.Multiply(options.harmonicity);
	        this.harmonicity.units = Tone.Type.Positive;
	        //control the two voices frequency
	        this.frequency.connect(this.voice0.frequency);
	        this.frequency.chain(this.harmonicity, this.voice1.frequency);
	        this._vibrato.connect(this._vibratoGain);
	        this._vibratoGain.fan(this.voice0.detune, this.voice1.detune);
	        this.voice0.connect(this.output);
	        this.voice1.connect(this.output);
	        this._readOnly([
	            'voice0',
	            'voice1',
	            'frequency',
	            'vibratoAmount',
	            'vibratoRate'
	        ]);
	    };
	    Tone.extend(Tone.DuoSynth, Tone.Monophonic);
	    /**
		 *  @static
		 *  @type {Object}
		 */
	    Tone.DuoSynth.defaults = {
	        'vibratoAmount': 0.5,
	        'vibratoRate': 5,
	        'harmonicity': 1.5,
	        'voice0': {
	            'volume': -10,
	            'portamento': 0,
	            'oscillator': { 'type': 'sine' },
	            'filterEnvelope': {
	                'attack': 0.01,
	                'decay': 0,
	                'sustain': 1,
	                'release': 0.5
	            },
	            'envelope': {
	                'attack': 0.01,
	                'decay': 0,
	                'sustain': 1,
	                'release': 0.5
	            }
	        },
	        'voice1': {
	            'volume': -10,
	            'portamento': 0,
	            'oscillator': { 'type': 'sine' },
	            'filterEnvelope': {
	                'attack': 0.01,
	                'decay': 0,
	                'sustain': 1,
	                'release': 0.5
	            },
	            'envelope': {
	                'attack': 0.01,
	                'decay': 0,
	                'sustain': 1,
	                'release': 0.5
	            }
	        }
	    };
	    /**
		 *  start the attack portion of the envelopes
		 *  
		 *  @param {Time} [time=now] the time the attack should start
		 *  @param {NormalRange} [velocity=1] the velocity of the note (0-1)
		 *  @returns {Tone.DuoSynth} this
		 *  @private
		 */
	    Tone.DuoSynth.prototype._triggerEnvelopeAttack = function (time, velocity) {
	        time = this.toSeconds(time);
	        this.voice0.envelope.triggerAttack(time, velocity);
	        this.voice1.envelope.triggerAttack(time, velocity);
	        this.voice0.filterEnvelope.triggerAttack(time);
	        this.voice1.filterEnvelope.triggerAttack(time);
	        return this;
	    };
	    /**
		 *  start the release portion of the envelopes
		 *  
		 *  @param {Time} [time=now] the time the release should start
		 *  @returns {Tone.DuoSynth} this
		 *  @private
		 */
	    Tone.DuoSynth.prototype._triggerEnvelopeRelease = function (time) {
	        this.voice0.triggerRelease(time);
	        this.voice1.triggerRelease(time);
	        return this;
	    };
	    /**
		 *  clean up
		 *  @returns {Tone.DuoSynth} this
		 */
	    Tone.DuoSynth.prototype.dispose = function () {
	        Tone.Monophonic.prototype.dispose.call(this);
	        this._writable([
	            'voice0',
	            'voice1',
	            'frequency',
	            'vibratoAmount',
	            'vibratoRate'
	        ]);
	        this.voice0.dispose();
	        this.voice0 = null;
	        this.voice1.dispose();
	        this.voice1 = null;
	        this.frequency.dispose();
	        this.frequency = null;
	        this._vibratoGain.dispose();
	        this._vibratoGain = null;
	        this._vibrato = null;
	        this.harmonicity.dispose();
	        this.harmonicity = null;
	        this.vibratoAmount.dispose();
	        this.vibratoAmount = null;
	        this.vibratoRate = null;
	        return this;
	    };
	    return Tone.DuoSynth;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  FMSynth is composed of two Tone.Synths where one Tone.Synth modulates
		 *          the frequency of a second Tone.Synth. A lot of spectral content 
		 *          can be explored using the modulationIndex parameter. Read more about
		 *          frequency modulation synthesis on [SoundOnSound](http://www.soundonsound.com/sos/apr00/articles/synthsecrets.htm).
		 *          <img src="https://docs.google.com/drawings/d/1h0PUDZXPgi4Ikx6bVT6oncrYPLluFKy7lj53puxj-DM/pub?w=902&h=462">
		 *
		 *  @constructor
		 *  @extends {Tone.Monophonic}
		 *  @param {Object} [options] the options available for the synth 
		 *                          see defaults below
		 *  @example
		 * var fmSynth = new Tone.FMSynth().toMaster();
		 * fmSynth.triggerAttackRelease("C5", "4n");
		 */
	    Tone.FMSynth = function (options) {
	        options = this.defaultArg(options, Tone.FMSynth.defaults);
	        Tone.Monophonic.call(this, options);
	        /**
			 *  The carrier voice.
			 *  @type {Tone.Synth}
			 *  @private
			 */
	        this._carrier = new Tone.Synth(options.carrier);
	        this._carrier.volume.value = -10;
	        /**
			 *  The carrier's oscillator
			 *  @type {Tone.Oscillator}
			 */
	        this.oscillator = this._carrier.oscillator;
	        /**
			 *  The carrier's envelope
			 *  @type {Tone.Oscillator}
			 */
	        this.envelope = this._carrier.envelope.set(options.envelope);
	        /**
			 *  The modulator voice.
			 *  @type {Tone.Synth}
			 *  @private
			 */
	        this._modulator = new Tone.Synth(options.modulator);
	        this._modulator.volume.value = -10;
	        /**
			 *  The modulator's oscillator which is applied
			 *  to the amplitude of the oscillator
			 *  @type {Tone.Oscillator}
			 */
	        this.modulation = this._modulator.oscillator.set(options.modulation);
	        /**
			 *  The modulator's envelope
			 *  @type {Tone.Oscillator}
			 */
	        this.modulationEnvelope = this._modulator.envelope.set(options.modulationEnvelope);
	        /**
			 *  The frequency control.
			 *  @type {Frequency}
			 *  @signal
			 */
	        this.frequency = new Tone.Signal(440, Tone.Type.Frequency);
	        /**
			 *  The detune in cents
			 *  @type {Cents}
			 *  @signal
			 */
	        this.detune = new Tone.Signal(options.detune, Tone.Type.Cents);
	        /**
			 *  Harmonicity is the ratio between the two voices. A harmonicity of
			 *  1 is no change. Harmonicity = 2 means a change of an octave. 
			 *  @type {Positive}
			 *  @signal
			 *  @example
			 * //pitch voice1 an octave below voice0
			 * synth.harmonicity.value = 0.5;
			 */
	        this.harmonicity = new Tone.Multiply(options.harmonicity);
	        this.harmonicity.units = Tone.Type.Positive;
	        /**
			 *  The modulation index which essentially the depth or amount of the modulation. It is the 
			 *  ratio of the frequency of the modulating signal (mf) to the amplitude of the 
			 *  modulating signal (ma) -- as in ma/mf. 
			 *	@type {Positive}
			 *	@signal
			 */
	        this.modulationIndex = new Tone.Multiply(options.modulationIndex);
	        this.modulationIndex.units = Tone.Type.Positive;
	        /**
			 *  the node where the modulation happens
			 *  @type {GainNode}
			 *  @private
			 */
	        this._modulationNode = new Tone.Gain(0);
	        //control the two voices frequency
	        this.frequency.connect(this._carrier.frequency);
	        this.frequency.chain(this.harmonicity, this._modulator.frequency);
	        this.frequency.chain(this.modulationIndex, this._modulationNode);
	        this.detune.fan(this._carrier.detune, this._modulator.detune);
	        this._modulator.connect(this._modulationNode.gain);
	        this._modulationNode.connect(this._carrier.frequency);
	        this._carrier.connect(this.output);
	        this._readOnly([
	            'frequency',
	            'harmonicity',
	            'modulationIndex',
	            'oscillator',
	            'envelope',
	            'modulation',
	            'modulationEnvelope',
	            'detune'
	        ]);
	    };
	    Tone.extend(Tone.FMSynth, Tone.Monophonic);
	    /**
		 *  @static
		 *  @type {Object}
		 */
	    Tone.FMSynth.defaults = {
	        'harmonicity': 3,
	        'modulationIndex': 10,
	        'detune': 0,
	        'oscillator': { 'type': 'sine' },
	        'envelope': {
	            'attack': 0.01,
	            'decay': 0.01,
	            'sustain': 1,
	            'release': 0.5
	        },
	        'modulation': { 'type': 'square' },
	        'modulationEnvelope': {
	            'attack': 0.5,
	            'decay': 0,
	            'sustain': 1,
	            'release': 0.5
	        }
	    };
	    /**
		 * 	trigger the attack portion of the note
		 *  
		 *  @param  {Time} [time=now] the time the note will occur
		 *  @param {number} [velocity=1] the velocity of the note
		 *  @returns {Tone.FMSynth} this
		 *  @private
		 */
	    Tone.FMSynth.prototype._triggerEnvelopeAttack = function (time, velocity) {
	        time = this.toSeconds(time);
	        //the envelopes
	        this.envelope.triggerAttack(time, velocity);
	        this.modulationEnvelope.triggerAttack(time);
	        return this;
	    };
	    /**
		 *  trigger the release portion of the note
		 *  
		 *  @param  {Time} [time=now] the time the note will release
		 *  @returns {Tone.FMSynth} this
		 *  @private
		 */
	    Tone.FMSynth.prototype._triggerEnvelopeRelease = function (time) {
	        time = this.toSeconds(time);
	        this.envelope.triggerRelease(time);
	        this.modulationEnvelope.triggerRelease(time);
	        return this;
	    };
	    /**
		 *  clean up
		 *  @returns {Tone.FMSynth} this
		 */
	    Tone.FMSynth.prototype.dispose = function () {
	        Tone.Monophonic.prototype.dispose.call(this);
	        this._writable([
	            'frequency',
	            'harmonicity',
	            'modulationIndex',
	            'oscillator',
	            'envelope',
	            'modulation',
	            'modulationEnvelope',
	            'detune'
	        ]);
	        this._carrier.dispose();
	        this._carrier = null;
	        this._modulator.dispose();
	        this._modulator = null;
	        this.frequency.dispose();
	        this.frequency = null;
	        this.detune.dispose();
	        this.detune = null;
	        this.modulationIndex.dispose();
	        this.modulationIndex = null;
	        this.harmonicity.dispose();
	        this.harmonicity = null;
	        this._modulationNode.dispose();
	        this._modulationNode = null;
	        this.oscillator = null;
	        this.envelope = null;
	        this.modulationEnvelope = null;
	        this.modulation = null;
	        return this;
	    };
	    return Tone.FMSynth;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  Tone.MembraneSynth makes kick and tom sounds using a single oscillator
		 *          with an amplitude envelope and frequency ramp. A Tone.OmniOscillator
		 *          is routed through a Tone.AmplitudeEnvelope to the output. The drum
		 *          quality of the sound comes from the frequency envelope applied
		 *          during during Tone.MembraneSynth.triggerAttack(note). The frequency
		 *          envelope starts at <code>note * .octaves</code> and ramps to 
		 *          <code>note</code> over the duration of <code>.pitchDecay</code>. 
		 *
		 *  @constructor
		 *  @extends {Tone.Instrument}
		 *  @param {Object} [options] the options available for the synth 
		 *                          see defaults below
		 *  @example
		 * var synth = new Tone.MembraneSynth().toMaster();
		 * synth.triggerAttackRelease("C2", "8n");
		 */
	    Tone.MembraneSynth = function (options) {
	        options = this.defaultArg(options, Tone.MembraneSynth.defaults);
	        Tone.Instrument.call(this, options);
	        /**
			 *  The oscillator.
			 *  @type {Tone.OmniOscillator}
			 */
	        this.oscillator = new Tone.OmniOscillator(options.oscillator).start();
	        /**
			 *  The amplitude envelope.
			 *  @type {Tone.AmplitudeEnvelope}
			 */
	        this.envelope = new Tone.AmplitudeEnvelope(options.envelope);
	        /**
			 *  The number of octaves the pitch envelope ramps.
			 *  @type {Positive}
			 */
	        this.octaves = options.octaves;
	        /**
			 *  The amount of time the frequency envelope takes. 
			 *  @type {Time}
			 */
	        this.pitchDecay = options.pitchDecay;
	        this.oscillator.chain(this.envelope, this.output);
	        this._readOnly([
	            'oscillator',
	            'envelope'
	        ]);
	    };
	    Tone.extend(Tone.MembraneSynth, Tone.Instrument);
	    /**
		 *  @static
		 *  @type {Object}
		 */
	    Tone.MembraneSynth.defaults = {
	        'pitchDecay': 0.05,
	        'octaves': 10,
	        'oscillator': { 'type': 'sine' },
	        'envelope': {
	            'attack': 0.001,
	            'decay': 0.4,
	            'sustain': 0.01,
	            'release': 1.4,
	            'attackCurve': 'exponential'
	        }
	    };
	    /**
		 *  Trigger the note at the given time with the given velocity. 
		 *  
		 *  @param  {Frequency} note     the note
		 *  @param  {Time} [time=now]     the time, if not given is now
		 *  @param  {number} [velocity=1] velocity defaults to 1
		 *  @returns {Tone.MembraneSynth} this
		 *  @example
		 *  kick.triggerAttack(60);
		 */
	    Tone.MembraneSynth.prototype.triggerAttack = function (note, time, velocity) {
	        time = this.toSeconds(time);
	        note = this.toFrequency(note);
	        var maxNote = note * this.octaves;
	        this.oscillator.frequency.setValueAtTime(maxNote, time);
	        this.oscillator.frequency.exponentialRampToValueAtTime(note, time + this.toSeconds(this.pitchDecay));
	        this.envelope.triggerAttack(time, velocity);
	        return this;
	    };
	    /**
		 *  Trigger the release portion of the note.
		 *  
		 *  @param  {Time} [time=now] the time the note will release
		 *  @returns {Tone.MembraneSynth} this
		 */
	    Tone.MembraneSynth.prototype.triggerRelease = function (time) {
	        this.envelope.triggerRelease(time);
	        return this;
	    };
	    /**
		 *  Clean up.
		 *  @returns {Tone.MembraneSynth} this
		 */
	    Tone.MembraneSynth.prototype.dispose = function () {
	        Tone.Instrument.prototype.dispose.call(this);
	        this._writable([
	            'oscillator',
	            'envelope'
	        ]);
	        this.oscillator.dispose();
	        this.oscillator = null;
	        this.envelope.dispose();
	        this.envelope = null;
	        return this;
	    };
	    return Tone.MembraneSynth;
	});
	Module(function (Tone) {
	    /**
		 *  Inharmonic ratio of frequencies based on the Roland TR-808
		 *  Taken from https://ccrma.stanford.edu/papers/tr-808-cymbal-physically-informed-circuit-bendable-digital-model
		 *  @private
		 *  @static
		 *  @type {Array}
		 */
	    var inharmRatios = [
	        1,
	        1.483,
	        1.932,
	        2.546,
	        2.63,
	        3.897
	    ];
	    /**
		 *  @class  A highly inharmonic and spectrally complex source with a highpass filter
		 *          and amplitude envelope which is good for making metalophone sounds. Based
		 *          on CymbalSynth by [@polyrhythmatic](https://github.com/polyrhythmatic).
		 *          Inspiration from [Sound on Sound](http://www.soundonsound.com/sos/jul02/articles/synthsecrets0702.asp).
		 *
		 *  @constructor
		 *  @extends {Tone.Instrument}
		 *  @param {Object} [options] The options availble for the synth
		 *                             see defaults below
		 */
	    Tone.MetalSynth = function (options) {
	        options = this.defaultArg(options, Tone.MetalSynth.defaults);
	        Tone.Instrument.call(this, options);
	        /**
			 *  The frequency of the cymbal
			 *  @type  {Frequency}
			 *  @signal
			 */
	        this.frequency = new Tone.Signal(options.frequency, Tone.Type.Frequency);
	        /**
			 *  The array of FMOscillators
			 *  @type  {Array}
			 *  @private
			 */
	        this._oscillators = [];
	        /**
			 *  The frequency multipliers
			 *  @type {Array}
			 *  @private
			 */
	        this._freqMultipliers = [];
	        /**
			 *  The amplitude for the body
			 *  @type {Tone.Gain}
			 *  @private
			 */
	        this._amplitue = new Tone.Gain(0).connect(this.output);
	        /**
			 *  highpass the output
			 *  @type {Tone.Filter}
			 *  @private
			 */
	        this._highpass = new Tone.Filter({
	            'type': 'highpass',
	            'Q': -3.0102999566398125
	        }).connect(this._amplitue);
	        /**
			 *  The number of octaves the highpass
			 *  filter frequency ramps
			 *  @type {Number}
			 *  @private
			 */
	        this._octaves = options.octaves;
	        /**
			 *  Scale the body envelope
			 *  for the bandpass
			 *  @type {Tone.Scale}
			 *  @private
			 */
	        this._filterFreqScaler = new Tone.Scale(options.resonance, 7000);
	        /**
			 *  The envelope which is connected both to the 
			 *  amplitude and highpass filter's cutoff frequency
			 *  @type  {Tone.Envelope}
			 */
	        this.envelope = new Tone.Envelope({
	            'attack': options.envelope.attack,
	            'attackCurve': 'linear',
	            'decay': options.envelope.decay,
	            'sustain': 0,
	            'release': options.envelope.release
	        }).chain(this._filterFreqScaler, this._highpass.frequency);
	        this.envelope.connect(this._amplitue.gain);
	        for (var i = 0; i < inharmRatios.length; i++) {
	            var osc = new Tone.FMOscillator({
	                'type': 'square',
	                'modulationType': 'square',
	                'harmonicity': options.harmonicity,
	                'modulationIndex': options.modulationIndex
	            });
	            osc.connect(this._highpass).start(0);
	            this._oscillators[i] = osc;
	            var mult = new Tone.Multiply(inharmRatios[i]);
	            this._freqMultipliers[i] = mult;
	            this.frequency.chain(mult, osc.frequency);
	        }
	        //set the octaves
	        this.octaves = options.octaves;
	    };
	    Tone.extend(Tone.MetalSynth, Tone.Instrument);
	    /**
		 *  default values
		 *  @static
		 *  @const
		 *  @type {Object}
		 */
	    Tone.MetalSynth.defaults = {
	        'frequency': 200,
	        'envelope': {
	            'attack': 0.001,
	            'decay': 1.4,
	            'release': 0.2
	        },
	        'harmonicity': 5.1,
	        'modulationIndex': 32,
	        'resonance': 4000,
	        'octaves': 1.5
	    };
	    /**
		 *  Trigger the attack.
		 *  @param  {Time}  time      When the attack should be triggered.
		 *  @param  {NormalRange=1}  velocity  The velocity that the envelope should be triggered at.
		 *  @return  {Tone.MetalSynth}  this
		 */
	    Tone.MetalSynth.prototype.triggerAttack = function (time, vel) {
	        time = this.toSeconds(time);
	        vel = this.defaultArg(vel, 1);
	        this.envelope.triggerAttack(time, vel);
	        return this;
	    };
	    /**
		 *  Trigger the release of the envelope.
		 *  @param  {Time}  time      When the release should be triggered.
		 *  @return  {Tone.MetalSynth}  this
		 */
	    Tone.MetalSynth.prototype.triggerRelease = function (time) {
	        time = this.toSeconds(time);
	        this.envelope.triggerRelease(time);
	        return this;
	    };
	    /**
		 *  Trigger the attack and release of the envelope after the given 
		 *  duration. 
		 *  @param  {Time}  duration  The duration before triggering the release
		 *  @param  {Time}  time      When the attack should be triggered.
		 *  @param  {NormalRange=1}  velocity  The velocity that the envelope should be triggered at.
		 *  @return  {Tone.MetalSynth}  this
		 */
	    Tone.MetalSynth.prototype.triggerAttackRelease = function (duration, time, velocity) {
	        time = this.toSeconds(time);
	        duration = this.toSeconds(duration);
	        this.triggerAttack(time, velocity);
	        this.triggerRelease(time + duration);
	        return this;
	    };
	    /**
		 *  The modulationIndex of the oscillators which make up the source.
		 *  see Tone.FMOscillator.modulationIndex
		 *  @memberOf Tone.MetalSynth#
		 *  @type {Positive}
		 *  @name  modulationIndex
		 */
	    Object.defineProperty(Tone.MetalSynth.prototype, 'modulationIndex', {
	        get: function () {
	            return this._oscillators[0].modulationIndex.value;
	        },
	        set: function (val) {
	            for (var i = 0; i < this._oscillators.length; i++) {
	                this._oscillators[i].modulationIndex.value = val;
	            }
	        }
	    });
	    /**
		 *  The harmonicity of the oscillators which make up the source.
		 *  see Tone.FMOscillator.harmonicity
		 *  @memberOf Tone.MetalSynth#
		 *  @type {Positive}
		 *  @name  harmonicity
		 */
	    Object.defineProperty(Tone.MetalSynth.prototype, 'harmonicity', {
	        get: function () {
	            return this._oscillators[0].harmonicity.value;
	        },
	        set: function (val) {
	            for (var i = 0; i < this._oscillators.length; i++) {
	                this._oscillators[i].harmonicity.value = val;
	            }
	        }
	    });
	    /**
		 *  The frequency of the highpass filter attached to the envelope
		 *  @memberOf Tone.MetalSynth#
		 *  @type {Frequency}
		 *  @name  resonance
		 */
	    Object.defineProperty(Tone.MetalSynth.prototype, 'resonance', {
	        get: function () {
	            return this._filterFreqScaler.min;
	        },
	        set: function (val) {
	            this._filterFreqScaler.min = val;
	            this.octaves = this._octaves;
	        }
	    });
	    /**
		 *  The number of octaves above the "resonance" frequency
		 *  that the filter ramps during the attack/decay envelope
		 *  @memberOf Tone.MetalSynth#
		 *  @type {Number}
		 *  @name  octaves
		 */
	    Object.defineProperty(Tone.MetalSynth.prototype, 'octaves', {
	        get: function () {
	            return this._octaves;
	        },
	        set: function (octs) {
	            this._octaves = octs;
	            this._filterFreqScaler.max = this._filterFreqScaler.min * Math.pow(2, octs);
	        }
	    });
	    /**
		 *  Clean up
		 *  @returns {Tone.MetalSynth} this
		 */
	    Tone.MetalSynth.prototype.dispose = function () {
	        Tone.Instrument.prototype.dispose.call(this);
	        for (var i = 0; i < this._oscillators.length; i++) {
	            this._oscillators[i].dispose();
	            this._freqMultipliers[i].dispose();
	        }
	        this._oscillators = null;
	        this._freqMultipliers = null;
	        this.frequency.dispose();
	        this.frequency = null;
	        this._filterFreqScaler.dispose();
	        this._filterFreqScaler = null;
	        this._amplitue.dispose();
	        this._amplitue = null;
	        this.envelope.dispose();
	        this.envelope = null;
	        this._highpass.dispose();
	        this._highpass = null;
	    };
	    return Tone.MetalSynth;
	});
	Module(function (Tone) {
	    /**
		 *  BufferSource polyfill
		 */
	    if (window.AudioBufferSourceNode && !AudioBufferSourceNode.prototype.start) {
	        AudioBufferSourceNode.prototype.start = AudioBufferSourceNode.prototype.noteGrainOn;
	        AudioBufferSourceNode.prototype.stop = AudioBufferSourceNode.prototype.noteOff;
	    }
	    /**
		 *  @class Wrapper around the native BufferSourceNode.
		 *  @param  {AudioBuffer|Tone.Buffer}  buffer   The buffer to play
		 *  @param  {Function}  onended  The callback to invoke when the 
		 *                               buffer is done playing.
		 */
	    Tone.BufferSource = function () {
	        var options = this.optionsObject(arguments, [
	            'buffer',
	            'onended'
	        ], Tone.BufferSource.defaults);
	        /**
			 *  The callback to invoke after the 
			 *  buffer source is done playing. 
			 *  @type  {Function}
			 */
	        this.onended = options.onended;
	        /**
			 *  The time that the buffer was started.
			 *  @type  {Number}
			 *  @private
			 */
	        this._startTime = -1;
	        /**
			 *  The time that the buffer is scheduled to stop.
			 *  @type  {Number}
			 *  @private
			 */
	        this._stopTime = -1;
	        /**
			 *  The gain node which envelopes the BufferSource
			 *  @type  {Tone.Gain}
			 *  @private
			 */
	        this._gainNode = this.output = new Tone.Gain();
	        /**
			 *  The buffer source
			 *  @type  {AudioBufferSourceNode}
			 *  @private
			 */
	        this._source = this.context.createBufferSource();
	        this._source.connect(this._gainNode);
	        /**
			 *  The playbackRate of the buffer
			 *  @type {Positive}
			 *  @signal
			 */
	        this.playbackRate = new Tone.Param(this._source.playbackRate, Tone.Type.Positive);
	        /**
			 *  The fadeIn time of the amplitude envelope.
			 *  @type {Time}
			 */
	        this.fadeIn = options.fadeIn;
	        /**
			 *  The fadeOut time of the amplitude envelope.
			 *  @type {Time}
			 */
	        this.fadeOut = options.fadeOut;
	        /**
			 *  The value that the buffer ramps to
			 *  @type {Gain}
			 *  @private
			 */
	        this._gain = 1;
	        /**
			 * The onended timeout
			 * @type {Number}
			 * @private
			 */
	        this._onendedTimeout = -1;
	        //set the buffer initially
	        if (!this.isUndef(options.buffer)) {
	            this.buffer = options.buffer;
	        }
	        this.loop = options.loop;
	    };
	    Tone.extend(Tone.BufferSource);
	    /**
		 *  The defaults
		 *  @const
		 *  @type  {Object}
		 */
	    Tone.BufferSource.defaults = {
	        'onended': Tone.noOp,
	        'fadeIn': 0,
	        'fadeOut': 0
	    };
	    /**
		 *  Returns the playback state of the source, either "started" or "stopped".
		 *  @type {Tone.State}
		 *  @readOnly
		 *  @memberOf Tone.BufferSource#
		 *  @name state
		 */
	    Object.defineProperty(Tone.BufferSource.prototype, 'state', {
	        get: function () {
	            var now = this.now();
	            if (this._startTime !== -1 && now >= this._startTime && now < this._stopTime) {
	                return Tone.State.Started;
	            } else {
	                return Tone.State.Stopped;
	            }
	        }
	    });
	    /**
		 *  Start the buffer
		 *  @param  {Time} [startTime=now] When the player should start.
		 *  @param  {Time} [offset=0] The offset from the beginning of the sample
		 *                                 to start at. 
		 *  @param  {Time=} duration How long the sample should play. If no duration
		 *                                is given, it will default to the full length 
		 *                                of the sample (minus any offset)
		 *  @param  {Gain}  [gain=1]  The gain to play the buffer back at.
		 *  @param  {Time=}  fadeInTime  The optional fadeIn ramp time.
		 *  @return  {Tone.BufferSource}  this
		 */
	    Tone.BufferSource.prototype.start = function (time, offset, duration, gain, fadeInTime) {
	        if (this._startTime !== -1) {
	            throw new Error('Tone.BufferSource: can only be started once.');
	        }
	        if (this.buffer) {
	            time = this.toSeconds(time);
	            //if it's a loop the default offset is the loopstart point
	            if (this.loop) {
	                offset = this.defaultArg(offset, this.loopStart);
	            } else {
	                //otherwise the default offset is 0
	                offset = this.defaultArg(offset, 0);
	            }
	            offset = this.toSeconds(offset);
	            //the values in seconds
	            time = this.toSeconds(time);
	            this._source.start(time, offset);
	            gain = this.defaultArg(gain, 1);
	            this._gain = gain;
	            //the fadeIn time
	            if (this.isUndef(fadeInTime)) {
	                fadeInTime = this.toSeconds(this.fadeIn);
	            } else {
	                fadeInTime = this.toSeconds(fadeInTime);
	            }
	            if (fadeInTime > 0) {
	                this._gainNode.gain.setValueAtTime(0, time);
	                this._gainNode.gain.linearRampToValueAtTime(this._gain, time + fadeInTime);
	            } else {
	                this._gainNode.gain.setValueAtTime(gain, time);
	            }
	            this._startTime = time + fadeInTime;
	            if (!this.isUndef(duration)) {
	                duration = this.defaultArg(duration, this.buffer.duration - offset);
	                duration = this.toSeconds(duration);
	                this.stop(time + duration + fadeInTime, fadeInTime);
	            }
	        }
	        return this;
	    };
	    /**
		 *  Stop the buffer. Optionally add a ramp time to fade the 
		 *  buffer out. 
		 *  @param  {Time=}  time         The time the buffer should stop.
		 *  @param  {Time=}  fadeOutTime  How long the gain should fade out for
		 *  @return  {Tone.BufferSource}  this
		 */
	    Tone.BufferSource.prototype.stop = function (time, fadeOutTime) {
	        if (this.buffer) {
	            time = this.toSeconds(time);
	            //the fadeOut time
	            if (this.isUndef(fadeOutTime)) {
	                fadeOutTime = this.toSeconds(this.fadeOut);
	            } else {
	                fadeOutTime = this.toSeconds(fadeOutTime);
	            }
	            this._stopTime = time + fadeOutTime;
	            //cancel the end curve
	            this._gainNode.gain.cancelScheduledValues(this._startTime + this.sampleTime);
	            //set a new one
	            if (fadeOutTime > 0) {
	                this._gainNode.gain.setValueAtTime(this._gain, time);
	                this._gainNode.gain.linearRampToValueAtTime(0, time + fadeOutTime);
	                time += fadeOutTime;
	            } else {
	                this._gainNode.gain.setValueAtTime(0, time);
	            }
	            // fix for safari bug and old FF
	            if (!this.isNumber(this._source.playbackState) || this._source.playbackState === 2) {
	                this._source.stop(time);
	            }
	            clearTimeout(this._onendedTimeout);
	            this._onendedTimeout = setTimeout(this._onended.bind(this), (this._stopTime - this.now()) * 1000);
	        }
	        return this;
	    };
	    /**
		 *  Internal callback when the buffer is ended. 
		 *  Invokes `onended` and disposes the node.
		 *  @private
		 */
	    Tone.BufferSource.prototype._onended = function () {
	        this.onended(this);
	        this.dispose();
	    };
	    /**
		 * If loop is true, the loop will start at this position. 
		 * @memberOf Tone.BufferSource#
		 * @type {Time}
		 * @name loopStart
		 */
	    Object.defineProperty(Tone.BufferSource.prototype, 'loopStart', {
	        get: function () {
	            return this._source.loopStart;
	        },
	        set: function (loopStart) {
	            this._source.loopStart = this.toSeconds(loopStart);
	        }
	    });
	    /**
		 * If loop is true, the loop will end at this position.
		 * @memberOf Tone.BufferSource#
		 * @type {Time}
		 * @name loopEnd
		 */
	    Object.defineProperty(Tone.BufferSource.prototype, 'loopEnd', {
	        get: function () {
	            return this._source.loopEnd;
	        },
	        set: function (loopEnd) {
	            this._source.loopEnd = this.toSeconds(loopEnd);
	        }
	    });
	    /**
		 * The audio buffer belonging to the player. 
		 * @memberOf Tone.BufferSource#
		 * @type {AudioBuffer}
		 * @name buffer
		 */
	    Object.defineProperty(Tone.BufferSource.prototype, 'buffer', {
	        get: function () {
	            if (this._source) {
	                return this._source.buffer;
	            } else {
	                return null;
	            }
	        },
	        set: function (buffer) {
	            if (buffer instanceof Tone.Buffer) {
	                this._source.buffer = buffer.get();
	            } else {
	                this._source.buffer = buffer;
	            }
	        }
	    });
	    /**
		 * If the buffer should loop once it's over. 
		 * @memberOf Tone.BufferSource#
		 * @type {boolean}
		 * @name loop
		 */
	    Object.defineProperty(Tone.BufferSource.prototype, 'loop', {
	        get: function () {
	            return this._source.loop;
	        },
	        set: function (loop) {
	            this._source.loop = loop;
	        }
	    });
	    /**
		 *  Clean up.
		 *  @return  {Tone.BufferSource}  this
		 */
	    Tone.BufferSource.prototype.dispose = function () {
	        this.onended = null;
	        if (this._source) {
	            this._source.disconnect();
	            this._source = null;
	        }
	        if (this._gainNode) {
	            this._gainNode.dispose();
	            this._gainNode = null;
	        }
	        this._startTime = -1;
	        this.playbackRate = null;
	        this.output = null;
	        clearTimeout(this._onendedTimeout);
	        return this;
	    };
	    return Tone.BufferSource;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  Tone.Noise is a noise generator. It uses looped noise buffers to save on performance.
		 *          Tone.Noise supports the noise types: "pink", "white", and "brown". Read more about
		 *          colors of noise on [Wikipedia](https://en.wikipedia.org/wiki/Colors_of_noise).
		 *
		 *  @constructor
		 *  @extends {Tone.Source}
		 *  @param {string} type the noise type (white|pink|brown)
		 *  @example
		 * //initialize the noise and start
		 * var noise = new Tone.Noise("pink").start();
		 * 
		 * //make an autofilter to shape the noise
		 * var autoFilter = new Tone.AutoFilter({
		 * 	"frequency" : "8m", 
		 * 	"min" : 800, 
		 * 	"max" : 15000
		 * }).connect(Tone.Master);
		 * 
		 * //connect the noise
		 * noise.connect(autoFilter);
		 * //start the autofilter LFO
		 * autoFilter.start()
		 */
	    Tone.Noise = function () {
	        var options = this.optionsObject(arguments, ['type'], Tone.Noise.defaults);
	        Tone.Source.call(this, options);
	        /**
			 *  @private
			 *  @type {AudioBufferSourceNode}
			 */
	        this._source = null;
	        /**
			 *  the buffer
			 *  @private
			 *  @type {AudioBuffer}
			 */
	        this._type = options.type;
	        /**
			 *  The playback rate of the noise. Affects
			 *  the "frequency" of the noise.
			 *  @type {Positive}
			 *  @signal
			 */
	        this._playbackRate = options.playbackRate;
	    };
	    Tone.extend(Tone.Noise, Tone.Source);
	    /**
		 *  the default parameters
		 *
		 *  @static
		 *  @const
		 *  @type {Object}
		 */
	    Tone.Noise.defaults = {
	        'type': 'white',
	        'playbackRate': 1
	    };
	    /**
		 * The type of the noise. Can be "white", "brown", or "pink". 
		 * @memberOf Tone.Noise#
		 * @type {string}
		 * @name type
		 * @example
		 * noise.type = "white";
		 */
	    Object.defineProperty(Tone.Noise.prototype, 'type', {
	        get: function () {
	            return this._type;
	        },
	        set: function (type) {
	            if (this._type !== type) {
	                if (type in _noiseBuffers) {
	                    this._type = type;
	                    //if it's playing, stop and restart it
	                    if (this.state === Tone.State.Started) {
	                        var now = this.now() + this.blockTime;
	                        this._stop(now);
	                        this._start(now);
	                    }
	                } else {
	                    throw new TypeError('Tone.Noise: invalid type: ' + type);
	                }
	            }
	        }
	    });
	    /**
		 *  The playback rate of the noise. Affects
		 *  the "frequency" of the noise.
		 *  @type {Positive}
		 *  @signal
		 */
	    Object.defineProperty(Tone.Noise.prototype, 'playbackRate', {
	        get: function () {
	            return this._playbackRate;
	        },
	        set: function (rate) {
	            this._playbackRate = rate;
	            if (this._source) {
	                this._source.playbackRate.value = rate;
	            }
	        }
	    });
	    /**
		 *  internal start method
		 *
		 *  @param {Time} time
		 *  @private
		 */
	    Tone.Noise.prototype._start = function (time) {
	        var buffer = _noiseBuffers[this._type];
	        this._source = new Tone.BufferSource(buffer).connect(this.output);
	        this._source.loop = true;
	        this._source.playbackRate.value = this._playbackRate;
	        this._source.start(this.toSeconds(time), Math.random() * (buffer.duration - 0.001));
	    };
	    /**
		 *  internal stop method
		 *
		 *  @param {Time} time
		 *  @private
		 */
	    Tone.Noise.prototype._stop = function (time) {
	        if (this._source) {
	            this._source.stop(this.toSeconds(time));
	            this._source = null;
	        }
	    };
	    /**
		 *  Clean up.
		 *  @returns {Tone.Noise} this
		 */
	    Tone.Noise.prototype.dispose = function () {
	        Tone.Source.prototype.dispose.call(this);
	        if (this._source !== null) {
	            this._source.disconnect();
	            this._source = null;
	        }
	        this._buffer = null;
	        return this;
	    };
	    ///////////////////////////////////////////////////////////////////////////
	    // THE BUFFERS
	    ///////////////////////////////////////////////////////////////////////////
	    //Noise buffer stats
	    var bufferLength = 44100 * 5;
	    var channels = 2;
	    /**
		 *	the noise arrays. only generated once on init
		 *  @static
		 *  @private
		 *  @type {Array}
		 *  borrowed heavily from https://github.com/zacharydenton/noise.js 
		 *  (c) 2013 Zach Denton (MIT)
		 */
	    var _noiseArrays = {
	        'pink': function () {
	            var buffer = [];
	            for (var channelNum = 0; channelNum < channels; channelNum++) {
	                var channel = new Float32Array(bufferLength);
	                buffer[channelNum] = channel;
	                var b0, b1, b2, b3, b4, b5, b6;
	                b0 = b1 = b2 = b3 = b4 = b5 = b6 = 0;
	                for (var i = 0; i < bufferLength; i++) {
	                    var white = Math.random() * 2 - 1;
	                    b0 = 0.99886 * b0 + white * 0.0555179;
	                    b1 = 0.99332 * b1 + white * 0.0750759;
	                    b2 = 0.969 * b2 + white * 0.153852;
	                    b3 = 0.8665 * b3 + white * 0.3104856;
	                    b4 = 0.55 * b4 + white * 0.5329522;
	                    b5 = -0.7616 * b5 - white * 0.016898;
	                    channel[i] = b0 + b1 + b2 + b3 + b4 + b5 + b6 + white * 0.5362;
	                    channel[i] *= 0.11;
	                    // (roughly) compensate for gain
	                    b6 = white * 0.115926;
	                }
	            }
	            return buffer;
	        }(),
	        'brown': function () {
	            var buffer = [];
	            for (var channelNum = 0; channelNum < channels; channelNum++) {
	                var channel = new Float32Array(bufferLength);
	                buffer[channelNum] = channel;
	                var lastOut = 0;
	                for (var i = 0; i < bufferLength; i++) {
	                    var white = Math.random() * 2 - 1;
	                    channel[i] = (lastOut + 0.02 * white) / 1.02;
	                    lastOut = channel[i];
	                    channel[i] *= 3.5;    // (roughly) compensate for gain
	                }
	            }
	            return buffer;
	        }(),
	        'white': function () {
	            var buffer = [];
	            for (var channelNum = 0; channelNum < channels; channelNum++) {
	                var channel = new Float32Array(bufferLength);
	                buffer[channelNum] = channel;
	                for (var i = 0; i < bufferLength; i++) {
	                    channel[i] = Math.random() * 2 - 1;
	                }
	            }
	            return buffer;
	        }()
	    };
	    /**
		 *	static noise buffers
		 *  @static
		 *  @private
		 *  @type {Tone.Buffer}
		 */
	    var _noiseBuffers = {};
	    //create the Tone.Buffers
	    function createBuffers() {
	        for (var type in _noiseArrays) {
	            _noiseBuffers[type] = new Tone.Buffer().fromArray(_noiseArrays[type]);
	        }
	    }
	    createBuffers();
	    Tone.Context.on('init', createBuffers);
	    return Tone.Noise;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  Tone.NoiseSynth is composed of a noise generator (Tone.Noise), one filter (Tone.Filter), 
		 *          and two envelopes (Tone.Envelop). One envelope controls the amplitude
		 *          of the noise and the other is controls the cutoff frequency of the filter. 
		 *          <img src="https://docs.google.com/drawings/d/1rqzuX9rBlhT50MRvD2TKml9bnZhcZmzXF1rf_o7vdnE/pub?w=918&h=242">
		 *
		 *  @constructor
		 *  @extends {Tone.Instrument}
		 *  @param {Object} [options] the options available for the synth 
		 *                          see defaults below
		 * @example
		 * var noiseSynth = new Tone.NoiseSynth().toMaster();
		 * noiseSynth.triggerAttackRelease("8n");
		 */
	    Tone.NoiseSynth = function (options) {
	        //get the defaults
	        options = this.defaultArg(options, Tone.NoiseSynth.defaults);
	        Tone.Instrument.call(this, options);
	        /**
			 *  The noise source.
			 *  @type {Tone.Noise}
			 *  @example
			 * noiseSynth.set("noise.type", "brown");
			 */
	        this.noise = new Tone.Noise();
	        /**
			 *  The amplitude envelope. 
			 *  @type {Tone.AmplitudeEnvelope}
			 */
	        this.envelope = new Tone.AmplitudeEnvelope(options.envelope);
	        //connect the noise to the output
	        this.noise.chain(this.envelope, this.output);
	        //start the noise
	        this.noise.start();
	        this._readOnly([
	            'noise',
	            'envelope'
	        ]);
	    };
	    Tone.extend(Tone.NoiseSynth, Tone.Instrument);
	    /**
		 *  @const
		 *  @static
		 *  @type {Object}
		 */
	    Tone.NoiseSynth.defaults = {
	        'noise': { 'type': 'white' },
	        'envelope': {
	            'attack': 0.005,
	            'decay': 0.1,
	            'sustain': 0
	        }
	    };
	    /**
		 *  Start the attack portion of the envelopes. Unlike other 
		 *  instruments, Tone.NoiseSynth doesn't have a note. 
		 *  @param {Time} [time=now] the time the attack should start
		 *  @param {number} [velocity=1] the velocity of the note (0-1)
		 *  @returns {Tone.NoiseSynth} this
		 *  @example
		 * noiseSynth.triggerAttack();
		 */
	    Tone.NoiseSynth.prototype.triggerAttack = function (time, velocity) {
	        //the envelopes
	        this.envelope.triggerAttack(time, velocity);
	        return this;
	    };
	    /**
		 *  Start the release portion of the envelopes.
		 *  @param {Time} [time=now] the time the release should start
		 *  @returns {Tone.NoiseSynth} this
		 */
	    Tone.NoiseSynth.prototype.triggerRelease = function (time) {
	        this.envelope.triggerRelease(time);
	        return this;
	    };
	    /**
		 *  Trigger the attack and then the release. 
		 *  @param  {Time} duration the duration of the note
		 *  @param  {Time} [time=now]     the time of the attack
		 *  @param  {number} [velocity=1] the velocity
		 *  @returns {Tone.NoiseSynth} this
		 */
	    Tone.NoiseSynth.prototype.triggerAttackRelease = function (duration, time, velocity) {
	        time = this.toSeconds(time);
	        duration = this.toSeconds(duration);
	        this.triggerAttack(time, velocity);
	        this.triggerRelease(time + duration);
	        return this;
	    };
	    /**
		 *  Clean up. 
		 *  @returns {Tone.NoiseSynth} this
		 */
	    Tone.NoiseSynth.prototype.dispose = function () {
	        Tone.Instrument.prototype.dispose.call(this);
	        this._writable([
	            'noise',
	            'envelope'
	        ]);
	        this.noise.dispose();
	        this.noise = null;
	        this.envelope.dispose();
	        this.envelope = null;
	        return this;
	    };
	    return Tone.NoiseSynth;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Karplus-String string synthesis. Often out of tune. 
		 *         Will change when the AudioWorkerNode is available across
		 *         browsers. 
		 *  
		 *  @constructor
		 *  @extends {Tone.Instrument}
		 *  @param {Object} [options] see the defaults
		 *  @example
		 * var plucky = new Tone.PluckSynth().toMaster();
		 * plucky.triggerAttack("C4");
		 */
	    Tone.PluckSynth = function (options) {
	        options = this.defaultArg(options, Tone.PluckSynth.defaults);
	        Tone.Instrument.call(this, options);
	        /**
			 *  @type {Tone.Noise}
			 *  @private
			 */
	        this._noise = new Tone.Noise('pink');
	        /**
			 *  The amount of noise at the attack. 
			 *  Nominal range of [0.1, 20]
			 *  @type {number}
			 */
	        this.attackNoise = options.attackNoise;
	        /**
			 *  the LFCF
			 *  @type {Tone.LowpassCombFilter}
			 *  @private
			 */
	        this._lfcf = new Tone.LowpassCombFilter({
	            'resonance': options.resonance,
	            'dampening': options.dampening
	        });
	        /**
			 *  The resonance control. 
			 *  @type {NormalRange}
			 *  @signal
			 */
	        this.resonance = this._lfcf.resonance;
	        /**
			 *  The dampening control. i.e. the lowpass filter frequency of the comb filter
			 *  @type {Frequency}
			 *  @signal
			 */
	        this.dampening = this._lfcf.dampening;
	        //connections
	        this._noise.connect(this._lfcf);
	        this._lfcf.connect(this.output);
	        this._readOnly([
	            'resonance',
	            'dampening'
	        ]);
	    };
	    Tone.extend(Tone.PluckSynth, Tone.Instrument);
	    /**
		 *  @static
		 *  @const
		 *  @type {Object}
		 */
	    Tone.PluckSynth.defaults = {
	        'attackNoise': 1,
	        'dampening': 4000,
	        'resonance': 0.9
	    };
	    /**
		 *  Trigger the note. 
		 *  @param {Frequency} note The note to trigger.
		 *  @param {Time} [time=now] When the note should be triggered.
		 *  @returns {Tone.PluckSynth} this
		 */
	    Tone.PluckSynth.prototype.triggerAttack = function (note, time) {
	        note = this.toFrequency(note);
	        time = this.toSeconds(time);
	        var delayAmount = 1 / note;
	        this._lfcf.delayTime.setValueAtTime(delayAmount, time);
	        this._noise.start(time);
	        this._noise.stop(time + delayAmount * this.attackNoise);
	        return this;
	    };
	    /**
		 *  Clean up. 
		 *  @returns {Tone.PluckSynth} this
		 */
	    Tone.PluckSynth.prototype.dispose = function () {
	        Tone.Instrument.prototype.dispose.call(this);
	        this._noise.dispose();
	        this._lfcf.dispose();
	        this._noise = null;
	        this._lfcf = null;
	        this._writable([
	            'resonance',
	            'dampening'
	        ]);
	        this.dampening = null;
	        this.resonance = null;
	        return this;
	    };
	    return Tone.PluckSynth;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  Tone.PolySynth handles voice creation and allocation for any
		 *          instruments passed in as the second paramter. PolySynth is 
		 *          not a synthesizer by itself, it merely manages voices of 
		 *          one of the other types of synths, allowing any of the 
		 *          monophonic synthesizers to be polyphonic. 
		 *
		 *  @constructor
		 *  @extends {Tone.Instrument}
		 *  @param {number|Object} [polyphony=4] The number of voices to create
		 *  @param {function} [voice=Tone.Synth] The constructor of the voices
		 *                                            uses Tone.Synth by default. 
		 *  @example
		 * //a polysynth composed of 6 Voices of Synth
		 * var synth = new Tone.PolySynth(6, Tone.Synth).toMaster();
		 * //set the attributes using the set interface
		 * synth.set("detune", -1200);
		 * //play a chord
		 * synth.triggerAttackRelease(["C4", "E4", "A4"], "4n");
		 */
	    Tone.PolySynth = function () {
	        Tone.Instrument.call(this);
	        var options = this.optionsObject(arguments, [
	            'polyphony',
	            'voice'
	        ], Tone.PolySynth.defaults);
	        options = this.defaultArg(options, Tone.Instrument.defaults);
	        //max polyphony
	        options.polyphony = Math.min(Tone.PolySynth.MAX_POLYPHONY, options.polyphony);
	        /**
			 *  the array of voices
			 *  @type {Array}
			 */
	        this.voices = new Array(options.polyphony);
	        /**
			 *  The queue of voices with data about last trigger
			 *  and the triggered note
			 *  @private
			 *  @type {Array}
			 */
	        this._triggers = new Array(options.polyphony);
	        /**
			 *  The detune in cents
			 *  @type {Cents}
			 *  @signal
			 */
	        this.detune = new Tone.Signal(options.detune, Tone.Type.Cents);
	        this._readOnly('detune');
	        //create the voices
	        for (var i = 0; i < options.polyphony; i++) {
	            var v = new options.voice(arguments[2], arguments[3]);
	            this.voices[i] = v;
	            v.connect(this.output);
	            if (v.hasOwnProperty('detune')) {
	                this.detune.connect(v.detune);
	            }
	            this._triggers[i] = {
	                release: -1,
	                note: null,
	                voice: v
	            };
	        }
	        //set the volume initially
	        this.volume.value = options.volume;
	    };
	    Tone.extend(Tone.PolySynth, Tone.Instrument);
	    /**
		 *  the defaults
		 *  @const
		 *  @static
		 *  @type {Object}
		 */
	    Tone.PolySynth.defaults = {
	        'polyphony': 4,
	        'volume': 0,
	        'detune': 0,
	        'voice': Tone.Synth
	    };
	    /**
		 *  Trigger the attack portion of the note
		 *  @param  {Frequency|Array} notes The notes to play. Accepts a single
		 *                                  Frequency or an array of frequencies.
		 *  @param  {Time} [time=now]  The start time of the note.
		 *  @param {number} [velocity=1] The velocity of the note.
		 *  @returns {Tone.PolySynth} this
		 *  @example
		 * //trigger a chord immediately with a velocity of 0.2
		 * poly.triggerAttack(["Ab3", "C4", "F5"], undefined, 0.2);
		 */
	    Tone.PolySynth.prototype.triggerAttack = function (notes, time, velocity) {
	        if (!Array.isArray(notes)) {
	            notes = [notes];
	        }
	        time = this.toSeconds(time);
	        for (var i = 0; i < notes.length; i++) {
	            var val = notes[i];
	            //trigger the oldest voice
	            var oldest = this._triggers[0];
	            var oldestIndex = 0;
	            for (var j = 1; j < this._triggers.length; j++) {
	                if (this._triggers[j].release < oldest.release) {
	                    oldest = this._triggers[j];
	                    oldestIndex = j;
	                }
	            }
	            oldest.release = Infinity;
	            oldest.note = JSON.stringify(val);
	            oldest.voice.triggerAttack(val, time, velocity);
	        }
	        return this;
	    };
	    /**
		 *  Trigger the attack and release after the specified duration
		 *  
		 *  @param  {Frequency|Array} notes The notes to play. Accepts a single
		 *                                  Frequency or an array of frequencies.
		 *  @param  {Time} duration the duration of the note
		 *  @param  {Time} [time=now]     if no time is given, defaults to now
		 *  @param  {number} [velocity=1] the velocity of the attack (0-1)
		 *  @returns {Tone.PolySynth} this
		 *  @example
		 * //trigger a chord for a duration of a half note 
		 * poly.triggerAttackRelease(["Eb3", "G4", "C5"], "2n");
		 *  @example
		 * //can pass in an array of durations as well
		 * poly.triggerAttackRelease(["Eb3", "G4", "C5"], ["2n", "4n", "4n"]);
		 */
	    Tone.PolySynth.prototype.triggerAttackRelease = function (notes, duration, time, velocity) {
	        time = this.toSeconds(time);
	        this.triggerAttack(notes, time, velocity);
	        if (this.isArray(duration) && this.isArray(notes)) {
	            for (var i = 0; i < notes.length; i++) {
	                var d = duration[Math.min(i, duration.length - 1)];
	                this.triggerRelease(notes[i], time + this.toSeconds(d));
	            }
	        } else {
	            this.triggerRelease(notes, time + this.toSeconds(duration));
	        }
	        return this;
	    };
	    /**
		 *  Trigger the release of the note. Unlike monophonic instruments, 
		 *  a note (or array of notes) needs to be passed in as the first argument.
		 *  @param  {Frequency|Array} notes The notes to play. Accepts a single
		 *                                  Frequency or an array of frequencies.
		 *  @param  {Time} [time=now]  When the release will be triggered. 
		 *  @returns {Tone.PolySynth} this
		 *  @example
		 * poly.triggerRelease(["Ab3", "C4", "F5"], "+2n");
		 */
	    Tone.PolySynth.prototype.triggerRelease = function (notes, time) {
	        if (!Array.isArray(notes)) {
	            notes = [notes];
	        }
	        time = this.toSeconds(time);
	        for (var i = 0; i < notes.length; i++) {
	            //get the voice
	            var stringified = JSON.stringify(notes[i]);
	            for (var v = 0; v < this._triggers.length; v++) {
	                var desc = this._triggers[v];
	                if (desc.note === stringified && desc.release > time) {
	                    desc.voice.triggerRelease(time);
	                    desc.release = time;
	                }
	            }
	        }
	        return this;
	    };
	    /**
		 *  Set a member/attribute of the voices. 
		 *  @param {Object|string} params
		 *  @param {number=} value
		 *  @param {Time=} rampTime
		 *  @returns {Tone.PolySynth} this
		 *  @example
		 * poly.set({
		 * 	"filter" : {
		 * 		"type" : "highpass"
		 * 	},
		 * 	"envelope" : {
		 * 		"attack" : 0.25
		 * 	}
		 * });
		 */
	    Tone.PolySynth.prototype.set = function (params, value, rampTime) {
	        for (var i = 0; i < this.voices.length; i++) {
	            this.voices[i].set(params, value, rampTime);
	        }
	        return this;
	    };
	    /**
		 *  Get the synth's attributes. Given no arguments get
		 *  will return all available object properties and their corresponding
		 *  values. Pass in a single attribute to retrieve or an array
		 *  of attributes. The attribute strings can also include a "."
		 *  to access deeper properties.
		 *  @param {Array=} params the parameters to get, otherwise will return 
		 *  					   all available.
		 */
	    Tone.PolySynth.prototype.get = function (params) {
	        return this.voices[0].get(params);
	    };
	    /**
		 *  Trigger the release portion of all the currently active voices.
		 *  @param {Time} [time=now] When the notes should be released.
		 *  @return {Tone.PolySynth} this
		 */
	    Tone.PolySynth.prototype.releaseAll = function (time) {
	        time = this.toSeconds(time);
	        for (var i = 0; i < this._triggers.length; i++) {
	            var desc = this._triggers[i];
	            if (desc.release > time) {
	                desc.release = time;
	                desc.voice.triggerRelease(time);
	            }
	        }
	        return this;
	    };
	    /**
		 *  Clean up.
		 *  @returns {Tone.PolySynth} this
		 */
	    Tone.PolySynth.prototype.dispose = function () {
	        Tone.Instrument.prototype.dispose.call(this);
	        for (var i = 0; i < this.voices.length; i++) {
	            this.voices[i].dispose();
	            this.voices[i] = null;
	        }
	        this._writable('detune');
	        this.detune.dispose();
	        this.detune = null;
	        this.voices = null;
	        this._triggers = null;
	        return this;
	    };
	    /**
		 *  The maximum number of notes that can be allocated 
		 *  to a polysynth. 
		 *  @type  {Number}
		 *  @static
		 */
	    Tone.PolySynth.MAX_POLYPHONY = 20;
	    return Tone.PolySynth;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  Tone.Player is an audio file player with start, loop, and stop functions.
		 *  
		 *  @constructor
		 *  @extends {Tone.Source} 
		 *  @param {string|AudioBuffer} url Either the AudioBuffer or the url from
		 *                                  which to load the AudioBuffer
		 *  @param {function=} onload The function to invoke when the buffer is loaded. 
		 *                            Recommended to use Tone.Buffer.on('load') instead.
		 *  @example
		 * var player = new Tone.Player("./path/to/sample.mp3").toMaster();
		 * //play as soon as the buffer is loaded
		 * player.autostart = true;
		 */
	    Tone.Player = function (url) {
	        var options;
	        if (url instanceof Tone.Buffer) {
	            url = url.get();
	            options = Tone.Player.defaults;
	        } else {
	            options = this.optionsObject(arguments, [
	                'url',
	                'onload'
	            ], Tone.Player.defaults);
	        }
	        Tone.Source.call(this, options);
	        /**
			 *  @private
			 *  @type {AudioBufferSourceNode}
			 */
	        this._source = null;
	        /**
			 *  If the file should play as soon
			 *  as the buffer is loaded. 
			 *  @type {boolean}
			 *  @example
			 * //will play as soon as it's loaded
			 * var player = new Tone.Player({
			 * 	"url" : "./path/to/sample.mp3",
			 * 	"autostart" : true,
			 * }).toMaster();
			 */
	        this.autostart = options.autostart;
	        /**
			 *  the buffer
			 *  @private
			 *  @type {Tone.Buffer}
			 */
	        this._buffer = new Tone.Buffer({
	            'url': options.url,
	            'onload': this._onload.bind(this, options.onload),
	            'reverse': options.reverse
	        });
	        if (url instanceof AudioBuffer) {
	            this._buffer.set(url);
	        }
	        /**
			 *  if the buffer should loop once it's over
			 *  @type {boolean}
			 *  @private
			 */
	        this._loop = options.loop;
	        /**
			 *  if 'loop' is true, the loop will start at this position
			 *  @type {Time}
			 *  @private
			 */
	        this._loopStart = options.loopStart;
	        /**
			 *  if 'loop' is true, the loop will end at this position
			 *  @type {Time}
			 *  @private
			 */
	        this._loopEnd = options.loopEnd;
	        /**
			 *  the playback rate
			 *  @private
			 *  @type {number}
			 */
	        this._playbackRate = options.playbackRate;
	        /**
			 *  Enabling retrigger will allow a player to be restarted
			 *  before the the previous 'start' is done playing. Otherwise, 
			 *  successive calls to Tone.Player.start will only start
			 *  the sample if it had played all the way through. 
			 *  @type {boolean}
			 */
	        this.retrigger = options.retrigger;
	    };
	    Tone.extend(Tone.Player, Tone.Source);
	    /**
		 *  the default parameters
		 *  @static
		 *  @const
		 *  @type {Object}
		 */
	    Tone.Player.defaults = {
	        'onload': Tone.noOp,
	        'playbackRate': 1,
	        'loop': false,
	        'autostart': false,
	        'loopStart': 0,
	        'loopEnd': 0,
	        'retrigger': false,
	        'reverse': false
	    };
	    /**
		 *  Load the audio file as an audio buffer.
		 *  Decodes the audio asynchronously and invokes
		 *  the callback once the audio buffer loads. 
		 *  Note: this does not need to be called if a url
		 *  was passed in to the constructor. Only use this
		 *  if you want to manually load a new url. 
		 * @param {string} url The url of the buffer to load.
		 *                     Filetype support depends on the
		 *                     browser.
		 *  @param  {function=} callback The function to invoke once
		 *                               the sample is loaded.
		 *  @returns {Promise}
		 */
	    Tone.Player.prototype.load = function (url, callback) {
	        return this._buffer.load(url, this._onload.bind(this, callback));
	    };
	    /**
		 * Internal callback when the buffer is loaded.
		 * @private
		 */
	    Tone.Player.prototype._onload = function (callback) {
	        callback = this.defaultArg(callback, Tone.noOp);
	        callback(this);
	        if (this.autostart) {
	            this.start();
	        }
	    };
	    /**
		 *  Play the buffer at the given startTime. Optionally add an offset
		 *  and/or duration which will play the buffer from a position
		 *  within the buffer for the given duration. 
		 *  
		 *  @param  {Time} [startTime=now] When the player should start.
		 *  @param  {Time} [offset=0] The offset from the beginning of the sample
		 *                                 to start at. 
		 *  @param  {Time=} duration How long the sample should play. If no duration
		 *                                is given, it will default to the full length 
		 *                                of the sample (minus any offset)
		 *  @returns {Tone.Player} this
		 *  @memberOf Tone.Player#
		 *  @method start
		 *  @name start
		 */
	    /**
		 *  Internal start method
		 *  @private
		 */
	    Tone.Player.prototype._start = function (startTime, offset, duration) {
	        if (this._buffer.loaded) {
	            //if it's a loop the default offset is the loopstart point
	            if (this._loop) {
	                offset = this.defaultArg(offset, this._loopStart);
	            } else {
	                //otherwise the default offset is 0
	                offset = this.defaultArg(offset, 0);
	            }
	            offset = this.toSeconds(offset);
	            //make sure it has a positive duration
	            duration = this.defaultArg(duration, Math.max(this._buffer.duration - offset, 0));
	            duration = this.toSeconds(duration);
	            //the values in seconds
	            startTime = this.toSeconds(startTime);
	            //make the source
	            this._source = this.context.createBufferSource();
	            this._source.buffer = this._buffer.get();
	            //set the looping properties
	            if (this._loop) {
	                this._source.loop = this._loop;
	                this._source.loopStart = this.toSeconds(this._loopStart);
	                this._source.loopEnd = this.toSeconds(this._loopEnd);
	            } else if (!this._synced) {
	                //if it's not looping, set the state change at the end of the sample
	                this._state.setStateAtTime(Tone.State.Stopped, startTime + duration);
	            }
	            //and other properties
	            this._source.playbackRate.value = this._playbackRate;
	            this._source.connect(this.output);
	            //start it
	            if (this._loop) {
	                //modify the offset if it's greater than the loop time
	                var loopEnd = this._source.loopEnd || this._buffer.duration;
	                var loopStart = this._source.loopStart;
	                var loopDuration = loopEnd - loopStart;
	                if (offset > loopEnd) {
	                    //move the offset back
	                    while (offset > loopEnd) {
	                        offset -= loopDuration;
	                    }
	                }
	                this._source.start(startTime, offset);
	            } else {
	                this._source.start(startTime, offset, duration);
	            }
	        } else {
	            throw Error('Tone.Player: tried to start Player before the buffer was loaded');
	        }
	        return this;
	    };
	    /**
		 *  Stop playback.
		 *  @private
		 *  @param  {Time} [time=now]
		 *  @returns {Tone.Player} this
		 */
	    Tone.Player.prototype._stop = function (time) {
	        if (this._source) {
	            this._source.stop(this.toSeconds(time));
	            this._source = null;
	        }
	        return this;
	    };
	    /**
		 *  Seek to a specific time in the player's buffer. If the 
		 *  source is no longer playing at that time, it will stop.
		 *  If you seek to a time that 
		 *  @param {Time} offset The time to seek to.
		 *  @param {Time=} time The time for the seek event to occur.
		 *  @return {Tone.Player} this
		 *  @example
		 * source.start(0.2);
		 * source.stop(0.4);
		 */
	    Tone.Player.prototype.seek = function (offset, time) {
	        time = this.toSeconds(time);
	        if (this._state.getValueAtTime(time) === Tone.State.Started) {
	            offset = this.toSeconds(offset);
	            // if it's currently playing, stop it
	            this._stop(time);
	            //restart it at the given time
	            this._start(time, offset);
	        }
	        return this;
	    };
	    /**
		 *  Set the loop start and end. Will only loop if loop is 
		 *  set to true. 
		 *  @param {Time} loopStart The loop end time
		 *  @param {Time} loopEnd The loop end time
		 *  @returns {Tone.Player} this
		 *  @example
		 * //loop 0.1 seconds of the file. 
		 * player.setLoopPoints(0.2, 0.3);
		 * player.loop = true;
		 */
	    Tone.Player.prototype.setLoopPoints = function (loopStart, loopEnd) {
	        this.loopStart = loopStart;
	        this.loopEnd = loopEnd;
	        return this;
	    };
	    /**
		 * If loop is true, the loop will start at this position. 
		 * @memberOf Tone.Player#
		 * @type {Time}
		 * @name loopStart
		 */
	    Object.defineProperty(Tone.Player.prototype, 'loopStart', {
	        get: function () {
	            return this._loopStart;
	        },
	        set: function (loopStart) {
	            this._loopStart = loopStart;
	            if (this._source) {
	                this._source.loopStart = this.toSeconds(loopStart);
	            }
	        }
	    });
	    /**
		 * If loop is true, the loop will end at this position.
		 * @memberOf Tone.Player#
		 * @type {Time}
		 * @name loopEnd
		 */
	    Object.defineProperty(Tone.Player.prototype, 'loopEnd', {
	        get: function () {
	            return this._loopEnd;
	        },
	        set: function (loopEnd) {
	            this._loopEnd = loopEnd;
	            if (this._source) {
	                this._source.loopEnd = this.toSeconds(loopEnd);
	            }
	        }
	    });
	    /**
		 * The audio buffer belonging to the player. 
		 * @memberOf Tone.Player#
		 * @type {Tone.Buffer}
		 * @name buffer
		 */
	    Object.defineProperty(Tone.Player.prototype, 'buffer', {
	        get: function () {
	            return this._buffer;
	        },
	        set: function (buffer) {
	            this._buffer.set(buffer);
	        }
	    });
	    /**
		 * If the buffer should loop once it's over. 
		 * @memberOf Tone.Player#
		 * @type {boolean}
		 * @name loop
		 */
	    Object.defineProperty(Tone.Player.prototype, 'loop', {
	        get: function () {
	            return this._loop;
	        },
	        set: function (loop) {
	            this._loop = loop;
	            if (this._source) {
	                this._source.loop = loop;
	            }
	        }
	    });
	    /**
		 * The playback speed. 1 is normal speed. This is not a signal because
		 * Safari and iOS currently don't support playbackRate as a signal.
		 * @memberOf Tone.Player#
		 * @type {number}
		 * @name playbackRate
		 */
	    Object.defineProperty(Tone.Player.prototype, 'playbackRate', {
	        get: function () {
	            return this._playbackRate;
	        },
	        set: function (rate) {
	            this._playbackRate = rate;
	            if (this._source) {
	                this._source.playbackRate.value = rate;
	            }
	        }
	    });
	    /**
		 * The direction the buffer should play in
		 * @memberOf Tone.Player#
		 * @type {boolean}
		 * @name reverse
		 */
	    Object.defineProperty(Tone.Player.prototype, 'reverse', {
	        get: function () {
	            return this._buffer.reverse;
	        },
	        set: function (rev) {
	            this._buffer.reverse = rev;
	        }
	    });
	    /**
		 *  Dispose and disconnect.
		 *  @return {Tone.Player} this
		 */
	    Tone.Player.prototype.dispose = function () {
	        Tone.Source.prototype.dispose.call(this);
	        if (this._source !== null) {
	            this._source.disconnect();
	            this._source = null;
	        }
	        this._buffer.dispose();
	        this._buffer = null;
	        return this;
	    };
	    return Tone.Player;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Sampler wraps Tone.Player in an AmplitudeEnvelope.
		 *
		 *  @constructor
		 *  @extends {Tone.Instrument}
		 *  @param {String} url the url of the audio file
		 *  @param {Function=} onload The callback to invoke when the sample is loaded.
		 *  @example
		 * var sampler = new Sampler("./audio/casio/A1.mp3", function(){
		 * 	//repitch the sample down a half step
		 * 	sampler.triggerAttack(-1);
		 * }).toMaster();
		 */
	    Tone.Sampler = function () {
	        var options = this.optionsObject(arguments, [
	            'url',
	            'onload'
	        ], Tone.Sampler.defaults);
	        Tone.Instrument.call(this, options);
	        /**
			 *  The sample player.
			 *  @type {Tone.Player}
			 */
	        this.player = new Tone.Player(options.url, options.onload);
	        this.player.retrigger = true;
	        /**
			 *  The amplitude envelope. 
			 *  @type {Tone.AmplitudeEnvelope}
			 */
	        this.envelope = new Tone.AmplitudeEnvelope(options.envelope);
	        this.player.chain(this.envelope, this.output);
	        this._readOnly([
	            'player',
	            'envelope'
	        ]);
	        this.loop = options.loop;
	        this.reverse = options.reverse;
	    };
	    Tone.extend(Tone.Sampler, Tone.Instrument);
	    /**
		 *  the default parameters
		 *  @static
		 */
	    Tone.Sampler.defaults = {
	        'onload': Tone.noOp,
	        'loop': false,
	        'reverse': false,
	        'envelope': {
	            'attack': 0.001,
	            'decay': 0,
	            'sustain': 1,
	            'release': 0.1
	        }
	    };
	    /**
		 *  Trigger the start of the sample. 
		 *  @param {Interval} [pitch=0] The amount the sample should
		 *                              be repitched. 
		 *  @param {Time} [time=now] The time when the sample should start
		 *  @param {NormalRange} [velocity=1] The velocity of the note
		 *  @returns {Tone.Sampler} this
		 *  @example
		 * sampler.triggerAttack(0, "+0.1", 0.5);
		 */
	    Tone.Sampler.prototype.triggerAttack = function (pitch, time, velocity) {
	        time = this.toSeconds(time);
	        pitch = this.defaultArg(pitch, 0);
	        this.player.playbackRate = this.intervalToFrequencyRatio(pitch);
	        this.player.start(time);
	        this.envelope.triggerAttack(time, velocity);
	        return this;
	    };
	    /**
		 *  Start the release portion of the sample. Will stop the sample once the 
		 *  envelope has fully released. 
		 *  
		 *  @param {Time} [time=now] The time when the note should release
		 *  @returns {Tone.Sampler} this
		 *  @example
		 * sampler.triggerRelease();
		 */
	    Tone.Sampler.prototype.triggerRelease = function (time) {
	        time = this.toSeconds(time);
	        this.envelope.triggerRelease(time);
	        this.player.stop(this.toSeconds(this.envelope.release) + time);
	        return this;
	    };
	    /**
		 *  Trigger the attack and then the release after the duration. 
		 *  @param  {Interval} interval     The interval in half-steps that the
		 *                                  sample should be pitch shifted.
		 *  @param  {Time} duration How long the note should be held for before
		 *                          triggering the release.
		 *  @param {Time} [time=now]  When the note should be triggered.
		 *  @param  {NormalRange} [velocity=1] The velocity the note should be triggered at.
		 *  @returns {Tone.Sampler} this
		 *  @example
		 * //trigger the unpitched note for the duration of an 8th note
		 * synth.triggerAttackRelease(0, "8n");
		 *  @memberOf Tone.Sampler#
		 *  @name triggerAttackRelease
		 *  @method triggerAttackRelease
		 */
	    /**
		 * If the output sample should loop or not.
		 * @memberOf Tone.Sampler#
		 * @type {number|string}
		 * @name loop
		 */
	    Object.defineProperty(Tone.Sampler.prototype, 'loop', {
	        get: function () {
	            return this.player.loop;
	        },
	        set: function (loop) {
	            this.player.loop = loop;
	        }
	    });
	    /**
		 * The direction the buffer should play in
		 * @memberOf Tone.Sampler#
		 * @type {boolean}
		 * @name reverse
		 */
	    Object.defineProperty(Tone.Sampler.prototype, 'reverse', {
	        get: function () {
	            return this.player.reverse;
	        },
	        set: function (rev) {
	            this.player.reverse = rev;
	        }
	    });
	    /**
		 * The buffer to play.
		 * @memberOf Tone.Sampler#
		 * @type {Tone.Buffer}
		 * @name buffer
		 */
	    Object.defineProperty(Tone.Sampler.prototype, 'buffer', {
	        get: function () {
	            return this.player.buffer;
	        },
	        set: function (buff) {
	            this.player.buffer = buff;
	        }
	    });
	    /**
		 *  Clean up.
		 *  @returns {Tone.Sampler} this
		 */
	    Tone.Sampler.prototype.dispose = function () {
	        Tone.Instrument.prototype.dispose.call(this);
	        this._writable([
	            'player',
	            'envelope'
	        ]);
	        this.player.dispose();
	        this.player = null;
	        this.envelope.dispose();
	        this.envelope = null;
	        return this;
	    };
	    return Tone.Sampler;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Maps a NormalRange [0, 1] to an AudioRange [-1, 1]. 
		 *         See also Tone.AudioToGain. 
		 *
		 *  @extends {Tone.SignalBase}
		 *  @constructor
		 *  @example
		 * var g2a = new Tone.GainToAudio();
		 */
	    Tone.GainToAudio = function () {
	        /**
			 *  @type {WaveShaperNode}
			 *  @private
			 */
	        this._norm = this.input = this.output = new Tone.WaveShaper(function (x) {
	            return Math.abs(x) * 2 - 1;
	        });
	    };
	    Tone.extend(Tone.GainToAudio, Tone.SignalBase);
	    /**
		 *  clean up
		 *  @returns {Tone.GainToAudio} this
		 */
	    Tone.GainToAudio.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._norm.dispose();
	        this._norm = null;
	        return this;
	    };
	    return Tone.GainToAudio;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class Normalize takes an input min and max and maps it linearly to NormalRange [0,1]
		 *
		 *  @extends {Tone.SignalBase}
		 *  @constructor
		 *  @param {number} inputMin the min input value
		 *  @param {number} inputMax the max input value
		 *  @example
		 * var norm = new Tone.Normalize(2, 4);
		 * var sig = new Tone.Signal(3).connect(norm);
		 * //output of norm is 0.5. 
		 */
	    Tone.Normalize = function (inputMin, inputMax) {
	        /**
			 *  the min input value
			 *  @type {number}
			 *  @private
			 */
	        this._inputMin = this.defaultArg(inputMin, 0);
	        /**
			 *  the max input value
			 *  @type {number}
			 *  @private
			 */
	        this._inputMax = this.defaultArg(inputMax, 1);
	        /**
			 *  subtract the min from the input
			 *  @type {Tone.Add}
			 *  @private
			 */
	        this._sub = this.input = new Tone.Add(0);
	        /**
			 *  divide by the difference between the input and output
			 *  @type {Tone.Multiply}
			 *  @private
			 */
	        this._div = this.output = new Tone.Multiply(1);
	        this._sub.connect(this._div);
	        this._setRange();
	    };
	    Tone.extend(Tone.Normalize, Tone.SignalBase);
	    /**
		 * The minimum value the input signal will reach.
		 * @memberOf Tone.Normalize#
		 * @type {number}
		 * @name min
		 */
	    Object.defineProperty(Tone.Normalize.prototype, 'min', {
	        get: function () {
	            return this._inputMin;
	        },
	        set: function (min) {
	            this._inputMin = min;
	            this._setRange();
	        }
	    });
	    /**
		 * The maximum value the input signal will reach.
		 * @memberOf Tone.Normalize#
		 * @type {number}
		 * @name max
		 */
	    Object.defineProperty(Tone.Normalize.prototype, 'max', {
	        get: function () {
	            return this._inputMax;
	        },
	        set: function (max) {
	            this._inputMax = max;
	            this._setRange();
	        }
	    });
	    /**
		 *  set the values
		 *  @private
		 */
	    Tone.Normalize.prototype._setRange = function () {
	        this._sub.value = -this._inputMin;
	        this._div.value = 1 / (this._inputMax - this._inputMin);
	    };
	    /**
		 *  clean up
		 *  @returns {Tone.Normalize} this
		 */
	    Tone.Normalize.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._sub.dispose();
	        this._sub = null;
	        this._div.dispose();
	        this._div = null;
	        return this;
	    };
	    return Tone.Normalize;
	});
	Module(function (Tone) {
	    /**
		 *  @class Tone.MultiPlayer is well suited for one-shots, multi-sampled instruments
		 *         or any time you need to play a bunch of audio buffers. 
		 *  @param  {Object|Array|Tone.Buffers}  buffers  The buffers which are available
		 *                                                to the MultiPlayer
		 *  @param {Function} onload The callback to invoke when all of the buffers are loaded.
		 *  @extends {Tone}
		 *  @example
		 * var multiPlayer = new MultiPlayer({
		 * 	"kick" : "path/to/kick.mp3",
		 * 	"snare" : "path/to/snare.mp3",
		 * }, function(){
		 * 	multiPlayer.start("kick");
		 * });
		 *  @example
		 * //can also store the values in an array
		 * var multiPlayer = new MultiPlayer(["path/to/kick.mp3", "path/to/snare.mp3"], 
		 * function(){
		 * 	//if an array is passed in, the samples are referenced to by index
		 * 	multiPlayer.start(1);
		 * });
		 */
	    Tone.MultiPlayer = function () {
	        var options = this.optionsObject(arguments, [
	            'urls',
	            'onload'
	        ], Tone.MultiPlayer.defaults);
	        if (options.urls instanceof Tone.Buffers) {
	            /**
				 *  All the buffers belonging to the player.
				 *  @type  {Tone.Buffers}
				 */
	            this.buffers = options.urls;
	        } else {
	            this.buffers = new Tone.Buffers(options.urls, options.onload);
	        }
	        /**
			 *  Keeps track of the currently playing sources.
			 *  @type  {Object}
			 *  @private
			 */
	        this._activeSources = {};
	        /**
			 *  The fade in envelope which is applied
			 *  to the beginning of the BufferSource
			 *  @type  {Time}
			 */
	        this.fadeIn = options.fadeIn;
	        /**
			 *  The fade out envelope which is applied
			 *  to the end of the BufferSource
			 *  @type  {Time}
			 */
	        this.fadeOut = options.fadeOut;
	        /**
			 *  The output volume node
			 *  @type  {Tone.Volume}
			 *  @private
			 */
	        this._volume = this.output = new Tone.Volume(options.volume);
	        /**
			 * The volume of the output in decibels.
			 * @type {Decibels}
			 * @signal
			 * @example
			 * source.volume.value = -6;
			 */
	        this.volume = this._volume.volume;
	        this._readOnly('volume');
	        //make the output explicitly stereo
	        this._volume.output.output.channelCount = 2;
	        this._volume.output.output.channelCountMode = 'explicit';
	        //mute initially
	        this.mute = options.mute;
	    };
	    Tone.extend(Tone.MultiPlayer, Tone.Source);
	    /**
		 *  The defaults
		 *  @type  {Object}
		 */
	    Tone.MultiPlayer.defaults = {
	        'onload': Tone.noOp,
	        'fadeIn': 0,
	        'fadeOut': 0
	    };
	    /**
		 * Make the source from the buffername
		 * @param  {String} bufferName
		 * @return {Tone.BufferSource}
		 * @private
		 */
	    Tone.MultiPlayer.prototype._makeSource = function (bufferName) {
	        var buffer;
	        if (this.isString(bufferName) || this.isNumber(bufferName)) {
	            buffer = this.buffers.get(bufferName).get();
	        } else if (bufferName instanceof Tone.Buffer) {
	            buffer = bufferName.get();
	        } else if (bufferName instanceof AudioBuffer) {
	            buffer = bufferName;
	        }
	        var source = new Tone.BufferSource(buffer).connect(this.output);
	        if (!this._activeSources.hasOwnProperty(bufferName)) {
	            this._activeSources[bufferName] = [];
	        }
	        this._activeSources[bufferName].push(source);
	        return source;
	    };
	    /**
		 *  Start a buffer by name. The `start` method allows a number of options
		 *  to be passed in such as offset, interval, and gain. This is good for multi-sampled 
		 *  instruments and sound sprites where samples are repitched played back at different velocities.
		 *  @param  {String}  bufferName    The name of the buffer to start.
		 *  @param  {Time}  time      When to start the buffer.
		 *  @param  {Time}  [offset=0]    The offset into the buffer to play from.
		 *  @param  {Time=}  duration   How long to play the buffer for.
		 *  @param  {Interval}  [pitch=0]  The interval to repitch the buffer.
		 *  @param  {Gain}  [gain=1]      The gain to play the sample at.
		 *  @return  {Tone.MultiPlayer}  this
		 */
	    Tone.MultiPlayer.prototype.start = function (bufferName, time, offset, duration, pitch, gain) {
	        time = this.toSeconds(time);
	        var source = this._makeSource(bufferName);
	        source.start(time, offset, duration, this.defaultArg(gain, 1), this.fadeIn);
	        if (duration) {
	            source.stop(time + this.toSeconds(duration), this.fadeOut);
	        }
	        pitch = this.defaultArg(pitch, 0);
	        source.playbackRate.value = this.intervalToFrequencyRatio(pitch);
	        return this;
	    };
	    /**
		 *  Start a looping buffer by name. Similar to `start`, but the buffer
		 *  is looped instead of played straight through. Can still be stopped with `stop`. 
		 *  @param  {String}  bufferName    The name of the buffer to start.
		 *  @param  {Time}  time      When to start the buffer.
		 *  @param  {Time}  [offset=0]    The offset into the buffer to play from.
		 *  @param  {Time=}  loopStart   The start of the loop.
		 *  @param  {Time=}  loopEnd	The end of the loop.
		 *  @param  {Interval}  [pitch=0]  The interval to repitch the buffer.
		 *  @param  {Gain}  [gain=1]      The gain to play the sample at.
		 *  @return  {Tone.MultiPlayer}  this
		 */
	    Tone.MultiPlayer.prototype.startLoop = function (bufferName, time, offset, loopStart, loopEnd, pitch, gain) {
	        time = this.toSeconds(time);
	        var source = this._makeSource(bufferName);
	        source.loop = true;
	        source.loopStart = this.toSeconds(this.defaultArg(loopStart, 0));
	        source.loopEnd = this.toSeconds(this.defaultArg(loopEnd, 0));
	        source.start(time, offset, undefined, this.defaultArg(gain, 1), this.fadeIn);
	        pitch = this.defaultArg(pitch, 0);
	        source.playbackRate.value = this.intervalToFrequencyRatio(pitch);
	        return this;
	    };
	    /**
		 *  Stop the first played instance of the buffer name.
		 *  @param  {String}  bufferName  The buffer to stop.
		 *  @param  {Time=}  time    When to stop the buffer
		 *  @return  {Tone.MultiPlayer}  this
		 */
	    Tone.MultiPlayer.prototype.stop = function (bufferName, time) {
	        if (this._activeSources[bufferName] && this._activeSources[bufferName].length) {
	            time = this.toSeconds(time);
	            this._activeSources[bufferName].shift().stop(time, this.fadeOut);
	        } else {
	            throw new Error('Tone.MultiPlayer: cannot stop a buffer that hasn\'t been started or is already stopped');
	        }
	        return this;
	    };
	    /**
		 *  Stop all currently playing buffers at the given time.
		 *  @param  {Time=}  time  When to stop the buffers.
		 *  @return  {Tone.MultiPlayer}  this
		 */
	    Tone.MultiPlayer.prototype.stopAll = function (time) {
	        time = this.toSeconds(time);
	        for (var bufferName in this._activeSources) {
	            var sources = this._activeSources[bufferName];
	            for (var i = 0; i < sources.length; i++) {
	                sources[i].stop(time);
	            }
	        }
	        return this;
	    };
	    /**
		 *  Add another buffer to the available buffers.
		 *  @param {String} name The name to that the buffer is refered
		 *                       to in start/stop methods. 
		 *  @param {String|Tone.Buffer} url The url of the buffer to load
		 *                                  or the buffer.
		 *  @param {Function} callback The function to invoke after the buffer is loaded.
		 */
	    Tone.MultiPlayer.prototype.add = function (name, url, callback) {
	        this.buffers.add(name, url, callback);
	        return this;
	    };
	    /**
		 *  Returns the playback state of the source. "started"
		 *  if there are any buffers playing. "stopped" otherwise.
		 *  @type {Tone.State}
		 *  @readOnly
		 *  @memberOf Tone.MultiPlayer#
		 *  @name state
		 */
	    Object.defineProperty(Tone.MultiPlayer.prototype, 'state', {
	        get: function () {
	            return this._activeSources.length > 0 ? Tone.State.Started : Tone.State.Stopped;
	        }
	    });
	    /**
		 * Mute the output. 
		 * @memberOf Tone.MultiPlayer#
		 * @type {boolean}
		 * @name mute
		 * @example
		 * //mute the output
		 * source.mute = true;
		 */
	    Object.defineProperty(Tone.MultiPlayer.prototype, 'mute', {
	        get: function () {
	            return this._volume.mute;
	        },
	        set: function (mute) {
	            this._volume.mute = mute;
	        }
	    });
	    /**
		 *  Clean up.
		 *  @return  {Tone.MultiPlayer}  this
		 */
	    Tone.MultiPlayer.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this._volume.dispose();
	        this._volume = null;
	        this._writable('volume');
	        this.volume = null;
	        for (var bufferName in this._activeSources) {
	            this._activeSources[bufferName].forEach(function (source) {
	                source.dispose();
	            });
	        }
	        this.buffers.dispose();
	        this.buffers = null;
	        this._activeSources = null;
	        return this;
	    };
	    return Tone.MultiPlayer;
	});
	Module(function (Tone) {
	    /**
		 * @class Tone.GrainPlayer implements [granular synthesis](https://en.wikipedia.org/wiki/Granular_synthesis).
		 *        Granular Synthesis enables you to adjust pitch and playback rate independently. The grainSize is the 
		 *        amount of time each small chunk of audio is played for and the overlap is the 
		 *        amount of crossfading transition time between successive grains.
		 * @extends {Tone}
		 * @param {String|Tone.Buffer} url	The url to load, or the Tone.Buffer to play.
		 * @param {Function=} callback The callback to invoke after the url is loaded.
		 */
	    Tone.GrainPlayer = function () {
	        var options = this.optionsObject(arguments, [
	            'url',
	            'onload'
	        ], Tone.GrainPlayer.defaults);
	        Tone.Source.call(this);
	        /**
			 *  The audio buffer belonging to the player.
			 *  @type  {Tone.Buffer}
			 */
	        this.buffer = new Tone.Buffer(options.url, options.onload);
	        /**
			 *  Plays the buffer with a small envelope
			 *  @type  {Tone.MultiPlayer}
			 *  @private
			 */
	        this._player = new Tone.MultiPlayer().connect(this.output);
	        /**
			 *  Create a repeating tick to schedule
			 *  the grains.
			 *  @type  {Tone.Clock}
			 *  @private
			 */
	        this._clock = new Tone.Clock(this._tick.bind(this), 1);
	        /**
			 *  @type  {Number}
			 *  @private
			 */
	        this._loopStart = 0;
	        /**
			 *  @type  {Number}
			 *  @private
			 */
	        this._loopEnd = 0;
	        /**
			 *  @type  {Number}
			 *  @private
			 */
	        this._playbackRate = options.playbackRate;
	        /**
			 *  @type  {Number}
			 *  @private
			 */
	        this._grainSize = options.grainSize;
	        /**
			 *  @private
			 *  @type {Number}
			 */
	        this._overlap = options.overlap;
	        /**
			 *  Adjust the pitch independently of the playbackRate.
			 *  @type  {Cents}
			 */
	        this.detune = options.detune;
	        /**
			 *  The amount of time randomly added
			 *  or subtracted from the grain's offset
			 *  @type  {Time}
			 */
	        this.drift = options.drift;
	        //setup
	        this.overlap = options.overlap;
	        this.loop = options.loop;
	        this.playbackRate = options.playbackRate;
	        this.grainSize = options.grainSize;
	        this.loopStart = options.loopStart;
	        this.loopEnd = options.loopEnd;
	        this.reverse = options.reverse;
	    };
	    Tone.extend(Tone.GrainPlayer, Tone.Source);
	    /**
		 *  the default parameters
		 *  @static
		 *  @const
		 *  @type {Object}
		 */
	    Tone.GrainPlayer.defaults = {
	        'onload': Tone.noOp,
	        'overlap': 0.1,
	        'grainSize': 0.2,
	        'drift': 0,
	        'playbackRate': 1,
	        'detune': 0,
	        'loop': false,
	        'loopStart': 0,
	        'loopEnd': 0,
	        'reverse': false
	    };
	    /**
		 *  Play the buffer at the given startTime. Optionally add an offset
		 *  and/or duration which will play the buffer from a position
		 *  within the buffer for the given duration. 
		 *  
		 *  @param  {Time} [startTime=now] When the player should start.
		 *  @param  {Time} [offset=0] The offset from the beginning of the sample
		 *                                 to start at. 
		 *  @param  {Time=} duration How long the sample should play. If no duration
		 *                                is given, it will default to the full length 
		 *                                of the sample (minus any offset)
		 *  @returns {Tone.GrainPlayer} this
		 *  @memberOf Tone.GrainPlayer#
		 *  @method start
		 *  @name start
		 */
	    /**
		 *  Internal start method
		 *  @param {Time} time
		 *  @param {Time} offset
		 *  @private
		 */
	    Tone.GrainPlayer.prototype._start = function (time, offset, duration) {
	        offset = this.defaultArg(offset, 0);
	        offset = this.toSeconds(offset);
	        time = this.toSeconds(time);
	        this._offset = offset;
	        this._clock.start(time);
	        //unmute the player
	        this._player.volume.setValueAtTime(0, time);
	        if (duration) {
	            this._stop(time + this.toSeconds(duration));
	        }
	    };
	    /**
		 *  Internal start method
		 *  @param {Time} time
		 *  @private
		 */
	    Tone.GrainPlayer.prototype._stop = function (time) {
	        this._clock.stop(time);
	        //mute the player
	        this._player.volume.cancelScheduledValues(time);
	        this._player.volume.setValueAtTime(-Infinity, time);
	    };
	    /**
		 *  Invoked on each clock tick. scheduled a new
		 *  grain at this time.
		 *  @param  {Time}  time 
		 *  @private
		 */
	    Tone.GrainPlayer.prototype._tick = function (time) {
	        var bufferDuration = this.buffer.duration;
	        if (this.loop && this._loopEnd > 0) {
	            bufferDuration = this._loopEnd;
	        }
	        var drift = (Math.random() * 2 - 1) * this.drift;
	        var offset = this._offset - this._overlap + drift;
	        var detune = this.detune / 100;
	        //keep the offset within the limits of the buffer
	        offset = Math.max(offset, 0);
	        offset = Math.min(offset, bufferDuration);
	        var originalFadeIn = this._player.fadeIn;
	        if (this.loop && this._offset > bufferDuration) {
	            //play the end
	            var endSegmentDuration = this._offset - bufferDuration;
	            this._player.start(this.buffer, time, offset, endSegmentDuration + this._overlap, detune);
	            //and play the beginning 
	            offset = this._offset % bufferDuration;
	            this._offset = this._loopStart;
	            this._player.fadeIn = 0;
	            this._player.start(this.buffer, time + endSegmentDuration, this._offset, offset + this._overlap, detune);
	        } else if (this._offset > bufferDuration) {
	            //set the state to stopped. 
	            this.stop(time);
	        } else {
	            if (offset === 0) {
	                this._player.fadeIn = 0;
	            }
	            this._player.start(this.buffer, time, offset, this.grainSize + this._overlap, detune);
	        }
	        this._player.fadeIn = originalFadeIn;
	        //increment the offset
	        var duration = this._clock._nextTick - time;
	        this._offset += duration * this._playbackRate;
	    };
	    /**
		 *  Jump to a specific time and play it.
		 *  @param  {Time}  offset  The offset to jump to.
		 *  @param {Time=} time When to make the jump.
		 *  @return  {[type]}  [description]
		 */
	    Tone.GrainPlayer.prototype.scrub = function (offset, time) {
	        this._offset = this.toSeconds(offset);
	        this._tick(this.toSeconds(time));
	        return this;
	    };
	    /**
		 * The playback rate of the sample
		 * @memberOf Tone.GrainPlayer#
		 * @type {Positive}
		 * @name playbackRate
		 */
	    Object.defineProperty(Tone.GrainPlayer.prototype, 'playbackRate', {
	        get: function () {
	            return this._playbackRate;
	        },
	        set: function (rate) {
	            this._playbackRate = rate;
	            this.grainSize = this._grainSize;
	        }
	    });
	    /**
		 * The loop start time. 
		 * @memberOf Tone.GrainPlayer#
		 * @type {Time}
		 * @name loopStart
		 */
	    Object.defineProperty(Tone.GrainPlayer.prototype, 'loopStart', {
	        get: function () {
	            return this._loopStart;
	        },
	        set: function (time) {
	            this._loopStart = this.toSeconds(time);
	        }
	    });
	    /**
		 * The loop end time. 
		 * @memberOf Tone.GrainPlayer#
		 * @type {Time}
		 * @name loopEnd
		 */
	    Object.defineProperty(Tone.GrainPlayer.prototype, 'loopEnd', {
	        get: function () {
	            return this._loopEnd;
	        },
	        set: function (time) {
	            this._loopEnd = this.toSeconds(time);
	        }
	    });
	    /**
		 * The direction the buffer should play in
		 * @memberOf Tone.GrainPlayer#
		 * @type {boolean}
		 * @name reverse
		 */
	    Object.defineProperty(Tone.GrainPlayer.prototype, 'reverse', {
	        get: function () {
	            return this.buffer.reverse;
	        },
	        set: function (rev) {
	            this.buffer.reverse = rev;
	        }
	    });
	    /**
		 * The size of each chunk of audio that the 
		 * buffer is chopped into and played back at.
		 * @memberOf Tone.GrainPlayer#
		 * @type {Time}
		 * @name grainSize
		 */
	    Object.defineProperty(Tone.GrainPlayer.prototype, 'grainSize', {
	        get: function () {
	            return this._grainSize;
	        },
	        set: function (size) {
	            this._grainSize = this.toSeconds(size);
	            this._clock.frequency.value = this._playbackRate / this._grainSize;
	        }
	    });
	    /**
		 * This is the duration of the cross-fade between 
		 * sucessive grains.
		 * @memberOf Tone.GrainPlayer#
		 * @type {Time}
		 * @name overlap
		 */
	    Object.defineProperty(Tone.GrainPlayer.prototype, 'overlap', {
	        get: function () {
	            return this._overlap;
	        },
	        set: function (time) {
	            time = this.toSeconds(time);
	            this._overlap = time;
	            if (this._overlap < 0) {
	                this._player.fadeIn = 0.01;
	                this._player.fadeOut = 0.01;
	            } else {
	                this._player.fadeIn = time;
	                this._player.fadeOut = time;
	            }
	        }
	    });
	    /**
		 * Clean up
		 * @return {Tone.GrainPlayer} this
		 */
	    Tone.GrainPlayer.prototype.dispose = function () {
	        Tone.Source.prototype.dispose.call(this);
	        this.buffer.dispose();
	        this.buffer = null;
	        this._player.dispose();
	        this._player = null;
	        this._clock.dispose();
	        this._clock = null;
	        return this;
	    };
	    return Tone.GrainPlayer;
	});
	Module(function (Tone) {
	    
	    /**
		 *  @class  Tone.UserMedia uses MediaDevices.getUserMedia to open up
		 *          and external microphone or audio input. Check 
		 *          [MediaDevices API Support](https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getUserMedia)
		 *          to see which browsers are supported. Access to an external input
		 *          is limited to secure (HTTPS) connections.
		 *         
		 *  @constructor
		 *  @extends {Tone}
		 *  @param {Decibels=} volume The level of the input
		 *  @example
		 * //list the inputs and open the third one
		 * var motu = new Tone.UserMedia();
		 * 
		 * //opening the input asks the user to activate their mic
		 * motu.open().then(function(){
		 * 	//opening is activates the microphone
		 * 	//starting lets audio through
		 * 	motu.start(10);
		 * });
		 */
	    Tone.UserMedia = function () {
	        var options = this.optionsObject(arguments, ['volume'], Tone.UserMedia.defaults);
	        /**
			 *  The MediaStreamNode 
			 *  @type {MediaStreamAudioSourceNode}
			 *  @private
			 */
	        this._mediaStream = null;
	        /**
			 *  The media stream created by getUserMedia.
			 *  @type {LocalMediaStream}
			 *  @private
			 */
	        this._stream = null;
	        /**
			 *  The open device
			 *  @type  {MediaDeviceInfo}
			 *  @private
			 */
	        this._device = null;
	        /**
			 *  The output volume node
			 *  @type  {Tone.Volume}
			 *  @private
			 */
	        this._volume = this.output = new Tone.Volume(options.volume);
	        /**
			 * The volume of the output in decibels.
			 * @type {Decibels}
			 * @signal
			 * @example
			 * input.volume.value = -6;
			 */
	        this.volume = this._volume.volume;
	        this._readOnly('volume');
	        this.mute = options.mute;
	    };
	    Tone.extend(Tone.UserMedia);
	    /**
		 * the default parameters
		 * @type {Object}
		 */
	    Tone.UserMedia.defaults = {
	        'volume': 0,
	        'mute': false
	    };
	    /**
		 *  Open the media stream. If a string is passed in, it is assumed
		 *  to be the label or id of the stream, if a number is passed in,
		 *  it is the input number of the stream.
		 *  @param  {String|Number} [labelOrId="default"] The label or id of the audio input media device. 
		 *                                                With no argument, the default stream is opened.
		 *  @return {Promise} The promise is resolved when the stream is open.
		 */
	    Tone.UserMedia.prototype.open = function (labelOrId) {
	        labelOrId = this.defaultArg(labelOrId, 'default');
	        return this.enumerateDevices().then(function (devices) {
	            var device;
	            if (this.isNumber(labelOrId)) {
	                device = devices[labelOrId];
	            } else {
	                device = devices.find(function (device) {
	                    return device.label === labelOrId || device.deviceId === labelOrId;
	                });
	                if (!device) {
	                    //otherwise just take the first one
	                    device = devices[0];
	                }
	            }
	            //didn't find a matching device
	            if (!device) {
	                throw new Error('Tone.UserMedia: no matching audio inputs.');
	            }
	            this._device = device;
	            //do getUserMedia
	            var constraints = {
	                audio: {
	                    'deviceId': device.deviceId,
	                    'echoCancellation': false,
	                    'sampleRate': this.context.sampleRate
	                }
	            };
	            return navigator.mediaDevices.getUserMedia(constraints).then(function (stream) {
	                //start a new source only if the previous one is closed
	                if (!this._stream) {
	                    this._stream = stream;
	                    //Wrap a MediaStreamSourceNode around the live input stream.
	                    this._mediaStream = this.context.createMediaStreamSource(stream);
	                    //Connect the MediaStreamSourceNode to a gate gain node
	                    this._mediaStream.connect(this.output);
	                }
	                return this;
	            }.bind(this));
	        }.bind(this));
	    };
	    /**
		 *  Close the media stream
		 *  @return {Tone.UserMedia} this
		 */
	    Tone.UserMedia.prototype.close = function () {
	        if (this._stream) {
	            this._stream.getAudioTracks().forEach(function (track) {
	                track.stop();
	            });
	            this._stream = null;
	            //remove the old media stream
	            this._mediaStream.disconnect();
	            this._mediaStream = null;
	        }
	        this._device = null;
	        return this;
	    };
	    /**
		 *  Returns a promise which resolves with the list of audio input devices available.
		 *  @return {Promise} The promise that is resolved with the devices
		 *  @example
		 * extInput.enumerateDevices().then(function(devices){
		 * 	console.log(devices)
		 * })
		 */
	    Tone.UserMedia.prototype.enumerateDevices = function () {
	        return navigator.mediaDevices.enumerateDevices().then(function (devices) {
	            return devices.filter(function (device) {
	                return device.kind === 'audioinput';
	            });
	        });
	    };
	    /**
		 *  Returns the playback state of the source, "started" when the microphone is open
		 *  and "stopped" when the mic is closed.
		 *  @type {Tone.State}
		 *  @readOnly
		 *  @memberOf Tone.UserMedia#
		 *  @name state
		 */
	    Object.defineProperty(Tone.UserMedia.prototype, 'state', {
	        get: function () {
	            return this._stream && this._stream.active ? Tone.State.Started : Tone.State.Stopped;
	        }
	    });
	    /**
		 * 	Returns an identifier for the represented device that is 
		 * 	persisted across sessions. It is un-guessable by other applications and 
		 * 	unique to the origin of the calling application. It is reset when the 
		 * 	user clears cookies (for Private Browsing, a different identifier is 
		 * 	used that is not persisted across sessions). Returns undefined when the 
		 * 	device is not open.
		 *  @type {String}
		 *  @readOnly
		 *  @memberOf Tone.UserMedia#
		 *  @name deviceId
		 */
	    Object.defineProperty(Tone.UserMedia.prototype, 'deviceId', {
	        get: function () {
	            if (this._device) {
	                return this._device.deviceId;
	            }
	        }
	    });
	    /**
		 * 	Returns a group identifier. Two devices have the 
		 * 	same group identifier if they belong to the same physical device.
		 * 	Returns undefined when the device is not open.
		 *  @type {String}
		 *  @readOnly
		 *  @memberOf Tone.UserMedia#
		 *  @name groupId
		 */
	    Object.defineProperty(Tone.UserMedia.prototype, 'groupId', {
	        get: function () {
	            if (this._device) {
	                return this._device.groupId;
	            }
	        }
	    });
	    /**
		 * 	Returns a label describing this device (for example "Built-in Microphone"). 
		 * 	Returns undefined when the device is not open or label is not available
		 * 	because of permissions.
		 *  @type {String}
		 *  @readOnly
		 *  @memberOf Tone.UserMedia#
		 *  @name groupId
		 */
	    Object.defineProperty(Tone.UserMedia.prototype, 'label', {
	        get: function () {
	            if (this._device) {
	                return this._device.label;
	            }
	        }
	    });
	    /**
		 * Mute the output. 
		 * @memberOf Tone.UserMedia#
		 * @type {boolean}
		 * @name mute
		 * @example
		 * //mute the output
		 * userMedia.mute = true;
		 */
	    Object.defineProperty(Tone.UserMedia.prototype, 'mute', {
	        get: function () {
	            return this._volume.mute;
	        },
	        set: function (mute) {
	            this._volume.mute = mute;
	        }
	    });
	    /**
		 * Clean up.
		 * @return {Tone.UserMedia} this
		 */
	    Tone.UserMedia.prototype.dispose = function () {
	        Tone.prototype.dispose.call(this);
	        this.close();
	        this._writable('volume');
	        this._volume.dispose();
	        this._volume = null;
	        this.volume = null;
	        return this;
	    };
	    /**
		 *  If getUserMedia is supported by the browser.
		 *  @type  {Boolean}
		 *  @memberOf Tone.UserMedia#
		 *  @name supported
		 *  @static
		 *  @readOnly
		 */
	    Object.defineProperty(Tone.UserMedia, 'supported', {
	        get: function () {
	            return !Tone.prototype.isUndef(navigator.mediaDevices) && Tone.prototype.isFunction(navigator.mediaDevices.getUserMedia);
	        }
	    });
	    return Tone.UserMedia;
	});
	
	return Tone;
}));

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showAboutMobile = exports.showHideUI = exports.clearAll = exports.startCountry = exports.showTradeBtn = exports.showCountriesBtn = undefined;

var _validCountries = __webpack_require__(71);

var _countryOptions = __webpack_require__(27);

var _utils = __webpack_require__(12);

var _Timeline = __webpack_require__(28);

// Custom GUI without dat.gui.js

var mobile = __webpack_require__(62);

var currentSelectedCountry = document.getElementById("currentSelectedCountry");
var currentSelectedTrade = document.getElementById("currentSelectedTrade");
var countryList = document.getElementById("countryList");
var warning = document.getElementById("warning");
var selectedCountry = null;
var selectedCountries = {};
var name = void 0;

// Add all Valid Countries to the dropdown
_validCountries.validCountries.sort();
_validCountries.validCountries.forEach(function (country) {
  var element = document.createElement("div");
  element.className = "country";
  element.dataset.name = country;
  element.appendChild(document.createTextNode(country));
  countryList.appendChild(element);
});

// Get element containing all countries
var showCountriesBtn = function showCountriesBtn() {
  document.getElementById("countryList").classList.toggle("show");
};
// Get element containing all trades
var showTradeBtn = function showTradeBtn() {
  document.getElementById("tradeList").classList.toggle("show");
};

// Function to trigger when a country is selected: Get country and it's data-name property
var allCountriesDropwdown = document.getElementsByClassName("country");
var selectCountry = function selectCountry(element) {
  name = this.getAttribute("data-name");
  selectedCountry = element.srcElement;
  currentSelectedCountry.innerHTML = name;
  _countryOptions.countryOptions.Country = name;
};
// Function to trigger when a trade is selected: Get trade type and it's data-name property
var tradeTypeDropwdown = document.getElementsByClassName("tradeType");
var selectTrade = function selectTrade(element) {
  var type = this.getAttribute("data-name");
  currentSelectedTrade.innerHTML = type.charAt(0).toUpperCase() + type.slice(1);
  _countryOptions.countryOptions["Trade Type"] = type;
  for (var country in selectedCountries) {
    if (selectedCountries[country][type]) {
      selectedCountries[country].elt.style.color = '#3e3c3c';
    } else {
      selectedCountries[country].elt.style.color = '#c7c7c7';
    }
  };
};

// Add event-listenr for each country.
for (var i = 0; i < allCountriesDropwdown.length; i++) {
  allCountriesDropwdown[i].addEventListener('click', selectCountry, false);
}
// Add event-listenr for trade types
for (var _i = 0; _i < tradeTypeDropwdown.length; _i++) {
  tradeTypeDropwdown[_i].addEventListener('click', selectTrade, false);
}

// If clicked outside of the button
window.onclick = function (event) {
  if (!event.target.matches('.dropbtn')) {
    var dropdowns = document.getElementsByClassName("dropdown-content");
    for (var _i2 = 0; _i2 < dropdowns.length; _i2++) {
      var openDropdown = dropdowns[_i2];
      if (openDropdown.classList.contains('show')) {
        openDropdown.classList.remove('show');
      }
    }
  }
};

// Start visualizing a country
var startCountry = function startCountry() {
  if (!_countryOptions.countryOptions.Country) {
    warning.style.display = 'block';
    warning.style.display = 'block';
    warning.innerHTML = "Please select a Country";
  } else if (!_countryOptions.countryOptions["Trade Type"]) {
    warning.style.display = 'block';
    warning.innerHTML = "Please select a Trade Type";
  } else {
    if (!selectedCountries[name]) {
      selectedCountries[name] = {};
    }
    selectedCountries[name][_countryOptions.countryOptions["Trade Type"]] = true;
    selectedCountries[name].elt = selectedCountry;
    warning.style.display = 'none';
    selectedCountry.style.color = '#3e3c3c';
    _countryOptions.countryOptions.Elt = selectedCountry;
    _countryOptions.countryOptions.Start();
  }
};

// Clear visualizing a country
var clearAll = function clearAll() {
  for (var country in selectedCountries) {
    selectedCountries[country].elt.style.color = '#c7c7c7';
  };
  selectedCountries = {};
  (0, _Timeline.removeAllCountriesFromTimeline)();
  _countryOptions.countryOptions["Clear All"]();
};

// Hide stuff when mobile
if (mobile()) {
  var info = document.getElementById('info');
  var ui = document.getElementById('ui');
  var hideUI = document.getElementById('hideUI');
  info.style.display = 'none';
  ui.style.top = '1em';
  hideUI.style.display = 'block';
}

var showHideUI = function showHideUI() {
  var hidden = false;
  var hideUIButton = document.getElementById('hideUIButton');
  var about = document.getElementById('aboutBtn');
  var UIs = document.getElementsByClassName('ui');

  return function () {
    hideUIButton.innerHTML = 'Options';
    about.style.display = 'none';
    if (hidden) {
      for (var _i3 = 0; _i3 < UIs.length; _i3++) {
        UIs[_i3].style.display = 'none';
      }
    } else {
      about.style.display = 'inline';
      hideUIButton.innerHTML = 'Hide Options';
      for (var _i4 = 0; _i4 < UIs.length; _i4++) {
        UIs[_i4].style.display = 'block';
      }
    }
    hidden = !hidden;
  };
};

var showAboutMobile = function showAboutMobile() {
  var overlays = document.getElementsByClassName('overlay');
  var showingAbout = false;

  return function () {
    if (showingAbout) {
      for (var _i5 = 0; _i5 < overlays.length; _i5++) {
        overlays[_i5].style.display = 'none';
      }
    } else {
      document.getElementById('start').innerHTML = 'Resume';
      for (var _i6 = 0; _i6 < overlays.length; _i6++) {
        overlays[_i6].style.display = 'block';
      }
    }
    showingAbout = !showingAbout;
  };
};

// Quick way to debug with a preset country. ONLY FOR DEVELOPMENT
// let overlays = document.getElementsByClassName('overlay');
// for(let i = 0; i < overlays.length; i++){
//   overlays[i].style.display = 'none'
// }
// let demoCountry = () =>{
//   let countries = document.getElementsByClassName("country");
//   let name = countries[2].getAttribute('data-name');
//   selectedCountry = countries[2];
//   currentSelectedCountry.innerHTML = name;
//   countryOptions.Country = name;

//   let types = document.getElementsByClassName("tradeType")
//   let type = types[0].getAttribute("data-name");
//   currentSelectedTrade.innerHTML = type.charAt(0).toUpperCase() + type.slice(1);
//   countryOptions["Trade Type"] = type;

//   selectedCountry.style.color = '#3e3c3c';
//   selectedCountries.push(selectedCountry);
//   countryOptions.Elt = selectedCountry;
//   // countryOptions.Start();
// }
// setTimeout(function(){
//   demoCountry();
// },1000)

exports.showCountriesBtn = showCountriesBtn;
exports.showTradeBtn = showTradeBtn;
exports.startCountry = startCountry;
exports.clearAll = clearAll;
exports.showHideUI = showHideUI;
exports.showAboutMobile = showAboutMobile;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function webpackUniversalModuleDefinition(root, factory) {
  if (( false ? 'undefined' : _typeof2(exports)) === 'object' && ( false ? 'undefined' : _typeof2(module)) === 'object') module.exports = factory();else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if ((typeof exports === 'undefined' ? 'undefined' : _typeof2(exports)) === 'object') exports["Mappa"] = factory();else root["Mappa"] = factory();
})(undefined, function () {
  return (/******/function (modules) {
      // webpackBootstrap
      /******/ // The module cache
      /******/var installedModules = {};
      /******/
      /******/ // The require function
      /******/function __webpack_require__(moduleId) {
        /******/
        /******/ // Check if module is in cache
        /******/if (installedModules[moduleId]) {
          /******/return installedModules[moduleId].exports;
          /******/
        }
        /******/ // Create a new module (and put it into the cache)
        /******/var module = installedModules[moduleId] = {
          /******/i: moduleId,
          /******/l: false,
          /******/exports: {}
          /******/ };
        /******/
        /******/ // Execute the module function
        /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/
        /******/ // Flag the module as loaded
        /******/module.l = true;
        /******/
        /******/ // Return the exports of the module
        /******/return module.exports;
        /******/
      }
      /******/
      /******/
      /******/ // expose the modules object (__webpack_modules__)
      /******/__webpack_require__.m = modules;
      /******/
      /******/ // expose the module cache
      /******/__webpack_require__.c = installedModules;
      /******/
      /******/ // identity function for calling harmony imports with the correct context
      /******/__webpack_require__.i = function (value) {
        return value;
      };
      /******/
      /******/ // define getter function for harmony exports
      /******/__webpack_require__.d = function (exports, name, getter) {
        /******/if (!__webpack_require__.o(exports, name)) {
          /******/Object.defineProperty(exports, name, {
            /******/configurable: false,
            /******/enumerable: true,
            /******/get: getter
            /******/ });
          /******/
        }
        /******/
      };
      /******/
      /******/ // getDefaultExport function for compatibility with non-harmony modules
      /******/__webpack_require__.n = function (module) {
        /******/var getter = module && module.__esModule ?
        /******/function getDefault() {
          return module['default'];
        } :
        /******/function getModuleExports() {
          return module;
        };
        /******/__webpack_require__.d(getter, 'a', getter);
        /******/return getter;
        /******/
      };
      /******/
      /******/ // Object.prototype.hasOwnProperty.call
      /******/__webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/
      /******/ // __webpack_public_path__
      /******/__webpack_require__.p = "/dist/";
      /******/
      /******/ // Load entry module and return exports
      /******/return __webpack_require__(__webpack_require__.s = 6);
      /******/
    }(
    /************************************************************************/
    /******/[
    /* 0 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.StaticMap = undefined;

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }(); // -----------
      // Static Map
      // -----------

      var _parseGeoJSON = __webpack_require__(3);

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      var StaticMap = function () {
        function StaticMap(options) {
          _classCallCheck(this, StaticMap);

          this.options = options;
          this.init();
        }

        _createClass(StaticMap, [{
          key: 'init',
          value: function init() {
            this.options.pixels = 256;
            !this.options.scale && (this.options.scale = 1);
            if (this.options.scale == 2) {
              this.options.pixels = 512;
            }
          }
        }, {
          key: 'latLngToPixel',
          value: function latLngToPixel(lat, lng) {
            return {
              x: this.fromLngToPoint(lng) - this.fromLngToPoint(this.options.lng) + this.options.width / (2 / this.options.scale),
              y: this.fromLatToPoint(lat) - this.fromLatToPoint(this.options.lat) + this.options.height / (2 / this.options.scale)
            };
          }
        }, {
          key: 'fromLatToPoint',
          value: function fromLatToPoint(l) {
            return this.options.pixels / Math.PI * Math.pow(2, this.options.zoom) * (Math.PI - Math.log(Math.tan(Math.PI / 4 + l * Math.PI / 180 / 2)));
          }
        }, {
          key: 'fromLngToPoint',
          value: function fromLngToPoint(l) {
            return this.options.pixels / Math.PI * Math.pow(2, this.options.zoom) * (l * Math.PI / 180 + Math.PI);
          }
        }, {
          key: 'geoJSON',
          value: function geoJSON() {
            return (0, _parseGeoJSON.parseGeoJSON)(arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1]);
          }
        }]);

        return StaticMap;
      }();

      exports.StaticMap = StaticMap;

      /***/
    },
    /* 1 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.Leaflet = undefined;

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _TileMap2 = __webpack_require__(2);

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      } // ----------- 
      // Leaflet v1.0.3 
      // Reference: http://leafletjs.com/reference-1.0.3.html 
      //-----------

      var Leaflet = function (_TileMap) {
        _inherits(Leaflet, _TileMap);

        function Leaflet(options) {
          _classCallCheck(this, Leaflet);

          var _this = _possibleConstructorReturn(this, (Leaflet.__proto__ || Object.getPrototypeOf(Leaflet)).call(this, options));

          _this.script = 'https://unpkg.com/leaflet@1.0.3/dist/leaflet.js';
          _this.style = 'https://unpkg.com/leaflet@1.0.3/dist/leaflet.css';
          _this.constructor.name == 'Leaflet' && _this.init();
          return _this;
        }

        _createClass(Leaflet, [{
          key: 'createMap',
          value: function createMap() {
            var _this2 = this;

            this.map = L.map('mappa', {
              center: [this.options.lat, this.options.lng],
              zoom: this.options.zoom,
              inertia: false
            });

            if (!this.options.style) {
              Leaflet.messages().tiles();
              this.ready = true;
            } else {
              this.tiles = L.tileLayer(this.options.style).addTo(this.map);
              this.tiles.on('tileload', function () {
                _this2.ready = true;
              });
            }
            this.canvasOverlay();
          }
        }, {
          key: 'canvasOverlay',
          value: function canvasOverlay() {
            var _this3 = this;

            if (this.tiles) {
              this.tiles.options.opacity = this.options.opacity;
            }

            L.overlay = L.Layer.extend({
              onAdd: function onAdd() {
                var overlayPane = overlay.getPane();
                var _container = L.DomUtil.create('div', 'leaflet-layer');
                _container.appendChild(_this3.canvas);
                overlayPane.appendChild(_container);
              },
              drawLayer: function drawLayer() {}
            });

            var overlay = new L.overlay();
            this.map.addLayer(overlay);

            var _canvas = this.canvas.getContext('webgl') || this.canvas.getContext('2d');

            this.map.on('move', function () {
              var d = _this3.map.dragging._draggable;
              d._newPos && (_canvas.canvas.style.transform = 'translate(' + -d._newPos.x + 'px,' + -d._newPos.y + 'px)');
            });
          }
        }, {
          key: 'fromLatLngtoPixel',
          value: function fromLatLngtoPixel(position) {
            if (this.ready) {
              var containerPoint = this.map.latLngToContainerPoint(position);
              return { x: containerPoint.x, y: containerPoint.y };
            } else {
              return { x: -100, y: -100 };
            }
          }
        }, {
          key: 'fromPointToLatLng',
          value: function fromPointToLatLng() {
            if (this.ready) {
              for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }

              return this.map.containerPointToLatLng(args);
            } else {
              return { lat: -100, lng: -100 };
            }
          }
        }, {
          key: 'getZoom',
          value: function getZoom() {
            if (this.ready) {
              return this.map.getZoom();
            } else {
              return 0;
            }
          }
        }, {
          key: 'onChange',
          value: function onChange(callback) {
            var _this4 = this;

            if (this.ready) {
              callback();
              this.map.on('move', callback);
            } else {
              setTimeout(function () {
                _this4.onChange(callback);
              }, 200);
            }
          }
        }, {
          key: 'removeOnChange',
          value: function removeOnChange(callback) {
            this.map.off('move', callback);
          }
        }], [{
          key: 'messages',
          value: function messages() {
            return {
              tiles: function tiles() {
                console.warn('You are not using any tiles for your map. Try with: http://{s}.tile.osm.org/{z}/' + '{x}/{y}.png');
              }
            };
          }
        }]);

        return Leaflet;
      }(_TileMap2.TileMap);

      exports.Leaflet = Leaflet;

      /***/
    },
    /* 2 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.TileMap = undefined;

      var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
        return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
      };

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }(); // -----------
      // Tiled Map
      // -----------

      var _parseGeoJSON = __webpack_require__(3);

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      var TileMap = function () {
        function TileMap(options) {
          _classCallCheck(this, TileMap);

          this.options = options;
          this.scriptTag;
          this.mappaDiv = null;
        }

        _createClass(TileMap, [{
          key: 'init',
          value: function init() {
            if (!document.getElementById(this.options.provider)) {
              this.scriptTag = document.createElement('script');
              this.scriptTag.type = 'text/javascript';
              this.scriptTag.src = this.script;
              this.scriptTag.id = this.options.provider;
              document.head.appendChild(this.scriptTag);
              if (this.style) {
                var styleTag = document.createElement('link');
                styleTag.rel = 'stylesheet';
                styleTag.href = this.style;
                document.head.appendChild(styleTag);
              }
            }
          }
        }, {
          key: 'overlay',
          value: function overlay(canvas, callback) {
            var _this = this;

            this.scriptTag.onload = function () {
              _this.mappaDiv = document.createElement('div');
              document.body.appendChild(_this.mappaDiv);
              _this.mappaDiv.setAttribute('style', 'position:relative;width:' + canvas.width + 'px;height:' + canvas.height + 'px;top:0;left:0;z-index:10');
              _this.mappaDiv.setAttribute('id', 'mappa');
              canvas.elt != undefined ? _this.canvas = canvas.elt : _this.canvas = canvas;
              _this.createMap();
              callback && callback();
            };
          }
        }, {
          key: 'resizeMap',
          value: function resizeMap(canvas) {
            this.mappaDiv.setAttribute('style', 'position:relative;width:' + canvas.width + 'px;height:' + canvas.height + 'px;top:0;left:0;z-index:10');
            this.canvasOverlay();
          }
        }, {
          key: 'latLngToPixel',
          value: function latLngToPixel() {
            var pos = void 0;
            _typeof(arguments.length <= 0 ? undefined : arguments[0]) == 'object' ? pos = arguments.length <= 0 ? undefined : arguments[0] : pos = { lat: Number(arguments.length <= 0 ? undefined : arguments[0]), lng: Number(arguments.length <= 1 ? undefined : arguments[1]) };
            return this.fromLatLngtoPixel(pos);
          }
        }, {
          key: 'pixelToLatLng',
          value: function pixelToLatLng() {
            return this.fromPointToLatLng.apply(this, arguments);
          }
        }, {
          key: 'geoJSON',
          value: function geoJSON() {
            return (0, _parseGeoJSON.parseGeoJSON)(arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1]);
          }
        }, {
          key: 'zoom',
          value: function zoom() {
            return Math.floor(this.getZoom());
          }
        }]);

        return TileMap;
      }();

      exports.TileMap = TileMap;

      /***/
    },
    /* 3 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      // -----------
      // Parse a GeoJSON file.
      // -----------

      var parseGeoJSON = function parseGeoJSON(data, type) {
        var result = [];

        if (data.type === 'FeatureCollection') {
          if (data.features instanceof Array) {
            data.features.forEach(function (feature) {
              var f = eachFeature(feature, type);
              f != undefined && result.push(f);
            });
          }
        } else {
          result = eachFeature(data, type);
        }
        return result;
      };

      var eachFeature = function eachFeature(feature, type) {
        if (feature.hasOwnProperty('geometry') && feature.geometry.type == type) {
          return feature.geometry.coordinates;
        } else if (feature.hasOwnProperty('geometries') && feature.geometries instanceof Array && feature.geometry.type == type) {
          feature.geometries.forEach(function (geometry) {
            return feature.geometry.coordinates;
          });
        } else if (feature.hasOwnProperty('coordinates') && feature.geometry.type == type) {
          return feature.geometry.coordinates;
        }
      };

      exports.parseGeoJSON = parseGeoJSON;

      /***/
    },
    /* 4 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _Mapbox = __webpack_require__(8);

      Object.keys(_Mapbox).forEach(function (key) {
        if (key === "default" || key === "__esModule") return;
        Object.defineProperty(exports, key, {
          enumerable: true,
          get: function get() {
            return _Mapbox[key];
          }
        });
      });

      var _Google = __webpack_require__(7);

      Object.keys(_Google).forEach(function (key) {
        if (key === "default" || key === "__esModule") return;
        Object.defineProperty(exports, key, {
          enumerable: true,
          get: function get() {
            return _Google[key];
          }
        });
      });

      var _Mapquest = __webpack_require__(9);

      Object.keys(_Mapquest).forEach(function (key) {
        if (key === "default" || key === "__esModule") return;
        Object.defineProperty(exports, key, {
          enumerable: true,
          get: function get() {
            return _Mapquest[key];
          }
        });
      });

      var _StaticMap = __webpack_require__(0);

      Object.keys(_StaticMap).forEach(function (key) {
        if (key === "default" || key === "__esModule") return;
        Object.defineProperty(exports, key, {
          enumerable: true,
          get: function get() {
            return _StaticMap[key];
          }
        });
      });

      /***/
    },
    /* 5 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _Mapboxgl = __webpack_require__(12);

      Object.keys(_Mapboxgl).forEach(function (key) {
        if (key === "default" || key === "__esModule") return;
        Object.defineProperty(exports, key, {
          enumerable: true,
          get: function get() {
            return _Mapboxgl[key];
          }
        });
      });

      var _Google = __webpack_require__(10);

      Object.keys(_Google).forEach(function (key) {
        if (key === "default" || key === "__esModule") return;
        Object.defineProperty(exports, key, {
          enumerable: true,
          get: function get() {
            return _Google[key];
          }
        });
      });

      var _Leaflet = __webpack_require__(1);

      Object.keys(_Leaflet).forEach(function (key) {
        if (key === "default" || key === "__esModule") return;
        Object.defineProperty(exports, key, {
          enumerable: true,
          get: function get() {
            return _Leaflet[key];
          }
        });
      });

      var _Mapbox = __webpack_require__(11);

      Object.keys(_Mapbox).forEach(function (key) {
        if (key === "default" || key === "__esModule") return;
        Object.defineProperty(exports, key, {
          enumerable: true,
          get: function get() {
            return _Mapbox[key];
          }
        });
      });

      var _Mapzen = __webpack_require__(13);

      Object.keys(_Mapzen).forEach(function (key) {
        if (key === "default" || key === "__esModule") return;
        Object.defineProperty(exports, key, {
          enumerable: true,
          get: function get() {
            return _Mapzen[key];
          }
        });
      });

      var _Tangram = __webpack_require__(14);

      Object.keys(_Tangram).forEach(function (key) {
        if (key === "default" || key === "__esModule") return;
        Object.defineProperty(exports, key, {
          enumerable: true,
          get: function get() {
            return _Tangram[key];
          }
        });
      });

      /***/
    },
    /* 6 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";
      /*
      * Mappa: A library to work with maps and p5.js
      * https://github.com/cvalenzuela/mappa
      *
      * Cristóbal Valenzuela
      * cv965@nyu.edu
      * Google Summer of Code 2017
      */

      var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
        return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
      };

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _tileMap2 = __webpack_require__(5);

      var _tileMap = _interopRequireWildcard(_tileMap2);

      var _staticMap2 = __webpack_require__(4);

      var _staticMap = _interopRequireWildcard(_staticMap2);

      function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
          return obj;
        } else {
          var newObj = {};if (obj != null) {
            for (var key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
          }newObj.default = obj;return newObj;
        }
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      console.log('%c p5.maps Loaded ✓', 'color:white; background:green;');

      var Mappa = function () {
        function Mappa(provider, key) {
          _classCallCheck(this, Mappa);

          this.provider = provider;
          this.key = key;
        }

        _createClass(Mappa, [{
          key: 'staticMap',
          value: function staticMap() {
            var options = {};

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            if (_typeof(args[0]) == 'object') {
              options = Object.assign({}, args[0]);
            } else {
              var _options = _staticMap[this.provider].options().userInput;
              args.forEach(function (el, i) {
                var option = _options[i];
                options[option] = el;
              });
            };
            options.key = this.key;
            this.provider == undefined && (this.provider = 'StaticMap');
            return new _staticMap[this.provider](options);
          }
        }, {
          key: 'tileMap',
          value: function tileMap() {
            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = arguments[_key2];
            }

            var options = {};

            if (_typeof(args[0]) == 'object') {
              options = Object.assign({}, args[0]);
            } else {
              ['lat', 'lng', 'zoom'].forEach(function (el, i) {
                options[el] = args[i];
              });
            };
            options.key = this.key;
            options.provider = this.provider;
            return new _tileMap[this.provider](options);
          }
        }]);

        return Mappa;
      }();

      module.exports = Mappa;

      /***/
    },
    /* 7 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.Google = undefined;

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _StaticMap2 = __webpack_require__(0);

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      } // -----------
      // Google Static Maps API v2
      // Reference: https://developers.google.com/maps/documentation/static-maps/
      // -----------

      var Google = function (_StaticMap) {
        _inherits(Google, _StaticMap);

        function Google(options) {
          _classCallCheck(this, Google);

          var _this = _possibleConstructorReturn(this, (Google.__proto__ || Object.getPrototypeOf(Google)).call(this, options));

          _this.imgUrl = 'https://maps.googleapis.com/maps/api/staticmap?';
          _this.createImage();
          return _this;
        }

        _createClass(Google, [{
          key: 'init',
          value: function init() {
            if (this.options.scale == 1 || this.options.scale == undefined) {
              this.options.pixels = 128;
              this.options.scale = 1;
            } else if (this.options.scale == 2) {
              this.options.pixels = 256;
            }
            if (this.options.width > 640) {
              Google.messages().size('width', this.options.width);
              this.options.width = 640;
            }
            if (this.options.height > 640) {
              Google.messages().size('height', this.options.height);
              this.options.height = 640;
            }
          }
        }, {
          key: 'createImage',
          value: function createImage() {
            !this.options.key && delete this.options.key && Google.messages().key();

            this.options.size = this.options.width + 'x' + this.options.height;
            !this.options.center && (this.options.center = this.options.lat + ',' + this.options.lng);
            !this.options.scale && (this.options.scale = 1);

            for (var option in this.options) {
              Google.options().valid.indexOf(option) > -1 && (this.imgUrl += '&' + option + '=' + this.options[option]);
            }

            return this.imgUrl;
          }
        }], [{
          key: 'options',
          value: function options() {
            return {
              valid: ['center', 'zoom', 'size', 'scale', 'format', 'maptype', 'language', 'region', 'markers', 'path', 'visible', 'style', 'signature', 'key', 'signature'],
              userInput: ['lat', 'lng', 'zoom', 'width', 'height', 'scale', 'format', 'maptype', 'language', 'region', 'markers', 'path', 'visible', 'style', 'key', 'signature', 'center']
            };
          }
        }, {
          key: 'messages',
          value: function messages() {
            return {
              size: function size(s, m) {
                console.warn('You requested an image with a ' + s + ' of ' + m + 'px. Google Maps Static API max ' + s + ' value is 640px. For larger images, change the scale to 2 and keep the ' + s + ' between 1-640px. i.e: if you want an image 800x800px, set the width and height to 400x400 and the scale to 2.');
              },
              key: function key() {
                console.warn('For large requests please provide an API key for your Google Maps Static API.');
              }
            };
          }
        }]);

        return Google;
      }(_StaticMap2.StaticMap);

      exports.Google = Google;

      /***/
    },
    /* 8 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.Mapbox = undefined;

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _StaticMap2 = __webpack_require__(0);

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      } // -----------
      // Mapbox Static API v1
      // Reference: https://www.mapbox.com/api-documentation/#static
      // -----------

      var Mapbox = function (_StaticMap) {
        _inherits(Mapbox, _StaticMap);

        function Mapbox(options) {
          _classCallCheck(this, Mapbox);

          var _this = _possibleConstructorReturn(this, (Mapbox.__proto__ || Object.getPrototypeOf(Mapbox)).call(this, options));

          _this.imgUrl = 'https://api.mapbox.com/styles/v1/';
          _this.createImage();
          return _this;
        }

        _createClass(Mapbox, [{
          key: 'init',
          value: function init() {
            this.options.pixels = 256;
            !this.options.scale && (this.options.scale = 1);
            if (this.options.scale == 2) {
              this.options.pixels = 512;
            } else {
              if (this.options.width > 1280) {
                Mapbox.messages().size('width', this.options.width);
                this.options.width = 1280;
              }
              if (this.options.height > 1280) {
                Mapbox.messages().size('height', this.options.width);
                this.options.height = 1280;
              }
            }
          }
        }, {
          key: 'createImage',
          value: function createImage() {
            var _this2 = this;

            if (!this.options.key) {
              Mapbox.messages().key();
              return;
            }
            this.options.username != undefined ? this.imgUrl += this.options.username + '/' : this.imgUrl += 'mapbox/';
            this.options.style != undefined ? this.imgUrl += this.options.style + '/' : this.imgUrl += 'streets-v10/';
            this.imgUrl += 'static/';
            this.options.overlay != undefined && (this.imgUrl += this.options.overlay + '/');
            this.imgUrl += this.options.lng + ',' + this.options.lat + ',';
            this.options.auto == false || this.options.auto == undefined ? ['zoom', 'bearing', 'pitch'].forEach(function (e, i) {
              _this2.options[e] != undefined ? _this2.imgUrl += _this2.options[e] : _this2.imgUrl += 0;
              i < 2 && (_this2.imgUrl += ',');
            }) : this.imgUrl += 'auto';
            this.imgUrl += '/' + this.options.width + 'x' + this.options.height;
            this.options.scale == 2 && (this.imgUrl += '@2x');
            this.imgUrl += '?access_token=' + this.options.key;
            this.options.attribution ? this.imgUrl += '&attribution=' + this.options.attribution : this.imgUrl += '&attribution=false';
            this.options.logo ? this.imgUrl += '&logo=' + this.options.logo : this.imgUrl += '&logo=false';
            this.options.before_layer ? this.imgUrl += '&before_layer=' + this.options.before_layer : this.imgUrl += '&before_layer=false';
            return this.imgUrl;
          }
        }], [{
          key: 'options',
          value: function options() {
            return {
              valid: ['lat', 'lng', 'zoom', 'width', 'height', 'scale', 'bearing', 'pitch', 'style', 'username', 'overlay', 'attribution', 'logo', 'before_layer', 'center', 'size'],
              userInput: ['lat', 'lng', 'zoom', 'width', 'height', 'scale', 'bearing', 'pitch', 'style', 'username', 'overlay', 'attribution', 'logo', 'before_layer', 'center', 'size']
            };
          }
        }, {
          key: 'messages',
          value: function messages() {
            return {
              size: function size(s, m) {
                return console.warn('You requested an image with a ' + s + ' of ' + m + 'px. Mapbox Static API max ' + s + ' value is 1280px. If you want a large image change the scale to 2.');
              },
              key: function key() {
                console.error('Mapbox Static API needs a key to work. To get a key visit: https://www.mapbox.com/api-documentation/#static');
              }
            };
          }
        }]);

        return Mapbox;
      }(_StaticMap2.StaticMap);

      exports.Mapbox = Mapbox;

      /***/
    },
    /* 9 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.Mapquest = undefined;

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _StaticMap2 = __webpack_require__(0);

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      } // -----------
      // Mapquest v5
      // Reference: https://developer.mapquest.com/documentation/static-map-api/v5/
      // -----------

      var Mapquest = function (_StaticMap) {
        _inherits(Mapquest, _StaticMap);

        function Mapquest(options) {
          _classCallCheck(this, Mapquest);

          var _this = _possibleConstructorReturn(this, (Mapquest.__proto__ || Object.getPrototypeOf(Mapquest)).call(this, options));

          _this.imgUrl = 'https://www.mapquestapi.com/staticmap/v5/map?';
          _this.createImage();
          return _this;
        }

        _createClass(Mapquest, [{
          key: 'init',
          value: function init() {
            if (this.options.scale == 1 || this.options.scale == undefined) {
              this.options.pixels = 128;
              this.options.scale = 1;
            } else if (this.options.scale == 2) {
              this.options.pixels = 256;
            }
            if (this.options.width > 1920) {
              Mapquest.messages().size('width', this.options.width);
              this.options.width = 1920;
            }
            if (this.options.height > 1920) {
              Mapquest.messages().size('height', this.options.height);
              this.options.height = 1920;
            }
          }
        }, {
          key: 'createImage',
          value: function createImage() {
            if (!this.options.key) {
              Mapquest.messages().key();
              return;
            }

            this.options.size = this.options.width + ',' + this.options.height;
            this.options.scale == 2 && (this.options.size += '@2x');
            !this.options.center && (this.options.center = this.options.lat + ',' + this.options.lng);

            for (var option in this.options) {
              Mapquest.options().valid.indexOf(option) > -1 && (this.imgUrl += '&' + option + '=' + this.options[option]);
            }

            return this.imgUrl;
          }
        }], [{
          key: 'options',
          value: function options() {
            return {
              valid: ['key', 'size', 'zoom', 'center', 'boundingBox', 'margin', 'format', 'type', 'scalebar', 'locations', 'declutter', 'defaultMarker', 'banner', 'traffic', 'key'],
              userInput: ['lat', 'lng', 'zoom', 'width', 'height', 'scale', 'boundingBox', 'margin', 'format', 'type', 'scalebar', 'locations', 'declutter', 'defaultMarker', 'banner', 'traffic', 'key']
            };
          }
        }, {
          key: 'messages',
          value: function messages() {
            return {
              size: function size(s, m) {
                console.warn('You requested an image with a ' + s + ' of ' + m + 'px. Mapquest Static API max ' + s + ' value is 1920px. For larger images, change the scale to 2 and keep the ' + s + ' between 170x30px. i.e: if you want an 3840x3840px image, set the width and height to 1920x1920 and the scale to 2.');
              },
              key: function key() {
                console.warn('Please provide and API key to work with Mapquest Static API. Get one here: https://developer.mapquest.com/documentation/');
              }
            };
          }
        }]);

        return Mapquest;
      }(_StaticMap2.StaticMap);

      exports.Mapquest = Mapquest;

      /***/
    },
    /* 10 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.Google = undefined;

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _TileMap2 = __webpack_require__(2);

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      } // -----------
      // Google Maps JavaScript v3.28
      // Reference: https://developers.google.com/maps/documentation/javascript/
      // -----------

      var Google = function (_TileMap) {
        _inherits(Google, _TileMap);

        function Google(options) {
          _classCallCheck(this, Google);

          var _this = _possibleConstructorReturn(this, (Google.__proto__ || Object.getPrototypeOf(Google)).call(this, options));

          _this.script = 'https://maps.googleapis.com/maps/api/js';
          _this.options.key && (_this.script += '?key=' + _this.options.key);
          _this.options.language && (_this.script += '&language=' + _this.options.language);
          _this.options.region && (_this.script += '&region=' + _this.options.region);
          _this.onChangeMetods = {};
          _this.init();
          return _this;
        }

        _createClass(Google, [{
          key: 'createMap',
          value: function createMap() {
            var _this2 = this;

            !this.options.key && Google.messages().key();

            this.map = new google.maps.Map(document.getElementById('mappa'), {
              center: { lat: this.options.lat, lng: this.options.lng },
              zoom: this.options.zoom || 6,
              mapTypeId: this.options.maptype || 'terrain',
              styles: this.options.styles || '',
              minZoom: 1 || this.options.minZoom
            });

            var overlay = new google.maps.OverlayView();
            overlay.onAdd = function () {
              overlay.getPanes().overlayLayer.appendChild(_this2.canvas);
            };
            overlay.draw = function () {};
            overlay.setMap(this.map);

            google.maps.event.addListener(this.map, 'bounds_changed', function () {
              var center = overlay.getProjection().fromLatLngToDivPixel(_this2.map.getCenter());
              var pixels = void 0;
              window.devicePixelRatio >= 2 ? pixels = 4 : pixels = 2;
              var offsetX = -Math.round(_this2.canvas.width / pixels - center.x);
              var offsetY = -Math.round(_this2.canvas.height / pixels - center.y);
              var _canvas = _this2.canvas.getContext('webgl') || _this2.canvas.getContext('2d');
              _canvas.canvas.style.transform = 'translate(' + offsetX + 'px,' + offsetY + 'px)';
            });

            google.maps.event.addListenerOnce(this.map, 'tilesloaded', function () {
              _this2.ready = true;
            });
          }
        }, {
          key: 'fromLatLngtoPixel',
          value: function fromLatLngtoPixel(position) {
            if (this.ready) {
              position = new google.maps.LatLng(position);
              var topRight = this.map.getProjection().fromLatLngToPoint(this.map.getBounds().getNorthEast());
              var bottomLeft = this.map.getProjection().fromLatLngToPoint(this.map.getBounds().getSouthWest());
              var scale = Math.pow(2, this.map.getZoom());
              var point = this.map.getProjection().fromLatLngToPoint(position);
              return new google.maps.Point((point.x - bottomLeft.x) * scale, (point.y - topRight.y) * scale);
            } else {
              return { x: -100, y: -100 };
            }
          }
        }, {
          key: 'fromPointToLatLng',
          value: function fromPointToLatLng() {
            if (this.ready) {
              var topRight = this.map.getProjection().fromLatLngToPoint(this.map.getBounds().getNorthEast());
              var bottomLeft = this.map.getProjection().fromLatLngToPoint(this.map.getBounds().getSouthWest());
              var scale = Math.pow(2, this.map.getZoom());
              var point = new google.maps.Point((arguments.length <= 0 ? undefined : arguments[0]) / scale + bottomLeft.x, (arguments.length <= 1 ? undefined : arguments[1]) / scale + topRight.y);
              var latlng = this.map.getProjection().fromPointToLatLng(point);
              return { lat: latlng.lat(), lng: latlng.lng() };
            } else {
              return { lat: -100, lng: -100 };
            }
          }
        }, {
          key: 'getZoom',
          value: function getZoom() {
            if (this.ready) {
              return this.map.getZoom();
            } else {
              return 0;
            }
          }
        }, {
          key: 'onChange',
          value: function onChange(callback) {
            var _this3 = this;

            if (this.ready) {
              callback();
              this.onChangeMetods[callback] = google.maps.event.addListener(this.map, 'bounds_changed', callback);
            } else {
              setTimeout(function () {
                _this3.onChange(callback);
              }, 200);
            }
          }
        }, {
          key: 'removeOnChange',
          value: function removeOnChange(callback) {
            google.maps.event.removeListener(this.onChangeMetods[callback]);
          }
        }], [{
          key: 'messages',
          value: function messages() {
            return {
              key: function key() {
                console.warn('Please provide a Goolge Maps API Key. Get one here: https://developers.google.com/maps/documentation/javascript/ ');
              }
            };
          }
        }]);

        return Google;
      }(_TileMap2.TileMap);

      exports.Google = Google;

      /***/
    },
    /* 11 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.Mapbox = undefined;

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _Leaflet2 = __webpack_require__(1);

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      } // -----------
      // Mapbox v3.1.1
      // Reference: https://www.mapbox.com/mapbox.js/api/v3.1.1/
      // -----------

      var Mapbox = function (_Leaflet) {
        _inherits(Mapbox, _Leaflet);

        function Mapbox(options) {
          _classCallCheck(this, Mapbox);

          var _this = _possibleConstructorReturn(this, (Mapbox.__proto__ || Object.getPrototypeOf(Mapbox)).call(this, options));

          _this.script = 'https://api.mapbox.com/mapbox.js/v3.1.1/mapbox.js';
          _this.style = 'https://api.mapbox.com/mapbox.js/v3.1.1/mapbox.css';
          _this.init();
          return _this;
        }

        _createClass(Mapbox, [{
          key: 'createMap',
          value: function createMap() {
            var _this2 = this;

            if (this.options.key) {
              L.mapbox.accessToken = this.options.key;
            } else {
              Mapbox.messages().key();
              return;
            }

            // Create a Mapbox Map
            this.map = L.mapbox.map('mappa').setView([this.options.lat, this.options.lng], this.options.zoom);

            this.options.studio ? this.tiles = L.mapbox.styleLayer(this.options.style || 'mapbox://styles/mapbox/emerald-v8').addTo(this.map) : this.tiles = L.mapbox.tileLayer(this.options.style || 'mapbox.streets').addTo(this.map);

            this.tiles.on('ready', function () {
              _this2.ready = true;
            });

            this.canvasOverlay();
          }
        }], [{
          key: 'messages',
          value: function messages() {
            return {
              key: function key() {
                console.warn('Please provide a Mapbox API key. Get one here: https://www.mapbox.com/mapbox.js/api/v3.1.1');
              }
            };
          }
        }]);

        return Mapbox;
      }(_Leaflet2.Leaflet);

      exports.Mapbox = Mapbox;

      /***/
    },
    /* 12 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.Mapboxgl = undefined;

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _TileMap2 = __webpack_require__(2);

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      } // -----------
      // Mapbox-gl v0.37.0
      // Reference: https://www.mapbox.com/mapbox-gl-js/api/
      // -----------

      var Mapboxgl = function (_TileMap) {
        _inherits(Mapboxgl, _TileMap);

        function Mapboxgl(options) {
          _classCallCheck(this, Mapboxgl);

          var _this = _possibleConstructorReturn(this, (Mapboxgl.__proto__ || Object.getPrototypeOf(Mapboxgl)).call(this, options));

          _this.script = 'https://api.mapbox.com/mapbox-gl-js/v0.37.0/mapbox-gl.js';
          _this.style = 'https://api.mapbox.com/mapbox-gl-js/v0.37.0/mapbox-gl.css';
          !_this.options.key ? Mapboxgl.messages().key() : _this.init();
          return _this;
        }

        _createClass(Mapboxgl, [{
          key: 'createMap',
          value: function createMap() {
            var _this2 = this;

            mapboxgl.accessToken = this.options.key;
            this.map = new mapboxgl.Map({
              container: 'mappa',
              style: this.options.style || 'mapbox://styles/mapbox/satellite-streets-v10',
              center: [this.options.lng, this.options.lat],
              zoom: this.options.zoom,
              minZoom: this.options.minZoom || 0,
              maxZoom: this.options.maxZoom || 22,
              bearing: this.options.bearing || 0,
              pitch: this.options.pitch || 0,
              renderWorldCopies: true && this.options.renderWorldCopies,
              maxBounds: this.options.maxBounds || undefined
            });

            this.map.getCanvasContainer().appendChild(this.canvas);
            this.canvas.style.position = 'relative';
            this.options.opacity && (document.getElementsByClassName('mapboxgl-canvas')[0].style.opacity = this.options.opacity);
            this.map.on('load', function () {
              _this2.ready = true;
            });
          }
        }, {
          key: 'fromLatLngtoPixel',
          value: function fromLatLngtoPixel(latLng) {
            if (this.ready) {
              return this.map.project(latLng);
            } else {
              return { x: -100, y: -100 };
            }
          }
        }, {
          key: 'fromPointToLatLng',
          value: function fromPointToLatLng() {
            if (this.ready) {
              for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }

              return this.map.unproject(args);
            } else {
              return { lat: -100, lng: -100 };
            }
          }
        }, {
          key: 'getZoom',
          value: function getZoom() {
            if (this.ready) {
              return this.map.getZoom();
            } else {
              return 0;
            }
          }
        }, {
          key: 'onChange',
          value: function onChange(callback) {
            var _this3 = this;

            if (this.ready) {
              callback();
              this.map.on('render', callback);
            } else {
              setTimeout(function () {
                _this3.onChange(callback);
              }, 200);
            }
          }
        }, {
          key: 'removeOnChange',
          value: function removeOnChange(callback) {
            this.map.off('render', callback);
          }
        }], [{
          key: 'messages',
          value: function messages() {
            return {
              key: function key() {
                console.warn('Please provide a Mapbox-gl API key. Get one here: https://www.mapbox.com/mapbox-gl-js/api/');
              }
            };
          }
        }]);

        return Mapboxgl;
      }(_TileMap2.TileMap);

      exports.Mapboxgl = Mapboxgl;

      /***/
    },
    /* 13 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.Mapzen = undefined;

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _Leaflet2 = __webpack_require__(1);

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      } // -----------
      // Mapzen v0.12.5
      // Reference: https://mapzen.com/documentation/mapzen-js/
      // -----------

      var Mapzen = function (_Leaflet) {
        _inherits(Mapzen, _Leaflet);

        function Mapzen(options) {
          _classCallCheck(this, Mapzen);

          var _this = _possibleConstructorReturn(this, (Mapzen.__proto__ || Object.getPrototypeOf(Mapzen)).call(this, options));

          _this.script = 'https://mapzen.com/js/mapzen.min.js';
          _this.style = 'https://mapzen.com/js/mapzen.css';
          _this.init();
          return _this;
        }

        _createClass(Mapzen, [{
          key: 'createMap',
          value: function createMap() {
            var _this2 = this;

            if (this.options.key) {
              L.Mapzen.apiKey = this.options.key;
            } else {
              Mapzen.messages().key();
              return;
            }

            // Create a Mapzen Map
            this.map = L.Mapzen.map('mappa', {
              center: [this.options.lat, this.options.lng],
              zoom: this.options.zoom,
              tangramOptions: {
                scene: this.options.BasemapStyles ? L.Mapzen.BasemapStyles[this.options.scene] : this.options.scene
              }
            });
            this.map.on('tangramloaded', function () {
              _this2.ready = true;
            });

            this.canvasOverlay();
          }
        }], [{
          key: 'messages',
          value: function messages() {
            return {
              key: function key() {
                console.warn('Please provide a API key for your Mapzen map.');
              }
            };
          }
        }]);

        return Mapzen;
      }(_Leaflet2.Leaflet);

      exports.Mapzen = Mapzen;

      /***/
    },
    /* 14 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.Tangram = undefined;

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _Leaflet2 = __webpack_require__(1);

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      } // -----------
      // Tangram v0.12.5
      // Reference: https://mapzen.com/documentation/tangram/
      // -----------

      var Tangram = function (_Leaflet) {
        _inherits(Tangram, _Leaflet);

        function Tangram(options) {
          _classCallCheck(this, Tangram);

          var _this = _possibleConstructorReturn(this, (Tangram.__proto__ || Object.getPrototypeOf(Tangram)).call(this, options));

          _this.options.provider = 'Leaflet';
          _this.init();
          _this.options.provider = 'Tangram';
          _this.script = 'https://mapzen.com/tangram/tangram.min.js';
          _this.init();
          return _this;
        }

        _createClass(Tangram, [{
          key: 'createMap',
          value: function createMap() {
            var _this2 = this;

            // Create a Tangram Map
            this.map = L.map('mappa');
            this.tangramScene = window.Tangram.leafletLayer({
              scene: this.options.scene,
              attribution: '<a href="https://mapzen.com/tangram" target="_blank">Tangram</a> | &copy; OSM contributors | <a href="https://mapzen.com/" target="_blank">Mapzen</a>'
            });
            this.tangramScene.addTo(this.map);
            this.map.setView([this.options.lat, this.options.lng], this.options.zoom);
            this.tangramScene.scene.subscribe({ load: function load() {
                _this2.ready = true;
              } });
            this.canvasOverlay();
          }
        }], [{
          key: 'messages',
          value: function messages() {
            return {
              key: function key() {
                console.warn('Please provide a API key for your Mapzen map.');
              }
            };
          }
        }]);

        return Tangram;
      }(_Leaflet2.Leaflet);

      exports.Tangram = Tangram;

      /***/
    }])
  );
});
//# sourceMappingURL=mappa.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(152)(module)))

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Mapbox key

exports.default = 'pk.eyJ1IjoiY3ZhbGVuenVlbGEiLCJhIjoiY2l2ZzkweTQ3MDFuODJ5cDM2NmRnaG4wdyJ9.P_0JJXX6sD1oX2D0RQeWFA';

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var require;var require;/*! p5.js v0.5.11 June 01, 2017 */
(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.p5 = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){

},{}],2:[function(_dereq_,module,exports){
(function (process,global){
/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   4.0.5
 */

(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  return typeof x === 'function' || typeof x === 'object' && x !== null;
}

function isFunction(x) {
  return typeof x === 'function';
}

var _isArray = undefined;
if (!Array.isArray) {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
} else {
  _isArray = Array.isArray;
}

var isArray = _isArray;

var len = 0;
var vertxNext = undefined;
var customSchedulerFn = undefined;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && ({}).toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var r = _dereq_;
    var vertx = r('vertx');
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = undefined;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && typeof _dereq_ === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var _arguments = arguments;

  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;

  if (_state) {
    (function () {
      var callback = _arguments[_state - 1];
      asap(function () {
        return invokeCallback(_state, child, callback, parent._result);
      });
    })();
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  _resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(16);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

var GET_THEN_ERROR = new ErrorObject();

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function getThen(promise) {
  try {
    return promise.then;
  } catch (error) {
    GET_THEN_ERROR.error = error;
    return GET_THEN_ERROR;
  }
}

function tryThen(then, value, fulfillmentHandler, rejectionHandler) {
  try {
    then.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        _resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      _reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      _reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    _reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return _resolve(promise, value);
    }, function (reason) {
      return _reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$) {
  if (maybeThenable.constructor === promise.constructor && then$$ === then && maybeThenable.constructor.resolve === resolve) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$ === GET_THEN_ERROR) {
      _reject(promise, GET_THEN_ERROR.error);
    } else if (then$$ === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$)) {
      handleForeignThenable(promise, maybeThenable, then$$);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function _resolve(promise, value) {
  if (promise === value) {
    _reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    handleMaybeThenable(promise, value, getThen(value));
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function _reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;

  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = undefined,
      callback = undefined,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function ErrorObject() {
  this.error = null;
}

var TRY_CATCH_ERROR = new ErrorObject();

function tryCatch(callback, detail) {
  try {
    return callback(detail);
  } catch (e) {
    TRY_CATCH_ERROR.error = e;
    return TRY_CATCH_ERROR;
  }
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = undefined,
      error = undefined,
      succeeded = undefined,
      failed = undefined;

  if (hasCallback) {
    value = tryCatch(callback, detail);

    if (value === TRY_CATCH_ERROR) {
      failed = true;
      error = value.error;
      value = null;
    } else {
      succeeded = true;
    }

    if (promise === value) {
      _reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
    succeeded = true;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
      _resolve(promise, value);
    } else if (failed) {
      _reject(promise, error);
    } else if (settled === FULFILLED) {
      fulfill(promise, value);
    } else if (settled === REJECTED) {
      _reject(promise, value);
    }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      _resolve(promise, value);
    }, function rejectPromise(reason) {
      _reject(promise, reason);
    });
  } catch (e) {
    _reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function Enumerator(Constructor, input) {
  this._instanceConstructor = Constructor;
  this.promise = new Constructor(noop);

  if (!this.promise[PROMISE_ID]) {
    makePromise(this.promise);
  }

  if (isArray(input)) {
    this._input = input;
    this.length = input.length;
    this._remaining = input.length;

    this._result = new Array(this.length);

    if (this.length === 0) {
      fulfill(this.promise, this._result);
    } else {
      this.length = this.length || 0;
      this._enumerate();
      if (this._remaining === 0) {
        fulfill(this.promise, this._result);
      }
    }
  } else {
    _reject(this.promise, validationError());
  }
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
};

Enumerator.prototype._enumerate = function () {
  var length = this.length;
  var _input = this._input;

  for (var i = 0; this._state === PENDING && i < length; i++) {
    this._eachEntry(_input[i], i);
  }
};

Enumerator.prototype._eachEntry = function (entry, i) {
  var c = this._instanceConstructor;
  var resolve$$ = c.resolve;

  if (resolve$$ === resolve) {
    var _then = getThen(entry);

    if (_then === then && entry._state !== PENDING) {
      this._settledAt(entry._state, i, entry._result);
    } else if (typeof _then !== 'function') {
      this._remaining--;
      this._result[i] = entry;
    } else if (c === Promise) {
      var promise = new c(noop);
      handleMaybeThenable(promise, entry, _then);
      this._willSettleAt(promise, i);
    } else {
      this._willSettleAt(new c(function (resolve$$) {
        return resolve$$(entry);
      }), i);
    }
  } else {
    this._willSettleAt(resolve$$(entry), i);
  }
};

Enumerator.prototype._settledAt = function (state, i, value) {
  var promise = this.promise;

  if (promise._state === PENDING) {
    this._remaining--;

    if (state === REJECTED) {
      _reject(promise, value);
    } else {
      this._result[i] = value;
    }
  }

  if (this._remaining === 0) {
    fulfill(promise, this._result);
  }
};

Enumerator.prototype._willSettleAt = function (promise, i) {
  var enumerator = this;

  subscribe(promise, undefined, function (value) {
    return enumerator._settledAt(FULFILLED, i, value);
  }, function (reason) {
    return enumerator._settledAt(REJECTED, i, reason);
  });
};

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  _reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {function} resolver
  Useful for tooling.
  @constructor
*/
function Promise(resolver) {
  this[PROMISE_ID] = nextId();
  this._result = this._state = undefined;
  this._subscribers = [];

  if (noop !== resolver) {
    typeof resolver !== 'function' && needsResolver();
    this instanceof Promise ? initializePromise(this, resolver) : needsNew();
  }
}

Promise.all = all;
Promise.race = race;
Promise.resolve = resolve;
Promise.reject = reject;
Promise._setScheduler = setScheduler;
Promise._setAsap = setAsap;
Promise._asap = asap;

Promise.prototype = {
  constructor: Promise,

  /**
    The primary way of interacting with a promise is through its `then` method,
    which registers callbacks to receive either a promise's eventual value or the
    reason why the promise cannot be fulfilled.
  
    ```js
    findUser().then(function(user){
      // user is available
    }, function(reason){
      // user is unavailable, and you are given the reason why
    });
    ```
  
    Chaining
    --------
  
    The return value of `then` is itself a promise.  This second, 'downstream'
    promise is resolved with the return value of the first promise's fulfillment
    or rejection handler, or rejected if the handler throws an exception.
  
    ```js
    findUser().then(function (user) {
      return user.name;
    }, function (reason) {
      return 'default name';
    }).then(function (userName) {
      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
      // will be `'default name'`
    });
  
    findUser().then(function (user) {
      throw new Error('Found user, but still unhappy');
    }, function (reason) {
      throw new Error('`findUser` rejected and we're unhappy');
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
    });
    ```
    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
  
    ```js
    findUser().then(function (user) {
      throw new PedagogicalException('Upstream error');
    }).then(function (value) {
      // never reached
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // The `PedgagocialException` is propagated all the way down to here
    });
    ```
  
    Assimilation
    ------------
  
    Sometimes the value you want to propagate to a downstream promise can only be
    retrieved asynchronously. This can be achieved by returning a promise in the
    fulfillment or rejection handler. The downstream promise will then be pending
    until the returned promise is settled. This is called *assimilation*.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // The user's comments are now available
    });
    ```
  
    If the assimliated promise rejects, then the downstream promise will also reject.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // If `findCommentsByAuthor` fulfills, we'll have the value here
    }, function (reason) {
      // If `findCommentsByAuthor` rejects, we'll have the reason here
    });
    ```
  
    Simple Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let result;
  
    try {
      result = findResult();
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
    findResult(function(result, err){
      if (err) {
        // failure
      } else {
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findResult().then(function(result){
      // success
    }, function(reason){
      // failure
    });
    ```
  
    Advanced Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let author, books;
  
    try {
      author = findAuthor();
      books  = findBooksByAuthor(author);
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
  
    function foundBooks(books) {
  
    }
  
    function failure(reason) {
  
    }
  
    findAuthor(function(author, err){
      if (err) {
        failure(err);
        // failure
      } else {
        try {
          findBoooksByAuthor(author, function(books, err) {
            if (err) {
              failure(err);
            } else {
              try {
                foundBooks(books);
              } catch(reason) {
                failure(reason);
              }
            }
          });
        } catch(error) {
          failure(err);
        }
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findAuthor().
      then(findBooksByAuthor).
      then(function(books){
        // found books
    }).catch(function(reason){
      // something went wrong
    });
    ```
  
    @method then
    @param {Function} onFulfilled
    @param {Function} onRejected
    Useful for tooling.
    @return {Promise}
  */
  then: then,

  /**
    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
    as the catch block of a try/catch statement.
  
    ```js
    function findAuthor(){
      throw new Error('couldn't find that author');
    }
  
    // synchronous
    try {
      findAuthor();
    } catch(reason) {
      // something went wrong
    }
  
    // async with promises
    findAuthor().catch(function(reason){
      // something went wrong
    });
    ```
  
    @method catch
    @param {Function} onRejection
    Useful for tooling.
    @return {Promise}
  */
  'catch': function _catch(onRejection) {
    return this.then(null, onRejection);
  }
};

function polyfill() {
    var local = undefined;

    if (typeof global !== 'undefined') {
        local = global;
    } else if (typeof self !== 'undefined') {
        local = self;
    } else {
        try {
            local = Function('return this')();
        } catch (e) {
            throw new Error('polyfill failed because global object is unavailable in this environment');
        }
    }

    var P = local.Promise;

    if (P) {
        var promiseToString = null;
        try {
            promiseToString = Object.prototype.toString.call(P.resolve());
        } catch (e) {
            // silently ignored
        }

        if (promiseToString === '[object Promise]' && !P.cast) {
            return;
        }
    }

    local.Promise = Promise;
}

// Strange compat..
Promise.polyfill = polyfill;
Promise.Promise = Promise;

return Promise;

})));

}).call(this,_dereq_('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"_process":31}],3:[function(_dereq_,module,exports){
(function (global, factory) {
  if (typeof define === 'function' && define.amd) {
    define(['exports', 'module'], factory);
  } else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
    factory(exports, module);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, mod);
    global.fetchJsonp = mod.exports;
  }
})(this, function (exports, module) {
  'use strict';

  var defaultOptions = {
    timeout: 5000,
    jsonpCallback: 'callback',
    jsonpCallbackFunction: null
  };

  function generateCallbackFunction() {
    return 'jsonp_' + Date.now() + '_' + Math.ceil(Math.random() * 100000);
  }

  // Known issue: Will throw 'Uncaught ReferenceError: callback_*** is not defined'
  // error if request timeout
  function clearFunction(functionName) {
    // IE8 throws an exception when you try to delete a property on window
    // http://stackoverflow.com/a/1824228/751089
    try {
      delete window[functionName];
    } catch (e) {
      window[functionName] = undefined;
    }
  }

  function removeScript(scriptId) {
    var script = document.getElementById(scriptId);
    document.getElementsByTagName('head')[0].removeChild(script);
  }

  function fetchJsonp(_url) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    // to avoid param reassign
    var url = _url;
    var timeout = options.timeout || defaultOptions.timeout;
    var jsonpCallback = options.jsonpCallback || defaultOptions.jsonpCallback;

    var timeoutId = undefined;

    return new Promise(function (resolve, reject) {
      var callbackFunction = options.jsonpCallbackFunction || generateCallbackFunction();
      var scriptId = jsonpCallback + '_' + callbackFunction;

      window[callbackFunction] = function (response) {
        resolve({
          ok: true,
          // keep consistent with fetch API
          json: function json() {
            return Promise.resolve(response);
          }
        });

        if (timeoutId) clearTimeout(timeoutId);

        removeScript(scriptId);

        clearFunction(callbackFunction);
      };

      // Check if the user set their own params, and if not add a ? to start a list of params
      url += url.indexOf('?') === -1 ? '?' : '&';

      var jsonpScript = document.createElement('script');
      jsonpScript.setAttribute('src', '' + url + jsonpCallback + '=' + callbackFunction);
      jsonpScript.id = scriptId;
      document.getElementsByTagName('head')[0].appendChild(jsonpScript);

      timeoutId = setTimeout(function () {
        reject(new Error('JSONP request to ' + _url + ' timed out'));

        clearFunction(callbackFunction);
        removeScript(scriptId);
      }, timeout);
    });
  }

  // export as global function
  /*
  let local;
  if (typeof global !== 'undefined') {
    local = global;
  } else if (typeof self !== 'undefined') {
    local = self;
  } else {
    try {
      local = Function('return this')();
    } catch (e) {
      throw new Error('polyfill failed because global object is unavailable in this environment');
    }
  }
  local.fetchJsonp = fetchJsonp;
  */

  module.exports = fetchJsonp;
});
},{}],4:[function(_dereq_,module,exports){
// Run-time checking of preconditions.

'use strict';

// Precondition function that checks if the given predicate is true.
// If not, it will throw an error.
exports.argument = function(predicate, message) {
    if (!predicate) {
        throw new Error(message);
    }
};

// Precondition function that checks if the given assertion is true.
// If not, it will throw an error.
exports.assert = exports.argument;

},{}],5:[function(_dereq_,module,exports){
// Drawing utility functions.

'use strict';

// Draw a line on the given context from point `x1,y1` to point `x2,y2`.
function line(ctx, x1, y1, x2, y2) {
    ctx.beginPath();
    ctx.moveTo(x1, y1);
    ctx.lineTo(x2, y2);
    ctx.stroke();
}

exports.line = line;

},{}],6:[function(_dereq_,module,exports){
// Glyph encoding

'use strict';

var cffStandardStrings = [
    '.notdef', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quoteright',
    'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two',
    'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater',
    'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S',
    'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore',
    'quoteleft', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't',
    'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', 'exclamdown', 'cent', 'sterling',
    'fraction', 'yen', 'florin', 'section', 'currency', 'quotesingle', 'quotedblleft', 'guillemotleft',
    'guilsinglleft', 'guilsinglright', 'fi', 'fl', 'endash', 'dagger', 'daggerdbl', 'periodcentered', 'paragraph',
    'bullet', 'quotesinglbase', 'quotedblbase', 'quotedblright', 'guillemotright', 'ellipsis', 'perthousand',
    'questiondown', 'grave', 'acute', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'dieresis', 'ring',
    'cedilla', 'hungarumlaut', 'ogonek', 'caron', 'emdash', 'AE', 'ordfeminine', 'Lslash', 'Oslash', 'OE',
    'ordmasculine', 'ae', 'dotlessi', 'lslash', 'oslash', 'oe', 'germandbls', 'onesuperior', 'logicalnot', 'mu',
    'trademark', 'Eth', 'onehalf', 'plusminus', 'Thorn', 'onequarter', 'divide', 'brokenbar', 'degree', 'thorn',
    'threequarters', 'twosuperior', 'registered', 'minus', 'eth', 'multiply', 'threesuperior', 'copyright',
    'Aacute', 'Acircumflex', 'Adieresis', 'Agrave', 'Aring', 'Atilde', 'Ccedilla', 'Eacute', 'Ecircumflex',
    'Edieresis', 'Egrave', 'Iacute', 'Icircumflex', 'Idieresis', 'Igrave', 'Ntilde', 'Oacute', 'Ocircumflex',
    'Odieresis', 'Ograve', 'Otilde', 'Scaron', 'Uacute', 'Ucircumflex', 'Udieresis', 'Ugrave', 'Yacute',
    'Ydieresis', 'Zcaron', 'aacute', 'acircumflex', 'adieresis', 'agrave', 'aring', 'atilde', 'ccedilla', 'eacute',
    'ecircumflex', 'edieresis', 'egrave', 'iacute', 'icircumflex', 'idieresis', 'igrave', 'ntilde', 'oacute',
    'ocircumflex', 'odieresis', 'ograve', 'otilde', 'scaron', 'uacute', 'ucircumflex', 'udieresis', 'ugrave',
    'yacute', 'ydieresis', 'zcaron', 'exclamsmall', 'Hungarumlautsmall', 'dollaroldstyle', 'dollarsuperior',
    'ampersandsmall', 'Acutesmall', 'parenleftsuperior', 'parenrightsuperior', '266 ff', 'onedotenleader',
    'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle', 'fouroldstyle', 'fiveoldstyle', 'sixoldstyle',
    'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'commasuperior', 'threequartersemdash', 'periodsuperior',
    'questionsmall', 'asuperior', 'bsuperior', 'centsuperior', 'dsuperior', 'esuperior', 'isuperior', 'lsuperior',
    'msuperior', 'nsuperior', 'osuperior', 'rsuperior', 'ssuperior', 'tsuperior', 'ff', 'ffi', 'ffl',
    'parenleftinferior', 'parenrightinferior', 'Circumflexsmall', 'hyphensuperior', 'Gravesmall', 'Asmall',
    'Bsmall', 'Csmall', 'Dsmall', 'Esmall', 'Fsmall', 'Gsmall', 'Hsmall', 'Ismall', 'Jsmall', 'Ksmall', 'Lsmall',
    'Msmall', 'Nsmall', 'Osmall', 'Psmall', 'Qsmall', 'Rsmall', 'Ssmall', 'Tsmall', 'Usmall', 'Vsmall', 'Wsmall',
    'Xsmall', 'Ysmall', 'Zsmall', 'colonmonetary', 'onefitted', 'rupiah', 'Tildesmall', 'exclamdownsmall',
    'centoldstyle', 'Lslashsmall', 'Scaronsmall', 'Zcaronsmall', 'Dieresissmall', 'Brevesmall', 'Caronsmall',
    'Dotaccentsmall', 'Macronsmall', 'figuredash', 'hypheninferior', 'Ogoneksmall', 'Ringsmall', 'Cedillasmall',
    'questiondownsmall', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds',
    'zerosuperior', 'foursuperior', 'fivesuperior', 'sixsuperior', 'sevensuperior', 'eightsuperior', 'ninesuperior',
    'zeroinferior', 'oneinferior', 'twoinferior', 'threeinferior', 'fourinferior', 'fiveinferior', 'sixinferior',
    'seveninferior', 'eightinferior', 'nineinferior', 'centinferior', 'dollarinferior', 'periodinferior',
    'commainferior', 'Agravesmall', 'Aacutesmall', 'Acircumflexsmall', 'Atildesmall', 'Adieresissmall',
    'Aringsmall', 'AEsmall', 'Ccedillasmall', 'Egravesmall', 'Eacutesmall', 'Ecircumflexsmall', 'Edieresissmall',
    'Igravesmall', 'Iacutesmall', 'Icircumflexsmall', 'Idieresissmall', 'Ethsmall', 'Ntildesmall', 'Ogravesmall',
    'Oacutesmall', 'Ocircumflexsmall', 'Otildesmall', 'Odieresissmall', 'OEsmall', 'Oslashsmall', 'Ugravesmall',
    'Uacutesmall', 'Ucircumflexsmall', 'Udieresissmall', 'Yacutesmall', 'Thornsmall', 'Ydieresissmall', '001.000',
    '001.001', '001.002', '001.003', 'Black', 'Bold', 'Book', 'Light', 'Medium', 'Regular', 'Roman', 'Semibold'];

var cffStandardEncoding = [
    '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
    '', '', '', '', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quoteright',
    'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two',
    'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater',
    'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S',
    'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore',
    'quoteleft', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't',
    'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', '', '', '', '', '', '', '', '',
    '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
    'exclamdown', 'cent', 'sterling', 'fraction', 'yen', 'florin', 'section', 'currency', 'quotesingle',
    'quotedblleft', 'guillemotleft', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', '', 'endash', 'dagger',
    'daggerdbl', 'periodcentered', '', 'paragraph', 'bullet', 'quotesinglbase', 'quotedblbase', 'quotedblright',
    'guillemotright', 'ellipsis', 'perthousand', '', 'questiondown', '', 'grave', 'acute', 'circumflex', 'tilde',
    'macron', 'breve', 'dotaccent', 'dieresis', '', 'ring', 'cedilla', '', 'hungarumlaut', 'ogonek', 'caron',
    'emdash', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'AE', '', 'ordfeminine', '', '', '',
    '', 'Lslash', 'Oslash', 'OE', 'ordmasculine', '', '', '', '', '', 'ae', '', '', '', 'dotlessi', '', '',
    'lslash', 'oslash', 'oe', 'germandbls'];

var cffExpertEncoding = [
    '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
    '', '', '', '', 'space', 'exclamsmall', 'Hungarumlautsmall', '', 'dollaroldstyle', 'dollarsuperior',
    'ampersandsmall', 'Acutesmall', 'parenleftsuperior', 'parenrightsuperior', 'twodotenleader', 'onedotenleader',
    'comma', 'hyphen', 'period', 'fraction', 'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle',
    'fouroldstyle', 'fiveoldstyle', 'sixoldstyle', 'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'colon',
    'semicolon', 'commasuperior', 'threequartersemdash', 'periodsuperior', 'questionsmall', '', 'asuperior',
    'bsuperior', 'centsuperior', 'dsuperior', 'esuperior', '', '', 'isuperior', '', '', 'lsuperior', 'msuperior',
    'nsuperior', 'osuperior', '', '', 'rsuperior', 'ssuperior', 'tsuperior', '', 'ff', 'fi', 'fl', 'ffi', 'ffl',
    'parenleftinferior', '', 'parenrightinferior', 'Circumflexsmall', 'hyphensuperior', 'Gravesmall', 'Asmall',
    'Bsmall', 'Csmall', 'Dsmall', 'Esmall', 'Fsmall', 'Gsmall', 'Hsmall', 'Ismall', 'Jsmall', 'Ksmall', 'Lsmall',
    'Msmall', 'Nsmall', 'Osmall', 'Psmall', 'Qsmall', 'Rsmall', 'Ssmall', 'Tsmall', 'Usmall', 'Vsmall', 'Wsmall',
    'Xsmall', 'Ysmall', 'Zsmall', 'colonmonetary', 'onefitted', 'rupiah', 'Tildesmall', '', '', '', '', '', '', '',
    '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
    'exclamdownsmall', 'centoldstyle', 'Lslashsmall', '', '', 'Scaronsmall', 'Zcaronsmall', 'Dieresissmall',
    'Brevesmall', 'Caronsmall', '', 'Dotaccentsmall', '', '', 'Macronsmall', '', '', 'figuredash', 'hypheninferior',
    '', '', 'Ogoneksmall', 'Ringsmall', 'Cedillasmall', '', '', '', 'onequarter', 'onehalf', 'threequarters',
    'questiondownsmall', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds', '',
    '', 'zerosuperior', 'onesuperior', 'twosuperior', 'threesuperior', 'foursuperior', 'fivesuperior',
    'sixsuperior', 'sevensuperior', 'eightsuperior', 'ninesuperior', 'zeroinferior', 'oneinferior', 'twoinferior',
    'threeinferior', 'fourinferior', 'fiveinferior', 'sixinferior', 'seveninferior', 'eightinferior',
    'nineinferior', 'centinferior', 'dollarinferior', 'periodinferior', 'commainferior', 'Agravesmall',
    'Aacutesmall', 'Acircumflexsmall', 'Atildesmall', 'Adieresissmall', 'Aringsmall', 'AEsmall', 'Ccedillasmall',
    'Egravesmall', 'Eacutesmall', 'Ecircumflexsmall', 'Edieresissmall', 'Igravesmall', 'Iacutesmall',
    'Icircumflexsmall', 'Idieresissmall', 'Ethsmall', 'Ntildesmall', 'Ogravesmall', 'Oacutesmall',
    'Ocircumflexsmall', 'Otildesmall', 'Odieresissmall', 'OEsmall', 'Oslashsmall', 'Ugravesmall', 'Uacutesmall',
    'Ucircumflexsmall', 'Udieresissmall', 'Yacutesmall', 'Thornsmall', 'Ydieresissmall'];

var standardNames = [
    '.notdef', '.null', 'nonmarkingreturn', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent',
    'ampersand', 'quotesingle', 'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash',
    'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less',
    'equal', 'greater', 'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O',
    'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright',
    'asciicircum', 'underscore', 'grave', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o',
    'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde',
    'Adieresis', 'Aring', 'Ccedilla', 'Eacute', 'Ntilde', 'Odieresis', 'Udieresis', 'aacute', 'agrave',
    'acircumflex', 'adieresis', 'atilde', 'aring', 'ccedilla', 'eacute', 'egrave', 'ecircumflex', 'edieresis',
    'iacute', 'igrave', 'icircumflex', 'idieresis', 'ntilde', 'oacute', 'ograve', 'ocircumflex', 'odieresis',
    'otilde', 'uacute', 'ugrave', 'ucircumflex', 'udieresis', 'dagger', 'degree', 'cent', 'sterling', 'section',
    'bullet', 'paragraph', 'germandbls', 'registered', 'copyright', 'trademark', 'acute', 'dieresis', 'notequal',
    'AE', 'Oslash', 'infinity', 'plusminus', 'lessequal', 'greaterequal', 'yen', 'mu', 'partialdiff', 'summation',
    'product', 'pi', 'integral', 'ordfeminine', 'ordmasculine', 'Omega', 'ae', 'oslash', 'questiondown',
    'exclamdown', 'logicalnot', 'radical', 'florin', 'approxequal', 'Delta', 'guillemotleft', 'guillemotright',
    'ellipsis', 'nonbreakingspace', 'Agrave', 'Atilde', 'Otilde', 'OE', 'oe', 'endash', 'emdash', 'quotedblleft',
    'quotedblright', 'quoteleft', 'quoteright', 'divide', 'lozenge', 'ydieresis', 'Ydieresis', 'fraction',
    'currency', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', 'daggerdbl', 'periodcentered', 'quotesinglbase',
    'quotedblbase', 'perthousand', 'Acircumflex', 'Ecircumflex', 'Aacute', 'Edieresis', 'Egrave', 'Iacute',
    'Icircumflex', 'Idieresis', 'Igrave', 'Oacute', 'Ocircumflex', 'apple', 'Ograve', 'Uacute', 'Ucircumflex',
    'Ugrave', 'dotlessi', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'ring', 'cedilla', 'hungarumlaut',
    'ogonek', 'caron', 'Lslash', 'lslash', 'Scaron', 'scaron', 'Zcaron', 'zcaron', 'brokenbar', 'Eth', 'eth',
    'Yacute', 'yacute', 'Thorn', 'thorn', 'minus', 'multiply', 'onesuperior', 'twosuperior', 'threesuperior',
    'onehalf', 'onequarter', 'threequarters', 'franc', 'Gbreve', 'gbreve', 'Idotaccent', 'Scedilla', 'scedilla',
    'Cacute', 'cacute', 'Ccaron', 'ccaron', 'dcroat'];

// This is the encoding used for fonts created from scratch.
// It loops through all glyphs and finds the appropriate unicode value.
// Since it's linear time, other encodings will be faster.
function DefaultEncoding(font) {
    this.font = font;
}

DefaultEncoding.prototype.charToGlyphIndex = function(c) {
    var code = c.charCodeAt(0);
    var glyphs = this.font.glyphs;
    if (glyphs) {
        for (var i = 0; i < glyphs.length; i += 1) {
            var glyph = glyphs.get(i);
            for (var j = 0; j < glyph.unicodes.length; j += 1) {
                if (glyph.unicodes[j] === code) {
                    return i;
                }
            }
        }
    } else {
        return null;
    }
};

function CmapEncoding(cmap) {
    this.cmap = cmap;
}

CmapEncoding.prototype.charToGlyphIndex = function(c) {
    return this.cmap.glyphIndexMap[c.charCodeAt(0)] || 0;
};

function CffEncoding(encoding, charset) {
    this.encoding = encoding;
    this.charset = charset;
}

CffEncoding.prototype.charToGlyphIndex = function(s) {
    var code = s.charCodeAt(0);
    var charName = this.encoding[code];
    return this.charset.indexOf(charName);
};

function GlyphNames(post) {
    var i;
    switch (post.version) {
    case 1:
        this.names = exports.standardNames.slice();
        break;
    case 2:
        this.names = new Array(post.numberOfGlyphs);
        for (i = 0; i < post.numberOfGlyphs; i++) {
            if (post.glyphNameIndex[i] < exports.standardNames.length) {
                this.names[i] = exports.standardNames[post.glyphNameIndex[i]];
            } else {
                this.names[i] = post.names[post.glyphNameIndex[i] - exports.standardNames.length];
            }
        }

        break;
    case 2.5:
        this.names = new Array(post.numberOfGlyphs);
        for (i = 0; i < post.numberOfGlyphs; i++) {
            this.names[i] = exports.standardNames[i + post.glyphNameIndex[i]];
        }

        break;
    case 3:
        this.names = [];
        break;
    }
}

GlyphNames.prototype.nameToGlyphIndex = function(name) {
    return this.names.indexOf(name);
};

GlyphNames.prototype.glyphIndexToName = function(gid) {
    return this.names[gid];
};

function addGlyphNames(font) {
    var glyph;
    var glyphIndexMap = font.tables.cmap.glyphIndexMap;
    var charCodes = Object.keys(glyphIndexMap);

    for (var i = 0; i < charCodes.length; i += 1) {
        var c = charCodes[i];
        var glyphIndex = glyphIndexMap[c];
        glyph = font.glyphs.get(glyphIndex);
        glyph.addUnicode(parseInt(c));
    }

    for (i = 0; i < font.glyphs.length; i += 1) {
        glyph = font.glyphs.get(i);
        if (font.cffEncoding) {
            glyph.name = font.cffEncoding.charset[i];
        } else {
            glyph.name = font.glyphNames.glyphIndexToName(i);
        }
    }
}

exports.cffStandardStrings = cffStandardStrings;
exports.cffStandardEncoding = cffStandardEncoding;
exports.cffExpertEncoding = cffExpertEncoding;
exports.standardNames = standardNames;
exports.DefaultEncoding = DefaultEncoding;
exports.CmapEncoding = CmapEncoding;
exports.CffEncoding = CffEncoding;
exports.GlyphNames = GlyphNames;
exports.addGlyphNames = addGlyphNames;

},{}],7:[function(_dereq_,module,exports){
// The Font object

'use strict';

var path = _dereq_('./path');
var sfnt = _dereq_('./tables/sfnt');
var encoding = _dereq_('./encoding');
var glyphset = _dereq_('./glyphset');

// A Font represents a loaded OpenType font file.
// It contains a set of glyphs and methods to draw text on a drawing context,
// or to get a path representing the text.
function Font(options) {
    options = options || {};

    // OS X will complain if the names are empty, so we put a single space everywhere by default.
    this.names = {
        fontFamily: {en: options.familyName || ' '},
        fontSubfamily: {en: options.styleName || ' '},
        designer: {en: options.designer || ' '},
        designerURL: {en: options.designerURL || ' '},
        manufacturer: {en: options.manufacturer || ' '},
        manufacturerURL: {en: options.manufacturerURL || ' '},
        license: {en: options.license || ' '},
        licenseURL: {en: options.licenseURL || ' '},
        version: {en: options.version || 'Version 0.1'},
        description: {en: options.description || ' '},
        copyright: {en: options.copyright || ' '},
        trademark: {en: options.trademark || ' '}
    };
    this.unitsPerEm = options.unitsPerEm || 1000;
    this.ascender = options.ascender;
    this.descender = options.descender;
    this.supported = true; // Deprecated: parseBuffer will throw an error if font is not supported.
    this.glyphs = new glyphset.GlyphSet(this, options.glyphs || []);
    this.encoding = new encoding.DefaultEncoding(this);
    this.tables = {};
}

// Check if the font has a glyph for the given character.
Font.prototype.hasChar = function(c) {
    return this.encoding.charToGlyphIndex(c) !== null;
};

// Convert the given character to a single glyph index.
// Note that this function assumes that there is a one-to-one mapping between
// the given character and a glyph; for complex scripts this might not be the case.
Font.prototype.charToGlyphIndex = function(s) {
    return this.encoding.charToGlyphIndex(s);
};

// Convert the given character to a single Glyph object.
// Note that this function assumes that there is a one-to-one mapping between
// the given character and a glyph; for complex scripts this might not be the case.
Font.prototype.charToGlyph = function(c) {
    var glyphIndex = this.charToGlyphIndex(c);
    var glyph = this.glyphs.get(glyphIndex);
    if (!glyph) {
        // .notdef
        glyph = this.glyphs.get(0);
    }

    return glyph;
};

// Convert the given text to a list of Glyph objects.
// Note that there is no strict one-to-one mapping between characters and
// glyphs, so the list of returned glyphs can be larger or smaller than the
// length of the given string.
Font.prototype.stringToGlyphs = function(s) {
    var glyphs = [];
    for (var i = 0; i < s.length; i += 1) {
        var c = s[i];
        glyphs.push(this.charToGlyph(c));
    }

    return glyphs;
};

Font.prototype.nameToGlyphIndex = function(name) {
    return this.glyphNames.nameToGlyphIndex(name);
};

Font.prototype.nameToGlyph = function(name) {
    var glyphIndex = this.nametoGlyphIndex(name);
    var glyph = this.glyphs.get(glyphIndex);
    if (!glyph) {
        // .notdef
        glyph = this.glyphs.get(0);
    }

    return glyph;
};

Font.prototype.glyphIndexToName = function(gid) {
    if (!this.glyphNames.glyphIndexToName) {
        return '';
    }

    return this.glyphNames.glyphIndexToName(gid);
};

// Retrieve the value of the kerning pair between the left glyph (or its index)
// and the right glyph (or its index). If no kerning pair is found, return 0.
// The kerning value gets added to the advance width when calculating the spacing
// between glyphs.
Font.prototype.getKerningValue = function(leftGlyph, rightGlyph) {
    leftGlyph = leftGlyph.index || leftGlyph;
    rightGlyph = rightGlyph.index || rightGlyph;
    var gposKerning = this.getGposKerningValue;
    return gposKerning ? gposKerning(leftGlyph, rightGlyph) :
        (this.kerningPairs[leftGlyph + ',' + rightGlyph] || 0);
};

// Helper function that invokes the given callback for each glyph in the given text.
// The callback gets `(glyph, x, y, fontSize, options)`.
Font.prototype.forEachGlyph = function(text, x, y, fontSize, options, callback) {
    x = x !== undefined ? x : 0;
    y = y !== undefined ? y : 0;
    fontSize = fontSize !== undefined ? fontSize : 72;
    options = options || {};
    var kerning = options.kerning === undefined ? true : options.kerning;
    var fontScale = 1 / this.unitsPerEm * fontSize;
    var glyphs = this.stringToGlyphs(text);
    for (var i = 0; i < glyphs.length; i += 1) {
        var glyph = glyphs[i];
        callback(glyph, x, y, fontSize, options);
        if (glyph.advanceWidth) {
            x += glyph.advanceWidth * fontScale;
        }

        if (kerning && i < glyphs.length - 1) {
            var kerningValue = this.getKerningValue(glyph, glyphs[i + 1]);
            x += kerningValue * fontScale;
        }
    }
};

// Create a Path object that represents the given text.
//
// text - The text to create.
// x - Horizontal position of the beginning of the text. (default: 0)
// y - Vertical position of the *baseline* of the text. (default: 0)
// fontSize - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`. (default: 72)
// Options is an optional object that contains:
// - kerning - Whether to take kerning information into account. (default: true)
//
// Returns a Path object.
Font.prototype.getPath = function(text, x, y, fontSize, options) {
    var fullPath = new path.Path();
    this.forEachGlyph(text, x, y, fontSize, options, function(glyph, gX, gY, gFontSize) {
        var glyphPath = glyph.getPath(gX, gY, gFontSize);
        fullPath.extend(glyphPath);
    });

    return fullPath;
};

// Draw the text on the given drawing context.
//
// ctx - A 2D drawing context, like Canvas.
// text - The text to create.
// x - Horizontal position of the beginning of the text. (default: 0)
// y - Vertical position of the *baseline* of the text. (default: 0)
// fontSize - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`. (default: 72)
// Options is an optional object that contains:
// - kerning - Whether to take kerning information into account. (default: true)
Font.prototype.draw = function(ctx, text, x, y, fontSize, options) {
    this.getPath(text, x, y, fontSize, options).draw(ctx);
};

// Draw the points of all glyphs in the text.
// On-curve points will be drawn in blue, off-curve points will be drawn in red.
//
// ctx - A 2D drawing context, like Canvas.
// text - The text to create.
// x - Horizontal position of the beginning of the text. (default: 0)
// y - Vertical position of the *baseline* of the text. (default: 0)
// fontSize - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`. (default: 72)
// Options is an optional object that contains:
// - kerning - Whether to take kerning information into account. (default: true)
Font.prototype.drawPoints = function(ctx, text, x, y, fontSize, options) {
    this.forEachGlyph(text, x, y, fontSize, options, function(glyph, gX, gY, gFontSize) {
        glyph.drawPoints(ctx, gX, gY, gFontSize);
    });
};

// Draw lines indicating important font measurements for all glyphs in the text.
// Black lines indicate the origin of the coordinate system (point 0,0).
// Blue lines indicate the glyph bounding box.
// Green line indicates the advance width of the glyph.
//
// ctx - A 2D drawing context, like Canvas.
// text - The text to create.
// x - Horizontal position of the beginning of the text. (default: 0)
// y - Vertical position of the *baseline* of the text. (default: 0)
// fontSize - Font size in pixels. We scale the glyph units by `1 / unitsPerEm * fontSize`. (default: 72)
// Options is an optional object that contains:
// - kerning - Whether to take kerning information into account. (default: true)
Font.prototype.drawMetrics = function(ctx, text, x, y, fontSize, options) {
    this.forEachGlyph(text, x, y, fontSize, options, function(glyph, gX, gY, gFontSize) {
        glyph.drawMetrics(ctx, gX, gY, gFontSize);
    });
};

Font.prototype.getEnglishName = function(name) {
    var translations = this.names[name];
    if (translations) {
        return translations.en;
    }
};

// Validate
Font.prototype.validate = function() {
    var warnings = [];
    var _this = this;

    function assert(predicate, message) {
        if (!predicate) {
            warnings.push(message);
        }
    }

    function assertNamePresent(name) {
        var englishName = _this.getEnglishName(name);
        assert(englishName && englishName.trim().length > 0,
               'No English ' + name + ' specified.');
    }

    // Identification information
    assertNamePresent('fontFamily');
    assertNamePresent('weightName');
    assertNamePresent('manufacturer');
    assertNamePresent('copyright');
    assertNamePresent('version');

    // Dimension information
    assert(this.unitsPerEm > 0, 'No unitsPerEm specified.');
};

// Convert the font object to a SFNT data structure.
// This structure contains all the necessary tables and metadata to create a binary OTF file.
Font.prototype.toTables = function() {
    return sfnt.fontToTable(this);
};

Font.prototype.toBuffer = function() {
    var sfntTable = this.toTables();
    var bytes = sfntTable.encode();
    var buffer = new ArrayBuffer(bytes.length);
    var intArray = new Uint8Array(buffer);
    for (var i = 0; i < bytes.length; i++) {
        intArray[i] = bytes[i];
    }

    return buffer;
};

// Initiate a download of the OpenType font.
Font.prototype.download = function() {
    var familyName = this.getEnglishName('fontFamily');
    var styleName = this.getEnglishName('fontSubfamily');
    var fileName = familyName.replace(/\s/g, '') + '-' + styleName + '.otf';
    var buffer = this.toBuffer();

    window.requestFileSystem = window.requestFileSystem || window.webkitRequestFileSystem;
    window.requestFileSystem(window.TEMPORARY, buffer.byteLength, function(fs) {
        fs.root.getFile(fileName, {create: true}, function(fileEntry) {
            fileEntry.createWriter(function(writer) {
                var dataView = new DataView(buffer);
                var blob = new Blob([dataView], {type: 'font/opentype'});
                writer.write(blob);

                writer.addEventListener('writeend', function() {
                    // Navigating to the file will download it.
                    location.href = fileEntry.toURL();
                }, false);
            });
        });
    },

    function(err) {
        throw err;
    });
};

exports.Font = Font;

},{"./encoding":6,"./glyphset":9,"./path":12,"./tables/sfnt":29}],8:[function(_dereq_,module,exports){
// The Glyph object

'use strict';

var check = _dereq_('./check');
var draw = _dereq_('./draw');
var path = _dereq_('./path');

function getPathDefinition(glyph, path) {
    var _path = path || { commands: [] };
    return {
        configurable: true,

        get: function() {
            if (typeof _path === 'function') {
                _path = _path();
            }

            return _path;
        },

        set: function(p) {
            _path = p;
        }
    };
}

// A Glyph is an individual mark that often corresponds to a character.
// Some glyphs, such as ligatures, are a combination of many characters.
// Glyphs are the basic building blocks of a font.
//
// The `Glyph` class contains utility methods for drawing the path and its points.
function Glyph(options) {
    // By putting all the code on a prototype function (which is only declared once)
    // we reduce the memory requirements for larger fonts by some 2%
    this.bindConstructorValues(options);
}

Glyph.prototype.bindConstructorValues = function(options) {
    this.index = options.index || 0;

    // These three values cannnot be deferred for memory optimization:
    this.name = options.name || null;
    this.unicode = options.unicode || undefined;
    this.unicodes = options.unicodes || options.unicode !== undefined ? [options.unicode] : [];

    // But by binding these values only when necessary, we reduce can
    // the memory requirements by almost 3% for larger fonts.
    if (options.xMin) {
        this.xMin = options.xMin;
    }

    if (options.yMin) {
        this.yMin = options.yMin;
    }

    if (options.xMax) {
        this.xMax = options.xMax;
    }

    if (options.yMax) {
        this.yMax = options.yMax;
    }

    if (options.advanceWidth) {
        this.advanceWidth = options.advanceWidth;
    }

    // The path for a glyph is the most memory intensive, and is bound as a value
    // with a getter/setter to ensure we actually do path parsing only once the
    // path is actually needed by anything.
    Object.defineProperty(this, 'path', getPathDefinition(this, options.path));
};

Glyph.prototype.addUnicode = function(unicode) {
    if (this.unicodes.length === 0) {
        this.unicode = unicode;
    }

    this.unicodes.push(unicode);
};

// Convert the glyph to a Path we can draw on a drawing context.
//
// x - Horizontal position of the glyph. (default: 0)
// y - Vertical position of the *baseline* of the glyph. (default: 0)
// fontSize - Font size, in pixels (default: 72).
Glyph.prototype.getPath = function(x, y, fontSize) {
    x = x !== undefined ? x : 0;
    y = y !== undefined ? y : 0;
    fontSize = fontSize !== undefined ? fontSize : 72;
    var scale = 1 / this.path.unitsPerEm * fontSize;
    var p = new path.Path();
    var commands = this.path.commands;
    for (var i = 0; i < commands.length; i += 1) {
        var cmd = commands[i];
        if (cmd.type === 'M') {
            p.moveTo(x + (cmd.x * scale), y + (-cmd.y * scale));
        } else if (cmd.type === 'L') {
            p.lineTo(x + (cmd.x * scale), y + (-cmd.y * scale));
        } else if (cmd.type === 'Q') {
            p.quadraticCurveTo(x + (cmd.x1 * scale), y + (-cmd.y1 * scale),
                               x + (cmd.x * scale), y + (-cmd.y * scale));
        } else if (cmd.type === 'C') {
            p.curveTo(x + (cmd.x1 * scale), y + (-cmd.y1 * scale),
                      x + (cmd.x2 * scale), y + (-cmd.y2 * scale),
                      x + (cmd.x * scale), y + (-cmd.y * scale));
        } else if (cmd.type === 'Z') {
            p.closePath();
        }
    }

    return p;
};

// Split the glyph into contours.
// This function is here for backwards compatibility, and to
// provide raw access to the TrueType glyph outlines.
Glyph.prototype.getContours = function() {
    if (this.points === undefined) {
        return [];
    }

    var contours = [];
    var currentContour = [];
    for (var i = 0; i < this.points.length; i += 1) {
        var pt = this.points[i];
        currentContour.push(pt);
        if (pt.lastPointOfContour) {
            contours.push(currentContour);
            currentContour = [];
        }
    }

    check.argument(currentContour.length === 0, 'There are still points left in the current contour.');
    return contours;
};

// Calculate the xMin/yMin/xMax/yMax/lsb/rsb for a Glyph.
Glyph.prototype.getMetrics = function() {
    var commands = this.path.commands;
    var xCoords = [];
    var yCoords = [];
    for (var i = 0; i < commands.length; i += 1) {
        var cmd = commands[i];
        if (cmd.type !== 'Z') {
            xCoords.push(cmd.x);
            yCoords.push(cmd.y);
        }

        if (cmd.type === 'Q' || cmd.type === 'C') {
            xCoords.push(cmd.x1);
            yCoords.push(cmd.y1);
        }

        if (cmd.type === 'C') {
            xCoords.push(cmd.x2);
            yCoords.push(cmd.y2);
        }
    }

    var metrics = {
        xMin: Math.min.apply(null, xCoords),
        yMin: Math.min.apply(null, yCoords),
        xMax: Math.max.apply(null, xCoords),
        yMax: Math.max.apply(null, yCoords),
        leftSideBearing: 0
    };

    if (!isFinite(metrics.xMin)) {
        metrics.xMin = 0;
    }

    if (!isFinite(metrics.xMax)) {
        metrics.xMax = this.advanceWidth;
    }

    if (!isFinite(metrics.yMin)) {
        metrics.yMin = 0;
    }

    if (!isFinite(metrics.yMax)) {
        metrics.yMax = 0;
    }

    metrics.rightSideBearing = this.advanceWidth - metrics.leftSideBearing - (metrics.xMax - metrics.xMin);
    return metrics;
};

// Draw the glyph on the given context.
//
// ctx - The drawing context.
// x - Horizontal position of the glyph. (default: 0)
// y - Vertical position of the *baseline* of the glyph. (default: 0)
// fontSize - Font size, in pixels (default: 72).
Glyph.prototype.draw = function(ctx, x, y, fontSize) {
    this.getPath(x, y, fontSize).draw(ctx);
};

// Draw the points of the glyph.
// On-curve points will be drawn in blue, off-curve points will be drawn in red.
//
// ctx - The drawing context.
// x - Horizontal position of the glyph. (default: 0)
// y - Vertical position of the *baseline* of the glyph. (default: 0)
// fontSize - Font size, in pixels (default: 72).
Glyph.prototype.drawPoints = function(ctx, x, y, fontSize) {

    function drawCircles(l, x, y, scale) {
        var PI_SQ = Math.PI * 2;
        ctx.beginPath();
        for (var j = 0; j < l.length; j += 1) {
            ctx.moveTo(x + (l[j].x * scale), y + (l[j].y * scale));
            ctx.arc(x + (l[j].x * scale), y + (l[j].y * scale), 2, 0, PI_SQ, false);
        }

        ctx.closePath();
        ctx.fill();
    }

    x = x !== undefined ? x : 0;
    y = y !== undefined ? y : 0;
    fontSize = fontSize !== undefined ? fontSize : 24;
    var scale = 1 / this.path.unitsPerEm * fontSize;

    var blueCircles = [];
    var redCircles = [];
    var path = this.path;
    for (var i = 0; i < path.commands.length; i += 1) {
        var cmd = path.commands[i];
        if (cmd.x !== undefined) {
            blueCircles.push({x: cmd.x, y: -cmd.y});
        }

        if (cmd.x1 !== undefined) {
            redCircles.push({x: cmd.x1, y: -cmd.y1});
        }

        if (cmd.x2 !== undefined) {
            redCircles.push({x: cmd.x2, y: -cmd.y2});
        }
    }

    ctx.fillStyle = 'blue';
    drawCircles(blueCircles, x, y, scale);
    ctx.fillStyle = 'red';
    drawCircles(redCircles, x, y, scale);
};

// Draw lines indicating important font measurements.
// Black lines indicate the origin of the coordinate system (point 0,0).
// Blue lines indicate the glyph bounding box.
// Green line indicates the advance width of the glyph.
//
// ctx - The drawing context.
// x - Horizontal position of the glyph. (default: 0)
// y - Vertical position of the *baseline* of the glyph. (default: 0)
// fontSize - Font size, in pixels (default: 72).
Glyph.prototype.drawMetrics = function(ctx, x, y, fontSize) {
    var scale;
    x = x !== undefined ? x : 0;
    y = y !== undefined ? y : 0;
    fontSize = fontSize !== undefined ? fontSize : 24;
    scale = 1 / this.path.unitsPerEm * fontSize;
    ctx.lineWidth = 1;

    // Draw the origin
    ctx.strokeStyle = 'black';
    draw.line(ctx, x, -10000, x, 10000);
    draw.line(ctx, -10000, y, 10000, y);

    // This code is here due to memory optimization: by not using
    // defaults in the constructor, we save a notable amount of memory.
    var xMin = this.xMin || 0;
    var yMin = this.yMin || 0;
    var xMax = this.xMax || 0;
    var yMax = this.yMax || 0;
    var advanceWidth = this.advanceWidth || 0;

    // Draw the glyph box
    ctx.strokeStyle = 'blue';
    draw.line(ctx, x + (xMin * scale), -10000, x + (xMin * scale), 10000);
    draw.line(ctx, x + (xMax * scale), -10000, x + (xMax * scale), 10000);
    draw.line(ctx, -10000, y + (-yMin * scale), 10000, y + (-yMin * scale));
    draw.line(ctx, -10000, y + (-yMax * scale), 10000, y + (-yMax * scale));

    // Draw the advance width
    ctx.strokeStyle = 'green';
    draw.line(ctx, x + (advanceWidth * scale), -10000, x + (advanceWidth * scale), 10000);
};

exports.Glyph = Glyph;

},{"./check":4,"./draw":5,"./path":12}],9:[function(_dereq_,module,exports){
// The GlyphSet object

'use strict';

var _glyph = _dereq_('./glyph');

// A GlyphSet represents all glyphs available in the font, but modelled using
// a deferred glyph loader, for retrieving glyphs only once they are absolutely
// necessary, to keep the memory footprint down.
function GlyphSet(font, glyphs) {
    this.font = font;
    this.glyphs = {};
    if (Array.isArray(glyphs)) {
        for (var i = 0; i < glyphs.length; i++) {
            this.glyphs[i] = glyphs[i];
        }
    }

    this.length = (glyphs && glyphs.length) || 0;
}

GlyphSet.prototype.get = function(index) {
    if (typeof this.glyphs[index] === 'function') {
        this.glyphs[index] = this.glyphs[index]();
    }

    return this.glyphs[index];
};

GlyphSet.prototype.push = function(index, loader) {
    this.glyphs[index] = loader;
    this.length++;
};

function glyphLoader(font, index) {
    return new _glyph.Glyph({index: index, font: font});
}

/**
 * Generate a stub glyph that can be filled with all metadata *except*
 * the "points" and "path" properties, which must be loaded only once
 * the glyph's path is actually requested for text shaping.
 */

function ttfGlyphLoader(font, index, parseGlyph, data, position, buildPath) {
    return function() {
        var glyph = new _glyph.Glyph({index: index, font: font});

        glyph.path = function() {
            parseGlyph(glyph, data, position);
            var path = buildPath(font.glyphs, glyph);
            path.unitsPerEm = font.unitsPerEm;
            return path;
        };

        return glyph;
    };
}

function cffGlyphLoader(font, index, parseCFFCharstring, charstring) {
    return function() {
        var glyph = new _glyph.Glyph({index: index, font: font});

        glyph.path = function() {
            var path = parseCFFCharstring(font, glyph, charstring);
            path.unitsPerEm = font.unitsPerEm;
            return path;
        };

        return glyph;
    };
}

exports.GlyphSet = GlyphSet;
exports.glyphLoader = glyphLoader;
exports.ttfGlyphLoader = ttfGlyphLoader;
exports.cffGlyphLoader = cffGlyphLoader;

},{"./glyph":8}],10:[function(_dereq_,module,exports){
// opentype.js
// https://github.com/nodebox/opentype.js
// (c) 2015 Frederik De Bleser
// opentype.js may be freely distributed under the MIT license.

/* global ArrayBuffer, DataView, Uint8Array, XMLHttpRequest  */

'use strict';

var encoding = _dereq_('./encoding');
var _font = _dereq_('./font');
var glyph = _dereq_('./glyph');
var parse = _dereq_('./parse');
var path = _dereq_('./path');

var cmap = _dereq_('./tables/cmap');
var cff = _dereq_('./tables/cff');
var fvar = _dereq_('./tables/fvar');
var glyf = _dereq_('./tables/glyf');
var gpos = _dereq_('./tables/gpos');
var head = _dereq_('./tables/head');
var hhea = _dereq_('./tables/hhea');
var hmtx = _dereq_('./tables/hmtx');
var kern = _dereq_('./tables/kern');
var ltag = _dereq_('./tables/ltag');
var loca = _dereq_('./tables/loca');
var maxp = _dereq_('./tables/maxp');
var _name = _dereq_('./tables/name');
var os2 = _dereq_('./tables/os2');
var post = _dereq_('./tables/post');

// File loaders /////////////////////////////////////////////////////////

// Convert a Node.js Buffer to an ArrayBuffer
function toArrayBuffer(buffer) {
    var arrayBuffer = new ArrayBuffer(buffer.length);
    var data = new Uint8Array(arrayBuffer);
    for (var i = 0; i < buffer.length; i += 1) {
        data[i] = buffer[i];
    }

    return arrayBuffer;
}

function loadFromFile(path, callback) {
    var fs = _dereq_('fs');
    fs.readFile(path, function(err, buffer) {
        if (err) {
            return callback(err.message);
        }

        callback(null, toArrayBuffer(buffer));
    });
}

function loadFromUrl(url, callback) {
    var request = new XMLHttpRequest();
    request.open('get', url, true);
    request.responseType = 'arraybuffer';
    request.onload = function() {
        if (request.status !== 200) {
            return callback('Font could not be loaded: ' + request.statusText);
        }

        return callback(null, request.response);
    };

    request.send();
}

// Public API ///////////////////////////////////////////////////////////

// Parse the OpenType file data (as an ArrayBuffer) and return a Font object.
// Throws an error if the font could not be parsed.
function parseBuffer(buffer) {
    var indexToLocFormat;
    var ltagTable;

    var cffOffset;
    var fvarOffset;
    var glyfOffset;
    var gposOffset;
    var hmtxOffset;
    var kernOffset;
    var locaOffset;
    var nameOffset;

    // OpenType fonts use big endian byte ordering.
    // We can't rely on typed array view types, because they operate with the endianness of the host computer.
    // Instead we use DataViews where we can specify endianness.

    var font = new _font.Font();
    var data = new DataView(buffer, 0);

    var version = parse.getFixed(data, 0);
    if (version === 1.0) {
        font.outlinesFormat = 'truetype';
    } else {
        version = parse.getTag(data, 0);
        if (version === 'OTTO') {
            font.outlinesFormat = 'cff';
        } else {
            throw new Error('Unsupported OpenType version ' + version);
        }
    }

    var numTables = parse.getUShort(data, 4);

    // Offset into the table records.
    var p = 12;
    for (var i = 0; i < numTables; i += 1) {
        var tag = parse.getTag(data, p);
        var offset = parse.getULong(data, p + 8);
        switch (tag) {
        case 'cmap':
            font.tables.cmap = cmap.parse(data, offset);
            font.encoding = new encoding.CmapEncoding(font.tables.cmap);
            break;
        case 'fvar':
            fvarOffset = offset;
            break;
        case 'head':
            font.tables.head = head.parse(data, offset);
            font.unitsPerEm = font.tables.head.unitsPerEm;
            indexToLocFormat = font.tables.head.indexToLocFormat;
            break;
        case 'hhea':
            font.tables.hhea = hhea.parse(data, offset);
            font.ascender = font.tables.hhea.ascender;
            font.descender = font.tables.hhea.descender;
            font.numberOfHMetrics = font.tables.hhea.numberOfHMetrics;
            break;
        case 'hmtx':
            hmtxOffset = offset;
            break;
        case 'ltag':
            ltagTable = ltag.parse(data, offset);
            break;
        case 'maxp':
            font.tables.maxp = maxp.parse(data, offset);
            font.numGlyphs = font.tables.maxp.numGlyphs;
            break;
        case 'name':
            nameOffset = offset;
            break;
        case 'OS/2':
            font.tables.os2 = os2.parse(data, offset);
            break;
        case 'post':
            font.tables.post = post.parse(data, offset);
            font.glyphNames = new encoding.GlyphNames(font.tables.post);
            break;
        case 'glyf':
            glyfOffset = offset;
            break;
        case 'loca':
            locaOffset = offset;
            break;
        case 'CFF ':
            cffOffset = offset;
            break;
        case 'kern':
            kernOffset = offset;
            break;
        case 'GPOS':
            gposOffset = offset;
            break;
        }
        p += 16;
    }

    font.tables.name = _name.parse(data, nameOffset, ltagTable);
    font.names = font.tables.name;

    if (glyfOffset && locaOffset) {
        var shortVersion = indexToLocFormat === 0;
        var locaTable = loca.parse(data, locaOffset, font.numGlyphs, shortVersion);
        font.glyphs = glyf.parse(data, glyfOffset, locaTable, font);
    } else if (cffOffset) {
        cff.parse(data, cffOffset, font);
    } else {
        throw new Error('Font doesn\'t contain TrueType or CFF outlines.');
    }

    hmtx.parse(data, hmtxOffset, font.numberOfHMetrics, font.numGlyphs, font.glyphs);
    encoding.addGlyphNames(font);

    if (kernOffset) {
        font.kerningPairs = kern.parse(data, kernOffset);
    } else {
        font.kerningPairs = {};
    }

    if (gposOffset) {
        gpos.parse(data, gposOffset, font);
    }

    if (fvarOffset) {
        font.tables.fvar = fvar.parse(data, fvarOffset, font.names);
    }

    return font;
}

// Asynchronously load the font from a URL or a filesystem. When done, call the callback
// with two arguments `(err, font)`. The `err` will be null on success,
// the `font` is a Font object.
//
// We use the node.js callback convention so that
// opentype.js can integrate with frameworks like async.js.
function load(url, callback) {
    var isNode = typeof window === 'undefined';
    var loadFn = isNode ? loadFromFile : loadFromUrl;
    loadFn(url, function(err, arrayBuffer) {
        if (err) {
            return callback(err);
        }

        var font = parseBuffer(arrayBuffer);
        return callback(null, font);
    });
}

// Syncronously load the font from a URL or file.
// When done, return the font object or throw an error.
function loadSync(url) {
    var fs = _dereq_('fs');
    var buffer = fs.readFileSync(url);
    return parseBuffer(toArrayBuffer(buffer));
}

exports._parse = parse;
exports.Font = _font.Font;
exports.Glyph = glyph.Glyph;
exports.Path = path.Path;
exports.parse = parseBuffer;
exports.load = load;
exports.loadSync = loadSync;

},{"./encoding":6,"./font":7,"./glyph":8,"./parse":11,"./path":12,"./tables/cff":14,"./tables/cmap":15,"./tables/fvar":16,"./tables/glyf":17,"./tables/gpos":18,"./tables/head":19,"./tables/hhea":20,"./tables/hmtx":21,"./tables/kern":22,"./tables/loca":23,"./tables/ltag":24,"./tables/maxp":25,"./tables/name":26,"./tables/os2":27,"./tables/post":28,"fs":1}],11:[function(_dereq_,module,exports){
// Parsing utility functions

'use strict';

// Retrieve an unsigned byte from the DataView.
exports.getByte = function getByte(dataView, offset) {
    return dataView.getUint8(offset);
};

exports.getCard8 = exports.getByte;

// Retrieve an unsigned 16-bit short from the DataView.
// The value is stored in big endian.
exports.getUShort = function(dataView, offset) {
    return dataView.getUint16(offset, false);
};

exports.getCard16 = exports.getUShort;

// Retrieve a signed 16-bit short from the DataView.
// The value is stored in big endian.
exports.getShort = function(dataView, offset) {
    return dataView.getInt16(offset, false);
};

// Retrieve an unsigned 32-bit long from the DataView.
// The value is stored in big endian.
exports.getULong = function(dataView, offset) {
    return dataView.getUint32(offset, false);
};

// Retrieve a 32-bit signed fixed-point number (16.16) from the DataView.
// The value is stored in big endian.
exports.getFixed = function(dataView, offset) {
    var decimal = dataView.getInt16(offset, false);
    var fraction = dataView.getUint16(offset + 2, false);
    return decimal + fraction / 65535;
};

// Retrieve a 4-character tag from the DataView.
// Tags are used to identify tables.
exports.getTag = function(dataView, offset) {
    var tag = '';
    for (var i = offset; i < offset + 4; i += 1) {
        tag += String.fromCharCode(dataView.getInt8(i));
    }

    return tag;
};

// Retrieve an offset from the DataView.
// Offsets are 1 to 4 bytes in length, depending on the offSize argument.
exports.getOffset = function(dataView, offset, offSize) {
    var v = 0;
    for (var i = 0; i < offSize; i += 1) {
        v <<= 8;
        v += dataView.getUint8(offset + i);
    }

    return v;
};

// Retrieve a number of bytes from start offset to the end offset from the DataView.
exports.getBytes = function(dataView, startOffset, endOffset) {
    var bytes = [];
    for (var i = startOffset; i < endOffset; i += 1) {
        bytes.push(dataView.getUint8(i));
    }

    return bytes;
};

// Convert the list of bytes to a string.
exports.bytesToString = function(bytes) {
    var s = '';
    for (var i = 0; i < bytes.length; i += 1) {
        s += String.fromCharCode(bytes[i]);
    }

    return s;
};

var typeOffsets = {
    byte: 1,
    uShort: 2,
    short: 2,
    uLong: 4,
    fixed: 4,
    longDateTime: 8,
    tag: 4
};

// A stateful parser that changes the offset whenever a value is retrieved.
// The data is a DataView.
function Parser(data, offset) {
    this.data = data;
    this.offset = offset;
    this.relativeOffset = 0;
}

Parser.prototype.parseByte = function() {
    var v = this.data.getUint8(this.offset + this.relativeOffset);
    this.relativeOffset += 1;
    return v;
};

Parser.prototype.parseChar = function() {
    var v = this.data.getInt8(this.offset + this.relativeOffset);
    this.relativeOffset += 1;
    return v;
};

Parser.prototype.parseCard8 = Parser.prototype.parseByte;

Parser.prototype.parseUShort = function() {
    var v = this.data.getUint16(this.offset + this.relativeOffset);
    this.relativeOffset += 2;
    return v;
};

Parser.prototype.parseCard16 = Parser.prototype.parseUShort;
Parser.prototype.parseSID = Parser.prototype.parseUShort;
Parser.prototype.parseOffset16 = Parser.prototype.parseUShort;

Parser.prototype.parseShort = function() {
    var v = this.data.getInt16(this.offset + this.relativeOffset);
    this.relativeOffset += 2;
    return v;
};

Parser.prototype.parseF2Dot14 = function() {
    var v = this.data.getInt16(this.offset + this.relativeOffset) / 16384;
    this.relativeOffset += 2;
    return v;
};

Parser.prototype.parseULong = function() {
    var v = exports.getULong(this.data, this.offset + this.relativeOffset);
    this.relativeOffset += 4;
    return v;
};

Parser.prototype.parseFixed = function() {
    var v = exports.getFixed(this.data, this.offset + this.relativeOffset);
    this.relativeOffset += 4;
    return v;
};

Parser.prototype.parseOffset16List =
Parser.prototype.parseUShortList = function(count) {
    var offsets = new Array(count);
    var dataView = this.data;
    var offset = this.offset + this.relativeOffset;
    for (var i = 0; i < count; i++) {
        offsets[i] = exports.getUShort(dataView, offset);
        offset += 2;
    }

    this.relativeOffset += count * 2;
    return offsets;
};

Parser.prototype.parseString = function(length) {
    var dataView = this.data;
    var offset = this.offset + this.relativeOffset;
    var string = '';
    this.relativeOffset += length;
    for (var i = 0; i < length; i++) {
        string += String.fromCharCode(dataView.getUint8(offset + i));
    }

    return string;
};

Parser.prototype.parseTag = function() {
    return this.parseString(4);
};

// LONGDATETIME is a 64-bit integer.
// JavaScript and unix timestamps traditionally use 32 bits, so we
// only take the last 32 bits.
Parser.prototype.parseLongDateTime = function() {
    var v = exports.getULong(this.data, this.offset + this.relativeOffset + 4);
    this.relativeOffset += 8;
    return v;
};

Parser.prototype.parseFixed = function() {
    var v = exports.getULong(this.data, this.offset + this.relativeOffset);
    this.relativeOffset += 4;
    return v / 65536;
};

Parser.prototype.parseVersion = function() {
    var major = exports.getUShort(this.data, this.offset + this.relativeOffset);

    // How to interpret the minor version is very vague in the spec. 0x5000 is 5, 0x1000 is 1
    // This returns the correct number if minor = 0xN000 where N is 0-9
    var minor = exports.getUShort(this.data, this.offset + this.relativeOffset + 2);
    this.relativeOffset += 4;
    return major + minor / 0x1000 / 10;
};

Parser.prototype.skip = function(type, amount) {
    if (amount === undefined) {
        amount = 1;
    }

    this.relativeOffset += typeOffsets[type] * amount;
};

exports.Parser = Parser;

},{}],12:[function(_dereq_,module,exports){
// Geometric objects

'use strict';

// A bézier path containing a set of path commands similar to a SVG path.
// Paths can be drawn on a context using `draw`.
function Path() {
    this.commands = [];
    this.fill = 'black';
    this.stroke = null;
    this.strokeWidth = 1;
}

Path.prototype.moveTo = function(x, y) {
    this.commands.push({
        type: 'M',
        x: x,
        y: y
    });
};

Path.prototype.lineTo = function(x, y) {
    this.commands.push({
        type: 'L',
        x: x,
        y: y
    });
};

Path.prototype.curveTo = Path.prototype.bezierCurveTo = function(x1, y1, x2, y2, x, y) {
    this.commands.push({
        type: 'C',
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2,
        x: x,
        y: y
    });
};

Path.prototype.quadTo = Path.prototype.quadraticCurveTo = function(x1, y1, x, y) {
    this.commands.push({
        type: 'Q',
        x1: x1,
        y1: y1,
        x: x,
        y: y
    });
};

Path.prototype.close = Path.prototype.closePath = function() {
    this.commands.push({
        type: 'Z'
    });
};

// Add the given path or list of commands to the commands of this path.
Path.prototype.extend = function(pathOrCommands) {
    if (pathOrCommands.commands) {
        pathOrCommands = pathOrCommands.commands;
    }

    Array.prototype.push.apply(this.commands, pathOrCommands);
};

// Draw the path to a 2D context.
Path.prototype.draw = function(ctx) {
    ctx.beginPath();
    for (var i = 0; i < this.commands.length; i += 1) {
        var cmd = this.commands[i];
        if (cmd.type === 'M') {
            ctx.moveTo(cmd.x, cmd.y);
        } else if (cmd.type === 'L') {
            ctx.lineTo(cmd.x, cmd.y);
        } else if (cmd.type === 'C') {
            ctx.bezierCurveTo(cmd.x1, cmd.y1, cmd.x2, cmd.y2, cmd.x, cmd.y);
        } else if (cmd.type === 'Q') {
            ctx.quadraticCurveTo(cmd.x1, cmd.y1, cmd.x, cmd.y);
        } else if (cmd.type === 'Z') {
            ctx.closePath();
        }
    }

    if (this.fill) {
        ctx.fillStyle = this.fill;
        ctx.fill();
    }

    if (this.stroke) {
        ctx.strokeStyle = this.stroke;
        ctx.lineWidth = this.strokeWidth;
        ctx.stroke();
    }
};

// Convert the Path to a string of path data instructions
// See http://www.w3.org/TR/SVG/paths.html#PathData
// Parameters:
// - decimalPlaces: The amount of decimal places for floating-point values (default: 2)
Path.prototype.toPathData = function(decimalPlaces) {
    decimalPlaces = decimalPlaces !== undefined ? decimalPlaces : 2;

    function floatToString(v) {
        if (Math.round(v) === v) {
            return '' + Math.round(v);
        } else {
            return v.toFixed(decimalPlaces);
        }
    }

    function packValues() {
        var s = '';
        for (var i = 0; i < arguments.length; i += 1) {
            var v = arguments[i];
            if (v >= 0 && i > 0) {
                s += ' ';
            }

            s += floatToString(v);
        }

        return s;
    }

    var d = '';
    for (var i = 0; i < this.commands.length; i += 1) {
        var cmd = this.commands[i];
        if (cmd.type === 'M') {
            d += 'M' + packValues(cmd.x, cmd.y);
        } else if (cmd.type === 'L') {
            d += 'L' + packValues(cmd.x, cmd.y);
        } else if (cmd.type === 'C') {
            d += 'C' + packValues(cmd.x1, cmd.y1, cmd.x2, cmd.y2, cmd.x, cmd.y);
        } else if (cmd.type === 'Q') {
            d += 'Q' + packValues(cmd.x1, cmd.y1, cmd.x, cmd.y);
        } else if (cmd.type === 'Z') {
            d += 'Z';
        }
    }

    return d;
};

// Convert the path to a SVG <path> element, as a string.
// Parameters:
// - decimalPlaces: The amount of decimal places for floating-point values (default: 2)
Path.prototype.toSVG = function(decimalPlaces) {
    var svg = '<path d="';
    svg += this.toPathData(decimalPlaces);
    svg += '"';
    if (this.fill & this.fill !== 'black') {
        if (this.fill === null) {
            svg += ' fill="none"';
        } else {
            svg += ' fill="' + this.fill + '"';
        }
    }

    if (this.stroke) {
        svg += ' stroke="' + this.stroke + '" stroke-width="' + this.strokeWidth + '"';
    }

    svg += '/>';
    return svg;
};

exports.Path = Path;

},{}],13:[function(_dereq_,module,exports){
// Table metadata

'use strict';

var check = _dereq_('./check');
var encode = _dereq_('./types').encode;
var sizeOf = _dereq_('./types').sizeOf;

function Table(tableName, fields, options) {
    var i;
    for (i = 0; i < fields.length; i += 1) {
        var field = fields[i];
        this[field.name] = field.value;
    }

    this.tableName = tableName;
    this.fields = fields;
    if (options) {
        var optionKeys = Object.keys(options);
        for (i = 0; i < optionKeys.length; i += 1) {
            var k = optionKeys[i];
            var v = options[k];
            if (this[k] !== undefined) {
                this[k] = v;
            }
        }
    }
}

Table.prototype.sizeOf = function() {
    var v = 0;
    for (var i = 0; i < this.fields.length; i += 1) {
        var field = this.fields[i];
        var value = this[field.name];
        if (value === undefined) {
            value = field.value;
        }

        if (typeof value.sizeOf === 'function') {
            v += value.sizeOf();
        } else {
            var sizeOfFunction = sizeOf[field.type];
            check.assert(typeof sizeOfFunction === 'function', 'Could not find sizeOf function for field' + field.name);
            v += sizeOfFunction(value);
        }
    }

    return v;
};

Table.prototype.encode = function() {
    return encode.TABLE(this);
};

exports.Table = Table;

},{"./check":4,"./types":30}],14:[function(_dereq_,module,exports){
// The `CFF` table contains the glyph outlines in PostScript format.
// https://www.microsoft.com/typography/OTSPEC/cff.htm
// http://download.microsoft.com/download/8/0/1/801a191c-029d-4af3-9642-555f6fe514ee/cff.pdf
// http://download.microsoft.com/download/8/0/1/801a191c-029d-4af3-9642-555f6fe514ee/type2.pdf

'use strict';

var encoding = _dereq_('../encoding');
var glyphset = _dereq_('../glyphset');
var parse = _dereq_('../parse');
var path = _dereq_('../path');
var table = _dereq_('../table');

// Custom equals function that can also check lists.
function equals(a, b) {
    if (a === b) {
        return true;
    } else if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length) {
            return false;
        }

        for (var i = 0; i < a.length; i += 1) {
            if (!equals(a[i], b[i])) {
                return false;
            }
        }

        return true;
    } else {
        return false;
    }
}

// Parse a `CFF` INDEX array.
// An index array consists of a list of offsets, then a list of objects at those offsets.
function parseCFFIndex(data, start, conversionFn) {
    //var i, objectOffset, endOffset;
    var offsets = [];
    var objects = [];
    var count = parse.getCard16(data, start);
    var i;
    var objectOffset;
    var endOffset;
    if (count !== 0) {
        var offsetSize = parse.getByte(data, start + 2);
        objectOffset = start + ((count + 1) * offsetSize) + 2;
        var pos = start + 3;
        for (i = 0; i < count + 1; i += 1) {
            offsets.push(parse.getOffset(data, pos, offsetSize));
            pos += offsetSize;
        }

        // The total size of the index array is 4 header bytes + the value of the last offset.
        endOffset = objectOffset + offsets[count];
    } else {
        endOffset = start + 2;
    }

    for (i = 0; i < offsets.length - 1; i += 1) {
        var value = parse.getBytes(data, objectOffset + offsets[i], objectOffset + offsets[i + 1]);
        if (conversionFn) {
            value = conversionFn(value);
        }

        objects.push(value);
    }

    return {objects: objects, startOffset: start, endOffset: endOffset};
}

// Parse a `CFF` DICT real value.
function parseFloatOperand(parser) {
    var s = '';
    var eof = 15;
    var lookup = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', 'E', 'E-', null, '-'];
    while (true) {
        var b = parser.parseByte();
        var n1 = b >> 4;
        var n2 = b & 15;

        if (n1 === eof) {
            break;
        }

        s += lookup[n1];

        if (n2 === eof) {
            break;
        }

        s += lookup[n2];
    }

    return parseFloat(s);
}

// Parse a `CFF` DICT operand.
function parseOperand(parser, b0) {
    var b1;
    var b2;
    var b3;
    var b4;
    if (b0 === 28) {
        b1 = parser.parseByte();
        b2 = parser.parseByte();
        return b1 << 8 | b2;
    }

    if (b0 === 29) {
        b1 = parser.parseByte();
        b2 = parser.parseByte();
        b3 = parser.parseByte();
        b4 = parser.parseByte();
        return b1 << 24 | b2 << 16 | b3 << 8 | b4;
    }

    if (b0 === 30) {
        return parseFloatOperand(parser);
    }

    if (b0 >= 32 && b0 <= 246) {
        return b0 - 139;
    }

    if (b0 >= 247 && b0 <= 250) {
        b1 = parser.parseByte();
        return (b0 - 247) * 256 + b1 + 108;
    }

    if (b0 >= 251 && b0 <= 254) {
        b1 = parser.parseByte();
        return -(b0 - 251) * 256 - b1 - 108;
    }

    throw new Error('Invalid b0 ' + b0);
}

// Convert the entries returned by `parseDict` to a proper dictionary.
// If a value is a list of one, it is unpacked.
function entriesToObject(entries) {
    var o = {};
    for (var i = 0; i < entries.length; i += 1) {
        var key = entries[i][0];
        var values = entries[i][1];
        var value;
        if (values.length === 1) {
            value = values[0];
        } else {
            value = values;
        }

        if (o.hasOwnProperty(key)) {
            throw new Error('Object ' + o + ' already has key ' + key);
        }

        o[key] = value;
    }

    return o;
}

// Parse a `CFF` DICT object.
// A dictionary contains key-value pairs in a compact tokenized format.
function parseCFFDict(data, start, size) {
    start = start !== undefined ? start : 0;
    var parser = new parse.Parser(data, start);
    var entries = [];
    var operands = [];
    size = size !== undefined ? size : data.length;

    while (parser.relativeOffset < size) {
        var op = parser.parseByte();

        // The first byte for each dict item distinguishes between operator (key) and operand (value).
        // Values <= 21 are operators.
        if (op <= 21) {
            // Two-byte operators have an initial escape byte of 12.
            if (op === 12) {
                op = 1200 + parser.parseByte();
            }

            entries.push([op, operands]);
            operands = [];
        } else {
            // Since the operands (values) come before the operators (keys), we store all operands in a list
            // until we encounter an operator.
            operands.push(parseOperand(parser, op));
        }
    }

    return entriesToObject(entries);
}

// Given a String Index (SID), return the value of the string.
// Strings below index 392 are standard CFF strings and are not encoded in the font.
function getCFFString(strings, index) {
    if (index <= 390) {
        index = encoding.cffStandardStrings[index];
    } else {
        index = strings[index - 391];
    }

    return index;
}

// Interpret a dictionary and return a new dictionary with readable keys and values for missing entries.
// This function takes `meta` which is a list of objects containing `operand`, `name` and `default`.
function interpretDict(dict, meta, strings) {
    var newDict = {};

    // Because we also want to include missing values, we start out from the meta list
    // and lookup values in the dict.
    for (var i = 0; i < meta.length; i += 1) {
        var m = meta[i];
        var value = dict[m.op];
        if (value === undefined) {
            value = m.value !== undefined ? m.value : null;
        }

        if (m.type === 'SID') {
            value = getCFFString(strings, value);
        }

        newDict[m.name] = value;
    }

    return newDict;
}

// Parse the CFF header.
function parseCFFHeader(data, start) {
    var header = {};
    header.formatMajor = parse.getCard8(data, start);
    header.formatMinor = parse.getCard8(data, start + 1);
    header.size = parse.getCard8(data, start + 2);
    header.offsetSize = parse.getCard8(data, start + 3);
    header.startOffset = start;
    header.endOffset = start + 4;
    return header;
}

var TOP_DICT_META = [
    {name: 'version', op: 0, type: 'SID'},
    {name: 'notice', op: 1, type: 'SID'},
    {name: 'copyright', op: 1200, type: 'SID'},
    {name: 'fullName', op: 2, type: 'SID'},
    {name: 'familyName', op: 3, type: 'SID'},
    {name: 'weight', op: 4, type: 'SID'},
    {name: 'isFixedPitch', op: 1201, type: 'number', value: 0},
    {name: 'italicAngle', op: 1202, type: 'number', value: 0},
    {name: 'underlinePosition', op: 1203, type: 'number', value: -100},
    {name: 'underlineThickness', op: 1204, type: 'number', value: 50},
    {name: 'paintType', op: 1205, type: 'number', value: 0},
    {name: 'charstringType', op: 1206, type: 'number', value: 2},
    {name: 'fontMatrix', op: 1207, type: ['real', 'real', 'real', 'real', 'real', 'real'], value: [0.001, 0, 0, 0.001, 0, 0]},
    {name: 'uniqueId', op: 13, type: 'number'},
    {name: 'fontBBox', op: 5, type: ['number', 'number', 'number', 'number'], value: [0, 0, 0, 0]},
    {name: 'strokeWidth', op: 1208, type: 'number', value: 0},
    {name: 'xuid', op: 14, type: [], value: null},
    {name: 'charset', op: 15, type: 'offset', value: 0},
    {name: 'encoding', op: 16, type: 'offset', value: 0},
    {name: 'charStrings', op: 17, type: 'offset', value: 0},
    {name: 'private', op: 18, type: ['number', 'offset'], value: [0, 0]}
];

var PRIVATE_DICT_META = [
    {name: 'subrs', op: 19, type: 'offset', value: 0},
    {name: 'defaultWidthX', op: 20, type: 'number', value: 0},
    {name: 'nominalWidthX', op: 21, type: 'number', value: 0}
];

// Parse the CFF top dictionary. A CFF table can contain multiple fonts, each with their own top dictionary.
// The top dictionary contains the essential metadata for the font, together with the private dictionary.
function parseCFFTopDict(data, strings) {
    var dict = parseCFFDict(data, 0, data.byteLength);
    return interpretDict(dict, TOP_DICT_META, strings);
}

// Parse the CFF private dictionary. We don't fully parse out all the values, only the ones we need.
function parseCFFPrivateDict(data, start, size, strings) {
    var dict = parseCFFDict(data, start, size);
    return interpretDict(dict, PRIVATE_DICT_META, strings);
}

// Parse the CFF charset table, which contains internal names for all the glyphs.
// This function will return a list of glyph names.
// See Adobe TN #5176 chapter 13, "Charsets".
function parseCFFCharset(data, start, nGlyphs, strings) {
    var i;
    var sid;
    var count;
    var parser = new parse.Parser(data, start);

    // The .notdef glyph is not included, so subtract 1.
    nGlyphs -= 1;
    var charset = ['.notdef'];

    var format = parser.parseCard8();
    if (format === 0) {
        for (i = 0; i < nGlyphs; i += 1) {
            sid = parser.parseSID();
            charset.push(getCFFString(strings, sid));
        }
    } else if (format === 1) {
        while (charset.length <= nGlyphs) {
            sid = parser.parseSID();
            count = parser.parseCard8();
            for (i = 0; i <= count; i += 1) {
                charset.push(getCFFString(strings, sid));
                sid += 1;
            }
        }
    } else if (format === 2) {
        while (charset.length <= nGlyphs) {
            sid = parser.parseSID();
            count = parser.parseCard16();
            for (i = 0; i <= count; i += 1) {
                charset.push(getCFFString(strings, sid));
                sid += 1;
            }
        }
    } else {
        throw new Error('Unknown charset format ' + format);
    }

    return charset;
}

// Parse the CFF encoding data. Only one encoding can be specified per font.
// See Adobe TN #5176 chapter 12, "Encodings".
function parseCFFEncoding(data, start, charset) {
    var i;
    var code;
    var enc = {};
    var parser = new parse.Parser(data, start);
    var format = parser.parseCard8();
    if (format === 0) {
        var nCodes = parser.parseCard8();
        for (i = 0; i < nCodes; i += 1) {
            code = parser.parseCard8();
            enc[code] = i;
        }
    } else if (format === 1) {
        var nRanges = parser.parseCard8();
        code = 1;
        for (i = 0; i < nRanges; i += 1) {
            var first = parser.parseCard8();
            var nLeft = parser.parseCard8();
            for (var j = first; j <= first + nLeft; j += 1) {
                enc[j] = code;
                code += 1;
            }
        }
    } else {
        throw new Error('Unknown encoding format ' + format);
    }

    return new encoding.CffEncoding(enc, charset);
}

// Take in charstring code and return a Glyph object.
// The encoding is described in the Type 2 Charstring Format
// https://www.microsoft.com/typography/OTSPEC/charstr2.htm
function parseCFFCharstring(font, glyph, code) {
    var c1x;
    var c1y;
    var c2x;
    var c2y;
    var p = new path.Path();
    var stack = [];
    var nStems = 0;
    var haveWidth = false;
    var width = font.defaultWidthX;
    var open = false;
    var x = 0;
    var y = 0;

    function newContour(x, y) {
        if (open) {
            p.closePath();
        }

        p.moveTo(x, y);
        open = true;
    }

    function parseStems() {
        var hasWidthArg;

        // The number of stem operators on the stack is always even.
        // If the value is uneven, that means a width is specified.
        hasWidthArg = stack.length % 2 !== 0;
        if (hasWidthArg && !haveWidth) {
            width = stack.shift() + font.nominalWidthX;
        }

        nStems += stack.length >> 1;
        stack.length = 0;
        haveWidth = true;
    }

    function parse(code) {
        var b1;
        var b2;
        var b3;
        var b4;
        var codeIndex;
        var subrCode;
        var jpx;
        var jpy;
        var c3x;
        var c3y;
        var c4x;
        var c4y;

        var i = 0;
        while (i < code.length) {
            var v = code[i];
            i += 1;
            switch (v) {
            case 1: // hstem
                parseStems();
                break;
            case 3: // vstem
                parseStems();
                break;
            case 4: // vmoveto
                if (stack.length > 1 && !haveWidth) {
                    width = stack.shift() + font.nominalWidthX;
                    haveWidth = true;
                }

                y += stack.pop();
                newContour(x, y);
                break;
            case 5: // rlineto
                while (stack.length > 0) {
                    x += stack.shift();
                    y += stack.shift();
                    p.lineTo(x, y);
                }

                break;
            case 6: // hlineto
                while (stack.length > 0) {
                    x += stack.shift();
                    p.lineTo(x, y);
                    if (stack.length === 0) {
                        break;
                    }

                    y += stack.shift();
                    p.lineTo(x, y);
                }

                break;
            case 7: // vlineto
                while (stack.length > 0) {
                    y += stack.shift();
                    p.lineTo(x, y);
                    if (stack.length === 0) {
                        break;
                    }

                    x += stack.shift();
                    p.lineTo(x, y);
                }

                break;
            case 8: // rrcurveto
                while (stack.length > 0) {
                    c1x = x + stack.shift();
                    c1y = y + stack.shift();
                    c2x = c1x + stack.shift();
                    c2y = c1y + stack.shift();
                    x = c2x + stack.shift();
                    y = c2y + stack.shift();
                    p.curveTo(c1x, c1y, c2x, c2y, x, y);
                }

                break;
            case 10: // callsubr
                codeIndex = stack.pop() + font.subrsBias;
                subrCode = font.subrs[codeIndex];
                if (subrCode) {
                    parse(subrCode);
                }

                break;
            case 11: // return
                return;
            case 12: // flex operators
                v = code[i];
                i += 1;
                switch (v) {
                case 35: // flex
                    // |- dx1 dy1 dx2 dy2 dx3 dy3 dx4 dy4 dx5 dy5 dx6 dy6 fd flex (12 35) |-
                    c1x = x   + stack.shift();    // dx1
                    c1y = y   + stack.shift();    // dy1
                    c2x = c1x + stack.shift();    // dx2
                    c2y = c1y + stack.shift();    // dy2
                    jpx = c2x + stack.shift();    // dx3
                    jpy = c2y + stack.shift();    // dy3
                    c3x = jpx + stack.shift();    // dx4
                    c3y = jpy + stack.shift();    // dy4
                    c4x = c3x + stack.shift();    // dx5
                    c4y = c3y + stack.shift();    // dy5
                    x = c4x + stack.shift();      // dx6
                    y = c4y + stack.shift();      // dy6
                    stack.shift();                // flex depth
                    p.curveTo(c1x, c1y, c2x, c2y, jpx, jpy);
                    p.curveTo(c3x, c3y, c4x, c4y, x, y);
                    break;
                case 34: // hflex
                    // |- dx1 dx2 dy2 dx3 dx4 dx5 dx6 hflex (12 34) |-
                    c1x = x   + stack.shift();    // dx1
                    c1y = y;                      // dy1
                    c2x = c1x + stack.shift();    // dx2
                    c2y = c1y + stack.shift();    // dy2
                    jpx = c2x + stack.shift();    // dx3
                    jpy = c2y;                    // dy3
                    c3x = jpx + stack.shift();    // dx4
                    c3y = c2y;                    // dy4
                    c4x = c3x + stack.shift();    // dx5
                    c4y = y;                      // dy5
                    x = c4x + stack.shift();      // dx6
                    p.curveTo(c1x, c1y, c2x, c2y, jpx, jpy);
                    p.curveTo(c3x, c3y, c4x, c4y, x, y);
                    break;
                case 36: // hflex1
                    // |- dx1 dy1 dx2 dy2 dx3 dx4 dx5 dy5 dx6 hflex1 (12 36) |-
                    c1x = x   + stack.shift();    // dx1
                    c1y = y   + stack.shift();    // dy1
                    c2x = c1x + stack.shift();    // dx2
                    c2y = c1y + stack.shift();    // dy2
                    jpx = c2x + stack.shift();    // dx3
                    jpy = c2y;                    // dy3
                    c3x = jpx + stack.shift();    // dx4
                    c3y = c2y;                    // dy4
                    c4x = c3x + stack.shift();    // dx5
                    c4y = c3y + stack.shift();    // dy5
                    x = c4x + stack.shift();      // dx6
                    p.curveTo(c1x, c1y, c2x, c2y, jpx, jpy);
                    p.curveTo(c3x, c3y, c4x, c4y, x, y);
                    break;
                case 37: // flex1
                    // |- dx1 dy1 dx2 dy2 dx3 dy3 dx4 dy4 dx5 dy5 d6 flex1 (12 37) |-
                    c1x = x   + stack.shift();    // dx1
                    c1y = y   + stack.shift();    // dy1
                    c2x = c1x + stack.shift();    // dx2
                    c2y = c1y + stack.shift();    // dy2
                    jpx = c2x + stack.shift();    // dx3
                    jpy = c2y + stack.shift();    // dy3
                    c3x = jpx + stack.shift();    // dx4
                    c3y = jpy + stack.shift();    // dy4
                    c4x = c3x + stack.shift();    // dx5
                    c4y = c3y + stack.shift();    // dy5
                    if (Math.abs(c4x - x) > Math.abs(c4y - y)) {
                        x = c4x + stack.shift();
                    } else {
                        y = c4y + stack.shift();
                    }

                    p.curveTo(c1x, c1y, c2x, c2y, jpx, jpy);
                    p.curveTo(c3x, c3y, c4x, c4y, x, y);
                    break;
                default:
                    console.log('Glyph ' + glyph.index + ': unknown operator ' + 1200 + v);
                    stack.length = 0;
                }
                break;
            case 14: // endchar
                if (stack.length > 0 && !haveWidth) {
                    width = stack.shift() + font.nominalWidthX;
                    haveWidth = true;
                }

                if (open) {
                    p.closePath();
                    open = false;
                }

                break;
            case 18: // hstemhm
                parseStems();
                break;
            case 19: // hintmask
            case 20: // cntrmask
                parseStems();
                i += (nStems + 7) >> 3;
                break;
            case 21: // rmoveto
                if (stack.length > 2 && !haveWidth) {
                    width = stack.shift() + font.nominalWidthX;
                    haveWidth = true;
                }

                y += stack.pop();
                x += stack.pop();
                newContour(x, y);
                break;
            case 22: // hmoveto
                if (stack.length > 1 && !haveWidth) {
                    width = stack.shift() + font.nominalWidthX;
                    haveWidth = true;
                }

                x += stack.pop();
                newContour(x, y);
                break;
            case 23: // vstemhm
                parseStems();
                break;
            case 24: // rcurveline
                while (stack.length > 2) {
                    c1x = x + stack.shift();
                    c1y = y + stack.shift();
                    c2x = c1x + stack.shift();
                    c2y = c1y + stack.shift();
                    x = c2x + stack.shift();
                    y = c2y + stack.shift();
                    p.curveTo(c1x, c1y, c2x, c2y, x, y);
                }

                x += stack.shift();
                y += stack.shift();
                p.lineTo(x, y);
                break;
            case 25: // rlinecurve
                while (stack.length > 6) {
                    x += stack.shift();
                    y += stack.shift();
                    p.lineTo(x, y);
                }

                c1x = x + stack.shift();
                c1y = y + stack.shift();
                c2x = c1x + stack.shift();
                c2y = c1y + stack.shift();
                x = c2x + stack.shift();
                y = c2y + stack.shift();
                p.curveTo(c1x, c1y, c2x, c2y, x, y);
                break;
            case 26: // vvcurveto
                if (stack.length % 2) {
                    x += stack.shift();
                }

                while (stack.length > 0) {
                    c1x = x;
                    c1y = y + stack.shift();
                    c2x = c1x + stack.shift();
                    c2y = c1y + stack.shift();
                    x = c2x;
                    y = c2y + stack.shift();
                    p.curveTo(c1x, c1y, c2x, c2y, x, y);
                }

                break;
            case 27: // hhcurveto
                if (stack.length % 2) {
                    y += stack.shift();
                }

                while (stack.length > 0) {
                    c1x = x + stack.shift();
                    c1y = y;
                    c2x = c1x + stack.shift();
                    c2y = c1y + stack.shift();
                    x = c2x + stack.shift();
                    y = c2y;
                    p.curveTo(c1x, c1y, c2x, c2y, x, y);
                }

                break;
            case 28: // shortint
                b1 = code[i];
                b2 = code[i + 1];
                stack.push(((b1 << 24) | (b2 << 16)) >> 16);
                i += 2;
                break;
            case 29: // callgsubr
                codeIndex = stack.pop() + font.gsubrsBias;
                subrCode = font.gsubrs[codeIndex];
                if (subrCode) {
                    parse(subrCode);
                }

                break;
            case 30: // vhcurveto
                while (stack.length > 0) {
                    c1x = x;
                    c1y = y + stack.shift();
                    c2x = c1x + stack.shift();
                    c2y = c1y + stack.shift();
                    x = c2x + stack.shift();
                    y = c2y + (stack.length === 1 ? stack.shift() : 0);
                    p.curveTo(c1x, c1y, c2x, c2y, x, y);
                    if (stack.length === 0) {
                        break;
                    }

                    c1x = x + stack.shift();
                    c1y = y;
                    c2x = c1x + stack.shift();
                    c2y = c1y + stack.shift();
                    y = c2y + stack.shift();
                    x = c2x + (stack.length === 1 ? stack.shift() : 0);
                    p.curveTo(c1x, c1y, c2x, c2y, x, y);
                }

                break;
            case 31: // hvcurveto
                while (stack.length > 0) {
                    c1x = x + stack.shift();
                    c1y = y;
                    c2x = c1x + stack.shift();
                    c2y = c1y + stack.shift();
                    y = c2y + stack.shift();
                    x = c2x + (stack.length === 1 ? stack.shift() : 0);
                    p.curveTo(c1x, c1y, c2x, c2y, x, y);
                    if (stack.length === 0) {
                        break;
                    }

                    c1x = x;
                    c1y = y + stack.shift();
                    c2x = c1x + stack.shift();
                    c2y = c1y + stack.shift();
                    x = c2x + stack.shift();
                    y = c2y + (stack.length === 1 ? stack.shift() : 0);
                    p.curveTo(c1x, c1y, c2x, c2y, x, y);
                }

                break;
            default:
                if (v < 32) {
                    console.log('Glyph ' + glyph.index + ': unknown operator ' + v);
                } else if (v < 247) {
                    stack.push(v - 139);
                } else if (v < 251) {
                    b1 = code[i];
                    i += 1;
                    stack.push((v - 247) * 256 + b1 + 108);
                } else if (v < 255) {
                    b1 = code[i];
                    i += 1;
                    stack.push(-(v - 251) * 256 - b1 - 108);
                } else {
                    b1 = code[i];
                    b2 = code[i + 1];
                    b3 = code[i + 2];
                    b4 = code[i + 3];
                    i += 4;
                    stack.push(((b1 << 24) | (b2 << 16) | (b3 << 8) | b4) / 65536);
                }
            }
        }
    }

    parse(code);

    glyph.advanceWidth = width;
    return p;
}

// Subroutines are encoded using the negative half of the number space.
// See type 2 chapter 4.7 "Subroutine operators".
function calcCFFSubroutineBias(subrs) {
    var bias;
    if (subrs.length < 1240) {
        bias = 107;
    } else if (subrs.length < 33900) {
        bias = 1131;
    } else {
        bias = 32768;
    }

    return bias;
}

// Parse the `CFF` table, which contains the glyph outlines in PostScript format.
function parseCFFTable(data, start, font) {
    font.tables.cff = {};
    var header = parseCFFHeader(data, start);
    var nameIndex = parseCFFIndex(data, header.endOffset, parse.bytesToString);
    var topDictIndex = parseCFFIndex(data, nameIndex.endOffset);
    var stringIndex = parseCFFIndex(data, topDictIndex.endOffset, parse.bytesToString);
    var globalSubrIndex = parseCFFIndex(data, stringIndex.endOffset);
    font.gsubrs = globalSubrIndex.objects;
    font.gsubrsBias = calcCFFSubroutineBias(font.gsubrs);

    var topDictData = new DataView(new Uint8Array(topDictIndex.objects[0]).buffer);
    var topDict = parseCFFTopDict(topDictData, stringIndex.objects);
    font.tables.cff.topDict = topDict;

    var privateDictOffset = start + topDict['private'][1];
    var privateDict = parseCFFPrivateDict(data, privateDictOffset, topDict['private'][0], stringIndex.objects);
    font.defaultWidthX = privateDict.defaultWidthX;
    font.nominalWidthX = privateDict.nominalWidthX;

    if (privateDict.subrs !== 0) {
        var subrOffset = privateDictOffset + privateDict.subrs;
        var subrIndex = parseCFFIndex(data, subrOffset);
        font.subrs = subrIndex.objects;
        font.subrsBias = calcCFFSubroutineBias(font.subrs);
    } else {
        font.subrs = [];
        font.subrsBias = 0;
    }

    // Offsets in the top dict are relative to the beginning of the CFF data, so add the CFF start offset.
    var charStringsIndex = parseCFFIndex(data, start + topDict.charStrings);
    font.nGlyphs = charStringsIndex.objects.length;

    var charset = parseCFFCharset(data, start + topDict.charset, font.nGlyphs, stringIndex.objects);
    if (topDict.encoding === 0) { // Standard encoding
        font.cffEncoding = new encoding.CffEncoding(encoding.cffStandardEncoding, charset);
    } else if (topDict.encoding === 1) { // Expert encoding
        font.cffEncoding = new encoding.CffEncoding(encoding.cffExpertEncoding, charset);
    } else {
        font.cffEncoding = parseCFFEncoding(data, start + topDict.encoding, charset);
    }

    // Prefer the CMAP encoding to the CFF encoding.
    font.encoding = font.encoding || font.cffEncoding;

    font.glyphs = new glyphset.GlyphSet(font);
    for (var i = 0; i < font.nGlyphs; i += 1) {
        var charString = charStringsIndex.objects[i];
        font.glyphs.push(i, glyphset.cffGlyphLoader(font, i, parseCFFCharstring, charString));
    }
}

// Convert a string to a String ID (SID).
// The list of strings is modified in place.
function encodeString(s, strings) {
    var sid;

    // Is the string in the CFF standard strings?
    var i = encoding.cffStandardStrings.indexOf(s);
    if (i >= 0) {
        sid = i;
    }

    // Is the string already in the string index?
    i = strings.indexOf(s);
    if (i >= 0) {
        sid = i + encoding.cffStandardStrings.length;
    } else {
        sid = encoding.cffStandardStrings.length + strings.length;
        strings.push(s);
    }

    return sid;
}

function makeHeader() {
    return new table.Table('Header', [
        {name: 'major', type: 'Card8', value: 1},
        {name: 'minor', type: 'Card8', value: 0},
        {name: 'hdrSize', type: 'Card8', value: 4},
        {name: 'major', type: 'Card8', value: 1}
    ]);
}

function makeNameIndex(fontNames) {
    var t = new table.Table('Name INDEX', [
        {name: 'names', type: 'INDEX', value: []}
    ]);
    t.names = [];
    for (var i = 0; i < fontNames.length; i += 1) {
        t.names.push({name: 'name_' + i, type: 'NAME', value: fontNames[i]});
    }

    return t;
}

// Given a dictionary's metadata, create a DICT structure.
function makeDict(meta, attrs, strings) {
    var m = {};
    for (var i = 0; i < meta.length; i += 1) {
        var entry = meta[i];
        var value = attrs[entry.name];
        if (value !== undefined && !equals(value, entry.value)) {
            if (entry.type === 'SID') {
                value = encodeString(value, strings);
            }

            m[entry.op] = {name: entry.name, type: entry.type, value: value};
        }
    }

    return m;
}

// The Top DICT houses the global font attributes.
function makeTopDict(attrs, strings) {
    var t = new table.Table('Top DICT', [
        {name: 'dict', type: 'DICT', value: {}}
    ]);
    t.dict = makeDict(TOP_DICT_META, attrs, strings);
    return t;
}

function makeTopDictIndex(topDict) {
    var t = new table.Table('Top DICT INDEX', [
        {name: 'topDicts', type: 'INDEX', value: []}
    ]);
    t.topDicts = [{name: 'topDict_0', type: 'TABLE', value: topDict}];
    return t;
}

function makeStringIndex(strings) {
    var t = new table.Table('String INDEX', [
        {name: 'strings', type: 'INDEX', value: []}
    ]);
    t.strings = [];
    for (var i = 0; i < strings.length; i += 1) {
        t.strings.push({name: 'string_' + i, type: 'STRING', value: strings[i]});
    }

    return t;
}

function makeGlobalSubrIndex() {
    // Currently we don't use subroutines.
    return new table.Table('Global Subr INDEX', [
        {name: 'subrs', type: 'INDEX', value: []}
    ]);
}

function makeCharsets(glyphNames, strings) {
    var t = new table.Table('Charsets', [
        {name: 'format', type: 'Card8', value: 0}
    ]);
    for (var i = 0; i < glyphNames.length; i += 1) {
        var glyphName = glyphNames[i];
        var glyphSID = encodeString(glyphName, strings);
        t.fields.push({name: 'glyph_' + i, type: 'SID', value: glyphSID});
    }

    return t;
}

function glyphToOps(glyph) {
    var ops = [];
    var path = glyph.path;
    ops.push({name: 'width', type: 'NUMBER', value: glyph.advanceWidth});
    var x = 0;
    var y = 0;
    for (var i = 0; i < path.commands.length; i += 1) {
        var dx;
        var dy;
        var cmd = path.commands[i];
        if (cmd.type === 'Q') {
            // CFF only supports bézier curves, so convert the quad to a bézier.
            var _13 = 1 / 3;
            var _23 = 2 / 3;

            // We're going to create a new command so we don't change the original path.
            cmd = {
                type: 'C',
                x: cmd.x,
                y: cmd.y,
                x1: _13 * x + _23 * cmd.x1,
                y1: _13 * y + _23 * cmd.y1,
                x2: _13 * cmd.x + _23 * cmd.x1,
                y2: _13 * cmd.y + _23 * cmd.y1
            };
        }

        if (cmd.type === 'M') {
            dx = Math.round(cmd.x - x);
            dy = Math.round(cmd.y - y);
            ops.push({name: 'dx', type: 'NUMBER', value: dx});
            ops.push({name: 'dy', type: 'NUMBER', value: dy});
            ops.push({name: 'rmoveto', type: 'OP', value: 21});
            x = Math.round(cmd.x);
            y = Math.round(cmd.y);
        } else if (cmd.type === 'L') {
            dx = Math.round(cmd.x - x);
            dy = Math.round(cmd.y - y);
            ops.push({name: 'dx', type: 'NUMBER', value: dx});
            ops.push({name: 'dy', type: 'NUMBER', value: dy});
            ops.push({name: 'rlineto', type: 'OP', value: 5});
            x = Math.round(cmd.x);
            y = Math.round(cmd.y);
        } else if (cmd.type === 'C') {
            var dx1 = Math.round(cmd.x1 - x);
            var dy1 = Math.round(cmd.y1 - y);
            var dx2 = Math.round(cmd.x2 - cmd.x1);
            var dy2 = Math.round(cmd.y2 - cmd.y1);
            dx = Math.round(cmd.x - cmd.x2);
            dy = Math.round(cmd.y - cmd.y2);
            ops.push({name: 'dx1', type: 'NUMBER', value: dx1});
            ops.push({name: 'dy1', type: 'NUMBER', value: dy1});
            ops.push({name: 'dx2', type: 'NUMBER', value: dx2});
            ops.push({name: 'dy2', type: 'NUMBER', value: dy2});
            ops.push({name: 'dx', type: 'NUMBER', value: dx});
            ops.push({name: 'dy', type: 'NUMBER', value: dy});
            ops.push({name: 'rrcurveto', type: 'OP', value: 8});
            x = Math.round(cmd.x);
            y = Math.round(cmd.y);
        }

        // Contours are closed automatically.

    }

    ops.push({name: 'endchar', type: 'OP', value: 14});
    return ops;
}

function makeCharStringsIndex(glyphs) {
    var t = new table.Table('CharStrings INDEX', [
        {name: 'charStrings', type: 'INDEX', value: []}
    ]);

    for (var i = 0; i < glyphs.length; i += 1) {
        var glyph = glyphs.get(i);
        var ops = glyphToOps(glyph);
        t.charStrings.push({name: glyph.name, type: 'CHARSTRING', value: ops});
    }

    return t;
}

function makePrivateDict(attrs, strings) {
    var t = new table.Table('Private DICT', [
        {name: 'dict', type: 'DICT', value: {}}
    ]);
    t.dict = makeDict(PRIVATE_DICT_META, attrs, strings);
    return t;
}

function makePrivateDictIndex(privateDict) {
    var t = new table.Table('Private DICT INDEX', [
        {name: 'privateDicts', type: 'INDEX', value: []}
    ]);
    t.privateDicts = [{name: 'privateDict_0', type: 'TABLE', value: privateDict}];
    return t;
}

function makeCFFTable(glyphs, options) {
    var t = new table.Table('CFF ', [
        {name: 'header', type: 'TABLE'},
        {name: 'nameIndex', type: 'TABLE'},
        {name: 'topDictIndex', type: 'TABLE'},
        {name: 'stringIndex', type: 'TABLE'},
        {name: 'globalSubrIndex', type: 'TABLE'},
        {name: 'charsets', type: 'TABLE'},
        {name: 'charStringsIndex', type: 'TABLE'},
        {name: 'privateDictIndex', type: 'TABLE'}
    ]);

    var fontScale = 1 / options.unitsPerEm;
    // We use non-zero values for the offsets so that the DICT encodes them.
    // This is important because the size of the Top DICT plays a role in offset calculation,
    // and the size shouldn't change after we've written correct offsets.
    var attrs = {
        version: options.version,
        fullName: options.fullName,
        familyName: options.familyName,
        weight: options.weightName,
        fontMatrix: [fontScale, 0, 0, fontScale, 0, 0],
        charset: 999,
        encoding: 0,
        charStrings: 999,
        private: [0, 999]
    };

    var privateAttrs = {};

    var glyphNames = [];
    var glyph;

    // Skip first glyph (.notdef)
    for (var i = 1; i < glyphs.length; i += 1) {
        glyph = glyphs.get(i);
        glyphNames.push(glyph.name);
    }

    var strings = [];

    t.header = makeHeader();
    t.nameIndex = makeNameIndex([options.postScriptName]);
    var topDict = makeTopDict(attrs, strings);
    t.topDictIndex = makeTopDictIndex(topDict);
    t.globalSubrIndex = makeGlobalSubrIndex();
    t.charsets = makeCharsets(glyphNames, strings);
    t.charStringsIndex = makeCharStringsIndex(glyphs);
    var privateDict = makePrivateDict(privateAttrs, strings);
    t.privateDictIndex = makePrivateDictIndex(privateDict);

    // Needs to come at the end, to encode all custom strings used in the font.
    t.stringIndex = makeStringIndex(strings);

    var startOffset = t.header.sizeOf() +
        t.nameIndex.sizeOf() +
        t.topDictIndex.sizeOf() +
        t.stringIndex.sizeOf() +
        t.globalSubrIndex.sizeOf();
    attrs.charset = startOffset;

    // We use the CFF standard encoding; proper encoding will be handled in cmap.
    attrs.encoding = 0;
    attrs.charStrings = attrs.charset + t.charsets.sizeOf();
    attrs.private[1] = attrs.charStrings + t.charStringsIndex.sizeOf();

    // Recreate the Top DICT INDEX with the correct offsets.
    topDict = makeTopDict(attrs, strings);
    t.topDictIndex = makeTopDictIndex(topDict);

    return t;
}

exports.parse = parseCFFTable;
exports.make = makeCFFTable;

},{"../encoding":6,"../glyphset":9,"../parse":11,"../path":12,"../table":13}],15:[function(_dereq_,module,exports){
// The `cmap` table stores the mappings from characters to glyphs.
// https://www.microsoft.com/typography/OTSPEC/cmap.htm

'use strict';

var check = _dereq_('../check');
var parse = _dereq_('../parse');
var table = _dereq_('../table');

// Parse the `cmap` table. This table stores the mappings from characters to glyphs.
// There are many available formats, but we only support the Windows format 4.
// This function returns a `CmapEncoding` object or null if no supported format could be found.
function parseCmapTable(data, start) {
    var i;
    var cmap = {};
    cmap.version = parse.getUShort(data, start);
    check.argument(cmap.version === 0, 'cmap table version should be 0.');

    // The cmap table can contain many sub-tables, each with their own format.
    // We're only interested in a "platform 3" table. This is a Windows format.
    cmap.numTables = parse.getUShort(data, start + 2);
    var offset = -1;
    for (i = 0; i < cmap.numTables; i += 1) {
        var platformId = parse.getUShort(data, start + 4 + (i * 8));
        var encodingId = parse.getUShort(data, start + 4 + (i * 8) + 2);
        if (platformId === 3 && (encodingId === 1 || encodingId === 0)) {
            offset = parse.getULong(data, start + 4 + (i * 8) + 4);
            break;
        }
    }

    if (offset === -1) {
        // There is no cmap table in the font that we support, so return null.
        // This font will be marked as unsupported.
        return null;
    }

    var p = new parse.Parser(data, start + offset);
    cmap.format = p.parseUShort();
    check.argument(cmap.format === 4, 'Only format 4 cmap tables are supported.');

    // Length in bytes of the sub-tables.
    cmap.length = p.parseUShort();
    cmap.language = p.parseUShort();

    // segCount is stored x 2.
    var segCount;
    cmap.segCount = segCount = p.parseUShort() >> 1;

    // Skip searchRange, entrySelector, rangeShift.
    p.skip('uShort', 3);

    // The "unrolled" mapping from character codes to glyph indices.
    cmap.glyphIndexMap = {};

    var endCountParser = new parse.Parser(data, start + offset + 14);
    var startCountParser = new parse.Parser(data, start + offset + 16 + segCount * 2);
    var idDeltaParser = new parse.Parser(data, start + offset + 16 + segCount * 4);
    var idRangeOffsetParser = new parse.Parser(data, start + offset + 16 + segCount * 6);
    var glyphIndexOffset = start + offset + 16 + segCount * 8;
    for (i = 0; i < segCount - 1; i += 1) {
        var glyphIndex;
        var endCount = endCountParser.parseUShort();
        var startCount = startCountParser.parseUShort();
        var idDelta = idDeltaParser.parseShort();
        var idRangeOffset = idRangeOffsetParser.parseUShort();
        for (var c = startCount; c <= endCount; c += 1) {
            if (idRangeOffset !== 0) {
                // The idRangeOffset is relative to the current position in the idRangeOffset array.
                // Take the current offset in the idRangeOffset array.
                glyphIndexOffset = (idRangeOffsetParser.offset + idRangeOffsetParser.relativeOffset - 2);

                // Add the value of the idRangeOffset, which will move us into the glyphIndex array.
                glyphIndexOffset += idRangeOffset;

                // Then add the character index of the current segment, multiplied by 2 for USHORTs.
                glyphIndexOffset += (c - startCount) * 2;
                glyphIndex = parse.getUShort(data, glyphIndexOffset);
                if (glyphIndex !== 0) {
                    glyphIndex = (glyphIndex + idDelta) & 0xFFFF;
                }
            } else {
                glyphIndex = (c + idDelta) & 0xFFFF;
            }

            cmap.glyphIndexMap[c] = glyphIndex;
        }
    }

    return cmap;
}

function addSegment(t, code, glyphIndex) {
    t.segments.push({
        end: code,
        start: code,
        delta: -(code - glyphIndex),
        offset: 0
    });
}

function addTerminatorSegment(t) {
    t.segments.push({
        end: 0xFFFF,
        start: 0xFFFF,
        delta: 1,
        offset: 0
    });
}

function makeCmapTable(glyphs) {
    var i;
    var t = new table.Table('cmap', [
        {name: 'version', type: 'USHORT', value: 0},
        {name: 'numTables', type: 'USHORT', value: 1},
        {name: 'platformID', type: 'USHORT', value: 3},
        {name: 'encodingID', type: 'USHORT', value: 1},
        {name: 'offset', type: 'ULONG', value: 12},
        {name: 'format', type: 'USHORT', value: 4},
        {name: 'length', type: 'USHORT', value: 0},
        {name: 'language', type: 'USHORT', value: 0},
        {name: 'segCountX2', type: 'USHORT', value: 0},
        {name: 'searchRange', type: 'USHORT', value: 0},
        {name: 'entrySelector', type: 'USHORT', value: 0},
        {name: 'rangeShift', type: 'USHORT', value: 0}
    ]);

    t.segments = [];
    for (i = 0; i < glyphs.length; i += 1) {
        var glyph = glyphs.get(i);
        for (var j = 0; j < glyph.unicodes.length; j += 1) {
            addSegment(t, glyph.unicodes[j], i);
        }

        t.segments = t.segments.sort(function(a, b) {
            return a.start - b.start;
        });
    }

    addTerminatorSegment(t);

    var segCount;
    segCount = t.segments.length;
    t.segCountX2 = segCount * 2;
    t.searchRange = Math.pow(2, Math.floor(Math.log(segCount) / Math.log(2))) * 2;
    t.entrySelector = Math.log(t.searchRange / 2) / Math.log(2);
    t.rangeShift = t.segCountX2 - t.searchRange;

    // Set up parallel segment arrays.
    var endCounts = [];
    var startCounts = [];
    var idDeltas = [];
    var idRangeOffsets = [];
    var glyphIds = [];

    for (i = 0; i < segCount; i += 1) {
        var segment = t.segments[i];
        endCounts = endCounts.concat({name: 'end_' + i, type: 'USHORT', value: segment.end});
        startCounts = startCounts.concat({name: 'start_' + i, type: 'USHORT', value: segment.start});
        idDeltas = idDeltas.concat({name: 'idDelta_' + i, type: 'SHORT', value: segment.delta});
        idRangeOffsets = idRangeOffsets.concat({name: 'idRangeOffset_' + i, type: 'USHORT', value: segment.offset});
        if (segment.glyphId !== undefined) {
            glyphIds = glyphIds.concat({name: 'glyph_' + i, type: 'USHORT', value: segment.glyphId});
        }
    }

    t.fields = t.fields.concat(endCounts);
    t.fields.push({name: 'reservedPad', type: 'USHORT', value: 0});
    t.fields = t.fields.concat(startCounts);
    t.fields = t.fields.concat(idDeltas);
    t.fields = t.fields.concat(idRangeOffsets);
    t.fields = t.fields.concat(glyphIds);

    t.length = 14 + // Subtable header
        endCounts.length * 2 +
        2 + // reservedPad
        startCounts.length * 2 +
        idDeltas.length * 2 +
        idRangeOffsets.length * 2 +
        glyphIds.length * 2;

    return t;
}

exports.parse = parseCmapTable;
exports.make = makeCmapTable;

},{"../check":4,"../parse":11,"../table":13}],16:[function(_dereq_,module,exports){
// The `fvar` table stores font variation axes and instances.
// https://developer.apple.com/fonts/TrueType-Reference-Manual/RM06/Chap6fvar.html

'use strict';

var check = _dereq_('../check');
var parse = _dereq_('../parse');
var table = _dereq_('../table');

function addName(name, names) {
    var nameString = JSON.stringify(name);
    var nameID = 256;
    for (var nameKey in names) {
        var n = parseInt(nameKey);
        if (!n || n < 256) {
            continue;
        }

        if (JSON.stringify(names[nameKey]) === nameString) {
            return n;
        }

        if (nameID <= n) {
            nameID = n + 1;
        }
    }

    names[nameID] = name;
    return nameID;
}

function makeFvarAxis(axis, names) {
    var nameID = addName(axis.name, names);
    return new table.Table('fvarAxis', [
        {name: 'tag', type: 'TAG', value: axis.tag},
        {name: 'minValue', type: 'FIXED', value: axis.minValue << 16},
        {name: 'defaultValue', type: 'FIXED', value: axis.defaultValue << 16},
        {name: 'maxValue', type: 'FIXED', value: axis.maxValue << 16},
        {name: 'flags', type: 'USHORT', value: 0},
        {name: 'nameID', type: 'USHORT', value: nameID}
    ]);
}

function parseFvarAxis(data, start, names) {
    var axis = {};
    var p = new parse.Parser(data, start);
    axis.tag = p.parseTag();
    axis.minValue = p.parseFixed();
    axis.defaultValue = p.parseFixed();
    axis.maxValue = p.parseFixed();
    p.skip('uShort', 1);  // reserved for flags; no values defined
    axis.name = names[p.parseUShort()] || {};
    return axis;
}

function makeFvarInstance(inst, axes, names) {
    var nameID = addName(inst.name, names);
    var fields = [
        {name: 'nameID', type: 'USHORT', value: nameID},
        {name: 'flags', type: 'USHORT', value: 0}
    ];

    for (var i = 0; i < axes.length; ++i) {
        var axisTag = axes[i].tag;
        fields.push({
            name: 'axis ' + axisTag,
            type: 'FIXED',
            value: inst.coordinates[axisTag] << 16
        });
    }

    return new table.Table('fvarInstance', fields);
}

function parseFvarInstance(data, start, axes, names) {
    var inst = {};
    var p = new parse.Parser(data, start);
    inst.name = names[p.parseUShort()] || {};
    p.skip('uShort', 1);  // reserved for flags; no values defined

    inst.coordinates = {};
    for (var i = 0; i < axes.length; ++i) {
        inst.coordinates[axes[i].tag] = p.parseFixed();
    }

    return inst;
}

function makeFvarTable(fvar, names) {
    var result = new table.Table('fvar', [
        {name: 'version', type: 'ULONG', value: 0x10000},
        {name: 'offsetToData', type: 'USHORT', value: 0},
        {name: 'countSizePairs', type: 'USHORT', value: 2},
        {name: 'axisCount', type: 'USHORT', value: fvar.axes.length},
        {name: 'axisSize', type: 'USHORT', value: 20},
        {name: 'instanceCount', type: 'USHORT', value: fvar.instances.length},
        {name: 'instanceSize', type: 'USHORT', value: 4 + fvar.axes.length * 4}
    ]);
    result.offsetToData = result.sizeOf();

    for (var i = 0; i < fvar.axes.length; i++) {
        result.fields.push({
            name: 'axis ' + i,
            type: 'TABLE',
            value: makeFvarAxis(fvar.axes[i], names)});
    }

    for (var j = 0; j < fvar.instances.length; j++) {
        result.fields.push({
            name: 'instance ' + j,
            type: 'TABLE',
            value: makeFvarInstance(fvar.instances[j], fvar.axes, names)
        });
    }

    return result;
}

function parseFvarTable(data, start, names) {
    var p = new parse.Parser(data, start);
    var tableVersion = p.parseULong();
    check.argument(tableVersion === 0x00010000, 'Unsupported fvar table version.');
    var offsetToData = p.parseOffset16();
    // Skip countSizePairs.
    p.skip('uShort', 1);
    var axisCount = p.parseUShort();
    var axisSize = p.parseUShort();
    var instanceCount = p.parseUShort();
    var instanceSize = p.parseUShort();

    var axes = [];
    for (var i = 0; i < axisCount; i++) {
        axes.push(parseFvarAxis(data, start + offsetToData + i * axisSize, names));
    }

    var instances = [];
    var instanceStart = start + offsetToData + axisCount * axisSize;
    for (var j = 0; j < instanceCount; j++) {
        instances.push(parseFvarInstance(data, instanceStart + j * instanceSize, axes, names));
    }

    return {axes:axes, instances:instances};
}

exports.make = makeFvarTable;
exports.parse = parseFvarTable;

},{"../check":4,"../parse":11,"../table":13}],17:[function(_dereq_,module,exports){
// The `glyf` table describes the glyphs in TrueType outline format.
// http://www.microsoft.com/typography/otspec/glyf.htm

'use strict';

var check = _dereq_('../check');
var glyphset = _dereq_('../glyphset');
var parse = _dereq_('../parse');
var path = _dereq_('../path');

// Parse the coordinate data for a glyph.
function parseGlyphCoordinate(p, flag, previousValue, shortVectorBitMask, sameBitMask) {
    var v;
    if ((flag & shortVectorBitMask) > 0) {
        // The coordinate is 1 byte long.
        v = p.parseByte();
        // The `same` bit is re-used for short values to signify the sign of the value.
        if ((flag & sameBitMask) === 0) {
            v = -v;
        }

        v = previousValue + v;
    } else {
        //  The coordinate is 2 bytes long.
        // If the `same` bit is set, the coordinate is the same as the previous coordinate.
        if ((flag & sameBitMask) > 0) {
            v = previousValue;
        } else {
            // Parse the coordinate as a signed 16-bit delta value.
            v = previousValue + p.parseShort();
        }
    }

    return v;
}

// Parse a TrueType glyph.
function parseGlyph(glyph, data, start) {
    var p = new parse.Parser(data, start);
    glyph.numberOfContours = p.parseShort();
    glyph.xMin = p.parseShort();
    glyph.yMin = p.parseShort();
    glyph.xMax = p.parseShort();
    glyph.yMax = p.parseShort();
    var flags;
    var flag;
    if (glyph.numberOfContours > 0) {
        var i;
        // This glyph is not a composite.
        var endPointIndices = glyph.endPointIndices = [];
        for (i = 0; i < glyph.numberOfContours; i += 1) {
            endPointIndices.push(p.parseUShort());
        }

        glyph.instructionLength = p.parseUShort();
        glyph.instructions = [];
        for (i = 0; i < glyph.instructionLength; i += 1) {
            glyph.instructions.push(p.parseByte());
        }

        var numberOfCoordinates = endPointIndices[endPointIndices.length - 1] + 1;
        flags = [];
        for (i = 0; i < numberOfCoordinates; i += 1) {
            flag = p.parseByte();
            flags.push(flag);
            // If bit 3 is set, we repeat this flag n times, where n is the next byte.
            if ((flag & 8) > 0) {
                var repeatCount = p.parseByte();
                for (var j = 0; j < repeatCount; j += 1) {
                    flags.push(flag);
                    i += 1;
                }
            }
        }

        check.argument(flags.length === numberOfCoordinates, 'Bad flags.');

        if (endPointIndices.length > 0) {
            var points = [];
            var point;
            // X/Y coordinates are relative to the previous point, except for the first point which is relative to 0,0.
            if (numberOfCoordinates > 0) {
                for (i = 0; i < numberOfCoordinates; i += 1) {
                    flag = flags[i];
                    point = {};
                    point.onCurve = !!(flag & 1);
                    point.lastPointOfContour = endPointIndices.indexOf(i) >= 0;
                    points.push(point);
                }

                var px = 0;
                for (i = 0; i < numberOfCoordinates; i += 1) {
                    flag = flags[i];
                    point = points[i];
                    point.x = parseGlyphCoordinate(p, flag, px, 2, 16);
                    px = point.x;
                }

                var py = 0;
                for (i = 0; i < numberOfCoordinates; i += 1) {
                    flag = flags[i];
                    point = points[i];
                    point.y = parseGlyphCoordinate(p, flag, py, 4, 32);
                    py = point.y;
                }
            }

            glyph.points = points;
        } else {
            glyph.points = [];
        }
    } else if (glyph.numberOfContours === 0) {
        glyph.points = [];
    } else {
        glyph.isComposite = true;
        glyph.points = [];
        glyph.components = [];
        var moreComponents = true;
        while (moreComponents) {
            flags = p.parseUShort();
            var component = {
                glyphIndex: p.parseUShort(),
                xScale: 1,
                scale01: 0,
                scale10: 0,
                yScale: 1,
                dx: 0,
                dy: 0
            };
            if ((flags & 1) > 0) {
                // The arguments are words
                component.dx = p.parseShort();
                component.dy = p.parseShort();
            } else {
                // The arguments are bytes
                component.dx = p.parseChar();
                component.dy = p.parseChar();
            }

            if ((flags & 8) > 0) {
                // We have a scale
                component.xScale = component.yScale = p.parseF2Dot14();
            } else if ((flags & 64) > 0) {
                // We have an X / Y scale
                component.xScale = p.parseF2Dot14();
                component.yScale = p.parseF2Dot14();
            } else if ((flags & 128) > 0) {
                // We have a 2x2 transformation
                component.xScale = p.parseF2Dot14();
                component.scale01 = p.parseF2Dot14();
                component.scale10 = p.parseF2Dot14();
                component.yScale = p.parseF2Dot14();
            }

            glyph.components.push(component);
            moreComponents = !!(flags & 32);
        }
    }
}

// Transform an array of points and return a new array.
function transformPoints(points, transform) {
    var newPoints = [];
    for (var i = 0; i < points.length; i += 1) {
        var pt = points[i];
        var newPt = {
            x: transform.xScale * pt.x + transform.scale01 * pt.y + transform.dx,
            y: transform.scale10 * pt.x + transform.yScale * pt.y + transform.dy,
            onCurve: pt.onCurve,
            lastPointOfContour: pt.lastPointOfContour
        };
        newPoints.push(newPt);
    }

    return newPoints;
}

function getContours(points) {
    var contours = [];
    var currentContour = [];
    for (var i = 0; i < points.length; i += 1) {
        var pt = points[i];
        currentContour.push(pt);
        if (pt.lastPointOfContour) {
            contours.push(currentContour);
            currentContour = [];
        }
    }

    check.argument(currentContour.length === 0, 'There are still points left in the current contour.');
    return contours;
}

// Convert the TrueType glyph outline to a Path.
function getPath(points) {
    var p = new path.Path();
    if (!points) {
        return p;
    }

    var contours = getContours(points);
    for (var i = 0; i < contours.length; i += 1) {
        var contour = contours[i];
        var firstPt = contour[0];
        var lastPt = contour[contour.length - 1];
        var curvePt;
        var realFirstPoint;
        if (firstPt.onCurve) {
            curvePt = null;
            // The first point will be consumed by the moveTo command,
            // so skip it in the loop.
            realFirstPoint = true;
        } else {
            if (lastPt.onCurve) {
                // If the first point is off-curve and the last point is on-curve,
                // start at the last point.
                firstPt = lastPt;
            } else {
                // If both first and last points are off-curve, start at their middle.
                firstPt = { x: (firstPt.x + lastPt.x) / 2, y: (firstPt.y + lastPt.y) / 2 };
            }

            curvePt = firstPt;
            // The first point is synthesized, so don't skip the real first point.
            realFirstPoint = false;
        }

        p.moveTo(firstPt.x, firstPt.y);

        for (var j = realFirstPoint ? 1 : 0; j < contour.length; j += 1) {
            var pt = contour[j];
            var prevPt = j === 0 ? firstPt : contour[j - 1];
            if (prevPt.onCurve && pt.onCurve) {
                // This is a straight line.
                p.lineTo(pt.x, pt.y);
            } else if (prevPt.onCurve && !pt.onCurve) {
                curvePt = pt;
            } else if (!prevPt.onCurve && !pt.onCurve) {
                var midPt = { x: (prevPt.x + pt.x) / 2, y: (prevPt.y + pt.y) / 2 };
                p.quadraticCurveTo(prevPt.x, prevPt.y, midPt.x, midPt.y);
                curvePt = pt;
            } else if (!prevPt.onCurve && pt.onCurve) {
                // Previous point off-curve, this point on-curve.
                p.quadraticCurveTo(curvePt.x, curvePt.y, pt.x, pt.y);
                curvePt = null;
            } else {
                throw new Error('Invalid state.');
            }
        }

        if (firstPt !== lastPt) {
            // Connect the last and first points
            if (curvePt) {
                p.quadraticCurveTo(curvePt.x, curvePt.y, firstPt.x, firstPt.y);
            } else {
                p.lineTo(firstPt.x, firstPt.y);
            }
        }
    }

    p.closePath();
    return p;
}

function buildPath(glyphs, glyph) {
    if (glyph.isComposite) {
        for (var j = 0; j < glyph.components.length; j += 1) {
            var component = glyph.components[j];
            var componentGlyph = glyphs.get(component.glyphIndex);
            // Force the ttfGlyphLoader to parse the glyph.
            componentGlyph.getPath();
            if (componentGlyph.points) {
                var transformedPoints = transformPoints(componentGlyph.points, component);
                glyph.points = glyph.points.concat(transformedPoints);
            }
        }
    }

    return getPath(glyph.points);
}

// Parse all the glyphs according to the offsets from the `loca` table.
function parseGlyfTable(data, start, loca, font) {
    var glyphs = new glyphset.GlyphSet(font);
    var i;

    // The last element of the loca table is invalid.
    for (i = 0; i < loca.length - 1; i += 1) {
        var offset = loca[i];
        var nextOffset = loca[i + 1];
        if (offset !== nextOffset) {
            glyphs.push(i, glyphset.ttfGlyphLoader(font, i, parseGlyph, data, start + offset, buildPath));
        } else {
            glyphs.push(i, glyphset.glyphLoader(font, i));
        }
    }

    return glyphs;
}

exports.parse = parseGlyfTable;

},{"../check":4,"../glyphset":9,"../parse":11,"../path":12}],18:[function(_dereq_,module,exports){
// The `GPOS` table contains kerning pairs, among other things.
// https://www.microsoft.com/typography/OTSPEC/gpos.htm

'use strict';

var check = _dereq_('../check');
var parse = _dereq_('../parse');

// Parse ScriptList and FeatureList tables of GPOS, GSUB, GDEF, BASE, JSTF tables.
// These lists are unused by now, this function is just the basis for a real parsing.
function parseTaggedListTable(data, start) {
    var p = new parse.Parser(data, start);
    var n = p.parseUShort();
    var list = [];
    for (var i = 0; i < n; i++) {
        list[p.parseTag()] = { offset: p.parseUShort() };
    }

    return list;
}

// Parse a coverage table in a GSUB, GPOS or GDEF table.
// Format 1 is a simple list of glyph ids,
// Format 2 is a list of ranges. It is expanded in a list of glyphs, maybe not the best idea.
function parseCoverageTable(data, start) {
    var p = new parse.Parser(data, start);
    var format = p.parseUShort();
    var count =  p.parseUShort();
    if (format === 1) {
        return p.parseUShortList(count);
    }
    else if (format === 2) {
        var coverage = [];
        for (; count--;) {
            var begin = p.parseUShort();
            var end = p.parseUShort();
            var index = p.parseUShort();
            for (var i = begin; i <= end; i++) {
                coverage[index++] = i;
            }
        }

        return coverage;
    }
}

// Parse a Class Definition Table in a GSUB, GPOS or GDEF table.
// Returns a function that gets a class value from a glyph ID.
function parseClassDefTable(data, start) {
    var p = new parse.Parser(data, start);
    var format = p.parseUShort();
    if (format === 1) {
        // Format 1 specifies a range of consecutive glyph indices, one class per glyph ID.
        var startGlyph = p.parseUShort();
        var glyphCount = p.parseUShort();
        var classes = p.parseUShortList(glyphCount);
        return function(glyphID) {
            return classes[glyphID - startGlyph] || 0;
        };
    }
    else if (format === 2) {
        // Format 2 defines multiple groups of glyph indices that belong to the same class.
        var rangeCount = p.parseUShort();
        var startGlyphs = [];
        var endGlyphs = [];
        var classValues = [];
        for (var i = 0; i < rangeCount; i++) {
            startGlyphs[i] = p.parseUShort();
            endGlyphs[i] = p.parseUShort();
            classValues[i] = p.parseUShort();
        }

        return function(glyphID) {
            var l = 0;
            var r = startGlyphs.length - 1;
            while (l < r) {
                var c = (l + r + 1) >> 1;
                if (glyphID < startGlyphs[c]) {
                    r = c - 1;
                } else {
                    l = c;
                }
            }

            if (startGlyphs[l] <= glyphID && glyphID <= endGlyphs[l]) {
                return classValues[l] || 0;
            }

            return 0;
        };
    }
}

// Parse a pair adjustment positioning subtable, format 1 or format 2
// The subtable is returned in the form of a lookup function.
function parsePairPosSubTable(data, start) {
    var p = new parse.Parser(data, start);
    // This part is common to format 1 and format 2 subtables
    var format = p.parseUShort();
    var coverageOffset = p.parseUShort();
    var coverage = parseCoverageTable(data, start + coverageOffset);
    // valueFormat 4: XAdvance only, 1: XPlacement only, 0: no ValueRecord for second glyph
    // Only valueFormat1=4 and valueFormat2=0 is supported.
    var valueFormat1 = p.parseUShort();
    var valueFormat2 = p.parseUShort();
    var value1;
    var value2;
    if (valueFormat1 !== 4 || valueFormat2 !== 0) return;
    var sharedPairSets = {};
    if (format === 1) {
        // Pair Positioning Adjustment: Format 1
        var pairSetCount = p.parseUShort();
        var pairSet = [];
        // Array of offsets to PairSet tables-from beginning of PairPos subtable-ordered by Coverage Index
        var pairSetOffsets = p.parseOffset16List(pairSetCount);
        for (var firstGlyph = 0; firstGlyph < pairSetCount; firstGlyph++) {
            var pairSetOffset = pairSetOffsets[firstGlyph];
            var sharedPairSet = sharedPairSets[pairSetOffset];
            if (!sharedPairSet) {
                // Parse a pairset table in a pair adjustment subtable format 1
                sharedPairSet = {};
                p.relativeOffset = pairSetOffset;
                var pairValueCount = p.parseUShort();
                for (; pairValueCount--;) {
                    var secondGlyph = p.parseUShort();
                    if (valueFormat1) value1 = p.parseShort();
                    if (valueFormat2) value2 = p.parseShort();
                    // We only support valueFormat1 = 4 and valueFormat2 = 0,
                    // so value1 is the XAdvance and value2 is empty.
                    sharedPairSet[secondGlyph] = value1;
                }
            }

            pairSet[coverage[firstGlyph]] = sharedPairSet;
        }

        return function(leftGlyph, rightGlyph) {
            var pairs = pairSet[leftGlyph];
            if (pairs) return pairs[rightGlyph];
        };
    }
    else if (format === 2) {
        // Pair Positioning Adjustment: Format 2
        var classDef1Offset = p.parseUShort();
        var classDef2Offset = p.parseUShort();
        var class1Count = p.parseUShort();
        var class2Count = p.parseUShort();
        var getClass1 = parseClassDefTable(data, start + classDef1Offset);
        var getClass2 = parseClassDefTable(data, start + classDef2Offset);

        // Parse kerning values by class pair.
        var kerningMatrix = [];
        for (var i = 0; i < class1Count; i++) {
            var kerningRow = kerningMatrix[i] = [];
            for (var j = 0; j < class2Count; j++) {
                if (valueFormat1) value1 = p.parseShort();
                if (valueFormat2) value2 = p.parseShort();
                // We only support valueFormat1 = 4 and valueFormat2 = 0,
                // so value1 is the XAdvance and value2 is empty.
                kerningRow[j] = value1;
            }
        }

        // Convert coverage list to a hash
        var covered = {};
        for (i = 0; i < coverage.length; i++) covered[coverage[i]] = 1;

        // Get the kerning value for a specific glyph pair.
        return function(leftGlyph, rightGlyph) {
            if (!covered[leftGlyph]) return;
            var class1 = getClass1(leftGlyph);
            var class2 = getClass2(rightGlyph);
            var kerningRow = kerningMatrix[class1];

            if (kerningRow) {
                return kerningRow[class2];
            }
        };
    }
}

// Parse a LookupTable (present in of GPOS, GSUB, GDEF, BASE, JSTF tables).
function parseLookupTable(data, start) {
    var p = new parse.Parser(data, start);
    var lookupType = p.parseUShort();
    var lookupFlag = p.parseUShort();
    var useMarkFilteringSet = lookupFlag & 0x10;
    var subTableCount = p.parseUShort();
    var subTableOffsets = p.parseOffset16List(subTableCount);
    var table = {
        lookupType: lookupType,
        lookupFlag: lookupFlag,
        markFilteringSet: useMarkFilteringSet ? p.parseUShort() : -1
    };
    // LookupType 2, Pair adjustment
    if (lookupType === 2) {
        var subtables = [];
        for (var i = 0; i < subTableCount; i++) {
            subtables.push(parsePairPosSubTable(data, start + subTableOffsets[i]));
        }
        // Return a function which finds the kerning values in the subtables.
        table.getKerningValue = function(leftGlyph, rightGlyph) {
            for (var i = subtables.length; i--;) {
                var value = subtables[i](leftGlyph, rightGlyph);
                if (value !== undefined) return value;
            }

            return 0;
        };
    }

    return table;
}

// Parse the `GPOS` table which contains, among other things, kerning pairs.
// https://www.microsoft.com/typography/OTSPEC/gpos.htm
function parseGposTable(data, start, font) {
    var p = new parse.Parser(data, start);
    var tableVersion = p.parseFixed();
    check.argument(tableVersion === 1, 'Unsupported GPOS table version.');

    // ScriptList and FeatureList - ignored for now
    parseTaggedListTable(data, start + p.parseUShort());
    // 'kern' is the feature we are looking for.
    parseTaggedListTable(data, start + p.parseUShort());

    // LookupList
    var lookupListOffset = p.parseUShort();
    p.relativeOffset = lookupListOffset;
    var lookupCount = p.parseUShort();
    var lookupTableOffsets = p.parseOffset16List(lookupCount);
    var lookupListAbsoluteOffset = start + lookupListOffset;
    for (var i = 0; i < lookupCount; i++) {
        var table = parseLookupTable(data, lookupListAbsoluteOffset + lookupTableOffsets[i]);
        if (table.lookupType === 2 && !font.getGposKerningValue) font.getGposKerningValue = table.getKerningValue;
    }
}

exports.parse = parseGposTable;

},{"../check":4,"../parse":11}],19:[function(_dereq_,module,exports){
// The `head` table contains global information about the font.
// https://www.microsoft.com/typography/OTSPEC/head.htm

'use strict';

var check = _dereq_('../check');
var parse = _dereq_('../parse');
var table = _dereq_('../table');

// Parse the header `head` table
function parseHeadTable(data, start) {
    var head = {};
    var p = new parse.Parser(data, start);
    head.version = p.parseVersion();
    head.fontRevision = Math.round(p.parseFixed() * 1000) / 1000;
    head.checkSumAdjustment = p.parseULong();
    head.magicNumber = p.parseULong();
    check.argument(head.magicNumber === 0x5F0F3CF5, 'Font header has wrong magic number.');
    head.flags = p.parseUShort();
    head.unitsPerEm = p.parseUShort();
    head.created = p.parseLongDateTime();
    head.modified = p.parseLongDateTime();
    head.xMin = p.parseShort();
    head.yMin = p.parseShort();
    head.xMax = p.parseShort();
    head.yMax = p.parseShort();
    head.macStyle = p.parseUShort();
    head.lowestRecPPEM = p.parseUShort();
    head.fontDirectionHint = p.parseShort();
    head.indexToLocFormat = p.parseShort();     // 50
    head.glyphDataFormat = p.parseShort();
    return head;
}

function makeHeadTable(options) {
    return new table.Table('head', [
        {name: 'version', type: 'FIXED', value: 0x00010000},
        {name: 'fontRevision', type: 'FIXED', value: 0x00010000},
        {name: 'checkSumAdjustment', type: 'ULONG', value: 0},
        {name: 'magicNumber', type: 'ULONG', value: 0x5F0F3CF5},
        {name: 'flags', type: 'USHORT', value: 0},
        {name: 'unitsPerEm', type: 'USHORT', value: 1000},
        {name: 'created', type: 'LONGDATETIME', value: 0},
        {name: 'modified', type: 'LONGDATETIME', value: 0},
        {name: 'xMin', type: 'SHORT', value: 0},
        {name: 'yMin', type: 'SHORT', value: 0},
        {name: 'xMax', type: 'SHORT', value: 0},
        {name: 'yMax', type: 'SHORT', value: 0},
        {name: 'macStyle', type: 'USHORT', value: 0},
        {name: 'lowestRecPPEM', type: 'USHORT', value: 0},
        {name: 'fontDirectionHint', type: 'SHORT', value: 2},
        {name: 'indexToLocFormat', type: 'SHORT', value: 0},
        {name: 'glyphDataFormat', type: 'SHORT', value: 0}
    ], options);
}

exports.parse = parseHeadTable;
exports.make = makeHeadTable;

},{"../check":4,"../parse":11,"../table":13}],20:[function(_dereq_,module,exports){
// The `hhea` table contains information for horizontal layout.
// https://www.microsoft.com/typography/OTSPEC/hhea.htm

'use strict';

var parse = _dereq_('../parse');
var table = _dereq_('../table');

// Parse the horizontal header `hhea` table
function parseHheaTable(data, start) {
    var hhea = {};
    var p = new parse.Parser(data, start);
    hhea.version = p.parseVersion();
    hhea.ascender = p.parseShort();
    hhea.descender = p.parseShort();
    hhea.lineGap = p.parseShort();
    hhea.advanceWidthMax = p.parseUShort();
    hhea.minLeftSideBearing = p.parseShort();
    hhea.minRightSideBearing = p.parseShort();
    hhea.xMaxExtent = p.parseShort();
    hhea.caretSlopeRise = p.parseShort();
    hhea.caretSlopeRun = p.parseShort();
    hhea.caretOffset = p.parseShort();
    p.relativeOffset += 8;
    hhea.metricDataFormat = p.parseShort();
    hhea.numberOfHMetrics = p.parseUShort();
    return hhea;
}

function makeHheaTable(options) {
    return new table.Table('hhea', [
        {name: 'version', type: 'FIXED', value: 0x00010000},
        {name: 'ascender', type: 'FWORD', value: 0},
        {name: 'descender', type: 'FWORD', value: 0},
        {name: 'lineGap', type: 'FWORD', value: 0},
        {name: 'advanceWidthMax', type: 'UFWORD', value: 0},
        {name: 'minLeftSideBearing', type: 'FWORD', value: 0},
        {name: 'minRightSideBearing', type: 'FWORD', value: 0},
        {name: 'xMaxExtent', type: 'FWORD', value: 0},
        {name: 'caretSlopeRise', type: 'SHORT', value: 1},
        {name: 'caretSlopeRun', type: 'SHORT', value: 0},
        {name: 'caretOffset', type: 'SHORT', value: 0},
        {name: 'reserved1', type: 'SHORT', value: 0},
        {name: 'reserved2', type: 'SHORT', value: 0},
        {name: 'reserved3', type: 'SHORT', value: 0},
        {name: 'reserved4', type: 'SHORT', value: 0},
        {name: 'metricDataFormat', type: 'SHORT', value: 0},
        {name: 'numberOfHMetrics', type: 'USHORT', value: 0}
    ], options);
}

exports.parse = parseHheaTable;
exports.make = makeHheaTable;

},{"../parse":11,"../table":13}],21:[function(_dereq_,module,exports){
// The `hmtx` table contains the horizontal metrics for all glyphs.
// https://www.microsoft.com/typography/OTSPEC/hmtx.htm

'use strict';

var parse = _dereq_('../parse');
var table = _dereq_('../table');

// Parse the `hmtx` table, which contains the horizontal metrics for all glyphs.
// This function augments the glyph array, adding the advanceWidth and leftSideBearing to each glyph.
function parseHmtxTable(data, start, numMetrics, numGlyphs, glyphs) {
    var advanceWidth;
    var leftSideBearing;
    var p = new parse.Parser(data, start);
    for (var i = 0; i < numGlyphs; i += 1) {
        // If the font is monospaced, only one entry is needed. This last entry applies to all subsequent glyphs.
        if (i < numMetrics) {
            advanceWidth = p.parseUShort();
            leftSideBearing = p.parseShort();
        }

        var glyph = glyphs.get(i);
        glyph.advanceWidth = advanceWidth;
        glyph.leftSideBearing = leftSideBearing;
    }
}

function makeHmtxTable(glyphs) {
    var t = new table.Table('hmtx', []);
    for (var i = 0; i < glyphs.length; i += 1) {
        var glyph = glyphs.get(i);
        var advanceWidth = glyph.advanceWidth || 0;
        var leftSideBearing = glyph.leftSideBearing || 0;
        t.fields.push({name: 'advanceWidth_' + i, type: 'USHORT', value: advanceWidth});
        t.fields.push({name: 'leftSideBearing_' + i, type: 'SHORT', value: leftSideBearing});
    }

    return t;
}

exports.parse = parseHmtxTable;
exports.make = makeHmtxTable;

},{"../parse":11,"../table":13}],22:[function(_dereq_,module,exports){
// The `kern` table contains kerning pairs.
// Note that some fonts use the GPOS OpenType layout table to specify kerning.
// https://www.microsoft.com/typography/OTSPEC/kern.htm

'use strict';

var check = _dereq_('../check');
var parse = _dereq_('../parse');

// Parse the `kern` table which contains kerning pairs.
function parseKernTable(data, start) {
    var pairs = {};
    var p = new parse.Parser(data, start);
    var tableVersion = p.parseUShort();
    check.argument(tableVersion === 0, 'Unsupported kern table version.');
    // Skip nTables.
    p.skip('uShort', 1);
    var subTableVersion = p.parseUShort();
    check.argument(subTableVersion === 0, 'Unsupported kern sub-table version.');
    // Skip subTableLength, subTableCoverage
    p.skip('uShort', 2);
    var nPairs = p.parseUShort();
    // Skip searchRange, entrySelector, rangeShift.
    p.skip('uShort', 3);
    for (var i = 0; i < nPairs; i += 1) {
        var leftIndex = p.parseUShort();
        var rightIndex = p.parseUShort();
        var value = p.parseShort();
        pairs[leftIndex + ',' + rightIndex] = value;
    }

    return pairs;
}

exports.parse = parseKernTable;

},{"../check":4,"../parse":11}],23:[function(_dereq_,module,exports){
// The `loca` table stores the offsets to the locations of the glyphs in the font.
// https://www.microsoft.com/typography/OTSPEC/loca.htm

'use strict';

var parse = _dereq_('../parse');

// Parse the `loca` table. This table stores the offsets to the locations of the glyphs in the font,
// relative to the beginning of the glyphData table.
// The number of glyphs stored in the `loca` table is specified in the `maxp` table (under numGlyphs)
// The loca table has two versions: a short version where offsets are stored as uShorts, and a long
// version where offsets are stored as uLongs. The `head` table specifies which version to use
// (under indexToLocFormat).
function parseLocaTable(data, start, numGlyphs, shortVersion) {
    var p = new parse.Parser(data, start);
    var parseFn = shortVersion ? p.parseUShort : p.parseULong;
    // There is an extra entry after the last index element to compute the length of the last glyph.
    // That's why we use numGlyphs + 1.
    var glyphOffsets = [];
    for (var i = 0; i < numGlyphs + 1; i += 1) {
        var glyphOffset = parseFn.call(p);
        if (shortVersion) {
            // The short table version stores the actual offset divided by 2.
            glyphOffset *= 2;
        }

        glyphOffsets.push(glyphOffset);
    }

    return glyphOffsets;
}

exports.parse = parseLocaTable;

},{"../parse":11}],24:[function(_dereq_,module,exports){
// The `ltag` table stores IETF BCP-47 language tags. It allows supporting
// languages for which TrueType does not assign a numeric code.
// https://developer.apple.com/fonts/TrueType-Reference-Manual/RM06/Chap6ltag.html
// http://www.w3.org/International/articles/language-tags/
// http://www.iana.org/assignments/language-subtag-registry/language-subtag-registry

'use strict';

var check = _dereq_('../check');
var parse = _dereq_('../parse');
var table = _dereq_('../table');

function makeLtagTable(tags) {
    var result = new table.Table('ltag', [
        {name: 'version', type: 'ULONG', value: 1},
        {name: 'flags', type: 'ULONG', value: 0},
        {name: 'numTags', type: 'ULONG', value: tags.length}
    ]);

    var stringPool = '';
    var stringPoolOffset = 12 + tags.length * 4;
    for (var i = 0; i < tags.length; ++i) {
        var pos = stringPool.indexOf(tags[i]);
        if (pos < 0) {
            pos = stringPool.length;
            stringPool += tags[i];
        }

        result.fields.push({name: 'offset ' + i, type: 'USHORT', value: stringPoolOffset + pos});
        result.fields.push({name: 'length ' + i, type: 'USHORT', value: tags[i].length});
    }

    result.fields.push({name: 'stringPool', type: 'CHARARRAY', value: stringPool});
    return result;
}

function parseLtagTable(data, start) {
    var p = new parse.Parser(data, start);
    var tableVersion = p.parseULong();
    check.argument(tableVersion === 1, 'Unsupported ltag table version.');
    // The 'ltag' specification does not define any flags; skip the field.
    p.skip('uLong', 1);
    var numTags = p.parseULong();

    var tags = [];
    for (var i = 0; i < numTags; i++) {
        var tag = '';
        var offset = start + p.parseUShort();
        var length = p.parseUShort();
        for (var j = offset; j < offset + length; ++j) {
            tag += String.fromCharCode(data.getInt8(j));
        }

        tags.push(tag);
    }

    return tags;
}

exports.make = makeLtagTable;
exports.parse = parseLtagTable;

},{"../check":4,"../parse":11,"../table":13}],25:[function(_dereq_,module,exports){
// The `maxp` table establishes the memory requirements for the font.
// We need it just to get the number of glyphs in the font.
// https://www.microsoft.com/typography/OTSPEC/maxp.htm

'use strict';

var parse = _dereq_('../parse');
var table = _dereq_('../table');

// Parse the maximum profile `maxp` table.
function parseMaxpTable(data, start) {
    var maxp = {};
    var p = new parse.Parser(data, start);
    maxp.version = p.parseVersion();
    maxp.numGlyphs = p.parseUShort();
    if (maxp.version === 1.0) {
        maxp.maxPoints = p.parseUShort();
        maxp.maxContours = p.parseUShort();
        maxp.maxCompositePoints = p.parseUShort();
        maxp.maxCompositeContours = p.parseUShort();
        maxp.maxZones = p.parseUShort();
        maxp.maxTwilightPoints = p.parseUShort();
        maxp.maxStorage = p.parseUShort();
        maxp.maxFunctionDefs = p.parseUShort();
        maxp.maxInstructionDefs = p.parseUShort();
        maxp.maxStackElements = p.parseUShort();
        maxp.maxSizeOfInstructions = p.parseUShort();
        maxp.maxComponentElements = p.parseUShort();
        maxp.maxComponentDepth = p.parseUShort();
    }

    return maxp;
}

function makeMaxpTable(numGlyphs) {
    return new table.Table('maxp', [
        {name: 'version', type: 'FIXED', value: 0x00005000},
        {name: 'numGlyphs', type: 'USHORT', value: numGlyphs}
    ]);
}

exports.parse = parseMaxpTable;
exports.make = makeMaxpTable;

},{"../parse":11,"../table":13}],26:[function(_dereq_,module,exports){
// The `name` naming table.
// https://www.microsoft.com/typography/OTSPEC/name.htm

'use strict';

var types = _dereq_('../types');
var decode = types.decode;
var encode = types.encode;
var parse = _dereq_('../parse');
var table = _dereq_('../table');

// NameIDs for the name table.
var nameTableNames = [
    'copyright',              // 0
    'fontFamily',             // 1
    'fontSubfamily',          // 2
    'uniqueID',               // 3
    'fullName',               // 4
    'version',                // 5
    'postScriptName',         // 6
    'trademark',              // 7
    'manufacturer',           // 8
    'designer',               // 9
    'description',            // 10
    'manufacturerURL',        // 11
    'designerURL',            // 12
    'licence',                // 13
    'licenceURL',             // 14
    'reserved',               // 15
    'preferredFamily',        // 16
    'preferredSubfamily',     // 17
    'compatibleFullName',     // 18
    'sampleText',             // 19
    'postScriptFindFontName', // 20
    'wwsFamily',              // 21
    'wwsSubfamily'            // 22
];

var macLanguages = {
    0: 'en',
    1: 'fr',
    2: 'de',
    3: 'it',
    4: 'nl',
    5: 'sv',
    6: 'es',
    7: 'da',
    8: 'pt',
    9: 'no',
    10: 'he',
    11: 'ja',
    12: 'ar',
    13: 'fi',
    14: 'el',
    15: 'is',
    16: 'mt',
    17: 'tr',
    18: 'hr',
    19: 'zh-Hant',
    20: 'ur',
    21: 'hi',
    22: 'th',
    23: 'ko',
    24: 'lt',
    25: 'pl',
    26: 'hu',
    27: 'es',
    28: 'lv',
    29: 'se',
    30: 'fo',
    31: 'fa',
    32: 'ru',
    33: 'zh',
    34: 'nl-BE',
    35: 'ga',
    36: 'sq',
    37: 'ro',
    38: 'cz',
    39: 'sk',
    40: 'si',
    41: 'yi',
    42: 'sr',
    43: 'mk',
    44: 'bg',
    45: 'uk',
    46: 'be',
    47: 'uz',
    48: 'kk',
    49: 'az-Cyrl',
    50: 'az-Arab',
    51: 'hy',
    52: 'ka',
    53: 'mo',
    54: 'ky',
    55: 'tg',
    56: 'tk',
    57: 'mn-CN',
    58: 'mn',
    59: 'ps',
    60: 'ks',
    61: 'ku',
    62: 'sd',
    63: 'bo',
    64: 'ne',
    65: 'sa',
    66: 'mr',
    67: 'bn',
    68: 'as',
    69: 'gu',
    70: 'pa',
    71: 'or',
    72: 'ml',
    73: 'kn',
    74: 'ta',
    75: 'te',
    76: 'si',
    77: 'my',
    78: 'km',
    79: 'lo',
    80: 'vi',
    81: 'id',
    82: 'tl',
    83: 'ms',
    84: 'ms-Arab',
    85: 'am',
    86: 'ti',
    87: 'om',
    88: 'so',
    89: 'sw',
    90: 'rw',
    91: 'rn',
    92: 'ny',
    93: 'mg',
    94: 'eo',
    128: 'cy',
    129: 'eu',
    130: 'ca',
    131: 'la',
    132: 'qu',
    133: 'gn',
    134: 'ay',
    135: 'tt',
    136: 'ug',
    137: 'dz',
    138: 'jv',
    139: 'su',
    140: 'gl',
    141: 'af',
    142: 'br',
    143: 'iu',
    144: 'gd',
    145: 'gv',
    146: 'ga',
    147: 'to',
    148: 'el-polyton',
    149: 'kl',
    150: 'az',
    151: 'nn'
};

// MacOS language ID → MacOS script ID
//
// Note that the script ID is not sufficient to determine what encoding
// to use in TrueType files. For some languages, MacOS used a modification
// of a mainstream script. For example, an Icelandic name would be stored
// with smRoman in the TrueType naming table, but the actual encoding
// is a special Icelandic version of the normal Macintosh Roman encoding.
// As another example, Inuktitut uses an 8-bit encoding for Canadian Aboriginal
// Syllables but MacOS had run out of available script codes, so this was
// done as a (pretty radical) "modification" of Ethiopic.
//
// http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/Readme.txt
var macLanguageToScript = {
    0: 0,  // langEnglish → smRoman
    1: 0,  // langFrench → smRoman
    2: 0,  // langGerman → smRoman
    3: 0,  // langItalian → smRoman
    4: 0,  // langDutch → smRoman
    5: 0,  // langSwedish → smRoman
    6: 0,  // langSpanish → smRoman
    7: 0,  // langDanish → smRoman
    8: 0,  // langPortuguese → smRoman
    9: 0,  // langNorwegian → smRoman
    10: 5,  // langHebrew → smHebrew
    11: 1,  // langJapanese → smJapanese
    12: 4,  // langArabic → smArabic
    13: 0,  // langFinnish → smRoman
    14: 6,  // langGreek → smGreek
    15: 0,  // langIcelandic → smRoman (modified)
    16: 0,  // langMaltese → smRoman
    17: 0,  // langTurkish → smRoman (modified)
    18: 0,  // langCroatian → smRoman (modified)
    19: 2,  // langTradChinese → smTradChinese
    20: 4,  // langUrdu → smArabic
    21: 9,  // langHindi → smDevanagari
    22: 21,  // langThai → smThai
    23: 3,  // langKorean → smKorean
    24: 29,  // langLithuanian → smCentralEuroRoman
    25: 29,  // langPolish → smCentralEuroRoman
    26: 29,  // langHungarian → smCentralEuroRoman
    27: 29,  // langEstonian → smCentralEuroRoman
    28: 29,  // langLatvian → smCentralEuroRoman
    29: 0,  // langSami → smRoman
    30: 0,  // langFaroese → smRoman (modified)
    31: 4,  // langFarsi → smArabic (modified)
    32: 7,  // langRussian → smCyrillic
    33: 25,  // langSimpChinese → smSimpChinese
    34: 0,  // langFlemish → smRoman
    35: 0,  // langIrishGaelic → smRoman (modified)
    36: 0,  // langAlbanian → smRoman
    37: 0,  // langRomanian → smRoman (modified)
    38: 29,  // langCzech → smCentralEuroRoman
    39: 29,  // langSlovak → smCentralEuroRoman
    40: 0,  // langSlovenian → smRoman (modified)
    41: 5,  // langYiddish → smHebrew
    42: 7,  // langSerbian → smCyrillic
    43: 7,  // langMacedonian → smCyrillic
    44: 7,  // langBulgarian → smCyrillic
    45: 7,  // langUkrainian → smCyrillic (modified)
    46: 7,  // langByelorussian → smCyrillic
    47: 7,  // langUzbek → smCyrillic
    48: 7,  // langKazakh → smCyrillic
    49: 7,  // langAzerbaijani → smCyrillic
    50: 4,  // langAzerbaijanAr → smArabic
    51: 24,  // langArmenian → smArmenian
    52: 23,  // langGeorgian → smGeorgian
    53: 7,  // langMoldavian → smCyrillic
    54: 7,  // langKirghiz → smCyrillic
    55: 7,  // langTajiki → smCyrillic
    56: 7,  // langTurkmen → smCyrillic
    57: 27,  // langMongolian → smMongolian
    58: 7,  // langMongolianCyr → smCyrillic
    59: 4,  // langPashto → smArabic
    60: 4,  // langKurdish → smArabic
    61: 4,  // langKashmiri → smArabic
    62: 4,  // langSindhi → smArabic
    63: 26,  // langTibetan → smTibetan
    64: 9,  // langNepali → smDevanagari
    65: 9,  // langSanskrit → smDevanagari
    66: 9,  // langMarathi → smDevanagari
    67: 13,  // langBengali → smBengali
    68: 13,  // langAssamese → smBengali
    69: 11,  // langGujarati → smGujarati
    70: 10,  // langPunjabi → smGurmukhi
    71: 12,  // langOriya → smOriya
    72: 17,  // langMalayalam → smMalayalam
    73: 16,  // langKannada → smKannada
    74: 14,  // langTamil → smTamil
    75: 15,  // langTelugu → smTelugu
    76: 18,  // langSinhalese → smSinhalese
    77: 19,  // langBurmese → smBurmese
    78: 20,  // langKhmer → smKhmer
    79: 22,  // langLao → smLao
    80: 30,  // langVietnamese → smVietnamese
    81: 0,  // langIndonesian → smRoman
    82: 0,  // langTagalog → smRoman
    83: 0,  // langMalayRoman → smRoman
    84: 4,  // langMalayArabic → smArabic
    85: 28,  // langAmharic → smEthiopic
    86: 28,  // langTigrinya → smEthiopic
    87: 28,  // langOromo → smEthiopic
    88: 0,  // langSomali → smRoman
    89: 0,  // langSwahili → smRoman
    90: 0,  // langKinyarwanda → smRoman
    91: 0,  // langRundi → smRoman
    92: 0,  // langNyanja → smRoman
    93: 0,  // langMalagasy → smRoman
    94: 0,  // langEsperanto → smRoman
    128: 0,  // langWelsh → smRoman (modified)
    129: 0,  // langBasque → smRoman
    130: 0,  // langCatalan → smRoman
    131: 0,  // langLatin → smRoman
    132: 0,  // langQuechua → smRoman
    133: 0,  // langGuarani → smRoman
    134: 0,  // langAymara → smRoman
    135: 7,  // langTatar → smCyrillic
    136: 4,  // langUighur → smArabic
    137: 26,  // langDzongkha → smTibetan
    138: 0,  // langJavaneseRom → smRoman
    139: 0,  // langSundaneseRom → smRoman
    140: 0,  // langGalician → smRoman
    141: 0,  // langAfrikaans → smRoman
    142: 0,  // langBreton → smRoman (modified)
    143: 28,  // langInuktitut → smEthiopic (modified)
    144: 0,  // langScottishGaelic → smRoman (modified)
    145: 0,  // langManxGaelic → smRoman (modified)
    146: 0,  // langIrishGaelicScript → smRoman (modified)
    147: 0,  // langTongan → smRoman
    148: 6,  // langGreekAncient → smRoman
    149: 0,  // langGreenlandic → smRoman
    150: 0,  // langAzerbaijanRoman → smRoman
    151: 0   // langNynorsk → smRoman
};

// While Microsoft indicates a region/country for all its language
// IDs, we omit the region code if it's equal to the "most likely
// region subtag" according to Unicode CLDR. For scripts, we omit
// the subtag if it is equal to the Suppress-Script entry in the
// IANA language subtag registry for IETF BCP 47.
//
// For example, Microsoft states that its language code 0x041A is
// Croatian in Croatia. We transform this to the BCP 47 language code 'hr'
// and not 'hr-HR' because Croatia is the default country for Croatian,
// according to Unicode CLDR. As another example, Microsoft states
// that 0x101A is Croatian (Latin) in Bosnia-Herzegovina. We transform
// this to 'hr-BA' and not 'hr-Latn-BA' because Latin is the default script
// for the Croatian language, according to IANA.
//
// http://www.unicode.org/cldr/charts/latest/supplemental/likely_subtags.html
// http://www.iana.org/assignments/language-subtag-registry/language-subtag-registry
var windowsLanguages = {
    0x0436: 'af',
    0x041C: 'sq',
    0x0484: 'gsw',
    0x045E: 'am',
    0x1401: 'ar-DZ',
    0x3C01: 'ar-BH',
    0x0C01: 'ar',
    0x0801: 'ar-IQ',
    0x2C01: 'ar-JO',
    0x3401: 'ar-KW',
    0x3001: 'ar-LB',
    0x1001: 'ar-LY',
    0x1801: 'ary',
    0x2001: 'ar-OM',
    0x4001: 'ar-QA',
    0x0401: 'ar-SA',
    0x2801: 'ar-SY',
    0x1C01: 'aeb',
    0x3801: 'ar-AE',
    0x2401: 'ar-YE',
    0x042B: 'hy',
    0x044D: 'as',
    0x082C: 'az-Cyrl',
    0x042C: 'az',
    0x046D: 'ba',
    0x042D: 'eu',
    0x0423: 'be',
    0x0845: 'bn',
    0x0445: 'bn-IN',
    0x201A: 'bs-Cyrl',
    0x141A: 'bs',
    0x047E: 'br',
    0x0402: 'bg',
    0x0403: 'ca',
    0x0C04: 'zh-HK',
    0x1404: 'zh-MO',
    0x0804: 'zh',
    0x1004: 'zh-SG',
    0x0404: 'zh-TW',
    0x0483: 'co',
    0x041A: 'hr',
    0x101A: 'hr-BA',
    0x0405: 'cs',
    0x0406: 'da',
    0x048C: 'prs',
    0x0465: 'dv',
    0x0813: 'nl-BE',
    0x0413: 'nl',
    0x0C09: 'en-AU',
    0x2809: 'en-BZ',
    0x1009: 'en-CA',
    0x2409: 'en-029',
    0x4009: 'en-IN',
    0x1809: 'en-IE',
    0x2009: 'en-JM',
    0x4409: 'en-MY',
    0x1409: 'en-NZ',
    0x3409: 'en-PH',
    0x4809: 'en-SG',
    0x1C09: 'en-ZA',
    0x2C09: 'en-TT',
    0x0809: 'en-GB',
    0x0409: 'en',
    0x3009: 'en-ZW',
    0x0425: 'et',
    0x0438: 'fo',
    0x0464: 'fil',
    0x040B: 'fi',
    0x080C: 'fr-BE',
    0x0C0C: 'fr-CA',
    0x040C: 'fr',
    0x140C: 'fr-LU',
    0x180C: 'fr-MC',
    0x100C: 'fr-CH',
    0x0462: 'fy',
    0x0456: 'gl',
    0x0437: 'ka',
    0x0C07: 'de-AT',
    0x0407: 'de',
    0x1407: 'de-LI',
    0x1007: 'de-LU',
    0x0807: 'de-CH',
    0x0408: 'el',
    0x046F: 'kl',
    0x0447: 'gu',
    0x0468: 'ha',
    0x040D: 'he',
    0x0439: 'hi',
    0x040E: 'hu',
    0x040F: 'is',
    0x0470: 'ig',
    0x0421: 'id',
    0x045D: 'iu',
    0x085D: 'iu-Latn',
    0x083C: 'ga',
    0x0434: 'xh',
    0x0435: 'zu',
    0x0410: 'it',
    0x0810: 'it-CH',
    0x0411: 'ja',
    0x044B: 'kn',
    0x043F: 'kk',
    0x0453: 'km',
    0x0486: 'quc',
    0x0487: 'rw',
    0x0441: 'sw',
    0x0457: 'kok',
    0x0412: 'ko',
    0x0440: 'ky',
    0x0454: 'lo',
    0x0426: 'lv',
    0x0427: 'lt',
    0x082E: 'dsb',
    0x046E: 'lb',
    0x042F: 'mk',
    0x083E: 'ms-BN',
    0x043E: 'ms',
    0x044C: 'ml',
    0x043A: 'mt',
    0x0481: 'mi',
    0x047A: 'arn',
    0x044E: 'mr',
    0x047C: 'moh',
    0x0450: 'mn',
    0x0850: 'mn-CN',
    0x0461: 'ne',
    0x0414: 'nb',
    0x0814: 'nn',
    0x0482: 'oc',
    0x0448: 'or',
    0x0463: 'ps',
    0x0415: 'pl',
    0x0416: 'pt',
    0x0816: 'pt-PT',
    0x0446: 'pa',
    0x046B: 'qu-BO',
    0x086B: 'qu-EC',
    0x0C6B: 'qu',
    0x0418: 'ro',
    0x0417: 'rm',
    0x0419: 'ru',
    0x243B: 'smn',
    0x103B: 'smj-NO',
    0x143B: 'smj',
    0x0C3B: 'se-FI',
    0x043B: 'se',
    0x083B: 'se-SE',
    0x203B: 'sms',
    0x183B: 'sma-NO',
    0x1C3B: 'sms',
    0x044F: 'sa',
    0x1C1A: 'sr-Cyrl-BA',
    0x0C1A: 'sr',
    0x181A: 'sr-Latn-BA',
    0x081A: 'sr-Latn',
    0x046C: 'nso',
    0x0432: 'tn',
    0x045B: 'si',
    0x041B: 'sk',
    0x0424: 'sl',
    0x2C0A: 'es-AR',
    0x400A: 'es-BO',
    0x340A: 'es-CL',
    0x240A: 'es-CO',
    0x140A: 'es-CR',
    0x1C0A: 'es-DO',
    0x300A: 'es-EC',
    0x440A: 'es-SV',
    0x100A: 'es-GT',
    0x480A: 'es-HN',
    0x080A: 'es-MX',
    0x4C0A: 'es-NI',
    0x180A: 'es-PA',
    0x3C0A: 'es-PY',
    0x280A: 'es-PE',
    0x500A: 'es-PR',

    // Microsoft has defined two different language codes for
    // “Spanish with modern sorting” and “Spanish with traditional
    // sorting”. This makes sense for collation APIs, and it would be
    // possible to express this in BCP 47 language tags via Unicode
    // extensions (eg., es-u-co-trad is Spanish with traditional
    // sorting). However, for storing names in fonts, the distinction
    // does not make sense, so we give “es” in both cases.
    0x0C0A: 'es',
    0x040A: 'es',

    0x540A: 'es-US',
    0x380A: 'es-UY',
    0x200A: 'es-VE',
    0x081D: 'sv-FI',
    0x041D: 'sv',
    0x045A: 'syr',
    0x0428: 'tg',
    0x085F: 'tzm',
    0x0449: 'ta',
    0x0444: 'tt',
    0x044A: 'te',
    0x041E: 'th',
    0x0451: 'bo',
    0x041F: 'tr',
    0x0442: 'tk',
    0x0480: 'ug',
    0x0422: 'uk',
    0x042E: 'hsb',
    0x0420: 'ur',
    0x0843: 'uz-Cyrl',
    0x0443: 'uz',
    0x042A: 'vi',
    0x0452: 'cy',
    0x0488: 'wo',
    0x0485: 'sah',
    0x0478: 'ii',
    0x046A: 'yo'
};

// Returns a IETF BCP 47 language code, for example 'zh-Hant'
// for 'Chinese in the traditional script'.
function getLanguageCode(platformID, languageID, ltag) {
    switch (platformID) {
    case 0:  // Unicode
        if (languageID === 0xFFFF) {
            return 'und';
        } else if (ltag) {
            return ltag[languageID];
        }

        break;

    case 1:  // Macintosh
        return macLanguages[languageID];

    case 3:  // Windows
        return windowsLanguages[languageID];
    }

    return undefined;
}

var utf16 = 'utf-16';

// MacOS script ID → encoding. This table stores the default case,
// which can be overridden by macLanguageEncodings.
var macScriptEncodings = {
    0: 'macintosh',           // smRoman
    1: 'x-mac-japanese',      // smJapanese
    2: 'x-mac-chinesetrad',   // smTradChinese
    3: 'x-mac-korean',        // smKorean
    6: 'x-mac-greek',         // smGreek
    7: 'x-mac-cyrillic',      // smCyrillic
    9: 'x-mac-devanagai',     // smDevanagari
    10: 'x-mac-gurmukhi',     // smGurmukhi
    11: 'x-mac-gujarati',     // smGujarati
    12: 'x-mac-oriya',        // smOriya
    13: 'x-mac-bengali',      // smBengali
    14: 'x-mac-tamil',        // smTamil
    15: 'x-mac-telugu',       // smTelugu
    16: 'x-mac-kannada',      // smKannada
    17: 'x-mac-malayalam',    // smMalayalam
    18: 'x-mac-sinhalese',    // smSinhalese
    19: 'x-mac-burmese',      // smBurmese
    20: 'x-mac-khmer',        // smKhmer
    21: 'x-mac-thai',         // smThai
    22: 'x-mac-lao',          // smLao
    23: 'x-mac-georgian',     // smGeorgian
    24: 'x-mac-armenian',     // smArmenian
    25: 'x-mac-chinesesimp',  // smSimpChinese
    26: 'x-mac-tibetan',      // smTibetan
    27: 'x-mac-mongolian',    // smMongolian
    28: 'x-mac-ethiopic',     // smEthiopic
    29: 'x-mac-ce',           // smCentralEuroRoman
    30: 'x-mac-vietnamese',   // smVietnamese
    31: 'x-mac-extarabic'     // smExtArabic
};

// MacOS language ID → encoding. This table stores the exceptional
// cases, which override macScriptEncodings. For writing MacOS naming
// tables, we need to emit a MacOS script ID. Therefore, we cannot
// merge macScriptEncodings into macLanguageEncodings.
//
// http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/Readme.txt
var macLanguageEncodings = {
    15: 'x-mac-icelandic',    // langIcelandic
    17: 'x-mac-turkish',      // langTurkish
    18: 'x-mac-croatian',     // langCroatian
    24: 'x-mac-ce',           // langLithuanian
    25: 'x-mac-ce',           // langPolish
    26: 'x-mac-ce',           // langHungarian
    27: 'x-mac-ce',           // langEstonian
    28: 'x-mac-ce',           // langLatvian
    30: 'x-mac-icelandic',    // langFaroese
    37: 'x-mac-romanian',     // langRomanian
    38: 'x-mac-ce',           // langCzech
    39: 'x-mac-ce',           // langSlovak
    40: 'x-mac-ce',           // langSlovenian
    143: 'x-mac-inuit',       // langInuktitut
    146: 'x-mac-gaelic'       // langIrishGaelicScript
};

function getEncoding(platformID, encodingID, languageID) {
    switch (platformID) {
    case 0:  // Unicode
        return utf16;

    case 1:  // Apple Macintosh
        return macLanguageEncodings[languageID] || macScriptEncodings[encodingID];

    case 3:  // Microsoft Windows
        if (encodingID === 1 || encodingID === 10) {
            return utf16;
        }

        break;
    }

    return undefined;
}

// Parse the naming `name` table.
// FIXME: Format 1 additional fields are not supported yet.
// ltag is the content of the `ltag' table, such as ['en', 'zh-Hans', 'de-CH-1904'].
function parseNameTable(data, start, ltag) {
    var name = {};
    var p = new parse.Parser(data, start);
    var format = p.parseUShort();
    var count = p.parseUShort();
    var stringOffset = p.offset + p.parseUShort();
    for (var i = 0; i < count; i++) {
        var platformID = p.parseUShort();
        var encodingID = p.parseUShort();
        var languageID = p.parseUShort();
        var nameID = p.parseUShort();
        var property = nameTableNames[nameID] || nameID;
        var byteLength = p.parseUShort();
        var offset = p.parseUShort();
        var language = getLanguageCode(platformID, languageID, ltag);
        var encoding = getEncoding(platformID, encodingID, languageID);
        if (encoding !== undefined && language !== undefined) {
            var text;
            if (encoding === utf16) {
                text = decode.UTF16(data, stringOffset + offset, byteLength);
            } else {
                text = decode.MACSTRING(data, stringOffset + offset, byteLength, encoding);
            }

            if (text) {
                var translations = name[property];
                if (translations === undefined) {
                    translations = name[property] = {};
                }

                translations[language] = text;
            }
        }
    }

    var langTagCount = 0;
    if (format === 1) {
        // FIXME: Also handle Microsoft's 'name' table 1.
        langTagCount = p.parseUShort();
    }

    return name;
}

// {23: 'foo'} → {'foo': 23}
// ['bar', 'baz'] → {'bar': 0, 'baz': 1}
function reverseDict(dict) {
    var result = {};
    for (var key in dict) {
        result[dict[key]] = parseInt(key);
    }

    return result;
}

function makeNameRecord(platformID, encodingID, languageID, nameID, length, offset) {
    return new table.Table('NameRecord', [
        {name: 'platformID', type: 'USHORT', value: platformID},
        {name: 'encodingID', type: 'USHORT', value: encodingID},
        {name: 'languageID', type: 'USHORT', value: languageID},
        {name: 'nameID', type: 'USHORT', value: nameID},
        {name: 'length', type: 'USHORT', value: length},
        {name: 'offset', type: 'USHORT', value: offset}
    ]);
}

// Finds the position of needle in haystack, or -1 if not there.
// Like String.indexOf(), but for arrays.
function findSubArray(needle, haystack) {
    var needleLength = needle.length;
    var limit = haystack.length - needleLength + 1;

    loop:
    for (var pos = 0; pos < limit; pos++) {
        for (; pos < limit; pos++) {
            for (var k = 0; k < needleLength; k++) {
                if (haystack[pos + k] !== needle[k]) {
                    continue loop;
                }
            }

            return pos;
        }
    }

    return -1;
}

function addStringToPool(s, pool) {
    var offset = findSubArray(s, pool);
    if (offset < 0) {
        offset = pool.length;
        for (var i = 0, len = s.length; i < len; ++i) {
            pool.push(s[i]);
        }

    }

    return offset;
}

function makeNameTable(names, ltag) {
    var nameID;
    var nameIDs = [];

    var namesWithNumericKeys = {};
    var nameTableIds = reverseDict(nameTableNames);
    for (var key in names) {
        var id = nameTableIds[key];
        if (id === undefined) {
            id = key;
        }

        nameID = parseInt(id);
        namesWithNumericKeys[nameID] = names[key];
        nameIDs.push(nameID);
    }

    var macLanguageIds = reverseDict(macLanguages);
    var windowsLanguageIds = reverseDict(windowsLanguages);

    var nameRecords = [];
    var stringPool = [];

    for (var i = 0; i < nameIDs.length; i++) {
        nameID = nameIDs[i];
        var translations = namesWithNumericKeys[nameID];
        for (var lang in translations) {
            var text = translations[lang];

            // For MacOS, we try to emit the name in the form that was introduced
            // in the initial version of the TrueType spec (in the late 1980s).
            // However, this can fail for various reasons: the requested BCP 47
            // language code might not have an old-style Mac equivalent;
            // we might not have a codec for the needed character encoding;
            // or the name might contain characters that cannot be expressed
            // in the old-style Macintosh encoding. In case of failure, we emit
            // the name in a more modern fashion (Unicode encoding with BCP 47
            // language tags) that is recognized by MacOS 10.5, released in 2009.
            // If fonts were only read by operating systems, we could simply
            // emit all names in the modern form; this would be much easier.
            // However, there are many applications and libraries that read
            // 'name' tables directly, and these will usually only recognize
            // the ancient form (silently skipping the unrecognized names).
            var macPlatform = 1;  // Macintosh
            var macLanguage = macLanguageIds[lang];
            var macScript = macLanguageToScript[macLanguage];
            var macEncoding = getEncoding(macPlatform, macScript, macLanguage);
            var macName = encode.MACSTRING(text, macEncoding);
            if (macName === undefined) {
                macPlatform = 0;  // Unicode
                macLanguage = ltag.indexOf(lang);
                if (macLanguage < 0) {
                    macLanguage = ltag.length;
                    ltag.push(lang);
                }

                macScript = 4;  // Unicode 2.0 and later
                macName = encode.UTF16(text);
            }

            var macNameOffset = addStringToPool(macName, stringPool);
            nameRecords.push(makeNameRecord(macPlatform, macScript, macLanguage,
                                            nameID, macName.length, macNameOffset));

            var winLanguage = windowsLanguageIds[lang];
            if (winLanguage !== undefined) {
                var winName = encode.UTF16(text);
                var winNameOffset = addStringToPool(winName, stringPool);
                nameRecords.push(makeNameRecord(3, 1, winLanguage,
                                                nameID, winName.length, winNameOffset));
            }
        }
    }

    nameRecords.sort(function(a, b) {
        return ((a.platformID - b.platformID) ||
                (a.encodingID - b.encodingID) ||
                (a.languageID - b.languageID) ||
                (a.nameID - b.nameID));
    });

    var t = new table.Table('name', [
        {name: 'format', type: 'USHORT', value: 0},
        {name: 'count', type: 'USHORT', value: nameRecords.length},
        {name: 'stringOffset', type: 'USHORT', value: 6 + nameRecords.length * 12}
    ]);

    for (var r = 0; r < nameRecords.length; r++) {
        t.fields.push({name: 'record_' + r, type: 'TABLE', value: nameRecords[r]});
    }

    t.fields.push({name: 'strings', type: 'LITERAL', value: stringPool});
    return t;
}

exports.parse = parseNameTable;
exports.make = makeNameTable;

},{"../parse":11,"../table":13,"../types":30}],27:[function(_dereq_,module,exports){
// The `OS/2` table contains metrics required in OpenType fonts.
// https://www.microsoft.com/typography/OTSPEC/os2.htm

'use strict';

var parse = _dereq_('../parse');
var table = _dereq_('../table');

var unicodeRanges = [
    {begin: 0x0000, end: 0x007F}, // Basic Latin
    {begin: 0x0080, end: 0x00FF}, // Latin-1 Supplement
    {begin: 0x0100, end: 0x017F}, // Latin Extended-A
    {begin: 0x0180, end: 0x024F}, // Latin Extended-B
    {begin: 0x0250, end: 0x02AF}, // IPA Extensions
    {begin: 0x02B0, end: 0x02FF}, // Spacing Modifier Letters
    {begin: 0x0300, end: 0x036F}, // Combining Diacritical Marks
    {begin: 0x0370, end: 0x03FF}, // Greek and Coptic
    {begin: 0x2C80, end: 0x2CFF}, // Coptic
    {begin: 0x0400, end: 0x04FF}, // Cyrillic
    {begin: 0x0530, end: 0x058F}, // Armenian
    {begin: 0x0590, end: 0x05FF}, // Hebrew
    {begin: 0xA500, end: 0xA63F}, // Vai
    {begin: 0x0600, end: 0x06FF}, // Arabic
    {begin: 0x07C0, end: 0x07FF}, // NKo
    {begin: 0x0900, end: 0x097F}, // Devanagari
    {begin: 0x0980, end: 0x09FF}, // Bengali
    {begin: 0x0A00, end: 0x0A7F}, // Gurmukhi
    {begin: 0x0A80, end: 0x0AFF}, // Gujarati
    {begin: 0x0B00, end: 0x0B7F}, // Oriya
    {begin: 0x0B80, end: 0x0BFF}, // Tamil
    {begin: 0x0C00, end: 0x0C7F}, // Telugu
    {begin: 0x0C80, end: 0x0CFF}, // Kannada
    {begin: 0x0D00, end: 0x0D7F}, // Malayalam
    {begin: 0x0E00, end: 0x0E7F}, // Thai
    {begin: 0x0E80, end: 0x0EFF}, // Lao
    {begin: 0x10A0, end: 0x10FF}, // Georgian
    {begin: 0x1B00, end: 0x1B7F}, // Balinese
    {begin: 0x1100, end: 0x11FF}, // Hangul Jamo
    {begin: 0x1E00, end: 0x1EFF}, // Latin Extended Additional
    {begin: 0x1F00, end: 0x1FFF}, // Greek Extended
    {begin: 0x2000, end: 0x206F}, // General Punctuation
    {begin: 0x2070, end: 0x209F}, // Superscripts And Subscripts
    {begin: 0x20A0, end: 0x20CF}, // Currency Symbol
    {begin: 0x20D0, end: 0x20FF}, // Combining Diacritical Marks For Symbols
    {begin: 0x2100, end: 0x214F}, // Letterlike Symbols
    {begin: 0x2150, end: 0x218F}, // Number Forms
    {begin: 0x2190, end: 0x21FF}, // Arrows
    {begin: 0x2200, end: 0x22FF}, // Mathematical Operators
    {begin: 0x2300, end: 0x23FF}, // Miscellaneous Technical
    {begin: 0x2400, end: 0x243F}, // Control Pictures
    {begin: 0x2440, end: 0x245F}, // Optical Character Recognition
    {begin: 0x2460, end: 0x24FF}, // Enclosed Alphanumerics
    {begin: 0x2500, end: 0x257F}, // Box Drawing
    {begin: 0x2580, end: 0x259F}, // Block Elements
    {begin: 0x25A0, end: 0x25FF}, // Geometric Shapes
    {begin: 0x2600, end: 0x26FF}, // Miscellaneous Symbols
    {begin: 0x2700, end: 0x27BF}, // Dingbats
    {begin: 0x3000, end: 0x303F}, // CJK Symbols And Punctuation
    {begin: 0x3040, end: 0x309F}, // Hiragana
    {begin: 0x30A0, end: 0x30FF}, // Katakana
    {begin: 0x3100, end: 0x312F}, // Bopomofo
    {begin: 0x3130, end: 0x318F}, // Hangul Compatibility Jamo
    {begin: 0xA840, end: 0xA87F}, // Phags-pa
    {begin: 0x3200, end: 0x32FF}, // Enclosed CJK Letters And Months
    {begin: 0x3300, end: 0x33FF}, // CJK Compatibility
    {begin: 0xAC00, end: 0xD7AF}, // Hangul Syllables
    {begin: 0xD800, end: 0xDFFF}, // Non-Plane 0 *
    {begin: 0x10900, end: 0x1091F}, // Phoenicia
    {begin: 0x4E00, end: 0x9FFF}, // CJK Unified Ideographs
    {begin: 0xE000, end: 0xF8FF}, // Private Use Area (plane 0)
    {begin: 0x31C0, end: 0x31EF}, // CJK Strokes
    {begin: 0xFB00, end: 0xFB4F}, // Alphabetic Presentation Forms
    {begin: 0xFB50, end: 0xFDFF}, // Arabic Presentation Forms-A
    {begin: 0xFE20, end: 0xFE2F}, // Combining Half Marks
    {begin: 0xFE10, end: 0xFE1F}, // Vertical Forms
    {begin: 0xFE50, end: 0xFE6F}, // Small Form Variants
    {begin: 0xFE70, end: 0xFEFF}, // Arabic Presentation Forms-B
    {begin: 0xFF00, end: 0xFFEF}, // Halfwidth And Fullwidth Forms
    {begin: 0xFFF0, end: 0xFFFF}, // Specials
    {begin: 0x0F00, end: 0x0FFF}, // Tibetan
    {begin: 0x0700, end: 0x074F}, // Syriac
    {begin: 0x0780, end: 0x07BF}, // Thaana
    {begin: 0x0D80, end: 0x0DFF}, // Sinhala
    {begin: 0x1000, end: 0x109F}, // Myanmar
    {begin: 0x1200, end: 0x137F}, // Ethiopic
    {begin: 0x13A0, end: 0x13FF}, // Cherokee
    {begin: 0x1400, end: 0x167F}, // Unified Canadian Aboriginal Syllabics
    {begin: 0x1680, end: 0x169F}, // Ogham
    {begin: 0x16A0, end: 0x16FF}, // Runic
    {begin: 0x1780, end: 0x17FF}, // Khmer
    {begin: 0x1800, end: 0x18AF}, // Mongolian
    {begin: 0x2800, end: 0x28FF}, // Braille Patterns
    {begin: 0xA000, end: 0xA48F}, // Yi Syllables
    {begin: 0x1700, end: 0x171F}, // Tagalog
    {begin: 0x10300, end: 0x1032F}, // Old Italic
    {begin: 0x10330, end: 0x1034F}, // Gothic
    {begin: 0x10400, end: 0x1044F}, // Deseret
    {begin: 0x1D000, end: 0x1D0FF}, // Byzantine Musical Symbols
    {begin: 0x1D400, end: 0x1D7FF}, // Mathematical Alphanumeric Symbols
    {begin: 0xFF000, end: 0xFFFFD}, // Private Use (plane 15)
    {begin: 0xFE00, end: 0xFE0F}, // Variation Selectors
    {begin: 0xE0000, end: 0xE007F}, // Tags
    {begin: 0x1900, end: 0x194F}, // Limbu
    {begin: 0x1950, end: 0x197F}, // Tai Le
    {begin: 0x1980, end: 0x19DF}, // New Tai Lue
    {begin: 0x1A00, end: 0x1A1F}, // Buginese
    {begin: 0x2C00, end: 0x2C5F}, // Glagolitic
    {begin: 0x2D30, end: 0x2D7F}, // Tifinagh
    {begin: 0x4DC0, end: 0x4DFF}, // Yijing Hexagram Symbols
    {begin: 0xA800, end: 0xA82F}, // Syloti Nagri
    {begin: 0x10000, end: 0x1007F}, // Linear B Syllabary
    {begin: 0x10140, end: 0x1018F}, // Ancient Greek Numbers
    {begin: 0x10380, end: 0x1039F}, // Ugaritic
    {begin: 0x103A0, end: 0x103DF}, // Old Persian
    {begin: 0x10450, end: 0x1047F}, // Shavian
    {begin: 0x10480, end: 0x104AF}, // Osmanya
    {begin: 0x10800, end: 0x1083F}, // Cypriot Syllabary
    {begin: 0x10A00, end: 0x10A5F}, // Kharoshthi
    {begin: 0x1D300, end: 0x1D35F}, // Tai Xuan Jing Symbols
    {begin: 0x12000, end: 0x123FF}, // Cuneiform
    {begin: 0x1D360, end: 0x1D37F}, // Counting Rod Numerals
    {begin: 0x1B80, end: 0x1BBF}, // Sundanese
    {begin: 0x1C00, end: 0x1C4F}, // Lepcha
    {begin: 0x1C50, end: 0x1C7F}, // Ol Chiki
    {begin: 0xA880, end: 0xA8DF}, // Saurashtra
    {begin: 0xA900, end: 0xA92F}, // Kayah Li
    {begin: 0xA930, end: 0xA95F}, // Rejang
    {begin: 0xAA00, end: 0xAA5F}, // Cham
    {begin: 0x10190, end: 0x101CF}, // Ancient Symbols
    {begin: 0x101D0, end: 0x101FF}, // Phaistos Disc
    {begin: 0x102A0, end: 0x102DF}, // Carian
    {begin: 0x1F030, end: 0x1F09F}  // Domino Tiles
];

function getUnicodeRange(unicode) {
    for (var i = 0; i < unicodeRanges.length; i += 1) {
        var range = unicodeRanges[i];
        if (unicode >= range.begin && unicode < range.end) {
            return i;
        }
    }

    return -1;
}

// Parse the OS/2 and Windows metrics `OS/2` table
function parseOS2Table(data, start) {
    var os2 = {};
    var p = new parse.Parser(data, start);
    os2.version = p.parseUShort();
    os2.xAvgCharWidth = p.parseShort();
    os2.usWeightClass = p.parseUShort();
    os2.usWidthClass = p.parseUShort();
    os2.fsType = p.parseUShort();
    os2.ySubscriptXSize = p.parseShort();
    os2.ySubscriptYSize = p.parseShort();
    os2.ySubscriptXOffset = p.parseShort();
    os2.ySubscriptYOffset = p.parseShort();
    os2.ySuperscriptXSize = p.parseShort();
    os2.ySuperscriptYSize = p.parseShort();
    os2.ySuperscriptXOffset = p.parseShort();
    os2.ySuperscriptYOffset = p.parseShort();
    os2.yStrikeoutSize = p.parseShort();
    os2.yStrikeoutPosition = p.parseShort();
    os2.sFamilyClass = p.parseShort();
    os2.panose = [];
    for (var i = 0; i < 10; i++) {
        os2.panose[i] = p.parseByte();
    }

    os2.ulUnicodeRange1 = p.parseULong();
    os2.ulUnicodeRange2 = p.parseULong();
    os2.ulUnicodeRange3 = p.parseULong();
    os2.ulUnicodeRange4 = p.parseULong();
    os2.achVendID = String.fromCharCode(p.parseByte(), p.parseByte(), p.parseByte(), p.parseByte());
    os2.fsSelection = p.parseUShort();
    os2.usFirstCharIndex = p.parseUShort();
    os2.usLastCharIndex = p.parseUShort();
    os2.sTypoAscender = p.parseShort();
    os2.sTypoDescender = p.parseShort();
    os2.sTypoLineGap = p.parseShort();
    os2.usWinAscent = p.parseUShort();
    os2.usWinDescent = p.parseUShort();
    if (os2.version >= 1) {
        os2.ulCodePageRange1 = p.parseULong();
        os2.ulCodePageRange2 = p.parseULong();
    }

    if (os2.version >= 2) {
        os2.sxHeight = p.parseShort();
        os2.sCapHeight = p.parseShort();
        os2.usDefaultChar = p.parseUShort();
        os2.usBreakChar = p.parseUShort();
        os2.usMaxContent = p.parseUShort();
    }

    return os2;
}

function makeOS2Table(options) {
    return new table.Table('OS/2', [
        {name: 'version', type: 'USHORT', value: 0x0003},
        {name: 'xAvgCharWidth', type: 'SHORT', value: 0},
        {name: 'usWeightClass', type: 'USHORT', value: 0},
        {name: 'usWidthClass', type: 'USHORT', value: 0},
        {name: 'fsType', type: 'USHORT', value: 0},
        {name: 'ySubscriptXSize', type: 'SHORT', value: 650},
        {name: 'ySubscriptYSize', type: 'SHORT', value: 699},
        {name: 'ySubscriptXOffset', type: 'SHORT', value: 0},
        {name: 'ySubscriptYOffset', type: 'SHORT', value: 140},
        {name: 'ySuperscriptXSize', type: 'SHORT', value: 650},
        {name: 'ySuperscriptYSize', type: 'SHORT', value: 699},
        {name: 'ySuperscriptXOffset', type: 'SHORT', value: 0},
        {name: 'ySuperscriptYOffset', type: 'SHORT', value: 479},
        {name: 'yStrikeoutSize', type: 'SHORT', value: 49},
        {name: 'yStrikeoutPosition', type: 'SHORT', value: 258},
        {name: 'sFamilyClass', type: 'SHORT', value: 0},
        {name: 'bFamilyType', type: 'BYTE', value: 0},
        {name: 'bSerifStyle', type: 'BYTE', value: 0},
        {name: 'bWeight', type: 'BYTE', value: 0},
        {name: 'bProportion', type: 'BYTE', value: 0},
        {name: 'bContrast', type: 'BYTE', value: 0},
        {name: 'bStrokeVariation', type: 'BYTE', value: 0},
        {name: 'bArmStyle', type: 'BYTE', value: 0},
        {name: 'bLetterform', type: 'BYTE', value: 0},
        {name: 'bMidline', type: 'BYTE', value: 0},
        {name: 'bXHeight', type: 'BYTE', value: 0},
        {name: 'ulUnicodeRange1', type: 'ULONG', value: 0},
        {name: 'ulUnicodeRange2', type: 'ULONG', value: 0},
        {name: 'ulUnicodeRange3', type: 'ULONG', value: 0},
        {name: 'ulUnicodeRange4', type: 'ULONG', value: 0},
        {name: 'achVendID', type: 'CHARARRAY', value: 'XXXX'},
        {name: 'fsSelection', type: 'USHORT', value: 0},
        {name: 'usFirstCharIndex', type: 'USHORT', value: 0},
        {name: 'usLastCharIndex', type: 'USHORT', value: 0},
        {name: 'sTypoAscender', type: 'SHORT', value: 0},
        {name: 'sTypoDescender', type: 'SHORT', value: 0},
        {name: 'sTypoLineGap', type: 'SHORT', value: 0},
        {name: 'usWinAscent', type: 'USHORT', value: 0},
        {name: 'usWinDescent', type: 'USHORT', value: 0},
        {name: 'ulCodePageRange1', type: 'ULONG', value: 0},
        {name: 'ulCodePageRange2', type: 'ULONG', value: 0},
        {name: 'sxHeight', type: 'SHORT', value: 0},
        {name: 'sCapHeight', type: 'SHORT', value: 0},
        {name: 'usDefaultChar', type: 'USHORT', value: 0},
        {name: 'usBreakChar', type: 'USHORT', value: 0},
        {name: 'usMaxContext', type: 'USHORT', value: 0}
    ], options);
}

exports.unicodeRanges = unicodeRanges;
exports.getUnicodeRange = getUnicodeRange;
exports.parse = parseOS2Table;
exports.make = makeOS2Table;

},{"../parse":11,"../table":13}],28:[function(_dereq_,module,exports){
// The `post` table stores additional PostScript information, such as glyph names.
// https://www.microsoft.com/typography/OTSPEC/post.htm

'use strict';

var encoding = _dereq_('../encoding');
var parse = _dereq_('../parse');
var table = _dereq_('../table');

// Parse the PostScript `post` table
function parsePostTable(data, start) {
    var post = {};
    var p = new parse.Parser(data, start);
    var i;
    post.version = p.parseVersion();
    post.italicAngle = p.parseFixed();
    post.underlinePosition = p.parseShort();
    post.underlineThickness = p.parseShort();
    post.isFixedPitch = p.parseULong();
    post.minMemType42 = p.parseULong();
    post.maxMemType42 = p.parseULong();
    post.minMemType1 = p.parseULong();
    post.maxMemType1 = p.parseULong();
    switch (post.version) {
    case 1:
        post.names = encoding.standardNames.slice();
        break;
    case 2:
        post.numberOfGlyphs = p.parseUShort();
        post.glyphNameIndex = new Array(post.numberOfGlyphs);
        for (i = 0; i < post.numberOfGlyphs; i++) {
            post.glyphNameIndex[i] = p.parseUShort();
        }

        post.names = [];
        for (i = 0; i < post.numberOfGlyphs; i++) {
            if (post.glyphNameIndex[i] >= encoding.standardNames.length) {
                var nameLength = p.parseChar();
                post.names.push(p.parseString(nameLength));
            }
        }

        break;
    case 2.5:
        post.numberOfGlyphs = p.parseUShort();
        post.offset = new Array(post.numberOfGlyphs);
        for (i = 0; i < post.numberOfGlyphs; i++) {
            post.offset[i] = p.parseChar();
        }

        break;
    }
    return post;
}

function makePostTable() {
    return new table.Table('post', [
        {name: 'version', type: 'FIXED', value: 0x00030000},
        {name: 'italicAngle', type: 'FIXED', value: 0},
        {name: 'underlinePosition', type: 'FWORD', value: 0},
        {name: 'underlineThickness', type: 'FWORD', value: 0},
        {name: 'isFixedPitch', type: 'ULONG', value: 0},
        {name: 'minMemType42', type: 'ULONG', value: 0},
        {name: 'maxMemType42', type: 'ULONG', value: 0},
        {name: 'minMemType1', type: 'ULONG', value: 0},
        {name: 'maxMemType1', type: 'ULONG', value: 0}
    ]);
}

exports.parse = parsePostTable;
exports.make = makePostTable;

},{"../encoding":6,"../parse":11,"../table":13}],29:[function(_dereq_,module,exports){
// The `sfnt` wrapper provides organization for the tables in the font.
// It is the top-level data structure in a font.
// https://www.microsoft.com/typography/OTSPEC/otff.htm
// Recommendations for creating OpenType Fonts:
// http://www.microsoft.com/typography/otspec140/recom.htm

'use strict';

var check = _dereq_('../check');
var table = _dereq_('../table');

var cmap = _dereq_('./cmap');
var cff = _dereq_('./cff');
var head = _dereq_('./head');
var hhea = _dereq_('./hhea');
var hmtx = _dereq_('./hmtx');
var ltag = _dereq_('./ltag');
var maxp = _dereq_('./maxp');
var _name = _dereq_('./name');
var os2 = _dereq_('./os2');
var post = _dereq_('./post');

function log2(v) {
    return Math.log(v) / Math.log(2) | 0;
}

function computeCheckSum(bytes) {
    while (bytes.length % 4 !== 0) {
        bytes.push(0);
    }

    var sum = 0;
    for (var i = 0; i < bytes.length; i += 4) {
        sum += (bytes[i] << 24) +
            (bytes[i + 1] << 16) +
            (bytes[i + 2] << 8) +
            (bytes[i + 3]);
    }

    sum %= Math.pow(2, 32);
    return sum;
}

function makeTableRecord(tag, checkSum, offset, length) {
    return new table.Table('Table Record', [
        {name: 'tag', type: 'TAG', value: tag !== undefined ? tag : ''},
        {name: 'checkSum', type: 'ULONG', value: checkSum !== undefined ? checkSum : 0},
        {name: 'offset', type: 'ULONG', value: offset !== undefined ? offset : 0},
        {name: 'length', type: 'ULONG', value: length !== undefined ? length : 0}
    ]);
}

function makeSfntTable(tables) {
    var sfnt = new table.Table('sfnt', [
        {name: 'version', type: 'TAG', value: 'OTTO'},
        {name: 'numTables', type: 'USHORT', value: 0},
        {name: 'searchRange', type: 'USHORT', value: 0},
        {name: 'entrySelector', type: 'USHORT', value: 0},
        {name: 'rangeShift', type: 'USHORT', value: 0}
    ]);
    sfnt.tables = tables;
    sfnt.numTables = tables.length;
    var highestPowerOf2 = Math.pow(2, log2(sfnt.numTables));
    sfnt.searchRange = 16 * highestPowerOf2;
    sfnt.entrySelector = log2(highestPowerOf2);
    sfnt.rangeShift = sfnt.numTables * 16 - sfnt.searchRange;

    var recordFields = [];
    var tableFields = [];

    var offset = sfnt.sizeOf() + (makeTableRecord().sizeOf() * sfnt.numTables);
    while (offset % 4 !== 0) {
        offset += 1;
        tableFields.push({name: 'padding', type: 'BYTE', value: 0});
    }

    for (var i = 0; i < tables.length; i += 1) {
        var t = tables[i];
        check.argument(t.tableName.length === 4, 'Table name' + t.tableName + ' is invalid.');
        var tableLength = t.sizeOf();
        var tableRecord = makeTableRecord(t.tableName, computeCheckSum(t.encode()), offset, tableLength);
        recordFields.push({name: tableRecord.tag + ' Table Record', type: 'TABLE', value: tableRecord});
        tableFields.push({name: t.tableName + ' table', type: 'TABLE', value: t});
        offset += tableLength;
        check.argument(!isNaN(offset), 'Something went wrong calculating the offset.');
        while (offset % 4 !== 0) {
            offset += 1;
            tableFields.push({name: 'padding', type: 'BYTE', value: 0});
        }
    }

    // Table records need to be sorted alphabetically.
    recordFields.sort(function(r1, r2) {
        if (r1.value.tag > r2.value.tag) {
            return 1;
        } else {
            return -1;
        }
    });

    sfnt.fields = sfnt.fields.concat(recordFields);
    sfnt.fields = sfnt.fields.concat(tableFields);
    return sfnt;
}

// Get the metrics for a character. If the string has more than one character
// this function returns metrics for the first available character.
// You can provide optional fallback metrics if no characters are available.
function metricsForChar(font, chars, notFoundMetrics) {
    for (var i = 0; i < chars.length; i += 1) {
        var glyphIndex = font.charToGlyphIndex(chars[i]);
        if (glyphIndex > 0) {
            var glyph = font.glyphs.get(glyphIndex);
            return glyph.getMetrics();
        }
    }

    return notFoundMetrics;
}

function average(vs) {
    var sum = 0;
    for (var i = 0; i < vs.length; i += 1) {
        sum += vs[i];
    }

    return sum / vs.length;
}

// Convert the font object to a SFNT data structure.
// This structure contains all the necessary tables and metadata to create a binary OTF file.
function fontToSfntTable(font) {
    var xMins = [];
    var yMins = [];
    var xMaxs = [];
    var yMaxs = [];
    var advanceWidths = [];
    var leftSideBearings = [];
    var rightSideBearings = [];
    var firstCharIndex;
    var lastCharIndex = 0;
    var ulUnicodeRange1 = 0;
    var ulUnicodeRange2 = 0;
    var ulUnicodeRange3 = 0;
    var ulUnicodeRange4 = 0;

    for (var i = 0; i < font.glyphs.length; i += 1) {
        var glyph = font.glyphs.get(i);
        var unicode = glyph.unicode | 0;
        if (firstCharIndex > unicode || firstCharIndex === null) {
            firstCharIndex = unicode;
        }

        if (lastCharIndex < unicode) {
            lastCharIndex = unicode;
        }

        var position = os2.getUnicodeRange(unicode);
        if (position < 32) {
            ulUnicodeRange1 |= 1 << position;
        } else if (position < 64) {
            ulUnicodeRange2 |= 1 << position - 32;
        } else if (position < 96) {
            ulUnicodeRange3 |= 1 << position - 64;
        } else if (position < 123) {
            ulUnicodeRange4 |= 1 << position - 96;
        } else {
            throw new Error('Unicode ranges bits > 123 are reserved for internal usage');
        }
        // Skip non-important characters.
        if (glyph.name === '.notdef') continue;
        var metrics = glyph.getMetrics();
        xMins.push(metrics.xMin);
        yMins.push(metrics.yMin);
        xMaxs.push(metrics.xMax);
        yMaxs.push(metrics.yMax);
        leftSideBearings.push(metrics.leftSideBearing);
        rightSideBearings.push(metrics.rightSideBearing);
        advanceWidths.push(glyph.advanceWidth);
    }

    var globals = {
        xMin: Math.min.apply(null, xMins),
        yMin: Math.min.apply(null, yMins),
        xMax: Math.max.apply(null, xMaxs),
        yMax: Math.max.apply(null, yMaxs),
        advanceWidthMax: Math.max.apply(null, advanceWidths),
        advanceWidthAvg: average(advanceWidths),
        minLeftSideBearing: Math.min.apply(null, leftSideBearings),
        maxLeftSideBearing: Math.max.apply(null, leftSideBearings),
        minRightSideBearing: Math.min.apply(null, rightSideBearings)
    };
    globals.ascender = font.ascender !== undefined ? font.ascender : globals.yMax;
    globals.descender = font.descender !== undefined ? font.descender : globals.yMin;

    var headTable = head.make({
        unitsPerEm: font.unitsPerEm,
        xMin: globals.xMin,
        yMin: globals.yMin,
        xMax: globals.xMax,
        yMax: globals.yMax
    });

    var hheaTable = hhea.make({
        ascender: globals.ascender,
        descender: globals.descender,
        advanceWidthMax: globals.advanceWidthMax,
        minLeftSideBearing: globals.minLeftSideBearing,
        minRightSideBearing: globals.minRightSideBearing,
        xMaxExtent: globals.maxLeftSideBearing + (globals.xMax - globals.xMin),
        numberOfHMetrics: font.glyphs.length
    });

    var maxpTable = maxp.make(font.glyphs.length);

    var os2Table = os2.make({
        xAvgCharWidth: Math.round(globals.advanceWidthAvg),
        usWeightClass: 500, // Medium FIXME Make this configurable
        usWidthClass: 5, // Medium (normal) FIXME Make this configurable
        usFirstCharIndex: firstCharIndex,
        usLastCharIndex: lastCharIndex,
        ulUnicodeRange1: ulUnicodeRange1,
        ulUnicodeRange2: ulUnicodeRange2,
        ulUnicodeRange3: ulUnicodeRange3,
        ulUnicodeRange4: ulUnicodeRange4,
        // See http://typophile.com/node/13081 for more info on vertical metrics.
        // We get metrics for typical characters (such as "x" for xHeight).
        // We provide some fallback characters if characters are unavailable: their
        // ordering was chosen experimentally.
        sTypoAscender: globals.ascender,
        sTypoDescender: globals.descender,
        sTypoLineGap: 0,
        usWinAscent: globals.ascender,
        usWinDescent: -globals.descender,
        sxHeight: metricsForChar(font, 'xyvw', {yMax: 0}).yMax,
        sCapHeight: metricsForChar(font, 'HIKLEFJMNTZBDPRAGOQSUVWXY', globals).yMax,
        usBreakChar: font.hasChar(' ') ? 32 : 0 // Use space as the break character, if available.
    });

    var hmtxTable = hmtx.make(font.glyphs);
    var cmapTable = cmap.make(font.glyphs);

    var englishFamilyName = font.getEnglishName('fontFamily');
    var englishStyleName = font.getEnglishName('fontSubfamily');
    var englishFullName = englishFamilyName + ' ' + englishStyleName;
    var postScriptName = font.getEnglishName('postScriptName');
    if (!postScriptName) {
        postScriptName = englishFamilyName.replace(/\s/g, '') + '-' + englishStyleName;
    }

    var names = {};
    for (var n in font.names) {
        names[n] = font.names[n];
    }

    if (!names.uniqueID) {
        names.uniqueID = {en: font.getEnglishName('manufacturer') + ':' + englishFullName};
    }

    if (!names.postScriptName) {
        names.postScriptName = {en: postScriptName};
    }

    if (!names.preferredFamily) {
        names.preferredFamily = font.names.fontFamily;
    }

    if (!names.preferredSubfamily) {
        names.preferredSubfamily = font.names.fontSubfamily;
    }

    var languageTags = [];
    var nameTable = _name.make(names, languageTags);
    var ltagTable = (languageTags.length > 0 ? ltag.make(languageTags) : undefined);

    var postTable = post.make();
    var cffTable = cff.make(font.glyphs, {
        version: font.getEnglishName('version'),
        fullName: englishFullName,
        familyName: englishFamilyName,
        weightName: englishStyleName,
        postScriptName: postScriptName,
        unitsPerEm: font.unitsPerEm
    });

    // The order does not matter because makeSfntTable() will sort them.
    var tables = [headTable, hheaTable, maxpTable, os2Table, nameTable, cmapTable, postTable, cffTable, hmtxTable];
    if (ltagTable) {
        tables.push(ltagTable);
    }

    var sfntTable = makeSfntTable(tables);

    // Compute the font's checkSum and store it in head.checkSumAdjustment.
    var bytes = sfntTable.encode();
    var checkSum = computeCheckSum(bytes);
    var tableFields = sfntTable.fields;
    var checkSumAdjusted = false;
    for (i = 0; i < tableFields.length; i += 1) {
        if (tableFields[i].name === 'head table') {
            tableFields[i].value.checkSumAdjustment = 0xB1B0AFBA - checkSum;
            checkSumAdjusted = true;
            break;
        }
    }

    if (!checkSumAdjusted) {
        throw new Error('Could not find head table with checkSum to adjust.');
    }

    return sfntTable;
}

exports.computeCheckSum = computeCheckSum;
exports.make = makeSfntTable;
exports.fontToTable = fontToSfntTable;

},{"../check":4,"../table":13,"./cff":14,"./cmap":15,"./head":19,"./hhea":20,"./hmtx":21,"./ltag":24,"./maxp":25,"./name":26,"./os2":27,"./post":28}],30:[function(_dereq_,module,exports){
// Data types used in the OpenType font file.
// All OpenType fonts use Motorola-style byte ordering (Big Endian)

/* global WeakMap */

'use strict';

var check = _dereq_('./check');

var LIMIT16 = 32768; // The limit at which a 16-bit number switches signs == 2^15
var LIMIT32 = 2147483648; // The limit at which a 32-bit number switches signs == 2 ^ 31

var decode = {};
var encode = {};
var sizeOf = {};

// Return a function that always returns the same value.
function constant(v) {
    return function() {
        return v;
    };
}

// OpenType data types //////////////////////////////////////////////////////

// Convert an 8-bit unsigned integer to a list of 1 byte.
encode.BYTE = function(v) {
    check.argument(v >= 0 && v <= 255, 'Byte value should be between 0 and 255.');
    return [v];
};

sizeOf.BYTE = constant(1);

// Convert a 8-bit signed integer to a list of 1 byte.
encode.CHAR = function(v) {
    return [v.charCodeAt(0)];
};

sizeOf.CHAR = constant(1);

// Convert an ASCII string to a list of bytes.
encode.CHARARRAY = function(v) {
    var b = [];
    for (var i = 0; i < v.length; i += 1) {
        b.push(v.charCodeAt(i));
    }

    return b;
};

sizeOf.CHARARRAY = function(v) {
    return v.length;
};

// Convert a 16-bit unsigned integer to a list of 2 bytes.
encode.USHORT = function(v) {
    return [(v >> 8) & 0xFF, v & 0xFF];
};

sizeOf.USHORT = constant(2);

// Convert a 16-bit signed integer to a list of 2 bytes.
encode.SHORT = function(v) {
    // Two's complement
    if (v >= LIMIT16) {
        v = -(2 * LIMIT16 - v);
    }

    return [(v >> 8) & 0xFF, v & 0xFF];
};

sizeOf.SHORT = constant(2);

// Convert a 24-bit unsigned integer to a list of 3 bytes.
encode.UINT24 = function(v) {
    return [(v >> 16) & 0xFF, (v >> 8) & 0xFF, v & 0xFF];
};

sizeOf.UINT24 = constant(3);

// Convert a 32-bit unsigned integer to a list of 4 bytes.
encode.ULONG = function(v) {
    return [(v >> 24) & 0xFF, (v >> 16) & 0xFF, (v >> 8) & 0xFF, v & 0xFF];
};

sizeOf.ULONG = constant(4);

// Convert a 32-bit unsigned integer to a list of 4 bytes.
encode.LONG = function(v) {
    // Two's complement
    if (v >= LIMIT32) {
        v = -(2 * LIMIT32 - v);
    }

    return [(v >> 24) & 0xFF, (v >> 16) & 0xFF, (v >> 8) & 0xFF, v & 0xFF];
};

sizeOf.LONG = constant(4);

encode.FIXED = encode.ULONG;
sizeOf.FIXED = sizeOf.ULONG;

encode.FWORD = encode.SHORT;
sizeOf.FWORD = sizeOf.SHORT;

encode.UFWORD = encode.USHORT;
sizeOf.UFWORD = sizeOf.USHORT;

// FIXME Implement LONGDATETIME
encode.LONGDATETIME = function() {
    return [0, 0, 0, 0, 0, 0, 0, 0];
};

sizeOf.LONGDATETIME = constant(8);

// Convert a 4-char tag to a list of 4 bytes.
encode.TAG = function(v) {
    check.argument(v.length === 4, 'Tag should be exactly 4 ASCII characters.');
    return [v.charCodeAt(0),
            v.charCodeAt(1),
            v.charCodeAt(2),
            v.charCodeAt(3)];
};

sizeOf.TAG = constant(4);

// CFF data types ///////////////////////////////////////////////////////////

encode.Card8 = encode.BYTE;
sizeOf.Card8 = sizeOf.BYTE;

encode.Card16 = encode.USHORT;
sizeOf.Card16 = sizeOf.USHORT;

encode.OffSize = encode.BYTE;
sizeOf.OffSize = sizeOf.BYTE;

encode.SID = encode.USHORT;
sizeOf.SID = sizeOf.USHORT;

// Convert a numeric operand or charstring number to a variable-size list of bytes.
encode.NUMBER = function(v) {
    if (v >= -107 && v <= 107) {
        return [v + 139];
    } else if (v >= 108 && v <= 1131) {
        v = v - 108;
        return [(v >> 8) + 247, v & 0xFF];
    } else if (v >= -1131 && v <= -108) {
        v = -v - 108;
        return [(v >> 8) + 251, v & 0xFF];
    } else if (v >= -32768 && v <= 32767) {
        return encode.NUMBER16(v);
    } else {
        return encode.NUMBER32(v);
    }
};

sizeOf.NUMBER = function(v) {
    return encode.NUMBER(v).length;
};

// Convert a signed number between -32768 and +32767 to a three-byte value.
// This ensures we always use three bytes, but is not the most compact format.
encode.NUMBER16 = function(v) {
    return [28, (v >> 8) & 0xFF, v & 0xFF];
};

sizeOf.NUMBER16 = constant(3);

// Convert a signed number between -(2^31) and +(2^31-1) to a five-byte value.
// This is useful if you want to be sure you always use four bytes,
// at the expense of wasting a few bytes for smaller numbers.
encode.NUMBER32 = function(v) {
    return [29, (v >> 24) & 0xFF, (v >> 16) & 0xFF, (v >> 8) & 0xFF, v & 0xFF];
};

sizeOf.NUMBER32 = constant(5);

encode.REAL = function(v) {
    var value = v.toString();

    // Some numbers use an epsilon to encode the value. (e.g. JavaScript will store 0.0000001 as 1e-7)
    // This code converts it back to a number without the epsilon.
    var m = /\.(\d*?)(?:9{5,20}|0{5,20})\d{0,2}(?:e(.+)|$)/.exec(value);
    if (m) {
        var epsilon = parseFloat('1e' + ((m[2] ? +m[2] : 0) + m[1].length));
        value = (Math.round(v * epsilon) / epsilon).toString();
    }

    var nibbles = '';
    var i;
    var ii;
    for (i = 0, ii = value.length; i < ii; i += 1) {
        var c = value[i];
        if (c === 'e') {
            nibbles += value[++i] === '-' ? 'c' : 'b';
        } else if (c === '.') {
            nibbles += 'a';
        } else if (c === '-') {
            nibbles += 'e';
        } else {
            nibbles += c;
        }
    }

    nibbles += (nibbles.length & 1) ? 'f' : 'ff';
    var out = [30];
    for (i = 0, ii = nibbles.length; i < ii; i += 2) {
        out.push(parseInt(nibbles.substr(i, 2), 16));
    }

    return out;
};

sizeOf.REAL = function(v) {
    return encode.REAL(v).length;
};

encode.NAME = encode.CHARARRAY;
sizeOf.NAME = sizeOf.CHARARRAY;

encode.STRING = encode.CHARARRAY;
sizeOf.STRING = sizeOf.CHARARRAY;

decode.UTF16 = function(data, offset, numBytes) {
    var codePoints = [];
    var numChars = numBytes / 2;
    for (var j = 0; j < numChars; j++, offset += 2) {
        codePoints[j] = data.getUint16(offset);
    }

    return String.fromCharCode.apply(null, codePoints);
};

// Convert a JavaScript string to UTF16-BE.
encode.UTF16 = function(v) {
    var b = [];
    for (var i = 0; i < v.length; i += 1) {
        var codepoint = v.charCodeAt(i);
        b.push((codepoint >> 8) & 0xFF);
        b.push(codepoint & 0xFF);
    }

    return b;
};

sizeOf.UTF16 = function(v) {
    return v.length * 2;
};

// Data for converting old eight-bit Macintosh encodings to Unicode.
// This representation is optimized for decoding; encoding is slower
// and needs more memory. The assumption is that all opentype.js users
// want to open fonts, but saving a font will be comperatively rare
// so it can be more expensive. Keyed by IANA character set name.
//
// Python script for generating these strings:
//
//     s = u''.join([chr(c).decode('mac_greek') for c in range(128, 256)])
//     print(s.encode('utf-8'))
var eightBitMacEncodings = {
    'x-mac-croatian':  // Python: 'mac_croatian'
        'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®Š™´¨≠ŽØ∞±≤≥∆µ∂∑∏š∫ªºΩžø' +
        '¿¡¬√ƒ≈Ć«Č… ÀÃÕŒœĐ—“”‘’÷◊©⁄€‹›Æ»–·‚„‰ÂćÁčÈÍÎÏÌÓÔđÒÚÛÙıˆ˜¯πË˚¸Êæˇ',
    'x-mac-cyrillic':  // Python: 'mac_cyrillic'
        'АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°Ґ£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµґЈЄєЇїЉљЊњ' +
        'јЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю',
    'x-mac-gaelic':
        // http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/GAELIC.TXT
        'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØḂ±≤≥ḃĊċḊḋḞḟĠġṀæø' +
        'ṁṖṗɼƒſṠ«»… ÀÃÕŒœ–—“”‘’ṡẛÿŸṪ€‹›Ŷŷṫ·Ỳỳ⁊ÂÊÁËÈÍÎÏÌÓÔ♣ÒÚÛÙıÝýŴŵẄẅẀẁẂẃ',
    'x-mac-greek':  // Python: 'mac_greek'
        'Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦€ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩ' +
        'άΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ\u00AD',
    'x-mac-icelandic':  // Python: 'mac_iceland'
        'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø' +
        '¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ',
    'x-mac-inuit':
        // http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/INUIT.TXT
        'ᐃᐄᐅᐆᐊᐋᐱᐲᐳᐴᐸᐹᑉᑎᑏᑐᑑᑕᑖᑦᑭᑮᑯᑰᑲᑳᒃᒋᒌᒍᒎᒐᒑ°ᒡᒥᒦ•¶ᒧ®©™ᒨᒪᒫᒻᓂᓃᓄᓅᓇᓈᓐᓯᓰᓱᓲᓴᓵᔅᓕᓖᓗ' +
        'ᓘᓚᓛᓪᔨᔩᔪᔫᔭ… ᔮᔾᕕᕖᕗ–—“”‘’ᕘᕙᕚᕝᕆᕇᕈᕉᕋᕌᕐᕿᖀᖁᖂᖃᖄᖅᖏᖐᖑᖒᖓᖔᖕᙱᙲᙳᙴᙵᙶᖖᖠᖡᖢᖣᖤᖥᖦᕼŁł',
    'x-mac-ce':  // Python: 'mac_latin2'
        'ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅ' +
        'ņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ',
    macintosh:  // Python: 'mac_roman'
        'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø' +
        '¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ',
    'x-mac-romanian':  // Python: 'mac_romanian'
        'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ĂȘ∞±≤≥¥µ∂∑∏π∫ªºΩăș' +
        '¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€‹›Țț‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ',
    'x-mac-turkish':  // Python: 'mac_turkish'
        'ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø' +
        '¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙˆ˜¯˘˙˚¸˝˛ˇ'
};

// Decodes an old-style Macintosh string. Returns either a Unicode JavaScript
// string, or 'undefined' if the encoding is unsupported. For example, we do
// not support Chinese, Japanese or Korean because these would need large
// mapping tables.
decode.MACSTRING = function(dataView, offset, dataLength, encoding) {
    var table = eightBitMacEncodings[encoding];
    if (table === undefined) {
        return undefined;
    }

    var result = '';
    for (var i = 0; i < dataLength; i++) {
        var c = dataView.getUint8(offset + i);
        // In all eight-bit Mac encodings, the characters 0x00..0x7F are
        // mapped to U+0000..U+007F; we only need to look up the others.
        if (c <= 0x7F) {
            result += String.fromCharCode(c);
        } else {
            result += table[c & 0x7F];
        }
    }

    return result;
};

// Helper function for encode.MACSTRING. Returns a dictionary for mapping
// Unicode character codes to their 8-bit MacOS equivalent. This table
// is not exactly a super cheap data structure, but we do not care because
// encoding Macintosh strings is only rarely needed in typical applications.
var macEncodingTableCache = typeof WeakMap === 'function' && new WeakMap();
var macEncodingCacheKeys;
var getMacEncodingTable = function(encoding) {
    // Since we use encoding as a cache key for WeakMap, it has to be
    // a String object and not a literal. And at least on NodeJS 2.10.1,
    // WeakMap requires that the same String instance is passed for cache hits.
    if (!macEncodingCacheKeys) {
        macEncodingCacheKeys = {};
        for (var e in eightBitMacEncodings) {
            /*jshint -W053 */  // Suppress "Do not use String as a constructor."
            macEncodingCacheKeys[e] = new String(e);
        }
    }

    var cacheKey = macEncodingCacheKeys[encoding];
    if (cacheKey === undefined) {
        return undefined;
    }

    // We can't do "if (cache.has(key)) {return cache.get(key)}" here:
    // since garbage collection may run at any time, it could also kick in
    // between the calls to cache.has() and cache.get(). In that case,
    // we would return 'undefined' even though we do support the encoding.
    if (macEncodingTableCache) {
        var cachedTable = macEncodingTableCache.get(cacheKey);
        if (cachedTable !== undefined) {
            return cachedTable;
        }
    }

    var decodingTable = eightBitMacEncodings[encoding];
    if (decodingTable === undefined) {
        return undefined;
    }

    var encodingTable = {};
    for (var i = 0; i < decodingTable.length; i++) {
        encodingTable[decodingTable.charCodeAt(i)] = i + 0x80;
    }

    if (macEncodingTableCache) {
        macEncodingTableCache.set(cacheKey, encodingTable);
    }

    return encodingTable;
};

// Encodes an old-style Macintosh string. Returns a byte array upon success.
// If the requested encoding is unsupported, or if the input string contains
// a character that cannot be expressed in the encoding, the function returns
// 'undefined'.
encode.MACSTRING = function(str, encoding) {
    var table = getMacEncodingTable(encoding);
    if (table === undefined) {
        return undefined;
    }

    var result = [];
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);

        // In all eight-bit Mac encodings, the characters 0x00..0x7F are
        // mapped to U+0000..U+007F; we only need to look up the others.
        if (c >= 0x80) {
            c = table[c];
            if (c === undefined) {
                // str contains a Unicode character that cannot be encoded
                // in the requested encoding.
                return undefined;
            }
        }

        result.push(c);
    }

    return result;
};

sizeOf.MACSTRING = function(str, encoding) {
    var b = encode.MACSTRING(str, encoding);
    if (b !== undefined) {
        return b.length;
    } else {
        return 0;
    }
};

// Convert a list of values to a CFF INDEX structure.
// The values should be objects containing name / type / value.
encode.INDEX = function(l) {
    var i;
    //var offset, offsets, offsetEncoder, encodedOffsets, encodedOffset, data,
    //    dataSize, i, v;
    // Because we have to know which data type to use to encode the offsets,
    // we have to go through the values twice: once to encode the data and
    // calculate the offets, then again to encode the offsets using the fitting data type.
    var offset = 1; // First offset is always 1.
    var offsets = [offset];
    var data = [];
    var dataSize = 0;
    for (i = 0; i < l.length; i += 1) {
        var v = encode.OBJECT(l[i]);
        Array.prototype.push.apply(data, v);
        dataSize += v.length;
        offset += v.length;
        offsets.push(offset);
    }

    if (data.length === 0) {
        return [0, 0];
    }

    var encodedOffsets = [];
    var offSize = (1 + Math.floor(Math.log(dataSize) / Math.log(2)) / 8) | 0;
    var offsetEncoder = [undefined, encode.BYTE, encode.USHORT, encode.UINT24, encode.ULONG][offSize];
    for (i = 0; i < offsets.length; i += 1) {
        var encodedOffset = offsetEncoder(offsets[i]);
        Array.prototype.push.apply(encodedOffsets, encodedOffset);
    }

    return Array.prototype.concat(encode.Card16(l.length),
                           encode.OffSize(offSize),
                           encodedOffsets,
                           data);
};

sizeOf.INDEX = function(v) {
    return encode.INDEX(v).length;
};

// Convert an object to a CFF DICT structure.
// The keys should be numeric.
// The values should be objects containing name / type / value.
encode.DICT = function(m) {
    var d = [];
    var keys = Object.keys(m);
    var length = keys.length;

    for (var i = 0; i < length; i += 1) {
        // Object.keys() return string keys, but our keys are always numeric.
        var k = parseInt(keys[i], 0);
        var v = m[k];
        // Value comes before the key.
        d = d.concat(encode.OPERAND(v.value, v.type));
        d = d.concat(encode.OPERATOR(k));
    }

    return d;
};

sizeOf.DICT = function(m) {
    return encode.DICT(m).length;
};

encode.OPERATOR = function(v) {
    if (v < 1200) {
        return [v];
    } else {
        return [12, v - 1200];
    }
};

encode.OPERAND = function(v, type) {
    var d = [];
    if (Array.isArray(type)) {
        for (var i = 0; i < type.length; i += 1) {
            check.argument(v.length === type.length, 'Not enough arguments given for type' + type);
            d = d.concat(encode.OPERAND(v[i], type[i]));
        }
    } else {
        if (type === 'SID') {
            d = d.concat(encode.NUMBER(v));
        } else if (type === 'offset') {
            // We make it easy for ourselves and always encode offsets as
            // 4 bytes. This makes offset calculation for the top dict easier.
            d = d.concat(encode.NUMBER32(v));
        } else if (type === 'number') {
            d = d.concat(encode.NUMBER(v));
        } else if (type === 'real') {
            d = d.concat(encode.REAL(v));
        } else {
            throw new Error('Unknown operand type ' + type);
            // FIXME Add support for booleans
        }
    }

    return d;
};

encode.OP = encode.BYTE;
sizeOf.OP = sizeOf.BYTE;

// memoize charstring encoding using WeakMap if available
var wmm = typeof WeakMap === 'function' && new WeakMap();
// Convert a list of CharString operations to bytes.
encode.CHARSTRING = function(ops) {
    // See encode.MACSTRING for why we don't do "if (wmm && wmm.has(ops))".
    if (wmm) {
        var cachedValue = wmm.get(ops);
        if (cachedValue !== undefined) {
            return cachedValue;
        }
    }

    var d = [];
    var length = ops.length;

    for (var i = 0; i < length; i += 1) {
        var op = ops[i];
        d = d.concat(encode[op.type](op.value));
    }

    if (wmm) {
        wmm.set(ops, d);
    }

    return d;
};

sizeOf.CHARSTRING = function(ops) {
    return encode.CHARSTRING(ops).length;
};

// Utility functions ////////////////////////////////////////////////////////

// Convert an object containing name / type / value to bytes.
encode.OBJECT = function(v) {
    var encodingFunction = encode[v.type];
    check.argument(encodingFunction !== undefined, 'No encoding function for type ' + v.type);
    return encodingFunction(v.value);
};

sizeOf.OBJECT = function(v) {
    var sizeOfFunction = sizeOf[v.type];
    check.argument(sizeOfFunction !== undefined, 'No sizeOf function for type ' + v.type);
    return sizeOfFunction(v.value);
};

// Convert a table object to bytes.
// A table contains a list of fields containing the metadata (name, type and default value).
// The table itself has the field values set as attributes.
encode.TABLE = function(table) {
    var d = [];
    var length = table.fields.length;

    for (var i = 0; i < length; i += 1) {
        var field = table.fields[i];
        var encodingFunction = encode[field.type];
        check.argument(encodingFunction !== undefined, 'No encoding function for field type ' + field.type);
        var value = table[field.name];
        if (value === undefined) {
            value = field.value;
        }

        var bytes = encodingFunction(value);
        d = d.concat(bytes);
    }

    return d;
};

sizeOf.TABLE = function(table) {
    var numBytes = 0;
    var length = table.fields.length;

    for (var i = 0; i < length; i += 1) {
        var field = table.fields[i];
        var sizeOfFunction = sizeOf[field.type];
        check.argument(sizeOfFunction !== undefined, 'No sizeOf function for field type ' + field.type);
        var value = table[field.name];
        if (value === undefined) {
            value = field.value;
        }

        numBytes += sizeOfFunction(value);
    }

    return numBytes;
};

// Merge in a list of bytes.
encode.LITERAL = function(v) {
    return v;
};

sizeOf.LITERAL = function(v) {
    return v.length;
};

exports.decode = decode;
exports.encode = encode;
exports.sizeOf = sizeOf;

},{"./check":4}],31:[function(_dereq_,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],32:[function(_dereq_,module,exports){
(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);

},{}],33:[function(_dereq_,module,exports){

'use strict';

var p5 = _dereq_('./core/core');
_dereq_('./color/p5.Color');
_dereq_('./core/p5.Element');
_dereq_('./typography/p5.Font');
_dereq_('./core/p5.Graphics');
_dereq_('./core/p5.Renderer2D');

_dereq_('./image/p5.Image');
_dereq_('./math/p5.Vector');
_dereq_('./io/p5.TableRow');
_dereq_('./io/p5.Table');
_dereq_('./io/p5.XML');

_dereq_('./color/creating_reading');
_dereq_('./color/setting');
_dereq_('./core/constants');
_dereq_('./utilities/conversion');
_dereq_('./utilities/array_functions');
_dereq_('./utilities/string_functions');
_dereq_('./core/environment');
_dereq_('./image/image');
_dereq_('./image/loading_displaying');
_dereq_('./image/pixels');
_dereq_('./io/files');
_dereq_('./events/keyboard');
_dereq_('./events/acceleration'); //john
_dereq_('./events/mouse');
_dereq_('./utilities/time_date');
_dereq_('./events/touch');
_dereq_('./math/math');
_dereq_('./math/calculation');
_dereq_('./math/random');
_dereq_('./math/noise');
_dereq_('./math/trigonometry');
_dereq_('./core/rendering');
_dereq_('./core/2d_primitives');

_dereq_('./core/attributes');
_dereq_('./core/curves');
_dereq_('./core/vertex');
_dereq_('./core/structure');
_dereq_('./core/transform');
_dereq_('./typography/attributes');
_dereq_('./typography/loading_displaying');

_dereq_('./webgl/p5.RendererGL');
_dereq_('./webgl/p5.Geometry');
_dereq_('./webgl/p5.RendererGL.Retained');
_dereq_('./webgl/p5.RendererGL.Immediate');
_dereq_('./webgl/primitives');
_dereq_('./webgl/loading');
_dereq_('./webgl/p5.Matrix');
_dereq_('./webgl/material');
_dereq_('./webgl/light');
_dereq_('./webgl/shader');
_dereq_('./webgl/camera');
_dereq_('./webgl/interaction');

/**
 * _globalInit
 *
 * TODO: ???
 * if sketch is on window
 * assume "global" mode
 * and instantiate p5 automatically
 * otherwise do nothing
 *
 * @return {Undefined}
 */
var _globalInit = function() {
  if (!window.PHANTOMJS && !window.mocha) {
    // If there is a setup or draw function on the window
    // then instantiate p5 in "global" mode
    if(((window.setup && typeof window.setup === 'function') ||
       (window.draw && typeof window.draw === 'function')) &&
       !p5.instance) {
      new p5();
    }
  }
};

// TODO: ???
if (document.readyState === 'complete') {
  _globalInit();
} else {
  window.addEventListener('load', _globalInit , false);
}

module.exports = p5;

},{"./color/creating_reading":35,"./color/p5.Color":36,"./color/setting":37,"./core/2d_primitives":38,"./core/attributes":39,"./core/constants":41,"./core/core":42,"./core/curves":43,"./core/environment":44,"./core/p5.Element":46,"./core/p5.Graphics":47,"./core/p5.Renderer2D":49,"./core/rendering":50,"./core/structure":52,"./core/transform":53,"./core/vertex":54,"./events/acceleration":55,"./events/keyboard":56,"./events/mouse":57,"./events/touch":58,"./image/image":60,"./image/loading_displaying":61,"./image/p5.Image":62,"./image/pixels":63,"./io/files":64,"./io/p5.Table":65,"./io/p5.TableRow":66,"./io/p5.XML":67,"./math/calculation":68,"./math/math":69,"./math/noise":70,"./math/p5.Vector":71,"./math/random":73,"./math/trigonometry":74,"./typography/attributes":75,"./typography/loading_displaying":76,"./typography/p5.Font":77,"./utilities/array_functions":78,"./utilities/conversion":79,"./utilities/string_functions":80,"./utilities/time_date":81,"./webgl/camera":82,"./webgl/interaction":83,"./webgl/light":84,"./webgl/loading":85,"./webgl/material":86,"./webgl/p5.Geometry":87,"./webgl/p5.Matrix":88,"./webgl/p5.RendererGL":91,"./webgl/p5.RendererGL.Immediate":89,"./webgl/p5.RendererGL.Retained":90,"./webgl/primitives":92,"./webgl/shader":93}],34:[function(_dereq_,module,exports){
/**
 * module Conversion
 * submodule Color Conversion
 * @for p5
 * @requires core
 */

'use strict';

/**
 * Conversions adapted from <http://www.easyrgb.com/math.html>.
 *
 * In these functions, hue is always in the range [0,1); all other components
 * are in the range [0,1]. 'Brightness' and 'value' are used interchangeably.
 */

var p5 = _dereq_('../core/core');
p5.ColorConversion = {};

/**
 * Convert an HSBA array to HSLA.
 */
p5.ColorConversion._hsbaToHSLA = function(hsba) {
  var hue = hsba[0];
  var sat = hsba[1];
  var val = hsba[2];

  // Calculate lightness.
  var li = (2 - sat) * val / 2;

  // Convert saturation.
  if (li !== 0) {
    if (li === 1) {
      sat = 0;
    } else if (li < 0.5) {
      sat = sat / (2 - sat);
    } else {
      sat = sat * val / (2 - li * 2);
    }
  }

  // Hue and alpha stay the same.
  return [hue, sat, li, hsba[3]];
};

/**
 * Convert an HSBA array to RGBA.
 */
p5.ColorConversion._hsbaToRGBA = function(hsba) {
  var hue = hsba[0] * 6;  // We will split hue into 6 sectors.
  var sat = hsba[1];
  var val = hsba[2];

  var RGBA = [];

  if (sat === 0) {
    RGBA = [val, val, val, hsba[3]];  // Return early if grayscale.
  } else {
    var sector = Math.floor(hue);
    var tint1 = val * (1 - sat);
    var tint2 = val * (1 - sat * (hue - sector));
    var tint3 = val * (1 - sat * (1 + sector - hue));
    var red, green, blue;
    if (sector === 1) {  // Yellow to green.
      red = tint2;
      green = val;
      blue = tint1;
    } else if (sector === 2) {  // Green to cyan.
      red = tint1;
      green = val;
      blue = tint3;
    } else if (sector === 3) {  // Cyan to blue.
      red = tint1;
      green = tint2;
      blue = val;
    } else if (sector === 4) {  // Blue to magenta.
      red = tint3;
      green = tint1;
      blue = val;
    } else if (sector === 5) {  // Magenta to red.
      red = val;
      green = tint1;
      blue = tint2;
    } else {  // Red to yellow (sector could be 0 or 6).
      red = val;
      green = tint3;
      blue = tint1;
    }
    RGBA = [red, green, blue, hsba[3]];
  }

  return RGBA;
};

/**
 * Convert an HSLA array to HSBA.
 */
p5.ColorConversion._hslaToHSBA = function(hsla) {
  var hue = hsla[0];
  var sat = hsla[1];
  var li = hsla[2];

  // Calculate brightness.
  var val;
  if (li < 0.5) {
    val = (1 + sat) * li;
  } else {
    val = li + sat - li * sat;
  }

  // Convert saturation.
  sat = 2 * (val - li) / val;

  // Hue and alpha stay the same.
  return [hue, sat, val, hsla[3]];
};

/**
 * Convert an HSLA array to RGBA.
 *
 * We need to change basis from HSLA to something that can be more easily be
 * projected onto RGBA. We will choose hue and brightness as our first two
 * components, and pick a convenient third one ('zest') so that we don't need
 * to calculate formal HSBA saturation.
 */
p5.ColorConversion._hslaToRGBA = function(hsla){
  var hue = hsla[0] * 6;  // We will split hue into 6 sectors.
  var sat = hsla[1];
  var li = hsla[2];

  var RGBA = [];

  if (sat === 0) {
    RGBA = [li, li, li, hsla[3]]; // Return early if grayscale.
  } else {

    // Calculate brightness.
    var val;
    if (li < 0.5) {
      val = (1 + sat) * li;
    } else {
      val = li + sat - li * sat;
    }

    // Define zest.
    var zest = 2 * li - val;

    // Implement projection (project onto green by default).
    var hzvToRGB = function(hue, zest, val) {
      if (hue < 0) {  // Hue must wrap to allow projection onto red and blue.
        hue += 6;
      } else if (hue >= 6) {
        hue -= 6;
      }
      if (hue < 1) {  // Red to yellow (increasing green).
        return (zest + (val - zest) * hue);
      } else if (hue < 3) {  // Yellow to cyan (greatest green).
        return val;
      } else if (hue < 4) {  // Cyan to blue (decreasing green).
        return (zest + (val - zest) * (4 - hue));
      } else {  // Blue to red (least green).
        return zest;
      }
    };

    // Perform projections, offsetting hue as necessary.
    RGBA = [hzvToRGB(hue + 2, zest, val),
            hzvToRGB(hue    , zest, val),
            hzvToRGB(hue - 2, zest, val),
            hsla[3]];
  }

  return RGBA;
};

/**
 * Convert an RGBA array to HSBA.
 */
p5.ColorConversion._rgbaToHSBA = function(rgba) {
  var red = rgba[0];
  var green = rgba[1];
  var blue = rgba[2];

  var val = Math.max(red, green, blue);
  var chroma = val - Math.min(red, green, blue);

  var hue, sat;
  if (chroma === 0) {  // Return early if grayscale.
    hue = 0;
    sat = 0;
  }
  else {
    sat = chroma / val;
    if (red === val) {  // Magenta to yellow.
      hue = (green - blue) / chroma;
    } else if (green === val) { // Yellow to cyan.
      hue = 2 + (blue - red) / chroma;
    } else if (blue === val) {  // Cyan to magenta.
      hue = 4 + (red - green) / chroma;
    }
    if (hue < 0) {  // Confine hue to the interval [0, 1).
      hue += 6;
    } else if (hue >= 6) {
      hue -= 6;
    }
  }

  return [hue / 6, sat, val, rgba[3]];
};

/**
 * Convert an RGBA array to HSLA.
 */
p5.ColorConversion._rgbaToHSLA = function(rgba) {
  var red = rgba[0];
  var green = rgba[1];
  var blue = rgba[2];

  var val = Math.max(red, green, blue);
  var min = Math.min(red, green, blue);
  var li = val + min;  // We will halve this later.
  var chroma = val - min;

  var hue, sat;
  if (chroma === 0) {  // Return early if grayscale.
    hue = 0;
    sat = 0;
  } else {
    if (li < 1) {
      sat = chroma / li;
    } else {
      sat = chroma / (2 - li);
    }
    if (red === val) {  // Magenta to yellow.
      hue = (green - blue) / chroma;
    } else if (green === val) {  // Yellow to cyan.
      hue = 2 + (blue - red) / chroma;
    } else if (blue === val) {  // Cyan to magenta.
      hue = 4 + (red - green) / chroma;
    }
    if (hue < 0) {  // Confine hue to the interval [0, 1).
      hue += 6;
    } else if (hue >= 6) {
      hue -= 6;
    }
  }

  return [hue / 6, sat, li / 2, rgba[3]];
};

module.exports = p5.ColorConversion;

},{"../core/core":42}],35:[function(_dereq_,module,exports){
/**
 * @module Color
 * @submodule Creating & Reading
 * @for p5
 * @requires core
 * @requires constants
 */

'use strict';

var p5 = _dereq_('../core/core');
var constants = _dereq_('../core/constants');
_dereq_('./p5.Color');

/**
 * Extracts the alpha value from a color or pixel array.
 *
 * @method alpha
 * @param {Object} obj p5.Color object or pixel array
 * @example
 * <div>
 * <code>
 * noStroke();
 * c = color(0, 126, 255, 102);
 * fill(c);
 * rect(15, 15, 35, 70);
 * value = alpha(c);  // Sets 'value' to 102
 * fill(value);
 * rect(50, 15, 35, 70);
 * </code>
 * </div>
 *
 * @alt
 * Left half of canvas light blue and right half light charcoal grey.
 * Left half of canvas light purple and right half a royal blue.
 * Left half of canvas salmon pink and the right half white.
 * Yellow rect in middle right of canvas, with 55 pixel width and height.
 * Yellow ellipse in top left canvas, black ellipse in bottom right,both 80x80.
 * Bright fuschia rect in middle of canvas, 60 pixel width and height.
 * Two bright green rects on opposite sides of the canvas, both 45x80.
 * Four blue rects in each corner of the canvas, each are 35x35.
 * Bright sea green rect on left and darker rect on right of canvas, both 45x80.
 * Dark green rect on left and light green rect on right of canvas, both 45x80.
 * Dark blue rect on left and light teal rect on right of canvas, both 45x80.
 * blue rect on left and green on right, both with black outlines & 35x60.
 * salmon pink rect on left and black on right, both 35x60.
 * 4 rects, tan, brown, brownish purple and purple, with white outlines & 20x60.
 * light pastel green rect on left and dark grey rect on right, both 35x60.
 * yellow rect on left and red rect on right, both with black outlines & 35x60.
 * grey canvas
 * deep pink rect on left and grey rect on right, both 35x60.
 */
p5.prototype.alpha = function(c) {
  if (c instanceof p5.Color || c instanceof Array) {
    return this.color(c)._getAlpha();
  } else {
    throw new Error('Needs p5.Color or pixel array as argument.');
  }
};

/**
 * Extracts the blue value from a color or pixel array.
 *
 * @method blue
 * @param {Object} obj p5.Color object or pixel array
 * @example
 * <div>
 * <code>
 * c = color(175, 100, 220);  // Define color 'c'
 * fill(c);  // Use color variable 'c' as fill color
 * rect(15, 20, 35, 60);  // Draw left rectangle
 *
 * blueValue = blue(c);  // Get blue in 'c'
 * print(blueValue);  // Prints "220.0"
 * fill(0, 0, blueValue);  // Use 'blueValue' in new fill
 * rect(50, 20, 35, 60);  // Draw right rectangle
 * </code>
 * </div>
 *
 * @alt
 * Left half of canvas light purple and right half a royal blue.
 *
 */
p5.prototype.blue = function(c) {
  if (c instanceof p5.Color || c instanceof Array) {
    return this.color(c)._getBlue();
  } else {
    throw new Error('Needs p5.Color or pixel array as argument.');
  }
};

/**
 * Extracts the HSB brightness value from a color or pixel array.
 *
 * @method brightness
 * @param {Object} color p5.Color object or pixel array
 * @example
 * <div>
 * <code>
 * noStroke();
 * colorMode(HSB, 255);
 * c = color(0, 126, 255);
 * fill(c);
 * rect(15, 20, 35, 60);
 * value = brightness(c);  // Sets 'value' to 255
 * fill(value);
 * rect(50, 20, 35, 60);
 * </code>
 * </div>
 *
 * @alt
 * Left half of canvas salmon pink and the right half white.
 *
 */
p5.prototype.brightness = function(c) {
  if (c instanceof p5.Color || c instanceof Array) {
    return this.color(c)._getBrightness();
  } else {
    throw new Error('Needs p5.Color or pixel array as argument.');
  }
};

/**
 * Creates colors for storing in variables of the color datatype. The
 * parameters are interpreted as RGB or HSB values depending on the
 * current colorMode(). The default mode is RGB values from 0 to 255
 * and, therefore, the function call color(255, 204, 0) will return a
 * bright yellow color.
 * <br><br>
 * Note that if only one value is provided to color(), it will be interpreted
 * as a grayscale value. Add a second value, and it will be used for alpha
 * transparency. When three values are specified, they are interpreted as
 * either RGB or HSB values. Adding a fourth value applies alpha
 * transparency. If a single string parameter is provided it will be
 * interpreted as a CSS-compatible color string.
 *
 * Colors are stored as Numbers or Arrays.
 *
 * @method color
 * @param  {Number}        gray    number specifying value between white
 *                                 and black.
 * @param  {Number}        [alpha] alpha value relative to current color range
 *                                 (default is 0-255)
 * @return {Array}                 resulting color
 *
 * @example
 * <div>
 * <code>
 * var c = color(255, 204, 0);  // Define color 'c'
 * fill(c);  // Use color variable 'c' as fill color
 * noStroke();  // Don't draw a stroke around shapes
 * rect(30, 20, 55, 55);  // Draw rectangle
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * var c = color(255, 204, 0);  // Define color 'c'
 * fill(c);  // Use color variable 'c' as fill color
 * noStroke();  // Don't draw a stroke around shapes
 * ellipse(25, 25, 80, 80);  // Draw left circle
 *
 * // Using only one value with color()
 * // generates a grayscale value.
 * var c = color(65);  // Update 'c' with grayscale value
 * fill(c);  // Use updated 'c' as fill color
 * ellipse(75, 75, 80, 80);  // Draw right circle
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // Named SVG & CSS colors may be used,
 * var c = color('magenta');
 * fill(c);  // Use 'c' as fill color
 * noStroke();  // Don't draw a stroke around shapes
 * rect(20, 20, 60, 60);  // Draw rectangle
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // as can hex color codes:
 * noStroke();  // Don't draw a stroke around shapes
 * var c = color('#0f0');
 * fill(c);  // Use 'c' as fill color
 * rect(0, 10, 45, 80);  // Draw rectangle
 *
 * c = color('#00ff00');
 * fill(c);  // Use updated 'c' as fill color
 * rect(55, 10, 45, 80);  // Draw rectangle
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // RGB and RGBA color strings are also supported:
 * // these all set to the same color (solid blue)
 * var c;
 * noStroke();  // Don't draw a stroke around shapes
 * c = color('rgb(0,0,255)');
 * fill(c); // Use 'c' as fill color
 * rect(10, 10, 35, 35);  // Draw rectangle
 *
 * c = color('rgb(0%, 0%, 100%)');
 * fill(c); // Use updated 'c' as fill color
 * rect(55, 10, 35, 35);  // Draw rectangle
 *
 * c = color('rgba(0, 0, 255, 1)');
 * fill(c); // Use updated 'c' as fill color
 * rect(10, 55, 35, 35);  // Draw rectangle
 *
 * c = color('rgba(0%, 0%, 100%, 1)');
 * fill(c); // Use updated 'c' as fill color
 * rect(55, 55, 35, 35);  // Draw rectangle
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // HSL color is also supported and can be specified
 * // by value
 * var c;
 * noStroke();  // Don't draw a stroke around shapes
 * c = color('hsl(160, 100%, 50%)');
 * fill(c);  // Use 'c' as fill color
 * rect(0, 10, 45, 80);  // Draw rectangle
 *
 * c = color('hsla(160, 100%, 50%, 0.5)');
 * fill(c); // Use updated 'c' as fill color
 * rect(55, 10, 45, 80);  // Draw rectangle
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // HSB color is also supported and can be specified
 * // by value
 * var c;
 * noStroke();  // Don't draw a stroke around shapes
 * c = color('hsb(160, 100%, 50%)');
 * fill(c);  // Use 'c' as fill color
 * rect(0, 10, 45, 80);  // Draw rectangle
 *
 * c = color('hsba(160, 100%, 50%, 0.5)');
 * fill(c); // Use updated 'c' as fill color
 * rect(55, 10, 45, 80);  // Draw rectangle
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * var c;  // Declare color 'c'
 * noStroke();  // Don't draw a stroke around shapes
 *
 * // If no colorMode is specified, then the
 * // default of RGB with scale of 0-255 is used.
 * c = color(50, 55, 100);  // Create a color for 'c'
 * fill(c);  // Use color variable 'c' as fill color
 * rect(0, 10, 45, 80);  // Draw left rect
 *
 * colorMode(HSB, 100);  // Use HSB with scale of 0-100
 * c = color(50, 55, 100);  // Update 'c' with new color
 * fill(c);  // Use updated 'c' as fill color
 * rect(55, 10, 45, 80);  // Draw right rect
 * </code>
 * </div>
 *
 * @alt
 * Yellow rect in middle right of canvas, with 55 pixel width and height.
 * Yellow ellipse in top left of canvas, black ellipse in bottom right,both 80x80.
 * Bright fuschia rect in middle of canvas, 60 pixel width and height.
 * Two bright green rects on opposite sides of the canvas, both 45x80.
 * Four blue rects in each corner of the canvas, each are 35x35.
 * Bright sea green rect on left and darker rect on right of canvas, both 45x80.
 * Dark green rect on left and lighter green rect on right of canvas, both 45x80.
 * Dark blue rect on left and light teal rect on right of canvas, both 45x80.
 *
 */

/**
 * @method color
 * @param  {Number|String} v1      red or hue value relative to
 *                                 the current color range, or a color string
 * @param  {Number}        v2      green or saturation value
 *                                 relative to the current color range
 * @param  {Number}        v3      blue or brightness value
 *                                 relative to the current color range
 * @param  {Number}        [alpha]
 */

p5.prototype.color = function() {
  if (arguments[0] instanceof p5.Color) {
    return arguments[0];  // Do nothing if argument is already a color object.
  } else if (arguments[0] instanceof Array) {
    if (this instanceof p5.Renderer) {
      return new p5.Color(this, arguments[0]);
    } else {
      return new p5.Color(this._renderer, arguments[0]);
    }
  } else {
    if (this instanceof p5.Renderer) {
      return new p5.Color(this, arguments);
    } else {
      return new p5.Color(this._renderer, arguments);
    }
  }
};

/**
 * Extracts the green value from a color or pixel array.
 *
 * @method green
 * @param {Object} color p5.Color object or pixel array
 * @example
 * <div>
 * <code>
 * c = color(20, 75, 200);  // Define color 'c'
 * fill(c);  // Use color variable 'c' as fill color
 * rect(15, 20, 35, 60);  // Draw left rectangle
 *
 * greenValue = green(c);  // Get green in 'c'
 * print(greenValue);  // Print "75.0"
 * fill(0, greenValue, 0);  // Use 'greenValue' in new fill
 * rect(50, 20, 35, 60);  // Draw right rectangle
 * </code>
 * </div>
 *
 * @alt
 * blue rect on left and green on right, both with black outlines & 35x60.
 *
 */

p5.prototype.green = function(c) {
  if (c instanceof p5.Color || c instanceof Array) {
    return this.color(c)._getGreen();
  } else {
    throw new Error('Needs p5.Color or pixel array as argument.');
  }
};

/**
 * Extracts the hue value from a color or pixel array.
 *
 * Hue exists in both HSB and HSL. This function will return the
 * HSB-normalized hue when supplied with an HSB color object (or when supplied
 * with a pixel array while the color mode is HSB), but will default to the
 * HSL-normalized hue otherwise. (The values will only be different if the
 * maximum hue setting for each system is different.)
 *
 * @method hue
 * @param {Object} color p5.Color object or pixel array
 * @example
 * <div>
 * <code>
 * noStroke();
 * colorMode(HSB, 255);
 * c = color(0, 126, 255);
 * fill(c);
 * rect(15, 20, 35, 60);
 * value = hue(c);  // Sets 'value' to "0"
 * fill(value);
 * rect(50, 20, 35, 60);
 * </code>
 * </div>
 *
 * @alt
 * salmon pink rect on left and black on right, both 35x60.
 *
 */

p5.prototype.hue = function(c) {
  if (c instanceof p5.Color || c instanceof Array) {
    return this.color(c)._getHue();
  } else {
    throw new Error('Needs p5.Color or pixel array as argument.');
  }
};

/**
 * Blends two colors to find a third color somewhere between them. The amt
 * parameter is the amount to interpolate between the two values where 0.0
 * equal to the first color, 0.1 is very near the first color, 0.5 is halfway
 * in between, etc. An amount below 0 will be treated as 0. Likewise, amounts
 * above 1 will be capped at 1. This is different from the behavior of lerp(),
 * but necessary because otherwise numbers outside the range will produce
 * strange and unexpected colors.
 * <br><br>
 * The way that colours are interpolated depends on the current color mode.
 *
 * @method lerpColor
 * @param  {Array|Number} c1  interpolate from this color
 * @param  {Array|Number} c2  interpolate to this color
 * @param  {Number}       amt number between 0 and 1
 * @return {Array|Number}     interpolated color
 * @example
 * <div>
 * <code>
 * colorMode(RGB);
 * stroke(255);
 * background(51);
 * from = color(218, 165, 32);
 * to = color(72, 61, 139);
 * colorMode(RGB);  // Try changing to HSB.
 * interA = lerpColor(from, to, .33);
 * interB = lerpColor(from, to, .66);
 * fill(from);
 * rect(10, 20, 20, 60);
 * fill(interA);
 * rect(30, 20, 20, 60);
 * fill(interB);
 * rect(50, 20, 20, 60);
 * fill(to);
 * rect(70, 20, 20, 60);
 * </code>
 * </div>
 *
 * @alt
 * 4 rects one tan, brown, brownish purple, purple, with white outlines & 20x60
 *
 */

p5.prototype.lerpColor = function(c1, c2, amt) {
  var mode = this._renderer._colorMode;
  var maxes = this._renderer._colorMaxes;
  var l0, l1, l2, l3;
  var fromArray, toArray;

  if (mode === constants.RGB) {
    fromArray = c1.levels.map(function(level) {
      return level / 255;
    });
    toArray = c2.levels.map(function(level) {
      return level / 255;
    });
  } else if (mode === constants.HSB) {
    c1._getBrightness();  // Cache hsba so it definitely exists.
    c2._getBrightness();
    fromArray = c1.hsba;
    toArray = c2.hsba;
  } else if (mode === constants.HSL) {
    c1._getLightness();  // Cache hsla so it definitely exists.
    c2._getLightness();
    fromArray = c1.hsla;
    toArray = c2.hsla;
  } else {
    throw new Error (mode + 'cannot be used for interpolation.');
  }

  // Prevent extrapolation.
  amt = Math.max(Math.min(amt, 1), 0);

  // Perform interpolation.
  l0 = this.lerp(fromArray[0], toArray[0], amt);
  l1 = this.lerp(fromArray[1], toArray[1], amt);
  l2 = this.lerp(fromArray[2], toArray[2], amt);
  l3 = this.lerp(fromArray[3], toArray[3], amt);

  // Scale components.
  l0 *= maxes[mode][0];
  l1 *= maxes[mode][1];
  l2 *= maxes[mode][2];
  l3 *= maxes[mode][3];

  return this.color(l0, l1, l2, l3);
};

/**
 * Extracts the HSL lightness value from a color or pixel array.
 *
 * @method lightness
 * @param {Object} color p5.Color object or pixel array
 * @example
 * <div>
 * <code>
 * noStroke();
 * colorMode(HSL);
 * c = color(156, 100, 50, 1);
 * fill(c);
 * rect(15, 20, 35, 60);
 * value = lightness(c);  // Sets 'value' to 50
 * fill(value);
 * rect(50, 20, 35, 60);
 * </code>
 * </div>
 *
 * @alt
 * light pastel green rect on left and dark grey rect on right, both 35x60.
 *
 */
p5.prototype.lightness = function(c) {
  if (c instanceof p5.Color || c instanceof Array) {
    return this.color(c)._getLightness();
  } else {
    throw new Error('Needs p5.Color or pixel array as argument.');
  }
};

/**
 * Extracts the red value from a color or pixel array.
 *
 * @method red
 * @param {Object} obj p5.Color object or pixel array
 * @example
 * <div>
 * <code>
 * c = color(255, 204, 0);  // Define color 'c'
 * fill(c);  // Use color variable 'c' as fill color
 * rect(15, 20, 35, 60);  // Draw left rectangle
 *
 * redValue = red(c);  // Get red in 'c'
 * print(redValue);  // Print "255.0"
 * fill(redValue, 0, 0);  // Use 'redValue' in new fill
 * rect(50, 20, 35, 60);  // Draw right rectangle
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * colorMode(RGB, 255);
 * var c = color(127, 255, 0);
 * colorMode(RGB, 1);
 * var myColor = red(c);
 * print(myColor);
 * </code>
 * </div>
 *
 * @alt
 * yellow rect on left and red rect on right, both with black outlines and 35x60.
 * grey canvas
 */
p5.prototype.red = function(c) {
  if (c instanceof p5.Color || c instanceof Array) {
    return this.color(c)._getRed();
  } else {
    throw new Error('Needs p5.Color or pixel array as argument.');
  }
};

/**
 * Extracts the saturation value from a color or pixel array.
 *
 * Saturation is scaled differently in HSB and HSL. This function will return
 * the HSB saturation when supplied with an HSB color object (or when supplied
 * with a pixel array while the color mode is HSB), but will default to the
 * HSL saturation otherwise.
 *
 * @method saturation
 * @param {Object} color p5.Color object or pixel array
 * @example
 * <div>
 * <code>
 * noStroke();
 * colorMode(HSB, 255);
 * c = color(0, 126, 255);
 * fill(c);
 * rect(15, 20, 35, 60);
 * value = saturation(c);  // Sets 'value' to 126
 * fill(value);
 * rect(50, 20, 35, 60);
 * </code>
 * </div>
 *
 * @alt
 *deep pink rect on left and grey rect on right, both 35x60.
 *
 */

p5.prototype.saturation = function(c) {
  if (c instanceof p5.Color || c instanceof Array) {
    return this.color(c)._getSaturation();
  } else {
    throw new Error('Needs p5.Color or pixel array as argument.');
  }
};

module.exports = p5;

},{"../core/constants":41,"../core/core":42,"./p5.Color":36}],36:[function(_dereq_,module,exports){
/**
 * @module Color
 * @submodule Creating & Reading
 * @for p5
 * @requires core
 * @requires constants
 * @requires color_conversion
 */

var p5 = _dereq_('../core/core');
var constants = _dereq_('../core/constants');
var color_conversion = _dereq_('./color_conversion');

/**
 * We define colors to be immutable objects. Each color stores the color mode
 * and level maxes that applied at the time of its construction. These are
 * used to interpret the input arguments and to format the output e.g. when
 * saturation() is requested.
 *
 * Internally we store an array representing the ideal RGBA values in floating
 * point form, normalized from 0 to 1. From this we calculate the closest
 * screen color (RGBA levels from 0 to 255) and expose this to the renderer.
 *
 * We also cache normalized, floating point components of the color in various
 * representations as they are calculated. This is done to prevent repeating a
 * conversion that has already been performed.
 *
 * @class p5.Color
 * @constructor
 */
p5.Color = function(renderer, vals) {

  // Record color mode and maxes at time of construction.
  this.mode = renderer._colorMode;
  this.maxes = renderer._colorMaxes;

  // Calculate normalized RGBA values.
  if (this.mode !== constants.RGB &&
      this.mode !== constants.HSL &&
      this.mode !== constants.HSB) {
    throw new Error(this.mode + ' is an invalid colorMode.');
  } else {
    this._array = p5.Color._parseInputs.apply(renderer, vals);
  }

  // Expose closest screen color.
  this.levels = this._array.map(function(level) {
    return Math.round(level * 255);
  });

  return this;
};

p5.Color.prototype.toString = function() {
  var a = this.levels;
  var alpha = this._array[3];  // String representation uses normalized alpha.
  return 'rgba('+a[0]+','+a[1]+','+a[2]+','+ alpha +')';
};

p5.Color.prototype._getAlpha = function() {
  return this._array[3] * this.maxes[this.mode][3];
};

p5.Color.prototype._getBlue = function() {
  return this._array[2] * this.maxes[constants.RGB][2];
};

p5.Color.prototype._getBrightness = function() {
  if (!this.hsba) {
    this.hsba = color_conversion._rgbaToHSBA(this._array);
  }
  return this.hsba[2] * this.maxes[constants.HSB][2];
};

p5.Color.prototype._getGreen = function() {
  return this._array[1] * this.maxes[constants.RGB][1];
};

/**
 * Hue is the same in HSB and HSL, but the maximum value may be different.
 * This function will return the HSB-normalized saturation when supplied with
 * an HSB color object, but will default to the HSL-normalized saturation
 * otherwise.
 */
p5.Color.prototype._getHue = function() {
  if (this.mode === constants.HSB) {
    if (!this.hsba) {
      this.hsba = color_conversion._rgbaToHSBA(this._array);
    }
    return this.hsba[0] * this.maxes[constants.HSB][0];
  } else {
    if (!this.hsla) {
      this.hsla = color_conversion._rgbaToHSLA(this._array);
    }
    return this.hsla[0] * this.maxes[constants.HSL][0];
  }
};

p5.Color.prototype._getLightness = function() {
  if (!this.hsla) {
    this.hsla = color_conversion._rgbaToHSLA(this._array);
  }
  return this.hsla[2] * this.maxes[constants.HSL][2];
};

p5.Color.prototype._getRed = function() {
  return this._array[0] * this.maxes[constants.RGB][0];
};

/**
 * Saturation is scaled differently in HSB and HSL. This function will return
 * the HSB saturation when supplied with an HSB color object, but will default
 * to the HSL saturation otherwise.
 */
p5.Color.prototype._getSaturation = function() {
  if (this.mode === constants.HSB) {
    if (!this.hsba) {
      this.hsba = color_conversion._rgbaToHSBA(this._array);
    }
    return this.hsba[1] * this.maxes[constants.HSB][1];
  } else {
    if (!this.hsla) {
      this.hsla = color_conversion._rgbaToHSLA(this._array);
    }
    return this.hsla[1] * this.maxes[constants.HSL][1];
  }
};

/**
 * CSS named colors.
 */
var namedColors = {
  aliceblue:             '#f0f8ff',
  antiquewhite:          '#faebd7',
  aqua:                  '#00ffff',
  aquamarine:            '#7fffd4',
  azure:                 '#f0ffff',
  beige:                 '#f5f5dc',
  bisque:                '#ffe4c4',
  black:                 '#000000',
  blanchedalmond:        '#ffebcd',
  blue:                  '#0000ff',
  blueviolet:            '#8a2be2',
  brown:                 '#a52a2a',
  burlywood:             '#deb887',
  cadetblue:             '#5f9ea0',
  chartreuse:            '#7fff00',
  chocolate:             '#d2691e',
  coral:                 '#ff7f50',
  cornflowerblue:        '#6495ed',
  cornsilk:              '#fff8dc',
  crimson:               '#dc143c',
  cyan:                  '#00ffff',
  darkblue:              '#00008b',
  darkcyan:              '#008b8b',
  darkgoldenrod:         '#b8860b',
  darkgray:              '#a9a9a9',
  darkgreen:             '#006400',
  darkgrey:              '#a9a9a9',
  darkkhaki:             '#bdb76b',
  darkmagenta:           '#8b008b',
  darkolivegreen:        '#556b2f',
  darkorange:            '#ff8c00',
  darkorchid:            '#9932cc',
  darkred:               '#8b0000',
  darksalmon:            '#e9967a',
  darkseagreen:          '#8fbc8f',
  darkslateblue:         '#483d8b',
  darkslategray:         '#2f4f4f',
  darkslategrey:         '#2f4f4f',
  darkturquoise:         '#00ced1',
  darkviolet:            '#9400d3',
  deeppink:              '#ff1493',
  deepskyblue:           '#00bfff',
  dimgray:               '#696969',
  dimgrey:               '#696969',
  dodgerblue:            '#1e90ff',
  firebrick:             '#b22222',
  floralwhite:           '#fffaf0',
  forestgreen:           '#228b22',
  fuchsia:               '#ff00ff',
  gainsboro:             '#dcdcdc',
  ghostwhite:            '#f8f8ff',
  gold:                  '#ffd700',
  goldenrod:             '#daa520',
  gray:                  '#808080',
  green:                 '#008000',
  greenyellow:           '#adff2f',
  grey:                  '#808080',
  honeydew:              '#f0fff0',
  hotpink:               '#ff69b4',
  indianred:             '#cd5c5c',
  indigo:                '#4b0082',
  ivory:                 '#fffff0',
  khaki:                 '#f0e68c',
  lavender:              '#e6e6fa',
  lavenderblush:         '#fff0f5',
  lawngreen:             '#7cfc00',
  lemonchiffon:          '#fffacd',
  lightblue:             '#add8e6',
  lightcoral:            '#f08080',
  lightcyan:             '#e0ffff',
  lightgoldenrodyellow:  '#fafad2',
  lightgray:             '#d3d3d3',
  lightgreen:            '#90ee90',
  lightgrey:             '#d3d3d3',
  lightpink:             '#ffb6c1',
  lightsalmon:           '#ffa07a',
  lightseagreen:         '#20b2aa',
  lightskyblue:          '#87cefa',
  lightslategray:        '#778899',
  lightslategrey:        '#778899',
  lightsteelblue:        '#b0c4de',
  lightyellow:           '#ffffe0',
  lime:                  '#00ff00',
  limegreen:             '#32cd32',
  linen:                 '#faf0e6',
  magenta:               '#ff00ff',
  maroon:                '#800000',
  mediumaquamarine:      '#66cdaa',
  mediumblue:            '#0000cd',
  mediumorchid:          '#ba55d3',
  mediumpurple:          '#9370db',
  mediumseagreen:        '#3cb371',
  mediumslateblue:       '#7b68ee',
  mediumspringgreen:     '#00fa9a',
  mediumturquoise:       '#48d1cc',
  mediumvioletred:       '#c71585',
  midnightblue:          '#191970',
  mintcream:             '#f5fffa',
  mistyrose:             '#ffe4e1',
  moccasin:              '#ffe4b5',
  navajowhite:           '#ffdead',
  navy:                  '#000080',
  oldlace:               '#fdf5e6',
  olive:                 '#808000',
  olivedrab:             '#6b8e23',
  orange:                '#ffa500',
  orangered:             '#ff4500',
  orchid:                '#da70d6',
  palegoldenrod:         '#eee8aa',
  palegreen:             '#98fb98',
  paleturquoise:         '#afeeee',
  palevioletred:         '#db7093',
  papayawhip:            '#ffefd5',
  peachpuff:             '#ffdab9',
  peru:                  '#cd853f',
  pink:                  '#ffc0cb',
  plum:                  '#dda0dd',
  powderblue:            '#b0e0e6',
  purple:                '#800080',
  red:                   '#ff0000',
  rosybrown:             '#bc8f8f',
  royalblue:             '#4169e1',
  saddlebrown:           '#8b4513',
  salmon:                '#fa8072',
  sandybrown:            '#f4a460',
  seagreen:              '#2e8b57',
  seashell:              '#fff5ee',
  sienna:                '#a0522d',
  silver:                '#c0c0c0',
  skyblue:               '#87ceeb',
  slateblue:             '#6a5acd',
  slategray:             '#708090',
  slategrey:             '#708090',
  snow:                  '#fffafa',
  springgreen:           '#00ff7f',
  steelblue:             '#4682b4',
  tan:                   '#d2b48c',
  teal:                  '#008080',
  thistle:               '#d8bfd8',
  tomato:                '#ff6347',
  turquoise:             '#40e0d0',
  violet:                '#ee82ee',
  wheat:                 '#f5deb3',
  white:                 '#ffffff',
  whitesmoke:            '#f5f5f5',
  yellow:                '#ffff00',
  yellowgreen:           '#9acd32'
};

/**
 * These regular expressions are used to build up the patterns for matching
 * viable CSS color strings: fragmenting the regexes in this way increases the
 * legibility and comprehensibility of the code.
 *
 * Note that RGB values of .9 are not parsed by IE, but are supported here for
 * color string consistency.
 */
var WHITESPACE = /\s*/;  // Match zero or more whitespace characters.
var INTEGER = /(\d{1,3})/;  // Match integers: 79, 255, etc.
var DECIMAL = /((?:\d+(?:\.\d+)?)|(?:\.\d+))/;  // Match 129.6, 79, .9, etc.
var PERCENT = new RegExp(DECIMAL.source + '%');  // Match 12.9%, 79%, .9%, etc.

/**
 * Full color string patterns. The capture groups are necessary.
 */
var colorPatterns = {
  // Match colors in format #XXX, e.g. #416.
  HEX3: /^#([a-f0-9])([a-f0-9])([a-f0-9])$/i,

  // Match colors in format #XXXXXX, e.g. #b4d455.
  HEX6: /^#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})$/i,

  // Match colors in format rgb(R, G, B), e.g. rgb(255, 0, 128).
  RGB: new RegExp([
    '^rgb\\(',
    INTEGER.source,
    ',',
    INTEGER.source,
    ',',
    INTEGER.source,
    '\\)$'
  ].join(WHITESPACE.source), 'i'),

  // Match colors in format rgb(R%, G%, B%), e.g. rgb(100%, 0%, 28.9%).
  RGB_PERCENT: new RegExp([
    '^rgb\\(',
    PERCENT.source,
    ',',
    PERCENT.source,
    ',',
    PERCENT.source,
    '\\)$'
  ].join(WHITESPACE.source), 'i'),

  // Match colors in format rgb(R, G, B, A), e.g. rgb(255, 0, 128, 0.25).
  RGBA: new RegExp([
    '^rgba\\(',
    INTEGER.source,
    ',',
    INTEGER.source,
    ',',
    INTEGER.source,
    ',',
    DECIMAL.source,
    '\\)$'
  ].join(WHITESPACE.source), 'i'),

  // Match colors in format rgb(R%, G%, B%, A), e.g. rgb(100%, 0%, 28.9%, 0.5).
  RGBA_PERCENT: new RegExp([
    '^rgba\\(',
    PERCENT.source,
    ',',
    PERCENT.source,
    ',',
    PERCENT.source,
    ',',
    DECIMAL.source,
    '\\)$'
  ].join(WHITESPACE.source), 'i'),

  // Match colors in format hsla(H, S%, L%), e.g. hsl(100, 40%, 28.9%).
  HSL: new RegExp([
    '^hsl\\(',
    INTEGER.source,
    ',',
    PERCENT.source,
    ',',
    PERCENT.source,
    '\\)$'
  ].join(WHITESPACE.source), 'i'),

  // Match colors in format hsla(H, S%, L%, A), e.g. hsla(100, 40%, 28.9%, 0.5).
  HSLA: new RegExp([
    '^hsla\\(',
    INTEGER.source,
    ',',
    PERCENT.source,
    ',',
    PERCENT.source,
    ',',
    DECIMAL.source,
    '\\)$'
  ].join(WHITESPACE.source), 'i'),

  // Match colors in format hsb(H, S%, B%), e.g. hsb(100, 40%, 28.9%).
  HSB: new RegExp([
    '^hsb\\(',
    INTEGER.source,
    ',',
    PERCENT.source,
    ',',
    PERCENT.source,
    '\\)$'
  ].join(WHITESPACE.source), 'i'),

  // Match colors in format hsba(H, S%, B%, A), e.g. hsba(100, 40%, 28.9%, 0.5).
  HSBA: new RegExp([
    '^hsba\\(',
    INTEGER.source,
    ',',
    PERCENT.source,
    ',',
    PERCENT.source,
    ',',
    DECIMAL.source,
    '\\)$'
  ].join(WHITESPACE.source), 'i')
};

/**
 * For a number of different inputs, returns a color formatted as [r, g, b, a]
 * arrays, with each component normalized between 0 and 1.
 *
 * @param {Array-like} args An 'array-like' object that represents a list of
 *                          arguments
 * @return {Array}          a color formatted as [r, g, b, a]
 *                          Example:
 *                          input        ==> output
 *                          g            ==> [g, g, g, 255]
 *                          g,a          ==> [g, g, g, a]
 *                          r, g, b      ==> [r, g, b, 255]
 *                          r, g, b, a   ==> [r, g, b, a]
 *                          [g]          ==> [g, g, g, 255]
 *                          [g, a]       ==> [g, g, g, a]
 *                          [r, g, b]    ==> [r, g, b, 255]
 *                          [r, g, b, a] ==> [r, g, b, a]
 * @example
 * <div>
 * <code>
 * // todo
 * </code>
 * </div>
 *
 * @alt
 * //todo
 *
 */
p5.Color._parseInputs = function() {
  var numArgs = arguments.length;
  var mode = this._colorMode;
  var maxes = this._colorMaxes;
  var results = [];

  if (numArgs >= 3) {  // Argument is a list of component values.

    results[0] = arguments[0] / maxes[mode][0];
    results[1] = arguments[1] / maxes[mode][1];
    results[2] = arguments[2] / maxes[mode][2];

    // Alpha may be undefined, so default it to 100%.
    if (typeof arguments[3] === 'number') {
      results[3] = arguments[3] / maxes[mode][3];
    } else {
      results[3] = 1;
    }

    // Constrain components to the range [0,1].
    results = results.map(function(value) {
      return Math.max(Math.min(value, 1), 0);
    });

    // Convert to RGBA and return.
    if (mode === constants.HSL) {
      return color_conversion._hslaToRGBA(results);
    } else if (mode === constants.HSB) {
      return color_conversion._hsbaToRGBA(results);
    } else {
      return results;
    }

  } else if (numArgs === 1 && typeof arguments[0] === 'string') {

    var str = arguments[0].trim().toLowerCase();

    // Return if string is a named colour.
    if (namedColors[str]) {
      return p5.Color._parseInputs.apply(this, [namedColors[str]]);
    }

    // Try RGBA pattern matching.
    if (colorPatterns.HEX3.test(str)) {  // #rgb
      results = colorPatterns.HEX3.exec(str).slice(1).map(function(color) {
        return parseInt(color + color, 16) / 255;
      });
      results[3] = 1;
      return results;
    } else if (colorPatterns.HEX6.test(str)) {  // #rrggbb
      results = colorPatterns.HEX6.exec(str).slice(1).map(function(color) {
        return parseInt(color, 16) / 255;
      });
      results[3] = 1;
      return results;
    } else if (colorPatterns.RGB.test(str)) {  // rgb(R,G,B)
      results = colorPatterns.RGB.exec(str).slice(1).map(function(color) {
        return color / 255;
      });
      results[3] = 1;
      return results;
    } else if (colorPatterns.RGB_PERCENT.test(str)) {  // rgb(R%,G%,B%)
      results = colorPatterns.RGB_PERCENT.exec(str).slice(1)
        .map(function(color) {
          return parseFloat(color) / 100;
        });
      results[3] = 1;
      return results;
    } else if (colorPatterns.RGBA.test(str)) {  // rgba(R,G,B,A)
      results = colorPatterns.RGBA.exec(str).slice(1)
        .map(function(color, idx) {
          if (idx === 3) {
            return parseFloat(color);
          }
          return color / 255;
        });
      return results;
    } else if (colorPatterns.RGBA_PERCENT.test(str)) {  // rgba(R%,G%,B%,A%)
      results = colorPatterns.RGBA_PERCENT.exec(str).slice(1)
        .map(function(color, idx) {
          if (idx === 3) {
            return parseFloat(color);
          }
          return parseFloat(color) / 100;
        });
      return results;
    }

    // Try HSLA pattern matching.
    if (colorPatterns.HSL.test(str)) {  // hsl(H,S,L)
      results = colorPatterns.HSL.exec(str).slice(1)
        .map(function(color, idx) {
        if (idx === 0) {
          return parseInt(color, 10) / 360;
        }
        return parseInt(color, 10) / 100;
      });
      results[3] = 1;
    } else if (colorPatterns.HSLA.test(str)) {  // hsla(H,S,L,A)
      results = colorPatterns.HSLA.exec(str).slice(1)
        .map(function(color, idx) {
        if (idx === 0) {
          return parseInt(color, 10) / 360;
        }
        else if (idx === 3) {
          return parseFloat(color);
        }
        return parseInt(color, 10) / 100;
      });
    }
    results = results.map(function(value) {
      return Math.max(Math.min(value, 1), 0);
    });
    if (results.length) {
      return color_conversion._hslaToRGBA(results);
    }

    // Try HSBA pattern matching.
    if (colorPatterns.HSB.test(str)) {  // hsb(H,S,B)
      results = colorPatterns.HSB.exec(str).slice(1)
        .map(function(color, idx) {
        if (idx === 0) {
          return parseInt(color, 10) / 360;
        }
        return parseInt(color, 10) / 100;
      });
      results[3] = 1;
    } else if (colorPatterns.HSBA.test(str)) {  // hsba(H,S,B,A)
      results = colorPatterns.HSBA.exec(str).slice(1)
        .map(function(color, idx) {
        if (idx === 0) {
          return parseInt(color, 10) / 360;
        }
        else if (idx === 3) {
          return parseFloat(color);
        }
        return parseInt(color, 10) / 100;
      });
    }
    results = results.map(function(value) {
      return Math.max(Math.min(value, 1), 0);
    });

    if (results.length) {
      return color_conversion._hsbaToRGBA(results);
    }

    // Input did not match any CSS color pattern: default to white.
    results = [1, 1, 1, 1];

  } else if ((numArgs === 1 || numArgs === 2) &&
              typeof arguments[0] === 'number') {  // 'Grayscale' mode.

    /**
     * For HSB and HSL, interpret the gray level as a brightness/lightness
     * value (they are equivalent when chroma is zero). For RGB, normalize the
     * gray level according to the blue maximum.
     */
    results[0] = arguments[0] / maxes[mode][2];
    results[1] = arguments[0] / maxes[mode][2];
    results[2] = arguments[0] / maxes[mode][2];

    // Alpha may be undefined, so default it to 100%.
    if (typeof arguments[1] === 'number') {
      results[3] = arguments[1] / maxes[mode][3];
    } else {
      results[3] = 1;
    }

    // Constrain components to the range [0,1].
    results = results.map(function(value) {
      return Math.max(Math.min(value, 1), 0);
    });

  } else {
    throw new Error (arguments + 'is not a valid color representation.');
  }

  return results;
};

module.exports = p5.Color;

},{"../core/constants":41,"../core/core":42,"./color_conversion":34}],37:[function(_dereq_,module,exports){
/**
 * @module Color
 * @submodule Setting
 * @for p5
 * @requires core
 * @requires constants
 */

'use strict';

var p5 = _dereq_('../core/core');
var constants = _dereq_('../core/constants');
_dereq_('./p5.Color');

/**
 * The background() function sets the color used for the background of the
 * p5.js canvas. The default background is light gray. This function is
 * typically used within draw() to clear the display window at the beginning
 * of each frame, but it can be used inside setup() to set the background on
 * the first frame of animation or if the background need only be set once.
 *
 * @method background
 * @param {p5.Color} color     any value created by the color() function
 * @param {Number} [a]         opacity of the background relative to current
 *                             color range (default is 0-100)
 *
 * @example
 * <div>
 * <code>
 * // Grayscale integer value
 * background(51);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // R, G & B integer values
 * background(255, 204, 0);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // H, S & B integer values
 * colorMode(HSB);
 * background(255, 204, 100);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // Named SVG/CSS color string
 * background('red');
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // three-digit hexadecimal RGB notation
 * background('#fae');
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // six-digit hexadecimal RGB notation
 * background('#222222');
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // integer RGB notation
 * background('rgb(0,255,0)');
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // integer RGBA notation
 * background('rgba(0,255,0, 0.25)');
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // percentage RGB notation
 * background('rgb(100%,0%,10%)');
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // percentage RGBA notation
 * background('rgba(100%,0%,100%,0.5)');
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // p5 Color object
 * background(color(0, 0, 255));
 * </code>
 * </div>
 *
 * @alt
 * canvas with darkest charcoal grey background.
 * canvas with yellow background.
 * canvas with royal blue background.
 * canvas with red background.
 * canvas with pink background.
 * canvas with black background.
 * canvas with bright green background.
 * canvas with soft green background.
 * canvas with red background.
 * canvas with light purple background.
 * canvas with blue background.
 */

/**
 * @method background
 * @param {String} colorstring color string, possible formats include: integer
 *                         rgb() or rgba(), percentage rgb() or rgba(),
 *                         3-digit hex, 6-digit hex
 * @param {Number} [a]
 */

/**
 * @method background
 * @param {Number} gray   specifies a value between white and black
 * @param {Number} [a]
 */

/**
 * @method background
 * @param {Number} v1     red or hue value (depending on the current color
 *                        mode)
 * @param {Number} v2     green or saturation value (depending on the current
 *                        color mode)
 * @param {Number} v3     blue or brightness value (depending on the current
 *                        color mode)
 * @param  {Number} [a]
 */

/**
 * @method background
 * @param {p5.Image} image     image created with loadImage() or createImage(),
 *                             to set as background
 *                             (must be same size as the sketch window)
 * @param  {Number}  [a]
 */
p5.prototype.background = function() {
  if (arguments[0] instanceof p5.Image) {
    this.image(arguments[0], 0, 0, this.width, this.height);
  } else {
    this._renderer.background.apply(this._renderer, arguments);
  }
  return this;
};

/**
 * Clears the pixels within a buffer. This function only works on p5.Canvas
 * objects created with the createCanvas() function; it won't work with the
 * main display window. Unlike the main graphics context, pixels in
 * additional graphics areas created with createGraphics() can be entirely
 * or partially transparent. This function clears everything to make all of
 * the pixels 100% transparent.
 *
 * @method clear
 * @example
 * <div>
 * <code>
 * // Clear the screen on mouse press.
 * function setup() {
 *   createCanvas(100, 100);
 * }
 *
 * function draw() {
 *   ellipse(mouseX, mouseY, 20, 20);
 * }
 *
 * function mousePressed() {
 *   clear();
 * }
 * </code>
 * </div>
 *
 * @alt
 * 20x20 white ellipses are continually drawn at mouse x and y coordinates.
 *
 */

p5.prototype.clear = function() {
  this._renderer.clear();
  return this;
};

/**
 * colorMode() changes the way p5.js interprets color data. By default, the
 * parameters for fill(), stroke(), background(), and color() are defined by
 * values between 0 and 255 using the RGB color model. This is equivalent to
 * setting colorMode(RGB, 255). Setting colorMode(HSB) lets you use the HSB
 * system instead. By default, this is colorMode(HSB, 360, 100, 100, 1). You
 * can also use HSL.
 * <br><br>
 * Note: existing color objects remember the mode that they were created in,
 * so you can change modes as you like without affecting their appearance.
 *
 * @method colorMode
 * @param {Constant} mode   either RGB or HSB, corresponding to
 *                          Red/Green/Blue and Hue/Saturation/Brightness
 *                          (or Lightness)
 * @param {Number} [max1] range for the red or hue depending on the
 *                              current color mode, or range for all values
 * @param {Number} [max2] range for the green or saturation depending
 *                              on the current color mode
 * @param {Number} [max3] range for the blue or brightness/lighntess
 *                              depending on the current color mode
 * @param {Number} [maxA] range for the alpha
 * @example
 * <div>
 * <code>
 * noStroke();
 * colorMode(RGB, 100);
 * for (i = 0; i < 100; i++) {
 *   for (j = 0; j < 100; j++) {
 *     stroke(i, j, 0);
 *     point(i, j);
 *   }
 * }
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * noStroke();
 * colorMode(HSB, 100);
 * for (i = 0; i < 100; i++) {
 *   for (j = 0; j < 100; j++) {
 *     stroke(i, j, 100);
 *     point(i, j);
 *   }
 * }
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * colorMode(RGB, 255);
 * var c = color(127, 255, 0);
 *
 * colorMode(RGB, 1);
 * var myColor = c._getRed();
 * text(myColor, 10, 10, 80, 80);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * noFill();
 * colorMode(RGB, 255, 255, 255, 1);
 * background(255);
 *
 * strokeWeight(4);
 * stroke(255, 0 , 10, 0.3);
 * ellipse(40, 40, 50, 50);
 * ellipse(50, 50, 40, 40);
 * </code>
 * </div>
 *
 * @alt
 *Green to red gradient from bottom L to top R. shading originates from top left.
 *Rainbow gradient from left to right. Brightness increasing to white at top.
 *unknown image.
 *50x50 ellipse at middle L & 40x40 ellipse at center. Transluscent pink outlines.
 *
 */
p5.prototype.colorMode = function() {
  if (arguments[0] === constants.RGB ||
      arguments[0] === constants.HSB ||
      arguments[0] === constants.HSL) {

    // Set color mode.
    this._renderer._colorMode = arguments[0];

    // Set color maxes.
    var maxes = this._renderer._colorMaxes[this._renderer._colorMode];
    if (arguments.length === 2) {
      maxes[0] = arguments[1];  // Red
      maxes[1] = arguments[1];  // Green
      maxes[2] = arguments[1];  // Blue
      maxes[3] = arguments[1];  // Alpha
    } else if (arguments.length === 4) {
      maxes[0] = arguments[1];  // Red
      maxes[1] = arguments[2];  // Green
      maxes[2] = arguments[3];  // Blue
    } else if (arguments.length === 5) {
      maxes[0] = arguments[1];  // Red
      maxes[1] = arguments[2];  // Green
      maxes[2] = arguments[3];  // Blue
      maxes[3] = arguments[4];  // Alpha
    }
  }

  return this;
};

/**
 * Sets the color used to fill shapes. For example, if you run
 * fill(204, 102, 0), all subsequent shapes will be filled with orange. This
 * color is either specified in terms of the RGB or HSB color depending on
 * the current colorMode(). (The default color space is RGB, with each value
 * in the range from 0 to 255).
 * <br><br>
 * If a single string argument is provided, RGB, RGBA and Hex CSS color strings
 * and all named color strings are supported. A p5 Color object can also be
 * provided to set the fill color.
 *
 * @method fill
 * @param {Number|Array|String|p5.Color} v1   gray value, red or hue value
 *                                            (depending on the current color
 *                                            mode), or color Array, or CSS
 *                                            color string
 * @param {Number}                       [v2] green or saturation value
 *                                            (depending on the current
 *                                            color mode)
 * @param {Number}                       [v3] blue or brightness value
 *                                            (depending on the current
 *                                            color mode)
 * @param {Number}                       [a]  opacity of the background
 *
 * @example
 * <div>
 * <code>
 * // Grayscale integer value
 * fill(51);
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // R, G & B integer values
 * fill(255, 204, 0);
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // H, S & B integer values
 * colorMode(HSB);
 * fill(255, 204, 100);
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // Named SVG/CSS color string
 * fill('red');
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // three-digit hexadecimal RGB notation
 * fill('#fae');
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // six-digit hexadecimal RGB notation
 * fill('#222222');
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // integer RGB notation
 * fill('rgb(0,255,0)');
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // integer RGBA notation
 * fill('rgba(0,255,0, 0.25)');
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // percentage RGB notation
 * fill('rgb(100%,0%,10%)');
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // percentage RGBA notation
 * fill('rgba(100%,0%,100%,0.5)');
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // p5 Color object
 * fill(color(0, 0, 255));
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 * @alt
 * 60x60 dark charcoal grey rect with black outline in center of canvas.
 * 60x60 yellow rect with black outline in center of canvas.
 * 60x60 royal blue rect with black outline in center of canvas.
 * 60x60 red rect with black outline in center of canvas.
 * 60x60 pink rect with black outline in center of canvas.
 * 60x60 black rect with black outline in center of canvas.
 * 60x60 light green rect with black outline in center of canvas.
 * 60x60 soft green rect with black outline in center of canvas.
 * 60x60 red rect with black outline in center of canvas.
 * 60x60 dark fushcia rect with black outline in center of canvas.
 * 60x60 blue rect with black outline in center of canvas.
 */

p5.prototype.fill = function() {
  this._renderer._setProperty('_fillSet', true);
  this._renderer._setProperty('_doFill', true);
  this._renderer.fill.apply(this._renderer, arguments);
  return this;
};

/**
 * Disables filling geometry. If both noStroke() and noFill() are called,
 * nothing will be drawn to the screen.
 *
 * @method noFill
 * @example
 * <div>
 * <code>
 * rect(15, 10, 55, 55);
 * noFill();
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 * @alt
 * white rect top middle and noFill rect center. Both 60x60 with black outlines.
 */
p5.prototype.noFill = function() {
  this._renderer._setProperty('_doFill', false);
  return this;
};

/**
 * Disables drawing the stroke (outline). If both noStroke() and noFill()
 * are called, nothing will be drawn to the screen.
 *
 * @method noStroke
 * @example
 * <div>
 * <code>
 * noStroke();
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 *
 * @alt
 *60x60 white rect at center. no outline.
 *
 */

p5.prototype.noStroke = function() {
  this._renderer._setProperty('_doStroke', false);
  return this;
};

/**
 * Sets the color used to draw lines and borders around shapes. This color
 * is either specified in terms of the RGB or HSB color depending on the
 * current colorMode() (the default color space is RGB, with each value in
 * the range from 0 to 255).
 * <br><br>
 * If a single string argument is provided, RGB, RGBA and Hex CSS color
 * strings and all named color strings are supported. A p5 Color object
 * can also be provided to set the stroke color.
 *
 * @method stroke
 * @param {Number|Array|String|p5.Color} v1   gray value, red or hue value
 *                                            (depending on the current color
 *                                            mode), or color Array, or CSS
 *                                            color string
 * @param {Number}                       [v2] green or saturation value
 *                                            (depending on the current
 *                                            color mode)
 * @param {Number}                       [v3] blue or brightness value
 *                                            (depending on the current
 *                                            color mode)
 * @param {Number}                       [a]  opacity of the background
 *
 * @example
 * <div>
 * <code>
 * // Grayscale integer value
 * strokeWeight(4);
 * stroke(51);
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // R, G & B integer values
 * stroke(255, 204, 0);
 * strokeWeight(4);
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // H, S & B integer values
 * colorMode(HSB);
 * strokeWeight(4);
 * stroke(255, 204, 100);
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // Named SVG/CSS color string
 * stroke('red');
 * strokeWeight(4);
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // three-digit hexadecimal RGB notation
 * stroke('#fae');
 * strokeWeight(4);
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // six-digit hexadecimal RGB notation
 * stroke('#222222');
 * strokeWeight(4);
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // integer RGB notation
 * stroke('rgb(0,255,0)');
 * strokeWeight(4);
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // integer RGBA notation
 * stroke('rgba(0,255,0,0.25)');
 * strokeWeight(4);
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // percentage RGB notation
 * stroke('rgb(100%,0%,10%)');
 * strokeWeight(4);
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // percentage RGBA notation
 * stroke('rgba(100%,0%,100%,0.5)');
 * strokeWeight(4);
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // p5 Color object
 * stroke(color(0, 0, 255));
 * strokeWeight(4);
 * rect(20, 20, 60, 60);
 * </code>
 * </div>
 *
 * @alt
 * 60x60 white rect at center. Dark charcoal grey outline.
 * 60x60 white rect at center. Yellow outline.
 * 60x60 white rect at center. Royal blue outline.
 * 60x60 white rect at center. Red outline.
 * 60x60 white rect at center. Pink outline.
 * 60x60 white rect at center. Black outline.
 * 60x60 white rect at center. Bright green outline.
 * 60x60 white rect at center. Soft green outline.
 * 60x60 white rect at center. Red outline.
 * 60x60 white rect at center. Dark fushcia outline.
 * 60x60 white rect at center. Blue outline.
 */

p5.prototype.stroke = function() {
  this._renderer._setProperty('_strokeSet', true);
  this._renderer._setProperty('_doStroke', true);
  this._renderer.stroke.apply(this._renderer, arguments);
  return this;
};

module.exports = p5;

},{"../core/constants":41,"../core/core":42,"./p5.Color":36}],38:[function(_dereq_,module,exports){
/**
 * @module Shape
 * @submodule 2D Primitives
 * @for p5
 * @requires core
 * @requires constants
 */

'use strict';

var p5 = _dereq_('./core');
var constants = _dereq_('./constants');
var canvas = _dereq_('./canvas');
_dereq_('./error_helpers');

/**
 * Draw an arc to the screen. If called with only a, b, c, d, start, and
 * stop, the arc will be drawn as an open pie. If mode is provided, the arc
 * will be drawn either open, as a chord, or as a pie as specified. The
 * origin may be changed with the ellipseMode() function.<br><br>
 * Note that drawing a full circle (ex: 0 to TWO_PI) will appear blank
 * because 0 and TWO_PI are the same position on the unit circle. The
 * best way to handle this is by using the ellipse() function instead
 * to create a closed ellipse, and to use the arc() function
 * only to draw parts of an ellipse.
 *
 * @method arc
 * @param  {Number} a      x-coordinate of the arc's ellipse
 * @param  {Number} b      y-coordinate of the arc's ellipse
 * @param  {Number} c      width of the arc's ellipse by default
 * @param  {Number} d      height of the arc's ellipse by default
 * @param  {Number} start  angle to start the arc, specified in radians
 * @param  {Number} stop   angle to stop the arc, specified in radians
 * @param  {Constant} [mode] optional parameter to determine the way of drawing
 *                         the arc
 * @return {Object}        the p5 object
 * @example
 * <div>
 * <code>
 * arc(50, 55, 50, 50, 0, HALF_PI);
 * noFill();
 * arc(50, 55, 60, 60, HALF_PI, PI);
 * arc(50, 55, 70, 70, PI, PI+QUARTER_PI);
 * arc(50, 55, 80, 80, PI+QUARTER_PI, TWO_PI);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * arc(50, 50, 80, 80, 0, PI+QUARTER_PI, OPEN);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * arc(50, 50, 80, 80, 0, PI+QUARTER_PI, CHORD);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * arc(50, 50, 80, 80, 0, PI+QUARTER_PI, PIE);
 * </code>
 * </div>
 *
 * @alt
 *shattered outline of an ellipse with a quarter of a white circle bottom-right.
 *white ellipse with black outline with top right missing.
 *white ellipse with top right missing with black outline around shape.
 *white ellipse with top right quarter missing with black outline around the shape.
 *
 */
p5.prototype.arc = function(x, y, w, h, start, stop, mode) {
  var args = new Array(arguments.length);
  for (var i = 0; i < args.length; ++i) {
    args[i] = arguments[i];
  }
  if (!this._renderer._doStroke && !this._renderer._doFill) {
    return this;
  }
  if (this._angleMode === constants.DEGREES) {
    start = this.radians(start);
    stop = this.radians(stop);
  }

  // Make all angles positive...
  while (start < 0) {
    start += constants.TWO_PI;
  }
  while (stop < 0) {
    stop += constants.TWO_PI;
  }
  // ...and confine them to the interval [0,TWO_PI).
  start %= constants.TWO_PI;
  stop %= constants.TWO_PI;

  // account for full circle
  if (stop === start) {
    stop += constants.TWO_PI;
  }

  // Adjust angles to counter linear scaling.
  if (start <= constants.HALF_PI) {
    start = Math.atan(w / h * Math.tan(start));
  } else  if (start > constants.HALF_PI && start <= 3 * constants.HALF_PI) {
    start = Math.atan(w / h * Math.tan(start)) + constants.PI;
  } else {
    start = Math.atan(w / h * Math.tan(start)) + constants.TWO_PI;
  }
  if (stop <= constants.HALF_PI) {
    stop = Math.atan(w / h * Math.tan(stop));
  } else  if (stop > constants.HALF_PI && stop <= 3 * constants.HALF_PI) {
    stop = Math.atan(w / h * Math.tan(stop)) + constants.PI;
  } else {
    stop = Math.atan(w / h * Math.tan(stop)) + constants.TWO_PI;
  }

  // Exceed the interval if necessary in order to preserve the size and
  // orientation of the arc.
  if (start > stop) {
    stop += constants.TWO_PI;
  }
  // p5 supports negative width and heights for ellipses
  w = Math.abs(w);
  h = Math.abs(h);
  this._renderer.arc(x, y, w, h, start, stop, mode);
  return this;
};

/**
 * Draws an ellipse (oval) to the screen. An ellipse with equal width and
 * height is a circle. By default, the first two parameters set the location,
 * and the third and fourth parameters set the shape's width and height. If
 * no height is specified, the value of width is used for both the width and
 * height. If a negative height or width is specified, the absolute value is taken.
 * The origin may be changed with the ellipseMode() function.
 *
 * @method ellipse
 * @param  {Number} x x-coordinate of the ellipse.
 * @param  {Number} y y-coordinate of the ellipse.
 * @param  {Number} w width of the ellipse.
 * @param  {Number} [h] height of the ellipse.
 * @return {p5}       the p5 object
 * @example
 * <div>
 * <code>
 * ellipse(56, 46, 55, 55);
 * </code>
 * </div>
 *
 * @alt
 *white ellipse with black outline in middle-right of canvas that is 55x55.
 *
 */
/**
 * @method ellipse
 * @param {Number} x
 * @param {Number} y
 * @param {Number} w
 * @param {Number} [h]
 * @return {p5}
 */
p5.prototype.ellipse = function() {
  var args = new Array(arguments.length);
  for (var i = 0; i < args.length; ++i) {
    args[i] = arguments[i];
  }
  // Duplicate 3rd argument if only 3 given.
  if (args.length === 3) {
    args.push(args[2]);
  }
  // p5 supports negative width and heights for rects
  if (args[2] < 0){args[2] = Math.abs(args[2]);}
  if (args[3] < 0){args[3] = Math.abs(args[3]);}
  if (!this._renderer._doStroke && !this._renderer._doFill) {
    return this;
  }
  var vals = canvas.modeAdjust(
    args[0],
    args[1],
    args[2],
    args[3],
    this._renderer._ellipseMode);
  args[0] = vals.x;
  args[1] = vals.y;
  args[2] = vals.w;
  args[3] = vals.h;
  this._renderer.ellipse(args);
  return this;
};
/**
 * Draws a line (a direct path between two points) to the screen. The version
 * of line() with four parameters draws the line in 2D. To color a line, use
 * the stroke() function. A line cannot be filled, therefore the fill()
 * function will not affect the color of a line. 2D lines are drawn with a
 * width of one pixel by default, but this can be changed with the
 * strokeWeight() function.
 *
 * @method line
 * @param  {Number} x1 the x-coordinate of the first point
 * @param  {Number} y1 the y-coordinate of the first point
 * @param  {Number} x2 the x-coordinate of the second point
 * @param  {Number} y2 the y-coordinate of the second point
 * @return {p5}        the p5 object
 * @example
 * <div>
 * <code>
 * line(30, 20, 85, 75);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * line(30, 20, 85, 20);
 * stroke(126);
 * line(85, 20, 85, 75);
 * stroke(255);
 * line(85, 75, 30, 75);
 * </code>
 * </div>
 *
 * @alt
 *line 78 pixels long running from mid-top to bottom-right of canvas.
 *3 lines of various stroke sizes. Form top, bottom and right sides of a square.
 *
 */
////commented out original
// p5.prototype.line = function(x1, y1, x2, y2) {
//   if (!this._renderer._doStroke) {
//     return this;
//   }
//   if(this._renderer.isP3D){
//   } else {
//     this._renderer.line(x1, y1, x2, y2);
//   }
// };
p5.prototype.line = function() {
  if (!this._renderer._doStroke) {
    return this;
  }
  var args = new Array(arguments.length);
  for (var i = 0; i < args.length; ++i) {
    args[i] = arguments[i];
  }
  //check whether we should draw a 3d line or 2d
  if(this._renderer.isP3D){
    this._renderer.line(
      args[0],
      args[1],
      args[2],
      args[3],
      args[4],
      args[5]);
  } else {
    this._renderer.line(
      args[0],
      args[1],
      args[2],
      args[3]);
  }
  return this;
};

/**
 * Draws a point, a coordinate in space at the dimension of one pixel.
 * The first parameter is the horizontal value for the point, the second
 * value is the vertical value for the point. The color of the point is
 * determined by the current stroke.
 *
 * @method point
 * @param  {Number} x the x-coordinate
 * @param  {Number} y the y-coordinate
 * @return {p5}       the p5 object
 * @example
 * <div>
 * <code>
 * point(30, 20);
 * point(85, 20);
 * point(85, 75);
 * point(30, 75);
 * </code>
 * </div>
 *
 * @alt
 *4 points centered in the middle-right of the canvas.
 *
 */
p5.prototype.point = function() {
  if (!this._renderer._doStroke) {
    return this;
  }
  var args = new Array(arguments.length);
  for (var i = 0; i < args.length; ++i) {
    args[i] = arguments[i];
  }
  //check whether we should draw a 3d line or 2d
  if(this._renderer.isP3D){
    this._renderer.point(
      args[0],
      args[1],
      args[2]
      );
  } else {
    this._renderer.point(
      args[0],
      args[1]
    );
  }
  return this;
};


/**
 * Draw a quad. A quad is a quadrilateral, a four sided polygon. It is
 * similar to a rectangle, but the angles between its edges are not
 * constrained to ninety degrees. The first pair of parameters (x1,y1)
 * sets the first vertex and the subsequent pairs should proceed
 * clockwise or counter-clockwise around the defined shape.
 *
 * @method quad
 * @param {Number} x1 the x-coordinate of the first point
 * @param {Number} y1 the y-coordinate of the first point
 * @param {Number} x2 the x-coordinate of the second point
 * @param {Number} y2 the y-coordinate of the second point
 * @param {Number} x3 the x-coordinate of the third point
 * @param {Number} y3 the y-coordinate of the third point
 * @param {Number} x4 the x-coordinate of the fourth point
 * @param {Number} y4 the y-coordinate of the fourth point
 * @return {p5}     the p5 object
 * @example
 * <div>
 * <code>
 * quad(38, 31, 86, 20, 69, 63, 30, 76);
 * </code>
 * </div>
 *
 * @alt
 *irregular white quadrilateral shape with black outline mid-right of canvas.
 *
 */
/**
 * @method quad
 * @param {Number} x1
 * @param {Number} y1
 * @param {Number} x2
 * @param {Number} y2
 * @param {Number} x3
 * @param {Number} y3
 * @param {Number} x4
 * @param {Number} y4
 * @return {p5} the p5 object
 */
p5.prototype.quad = function() {
  if (!this._renderer._doStroke && !this._renderer._doFill) {
    return this;
  }
  var args = new Array(arguments.length);
  for (var i = 0; i < args.length; ++i) {
    args[i] = arguments[i];
  }
  if(this._renderer.isP3D){
    this._renderer.quad(
      args[0],
      args[1],
      args[2],
      args[3],
      args[4],
      args[5],
      args[6],
      args[7],
      args[8],
      args[9],
      args[10],
      args[11]
      );
  } else {
    this._renderer.quad(
     args[0],
     args[1],
     args[2],
     args[3],
     args[4],
     args[5],
     args[6],
    args[7]
    );
  }
  return this;
};

/**
* Draws a rectangle to the screen. A rectangle is a four-sided shape with
* every angle at ninety degrees. By default, the first two parameters set
* the location of the upper-left corner, the third sets the width, and the
* fourth sets the height. The way these parameters are interpreted, however,
* may be changed with the rectMode() function.
* <br><br>
* The fifth, sixth, seventh and eighth parameters, if specified,
* determine corner radius for the top-right, top-left, lower-right and
* lower-left corners, respectively. An omitted corner radius parameter is set
* to the value of the previously specified radius value in the parameter list.
*
* @method rect
* @param  {Number} x  x-coordinate of the rectangle.
* @param  {Number} y  y-coordinate of the rectangle.
* @param  {Number} w  width of the rectangle.
* @param  {Number} h  height of the rectangle.
* @param  {Number} [tl] optional radius of top-left corner.
* @param  {Number} [tr] optional radius of top-right corner.
* @param  {Number} [br] optional radius of bottom-right corner.
* @param  {Number} [bl] optional radius of bottom-left corner.
* @return {p5}          the p5 object.
* @example
* <div>
* <code>
* // Draw a rectangle at location (30, 20) with a width and height of 55.
* rect(30, 20, 55, 55);
* </code>
* </div>
*
* <div>
* <code>
* // Draw a rectangle with rounded corners, each having a radius of 20.
* rect(30, 20, 55, 55, 20);
* </code>
* </div>
*
* <div>
* <code>
* // Draw a rectangle with rounded corners having the following radii:
* // top-left = 20, top-right = 15, bottom-right = 10, bottom-left = 5.
* rect(30, 20, 55, 55, 20, 15, 10, 5);
* </code>
* </div>
*
* @alt
* 55x55 white rect with black outline in mid-right of canvas.
* 55x55 white rect with black outline and rounded edges in mid-right of canvas.
* 55x55 white rect with black outline and rounded edges of different radii.
*/
/**
* @method rect
* @param  {Number} x
* @param  {Number} y
* @param  {Number} w
* @param  {Number} h
* @param  {Number} [detailX]
* @param  {Number} [detailY]
* @return {p5}          the p5 object.
*/
p5.prototype.rect = function () {
  var args = new Array(arguments.length);
  for (var i = 0; i < args.length; ++i) {
    args[i] = arguments[i];
  }
  if (!this._renderer._doStroke && !this._renderer._doFill) {
    return;
  }
  var vals = canvas.modeAdjust(
    args[0],
    args[1],
    args[2],
    args[3],
    this._renderer._rectMode);
  args[0] = vals.x;
  args[1] = vals.y;
  args[2] = vals.w;
  args[3] = vals.h;
  this._renderer.rect(args);
  return this;
};

/**
* A triangle is a plane created by connecting three points. The first two
* arguments specify the first point, the middle two arguments specify the
* second point, and the last two arguments specify the third point.
*
* @method triangle
* @param  {Number} x1 x-coordinate of the first point
* @param  {Number} y1 y-coordinate of the first point
* @param  {Number} x2 x-coordinate of the second point
* @param  {Number} y2 y-coordinate of the second point
* @param  {Number} x3 x-coordinate of the third point
* @param  {Number} y3 y-coordinate of the third point
* @return {p5}        the p5 object
* @example
* <div>
* <code>
* triangle(30, 75, 58, 20, 86, 75);
* </code>
* </div>
*
*@alt
* white triangle with black outline in mid-right of canvas.
*
*/
p5.prototype.triangle = function() {

  if (!this._renderer._doStroke && !this._renderer._doFill) {
    return this;
  }
  var args = new Array(arguments.length);
  for (var i = 0; i < args.length; ++i) {
    args[i] = arguments[i];
  }
  this._renderer.triangle(args);
  return this;
};

module.exports = p5;

},{"./canvas":40,"./constants":41,"./core":42,"./error_helpers":45}],39:[function(_dereq_,module,exports){
/**
 * @module Shape
 * @submodule Attributes
 * @for p5
 * @requires core
 * @requires constants
 */

'use strict';

var p5 = _dereq_('./core');
var constants = _dereq_('./constants');

/**
 * Modifies the location from which ellipses are drawn by changing the way
 * in which parameters given to ellipse() are interpreted.
 * <br><br>
 * The default mode is ellipseMode(CENTER), which interprets the first two
 * parameters of ellipse() as the shape's center point, while the third and
 * fourth parameters are its width and height.
 * <br><br>
 * ellipseMode(RADIUS) also uses the first two parameters of ellipse() as
 * the shape's center point, but uses the third and fourth parameters to
 * specify half of the shapes's width and height.
 * <br><br>
 * ellipseMode(CORNER) interprets the first two parameters of ellipse() as
 * the upper-left corner of the shape, while the third and fourth parameters
 * are its width and height.
 * <br><br>
 * ellipseMode(CORNERS) interprets the first two parameters of ellipse() as
 * the location of one corner of the ellipse's bounding box, and the third
 * and fourth parameters as the location of the opposite corner.
 * <br><br>
 * The parameter must be written in ALL CAPS because Javascript is a
 * case-sensitive language.
 *
 * @method ellipseMode
 * @param  {Constant} mode either CENTER, RADIUS, CORNER, or CORNERS
 * @return {p5}                   the p5 object
 * @example
 * <div>
 * <code>
 * ellipseMode(RADIUS);  // Set ellipseMode to RADIUS
 * fill(255);  // Set fill to white
 * ellipse(50, 50, 30, 30);  // Draw white ellipse using RADIUS mode
 *
 * ellipseMode(CENTER);  // Set ellipseMode to CENTER
 * fill(100);  // Set fill to gray
 * ellipse(50, 50, 30, 30);  // Draw gray ellipse using CENTER mode
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * ellipseMode(CORNER);  // Set ellipseMode is CORNER
 * fill(255);  // Set fill to white
 * ellipse(25, 25, 50, 50);  // Draw white ellipse using CORNER mode
 *
 * ellipseMode(CORNERS);  // Set ellipseMode to CORNERS
 * fill(100);  // Set fill to gray
 * ellipse(25, 25, 50, 50);  // Draw gray ellipse using CORNERS mode
 * </code>
 * </div>
 *
 * @alt
 * 60x60 white ellipse and 30x30 grey ellipse with black outlines at center.
 * 60x60 white ellipse @center and 30x30 grey ellipse top-right, black outlines.
 *
 */
p5.prototype.ellipseMode = function(m) {
  if (m === constants.CORNER ||
    m === constants.CORNERS ||
    m === constants.RADIUS ||
    m === constants.CENTER) {
    this._renderer._ellipseMode = m;
  }
  return this;
};

/**
 * Draws all geometry with jagged (aliased) edges. Note that smooth() is
 * active by default, so it is necessary to call noSmooth() to disable
 * smoothing of geometry, images, and fonts.
 *
 * @method noSmooth
 * @return {p5} the p5 object
 * @example
 * <div>
 * <code>
 * background(0);
 * noStroke();
 * smooth();
 * ellipse(30, 48, 36, 36);
 * noSmooth();
 * ellipse(70, 48, 36, 36);
 * </code>
 * </div>
 *
 * @alt
 * 2 pixelated 36x36 white ellipses to left & right of center, black background
 *
 */
p5.prototype.noSmooth = function() {
  this._renderer.noSmooth();
  return this;
};

/**
 * Modifies the location from which rectangles are drawn by changing the way
 * in which parameters given to rect() are interpreted.
 * <br><br>
 * The default mode is rectMode(CORNER), which interprets the first two
 * parameters of rect() as the upper-left corner of the shape, while the
 * third and fourth parameters are its width and height.
 * <br><br>
 * rectMode(CORNERS) interprets the first two parameters of rect() as the
 * location of one corner, and the third and fourth parameters as the
 * location of the opposite corner.
 * <br><br>
 * rectMode(CENTER) interprets the first two parameters of rect() as the
 * shape's center point, while the third and fourth parameters are its
 * width and height.
 * <br><br>
 * rectMode(RADIUS) also uses the first two parameters of rect() as the
 * shape's center point, but uses the third and fourth parameters to specify
 * half of the shapes's width and height.
 * <br><br>
 * The parameter must be written in ALL CAPS because Javascript is a
 * case-sensitive language.
 *
 * @method rectMode
 * @param  {Constant} mode either CORNER, CORNERS, CENTER, or RADIUS
 * @return {p5}                   the p5 object
 * @example
 * <div>
 * <code>
 * rectMode(CORNER);  // Default rectMode is CORNER
 * fill(255);  // Set fill to white
 * rect(25, 25, 50, 50);  // Draw white rect using CORNER mode
 *
 * rectMode(CORNERS);  // Set rectMode to CORNERS
 * fill(100);  // Set fill to gray
 * rect(25, 25, 50, 50);  // Draw gray rect using CORNERS mode
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * rectMode(RADIUS);  // Set rectMode to RADIUS
 * fill(255);  // Set fill to white
 * rect(50, 50, 30, 30);  // Draw white rect using RADIUS mode
 *
 * rectMode(CENTER);  // Set rectMode to CENTER
 * fill(100);  // Set fill to gray
 * rect(50, 50, 30, 30);  // Draw gray rect using CENTER mode
 * </code>
 * </div>
 *
 * @alt
 * 50x50 white rect at center and 25x25 grey rect in the top left of the other.
 * 50x50 white rect at center and 25x25 grey rect in the center of the other.
 *
 */
p5.prototype.rectMode = function(m) {
  if (m === constants.CORNER ||
    m === constants.CORNERS ||
    m === constants.RADIUS ||
    m === constants.CENTER) {
    this._renderer._rectMode = m;
  }
  return this;
};

/**
 * Draws all geometry with smooth (anti-aliased) edges. smooth() will also
 * improve image quality of resized images. Note that smooth() is active by
 * default; noSmooth() can be used to disable smoothing of geometry,
 * images, and fonts.
 *
 * @method smooth
 * @return {p5} the p5 object
 * @example
 * <div>
 * <code>
 * background(0);
 * noStroke();
 * smooth();
 * ellipse(30, 48, 36, 36);
 * noSmooth();
 * ellipse(70, 48, 36, 36);
 * </code>
 * </div>
 *
 * @alt
 * 2 pixelated 36x36 white ellipses one left one right of center. On black.
 *
 */
p5.prototype.smooth = function() {
  this._renderer.smooth();
  return this;
};

/**
 * Sets the style for rendering line endings. These ends are either squared,
 * extended, or rounded, each of which specified with the corresponding
 * parameters: SQUARE, PROJECT, and ROUND. The default cap is ROUND.
 *
 * @method strokeCap
 * @param  {Number|Constant} cap either SQUARE, PROJECT, or ROUND
 * @return {p5}                  the p5 object
 * @example
 * <div>
 * <code>
 * strokeWeight(12.0);
 * strokeCap(ROUND);
 * line(20, 30, 80, 30);
 * strokeCap(SQUARE);
 * line(20, 50, 80, 50);
 * strokeCap(PROJECT);
 * line(20, 70, 80, 70);
 * </code>
 * </div>
 *
 * @alt
 * 3 lines. Top line: rounded ends, mid: squared, bottom:longer squared ends.
 *
 */
p5.prototype.strokeCap = function(cap) {
  if (cap === constants.ROUND ||
    cap === constants.SQUARE ||
    cap === constants.PROJECT) {
    this._renderer.strokeCap(cap);
  }
  return this;
};

/**
 * Sets the style of the joints which connect line segments. These joints
 * are either mitered, beveled, or rounded and specified with the
 * corresponding parameters MITER, BEVEL, and ROUND. The default joint is
 * MITER.
 *
 * @method strokeJoin
 * @param  {Number|Constant} join either MITER, BEVEL, ROUND
 * @return {p5}                   the p5 object
 * @example
 * <div>
 * <code>
 * noFill();
 * strokeWeight(10.0);
 * strokeJoin(MITER);
 * beginShape();
 * vertex(35, 20);
 * vertex(65, 50);
 * vertex(35, 80);
 * endShape();
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * noFill();
 * strokeWeight(10.0);
 * strokeJoin(BEVEL);
 * beginShape();
 * vertex(35, 20);
 * vertex(65, 50);
 * vertex(35, 80);
 * endShape();
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * noFill();
 * strokeWeight(10.0);
 * strokeJoin(ROUND);
 * beginShape();
 * vertex(35, 20);
 * vertex(65, 50);
 * vertex(35, 80);
 * endShape();
 * </code>
 * </div>
 *
 * @alt
 * Right-facing arrowhead shape with pointed tip in center of canvas.
 * Right-facing arrowhead shape with flat tip in center of canvas.
 * Right-facing arrowhead shape with rounded tip in center of canvas.
 *
 */
p5.prototype.strokeJoin = function(join) {
  if (join === constants.ROUND ||
    join === constants.BEVEL ||
    join === constants.MITER) {
    this._renderer.strokeJoin(join);
  }
  return this;
};

/**
 * Sets the width of the stroke used for lines, points, and the border
 * around shapes. All widths are set in units of pixels.
 *
 * @method strokeWeight
 * @param  {Number} weight the weight (in pixels) of the stroke
 * @return {p5}            the p5 object
 * @example
 * <div>
 * <code>
 * strokeWeight(1);  // Default
 * line(20, 20, 80, 20);
 * strokeWeight(4);  // Thicker
 * line(20, 40, 80, 40);
 * strokeWeight(10);  // Beastly
 * line(20, 70, 80, 70);
 * </code>
 * </div>
 *
 * @alt
 * 3 horizontal black lines. Top line: thin, mid: medium, bottom:thick.
 *
 */
p5.prototype.strokeWeight = function(w) {
  this._renderer.strokeWeight(w);
  return this;
};

module.exports = p5;

},{"./constants":41,"./core":42}],40:[function(_dereq_,module,exports){
/**
 * @requires constants
 */

var constants = _dereq_('./constants');

module.exports = {

  modeAdjust: function(a, b, c, d, mode) {
    if (mode === constants.CORNER) {
      return { x: a, y: b, w: c, h: d };
    } else if (mode === constants.CORNERS) {
      return { x: a, y: b, w: c-a, h: d-b };
    } else if (mode === constants.RADIUS) {
      return { x: a-c, y: b-d, w: 2*c, h: 2*d };
    } else if (mode === constants.CENTER) {
      return { x: a-c*0.5, y: b-d*0.5, w: c, h: d };
    }
  },

  arcModeAdjust: function(a, b, c, d, mode) {
    if (mode === constants.CORNER) {
      return { x: a+c*0.5, y: b+d*0.5, w: c, h: d };
    } else if (mode === constants.CORNERS) {
      return { x: a, y: b, w: c+a, h: d+b };
    } else if (mode === constants.RADIUS) {
      return { x: a, y: b, w: 2*c, h: 2*d };
    } else if (mode === constants.CENTER) {
      return { x: a, y: b, w: c, h: d };
    }
  }

};


},{"./constants":41}],41:[function(_dereq_,module,exports){
/**
 * @module Constants
 * @submodule Constants
 * @for p5
 */

var PI = Math.PI;

module.exports = {

  // GRAPHICS RENDERER
  P2D: 'p2d',
  WEBGL: 'webgl',

  // ENVIRONMENT
  ARROW: 'default',
  CROSS: 'crosshair',
  HAND: 'pointer',
  MOVE: 'move',
  TEXT: 'text',
  WAIT: 'wait',

  // TRIGONOMETRY

  /**
   * HALF_PI is a mathematical constant with the value
   * 1.57079632679489661923. It is half the ratio of the
   * circumference of a circle to its diameter. It is useful in
   * combination with the trigonometric functions sin() and cos().
   *
   * @property HALF_PI
   *
   * @example
   * <div><code>
   * arc(50, 50, 80, 80, 0, HALF_PI);
   * </code></div>
   *
   * @alt
   * 80x80 white quarter-circle with curve toward bottom right of canvas.
   *
   */
  HALF_PI: PI / 2,
  /**
   * PI is a mathematical constant with the value
   * 3.14159265358979323846. It is the ratio of the circumference
   * of a circle to its diameter. It is useful in combination with
   * the trigonometric functions sin() and cos().
   *
   * @property PI
   *
   * @example
   * <div><code>
   * arc(50, 50, 80, 80, 0, PI);
   * </code></div>
   *
   * @alt
   * white half-circle with curve toward bottom of canvas.
   *
   */
  PI: PI,
  /**
   * QUARTER_PI is a mathematical constant with the value 0.7853982.
   * It is one quarter the ratio of the circumference of a circle to
   * its diameter. It is useful in combination with the trigonometric
   * functions sin() and cos().
   *
   * @property QUARTER_PI
   *
   * @example
   * <div><code>
   * arc(50, 50, 80, 80, 0, QUARTER_PI);
   * </code></div>
   *
   * @alt
   * white eighth-circle rotated about 40 degrees with curve bottom right canvas.
   *
   */
  QUARTER_PI: PI / 4,
  /**
   * TAU is an alias for TWO_PI, a mathematical constant with the
   * value 6.28318530717958647693. It is twice the ratio of the
   * circumference of a circle to its diameter. It is useful in
   * combination with the trigonometric functions sin() and cos().
   *
   * @property TAU
   *
   * @example
   * <div><code>
   * arc(50, 50, 80, 80, 0, TAU);
   * </code></div>
   *
   * @alt
   * 80x80 white ellipse shape in center of canvas.
   *
   */
  TAU: PI * 2,
  /**
   * TWO_PI is a mathematical constant with the value
   * 6.28318530717958647693. It is twice the ratio of the
   * circumference of a circle to its diameter. It is useful in
   * combination with the trigonometric functions sin() and cos().
   *
   * @property TWO_PI
   *
   * @example
   * <div><code>
   * arc(50, 50, 80, 80, 0, TWO_PI);
   * </code></div>
   *
   * @alt
   * 80x80 white ellipse shape in center of canvas.
   *
   */
  TWO_PI: PI * 2,
  DEGREES: 'degrees',
  RADIANS: 'radians',

  // SHAPE
  CORNER: 'corner',
  CORNERS: 'corners',
  RADIUS: 'radius',
  RIGHT: 'right',
  LEFT: 'left',
  CENTER: 'center',
  TOP: 'top',
  BOTTOM: 'bottom',
  BASELINE: 'alphabetic',
  POINTS: 0x0000,
  LINES: 0x0001,
  LINE_STRIP: 0x0003,
  LINE_LOOP: 0x0002,
  TRIANGLES: 0x0004,
  TRIANGLE_FAN: 0x0006,
  TRIANGLE_STRIP: 0x0005,
  QUADS: 'quads',
  QUAD_STRIP: 'quad_strip',
  CLOSE: 'close',
  OPEN: 'open',
  CHORD: 'chord',
  PIE: 'pie',
  PROJECT: 'square', // PEND: careful this is counterintuitive
  SQUARE: 'butt',
  ROUND: 'round',
  BEVEL: 'bevel',
  MITER: 'miter',

  // COLOR
  RGB: 'rgb',
  HSB: 'hsb',
  HSL: 'hsl',

  // DOM EXTENSION
  AUTO: 'auto',

  // INPUT
  ALT: 18,
  BACKSPACE: 8,
  CONTROL: 17,
  DELETE: 46,
  DOWN_ARROW: 40,
  ENTER: 13,
  ESCAPE: 27,
  LEFT_ARROW: 37,
  OPTION: 18,
  RETURN: 13,
  RIGHT_ARROW: 39,
  SHIFT: 16,
  TAB: 9,
  UP_ARROW: 38,

  // RENDERING
  BLEND: 'source-over',
  ADD: 'lighter',
  //ADD: 'add', //
  //SUBTRACT: 'subtract', //
  DARKEST: 'darken',
  LIGHTEST: 'lighten',
  DIFFERENCE: 'difference',
  EXCLUSION: 'exclusion',
  MULTIPLY: 'multiply',
  SCREEN: 'screen',
  REPLACE: 'copy',
  OVERLAY: 'overlay',
  HARD_LIGHT: 'hard-light',
  SOFT_LIGHT: 'soft-light',
  DODGE: 'color-dodge',
  BURN: 'color-burn',

  // FILTERS
  THRESHOLD: 'threshold',
  GRAY: 'gray',
  OPAQUE: 'opaque',
  INVERT: 'invert',
  POSTERIZE: 'posterize',
  DILATE: 'dilate',
  ERODE: 'erode',
  BLUR: 'blur',

  // TYPOGRAPHY
  NORMAL: 'normal',
  ITALIC: 'italic',
  BOLD: 'bold',

  // TYPOGRAPHY-INTERNAL
  _DEFAULT_TEXT_FILL: '#000000',
  _DEFAULT_LEADMULT: 1.25,
  _CTX_MIDDLE: 'middle',

  // VERTICES
  LINEAR: 'linear',
  QUADRATIC: 'quadratic',
  BEZIER: 'bezier',
  CURVE: 'curve',

  // DEFAULTS
  _DEFAULT_STROKE: '#000000',
  _DEFAULT_FILL: '#FFFFFF'

};

},{}],42:[function(_dereq_,module,exports){
/**
 * @module Structure
 * @submodule Structure
 * @for p5
 * @requires constants
 */

'use strict';

_dereq_('./shim');

// Core needs the PVariables object
var constants = _dereq_('./constants');

/**
 * This is the p5 instance constructor.
 *
 * A p5 instance holds all the properties and methods related to
 * a p5 sketch.  It expects an incoming sketch closure and it can also
 * take an optional node parameter for attaching the generated p5 canvas
 * to a node.  The sketch closure takes the newly created p5 instance as
 * its sole argument and may optionally set preload(), setup(), and/or
 * draw() properties on it for running a sketch.
 *
 * A p5 sketch can run in "global" or "instance" mode:
 * "global"   - all properties and methods are attached to the window
 * "instance" - all properties and methods are bound to this p5 object
 *
 * @param  {Function}    sketch a closure that can set optional preload(),
 *                              setup(), and/or draw() properties on the
 *                              given p5 instance
 * @param  {HTMLElement|boolean} [node] element to attach canvas to, if a
 *                                      boolean is passed in use it as sync
 * @param  {boolean}     [sync] start synchronously (optional)
 * @return {p5}                 a p5 instance
 */
var p5 = function(sketch, node, sync) {

  if (arguments.length === 2 && typeof node === 'boolean') {
    sync = node;
    node = undefined;
  }

  //////////////////////////////////////////////
  // PUBLIC p5 PROPERTIES AND METHODS
  //////////////////////////////////////////////


  /**
   * Called directly before setup(), the preload() function is used to handle
   * asynchronous loading of external files. If a preload function is
   * defined, setup() will wait until any load calls within have finished.
   * Nothing besides load calls should be inside preload (loadImage,
   * loadJSON, loadFont, loadStrings, etc).<br><br>
   * By default the text "loading..." will be displayed. To make your own
   * loading page, include an HTML element with id "p5_loading" in your
   * page. More information <a href="http://bit.ly/2kQ6Nio">here</a>.
   *
   * @method preload
   * @example
   * <div><code>
   * var img;
   * var c;
   * function preload() {  // preload() runs once
   *   img = loadImage('assets/laDefense.jpg');
   * }
   *
   * function setup() {  // setup() waits until preload() is done
   *   img.loadPixels();
   *   // get color of middle pixel
   *   c = img.get(img.width/2, img.height/2);
   * }
   *
   * function draw() {
   *   background(c);
   *   image(img, 25, 25, 50, 50);
   * }
   * </code></div>
   *
   * @alt
   * nothing displayed
   *
   */

  /**
   * The setup() function is called once when the program starts. It's used to
   * define initial environment properties such as screen size and background
   * color and to load media such as images and fonts as the program starts.
   * There can only be one setup() function for each program and it shouldn't
   * be called again after its initial execution.
   * <br><br>
   * Note: Variables declared within setup() are not accessible within other
   * functions, including draw().
   *
   * @method setup
   * @example
   * <div><code>
   * var a = 0;
   *
   * function setup() {
   *   background(0);
   *   noStroke();
   *   fill(102);
   * }
   *
   * function draw() {
   *   rect(a++%width, 10, 2, 80);
   * }
   * </code></div>
   *
   * @alt
   * nothing displayed
   *
   */

  /**
   * Called directly after setup(), the draw() function continuously executes
   * the lines of code contained inside its block until the program is stopped
   * or noLoop() is called. Note if noLoop() is called in setup(), draw() will
   * still be executed once before stopping. draw() is called automatically and
   * should never be called explicitly.
   * <br><br>
   * It should always be controlled with noLoop(), redraw() and loop(). After
   * noLoop() stops the code in draw() from executing, redraw() causes the
   * code inside draw() to execute once, and loop() will cause the code
   * inside draw() to resume executing continuously.
   * <br><br>
   * The number of times draw() executes in each second may be controlled with
   * the frameRate() function.
   * <br><br>
   * There can only be one draw() function for each sketch, and draw() must
   * exist if you want the code to run continuously, or to process events such
   * as mousePressed(). Sometimes, you might have an empty call to draw() in
   * your program, as shown in the above example.
   * <br><br>
   * It is important to note that the drawing coordinate system will be reset
   * at the beginning of each draw() call. If any transformations are performed
   * within draw() (ex: scale, rotate, translate, their effects will be
   * undone at the beginning of draw(), so transformations will not accumulate
   * over time. On the other hand, styling applied (ex: fill, stroke, etc) will
   * remain in effect.
   *
   * @method draw
   * @example
   * <div><code>
   * var yPos = 0;
   * function setup() {  // setup() runs once
   *   frameRate(30);
   * }
   * function draw() {  // draw() loops forever, until stopped
   *   background(204);
   *   yPos = yPos - 1;
   *   if (yPos < 0) {
   *     yPos = height;
   *   }
   *   line(0, yPos, width, yPos);
   * }
   * </code></div>
   *
   * @alt
   * nothing displayed
   *
   */


  //////////////////////////////////////////////
  // PRIVATE p5 PROPERTIES AND METHODS
  //////////////////////////////////////////////

  this._setupDone = false;
  // for handling hidpi
  this._pixelDensity = Math.ceil(window.devicePixelRatio) || 1;
  this._userNode = node;
  this._curElement = null;
  this._elements = [];
  this._requestAnimId = 0;
  this._preloadCount = 0;
  this._isGlobal = false;
  this._loop = true;
  this._styles = [];
  this._defaultCanvasSize = {
    width: 100,
    height: 100
  };
  this._events = { // keep track of user-events for unregistering later
    'mousemove': null,
    'mousedown': null,
    'mouseup': null,
    'dragend': null,
    'dragover': null,
    'click': null,
    'mouseover': null,
    'mouseout': null,
    'keydown': null,
    'keyup': null,
    'keypress': null,
    'touchstart': null,
    'touchmove': null,
    'touchend': null,
    'resize': null,
    'blur': null
  };

  this._events.wheel = null;
  this._loadingScreenId = 'p5_loading';

  if (window.DeviceOrientationEvent) {
    this._events.deviceorientation = null;
  }
  if (window.DeviceMotionEvent && !window._isNodeWebkit) {
    this._events.devicemotion = null;
  }

  this._start = function () {
    // Find node if id given
    if (this._userNode) {
      if (typeof this._userNode === 'string') {
        this._userNode = document.getElementById(this._userNode);
      }
    }

    var userPreload = this.preload || window.preload; // look for "preload"
    if (userPreload) {

      // Setup loading screen
      // Set loading scfeen into dom if not present
      // Otherwise displays and removes user provided loading screen
      var loadingScreen = document.getElementById(this._loadingScreenId);
      if(!loadingScreen){
        loadingScreen = document.createElement('div');
        loadingScreen.innerHTML = 'Loading...';
        loadingScreen.style.position = 'absolute';
        loadingScreen.id = this._loadingScreenId;
        var node = this._userNode || document.body;
        node.appendChild(loadingScreen);
      }
      // var methods = this._preloadMethods;
      for (var method in this._preloadMethods){
        // default to p5 if no object defined
        this._preloadMethods[method] = this._preloadMethods[method] || p5;
        var obj = this._preloadMethods[method];
        //it's p5, check if it's global or instance
        if (obj === p5.prototype || obj === p5){
          obj = this._isGlobal ? window : this;
        }
        this._registeredPreloadMethods[method] = obj[method];
        obj[method] = this._wrapPreload(obj, method);
      }

      userPreload();
      this._runIfPreloadsAreDone();
    } else {
      this._setup();
      this._runFrames();
      this._draw();
    }
  }.bind(this);

  this._runIfPreloadsAreDone = function(){
    var context = this._isGlobal ? window : this;
    if (context._preloadCount === 0) {
      var loadingScreen = document.getElementById(context._loadingScreenId);
      if (loadingScreen) {
        loadingScreen.parentNode.removeChild(loadingScreen);
      }
      context._setup();
      context._runFrames();
      context._draw();
    }
  };

  this._decrementPreload = function(){
    var context = this._isGlobal ? window : this;
    context._setProperty('_preloadCount', context._preloadCount - 1);
    context._runIfPreloadsAreDone();
  };

  this._wrapPreload = function(obj, fnName){
    return function(){
      //increment counter
      this._incrementPreload();
      //call original function
      var args = new Array(arguments.length);
      for (var i = 0; i < args.length; ++i) {
        args[i] = arguments[i];
      }
      args.push(this._decrementPreload.bind(this));
      return this._registeredPreloadMethods[fnName].apply(obj, args);
    }.bind(this);
  };

  this._incrementPreload = function(){
    var context = this._isGlobal ? window : this;
    context._setProperty('_preloadCount', context._preloadCount + 1);
  };

  this._setup = function() {

    // Always create a default canvas.
    // Later on if the user calls createCanvas, this default one
    // will be replaced
    this.createCanvas(
      this._defaultCanvasSize.width,
      this._defaultCanvasSize.height,
      'p2d',
      true
    );

    // return preload functions to their normal vals if switched by preload
    var context = this._isGlobal ? window : this;
    if (typeof context.preload === 'function') {
      for (var f in this._preloadMethods) {
        context[f] = this._preloadMethods[f][f];
        if (context[f] && this) {
          context[f] = context[f].bind(this);
        }
      }
    }

    // Short-circuit on this, in case someone used the library in "global"
    // mode earlier
    if (typeof context.setup === 'function') {
      context.setup();
    }

    // unhide any hidden canvases that were created
    var canvases = document.getElementsByTagName('canvas');
    for (var i = 0; i < canvases.length; i++) {
      var k = canvases[i];
      if (k.dataset.hidden === 'true') {
        k.style.visibility = '';
        delete(k.dataset.hidden);
      }
    }
    this._setupDone = true;

  }.bind(this);

  this._draw = function () {
    var now = window.performance.now();
    var time_since_last = now - this._lastFrameTime;
    var target_time_between_frames = 1000 / this._targetFrameRate;

    // only draw if we really need to; don't overextend the browser.
    // draw if we're within 5ms of when our next frame should paint
    // (this will prevent us from giving up opportunities to draw
    // again when it's really about time for us to do so). fixes an
    // issue where the frameRate is too low if our refresh loop isn't
    // in sync with the browser. note that we have to draw once even
    // if looping is off, so we bypass the time delay if that
    // is the case.
    var epsilon = 5;
    if (!this._loop ||
        time_since_last >= target_time_between_frames - epsilon) {

      //mandatory update values(matrixs and stack)

      this._setProperty('frameCount', this.frameCount + 1);
      this.redraw();
      this._updateMouseCoords();
      this._frameRate = 1000.0/(now - this._lastFrameTime);
      this._lastFrameTime = now;
    }

    // get notified the next time the browser gives us
    // an opportunity to draw.
    if (this._loop) {
      this._requestAnimId = window.requestAnimationFrame(this._draw);
    }
  }.bind(this);

  this._runFrames = function() {
    if (this._updateInterval) {
      clearInterval(this._updateInterval);
    }
  }.bind(this);

  this._setProperty = function(prop, value) {
    this[prop] = value;
    if (this._isGlobal) {
      window[prop] = value;
    }
  }.bind(this);

  /**
   * Removes the entire p5 sketch. This will remove the canvas and any
   * elements created by p5.js. It will also stop the draw loop and unbind
   * any properties or methods from the window global scope. It will
   * leave a variable p5 in case you wanted to create a new p5 sketch.
   * If you like, you can set p5 = null to erase it.
   * @method remove
   * @example
   * <div class='norender'><code>
   * function draw() {
   *   ellipse(50, 50, 10, 10);
   * }
   *
   * function mousePressed() {
   *   remove(); // remove whole sketch on mouse press
   * }
   * </code></div>
   *
   * @alt
   * nothing displayed
   *
   */
  this.remove = function() {
    if (this._curElement) {

      // stop draw
      this._loop = false;
      if (this._requestAnimId) {
        window.cancelAnimationFrame(this._requestAnimId);
      }

      // unregister events sketch-wide
      for (var ev in this._events) {
        window.removeEventListener(ev, this._events[ev]);
      }

      // remove DOM elements created by p5, and listeners
      for (var i=0; i<this._elements.length; i++) {
        var e = this._elements[i];
        if (e.elt.parentNode) {
          e.elt.parentNode.removeChild(e.elt);
        }
        for (var elt_ev in e._events) {
          e.elt.removeEventListener(elt_ev, e._events[elt_ev]);
        }
      }

      // call any registered remove functions
      var self = this;
      this._registeredMethods.remove.forEach(function (f) {
        if (typeof(f) !== 'undefined') {
          f.call(self);
        }
      });

      // remove window bound properties and methods
      if (this._isGlobal) {
        for (var p in p5.prototype) {
          try {
            delete window[p];
          } catch (x) {
            window[p] = undefined;
          }
        }
        for (var p2 in this) {
          if (this.hasOwnProperty(p2)) {
            try {
              delete window[p2];
            } catch (x) {
              window[p2] = undefined;
            }
          }
        }
      }
    }
    // window.p5 = undefined;
  }.bind(this);

  // call any registered init functions
  this._registeredMethods.init.forEach(function (f) {
    if (typeof(f) !== 'undefined') {
      f.call(this);
    }
  }, this);

  var friendlyBindGlobal = this._createFriendlyGlobalFunctionBinder();

  // If the user has created a global setup or draw function,
  // assume "global" mode and make everything global (i.e. on the window)
  if (!sketch) {
    this._isGlobal = true;
    p5.instance = this;
    // Loop through methods on the prototype and attach them to the window
    for (var p in p5.prototype) {
      if(typeof p5.prototype[p] === 'function') {
        var ev = p.substring(2);
        if (!this._events.hasOwnProperty(ev)) {
          if (Math.hasOwnProperty(p) && (Math[p] === p5.prototype[p])) {
            // Multiple p5 methods are just native Math functions. These can be
            // called without any binding.
            friendlyBindGlobal(p, p5.prototype[p]);
          } else {
            friendlyBindGlobal(p, p5.prototype[p].bind(this));
          }
        }
      } else {
        friendlyBindGlobal(p, p5.prototype[p]);
      }
    }
    // Attach its properties to the window
    for (var p2 in this) {
      if (this.hasOwnProperty(p2)) {
        friendlyBindGlobal(p2, this[p2]);
      }
    }

  } else {
    // Else, the user has passed in a sketch closure that may set
    // user-provided 'setup', 'draw', etc. properties on this instance of p5
    sketch(this);
  }

  // Bind events to window (not using container div bc key events don't work)

  for (var e in this._events) {
    var f = this['_on'+e];
    if (f) {
      var m = f.bind(this);
      window.addEventListener(e, m, {passive: false});
      this._events[e] = m;
    }
  }

  var focusHandler = function() {
    this._setProperty('focused', true);
  }.bind(this);
  var blurHandler = function() {
    this._setProperty('focused', false);
  }.bind(this);
  window.addEventListener('focus', focusHandler);
  window.addEventListener('blur', blurHandler);
  this.registerMethod('remove', function() {
    window.removeEventListener('focus', focusHandler);
    window.removeEventListener('blur', blurHandler);
  });

  if (sync) {
    this._start();
  } else {
    if (document.readyState === 'complete') {
      this._start();
    } else {
      window.addEventListener('load', this._start.bind(this), false);
    }
  }
};

// This is a pointer to our global mode p5 instance, if we're in
// global mode.
p5.instance = null;

// Allows for the friendly error system to be turned off when creating a sketch,
// which can give a significant boost to performance when needed.
p5.disableFriendlyErrors = false;

// attach constants to p5 prototype
for (var k in constants) {
  p5.prototype[k] = constants[k];
}

// functions that cause preload to wait
// more can be added by using registerPreloadMethod(func)
p5.prototype._preloadMethods = {
  loadJSON: p5.prototype,
  loadImage: p5.prototype,
  loadStrings: p5.prototype,
  loadXML: p5.prototype,
  loadShape: p5.prototype,
  loadTable: p5.prototype,
  loadFont: p5.prototype,
  loadModel: p5.prototype
};

p5.prototype._registeredMethods = { init: [], pre: [], post: [], remove: [] };

p5.prototype._registeredPreloadMethods = {};

p5.prototype.registerPreloadMethod = function(fnString, obj) {
  // obj = obj || p5.prototype;
  if (!p5.prototype._preloadMethods.hasOwnProperty(fnString)) {
    p5.prototype._preloadMethods[fnString] = obj;
  }
};

p5.prototype.registerMethod = function(name, m) {
  if (!p5.prototype._registeredMethods.hasOwnProperty(name)) {
    p5.prototype._registeredMethods[name] = [];
  }
  p5.prototype._registeredMethods[name].push(m);
};

p5.prototype._createFriendlyGlobalFunctionBinder = function(options) {
  options = options || {};

  var globalObject = options.globalObject || window;
  var log = options.log || console.log.bind(console);
  var propsToForciblyOverwrite = {
    // p5.print actually always overwrites an existing global function,
    // albeit one that is very unlikely to be used:
    //
    //   https://developer.mozilla.org/en-US/docs/Web/API/Window/print
    'print': true
  };

  return function(prop, value) {
    if (!p5.disableFriendlyErrors &&
        typeof(IS_MINIFIED) === 'undefined' &&
        typeof(value) === 'function' &&
        !(prop in p5.prototype._preloadMethods)) {
      try {
        // Because p5 has so many common function names, it's likely
        // that users may accidentally overwrite global p5 functions with
        // their own variables. Let's allow this but log a warning to
        // help users who may be doing this unintentionally.
        //
        // For more information, see:
        //
        //   https://github.com/processing/p5.js/issues/1317

        if (prop in globalObject && !(prop in propsToForciblyOverwrite)) {
          throw new Error('global "' + prop + '" already exists');
        }

        // It's possible that this might throw an error because there
        // are a lot of edge-cases in which `Object.defineProperty` might
        // not succeed; since this functionality is only intended to
        // help beginners anyways, we'll just catch such an exception
        // if it occurs, and fall back to legacy behavior.
        Object.defineProperty(globalObject, prop, {
          configurable: true,
          enumerable: true,
          get: function() {
            return value;
          },
          set: function(newValue) {
            Object.defineProperty(globalObject, prop, {
              configurable: true,
              enumerable: true,
              value: newValue,
              writable: true
            });
            log(
              'You just changed the value of "' + prop + '", which was ' +
              'a p5 function. This could cause problems later if you\'re ' +
              'not careful.'
            );
          }
        });
      } catch (e) {
        log(
          'p5 had problems creating the global function "' + prop + '", ' +
          'possibly because your code is already using that name as ' +
          'a variable. You may want to rename your variable to something ' +
          'else.'
        );
        globalObject[prop] = value;
      }
    } else {
      globalObject[prop] = value;
    }
  };
};

module.exports = p5;

},{"./constants":41,"./shim":51}],43:[function(_dereq_,module,exports){
/**
 * @module Shape
 * @submodule Curves
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('./core');

_dereq_('./error_helpers');

var bezierDetail = 20;
var curveDetail = 20;

/**
 * Draws a cubic Bezier curve on the screen. These curves are defined by a
 * series of anchor and control points. The first two parameters specify
 * the first anchor point and the last two parameters specify the other
 * anchor point, which become the first and last points on the curve. The
 * middle parameters specify the two control points which define the shape
 * of the curve. Approximately speaking, control points "pull" the curve
 * towards them.<br /><br />Bezier curves were developed by French
 * automotive engineer Pierre Bezier, and are commonly used in computer
 * graphics to define gently sloping curves. See also curve().
 *
 * @method bezier
 * @param  {Number} x1 x-coordinate for the first anchor point
 * @param  {Number} y1 y-coordinate for the first anchor point
 * @param  {Number} x2 x-coordinate for the first control point
 * @param  {Number} y2 y-coordinate for the first control point
 * @param  {Number} x3 x-coordinate for the second control point
 * @param  {Number} y3 y-coordinate for the second control point
 * @param  {Number} x4 x-coordinate for the second anchor point
 * @param  {Number} y4 y-coordinate for the second anchor point
 * @return {Object}    the p5 object
 * @example
 * <div>
 * <code>
 * noFill();
 * stroke(255, 102, 0);
 * line(85, 20, 10, 10);
 * line(90, 90, 15, 80);
 * stroke(0, 0, 0);
 * bezier(85, 20, 10, 10, 90, 90, 15, 80);
 * </code>
 * </div>
 * @alt
 * stretched black s-shape in center with orange lines extending from end points.
 * stretched black s-shape with 10 5x5 white ellipses along the shape.
 * stretched black s-shape with 7 5x5 ellipses and orange lines along the shape.
 * stretched black s-shape with 17 small orange lines extending from under shape.
 * horseshoe shape with orange ends facing left and black curved center.
 * horseshoe shape with orange ends facing left and black curved center.
 * Line shaped like right-facing arrow,points move with mouse-x and warp shape.
 * horizontal line that hooks downward on the right and 13 5x5 ellipses along it.
 * right curving line mid-right of canvas with 7 short lines radiating from it.
 */
/**
 * @method bezier
 * @param  {Number} z1 z-coordinate for the first anchor point
 * @param  {Number} z2 z-coordinate for the first control point
 * @param  {Number} z3 z-coordinate for the first anchor point
 * @param  {Number} z4 z-coordinate for the first control point
 * @return {p5.Renderer3D}   [description]
 * @example
 * <div>
 * <code>
 *background(0, 0, 0);
 *noFill();
 *stroke(255);
 *bezier(250,250,0, 100,100,0, 100,0,0, 0,100,0);
 * </code>
 * </div>
*/
p5.prototype.bezier = function() {
  var args = new Array(arguments.length);
  for (var i = 0; i < args.length; ++i) {
    args[i] = arguments[i];
  }
  if (!this._renderer._doStroke && !this._renderer._doFill) {
    return this;
  }
  if (this._renderer.isP3D){
    args.push(bezierDetail);//adding value of bezier detail to the args array
    this._renderer.bezier(args);
  } else{
    this._renderer.bezier(args[0],args[1],
      args[2],args[3],
      args[4],args[5],
      args[6],args[7]);
  }

  return this;
};

/**
 * Sets the resolution at which Beziers display.
 *
 * The default value is 20.
 *
 * @param {Number} detail resolution of the curves
 * @return {Object} the p5 object
 * @example
 * <div>
 * <code>
 * background(204);
 * bezierDetail(50);
 * bezier(85, 20, 10, 10, 90, 90, 15, 80);
 * </code>
 * </div>
 *
 * @alt
 * stretched black s-shape with 7 5x5 ellipses and orange lines along the shape.
 *
 */
p5.prototype.bezierDetail = function(d) {
  bezierDetail = d;
  return this;
};

/**
 * Evaluates the Bezier at position t for points a, b, c, d.
 * The parameters a and d are the first and last points
 * on the curve, and b and c are the control points.
 * The final parameter t varies between 0 and 1.
 * This can be done once with the x coordinates and a second time
 * with the y coordinates to get the location of a bezier curve at t.
 *
 * @method bezierPoint
 * @param {Number} a coordinate of first point on the curve
 * @param {Number} b coordinate of first control point
 * @param {Number} c coordinate of second control point
 * @param {Number} d coordinate of second point on the curve
 * @param {Number} t value between 0 and 1
 * @return {Number} the value of the Bezier at position t
 * @example
 * <div>
 * <code>
 * noFill();
 * x1 = 85, x2 = 10, x3 = 90, x4 = 15;
 * y1 = 20, y2 = 10, y3 = 90, y4 = 80;
 * bezier(x1, y1, x2, y2, x3, y3, x4, y4);
 * fill(255);
 * steps = 10;
 * for (i = 0; i <= steps; i++) {
 *   t = i / steps;
 *   x = bezierPoint(x1, x2, x3, x4, t);
 *   y = bezierPoint(y1, y2, y3, y4, t);
 *   ellipse(x, y, 5, 5);
 * }
 * </code>
 * </div>
 *
 * @alt
 * stretched black s-shape with 17 small orange lines extending from under shape.
 *
 */
p5.prototype.bezierPoint = function(a, b, c, d, t) {
  var adjustedT = 1-t;
  return Math.pow(adjustedT,3)*a +
   3*(Math.pow(adjustedT,2))*t*b +
   3*adjustedT*Math.pow(t,2)*c +
   Math.pow(t,3)*d;
};

/**
 * Evaluates the tangent to the Bezier at position t for points a, b, c, d.
 * The parameters a and d are the first and last points
 * on the curve, and b and c are the control points.
 * The final parameter t varies between 0 and 1.
 *
 * @method bezierTangent
 * @param {Number} a coordinate of first point on the curve
 * @param {Number} b coordinate of first control point
 * @param {Number} c coordinate of second control point
 * @param {Number} d coordinate of second point on the curve
 * @param {Number} t value between 0 and 1
 * @return {Number} the tangent at position t
 * @example
 * <div>
 * <code>
 * noFill();
 * bezier(85, 20, 10, 10, 90, 90, 15, 80);
 * steps = 6;
 * fill(255);
 * for (i = 0; i <= steps; i++) {
 *   t = i / steps;
 *   // Get the location of the point
 *   x = bezierPoint(85, 10, 90, 15, t);
 *   y = bezierPoint(20, 10, 90, 80, t);
 *   // Get the tangent points
 *   tx = bezierTangent(85, 10, 90, 15, t);
 *   ty = bezierTangent(20, 10, 90, 80, t);
 *   // Calculate an angle from the tangent points
 *   a = atan2(ty, tx);
 *   a += PI;
 *   stroke(255, 102, 0);
 *   line(x, y, cos(a)*30 + x, sin(a)*30 + y);
 *   // The following line of code makes a line
 *   // inverse of the above line
 *   //line(x, y, cos(a)*-30 + x, sin(a)*-30 + y);
 *   stroke(0);
 *   ellipse(x, y, 5, 5);
 * }
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * noFill();
 * bezier(85, 20, 10, 10, 90, 90, 15, 80);
 * stroke(255, 102, 0);
 * steps = 16;
 * for (i = 0; i <= steps; i++) {
 *   t = i / steps;
 *   x = bezierPoint(85, 10, 90, 15, t);
 *   y = bezierPoint(20, 10, 90, 80, t);
 *   tx = bezierTangent(85, 10, 90, 15, t);
 *   ty = bezierTangent(20, 10, 90, 80, t);
 *   a = atan2(ty, tx);
 *   a -= HALF_PI;
 *   line(x, y, cos(a)*8 + x, sin(a)*8 + y);
 * }
 * </code>
 * </div>
 *
 * @alt
 * s-shaped line with 17 short orange lines extending from underside of shape
 *
 */
p5.prototype.bezierTangent = function(a, b, c, d, t) {
  var adjustedT = 1-t;
  return 3*d*Math.pow(t,2) -
   3*c*Math.pow(t,2) +
   6*c*adjustedT*t -
   6*b*adjustedT*t +
   3*b*Math.pow(adjustedT,2) -
   3*a*Math.pow(adjustedT,2);
};

/**
 * Draws a curved line on the screen between two points, given as the
 * middle four parameters. The first two parameters are a control point, as
 * if the curve came from this point even though it's not drawn. The last
 * two parameters similarly describe the other control point. <br /><br />
 * Longer curves can be created by putting a series of curve() functions
 * together or using curveVertex(). An additional function called
 * curveTightness() provides control for the visual quality of the curve.
 * The curve() function is an implementation of Catmull-Rom splines.
 *
 * @method curve
 * @param  {Number} x1 x-coordinate for the beginning control point
 * @param  {Number} y1 y-coordinate for the beginning control point
 * @param  {Number} x2 x-coordinate for the first point
 * @param  {Number} y2 y-coordinate for the first point
 * @param  {Number} x3 x-coordinate for the second point
 * @param  {Number} y3 y-coordinate for the second point
 * @param  {Number} x4 x-coordinate for the ending control point
 * @param  {Number} y4 y-coordinate for the ending control point
 * @return {Object}    the p5 object
 * @example
 * <div>
 * <code>
 * noFill();
 * stroke(255, 102, 0);
 * curve(5, 26, 5, 26, 73, 24, 73, 61);
 * stroke(0);
 * curve(5, 26, 73, 24, 73, 61, 15, 65);
 * stroke(255, 102, 0);
 * curve(73, 24, 73, 61, 15, 65, 15, 65);
 * </code>
 * </div>
 * <div>
 * <code>
 * // Define the curve points as JavaScript objects
 * p1 = {x: 5, y: 26}, p2 = {x: 73, y: 24}
 * p3 = {x: 73, y: 61}, p4 = {x: 15, y: 65}
 * noFill();
 * stroke(255, 102, 0);
 * curve(p1.x, p1.y, p1.x, p1.y, p2.x, p2.y, p3.x, p3.y)
 * stroke(0);
 * curve(p1.x, p1.y, p2.x, p2.y, p3.x, p3.y, p4.x, p4.y)
 * stroke(255, 102, 0);
 * curve(p2.x, p2.y, p3.x, p3.y, p4.x, p4.y, p4.x, p4.y)
 * </code>
 * </div>
 *
 * @alt
 * horseshoe shape with orange ends facing left and black curved center.
 * horseshoe shape with orange ends facing left and black curved center.
 *
 */
/**
 * @method curve
 * @param  {Number} z1 z-coordinate for the beginning control point
 * @param  {Number} z2 z-coordinate for the first point
 * @param  {Number} z3 z-coordinate for the second point
 * @param  {Number} z4 z-coordinate for the ending control point
 * @return {Object}    the p5 object
 * @example
 * <div>
 * <code>
 * noFill();
 * stroke(255, 102, 0);
 * curve(5,26,0, 5,26,0, 73,24,0, 73,61,0);
 * stroke(0);
 * curve(5,26,0, 73,24,0, 73,61,0, 15,65,0);
 * stroke(255, 102, 0);
 * curve(73,24,0, 73,61,0, 15,65,0, 15,65,0);
 * </code>
 * </div>
 *
 * @alt
 * curving black and orange lines.
 */
p5.prototype.curve = function() {
  var args = new Array(arguments.length);
  for (var i = 0; i < args.length; ++i) {
    args[i] = arguments[i];
  }
  if (!this._renderer._doStroke) {
    return this;
  }
  if (this._renderer.isP3D){
    args.push(curveDetail);
    this._renderer.curve(args);
  } else{
    this._renderer.curve(args[0],args[1],
      args[2],args[3],
      args[4],args[5],
      args[6],args[7]);
  }
  return this;
};

/**
 * Sets the resolution at which curves display.
 *
 * The default value is 20.
 *
 * @param {Number} resolution of the curves
 * @return {Object} the p5 object
 * @example
 * <div>
 * <code>
 * background(204);
 * curveDetail(20);
 * curve(5, 26, 5, 26, 73, 24, 73, 61);
 * </code>
 * </div>
 *
 * @alt
 * white arch shape in top-mid canvas.
 *
 */
p5.prototype.curveDetail = function(d) {
  curveDetail = d;
  return this;
};

/**
 * Modifies the quality of forms created with curve() and curveVertex().
 * The parameter tightness determines how the curve fits to the vertex
 * points. The value 0.0 is the default value for tightness (this value
 * defines the curves to be Catmull-Rom splines) and the value 1.0 connects
 * all the points with straight lines. Values within the range -5.0 and 5.0
 * will deform the curves but will leave them recognizable and as values
 * increase in magnitude, they will continue to deform.
 *
 * @method curveTightness
 * @param {Number} amount of deformation from the original vertices
 * @return {Object} the p5 object
 * @example
 * <div>
 * <code>
 * // Move the mouse left and right to see the curve change
 *
 * function setup() {
 *   createCanvas(100, 100);
 *   noFill();
 * }
 *
 * function draw() {
 *   background(204);
 *   var t = map(mouseX, 0, width, -5, 5);
 *   curveTightness(t);
 *   beginShape();
 *   curveVertex(10, 26);
 *   curveVertex(10, 26);
 *   curveVertex(83, 24);
 *   curveVertex(83, 61);
 *   curveVertex(25, 65);
 *   curveVertex(25, 65);
 *   endShape();
 * }
 * </code>
 * </div>
 *
 * @alt
 * Line shaped like right-facing arrow,points move with mouse-x and warp shape.
 */
p5.prototype.curveTightness = function (t) {
  this._renderer._curveTightness = t;
};

/**
 * Evaluates the curve at position t for points a, b, c, d.
 * The parameter t varies between 0 and 1, a and d are points
 * on the curve, and b and c are the control points.
 * This can be done once with the x coordinates and a second time
 * with the y coordinates to get the location of a curve at t.
 *
 * @method curvePoint
 * @param {Number} a coordinate of first point on the curve
 * @param {Number} b coordinate of first control point
 * @param {Number} c coordinate of second control point
 * @param {Number} d coordinate of second point on the curve
 * @param {Number} t value between 0 and 1
 * @return {Number} bezier value at position t
 * @example
 * <div>
 * <code>
 * noFill();
 * curve(5, 26, 5, 26, 73, 24, 73, 61);
 * curve(5, 26, 73, 24, 73, 61, 15, 65);
 * fill(255);
 * ellipseMode(CENTER);
 * steps = 6;
 * for (i = 0; i <= steps; i++) {
 *   t = i / steps;
 *   x = curvePoint(5, 5, 73, 73, t);
 *   y = curvePoint(26, 26, 24, 61, t);
 *   ellipse(x, y, 5, 5);
 *   x = curvePoint(5, 73, 73, 15, t);
 *   y = curvePoint(26, 24, 61, 65, t);
 *   ellipse(x, y, 5, 5);
 * }
 * </code>
 * </div>
 *
 *line hooking down to right-bottom with 13 5x5 white ellipse points
 */
p5.prototype.curvePoint = function(a, b, c, d, t) {
  var t3 = t*t*t,
    t2 = t*t,
    f1 = -0.5 * t3 + t2 - 0.5 * t,
    f2 = 1.5 * t3 - 2.5 * t2 + 1.0,
    f3 = -1.5 * t3 + 2.0 * t2 + 0.5 * t,
    f4 = 0.5 * t3 - 0.5 * t2;
  return a*f1 + b*f2 + c*f3 + d*f4;
};

/**
 * Evaluates the tangent to the curve at position t for points a, b, c, d.
 * The parameter t varies between 0 and 1, a and d are points on the curve,
 * and b and c are the control points.
 *
 * @method curveTangent
 * @param {Number} a coordinate of first point on the curve
 * @param {Number} b coordinate of first control point
 * @param {Number} c coordinate of second control point
 * @param {Number} d coordinate of second point on the curve
 * @param {Number} t value between 0 and 1
 * @return {Number} the tangent at position t
 * @example
 * <div>
 * <code>
 * noFill();
 * curve(5, 26, 73, 24, 73, 61, 15, 65);
 * steps = 6;
 * for (i = 0; i <= steps; i++) {
 *   t = i / steps;
 *   x = curvePoint(5, 73, 73, 15, t);
 *   y = curvePoint(26, 24, 61, 65, t);
 *   //ellipse(x, y, 5, 5);
 *   tx = curveTangent(5, 73, 73, 15, t);
 *   ty = curveTangent(26, 24, 61, 65, t);
 *   a = atan2(ty, tx);
 *   a -= PI/2.0;
 *   line(x, y, cos(a)*8 + x, sin(a)*8 + y);
 * }
 * </code>
 * </div>
 *
 * @alt
 *right curving line mid-right of canvas with 7 short lines radiating from it.
 */
p5.prototype.curveTangent = function(a, b,c, d, t) {
  var t2 = t*t,
    f1 = (-3*t2)/2 + 2*t - 0.5,
    f2 = (9*t2)/2 - 5*t,
    f3 = (-9*t2)/2 + 4*t + 0.5,
    f4 = (3*t2)/2 - t;
  return a*f1 + b*f2 + c*f3 + d*f4;
};

module.exports = p5;

},{"./core":42,"./error_helpers":45}],44:[function(_dereq_,module,exports){
/**
 * @module Environment
 * @submodule Environment
 * @for p5
 * @requires core
 * @requires constants
 */

'use strict';

var p5 = _dereq_('./core');
var C = _dereq_('./constants');

var standardCursors = [C.ARROW, C.CROSS, C.HAND, C.MOVE, C.TEXT, C.WAIT];

p5.prototype._frameRate = 0;
p5.prototype._lastFrameTime = window.performance.now();
p5.prototype._targetFrameRate = 60;

var _windowPrint = window.print;


if (window.console && console.log) {
  /**
   * The print() function writes to the console area of your browser.
   * This function is often helpful for looking at the data a program is
   * producing. This function creates a new line of text for each call to
   * the function. Individual elements can be
   * separated with quotes ("") and joined with the addition operator (+).
   * <br><br>
   * While print() is similar to console.log(), it does not directly map to
   * it in order to simulate easier to understand behavior than
   * console.log(). Due to this, it is slower. For fastest results, use
   * console.log().
   *
   * @method print
   * @param {Any} contents any combination of Number, String, Object, Boolean,
   *                       Array to print
   * @example
   * <div><code class='norender'>
   * var x = 10;
   * print("The value of x is " + x);
   * // prints "The value of x is 10"
   * </code></div>
   * @alt
   * default grey canvas
   */
  // Converts passed args into a string and then parses that string to
  // simulate synchronous behavior. This is a hack and is gross.
  // Since this will not work on all objects, particularly circular
  // structures, simply console.log() on error.
  p5.prototype.print = function(args) {
    try {
      if (arguments.length === 0) {
        _windowPrint();
      }
      else if (arguments.length > 1) {
        console.log.apply(console, arguments);
      } else {
        var newArgs = JSON.parse(JSON.stringify(args));
        if (JSON.stringify(newArgs)==='{}'){
          console.log(args);
        } else {
          console.log(newArgs);
        }
      }
    } catch(err) {
      console.log(args);
    }
  };
} else {
  p5.prototype.print = function() {};
}


/**
 * The system variable frameCount contains the number of frames that have
 * been displayed since the program started. Inside setup() the value is 0,
 * after the first iteration of draw it is 1, etc.
 *
 * @property frameCount
 * @example
 *   <div><code>
 *     function setup() {
 *       frameRate(30);
 *       textSize(20);
 *       textSize(30);
 *       textAlign(CENTER);
 *     }
 *
 *     function draw() {
 *       background(200);
 *       text(frameCount, width/2, height/2);
 *     }
 *   </code></div>
 *
 * @alt
 * numbers rapidly counting upward with frame count set to 30.
 *
 */
p5.prototype.frameCount = 0;

/**
 * Confirms if the window a p5.js program is in is "focused," meaning that
 * the sketch will accept mouse or keyboard input. This variable is
 * "true" if the window is focused and "false" if not.
 *
 * @property focused
 * @example
 * <div><code>
 * // To demonstrate, put two windows side by side.
 * // Click on the window that the p5 sketch isn't in!
 * function draw() {
 *   background(200);
 *   noStroke();
 *   fill(0, 200, 0);
 *   ellipse(25, 25, 50, 50);
 *
 *   if (!focused) {  // or "if (focused === false)"
 *     stroke(200,0,0);
 *     line(0, 0, 100, 100);
 *     line(100, 0, 0, 100);
 *   }
 * }
 * </code></div>
 *
 * @alt
 * green 50x50 ellipse at top left. Red X covers canvas when page focus changes
 *
 */
p5.prototype.focused = (document.hasFocus());

/**
 * Sets the cursor to a predefined symbol or an image, or makes it visible
 * if already hidden. If you are trying to set an image as the cursor, the
 * recommended size is 16x16 or 32x32 pixels. It is not possible to load an
 * image as the cursor if you are exporting your program for the Web, and not
 * all MODES work with all browsers. The values for parameters x and y must
 * be less than the dimensions of the image.
 *
 * @method cursor
 * @param {Number|Constant} type either ARROW, CROSS, HAND, MOVE, TEXT, or
 *                               WAIT, or path for image
 * @param {Number}          [x]  the horizontal active spot of the cursor
 * @param {Number}          [y]  the vertical active spot of the cursor
 * @example
 * <div><code>
 * // Move the mouse left and right across the image
 * // to see the cursor change from a cross to a hand
 * function draw() {
 *   line(width/2, 0, width/2, height);
 *   if (mouseX < 50) {
 *     cursor(CROSS);
 *   } else {
 *     cursor(HAND);
 *   }
 * }
 * </code></div>
 *
 * @alt
 * horizontal line divides canvas. cursor on left is a cross, right is hand.
 *
 */
p5.prototype.cursor = function(type, x, y) {
  var cursor = 'auto';
  var canvas = this._curElement.elt;
  if (standardCursors.indexOf(type) > -1) {
    // Standard css cursor
    cursor = type;
  } else if (typeof type === 'string') {
    var coords = '';
    if (x && y && (typeof x === 'number' && typeof y === 'number')) {
      // Note that x and y values must be unit-less positive integers < 32
      // https://developer.mozilla.org/en-US/docs/Web/CSS/cursor
      coords = x + ' ' + y;
    }
    if ((type.substring(0, 7) === 'http://') ||
        (type.substring(0, 8) === 'https://')) {
      // Image (absolute url)
      cursor = 'url(' + type + ') ' + coords + ', auto';
    } else if (/\.(cur|jpg|jpeg|gif|png|CUR|JPG|JPEG|GIF|PNG)$/.test(type)) {
      // Image file (relative path) - Separated for performance reasons
      cursor = 'url(' + type + ') ' + coords + ', auto';
    } else {
      // Any valid string for the css cursor property
      cursor = type;
    }
  }
  canvas.style.cursor = cursor;
};

/**
 * Specifies the number of frames to be displayed every second. For example,
 * the function call frameRate(30) will attempt to refresh 30 times a second.
 * If the processor is not fast enough to maintain the specified rate, the
 * frame rate will not be achieved. Setting the frame rate within setup() is
 * recommended. The default rate is 60 frames per second. This is the same as
 * setFrameRate(val).
 * <br><br>
 * Calling frameRate() with no arguments returns the current framerate. The
 * draw function must run at least once before it will return a value. This
 * is the same as getFrameRate().
 * <br><br>
 * Calling frameRate() with arguments that are not of the type numbers
 * or are non positive also returns current framerate.
 *
 * @method frameRate
 * @param  {Number} [fps] number of frames to be displayed every second
 * @return {Number}       current frameRate
 * @example
 *
 * <div><code>
 * var rectX = 0;
 * var fr = 30; //starting FPS
 * var clr;
 *
 * function setup() {
 *   background(200);
 *   frameRate(fr); // Attempt to refresh at starting FPS
 *   clr = color(255,0,0);
 * }
 *
 * function draw() {
 *   background(200);
 *   rectX = rectX += 1; // Move Rectangle
 *
 *   if (rectX >= width) { // If you go off screen.
 *     if (fr == 30) {
 *       clr = color(0,0,255);
 *       fr = 10;
 *       frameRate(fr); // make frameRate 10 FPS
 *     } else {
 *       clr = color(255,0,0);
 *       fr = 30;
 *       frameRate(fr); // make frameRate 30 FPS
 *     }
 *     rectX = 0;
 *   }
 *   fill(clr);
 *   rect(rectX, 40, 20,20);
 * }
 * </div></code>
 *
 * @alt
 * blue rect moves left to right, followed by red rect moving faster. Loops.
 *
 */
p5.prototype.frameRate = function(fps) {
  if (typeof fps !== 'number' || fps <= 0) {
    return this._frameRate;
  } else {
    this._setProperty('_targetFrameRate', fps);
    this._runFrames();
    return this;
  }
};
/**
 * Returns the current framerate.
 *
 * @return {Number} current frameRate
 */
p5.prototype.getFrameRate = function() {
  return this.frameRate();
};

/**
 * Specifies the number of frames to be displayed every second. For example,
 * the function call frameRate(30) will attempt to refresh 30 times a second.
 * If the processor is not fast enough to maintain the specified rate, the
 * frame rate will not be achieved. Setting the frame rate within setup() is
 * recommended. The default rate is 60 frames per second.
 *
 * Calling frameRate() with no arguments returns the current framerate.
 *
 * @param {Number} [fps] number of frames to be displayed every second
 */
p5.prototype.setFrameRate = function(fps) {
  return this.frameRate(fps);
};

/**
 * Hides the cursor from view.
 *
 * @method noCursor
 * @example
 * <div><code>
 * function setup() {
 *   noCursor();
 * }
 *
 * function draw() {
 *   background(200);
 *   ellipse(mouseX, mouseY, 10, 10);
 * }
 * </code></div>
 *
 *
 * @alt
 * cursor becomes 10x 10 white ellipse the moves with mouse x and y.
 *
 */
p5.prototype.noCursor = function() {
  this._curElement.elt.style.cursor = 'none';
};


/**
 * System variable that stores the width of the entire screen display. This
 * is used to run a full-screen program on any display size.
 *
 * @property displayWidth
 * @example
 * <div class="norender"><code>
 * createCanvas(displayWidth, displayHeight);
 * </code></div>
 *
 * @alt
 * cursor becomes 10x 10 white ellipse the moves with mouse x and y.
 *
 */
p5.prototype.displayWidth = screen.width;

/**
 * System variable that stores the height of the entire screen display. This
 * is used to run a full-screen program on any display size.
 *
 * @property displayHeight
 * @example
 * <div class="norender"><code>
 * createCanvas(displayWidth, displayHeight);
 * </code></div>
 *
 * @alt
 * no display.
 *
 */
p5.prototype.displayHeight = screen.height;

/**
 * System variable that stores the width of the inner window, it maps to
 * window.innerWidth.
 *
 * @property windowWidth
 * @example
 * <div class="norender"><code>
 * createCanvas(windowWidth, windowHeight);
 * </code></div>
 *
 * @alt
 * no display.
 *
 */
p5.prototype.windowWidth = getWindowWidth();
/**
 * System variable that stores the height of the inner window, it maps to
 * window.innerHeight.
 *
 * @property windowHeight
 * @example
 * <div class="norender"><code>
 * createCanvas(windowWidth, windowHeight);
 * </code></div>
*@alt
 * no display.
 *
*/
p5.prototype.windowHeight = getWindowHeight();

/**
 * The windowResized() function is called once every time the browser window
 * is resized. This is a good place to resize the canvas or do any other
 * adjustments to accommodate the new window size.
 *
 * @method windowResized
 * @example
 * <div class="norender"><code>
 * function setup() {
 *   createCanvas(windowWidth, windowHeight);
 * }
 *
 * function draw() {
 *  background(0, 100, 200);
 * }
 *
 * function windowResized() {
 *   resizeCanvas(windowWidth, windowHeight);
 * }
 * </code></div>
 * @alt
 * no display.
 */
p5.prototype._onresize = function(e){
  this._setProperty('windowWidth', getWindowWidth());
  this._setProperty('windowHeight', getWindowHeight());
  var context = this._isGlobal ? window : this;
  var executeDefault;
  if (typeof context.windowResized === 'function') {
    executeDefault = context.windowResized(e);
    if (executeDefault !== undefined && !executeDefault) {
      e.preventDefault();
    }
  }
};

function getWindowWidth() {
  return window.innerWidth ||
         document.documentElement && document.documentElement.clientWidth ||
         document.body && document.body.clientWidth ||
         0;
}

function getWindowHeight() {
  return window.innerHeight ||
         document.documentElement && document.documentElement.clientHeight ||
         document.body && document.body.clientHeight ||
         0;
}

/**
 * System variable that stores the width of the drawing canvas. This value
 * is set by the first parameter of the createCanvas() function.
 * For example, the function call createCanvas(320, 240) sets the width
 * variable to the value 320. The value of width defaults to 100 if
 * createCanvas() is not used in a program.
 *
 * @property width
 */
p5.prototype.width = 0;

/**
 * System variable that stores the height of the drawing canvas. This value
 * is set by the second parameter of the createCanvas() function. For
 * example, the function call createCanvas(320, 240) sets the height
 * variable to the value 240. The value of height defaults to 100 if
 * createCanvas() is not used in a program.
 *
 * @property height
 */
p5.prototype.height = 0;

/**
 * If argument is given, sets the sketch to fullscreen or not based on the
 * value of the argument. If no argument is given, returns the current
 * fullscreen state. Note that due to browser restrictions this can only
 * be called on user input, for example, on mouse press like the example
 * below.
 *
 * @method fullscreen
 * @param  {Boolean} [val] whether the sketch should be in fullscreen mode
 * or not
 * @return {Boolean} current fullscreen state
 * @example
 * <div>
 * <code>
 * // Clicking in the box toggles fullscreen on and off.
 * function setup() {
 *   background(200);
 * }
 * function mousePressed() {
 *   if (mouseX > 0 && mouseX < 100 && mouseY > 0 && mouseY < 100) {
 *     var fs = fullscreen();
 *     fullscreen(!fs);
 *   }
 * }
 * </code>
 * </div>
 *
 * @alt
 * no display.
 *
 */
p5.prototype.fullscreen = function(val) {
  // no arguments, return fullscreen or not
  if (typeof val === 'undefined') {
    return document.fullscreenElement ||
           document.webkitFullscreenElement ||
           document.mozFullScreenElement ||
           document.msFullscreenElement;
  } else { // otherwise set to fullscreen or not
    if (val) {
      launchFullscreen(document.documentElement);
    } else {
      exitFullscreen();
    }
  }
};

/**
 * Sets the pixel scaling for high pixel density displays. By default
 * pixel density is set to match display density, call pixelDensity(1)
 * to turn this off. Calling pixelDensity() with no arguments returns
 * the current pixel density of the sketch.
 *
 *
 * @method pixelDensity
 * @param  {Number} [val] whether or how much the sketch should scale
 * @returns {Number} current pixel density of the sketch
 * @example
 * <div>
 * <code>
 * function setup() {
 *   pixelDensity(1);
 *   createCanvas(100, 100);
 *   background(200);
 *   ellipse(width/2, height/2, 50, 50);
 * }
 * </code>
 * </div>
 * <div>
 * <code>
 * function setup() {
 *   pixelDensity(3.0);
 *   createCanvas(100, 100);
 *   background(200);
 *   ellipse(width/2, height/2, 50, 50);
 * }
 * </code>
 * </div>
 *
 * @alt
 * fuzzy 50x50 white ellipse with black outline in center of canvas.
 * sharp 50x50 white ellipse with black outline in center of canvas.
 */
p5.prototype.pixelDensity = function(val) {
  if (typeof val === 'number') {
    this._pixelDensity = val;
  } else {
    return this._pixelDensity;
  }
  this.resizeCanvas(this.width, this.height, true);
};

/**
 * Returns the pixel density of the current display the sketch is running on.
 *
 * @method displayDensity
 * @returns {Number} current pixel density of the display
 * @example
 * <div>
 * <code>
 * function setup() {
 *   var density = displayDensity();
 *   pixelDensity(density);
 *   createCanvas(100, 100);
 *   background(200);
 *   ellipse(width/2, height/2, 50, 50);
 * }
 * </code>
 * </div>
 *
 * @alt
 * 50x50 white ellipse with black outline in center of canvas.
 */
p5.prototype.displayDensity = function() {
  return window.devicePixelRatio;
};

function launchFullscreen(element) {
  var enabled = document.fullscreenEnabled ||
                document.webkitFullscreenEnabled ||
                document.mozFullScreenEnabled ||
                document.msFullscreenEnabled;
  if (!enabled) {
    throw new Error('Fullscreen not enabled in this browser.');
  }
  if(element.requestFullscreen) {
    element.requestFullscreen();
  } else if(element.mozRequestFullScreen) {
    element.mozRequestFullScreen();
  } else if(element.webkitRequestFullscreen) {
    element.webkitRequestFullscreen();
  } else if(element.msRequestFullscreen) {
    element.msRequestFullscreen();
  }
}

function exitFullscreen() {
  if(document.exitFullscreen) {
    document.exitFullscreen();
  } else if(document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if(document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  }
}


/**
 * Gets the current URL.
 * @method getURL
 * @return {String} url
 * @example
 * <div>
 * <code>
 * var url;
 * var x = 100;
 *
 * function setup() {
 *   fill(0);
 *   noStroke();
 *   url = getURL();
 * }
 *
 * function draw() {
 *   background(200);
 *   text(url, x, height/2);
 *   x--;
 * }
 * </code>
 * </div>
 *
 * @alt
 * current url (http://p5js.org/reference/#/p5/getURL) moves right to left.
 *
 */
p5.prototype.getURL = function() {
  return location.href;
};
/**
 * Gets the current URL path as an array.
 * @method getURLPath
 * @return {Array} path components
 * @example
 * <div class='norender'><code>
 * function setup() {
 *   var urlPath = getURLPath();
 *   for (var i=0; i&lt;urlPath.length; i++) {
 *     text(urlPath[i], 10, i*20+20);
 *   }
 * }
 * </code></div>
 *
 * @alt
 *no display
 *
 */
p5.prototype.getURLPath = function() {
  return location.pathname.split('/').filter(function(v){return v!=='';});
};
/**
 * Gets the current URL params as an Object.
 * @method getURLParams
 * @return {Object} URL params
 * @example
 * <div class='norender'>
 * <code>
 * // Example: http://p5js.org?year=2014&month=May&day=15
 *
 * function setup() {
 *   var params = getURLParams();
 *   text(params.day, 10, 20);
 *   text(params.month, 10, 40);
 *   text(params.year, 10, 60);
 * }
 * </code>
 * </div>
 * @alt
 * no display.
 *
 */
p5.prototype.getURLParams = function() {
  var re = /[?&]([^&=]+)(?:[&=])([^&=]+)/gim;
  var m;
  var v={};
  while ((m = re.exec(location.search)) != null) {
    if (m.index === re.lastIndex) {
      re.lastIndex++;
    }
    v[m[1]]=m[2];
  }
  return v;
};

module.exports = p5;

},{"./constants":41,"./core":42}],45:[function(_dereq_,module,exports){
/**
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('./core');
var doFriendlyWelcome = false; // TEMP until we get it all working LM

// -- Borrowed from jQuery 1.11.3 --
var class2type = {};
var toString = class2type.toString;
var names = ['Boolean', 'Number', 'String', 'Function',
             'Array', 'Date', 'RegExp', 'Object', 'Error'];
for (var n=0; n<names.length; n++) {
  class2type[ '[object ' + names[n] + ']' ] = names[n].toLowerCase();
}
var getType = function( obj ) {
  if ( obj == null ) {
    return obj + '';
  }
  return typeof obj === 'object' || typeof obj === 'function' ?
    class2type[ toString.call(obj) ] || 'object' :
    typeof obj;
};

// -- End borrow --


/**
 * Prints out a fancy, colorful message to the console log
 *
 * @param  {String}               message the words to be said
 * @param  {String}               func    the name of the function to link
 * @param  {Integer/Color String} color   CSS color string or error type
 *
 * @return console logs
 */
// Wrong number of params, undefined param, wrong type
var FILE_LOAD = 3;
// p5.js blue, p5.js orange, auto dark green; fallback p5.js darkened magenta
// See testColors below for all the color codes and names
var typeColors = ['#2D7BB6', '#EE9900', '#4DB200', '#C83C00'];
function report(message, func, color) {
  if(doFriendlyWelcome){
    friendlyWelcome();
    doFriendlyWelcome =false;
  }
  if ('undefined' === getType(color)) {
    color   = '#B40033'; // dark magenta
  } else if (getType(color) === 'number') { // Type to color
    color = typeColors[color];
  }
  // LM TEMP commenting this out until we get the whole system working
  // if (func.substring(0,4) === 'load'){
  //   console.log(
  //     '%c> p5.js says: '+message+'%c'+
  //     '[https://github.com/processing/p5.js/wiki/Local-server]',
  //     'background-color:' + color + ';color:#FFF;',
  //     'background-color:transparent;color:' + color +';',
  //     'background-color:' + color + ';color:#FFF;',
  //     'background-color:transparent;color:' + color +';'
  //   );
  // }
  // else{
  //   console.log(
  //     '%c> p5.js says: '+message+'%c [http://p5js.org/reference/#p5/'+func+
  //     ']', 'background-color:' + color + ';color:#FFF;',
  //     'background-color:transparent;color:' + color +';'
  //   );
  // }
}

var errorCases = {
  '0': {
    fileType: 'image',
    method: 'loadImage',
    message: ' hosting the image online,'
  },
  '1': {
    fileType: 'XML file',
    method: 'loadXML'
  },
  '2': {
    fileType: 'table file',
    method: 'loadTable'
  },
  '3': {
    fileType: 'text file',
    method: 'loadStrings'
  },
  '4': {
    fileType: 'font',
    method: 'loadFont',
    message: ' hosting the font online,'
  },
};
p5._friendlyFileLoadError = function (errorType, filePath) {
  var errorInfo = errorCases[ errorType ];
  var message = 'It looks like there was a problem' +
  ' loading your ' + errorInfo.fileType + '.' +
  ' Try checking if the file path%c [' + filePath + '] %cis correct,' +
  (errorInfo.message || '') + ' or running a local server.';
  report(message, errorInfo.method, FILE_LOAD);
};

function friendlyWelcome() {
  // p5.js brand - magenta: #ED225D
  var astrixBgColor = 'transparent';
  var astrixTxtColor = '#ED225D';
  var welcomeBgColor = '#ED225D';
  var welcomeTextColor = 'white';
  console.log(
  '%c    _ \n'+
  ' /\\| |/\\ \n'+
  ' \\ ` \' /  \n'+
  ' / , . \\  \n'+
  ' \\/|_|\\/ '+
  '\n\n%c> p5.js says: Welcome! '+
  'This is your friendly debugger. ' +
  'To turn me off switch to using “p5.min.js”.',
  'background-color:'+astrixBgColor+';color:' + astrixTxtColor +';',
  'background-color:'+welcomeBgColor+';color:' + welcomeTextColor +';'
  );
}

/**
 * Prints out all the colors in the color pallete with white text.
 * For color blindness testing.
 */
/* function testColors() {
  var str = 'A box of biscuits, a box of mixed biscuits and a biscuit mixer';
  report(str, 'print', '#ED225D'); // p5.js magenta
  report(str, 'print', '#2D7BB6'); // p5.js blue
  report(str, 'print', '#EE9900'); // p5.js orange
  report(str, 'print', '#A67F59'); // p5.js light brown
  report(str, 'print', '#704F21'); // p5.js gold
  report(str, 'print', '#1CC581'); // auto cyan
  report(str, 'print', '#FF6625'); // auto orange
  report(str, 'print', '#79EB22'); // auto green
  report(str, 'print', '#B40033'); // p5.js darkened magenta
  report(str, 'print', '#084B7F'); // p5.js darkened blue
  report(str, 'print', '#945F00'); // p5.js darkened orange
  report(str, 'print', '#6B441D'); // p5.js darkened brown
  report(str, 'print', '#2E1B00'); // p5.js darkened gold
  report(str, 'print', '#008851'); // auto dark cyan
  report(str, 'print', '#C83C00'); // auto dark orange
  report(str, 'print', '#4DB200'); // auto dark green
} */

// This is a lazily-defined list of p5 symbols that may be
// misused by beginners at top-level code, outside of setup/draw. We'd like
// to detect these errors and help the user by suggesting they move them
// into setup/draw.
//
// For more details, see https://github.com/processing/p5.js/issues/1121.
var misusedAtTopLevelCode = null;
var FAQ_URL = 'https://github.com/processing/p5.js/wiki/' +
              'Frequently-Asked-Questions' +
              '#why-cant-i-assign-variables-using-p5-functions-and-' +
              'variables-before-setup';

function defineMisusedAtTopLevelCode() {
  var uniqueNamesFound = {};

  var getSymbols = function(obj) {
    return Object.getOwnPropertyNames(obj).filter(function(name) {
      if (name[0] === '_') {
        return false;
      }
      if (name in uniqueNamesFound) {
        return false;
      }

      uniqueNamesFound[name] = true;

      return true;
    }).map(function(name) {
      var type;

      if (typeof(obj[name]) === 'function') {
        type = 'function';
      } else if (name === name.toUpperCase()) {
        type = 'constant';
      } else {
        type = 'variable';
      }

      return {name: name, type: type};
    });
  };

  misusedAtTopLevelCode = [].concat(
    getSymbols(p5.prototype),
    // At present, p5 only adds its constants to p5.prototype during
    // construction, which may not have happened at the time a
    // ReferenceError is thrown, so we'll manually add them to our list.
    getSymbols(_dereq_('./constants'))
  );

  // This will ultimately ensure that we report the most specific error
  // possible to the user, e.g. advising them about HALF_PI instead of PI
  // when their code misuses the former.
  misusedAtTopLevelCode.sort(function(a, b) {
    return b.name.length - a.name.length;
  });
}

function helpForMisusedAtTopLevelCode(e, log) {
  if (!log) {
    log = console.log.bind(console);
  }

  if (!misusedAtTopLevelCode) {
    defineMisusedAtTopLevelCode();
  }

  // If we find that we're logging lots of false positives, we can
  // uncomment the following code to avoid displaying anything if the
  // user's code isn't likely to be using p5's global mode. (Note that
  // setup/draw are more likely to be defined due to JS function hoisting.)
  //
  //if (!('setup' in window || 'draw' in window)) {
  //  return;
  //}

  misusedAtTopLevelCode.some(function(symbol) {
    // Note that while just checking for the occurrence of the
    // symbol name in the error message could result in false positives,
    // a more rigorous test is difficult because different browsers
    // log different messages, and the format of those messages may
    // change over time.
    //
    // For example, if the user uses 'PI' in their code, it may result
    // in any one of the following messages:
    //
    //   * 'PI' is undefined                           (Microsoft Edge)
    //   * ReferenceError: PI is undefined             (Firefox)
    //   * Uncaught ReferenceError: PI is not defined  (Chrome)

    if (e.message && e.message.match('\\W?'+symbol.name+'\\W') !== null) {
      log('%cDid you just try to use p5.js\'s ' + symbol.name +
          (symbol.type === 'function' ? '() ' : ' ') + symbol.type +
          '? If so, you may want to ' +
          'move it into your sketch\'s setup() function.\n\n' +
          'For more details, see: ' + FAQ_URL,
          'color: #B40033' /* Dark magenta */);
      return true;
    }
  });
}

// Exposing this primarily for unit testing.
p5.prototype._helpForMisusedAtTopLevelCode = helpForMisusedAtTopLevelCode;

if (document.readyState !== 'complete') {
  window.addEventListener('error', helpForMisusedAtTopLevelCode, false);

  // Our job is only to catch ReferenceErrors that are thrown when
  // global (non-instance mode) p5 APIs are used at the top-level
  // scope of a file, so we'll unbind our error listener now to make
  // sure we don't log false positives later.
  window.addEventListener('load', function() {
    window.removeEventListener('error', helpForMisusedAtTopLevelCode, false);
  });
}

module.exports = p5;

},{"./constants":41,"./core":42}],46:[function(_dereq_,module,exports){
/**
 * @module DOM
 * @submodule DOM
 * @for p5.Element
 */

var p5 = _dereq_('./core');

/**
 * Base class for all elements added to a sketch, including canvas,
 * graphics buffers, and other HTML elements. Methods in blue are
 * included in the core functionality, methods in brown are added
 * with the <a href="http://p5js.org/reference/#/libraries/p5.dom">p5.dom
 * library</a>.
 * It is not called directly, but p5.Element
 * objects are created by calling createCanvas, createGraphics,
 * or in the p5.dom library, createDiv, createImg, createInput, etc.
 *
 * @class p5.Element
 * @constructor
 * @param {String} elt DOM node that is wrapped
 * @param {Object} [pInst] pointer to p5 instance
 */
p5.Element = function(elt, pInst) {
  /**
   * Underlying HTML element. All normal HTML methods can be called on this.
   *
   * @property elt
   */
  this.elt = elt;
  this._pInst = pInst;
  this._events = {};
  this.width = this.elt.offsetWidth;
  this.height = this.elt.offsetHeight;
};

/**
 *
 * Attaches the element to the parent specified. A way of setting
 * the container for the element. Accepts either a string ID, DOM
 * node, or p5.Element. If no arguments given, parent node is returned.
 * For more ways to position the canvas, see the
 * <a href='https://github.com/processing/p5.js/wiki/Positioning-your-canvas'>
 * positioning the canvas</a> wiki page.
 *
 * @method parent
 * @param  {String|Object} parent the ID, DOM node, or p5.Element
 *                         of desired parent element
 * @return {p5.Element}
 * @example
 * <div class="norender"><code>
 * // in the html file:
 * &lt;div id="myContainer">&lt;/div>
 * // in the js file:
 * var cnv = createCanvas(100, 100);
 * cnv.parent("myContainer");
 * </code></div>
 * <div class='norender'><code>
 * var div0 = createDiv('this is the parent');
 * var div1 = createDiv('this is the child');
 * div1.parent(div0); // use p5.Element
 * </code></div>
 * <div class='norender'><code>
 * var div0 = createDiv('this is the parent');
 * div0.id('apples');
 * var div1 = createDiv('this is the child');
 * div1.parent('apples'); // use id
 * </code></div>
 * <div class='norender'><code>
 * var elt = document.getElementById('myParentDiv');
 * var div1 = createDiv('this is the child');
 * div1.parent(elt); // use element from page
 * </code></div>
 *
 * @alt
 * no display.
 *
 */
p5.Element.prototype.parent = function(p) {
  if (arguments.length === 0){
    return this.elt.parentNode;
  } else {
    if (typeof p === 'string') {
      if (p[0] === '#') {
        p = p.substring(1);
      }
      p = document.getElementById(p);
    } else if (p instanceof p5.Element) {
      p = p.elt;
    }
    p.appendChild(this.elt);
    return this;
  }
};

/**
 *
 * Sets the ID of the element. If no ID argument is passed in, it instead
 * returns the current ID of the element.
 *
 * @method id
 * @param  {String} [id] ID of the element
 * @return {p5.Element|String}
 * @example
 * <div class='norender'><code>
 * function setup() {
 *   var cnv = createCanvas(100, 100);
 *   // Assigns a CSS selector ID to
 *   // the canvas element.
 *   cnv.id("mycanvas");
 * }
 * </code></div>
 *
 * @alt
 * no display.
 *
 */
p5.Element.prototype.id = function(id) {
  if (arguments.length === 0) {
    return this.elt.id;
  } else {
    this.elt.id = id;
    this.width = this.elt.offsetWidth;
    this.height = this.elt.offsetHeight;
    return this;
  }
};

/**
 *
 * Adds given class to the element. If no class argument is passed in, it
 * instead returns a string containing the current class(es) of the element.
 *
 * @method class
 * @param  {String} [class] class to add
 * @return {p5.Element|String}
 */
p5.Element.prototype.class = function(c) {
  if (arguments.length === 0) {
    return this.elt.className;
  } else {
    this.elt.className = c;
    return this;
  }
};

/**
 * The .mousePressed() function is called once after every time a
 * mouse button is pressed over the element. This can be used to
 * attach element specific event listeners.
 *
 * @method mousePressed
 * @param  {Function} fxn function to be fired when mouse is
 *                    pressed over the element.
 * @return {p5.Element}
 * @example
 * <div class='norender'><code>
 * var cnv;
 * var d;
 * var g;
 * function setup() {
 *   cnv = createCanvas(100, 100);
 *   cnv.mousePressed(changeGray); // attach listener for
 *                                 // canvas click only
 *   d = 10;
 *   g = 100;
 * }
 *
 * function draw() {
 *   background(g);
 *   ellipse(width/2, height/2, d, d);
 * }
 *
 * // this function fires with any click anywhere
 * function mousePressed() {
 *   d = d + 10;
 * }
 *
 * // this function fires only when cnv is clicked
 * function changeGray() {
 *   g = random(0, 255);
 * }
 * </code></div>
 *
 * @alt
 * no display.
 *
 */
p5.Element.prototype.mousePressed = function (fxn) {
  attachListener('mousedown', fxn, this);
  attachListener('touchstart', fxn, this);
  return this;
};

/**
 * The .mouseWheel() function is called once after every time a
 * mouse wheel is scrolled over the element. This can be used to
 * attach element specific event listeners.
 * <br><br>
 * The function accepts a callback function as argument which will be executed
 * when the `wheel` event is triggered on the element, the callabck function is
 * passed one argument `event`. The `event.deltaY` property returns negative
 * values if the mouse wheel is rotated up or away from the user and positive
 * in the other direction. The `event.deltaX` does the same as `event.deltaY`
 * except it reads the horizontal wheel scroll of the mouse wheel.
 * <br><br>
 * On OS X with "natural" scrolling enabled, the `event.deltaY` values are
 * reversed.
 *
 * @method mouseWheel
 * @param  {Function} fxn function to be fired when mouse wheel is
 *                    scrolled over the element.
 * @return {p5.Element}
 * @example
 * <div class='norender'><code>
 * var cnv;
 * var d;
 * var g;
 * function setup() {
 *   cnv = createCanvas(100, 100);
 *   cnv.mouseWheel(changeSize); // attach listener for
 *                               // activity on canvas only
 *   d = 10;
 *   g = 100;
 * }
 *
 * function draw() {
 *   background(g);
 *   ellipse(width/2, height/2, d, d);
 * }
 *
 * // this function fires with mousewheel movement
 * // anywhere on screen
 * function mouseWheel() {
 *   g = g + 10;
 * }
 *
 * // this function fires with mousewheel movement
 * // over canvas only
 * function changeSize(event) {
 *   if (event.deltaY > 0) {
 *     d = d + 10;
 *   } else {
 *     d = d - 10;
 *   }
 * }
 * </code></div>
 *
 *
 * @alt
 * no display.
 *
 */
p5.Element.prototype.mouseWheel = function (fxn) {
  attachListener('wheel', fxn, this);
  return this;
};

/**
 * The .mouseReleased() function is called once after every time a
 * mouse button is released over the element. This can be used to
 * attach element specific event listeners.
 *
 * @method mouseReleased
 * @param  {Function} fxn function to be fired when mouse is
 *                    released over the element.
 * @return {p5.Element}
 * @example
 * <div class='norender'><code>
 * var cnv;
 * var d;
 * var g;
 * function setup() {
 *   cnv = createCanvas(100, 100);
 *   cnv.mouseReleased(changeGray); // attach listener for
 *                                  // activity on canvas only
 *   d = 10;
 *   g = 100;
 * }
 *
 * function draw() {
 *   background(g);
 *   ellipse(width/2, height/2, d, d);
 * }
 *
 * // this function fires after the mouse has been
 * // released
 * function mouseReleased() {
 *   d = d + 10;
 * }
 *
 * // this function fires after the mouse has been
 * // released while on canvas
 * function changeGray() {
 *   g = random(0, 255);
 * }
 * </code></div>
 *
 *
 * @alt
 * no display.
 *
 */
p5.Element.prototype.mouseReleased = function (fxn) {
  attachListener('mouseup', fxn, this);
  attachListener('touchend', fxn, this);
  return this;
};


/**
 * The .mouseClicked() function is called once after a mouse button is
 * pressed and released over the element. This can be used to
 * attach element specific event listeners.
 *
 * @method mouseClicked
 * @param  {Function} fxn function to be fired when mouse is
 *                    clicked over the element.
 * @return {p5.Element}
 * @example
 * <div class="norender">
 * <code>
 * var cnv;
 * var d;
 * var g;
 *
 * function setup() {
 *   cnv = createCanvas(100, 100);
 *   cnv.mouseClicked(changeGray); // attach listener for
 *                                 // activity on canvas only
 *   d = 10;
 *   g = 100;
 * }
 *
 * function draw() {
 *   background(g);
 *   ellipse(width/2, height/2, d, d);
 * }
 *
 * // this function fires after the mouse has been
 * // clicked anywhere
 * function mouseClicked() {
 *   d = d + 10;
 * }
 *
 * // this function fires after the mouse has been
 * // clicked on canvas
 * function changeGray() {
 *   g = random(0, 255);
 * }
 * </code>
 * </div>
 *
 * @alt
 * no display.
 *
 */
p5.Element.prototype.mouseClicked = function (fxn) {
  attachListener('click', fxn, this);
  return this;
};

/**
 * The .mouseMoved() function is called once every time a
 * mouse moves over the element. This can be used to attach an
 * element specific event listener.
 *
 * @method mouseMoved
 * @param  {Function} fxn function to be fired when mouse is
 *                    moved over the element.
 * @return {p5.Element}
 * @example
 * <div class='norender'><code>
 * var cnv;
 * var d = 30;
 * var g;
 * function setup() {
 *   cnv = createCanvas(100, 100);
 *   cnv.mouseMoved(changeSize); // attach listener for
 *                               // activity on canvas only
 *   d = 10;
 *   g = 100;
 * }
 *
 * function draw() {
 *   background(g);
 *   fill(200);
 *   ellipse(width/2, height/2, d, d);
 * }
 *
 * // this function fires when mouse moves anywhere on
 * // page
 * function mouseMoved() {
 *   g = g + 5;
 *   if (g > 255) {
 *     g = 0;
 *   }
 * }
 *
 * // this function fires when mouse moves over canvas
 * function changeSize() {
 *   d = d + 2;
 *   if (d > 100) {
 *     d = 0;
 *   }
 * }
 * </code></div>
 *
 *
 * @alt
 * no display.
 *
 */
p5.Element.prototype.mouseMoved = function (fxn) {
  attachListener('mousemove', fxn, this);
  attachListener('touchmove', fxn, this);
  return this;
};

/**
 * The .mouseOver() function is called once after every time a
 * mouse moves onto the element. This can be used to attach an
 * element specific event listener.
 *
 * @method mouseOver
 * @param  {Function} fxn function to be fired when mouse is
 *                    moved over the element.
 * @return {p5.Element}
 * @example
 * <div class='norender'><code>
 * var cnv;
 * var d;
 * var g;
 * function setup() {
 *   cnv = createCanvas(100, 100);
 *   cnv.mouseOver(changeGray);
 *   d = 10;
 * }
 *
 * function draw() {
 *   ellipse(width/2, height/2, d, d);
 * }
 *
 * function changeGray() {
 *   d = d + 10;
 *   if (d > 100) {
 *     d = 0;
 *   }
 * }
 * </code></div>
 *
 *
 * @alt
 * no display.
 *
 */
p5.Element.prototype.mouseOver = function (fxn) {
  attachListener('mouseover', fxn, this);
  return this;
};


/**
 * The .changed() function is called when the value of an
 * element is changed.
 * This can be used to attach an element specific event listener.
 *
 * @method changed
 * @param  {Function} fxn function to be fired when the value of an
 * element changes.
 * @return {p5.Element}
 * @example
 * <div><code>
 * var sel;
 *
 * function setup() {
 *   textAlign(CENTER);
 *   background(200);
 *   sel = createSelect();
 *   sel.position(10, 10);
 *   sel.option('pear');
 *   sel.option('kiwi');
 *   sel.option('grape');
 *   sel.changed(mySelectEvent);
 * }
 *
 * function mySelectEvent() {
 *   var item = sel.value();
 *   background(200);
 *   text("it's a "+item+"!", 50, 50);
 * }
 * </code></div>
 * <div><code>
 * var checkbox;
 * var cnv;
 *
 * function setup() {
 *   checkbox = createCheckbox(" fill");
 *   checkbox.changed(changeFill);
 *   cnv = createCanvas(100, 100);
 *   cnv.position(0, 30);
 *   noFill();
 * }
 *
 * function draw() {
 *   background(200);
 *   ellipse(50, 50, 50, 50);
 * }
 *
 * function changeFill() {
 *   if (checkbox.checked()) {
 *     fill(0);
 *   } else {
 *     noFill();
 *   }
 * }
 * </code></div>
 *
 * @alt
 * dropdown: pear, kiwi, grape. When selected text "its a" + selection shown.
 *
 */
p5.Element.prototype.changed = function (fxn) {
  attachListener('change', fxn, this);
  return this;
};

/**
 * The .input() function is called when any user input is
 * detected with an element. The input event is often used
 * to detect keystrokes in a input element, or changes on a
 * slider element. This can be used to attach an element specific
 * event listener.
 *
 * @method input
 * @param  {Function} fxn function to be fired on user input.
 * @return {p5.Element}
 * @example
 * <div class='norender'><code>
 * // Open your console to see the output
 * function setup() {
 *   var inp = createInput('');
 *   inp.input(myInputEvent);
 * }
 *
 * function myInputEvent() {
 *   console.log('you are typing: ', this.value());
 * }
 * </code></div>
 *
 * @alt
 * no display.
 *
 */
p5.Element.prototype.input = function (fxn) {
  attachListener('input', fxn, this);
  return this;
};

/**
 * The .mouseOut() function is called once after every time a
 * mouse moves off the element. This can be used to attach an
 * element specific event listener.
 *
 * @method mouseOut
 * @param  {Function} fxn function to be fired when mouse is
 *                    moved off the element.
 * @return {p5.Element}
 * @example
 * <div class='norender'><code>
 * var cnv;
 * var d;
 * var g;
 * function setup() {
 *   cnv = createCanvas(100, 100);
 *   cnv.mouseOut(changeGray);
 *   d = 10;
 * }
 *
 * function draw() {
 *   ellipse(width/2, height/2, d, d);
 * }
 *
 * function changeGray() {
 *   d = d + 10;
 *   if (d > 100) {
 *     d = 0;
 *   }
 * }
 * </code></div>
 *
 * @alt
 * no display.
 *
 */
p5.Element.prototype.mouseOut = function (fxn) {
  attachListener('mouseout', fxn, this);
  return this;
};

/**
 * The .touchStarted() function is called once after every time a touch is
 * registered. This can be used to attach element specific event listeners.
 *
 * @method touchStarted
 * @param  {Function} fxn function to be fired when touch is
 *                    started over the element.
 * @return {p5.Element}
 * @example
 * <div class='norender'><code>
 * var cnv;
 * var d;
 * var g;
 * function setup() {
 *   cnv = createCanvas(100, 100);
 *   cnv.touchStarted(changeGray); // attach listener for
 *                                 // canvas click only
 *   d = 10;
 *   g = 100;
 * }
 *
 * function draw() {
 *   background(g);
 *   ellipse(width/2, height/2, d, d);
 * }
 *
 * // this function fires with any touch anywhere
 * function touchStarted() {
 *   d = d + 10;
 * }
 *
 * // this function fires only when cnv is clicked
 * function changeGray() {
 *   g = random(0, 255);
 * }
 * </code></div>
 *
 * @alt
 * no display.
 *
 */
p5.Element.prototype.touchStarted = function (fxn) {
  attachListener('touchstart', fxn, this);
  attachListener('mousedown', fxn, this);
  return this;
};

/**
 * The .touchMoved() function is called once after every time a touch move is
 * registered. This can be used to attach element specific event listeners.
 *
 * @method touchMoved
 * @param  {Function} fxn function to be fired when touch is moved
 *                    over the element.
 * @return {p5.Element}
 * @example
 * <div class='norender'><code>
 * var cnv;
 * var g;
 * function setup() {
 *   cnv = createCanvas(100, 100);
 *   cnv.touchMoved(changeGray); // attach listener for
 *                               // canvas click only
 *   g = 100;
 * }
 *
 * function draw() {
 *   background(g);
 * }
 *
 * // this function fires only when cnv is clicked
 * function changeGray() {
 *   g = random(0, 255);
 * }
 * </code></div>
 *
 * @alt
 * no display.
 *
 */
p5.Element.prototype.touchMoved = function (fxn) {
  attachListener('touchmove', fxn, this);
  attachListener('mousemove', fxn, this);
  return this;
};

/**
 * The .touchEnded() function is called once after every time a touch is
 * registered. This can be used to attach element specific event listeners.
 *
 * @method touchEnded
 * @param  {Function} fxn function to be fired when touch is
 *                    ended over the element.
 * @return {p5.Element}
 * @example
 * <div class='norender'><code>
 * var cnv;
 * var d;
 * var g;
 * function setup() {
 *   cnv = createCanvas(100, 100);
 *   cnv.touchEnded(changeGray);   // attach listener for
 *                                 // canvas click only
 *   d = 10;
 *   g = 100;
 * }
 *
 * function draw() {
 *   background(g);
 *   ellipse(width/2, height/2, d, d);
 * }
 *
 * // this function fires with any touch anywhere
 * function touchEnded() {
 *   d = d + 10;
 * }
 *
 * // this function fires only when cnv is clicked
 * function changeGray() {
 *   g = random(0, 255);
 * }
 * </code></div>
 *
 *
 * @alt
 * no display.
 *
 */
p5.Element.prototype.touchEnded = function (fxn) {
  attachListener('touchend', fxn, this);
  attachListener('mouseup', fxn, this);
  return this;
};



/**
 * The .dragOver() function is called once after every time a
 * file is dragged over the element. This can be used to attach an
 * element specific event listener.
 *
 * @method dragOver
 * @param  {Function} fxn function to be fired when mouse is
 *                    dragged over the element.
 * @return {p5.Element}
 */
p5.Element.prototype.dragOver = function (fxn) {
  attachListener('dragover', fxn, this);
  return this;
};

/**
 * The .dragLeave() function is called once after every time a
 * dragged file leaves the element area. This can be used to attach an
 * element specific event listener.
 *
 * @method dragLeave
 * @param  {Function} fxn function to be fired when mouse is
 *                    dragged over the element.
 * @return {p5.Element}
 */
p5.Element.prototype.dragLeave = function (fxn) {
  attachListener('dragleave', fxn, this);
  return this;
};

/**
 * The .drop() function is called for each file dropped on the element.
 * It requires a callback that is passed a p5.File object.  You can
 * optionally pass two callbacks, the first one (required) is triggered
 * for each file dropped when the file is loaded.  The second (optional)
 * is triggered just once when a file (or files) are dropped.
 *
 * @method drop
 * @param  {Function} callback  callback triggered when files are dropped.
 * @param  {Function} fxn       callback to receive loaded file.
 * @return {p5.Element}
 * @example
 * <div><code>
 * function setup() {
 *   var c = createCanvas(100, 100);
 *   background(200);
 *   textAlign(CENTER);
 *   text('drop image', width/2, height/2);
 *   c.drop(gotFile);
 * }
 *
 * function gotFile(file) {
 *   var img = createImg(file.data).hide();
 *   // Draw the image onto the canvas
 *   image(img, 0, 0, width, height);
 * }
 * </code></div>
 *
 * @alt
 * Canvas turns into whatever image is dragged/dropped onto it.
 *
 */
p5.Element.prototype.drop = function (callback, fxn) {
  // Make a file loader callback and trigger user's callback
  function makeLoader(theFile) {
    // Making a p5.File object
    var p5file = new p5.File(theFile);
    return function(e) {
      p5file.data = e.target.result;
      callback(p5file);
    };
  }

  // Is the file stuff supported?
  if (window.File && window.FileReader && window.FileList && window.Blob) {

    // If you want to be able to drop you've got to turn off
    // a lot of default behavior
    attachListener('dragover',function(evt) {
      evt.stopPropagation();
      evt.preventDefault();
    },this);

    // If this is a drag area we need to turn off the default behavior
    attachListener('dragleave',function(evt) {
      evt.stopPropagation();
      evt.preventDefault();
    },this);

    // If just one argument it's the callback for the files
    if (arguments.length > 1) {
      attachListener('drop', fxn, this);
    }

    // Deal with the files
    attachListener('drop', function(evt) {

      evt.stopPropagation();
      evt.preventDefault();

      // A FileList
      var files = evt.dataTransfer.files;

      // Load each one and trigger the callback
      for (var i = 0; i < files.length; i++) {
        var f = files[i];
        var reader = new FileReader();
        reader.onload = makeLoader(f);


        // Text or data?
        // This should likely be improved
        if (f.type.indexOf('text') > -1) {
          reader.readAsText(f);
        } else {
          reader.readAsDataURL(f);
        }
      }
    }, this);
  } else {
    console.log('The File APIs are not fully supported in this browser.');
  }

  return this;
};




function attachListener(ev, fxn, ctx) {
  // LM removing, not sure why we had this?
  // var _this = ctx;
  // var f = function (e) { fxn(e, _this); };
  var f = fxn.bind(ctx);
  ctx.elt.addEventListener(ev, f, false);
  ctx._events[ev] = f;
}

/**
 * Helper fxn for sharing pixel methods
 *
 */
p5.Element.prototype._setProperty = function (prop, value) {
  this[prop] = value;
};


module.exports = p5.Element;

},{"./core":42}],47:[function(_dereq_,module,exports){
/**
 * @module Rendering
 * @submodule Rendering
 * @for p5
 */

var p5 = _dereq_('./core');
var constants = _dereq_('./constants');

/**
 * Thin wrapper around a renderer, to be used for creating a
 * graphics buffer object. Use this class if you need
 * to draw into an off-screen graphics buffer. The two parameters define the
 * width and height in pixels. The fields and methods for this class are
 * extensive, but mirror the normal drawing API for p5.
 *
 * @class p5.Graphics
 * @constructor
 * @extends p5.Element
 * @param {String} elt DOM node that is wrapped
 * @param {Object} [pInst] pointer to p5 instance
 * @param {Boolean} whether we're using it as main canvas
 */
p5.Graphics = function(w, h, renderer, pInst) {

  var r = renderer || constants.P2D;

  this.canvas = document.createElement('canvas');
  var node = this._userNode || document.body;
  node.appendChild(this.canvas);

  p5.Element.call(this, this.canvas, pInst, false);
  this._styles = [];
  this.width = w;
  this.height = h;
  this._pixelDensity = pInst._pixelDensity;

  if (r === constants.WEBGL) {
    this._renderer = new p5.RendererGL(this.canvas, this, false);
  } else {
    this._renderer = new p5.Renderer2D(this.canvas, this, false);
  }

  this._renderer.resize(w, h);
  this._renderer._applyDefaults();

  pInst._elements.push(this);

  // bind methods and props of p5 to the new object
  for (var p in p5.prototype) {
    if (!this[p]) {
      if (typeof p5.prototype[p] === 'function') {
        this[p] = p5.prototype[p].bind(this);
      } else {
        this[p] = p5.prototype[p];
      }
    }
  }

  return this;
};

p5.Graphics.prototype = Object.create(p5.Element.prototype);

p5.Graphics.prototype.remove = function() {
  if (this.elt.parentNode) {
    this.elt.parentNode.removeChild(this.elt);
  }
  for (var elt_ev in this._events) {
    this.elt.removeEventListener(elt_ev, this._events[elt_ev]);
  }
};

module.exports = p5.Graphics;

},{"./constants":41,"./core":42}],48:[function(_dereq_,module,exports){
/**
 * @module Rendering
 * @submodule Rendering
 * @for p5
 */

var p5 = _dereq_('./core');
var constants = _dereq_('../core/constants');

/**
 * Main graphics and rendering context, as well as the base API
 * implementation for p5.js "core". To be used as the superclass for
 * Renderer2D and Renderer3D classes, respecitvely.
 *
 * @class p5.Renderer
 * @constructor
 * @extends p5.Element
 * @param {String} elt DOM node that is wrapped
 * @param {Object} [pInst] pointer to p5 instance
 * @param {Boolean} whether we're using it as main canvas
 */
p5.Renderer = function(elt, pInst, isMainCanvas) {
  p5.Element.call(this, elt, pInst);
  this.canvas = elt;
  this._pInst = pInst;
  if (isMainCanvas) {
    this._isMainCanvas = true;
    // for pixel method sharing with pimage
    this._pInst._setProperty('_curElement', this);
    this._pInst._setProperty('canvas', this.canvas);
    this._pInst._setProperty('width', this.width);
    this._pInst._setProperty('height', this.height);
  } else { // hide if offscreen buffer by default
    this.canvas.style.display = 'none';
    this._styles = []; // non-main elt styles stored in p5.Renderer
  }


  this._textSize = 12;
  this._textLeading = 15;
  this._textFont = 'sans-serif';
  this._textStyle = constants.NORMAL;
  this._textAscent = null;
  this._textDescent = null;


  this._rectMode = constants.CORNER;
  this._ellipseMode = constants.CENTER;
  this._curveTightness = 0;
  this._imageMode = constants.CORNER;

  this._tint = null;
  this._doStroke = true;
  this._doFill = true;
  this._strokeSet = false;
  this._fillSet = false;
  this._colorMode = constants.RGB;
  this._colorMaxes = {
    rgb: [255, 255, 255, 255],
    hsb: [360, 100, 100, 1],
    hsl: [360, 100, 100, 1]
  };

};

p5.Renderer.prototype = Object.create(p5.Element.prototype);




/**
 * Resize our canvas element.
 */
p5.Renderer.prototype.resize = function(w, h) {
  this.width = w;
  this.height = h;
  this.elt.width = w * this._pInst._pixelDensity;
  this.elt.height = h * this._pInst._pixelDensity;
  this.elt.style.width = w +'px';
  this.elt.style.height = h + 'px';
  if (this._isMainCanvas) {
    this._pInst._setProperty('width', this.width);
    this._pInst._setProperty('height', this.height);
  }
};

p5.Renderer.prototype.textLeading = function(l) {

  if (arguments.length && arguments[0]) {

    this._setProperty('_textLeading', l);
    return this;
  }

  return this._textLeading;
};

p5.Renderer.prototype.textSize = function(s) {

  if (arguments.length && arguments[0]) {

    this._setProperty('_textSize', s);
    this._setProperty('_textLeading', s * constants._DEFAULT_LEADMULT);
    return this._applyTextProperties();
  }

  return this._textSize;
};

p5.Renderer.prototype.textStyle = function(s) {

  if (arguments.length && arguments[0]) {

    if (s === constants.NORMAL ||
      s === constants.ITALIC ||
      s === constants.BOLD) {
      this._setProperty('_textStyle', s);
    }

    return this._applyTextProperties();
  }

  return this._textStyle;
};

p5.Renderer.prototype.textAscent = function() {
  if (this._textAscent === null) {
    this._updateTextMetrics();
  }
  return this._textAscent;
};

p5.Renderer.prototype.textDescent = function() {

  if (this._textDescent === null) {
    this._updateTextMetrics();
  }
  return this._textDescent;
};

p5.Renderer.prototype._applyDefaults = function(){
  return this;
};

/**
 * Helper fxn to check font type (system or otf)
 */
p5.Renderer.prototype._isOpenType = function(f) {

  f = f || this._textFont;
  return (typeof f === 'object' && f.font && f.font.supported);
};

p5.Renderer.prototype._updateTextMetrics = function() {

  if (this._isOpenType()) {

    this._setProperty('_textAscent', this._textFont._textAscent());
    this._setProperty('_textDescent', this._textFont._textDescent());
    return this;
  }

  // Adapted from http://stackoverflow.com/a/25355178
  var text = document.createElement('span');
  text.style.fontFamily = this._textFont;
  text.style.fontSize = this._textSize + 'px';
  text.innerHTML = 'ABCjgq|';

  var block = document.createElement('div');
  block.style.display = 'inline-block';
  block.style.width = '1px';
  block.style.height = '0px';

  var container = document.createElement('div');
  container.appendChild(text);
  container.appendChild(block);

  container.style.height = '0px';
  container.style.overflow = 'hidden';
  document.body.appendChild(container);

  block.style.verticalAlign = 'baseline';
  var blockOffset = calculateOffset(block);
  var textOffset = calculateOffset(text);
  var ascent = blockOffset[1] - textOffset[1];

  block.style.verticalAlign = 'bottom';
  blockOffset = calculateOffset(block);
  textOffset = calculateOffset(text);
  var height = blockOffset[1] - textOffset[1];
  var descent = height - ascent;

  document.body.removeChild(container);

  this._setProperty('_textAscent', ascent);
  this._setProperty('_textDescent', descent);

  return this;
};

/**
 * Helper fxn to measure ascent and descent.
 * Adapted from http://stackoverflow.com/a/25355178
 */
function calculateOffset(object) {
  var currentLeft = 0,
    currentTop = 0;
  if (object.offsetParent) {
    do {
      currentLeft += object.offsetLeft;
      currentTop += object.offsetTop;
    } while (object = object.offsetParent);
  } else {
    currentLeft += object.offsetLeft;
    currentTop += object.offsetTop;
  }
  return [currentLeft, currentTop];
}

module.exports = p5.Renderer;

},{"../core/constants":41,"./core":42}],49:[function(_dereq_,module,exports){

var p5 = _dereq_('./core');
var canvas = _dereq_('./canvas');
var constants = _dereq_('./constants');
var filters = _dereq_('../image/filters');

_dereq_('./p5.Renderer');

/**
 * p5.Renderer2D
 * The 2D graphics canvas renderer class.
 * extends p5.Renderer
 */
var styleEmpty = 'rgba(0,0,0,0)';
// var alphaThreshold = 0.00125; // minimum visible

p5.Renderer2D = function(elt, pInst, isMainCanvas){
  p5.Renderer.call(this, elt, pInst, isMainCanvas);
  this.drawingContext = this.canvas.getContext('2d');
  this._pInst._setProperty('drawingContext', this.drawingContext);
  return this;
};

p5.Renderer2D.prototype = Object.create(p5.Renderer.prototype);

p5.Renderer2D.prototype._applyDefaults = function() {
  this.drawingContext.fillStyle = constants._DEFAULT_FILL;
  this.drawingContext.strokeStyle = constants._DEFAULT_STROKE;
  this.drawingContext.lineCap = constants.ROUND;
  this.drawingContext.font = 'normal 12px sans-serif';
};

p5.Renderer2D.prototype.resize = function(w,h) {
  p5.Renderer.prototype.resize.call(this, w,h);
  this.drawingContext.scale(this._pInst._pixelDensity,
                            this._pInst._pixelDensity);
};

//////////////////////////////////////////////
// COLOR | Setting
//////////////////////////////////////////////

p5.Renderer2D.prototype.background = function() {
  this.drawingContext.save();
  this.drawingContext.setTransform(1, 0, 0, 1, 0, 0);
  this.drawingContext.scale(this._pInst._pixelDensity,
                            this._pInst._pixelDensity);

  if (arguments[0] instanceof p5.Image) {
    this._pInst.image(arguments[0], 0, 0, this.width, this.height);
  } else {
    var curFill = this.drawingContext.fillStyle;
    // create background rect
    var color = this._pInst.color.apply(this, arguments);
    var newFill = color.toString();
    this.drawingContext.fillStyle = newFill;
    this.drawingContext.fillRect(0, 0, this.width, this.height);
    // reset fill
    this.drawingContext.fillStyle = curFill;
  }
  this.drawingContext.restore();
};

p5.Renderer2D.prototype.clear = function() {
  this.drawingContext.clearRect(0, 0, this.width, this.height);
};

p5.Renderer2D.prototype.fill = function() {

  var ctx = this.drawingContext;
  var color = this._pInst.color.apply(this, arguments);
  ctx.fillStyle = color.toString();
};

p5.Renderer2D.prototype.stroke = function() {
  var ctx = this.drawingContext;
  var color = this._pInst.color.apply(this, arguments);
  ctx.strokeStyle = color.toString();
};

//////////////////////////////////////////////
// IMAGE | Loading & Displaying
//////////////////////////////////////////////

p5.Renderer2D.prototype.image =
  function (img, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight) {
  var cnv;
  try {
    if (this._tint) {
      if (p5.MediaElement && img instanceof p5.MediaElement) {
        img.loadPixels();
      }
      if (img.canvas) {
        cnv = this._getTintedImageCanvas(img);
      }
    }
    if (!cnv) {
      cnv = img.canvas || img.elt;
    }
    this.drawingContext.drawImage(cnv, sx, sy, sWidth, sHeight, dx, dy,
      dWidth, dHeight);
  } catch (e) {
    if (e.name !== 'NS_ERROR_NOT_AVAILABLE') {
      throw e;
    }
  }
};

p5.Renderer2D.prototype._getTintedImageCanvas = function (img) {
  if (!img.canvas) {
    return img;
  }
  var pixels = filters._toPixels(img.canvas);
  var tmpCanvas = document.createElement('canvas');
  tmpCanvas.width = img.canvas.width;
  tmpCanvas.height = img.canvas.height;
  var tmpCtx = tmpCanvas.getContext('2d');
  var id = tmpCtx.createImageData(img.canvas.width, img.canvas.height);
  var newPixels = id.data;
  for (var i = 0; i < pixels.length; i += 4) {
    var r = pixels[i];
    var g = pixels[i + 1];
    var b = pixels[i + 2];
    var a = pixels[i + 3];
    newPixels[i] = r * this._tint[0] / 255;
    newPixels[i + 1] = g * this._tint[1] / 255;
    newPixels[i + 2] = b * this._tint[2] / 255;
    newPixels[i + 3] = a * this._tint[3] / 255;
  }
  tmpCtx.putImageData(id, 0, 0);
  return tmpCanvas;
};


//////////////////////////////////////////////
// IMAGE | Pixels
//////////////////////////////////////////////

p5.Renderer2D.prototype.blendMode = function(mode) {
  this.drawingContext.globalCompositeOperation = mode;
};
p5.Renderer2D.prototype.blend = function() {
  var currBlend = this.drawingContext.globalCompositeOperation;
  var blendMode = arguments[arguments.length - 1];

  var copyArgs = Array.prototype.slice.call(
    arguments,
    0,
    arguments.length - 1
  );

  this.drawingContext.globalCompositeOperation = blendMode;
  if (this._pInst) {
    this._pInst.copy.apply(this._pInst, copyArgs);
  } else {
    this.copy.apply(this, copyArgs);
  }
  this.drawingContext.globalCompositeOperation = currBlend;
};

p5.Renderer2D.prototype.copy = function () {
  var srcImage, sx, sy, sw, sh, dx, dy, dw, dh;
  if (arguments.length === 9) {
    srcImage = arguments[0];
    sx = arguments[1];
    sy = arguments[2];
    sw = arguments[3];
    sh = arguments[4];
    dx = arguments[5];
    dy = arguments[6];
    dw = arguments[7];
    dh = arguments[8];
  } else if (arguments.length === 8) {
    srcImage = this._pInst;
    sx = arguments[0];
    sy = arguments[1];
    sw = arguments[2];
    sh = arguments[3];
    dx = arguments[4];
    dy = arguments[5];
    dw = arguments[6];
    dh = arguments[7];
  } else {
    throw new Error('Signature not supported');
  }
  p5.Renderer2D._copyHelper(srcImage, sx, sy, sw, sh, dx, dy, dw, dh);
};

p5.Renderer2D._copyHelper =
function (srcImage, sx, sy, sw, sh, dx, dy, dw, dh) {
  srcImage.loadPixels();
  var s = srcImage.canvas.width / srcImage.width;
  this.drawingContext.drawImage(srcImage.canvas,
    s * sx, s * sy, s * sw, s * sh, dx, dy, dw, dh);
};

p5.Renderer2D.prototype.get = function(x, y, w, h) {
  if (x === undefined && y === undefined &&
      w === undefined && h === undefined){
    x = 0;
    y = 0;
    w = this.width;
    h = this.height;
  } else if (w === undefined && h === undefined) {
    w = 1;
    h = 1;
  }

  // if the section does not overlap the canvas
  if(x + w < 0 || y + h < 0 || x > this.width || y > this.height){
    return [0, 0, 0, 255];
  }

  var ctx = this._pInst || this;
  ctx.loadPixels();

  var pd = ctx._pixelDensity;

  // round down to get integer numbers
  x = Math.floor(x);
  y = Math.floor(y);
  w = Math.floor(w);
  h = Math.floor(h);

  var sx = x * pd;
  var sy = y * pd;
  if (w === 1 && h === 1){
    var imageData = this.drawingContext.getImageData(sx, sy, 1, 1).data;
    //imageData = [0,0,0,0];
    return [
      imageData[0],
      imageData[1],
      imageData[2],
      imageData[3]
    ];
  } else {
    //auto constrain the width and height to
    //dimensions of the source image
    var dw = Math.min(w, ctx.width);
    var dh = Math.min(h, ctx.height);
    var sw = dw * pd;
    var sh = dh * pd;

    var region = new p5.Image(dw, dh);
    region.canvas.getContext('2d').drawImage(this.canvas, sx, sy, sw, sh,
      0, 0, dw, dh);

    return region;
  }
};

p5.Renderer2D.prototype.loadPixels = function () {
  var pd = this._pixelDensity || this._pInst._pixelDensity;
  var w = this.width * pd;
  var h = this.height * pd;
  var imageData = this.drawingContext.getImageData(0, 0, w, h);
  // @todo this should actually set pixels per object, so diff buffers can
  // have diff pixel arrays.
  if (this._pInst) {
    this._pInst._setProperty('imageData', imageData);
    this._pInst._setProperty('pixels', imageData.data);
  } else { // if called by p5.Image
    this._setProperty('imageData', imageData);
    this._setProperty('pixels', imageData.data);
  }
};

p5.Renderer2D.prototype.set = function (x, y, imgOrCol) {
  // round down to get integer numbers
  x = Math.floor(x);
  y = Math.floor(y);
  if (imgOrCol instanceof p5.Image) {
    this.drawingContext.save();
    this.drawingContext.setTransform(1, 0, 0, 1, 0, 0);
    this.drawingContext.scale(this._pInst._pixelDensity,
      this._pInst._pixelDensity);
    this.drawingContext.drawImage(imgOrCol.canvas, x, y);
    this.loadPixels.call(this._pInst);
    this.drawingContext.restore();
  } else {
    var ctx = this._pInst || this;
    var r = 0, g = 0, b = 0, a = 0;
    var idx = 4*((y * ctx._pixelDensity) *
      (this.width * ctx._pixelDensity) + (x * ctx._pixelDensity));
    if (!ctx.imageData) {
      ctx.loadPixels.call(ctx);
    }
    if (typeof imgOrCol === 'number') {
      if (idx < ctx.pixels.length) {
        r = imgOrCol;
        g = imgOrCol;
        b = imgOrCol;
        a = 255;
        //this.updatePixels.call(this);
      }
    }
    else if (imgOrCol instanceof Array) {
      if (imgOrCol.length < 4) {
        throw new Error('pixel array must be of the form [R, G, B, A]');
      }
      if (idx < ctx.pixels.length) {
        r = imgOrCol[0];
        g = imgOrCol[1];
        b = imgOrCol[2];
        a = imgOrCol[3];
        //this.updatePixels.call(this);
      }
    } else if (imgOrCol instanceof p5.Color) {
      if (idx < ctx.pixels.length) {
        r = imgOrCol.levels[0];
        g = imgOrCol.levels[1];
        b = imgOrCol.levels[2];
        a = imgOrCol.levels[3];
        //this.updatePixels.call(this);
      }
    }
    // loop over pixelDensity * pixelDensity
    for (var i = 0; i < ctx._pixelDensity; i++) {
      for (var j = 0; j < ctx._pixelDensity; j++) {
        // loop over
        idx = 4*((y * ctx._pixelDensity + j) * this.width *
          ctx._pixelDensity + (x * ctx._pixelDensity + i));
        ctx.pixels[idx] = r;
        ctx.pixels[idx+1] = g;
        ctx.pixels[idx+2] = b;
        ctx.pixels[idx+3] = a;
      }
    }
  }
};

p5.Renderer2D.prototype.updatePixels = function (x, y, w, h) {
  var pd = this._pixelDensity || this._pInst._pixelDensity;
  if (x === undefined &&
      y === undefined &&
      w === undefined &&
      h === undefined) {
    x = 0;
    y = 0;
    w = this.width;
    h = this.height;
  }
  w *= pd;
  h *= pd;

  if (this._pInst) {
    this.drawingContext.putImageData(this._pInst.imageData, x, y, 0, 0, w, h);
  } else {
    this.drawingContext.putImageData(this.imageData, x, y, 0, 0, w, h);
  }
};

//////////////////////////////////////////////
// SHAPE | 2D Primitives
//////////////////////////////////////////////

/**
 * Generate a cubic Bezier representing an arc on the unit circle of total
 * angle `size` radians, beginning `start` radians above the x-axis. Up to
 * four of these curves are combined to make a full arc.
 *
 * See www.joecridge.me/bezier.pdf for an explanation of the method.
 */
p5.Renderer2D.prototype._acuteArcToBezier =
  function _acuteArcToBezier(start, size) {
  // Evauate constants.
  var alpha = size / 2.0,
    cos_alpha = Math.cos(alpha),
    sin_alpha = Math.sin(alpha),
    cot_alpha = 1.0 / Math.tan(alpha),
    phi = start + alpha,  // This is how far the arc needs to be rotated.
    cos_phi = Math.cos(phi),
    sin_phi = Math.sin(phi),
    lambda = (4.0 - cos_alpha) / 3.0,
    mu = sin_alpha + (cos_alpha - lambda) * cot_alpha;

  // Return rotated waypoints.
  return {
    ax: Math.cos(start),
    ay: Math.sin(start),
    bx: lambda * cos_phi + mu * sin_phi,
    by: lambda * sin_phi - mu * cos_phi,
    cx: lambda * cos_phi - mu * sin_phi,
    cy: lambda * sin_phi + mu * cos_phi,
    dx: Math.cos(start + size),
    dy: Math.sin(start + size)
  };
};

p5.Renderer2D.prototype.arc =
  function(x, y, w, h, start, stop, mode) {
  var ctx = this.drawingContext;
  var vals = canvas.arcModeAdjust(x, y, w, h, this._ellipseMode);
  var rx = vals.w / 2.0;
  var ry = vals.h / 2.0;
  var epsilon = 0.00001;  // Smallest visible angle on displays up to 4K.
  var arcToDraw = 0;
  var curves = [];

  // Create curves
  while(stop - start > epsilon) {
    arcToDraw = Math.min(stop - start, constants.HALF_PI);
    curves.push(this._acuteArcToBezier(start, arcToDraw));
    start += arcToDraw;
  }

  // Fill curves
  if (this._doFill) {
    ctx.beginPath();
    curves.forEach(function (curve, index) {
      if (index === 0) {
        ctx.moveTo(vals.x + curve.ax * rx, vals.y + curve.ay * ry);
      }
      ctx.bezierCurveTo(vals.x + curve.bx * rx, vals.y + curve.by * ry,
                        vals.x + curve.cx * rx, vals.y + curve.cy * ry,
                        vals.x + curve.dx * rx, vals.y + curve.dy * ry);
    });
    if (mode === constants.PIE || mode == null) {
      ctx.lineTo(vals.x, vals.y);
    }
    ctx.closePath();
    ctx.fill();
  }

  // Stroke curves
  if (this._doStroke) {
    ctx.beginPath();
    curves.forEach(function (curve, index) {
      if (index === 0) {
        ctx.moveTo(vals.x + curve.ax * rx, vals.y + curve.ay * ry);
      }
      ctx.bezierCurveTo(vals.x + curve.bx * rx, vals.y + curve.by * ry,
                        vals.x + curve.cx * rx, vals.y + curve.cy * ry,
                        vals.x + curve.dx * rx, vals.y + curve.dy * ry);
    });
    if (mode === constants.PIE) {
      ctx.lineTo(vals.x, vals.y);
      ctx.closePath();
    } else if (mode === constants.CHORD) {
      ctx.closePath();
    }
    ctx.stroke();
  }
  return this;
};

p5.Renderer2D.prototype.ellipse = function(args) {
  var ctx = this.drawingContext;
  var doFill = this._doFill, doStroke = this._doStroke;
  var x = args[0],
    y = args[1],
    w = args[2],
    h = args[3];
  if (doFill && !doStroke) {
    if(ctx.fillStyle === styleEmpty) {
      return this;
    }
  } else if (!doFill && doStroke) {
    if(ctx.strokeStyle === styleEmpty) {
      return this;
    }
  }
  var kappa = 0.5522847498,
    ox = (w / 2) * kappa, // control point offset horizontal
    oy = (h / 2) * kappa, // control point offset vertical
    xe = x + w,      // x-end
    ye = y + h,      // y-end
    xm = x + w / 2,  // x-middle
    ym = y + h / 2;  // y-middle
  ctx.beginPath();
  ctx.moveTo(x, ym);
  ctx.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
  ctx.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
  ctx.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
  ctx.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
  ctx.closePath();
  if (doFill) {
    ctx.fill();
  }
  if (doStroke) {
    ctx.stroke();
  }
};

p5.Renderer2D.prototype.line = function(x1, y1, x2, y2) {
  var ctx = this.drawingContext;
  if (!this._doStroke) {
    return this;
  } else if(ctx.strokeStyle === styleEmpty){
    return this;
  }
  // Translate the line by (0.5, 0.5) to draw it crisp
  if (ctx.lineWidth % 2 === 1) {
    ctx.translate(0.5, 0.5);
  }
  ctx.beginPath();
  ctx.moveTo(x1, y1);
  ctx.lineTo(x2, y2);
  ctx.stroke();
  if (ctx.lineWidth % 2 === 1) {
    ctx.translate(-0.5, -0.5);
  }
  return this;
};

p5.Renderer2D.prototype.point = function(x, y) {
  var ctx = this.drawingContext;
  var s = ctx.strokeStyle;
  var f = ctx.fillStyle;
  if (!this._doStroke) {
    return this;
  } else if(ctx.strokeStyle === styleEmpty){
    return this;
  }
  x = Math.round(x);
  y = Math.round(y);
  ctx.fillStyle = s;
  if (ctx.lineWidth > 1) {
    ctx.beginPath();
    ctx.arc(
      x,
      y,
      ctx.lineWidth / 2,
      0,
      constants.TWO_PI,
      false
    );
    ctx.fill();
  } else {
    ctx.fillRect(x, y, 1, 1);
  }
  ctx.fillStyle = f;
};

p5.Renderer2D.prototype.quad =
  function(x1, y1, x2, y2, x3, y3, x4, y4) {
  var ctx = this.drawingContext;
  var doFill = this._doFill, doStroke = this._doStroke;
  if (doFill && !doStroke) {
    if(ctx.fillStyle === styleEmpty) {
      return this;
    }
  } else if (!doFill && doStroke) {
    if(ctx.strokeStyle === styleEmpty) {
      return this;
    }
  }
  ctx.beginPath();
  ctx.moveTo(x1, y1);
  ctx.lineTo(x2, y2);
  ctx.lineTo(x3, y3);
  ctx.lineTo(x4, y4);
  ctx.closePath();
  if (doFill) {
    ctx.fill();
  }
  if (doStroke) {
    ctx.stroke();
  }
  return this;
};

p5.Renderer2D.prototype.rect = function(args) {
  var x = args[0],
    y = args[1],
    w = args[2],
    h = args[3],
    tl = args[4],
    tr = args[5],
    br = args[6],
    bl = args[7];
  var ctx = this.drawingContext;
  var doFill = this._doFill, doStroke = this._doStroke;
  if (doFill && !doStroke) {
    if(ctx.fillStyle === styleEmpty) {
      return this;
    }
  } else if (!doFill && doStroke) {
    if(ctx.strokeStyle === styleEmpty) {
      return this;
    }
  }
  // Translate the line by (0.5, 0.5) to draw a crisp rectangle border
  if (this._doStroke && ctx.lineWidth % 2 === 1) {
    ctx.translate(0.5, 0.5);
  }
  ctx.beginPath();

  if (typeof tl === 'undefined') {
    // No rounded corners
    ctx.rect(x, y, w, h);
  } else {
    // At least one rounded corner
    // Set defaults when not specified
    if (typeof tr === 'undefined') { tr = tl; }
    if (typeof br === 'undefined') { br = tr; }
    if (typeof bl === 'undefined') { bl = br; }

    var hw = w / 2;
    var hh = h / 2;

    // Clip radii
    if (w < 2 * tl) { tl = hw; }
    if (h < 2 * tl) { tl = hh; }
    if (w < 2 * tr) { tr = hw; }
    if (h < 2 * tr) { tr = hh; }
    if (w < 2 * br) { br = hw; }
    if (h < 2 * br) { br = hh; }
    if (w < 2 * bl) { bl = hw; }
    if (h < 2 * bl) { bl = hh; }

    // Draw shape
    ctx.beginPath();
    ctx.moveTo(x + tl, y);
    ctx.arcTo(x + w, y, x + w, y + h, tr);
    ctx.arcTo(x + w, y + h, x, y + h, br);
    ctx.arcTo(x, y + h, x, y, bl);
    ctx.arcTo(x, y, x + w, y, tl);
    ctx.closePath();
  }
  if (this._doFill) {
    ctx.fill();
  }
  if (this._doStroke) {
    ctx.stroke();
  }
  if (this._doStroke && ctx.lineWidth % 2 === 1) {
    ctx.translate(-0.5, -0.5);
  }
  return this;
};

p5.Renderer2D.prototype.triangle = function(args) {
  var ctx = this.drawingContext;
  var doFill = this._doFill, doStroke = this._doStroke;
  var x1=args[0], y1=args[1];
  var x2=args[2], y2=args[3];
  var x3=args[4], y3=args[5];
  if (doFill && !doStroke) {
    if(ctx.fillStyle === styleEmpty) {
      return this;
    }
  } else if (!doFill && doStroke) {
    if(ctx.strokeStyle === styleEmpty) {
      return this;
    }
  }
  ctx.beginPath();
  ctx.moveTo(x1, y1);
  ctx.lineTo(x2, y2);
  ctx.lineTo(x3, y3);
  ctx.closePath();
  if (doFill) {
    ctx.fill();
  }
  if (doStroke) {
    ctx.stroke();
  }
};

p5.Renderer2D.prototype.endShape =
function (mode, vertices, isCurve, isBezier,
    isQuadratic, isContour, shapeKind) {
  if (vertices.length === 0) {
    return this;
  }
  if (!this._doStroke && !this._doFill) {
    return this;
  }
  var closeShape = mode === constants.CLOSE;
  var v;
  if (closeShape && !isContour) {
    vertices.push(vertices[0]);
  }
  var i, j;
  var numVerts = vertices.length;
  if (isCurve && (shapeKind === constants.POLYGON || shapeKind === null)) {
    if (numVerts > 3) {
      var b = [], s = 1 - this._curveTightness;
      this.drawingContext.beginPath();
      this.drawingContext.moveTo(vertices[1][0], vertices[1][1]);
      for (i = 1; i + 2 < numVerts; i++) {
        v = vertices[i];
        b[0] = [
          v[0],
          v[1]
        ];
        b[1] = [
          v[0] + (s * vertices[i + 1][0] - s * vertices[i - 1][0]) / 6,
          v[1] + (s * vertices[i + 1][1] - s * vertices[i - 1][1]) / 6
        ];
        b[2] = [
          vertices[i + 1][0] +
          (s * vertices[i][0]-s * vertices[i + 2][0]) / 6,
          vertices[i + 1][1]+(s * vertices[i][1] - s*vertices[i + 2][1]) / 6
        ];
        b[3] = [
          vertices[i + 1][0],
          vertices[i + 1][1]
        ];
        this.drawingContext.bezierCurveTo(b[1][0],b[1][1],
          b[2][0],b[2][1],b[3][0],b[3][1]);
      }
      if (closeShape) {
        this.drawingContext.lineTo(vertices[i + 1][0], vertices[i + 1][1]);
      }
      this._doFillStrokeClose();
    }
  } else if (isBezier&&(shapeKind===constants.POLYGON ||shapeKind === null)) {
    this.drawingContext.beginPath();
    for (i = 0; i < numVerts; i++) {
      if (vertices[i].isVert) {
        if (vertices[i].moveTo) {
          this.drawingContext.moveTo(vertices[i][0], vertices[i][1]);
        } else {
          this.drawingContext.lineTo(vertices[i][0], vertices[i][1]);
        }
      } else {
        this.drawingContext.bezierCurveTo(vertices[i][0], vertices[i][1],
          vertices[i][2], vertices[i][3], vertices[i][4], vertices[i][5]);
      }
    }
    this._doFillStrokeClose();
  } else if (isQuadratic &&
    (shapeKind === constants.POLYGON || shapeKind === null)) {
    this.drawingContext.beginPath();
    for (i = 0; i < numVerts; i++) {
      if (vertices[i].isVert) {
        if (vertices[i].moveTo) {
          this.drawingContext.moveTo([0], vertices[i][1]);
        } else {
          this.drawingContext.lineTo(vertices[i][0], vertices[i][1]);
        }
      } else {
        this.drawingContext.quadraticCurveTo(vertices[i][0], vertices[i][1],
          vertices[i][2], vertices[i][3]);
      }
    }
    this._doFillStrokeClose();
  } else {
    if (shapeKind === constants.POINTS) {
      for (i = 0; i < numVerts; i++) {
        v = vertices[i];
        if (this._doStroke) {
          this._pInst.stroke(v[6]);
        }
        this._pInst.point(v[0], v[1]);
      }
    } else if (shapeKind === constants.LINES) {
      for (i = 0; i + 1 < numVerts; i += 2) {
        v = vertices[i];
        if (this._doStroke) {
          this._pInst.stroke(vertices[i + 1][6]);
        }
        this._pInst.line(v[0], v[1], vertices[i + 1][0], vertices[i + 1][1]);
      }
    } else if (shapeKind === constants.TRIANGLES) {
      for (i = 0; i + 2 < numVerts; i += 3) {
        v = vertices[i];
        this.drawingContext.beginPath();
        this.drawingContext.moveTo(v[0], v[1]);
        this.drawingContext.lineTo(vertices[i + 1][0], vertices[i + 1][1]);
        this.drawingContext.lineTo(vertices[i + 2][0], vertices[i + 2][1]);
        this.drawingContext.lineTo(v[0], v[1]);
        if (this._doFill) {
          this._pInst.fill(vertices[i + 2][5]);
          this.drawingContext.fill();
        }
        if (this._doStroke) {
          this._pInst.stroke(vertices[i + 2][6]);
          this.drawingContext.stroke();
        }
        this.drawingContext.closePath();
      }
    } else if (shapeKind === constants.TRIANGLE_STRIP) {
      for (i = 0; i + 1 < numVerts; i++) {
        v = vertices[i];
        this.drawingContext.beginPath();
        this.drawingContext.moveTo(vertices[i + 1][0], vertices[i + 1][1]);
        this.drawingContext.lineTo(v[0], v[1]);
        if (this._doStroke) {
          this._pInst.stroke(vertices[i + 1][6]);
        }
        if (this._doFill) {
          this._pInst.fill(vertices[i + 1][5]);
        }
        if (i + 2 < numVerts) {
          this.drawingContext.lineTo(vertices[i + 2][0], vertices[i + 2][1]);
          if (this._doStroke) {
            this._pInst.stroke(vertices[i + 2][6]);
          }
          if (this._doFill) {
            this._pInst.fill(vertices[i + 2][5]);
          }
        }
        this._doFillStrokeClose();
      }
    } else if (shapeKind === constants.TRIANGLE_FAN) {
      if (numVerts > 2) {
        this.drawingContext.beginPath();
        this.drawingContext.moveTo(vertices[0][0], vertices[0][1]);
        this.drawingContext.lineTo(vertices[1][0], vertices[1][1]);
        this.drawingContext.lineTo(vertices[2][0], vertices[2][1]);
        if (this._doFill) {
          this._pInst.fill(vertices[2][5]);
        }
        if (this._doStroke) {
          this._pInst.stroke(vertices[2][6]);
        }
        this._doFillStrokeClose();
        for (i = 3; i < numVerts; i++) {
          v = vertices[i];
          this.drawingContext.beginPath();
          this.drawingContext.moveTo(vertices[0][0], vertices[0][1]);
          this.drawingContext.lineTo(vertices[i - 1][0], vertices[i - 1][1]);
          this.drawingContext.lineTo(v[0], v[1]);
          if (this._doFill) {
            this._pInst.fill(v[5]);
          }
          if (this._doStroke) {
            this._pInst.stroke(v[6]);
          }
          this._doFillStrokeClose();
        }
      }
    } else if (shapeKind === constants.QUADS) {
      for (i = 0; i + 3 < numVerts; i += 4) {
        v = vertices[i];
        this.drawingContext.beginPath();
        this.drawingContext.moveTo(v[0], v[1]);
        for (j = 1; j < 4; j++) {
          this.drawingContext.lineTo(vertices[i + j][0], vertices[i + j][1]);
        }
        this.drawingContext.lineTo(v[0], v[1]);
        if (this._doFill) {
          this._pInst.fill(vertices[i + 3][5]);
        }
        if (this._doStroke) {
          this._pInst.stroke(vertices[i + 3][6]);
        }
        this._doFillStrokeClose();
      }
    } else if (shapeKind === constants.QUAD_STRIP) {
      if (numVerts > 3) {
        for (i = 0; i + 1 < numVerts; i += 2) {
          v = vertices[i];
          this.drawingContext.beginPath();
          if (i + 3 < numVerts) {
            this.drawingContext.moveTo(vertices[i + 2][0], vertices[i+2][1]);
            this.drawingContext.lineTo(v[0], v[1]);
            this.drawingContext.lineTo(vertices[i + 1][0], vertices[i+1][1]);
            this.drawingContext.lineTo(vertices[i + 3][0], vertices[i+3][1]);
            if (this._doFill) {
              this._pInst.fill(vertices[i + 3][5]);
            }
            if (this._doStroke) {
              this._pInst.stroke(vertices[i + 3][6]);
            }
          } else {
            this.drawingContext.moveTo(v[0], v[1]);
            this.drawingContext.lineTo(vertices[i + 1][0], vertices[i+1][1]);
          }
          this._doFillStrokeClose();
        }
      }
    } else {
      this.drawingContext.beginPath();
      this.drawingContext.moveTo(vertices[0][0], vertices[0][1]);
      for (i = 1; i < numVerts; i++) {
        v = vertices[i];
        if (v.isVert) {
          if (v.moveTo) {
            this.drawingContext.moveTo(v[0], v[1]);
          } else {
            this.drawingContext.lineTo(v[0], v[1]);
          }
        }
      }
      this._doFillStrokeClose();
    }
  }
  isCurve = false;
  isBezier = false;
  isQuadratic = false;
  isContour = false;
  if (closeShape) {
    vertices.pop();
  }
  return this;
};
//////////////////////////////////////////////
// SHAPE | Attributes
//////////////////////////////////////////////

p5.Renderer2D.prototype.noSmooth = function() {
  if ('imageSmoothingEnabled' in this.drawingContext) {
    this.drawingContext.imageSmoothingEnabled = false;
  }
  else if ('mozImageSmoothingEnabled' in this.drawingContext) {
    this.drawingContext.mozImageSmoothingEnabled = false;
  }
  else if ('webkitImageSmoothingEnabled' in this.drawingContext) {
    this.drawingContext.webkitImageSmoothingEnabled = false;
  }
  else if ('msImageSmoothingEnabled' in this.drawingContext) {
    this.drawingContext.msImageSmoothingEnabled = false;
  }
  return this;
};

p5.Renderer2D.prototype.smooth = function() {
  if ('imageSmoothingEnabled' in this.drawingContext) {
    this.drawingContext.imageSmoothingEnabled = true;
  }
  else if ('mozImageSmoothingEnabled' in this.drawingContext) {
    this.drawingContext.mozImageSmoothingEnabled = true;
  }
  else if ('webkitImageSmoothingEnabled' in this.drawingContext) {
    this.drawingContext.webkitImageSmoothingEnabled = true;
  }
  else if ('msImageSmoothingEnabled' in this.drawingContext) {
    this.drawingContext.msImageSmoothingEnabled = true;
  }
  return this;
};

p5.Renderer2D.prototype.strokeCap = function(cap) {
  if (cap === constants.ROUND ||
    cap === constants.SQUARE ||
    cap === constants.PROJECT) {
    this.drawingContext.lineCap = cap;
  }
  return this;
};

p5.Renderer2D.prototype.strokeJoin = function(join) {
  if (join === constants.ROUND ||
    join === constants.BEVEL ||
    join === constants.MITER) {
    this.drawingContext.lineJoin = join;
  }
  return this;
};

p5.Renderer2D.prototype.strokeWeight = function(w) {
  if (typeof w === 'undefined' || w === 0) {
    // hack because lineWidth 0 doesn't work
    this.drawingContext.lineWidth = 0.0001;
  } else {
    this.drawingContext.lineWidth = w;
  }
  return this;
};

p5.Renderer2D.prototype._getFill = function(){
  return this.drawingContext.fillStyle;
};

p5.Renderer2D.prototype._getStroke = function(){
  return this.drawingContext.strokeStyle;
};

//////////////////////////////////////////////
// SHAPE | Curves
//////////////////////////////////////////////
p5.Renderer2D.prototype.bezier = function (x1, y1, x2, y2, x3, y3, x4, y4) {
  this._pInst.beginShape();
  this._pInst.vertex(x1, y1);
  this._pInst.bezierVertex(x2, y2, x3, y3, x4, y4);
  this._pInst.endShape();
  return this;
};

p5.Renderer2D.prototype.curve = function (x1, y1, x2, y2, x3, y3, x4, y4) {
  this._pInst.beginShape();
  this._pInst.curveVertex(x1, y1);
  this._pInst.curveVertex(x2, y2);
  this._pInst.curveVertex(x3, y3);
  this._pInst.curveVertex(x4, y4);
  this._pInst.endShape();
  return this;
};

//////////////////////////////////////////////
// SHAPE | Vertex
//////////////////////////////////////////////

p5.Renderer2D.prototype._doFillStrokeClose = function () {
  if (this._doFill) {
    this.drawingContext.fill();
  }
  if (this._doStroke) {
    this.drawingContext.stroke();
  }
  this.drawingContext.closePath();
};

//////////////////////////////////////////////
// TRANSFORM
//////////////////////////////////////////////

p5.Renderer2D.prototype.applyMatrix =
function(n00, n01, n02, n10, n11, n12) {
  this.drawingContext.transform(n00, n01, n02, n10, n11, n12);
};

p5.Renderer2D.prototype.resetMatrix = function() {
  this.drawingContext.setTransform(1, 0, 0, 1, 0, 0);
  this.drawingContext.scale(this._pInst._pixelDensity,
                            this._pInst._pixelDensity);
  return this;
};

p5.Renderer2D.prototype.rotate = function(r) {
  this.drawingContext.rotate(r);
};

p5.Renderer2D.prototype.scale = function(x,y) {
  this.drawingContext.scale(x, y);
  return this;
};

p5.Renderer2D.prototype.shearX = function(angle) {
  if (this._pInst._angleMode === constants.DEGREES) {
    // undoing here, because it gets redone in tan()
    angle = this._pInst.degrees(angle);
  }
  this.drawingContext.transform(1, 0, this._pInst.tan(angle), 1, 0, 0);
  return this;
};

p5.Renderer2D.prototype.shearY = function(angle) {
  if (this._pInst._angleMode === constants.DEGREES) {
    // undoing here, because it gets redone in tan()
    angle = this._pInst.degrees(angle);
  }
  this.drawingContext.transform(1, this._pInst.tan(angle), 0, 1, 0, 0);
  return this;
};

p5.Renderer2D.prototype.translate = function(x, y) {
  this.drawingContext.translate(x, y);
  return this;
};

//////////////////////////////////////////////
// TYPOGRAPHY
//
//////////////////////////////////////////////

p5.Renderer2D.prototype.text = function (str, x, y, maxWidth, maxHeight) {

  var p = this._pInst, cars, n, ii, jj, line, testLine,
    testWidth, words, totalHeight, baselineHacked,
    finalMaxHeight = Number.MAX_VALUE;

  // baselineHacked: (HACK)
  // A temporary fix to conform to Processing's implementation
  // of BASELINE vertical alignment in a bounding box

  if (!(this._doFill || this._doStroke)) {
    return;
  }

  if (typeof str !== 'string') {
    str = str.toString();
  }

  str = str.replace(/(\t)/g, '  ');
  cars = str.split('\n');

  if (typeof maxWidth !== 'undefined') {

    totalHeight = 0;
    for (ii = 0; ii < cars.length; ii++) {
      line = '';
      words = cars[ii].split(' ');
      for (n = 0; n < words.length; n++) {
        testLine = line + words[n] + ' ';
        testWidth = this.textWidth(testLine);
        if (testWidth > maxWidth) {
          line = words[n] + ' ';
          totalHeight += p.textLeading();
        } else {
          line = testLine;
        }
      }
    }

    if (this._rectMode === constants.CENTER) {

      x -= maxWidth / 2;
      y -= maxHeight / 2;
    }

    switch (this.drawingContext.textAlign) {

      case constants.CENTER:
        x += maxWidth / 2;
        break;
      case constants.RIGHT:
        x += maxWidth;
        break;
    }

    if (typeof maxHeight !== 'undefined') {

      switch (this.drawingContext.textBaseline) {
        case constants.BOTTOM:
          y += (maxHeight - totalHeight);
          break;
        case constants._CTX_MIDDLE: // CENTER?
          y += (maxHeight - totalHeight) / 2;
          break;
        case constants.BASELINE:
          baselineHacked = true;
          this.drawingContext.textBaseline = constants.TOP;
          break;
      }

      // remember the max-allowed y-position for any line (fix to #928)
      finalMaxHeight = (y + maxHeight) - p.textAscent();
    }

    for (ii = 0; ii < cars.length; ii++) {

      line = '';
      words = cars[ii].split(' ');
      for (n = 0; n < words.length; n++) {
        testLine = line + words[n] + ' ';
        testWidth = this.textWidth(testLine);
        if (testWidth > maxWidth && line.length > 0) {
          this._renderText(p, line, x, y, finalMaxHeight);
          line = words[n] + ' ';
          y += p.textLeading();
        } else {
          line = testLine;
        }
      }

      this._renderText(p, line, x, y, finalMaxHeight);
      y += p.textLeading();
    }
  }
  else {
    // Offset to account for vertically centering multiple lines of text - no
    // need to adjust anything for vertical align top or baseline
    var offset = 0,
      vAlign = p.textAlign().vertical;
    if (vAlign === constants.CENTER) {
      offset = ((cars.length - 1) * p.textLeading()) / 2;
    } else if (vAlign === constants.BOTTOM) {
      offset = (cars.length - 1) * p.textLeading();
    }

    for (jj = 0; jj < cars.length; jj++) {

      this._renderText(p, cars[jj], x, y-offset, finalMaxHeight);
      y += p.textLeading();
    }
  }

  if (baselineHacked) {
    this.drawingContext.textBaseline = constants.BASELINE;
  }

  return p;
};

p5.Renderer2D.prototype._renderText = function(p, line, x, y, maxY) {

  if (y >= maxY) {
    return; // don't render lines beyond our maxY position
  }

  p.push(); // fix to #803

  if (!this._isOpenType()) {  // a system/browser font

    // no stroke unless specified by user
    if (this._doStroke && this._strokeSet) {

      this.drawingContext.strokeText(line, x, y);
    }

    if (this._doFill) {

      // if fill hasn't been set by user, use default text fill
      this.drawingContext.fillStyle =  this._fillSet ?
        this.drawingContext.fillStyle : constants._DEFAULT_TEXT_FILL;

      this.drawingContext.fillText(line, x, y);
    }
  }
  else { // an opentype font, let it handle the rendering

    this._textFont._renderPath(line, x, y, { renderer: this });
  }

  p.pop();

  return p;
};

p5.Renderer2D.prototype.textWidth = function(s) {

  if (this._isOpenType()) {

    return this._textFont._textWidth(s, this._textSize);
  }

  return this.drawingContext.measureText(s).width;
};

p5.Renderer2D.prototype.textAlign = function(h, v) {

  if (arguments.length) {

    if (h === constants.LEFT ||
      h === constants.RIGHT ||
      h === constants.CENTER) {

      this.drawingContext.textAlign = h;
    }

    if (v === constants.TOP ||
      v === constants.BOTTOM ||
      v === constants.CENTER ||
      v === constants.BASELINE) {

      if (v === constants.CENTER) {
        this.drawingContext.textBaseline = constants._CTX_MIDDLE;
      } else {
        this.drawingContext.textBaseline = v;
      }
    }

    return this._pInst;

  } else {

    var valign = this.drawingContext.textBaseline;

    if (valign === constants._CTX_MIDDLE) {

      valign = constants.CENTER;
    }

    return {

      horizontal: this.drawingContext.textAlign,
      vertical: valign
    };
  }
};

p5.Renderer2D.prototype._applyTextProperties = function() {

  var font, p = this._pInst;

  this._setProperty('_textAscent', null);
  this._setProperty('_textDescent', null);

  font = this._textFont;

  if (this._isOpenType()) {

    font = this._textFont.font.familyName;
    this._setProperty('_textStyle', this._textFont.font.styleName);
  }

  this.drawingContext.font = this._textStyle + ' ' +
    this._textSize + 'px ' + font;

  return p;
};


//////////////////////////////////////////////
// STRUCTURE
//////////////////////////////////////////////

p5.Renderer2D.prototype.push = function() {
  this.drawingContext.save();
};

p5.Renderer2D.prototype.pop = function() {
  this.drawingContext.restore();
};

module.exports = p5.Renderer2D;

},{"../image/filters":59,"./canvas":40,"./constants":41,"./core":42,"./p5.Renderer":48}],50:[function(_dereq_,module,exports){
/**
 * @module Rendering
 * @submodule Rendering
 * @for p5
 */

var p5 = _dereq_('./core');
var constants = _dereq_('./constants');
_dereq_('./p5.Graphics');
_dereq_('./p5.Renderer2D');
_dereq_('../webgl/p5.RendererGL');
var defaultId = 'defaultCanvas0'; // this gets set again in createCanvas

/**
 * Creates a canvas element in the document, and sets the dimensions of it
 * in pixels. This method should be called only once at the start of setup.
 * Calling createCanvas more than once in a sketch will result in very
 * unpredicable behavior. If you want more than one drawing canvas
 * you could use createGraphics (hidden by default but it can be shown).
 * <br><br>
 * The system variables width and height are set by the parameters passed
 * to this function. If createCanvas() is not used, the window will be
 * given a default size of 100x100 pixels.
 * <br><br>
 * For more ways to position the canvas, see the
 * <a href='https://github.com/processing/p5.js/wiki/Positioning-your-canvas'>
 * positioning the canvas</a> wiki page.
 *
 * @method createCanvas
 * @param  {Number} w width of the canvas
 * @param  {Number} h height of the canvas
 * @param  {Constant} [renderer] P2D or WEBGL
 * @return {Object} canvas generated
 * @example
 * <div>
 * <code>
 * function setup() {
 *   createCanvas(100, 50);
 *   background(153);
 *   line(0, 0, width, height);
 * }
 * </code>
 * </div>
 *
 * @alt
 * Black line extending from top-left of canvas to bottom right.
 *
 */

p5.prototype.createCanvas = function(w, h, renderer) {
  //optional: renderer, otherwise defaults to p2d
  var r = renderer || constants.P2D;
  var isDefault, c;

  //4th arg (isDefault) used when called onLoad,
  //otherwise hidden to the public api
  if(arguments[3]){
    isDefault =
    (typeof arguments[3] === 'boolean') ? arguments[3] : false;
  }

  if(r === constants.WEBGL){
    c = document.getElementById(defaultId);
    if(c){ //if defaultCanvas already exists
      c.parentNode.removeChild(c); //replace the existing defaultCanvas
    }
    c = document.createElement('canvas');
    c.id = defaultId;
  }
  else {
    if (isDefault) {
      c = document.createElement('canvas');
      var i = 0;
      while (document.getElementById('defaultCanvas'+i)) {
        i++;
      }
      defaultId = 'defaultCanvas'+i;
      c.id = defaultId;
    } else { // resize the default canvas if new one is created
      c = this.canvas;
    }
  }

  // set to invisible if still in setup (to prevent flashing with manipulate)
  if (!this._setupDone) {
    c.dataset.hidden = true; // tag to show later
    c.style.visibility='hidden';
  }

  if (this._userNode) { // user input node case
    this._userNode.appendChild(c);
  } else {
    document.body.appendChild(c);
  }



  // Init our graphics renderer
  //webgl mode
  if (r === constants.WEBGL) {
    this._setProperty('_renderer', new p5.RendererGL(c, this, true));
    this._isdefaultGraphics = true;
  }
  //P2D mode
  else {
    if (!this._isdefaultGraphics) {
      this._setProperty('_renderer', new p5.Renderer2D(c, this, true));
      this._isdefaultGraphics = true;
    }
  }
  this._renderer.resize(w, h);
  this._renderer._applyDefaults();
  if (isDefault) { // only push once
    this._elements.push(this._renderer);
  }
  return this._renderer;
};

/**
 * Resizes the canvas to given width and height. The canvas will be cleared
 * and draw will be called immediately, allowing the sketch to re-render itself
 * in the resized canvas.
 * @method resizeCanvas
 * @example
 * <div class="norender"><code>
 * function setup() {
 *   createCanvas(windowWidth, windowHeight);
 * }
 *
 * function draw() {
 *  background(0, 100, 200);
 * }
 *
 * function windowResized() {
 *   resizeCanvas(windowWidth, windowHeight);
 * }
 * </code></div>
 *
 * @alt
 * No image displayed.
 *
 */
p5.prototype.resizeCanvas = function (w, h, noRedraw) {
  if (this._renderer) {

    // save canvas properties
    var props = {};
    for (var key in this.drawingContext) {
      var val = this.drawingContext[key];
      if (typeof val !== 'object' && typeof val !== 'function') {
        props[key] = val;
      }
    }
    this._renderer.resize(w, h);
    // reset canvas properties
    for (var savedKey in props) {
      this.drawingContext[savedKey] = props[savedKey];
    }
    if (!noRedraw) {
      this.redraw();
    }
  }
};


/**
 * Removes the default canvas for a p5 sketch that doesn't
 * require a canvas
 * @method noCanvas
 * @example
 * <div>
 * <code>
 * function setup() {
 *   noCanvas();
 * }
 * </code>
 * </div>
 *
 * @alt
 * no image displayed
 *
 */
p5.prototype.noCanvas = function() {
  if (this.canvas) {
    this.canvas.parentNode.removeChild(this.canvas);
  }
};

/**
 * Creates and returns a new p5.Renderer object. Use this class if you need
 * to draw into an off-screen graphics buffer. The two parameters define the
 * width and height in pixels.
 *
 * @method createGraphics
 * @param  {Number} w width of the offscreen graphics buffer
 * @param  {Number} h height of the offscreen graphics buffer
 * @param  {Constant} [renderer] P2D or WEBGL
 * undefined defaults to p2d
 * @return {Object} offscreen graphics buffer
 * @example
 * <div>
 * <code>
 * var pg;
 * function setup() {
 *   createCanvas(100, 100);
 *   pg = createGraphics(100, 100);
 * }
 * function draw() {
 *   background(200);
 *   pg.background(100);
 *   pg.noStroke();
 *   pg.ellipse(pg.width/2, pg.height/2, 50, 50);
 *   image(pg, 50, 50);
 *   image(pg, 0, 0, 50, 50);
 * }
 * </code>
 * </div>
 *
 * @alt
 * 4 grey squares alternating light and dark grey. White quarter circle mid-left.
 *
 */
p5.prototype.createGraphics = function(w, h, renderer){
  return new p5.Graphics(w, h, renderer, this);
};

/**
 * Blends the pixels in the display window according to the defined mode.
 * There is a choice of the following modes to blend the source pixels (A)
 * with the ones of pixels already in the display window (B):
 * <ul>
 * <li><code>BLEND</code> - linear interpolation of colours: C =
 * A*factor + B. This is the default blending mode.</li>
 * <li><code>ADD</code> - sum of A and B</li>
 * <li><code>DARKEST</code> - only the darkest colour succeeds: C =
 * min(A*factor, B).</li>
 * <li><code>LIGHTEST</code> - only the lightest colour succeeds: C =
 * max(A*factor, B).</li>
 * <li><code>DIFFERENCE</code> - subtract colors from underlying image.</li>
 * <li><code>EXCLUSION</code> - similar to <code>DIFFERENCE</code>, but less
 * extreme.</li>
 * <li><code>MULTIPLY</code> - multiply the colors, result will always be
 * darker.</li>
 * <li><code>SCREEN</code> - opposite multiply, uses inverse values of the
 * colors.</li>
 * <li><code>REPLACE</code> - the pixels entirely replace the others and
 * don't utilize alpha (transparency) values.</li>
 * <li><code>OVERLAY</code> - mix of <code>MULTIPLY</code> and <code>SCREEN
 * </code>. Multiplies dark values, and screens light values.</li>
 * <li><code>HARD_LIGHT</code> - <code>SCREEN</code> when greater than 50%
 * gray, <code>MULTIPLY</code> when lower.</li>
 * <li><code>SOFT_LIGHT</code> - mix of <code>DARKEST</code> and
 * <code>LIGHTEST</code>. Works like <code>OVERLAY</code>, but not as harsh.
 * </li>
 * <li><code>DODGE</code> - lightens light tones and increases contrast,
 * ignores darks.</li>
 * <li><code>BURN</code> - darker areas are applied, increasing contrast,
 * ignores lights.</li>
 * </ul>
 *
 * @method blendMode
 * @param  {Constant} mode blend mode to set for canvas
 * @example
 * <div>
 * <code>
 * blendMode(LIGHTEST);
 * strokeWeight(30);
 * stroke(80, 150, 255);
 * line(25, 25, 75, 75);
 * stroke(255, 50, 50);
 * line(75, 25, 25, 75);
 * </code>
 * </div>
 * <div>
 * <code>
 * blendMode(MULTIPLY);
 * strokeWeight(30);
 * stroke(80, 150, 255);
 * line(25, 25, 75, 75);
 * stroke(255, 50, 50);
 * line(75, 25, 25, 75);
 * </code>
 * </div>
 * @alt
 * translucent image thick red & blue diagonal rounded lines intersecting center
 * Thick red & blue diagonal rounded lines intersecting center. dark at overlap
 *
 */
p5.prototype.blendMode = function(mode) {
  if (mode === constants.BLEND || mode === constants.DARKEST ||
    mode === constants.LIGHTEST || mode === constants.DIFFERENCE ||
    mode === constants.MULTIPLY || mode === constants.EXCLUSION ||
    mode === constants.SCREEN || mode === constants.REPLACE ||
    mode === constants.OVERLAY || mode === constants.HARD_LIGHT ||
    mode === constants.SOFT_LIGHT || mode === constants.DODGE ||
    mode === constants.BURN || mode === constants.ADD ||
    mode === constants.NORMAL) {
    this._renderer.blendMode(mode);
  } else {
    throw new Error('Mode '+mode+' not recognized.');
  }
};

module.exports = p5;

},{"../webgl/p5.RendererGL":91,"./constants":41,"./core":42,"./p5.Graphics":47,"./p5.Renderer2D":49}],51:[function(_dereq_,module,exports){

// requestAnim shim layer by Paul Irish
window.requestAnimationFrame = (function(){
  return window.requestAnimationFrame      ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame    ||
        window.oRequestAnimationFrame      ||
        window.msRequestAnimationFrame     ||
        function(callback, element){
          // should '60' here be framerate?
          window.setTimeout(callback, 1000 / 60);
        };
})();

// use window.performance() to get max fast and accurate time in milliseconds
window.performance = window.performance || {};
window.performance.now = (function(){
  var load_date = Date.now();
  return window.performance.now        ||
        window.performance.mozNow      ||
        window.performance.msNow       ||
        window.performance.oNow        ||
        window.performance.webkitNow   ||
        function () {
          return Date.now() - load_date;
        };
})();

/*
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/
// requestanimationframe-for-smart-er-animating
// requestAnimationFrame polyfill by Erik Möller
// fixes from Paul Irish and Tino Zijdel
(function() {
  var lastTime = 0;
  var vendors = ['ms', 'moz', 'webkit', 'o'];
  for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    window.requestAnimationFrame =
      window[vendors[x]+'RequestAnimationFrame'];
    window.cancelAnimationFrame =
      window[vendors[x]+'CancelAnimationFrame'] ||
      window[vendors[x]+'CancelRequestAnimationFrame'];
  }

  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = function(callback, element) {
      var currTime = new Date().getTime();
      var timeToCall = Math.max(0, 16 - (currTime - lastTime));
      var id = window.setTimeout(function()
        { callback(currTime + timeToCall); }, timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };
  }

  if (!window.cancelAnimationFrame) {
    window.cancelAnimationFrame = function(id) {
      clearTimeout(id);
    };
  }
}());
*/

/**
 * shim for Uint8ClampedArray.slice
 * (allows arrayCopy to work with pixels[])
 * with thanks to http://halfpapstudios.com/blog/tag/html5-canvas/
 * Enumerable set to false to protect for...in from
 * Uint8ClampedArray.prototype pollution.
 */
(function () {
  'use strict';
  if (typeof Uint8ClampedArray !== 'undefined' &&
      !Uint8ClampedArray.prototype.slice) {
    Object.defineProperty(Uint8ClampedArray.prototype, 'slice', {
      value: Array.prototype.slice,
      writable: true, configurable: true, enumerable: false
    });
  }
}());

},{}],52:[function(_dereq_,module,exports){
/**
 * @module Structure
 * @submodule Structure
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('./core');

p5.prototype.exit = function() {
  throw 'exit() not implemented, see remove()';
};
/**
 * Stops p5.js from continuously executing the code within draw().
 * If loop() is called, the code in draw() begins to run continuously again.
 * If using noLoop() in setup(), it should be the last line inside the block.
 * <br><br>
 * When noLoop() is used, it's not possible to manipulate or access the
 * screen inside event handling functions such as mousePressed() or
 * keyPressed(). Instead, use those functions to call redraw() or loop(),
 * which will run draw(), which can update the screen properly. This means
 * that when noLoop() has been called, no drawing can happen, and functions
 * like saveFrame() or loadPixels() may not be used.
 * <br><br>
 * Note that if the sketch is resized, redraw() will be called to update
 * the sketch, even after noLoop() has been specified. Otherwise, the sketch
 * would enter an odd state until loop() was called.
 *
 * @method noLoop
 * @example
 * <div><code>
 * function setup() {
 *   createCanvas(100, 100);
 *   background(200);
 *   noLoop();
 * }

 * function draw() {
 *   line(10, 10, 90, 90);
 * }
 * </code></div>
 *
 * <div><code>
 * var x = 0;
 * function setup() {
 *   createCanvas(100, 100);
 * }
 *
 * function draw() {
 *   background(204);
 *   x = x + 0.1;
 *   if (x > width) {
 *     x = 0;
 *   }
 *   line(x, 0, x, height);
 * }
 *
 * function mousePressed() {
 *   noLoop();
 * }
 *
 * function mouseReleased() {
 *   loop();
 * }
 * </code></div>
 *
 * @alt
 * 113 pixel long line extending from top-left to bottom right of canvas.
 * horizontal line moves slowly from left. Loops but stops on mouse press.
 *
 */
p5.prototype.noLoop = function() {
  this._loop = false;
};
/**
 * By default, p5.js loops through draw() continuously, executing the code
 * within it. However, the draw() loop may be stopped by calling noLoop().
 * In that case, the draw() loop can be resumed with loop().
 *
 * @method loop
 * @example
 * <div><code>
 * var x = 0;
 * function setup() {
 *   createCanvas(100, 100);
 *   noLoop();
 * }
 *
 * function draw() {
 *   background(204);
 *   x = x + 0.1;
 *   if (x > width) {
 *     x = 0;
 *   }
 *   line(x, 0, x, height);
 * }
 *
 * function mousePressed() {
 *   loop();
 * }
 *
 * function mouseReleased() {
 *   noLoop();
 * }
 * </code></div>
 *
 * @alt
 * horizontal line moves slowly from left. Loops but stops on mouse press.
 *
 */

p5.prototype.loop = function() {
  this._loop = true;
  this._draw();
};

/**
 * The push() function saves the current drawing style settings and
 * transformations, while pop() restores these settings. Note that these
 * functions are always used together. They allow you to change the style
 * and transformation settings and later return to what you had. When a new
 * state is started with push(), it builds on the current style and transform
 * information. The push() and pop() functions can be embedded to provide
 * more control. (See the second example for a demonstration.)
 * <br><br>
 * push() stores information related to the current transformation state
 * and style settings controlled by the following functions: fill(),
 * stroke(), tint(), strokeWeight(), strokeCap(), strokeJoin(),
 * imageMode(), rectMode(), ellipseMode(), colorMode(), textAlign(),
 * textFont(), textMode(), textSize(), textLeading().
 *
 * @method push
 * @example
 * <div>
 * <code>
 * ellipse(0, 50, 33, 33);  // Left circle
 *
 * push();  // Start a new drawing state
 * strokeWeight(10);
 * fill(204, 153, 0);
 * translate(50, 0);
 * ellipse(0, 50, 33, 33);  // Middle circle
 * pop();  // Restore original state
 *
 * ellipse(100, 50, 33, 33);  // Right circle
 * </code>
 * </div>
 * <div>
 * <code>
 * ellipse(0, 50, 33, 33);  // Left circle
 *
 * push();  // Start a new drawing state
 * strokeWeight(10);
 * fill(204, 153, 0);
 * ellipse(33, 50, 33, 33);  // Left-middle circle
 *
 * push();  // Start another new drawing state
 * stroke(0, 102, 153);
 * ellipse(66, 50, 33, 33);  // Right-middle circle
 * pop();  // Restore previous state
 *
 * pop();  // Restore original state
 *
 * ellipse(100, 50, 33, 33);  // Right circle
 * </code>
 * </div>
 *
 * @alt
 * Gold ellipse + thick black outline @center 2 white ellipses on left and right.
 * 2 Gold ellipses left black right blue stroke. 2 white ellipses on left+right.
 *
 */
p5.prototype.push = function () {
  this._renderer.push();
  this._styles.push({
    _doStroke: this._renderer._doStroke,
    _strokeSet: this._renderer._strokeSet,
    _doFill: this._renderer._doFill,
    _fillSet: this._renderer._fillSet,
    _tint: this._renderer._tint,
    _imageMode: this._renderer._imageMode,
    _rectMode: this._renderer._rectMode,
    _ellipseMode: this._renderer._ellipseMode,
    _colorMode: this._renderer._colorMode,
    _textFont: this._renderer._textFont,
    _textLeading: this._renderer._textLeading,
    _textSize: this._renderer._textSize,
    _textStyle: this._renderer._textStyle
  });
};

/**
 * The push() function saves the current drawing style settings and
 * transformations, while pop() restores these settings. Note that these
 * functions are always used together. They allow you to change the style
 * and transformation settings and later return to what you had. When a new
 * state is started with push(), it builds on the current style and transform
 * information. The push() and pop() functions can be embedded to provide
 * more control. (See the second example for a demonstration.)
 * <br><br>
 * push() stores information related to the current transformation state
 * and style settings controlled by the following functions: fill(),
 * stroke(), tint(), strokeWeight(), strokeCap(), strokeJoin(),
 * imageMode(), rectMode(), ellipseMode(), colorMode(), textAlign(),
 * textFont(), textMode(), textSize(), textLeading().
 *
 * @method pop
 * @example
 * <div>
 * <code>
 * ellipse(0, 50, 33, 33);  // Left circle
 *
 * push();  // Start a new drawing state
 * translate(50, 0);
 * strokeWeight(10);
 * fill(204, 153, 0);
 * ellipse(0, 50, 33, 33);  // Middle circle
 * pop();  // Restore original state
 *
 * ellipse(100, 50, 33, 33);  // Right circle
 * </code>
 * </div>
 * <div>
 * <code>
 * ellipse(0, 50, 33, 33);  // Left circle
 *
 * push();  // Start a new drawing state
 * strokeWeight(10);
 * fill(204, 153, 0);
 * ellipse(33, 50, 33, 33);  // Left-middle circle
 *
 * push();  // Start another new drawing state
 * stroke(0, 102, 153);
 * ellipse(66, 50, 33, 33);  // Right-middle circle
 * pop();  // Restore previous state
 *
 * pop();  // Restore original state
 *
 * ellipse(100, 50, 33, 33);  // Right circle
 * </code>
 * </div>
 *
 * @alt
 * Gold ellipse + thick black outline @center 2 white ellipses on left and right.
 * 2 Gold ellipses left black right blue stroke. 2 white ellipses on left+right.
 *
 */
p5.prototype.pop = function () {
  this._renderer.pop();
  var lastS = this._styles.pop();
  for(var prop in lastS){
    this._renderer[prop] = lastS[prop];
  }
};

p5.prototype.pushStyle = function() {
  throw new Error('pushStyle() not used, see push()');
};

p5.prototype.popStyle = function() {
  throw new Error('popStyle() not used, see pop()');
};

/**
 *
 * Executes the code within draw() one time. This functions allows the
 * program to update the display window only when necessary, for example
 * when an event registered by mousePressed() or keyPressed() occurs.
 * <br><br>
 * In structuring a program, it only makes sense to call redraw() within
 * events such as mousePressed(). This is because redraw() does not run
 * draw() immediately (it only sets a flag that indicates an update is
 * needed).
 * <br><br>
 * The redraw() function does not work properly when called inside draw().
 * To enable/disable animations, use loop() and noLoop().
 * <br><br>
 * In addition you can set the number of redraws per method call. Just
 * add an integer as single parameter for the number of redraws.
 *
 * @method redraw
 * @param  {Integer} [n] Redraw for n-times. The default value is 1.
 * @example
 * <div><code>
 * var x = 0;
 *
 * function setup() {
 *   createCanvas(100, 100);
 *   noLoop();
 * }
 *
 * function draw() {
 *   background(204);
 *   line(x, 0, x, height);
 * }
 *
 * function mousePressed() {
 *   x += 1;
 *   redraw();
 * }
 * </code></div>
 *
 * <div class='norender'><code>
 * var x = 0;
 *
 * function setup() {
 *   createCanvas(100, 100);
 *   noLoop();
 * }
 *
 * function draw() {
 *   background(204);
 *   x += 1;
 *   line(x, 0, x, height);
 * }
 *
 * function mousePressed() {
 *   redraw(5);
 * }
 * </code></div>
 *
 * @alt
 * black line on far left of canvas
 * black line on far left of canvas
 *
 */
p5.prototype.redraw = function () {
  this.resetMatrix();
  if(this._renderer.isP3D){
    this._renderer._update();
  }

  var numberOfRedraws = 1;
  if (arguments.length === 1) {
    try {
      if (parseInt(arguments[0]) > 1) {
        numberOfRedraws = parseInt(arguments[0]);
      }
    } catch (error) {
      // Do nothing, because the default value didn't be changed.
    }
  }
  var userSetup = this.setup || window.setup;
  var userDraw = this.draw || window.draw;
  if (typeof userDraw === 'function') {
    if (typeof userSetup === 'undefined') {
      this.scale(this._pixelDensity, this._pixelDensity);
    }
    var self = this;
    var callMethod = function (f) {
      f.call(self);
    };
    for (var idxRedraw = 0; idxRedraw < numberOfRedraws; idxRedraw++) {
      this._registeredMethods.pre.forEach(callMethod);
      userDraw();
      this._registeredMethods.post.forEach(callMethod);
    }
  }
};

p5.prototype.size = function() {
  var s = 'size() is not a valid p5 function, to set the size of the ';
  s += 'drawing canvas, please use createCanvas() instead';
  throw s;
};


module.exports = p5;

},{"./core":42}],53:[function(_dereq_,module,exports){
/**
 * @module Transform
 * @submodule Transform
 * @for p5
 * @requires core
 * @requires constants
 */


'use strict';

var p5 = _dereq_('./core');
var constants = _dereq_('./constants');

/**
 * Multiplies the current matrix by the one specified through the parameters.
 * This is very slow because it will try to calculate the inverse of the
 * transform, so avoid it whenever possible.
 *
 * @method applyMatrix
 * @param  {Number} n00 numbers which define the 3x2 matrix to be multiplied
 * @param  {Number} n01 numbers which define the 3x2 matrix to be multiplied
 * @param  {Number} n02 numbers which define the 3x2 matrix to be multiplied
 * @param  {Number} n10 numbers which define the 3x2 matrix to be multiplied
 * @param  {Number} n11 numbers which define the 3x2 matrix to be multiplied
 * @param  {Number} n12 numbers which define the 3x2 matrix to be multiplied
 * @return {p5}         the p5 object
 * @example
 * <div>
 * <code>
 * // Example in the works.
 * </code>
 * </div>
 *
 * @alt
 * no image diplayed
 *
 */
p5.prototype.applyMatrix = function(n00, n01, n02, n10, n11, n12) {
  this._renderer.applyMatrix(n00, n01, n02, n10, n11, n12);
  return this;
};

p5.prototype.popMatrix = function() {
  throw new Error('popMatrix() not used, see pop()');
};

p5.prototype.printMatrix = function() {
  throw new Error('printMatrix() not implemented');
};

p5.prototype.pushMatrix = function() {
  throw new Error('pushMatrix() not used, see push()');
};

/**
 * Replaces the current matrix with the identity matrix.
 *
 * @method resetMatrix
 * @return {p5} the p5 object
 * @example
 * <div>
 * <code>
 * // Example in the works.
 * </code>
 * </div>
 *
 * @alt
 * no image diplayed
 *
 */
p5.prototype.resetMatrix = function() {
  this._renderer.resetMatrix();
  return this;
};

/**
 * Rotates a shape the amount specified by the angle parameter. This
 * function accounts for angleMode, so angles can be entered in either
 * RADIANS or DEGREES.
 * <br><br>
 * Objects are always rotated around their relative position to the
 * origin and positive numbers rotate objects in a clockwise direction.
 * Transformations apply to everything that happens after and subsequent
 * calls to the function accumulates the effect. For example, calling
 * rotate(HALF_PI) and then rotate(HALF_PI) is the same as rotate(PI).
 * All tranformations are reset when draw() begins again.
 * <br><br>
 * Technically, rotate() multiplies the current transformation matrix
 * by a rotation matrix. This function can be further controlled by
 * the push() and pop().
 *
 * @method rotate
 * @param  {Number} angle the angle of rotation, specified in radians
 *                        or degrees, depending on current angleMode
 * @return {p5}           the p5 object
 * @example
 * <div>
 * <code>
 * translate(width/2, height/2);
 * rotate(PI/3.0);
 * rect(-26, -26, 52, 52);
 * </code>
 * </div>
 *
 * @alt
 * white 52x52 rect with black outline at center rotated counter 45 degrees
 *
 */
/**
 * @method rotate
 * @param  {Number} rad angle in radians
 * @param  {p5.Vector|Array} axis axis to rotate around
 * @return {p5} the p5 object
 */
p5.prototype.rotate = function() {
  var args = new Array(arguments.length);
  var r;
  for (var i = 0; i < args.length; ++i) {
    args[i] = arguments[i];
  }
  if (this._angleMode === constants.DEGREES) {
    r = this.radians(args[0]);
  } else if (this._angleMode === constants.RADIANS){
    r = args[0];
  }
  //in webgl mode
  if(args.length > 1){
    this._renderer.rotate(r, args[1]);
  }
  else {
    this._renderer.rotate(r);
  }
  return this;
};

/**
 * Rotates around X axis.
 * @method  rotateX
 * @param  {Number} rad angles in radians
 * @return {p5} the p5 object
 */
p5.prototype.rotateX = function(rad) {
  if (this._renderer.isP3D) {
    this._renderer.rotateX(rad);
  } else {
    throw 'not supported in p2d. Please use webgl mode';
  }
  return this;
};

/**
 * Rotates around Y axis.
 * @method rotateY
 * @param  {Number} rad angles in radians
 * @return {p5} the p5 object
 */
p5.prototype.rotateY = function(rad) {
  if (this._renderer.isP3D) {
    this._renderer.rotateY(rad);
  } else {
    throw 'not supported in p2d. Please use webgl mode';
  }
  return this;
};

/**
 * Rotates around Z axis. Webgl mode only.
 * @method rotateZ
 * @param  {Number} rad angles in radians
 * @return {p5} the p5 object
 */
p5.prototype.rotateZ = function(rad) {
  if (this._renderer.isP3D) {
    this._renderer.rotateZ(rad);
  } else {
    throw 'not supported in p2d. Please use webgl mode';
  }
  return this;
};

/**
 * Increases or decreases the size of a shape by expanding and contracting
 * vertices. Objects always scale from their relative origin to the
 * coordinate system. Scale values are specified as decimal percentages.
 * For example, the function call scale(2.0) increases the dimension of a
 * shape by 200%.
 * <br><br>
 * Transformations apply to everything that happens after and subsequent
 * calls to the function multiply the effect. For example, calling scale(2.0)
 * and then scale(1.5) is the same as scale(3.0). If scale() is called
 * within draw(), the transformation is reset when the loop begins again.
 * <br><br>
 * Using this function with the z parameter is only available in WEBGL mode.
 * This function can be further controlled with push() and pop().
 *
 * @method scale
 * @param  {Number|p5.Vector|Array} s
 *                      percent to scale the object, or percentage to
 *                      scale the object in the x-axis if multiple arguments
 *                      are given
 * @param  {Number} [y] percent to scale the object in the y-axis
 * @param  {Number} [z] percent to scale the object in the z-axis (webgl only)
 * @return {p5}         the p5 object
 * @example
 * <div>
 * <code>
 * translate(width/2, height/2);
 * rotate(PI/3.0);
 * rect(-26, -26, 52, 52);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * rect(30, 20, 50, 50);
 * scale(0.5, 1.3);
 * rect(30, 20, 50, 50);
 * </code>
 * </div>
 *
 * @alt
 * white 52x52 rect with black outline at center rotated counter 45 degrees
 * 2 white rects with black outline- 1 50x50 at center. other 25x65 bottom left
 *
 */
p5.prototype.scale = function() {
  var x,y,z;
  var args = new Array(arguments.length);
  for(var i = 0; i < args.length; i++) {
    args[i] = arguments[i];
  }
  if(args[0] instanceof p5.Vector){
    x = args[0].x;
    y = args[0].y;
    z = args[0].z;
  }
  else if(args[0] instanceof Array){
    x = args[0][0];
    y = args[0][1];
    z = args[0][2] || 1;
  }
  else {
    if(args.length === 1){
      x = y = z = args[0];
    }
    else {
      x = args[0];
      y = args[1];
      z = args[2] || 1;
    }
  }

  if(this._renderer.isP3D){
    this._renderer.scale.call(this._renderer, x,y,z);
  }
  else {
    this._renderer.scale.call(this._renderer, x,y);
  }
  return this;
};

/**
 * Shears a shape around the x-axis the amount specified by the angle
 * parameter. Angles should be specified in the current angleMode.
 * Objects are always sheared around their relative position to the origin
 * and positive numbers shear objects in a clockwise direction.
 * <br><br>
 * Transformations apply to everything that happens after and subsequent
 * calls to the function accumulates the effect. For example, calling
 * shearX(PI/2) and then shearX(PI/2) is the same as shearX(PI).
 * If shearX() is called within the draw(), the transformation is reset when
 * the loop begins again.
 * <br><br>
 * Technically, shearX() multiplies the current transformation matrix by a
 * rotation matrix. This function can be further controlled by the
 * push() and pop() functions.
 *
 * @method shearX
 * @param  {Number} angle angle of shear specified in radians or degrees,
 *                        depending on current angleMode
 * @return {p5}           the p5 object
 * @example
 * <div>
 * <code>
 * translate(width/4, height/4);
 * shearX(PI/4.0);
 * rect(0, 0, 30, 30);
 * </code>
 * </div>
 *
 * @alt
  * white irregular quadrilateral with black outline at top middle.
 *
 */
p5.prototype.shearX = function(angle) {
  if (this._angleMode === constants.DEGREES) {
    angle = this.radians(angle);
  }
  this._renderer.shearX(angle);
  return this;
};

/**
 * Shears a shape around the y-axis the amount specified by the angle
 * parameter. Angles should be specified in the current angleMode. Objects
 * are always sheared around their relative position to the origin and
 * positive numbers shear objects in a clockwise direction.
 * <br><br>
 * Transformations apply to everything that happens after and subsequent
 * calls to the function accumulates the effect. For example, calling
 * shearY(PI/2) and then shearY(PI/2) is the same as shearY(PI). If
 * shearY() is called within the draw(), the transformation is reset when
 * the loop begins again.
 * <br><br>
 * Technically, shearY() multiplies the current transformation matrix by a
 * rotation matrix. This function can be further controlled by the
 * push() and pop() functions.
 *
 * @method shearY
 * @param  {Number} angle angle of shear specified in radians or degrees,
 *                        depending on current angleMode
 * @return {p5}           the p5 object
 * @example
 * <div>
 * <code>
 * translate(width/4, height/4);
 * shearY(PI/4.0);
 * rect(0, 0, 30, 30);
 * </code>
 * </div>
 *
 * @alt
 * white irregular quadrilateral with black outline at middle bottom.
 *
 */
p5.prototype.shearY = function(angle) {
  if (this._angleMode === constants.DEGREES) {
    angle = this.radians(angle);
  }
  this._renderer.shearY(angle);
  return this;
};

/**
 * Specifies an amount to displace objects within the display window.
 * The x parameter specifies left/right translation, the y parameter
 * specifies up/down translation.
 * <br><br>
 * Transformations are cumulative and apply to everything that happens after
 * and subsequent calls to the function accumulates the effect. For example,
 * calling translate(50, 0) and then translate(20, 0) is the same as
 * translate(70, 0). If translate() is called within draw(), the
 * transformation is reset when the loop begins again. This function can be
 * further controlled by using push() and pop().
 *
 * @method translate
 * @param  {Number} x left/right translation
 * @param  {Number} y up/down translation
 * @param  {Number} [z] forward/backward translation (webgl only)
 * @return {p5}       the p5 object
 * @example
 * <div>
 * <code>
 * translate(30, 20);
 * rect(0, 0, 55, 55);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * rect(0, 0, 55, 55);  // Draw rect at original 0,0
 * translate(30, 20);
 * rect(0, 0, 55, 55);  // Draw rect at new 0,0
 * translate(14, 14);
 * rect(0, 0, 55, 55);  // Draw rect at new 0,0
 * </code>
 * </div>
 *
 * @alt
 * white 55x55 rect with black outline at center right.
 * 3 white 55x55 rects with black outlines at top-l, center-r and bottom-r.
 *
 */
p5.prototype.translate = function(x, y, z) {
  if (this._renderer.isP3D) {
    this._renderer.translate(x, y, z);
  } else {
    this._renderer.translate(x, y);
  }
  return this;
};

module.exports = p5;

},{"./constants":41,"./core":42}],54:[function(_dereq_,module,exports){
/**
 * @module Shape
 * @submodule Vertex
 * @for p5
 * @requires core
 * @requires constants
 */

'use strict';

var p5 = _dereq_('./core');
var constants = _dereq_('./constants');
var shapeKind = null;
var vertices = [];
var contourVertices = [];
var isBezier = false;
var isCurve = false;
var isQuadratic = false;
var isContour = false;
var isFirstContour = true;

/**
 * Use the beginContour() and endContour() functions to create negative
 * shapes within shapes such as the center of the letter 'O'. beginContour()
 * begins recording vertices for the shape and endContour() stops recording.
 * The vertices that define a negative shape must "wind" in the opposite
 * direction from the exterior shape. First draw vertices for the exterior
 * clockwise order, then for internal shapes, draw vertices
 * shape in counter-clockwise.
 * <br><br>
 * These functions can only be used within a beginShape()/endShape() pair and
 * transformations such as translate(), rotate(), and scale() do not work
 * within a beginContour()/endContour() pair. It is also not possible to use
 * other shapes, such as ellipse() or rect() within.
 *
 * @method beginContour
 * @return {Object} the p5 object
 * @example
 * <div>
 * <code>
 * translate(50, 50);
 * stroke(255, 0, 0);
 * beginShape();
 * // Exterior part of shape, clockwise winding
 * vertex(-40, -40);
 * vertex(40, -40);
 * vertex(40, 40);
 * vertex(-40, 40);
 * // Interior part of shape, counter-clockwise winding
 * beginContour();
 * vertex(-20, -20);
 * vertex(-20, 20);
 * vertex(20, 20);
 * vertex(20, -20);
 * endContour();
 * endShape(CLOSE);
 * </code>
 * </div>
 *
 * @alt
 * white rect and smaller grey rect with red outlines in center of canvas.
 *
 */
p5.prototype.beginContour = function() {
  contourVertices = [];
  isContour = true;
  return this;
};

/**
 * Using the beginShape() and endShape() functions allow creating more
 * complex forms. beginShape() begins recording vertices for a shape and
 * endShape() stops recording. The value of the kind parameter tells it which
 * types of shapes to create from the provided vertices. With no mode
 * specified, the shape can be any irregular polygon.
 * <br><br>
 * The parameters available for beginShape() are POINTS, LINES, TRIANGLES,
 * TRIANGLE_FAN, TRIANGLE_STRIP, QUADS, and QUAD_STRIP. After calling the
 * beginShape() function, a series of vertex() commands must follow. To stop
 * drawing the shape, call endShape(). Each shape will be outlined with the
 * current stroke color and filled with the fill color.
 * <br><br>
 * Transformations such as translate(), rotate(), and scale() do not work
 * within beginShape(). It is also not possible to use other shapes, such as
 * ellipse() or rect() within beginShape().
 *
 * @method beginShape
 * @param  {Constant} kind either POINTS, LINES, TRIANGLES, TRIANGLE_FAN
 *                                TRIANGLE_STRIP, QUADS, or QUAD_STRIP
 * @return {Object}               the p5 object
 * @example
 * <div>
 * <code>
 * beginShape();
 * vertex(30, 20);
 * vertex(85, 20);
 * vertex(85, 75);
 * vertex(30, 75);
 * endShape(CLOSE);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * // currently not working
 * beginShape(POINTS);
 * vertex(30, 20);
 * vertex(85, 20);
 * vertex(85, 75);
 * vertex(30, 75);
 * endShape();
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * beginShape(LINES);
 * vertex(30, 20);
 * vertex(85, 20);
 * vertex(85, 75);
 * vertex(30, 75);
 * endShape();
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * noFill();
 * beginShape();
 * vertex(30, 20);
 * vertex(85, 20);
 * vertex(85, 75);
 * vertex(30, 75);
 * endShape();
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * noFill();
 * beginShape();
 * vertex(30, 20);
 * vertex(85, 20);
 * vertex(85, 75);
 * vertex(30, 75);
 * endShape(CLOSE);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * beginShape(TRIANGLES);
 * vertex(30, 75);
 * vertex(40, 20);
 * vertex(50, 75);
 * vertex(60, 20);
 * vertex(70, 75);
 * vertex(80, 20);
 * endShape();
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * beginShape(TRIANGLE_STRIP);
 * vertex(30, 75);
 * vertex(40, 20);
 * vertex(50, 75);
 * vertex(60, 20);
 * vertex(70, 75);
 * vertex(80, 20);
 * vertex(90, 75);
 * endShape();
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * beginShape(TRIANGLE_FAN);
 * vertex(57.5, 50);
 * vertex(57.5, 15);
 * vertex(92, 50);
 * vertex(57.5, 85);
 * vertex(22, 50);
 * vertex(57.5, 15);
 * endShape();
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * beginShape(QUADS);
 * vertex(30, 20);
 * vertex(30, 75);
 * vertex(50, 75);
 * vertex(50, 20);
 * vertex(65, 20);
 * vertex(65, 75);
 * vertex(85, 75);
 * vertex(85, 20);
 * endShape();
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * beginShape(QUAD_STRIP);
 * vertex(30, 20);
 * vertex(30, 75);
 * vertex(50, 20);
 * vertex(50, 75);
 * vertex(65, 20);
 * vertex(65, 75);
 * vertex(85, 20);
 * vertex(85, 75);
 * endShape();
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * beginShape();
 * vertex(20, 20);
 * vertex(40, 20);
 * vertex(40, 40);
 * vertex(60, 40);
 * vertex(60, 60);
 * vertex(20, 60);
 * endShape(CLOSE);
 * </code>
 * </div>
  * @alt
 * white square-shape with black outline in middle-right of canvas.
 * 4 black points in a square shape in middle-right of canvas.
 * 2 horizontal black lines. In the top-right and bottom-right of canvas.
 * 3 line shape with horizontal on top, vertical in middle and horizontal bottom.
 * square line shape in middle-right of canvas.
 * 2 white triangle shapes mid-right canvas. left one pointing up and right down.
 * 5 horizontal interlocking and alternating white triangles in mid-right canvas.
 * 4 interlocking white triangles in 45 degree rotated square-shape.
 * 2 white rectangle shapes in mid-right canvas. Both 20x55.
 * 3 side-by-side white rectangles center rect is smaller in mid-right canvas.
 * Thick white l-shape with black outline mid-top-left of canvas.
 *
 */
p5.prototype.beginShape = function(kind) {
  if (kind === constants.POINTS ||
    kind === constants.LINES ||
    kind === constants.TRIANGLES ||
    kind === constants.TRIANGLE_FAN ||
    kind === constants.TRIANGLE_STRIP ||
    kind === constants.QUADS ||
    kind === constants.QUAD_STRIP) {
    shapeKind = kind;
  } else {
    shapeKind = null;
  }
  if(this._renderer.isP3D){
    this._renderer.beginShape(kind);
  } else {
    vertices = [];
    contourVertices = [];
  }
  return this;
};

/**
 * Specifies vertex coordinates for Bezier curves. Each call to
 * bezierVertex() defines the position of two control points and
 * one anchor point of a Bezier curve, adding a new segment to a
 * line or shape.
 * <br><br>
 * The first time bezierVertex() is used within a
 * beginShape() call, it must be prefaced with a call to vertex()
 * to set the first anchor point. This function must be used between
 * beginShape() and endShape() and only when there is no MODE
 * parameter specified to beginShape().
 *
 * @method bezierVertex
 * @param  {Number} x2 x-coordinate for the first control point
 * @param  {Number} y2 y-coordinate for the first control point
 * @param  {Number} x3 x-coordinate for the second control point
 * @param  {Number} y3 y-coordinate for the second control point
 * @param  {Number} x4 x-coordinate for the anchor point
 * @param  {Number} y4 y-coordinate for the anchor point
 * @return {Object}    the p5 object
 * @example
 * <div>
 * <code>
 * noFill();
 * beginShape();
 * vertex(30, 20);
 * bezierVertex(80, 0, 80, 75, 30, 75);
 * endShape();
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * beginShape();
 * vertex(30, 20);
 * bezierVertex(80, 0, 80, 75, 30, 75);
 * bezierVertex(50, 80, 60, 25, 30, 20);
 * endShape();
 * </code>
 * </div>
 *
 * @alt
 * crescent-shaped line in middle of canvas. Points facing left.
 * white crescent shape in middle of canvas. Points facing left.
 *
 */
p5.prototype.bezierVertex = function(x2, y2, x3, y3, x4, y4) {
  if (vertices.length === 0) {
    throw 'vertex() must be used once before calling bezierVertex()';
  } else {
    isBezier = true;
    var vert = [];
    for (var i = 0; i < arguments.length; i++) {
      vert[i] = arguments[i];
    }
    vert.isVert = false;
    if (isContour) {
      contourVertices.push(vert);
    } else {
      vertices.push(vert);
    }
  }
  return this;
};

/**
 * Specifies vertex coordinates for curves. This function may only
 * be used between beginShape() and endShape() and only when there
 * is no MODE parameter specified to beginShape().
 * <br><br>
 * The first and last points in a series of curveVertex() lines will be used to
 * guide the beginning and end of a the curve. A minimum of four
 * points is required to draw a tiny curve between the second and
 * third points. Adding a fifth point with curveVertex() will draw
 * the curve between the second, third, and fourth points. The
 * curveVertex() function is an implementation of Catmull-Rom
 * splines.
 *
 * @method curveVertex
 * @param {Number} x x-coordinate of the vertex
 * @param {Number} y y-coordinate of the vertex
 * @return {Object} the p5 object
 * @example
 * <div>
 * <code>
 * noFill();
 * beginShape();
 * curveVertex(84,  91);
 * curveVertex(84,  91);
 * curveVertex(68,  19);
 * curveVertex(21,  17);
 * curveVertex(32, 100);
 * curveVertex(32, 100);
 * endShape();
 * </code>
 * </div>
 *
 * @alt
 * Upside-down u-shape line, mid canvas. left point extends beyond canvas view.
 *
 */
p5.prototype.curveVertex = function(x,y) {
  isCurve = true;
  this.vertex(x, y);
  return this;
};

/**
 * Use the beginContour() and endContour() functions to create negative
 * shapes within shapes such as the center of the letter 'O'. beginContour()
 * begins recording vertices for the shape and endContour() stops recording.
 * The vertices that define a negative shape must "wind" in the opposite
 * direction from the exterior shape. First draw vertices for the exterior
 * clockwise order, then for internal shapes, draw vertices
 * shape in counter-clockwise.
 * <br><br>
 * These functions can only be used within a beginShape()/endShape() pair and
 * transformations such as translate(), rotate(), and scale() do not work
 * within a beginContour()/endContour() pair. It is also not possible to use
 * other shapes, such as ellipse() or rect() within.
 *
 * @method endContour
 * @return {Object} the p5 object
 * @example
 * <div>
 * <code>
 * translate(50, 50);
 * stroke(255, 0, 0);
 * beginShape();
 * // Exterior part of shape, clockwise winding
 * vertex(-40, -40);
 * vertex(40, -40);
 * vertex(40, 40);
 * vertex(-40, 40);
 * // Interior part of shape, counter-clockwise winding
 * beginContour();
 * vertex(-20, -20);
 * vertex(-20, 20);
 * vertex(20, 20);
 * vertex(20, -20);
 * endContour();
 * endShape(CLOSE);
 * </code>
 * </div>
 *
 * @alt
 * white rect and smaller grey rect with red outlines in center of canvas.
 *
 */
p5.prototype.endContour = function() {
  var vert = contourVertices[0].slice(); // copy all data
  vert.isVert = contourVertices[0].isVert;
  vert.moveTo = false;
  contourVertices.push(vert);

  // prevent stray lines with multiple contours
  if (isFirstContour) {
    vertices.push(vertices[0]);
    isFirstContour = false;
  }

  for (var i = 0; i < contourVertices.length; i++) {
    vertices.push(contourVertices[i]);
  }
  return this;
};

/**
 * The endShape() function is the companion to beginShape() and may only be
 * called after beginShape(). When endshape() is called, all of image data
 * defined since the previous call to beginShape() is written into the image
 * buffer. The constant CLOSE as the value for the MODE parameter to close
 * the shape (to connect the beginning and the end).
 *
 * @method endShape
 * @param  {Constant} mode use CLOSE to close the shape
 * @return {Object}               the p5 object
 * @example
 * <div>
 * <code>
 * noFill();
 *
 * beginShape();
 * vertex(20, 20);
 * vertex(45, 20);
 * vertex(45, 80);
 * endShape(CLOSE);
 *
 * beginShape();
 * vertex(50, 20);
 * vertex(75, 20);
 * vertex(75, 80);
 * endShape();
 * </code>
 * </div>
 *
 * @alt
 * Triangle line shape with smallest interior angle on bottom and upside-down L.
 *
 */
p5.prototype.endShape = function(mode) {
  if(this._renderer.isP3D){
    this._renderer.endShape(mode, isCurve, isBezier,
      isQuadratic, isContour, shapeKind);
  }else{
    if (vertices.length === 0) { return this; }
    if (!this._renderer._doStroke && !this._renderer._doFill) { return this; }

    var closeShape = mode === constants.CLOSE;

    // if the shape is closed, the first element is also the last element
    if (closeShape && !isContour) {
      vertices.push(vertices[0]);
    }

    this._renderer.endShape(mode, vertices, isCurve, isBezier,
      isQuadratic, isContour, shapeKind);

    // Reset some settings
    isCurve = false;
    isBezier = false;
    isQuadratic = false;
    isContour = false;
    isFirstContour = true;

    // If the shape is closed, the first element was added as last element.
    // We must remove it again to prevent the list of vertices from growing
    // over successive calls to endShape(CLOSE)
    if (closeShape) {
      vertices.pop();
    }
  }
  return this;
};

/**
 * Specifies vertex coordinates for quadratic Bezier curves. Each call to
 * quadraticVertex() defines the position of one control points and one
 * anchor point of a Bezier curve, adding a new segment to a line or shape.
 * The first time quadraticVertex() is used within a beginShape() call, it
 * must be prefaced with a call to vertex() to set the first anchor point.
 * This function must be used between beginShape() and endShape() and only
 * when there is no MODE parameter specified to beginShape().
 *
 * @method quadraticVertex
 * @param  {Number} cx x-coordinate for the control point
 * @param  {Number} cy y-coordinate for the control point
 * @param  {Number} x3 x-coordinate for the anchor point
 * @param  {Number} y3 y-coordinate for the anchor point
 * @return {Object}    the p5 object
 * @example
 * <div>
 * <code>
 * noFill();
 * strokeWeight(4);
 * beginShape();
 * vertex(20, 20);
 * quadraticVertex(80, 20, 50, 50);
 * endShape();
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * noFill();
 * strokeWeight(4);
 * beginShape();
 * vertex(20, 20);
 * quadraticVertex(80, 20, 50, 50);
 * quadraticVertex(20, 80, 80, 80);
 * vertex(80, 60);
 * endShape();
 * </code>
 * </div>
 *
 * @alt
 * arched-shaped black line with 4 pixel thick stroke weight.
 * backwards s-shaped black line with 4 pixel thick stroke weight.
 *
 */
p5.prototype.quadraticVertex = function(cx, cy, x3, y3) {
  //if we're drawing a contour, put the points into an
  // array for inside drawing
  if(this._contourInited) {
    var pt = {};
    pt.x = cx;
    pt.y = cy;
    pt.x3 = x3;
    pt.y3 = y3;
    pt.type = constants.QUADRATIC;
    this._contourVertices.push(pt);

    return this;
  }
  if (vertices.length > 0) {
    isQuadratic = true;
    var vert = [];
    for (var i = 0; i < arguments.length; i++) {
      vert[i] = arguments[i];
    }
    vert.isVert = false;
    if (isContour) {
      contourVertices.push(vert);
    } else {
      vertices.push(vert);
    }
  } else {
    throw 'vertex() must be used once before calling quadraticVertex()';
  }
  return this;
};

/**
 * All shapes are constructed by connecting a series of vertices. vertex()
 * is used to specify the vertex coordinates for points, lines, triangles,
 * quads, and polygons. It is used exclusively within the beginShape() and
 * endShape() functions.
 *
 * @method vertex
 * @param  {Number} x x-coordinate of the vertex
 * @param  {Number} y y-coordinate of the vertex
 * @return {Object}   the p5 object
 * @example
 * <div>
 * <code>
 * beginShape(POINTS);
 * vertex(30, 20);
 * vertex(85, 20);
 * vertex(85, 75);
 * vertex(30, 75);
 * endShape();
 * </code>
 * </div>
 *
 * @alt
 * 4 black points in a square shape in middle-right of canvas.
 *
 */
p5.prototype.vertex = function(x, y, moveTo) {
  if(this._renderer.isP3D){
    this._renderer.vertex(x, y, moveTo);
  }else{
    var vert = [];
    vert.isVert = true;
    vert[0] = x;
    vert[1] = y;
    vert[2] = 0;
    vert[3] = 0;
    vert[4] = 0;
    vert[5] = this._renderer._getFill();
    vert[6] = this._renderer._getStroke();

    if (moveTo) {
      vert.moveTo = moveTo;
    }
    if (isContour) {
      if (contourVertices.length === 0) {
        vert.moveTo = true;
      }
      contourVertices.push(vert);
    } else {
      vertices.push(vert);
    }
  }
  return this;
};

module.exports = p5;

},{"./constants":41,"./core":42}],55:[function(_dereq_,module,exports){
/**
 * @module Events
 * @submodule Acceleration
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');

/**
 * The system variable deviceOrientation always contains the orientation of
 * the device. The value of this variable will either be set 'landscape'
 * or 'portrait'. If no data is available it will be set to 'undefined'.
 *
 * @property deviceOrientation
 */
p5.prototype.deviceOrientation = undefined;

/**
 * The system variable accelerationX always contains the acceleration of the
 * device along the x axis. Value is represented as meters per second squared.
 *
 * @property accelerationX
 */
p5.prototype.accelerationX = 0;

/**
 * The system variable accelerationY always contains the acceleration of the
 * device along the y axis. Value is represented as meters per second squared.
 *
 * @property accelerationY
 */
p5.prototype.accelerationY = 0;

/**
 * The system variable accelerationZ always contains the acceleration of the
 * device along the z axis. Value is represented as meters per second squared.
 *
 * @property accelerationZ
 */
p5.prototype.accelerationZ = 0;

/**
 * The system variable pAccelerationX always contains the acceleration of the
 * device along the x axis in the frame previous to the current frame. Value
 * is represented as meters per second squared.
 *
 * @property pAccelerationX
 */
p5.prototype.pAccelerationX = 0;

/**
 * The system variable pAccelerationY always contains the acceleration of the
 * device along the y axis in the frame previous to the current frame. Value
 * is represented as meters per second squared.
 *
 * @property pAccelerationY
 */
p5.prototype.pAccelerationY = 0;

/**
 * The system variable pAccelerationZ always contains the acceleration of the
 * device along the z axis in the frame previous to the current frame. Value
 * is represented as meters per second squared.
 *
 * @property pAccelerationZ
 */
p5.prototype.pAccelerationZ = 0;

/**
 * _updatePAccelerations updates the pAcceleration values
 *
 * @private
 */
p5.prototype._updatePAccelerations = function(){
  this._setProperty('pAccelerationX', this.accelerationX);
  this._setProperty('pAccelerationY', this.accelerationY);
  this._setProperty('pAccelerationZ', this.accelerationZ);
};

/**
 * The system variable rotationX always contains the rotation of the
 * device along the x axis. Value is represented as 0 to +/-180 degrees.
 * <br><br>
 * Note: The order the rotations are called is important, ie. if used
 * together, it must be called in the order Z-X-Y or there might be
 * unexpected behaviour.
 *
 * @example
 * <div>
 * <code>
 * function setup(){
 *   createCanvas(100, 100, WEBGL);
 * }
 *
 * function draw(){
 *   background(200);
 *   //rotateZ(radians(rotationZ));
 *   rotateX(radians(rotationX));
 *   //rotateY(radians(rotationY));
 *   box(200, 200, 200);
 * }
 * </code>
 * </div>
 *
 * @property rotationX
 *
 * @alt
 * red horizontal line right, green vertical line bottom. black background.
 *
 */
p5.prototype.rotationX = 0;

/**
 * The system variable rotationY always contains the rotation of the
 * device along the y axis. Value is represented as 0 to +/-90 degrees.
 * <br><br>
 * Note: The order the rotations are called is important, ie. if used
 * together, it must be called in the order Z-X-Y or there might be
 * unexpected behaviour.
 *
 * @example
 * <div>
 * <code>
 * function setup(){
 *   createCanvas(100, 100, WEBGL);
 * }
 *
 * function draw(){
 *   background(200);
 *   //rotateZ(radians(rotationZ));
 *   //rotateX(radians(rotationX));
 *   rotateY(radians(rotationY));
 *   box(200, 200, 200);
 * }
 * </code>
 * </div>
 *
 * @property rotationY
 *
 * @alt
 * red horizontal line right, green vertical line bottom. black background.
 */
p5.prototype.rotationY = 0;

/**
 * The system variable rotationZ always contains the rotation of the
 * device along the z axis. Value is represented as 0 to 359 degrees.
 * <br><br>
 * Unlike rotationX and rotationY, this variable is available for devices
 * with a built-in compass only.
 * <br><br>
 * Note: The order the rotations are called is important, ie. if used
 * together, it must be called in the order Z-X-Y or there might be
 * unexpected behaviour.
 *
 * @example
 * <div>
 * <code>
 * function setup(){
 *   createCanvas(100, 100, WEBGL);
 * }
 *
 * function draw(){
 *   background(200);
 *   rotateZ(radians(rotationZ));
 *   //rotateX(radians(rotationX));
 *   //rotateY(radians(rotationY));
 *   box(200, 200, 200);
 * }
 * </code>
 * </div>
 *
 * @property rotationZ
 *
 * @alt
 * red horizontal line right, green vertical line bottom. black background.
 */
p5.prototype.rotationZ = 0;

/**
 * The system variable pRotationX always contains the rotation of the
 * device along the x axis in the frame previous to the current frame. Value
 * is represented as 0 to +/-180 degrees.
 * <br><br>
 * pRotationX can also be used with rotationX to determine the rotate
 * direction of the device along the X-axis.
 * @example
 * <div class='norender'>
 * <code>
 * // A simple if statement looking at whether
 * // rotationX - pRotationX < 0 is true or not will be
 * // sufficient for determining the rotate direction
 * // in most cases.
 *
 * // Some extra logic is needed to account for cases where
 * // the angles wrap around.
 * var rotateDirection = 'clockwise';
 *
 * // Simple range conversion to make things simpler.
 * // This is not absolutely neccessary but the logic
 * // will be different in that case.
 *
 * var rX = rotationX + 180;
 * var pRX = pRotationX + 180;
 *
 * if ((rX - pRX > 0 && rX - pRX < 270)|| rX - pRX < -270){
 *   rotateDirection = 'clockwise';
 * } else if (rX - pRX < 0 || rX - pRX > 270){
 *   rotateDirection = 'counter-clockwise';
 * }
 * </code>
 * </div>
 *
 * @alt
 * no image to display.
 *
 *
 * @property pRotationX
 */
p5.prototype.pRotationX = 0;

/**
 * The system variable pRotationY always contains the rotation of the
 * device along the y axis in the frame previous to the current frame. Value
 * is represented as 0 to +/-90 degrees.
 * <br><br>
 * pRotationY can also be used with rotationY to determine the rotate
 * direction of the device along the Y-axis.
 * @example
 * <div class='norender'>
 * <code>
 * // A simple if statement looking at whether
 * // rotationY - pRotationY < 0 is true or not will be
 * // sufficient for determining the rotate direction
 * // in most cases.
 *
 * // Some extra logic is needed to account for cases where
 * // the angles wrap around.
 * var rotateDirection = 'clockwise';
 *
 * // Simple range conversion to make things simpler.
 * // This is not absolutely neccessary but the logic
 * // will be different in that case.
 *
 * var rY = rotationY + 180;
 * var pRY = pRotationY + 180;
 *
 * if ((rY - pRY > 0 && rY - pRY < 270)|| rY - pRY < -270){
 *   rotateDirection = 'clockwise';
 * } else if (rY - pRY < 0 || rY - pRY > 270){
 *   rotateDirection = 'counter-clockwise';
 * }
 * </code>
 * </div>
 *
 * @alt
 * no image to display.
 *
 *
 * @property pRotationY
 */
p5.prototype.pRotationY = 0;

/**
 * The system variable pRotationZ always contains the rotation of the
 * device along the z axis in the frame previous to the current frame. Value
 * is represented as 0 to 359 degrees.
 * <br><br>
 * pRotationZ can also be used with rotationZ to determine the rotate
 * direction of the device along the Z-axis.
 * @example
 * <div class='norender'>
 * <code>
 * // A simple if statement looking at whether
 * // rotationZ - pRotationZ < 0 is true or not will be
 * // sufficient for determining the rotate direction
 * // in most cases.
 *
 * // Some extra logic is needed to account for cases where
 * // the angles wrap around.
 * var rotateDirection = 'clockwise';
 *
 * if ((rotationZ - pRotationZ > 0 &&
 *   rotationZ - pRotationZ < 270)||
 *   rotationZ - pRotationZ < -270){
 *
 *   rotateDirection = 'clockwise';
 *
 * } else if (rotationZ - pRotationZ < 0 ||
 *   rotationZ - pRotationZ > 270){
 *
 *   rotateDirection = 'counter-clockwise';
 *
 * }
 * </code>
 * </div>
 *
 * @alt
 * no image to display.
 *
 *
 * @property pRotationZ
 */
p5.prototype.pRotationZ = 0;

var startAngleX = 0;
var startAngleY = 0;
var startAngleZ = 0;

var rotateDirectionX = 'clockwise';
var rotateDirectionY = 'clockwise';
var rotateDirectionZ = 'clockwise';

var pRotateDirectionX;
var pRotateDirectionY;
var pRotateDirectionZ;

p5.prototype._updatePRotations = function(){
  this._setProperty('pRotationX', this.rotationX);
  this._setProperty('pRotationY', this.rotationY);
  this._setProperty('pRotationZ', this.rotationZ);
};

p5.prototype.turnAxis = undefined;

var move_threshold = 0.5;
var shake_threshold = 30;

/**
 * The setMoveThreshold() function is used to set the movement threshold for
 * the deviceMoved() function. The default threshold is set to 0.5.
 *
 * @method setMoveThreshold
 * @param {number} value The threshold value
 */
p5.prototype.setMoveThreshold = function(val){
  if(typeof val === 'number'){
    move_threshold = val;
  }
};

/**
 * The setShakeThreshold() function is used to set the movement threshold for
 * the deviceShaken() function. The default threshold is set to 30.
 *
 * @method setShakeThreshold
 * @param {number} value The threshold value
 */
p5.prototype.setShakeThreshold = function(val){
  if(typeof val === 'number'){
    shake_threshold = val;
  }
};

/**
 * The deviceMoved() function is called when the device is moved by more than
 * the threshold value along X, Y or Z axis. The default threshold is set to
 * 0.5.
 * @method deviceMoved
 * @example
 * <div class="norender">
 * <code>
 * // Run this example on a mobile device
 * // Move the device around
 * // to change the value.
 *
 * var value = 0;
 * function draw() {
 *   fill(value);
 *   rect(25, 25, 50, 50);
 * }
 * function deviceMoved() {
 *   value = value + 5;
 *   if (value > 255) {
 *     value = 0;
 *   }
 * }
 * </code>
 * </div>
 *
 * @alt
 * 50x50 black rect in center of canvas. turns white on mobile when device moves
 *
 */

/**
 * The deviceTurned() function is called when the device rotates by
 * more than 90 degrees continuously.
 * <br><br>
 * The axis that triggers the deviceTurned() method is stored in the turnAxis
 * variable. The deviceTurned() method can be locked to trigger on any axis:
 * X, Y or Z by comparing the turnAxis variable to 'X', 'Y' or 'Z'.
 *
 * @method deviceTurned
 * @example
 * <div class="norender">
 * <code>
 * // Run this example on a mobile device
 * // Rotate the device by 90 degrees
 * // to change the value.
 *
 * var value = 0;
 * function draw() {
 *   fill(value);
 *   rect(25, 25, 50, 50);
 * }
 * function deviceTurned() {
 *   if (value == 0){
 *     value = 255
 *   } else if (value == 255) {
 *     value = 0;
 *   }
 * }
 * </code>
 * </div>
 * <div>
 * <code>
 * // Run this example on a mobile device
 * // Rotate the device by 90 degrees in the
 * // X-axis to change the value.
 *
 * var value = 0;
 * function draw() {
 *   fill(value);
 *   rect(25, 25, 50, 50);
 * }
 * function deviceTurned() {
 *   if (turnAxis == 'X'){
 *     if (value == 0){
 *       value = 255
 *     } else if (value == 255) {
 *       value = 0;
 *     }
 *   }
 * }
 * </code>
 * </div>
 *
 * @alt
 * 50x50 black rect in center of canvas. turns white on mobile when device turns
 * 50x50 black rect in center of canvas. turns white on mobile when x-axis turns
 *
 */

/**
 * The deviceShaken() function is called when the device total acceleration
 * changes of accelerationX and accelerationY values is more than
 * the threshold value. The default threshold is set to 30.
 * @method deviceShaken
 * @example
 * <div class="norender">
 * <code>
 * // Run this example on a mobile device
 * // Shake the device to change the value.
 *
 * var value = 0;
 * function draw() {
 *   fill(value);
 *   rect(25, 25, 50, 50);
 * }
 * function deviceShaken() {
 *   value = value + 5;
 *   if (value > 255) {
 *     value = 0;
 *   }
 * }
 * </code>
 * </div>
 *
 * @alt
 * 50x50 black rect in center of canvas. turns white on mobile when device shakes
 *
 */

p5.prototype._ondeviceorientation = function (e) {
  this._updatePRotations();
  this._setProperty('rotationX', e.beta);
  this._setProperty('rotationY', e.gamma);
  this._setProperty('rotationZ', e.alpha);
  this._handleMotion();
};
p5.prototype._ondevicemotion = function (e) {
  this._updatePAccelerations();
  this._setProperty('accelerationX', e.acceleration.x * 2);
  this._setProperty('accelerationY', e.acceleration.y * 2);
  this._setProperty('accelerationZ', e.acceleration.z * 2);
  this._handleMotion();
};
p5.prototype._handleMotion = function() {
  if (window.orientation === 90 || window.orientation === -90) {
    this._setProperty('deviceOrientation', 'landscape');
  } else if (window.orientation === 0) {
    this._setProperty('deviceOrientation', 'portrait');
  } else if (window.orientation === undefined) {
    this._setProperty('deviceOrientation', 'undefined');
  }
  var deviceMoved = this.deviceMoved || window.deviceMoved;
  if (typeof deviceMoved === 'function') {
    if (Math.abs(this.accelerationX - this.pAccelerationX) > move_threshold ||
      Math.abs(this.accelerationY - this.pAccelerationY) > move_threshold ||
      Math.abs(this.accelerationZ - this.pAccelerationZ) > move_threshold) {
      deviceMoved();
    }
  }
  var deviceTurned = this.deviceTurned || window.deviceTurned;
  if (typeof deviceTurned === 'function') {
    // The angles given by rotationX etc is from range -180 to 180.
    // The following will convert them to 0 to 360 for ease of calculation
    // of cases when the angles wrapped around.
    // _startAngleX will be converted back at the end and updated.
    var wRX = this.rotationX + 180;
    var wPRX = this.pRotationX + 180;
    var wSAX = startAngleX + 180;
    if ((wRX - wPRX > 0 && wRX - wPRX < 270)|| wRX - wPRX < -270){
      rotateDirectionX = 'clockwise';
    } else if (wRX - wPRX < 0 || wRX - wPRX > 270){
      rotateDirectionX = 'counter-clockwise';
    }
    if (rotateDirectionX !== pRotateDirectionX){
      wSAX = wRX;
    }
    if (Math.abs(wRX - wSAX) > 90 && Math.abs(wRX - wSAX) < 270){
      wSAX = wRX;
      this._setProperty('turnAxis', 'X');
      deviceTurned();
    }
    pRotateDirectionX = rotateDirectionX;
    startAngleX = wSAX - 180;

    // Y-axis is identical to X-axis except for changing some names.
    var wRY = this.rotationY + 180;
    var wPRY = this.pRotationY + 180;
    var wSAY = startAngleY + 180;
    if ((wRY - wPRY > 0 && wRY - wPRY < 270)|| wRY - wPRY < -270){
      rotateDirectionY = 'clockwise';
    } else if (wRY - wPRY < 0 || wRY - this.pRotationY > 270){
      rotateDirectionY = 'counter-clockwise';
    }
    if (rotateDirectionY !== pRotateDirectionY){
      wSAY = wRY;
    }
    if (Math.abs(wRY - wSAY) > 90 && Math.abs(wRY - wSAY) < 270){
      wSAY = wRY;
      this._setProperty('turnAxis', 'Y');
      deviceTurned();
    }
    pRotateDirectionY = rotateDirectionY;
    startAngleY = wSAY - 180;

    // Z-axis is already in the range 0 to 360
    // so no conversion is needed.
    if ((this.rotationZ - this.pRotationZ > 0 &&
      this.rotationZ - this.pRotationZ < 270)||
      this.rotationZ - this.pRotationZ < -270){
      rotateDirectionZ = 'clockwise';
    } else if (this.rotationZ - this.pRotationZ < 0 ||
      this.rotationZ - this.pRotationZ > 270){
      rotateDirectionZ = 'counter-clockwise';
    }
    if (rotateDirectionZ !== pRotateDirectionZ){
      startAngleZ = this.rotationZ;
    }
    if (Math.abs(this.rotationZ - startAngleZ) > 90 &&
      Math.abs(this.rotationZ - startAngleZ) < 270){
      startAngleZ = this.rotationZ;
      this._setProperty('turnAxis', 'Z');
      deviceTurned();
    }
    pRotateDirectionZ = rotateDirectionZ;
    this._setProperty('turnAxis', undefined);
  }
  var deviceShaken = this.deviceShaken || window.deviceShaken;
  if (typeof deviceShaken === 'function') {
    var accelerationChangeX;
    var accelerationChangeY;
    // Add accelerationChangeZ if acceleration change on Z is needed
    if (this.pAccelerationX !== null) {
      accelerationChangeX = Math.abs(this.accelerationX - this.pAccelerationX);
      accelerationChangeY = Math.abs(this.accelerationY - this.pAccelerationY);
    }
    if (accelerationChangeX + accelerationChangeY > shake_threshold) {
      deviceShaken();
    }
  }
};


module.exports = p5;

},{"../core/core":42}],56:[function(_dereq_,module,exports){
/**
 * @module Events
 * @submodule Keyboard
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');

/**
 * Holds the key codes of currently pressed keys.
 * @private
 */
var downKeys = {};

/**
 * The boolean system variable keyIsPressed is true if any key is pressed
 * and false if no keys are pressed.
 *
 * @property keyIsPressed
 * @example
 * <div>
 * <code>
 * var value = 0;
 * function draw() {
 *   if (keyIsPressed === true) {
 *     fill(0);
 *   } else {
 *     fill(255);
 *   }
 *   rect(25, 25, 50, 50);
 * }
 * </code>
 * </div>
 *
 * @alt
 * 50x50 white rect that turns black on keypress.
 *
 */
p5.prototype.isKeyPressed = false;
p5.prototype.keyIsPressed = false; // khan

/**
 * The system variable key always contains the value of the most recent
 * key on the keyboard that was typed. To get the proper capitalization, it
 * is best to use it within keyTyped(). For non-ASCII keys, use the keyCode
 * variable.
 *
 * @property key
 * @example
 * <div><code>
 * // Click any key to display it!
 * // (Not Guaranteed to be Case Sensitive)
 * function setup() {
 *   fill(245, 123, 158);
 *   textSize(50);
 * }
 *
 * function draw() {
 *   background(200);
 *   text(key, 33,65); // Display last key pressed.
 * }
 * </div></code>
 *
 * @alt
 * canvas displays any key value that is pressed in pink font.
 *
 */
p5.prototype.key = '';

/**
 * The variable keyCode is used to detect special keys such as BACKSPACE,
 * DELETE, ENTER, RETURN, TAB, ESCAPE, SHIFT, CONTROL, OPTION, ALT, UP_ARROW,
 * DOWN_ARROW, LEFT_ARROW, RIGHT_ARROW.
 * You can also check for custom keys by looking up the keyCode of any key
 * on a site like this: <a href="http://keycode.info/">keycode.info</a>.
 *
 * @property keyCode
 * @example
 * <div><code>
 * var fillVal = 126;
 * function draw() {
 *   fill(fillVal);
 *   rect(25, 25, 50, 50);
 * }
 *
 * function keyPressed() {
 *   if (keyCode == UP_ARROW) {
 *     fillVal = 255;
 *   } else if (keyCode == DOWN_ARROW) {
 *     fillVal = 0;
 *   }
 *   return false; // prevent default
 * }
 * </code></div>
 *
 * @alt
 * Grey rect center. turns white when up arrow pressed and black when down
 *
 */
p5.prototype.keyCode = 0;

/**
 * The keyPressed() function is called once every time a key is pressed. The
 * keyCode for the key that was pressed is stored in the keyCode variable.
 * <br><br>
 * For non-ASCII keys, use the keyCode variable. You can check if the keyCode
 * equals BACKSPACE, DELETE, ENTER, RETURN, TAB, ESCAPE, SHIFT, CONTROL,
 * OPTION, ALT, UP_ARROW, DOWN_ARROW, LEFT_ARROW, RIGHT_ARROW.
 * <br><br>
 * For ASCII keys that was pressed is stored in the key variable. However, it
 * does not distinguish between uppercase and lowercase. For this reason, it
 * is recommended to use keyTyped() to read the key variable, in which the
 * case of the variable will be distinguished.
 * <br><br>
 * Because of how operating systems handle key repeats, holding down a key
 * may cause multiple calls to keyTyped() (and keyReleased() as well). The
 * rate of repeat is set by the operating system and how each computer is
 * configured.<br><br>
 * Browsers may have different default
 * behaviors attached to various key events. To prevent any default
 * behavior for this event, add "return false" to the end of the method.
 *
 * @method keyPressed
 * @example
 * <div>
 * <code>
 * var value = 0;
 * function draw() {
 *   fill(value);
 *   rect(25, 25, 50, 50);
 * }
 * function keyPressed() {
 *   if (value === 0) {
 *     value = 255;
 *   } else {
 *     value = 0;
 *   }
 * }
 * </code>
 * </div>
 * <div>
 * <code>
 * var value = 0;
 * function draw() {
 *   fill(value);
 *   rect(25, 25, 50, 50);
 * }
 * function keyPressed() {
 *   if (keyCode === LEFT_ARROW) {
 *     value = 255;
 *   } else if (keyCode === RIGHT_ARROW) {
 *     value = 0;
 *   }
 * }
 * </code>
 * </div>
 * <div class="norender">
 * <code>
 * function keyPressed(){
 *   // Do something
 *   return false; // prevent any default behaviour
 * }
 * </code>
 *
 * @alt
 * black rect center. turns white when key pressed and black when released
 * black rect center. turns white when left arrow pressed and black when right.
 *
 * </div>
 */
p5.prototype._onkeydown = function (e) {
  if (downKeys[e.which]) { // prevent multiple firings
    return;
  }
  this._setProperty('isKeyPressed', true);
  this._setProperty('keyIsPressed', true);
  this._setProperty('keyCode', e.which);
  downKeys[e.which] = true;
  var key = String.fromCharCode(e.which);
  if (!key) {
    key = e.which;
  }
  this._setProperty('key', key);
  var keyPressed = this.keyPressed || window.keyPressed;
  if (typeof keyPressed === 'function' && !e.charCode) {
    var executeDefault = keyPressed(e);
    if(executeDefault === false) {
      e.preventDefault();
    }
  }
};
/**
 * The keyReleased() function is called once every time a key is released.
 * See key and keyCode for more information.<br><br>
 * Browsers may have different default
 * behaviors attached to various key events. To prevent any default
 * behavior for this event, add "return false" to the end of the method.
 *
 * @method keyReleased
 * @example
 * <div>
 * <code>
 * var value = 0;
 * function draw() {
 *   fill(value);
 *   rect(25, 25, 50, 50);
 * }
 * function keyReleased() {
 *   if (value === 0) {
 *     value = 255;
 *   } else {
 *     value = 0;
 *   }
 *   return false; // prevent any default behavior
 * }
 * </code>
 * </div>
 *
 * @alt
 * black rect center. turns white when key pressed and black when pressed again
 *
 */
p5.prototype._onkeyup = function (e) {
  var keyReleased = this.keyReleased || window.keyReleased;
  downKeys[e.which] = false;

  if(!areDownKeys()) {
    this._setProperty('isKeyPressed', false);
    this._setProperty('keyIsPressed', false);
  }

  this._setProperty('_lastKeyCodeTyped', null);

  var key = String.fromCharCode(e.which);
  if (!key) {
    key = e.which;
  }
  this._setProperty('key', key);
  this._setProperty('keyCode', e.which);
  if (typeof keyReleased === 'function') {
    var executeDefault = keyReleased(e);
    if(executeDefault === false) {
      e.preventDefault();
    }
  }
};

/**
 * The keyTyped() function is called once every time a key is pressed, but
 * action keys such as Ctrl, Shift, and Alt are ignored. The most recent
 * key pressed will be stored in the key variable.
 * <br><br>
 * Because of how operating systems handle key repeats, holding down a key
 * will cause multiple calls to keyTyped() (and keyReleased() as well). The
 * rate of repeat is set by the operating system and how each computer is
 * configured.<br><br>
 * Browsers may have different default behaviors attached to various key
 * events. To prevent any default behavior for this event, add "return false"
 * to the end of the method.
 *
 * @method keyTyped
 * @example
 * <div>
 * <code>
 * var value = 0;
 * function draw() {
 *   fill(value);
 *   rect(25, 25, 50, 50);
 * }
 * function keyTyped() {
 *   if (key === 'a') {
 *     value = 255;
 *   } else if (key === 'b') {
 *     value = 0;
 *   }
 *   // uncomment to prevent any default behavior
 *   // return false;
 * }
 * </code>
 * </div>
 *
 * @alt
 * black rect center. turns white when 'a' key typed and black when 'b' pressed
 *
 */
p5.prototype._onkeypress = function (e) {
  if (e.which === this._lastKeyCodeTyped) { // prevent multiple firings
    return;
  }
  this._setProperty('keyCode', e.which);
  this._setProperty('_lastKeyCodeTyped', e.which); // track last keyCode
  this._setProperty('key', String.fromCharCode(e.which));
  var keyTyped = this.keyTyped || window.keyTyped;
  if (typeof keyTyped === 'function') {
    var executeDefault = keyTyped(e);
    if(executeDefault === false) {
      e.preventDefault();
    }
  }
};
/**
 * The onblur function is called when the user is no longer focused
 * on the p5 element. Because the keyup events will not fire if the user is
 * not focused on the element we must assume all keys currently down have
 * been released.
 */
p5.prototype._onblur = function (e) {
  downKeys = {};
};

/**
 * The keyIsDown() function checks if the key is currently down, i.e. pressed.
 * It can be used if you have an object that moves, and you want several keys
 * to be able to affect its behaviour simultaneously, such as moving a
 * sprite diagonally. You can put in any number representing the keyCode of
 * the key, or use any of the variable keyCode names listed
 * <a href="http://p5js.org/reference/#p5/keyCode">here</a>.
 *
 * @method keyIsDown
 * @param {Number}          code The key to check for.
 * @return {Boolean}        whether key is down or not
 * @example
 * <div><code>
 * var x = 100;
 * var y = 100;
 *
 * function setup() {
 *   createCanvas(512, 512);
 * }
 *
 * function draw() {
 *   if (keyIsDown(LEFT_ARROW))
 *     x-=5;
 *
 *   if (keyIsDown(RIGHT_ARROW))
 *     x+=5;
 *
 *   if (keyIsDown(UP_ARROW))
 *     y-=5;
 *
 *   if (keyIsDown(DOWN_ARROW))
 *     y+=5;
 *
 *   clear();
 *   fill(255, 0, 0);
 *   ellipse(x, y, 50, 50);
 * }
 * </code></div>
 *
 * @alt
 * 50x50 red ellipse moves left, right, up and down with arrow presses.
 *
 */
p5.prototype.keyIsDown = function(code) {
  return downKeys[code];
};

/**
 * The checkDownKeys function returns a boolean true if any keys pressed
 * and a false if no keys are currently pressed.

 * Helps avoid instances where a multiple keys are pressed simultaneously and
 * releasing a single key will then switch the
 * keyIsPressed property to true.
 * @private
**/
function areDownKeys() {
  for (var key in downKeys) {
    if (downKeys.hasOwnProperty(key) && downKeys[key] === true) {
      return true;
    }
  }
  return false;
}

module.exports = p5;

},{"../core/core":42}],57:[function(_dereq_,module,exports){
/**
 * @module Events
 * @submodule Mouse
 * @for p5
 * @requires core
 * @requires constants
 */


'use strict';

var p5 = _dereq_('../core/core');
var constants = _dereq_('../core/constants');

/*
 * This is a flag which is false until the first time
 * we receive a mouse event. The pmouseX and pmouseY
 * values will match the mouseX and mouseY values until
 * this interaction takes place.
 */
p5.prototype._hasMouseInteracted = false;

/**
 * The system variable mouseX always contains the current horizontal
 * position of the mouse, relative to (0, 0) of the canvas. If touch is
 * used instead of mouse input, mouseX will hold the x value of the most
 * recent touch point.
 *
 * @property mouseX
 *
 * @example
 * <div>
 * <code>
 * // Move the mouse across the canvas
 * function draw() {
 *   background(244, 248, 252);
 *   line(mouseX, 0, mouseX, 100);
 * }
 * </code>
 * </div>
 *
 * @alt
 * horizontal black line moves left and right with mouse x-position
 *
 */
p5.prototype.mouseX = 0;

/**
 * The system variable mouseY always contains the current vertical position
 * of the mouse, relative to (0, 0) of the canvas. If touch is
 * used instead of mouse input, mouseY will hold the y value of the most
 * recent touch point.
 *
 * @property mouseY
 *
 * @example
 * <div>
 * <code>
 * // Move the mouse across the canvas
 * function draw() {
 *   background(244, 248, 252);
 *   line(0, mouseY, 100, mouseY);
 *}
 * </code>
 * </div>
 *
 * @alt
 * vertical black line moves up and down with mouse y-position
 *
 */
p5.prototype.mouseY = 0;

/**
 * The system variable pmouseX always contains the horizontal position of
 * the mouse or finger in the frame previous to the current frame, relative to
 * (0, 0) of the canvas.
 *
 * @property pmouseX
 *
 * @example
 * <div>
 * <code>
 * // Move the mouse across the canvas to leave a trail
 * function setup() {
 *   //slow down the frameRate to make it more visible
 *   frameRate(10);
 * }
 *
 * function draw() {
 *   background(244, 248, 252);
 *   line(mouseX, mouseY, pmouseX, pmouseY);
 *   print(pmouseX + " -> " + mouseX);
 * }
 *
 * </code>
 * </div>
 *
 * @alt
 * line trail is created from cursor movements. faster movement make longer line.
 *
 */
p5.prototype.pmouseX = 0;

/**
 * The system variable pmouseY always contains the vertical position of the
 * mouse or finger in the frame previous to the current frame, relative to
 * (0, 0) of the canvas.
 *
 * @property pmouseY
 *
 * @example
 * <div>
 * <code>
 * function draw() {
 *   background(237, 34, 93);
 *   fill(0);
 *   //draw a square only if the mouse is not moving
 *   if(mouseY == pmouseY && mouseX == pmouseX)
 *     rect(20,20,60,60);
 *
 *   print(pmouseY + " -> " + mouseY);
 * }
 *
 * </code>
 * </div>
 *
 * @alt
 * 60x60 black rect center, fuschia background. rect flickers on mouse movement
 *
 */
p5.prototype.pmouseY = 0;

/**
 * The system variable winMouseX always contains the current horizontal
 * position of the mouse, relative to (0, 0) of the window.
 *
 * @property winMouseX
 *
 * @example
 * <div>
 * <code>
 * var myCanvas;
 *
 * function setup() {
 *   //use a variable to store a pointer to the canvas
 *   myCanvas = createCanvas(100, 100);
 * }
 *
 * function draw() {
 *   background(237, 34, 93);
 *   fill(0);
 *
 *   //move the canvas to the horizontal mouse position
 *   //relative to the window
 *   myCanvas.position(winMouseX+1, windowHeight/2);
 *
 *  //the y of the square is relative to the canvas
 *  rect(20,mouseY,60,60);
 * }
 *
 * </code>
 * </div>
 *
 * @alt
 * 60x60 black rect y moves with mouse y and fuschia canvas moves with mouse x
 *
 */
p5.prototype.winMouseX = 0;

/**
 * The system variable winMouseY always contains the current vertical
 * position of the mouse, relative to (0, 0) of the window.
 *
 * @property winMouseY
 *
 * @example
 * <div>
 * <code>
 *var myCanvas;
 *
 * function setup() {
 *   //use a variable to store a pointer to the canvas
 *   myCanvas = createCanvas(100, 100);
 * }
 *
 * function draw() {
 *   background(237, 34, 93);
 *   fill(0);
 *
 *   //move the canvas to the vertical mouse position
 *   //relative to the window
 *   myCanvas.position(windowWidth/2, winMouseY+1);
 *
 *  //the x of the square is relative to the canvas
 *  rect(mouseX,20,60,60);
 * }
 *
 * </code>
 * </div>
 *
 * @alt
 * 60x60 black rect x moves with mouse x and fuschia canvas y moves with mouse y
 *
 */
p5.prototype.winMouseY = 0;

/**
 * The system variable pwinMouseX always contains the horizontal position
 * of the mouse in the frame previous to the current frame, relative to
 * (0, 0) of the window.
 *
 * @property pwinMouseX
 *
 * @example
 * <div>
 * <code>
 *
 * var myCanvas;
 *
 * function setup() {
 *   //use a variable to store a pointer to the canvas
 *   myCanvas = createCanvas(100, 100);
 *   noStroke();
 *   fill(237, 34, 93);
 *   }
 *
 * function draw() {
 *   clear();
 *   //the difference between previous and
 *   //current x position is the horizontal mouse speed
 *   var speed = abs(winMouseX-pwinMouseX);
 *   //change the size of the circle
 *   //according to the horizontal speed
 *   ellipse(50, 50, 10+speed*5, 10+speed*5);
 *   //move the canvas to the mouse position
 *   myCanvas.position( winMouseX+1, winMouseY+1);
 * }
 *
 * </code>
 * </div>
 *
 * @alt
 * fuschia ellipse moves with mouse x and y. Grows and shrinks with mouse speed
 *
 */
p5.prototype.pwinMouseX = 0;

/**
 * The system variable pwinMouseY always contains the vertical position of
 * the mouse in the frame previous to the current frame, relative to (0, 0)
 * of the window.
 *
 * @property pwinMouseY
 *
 *
 * @example
 * <div>
 * <code>
 *
 * var myCanvas;
 *
 * function setup() {
 *   //use a variable to store a pointer to the canvas
 *   myCanvas = createCanvas(100, 100);
 *   noStroke();
 *   fill(237, 34, 93);
 *   }
 *
 * function draw() {
 *   clear();
 *   //the difference between previous and
 *   //current y position is the vertical mouse speed
 *   var speed = abs(winMouseY-pwinMouseY);
 *   //change the size of the circle
 *   //according to the vertical speed
 *   ellipse(50, 50, 10+speed*5, 10+speed*5);
 *   //move the canvas to the mouse position
 *   myCanvas.position( winMouseX+1, winMouseY+1);
 * }
 *
 * </code>
 * </div>
 *
 * @alt
 * fuschia ellipse moves with mouse x and y. Grows and shrinks with mouse speed
 *
 */
p5.prototype.pwinMouseY = 0;

/**
 * Processing automatically tracks if the mouse button is pressed and which
 * button is pressed. The value of the system variable mouseButton is either
 * LEFT, RIGHT, or CENTER depending on which button was pressed last.
 * Warning: different browsers may track mouseButton differently.
 *
 * @property mouseButton
 *
 * @example
	* <div>
	* <code>
	* function draw() {
	*   background(237, 34, 93);
	*   fill(0);
	*
	*   if (mouseIsPressed) {
	*     if (mouseButton == LEFT)
	*       ellipse(50, 50, 50, 50);
	*     if (mouseButton == RIGHT)
	*       rect(25, 25, 50, 50);
	*     if (mouseButton == CENTER)
	*       triangle(23, 75, 50, 20, 78, 75);
	*   }
	*
	*   print(mouseButton);
	* }
	* </code>
 * </div>
 *
 * @alt
 * 50x50 black ellipse appears on center of fuschia canvas on mouse click/press.
 *
 */
p5.prototype.mouseButton = 0;

/**
 * The boolean system variable mouseIsPressed is true if the mouse is pressed
 * and false if not.
 *
 * @property mouseIsPressed
 *
 * @example
	* <div>
	* <code>
	* function draw() {
	*   background(237, 34, 93);
	*   fill(0);
	*
	*   if (mouseIsPressed)
	*     ellipse(50, 50, 50, 50);
	*   else
	*     rect(25, 25, 50, 50);
	*
	*   print(mouseIsPressed);
	* }
	* </code>
	* </div>
  *
 * @alt
 * black 50x50 rect becomes ellipse with mouse click/press. fuschia background.
 *
 */
p5.prototype.mouseIsPressed = false;

p5.prototype._updateNextMouseCoords = function(e) {
  if(this._curElement !== null && (!e.touches || e.touches.length>0)) {
    var mousePos = getMousePos(this._curElement.elt, this.width, this.height, e);
    this._setProperty('mouseX', mousePos.x);
    this._setProperty('mouseY', mousePos.y);
    this._setProperty('winMouseX', mousePos.winX);
    this._setProperty('winMouseY', mousePos.winY);
  }
  if (!this._hasMouseInteracted) {
    // For first draw, make previous and next equal
    this._updateMouseCoords();
    this._setProperty('_hasMouseInteracted', true);
  }
};

p5.prototype._updateMouseCoords = function() {
  this._setProperty('pmouseX', this.mouseX);
  this._setProperty('pmouseY', this.mouseY);
  this._setProperty('pwinMouseX', this.winMouseX);
  this._setProperty('pwinMouseY', this.winMouseY);
};

function getMousePos(canvas, w, h, evt) {
  if (evt && !evt.clientX) { // use touches if touch and not mouse
    if (evt.touches) {
      evt = evt.touches[0];
    } else if (evt.changedTouches) {
      evt = evt.changedTouches[0];
    }
  }
  var rect = canvas.getBoundingClientRect();
  var sx = canvas.scrollWidth / w;
  var sy = canvas.scrollHeight / h;
  return {
    x: (evt.clientX - rect.left) / sx,
    y: (evt.clientY - rect.top) / sy,
    winX: evt.clientX,
    winY: evt.clientY,
    id: evt.identifier
  };
}

p5.prototype._setMouseButton = function(e) {
  if (e.button === 1) {
    this._setProperty('mouseButton', constants.CENTER);
  } else if (e.button === 2) {
    this._setProperty('mouseButton', constants.RIGHT);
  } else {
    this._setProperty('mouseButton', constants.LEFT);
  }
};

/**
 * The mouseMoved() function is called every time the mouse moves and a mouse
 * button is not pressed.<br><br>
 * Browsers may have different default
 * behaviors attached to various mouse events. To prevent any default
 * behavior for this event, add "return false" to the end of the method.
 *
 * @method mouseMoved
 * @example
 * <div>
 * <code>
 * // Move the mouse across the page
 * // to change its value
 *
 * var value = 0;
 * function draw() {
 *   fill(value);
 *   rect(25, 25, 50, 50);
 * }
 * function mouseMoved() {
 *   value = value + 5;
 *   if (value > 255) {
 *     value = 0;
 *   }
 * }
 * </code>
 * </div>
 *
 * <div class="norender">
 * <code>
 * function mouseMoved() {
 *   ellipse(mouseX, mouseY, 5, 5);
 *   // prevent default
 *   return false;
 * }
 * </code>
 * </div>
 *
 * @alt
 * black 50x50 rect becomes lighter with mouse movements until white then resets
 * no image displayed
 *
 */

/**
 * The mouseDragged() function is called once every time the mouse moves and
 * a mouse button is pressed. If no mouseDragged() function is defined, the
 * touchMoved() function will be called instead if it is defined.<br><br>
 * Browsers may have different default
 * behaviors attached to various mouse events. To prevent any default
 * behavior for this event, add "return false" to the end of the method.
 *
 * @method mouseDragged
 * @example
 * <div>
 * <code>
 * // Drag the mouse across the page
 * // to change its value
 *
 * var value = 0;
 * function draw() {
 *   fill(value);
 *   rect(25, 25, 50, 50);
 * }
 * function mouseDragged() {
 *   value = value + 5;
 *   if (value > 255) {
 *     value = 0;
 *   }
 * }
 * </code>
 * </div>
 *
 * <div class="norender">
 * <code>
 * function mouseDragged() {
 *   ellipse(mouseX, mouseY, 5, 5);
 *   // prevent default
 *   return false;
 * }
 * </code>
 * </div>
 *
 * @alt
 * black 50x50 rect turns lighter with mouse click and drag until white, resets
 * no image displayed
 *
 */
p5.prototype._onmousemove = function(e){
  var context = this._isGlobal ? window : this;
  var executeDefault;
  this._updateNextMouseCoords(e);
  if (!this.mouseIsPressed) {
    if (typeof context.mouseMoved === 'function') {
      executeDefault = context.mouseMoved(e);
      if(executeDefault === false) {
        e.preventDefault();
      }
    }
  }
  else {
    if (typeof context.mouseDragged === 'function') {
      executeDefault = context.mouseDragged(e);
      if(executeDefault === false) {
        e.preventDefault();
      }
    } else if (typeof context.touchMoved === 'function') {
      executeDefault = context.touchMoved(e);
      if(executeDefault === false) {
        e.preventDefault();
      }
    }
  }
};

/**
 * The mousePressed() function is called once after every time a mouse button
 * is pressed. The mouseButton variable (see the related reference entry)
 * can be used to determine which button has been pressed. If no
 * mousePressed() function is defined, the touchStarted() function will be
 * called instead if it is defined.<br><br>
 * Browsers may have different default
 * behaviors attached to various mouse events. To prevent any default
 * behavior for this event, add "return false" to the end of the method.
 *
 * @method mousePressed
 * @example
 * <div>
 * <code>
 * // Click within the image to change
 * // the value of the rectangle
 *
 * var value = 0;
 * function draw() {
 *   fill(value);
 *   rect(25, 25, 50, 50);
 * }
 * function mousePressed() {
 *   if (value == 0) {
 *     value = 255;
 *   } else {
 *     value = 0;
 *   }
 * }
 * </code>
 * </div>
 *
 * <div class="norender">
 * <code>
 * function mousePressed() {
 *   ellipse(mouseX, mouseY, 5, 5);
 *   // prevent default
 *   return false;
 * }
 * </code>
 * </div>
 *
 * @alt
 * black 50x50 rect turns white with mouse click/press.
 * no image displayed
 *
 */
p5.prototype._onmousedown = function(e) {
  var context = this._isGlobal ? window : this;
  var executeDefault;
  this._setProperty('mouseIsPressed', true);
  this._setMouseButton(e);
  this._updateNextMouseCoords(e);
  if (typeof context.mousePressed === 'function') {
    executeDefault = context.mousePressed(e);
    if(executeDefault === false) {
      e.preventDefault();
    }
  } else if (typeof context.touchStarted === 'function') {
    executeDefault = context.touchStarted(e);
    if(executeDefault === false) {
      e.preventDefault();
    }
  }
};

/**
 * The mouseReleased() function is called every time a mouse button is
 * released. If no mouseReleased() function is defined, the touchEnded()
 * function will be called instead if it is defined.<br><br>
 * Browsers may have different default
 * behaviors attached to various mouse events. To prevent any default
 * behavior for this event, add "return false" to the end of the method.
 *
 *
 * @method mouseReleased
 * @example
 * <div>
 * <code>
 * // Click within the image to change
 * // the value of the rectangle
 * // after the mouse has been clicked
 *
 * var value = 0;
 * function draw() {
 *   fill(value);
 *   rect(25, 25, 50, 50);
 * }
 * function mouseReleased() {
 *   if (value == 0) {
 *     value = 255;
 *   } else {
 *     value = 0;
 *   }
 * }
 * </code>
 * </div>
 *
 * <div class="norender">
 * <code>
 * function mouseReleased() {
 *   ellipse(mouseX, mouseY, 5, 5);
 *   // prevent default
 *   return false;
 * }
 * </code>
 * </div>
 *
 * @alt
 * black 50x50 rect turns white with mouse click/press.
 * no image displayed
 *
 */
p5.prototype._onmouseup = function(e) {
  var context = this._isGlobal ? window : this;
  var executeDefault;
  this._setProperty('mouseIsPressed', false);
  if (typeof context.mouseReleased === 'function') {
    executeDefault = context.mouseReleased(e);
    if(executeDefault === false) {
      e.preventDefault();
    }
  } else if (typeof context.touchEnded === 'function') {
    executeDefault = context.touchEnded(e);
    if(executeDefault === false) {
      e.preventDefault();
    }
  }
};

p5.prototype._ondragend = p5.prototype._onmouseup;
p5.prototype._ondragover = p5.prototype._onmousemove;

/**
 * The mouseClicked() function is called once after a mouse button has been
 * pressed and then released.<br><br>
 * Browsers handle clicks differently, so this function is only guaranteed to be
 * run when the left mouse button is clicked. To handle other mouse buttons
 * being pressed or released, see mousePressed() or mouseReleased().<br><br>
 * Browsers may have different default
 * behaviors attached to various mouse events. To prevent any default
 * behavior for this event, add "return false" to the end of the method.
 *
 * @method mouseClicked
 * @example
 * <div>
 * <code>
 * // Click within the image to change
 * // the value of the rectangle
 * // after the mouse has been clicked
 *
 * var value = 0;
 * function draw() {
 *   fill(value);
 *   rect(25, 25, 50, 50);
 * }
 *
 * function mouseClicked() {
 *   if (value == 0) {
 *     value = 255;
 *   } else {
 *     value = 0;
 *   }
 * }
 * </code>
 * </div>
 *
 * <div class="norender">
 * <code>
 * function mouseClicked() {
 *   ellipse(mouseX, mouseY, 5, 5);
 *   // prevent default
 *   return false;
 * }
 * </code>
 * </div>
 *
 * @alt
 * black 50x50 rect turns white with mouse click/press.
 * no image displayed
 *
 */
p5.prototype._onclick = function(e) {
  var context = this._isGlobal ? window : this;
  if (typeof context.mouseClicked === 'function') {
    var executeDefault = context.mouseClicked(e);
    if(executeDefault === false) {
      e.preventDefault();
    }
  }
};

/**
 * The function mouseWheel() is executed every time a vertical mouse wheel
 * event is detected either triggered by an actual mouse wheel or by a
 * touchpad.<br><br>
 * The event.delta property returns the amount the mouse wheel
 * have scrolled. The values can be positive or negative depending on the
 * scroll direction (on OS X with "natural" scrolling enabled, the signs
 * are inverted).<br><br>
 * Browsers may have different default behaviors attached to various
 * mouse events. To prevent any default behavior for this event, add
 * "return false" to the end of the method.<br><br>
 * Due to the current support of the "wheel" event on Safari, the function
 * may only work as expected if "return false" is included while using Safari.
 *
 * @method mouseWheel
 *
 * @example
 * <div>
 * <code>
 * var pos = 25;
 *
 * function draw() {
 *   background(237, 34, 93);
 *   fill(0);
 *   rect(25, pos, 50, 50);
 * }
 *
 * function mouseWheel(event) {
 *   print(event.delta);
 *   //move the square according to the vertical scroll amount
 *   pos += event.delta;
 *   //uncomment to block page scrolling
 *   //return false;
 * }
 * </code>
 * </div>
 *
 * @alt
 * black 50x50 rect moves up and down with vertical scroll. fuschia background
 *
 */
p5.prototype._onwheel = function(e) {
  var context = this._isGlobal ? window : this;
  if (typeof context.mouseWheel === 'function') {
    e.delta = e.deltaY;
    var executeDefault = context.mouseWheel(e);
    if(executeDefault === false) {
      e.preventDefault();
    }
  }
};

module.exports = p5;

},{"../core/constants":41,"../core/core":42}],58:[function(_dereq_,module,exports){
/**
 * @module Events
 * @submodule Touch
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');

/**
 * The system variable touches[] contains an array of the positions of all
 * current touch points, relative to (0, 0) of the canvas, and IDs identifying a
 * unique touch as it moves. Each element in the array is an object with x, y,
 * and id properties.
 *
 * The touches[] array is not supported on Safari and IE on touch-based
 * desktops (laptops).
 *
 * @property {Object[]} touches
 */
p5.prototype.touches = [];

p5.prototype._updateTouchCoords = function(e) {
  if (this._curElement !== null) {
    var touches = [];
    for(var i = 0; i < e.touches.length; i++){
      touches[i] = getTouchInfo(this._curElement.elt,
        this.width, this.height, e, i);
    }
    this._setProperty('touches', touches);
  }
};


function getTouchInfo(canvas, w, h, e, i) {
  i = i || 0;
  var rect = canvas.getBoundingClientRect();
  var sx = canvas.scrollWidth / w;
  var sy = canvas.scrollHeight / h;
  var touch = e.touches[i] || e.changedTouches[i];
  return {
    x: (touch.clientX - rect.left) / sx,
    y: (touch.clientY - rect.top) / sy,
    winX: touch.clientX,
    winY: touch.clientY,
    id: touch.identifier
  };
}

/**
 * The touchStarted() function is called once after every time a touch is
 * registered. If no touchStarted() function is defined, the mousePressed()
 * function will be called instead if it is defined.<br><br>
 * Browsers may have different default behaviors attached to various touch
 * events. To prevent any default behavior for this event, add "return false"
 * to the end of the method.
 *
 * @method touchStarted
 * @example
 * <div>
 * <code>
 * // Touch within the image to change
 * // the value of the rectangle
 *
 * var value = 0;
 * function draw() {
 *   fill(value);
 *   rect(25, 25, 50, 50);
 * }
 * function touchStarted() {
 *   if (value == 0) {
 *     value = 255;
 *   } else {
 *     value = 0;
 *   }
 * }
 * </code>
 * </div>
 *
 * <div class="norender">
 * <code>
 * function touchStarted() {
 *   ellipse(mouseX, mouseY, 5, 5);
 *   // prevent default
 *   return false;
 * }
 * </code>
 * </div>
 *
 * @alt
 * 50x50 black rect turns white with touch event.
 * no image displayed
 */
p5.prototype._ontouchstart = function(e) {
  var context = this._isGlobal ? window : this;
  var executeDefault;
  this._setProperty('mouseIsPressed', true);
  this._updateTouchCoords(e);
  this._updateNextMouseCoords(e);
  if(typeof context.touchStarted === 'function') {
    executeDefault = context.touchStarted(e);
    if(executeDefault === false) {
      e.preventDefault();
    }
  } else if (typeof context.mousePressed === 'function') {
    executeDefault = context.mousePressed(e);
    if(executeDefault === false) {
      e.preventDefault();
    }
  }
};

/**
 * The touchMoved() function is called every time a touch move is registered.
 * If no touchMoved() function is defined, the mouseDragged() function will
 * be called instead if it is defined.<br><br>
 * Browsers may have different default behaviors attached to various touch
 * events. To prevent any default behavior for this event, add "return false"
 * to the end of the method.
 *
 * @method touchMoved
 * @example
 * <div>
 * <code>
 * // Move your finger across the page
 * // to change its value
 *
 * var value = 0;
 * function draw() {
 *   fill(value);
 *   rect(25, 25, 50, 50);
 * }
 * function touchMoved() {
 *   value = value + 5;
 *   if (value > 255) {
 *     value = 0;
 *   }
 * }
 * </code>
 * </div>
 *
 * <div class="norender">
 * <code>
 * function touchMoved() {
 *   ellipse(mouseX, mouseY, 5, 5);
 *   // prevent default
 *   return false;
 * }
 * </code>
 * </div>
 *
 * @alt
 * 50x50 black rect turns lighter with touch until white. resets
 * no image displayed
 *
 */
p5.prototype._ontouchmove = function(e) {
  var context = this._isGlobal ? window : this;
  var executeDefault;
  this._updateTouchCoords(e);
  this._updateNextMouseCoords(e);
  if (typeof context.touchMoved === 'function') {
    executeDefault = context.touchMoved(e);
    if(executeDefault === false) {
      e.preventDefault();
    }
  } else if (typeof context.mouseDragged === 'function') {
    executeDefault = context.mouseDragged(e);
    if(executeDefault === false) {
      e.preventDefault();
    }
  }
};

/**
 * The touchEnded() function is called every time a touch ends. If no
 * touchEnded() function is defined, the mouseReleased() function will be
 * called instead if it is defined.<br><br>
 * Browsers may have different default behaviors attached to various touch
 * events. To prevent any default behavior for this event, add "return false"
 * to the end of the method.
 *
 * @method touchEnded
 * @example
 * <div>
 * <code>
 * // Release touch within the image to
 * // change the value of the rectangle
 *
 * var value = 0;
 * function draw() {
 *   fill(value);
 *   rect(25, 25, 50, 50);
 * }
 * function touchEnded() {
 *   if (value == 0) {
 *     value = 255;
 *   } else {
 *     value = 0;
 *   }
 * }
 * </code>
 * </div>
 *
 * <div class="norender">
 * <code>
 * function touchEnded() {
 *   ellipse(mouseX, mouseY, 5, 5);
 *   // prevent default
 *   return false;
 * }
 * </code>
 * </div>
 *
 * @alt
 * 50x50 black rect turns white with touch.
 * no image displayed
 *
 */
p5.prototype._ontouchend = function(e) {
  this._setProperty('mouseIsPressed', false);
  this._updateTouchCoords(e);
  this._updateNextMouseCoords(e);
  var context = this._isGlobal ? window : this;
  var executeDefault;
  if (typeof context.touchEnded === 'function') {
    executeDefault = context.touchEnded(e);
    if(executeDefault === false) {
      e.preventDefault();
    }
  } else if (typeof context.mouseReleased === 'function') {
    executeDefault = context.mouseReleased(e);
    if(executeDefault === false) {
      e.preventDefault();
    }
  }
};

module.exports = p5;

},{"../core/core":42}],59:[function(_dereq_,module,exports){
/*global ImageData:false */

/**
 * This module defines the filters for use with image buffers.
 *
 * This module is basically a collection of functions stored in an object
 * as opposed to modules. The functions are destructive, modifying
 * the passed in canvas rather than creating a copy.
 *
 * Generally speaking users of this module will use the Filters.apply method
 * on a canvas to create an effect.
 *
 * A number of functions are borrowed/adapted from
 * http://www.html5rocks.com/en/tutorials/canvas/imagefilters/
 * or the java processing implementation.
 */

'use strict';

var Filters = {};


/*
 * Helper functions
 */


/**
 * Returns the pixel buffer for a canvas
 *
 * @private
 *
 * @param  {Canvas|ImageData} canvas the canvas to get pixels from
 * @return {Uint8ClampedArray}       a one-dimensional array containing
 *                                   the data in thc RGBA order, with integer
 *                                   values between 0 and 255
 */
Filters._toPixels = function (canvas) {
  if (canvas instanceof ImageData) {
    return canvas.data;
  } else {
    return canvas.getContext('2d').getImageData(
      0,
      0,
      canvas.width,
      canvas.height
    ).data;
  }
};

/**
 * Returns a 32 bit number containing ARGB data at ith pixel in the
 * 1D array containing pixels data.
 *
 * @private
 *
 * @param  {Uint8ClampedArray} data array returned by _toPixels()
 * @param  {Integer}           i    index of a 1D Image Array
 * @return {Integer}                32 bit integer value representing
 *                                  ARGB value.
 */
Filters._getARGB = function (data, i) {
  var offset = i * 4;
  return (data[offset+3] << 24) & 0xff000000 |
    (data[offset] << 16) & 0x00ff0000 |
    (data[offset+1] << 8) & 0x0000ff00 |
    data[offset+2] & 0x000000ff;
};

/**
 * Modifies pixels RGBA values to values contained in the data object.
 *
 * @private
 *
 * @param {Uint8ClampedArray} pixels array returned by _toPixels()
 * @param {Int32Array}        data   source 1D array where each value
 *                                   represents ARGB values
 */
Filters._setPixels = function (pixels, data) {
  var offset = 0;
  for( var i = 0, al = pixels.length; i < al; i++) {
    offset = i*4;
    pixels[offset + 0] = (data[i] & 0x00ff0000)>>>16;
    pixels[offset + 1] = (data[i] & 0x0000ff00)>>>8;
    pixels[offset + 2] = (data[i] & 0x000000ff);
    pixels[offset + 3] = (data[i] & 0xff000000)>>>24;
  }
};

/**
 * Returns the ImageData object for a canvas
 * https://developer.mozilla.org/en-US/docs/Web/API/ImageData
 *
 * @private
 *
 * @param  {Canvas|ImageData} canvas canvas to get image data from
 * @return {ImageData}               Holder of pixel data (and width and
 *                                   height) for a canvas
 */
Filters._toImageData = function (canvas) {
  if (canvas instanceof ImageData) {
    return canvas;
  } else {
    return canvas.getContext('2d').getImageData(
      0,
      0,
      canvas.width,
      canvas.height
    );
  }
};

/**
 * Returns a blank ImageData object.
 *
 * @private
 *
 * @param  {Integer} width
 * @param  {Integer} height
 * @return {ImageData}
 */
Filters._createImageData = function (width, height) {
  Filters._tmpCanvas = document.createElement('canvas');
  Filters._tmpCtx = Filters._tmpCanvas.getContext('2d');
  return this._tmpCtx.createImageData(width, height);
};


/**
 * Applys a filter function to a canvas.
 *
 * The difference between this and the actual filter functions defined below
 * is that the filter functions generally modify the pixel buffer but do
 * not actually put that data back to the canvas (where it would actually
 * update what is visible). By contrast this method does make the changes
 * actually visible in the canvas.
 *
 * The apply method is the method that callers of this module would generally
 * use. It has been separated from the actual filters to support an advanced
 * use case of creating a filter chain that executes without actually updating
 * the canvas in between everystep.
 *
 * @param  {[type]} func   [description]
 * @param  {[type]} canvas [description]
 * @param  {[type]} level  [description]
 * @return {[type]}        [description]
 */
Filters.apply = function (canvas, func, filterParam) {
  var ctx = canvas.getContext('2d');
  var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);

  //Filters can either return a new ImageData object, or just modify
  //the one they received.
  var newImageData = func(imageData, filterParam);
  if (newImageData instanceof ImageData) {
    ctx.putImageData(newImageData, 0, 0, 0, 0, canvas.width, canvas.height);
  } else {
    ctx.putImageData(imageData, 0, 0, 0, 0, canvas.width, canvas.height);
  }
};


/*
 * Filters
 */


/**
 * Converts the image to black and white pixels depending if they are above or
 * below the threshold defined by the level parameter. The parameter must be
 * between 0.0 (black) and 1.0 (white). If no level is specified, 0.5 is used.
 *
 * Borrowed from http://www.html5rocks.com/en/tutorials/canvas/imagefilters/
 *
 * @param  {Canvas} canvas
 * @param  {Float} level
 */
Filters.threshold = function (canvas, level) {
  var pixels = Filters._toPixels(canvas);

  if (level === undefined) {
    level = 0.5;
  }
  var thresh = Math.floor(level * 255);

  for (var i = 0; i < pixels.length; i += 4) {
    var r = pixels[i];
    var g = pixels[i + 1];
    var b = pixels[i + 2];
    var gray = (0.2126 * r + 0.7152 * g + 0.0722 * b);
    var val;
    if (gray >= thresh) {
      val = 255;
    } else {
      val = 0;
    }
    pixels[i] = pixels[i + 1] = pixels[i + 2] = val;
  }

};


/**
 * Converts any colors in the image to grayscale equivalents.
 * No parameter is used.
 *
 * Borrowed from http://www.html5rocks.com/en/tutorials/canvas/imagefilters/
 *
 * @param {Canvas} canvas
 */
Filters.gray = function (canvas) {
  var pixels = Filters._toPixels(canvas);

  for (var i = 0; i < pixels.length; i += 4) {
    var r = pixels[i];
    var g = pixels[i + 1];
    var b = pixels[i + 2];

    // CIE luminance for RGB
    var gray = (0.2126 * r + 0.7152 * g + 0.0722 * b);
    pixels[i] = pixels[i + 1] = pixels[i + 2] = gray;
  }
};

/**
 * Sets the alpha channel to entirely opaque. No parameter is used.
 *
 * @param {Canvas} canvas
 */
Filters.opaque = function (canvas) {
  var pixels = Filters._toPixels(canvas);

  for (var i = 0; i < pixels.length; i += 4) {
    pixels[i + 3] = 255;
  }

  return pixels;
};

/**
 * Sets each pixel to its inverse value. No parameter is used.
 * @param  {Canvas} canvas
 */
Filters.invert = function (canvas) {
  var pixels = Filters._toPixels(canvas);

  for (var i = 0; i < pixels.length; i += 4) {
    pixels[i] = 255 - pixels[i];
    pixels[i + 1] = 255 - pixels[i + 1];
    pixels[i + 2] = 255 - pixels[i + 2];
  }

};


/**
 * Limits each channel of the image to the number of colors specified as
 * the parameter. The parameter can be set to values between 2 and 255, but
 * results are most noticeable in the lower ranges.
 *
 * Adapted from java based processing implementation
 *
 * @param  {Canvas} canvas
 * @param  {Integer} level
 */
Filters.posterize = function (canvas, level) {
  var pixels = Filters._toPixels(canvas);

  if ((level < 2) || (level > 255)) {
    throw new Error(
      'Level must be greater than 2 and less than 255 for posterize'
    );
  }

  var levels1 = level - 1;
  for (var i = 0; i < pixels.length; i+=4) {
    var rlevel = pixels[i];
    var glevel = pixels[i + 1];
    var blevel = pixels[i + 2];

    pixels[i] = (((rlevel * level) >> 8) * 255) / levels1;
    pixels[i + 1] = (((glevel * level) >> 8) * 255) / levels1;
    pixels[i + 2] = (((blevel * level) >> 8) * 255) / levels1;
  }
};

/**
 * reduces the bright areas in an image
 * @param  {Canvas} canvas
 *
 */
Filters.dilate = function (canvas) {
  var pixels = Filters._toPixels(canvas);
  var currIdx = 0;
  var maxIdx = pixels.length ? pixels.length/4 : 0;
  var out = new Int32Array(maxIdx);
  var currRowIdx, maxRowIdx, colOrig, colOut, currLum;
  var idxRight, idxLeft, idxUp, idxDown,
      colRight, colLeft, colUp, colDown,
      lumRight, lumLeft, lumUp, lumDown;

  while(currIdx < maxIdx) {
    currRowIdx = currIdx;
    maxRowIdx = currIdx + canvas.width;
    while (currIdx < maxRowIdx) {
      colOrig = colOut = Filters._getARGB(pixels, currIdx);
      idxLeft = currIdx - 1;
      idxRight = currIdx + 1;
      idxUp = currIdx - canvas.width;
      idxDown = currIdx + canvas.width;

      if (idxLeft < currRowIdx) {
        idxLeft = currIdx;
      }
      if (idxRight >= maxRowIdx) {
        idxRight = currIdx;
      }
      if (idxUp < 0){
        idxUp = 0;
      }
      if (idxDown >= maxIdx) {
        idxDown = currIdx;
      }
      colUp = Filters._getARGB(pixels, idxUp);
      colLeft = Filters._getARGB(pixels, idxLeft);
      colDown = Filters._getARGB(pixels, idxDown);
      colRight = Filters._getARGB(pixels, idxRight);

      //compute luminance
      currLum = 77*(colOrig>>16&0xff) +
        151*(colOrig>>8&0xff) +
        28*(colOrig&0xff);
      lumLeft = 77*(colLeft>>16&0xff) +
        151*(colLeft>>8&0xff) +
        28*(colLeft&0xff);
      lumRight = 77*(colRight>>16&0xff) +
        151*(colRight>>8&0xff) +
        28*(colRight&0xff);
      lumUp = 77*(colUp>>16&0xff) +
        151*(colUp>>8&0xff) +
        28*(colUp&0xff);
      lumDown = 77*(colDown>>16&0xff) +
        151*(colDown>>8&0xff) +
        28*(colDown&0xff);

      if (lumLeft > currLum) {
        colOut = colLeft;
        currLum = lumLeft;
      }
      if (lumRight > currLum) {
        colOut = colRight;
        currLum = lumRight;
      }
      if (lumUp > currLum) {
        colOut = colUp;
        currLum = lumUp;
      }
      if (lumDown > currLum) {
        colOut = colDown;
        currLum = lumDown;
      }
      out[currIdx++]=colOut;
    }
  }
  Filters._setPixels(pixels, out);
};

/**
 * increases the bright areas in an image
 * @param  {Canvas} canvas
 *
 */
Filters.erode = function(canvas) {
  var pixels = Filters._toPixels(canvas);
  var currIdx = 0;
  var maxIdx = pixels.length ? pixels.length/4 : 0;
  var out = new Int32Array(maxIdx);
  var currRowIdx, maxRowIdx, colOrig, colOut, currLum;
  var idxRight, idxLeft, idxUp, idxDown,
      colRight, colLeft, colUp, colDown,
      lumRight, lumLeft, lumUp, lumDown;

  while(currIdx < maxIdx) {
    currRowIdx = currIdx;
    maxRowIdx = currIdx + canvas.width;
    while (currIdx < maxRowIdx) {
      colOrig = colOut = Filters._getARGB(pixels, currIdx);
      idxLeft = currIdx - 1;
      idxRight = currIdx + 1;
      idxUp = currIdx - canvas.width;
      idxDown = currIdx + canvas.width;

      if (idxLeft < currRowIdx) {
        idxLeft = currIdx;
      }
      if (idxRight >= maxRowIdx) {
        idxRight = currIdx;
      }
      if (idxUp < 0) {
        idxUp = 0;
      }
      if (idxDown >= maxIdx) {
        idxDown = currIdx;
      }
      colUp = Filters._getARGB(pixels, idxUp);
      colLeft = Filters._getARGB(pixels, idxLeft);
      colDown = Filters._getARGB(pixels, idxDown);
      colRight = Filters._getARGB(pixels, idxRight);

      //compute luminance
      currLum = 77*(colOrig>>16&0xff) +
        151*(colOrig>>8&0xff) +
        28*(colOrig&0xff);
      lumLeft = 77*(colLeft>>16&0xff) +
        151*(colLeft>>8&0xff) +
        28*(colLeft&0xff);
      lumRight = 77*(colRight>>16&0xff) +
        151*(colRight>>8&0xff) +
        28*(colRight&0xff);
      lumUp = 77*(colUp>>16&0xff) +
        151*(colUp>>8&0xff) +
        28*(colUp&0xff);
      lumDown = 77*(colDown>>16&0xff) +
        151*(colDown>>8&0xff) +
        28*(colDown&0xff);

      if (lumLeft < currLum) {
        colOut = colLeft;
        currLum = lumLeft;
      }
      if (lumRight < currLum) {
        colOut = colRight;
        currLum = lumRight;
      }
      if (lumUp < currLum) {
        colOut = colUp;
        currLum = lumUp;
      }
      if (lumDown < currLum) {
        colOut = colDown;
        currLum = lumDown;
      }

      out[currIdx++]=colOut;
    }
  }
  Filters._setPixels(pixels, out);
};

// BLUR

// internal kernel stuff for the gaussian blur filter
var blurRadius;
var blurKernelSize;
var blurKernel;
var blurMult;

/*
 * Port of https://github.com/processing/processing/blob/
 * master/core/src/processing/core/PImage.java#L1250
 *
 * Optimized code for building the blur kernel.
 * further optimized blur code (approx. 15% for radius=20)
 * bigger speed gains for larger radii (~30%)
 * added support for various image types (ALPHA, RGB, ARGB)
 * [toxi 050728]
 */
function buildBlurKernel(r) {
  var radius = (r * 3.5)|0;
  radius = (radius < 1) ? 1 : ((radius < 248) ? radius : 248);

  if (blurRadius !== radius) {
    blurRadius = radius;
    blurKernelSize = 1 + blurRadius<<1;
    blurKernel = new Int32Array(blurKernelSize);
    blurMult = new Array(blurKernelSize);
    for(var l = 0; l < blurKernelSize; l++){
      blurMult[l] = new Int32Array(256);
    }

    var bk,bki;
    var bm,bmi;

    for (var i = 1, radiusi = radius - 1; i < radius; i++) {
      blurKernel[radius+i] = blurKernel[radiusi] = bki = radiusi * radiusi;
      bm = blurMult[radius+i];
      bmi = blurMult[radiusi--];
      for (var j = 0; j < 256; j++){
        bm[j] = bmi[j] = bki * j;
      }
    }
    bk = blurKernel[radius] = radius * radius;
    bm = blurMult[radius];

    for (var k = 0; k < 256; k++){
      bm[k] = bk * k;
    }
  }

}

// Port of https://github.com/processing/processing/blob/
// master/core/src/processing/core/PImage.java#L1433
function blurARGB(canvas, radius) {
  var pixels = Filters._toPixels(canvas);
  var width = canvas.width;
  var height = canvas.height;
  var numPackedPixels = width * height;
  var argb = new Int32Array(numPackedPixels);
  for (var j = 0; j < numPackedPixels; j++) {
    argb[j] = Filters._getARGB(pixels, j);
  }
  var sum, cr, cg, cb, ca;
  var read, ri, ym, ymi, bk0;
  var a2 = new Int32Array(numPackedPixels);
  var r2 = new Int32Array(numPackedPixels);
  var g2 = new Int32Array(numPackedPixels);
  var b2 = new Int32Array(numPackedPixels);
  var yi = 0;
  buildBlurKernel(radius);
  var x, y, i;
  var bm;
  for (y = 0; y < height; y++) {
    for (x = 0; x < width; x++) {
      cb = cg = cr = ca = sum = 0;
      read = x - blurRadius;
      if (read < 0) {
        bk0 = -read;
        read = 0;
      } else {
        if (read >= width) {
          break;
        }
        bk0 = 0;
      }
      for (i = bk0; i < blurKernelSize; i++) {
        if (read >= width) {
          break;
        }
        var c = argb[read + yi];
        bm = blurMult[i];
        ca += bm[(c & -16777216) >>> 24];
        cr += bm[(c & 16711680) >> 16];
        cg += bm[(c & 65280) >> 8];
        cb += bm[c & 255];
        sum += blurKernel[i];
        read++;
      }
      ri = yi + x;
      a2[ri] = ca / sum;
      r2[ri] = cr / sum;
      g2[ri] = cg / sum;
      b2[ri] = cb / sum;
    }
    yi += width;
  }
  yi = 0;
  ym = -blurRadius;
  ymi = ym * width;
  for (y = 0; y < height; y++) {
    for (x = 0; x < width; x++) {
      cb = cg = cr = ca = sum = 0;
      if (ym < 0) {
        bk0 = ri = -ym;
        read = x;
      } else {
        if (ym >= height) {
          break;
        }
        bk0 = 0;
        ri = ym;
        read = x + ymi;
      }
      for (i = bk0; i < blurKernelSize; i++) {
        if (ri >= height) {
          break;
        }
        bm = blurMult[i];
        ca += bm[a2[read]];
        cr += bm[r2[read]];
        cg += bm[g2[read]];
        cb += bm[b2[read]];
        sum += blurKernel[i];
        ri++;
        read += width;
      }
      argb[x + yi] = (ca/sum)<<24 | (cr/sum)<<16 | (cg/sum)<<8 | (cb/sum);
    }
    yi += width;
    ymi += width;
    ym++;
  }
  Filters._setPixels(pixels, argb);
}

Filters.blur = function(canvas, radius){
  blurARGB(canvas, radius);
};


module.exports = Filters;

},{}],60:[function(_dereq_,module,exports){
/**
 * @module Image
 * @submodule Image
 * @for p5
 * @requires core
 */

/**
 * This module defines the p5 methods for the p5.Image class
 * for drawing images to the main display canvas.
 */
'use strict';


var p5 = _dereq_('../core/core');

/* global frames:true */// This is not global, but JSHint is not aware that
// this module is implicitly enclosed with Browserify: this overrides the
// redefined-global error and permits using the name "frames" for the array
// of saved animation frames.
var frames = [];


/**
 * Creates a new p5.Image (the datatype for storing images). This provides a
 * fresh buffer of pixels to play with. Set the size of the buffer with the
 * width and height parameters.
 * <br><br>
 * .pixels gives access to an array containing the values for all the pixels
 * in the display window.
 * These values are numbers. This array is the size (including an appropriate
 * factor for the pixelDensity) of the display window x4,
 * representing the R, G, B, A values in order for each pixel, moving from
 * left to right across each row, then down each column. See .pixels for
 * more info. It may also be simpler to use set() or get().
 * <br><br>
 * Before accessing the pixels of an image, the data must loaded with the
 * loadPixels() function. After the array data has been modified, the
 * updatePixels() function must be run to update the changes.
 *
 * @method createImage
 * @param  {Integer} width  width in pixels
 * @param  {Integer} height height in pixels
 * @return {p5.Image}       the p5.Image object
 * @example
 * <div>
 * <code>
 * img = createImage(66, 66);
 * img.loadPixels();
 * for (i = 0; i < img.width; i++) {
 *   for (j = 0; j < img.height; j++) {
 *     img.set(i, j, color(0, 90, 102));
 *   }
 * }
 * img.updatePixels();
 * image(img, 17, 17);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * img = createImage(66, 66);
 * img.loadPixels();
 * for (i = 0; i < img.width; i++) {
 *   for (j = 0; j < img.height; j++) {
 *     img.set(i, j, color(0, 90, 102, i % img.width * 2));
 *   }
 * }
 * img.updatePixels();
 * image(img, 17, 17);
 * image(img, 34, 34);
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * var pink = color(255, 102, 204);
 * img = createImage(66, 66);
 * img.loadPixels();
 * var d = pixelDensity();
 * var halfImage = 4 * (width * d) * (height/2 * d);
 * for (var i = 0; i < halfImage; i+=4) {
 *   img.pixels[i] = red(pink);
 *   img.pixels[i+1] = green(pink);
 *   img.pixels[i+2] = blue(pink);
 *   img.pixels[i+3] = alpha(pink);
 * }
 * img.updatePixels();
 * image(img, 17, 17);
 * </code>
 * </div>
 *
 * @alt
 * 66x66 dark turquoise rect in center of canvas.
 * 2 gradated dark turquoise rects fade left. 1 center 1 bottom right of canvas
 * no image displayed
 *
 */
p5.prototype.createImage = function(width, height) {
  return new p5.Image(width, height);
};

/**
 *  Save the current canvas as an image. In Safari, this will open the
 *  image in the window and the user must provide their own
 *  filename on save-as. Other browsers will either save the
 *  file immediately, or prompt the user with a dialogue window.
 *
 *  @method saveCanvas
 *  @param  {Canvas} [selectedCanvas] a variable representing a
 *                             specific html5 canvas (optional)
 *  @param  {String} [filename]
 *  @param  {String} [extension] 'jpg' or 'png'
 *  @example
 *  <div class='norender'><code>
 *  function setup() {
 *    var c = createCanvas(100, 100);
 *    background(255, 0, 0);
 *    saveCanvas(c, 'myCanvas', 'jpg');
 *  }
 *  </code></div>
 *  <div class='norender'><code>
 *  // note that this example has the same result as above
 *  // if no canvas is specified, defaults to main canvas
 *  function setup() {
 *    createCanvas(100, 100);
 *    background(255, 0, 0);
 *    saveCanvas('myCanvas', 'jpg');
 *  }
 *  </code></div>
 *  <div class='norender'><code>
 *  // all of the following are valid
 *  saveCanvas(c, 'myCanvas', 'jpg');
 *  saveCanvas(c, 'myCanvas');
 *  saveCanvas(c);
 *  saveCanvas('myCanvas', 'png');
 *  saveCanvas('myCanvas');
 *  saveCanvas();
 *  </code></div>
 *
 * @alt
 * no image displayed
 * no image displayed
 * no image displayed
 *
 */
p5.prototype.saveCanvas = function() {

  var cnv, filename, extension;
  if (arguments.length === 3) {
    cnv = arguments[0];
    filename = arguments[1];
    extension = arguments[2];
  } else if (arguments.length === 2) {
    if (typeof arguments[0] === 'object') {
      cnv = arguments[0];
      filename = arguments[1];
    } else {
      filename = arguments[0];
      extension = arguments[1];
    }
  } else if (arguments.length === 1) {
    if (typeof arguments[0] === 'object') {
      cnv = arguments[0];
    } else {
      filename = arguments[0];
    }
  }

  if (cnv instanceof p5.Element) {
    cnv = cnv.elt;
  }
  if (!(cnv instanceof HTMLCanvasElement)) {
    cnv = null;
  }

  if (!extension) {
    extension = p5.prototype._checkFileExtension(filename, extension)[1];
    if (extension === '') {
      extension = 'png';
    }
  }

  if (!cnv) {
    if (this._curElement && this._curElement.elt) {
      cnv = this._curElement.elt;
    }
  }

  if ( p5.prototype._isSafari() ) {
    var aText = 'Hello, Safari user!\n';
    aText += 'Now capturing a screenshot...\n';
    aText += 'To save this image,\n';
    aText += 'go to File --> Save As.\n';
    alert(aText);
    window.location.href = cnv.toDataURL();
  } else {
    var mimeType;
    if (typeof(extension) === 'undefined') {
      extension = 'png';
      mimeType = 'image/png';
    }
    else {
      switch(extension){
        case 'png':
          mimeType = 'image/png';
          break;
        case 'jpeg':
          mimeType = 'image/jpeg';
          break;
        case 'jpg':
          mimeType = 'image/jpeg';
          break;
        default:
          mimeType = 'image/png';
          break;
      }
    }
    var downloadMime = 'image/octet-stream';
    var imageData = cnv.toDataURL(mimeType);
    imageData = imageData.replace(mimeType, downloadMime);

    p5.prototype.downloadFile(imageData, filename, extension);
  }
};

/**
 *  Capture a sequence of frames that can be used to create a movie.
 *  Accepts a callback. For example, you may wish to send the frames
 *  to a server where they can be stored or converted into a movie.
 *  If no callback is provided, the browser will pop up save dialogues in an
 *  attempt to download all of the images that have just been created. With the
 *  callback provided the image data isn't saved by default but instead passed
 *  as an argument to the callback function as an array of objects, with the
 *  size of array equal to the total number of frames.
 *
 *  @method saveFrames
 *  @param  {String}   filename
 *  @param  {String}   extension 'jpg' or 'png'
 *  @param  {Number}   duration  Duration in seconds to save the frames for.
 *  @param  {Number}   framerate  Framerate to save the frames in.
 *  @param  {Function} [callback] A callback function that will be executed
                                  to handle the image data. This function
                                  should accept an array as argument. The
                                  array will contain the specified number of
                                  frames of objects. Each object has three
                                  properties: imageData - an
                                  image/octet-stream, filename and extension.
 *  @example
 *  <div><code>
 *  function draw() {
 *    background(mouseX);
 *  }
 *
 *  function mousePressed() {
 *    saveFrames("out", "png", 1, 25, function(data){
 *      print(data);
 *    });
 *  }
 *  </code></div>
 *
 * @alt
 * canvas background goes from light to dark with mouse x.
 *
 */
p5.prototype.saveFrames = function(fName, ext, _duration, _fps, callback) {
  var duration = _duration || 3;
  duration = p5.prototype.constrain(duration, 0, 15);
  duration = duration * 1000;
  var fps = _fps || 15;
  fps = p5.prototype.constrain(fps, 0, 22);
  var count = 0;

  var makeFrame = p5.prototype._makeFrame;
  var cnv = this._curElement.elt;
  var frameFactory = setInterval(function(){
    makeFrame(fName + count, ext, cnv);
    count++;
  },1000/fps);

  setTimeout(function(){
    clearInterval(frameFactory);
    if (callback) {
      callback(frames);
    }
    else {
      for (var i = 0; i < frames.length; i++) {
        var f = frames[i];
        p5.prototype.downloadFile(f.imageData, f.filename, f.ext);
      }
    }
    frames = []; // clear frames
  }, duration + 0.01);
};

p5.prototype._makeFrame = function(filename, extension, _cnv) {
  var cnv;
  if (this) {
    cnv = this._curElement.elt;
  } else {
    cnv = _cnv;
  }
  var mimeType;
  if (!extension) {
    extension = 'png';
    mimeType = 'image/png';
  }
  else {
    switch(extension.toLowerCase()){
      case 'png':
        mimeType = 'image/png';
        break;
      case 'jpeg':
        mimeType = 'image/jpeg';
        break;
      case 'jpg':
        mimeType = 'image/jpeg';
        break;
      default:
        mimeType = 'image/png';
        break;
    }
  }
  var downloadMime = 'image/octet-stream';
  var imageData = cnv.toDataURL(mimeType);
  imageData = imageData.replace(mimeType, downloadMime);

  var thisFrame = {};
  thisFrame.imageData = imageData;
  thisFrame.filename = filename;
  thisFrame.ext = extension;
  frames.push(thisFrame);
};

module.exports = p5;

},{"../core/core":42}],61:[function(_dereq_,module,exports){
/**
 * @module Image
 * @submodule Loading & Displaying
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');
var Filters = _dereq_('./filters');
var canvas = _dereq_('../core/canvas');
var constants = _dereq_('../core/constants');

_dereq_('../core/error_helpers');

/**
 * Loads an image from a path and creates a p5.Image from it.
 * <br><br>
 * The image may not be immediately available for rendering
 * If you want to ensure that the image is ready before doing
 * anything with it, place the loadImage() call in preload().
 * You may also supply a callback function to handle the image when it's ready.
 * <br><br>
 * The path to the image should be relative to the HTML file
 * that links in your sketch. Loading an from a URL or other
 * remote location may be blocked due to your browser's built-in
 * security.
 *
 * @method loadImage
 * @param  {String} path Path of the image to be loaded
 * @param  {Function(p5.Image)} [successCallback] Function to be called once
 *                                the image is loaded. Will be passed the
 *                                p5.Image.
 * @param  {Function(Event)}    [failureCallback] called with event error if
 *                                the image fails to load.
 * @return {p5.Image}             the p5.Image object
 * @example
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage("assets/laDefense.jpg");
 * }
 * function setup() {
 *   image(img, 0, 0);
 * }
 * </code>
 * </div>
 * <div>
 * <code>
 * function setup() {
 *   // here we use a callback to display the image after loading
 *   loadImage("assets/laDefense.jpg", function(img) {
 *     image(img, 0, 0);
 *   });
 * }
 * </code>
 * </div>
 *
 * @alt
 * image of the underside of a white umbrella and grided ceililng above
 * image of the underside of a white umbrella and grided ceililng above
 *
 */
p5.prototype.loadImage = function(path, successCallback, failureCallback) {
  var img = new Image();
  var pImg = new p5.Image(1, 1, this);
  var decrementPreload = p5._getDecrementPreload.apply(this, arguments);

  img.onload = function() {
    pImg.width = pImg.canvas.width = img.width;
    pImg.height = pImg.canvas.height = img.height;

    // Draw the image into the backing canvas of the p5.Image
    pImg.drawingContext.drawImage(img, 0, 0);

    if (typeof successCallback === 'function') {
      successCallback(pImg);
    }
    if (decrementPreload && (successCallback !== decrementPreload)) {
      decrementPreload();
    }
  };
  img.onerror = function(e) {
    p5._friendlyFileLoadError(0,img.src);
    // don't get failure callback mixed up with decrementPreload
    if ((typeof failureCallback === 'function') &&
      (failureCallback !== decrementPreload)) {
      failureCallback(e);
    }
  };

  //set crossOrigin in case image is served which CORS headers
  //this will let us draw to canvas without tainting it.
  //see https://developer.mozilla.org/en-US/docs/HTML/CORS_Enabled_Image
  // When using data-uris the file will be loaded locally
  // so we don't need to worry about crossOrigin with base64 file types
  if(path.indexOf('data:image/') !== 0) {
    img.crossOrigin = 'Anonymous';
  }

  //start loading the image
  img.src = path;

  return pImg;
};

/**
 * Validates clipping params. Per drawImage spec sWidth and sHight cannot be
 * negative or greater than image intrinsic width and height
 * @private
 * @param {Number} sVal
 * @param {Number} iVal
 * @returns {Number}
 * @private
 */
function _sAssign(sVal, iVal) {
  if (sVal > 0 && sVal < iVal) {
    return sVal;
  }
  else {
    return iVal;
  }
}

/**
 * Draw an image to the main canvas of the p5js sketch
 *
 * @method image
 * @param  {p5.Image} img    the image to display
 * @param  {Number}   x      the x-coordinate at which to place the top-left
 *                           corner of the source image
 * @param  {Number}   y      the y-coordinate at which to place the top-left
 *                           corner of the source image
 * @param  {Number}   width  the width to draw the image
 * @param  {Number}   height the height to draw the image
 * @example
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage("assets/laDefense.jpg");
 * }
 * function setup() {
 *   image(img, 0, 0);
 *   image(img, 0, 0, 100, 100);
 *   image(img, 0, 0, 100, 100, 0, 0, 100, 100);
 * }
 * </code>
 * </div>
 * <div>
 * <code>
 * function setup() {
 *   // here we use a callback to display the image after loading
 *   loadImage("assets/laDefense.jpg", function(img) {
 *     image(img, 0, 0);
 *   });
 * }
 * </code>
 * </div>
 *
 * @alt
 * image of the underside of a white umbrella and grided ceiling above
 * image of the underside of a white umbrella and grided ceiling above
 *
 */
/**
 * @method image
 * @param  {p5.Image} img
 * @param  {Number}   dx     the x-coordinate in the destination canvas at
 *                           which to place the top-left corner of the
 *                           source image
 * @param  {Number}   dy     the y-coordinate in the destination canvas at
 *                           which to place the top-left corner of the
 *                           source image
 * @param  {Number}   dWidth the width to draw the image in the destination
 *                           canvas
 * @param  {Number}   dHeight the height to draw the image in the destination
 *                            canvas
 * @param  {Number}   sx     the x-coordinate of the top left corner of the
 *                           sub-rectangle of the source image to draw into
 *                           the destination canvas
 * @param  {Number}   sy     the y-coordinate of the top left corner of the
 *                           sub-rectangle of the source image to draw into
 *                           the destination canvas
 * @param {Number}    [sWidth] the width of the sub-rectangle of the
 *                           source image to draw into the destination
 *                           canvas
 * @param {Number}    [sHeight] the height of the sub-rectangle of the
 *                            source image to draw into the destination context
 */
p5.prototype.image =
  function(img, dx, dy, dWidth, dHeight, sx, sy, sWidth, sHeight) {
  // set defaults per spec: https://goo.gl/3ykfOq

  var defW = img.width;
  var defH = img.height;

  if (img.elt && img.elt.videoWidth && !img.canvas) { // video no canvas
    defW = img.elt.videoWidth;
    defH = img.elt.videoHeight;
  }

  var _dx = dx;
  var _dy = dy;
  var _dw = dWidth || defW;
  var _dh = dHeight || defH;
  var _sx = sx || 0;
  var _sy = sy || 0;
  var _sw = sWidth || defW;
  var _sh = sHeight || defH;

  _sw = _sAssign(_sw, defW);
  _sh = _sAssign(_sh, defH);


  // This part needs cleanup and unit tests
  // see issues https://github.com/processing/p5.js/issues/1741
  // and https://github.com/processing/p5.js/issues/1673
  var pd = 1;

  if (img.elt && !img.canvas && img.elt.style.width) {
    //if img is video and img.elt.size() has been used and
    //no width passed to image()
    if(img.elt.videoWidth && !dWidth){
      pd = img.elt.videoWidth;
    }
    //all other cases
    else {
      pd = img.elt.width;
    }
    pd /= parseInt(img.elt.style.width, 10);
  }

  _sx *= pd;
  _sy *= pd;
  _sh *= pd;
  _sw *= pd;

  var vals = canvas.modeAdjust(_dx, _dy, _dw, _dh,
    this._renderer._imageMode);

  // tint the image if there is a tint
  this._renderer.image(img, _sx, _sy, _sw, _sh, vals.x, vals.y, vals.w,
    vals.h);
};


/**
 * Sets the fill value for displaying images. Images can be tinted to
 * specified colors or made transparent by including an alpha value.
 * <br><br>
 * To apply transparency to an image without affecting its color, use
 * white as the tint color and specify an alpha value. For instance,
 * tint(255, 128) will make an image 50% transparent (assuming the default
 * alpha range of 0-255, which can be changed with colorMode()).
 * <br><br>
 * The value for the gray parameter must be less than or equal to the current
 * maximum value as specified by colorMode(). The default maximum value is
 * 255.
 *
 * @method tint
 * @param {Number|Array} v1   gray value, red or hue value (depending on the
 *                            current color mode), or color Array
 * @param {Number|Array} [v2] green or saturation value (depending on the
 *                            current color mode)
 * @param {Number|Array} [v3] blue or brightness value (depending on the
 *                            current color mode)
 * @param {Number|Array} [a]  opacity of the background
 * @example
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage("assets/laDefense.jpg");
 * }
 * function setup() {
 *   image(img, 0, 0);
 *   tint(0, 153, 204);  // Tint blue
 *   image(img, 50, 0);
 * }
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage("assets/laDefense.jpg");
 * }
 * function setup() {
 *   image(img, 0, 0);
 *   tint(0, 153, 204, 126);  // Tint blue and set transparency
 *   image(img, 50, 0);
 * }
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage("assets/laDefense.jpg");
 * }
 * function setup() {
 *   image(img, 0, 0);
 *   tint(255, 126);  // Apply transparency without changing color
 *   image(img, 50, 0);
 * }
 * </code>
 * </div>
 *
 * @alt
 * 2 side by side images of umbrella and ceiling, one image with blue tint
 * Images of umbrella and ceiling, one half of image with blue tint
 * 2 side by side images of umbrella and ceiling, one image translucent
 *
 */
p5.prototype.tint = function () {
  var c = this.color.apply(this, arguments);
  this._renderer._tint = c.levels;
};

/**
 * Removes the current fill value for displaying images and reverts to
 * displaying images with their original hues.
 *
 * @method noTint
 * @example
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage("assets/bricks.jpg");
 * }
 * function setup() {
 *   tint(0, 153, 204);  // Tint blue
 *   image(img, 0, 0);
 *   noTint();  // Disable tint
 *   image(img, 50, 0);
 * }
 * </code>
 * </div>
 *
 * @alt
 * 2 side by side images of bricks, left image with blue tint
 *
 */
p5.prototype.noTint = function() {
  this._renderer._tint = null;
};

/**
 * Apply the current tint color to the input image, return the resulting
 * canvas.
 *
 * @param {p5.Image} The image to be tinted
 * @return {canvas} The resulting tinted canvas
 *
 */
p5.prototype._getTintedImageCanvas = function(img) {
  if (!img.canvas) {
    return img;
  }
  var pixels = Filters._toPixels(img.canvas);
  var tmpCanvas = document.createElement('canvas');
  tmpCanvas.width = img.canvas.width;
  tmpCanvas.height = img.canvas.height;
  var tmpCtx = tmpCanvas.getContext('2d');
  var id = tmpCtx.createImageData(img.canvas.width, img.canvas.height);
  var newPixels = id.data;

  for(var i = 0; i < pixels.length; i += 4) {
    var r = pixels[i];
    var g = pixels[i+1];
    var b = pixels[i+2];
    var a = pixels[i+3];

    newPixels[i] = r*this._renderer._tint[0]/255;
    newPixels[i+1] = g*this._renderer._tint[1]/255;
    newPixels[i+2] = b*this._renderer._tint[2]/255;
    newPixels[i+3] = a*this._renderer._tint[3]/255;
  }

  tmpCtx.putImageData(id, 0, 0);
  return tmpCanvas;
};

/**
 * Set image mode. Modifies the location from which images are drawn by
 * changing the way in which parameters given to image() are interpreted.
 * The default mode is imageMode(CORNER), which interprets the second and
 * third parameters of image() as the upper-left corner of the image. If
 * two additional parameters are specified, they are used to set the image's
 * width and height.
 * <br><br>
 * imageMode(CORNERS) interprets the second and third parameters of image()
 * as the location of one corner, and the fourth and fifth parameters as the
 * opposite corner.
 * <br><br>
 * imageMode(CENTER) interprets the second and third parameters of image()
 * as the image's center point. If two additional parameters are specified,
 * they are used to set the image's width and height.
 *
 * @method imageMode
 * @param {Constant} mode either CORNER, CORNERS, or CENTER
 * @example
 *
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage("assets/bricks.jpg");
 * }
 * function setup() {
 *   imageMode(CORNER);
 *   image(img, 10, 10, 50, 50);
 * }
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage("assets/bricks.jpg");
 * }
 * function setup() {
 *   imageMode(CORNERS);
 *   image(img, 10, 10, 90, 40);
 * }
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage("assets/bricks.jpg");
 * }
 * function setup() {
 *   imageMode(CENTER);
 *   image(img, 50, 50, 80, 80);
 * }
 * </code>
 * </div>
 *
 * @alt
 * small square image of bricks
 * horizontal rectangle image of bricks
 * large square image of bricks
 *
 */
p5.prototype.imageMode = function(m) {
  if (m === constants.CORNER ||
    m === constants.CORNERS ||
    m === constants.CENTER) {
    this._renderer._imageMode = m;
  }
};


module.exports = p5;

},{"../core/canvas":40,"../core/constants":41,"../core/core":42,"../core/error_helpers":45,"./filters":59}],62:[function(_dereq_,module,exports){
/**
 * @module Image
 * @submodule Image
 * @requires core
 * @requires constants
 * @requires filters
 */

/**
 * This module defines the p5.Image class and P5 methods for
 * drawing images to the main display canvas.
 */

'use strict';

var p5 = _dereq_('../core/core');
var Filters = _dereq_('./filters');

/*
 * Class methods
 */

/**
 * Creates a new p5.Image. A p5.Image is a canvas backed representation of an
 * image.
 * <br><br>
 * p5 can display .gif, .jpg and .png images. Images may be displayed
 * in 2D and 3D space. Before an image is used, it must be loaded with the
 * loadImage() function. The p5.Image class contains fields for the width and
 * height of the image, as well as an array called pixels[] that contains the
 * values for every pixel in the image.
 * <br><br>
 * The methods described below allow easy access to the image's pixels and
 * alpha channel and simplify the process of compositing.
 * <br><br>
 * Before using the pixels[] array, be sure to use the loadPixels() method on
 * the image to make sure that the pixel data is properly loaded.
 *
 * @class p5.Image
 * @constructor
 * @param {Number} width
 * @param {Number} height
 * @param {Object} pInst An instance of a p5 sketch.
 */
p5.Image = function(width, height){
  /**
   * Image width.
   * @property width
   * @example
   * <div><code>
   * var img;
   * function preload() {
   *   img = loadImage("assets/rockies.jpg");
   * }
   *
   * function setup() {
   *   createCanvas(100, 100);
   *   image(img, 0, 0);
   *   for (var i=0; i < img.width; i++) {
   *     var c = img.get(i, img.height/2);
   *     stroke(c);
   *     line(i, height/2, i, height);
   *   }
   * }
   * </code></div>
   *
   * @alt
   * rocky mountains in top and horizontal lines in corresponding colors in bottom.
   *
   */
  this.width = width;
  /**
   * Image height.
   * @property height
   * @example
   * <div><code>
   * var img;
   * function preload() {
   *   img = loadImage("assets/rockies.jpg");
   * }
   *
   * function setup() {
   *   createCanvas(100, 100);
   *   image(img, 0, 0);
   *   for (var i=0; i < img.height; i++) {
   *     var c = img.get(img.width/2, i);
   *     stroke(c);
   *     line(0, i, width/2, i);
   *   }
   * }
   * </code></div>
   *
   * @alt
   * rocky mountains on right and vertical lines in corresponding colors on left.
   *
   */
  this.height = height;
  this.canvas = document.createElement('canvas');
  this.canvas.width = this.width;
  this.canvas.height = this.height;
  this.drawingContext = this.canvas.getContext('2d');
  this._pixelDensity = 1;
  //used for webgl texturing only
  this.isTexture = false;
  /**
   * Array containing the values for all the pixels in the display window.
   * These values are numbers. This array is the size (include an appropriate
   * factor for pixelDensity) of the display window x4,
   * representing the R, G, B, A values in order for each pixel, moving from
   * left to right across each row, then down each column. Retina and other
   * high denisty displays may have more pixels[] (by a factor of
   * pixelDensity^2).
   * For example, if the image is 100x100 pixels, there will be 40,000. With
   * pixelDensity = 2, there will be 160,000. The first four values
   * (indices 0-3) in the array will be the R, G, B, A values of the pixel at
   * (0, 0). The second four values (indices 4-7) will contain the R, G, B, A
   * values of the pixel at (1, 0). More generally, to set values for a pixel
   * at (x, y):
   * ```javascript
   * var d = pixelDensity;
   * for (var i = 0; i < d; i++) {
   *   for (var j = 0; j < d; j++) {
   *     // loop over
   *     idx = 4 * ((y * d + j) * width * d + (x * d + i));
   *     pixels[idx] = r;
   *     pixels[idx+1] = g;
   *     pixels[idx+2] = b;
   *     pixels[idx+3] = a;
   *   }
   * }
   * ```
   * <br><br>
   * Before accessing this array, the data must loaded with the loadPixels()
   * function. After the array data has been modified, the updatePixels()
   * function must be run to update the changes.
   * @property {Number[]} pixels
   * @example
   * <div>
   * <code>
   * img = createImage(66, 66);
   * img.loadPixels();
   * for (i = 0; i < img.width; i++) {
   *   for (j = 0; j < img.height; j++) {
   *     img.set(i, j, color(0, 90, 102));
   *   }
   * }
   * img.updatePixels();
   * image(img, 17, 17);
   * </code>
   * </div>
   * <div>
   * <code>
   * var pink = color(255, 102, 204);
   * img = createImage(66, 66);
   * img.loadPixels();
   * for (var i = 0; i < 4*(width*height/2); i+=4) {
   *   img.pixels[i] = red(pink);
   *   img.pixels[i+1] = green(pink);
   *   img.pixels[i+2] = blue(pink);
   *   img.pixels[i+3] = alpha(pink);
   * }
   * img.updatePixels();
   * image(img, 17, 17);
   * </code>
   * </div>
   *
   * @alt
   * 66x66 turquoise rect in center of canvas
   * 66x66 pink rect in center of canvas
   *
   */
  this.pixels = [];
};

/**
 * Helper fxn for sharing pixel methods
 *
 */
p5.Image.prototype._setProperty = function (prop, value) {
  this[prop] = value;
};

/**
 * Loads the pixels data for this image into the [pixels] attribute.
 *
 * @method loadPixels
 * @example
 * <div><code>
 * var myImage;
 * var halfImage;
 *
 * function preload() {
 *   myImage = loadImage("assets/rockies.jpg");
 * }
 *
 * function setup() {
 *   myImage.loadPixels();
 *   halfImage = 4 * width * height/2;
 *   for(var i = 0; i < halfImage; i++){
 *     myImage.pixels[i+halfImage] = myImage.pixels[i];
 *   }
 *   myImage.updatePixels();
 * }
 *
 * function draw() {
 *   image(myImage, 0, 0);
 * }
 * </code></div>
 *
   * @alt
   * 2 images of rocky mountains vertically stacked
   *
 */
p5.Image.prototype.loadPixels = function(){
  p5.Renderer2D.prototype.loadPixels.call(this);
};

/**
 * Updates the backing canvas for this image with the contents of
 * the [pixels] array.
 *
 * @method updatePixels
 * @param {Integer|undefined} x x-offset of the target update area for the
 *                              underlying canvas
 * @param {Integer|undefined} y y-offset of the target update area for the
 *                              underlying canvas
 * @param {Integer|undefined} w height of the target update area for the
 *                              underlying canvas
 * @param {Integer|undefined} h height of the target update area for the
 *                              underlying canvas
 * @example
 * <div><code>
 * var myImage;
 * var halfImage;
 *
 * function preload() {
 *   myImage = loadImage("assets/rockies.jpg");
 * }
 *
 * function setup() {
 *   myImage.loadPixels();
 *   halfImage = 4 * width * height/2;
 *   for(var i = 0; i < halfImage; i++){
 *     myImage.pixels[i+halfImage] = myImage.pixels[i];
 *   }
 *   myImage.updatePixels();
 * }
 *
 * function draw() {
 *   image(myImage, 0, 0);
 * }
 * </code></div>
 *
 * @alt
 * 2 images of rocky mountains vertically stacked
 *
 */
p5.Image.prototype.updatePixels = function(x, y, w, h){
  p5.Renderer2D.prototype.updatePixels.call(this, x, y, w, h);
};

/**
 * Get a region of pixels from an image.
 *
 * If no params are passed, those whole image is returned,
 * if x and y are the only params passed a single pixel is extracted
 * if all params are passed a rectangle region is extracted and a p5.Image
 * is returned.
 *
 * Returns undefined if the region is outside the bounds of the image
 *
 * @method get
 * @param  {Number}               [x] x-coordinate of the pixel
 * @param  {Number}               [y] y-coordinate of the pixel
 * @param  {Number}               [w] width
 * @param  {Number}               [h] height
 * @return {Array|Color|p5.Image}     color of pixel at x,y in array format
 *                                    [R, G, B, A] or p5.Image
 * @example
 * <div><code>
 * var myImage;
 * var c;
 *
 * function preload() {
 *   myImage = loadImage("assets/rockies.jpg");
 * }
 *
 * function setup() {
 *   background(myImage);
 *   noStroke();
 *   c = myImage.get(60, 90);
 *   fill(c);
 *   rect(25, 25, 50, 50);
 * }
 *
 * //get() returns color here
 * </code></div>
 *
 * @alt
 * image of rocky mountains with 50x50 green rect in front
 *
 */
p5.Image.prototype.get = function(x, y, w, h){
  return p5.Renderer2D.prototype.get.call(this, x, y, w, h);
};

/**
 * Set the color of a single pixel or write an image into
 * this p5.Image.
 *
 * Note that for a large number of pixels this will
 * be slower than directly manipulating the pixels array
 * and then calling updatePixels().
 *
 * @method set
 * @param {Number}              x x-coordinate of the pixel
 * @param {Number}              y y-coordinate of the pixel
 * @param {Number|Array|Object}   a grayscale value | pixel array |
 *                                a p5.Color | image to copy
 * @example
 * <div>
 * <code>
 * img = createImage(66, 66);
 * img.loadPixels();
 * for (i = 0; i < img.width; i++) {
 *   for (j = 0; j < img.height; j++) {
 *     img.set(i, j, color(0, 90, 102, i % img.width * 2));
 *   }
 * }
 * img.updatePixels();
 * image(img, 17, 17);
 * image(img, 34, 34);
 * </code>
 * </div>
 *
 * @alt
 * 2 gradated dark turquoise rects fade left. 1 center 1 bottom right of canvas
 *
 */
p5.Image.prototype.set = function(x, y, imgOrCol){
  p5.Renderer2D.prototype.set.call(this, x, y, imgOrCol);
};

/**
 * Resize the image to a new width and height. To make the image scale
 * proportionally, use 0 as the value for the wide or high parameter.
 * For instance, to make the width of an image 150 pixels, and change
 * the height using the same proportion, use resize(150, 0).
 *
 * @method resize
 * @param {Number} width the resized image width
 * @param {Number} height the resized image height
 * @example
 * <div><code>
 * var img;
 *
 * function setup() {
 *   img = loadImage("assets/rockies.jpg");
 * }

 * function draw() {
 *   image(img, 0, 0);
 * }
 *
 * function mousePressed() {
 *   img.resize(50, 100);
 * }
 * </code></div>
 *
 * @alt
 * image of rocky mountains. zoomed in
 *
 */
p5.Image.prototype.resize = function(width, height){

  // Copy contents to a temporary canvas, resize the original
  // and then copy back.
  //
  // There is a faster approach that involves just one copy and swapping the
  // this.canvas reference. We could switch to that approach if (as i think
  // is the case) there an expectation that the user would not hold a
  // reference to the backing canvas of a p5.Image. But since we do not
  // enforce that at the moment, I am leaving in the slower, but safer
  // implementation.

  // auto-resize
  if (width === 0 && height === 0) {
    width = this.canvas.width;
    height = this.canvas.height;
  } else if (width === 0) {
    width = this.canvas.width * height / this.canvas.height;
  } else if (height === 0) {
    height = this.canvas.height * width / this.canvas.width;
  }

  width = Math.floor(width);
  height = Math.floor(height);

  var tempCanvas = document.createElement('canvas');
  tempCanvas.width = width;
  tempCanvas.height = height;
  tempCanvas.getContext('2d').drawImage(this.canvas,
    0, 0, this.canvas.width, this.canvas.height,
    0, 0, tempCanvas.width, tempCanvas.height
  );


  // Resize the original canvas, which will clear its contents
  this.canvas.width = this.width = width;
  this.canvas.height = this.height = height;

  //Copy the image back

  this.drawingContext.drawImage(tempCanvas,
    0, 0, width, height,
    0, 0, width, height
  );

  if(this.pixels.length > 0){
    this.loadPixels();
  }
};

/**
 * Copies a region of pixels from one image to another. If no
 * srcImage is specified this is used as the source. If the source
 * and destination regions aren't the same size, it will
 * automatically resize source pixels to fit the specified
 * target region.
 *
 * @method copy
 * @param  {p5.Image|undefined} srcImage source image
 * @param  {Integer} sx X coordinate of the source's upper left corner
 * @param  {Integer} sy Y coordinate of the source's upper left corner
 * @param  {Integer} sw source image width
 * @param  {Integer} sh source image height
 * @param  {Integer} dx X coordinate of the destination's upper left corner
 * @param  {Integer} dy Y coordinate of the destination's upper left corner
 * @param  {Integer} dw destination image width
 * @param  {Integer} dh destination image height
 * @example
 * <div><code>
 * var photo;
 * var bricks;
 * var x;
 * var y;
 *
 * function preload() {
 *   photo = loadImage("assets/rockies.jpg");
 *   bricks = loadImage("assets/bricks.jpg");
 * }
 *
 * function setup() {
 *   x = bricks.width/2;
 *   y = bricks.height/2;
 *   photo.copy(bricks, 0, 0, x, y, 0, 0, x, y);
 *   image(photo, 0, 0);
 * }
 * </code></div>
 *
 * @alt
 * image of rocky mountains and smaller image on top of bricks at top left
 *
 */
p5.Image.prototype.copy = function () {
  p5.prototype.copy.apply(this, arguments);
};

/**
 * Masks part of an image from displaying by loading another
 * image and using it's alpha channel as an alpha channel for
 * this image.
 *
 * @method mask
 * @param {p5.Image} srcImage source image
 * @example
 * <div><code>
 * var photo, maskImage;
 * function preload() {
 *   photo = loadImage("assets/rockies.jpg");
 *   maskImage = loadImage("assets/mask2.png");
 * }
 *
 * function setup() {
 *   createCanvas(100, 100);
 *   photo.mask(maskImage);
 *   image(photo, 0, 0);
 * }
 * </code></div>
 *
 * @alt
 * image of rocky mountains with white at right
 *
 *
 * http://blogs.adobe.com/webplatform/2013/01/28/blending-features-in-canvas/
 *
 */
// TODO: - Accept an array of alpha values.
//       - Use other channels of an image. p5 uses the
//       blue channel (which feels kind of arbitrary). Note: at the
//       moment this method does not match native processings original
//       functionality exactly.
p5.Image.prototype.mask = function(p5Image) {
  if(p5Image === undefined){
    p5Image = this;
  }
  var currBlend = this.drawingContext.globalCompositeOperation;

  var scaleFactor = 1;
  if (p5Image instanceof p5.Renderer) {
    scaleFactor = p5Image._pInst._pixelDensity;
  }

  var copyArgs = [
    p5Image,
    0,
    0,
    scaleFactor*p5Image.width,
    scaleFactor*p5Image.height,
    0,
    0,
    this.width,
    this.height
  ];

  this.drawingContext.globalCompositeOperation = 'destination-in';
  p5.Image.prototype.copy.apply(this, copyArgs);
  this.drawingContext.globalCompositeOperation = currBlend;
};

/**
 * Applies an image filter to a p5.Image
 *
 * @method filter
 * @param {String} operation one of threshold, gray, invert, posterize, opaque
 *                           erode, dilate and blur. See Filters.js for docs on
 *                           each available filter
 * @param {Number|undefined} value
 * @example
 * <div><code>
 * var photo1;
 * var photo2;
 *
 * function preload() {
 *   photo1 = loadImage("assets/rockies.jpg");
 *   photo2 = loadImage("assets/rockies.jpg");
 * }
 *
 * function setup() {
 *   photo2.filter("gray");
 *   image(photo1, 0, 0);
 *   image(photo2, width/2, 0);
 * }
 * </code></div>
 *
 * @alt
 * 2 images of rocky mountains left one in color, right in black and white
 *
 */
p5.Image.prototype.filter = function(operation, value) {
  Filters.apply(this.canvas, Filters[operation.toLowerCase()], value);
};

/**
 * Copies a region of pixels from one image to another, using a specified
 * blend mode to do the operation.
 *
 * @method blend
 * @param  {p5.Image|undefined} srcImage source image
 * @param  {Integer} sx X coordinate of the source's upper left corner
 * @param  {Integer} sy Y coordinate of the source's upper left corner
 * @param  {Integer} sw source image width
 * @param  {Integer} sh source image height
 * @param  {Integer} dx X coordinate of the destination's upper left corner
 * @param  {Integer} dy Y coordinate of the destination's upper left corner
 * @param  {Integer} dw destination image width
 * @param  {Integer} dh destination image height
 * @param  {Integer} blendMode the blend mode
 *
 * Available blend modes are: normal | multiply | screen | overlay |
 *            darken | lighten | color-dodge | color-burn | hard-light |
 *            soft-light | difference | exclusion | hue | saturation |
 *            color | luminosity
 *
 *
 * http://blogs.adobe.com/webplatform/2013/01/28/blending-features-in-canvas/
 * @example
 * <div><code>
 * var mountains;
 * var bricks;
 *
 * function preload() {
 *   mountains = loadImage("assets/rockies.jpg");
 *   bricks = loadImage("assets/bricks_third.jpg");
 * }
 *
 * function setup() {
 *   mountains.blend(bricks, 0, 0, 33, 100, 67, 0, 33, 100, ADD);
 *   image(mountains, 0, 0);
 *   image(bricks, 0, 0);
 * }
 * </code></div>
 * <div><code>
 * var mountains;
 * var bricks;
 *
 * function preload() {
 *   mountains = loadImage("assets/rockies.jpg");
 *   bricks = loadImage("assets/bricks_third.jpg");
 * }
 *
 * function setup() {
 *   mountains.blend(bricks, 0, 0, 33, 100, 67, 0, 33, 100, DARKEST);
 *   image(mountains, 0, 0);
 *   image(bricks, 0, 0);
 * }
 * </code></div>
 * <div><code>
 * var mountains;
 * var bricks;
 *
 * function preload() {
 *   mountains = loadImage("assets/rockies.jpg");
 *   bricks = loadImage("assets/bricks_third.jpg");
 * }
 *
 * function setup() {
 *   mountains.blend(bricks, 0, 0, 33, 100, 67, 0, 33, 100, LIGHTEST);
 *   image(mountains, 0, 0);
 *   image(bricks, 0, 0);
 * }
 * </code></div>
 *
 * @alt
 * image of rocky mountains. Brick images on left and right. Right overexposed
 * image of rockies. Brickwall images on left and right. Right mortar transparent
 * image of rockies. Brickwall images on left and right. Right translucent
 *
 */
p5.Image.prototype.blend = function() {
  p5.prototype.blend.apply(this, arguments);
};

/**
 * Saves the image to a file and force the browser to download it.
 * Accepts two strings for filename and file extension
 * Supports png (default) and jpg.
 *
 * @method save
 * @param {String} filename give your file a name
 * @param  {String} extension 'png' or 'jpg'
 * @example
 * <div><code>
 * var photo;
 *
 * function preload() {
 *   photo = loadImage("assets/rockies.jpg");
 * }
 *
 * function draw() {
 *   image(photo, 0, 0);
 * }
 *
 * function keyTyped() {
 *   if (key == 's') {
 *     photo.save("photo", "png");
 *   }
 * }
 * </code></div>
 *
 * @alt
 * image of rocky mountains.
 *
 */
p5.Image.prototype.save = function(filename, extension) {
  var mimeType;
  if (!extension) {
    extension = 'png';
    mimeType = 'image/png';
  }
  else {
    // en.wikipedia.org/wiki/Comparison_of_web_browsers#Image_format_support
    switch(extension.toLowerCase()){
      case 'png':
        mimeType = 'image/png';
        break;
      case 'jpeg':
        mimeType = 'image/jpeg';
        break;
      case 'jpg':
        mimeType = 'image/jpeg';
        break;
      default:
        mimeType = 'image/png';
        break;
    }
  }
  var downloadMime = 'image/octet-stream';
  var imageData = this.canvas.toDataURL(mimeType);
  imageData = imageData.replace(mimeType, downloadMime);

  //Make the browser download the file
  p5.prototype.downloadFile(imageData, filename, extension);
};

module.exports = p5.Image;
},{"../core/core":42,"./filters":59}],63:[function(_dereq_,module,exports){
/**
 * @module Image
 * @submodule Pixels
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');
var Filters = _dereq_('./filters');
_dereq_('../color/p5.Color');

/**
 * <a href='https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference
 * /Global_Objects/Uint8ClampedArray' target='_blank'>Uint8ClampedArray</a>
 * containing the values for all the pixels in the display window.
 * These values are numbers. This array is the size (include an appropriate
 * factor for pixelDensity) of the display window x4,
 * representing the R, G, B, A values in order for each pixel, moving from
 * left to right across each row, then down each column. Retina and other
 * high density displays will have more pixels[] (by a factor of
 * pixelDensity^2).
 * For example, if the image is 100x100 pixels, there will be 40,000. On a
 * retina display, there will be 160,000.
 * <br><br>
 * The first four values (indices 0-3) in the array will be the R, G, B, A
 * values of the pixel at (0, 0). The second four values (indices 4-7) will
 * contain the R, G, B, A values of the pixel at (1, 0). More generally, to
 * set values for a pixel at (x, y):
 * ```javascript
 * var d = pixelDensity;
 * for (var i = 0; i < d; i++) {
 *   for (var j = 0; j < d; j++) {
 *     // loop over
 *     idx = 4 * ((y * d + j) * width * d + (x * d + i));
 *     pixels[idx] = r;
 *     pixels[idx+1] = g;
 *     pixels[idx+2] = b;
 *     pixels[idx+3] = a;
 *   }
 * }
 * ```
 * <p>While the above method is complex, it is flexible enough to work with
 * any pixelDensity. Note that set() will automatically take care of
 * setting all the appropriate values in pixels[] for a given (x, y) at
 * any pixelDensity, but the performance may not be as fast when lots of
 * modifications are made to the pixel array.
 * <br><br>
 * Before accessing this array, the data must loaded with the loadPixels()
 * function. After the array data has been modified, the updatePixels()
 * function must be run to update the changes.
 * <br><br>
 * Note that this is not a standard javascript array.  This means that
 * standard javascript functions such as <code>slice()</code> or
 * <code>arrayCopy()</code> do not
 * work.</p>
 *
 * @property {Number[]} pixels
 * @example
 * <div>
 * <code>
 * var pink = color(255, 102, 204);
 * loadPixels();
 * var d = pixelDensity();
 * var halfImage = 4 * (width * d) * (height/2 * d);
 * for (var i = 0; i < halfImage; i+=4) {
 *   pixels[i] = red(pink);
 *   pixels[i+1] = green(pink);
 *   pixels[i+2] = blue(pink);
 *   pixels[i+3] = alpha(pink);
 * }
 * updatePixels();
 * </code>
 * </div>
 *
 * @alt
 * top half of canvas pink, bottom grey
 *
 */
p5.prototype.pixels = [];

/**
 * Copies a region of pixels from one image to another, using a specified
 * blend mode to do the operation.<br><br>
 * Available blend modes are: BLEND | DARKEST | LIGHTEST | DIFFERENCE |
 * MULTIPLY| EXCLUSION | SCREEN | REPLACE | OVERLAY | HARD_LIGHT |
 * SOFT_LIGHT | DODGE | BURN | ADD | NORMAL
 *
 *
 * @method blend
 * @param  {p5.Image|undefined} srcImage source image
 * @param  {Integer} sx X coordinate of the source's upper left corner
 * @param  {Integer} sy Y coordinate of the source's upper left corner
 * @param  {Integer} sw source image width
 * @param  {Integer} sh source image height
 * @param  {Integer} dx X coordinate of the destination's upper left corner
 * @param  {Integer} dy Y coordinate of the destination's upper left corner
 * @param  {Integer} dw destination image width
 * @param  {Integer} dh destination image height
 * @param  {Integer} blendMode the blend mode
 *
 * @example
 * <div><code>
 * var img0;
 * var img1;
 *
 * function preload() {
 *   img0 = loadImage("assets/rockies.jpg");
 *   img1 = loadImage("assets/bricks_third.jpg");
 * }
 *
 * function setup() {
 *   background(img0);
 *   image(img1, 0, 0);
 *   blend(img1, 0, 0, 33, 100, 67, 0, 33, 100, LIGHTEST);
 * }
 * </code></div>
 * <div><code>
 * var img0;
 * var img1;
 *
 * function preload() {
 *   img0 = loadImage("assets/rockies.jpg");
 *   img1 = loadImage("assets/bricks_third.jpg");
 * }
 *
 * function setup() {
 *   background(img0);
 *   image(img1, 0, 0);
 *   blend(img1, 0, 0, 33, 100, 67, 0, 33, 100, DARKEST);
 * }
 * </code></div>
 * <div><code>
 * var img0;
 * var img1;
 *
 * function preload() {
 *   img0 = loadImage("assets/rockies.jpg");
 *   img1 = loadImage("assets/bricks_third.jpg");
 * }
 *
 * function setup() {
 *   background(img0);
 *   image(img1, 0, 0);
 *   blend(img1, 0, 0, 33, 100, 67, 0, 33, 100, ADD);
 * }
 * </code></div>
 *
 * @alt
 * image of rocky mountains. Brick images on left and right. Right overexposed
 * image of rockies. Brickwall images on left and right. Right mortar transparent
 * image of rockies. Brickwall images on left and right. Right translucent
 *
 *
 */
p5.prototype.blend = function() {
  if (this._renderer) {
    this._renderer.blend.apply(this._renderer, arguments);
  } else {
    p5.Renderer2D.prototype.blend.apply(this, arguments);
  }
};

/**
 * Copies a region of the canvas to another region of the canvas
 * and copies a region of pixels from an image used as the srcImg parameter
 * into the canvas srcImage is specified this is used as the source. If
 * the source and destination regions aren't the same size, it will
 * automatically resize source pixels to fit the specified
 * target region.
 *
 * @method copy
 * @param  {p5.Image|undefined} srcImage source image
 * @param  {Integer} sx X coordinate of the source's upper left corner
 * @param  {Integer} sy Y coordinate of the source's upper left corner
 * @param  {Integer} sw source image width
 * @param  {Integer} sh source image height
 * @param  {Integer} dx X coordinate of the destination's upper left corner
 * @param  {Integer} dy Y coordinate of the destination's upper left corner
 * @param  {Integer} dw destination image width
 * @param  {Integer} dh destination image height
 *
 * @example
 * <div><code>
 * var img;
 *
 * function preload() {
 *   img = loadImage("assets/rockies.jpg");
 * }
 *
 * function setup() {
 *   background(img);
 *   copy(img, 7, 22, 10, 10, 35, 25, 50, 50);
 *   stroke(255);
 *   noFill();
 *   // Rectangle shows area being copied
 *   rect(7, 22, 10, 10);
 * }
 * </code></div>
 *
 * @alt
 * image of rocky mountains. Brick images on left and right. Right overexposed
 * image of rockies. Brickwall images on left and right. Right mortar transparent
 * image of rockies. Brickwall images on left and right. Right translucent
 *
 */
p5.prototype.copy = function () {
  p5.Renderer2D._copyHelper.apply(this, arguments);
};

/**
 * Applies a filter to the canvas.
 * <br><br>
 *
 * The presets options are:
 * <br><br>
 *
 * THRESHOLD
 * Converts the image to black and white pixels depending if they are above or
 * below the threshold defined by the level parameter. The parameter must be
 * between 0.0 (black) and 1.0 (white). If no level is specified, 0.5 is used.
 * <br><br>
 *
 * GRAY
 * Converts any colors in the image to grayscale equivalents. No parameter
 * is used.
 * <br><br>
 *
 * OPAQUE
 * Sets the alpha channel to entirely opaque. No parameter is used.
 * <br><br>
 *
 * INVERT
 * Sets each pixel to its inverse value. No parameter is used.
 * <br><br>
 *
 * POSTERIZE
 * Limits each channel of the image to the number of colors specified as the
 * parameter. The parameter can be set to values between 2 and 255, but
 * results are most noticeable in the lower ranges.
 * <br><br>
 *
 * BLUR
 * Executes a Guassian blur with the level parameter specifying the extent
 * of the blurring. If no parameter is used, the blur is equivalent to
 * Guassian blur of radius 1. Larger values increase the blur.
 * <br><br>
 *
 * ERODE
 * Reduces the light areas. No parameter is used.
 * <br><br>
 *
 * DILATE
 * Increases the light areas. No parameter is used.
 *
 * @method filter
 * @param  {Constant} filterType
 * @param  {Number} filterParam an optional parameter unique
 *  to each filter, see above
 *
 *
 * @example
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage("assets/bricks.jpg");
 * }
 * function setup() {
 *  image(img, 0, 0);
 *  filter(THRESHOLD);
 * }
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage("assets/bricks.jpg");
 * }
 * function setup() {
 *  image(img, 0, 0);
 *  filter(GRAY);
 * }
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage("assets/bricks.jpg");
 * }
 * function setup() {
 *  image(img, 0, 0);
 *  filter(OPAQUE);
 * }
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage("assets/bricks.jpg");
 * }
 * function setup() {
 *  image(img, 0, 0);
 *  filter(INVERT);
 * }
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage("assets/bricks.jpg");
 * }
 * function setup() {
 *  image(img, 0, 0);
 *  filter(POSTERIZE,3);
 * }
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage("assets/bricks.jpg");
 * }
 * function setup() {
 *  image(img, 0, 0);
 *  filter(DILATE);
 * }
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage("assets/bricks.jpg");
 * }
 * function setup() {
 *  image(img, 0, 0);
 *  filter(BLUR,3);
 * }
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage("assets/bricks.jpg");
 * }
 * function setup() {
 *  image(img, 0, 0);
 *  filter(ERODE);
 * }
 * </code>
 * </div>
 *
 * @alt
 * black and white image of a brick wall.
 * greyscale image of a brickwall
 * image of a brickwall
 * jade colored image of a brickwall
 * red and pink image of a brickwall
 * image of a brickwall
 * blurry image of a brickwall
 * image of a brickwall
 * image of a brickwall with less detail
 *
 */
p5.prototype.filter = function(operation, value) {
  if(this.canvas !== undefined) {
    Filters.apply(this.canvas, Filters[operation.toLowerCase()], value);
  }
  else {
    Filters.apply(this.elt, Filters[operation.toLowerCase()], value);
  }
};

/**
 * Returns an array of [R,G,B,A] values for any pixel or grabs a section of
 * an image. If no parameters are specified, the entire image is returned.
 * Use the x and y parameters to get the value of one pixel. Get a section of
 * the display window by specifying additional w and h parameters. When
 * getting an image, the x and y parameters define the coordinates for the
 * upper-left corner of the image, regardless of the current imageMode().
 * <br><br>
 * If the pixel requested is outside of the image window, [0,0,0,255] is
 * returned. To get the numbers scaled according to the current color ranges
 * and taking into account colorMode, use getColor instead of get.
 * <br><br>
 * Getting the color of a single pixel with get(x, y) is easy, but not as fast
 * as grabbing the data directly from pixels[]. The equivalent statement to
 * get(x, y) using pixels[] with pixel density d is
 * <code>
 * var off = (y * width + x) * d * 4;
 * [pixels[off],
 * pixels[off+1],
 * pixels[off+2],
 * pixels[off+3]]</code>
 * <br><br>
 * See the reference for pixels[] for more information.
 *
 * @method get
 * @param  {Number}         [x] x-coordinate of the pixel
 * @param  {Number}         [y] y-coordinate of the pixel
 * @param  {Number}         [w] width
 * @param  {Number}         [h] height
 * @return {Array|p5.Image}     values of pixel at x,y in array format
 *                              [R, G, B, A] or p5.Image
 * @example
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage("assets/rockies.jpg");
 * }
 * function setup() {
 *   image(img, 0, 0);
 *   var c = get();
 *   image(c, width/2, 0);
 * }
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage("assets/rockies.jpg");
 * }
 * function setup() {
 *   image(img, 0, 0);
 *   var c = get(50, 90);
 *   fill(c);
 *   noStroke();
 *   rect(25, 25, 50, 50);
 * }
 * </code>
 * </div>
 *
 * @alt
 * 2 images of the rocky mountains, side-by-side
 * Image of the rocky mountains with 50x50 green rect in center of canvas
 *
 */
p5.prototype.get = function(x, y, w, h){
  return this._renderer.get(x, y, w, h);
};

/**
 * Loads the pixel data for the display window into the pixels[] array. This
 * function must always be called before reading from or writing to pixels[].
 * Note that only changes made with set() or direct manipulation of pixels[]
 * will occur.
 *
 * @method loadPixels
 * @example
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage("assets/rockies.jpg");
 * }
 *
 * function setup() {
 *   image(img, 0, 0);
 *   var d = pixelDensity();
 *   var halfImage = 4 * (img.width * d) *
       (img.height/2 * d);
 *   loadPixels();
 *   for (var i = 0; i < halfImage; i++) {
 *     pixels[i+halfImage] = pixels[i];
 *   }
 *   updatePixels();
 * }
 * </code>
 * </div>
 *
 * @alt
 * two images of the rocky mountains. one on top, one on bottom of canvas.
 *
 */
p5.prototype.loadPixels = function() {
  this._renderer.loadPixels();
};

/**
 * <p>Changes the color of any pixel, or writes an image directly to the
 * display window.</p>
 * <p>The x and y parameters specify the pixel to change and the c parameter
 * specifies the color value. This can be a p5.Color object, or [R, G, B, A]
 * pixel array. It can also be a single grayscale value.
 * When setting an image, the x and y parameters define the coordinates for
 * the upper-left corner of the image, regardless of the current imageMode().
 * </p>
 * <p>
 * After using set(), you must call updatePixels() for your changes to appear.
 * This should be called once all pixels have been set, and must be called before
 * calling .get() or drawing the image.
 * </p>
 * <p>Setting the color of a single pixel with set(x, y) is easy, but not as
 * fast as putting the data directly into pixels[]. Setting the pixels[]
 * values directly may be complicated when working with a retina display,
 * but will perform better when lots of pixels need to be set directly on
 * every loop.</p>
 * <p>See the reference for pixels[] for more information.</p>
 *
 * @method set
 * @param {Number}              x x-coordinate of the pixel
 * @param {Number}              y y-coordinate of the pixel
 * @param {Number|Array|Object} c insert a grayscale value | a pixel array |
 *                                a p5.Color object | a p5.Image to copy
 * @example
 * <div>
 * <code>
 * var black = color(0);
 * set(30, 20, black);
 * set(85, 20, black);
 * set(85, 75, black);
 * set(30, 75, black);
 * updatePixels();
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * for (var i = 30; i < width-15; i++) {
 *   for (var j = 20; j < height-25; j++) {
 *     var c = color(204-j, 153-i, 0);
 *     set(i, j, c);
 *   }
 * }
 * updatePixels();
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage("assets/rockies.jpg");
 * }
 *
 * function setup() {
 *   set(0, 0, img);
 *   updatePixels();
 *   line(0, 0, width, height);
 *   line(0, height, width, 0);
 * }
 * </code>
 * </div>
 *
 * @alt
 * 4 black points in the shape of a square middle-right of canvas.
 * square with orangey-brown gradient lightening at bottom right.
 * image of the rocky mountains. with lines like an 'x' through the center.
 */
p5.prototype.set = function (x, y, imgOrCol) {
  this._renderer.set(x, y, imgOrCol);
};
/**
 * Updates the display window with the data in the pixels[] array.
 * Use in conjunction with loadPixels(). If you're only reading pixels from
 * the array, there's no need to call updatePixels() — updating is only
 * necessary to apply changes. updatePixels() should be called anytime the
 * pixels array is manipulated or set() is called, and only changes made with
 * set() or direct changes to pixels[] will occur.
 *
 * @method updatePixels
 * @param  {Number} [x]    x-coordinate of the upper-left corner of region
 *                         to update
 * @param  {Number} [y]    y-coordinate of the upper-left corner of region
 *                         to update
 * @param  {Number} [w]    width of region to update
 * @param  {Number} [h]    height of region to update
 * @example
 * <div>
 * <code>
 * var img;
 * function preload() {
 *   img = loadImage("assets/rockies.jpg");
 * }
 *
 * function setup() {
 *   image(img, 0, 0);
 *   var halfImage = 4 * (img.width * pixelDensity()) *
 *     (img.height * pixelDensity()/2);
 *   loadPixels();
 *   for (var i = 0; i < halfImage; i++) {
 *     pixels[i+halfImage] = pixels[i];
 *   }
 *   updatePixels();
 * }
 * </code>
 * </div>
 * @alt
 * two images of the rocky mountains. one on top, one on bottom of canvas.
 */
p5.prototype.updatePixels = function (x, y, w, h) {
  // graceful fail - if loadPixels() or set() has not been called, pixel
  // array will be empty, ignore call to updatePixels()
  if (this.pixels.length === 0) {
    return;
  }
  this._renderer.updatePixels(x, y, w, h);
};

module.exports = p5;

},{"../color/p5.Color":36,"../core/core":42,"./filters":59}],64:[function(_dereq_,module,exports){
/**
 * @module IO
 * @submodule Input
 * @for p5
 * @requires core
 */

/* globals Request: false */
/* globals Headers: false */

'use strict';

var p5 = _dereq_('../core/core');
var opentype = _dereq_('opentype.js');
_dereq_('whatwg-fetch');
_dereq_('es6-promise').polyfill();
var fetchJsonp = _dereq_('fetch-jsonp');
_dereq_('../core/error_helpers');

/**
 * Checks if we are in preload and returns the last arg which will be the
 * _decrementPreload function if called from a loadX() function.  Should
 * only be used in loadX() functions.
 * @private
 */
p5._getDecrementPreload = function () {
  var decrementPreload = arguments[arguments.length - 1];

  // when in preload decrementPreload will always be the last arg as it is set
  // with args.push() before invocation in _wrapPreload
  if ((window.preload || (this && this.preload)) &&
    typeof decrementPreload === 'function') {
    return decrementPreload;
  } else {
    return null;
  }
};

/**
 * Loads an opentype font file (.otf, .ttf) from a file or a URL,
 * and returns a PFont Object. This method is asynchronous,
 * meaning it may not finish before the next line in your sketch
 * is executed.
 * <br><br>
 * The path to the font should be relative to the HTML file
 * that links in your sketch. Loading an from a URL or other
 * remote location may be blocked due to your browser's built-in
 * security.
 *
 * @method loadFont
 * @param  {String}        path       name of the file or url to load
 * @param  {Function}      [callback] function to be executed after
 *                                    loadFont()
 *                                    completes
 * @return {Object}                   p5.Font object
 * @example
 *
 * <p>Calling loadFont() inside preload() guarantees that the load
 * operation will have completed before setup() and draw() are called.</p>
 *
 * <div><code>
 * var myFont;
 * function preload() {
 *   myFont = loadFont('assets/AvenirNextLTPro-Demi.otf');
 * }
 *
 * function setup() {
 *   fill('#ED225D');
 *   textFont(myFont);
 *   textSize(36);
 *   text('p5*js', 10, 50);
 * }
 * </code></div>
 *
 * Outside of preload(), you may supply a callback function to handle the
 * object:
 *
 * <div><code>
 * function setup() {
 *   loadFont('assets/AvenirNextLTPro-Demi.otf', drawText);
 * }
 *
 * function drawText(font) {
 *   fill('#ED225D');
 *   textFont(font, 36);
 *   text('p5*js', 10, 50);
 * }
 *
 * </code></div>
 *
 * <p>You can also use the string name of the font to style other HTML
 * elements.</p>
 *
 * <div><code>
 * var myFont;
 *
 * function preload() {
 *   myFont = loadFont('assets/Avenir.otf');
 * }
 *
 * function setup() {
 *   var myDiv = createDiv('hello there');
 *   myDiv.style('font-family', 'Avenir');
 * }
 * </code></div>
 *
 * @alt
 * p5*js in p5's theme dark pink
 * p5*js in p5's theme dark pink
 *
 */
p5.prototype.loadFont = function (path, onSuccess, onError) {

  var p5Font = new p5.Font(this);
  var decrementPreload = p5._getDecrementPreload.apply(this, arguments);

  opentype.load(path, function (err, font) {

    if (err) {

      if ((typeof onError !== 'undefined') && (onError !== decrementPreload)) {
        return onError(err);
      }
      p5._friendlyFileLoadError(4, path);
      console.error(err, path);
      return;
    }

    p5Font.font = font;

    if (typeof onSuccess !== 'undefined') {
      onSuccess(p5Font);
    }

    if (decrementPreload && (onSuccess !== decrementPreload)) {
      decrementPreload();
    }

    // check that we have an acceptable font type
    var validFontTypes = [ 'ttf', 'otf', 'woff', 'woff2' ],
      fileNoPath = path.split('\\').pop().split('/').pop(),
      lastDotIdx = fileNoPath.lastIndexOf('.'), fontFamily, newStyle,
      fileExt = lastDotIdx < 1 ? null : fileNoPath.substr(lastDotIdx + 1);

    // if so, add it to the DOM (name-only) for use with p5.dom
    if (validFontTypes.indexOf(fileExt) > -1) {

      fontFamily = fileNoPath.substr(0, lastDotIdx);
      newStyle = document.createElement('style');
      newStyle.appendChild(document.createTextNode('\n@font-face {' +
        '\nfont-family: ' + fontFamily + ';\nsrc: url(' + path + ');\n}\n'));
      document.head.appendChild(newStyle);
    }

  });

  return p5Font;
};


/**
 * Loads a JSON file from a file or a URL, and returns an Object or Array.
 * This method is asynchronous, meaning it may not finish before the next
 * line in your sketch is executed. JSONP is supported via a polyfill and you
 * can pass in as the second argument an object with definitions of the json
 * callback following the syntax specified <a href="https://github.com/camsong/
 * fetch-jsonp">here</a>.
 *
 * @method loadJSON
 * @param  {String}        path       name of the file or url to load
 * @param  {Object}        [jsonpOptions] options object for jsonp related settings
 * @param  {String}        [datatype] "json" or "jsonp"
 * @param  {Function}      [callback] function to be executed after
 *                                    loadJSON() completes, data is passed
 *                                    in as first argument
 * @param  {Function}      [errorCallback] function to be executed if
 *                                    there is an error, response is passed
 *                                    in as first argument
 * @return {Object|Array}             JSON data
 * @example
 *
 * <p>Calling loadJSON() inside preload() guarantees to complete the
 * operation before setup() and draw() are called.</p>
 *
 * <div><code>
 * // Examples use USGS Earthquake API:
 * //   https://earthquake.usgs.gov/fdsnws/event/1/#methods
 * var earthquakes;
 * function preload() {
 *   // Get the most recent earthquake in the database
 *   var url = 'https://earthquake.usgs.gov/fdsnws/event/1/query?' +
 *     'format=geojson&limit=1&orderby=time';
 *   earthquakes = loadJSON(url);
 * }
 *
 * function setup() {
 *   noLoop();
 * }
 *
 * function draw() {
 *   background(200);
 *   // Get the magnitude and name of the earthquake out of the loaded JSON
 *   var earthquakeMag = earthquakes.features[0].properties.mag;
 *   var earthquakeName = earthquakes.features[0].properties.place;
 *   ellipse(width/2, height/2, earthquakeMag * 10, earthquakeMag * 10);
 *   textAlign(CENTER);
 *   text(earthquakeName, 0, height - 30, width, 30);
 * }
 * </code></div>
 *
 *
 * <p>Outside of preload(), you may supply a callback function to handle the
 * object:</p>
 * <div><code>
 * function setup() {
 *   noLoop();
 *   var url = 'https://earthquake.usgs.gov/fdsnws/event/1/query?' +
 *     'format=geojson&limit=1&orderby=time';
 *   loadJSON(url, drawEarthquake);
 * }
 *
 * function draw() {
 *   background(200);
 * }
 *
 * function drawEarthquake(earthquakes) {
 *   // Get the magnitude and name of the earthquake out of the loaded JSON
 *   var earthquakeMag = earthquakes.features[0].properties.mag;
 *   var earthquakeName = earthquakes.features[0].properties.place;
 *   ellipse(width/2, height/2, earthquakeMag * 10, earthquakeMag * 10);
 *   textAlign(CENTER);
 *   text(earthquakeName, 0, height - 30, width, 30);
 * }
 * </code></div>
 *
 * @alt
 * 50x50 ellipse that changes from black to white depending on the current humidity
 * 50x50 ellipse that changes from black to white depending on the current humidity
 *
 */
p5.prototype.loadJSON = function () {
  var path = arguments[0];
  var callback;
  var errorCallback;
  var options;
  var decrementPreload = p5._getDecrementPreload.apply(this, arguments);

  var ret = {}; // object needed for preload
  var t = 'json';

  // check for explicit data type argument
  for (var i = 1; i < arguments.length; i++) {
    var arg = arguments[i];
    if (typeof arg === 'string') {
      if (arg === 'jsonp' || arg === 'json') {
        t = arg;
      }
    } else if (typeof arg === 'function' && arg !== decrementPreload) {
      if(!callback){
        callback = arg;
      }else{
        errorCallback = arg;
      }
    } else if (typeof arg === 'object' && arg.hasOwnProperty('jsonpCallback')){
      t = 'jsonp';
      options = arg;
    }
  }

  p5.prototype.httpDo(path, 'GET', options, t, function(resp){
    for (var k in resp) {
      ret[k] = resp[k];
    }
    if (typeof callback !== 'undefined') {
      callback(resp);
    }
    if (decrementPreload && (callback !== decrementPreload)) {
      decrementPreload();
    }
  }, errorCallback);

  return ret;
};

/**
 * Reads the contents of a file and creates a String array of its individual
 * lines. If the name of the file is used as the parameter, as in the above
 * example, the file must be located in the sketch directory/folder.
 * <br><br>
 * Alternatively, the file maybe be loaded from anywhere on the local
 * computer using an absolute path (something that starts with / on Unix and
 * Linux, or a drive letter on Windows), or the filename parameter can be a
 * URL for a file found on a network.
 * <br><br>
 * This method is asynchronous, meaning it may not finish before the next
 * line in your sketch is executed.
 *
 * @method loadStrings
 * @param  {String}   filename   name of the file or url to load
 * @param  {Function} [callback] function to be executed after loadStrings()
 *                               completes, Array is passed in as first
 *                               argument
 * @param  {Function} [errorCallback] function to be executed if
 *                               there is an error, response is passed
 *                               in as first argument
 * @return {Array}               Array of Strings
 * @example
 *
 * <p>Calling loadStrings() inside preload() guarantees to complete the
 * operation before setup() and draw() are called.</p>
 *
 * <div><code>
 * var result;
 * function preload() {
 *   result = loadStrings('assets/test.txt');
 * }

 * function setup() {
 *   background(200);
 *   var ind = floor(random(result.length));
 *   text(result[ind], 10, 10, 80, 80);
 * }
 * </code></div>
 *
 * <p>Outside of preload(), you may supply a callback function to handle the
 * object:</p>
 *
 * <div><code>
 * function setup() {
 *   loadStrings('assets/test.txt', pickString);
 * }
 *
 * function pickString(result) {
 *   background(200);
 *   var ind = floor(random(result.length));
 *   text(result[ind], 10, 10, 80, 80);
 * }
 * </code></div>
 *
 * @alt
 * randomly generated text from a file, for example "i smell like butter"
 * randomly generated text from a file, for example "i have three feet"
 *
 */
p5.prototype.loadStrings = function () {
  var ret = [];
  var decrementPreload = p5._getDecrementPreload.apply(this, arguments);
  var callback, errorCallback;

  for(var i=1; i<arguments.length; i++){
    var arg = arguments[i];
    if(typeof arg === 'function' && arg !== decrementPreload){
      if(typeof callback === 'undefined'){
        callback = arg;
      }else{
        errorCallback = arg;
      }
    }
  }

  p5.prototype.httpDo(arguments[0], 'GET', 'text', function(data){
    var arr = data.match(/[^\r\n]+/g);
    for (var k in arr) {
      ret[k] = arr[k];
    }

    if (typeof callback !== 'undefined') {
      callback(ret);
    }
    if (decrementPreload && (callback !== decrementPreload)) {
      decrementPreload();
    }
  }, errorCallback);

  return ret;
};

/**
 * <p>Reads the contents of a file or URL and creates a p5.Table object with
 * its values. If a file is specified, it must be located in the sketch's
 * "data" folder. The filename parameter can also be a URL to a file found
 * online. By default, the file is assumed to be comma-separated (in CSV
 * format). Table only looks for a header row if the 'header' option is
 * included.</p>
 *
 * <p>Possible options include:
 * <ul>
 * <li>csv - parse the table as comma-separated values</li>
 * <li>tsv - parse the table as tab-separated values</li>
 * <li>header - this table has a header (title) row</li>
 * </ul>
 * </p>
 *
 * <p>When passing in multiple options, pass them in as separate parameters,
 * seperated by commas. For example:
 * <br><br>
 * <code>
 *   loadTable("my_csv_file.csv", "csv", "header")
 * </code>
 * </p>
 *
 * <p> All files loaded and saved use UTF-8 encoding.</p>
 *
 * <p>This method is asynchronous, meaning it may not finish before the next
 * line in your sketch is executed. Calling loadTable() inside preload()
 * guarantees to complete the operation before setup() and draw() are called.
 * <p>Outside of preload(), you may supply a callback function to handle the
 * object:</p>
 * </p>
 *
 * @method loadTable
 * @param  {String}         filename   name of the file or URL to load
 * @param  {String} [options]  "header" "csv" "tsv"
 * @param  {Function}       [callback] function to be executed after
 *                                     loadTable() completes. On success, the
 *                                     Table object is passed in as the
 *                                     first argument.
 * @param  {Function}  [errorCallback] function to be executed if
 *                                     there is an error, response is passed
 *                                     in as first argument
 * @return {Object}                    Table object containing data
 *
 * @example
 * <div class="norender">
 * <code>
 * // Given the following CSV file called "mammals.csv"
 * // located in the project's "assets" folder:
 * //
 * // id,species,name
 * // 0,Capra hircus,Goat
 * // 1,Panthera pardus,Leopard
 * // 2,Equus zebra,Zebra
 *
 * var table;
 *
 * function preload() {
 *   //my table is comma separated value "csv"
 *   //and has a header specifying the columns labels
 *   table = loadTable("assets/mammals.csv", "csv", "header");
 *   //the file can be remote
 *   //table = loadTable("http://p5js.org/reference/assets/mammals.csv",
 *   //                  "csv", "header");
 * }
 *
 * function setup() {
 *   //count the columns
 *   print(table.getRowCount() + " total rows in table");
 *   print(table.getColumnCount() + " total columns in table");
 *
 *   print(table.getColumn("name"));
 *   //["Goat", "Leopard", "Zebra"]
 *
 *   //cycle through the table
 *   for (var r = 0; r < table.getRowCount(); r++)
 *     for (var c = 0; c < table.getColumnCount(); c++) {
 *       print(table.getString(r, c));
 *     }
 * }
 * </code>
 * </div>
 *
 * @alt
 * randomly generated text from a file, for example "i smell like butter"
 * randomly generated text from a file, for example "i have three feet"
 *
 */
p5.prototype.loadTable = function (path) {
  var callback = null;
  var errorCallback = null;
  var options = [];
  var header = false;
  var ext = path.substring(path.lastIndexOf('.')+1,path.length);
  var sep = ',';
  var separatorSet = false;
  var decrementPreload = p5._getDecrementPreload.apply(this, arguments);

  if(ext === 'tsv'){ //Only need to check extension is tsv because csv is default
    sep = '\t';
  }

  for (var i = 1; i < arguments.length; i++) {
    if ((typeof (arguments[i]) === 'function') &&
      (arguments[i] !== decrementPreload)) {
      if(!callback){
        callback = arguments[i];
      } else {
        errorCallback = arguments[i];
      }
    } else if (typeof (arguments[i]) === 'string') {
      options.push(arguments[i]);
      if (arguments[i] === 'header') {
        header = true;
      }
      if (arguments[i] === 'csv') {
        if (separatorSet) {
          throw new Error('Cannot set multiple separator types.');
        } else {
          sep = ',';
          separatorSet = true;
        }
      } else if (arguments[i] === 'tsv') {
        if (separatorSet) {
          throw new Error('Cannot set multiple separator types.');
        } else {
          sep = '\t';
          separatorSet = true;
        }
      }
    }
  }

  var t = new p5.Table();

  p5.prototype.httpDo(path, 'GET', 'text', function(resp){
    var state = {};

    // define constants
    var PRE_TOKEN = 0,
      MID_TOKEN = 1,
      POST_TOKEN = 2,
      POST_RECORD = 4;

    var QUOTE = '\"',
      CR = '\r',
      LF = '\n';

    var records = [];
    var offset = 0;
    var currentRecord = null;
    var currentChar;

    var tokenBegin = function () {
      state.currentState = PRE_TOKEN;
      state.token = '';
    };

    var tokenEnd = function () {
      currentRecord.push(state.token);
      tokenBegin();
    };

    var recordBegin = function () {
      state.escaped = false;
      currentRecord = [];
      tokenBegin();
    };

    var recordEnd = function () {
      state.currentState = POST_RECORD;
      records.push(currentRecord);
      currentRecord = null;
    };

    while (true) {
      currentChar = resp[offset++];

      // EOF
      if (currentChar == null) {
        if (state.escaped) {
          throw new Error('Unclosed quote in file.');
        }
        if (currentRecord) {
          tokenEnd();
          recordEnd();
          break;
        }
      }
      if (currentRecord === null) {
        recordBegin();
      }

      // Handle opening quote
      if (state.currentState === PRE_TOKEN) {
        if (currentChar === QUOTE) {
          state.escaped = true;
          state.currentState = MID_TOKEN;
          continue;
        }
        state.currentState = MID_TOKEN;
      }

      // mid-token and escaped, look for sequences and end quote
      if (state.currentState === MID_TOKEN && state.escaped) {
        if (currentChar === QUOTE) {
          if (resp[offset] === QUOTE) {
            state.token += QUOTE;
            offset++;
          } else {
            state.escaped = false;
            state.currentState = POST_TOKEN;
          }
        } else {
          state.token += currentChar;
        }
        continue;
      }

      // fall-through: mid-token or post-token, not escaped
      if (currentChar === CR) {
        if (resp[offset] === LF) {
          offset++;
        }
        tokenEnd();
        recordEnd();
      } else if (currentChar === LF) {
        tokenEnd();
        recordEnd();
      } else if (currentChar === sep) {
        tokenEnd();
      } else if (state.currentState === MID_TOKEN) {
        state.token += currentChar;
      }
    }

    // set up column names
    if (header) {
      t.columns = records.shift();
    } else {
      for (i = 0; i < records[0].length; i++) {
        t.columns[i] = 'null';
      }
    }
    var row;
    for (i = 0; i < records.length; i++) {
      //Handles row of 'undefined' at end of some CSVs
      if (records[i].length === 1) {
        if (records[i][0] === 'undefined' || records[i][0] === '') {
          continue;
        }
      }
      row = new p5.TableRow();
      row.arr = records[i];
      row.obj = makeObject(records[i], t.columns);
      t.addRow(row);
    }
    if (callback !== null) {
      callback(t);
    }
    if (decrementPreload && (callback !== decrementPreload)) {
      decrementPreload();
    }

  }, function(err){
    // Error handling
    p5._friendlyFileLoadError(2, path);

    if(errorCallback){
      errorCallback(err);
    }else{
      throw err;
    }
  });

  return t;
};

// helper function to turn a row into a JSON object
function makeObject(row, headers) {
  var ret = {};
  headers = headers || [];
  if (typeof (headers) === 'undefined') {
    for (var j = 0; j < row.length; j++) {
      headers[j.toString()] = j;
    }
  }
  for (var i = 0; i < headers.length; i++) {
    var key = headers[i];
    var val = row[i];
    ret[key] = val;
  }
  return ret;
}

/*global parseXML */
p5.prototype.parseXML = function (two) {
  var one = new p5.XML();
  var i;
  if (two.children.length) {
    for ( i = 0; i < two.children.length; i++ ) {
      var node = parseXML(two.children[i]);
      one.addChild(node);
    }
    one.setName(two.nodeName);
    one._setCont(two.textContent);
    one._setAttributes(two);
    for (var j = 0; j < one.children.length; j++) {
      one.children[j].parent = one;
    }
    return one;
  }
  else {
    one.setName(two.nodeName);
    one._setCont(two.textContent);
    one._setAttributes(two);
    return one;
  }
};

/**
 * Reads the contents of a file and creates an XML object with its values.
 * If the name of the file is used as the parameter, as in the above example,
 * the file must be located in the sketch directory/folder.
 *
 * Alternatively, the file maybe be loaded from anywhere on the local
 * computer using an absolute path (something that starts with / on Unix and
 * Linux, or a drive letter on Windows), or the filename parameter can be a
 * URL for a file found on a network.
 *
 * This method is asynchronous, meaning it may not finish before the next
 * line in your sketch is executed. Calling loadXML() inside preload()
 * guarantees to complete the operation before setup() and draw() are called.
 *
 * <p>Outside of preload(), you may supply a callback function to handle the
 * object:</p>
 *
 * @method loadXML
 * @param  {String}   filename   name of the file or URL to load
 * @param  {Function} [callback] function to be executed after loadXML()
 *                               completes, XML object is passed in as
 *                               first argument
 * @param  {Function} [errorCallback] function to be executed if
 *                               there is an error, response is passed
 *                               in as first argument
 * @return {Object}              XML object containing data
 */
p5.prototype.loadXML = function() {
  var ret = {};
  var decrementPreload = p5._getDecrementPreload.apply(this, arguments);
  var callback, errorCallback;

  for(var i=1; i<arguments.length; i++){
    var arg = arguments[i];
    if(typeof arg === 'function' && arg !== decrementPreload){
      if(typeof callback === 'undefined'){
        callback = arg;
      }else{
        errorCallback = arg;
      }
    }
  }

  p5.prototype.httpDo(arguments[0], 'GET', 'xml', function(xml){
    for(var key in xml) {
      ret[key] = xml[key];
    }
    if (typeof callback !== 'undefined') {
      callback(ret);
    }
    if (decrementPreload && (callback !== decrementPreload)) {
      decrementPreload();
    }
  }, errorCallback);

  return ret;
};


/**
 * Method for executing an HTTP GET request. If data type is not specified,
 * p5 will try to guess based on the URL, defaulting to text. This is equivalent to
 * calling <code>httpDo(path, 'GET')</code>.
 *
 * @method httpGet
 * @param  {String}        path       name of the file or url to load
 * @param  {String}        [datatype] "json", "jsonp", "xml", or "text"
 * @param  {Object}        [data]     param data passed sent with request
 * @param  {Function}      [callback] function to be executed after
 *                                    httpGet() completes, data is passed in
 *                                    as first argument
 * @param  {Function}      [errorCallback] function to be executed if
 *                                    there is an error, response is passed
 *                                    in as first argument
 */
p5.prototype.httpGet = function () {
  var args = Array.prototype.slice.call(arguments);
  args.splice(1, 0, 'GET');
  p5.prototype.httpDo.apply(this, args);
};

/**
 * Method for executing an HTTP POST request. If data type is not specified,
 * p5 will try to guess based on the URL, defaulting to text. This is equivalent to
 * calling <code>httpDo(path, 'POST')</code>.
 *
 * @method httpPost
 * @param  {String}        path       name of the file or url to load
 * @param  {String}        [datatype] "json", "jsonp", "xml", or "text"
 * @param  {Object}        [data]     param data passed sent with request
 * @param  {Function}      [callback] function to be executed after
 *                                    httpGet() completes, data is passed in
 *                                    as first argument
 * @param  {Function}      [errorCallback] function to be executed if
 *                                    there is an error, response is passed
 *                                    in as first argument
 */
p5.prototype.httpPost = function () {
  var args = Array.prototype.slice.call(arguments);
  args.splice(1, 0, 'POST');
  p5.prototype.httpDo.apply(this, args);
};

/**
 * Method for executing an HTTP request. If data type is not specified,
 * p5 will try to guess based on the URL, defaulting to text.<br><br>
 * For more advanced use, you may also pass in the path as the first argument
 * and a object as the second argument, the signature follows the one specified
 * in the Fetch API specification.
 *
 * @method httpDo
 * @param  {String}        path       name of the file or url to load
 * @param  {String}        [method]   either "GET", "POST", or "PUT",
 *                                    defaults to "GET"
 * @param  {String}        [datatype] "json", "jsonp", "xml", or "text"
 * @param  {Object}        [data]     param data passed sent with request
 * @param  {Function}      [callback] function to be executed after
 *                                    httpGet() completes, data is passed in
 *                                    as first argument
 * @param  {Function}      [errorCallback] function to be executed if
 *                                    there is an error, response is passed
 *                                    in as first argument
 */

/**
 * @method httpDo
 * @param  {String}        path
 * @param  {Object}        options   Request object options as documented in the
 *                                    "fetch" API
 * <a href="https://developer.mozilla.org/en/docs/Web/API/Fetch_API">reference</a>
 * @param  {Function}      [callback]
 * @param  {Function}      [errorCallback]
 */
p5.prototype.httpDo = function () {
  var type = '';
  var callback;
  var errorCallback;
  var request;
  var jsonpOptions = {};
  var cbCount = 0;
  var contentType = 'text/plain';
  // Trim the callbacks off the end to get an idea of how many arguments are passed
  for (var i = arguments.length-1; i > 0; i--){
    if(typeof arguments[i] === 'function'){
      cbCount++;
    }else{
      break;
    }
  }
  // The number of arguments minus callbacks
  var argsCount = arguments.length - cbCount;
  if(argsCount === 2 &&
     typeof arguments[0] === 'string' &&
     typeof arguments[1] === 'object'){
    // Intended for more advanced use, pass in Request parameters directly
    request = new Request(arguments[0], arguments[1]);
    callback = arguments[2];
    errorCallback = arguments[3];

    // do some sort of smart type checking
    if (type === '') {
      if (request.url.indexOf('json') !== -1) {
        type = 'json';
      } else if (request.url.indexOf('xml') !== -1) {
        type = 'xml';
      } else {
        type = 'text';
      }
    }
  } else {
    // Provided with arguments
    var path = arguments[0];
    var method = 'GET';
    var data;

    for (var j = 1; j < arguments.length; j++) {
      var a = arguments[j];
      if (typeof a === 'string') {
        if (a === 'GET' || a === 'POST' || a === 'PUT' || a === 'DELETE') {
          method = a;
        } else if(a === 'json' || a === 'jsonp' || a === 'xml' || a === 'text') {
          type = a;
        } else {
          data = a;
        }
      } else if (typeof a === 'number') {
        data = a.toString();
      } else if (typeof a === 'object') {
        if(a.hasOwnProperty('jsonpCallback')){
          for (var attr in a) {
            jsonpOptions[attr] = a[attr];
          }
        }else{
          data = JSON.stringify(a);
          contentType = 'application/json';
        }
      } else if (typeof a === 'function') {
        if (!callback) {
          callback = a;
        } else {
          errorCallback = a;
        }
      }
    }
    // do some sort of smart type checking
    if (type === '') {
      if (path.indexOf('json') !== -1) {
        type = 'json';
      } else if (path.indexOf('xml') !== -1) {
        type = 'xml';
      } else {
        type = 'text';
      }
    }

    request = new Request(path, {
      method: method,
      mode: 'cors',
      body: data,
      headers: new Headers({
        'Content-Type': contentType
      })
    });
  }

  if(type === 'jsonp'){
    fetchJsonp(arguments[0], jsonpOptions)
      .then(function(res){
        if(res.ok){
          return res.json();
        }
        throw res;
      }).then(function(resp){
        callback(resp);
      }).catch(function(err){
        if (errorCallback) {
          errorCallback(err);
        } else {
          throw err;
        }
      });
  }else{
    fetch(request)
      .then(function(res){
        if(res.ok){
          if(type === 'json'){
            return res.json();
          }else{
            return res.text();
          }
        }

        throw res;
      })
      .then(function(resp){
        if (type === 'xml'){
          var parser = new DOMParser();
          resp = parser.parseFromString(resp, 'text/xml');
          resp = parseXML(resp.documentElement);
        }
        callback(resp);
      }).catch(function(err, msg){
        if (errorCallback) {
          errorCallback(err);
        } else {
          throw err;
        }
      });
  }
};

/**
 * @module IO
 * @submodule Output
 * @for p5
 */

window.URL = window.URL || window.webkitURL;

// private array of p5.PrintWriter objects
p5.prototype._pWriters = [];


p5.prototype.createWriter = function (name, extension) {
  var newPW;
  // check that it doesn't already exist
  for (var i in p5.prototype._pWriters) {
    if (p5.prototype._pWriters[i].name === name) {
      // if a p5.PrintWriter w/ this name already exists...
      // return p5.prototype._pWriters[i]; // return it w/ contents intact.
      // or, could return a new, empty one with a unique name:
      newPW = new p5.PrintWriter(name + window.millis(), extension);
      p5.prototype._pWriters.push(newPW);
      return newPW;
    }
  }
  newPW = new p5.PrintWriter(name, extension);
  p5.prototype._pWriters.push(newPW);
  return newPW;
};


p5.PrintWriter = function (filename, extension) {
  var self = this;
  this.name = filename;
  this.content = '';
  //Changed to write because it was being overloaded by function below.
  this.write = function (data) {
    this.content += data;
  };
  this.print = function (data) {
    this.content += data + '\n';
  };
  this.flush = function () {
    this.content = '';
  };
  this.close = function () {
    // convert String to Array for the writeFile Blob
    var arr = [];
    arr.push(this.content);
    p5.prototype.writeFile(arr, filename, extension);
    // remove from _pWriters array and delete self
    for (var i in p5.prototype._pWriters) {
      if (p5.prototype._pWriters[i].name === this.name) {
        // remove from _pWriters array
        p5.prototype._pWriters.splice(i, 1);
      }
    }
    self.flush();
    self = {};
  };
};

// object, filename, options --> saveJSON, saveStrings,
// filename, [extension] [canvas] --> saveImage

/**
 *  <p>Save an image, text, json, csv, wav, or html. Prompts download to
 *  the client's computer. <b>Note that it is not recommended to call save()
 *  within draw if it's looping, as the save() function will open a new save
 *  dialog every frame.</b></p>
 *  <p>The default behavior is to save the canvas as an image. You can
 *  optionally specify a filename.
 *  For example:</p>
 *  <pre class='language-javascript'><code>
 *  save();
 *  save('myCanvas.jpg'); // save a specific canvas with a filename
 *  </code></pre>
 *
 *  <p>Alternately, the first parameter can be a pointer to a canvas
 *  p5.Element, an Array of Strings,
 *  an Array of JSON, a JSON object, a p5.Table, a p5.Image, or a
 *  p5.SoundFile (requires p5.sound). The second parameter is a filename
 *  (including extension). The third parameter is for options specific
 *  to this type of object. This method will save a file that fits the
 *  given paramaters. For example:</p>
 *
 *  <pre class='language-javascript'><code>
 *
 *  save('myCanvas.jpg');           // Saves canvas as an image
 *
 *  var cnv = createCanvas(100, 100);
 *  save(cnv, 'myCanvas.jpg');      // Saves canvas as an image
 *
 *  var gb = createGraphics(100, 100);
 *  save(gb, 'myGraphics.jpg');      // Saves p5.Renderer object as an image
 *
 *  save(myTable, 'myTable.html');  // Saves table as html file
 *  save(myTable, 'myTable.csv',);  // Comma Separated Values
 *  save(myTable, 'myTable.tsv');   // Tab Separated Values
 *
 *  save(myJSON, 'my.json');        // Saves pretty JSON
 *  save(myJSON, 'my.json', true);  // Optimizes JSON filesize
 *
 *  save(img, 'my.png');            // Saves pImage as a png image
 *
 *  save(arrayOfStrings, 'my.txt'); // Saves strings to a text file with line
 *                                  // breaks after each item in the array
 *  </code></pre>
 *
 *  @method save
 *  @param  {Object|String} [objectOrFilename]  If filename is provided, will
 *                                             save canvas as an image with
 *                                             either png or jpg extension
 *                                             depending on the filename.
 *                                             If object is provided, will
 *                                             save depending on the object
 *                                             and filename (see examples
 *                                             above).
 *  @param  {String} [filename] If an object is provided as the first
 *                               parameter, then the second parameter
 *                               indicates the filename,
 *                               and should include an appropriate
 *                               file extension (see examples above).
 *  @param  {Boolean|String} [options]  Additional options depend on
 *                            filetype. For example, when saving JSON,
 *                            <code>true</code> indicates that the
 *                            output will be optimized for filesize,
 *                            rather than readability.
 */
p5.prototype.save = function (object, _filename, _options) {
  // parse the arguments and figure out which things we are saving
  var args = arguments;
  // =================================================
  // OPTION 1: saveCanvas...

  // if no arguments are provided, save canvas
  var cnv = this._curElement.elt;
  if (args.length === 0) {
    p5.prototype.saveCanvas(cnv);
    return;
  }
  // otherwise, parse the arguments

  // if first param is a p5Graphics, then saveCanvas
  else if (args[0] instanceof p5.Renderer ||
    args[0] instanceof p5.Graphics) {
    p5.prototype.saveCanvas(args[0].elt, args[1], args[2]);
    return;
  }

  // if 1st param is String and only one arg, assume it is canvas filename
  else if (args.length === 1 && typeof (args[0]) === 'string') {
    p5.prototype.saveCanvas(cnv, args[0]);
  }

  // =================================================
  // OPTION 2: extension clarifies saveStrings vs. saveJSON
  else {
    var extension = _checkFileExtension(args[1], args[2])[1];
    switch (extension) {
      case 'json':
        p5.prototype.saveJSON(args[0], args[1], args[2]);
        return;
      case 'txt':
        p5.prototype.saveStrings(args[0], args[1], args[2]);
        return;
        // =================================================
        // OPTION 3: decide based on object...
      default:
        if (args[0] instanceof Array) {
          p5.prototype.saveStrings(args[0], args[1], args[2]);
        } else if (args[0] instanceof p5.Table) {
          p5.prototype.saveTable(args[0], args[1], args[2], args[3]);
        } else if (args[0] instanceof p5.Image) {
          p5.prototype.saveCanvas(args[0].canvas, args[1]);
        } else if (args[0] instanceof p5.SoundFile) {
          p5.prototype.saveSound(args[0], args[1], args[2], args[3]);
        }
    }
  }
};

/**
 *  Writes the contents of an Array or a JSON object to a .json file.
 *  The file saving process and location of the saved file will
 *  vary between web browsers.
 *
 *  @method saveJSON
 *  @param  {Array|Object} json
 *  @param  {String} filename
 *  @param  {Boolean} [optimize]   If true, removes line breaks
 *                                 and spaces from the output
 *                                 file to optimize filesize
 *                                 (but not readability).
 *  @example
 *  <div><code>
 *  var json;
 *
 *  function setup() {
 *
 *    json = {}; // new JSON Object
 *
 *    json.id = 0;
 *    json.species = 'Panthera leo';
 *    json.name = 'Lion';
 *
 *  // To save, un-comment the line below, then click 'run'
 *  // saveJSON(json, 'lion.json');
 *  }
 *
 *  // Saves the following to a file called "lion.json":
 *  // {
 *  //   "id": 0,
 *  //   "species": "Panthera leo",
 *  //   "name": "Lion"
 *  // }
 *  </div></code>
 *
 * @alt
 * no image displayed
 *
 */
p5.prototype.saveJSON = function (json, filename, opt) {
  var stringify;
  if (opt) {
    stringify = JSON.stringify(json);
  } else {
    stringify = JSON.stringify(json, undefined, 2);
  }
  this.saveStrings(stringify.split('\n'), filename, 'json');
};

p5.prototype.saveJSONObject = p5.prototype.saveJSON;
p5.prototype.saveJSONArray = p5.prototype.saveJSON;


/**
 *  Writes an array of Strings to a text file, one line per String.
 *  The file saving process and location of the saved file will
 *  vary between web browsers.
 *
 *  @method saveStrings
 *  @param  {Array} list      string array to be written
 *  @param  {String} filename filename for output
 *  @example
 *  <div><code>
 *  var words = 'apple bear cat dog';
 *
 *  // .split() outputs an Array
 *  var list = split(words, ' ');
 *
 *  // To save the file, un-comment next line and click 'run'
 *  // saveStrings(list, 'nouns.txt');
 *
 *  // Saves the following to a file called 'nouns.txt':
 *  //
 *  // apple
 *  // bear
 *  // cat
 *  // dog
 *  </code></div>
 *
 * @alt
 * no image displayed
 *
 */
p5.prototype.saveStrings = function (list, filename, extension) {
  var ext = extension || 'txt';
  var pWriter = this.createWriter(filename, ext);
  for (var i = 0; i < list.length; i++) {
    if (i < list.length - 1) {
      pWriter.print(list[i]);
    } else {
      pWriter.print(list[i]);
    }
  }
  pWriter.close();
  pWriter.flush();
};


// =======
// HELPERS
// =======

function escapeHelper(content) {
  return content
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

/**
 *  Writes the contents of a Table object to a file. Defaults to a
 *  text file with comma-separated-values ('csv') but can also
 *  use tab separation ('tsv'), or generate an HTML table ('html').
 *  The file saving process and location of the saved file will
 *  vary between web browsers.
 *
 *  @method saveTable
 *  @param  {p5.Table} Table  the Table object to save to a file
 *  @param  {String} filename the filename to which the Table should be saved
 *  @param  {String} [options]  can be one of "tsv", "csv", or "html"
 *  @example
 *  <div><code>
 *  var table;
 *
 *  function setup() {
 *    table = new p5.Table();
 *
 *    table.addColumn('id');
 *    table.addColumn('species');
 *    table.addColumn('name');
 *
 *    var newRow = table.addRow();
 *    newRow.setNum('id', table.getRowCount() - 1);
 *    newRow.setString('species', 'Panthera leo');
 *    newRow.setString('name', 'Lion');
 *
 *    // To save, un-comment next line then click 'run'
 *    // saveTable(table, 'new.csv');
 *    }
 *
 *    // Saves the following to a file called 'new.csv':
 *    // id,species,name
 *    // 0,Panthera leo,Lion
 *  </code></div>
 *
 * @alt
 * no image displayed
 *
 */
p5.prototype.saveTable = function (table, filename, options) {
  var ext;
  if(options === undefined){
    ext = filename.substring(filename.lastIndexOf('.')+1,filename.length);
  }else{
    ext = options;
  }
  var pWriter = this.createWriter(filename, ext);

  var header = table.columns;

  var sep = ','; // default to CSV
  if (ext === 'tsv') {
    sep = '\t';
  }
  if (ext !== 'html') {
    // make header if it has values
    if (header[0] !== '0') {
      for (var h = 0; h < header.length; h++) {
        if (h < header.length - 1) {
          pWriter.write(header[h] + sep);
        } else {
          pWriter.write(header[h]);
        }
      }
      pWriter.write('\n');
    }

    // make rows
    for (var i = 0; i < table.rows.length; i++) {
      var j;
      for (j = 0; j < table.rows[i].arr.length; j++) {
        if (j < table.rows[i].arr.length - 1) {
          pWriter.write(table.rows[i].arr[j] + sep);
        } else if (i < table.rows.length - 1) {
          pWriter.write(table.rows[i].arr[j]);
        } else {
          pWriter.write(table.rows[i].arr[j]);
        }
      }
      pWriter.write('\n');
    }
  }

  // otherwise, make HTML
  else {
    pWriter.print('<html>');
    pWriter.print('<head>');
    var str = '  <meta http-equiv=\"content-type\" content';
    str += '=\"text/html;charset=utf-8\" />';
    pWriter.print(str);
    pWriter.print('</head>');

    pWriter.print('<body>');
    pWriter.print('  <table>');

    // make header if it has values
    if (header[0] !== '0') {
      pWriter.print('    <tr>');
      for (var k = 0; k < header.length; k++) {
        var e = escapeHelper(header[k]);
        pWriter.print('      <td>' + e);
        pWriter.print('      </td>');
      }
      pWriter.print('    </tr>');
    }

    // make rows
    for (var row = 0; row < table.rows.length; row++) {
      pWriter.print('    <tr>');
      for (var col = 0; col < table.columns.length; col++) {
        var entry = table.rows[row].getString(col);
        var htmlEntry = escapeHelper(entry);
        pWriter.print('      <td>' + htmlEntry);
        pWriter.print('      </td>');
      }
      pWriter.print('    </tr>');
    }
    pWriter.print('  </table>');
    pWriter.print('</body>');
    pWriter.print('</html>');
  }
  // close and flush the pWriter
  pWriter.close();
  pWriter.flush();
}; // end saveTable()

/**
 *  Generate a blob of file data as a url to prepare for download.
 *  Accepts an array of data, a filename, and an extension (optional).
 *  This is a private function because it does not do any formatting,
 *  but it is used by saveStrings, saveJSON, saveTable etc.
 *
 *  @param  {Array} dataToDownload
 *  @param  {String} filename
 *  @param  {[String]} extension
 *  @private
 */
p5.prototype.writeFile = function (dataToDownload, filename, extension) {
  var type = 'application\/octet-stream';
  if (p5.prototype._isSafari()) {
    type = 'text\/plain';
  }
  var blob = new Blob(dataToDownload, {
    'type': type
  });
  var href = window.URL.createObjectURL(blob);
  p5.prototype.downloadFile(href, filename, extension);
};

/**
 *  Forces download. Accepts a url to filedata/blob, a filename,
 *  and an extension (optional).
 *  This is a private function because it does not do any formatting,
 *  but it is used by saveStrings, saveJSON, saveTable etc.
 *
 *  @param  {String} href      i.e. an href generated by createObjectURL
 *  @param  {[String]} filename
 *  @param  {[String]} extension
 */
p5.prototype.downloadFile = function (href, fName, extension) {
  var fx = _checkFileExtension(fName, extension);
  var filename = fx[0];
  var ext = fx[1];

  var a = document.createElement('a');
  a.href = href;
  a.download = filename;

  // Firefox requires the link to be added to the DOM before click()
  a.onclick = function(e) {
    destroyClickedElement(e);
    e.stopPropagation();
  };

  a.style.display = 'none';
  document.body.appendChild(a);

  // Safari will open this file in the same page as a confusing Blob.
  if (p5.prototype._isSafari()) {
    var aText = 'Hello, Safari user! To download this file...\n';
    aText += '1. Go to File --> Save As.\n';
    aText += '2. Choose "Page Source" as the Format.\n';
    aText += '3. Name it with this extension: .\"' + ext + '\"';
    alert(aText);
  }
  a.click();
  href = null;
};

/**
 *  Returns a file extension, or another string
 *  if the provided parameter has no extension.
 *
 *  @param   {String} filename
 *  @return  {Array} [fileName, fileExtension]
 *
 *  @private
 */
function _checkFileExtension(filename, extension) {
  if (!extension || extension === true || extension === 'true') {
    extension = '';
  }
  if (!filename) {
    filename = 'untitled';
  }
  var ext = '';
  // make sure the file will have a name, see if filename needs extension
  if (filename && filename.indexOf('.') > -1) {
    ext = filename.split('.').pop();
  }
  // append extension if it doesn't exist
  if (extension) {
    if (ext !== extension) {
      ext = extension;
      filename = filename + '.' + ext;
    }
  }
  return [filename, ext];
}
p5.prototype._checkFileExtension = _checkFileExtension;

/**
 *  Returns true if the browser is Safari, false if not.
 *  Safari makes trouble for downloading files.
 *
 *  @return  {Boolean} [description]
 *  @private
 */
p5.prototype._isSafari = function () {
  var x = Object.prototype.toString.call(window.HTMLElement);
  return x.indexOf('Constructor') > 0;
};

/**
 *  Helper function, a callback for download that deletes
 *  an invisible anchor element from the DOM once the file
 *  has been automatically downloaded.
 *
 *  @private
 */
function destroyClickedElement(event) {
  document.body.removeChild(event.target);
}

module.exports = p5;

},{"../core/core":42,"../core/error_helpers":45,"es6-promise":2,"fetch-jsonp":3,"opentype.js":10,"whatwg-fetch":32}],65:[function(_dereq_,module,exports){
/**
 * @module IO
 * @submodule Table
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');


/**
 *  Table Options
 *  <p>Generic class for handling tabular data, typically from a
 *  CSV, TSV, or other sort of spreadsheet file.</p>
 *  <p>CSV files are
 *  <a href="http://en.wikipedia.org/wiki/Comma-separated_values">
 *  comma separated values</a>, often with the data in quotes. TSV
 *  files use tabs as separators, and usually don't bother with the
 *  quotes.</p>
 *  <p>File names should end with .csv if they're comma separated.</p>
 *  <p>A rough "spec" for CSV can be found
 *  <a href="http://tools.ietf.org/html/rfc4180">here</a>.</p>
 *  <p>To load files, use the loadTable method.</p>
 *  <p>To save tables to your computer, use the save method
 *   or the saveTable method.</p>
 *
 *  Possible options include:
 *  <ul>
 *  <li>csv - parse the table as comma-separated values
 *  <li>tsv - parse the table as tab-separated values
 *  <li>header - this table has a header (title) row
 *  </ul>
 */

/**
 *  Table objects store data with multiple rows and columns, much
 *  like in a traditional spreadsheet. Tables can be generated from
 *  scratch, dynamically, or using data from an existing file.
 *
 *  @class p5.Table
 *  @constructor
 *  @param  {Array}     [rows] An array of p5.TableRow objects
 *  @return {p5.Table}         p5.Table generated
 */
p5.Table = function (rows) {
  /**
   *  @property columns
   *  @type {Array}
   */
  this.columns = [];

  /**
   *  @property rows
   *  @type {Array}
   */
  this.rows = [];
};

/**
 *  Use addRow() to add a new row of data to a p5.Table object. By default,
 *  an empty row is created. Typically, you would store a reference to
 *  the new row in a TableRow object (see newRow in the example above),
 *  and then set individual values using set().
 *
 *  If a p5.TableRow object is included as a parameter, then that row is
 *  duplicated and added to the table.
 *
 *  @method  addRow
 *  @param   {p5.TableRow} [row] row to be added to the table
 *
 * @example
	* <div class="norender">
	* <code>
	* // Given the CSV file "mammals.csv"
	* // in the project's "assets" folder:
	* //
	* // id,species,name
	* // 0,Capra hircus,Goat
	* // 1,Panthera pardus,Leopard
	* // 2,Equus zebra,Zebra
	*
	* var table;
	*
	* function preload() {
	*   //my table is comma separated value "csv"
	*   //and has a header specifying the columns labels
	*   table = loadTable("assets/mammals.csv", "csv", "header");
	* }
	*
	* function setup() {
	*   //add a row
	*   var newRow = table.addRow();
	*   newRow.setString("id", table.getRowCount() - 1);
	*   newRow.setString("species", "Canis Lupus");
	*   newRow.setString("name", "Wolf");
	*
	*   //print the results
	*   for (var r = 0; r < table.getRowCount(); r++)
	*     for (var c = 0; c < table.getColumnCount(); c++)
	*       print(table.getString(r, c));
	* }
	* </code>
	* </div>
	*
 * @alt
 * no image displayed
 *
 */
p5.Table.prototype.addRow = function(row) {
  // make sure it is a valid TableRow
  var r = row || new p5.TableRow();

  if (typeof(r.arr) === 'undefined' || typeof(r.obj) === 'undefined') {
    //r = new p5.prototype.TableRow(r);
    throw 'invalid TableRow: ' + r;
  }
  r.table = this;
  this.rows.push(r);
  return r;
};

/**
 * Removes a row from the table object.
 *
 * @method  removeRow
 * @param   {Number} id ID number of the row to remove
 *
 * @example
	* <div class="norender">
	* <code>
	* // Given the CSV file "mammals.csv"
	* // in the project's "assets" folder:
	* //
	* // id,species,name
	* // 0,Capra hircus,Goat
	* // 1,Panthera pardus,Leopard
	* // 2,Equus zebra,Zebra
	*
	* var table;
	*
	* function preload() {
	*   //my table is comma separated value "csv"
	*   //and has a header specifying the columns labels
	*   table = loadTable("assets/mammals.csv", "csv", "header");
	* }
	*
	* function setup() {
	*   //remove the first row
	*   var r = table.removeRow(0);
	*
	*   //print the results
	*   for (var r = 0; r < table.getRowCount(); r++)
	*     for (var c = 0; c < table.getColumnCount(); c++)
	*       print(table.getString(r, c));
	* }
	* </code>
	* </div>
	*
    * @alt
 	* no image displayed
 	*
 */
p5.Table.prototype.removeRow = function(id) {
  this.rows[id].table = null; // remove reference to table
  var chunk = this.rows.splice(id+1, this.rows.length);
  this.rows.pop();
  this.rows = this.rows.concat(chunk);
};


/**
 * Returns a reference to the specified p5.TableRow. The reference
 * can then be used to get and set values of the selected row.
 *
 * @method  getRow
 * @param  {Number}   rowID ID number of the row to get
 * @return {TableRow} p5.TableRow object
 *
 * @example
	* <div class="norender">
	* <code>
	* // Given the CSV file "mammals.csv"
	* // in the project's "assets" folder:
	* //
	* // id,species,name
	* // 0,Capra hircus,Goat
	* // 1,Panthera pardus,Leopard
	* // 2,Equus zebra,Zebra
	*
	* var table;
	*
	* function preload() {
	*   //my table is comma separated value "csv"
	*   //and has a header specifying the columns labels
	*   table = loadTable("assets/mammals.csv", "csv", "header");
	* }
	*
	* function setup() {
	*   var row = table.getRow(1);
	*   //print it column by column
	*   //note: a row is an object, not an array
	*   for (var c = 0; c < table.getColumnCount(); c++)
	*     print(row.getString(c));
	* }
	* </code>
	* </div>
	*
 	*@alt
 	* no image displayed
 	*
 */
p5.Table.prototype.getRow = function(r) {
  return this.rows[r];
};

/**
 *  Gets all rows from the table. Returns an array of p5.TableRows.
 *
 *  @method  getRows
 *  @return {Array}   Array of p5.TableRows
 *
 * @example
	* <div class="norender">
	* <code>
	* // Given the CSV file "mammals.csv"
	* // in the project's "assets" folder:
	* //
	* // id,species,name
	* // 0,Capra hircus,Goat
	* // 1,Panthera pardus,Leopard
	* // 2,Equus zebra,Zebra
	*
	* var table;
	*
	* function preload() {
	*   //my table is comma separated value "csv"
	*   //and has a header specifying the columns labels
	*   table = loadTable("assets/mammals.csv", "csv", "header");
	* }
	*
	* function setup() {
	*   var rows = table.getRows();
	*
	*   //warning: rows is an array of objects
	*   for (var r = 0; r < rows.length; r++)
	*     rows[r].set("name", "Unicorn");
	*
	*   //print the results
	*   for (var r = 0; r < table.getRowCount(); r++)
	*     for (var c = 0; c < table.getColumnCount(); c++)
	*       print(table.getString(r, c));
	* }
	* </code>
	* </div>
	*
    * @alt
    * no image displayed
    *
 */
p5.Table.prototype.getRows = function() {
  return this.rows;
};

/**
 *  Finds the first row in the Table that contains the value
 *  provided, and returns a reference to that row. Even if
 *  multiple rows are possible matches, only the first matching
 *  row is returned. The column to search may be specified by
 *  either its ID or title.
 *
 *  @method  findRow
 *  @param  {String} value  The value to match
 *  @param  {Number|String} column ID number or title of the
 *                                 column to search
 *  @return {TableRow}
 *
 * @example
	* <div class="norender">
	* <code>
	* // Given the CSV file "mammals.csv"
	* // in the project's "assets" folder:
	* //
	* // id,species,name
	* // 0,Capra hircus,Goat
	* // 1,Panthera pardus,Leopard
	* // 2,Equus zebra,Zebra
	*
	* var table;
	*
	* function preload() {
	*   //my table is comma separated value "csv"
	*   //and has a header specifying the columns labels
	*   table = loadTable("assets/mammals.csv", "csv", "header");
	* }
	*
	* function setup() {
	*   //find the animal named zebra
	*   var row = table.findRow("Zebra", "name");
	*   //find the corresponding species
	*   print(row.getString("species"));
	* }
	* </code>
	* </div>
	*
 * @alt
 * no image displayed
 *
 */
p5.Table.prototype.findRow = function(value, column) {
  // try the Object
  if (typeof(column) === 'string') {
    for (var i = 0; i < this.rows.length; i++){
      if (this.rows[i].obj[column] === value) {
        return this.rows[i];
      }
    }
  }
  // try the Array
  else {
    for (var j = 0; j < this.rows.length; j++){
      if (this.rows[j].arr[column] === value) {
        return this.rows[j];
      }
    }
  }
  // otherwise...
  return null;
};

/**
 *  Finds the rows in the Table that contain the value
 *  provided, and returns references to those rows. Returns an
 *  Array, so for must be used to iterate through all the rows,
 *  as shown in the example above. The column to search may be
 *  specified by either its ID or title.
 *
 *  @method  findRows
 *  @param  {String} value  The value to match
 *  @param  {Number|String} column ID number or title of the
 *                                 column to search
 *  @return {Array}        An Array of TableRow objects
 *
 * @example
	* <div class="norender">
	* <code>
	* // Given the CSV file "mammals.csv"
	* // in the project's "assets" folder:
	* //
	* // id,species,name
	* // 0,Capra hircus,Goat
	* // 1,Panthera pardus,Leopard
	* // 2,Equus zebra,Zebra
	*
	* var table;
	*
	* function preload() {
	*   //my table is comma separated value "csv"
	*   //and has a header specifying the columns labels
	*   table = loadTable("assets/mammals.csv", "csv", "header");
	* }
	*
	* function setup() {
	*   //add another goat
	*   var newRow = table.addRow();
	*   newRow.setString("id", table.getRowCount() - 1);
	*   newRow.setString("species", "Scape Goat");
	*   newRow.setString("name", "Goat");
	*
	*   //find the rows containing animals named Goat
	*   var rows = table.findRows("Goat", "name");
	*   print(rows.length + " Goats found");
	* }
	* </code>
	* </div>
	*
 	*@alt
 	* no image displayed
 	*
 */
p5.Table.prototype.findRows = function(value, column) {
  var ret = [];
  if (typeof(column) === 'string') {
    for (var i = 0; i < this.rows.length; i++){
      if (this.rows[i].obj[column] === value) {
        ret.push( this.rows[i] );
      }
    }
  }
  // try the Array
  else {
    for (var j = 0; j < this.rows.length; j++){
      if (this.rows[j].arr[column] === value) {
        ret.push( this.rows[j] );
      }
    }
  }
  return ret;
};

/**
 *  Finds the first row in the Table that matches the regular
 *  expression provided, and returns a reference to that row.
 *  Even if multiple rows are possible matches, only the first
 *  matching row is returned. The column to search may be
 *  specified by either its ID or title.
 *
 *  @method  matchRow
 *  @param  {String} regexp The regular expression to match
 *  @param  {String|Number} column The column ID (number) or
 *                                   title (string)
 *  @return {TableRow}        TableRow object
 */
p5.Table.prototype.matchRow = function(regexp, column) {
  if (typeof(column) === 'number') {
    for (var j = 0; j < this.rows.length; j++) {
      if ( this.rows[j].arr[column].match(regexp) ) {
        return this.rows[j];
      }
    }
  }

  else {
    for (var i = 0; i < this.rows.length; i++) {
      if ( this.rows[i].obj[column].match(regexp) ) {
        return this.rows[i];
      }
    }
  }
  return null;
};

/**
 *  Finds the rows in the Table that match the regular expression provided,
 *  and returns references to those rows. Returns an array, so for must be
 *  used to iterate through all the rows, as shown in the example. The
 *  column to search may be specified by either its ID or title.
 *
 *  @method  matchRows
 *  @param  {String} regexp The regular expression to match
 *  @param  {String|Number} [column] The column ID (number) or
 *                                   title (string)
 *  @return {Array}        An Array of TableRow objects
 *  @example
 *  var table;
 *
 *  function setup() {
 *
 *    table = new p5.Table();
 *
 *    table.addColumn('name');
 *    table.addColumn('type');
 *
 *    var newRow = table.addRow();
 *    newRow.setString('name', 'Lion');
 *    newRow.setString('type', 'Mammal');
 *
 *    newRow = table.addRow();
 *    newRow.setString('name', 'Snake');
 *    newRow.setString('type', 'Reptile');
 *
 *    newRow = table.addRow();
 *    newRow.setString('name', 'Mosquito');
 *    newRow.setString('type', 'Insect');
 *
 *    newRow = table.addRow();
 *    newRow.setString('name', 'Lizard');
 *    newRow.setString('type', 'Reptile');
 *
 *    var rows = table.matchRows('R.*', 'type');
 *    for (var i = 0; i < rows.length; i++) {
 *      print(rows[i].getString('name') + ': ' + rows[i].getString('type'));
 *    }
 *  }
 *  // Sketch prints:
 *  // Snake: Reptile
 *  // Lizard: Reptile
 */
p5.Table.prototype.matchRows = function(regexp, column) {
  var ret = [];
  if (typeof(column) === 'number') {
    for (var j = 0; j < this.rows.length; j++) {
      if ( this.rows[j].arr[column].match(regexp) ) {
        ret.push( this.rows[j] );
      }
    }
  }

  else {
    for (var i = 0; i < this.rows.length; i++) {
      if ( this.rows[i].obj[column].match(regexp) ) {
        ret.push( this.rows[i] );
      }
    }
  }
  return ret;
};


/**
 *  Retrieves all values in the specified column, and returns them
 *  as an array. The column may be specified by either its ID or title.
 *
 *  @method  getColumn
 *  @param  {String|Number} column String or Number of the column to return
 *  @return {Array}       Array of column values
 *
 * @example
	* <div class="norender">
	* <code>
	* // Given the CSV file "mammals.csv"
	* // in the project's "assets" folder:
	* //
	* // id,species,name
	* // 0,Capra hircus,Goat
	* // 1,Panthera pardus,Leopard
	* // 2,Equus zebra,Zebra
	*
	* var table;
	*
	* function preload() {
	*   //my table is comma separated value "csv"
	*   //and has a header specifying the columns labels
	*   table = loadTable("assets/mammals.csv", "csv", "header");
	* }
	*
	* function setup() {
	*   //getColumn returns an array that can be printed directly
	*   print(table.getColumn("species"));
	*   //outputs ["Capra hircus", "Panthera pardus", "Equus zebra"]
	* }
	* </code>
	* </div>
	*
 	*@alt
 	* no image displayed
 	*
 */
p5.Table.prototype.getColumn = function(value) {
  var ret = [];
  if (typeof(value) === 'string'){
    for (var i = 0; i < this.rows.length; i++){
      ret.push (this.rows[i].obj[value]);
    }
  } else {
    for (var j = 0; j < this.rows.length; j++){
      ret.push (this.rows[j].arr[value]);
    }
  }
  return ret;
};

/**
 *  Removes all rows from a Table. While all rows are removed,
 *  columns and column titles are maintained.
 *
 *  @method  clearRows
 *
 * @example
	* <div class="norender">
	* <code>
	* // Given the CSV file "mammals.csv"
	* // in the project's "assets" folder:
	* //
	* // id,species,name
	* // 0,Capra hircus,Goat
	* // 1,Panthera pardus,Leopard
	* // 2,Equus zebra,Zebra
	*
	* var table;
	*
	* function preload() {
	*   //my table is comma separated value "csv"
	*   //and has a header specifying the columns labels
	*   table = loadTable("assets/mammals.csv", "csv", "header");
	* }
	*
	* function setup() {
	*   table.clearRows();
	*   print(table.getRowCount() + " total rows in table");
	*   print(table.getColumnCount() + " total columns in table");
	* }
	* </code>
	* </div>
	*
 	*@alt
 	* no image displayed
 	*
 */
p5.Table.prototype.clearRows = function() {
  delete this.rows;
  this.rows = [];
};

/**
 *  Use addColumn() to add a new column to a Table object.
 *  Typically, you will want to specify a title, so the column
 *  may be easily referenced later by name. (If no title is
 *  specified, the new column's title will be null.)
 *
 *  @method  addColumn
 *  @param {String} [title] title of the given column
 *
 * @example
	* <div class="norender">
	* <code>
	* // Given the CSV file "mammals.csv"
	* // in the project's "assets" folder:
	* //
	* // id,species,name
	* // 0,Capra hircus,Goat
	* // 1,Panthera pardus,Leopard
	* // 2,Equus zebra,Zebra
	*
	* var table;
	*
	* function preload() {
	*   //my table is comma separated value "csv"
	*   //and has a header specifying the columns labels
	*   table = loadTable("assets/mammals.csv", "csv", "header");
	* }
	*
	* function setup() {
	*   table.addColumn("carnivore");
	*   table.set(0, "carnivore", "no");
	*   table.set(1, "carnivore", "yes");
	*   table.set(2, "carnivore", "no");
	*
	*   //print the results
	*   for (var r = 0; r < table.getRowCount(); r++)
	*     for (var c = 0; c < table.getColumnCount(); c++)
	*       print(table.getString(r, c));
	* }
	* </code>
	* </div>
	*
 	*@alt
 	* no image displayed
 	*
 */
p5.Table.prototype.addColumn = function(title) {
  var t = title || null;
  this.columns.push(t);
};

/**
 *  Returns the total number of columns in a Table.
 *
 *  @return {Number} Number of columns in this table
 */
p5.Table.prototype.getColumnCount = function() {
  return this.columns.length;
};

/**
 *  Returns the total number of rows in a Table.
 *
 *  @method  getRowCount
 *  @return {Number} Number of rows in this table

 */
p5.Table.prototype.getRowCount = function() {
  return this.rows.length;
};

/**
 *  <p>Removes any of the specified characters (or "tokens").</p>
 *
 *  <p>If no column is specified, then the values in all columns and
 *  rows are processed. A specific column may be referenced by
 *  either its ID or title.</p>
 *
 *  @method  removeTokens
 *  @param  {String} chars  String listing characters to be removed
 *  @param  {String|Number} [column] Column ID (number)
 *                                   or name (string)
 */
p5.Table.prototype.removeTokens = function(chars, column) {
  var escape= function(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  };
  var charArray = [];
  for (var i = 0; i < chars.length; i++) {
    charArray.push( escape( chars.charAt(i) ) );
  }
  var regex = new RegExp(charArray.join('|'), 'g');

  if (typeof(column) === 'undefined'){
    for (var c = 0; c < this.columns.length; c++) {
      for (var d = 0; d < this.rows.length; d++) {
        var s = this.rows[d].arr[c];
        s = s.replace(regex, '');
        this.rows[d].arr[c] = s;
        this.rows[d].obj[this.columns[c]] = s;
      }
    }
  }
  else if (typeof(column) === 'string'){
    for (var j = 0; j < this.rows.length; j++) {
      var val = this.rows[j].obj[column];
      val = val.replace(regex, '');
      this.rows[j].obj[column] = val;
      var pos = this.columns.indexOf(column);
      this.rows[j].arr[pos] = val;
    }
  }
  else {
    for (var k = 0; k < this.rows.length; k++) {
      var str = this.rows[k].arr[column];
      str = str.replace(regex, '');
      this.rows[k].arr[column] = str;
      this.rows[k].obj[this.columns[column]] = str;
    }
  }
};

/**
 *  Trims leading and trailing whitespace, such as spaces and tabs,
 *  from String table values. If no column is specified, then the
 *  values in all columns and rows are trimmed. A specific column
 *  may be referenced by either its ID or title.
 *
 *  @method  trim
 *  @param  {String|Number} column Column ID (number)
 *                                   or name (string)
 */
p5.Table.prototype.trim = function(column) {
  var regex = new RegExp( (' '), 'g');

  if (typeof(column) === 'undefined'){
    for (var c = 0; c < this.columns.length; c++) {
      for (var d = 0; d < this.rows.length; d++) {
        var s = this.rows[d].arr[c];
        s = s.replace(regex, '');
        this.rows[d].arr[c] = s;
        this.rows[d].obj[this.columns[c]] = s;
      }
    }
  }
  else if (typeof(column) === 'string'){
    for (var j = 0; j < this.rows.length; j++) {
      var val = this.rows[j].obj[column];
      val = val.replace(regex, '');
      this.rows[j].obj[column] = val;
      var pos = this.columns.indexOf(column);
      this.rows[j].arr[pos] = val;
    }
  }
  else {
    for (var k = 0; k < this.rows.length; k++) {
      var str = this.rows[k].arr[column];
      str = str.replace(regex, '');
      this.rows[k].arr[column] = str;
      this.rows[k].obj[this.columns[column]] = str;
    }
  }
};

/**
 *  Use removeColumn() to remove an existing column from a Table
 *  object. The column to be removed may be identified by either
 *  its title (a String) or its index value (an int).
 *  removeColumn(0) would remove the first column, removeColumn(1)
 *  would remove the second column, and so on.
 *
 *  @method  removeColumn
 *  @param  {String|Number} column columnName (string) or ID (number)
 *
 * @example
	* <div class="norender">
	* <code>
	* // Given the CSV file "mammals.csv"
	* // in the project's "assets" folder:
	* //
	* // id,species,name
	* // 0,Capra hircus,Goat
	* // 1,Panthera pardus,Leopard
	* // 2,Equus zebra,Zebra
	*
	* var table;
	*
	* function preload() {
	*   //my table is comma separated value "csv"
	*   //and has a header specifying the columns labels
	*   table = loadTable("assets/mammals.csv", "csv", "header");
	* }
	*
	* function setup() {
	*   table.removeColumn("id");
	*   print(table.getColumnCount());
	* }
	* </code>
	* </div>
	*
 	*@alt
 	* no image displayed
 	*
 */
p5.Table.prototype.removeColumn = function(c) {
  var cString;
  var cNumber;
  if (typeof(c) === 'string') {
    // find the position of c in the columns
    cString = c;
    cNumber = this.columns.indexOf(c);
    console.log('string');
  }
  else{
    cNumber = c;
    cString = this.columns[c];
  }

  var chunk = this.columns.splice(cNumber+1, this.columns.length);
  this.columns.pop();
  this.columns = this.columns.concat(chunk);

  for (var i = 0; i < this.rows.length; i++){
    var tempR = this.rows[i].arr;
    var chip = tempR.splice(cNumber+1, tempR.length);
    tempR.pop();
    this.rows[i].arr = tempR.concat(chip);
    delete this.rows[i].obj[cString];
  }

};


/**
 * Stores a value in the Table's specified row and column.
 * The row is specified by its ID, while the column may be specified
 * by either its ID or title.
 *
 * @method  set
 * @param {String|Number} column column ID (Number)
 *                               or title (String)
 * @param {String|Number} value  value to assign
 *
 * @example
	* <div class="norender">
	* <code>
	* // Given the CSV file "mammals.csv"
	* // in the project's "assets" folder:
	* //
	* // id,species,name
	* // 0,Capra hircus,Goat
	* // 1,Panthera pardus,Leopard
	* // 2,Equus zebra,Zebra
	*
	* var table;
	*
	* function preload() {
	*   //my table is comma separated value "csv"
	*   //and has a header specifying the columns labels
	*   table = loadTable("assets/mammals.csv", "csv", "header");
	* }
	*
	* function setup() {
	*   table.set(0, "species", "Canis Lupus");
	*   table.set(0, "name", "Wolf");
	*
	*   //print the results
	*   for (var r = 0; r < table.getRowCount(); r++)
	*     for (var c = 0; c < table.getColumnCount(); c++)
	*       print(table.getString(r, c));
	* }
	* </code>
	* </div>
	*
 	*@alt
 	* no image displayed
 	*
 */
p5.Table.prototype.set = function(row, column, value) {
  this.rows[row].set(column, value);
};

/**
 * Stores a Float value in the Table's specified row and column.
 * The row is specified by its ID, while the column may be specified
 * by either its ID or title.
 *
 * @method setNum
 * @param {Number} row row ID
 * @param {String|Number} column column ID (Number)
 *                               or title (String)
 * @param {Number} value  value to assign
 *
 * @example
	* <div class="norender">
	* <code>
	* // Given the CSV file "mammals.csv"
	* // in the project's "assets" folder:
	* //
	* // id,species,name
	* // 0,Capra hircus,Goat
	* // 1,Panthera pardus,Leopard
	* // 2,Equus zebra,Zebra
	*
	* var table;
	*
	* function preload() {
	*   //my table is comma separated value "csv"
	*   //and has a header specifying the columns labels
	*   table = loadTable("assets/mammals.csv", "csv", "header");
	* }
	*
	* function setup() {
	*   table.setNum(1, "id", 1);
	*
	*   print(table.getColumn(0));
	*   //["0", 1, "2"]
	* }
	* </code>
	* </div>
	*
 	*@alt
 	* no image displayed
 */
p5.Table.prototype.setNum = function(row, column, value){
  this.rows[row].setNum(column, value);
};


/**
 * Stores a String value in the Table's specified row and column.
 * The row is specified by its ID, while the column may be specified
 * by either its ID or title.
 *
 * @method  setString
 * @param {Number} row row ID
 * @param {String|Number} column column ID (Number)
 *                               or title (String)
 * @param {String} value  value to assign
 */
p5.Table.prototype.setString = function(row, column, value){
  this.rows[row].setString(column, value);
};

/**
 * Retrieves a value from the Table's specified row and column.
 * The row is specified by its ID, while the column may be specified by
 * either its ID or title.
 *
 * @method  get
 * @param {Number} row row ID
 * @param  {String|Number} column columnName (string) or
 *                                   ID (number)
 * @return {String|Number}
 *
 * @example
	* <div class="norender">
	* <code>
	* // Given the CSV file "mammals.csv"
	* // in the project's "assets" folder:
	* //
	* // id,species,name
	* // 0,Capra hircus,Goat
	* // 1,Panthera pardus,Leopard
	* // 2,Equus zebra,Zebra
	*
	* var table;
	*
	* function preload() {
	*   //my table is comma separated value "csv"
	*   //and has a header specifying the columns labels
	*   table = loadTable("assets/mammals.csv", "csv", "header");
	* }
	*
	* function setup() {
	*   print(table.get(0, 1));
	*   //Capra hircus
	*   print(table.get(0, "species"));
	*   //Capra hircus
	* }
	* </code>
	* </div>
	*
 	*@alt
 	* no image displayed
 	*
 */
p5.Table.prototype.get = function(row, column) {
  return this.rows[row].get(column);
};

/**
 * Retrieves a Float value from the Table's specified row and column.
 * The row is specified by its ID, while the column may be specified by
 * either its ID or title.
 *
 * @method  getNum
 * @param {Number} row row ID
 * @param  {String|Number} column columnName (string) or
 *                                   ID (number)
 * @return {Number}
 *
 * @example
	* <div class="norender">
	* <code>
	* // Given the CSV file "mammals.csv"
	* // in the project's "assets" folder:
	* //
	* // id,species,name
	* // 0,Capra hircus,Goat
	* // 1,Panthera pardus,Leopard
	* // 2,Equus zebra,Zebra
	*
	* var table;
	*
	* function preload() {
	*   //my table is comma separated value "csv"
	*   //and has a header specifying the columns labels
	*   table = loadTable("assets/mammals.csv", "csv", "header");
	* }
	*
	* function setup() {
	*   print(table.getNum(1, 0) + 100);
	*   //id 1 + 100 = 101
	* }
	* </code>
	* </div>
	*
 	*@alt
 	* no image displayed
 	*
 */
p5.Table.prototype.getNum = function(row, column) {
  return this.rows[row].getNum(column);
};

/**
 * Retrieves a String value from the Table's specified row and column.
 * The row is specified by its ID, while the column may be specified by
 * either its ID or title.
 *
 * @method  getString
 * @param {Number} row row ID
 * @param  {String|Number} column columnName (string) or
 *                                   ID (number)
 * @return {String}
 *
 * @example
	* <div class="norender">
	* <code>
	* // Given the CSV file "mammals.csv"
	* // in the project's "assets" folder:
	* //
	* // id,species,name
	* // 0,Capra hircus,Goat
	* // 1,Panthera pardus,Leopard
	* // 2,Equus zebra,Zebra
	*
	* var table;
	*
	* function preload() {
	*   //my table is comma separated value "csv"
	*   //and has a header specifying the columns labels
	*   table = loadTable("assets/mammals.csv", "csv", "header");
	* }
	*
	* function setup() {
	*   var tableArray = table.getArray();
	*
	*   //output each row as array
	*   for (var i = 0; i < tableArray.length; i++)
	*     print(tableArray[i]);
	* }
	* </code>
	* </div>
	*
 	*@alt
 	* no image displayed
 	*
 */
p5.Table.prototype.getString = function(row, column) {
  return this.rows[row].getString(column);
};

/**
 * Retrieves all table data and returns as an object. If a column name is
 * passed in, each row object will be stored with that attribute as its
 * title.
 *
 * @method  getObject
 * @param {String} headerColumn Name of the column which should be used to
 *                              title each row object (optional)
 * @return {Object}
 *
 * @example
	* <div class="norender">
	* <code>
	* // Given the CSV file "mammals.csv"
	* // in the project's "assets" folder:
	* //
	* // id,species,name
	* // 0,Capra hircus,Goat
	* // 1,Panthera pardus,Leopard
	* // 2,Equus zebra,Zebra
	*
	* var table;
	*
	* function preload() {
	*   //my table is comma separated value "csv"
	*   //and has a header specifying the columns labels
	*   table = loadTable("assets/mammals.csv", "csv", "header");
	* }
	*
	* function setup() {
	*   var tableObject = table.getObject();
	*
	*   print(tableObject);
	*   //outputs an object
	* }
	* </code>
	* </div>
	*
 	*@alt
 	* no image displayed
 	*
 */
p5.Table.prototype.getObject = function (headerColumn) {
  var tableObject = {};
  var obj, cPos, index;

  for(var i = 0; i < this.rows.length; i++) {
    obj = this.rows[i].obj;

    if (typeof(headerColumn) === 'string'){
      cPos = this.columns.indexOf(headerColumn); // index of columnID
      if (cPos >= 0) {
        index = obj[headerColumn];
        tableObject[index] = obj;
      } else {
        throw 'This table has no column named "' + headerColumn +'"';
      }
    } else {
      tableObject[i] = this.rows[i].obj;
    }
  }
  return tableObject;
};

/**
 * Retrieves all table data and returns it as a multidimensional array.
 *
 * @method  getArray
 * @return {Array}
 */
p5.Table.prototype.getArray = function () {
  var tableArray = [];
  for(var i = 0; i < this.rows.length; i++) {
    tableArray.push(this.rows[i].arr);
  }
  return tableArray;
};

module.exports = p5.Table;

},{"../core/core":42}],66:[function(_dereq_,module,exports){
/**
 * @module IO
 * @submodule Table
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');

/**
 *  A TableRow object represents a single row of data values,
 *  stored in columns, from a table.
 *
 *  A Table Row contains both an ordered array, and an unordered
 *  JSON object.
 *
 *  @class p5.TableRow
 *  @constructor
 *  @param {String} [str]       optional: populate the row with a
 *                              string of values, separated by the
 *                              separator
 *  @param {String} [separator] comma separated values (csv) by default
 */
p5.TableRow = function (str, separator) {
  var arr = [];
  var obj = {};
  if (str){
    separator = separator || ',';
    arr = str.split(separator);
  }
  for (var i = 0; i < arr.length; i++){
    var key = i;
    var val = arr[i];
    obj[key] = val;
  }
  this.arr = arr;
  this.obj = obj;
  this.table = null;
};

/**
 *  Stores a value in the TableRow's specified column.
 *  The column may be specified by either its ID or title.
 *
 *  @method  set
 *  @param {String|Number} column Column ID (Number)
 *                                or Title (String)
 *  @param {String|Number} value  The value to be stored
 */
p5.TableRow.prototype.set = function(column, value) {
  // if typeof column is string, use .obj
  if (typeof(column) === 'string'){
    var cPos = this.table.columns.indexOf(column); // index of columnID
    if (cPos >= 0) {
      this.obj[column] = value;
      this.arr[cPos] = value;
    }
    else {
      throw 'This table has no column named "' + column +'"';
    }
  }

  // if typeof column is number, use .arr
  else {
    if (column < this.table.columns.length) {
      this.arr[column] = value;
      var cTitle = this.table.columns[column];
      this.obj[cTitle] = value;
    }
    else {
      throw 'Column #' + column + ' is out of the range of this table';
    }
  }
};


/**
 *  Stores a Float value in the TableRow's specified column.
 *  The column may be specified by either its ID or title.
 *
 *  @method  setNum
 *  @param {String|Number} column Column ID (Number)
 *                                or Title (String)
 *  @param {Number} value  The value to be stored
 *                                as a Float
 */
p5.TableRow.prototype.setNum = function(column, value){
  var floatVal = parseFloat(value, 10);
  this.set(column, floatVal);
};


/**
 *  Stores a String value in the TableRow's specified column.
 *  The column may be specified by either its ID or title.
 *
 *  @method  setString
 *  @param {String|Number} column Column ID (Number)
 *                                or Title (String)
 *  @param {String} value  The value to be stored
 *                                as a String
 */
p5.TableRow.prototype.setString = function(column, value){
  var stringVal = value.toString();
  this.set(column, stringVal);
};

/**
 *  Retrieves a value from the TableRow's specified column.
 *  The column may be specified by either its ID or title.
 *
 *  @method  get
 *  @param  {String|Number} column columnName (string) or
 *                                   ID (number)
 *  @return {String|Number}
 */
p5.TableRow.prototype.get = function(column) {
  if (typeof(column) === 'string'){
    return this.obj[column];
  } else {
    return this.arr[column];
  }
};

/**
 *  Retrieves a Float value from the TableRow's specified
 *  column. The column may be specified by either its ID or
 *  title.
 *
 *  @method  getNum
 *  @param  {String|Number} column columnName (string) or
 *                                   ID (number)
 *  @return {Number}  Float Floating point number
 */
p5.TableRow.prototype.getNum = function(column) {
  var ret;
  if (typeof(column) === 'string'){
    ret = parseFloat(this.obj[column], 10);
  } else {
    ret = parseFloat(this.arr[column], 10);
  }

  if (ret.toString() === 'NaN') {
    throw 'Error: ' + this.obj[column]+ ' is NaN (Not a Number)';
  }
  return ret;
};

/**
 *  Retrieves an String value from the TableRow's specified
 *  column. The column may be specified by either its ID or
 *  title.
 *
 *  @method  getString
 *  @param  {String|Number} column columnName (string) or
 *                                   ID (number)
 *  @return {String}  String
 */
p5.TableRow.prototype.getString = function(column) {
  if (typeof(column) === 'string'){
    return this.obj[column].toString();
  } else {
    return this.arr[column].toString();
  }
};

module.exports = p5.TableRow;

},{"../core/core":42}],67:[function(_dereq_,module,exports){
/**
 * @module IO
 * @submodule XML
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');

/**
 * XML is a representation of an XML object, able to parse XML code. Use
 * loadXML() to load external XML files and create XML objects.
 *
 * @class p5.XML
 * @constructor
 * @return {p5.XML}    p5.XML object generated
 * @example
 * <div class='norender'><code>
 * // The following short XML file called "mammals.xml" is parsed
 * // in the code below.
 * //
 * // <?xml version="1.0"?>
 * // &lt;mammals&gt;
 * //   &lt;animal id="0" species="Capra hircus">Goat&lt;/animal&gt;
 * //   &lt;animal id="1" species="Panthera pardus">Leopard&lt;/animal&gt;
 * //   &lt;animal id="2" species="Equus zebra">Zebra&lt;/animal&gt;
 * // &lt;/mammals&gt;
 *
 * var xml;
 *
 * function preload() {
 *   xml = loadXML("assets/mammals.xml");
 * }
 *
 * function setup() {
 *   var children = xml.getChildren("animal");
 *
 *   for (var i = 0; i < children.length; i++) {
 *     var id = children[i].getNum("id");
 *     var coloring = children[i].getString("species");
 *     var name = children[i].getContent();
 *     print(id + ", " + coloring + ", " + name);
 *   }
 * }
 *
 * // Sketch prints:
 * // 0, Capra hircus, Goat
 * // 1, Panthera pardus, Leopard
 * // 2, Equus zebra, Zebra
 * </code></div>
  *
  * @alt
  * no image displayed
  *
 */
p5.XML = function () {
  this.name = null; //done
  this.attributes = {}; //done
  this.children = [];
  this.parent = null;
  this.content = null; //done
};


/**
 * Gets a copy of the element's parent. Returns the parent as another
 * p5.XML object.
 *
 * @method getParent
 * @return {Object}   element parent
 * @example
 * <div class='norender'><code>
 * // The following short XML file called "mammals.xml" is parsed
 * // in the code below.
 * //
 * // <?xml version="1.0"?>
 * // &lt;mammals&gt;
 * //   &lt;animal id="0" species="Capra hircus">Goat&lt;/animal&gt;
 * //   &lt;animal id="1" species="Panthera pardus">Leopard&lt;/animal&gt;
 * //   &lt;animal id="2" species="Equus zebra">Zebra&lt;/animal&gt;
 * // &lt;/mammals&gt;
 *
 * var xml;
 *
 * function preload() {
 *   xml = loadXML("assets/mammals.xml");
 * }
 *
 * function setup() {
 *   var children = xml.getChildren("animal");
 *   var parent = children[1].getParent();
 *   print(parent.getName());
 * }
 *
 * // Sketch prints:
 * // mammals
 * </code></div>
 */
p5.XML.prototype.getParent = function() {
  return this.parent;
};

/**
 *  Gets the element's full name, which is returned as a String.
 *
 * @method getName
 * @return {String} the name of the node
 * @example&lt;animal
 * <div class='norender'><code>
 * // The following short XML file called "mammals.xml" is parsed
 * // in the code below.
 * //
 * // <?xml version="1.0"?>
 * // &lt;mammals&gt;
 * //   &lt;animal id="0" species="Capra hircus">Goat&lt;/animal&gt;
 * //   &lt;animal id="1" species="Panthera pardus">Leopard&lt;/animal&gt;
 * //   &lt;animal id="2" species="Equus zebra">Zebra&lt;/animal&gt;
 * // &lt;/mammals&gt;
 *
 * var xml;
 *
 * function preload() {
 *   xml = loadXML("assets/mammals.xml");
 * }
 *
 * function setup() {
 *   print(xml.getName());
 * }
 *
 * // Sketch prints:
 * // mammals
 * </code></div>
 */
p5.XML.prototype.getName = function() {
  return this.name;
};

/**
 * Sets the element's name, which is specified as a String.
 *
 * @method setName
 * @param {String} the new name of the node
 * @example&lt;animal
 * <div class='norender'><code>
 * // The following short XML file called "mammals.xml" is parsed
 * // in the code below.
 * //
 * // <?xml version="1.0"?>
 * // &lt;mammals&gt;
 * //   &lt;animal id="0" species="Capra hircus">Goat&lt;/animal&gt;
 * //   &lt;animal id="1" species="Panthera pardus">Leopard&lt;/animal&gt;
 * //   &lt;animal id="2" species="Equus zebra">Zebra&lt;/animal&gt;
 * // &lt;/mammals&gt;
 *
 * var xml;
 *
 * function preload() {
 *   xml = loadXML("assets/mammals.xml");
 * }
 *
 * function setup() {
 *   print(xml.getName());
 *   xml.setName("fish");
 *   print(xml.getName());
 * }
 *
 * // Sketch prints:
 * // mammals
 * // fish
 * </code></div>
 */
p5.XML.prototype.setName = function(name) {
  this.name = name;
};

/**
 * Checks whether or not the element has any children, and returns the result
 * as a boolean.
 *
 * @method hasChildren
 * @return {boolean}
 * @example&lt;animal
 * <div class='norender'><code>
 * // The following short XML file called "mammals.xml" is parsed
 * // in the code below.
 * //
 * // <?xml version="1.0"?>
 * // &lt;mammals&gt;
 * //   &lt;animal id="0" species="Capra hircus">Goat&lt;/animal&gt;
 * //   &lt;animal id="1" species="Panthera pardus">Leopard&lt;/animal&gt;
 * //   &lt;animal id="2" species="Equus zebra">Zebra&lt;/animal&gt;
 * // &lt;/mammals&gt;
 *
 * var xml;
 *
 * function preload() {
 *   xml = loadXML("assets/mammals.xml");
 * }
 *
 * function setup() {
 *   print(xml.hasChildren());
 * }
 *
 * // Sketch prints:
 * // true
 * </code></div>
 */
p5.XML.prototype.hasChildren = function() {
  return this.children.length > 0;
};

/**
 * Get the names of all of the element's children, and returns the names as an
 * array of Strings. This is the same as looping through and calling getName()
 * on each child element individually.
 *
 * @method listChildren
 * @return {Array} names of the children of the element
 * @example&lt;animal
 * <div class='norender'><code>
 * // The following short XML file called "mammals.xml" is parsed
 * // in the code below.
 * //
 * // <?xml version="1.0"?>
 * // &lt;mammals&gt;
 * //   &lt;animal id="0" species="Capra hircus">Goat&lt;/animal&gt;
 * //   &lt;animal id="1" species="Panthera pardus">Leopard&lt;/animal&gt;
 * //   &lt;animal id="2" species="Equus zebra">Zebra&lt;/animal&gt;
 * // &lt;/mammals&gt;
 *
 * var xml;
 *
 * function preload() {
 *   xml = loadXML("assets/mammals.xml");
 * }
 *
 * function setup() {
 *   print(xml.listChildren());
 * }
 *
 * // Sketch prints:
 * // ["animal", "animal", "animal"]
 * </code></div>
 */
p5.XML.prototype.listChildren = function() {
  return this.children.map(function(c) { return c.name; });
};

/**
 * Returns all of the element's children as an array of p5.XML objects. When
 * the name parameter is specified, then it will return all children that match
 * that name.
 *
 * @method getChildren
 * @param {String} [name] element name
 * @return {Array} children of the element
 * @example&lt;animal
 * <div class='norender'><code>
 * // The following short XML file called "mammals.xml" is parsed
 * // in the code below.
 * //
 * // <?xml version="1.0"?>
 * // &lt;mammals&gt;
 * //   &lt;animal id="0" species="Capra hircus">Goat&lt;/animal&gt;
 * //   &lt;animal id="1" species="Panthera pardus">Leopard&lt;/animal&gt;
 * //   &lt;animal id="2" species="Equus zebra">Zebra&lt;/animal&gt;
 * // &lt;/mammals&gt;
 *
 * var xml;
 *
 * function preload() {
 *   xml = loadXML("assets/mammals.xml");
 * }
 *
 * function setup() {
 *   var animals = xml.getChildren("animal");
 *
 *   for (var i = 0; i < animals.length; i++) {
 *     print(animals[i].getContent());
 *   }
 * }
 *
 * // Sketch prints:
 * // "Goat"
 * // "Leopard"
 * // "Zebra"
 * </code></div>
 */
p5.XML.prototype.getChildren = function(param) {
  if (param) {
    return this.children.filter(function(c) { return c.name === param; });
  }
  else {
    return this.children;
  }
};

/**
 * Returns the first of the element's children that matches the name parameter
 * or the child of the given index.It returns undefined if no matching
 * child is found.
 *
 * @method getChild
 * @param {String|Number} name element name or index
 * @return {p5.XML}
 * @example&lt;animal
 * <div class='norender'><code>
 * // The following short XML file called "mammals.xml" is parsed
 * // in the code below.
 * //
 * // <?xml version="1.0"?>
 * // &lt;mammals&gt;
 * //   &lt;animal id="0" species="Capra hircus">Goat&lt;/animal&gt;
 * //   &lt;animal id="1" species="Panthera pardus">Leopard&lt;/animal&gt;
 * //   &lt;animal id="2" species="Equus zebra">Zebra&lt;/animal&gt;
 * // &lt;/mammals&gt;
 *
 * var xml;
 *
 * function preload() {
 *   xml = loadXML("assets/mammals.xml");
 * }
 *
 * function setup() {
 *   var firstChild = xml.getChild("animal");
 *   print(firstChild.getContent());
 * }
 *
 * // Sketch prints:
 * // "Goat"
 * </code></div>
 * <div class='norender'><code>
 * var xml;
 *
 * function preload() {
 *   xml = loadXML("assets/mammals.xml");
 * }
 *
 * function setup() {
 *   var secondChild = xml.getChild(1);
 *   print(secondChild.getContent());
 * }
 *
 * // Sketch prints:
 * // "Leopard"
 * </code></div>
 */
p5.XML.prototype.getChild = function(param) {
  if(typeof param === 'string') {
    return this.children.find(function(c) {
      return c.name === param;
    });
  }
  else {
    return this.children[param];
  }
};

/**
 * Appends a new child to the element. The child can be specified with
 * either a String, which will be used as the new tag's name, or as a
 * reference to an existing p5.XML object.
 * A reference to the newly created child is returned as an p5.XML object.
 *
 * @method addChild
 * @param {Object} a p5.XML Object which will be the child to be added
 */
p5.XML.prototype.addChild = function(node) {
  if (node instanceof p5.XML) {
    this.children.push(node);
  } else {
    // PEND
  }
};

/**
 * Removes the element specified by name or index.
 *
 * @method removeChild
 * @param {String|Number} name element name or index
 * @example
 * <div class='norender'><code>
 * // The following short XML file called "mammals.xml" is parsed
 * // in the code below.
 * //
 * // <?xml version="1.0"?>
 * // &lt;mammals&gt;
 * //   &lt;animal id="0" species="Capra hircus">Goat&lt;/animal&gt;
 * //   &lt;animal id="1" species="Panthera pardus">Leopard&lt;/animal&gt;
 * //   &lt;animal id="2" species="Equus zebra">Zebra&lt;/animal&gt;
 * // &lt;/mammals&gt;
 *
 * var xml;
 *
 * function preload() {
 *   xml = loadXML("assets/mammals.xml");
 * }
 *
 * function setup() {
 *   xml.removeChild("animal");
 *   var children = xml.getChildren();
 *   for (var i=0; i<children.length; i++) {
 *     print(children[i].getContent());
 *   }
 * }
 *
 * // Sketch prints:
 * // "Leopard"
 * // "Zebra"
 * </code></div>
 * <div class='norender'><code>
 * var xml;
 *
 * function preload() {
 *   xml = loadXML("assets/mammals.xml");
 * }
 *
 * function setup() {
 *   xml.removeChild(1);
 *   var children = xml.getChildren();
 *   for (var i=0; i<children.length; i++) {
 *     print(children[i].getContent());
 *   }
 * }
 *
 * // Sketch prints:
 * // "Goat"
 * // "Zebra"
 * </code></div>
 */
p5.XML.prototype.removeChild = function(param) {
  var ind = -1;
  if(typeof param === 'string') {
    for (var i=0; i<this.children.length; i++) {
      if (this.children[i].name === param) {
        ind = i;
        break;
      }
    }
  } else {
    ind = param;
  }
  if (ind !== -1) {
    this.children.splice(ind, 1);
  }
};


/**
 * Counts the specified element's number of attributes, returned as an Number.
 *
 * @method getAttributeCount
 * @return {Number}
 * @example
 * <div class='norender'><code>
 * // The following short XML file called "mammals.xml" is parsed
 * // in the code below.
 * //
 * // <?xml version="1.0"?>
 * // &lt;mammals&gt;
 * //   &lt;animal id="0" species="Capra hircus">Goat&lt;/animal&gt;
 * //   &lt;animal id="1" species="Panthera pardus">Leopard&lt;/animal&gt;
 * //   &lt;animal id="2" species="Equus zebra">Zebra&lt;/animal&gt;
 * // &lt;/mammals&gt;
 *
 * var xml;
 *
 * function preload() {
 *   xml = loadXML("assets/mammals.xml");
 * }
 *
 * function setup() {
 *   var firstChild = xml.getChild("animal");
 *   print(firstChild.getAttributeCount());
 * }
 *
 * // Sketch prints:
 * // 2
 * </code></div>
 */
p5.XML.prototype.getAttributeCount = function() {
  return Object.keys(this.attributes).length;
};

/**
 * Gets all of the specified element's attributes, and returns them as an
 * array of Strings.
 *
 * @method listAttributes
 * @return {Array} an array of strings containing the names of attributes
 * @example
 * <div class='norender'><code>
 * // The following short XML file called "mammals.xml" is parsed
 * // in the code below.
 * //
 * // <?xml version="1.0"?>
 * // &lt;mammals&gt;
 * //   &lt;animal id="0" species="Capra hircus">Goat&lt;/animal&gt;
 * //   &lt;animal id="1" species="Panthera pardus">Leopard&lt;/animal&gt;
 * //   &lt;animal id="2" species="Equus zebra">Zebra&lt;/animal&gt;
 * // &lt;/mammals&gt;
 *
 * var xml;
 *
 * function preload() {
 *   xml = loadXML("assets/mammals.xml");
 * }
 *
 * function setup() {
 *   var firstChild = xml.getChild("animal");
 *   print(firstChild.listAttributes());
 * }
 *
 * // Sketch prints:
 * // ["id", "species"]
 * </code></div>
 */
p5.XML.prototype.listAttributes = function() {
  return Object.keys(this.attributes);
};

/**
 *  Checks whether or not an element has the specified attribute.
 *
 * @method hasAttribute
 * @param {String} the attribute to be checked
 * @return {boolean} true if attribute found else false
 * @example
 * <div class='norender'><code>
 * // The following short XML file called "mammals.xml" is parsed
 * // in the code below.
 * //
 * // <?xml version="1.0"?>
 * // &lt;mammals&gt;
 * //   &lt;animal id="0" species="Capra hircus">Goat&lt;/animal&gt;
 * //   &lt;animal id="1" species="Panthera pardus">Leopard&lt;/animal&gt;
 * //   &lt;animal id="2" species="Equus zebra">Zebra&lt;/animal&gt;
 * // &lt;/mammals&gt;
 *
 * var xml;
 *
 * function preload() {
 *   xml = loadXML("assets/mammals.xml");
 * }
 *
 * function setup() {
 *   var firstChild = xml.getChild("animal");
 *   print(firstChild.hasAttribute("species"));
 *   print(firstChild.hasAttribute("color"));
 * }
 *
 * // Sketch prints:
 * // true
 * // false
 * </code></div>
 */
p5.XML.prototype.hasAttribute = function(name) {
  return this.attributes[name] ? true : false;
};

/**
 * Returns an attribute value of the element as an Number. If the defaultValue
 * parameter is specified and the attribute doesn't exist, then defaultValue
 * is returned. If no defaultValue is specified and the attribute doesn't
 * exist, the value 0 is returned.
 *
 * @method getNum
 * @param {String} name            the non-null full name of the attribute
 * @param {Number} [defaultValue]  the default value of the attribute
 * @return {Number}
 * @example
 * <div class='norender'><code>
 * // The following short XML file called "mammals.xml" is parsed
 * // in the code below.
 * //
 * // <?xml version="1.0"?>
 * // &lt;mammals&gt;
 * //   &lt;animal id="0" species="Capra hircus">Goat&lt;/animal&gt;
 * //   &lt;animal id="1" species="Panthera pardus">Leopard&lt;/animal&gt;
 * //   &lt;animal id="2" species="Equus zebra">Zebra&lt;/animal&gt;
 * // &lt;/mammals&gt;
 *
 * var xml;
 *
 * function preload() {
 *   xml = loadXML("assets/mammals.xml");
 * }
 *
 * function setup() {
 *   var firstChild = xml.getChild("animal");
 *   print(firstChild.getNum("id"));
 * }
 *
 * // Sketch prints:
 * // 0
 * </code></div>
 */
p5.XML.prototype.getNum = function(name, defaultValue) {
  return Number(this.attributes[name]) || defaultValue || 0;
};

/**
 * Returns an attribute value of the element as an String. If the defaultValue
 * parameter is specified and the attribute doesn't exist, then defaultValue
 * is returned. If no defaultValue is specified and the attribute doesn't
 * exist, null is returned.
 *
 * @method getString
 * @param {String} name            the non-null full name of the attribute
 * @param {Number} [defaultValue]  the default value of the attribute
 * @return {Number}
 * @example
 * <div class='norender'><code>
 * // The following short XML file called "mammals.xml" is parsed
 * // in the code below.
 * //
 * // <?xml version="1.0"?>
 * // &lt;mammals&gt;
 * //   &lt;animal id="0" species="Capra hircus">Goat&lt;/animal&gt;
 * //   &lt;animal id="1" species="Panthera pardus">Leopard&lt;/animal&gt;
 * //   &lt;animal id="2" species="Equus zebra">Zebra&lt;/animal&gt;
 * // &lt;/mammals&gt;
 *
 * var xml;
 *
 * function preload() {
 *   xml = loadXML("assets/mammals.xml");
 * }
 *
 * function setup() {
 *   var firstChild = xml.getChild("animal");
 *   print(firstChild.getString("species"));
 * }
 *
 * // Sketch prints:
 * // "Capra hircus"
 * </code></div>
 */
p5.XML.prototype.getString = function(name, defaultValue) {
  return String(this.attributes[name]) || defaultValue || null;
};

/**
 * Sets the content of an element's attribute. The first parameter specifies
 * the attribute name, while the second specifies the new content.
 *
 * @method setAttribute
 * @param {String} name            the full name of the attribute
 * @param {Number} value           the value of the attribute
 * @example
 * <div class='norender'><code>
 * // The following short XML file called "mammals.xml" is parsed
 * // in the code below.
 * //
 * // <?xml version="1.0"?>
 * // &lt;mammals&gt;
 * //   &lt;animal id="0" species="Capra hircus">Goat&lt;/animal&gt;
 * //   &lt;animal id="1" species="Panthera pardus">Leopard&lt;/animal&gt;
 * //   &lt;animal id="2" species="Equus zebra">Zebra&lt;/animal&gt;
 * // &lt;/mammals&gt;
 *
 * var xml;
 *
 * function preload() {
 *   xml = loadXML("assets/mammals.xml");
 * }
 *
 * function setup() {
 *   var firstChild = xml.getChild("animal");
 *   print(firstChild.getString("species"));
 *   firstChild.setAttribute("species", "Jamides zebra");
 *   print(firstChild.getString("species"));
 * }
 *
 * // Sketch prints:
 * // "Capra hircus"
 * // "Jamides zebra"
 * </code></div>
 */
p5.XML.prototype.setAttribute = function(name, value) {
  if (this.attributes[name]) {
    this.attributes[name] = value;
  }
};

/**
 * Returns the content of an element. If there is no such content,
 * defaultValue is returned if specified, otherwise null is returned.
 *
 * @method getContent
 * @param {String} [defaultValue] value returned if no content is found
 * @return {String}
 * @example
 * <div class='norender'><code>
 * // The following short XML file called "mammals.xml" is parsed
 * // in the code below.
 * //
 * // <?xml version="1.0"?>
 * // &lt;mammals&gt;
 * //   &lt;animal id="0" species="Capra hircus">Goat&lt;/animal&gt;
 * //   &lt;animal id="1" species="Panthera pardus">Leopard&lt;/animal&gt;
 * //   &lt;animal id="2" species="Equus zebra">Zebra&lt;/animal&gt;
 * // &lt;/mammals&gt;
 *
 * var xml;
 *
 * function preload() {
 *   xml = loadXML("assets/mammals.xml");
 * }
 *
 * function setup() {
 *   var firstChild = xml.getChild("animal");
 *   print(firstChild.getContent());
 * }
 *
 * // Sketch prints:
 * // "Goat"
 * </code></div>
 */
p5.XML.prototype.getContent = function(defaultValue) {
  return this.content || defaultValue || null;
};

/**
 * Sets the element's content.
 *
 * @method setContent
 * @param {String} text the new content
 * @example
 * <div class='norender'><code>
 * // The following short XML file called "mammals.xml" is parsed
 * // in the code below.
 * //
 * // <?xml version="1.0"?>
 * // &lt;mammals&gt;
 * //   &lt;animal id="0" species="Capra hircus">Goat&lt;/animal&gt;
 * //   &lt;animal id="1" species="Panthera pardus">Leopard&lt;/animal&gt;
 * //   &lt;animal id="2" species="Equus zebra">Zebra&lt;/animal&gt;
 * // &lt;/mammals&gt;
 *
 * var xml;
 *
 * function preload() {
 *   xml = loadXML("assets/mammals.xml");
 * }
 *
 * function setup() {
 *   var firstChild = xml.getChild("animal");
 *   print(firstChild.getContent());
 *   firstChild.setContent("Mountain Goat");
 *   print(firstChild.getContent());
 * }
 *
 * // Sketch prints:
 * // "Goat"
 * // "Mountain Goat"
 * </code></div>
 */
p5.XML.prototype.setContent = function( content ) {
  if(!this.children.length) {
    this.content = content;
  }
};

/* HELPERS */
/**
 * This method is called while the parsing of XML (when loadXML() is
 * called). The difference between this method and the setContent()
 * method defined later is that this one is used to set the content
 * when the node in question has more nodes under it and so on and
 * not directly text content. While in the other one is used when
 * the node in question directly has text inside it.
 *
 */
p5.XML.prototype._setCont = function(content) {
  var str;
  str = content;
  str = str.replace(/\s\s+/g, ',');
  //str = str.split(',');
  this.content = str;
};

/**
 * This method is called while the parsing of XML (when loadXML() is
 * called). The XML node is passed and its attributes are stored in the
 * p5.XML's attribute Object.
 *
 */
p5.XML.prototype._setAttributes = function(node) {
  var  i, att = {};
  for( i = 0; i < node.attributes.length; i++) {
    att[node.attributes[i].nodeName] = node.attributes[i].nodeValue;
  }
  this.attributes = att;
};

module.exports = p5.XML;
},{"../core/core":42}],68:[function(_dereq_,module,exports){
/**
 * @module Math
 * @submodule Calculation
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');

/**
 * Calculates the absolute value (magnitude) of a number. Maps to Math.abs().
 * The absolute value of a number is always positive.
 *
 * @method abs
 * @param  {Number} n number to compute
 * @return {Number}   absolute value of given number
 * @example
 * <div class = "norender"><code>
 * function setup() {
 *   var x = -3;
 *   var y = abs(x);
 *
 *   print(x); // -3
 *   print(y); // 3
 * }
 * </code></div>
 *
 * @alt
 * no image displayed
 *
 */
p5.prototype.abs = Math.abs;

/**
 * Calculates the closest int value that is greater than or equal to the
 * value of the parameter. Maps to Math.ceil(). For example, ceil(9.03)
 * returns the value 10.
 *
 * @method ceil
 * @param  {Number} n number to round up
 * @return {Number}   rounded up number
 * @example
 * <div><code>
 * function draw() {
 *   background(200);
 *   // map, mouseX between 0 and 5.
 *   var ax = map(mouseX, 0, 100, 0, 5);
 *   var ay = 66;
 *
 *   //Get the ceiling of the mapped number.
 *   var bx = ceil(map(mouseX, 0, 100, 0,5));
 *   var by = 33;
 *
 *   // Multiply the mapped numbers by 20 to more easily
 *   // see the changes.
 *   stroke(0);
 *   fill(0);
 *   line(0, ay, ax * 20, ay);
 *   line(0, by, bx * 20, by);
 *
 *   // Reformat the float returned by map and draw it.
 *   noStroke();
 *   text(nfc(ax, 2,2), ax, ay - 5);
 *   text(nfc(bx,1,1), bx, by - 5);
 * }
 * </code></div>
  *
 * @alt
 * 2 horizontal lines & number sets. increase with mouse x. bottom to 2 decimals
 *
 */
p5.prototype.ceil = Math.ceil;

/**
 * Constrains a value between a minimum and maximum value.
 *
 * @method constrain
 * @param  {Number} n    number to constrain
 * @param  {Number} low  minimum limit
 * @param  {Number} high maximum limit
 * @return {Number}      constrained number
 * @example
 * <div><code>
 * function draw() {
 *   background(200);
 *
 *   var leftWall = 25;
 *   var rightWall = 75;
 *
 *   // xm is just the mouseX, while
 *   // xc is the mouseX, but constrained
 *   // between the leftWall and rightWall!
 *   var xm = mouseX;
 *   var xc = constrain(mouseX, leftWall, rightWall);
 *
 *   // Draw the walls.
 *   stroke(150);
 *   line(leftWall, 0, leftWall, height);
 *   line(rightWall, 0, rightWall, height);
 *
 *   // Draw xm and xc as circles.
 *   noStroke();
 *   fill(150);
 *   ellipse(xm, 33, 9,9); // Not Constrained
 *   fill(0);
 *   ellipse(xc, 66, 9,9); // Constrained
 * }
 * </code></div>
 *
 * @alt
 * 2 vertical lines. 2 ellipses move with mouse X 1 does not move passed lines
 *
 */
p5.prototype.constrain = function(n, low, high) {
  return Math.max(Math.min(n, high), low);
};

/**
 * Calculates the distance between two points.
 *
 * @method dist
 * @param  {Number} x1 x-coordinate of the first point
 * @param  {Number} y1 y-coordinate of the first point
 * @param  {Number} [z1] z-coordinate of the first point
 * @param  {Number} x2 x-coordinate of the second point
 * @param  {Number} y2 y-coordinate of the second point
 * @param  {Number} [z2] z-coordinate of the second point
 * @return {Number}    distance between the two points
 * @example
 * <div><code>
 * // Move your mouse inside the canvas to see the
 * // change in distance between two points!
 * function draw() {
 *   background(200);
 *   fill(0);
 *
 *   var x1 = 10;
 *   var y1 = 90;
 *   var x2 = mouseX;
 *   var y2 = mouseY;
 *
 *   line(x1, y1, x2, y2);
 *   ellipse(x1, y1, 7, 7);
 *   ellipse(x2, y2, 7, 7);
 *
 *   // d is the length of the line
 *   // the distance from point 1 to point 2.
 *   var d = int(dist(x1, y1, x2, y2));
 *
 *   // Let's write d along the line we are drawing!
 *   push();
 *   translate( (x1+x2)/2, (y1+y2)/2 );
 *   rotate( atan2(y2-y1,x2-x1) );
 *   text(nfc(d,1,1), 0, -5);
 *   pop();
 *   // Fancy!
 * }
 * </code></div>
 *
 * @alt
 * 2 ellipses joined by line. 1 ellipse moves with mouse X&Y. Distance displayed.
 *
 */
p5.prototype.dist = function(x1, y1, z1, x2, y2, z2) {
  if (arguments.length === 4) {
    // In the case of 2d: z1 means x2 and x2 means y2
    return hypot(z1-x1, x2-y1);
  } else if (arguments.length === 6) {
    return hypot(x2-x1, y2-y1, z2-z1);
  }
};

/**
 * Returns Euler's number e (2.71828...) raised to the power of the n
 * parameter. Maps to Math.exp().
 *
 * @method exp
 * @param  {Number} n exponent to raise
 * @return {Number}   e^n
 * @example
 * <div><code>
 * function draw() {
 *   background(200);
 *
 *   // Compute the exp() function with a value between 0 and 2
 *   var xValue = map(mouseX, 0, width, 0, 2);
 *   var yValue = exp(xValue);
 *
 *   var y = map(yValue, 0, 8, height, 0);
 *
 *   var legend = "exp (" + nfc(xValue, 3) +")\n= " + nf(yValue, 1, 4);
 *   stroke(150);
 *   line(mouseX, y, mouseX, height);
 *   fill(0);
 *   text(legend, 5, 15);
 *   noStroke();
 *   ellipse (mouseX,y, 7, 7);
 *
 *   // Draw the exp(x) curve,
 *   // over the domain of x from 0 to 2
 *   noFill();
 *   stroke(0);
 *   beginShape();
 *   for (var x = 0; x < width; x++) {
 *     xValue = map(x, 0, width, 0, 2);
 *     yValue = exp(xValue);
 *     y = map(yValue, 0, 8, height, 0);
 *     vertex(x, y);
 *   }
 *
 *   endShape();
 *   line(0, 0, 0, height);
 *   line(0, height-1, width, height-1);
 * }
 * </code></div>
 *
 * @alt
 * ellipse moves along a curve with mouse x. e^n displayed.
 *
 */
p5.prototype.exp = Math.exp;

/**
 * Calculates the closest int value that is less than or equal to the
 * value of the parameter. Maps to Math.floor().
 *
 * @method floor
 * @param  {Number} n number to round down
 * @return {Number}   rounded down number
 * @example
 * <div><code>
 * function draw() {
 *   background(200);
 *   //map, mouseX between 0 and 5.
 *   var ax = map(mouseX, 0, 100, 0, 5);
 *   var ay = 66;
 *
 *   //Get the floor of the mapped number.
 *   var bx = floor(map(mouseX, 0, 100, 0,5));
 *   var by = 33;
 *
 *   // Multiply the mapped numbers by 20 to more easily
 *   // see the changes.
 *   stroke(0);
 *   fill(0);
 *   line(0, ay, ax * 20, ay);
 *   line(0, by, bx * 20, by);
 *
 *   // Reformat the float returned by map and draw it.
 *   noStroke();
 *   text(nfc(ax, 2,2), ax, ay - 5);
 *   text(nfc(bx,1,1), bx, by - 5);
 * }
 * </code></div>
 *
 * @alt
 * 2 horizontal lines & number sets. increase with mouse x. bottom to 2 decimals
 *
 */
p5.prototype.floor = Math.floor;

/**
 * Calculates a number between two numbers at a specific increment. The amt
 * parameter is the amount to interpolate between the two values where 0.0
 * equal to the first point, 0.1 is very near the first point, 0.5 is
 * half-way in between, etc. The lerp function is convenient for creating
 * motion along a straight path and for drawing dotted lines.
 *
 * @method lerp
 * @param  {Number} start first value
 * @param  {Number} stop  second value
 * @param  {Number} amt   number between 0.0 and 1.0
 * @return {Number}       lerped value
 * @example
 * <div><code>
 * function setup() {
 *   background(200);
 *   var a = 20;
 *   var b = 80;
 *   var c = lerp(a,b, .2);
 *   var d = lerp(a,b, .5);
 *   var e = lerp(a,b, .8);
 *
 *   var y = 50
 *
 *   strokeWeight(5);
 *   stroke(0); // Draw the original points in black
 *   point(a, y);
 *   point(b, y);
 *
 *   stroke(100); // Draw the lerp points in gray
 *   point(c, y);
 *   point(d, y);
 *   point(e, y);
 * }
 * </code></div>
 *
 * @alt
 * 5 points horizontally staggered mid-canvas. mid 3 are grey, outer black
 *
 */
p5.prototype.lerp = function(start, stop, amt) {
  return amt*(stop-start)+start;
};

/**
 * Calculates the natural logarithm (the base-e logarithm) of a number. This
 * function expects the n parameter to be a value greater than 0.0. Maps to
 * Math.log().
 *
 * @method log
 * @param  {Number} n number greater than 0
 * @return {Number}   natural logarithm of n
 * @example
 * <div><code>
 * function draw() {
 *   background(200);
 *   var maxX = 2.8;
 *   var maxY = 1.5;
 *
 *   // Compute the natural log of a value between 0 and maxX
 *   var xValue = map(mouseX, 0, width, 0, maxX);
 *   if (xValue > 0) { // Cannot take the log of a negative number.
 *     var yValue = log(xValue);
 *     var y = map(yValue, -maxY, maxY, height, 0);
 *
 *     // Display the calculation occurring.
 *     var legend = "log(" + nf(xValue, 1, 2) + ")\n= " + nf(yValue, 1, 3);
 *     stroke(150);
 *     line(mouseX, y, mouseX, height);
 *     fill(0);
 *     text (legend, 5, 15);
 *     noStroke();
 *     ellipse (mouseX, y, 7, 7);
 *   }
 *
 *   // Draw the log(x) curve,
 *   // over the domain of x from 0 to maxX
 *   noFill();
 *   stroke(0);
 *   beginShape();
 *   for(var x=0; x < width; x++) {
 *     xValue = map(x, 0, width, 0, maxX);
 *     yValue = log(xValue);
 *     y = map(yValue, -maxY, maxY, height, 0);
 *     vertex(x, y);
 *   }
 *   endShape();
 *   line(0,0,0,height);
 *   line(0,height/2,width, height/2);
 * }
 * </code></div>
 *
 * @alt
 * ellipse moves along a curve with mouse x. natural logarithm of n displayed.
 *
 */
p5.prototype.log = Math.log;

/**
 * Calculates the magnitude (or length) of a vector. A vector is a direction
 * in space commonly used in computer graphics and linear algebra. Because it
 * has no "start" position, the magnitude of a vector can be thought of as
 * the distance from the coordinate 0,0 to its x,y value. Therefore, mag() is
 * a shortcut for writing dist(0, 0, x, y).
 *
 * @method mag
 * @param  {Number} a first value
 * @param  {Number} b second value
 * @return {Number}   magnitude of vector from (0,0) to (a,b)
 * @example
 * <div><code>
 * function setup() {
 *   var x1 = 20;
 *   var x2 = 80;
 *   var y1 = 30;
 *   var y2 = 70;
 *
 *   line(0, 0, x1, y1);
 *   print(mag(x1, y1));  // Prints "36.05551275463989"
 *   line(0, 0, x2, y1);
 *   print(mag(x2, y1));  // Prints "85.44003745317531"
 *   line(0, 0, x1, y2);
 *   print(mag(x1, y2));  // Prints "72.80109889280519"
 *   line(0, 0, x2, y2);
 *   print(mag(x2, y2));  // Prints "106.3014581273465"
 * }
 * </code></div>
 *
 * @alt
 * 4 lines of different length radiate from top left of canvas.
 *
 */
p5.prototype.mag = function(x, y) {
  return hypot(x, y);
};

/**
 * Re-maps a number from one range to another.
 * <br><br>
 * In the first example above, the number 25 is converted from a value in the
 * range of 0 to 100 into a value that ranges from the left edge of the
 * window (0) to the right edge (width).
 *
 * @method map
 * @param  {Number} value  the incoming value to be converted
 * @param  {Number} start1 lower bound of the value's current range
 * @param  {Number} stop1  upper bound of the value's current range
 * @param  {Number} start2 lower bound of the value's target range
 * @param  {Number} stop2  upper bound of the value's target range
 * @return {Number}        remapped number
 * @example
 *   <div><code>
 *     var value = 25;
 *     var m = map(value, 0, 100, 0, width);
 *     ellipse(m, 50, 10, 10);
 *   </code></div>
 *
 *   <div><code>
 *     function setup() {
 *       noStroke();
 *     }
 *
 *     function draw() {
 *       background(204);
 *       var x1 = map(mouseX, 0, width, 25, 75);
 *       ellipse(x1, 25, 25, 25);
 *       var x2 = map(mouseX, 0, width, 0, 100);
 *       ellipse(x2, 75, 25, 25);
 *     }
 *   </code></div>
 *
 * @alt
 * 10 by 10 white ellipse with in mid left canvas
 * 2 25 by 25 white ellipses move with mouse x. Bottom has more range from X
 *
 */
p5.prototype.map = function(n, start1, stop1, start2, stop2) {
  return ((n-start1)/(stop1-start1))*(stop2-start2)+start2;
};

/**
 * Determines the largest value in a sequence of numbers, and then returns
 * that value. max() accepts any number of Number parameters, or an Array
 * of any length.
 *
 * @method max
 * @param  {Number|Array} n0 Numbers to compare
 * @return {Number}          maximum Number
 * @example
 * <div><code>
 * function setup() {
 *   // Change the elements in the array and run the sketch
 *   // to show how max() works!
 *   numArray = new Array(2,1,5,4,8,9);
 *   fill(0);
 *   noStroke();
 *   text("Array Elements", 0, 10);
 *   // Draw all numbers in the array
 *   var spacing = 15;
 *   var elemsY = 25;
 *   for(var i = 0; i < numArray.length; i++) {
 *     text(numArray[i], i * spacing, elemsY);
 *   }
 *   maxX = 33;
 *   maxY = 80;
 *   // Draw the Maximum value in the array.
 *   textSize(32);
 *   text(max(numArray), maxX, maxY);
 * }
 * </code></div>
 *
 * @alt
 * Small text at top reads: Array Elements 2 1 5 4 8 9. Large text at center: 9
 *
 */
p5.prototype.max = function() {
  if (arguments[0] instanceof Array) {
    return Math.max.apply(null,arguments[0]);
  } else {
    return Math.max.apply(null,arguments);
  }
};

/**
 * Determines the smallest value in a sequence of numbers, and then returns
 * that value. min() accepts any number of Number parameters, or an Array
 * of any length.
 *
 * @method min
 * @param  {Number|Array} n0 Numbers to compare
 * @return {Number}          minimum Number
 * @example
 * <div><code>
 * function setup() {
 *   // Change the elements in the array and run the sketch
 *   // to show how min() works!
 *   numArray = new Array(2,1,5,4,8,9);
 *   fill(0);
 *   noStroke();
 *   text("Array Elements", 0, 10);
 *   // Draw all numbers in the array
 *   var spacing = 15;
 *   var elemsY = 25;
 *   for(var i = 0; i < numArray.length; i++) {
 *     text(numArray[i], i * spacing, elemsY);
 *   }
 *   maxX = 33;
 *   maxY = 80;
 *   // Draw the Minimum value in the array.
 *   textSize(32);
 *   text(min(numArray), maxX, maxY);
 * }
 * </code></div>
 *
 * @alt
 * Small text at top reads: Array Elements 2 1 5 4 8 9. Large text at center: 1
 *
 */
p5.prototype.min = function() {
  if (arguments[0] instanceof Array) {
    return Math.min.apply(null,arguments[0]);
  } else {
    return Math.min.apply(null,arguments);
  }
};

/**
 * Normalizes a number from another range into a value between 0 and 1.
 * Identical to map(value, low, high, 0, 1).
 * Numbers outside of the range are not clamped to 0 and 1, because
 * out-of-range values are often intentional and useful. (See the second
 * example above.)
 *
 * @method norm
 * @param  {Number} value incoming value to be normalized
 * @param  {Number} start lower bound of the value's current range
 * @param  {Number} stop  upper bound of the value's current range
 * @return {Number}       normalized number
 * @example
 * <div><code>
 * function draw() {
 *   background(200);
 *   currentNum = mouseX;
 *   lowerBound = 0;
 *   upperBound = width; //100;
 *   normalized = norm(currentNum, lowerBound, upperBound);
 *   lineY = 70
 *   line(0, lineY, width, lineY);
 *   //Draw an ellipse mapped to the non-normalized value.
 *   noStroke();
 *   fill(50)
 *   var s = 7; // ellipse size
 *   ellipse(currentNum, lineY, s, s);
 *
 *   // Draw the guide
 *   guideY = lineY + 15;
 *   text("0", 0, guideY);
 *   textAlign(RIGHT);
 *   text("100", width, guideY);
 *
 *   // Draw the normalized value
 *   textAlign(LEFT);
 *   fill(0);
 *   textSize(32);
 *   normalY = 40;
 *   normalX = 20;
 *   text(normalized, normalX, normalY);
 * }
 * </code></div>
 *
 * @alt
 * ellipse moves with mouse. 0 shown left & 100 right and updating values center
 *
 */
p5.prototype.norm = function(n, start, stop) {
  return this.map(n, start, stop, 0, 1);
};

/**
 * Facilitates exponential expressions. The pow() function is an efficient
 * way of multiplying numbers by themselves (or their reciprocals) in large
 * quantities. For example, pow(3, 5) is equivalent to the expression
 * 3*3*3*3*3 and pow(3, -5) is equivalent to 1 / 3*3*3*3*3. Maps to
 * Math.pow().
 *
 * @method pow
 * @param  {Number} n base of the exponential expression
 * @param  {Number} e power by which to raise the base
 * @return {Number}   n^e
 * @example
 * <div><code>
 * function setup() {
 *   //Exponentially increase the size of an ellipse.
 *   eSize = 3; // Original Size
 *   eLoc = 10; // Original Location
 *
 *   ellipse(eLoc, eLoc, eSize, eSize);
 *
 *   ellipse(eLoc*2, eLoc*2, pow(eSize, 2), pow(eSize, 2));
 *
 *   ellipse(eLoc*4, eLoc*4, pow(eSize, 3), pow(eSize, 3));
 *
 *   ellipse(eLoc*8, eLoc*8, pow(eSize, 4), pow(eSize, 4));
 * }
 * </code></div>
 *
 * @alt
 * small to large ellipses radiating from top left of canvas
 *
 */
p5.prototype.pow = Math.pow;

/**
 * Calculates the integer closest to the n parameter. For example,
 * round(133.8) returns the value 134. Maps to Math.round().
 *
 * @method round
 * @param  {Number} n number to round
 * @return {Number}   rounded number
 * @example
 * <div><code>
 * function draw() {
 *   background(200);
 *   //map, mouseX between 0 and 5.
 *   var ax = map(mouseX, 0, 100, 0, 5);
 *   var ay = 66;
 *
 *   // Round the mapped number.
 *   var bx = round(map(mouseX, 0, 100, 0,5));
 *   var by = 33;
 *
 *   // Multiply the mapped numbers by 20 to more easily
 *   // see the changes.
 *   stroke(0);
 *   fill(0);
 *   line(0, ay, ax * 20, ay);
 *   line(0, by, bx * 20, by);
 *
 *   // Reformat the float returned by map and draw it.
 *   noStroke();
 *   text(nfc(ax, 2,2), ax, ay - 5);
 *   text(nfc(bx,1,1), bx, by - 5);
 * }
 * </code></div>
 *
 * @alt
 * horizontal center line squared values displayed on top and regular on bottom.
 *
 */
p5.prototype.round = Math.round;

/**
 * Squares a number (multiplies a number by itself). The result is always a
 * positive number, as multiplying two negative numbers always yields a
 * positive result. For example, -1 * -1 = 1.
 *
 * @method sq
 * @param  {Number} n number to square
 * @return {Number}   squared number
 * @example
 * <div><code>
 * function draw() {
 *   background(200);
 *   eSize = 7;
 *   x1 = map(mouseX, 0, width, 0, 10);
 *   y1 = 80;
 *   x2 = sq(x1);
 *   y2 = 20;
 *
 *   // Draw the non-squared.
 *   line(0, y1, width, y1);
 *   ellipse(x1, y1, eSize, eSize);
 *
 *   // Draw the squared.
 *   line(0, y2, width, y2);
 *   ellipse(x2, y2, eSize, eSize);
 *
 *   // Draw dividing line.
 *   stroke(100)
 *   line(0, height/2, width, height/2);
 *
 *   // Draw text.
 *   var spacing = 15;
 *   noStroke();
 *   fill(0);
 *   text("x = " + x1, 0, y1 + spacing);
 *   text("sq(x) = " + x2, 0, y2 + spacing);
 * }
 * </code></div>
 *
 * @alt
 * horizontal center line squared values displayed on top and regular on bottom.
 *
 */
p5.prototype.sq = function(n) { return n*n; };

/**
 * Calculates the square root of a number. The square root of a number is
 * always positive, even though there may be a valid negative root. The
 * square root s of number a is such that s*s = a. It is the opposite of
 * squaring. Maps to Math.sqrt().
 *
 * @method sqrt
 * @param  {Number} n non-negative number to square root
 * @return {Number}   square root of number
 * @example
 * <div><code>
 * function draw() {
 *   background(200);
 *   eSize = 7;
 *   x1 = mouseX;
 *   y1 = 80;
 *   x2 = sqrt(x1);
 *   y2 = 20;
 *
 *   // Draw the non-squared.
 *   line(0, y1, width, y1);
 *   ellipse(x1, y1, eSize, eSize);
 *
 *   // Draw the squared.
 *   line(0, y2, width, y2);
 *   ellipse(x2, y2, eSize, eSize);
 *
 *   // Draw dividing line.
 *   stroke(100)
 *   line(0, height/2, width, height/2);
 *
 *   // Draw text.
 *   noStroke();
 *   fill(0);
 *   var spacing = 15;
 *   text("x = " + x1, 0, y1 + spacing);
 *   text("sqrt(x) = " + x2, 0, y2 + spacing);
 * }
 * </code></div>
 *
 * @alt
 * horizontal center line squareroot values displayed on top and regular on bottom.
 *
 */
p5.prototype.sqrt = Math.sqrt;

// Calculate the length of the hypotenuse of a right triangle
// This won't under- or overflow in intermediate steps
// https://en.wikipedia.org/wiki/Hypot
function hypot(x, y, z) {
  // Use the native implementation if it's available
  if (typeof Math.hypot === 'function') {
    return Math.hypot.apply(null, arguments);
  }

  // Otherwise use the V8 implementation
  // https://github.com/v8/v8/blob/8cd3cf297287e581a49e487067f5cbd991b27123/src/js/math.js#L217
  var length = arguments.length;
  var args = [];
  var max = 0;
  for (var i = 0; i < length; i++) {
    var n = arguments[i];
    n = +n;
    if (n === Infinity || n === -Infinity) {
      return Infinity;
    }
    n = Math.abs(n);
    if (n > max) {
      max = n;
    }
    args[i] = n;
  }

  if (max === 0) {
    max = 1;
  }
  var sum = 0;
  var compensation = 0;
  for (var j = 0; j < length; j++) {
    var m = args[j] / max;
    var summand = m * m - compensation;
    var preliminary = sum + summand;
    compensation = (preliminary - sum) - summand;
    sum = preliminary;
  }
  return Math.sqrt(sum) * max;
}

module.exports = p5;

},{"../core/core":42}],69:[function(_dereq_,module,exports){
/**
 * @module Math
 * @submodule Math
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');


/**
 * Creates a new p5.Vector (the datatype for storing vectors). This provides a
 * two or three dimensional vector, specifically a Euclidean (also known as
 * geometric) vector. A vector is an entity that has both magnitude and
 * direction.
 *
 * @method createVector
 * @param {Number} [x] x component of the vector
 * @param {Number} [y] y component of the vector
 * @param {Number} [z] z component of the vector
 */
p5.prototype.createVector = function (x, y, z) {
  if (this instanceof p5) {
    return new p5.Vector(this, arguments);
  } else {
    return new p5.Vector(x, y, z);
  }
};

module.exports = p5;

},{"../core/core":42}],70:[function(_dereq_,module,exports){
//////////////////////////////////////////////////////////////

// http://mrl.nyu.edu/~perlin/noise/
// Adapting from PApplet.java
// which was adapted from toxi
// which was adapted from the german demo group farbrausch
// as used in their demo "art": http://www.farb-rausch.de/fr010src.zip

// someday we might consider using "improved noise"
// http://mrl.nyu.edu/~perlin/paper445.pdf
// See: https://github.com/shiffman/The-Nature-of-Code-Examples-p5.js/
//      blob/master/introduction/Noise1D/noise.js

/**
 * @module Math
 * @submodule Noise
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');

var PERLIN_YWRAPB = 4;
var PERLIN_YWRAP = 1<<PERLIN_YWRAPB;
var PERLIN_ZWRAPB = 8;
var PERLIN_ZWRAP = 1<<PERLIN_ZWRAPB;
var PERLIN_SIZE = 4095;

var perlin_octaves = 4; // default to medium smooth
var perlin_amp_falloff = 0.5; // 50% reduction/octave

var scaled_cosine = function(i) {
  return 0.5*(1.0-Math.cos(i*Math.PI));
};

var perlin; // will be initialized lazily by noise() or noiseSeed()


/**
 * Returns the Perlin noise value at specified coordinates. Perlin noise is
 * a random sequence generator producing a more natural ordered, harmonic
 * succession of numbers compared to the standard <b>random()</b> function.
 * It was invented by Ken Perlin in the 1980s and been used since in
 * graphical applications to produce procedural textures, natural motion,
 * shapes, terrains etc.<br /><br /> The main difference to the
 * <b>random()</b> function is that Perlin noise is defined in an infinite
 * n-dimensional space where each pair of coordinates corresponds to a
 * fixed semi-random value (fixed only for the lifespan of the program; see
 * the noiseSeed() function). p5.js can compute 1D, 2D and 3D noise,
 * depending on the number of coordinates given. The resulting value will
 * always be between 0.0 and 1.0. The noise value can be animated by moving
 * through the noise space as demonstrated in the example above. The 2nd
 * and 3rd dimension can also be interpreted as time.<br /><br />The actual
 * noise is structured similar to an audio signal, in respect to the
 * function's use of frequencies. Similar to the concept of harmonics in
 * physics, perlin noise is computed over several octaves which are added
 * together for the final result. <br /><br />Another way to adjust the
 * character of the resulting sequence is the scale of the input
 * coordinates. As the function works within an infinite space the value of
 * the coordinates doesn't matter as such, only the distance between
 * successive coordinates does (eg. when using <b>noise()</b> within a
 * loop). As a general rule the smaller the difference between coordinates,
 * the smoother the resulting noise sequence will be. Steps of 0.005-0.03
 * work best for most applications, but this will differ depending on use.
 *
 *
 * @method noise
 * @param  {Number} x   x-coordinate in noise space
 * @param  {Number} y   y-coordinate in noise space
 * @param  {Number} z   z-coordinate in noise space
 * @return {Number}     Perlin noise value (between 0 and 1) at specified
 *                      coordinates
 * @example
 * <div>
 * <code>var xoff = 0.0;
 *
 * function draw() {
 *   background(204);
 *   xoff = xoff + .01;
 *   var n = noise(xoff) * width;
 *   line(n, 0, n, height);
 * }
 * </code>
 * </div>
 * <div>
 * <code>var noiseScale=0.02;
 *
 * function draw() {
 *   background(0);
 *   for (var x=0; x < width; x++) {
 *     var noiseVal = noise((mouseX+x)*noiseScale, mouseY*noiseScale);
 *     stroke(noiseVal*255);
 *     line(x, mouseY+noiseVal*80, x, height);
 *   }
 * }
 * </code>
 * </div>
 *
 * @alt
 * vertical line moves left to right with updating noise values.
 * horizontal wave pattern effected by mouse x-position & updating noise values.
 *
 */

p5.prototype.noise = function(x,y,z) {
  y = y || 0;
  z = z || 0;

  if (perlin == null) {
    perlin = new Array(PERLIN_SIZE + 1);
    for (var i = 0; i < PERLIN_SIZE + 1; i++) {
      perlin[i] = Math.random();
    }
  }

  if (x<0) { x=-x; }
  if (y<0) { y=-y; }
  if (z<0) { z=-z; }

  var xi=Math.floor(x), yi=Math.floor(y), zi=Math.floor(z);
  var xf = x - xi;
  var yf = y - yi;
  var zf = z - zi;
  var rxf, ryf;

  var r=0;
  var ampl=0.5;

  var n1,n2,n3;

  for (var o=0; o<perlin_octaves; o++) {
    var of=xi+(yi<<PERLIN_YWRAPB)+(zi<<PERLIN_ZWRAPB);

    rxf = scaled_cosine(xf);
    ryf = scaled_cosine(yf);

    n1  = perlin[of&PERLIN_SIZE];
    n1 += rxf*(perlin[(of+1)&PERLIN_SIZE]-n1);
    n2  = perlin[(of+PERLIN_YWRAP)&PERLIN_SIZE];
    n2 += rxf*(perlin[(of+PERLIN_YWRAP+1)&PERLIN_SIZE]-n2);
    n1 += ryf*(n2-n1);

    of += PERLIN_ZWRAP;
    n2  = perlin[of&PERLIN_SIZE];
    n2 += rxf*(perlin[(of+1)&PERLIN_SIZE]-n2);
    n3  = perlin[(of+PERLIN_YWRAP)&PERLIN_SIZE];
    n3 += rxf*(perlin[(of+PERLIN_YWRAP+1)&PERLIN_SIZE]-n3);
    n2 += ryf*(n3-n2);

    n1 += scaled_cosine(zf)*(n2-n1);

    r += n1*ampl;
    ampl *= perlin_amp_falloff;
    xi<<=1;
    xf*=2;
    yi<<=1;
    yf*=2;
    zi<<=1;
    zf*=2;

    if (xf>=1.0) { xi++; xf--; }
    if (yf>=1.0) { yi++; yf--; }
    if (zf>=1.0) { zi++; zf--; }
  }
  return r;
};


/**
 *
 * Adjusts the character and level of detail produced by the Perlin noise
 * function. Similar to harmonics in physics, noise is computed over
 * several octaves. Lower octaves contribute more to the output signal and
 * as such define the overall intensity of the noise, whereas higher octaves
 * create finer grained details in the noise sequence.
 * <br><br>
 * By default, noise is computed over 4 octaves with each octave contributing
 * exactly half than its predecessor, starting at 50% strength for the 1st
 * octave. This falloff amount can be changed by adding an additional function
 * parameter. Eg. a falloff factor of 0.75 means each octave will now have
 * 75% impact (25% less) of the previous lower octave. Any value between
 * 0.0 and 1.0 is valid, however note that values greater than 0.5 might
 * result in greater than 1.0 values returned by <b>noise()</b>.
 * <br><br>
 * By changing these parameters, the signal created by the <b>noise()</b>
 * function can be adapted to fit very specific needs and characteristics.
 *
 * @method noiseDetail
 * @param {Number} lod number of octaves to be used by the noise
 * @param {Number} falloff falloff factor for each octave
 * @example
 * <div>
 * <code>
 *
 * var noiseVal;
 * var noiseScale=0.02;
 *
 * function setup() {
 *   createCanvas(100,100);
 * }
 *
 * function draw() {
 *   background(0);
 *   for (var y = 0; y < height; y++) {
 *     for (var x = 0; x < width/2; x++) {
 *       noiseDetail(2,0.2);
 *       noiseVal = noise((mouseX+x) * noiseScale,
 *                        (mouseY+y) * noiseScale);
 *       stroke(noiseVal*255);
 *       point(x,y);
 *       noiseDetail(8,0.65);
 *       noiseVal = noise((mouseX + x + width/2) * noiseScale,
 *                        (mouseY + y) * noiseScale);
 *       stroke(noiseVal*255);
 *       point(x + width/2, y);
 *     }
 *   }
 * }
 * </code>
 * </div>
 *
 * @alt
 * 2 vertical grey smokey patterns affected my mouse x-position and noise.
 *
 */
p5.prototype.noiseDetail = function(lod, falloff) {
  if (lod>0)     { perlin_octaves=lod; }
  if (falloff>0) { perlin_amp_falloff=falloff; }
};

/**
 * Sets the seed value for <b>noise()</b>. By default, <b>noise()</b>
 * produces different results each time the program is run. Set the
 * <b>value</b> parameter to a constant to return the same pseudo-random
 * numbers each time the software is run.
 *
 * @method noiseSeed
 * @param {Number} seed   the seed value
 * @example
 * <div>
 * <code>var xoff = 0.0;
 *
 * function setup() {
 *   noiseSeed(99);
 *   stroke(0, 10);
 * }
 *
 * function draw() {
 *   xoff = xoff + .01;
 *   var n = noise(xoff) * width;
 *   line(n, 0, n, height);
 * }
 * </code>
 * </div>
 *
 * @alt
 * vertical grey lines drawing in pattern affected by noise.
 *
 */
p5.prototype.noiseSeed = function(seed) {
  // Linear Congruential Generator
  // Variant of a Lehman Generator
  var lcg = (function() {
    // Set to values from http://en.wikipedia.org/wiki/Numerical_Recipes
    // m is basically chosen to be large (as it is the max period)
    // and for its relationships to a and c
    var m = 4294967296,
    // a - 1 should be divisible by m's prime factors
    a = 1664525,
     // c and m should be co-prime
    c = 1013904223,
    seed, z;
    return {
      setSeed : function(val) {
        // pick a random seed if val is undefined or null
        // the >>> 0 casts the seed to an unsigned 32-bit integer
        z = seed = (val == null ? Math.random() * m : val) >>> 0;
      },
      getSeed : function() {
        return seed;
      },
      rand : function() {
        // define the recurrence relationship
        z = (a * z + c) % m;
        // return a float in [0, 1)
        // if z = m then z / m = 0 therefore (z % m) / m < 1 always
        return z / m;
      }
    };
  }());

  lcg.setSeed(seed);
  perlin = new Array(PERLIN_SIZE + 1);
  for (var i = 0; i < PERLIN_SIZE + 1; i++) {
    perlin[i] = lcg.rand();
  }
};

module.exports = p5;

},{"../core/core":42}],71:[function(_dereq_,module,exports){
/**
 * @module Math
 * @submodule Math
 * @requires constants
 */

'use strict';

var p5 = _dereq_('../core/core');
var polarGeometry = _dereq_('./polargeometry');
var constants = _dereq_('../core/constants');

/**
 * A class to describe a two or three dimensional vector, specifically
 * a Euclidean (also known as geometric) vector. A vector is an entity
 * that has both magnitude and direction. The datatype, however, stores
 * the components of the vector (x, y for 2D, and x, y, z for 3D). The magnitude
 * and direction can be accessed via the methods mag() and heading().
 * <br><br>
 * In many of the p5.js examples, you will see p5.Vector used to describe a
 * position, velocity, or acceleration. For example, if you consider a rectangle
 * moving across the screen, at any given instant it has a position (a vector
 * that points from the origin to its location), a velocity (the rate at which
 * the object's position changes per time unit, expressed as a vector), and
 * acceleration (the rate at which the object's velocity changes per time
 * unit, expressed as a vector).
 * <br><br>
 * Since vectors represent groupings of values, we cannot simply use
 * traditional addition/multiplication/etc. Instead, we'll need to do some
 * "vector" math, which is made easy by the methods inside the p5.Vector class.
 *
 * @class p5.Vector
 * @constructor
 * @param {Number} [x] x component of the vector
 * @param {Number} [y] y component of the vector
 * @param {Number} [z] z component of the vector
 * @example
 * <div>
 * <code>
 * var v1 = createVector(40, 50);
 * var v2 = createVector(40, 50);
 *
 * ellipse(v1.x, v1.y, 50, 50);
 * ellipse(v2.x, v2.y, 50, 50);
 * v1.add(v2);
 * ellipse(v1.x, v1.y, 50, 50);
 * </code>
 * </div>
 *
 * @alt
 * 2 white ellipses. One center-left the other bottom right and off canvas
 *
 */
p5.Vector = function() {
  var x,y,z;
  // This is how it comes in with createVector()
  if(arguments[0] instanceof p5) {
    // save reference to p5 if passed in
    this.p5 = arguments[0];
    x  = arguments[1][0] || 0;
    y  = arguments[1][1] || 0;
    z  = arguments[1][2] || 0;
  // This is what we'll get with new p5.Vector()
  } else {
    x = arguments[0] || 0;
    y = arguments[1] || 0;
    z = arguments[2] || 0;
  }
  /**
   * The x component of the vector
   * @property x
   * @type {Number}
   */
  this.x = x;
  /**
   * The y component of the vector
   * @property y
   * @type {Number}
   */
  this.y = y;
  /**
   * The z component of the vector
   * @property z
   * @type {Number}
   */
  this.z = z;
};

/**
 * Returns a string representation of a vector v by calling String(v)
 * or v.toString(). This method is useful for logging vectors in the
 * console.
 * @method  toString
 * @example
 * <div class = "norender"><code>
 * function setup() {
 *   var v = createVector(20,30);
 *   print(String(v)); // prints "p5.Vector Object : [20, 30, 0]"
 * }
 * </div></code>
 *
 */
p5.Vector.prototype.toString = function p5VectorToString() {
  return 'p5.Vector Object : ['+ this.x +', '+ this.y +', '+ this.z + ']';
};

/**
 * Sets the x, y, and z component of the vector using two or three separate
 * variables, the data from a p5.Vector, or the values from a float array.
 * @method set
 *
 * @param {Number|p5.Vector|Array} [x] the x component of the vector or a
 *                                     p5.Vector or an Array
 * @param {Number}                 [y] the y component of the vector
 * @param {Number}                 [z] the z component of the vector
 * @example
 * <div class="norender">
 * <code>
 * function setup() {
 *    var v = createVector(1, 2, 3);
 *    v.set(4,5,6); // Sets vector to [4, 5, 6]
 *
 *    var v1 = createVector(0, 0, 0);
 *    var arr = [1, 2, 3];
 *    v1.set(arr); // Sets vector to [1, 2, 3]
 * }
 * </code>
 * </div>
 */
p5.Vector.prototype.set = function (x, y, z) {
  if (x instanceof p5.Vector) {
    this.x = x.x || 0;
    this.y = x.y || 0;
    this.z = x.z || 0;
    return this;
  }
  if (x instanceof Array) {
    this.x = x[0] || 0;
    this.y = x[1] || 0;
    this.z = x[2] || 0;
    return this;
  }
  this.x = x || 0;
  this.y = y || 0;
  this.z = z || 0;
  return this;
};

/**
 * Gets a copy of the vector, returns a p5.Vector object.
 *
 * @method copy
 * @return {p5.Vector} the copy of the p5.Vector object
 * @example
 * <div class="norender">
 * <code>
 * var v1 = createVector(1, 2, 3);
 * var v2 = v1.copy();
 * print(v1.x == v2.x && v1.y == v2.y && v1.z == v2.z);
 * // Prints "true"
 * </code>
 * </div>
 */
p5.Vector.prototype.copy = function () {
  if (this.p5) {
    return new p5.Vector(this.p5,[this.x, this.y, this.z]);
  } else {
    return new p5.Vector(this.x,this.y,this.z);
  }
};

/**
 * Adds x, y, and z components to a vector, adds one vector to another, or
 * adds two independent vectors together. The version of the method that adds
 * two vectors together is a static method and returns a p5.Vector, the others
 * acts directly on the vector. See the examples for more context.
 *
 * @method add
 * @chainable
 * @param  {Number|p5.Vector|Array} x   the x component of the vector to be
 *                                      added or a p5.Vector or an Array
 * @param  {Number}                 [y] the y component of the vector to be
 *                                      added
 * @param  {Number}                 [z] the z component of the vector to be
 *                                      added
 * @return {p5.Vector}                  the p5.Vector object.
 * @example
 * <div class="norender">
 * <code>
 * var v = createVector(1, 2, 3);
 * v.add(4,5,6);
 * // v's components are set to [5, 7, 9]
 * </code>
 * </div>
 * <div class="norender">
 * <code>
 * // Static method
 * var v1 = createVector(1, 2, 3);
 * var v2 = createVector(2, 3, 4);
 *
 * var v3 = p5.Vector.add(v1, v2);
 * // v3 has components [3, 5, 7]
 * </code>
 * </div>
 */
p5.Vector.prototype.add = function (x, y, z) {
  if (x instanceof p5.Vector) {
    this.x += x.x || 0;
    this.y += x.y || 0;
    this.z += x.z || 0;
    return this;
  }
  if (x instanceof Array) {
    this.x += x[0] || 0;
    this.y += x[1] || 0;
    this.z += x[2] || 0;
    return this;
  }
  this.x += x || 0;
  this.y += y || 0;
  this.z += z || 0;
  return this;
};

/**
 * Subtracts x, y, and z components from a vector, subtracts one vector from
 * another, or subtracts two independent vectors. The version of the method
 * that subtracts two vectors is a static method and returns a p5.Vector, the
 * other acts directly on the vector. See the examples for more context.
 *
 * @method sub
 * @chainable
 * @param  {Number|p5.Vector|Array} x   the x component of the vector or a
 *                                      p5.Vector or an Array
 * @param  {Number}                 [y] the y component of the vector
 * @param  {Number}                 [z] the z component of the vector
 * @return {p5.Vector}                  p5.Vector object.
 * @example
 * <div class="norender">
 * <code>
 * var v = createVector(4, 5, 6);
 * v.sub(1, 1, 1);
 * // v's components are set to [3, 4, 5]
 * </code>
 * </div>
 *
 * <div class="norender">
 * <code>
 * // Static method
 * var v1 = createVector(2, 3, 4);
 * var v2 = createVector(1, 2, 3);
 *
 * var v3 = p5.Vector.sub(v1, v2);
 * // v3 has components [1, 1, 1]
 * </code>
 * </div>
 */
p5.Vector.prototype.sub = function (x, y, z) {
  if (x instanceof p5.Vector) {
    this.x -= x.x || 0;
    this.y -= x.y || 0;
    this.z -= x.z || 0;
    return this;
  }
  if (x instanceof Array) {
    this.x -= x[0] || 0;
    this.y -= x[1] || 0;
    this.z -= x[2] || 0;
    return this;
  }
  this.x -= x || 0;
  this.y -= y || 0;
  this.z -= z || 0;
  return this;
};

/**
 * Multiply the vector by a scalar. The static version of this method
 * creates a new p5.Vector while the non static version acts on the vector
 * directly. See the examples for more context.
 *
 * @method mult
 * @chainable
 * @param  {Number}    n the number to multiply with the vector
 * @return {p5.Vector} a reference to the p5.Vector object (allow chaining)
 * @example
 * <div class="norender">
 * <code>
 * var v = createVector(1, 2, 3);
 * v.mult(2);
 * // v's components are set to [2, 4, 6]
 * </code>
 * </div>
 *
 * <div class="norender">
 * <code>
 * // Static method
 * var v1 = createVector(1, 2, 3);
 * var v2 = p5.Vector.mult(v1, 2);
 * // v2 has components [2, 4, 6]
 * </code>
 * </div>
 */
p5.Vector.prototype.mult = function (n) {
  this.x *= n || 0;
  this.y *= n || 0;
  this.z *= n || 0;
  return this;
};

/**
 * Divide the vector by a scalar. The static version of this method creates a
 * new p5.Vector while the non static version acts on the vector directly.
 * See the examples for more context.
 *
 * @method div
 * @chainable
 * @param  {number}    n the number to divide the vector by
 * @return {p5.Vector} a reference to the p5.Vector object (allow chaining)
 * @example
 * <div class="norender">
 * <code>
 * var v = createVector(6, 4, 2);
 * v.div(2); //v's components are set to [3, 2, 1]
 * </code>
 * </div>
 *
 * <div class="norender">
 * <code>
 * // Static method
 * var v1  = createVector(6, 4, 2);
 * var v2 = p5.Vector.div(v, 2);
 * // v2 has components [3, 2, 1]
 * </code>
 * </div>
 */
p5.Vector.prototype.div = function (n) {
  this.x /= n;
  this.y /= n;
  this.z /= n;
  return this;
};

/**
 * Calculates the magnitude (length) of the vector and returns the result as
 * a float (this is simply the equation sqrt(x*x + y*y + z*z).)
 *
 * @method mag
 * @return {Number} magnitude of the vector
 * @example
 * <div class="norender">
 * <code>
 * var v = createVector(20.0, 30.0, 40.0);
 * var m = v.mag();
 * print(m); // Prints "53.85164807134504"
 * </code>
 * </div>
 */
p5.Vector.prototype.mag = function () {
  return Math.sqrt(this.magSq());
};

/**
 * Calculates the squared magnitude of the vector and returns the result
 * as a float (this is simply the equation <em>(x*x + y*y + z*z)</em>.)
 * Faster if the real length is not required in the
 * case of comparing vectors, etc.
 *
 * @method magSq
 * @return {number} squared magnitude of the vector
 * @example
 * <div class="norender">
 * <code>
 * // Static method
 * var v1 = createVector(6, 4, 2);
 * print(v1.magSq()); // Prints "56"
 * </code>
 * </div>
 */
p5.Vector.prototype.magSq = function () {
  var x = this.x, y = this.y, z = this.z;
  return (x * x + y * y + z * z);
};

/**
 * Calculates the dot product of two vectors. The version of the method
 * that computes the dot product of two independent vectors is a static
 * method. See the examples for more context.
 *
 *
 * @method dot
 * @param  {Number|p5.Vector} x   x component of the vector or a p5.Vector
 * @param  {Number}           [y] y component of the vector
 * @param  {Number}           [z] z component of the vector
 * @return {Number}                 the dot product
 *
 * @example
 * <div class="norender">
 * <code>
 * var v1 = createVector(1, 2, 3);
 * var v2 = createVector(2, 3, 4);
 *
 * print(v1.dot(v2)); // Prints "20"
 * </code>
 * </div>
 *
 * <div class="norender">
 * <code>
 * //Static method
 * var v1 = createVector(1, 2, 3);
 * var v2 = createVector(3, 2, 1);
 * print (p5.Vector.dot(v1, v2)); // Prints "10"
 * </code>
 * </div>
 */
p5.Vector.prototype.dot = function (x, y, z) {
  if (x instanceof p5.Vector) {
    return this.dot(x.x, x.y, x.z);
  }
  return this.x * (x || 0) +
         this.y * (y || 0) +
         this.z * (z || 0);
};

/**
 * Calculates and returns a vector composed of the cross product between
 * two vectors. Both the static and non static methods return a new p5.Vector.
 * See the examples for more context.
 *
 * @method cross
 * @param  {p5.Vector} v p5.Vector to be crossed
 * @return {p5.Vector}   p5.Vector composed of cross product
 * @example
 * <div class="norender">
 * <code>
 * var v1 = createVector(1, 2, 3);
 * var v2 = createVector(1, 2, 3);
 *
 * v1.cross(v2); // v's components are [0, 0, 0]
 * </code>
 * </div>
 *
 * <div class="norender">
 * <code>
 * // Static method
 * var v1 = createVector(1, 0, 0);
 * var v2 = createVector(0, 1, 0);
 *
 * var crossProduct = p5.Vector.cross(v1, v2);
 * // crossProduct has components [0, 0, 1]
 * </code>
 * </div>
 */
p5.Vector.prototype.cross = function (v) {
  var x = this.y * v.z - this.z * v.y;
  var y = this.z * v.x - this.x * v.z;
  var z = this.x * v.y - this.y * v.x;
  if (this.p5) {
    return new p5.Vector(this.p5,[x,y,z]);
  } else {
    return new p5.Vector(x,y,z);
  }
};

/**
 * Calculates the Euclidean distance between two points (considering a
 * point as a vector object).
 *
 * @method dist
 * @param  {p5.Vector} v the x, y, and z coordinates of a p5.Vector
 * @return {Number}      the distance
 * @example
 * <div class="norender">
 * <code>
 * var v1 = createVector(1, 0, 0);
 * var v2 = createVector(0, 1, 0);
 *
 * var distance = v1.dist(v2); // distance is 1.4142...
 * </code>
 * </div>
 * <div class="norender">
 * <code>
 * // Static method
 * var v1 = createVector(1, 0, 0);
 * var v2 = createVector(0, 1, 0);
 *
 * var distance = p5.Vector.dist(v1,v2);
 * // distance is 1.4142...
 * </code>
 * </div>
 */
p5.Vector.prototype.dist = function (v) {
  var d = v.copy().sub(this);
  return d.mag();
};

/**
 * Normalize the vector to length 1 (make it a unit vector).
 *
 * @method normalize
 * @return {p5.Vector} normalized p5.Vector
 * @example
 * <div class="norender">
 * <code>
 * var v = createVector(10, 20, 2);
 * // v has components [10.0, 20.0, 2.0]
 * v.normalize();
 * // v's components are set to
 * // [0.4454354, 0.8908708, 0.089087084]
 * </code>
 * </div>
 *
 */
p5.Vector.prototype.normalize = function () {
  return this.mag() === 0 ? this : this.div(this.mag());
};

/**
 * Limit the magnitude of this vector to the value used for the <b>max</b>
 * parameter.
 *
 * @method limit
 * @param  {Number}    max the maximum magnitude for the vector
 * @return {p5.Vector}     the modified p5.Vector
 * @example
 * <div class="norender">
 * <code>
 * var v = createVector(10, 20, 2);
 * // v has components [10.0, 20.0, 2.0]
 * v.limit(5);
 * // v's components are set to
 * // [2.2271771, 4.4543543, 0.4454354]
 * </code>
 * </div>
 */
p5.Vector.prototype.limit = function (max) {
  var mSq = this.magSq();
  if(mSq > max*max) {
    this.div(Math.sqrt(mSq)); //normalize it
    this.mult(max);
  }
  return this;
};

/**
 * Set the magnitude of this vector to the value used for the <b>len</b>
 * parameter.
 *
 * @method setMag
 * @param  {number}    len the new length for this vector
 * @return {p5.Vector}     the modified p5.Vector
 * @example
 * <div class="norender">
 * <code>
 * var v = createVector(10, 20, 2);
 * // v has components [10.0, 20.0, 2.0]
 * v.setMag(10);
 * // v's components are set to [6.0, 8.0, 0.0]
 * </code>
 * </div>
 */
p5.Vector.prototype.setMag = function (n) {
  return this.normalize().mult(n);
};

/**
 * Calculate the angle of rotation for this vector (only 2D vectors)
 *
 * @method heading
 * @return {Number} the angle of rotation
 * @example
 * <div class = "norender"><code>
 * function setup() {
 *   var v1 = createVector(30,50);
 *   print(v1.heading()); // 1.0303768265243125
 *
 *   var v1 = createVector(40,50);
 *   print(v1.heading()); // 0.8960553845713439
 *
 *   var v1 = createVector(30,70);
 *   print(v1.heading()); // 1.1659045405098132
 * }
 * </div></code>
 */
p5.Vector.prototype.heading = function () {
  var h = Math.atan2(this.y, this.x);
  if (this.p5) {
    if (this.p5._angleMode === constants.RADIANS) {
      return h;
    } else {
      return polarGeometry.radiansToDegrees(h);
    }
  } else {
    return h;
  }
};

/**
 * Rotate the vector by an angle (only 2D vectors), magnitude remains the
 * same
 *
 * @method rotate
 * @param  {number}    angle the angle of rotation
 * @return {p5.Vector} the modified p5.Vector
 * @example
 * <div class="norender">
 * <code>
 * var v = createVector(10.0, 20.0);
 * // v has components [10.0, 20.0, 0.0]
 * v.rotate(HALF_PI);
 * // v's components are set to [-20.0, 9.999999, 0.0]
 * </code>
 * </div>
 */
p5.Vector.prototype.rotate = function (a) {
  var newHeading = this.heading() + a;
  if (this.p5) {
    if (this.p5._angleMode === constants.DEGREES) {
      newHeading = polarGeometry.degreesToRadians(newHeading);
    }
  }
  var mag = this.mag();
  this.x = Math.cos(newHeading) * mag;
  this.y = Math.sin(newHeading) * mag;
  return this;
};

/**
 * Calculates and returns the angle (in radians) between two vectors.
 * @method angleBetween
 * @param  {p5.Vector}    the x, y, and z components of a p5.Vector
 * @return {Number}       the angle between (in radians)
 * @example
 * <div class="norender">
 * <code>
 * var v1 = createVector(1, 0, 0);
 * var v2 = createVector(0, 1, 0);
 *
 * var angle = v1.angleBetween(v2);
 * // angle is PI/2
 * </code>
 * </div>
 */
p5.Vector.prototype.angleBetween = function (v) {
  var angle = Math.acos(this.dot(v) / (this.mag() * v.mag()));
  if (this.p5) {
    if (this.p5._angleMode === constants.DEGREES) {
      angle = polarGeometry.radiansToDegrees(angle);
    }
  }
  return angle;
};

/**
 * Linear interpolate the vector to another vector
 *
 * @method lerp
 * @param  {p5.Vector} x   the x component or the p5.Vector to lerp to
 * @param  {p5.Vector} [y] y the y component
 * @param  {p5.Vector} [z] z the z component
 * @param  {Number}    amt the amount of interpolation; some value between 0.0
 *                         (old vector) and 1.0 (new vector). 0.1 is very near
 *                         the new vector. 0.5 is halfway in between.
 * @return {p5.Vector}     the modified p5.Vector
 * @example
 * <div class="norender">
 * <code>
 * var v = createVector(1, 1, 0);
 *
 * v.lerp(3, 3, 0, 0.5); // v now has components [2,2,0]
 * </code>
 * </div>
 *
 * <div class="norender">
 * <code>
 * var v1 = createVector(0, 0, 0);
 * var v2 = createVector(100, 100, 0);
 *
 * var v3 = p5.Vector.lerp(v1, v2, 0.5);
 * // v3 has components [50,50,0]
 * </code>
 * </div>
 */
p5.Vector.prototype.lerp = function (x, y, z, amt) {
  if (x instanceof p5.Vector) {
    return this.lerp(x.x, x.y, x.z, y);
  }
  this.x += (x - this.x) * amt || 0;
  this.y += (y - this.y) * amt || 0;
  this.z += (z - this.z) * amt || 0;
  return this;
};

/**
 * Return a representation of this vector as a float array. This is only
 * for temporary use. If used in any other fashion, the contents should be
 * copied by using the <b>p5.Vector.copy()</b> method to copy into your own
 * array.
 *
 * @method array
 * @return {Array} an Array with the 3 values
 * @example
 * <div class = "norender"><code>
 * function setup() {
 *   var v = createVector(20,30);
 *   print(v.array()); // Prints : Array [20, 30, 0]
 * }
 * </div></code>
 * <div class="norender">
 * <code>
 * var v = createVector(10.0, 20.0, 30.0);
 * var f = v.array();
 * print(f[0]); // Prints "10.0"
 * print(f[1]); // Prints "20.0"
 * print(f[2]); // Prints "30.0"
 * </code>
 * </div>
 */
p5.Vector.prototype.array = function () {
  return [this.x || 0, this.y || 0, this.z || 0];
};

/**
 * Equality check against a p5.Vector
 *
 * @method equals
 * @param {Number|p5.Vector|Array} [x] the x component of the vector or a
 *                                     p5.Vector or an Array
 * @param {Number}                 [y] the y component of the vector
 * @param {Number}                 [z] the z component of the vector
 * @return {Boolean} whether the vectors are equals
 * @example
 * <div class = "norender"><code>
 * v1 = createVector(5,10,20);
 * v2 = createVector(5,10,20);
 * v3 = createVector(13,10,19);
 *
 * print(v1.equals(v2.x,v2.y,v2.z)); // true
 * print(v1.equals(v3.x,v3.y,v3.z)); // false
 * </div></code>
 * <div class="norender">
 * <code>
 * var v1 = createVector(10.0, 20.0, 30.0);
 * var v2 = createVector(10.0, 20.0, 30.0);
 * var v3 = createVector(0.0, 0.0, 0.0);
 * print (v1.equals(v2)) // true
 * print (v1.equals(v3)) // false
 * </code>
 * </div>
 */
p5.Vector.prototype.equals = function (x, y, z) {
  var a, b, c;
  if (x instanceof p5.Vector) {
    a = x.x || 0;
    b = x.y || 0;
    c = x.z || 0;
  } else if (x instanceof Array) {
    a = x[0] || 0;
    b = x[1] || 0;
    c = x[2] || 0;
  } else {
    a = x || 0;
    b = y || 0;
    c = z || 0;
  }
  return this.x === a && this.y === b && this.z === c;
};


// Static Methods


/**
 * Make a new 2D unit vector from an angle
 *
 * @method fromAngle
 * @static
 * @param {Number}     angle the desired angle
 * @return {p5.Vector}       the new p5.Vector object
 * @example
 * <div>
 * <code>
 * function draw() {
 *   background (200);
 *
 *   // Create a variable, proportional to the mouseX,
 *   // varying from 0-360, to represent an angle in degrees.
 *   angleMode(DEGREES);
 *   var myDegrees = map(mouseX, 0,width, 0,360);
 *
 *   // Display that variable in an onscreen text.
 *   // (Note the nfc() function to truncate additional decimal places,
 *   // and the "\xB0" character for the degree symbol.)
 *   var readout = "angle = " + nfc(myDegrees,1,1) + "\xB0"
 *   noStroke();
 *   fill (0);
 *   text (readout, 5, 15);
 *
 *   // Create a p5.Vector using the fromAngle function,
 *   // and extract its x and y components.
 *   var v = p5.Vector.fromAngle(radians(myDegrees));
 *   var vx = v.x;
 *   var vy = v.y;
 *
 *   push();
 *   translate (width/2, height/2);
 *   noFill();
 *   stroke (150);
 *   line (0,0, 30,0);
 *   stroke (0);
 *   line (0,0, 30*vx, 30*vy);
 *   pop()
 * }
 * </code>
 * </div>
 */
p5.Vector.fromAngle = function(angle) {
  if (this.p5) {
    if (this.p5._angleMode === constants.DEGREES) {
      angle = polarGeometry.degreesToRadians(angle);
    }
  }
  if (this.p5) {
    return new p5.Vector(this.p5,[Math.cos(angle),Math.sin(angle),0]);
  } else {
    return new p5.Vector(Math.cos(angle),Math.sin(angle),0);
  }
};

/**
 * Make a new 2D unit vector from a random angle
 *
 * @method random2D
 * @static
 * @return {p5.Vector} the new p5.Vector object
 * @example
 * <div class="norender">
 * <code>
 * var v = p5.Vector.random2D();
 * // May make v's attributes something like:
 * // [0.61554617, -0.51195765, 0.0] or
 * // [-0.4695841, -0.14366731, 0.0] or
 * // [0.6091097, -0.22805278, 0.0]
 * </code>
 * </div>
 */
p5.Vector.random2D = function () {
  var angle;
  // A lot of nonsense to determine if we know about a
  // p5 sketch and whether we should make a random angle in degrees or radians
  if (this.p5) {
    if (this.p5._angleMode === constants.DEGREES) {
      angle = this.p5.random(360);
    } else {
      angle = this.p5.random(constants.TWO_PI);
    }
  } else {
    angle = Math.random()*Math.PI*2;
  }
  return this.fromAngle(angle);
};

/**
 * Make a new random 3D unit vector.
 *
 * @method random3D
 * @static
 * @return {p5.Vector} the new p5.Vector object
 * @example
 * <div class="norender">
 * <code>
 * var v = p5.Vector.random3D();
 * // May make v's attributes something like:
 * // [0.61554617, -0.51195765, 0.599168] or
 * // [-0.4695841, -0.14366731, -0.8711202] or
 * // [0.6091097, -0.22805278, -0.7595902]
 * </code>
 * </div>
 */
p5.Vector.random3D = function () {
  var angle,vz;
  // If we know about p5
  if (this.p5) {
    angle = this.p5.random(0,constants.TWO_PI);
    vz = this.p5.random(-1,1);
  } else {
    angle = Math.random()*Math.PI*2;
    vz = Math.random()*2-1;
  }
  var vx = Math.sqrt(1-vz*vz)*Math.cos(angle);
  var vy = Math.sqrt(1-vz*vz)*Math.sin(angle);
  if (this.p5) {
    return new p5.Vector(this.p5,[vx,vy,vz]);
  } else {
    return new p5.Vector(vx,vy,vz);
  }
};


/**
 * Adds two vectors together and returns a new one.
 *
 * @static
 * @param  {p5.Vector} v1 a p5.Vector to add
 * @param  {p5.Vector} v2 a p5.Vector to add
 * @param  {p5.Vector} target if undefined a new vector will be created
 * @return {p5.Vector} the resulting p5.Vector
 *
 */

p5.Vector.add = function (v1, v2, target) {
  if (!target) {
    target = v1.copy();
  } else {
    target.set(v1);
  }
  target.add(v2);
  return target;
};

/**
 * Subtracts one p5.Vector from another and returns a new one.  The second
 * vector (v2) is subtracted from the first (v1), resulting in v1-v2.
 *
 * @static
 * @param  {p5.Vector} v1 a p5.Vector to subtract from
 * @param  {p5.Vector} v2 a p5.Vector to subtract
 * @param  {p5.Vector} target if undefined a new vector will be created
 * @return {p5.Vector} the resulting p5.Vector
 */

p5.Vector.sub = function (v1, v2, target) {
  if (!target) {
    target = v1.copy();
  } else {
    target.set(v1);
  }
  target.sub(v2);
  return target;
};


/**
 * Multiplies a vector by a scalar and returns a new vector.
 *
 * @static
 * @param  {p5.Vector} v the p5.Vector to multiply
 * @param  {Number}  n the scalar
 * @param  {p5.Vector} target if undefined a new vector will be created
 * @return {p5.Vector}  the resulting new p5.Vector
 */
p5.Vector.mult = function (v, n, target) {
  if (!target) {
    target = v.copy();
  } else {
    target.set(v);
  }
  target.mult(n);
  return target;
};

/**
 * Divides a vector by a scalar and returns a new vector.
 *
 * @static
 * @param  {p5.Vector} v the p5.Vector to divide
 * @param  {Number}  n the scalar
 * @param  {p5.Vector} target if undefined a new vector will be created
 * @return {p5.Vector} the resulting new p5.Vector
 */
p5.Vector.div = function (v, n, target) {
  if (!target) {
    target = v.copy();
  } else {
    target.set(v);
  }
  target.div(n);
  return target;
};


/**
 * Calculates the dot product of two vectors.
 *
 * @static
 * @param  {p5.Vector} v1 the first p5.Vector
 * @param  {p5.Vector} v2 the second p5.Vector
 * @return {Number}     the dot product
 */
p5.Vector.dot = function (v1, v2) {
  return v1.dot(v2);
};

/**
 * Calculates the cross product of two vectors.
 *
 * @static
 * @param  {p5.Vector} v1 the first p5.Vector
 * @param  {p5.Vector} v2 the second p5.Vector
 * @return {Number}     the cross product
 */
p5.Vector.cross = function (v1, v2) {
  return v1.cross(v2);
};

/**
 * Calculates the Euclidean distance between two points (considering a
 * point as a vector object).
 *
 * @static
 * @param  {p5.Vector} v1 the first p5.Vector
 * @param  {p5.Vector} v2 the second p5.Vector
 * @return {Number}     the distance
 */
p5.Vector.dist = function (v1,v2) {
  return v1.dist(v2);
};

/**
 * Linear interpolate a vector to another vector and return the result as a
 * new vector.
 *
 * @static
 * @param {p5.Vector} v1 a starting p5.Vector
 * @param {p5.Vector} v2 the p5.Vector to lerp to
 * @param {Number}       the amount of interpolation; some value between 0.0
 *                       (old vector) and 1.0 (new vector). 0.1 is very near
 *                       the new vector. 0.5 is halfway in between.
 */
p5.Vector.lerp = function (v1, v2, amt, target) {
  if (!target) {
    target = v1.copy();
  } else {
    target.set(v1);
  }
  target.lerp(v2, amt);
  return target;
};

/**
 * @static
 */
p5.Vector.mag = function (vecT){
  var x = vecT.x,
    y = vecT.y,
    z = vecT.z;
  var magSq = x * x + y * y + z * z;
  return Math.sqrt(magSq);
};

module.exports = p5.Vector;

},{"../core/constants":41,"../core/core":42,"./polargeometry":72}],72:[function(_dereq_,module,exports){

module.exports = {

  degreesToRadians: function(x) {
    return 2 * Math.PI * x / 360;
  },

  radiansToDegrees: function(x) {
    return 360 * x / (2 * Math.PI);
  }

};

},{}],73:[function(_dereq_,module,exports){
/**
 * @module Math
 * @submodule Random
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');

var seeded = false;
var previous = false;
var y2 = 0;

// Linear Congruential Generator
// Variant of a Lehman Generator
var lcg = (function() {
  // Set to values from http://en.wikipedia.org/wiki/Numerical_Recipes
  // m is basically chosen to be large (as it is the max period)
  // and for its relationships to a and c
  var m = 4294967296,
    // a - 1 should be divisible by m's prime factors
    a = 1664525,
    // c and m should be co-prime
    c = 1013904223,
    seed, z;
  return {
    setSeed : function(val) {
      // pick a random seed if val is undefined or null
      // the >>> 0 casts the seed to an unsigned 32-bit integer
      z = seed = (val == null ? Math.random() * m : val) >>> 0;
    },
    getSeed : function() {
      return seed;
    },
    rand : function() {
      // define the recurrence relationship
      z = (a * z + c) % m;
      // return a float in [0, 1)
      // if z = m then z / m = 0 therefore (z % m) / m < 1 always
      return z / m;
    }
  };
}());

/**
 * Sets the seed value for random().
 *
 * By default, random() produces different results each time the program
 * is run. Set the seed parameter to a constant to return the same
 * pseudo-random numbers each time the software is run.
 *
 * @method randomSeed
 * @param {Number} seed   the seed value
 * @example
 * <div>
 * <code>
 * randomSeed(99);
 * for (var i=0; i < 100; i++) {
 *   var r = random(0, 255);
 *   stroke(r);
 *   line(i, 0, i, 100);
 * }
 * </code>
 * </div>
 *
 * @alt
 * many vertical lines drawn in white, black or grey.
 *
 */
p5.prototype.randomSeed = function(seed) {
  lcg.setSeed(seed);
  seeded = true;
  previous = false;
};

/**
 * Return a random floating-point number.
 *
 * Takes either 0, 1 or 2 arguments.
 *
 * If no argument is given, returns a random number from 0
 * up to (but not including) 1.
 *
 * If one argument is given and it is a number, returns a random number from 0
 * up to (but not including) the number.
 *
 * If one argument is given and it is an array, returns a random element from
 * that array.
 *
 * If two arguments are given, returns a random number from the
 * first argument up to (but not including) the second argument.
 *
 * @method random
 * @param  {Number} [min]   the lower bound (inclusive)
 * @param  {Number} [max]   the upper bound (exclusive)
 * @return {Number} the random number
 * @example
 * <div>
 * <code>
 * for (var i = 0; i < 100; i++) {
 *   var r = random(50);
 *   stroke(r*5);
 *   line(50, i, 50+r, i);
 * }
 * </code>
 * </div>
 * <div>
 * <code>
 * for (var i = 0; i < 100; i++) {
 *   var r = random(-50, 50);
 *   line(50,i,50+r,i);
 * }
 * </code>
 * </div>
 * <div>
 * <code>
 * // Get a random element from an array using the random(Array) syntax
 * var words = [ "apple", "bear", "cat", "dog" ];
 * var word = random(words);  // select random word
 * text(word,10,50);  // draw the word
 * </code>
 * </div>
 *
 * @alt
 * 100 horizontal lines from center canvas to right. size+fill change each time
 * 100 horizontal lines from center of canvas. height & side change each render
 * word displayed at random. Either apple, bear, cat, or dog
 *
 */
/**
 * @method random
 * @param  {Array} choices   the array to choose from
 * @return {*} the random element from the array
 * @example
 */
p5.prototype.random = function (min, max) {

  var rand;

  if (seeded) {
    rand  = lcg.rand();
  } else {
    rand = Math.random();
  }
  if (typeof min === 'undefined') {
    return rand;
  } else
  if (typeof max === 'undefined') {
    if (min instanceof Array) {
      return min[Math.floor(rand * min.length)];
    } else {
      return rand * min;
    }
  } else {
    if (min > max) {
      var tmp = min;
      min = max;
      max = tmp;
    }

    return rand * (max-min) + min;
  }
};


/**
 *
 * Returns a random number fitting a Gaussian, or
 * normal, distribution. There is theoretically no minimum or maximum
 * value that randomGaussian() might return. Rather, there is
 * just a very low probability that values far from the mean will be
 * returned; and a higher probability that numbers near the mean will
 * be returned.
 * <br><br>
 * Takes either 0, 1 or 2 arguments.<br>
 * If no args, returns a mean of 0 and standard deviation of 1.<br>
 * If one arg, that arg is the mean (standard deviation is 1).<br>
 * If two args, first is mean, second is standard deviation.
 *
 * @method randomGaussian
 * @param  {Number} mean  the mean
 * @param  {Number} sd    the standard deviation
 * @return {Number} the random number
 * @example
 * <div>
 * <code>for (var y = 0; y < 100; y++) {
 *  var x = randomGaussian(50,15);
 *  line(50, y, x, y);
 *}
 * </code>
 * </div>
 * <div>
 * <code>
 *var distribution = new Array(360);
 *
 *function setup() {
 *  createCanvas(100, 100);
 *  for (var i = 0; i < distribution.length; i++) {
 *    distribution[i] = floor(randomGaussian(0,15));
 *  }
 *}
 *
 *function draw() {
 *  background(204);
 *
 *  translate(width/2, width/2);
 *
 *  for (var i = 0; i < distribution.length; i++) {
 *    rotate(TWO_PI/distribution.length);
 *    stroke(0);
 *    var dist = abs(distribution[i]);
 *    line(0, 0, dist, 0);
 *  }
 *}
 * </code>
 * </div>
 * @alt
 * 100 horizontal lines from center of canvas. height & side change each render
 * black lines radiate from center of canvas. size determined each render
 */
p5.prototype.randomGaussian = function(mean, sd)  {
  var y1,x1,x2,w;
  if (previous) {
    y1 = y2;
    previous = false;
  } else {
    do {
      x1 = this.random(2) - 1;
      x2 = this.random(2) - 1;
      w = x1 * x1 + x2 * x2;
    } while (w >= 1);
    w = Math.sqrt((-2 * Math.log(w))/w);
    y1 = x1 * w;
    y2 = x2 * w;
    previous = true;
  }

  var m = mean || 0;
  var s = sd || 1;
  return y1*s + m;
};

module.exports = p5;

},{"../core/core":42}],74:[function(_dereq_,module,exports){
/**
 * @module Math
 * @submodule Trigonometry
 * @for p5
 * @requires core
 * @requires polargeometry
 * @requires constants
 */

'use strict';

var p5 = _dereq_('../core/core');
var polarGeometry = _dereq_('./polargeometry');
var constants = _dereq_('../core/constants');

p5.prototype._angleMode = constants.RADIANS;

/**
 * The inverse of cos(), returns the arc cosine of a value. This function
 * expects the values in the range of -1 to 1 and values are returned in
 * the range 0 to PI (3.1415927).
 *
 * @method acos
 * @param  {Number} value the value whose arc cosine is to be returned
 * @return {Number}       the arc cosine of the given value
 *
 * @example
 * <div class= “norender">
 * <code>
 * var a = PI;
 * var c = cos(a);
 * var ac = acos(c);
 * // Prints: "3.1415927 : -1.0 : 3.1415927"
 * print(a + " : " + c + " : " +  ac);
 * </code>
 * </div>
 *
 * <div class= “norender">
 * <code>
 * var a = PI + PI/4.0;
 * var c = cos(a);
 * var ac = acos(c);
 * // Prints: "3.926991 : -0.70710665 : 2.3561943"
 * print(a + " : " + c + " : " +  ac);
 * </code>
 * </div>
 */
p5.prototype.acos = function(ratio) {
  if (this._angleMode === constants.RADIANS) {
    return Math.acos(ratio);
  } else {
    return polarGeometry.radiansToDegrees(Math.acos(ratio));
  }
};

/**
 * The inverse of sin(), returns the arc sine of a value. This function
 * expects the values in the range of -1 to 1 and values are returned
 * in the range -PI/2 to PI/2.
 *
 * @method asin
 * @param  {Number} value the value whose arc sine is to be returned
 * @return {Number}       the arc sine of the given value
 *
 * @example
 * <div class= “norender">
 * <code>
 * var a = PI + PI/3;
 * var s = sin(a);
 * var as = asin(s);
 * // Prints: "1.0471976 : 0.86602545 : 1.0471976"
 * print(a + " : " + s + " : " +  as);
 * </code>
 * </div>
 *
 * <div class= “norender">
 * <code>
 * var a = PI + PI/3.0;
 * var s = sin(a);
 * var as = asin(s);
 * // Prints: "4.1887903 : -0.86602545 : -1.0471976"
 * print(a + " : " + s + " : " +  as);
 * </code>
 * </div>
 *
 */
p5.prototype.asin = function(ratio) {
  if (this._angleMode === constants.RADIANS) {
    return Math.asin(ratio);
  } else {
    return polarGeometry.radiansToDegrees(Math.asin(ratio));
  }
};

/**
 * The inverse of tan(), returns the arc tangent of a value. This function
 * expects the values in the range of -Infinity to Infinity (exclusive) and
 * values are returned in the range -PI/2 to PI/2.
 *
 * @method atan
 * @param  {Number} value the value whose arc tangent is to be returned
 * @return {Number}       the arc tangent of the given value
 *
 * @example
 * <div class= “norender">
 * <code>
 * var a = PI + PI/3;
 * var t = tan(a);
 * var at = atan(t);
 * // Prints: "1.0471976 : 1.7320509 : 1.0471976"
 * print(a + " : " + t + " : " +  at);
 * </code>
 * </div>
 *
 * <div class= “norender">
 * <code>
 * var a = PI + PI/3.0;
 * var t = tan(a);
 * var at = atan(t);
 * // Prints: "4.1887903 : 1.7320513 : 1.0471977"
 * print(a + " : " + t + " : " +  at);
 * </code>
 * </div>
 *
 */
p5.prototype.atan = function(ratio) {
  if (this._angleMode === constants.RADIANS) {
    return Math.atan(ratio);
  } else {
    return polarGeometry.radiansToDegrees(Math.atan(ratio));
  }
};

/**
 * Calculates the angle (in radians) from a specified point to the coordinate
 * origin as measured from the positive x-axis. Values are returned as a
 * float in the range from PI to -PI. The atan2() function is most often used
 * for orienting geometry to the position of the cursor.
 * <br><br>
 * Note: The y-coordinate of the point is the first parameter, and the
 * x-coordinate is the second parameter, due the the structure of calculating
 * the tangent.
 *
 * @method atan2
 * @param  {Number} y y-coordinate of the point
 * @param  {Number} x x-coordinate of the point
 * @return {Number}   the arc tangent of the given point
 *
 * @example
 * <div>
 * <code>
 * function draw() {
 *   background(204);
 *   translate(width/2, height/2);
 *   var a = atan2(mouseY-height/2, mouseX-width/2);
 *   rotate(a);
 *   rect(-30, -5, 60, 10);
 * }
 * </code>
 * </div>
 *
 * @alt
 * 60 by 10 rect at center of canvas rotates with mouse movements
 *
 */
p5.prototype.atan2 = function (y, x) {
  if (this._angleMode === constants.RADIANS) {
    return Math.atan2(y, x);
  } else {
    return polarGeometry.radiansToDegrees(Math.atan2(y, x));
  }
};

/**
 * Calculates the cosine of an angle. This function takes into account the
 * current angleMode. Values are returned in the range -1 to 1.
 *
 * @method cos
 * @param  {Number} angle the angle
 * @return {Number}       the cosine of the angle
 *
 * @example
 * <div>
 * <code>
 * var a = 0.0;
 * var inc = TWO_PI/25.0;
 * for (var i = 0; i < 25; i++) {
 *   line(i*4, 50, i*4, 50+cos(a)*40.0);
 *   a = a + inc;
 * }
 * </code>
 * </div>
 *
 * @alt
 * vertical black lines form wave patterns, extend-down on left and right side
 *
 */
p5.prototype.cos = function(angle) {
  if (this._angleMode === constants.RADIANS) {
    return Math.cos(angle);
  } else {
    return Math.cos(this.radians(angle));
  }
};

/**
 * Calculates the sine of an angle. This function takes into account the
 * current angleMode. Values are returned in the range -1 to 1.
 *
 * @method sin
 * @param  {Number} angle the angle
 * @return {Number}       the sine of the angle
 *
 * @example
 * <div>
 * <code>
 * var a = 0.0;
 * var inc = TWO_PI/25.0;
 * for (var i = 0; i < 25; i++) {
 *   line(i*4, 50, i*4, 50+sin(a)*40.0);
 *   a = a + inc;
 * }
 * </code>
 * </div>
 *
 * @alt
 * vertical black lines extend down and up from center to form wave pattern
 *
 */
p5.prototype.sin = function(angle) {
  if (this._angleMode === constants.RADIANS) {
    return Math.sin(angle);
  } else {
    return Math.sin(this.radians(angle));
  }
};

/**
 * Calculates the tangent of an angle. This function takes into account
 * the current angleMode. Values are returned in the range -1 to 1.
 *
 * @method tan
 * @param  {Number} angle the angle
 * @return {Number}       the tangent of the angle
 *
 * @example
 * <div>
 * <code>
 *   var a = 0.0;
 *   var inc = TWO_PI/50.0;
 *   for (var i = 0; i < 100; i = i+2) {
 *     line(i, 50, i, 50+tan(a)*2.0);
 *     a = a + inc;
 *   }
 * </code>
 *
 *
 * @alt
 * vertical black lines end down and up from center to form spike pattern
 *
 */
p5.prototype.tan = function(angle) {
  if (this._angleMode === constants.RADIANS) {
    return Math.tan(angle);
  } else {
    return Math.tan(this.radians(angle));
  }
};

/**
 * Converts a radian measurement to its corresponding value in degrees.
 * Radians and degrees are two ways of measuring the same thing. There are
 * 360 degrees in a circle and 2*PI radians in a circle. For example,
 * 90° = PI/2 = 1.5707964.
 *
 * @method degrees
 * @param  {Number} radians the radians value to convert to degrees
 * @return {Number}         the converted angle
 *
 *
 * @example
 * <div class= “norender">
 * <code>
 * var rad = PI/4;
 * var deg = degrees(rad);
 * print(rad + " radians is " + deg + " degrees");
 * // Prints: 0.7853981633974483 radians is 45 degrees
 * </code>
 * </div>
 *
 */
p5.prototype.degrees = function(angle) {
  return polarGeometry.radiansToDegrees(angle);
};

/**
 * Converts a degree measurement to its corresponding value in radians.
 * Radians and degrees are two ways of measuring the same thing. There are
 * 360 degrees in a circle and 2*PI radians in a circle. For example,
 * 90° = PI/2 = 1.5707964.
 *
 * @method radians
 * @param  {Number} degrees the degree value to convert to radians
 * @return {Number}         the converted angle
 *
 * @example
 * <div class= “norender">
 * <code>
 * var deg = 45.0;
 * var rad = radians(deg);
 * print(deg + " degrees is " + rad + " radians");
 * // Prints: 45 degrees is 0.7853981633974483 radians
 * </code>
 * </div>
 */
p5.prototype.radians = function(angle) {
  return polarGeometry.degreesToRadians(angle);
};

/**
 * Sets the current mode of p5 to given mode. Default mode is RADIANS.
 *
 * @method angleMode
 * @param {Constant} mode either RADIANS or DEGREES
 *
 * @example
 * <div>
 * <code>
 * function draw(){
 *   background(204);
 *   angleMode(DEGREES); // Change the mode to DEGREES
 *   var a = atan2(mouseY-height/2, mouseX-width/2);
 *   translate(width/2, height/2);
 *   push();
 *   rotate(a);
 *   rect(-20, -5, 40, 10); // Larger rectangle is rotating in degrees
 *   pop();
 *   angleMode(RADIANS); // Change the mode to RADIANS
 *   rotate(a); // var a stays the same
 *   rect(-40, -5, 20, 10); // Smaller rectangle is rotating in radians
 * }
 * </code>
 * </div>
 *
 * @alt
 * 40 by 10 rect in center rotates with mouse moves. 20 by 10 rect moves faster.
 *
 *
 */
p5.prototype.angleMode = function(mode) {
  if (mode === constants.DEGREES || mode === constants.RADIANS) {
    this._angleMode = mode;
  }
};

module.exports = p5;

},{"../core/constants":41,"../core/core":42,"./polargeometry":72}],75:[function(_dereq_,module,exports){
/**
 * @module Typography
 * @submodule Attributes
 * @for p5
 * @requires core
 * @requires constants
 */

'use strict';

var p5 = _dereq_('../core/core');

/**
 * Sets the current alignment for drawing text. Accepts two
 * arguments: horizAlign (LEFT, CENTER, or RIGHT) and
 * vertAlign (TOP, BOTTOM, CENTER, or BASELINE).
 *
 * The horizAlign parameter is in reference to the x value
 * of the text() function, while the vertAlign parameter is
 * in reference to the y value.
 *
 * So if you write textAlign(LEFT), you are aligning the left
 * edge of your text to the x value you give in text(). If you
 * write textAlign(RIGHT, TOP), you are aligning the right edge
 * of your text to the x value and the top of edge of the text
 * to the y value.
 *
 * @method textAlign
 * @param {Constant} horizAlign horizontal alignment, either LEFT,
 *                            CENTER, or RIGHT
 * @param {Constant} vertAlign vertical alignment, either TOP,
 *                            BOTTOM, CENTER, or BASELINE
 * @return {Number}
 * @example
 * <div>
 * <code>
 * textSize(16);
 * textAlign(RIGHT);
 * text("ABCD", 50, 30);
 * textAlign(CENTER);
 * text("EFGH", 50, 50);
 * textAlign(LEFT);
 * text("IJKL", 50, 70);
 * </code>
 * </div>
 *
 * @alt
 *Letters ABCD displayed at top right, EFGH at center and IJKL at bottom left.
 *
 */
p5.prototype.textAlign = function(horizAlign, vertAlign) {
  return this._renderer.textAlign.apply(this._renderer, arguments);
};

/**
 * Sets/gets the spacing, in pixels, between lines of text. This
 * setting will be used in all subsequent calls to the text() function.
 *
 * @method textLeading
 * @param {Number} leading the size in pixels for spacing between lines
 * @return {Object|Number}
 * @example
 * <div>
 * <code>
 * // Text to display. The "\n" is a "new line" character
 * lines = "L1\nL2\nL3";
 * textSize(12);
 *
 * textLeading(10);  // Set leading to 10
 * text(lines, 10, 25);
 *
 * textLeading(20);  // Set leading to 20
 * text(lines, 40, 25);
 *
 * textLeading(30);  // Set leading to 30
 * text(lines, 70, 25);
 * </code>
 * </div>
 *
 * @alt
 *set L1 L2 & L3 displayed vertically 3 times. spacing increases for each set
 *
 */
p5.prototype.textLeading = function(theLeading) {
  return this._renderer.textLeading.apply(this._renderer, arguments);
};

/**
 * Sets/gets the current font size. This size will be used in all subsequent
 * calls to the text() function. Font size is measured in pixels.
 *
 * @method textSize
 * @param {Number} theSize the size of the letters in units of pixels
 * @return {Object|Number}
 * @example
 * <div>
 * <code>
 * textSize(12);
 * text("Font Size 12", 10, 30);
 * textSize(14);
 * text("Font Size 14", 10, 60);
 * textSize(16);
 * text("Font Size 16", 10, 90);
 * </code>
 * </div>
 *
 * @alt
 *Font Size 12 displayed small, Font Size 14 medium & Font Size 16 large
 *
 */
p5.prototype.textSize = function(theSize) {
  return this._renderer.textSize.apply(this._renderer, arguments);
};

/**
 * Sets/gets the style of the text for system fonts to NORMAL, ITALIC, or BOLD.
 * Note: this may be is overridden by CSS styling. For non-system fonts
 * (opentype, truetype, etc.) please load styled fonts instead.
 *
 * @method textStyle
 * @param {Number|Constant} theStyle styling for text, either NORMAL,
 *                            ITALIC, or BOLD
 * @return {Object|String}
 * @example
 * <div>
 * <code>
 * strokeWeight(0);
 * textSize(12);
 * textStyle(NORMAL);
 * text("Font Style Normal", 10, 30);
 * textStyle(ITALIC);
 * text("Font Style Italic", 10, 60);
 * textStyle(BOLD);
 * text("Font Style Bold", 10, 90);
 * </code>
 * </div>
 *
 * @alt
 *words Font Style Normal displayed normally, Italic in italic and bold in bold
 *
 */
p5.prototype.textStyle = function(theStyle) {
  return this._renderer.textStyle.apply(this._renderer, arguments);
};

/**
 * Calculates and returns the width of any character or text string.
 *
 * @method textWidth
 * @param {String} theText the String of characters to measure
 * @return {Number}
 * @example
 * <div>
 * <code>
 * textSize(28);
 *
 * var aChar = 'P';
 * var cWidth = textWidth(aChar);
 * text(aChar, 0, 40);
 * line(cWidth, 0, cWidth, 50);
 *
 * var aString = "p5.js";
 * var sWidth = textWidth(aString);
 * text(aString, 0, 85);
 * line(sWidth, 50, sWidth, 100);
 * </code>
 * </div>
 *
 * @alt
 *Letter P and p5.js are displayed with vertical lines at end. P is wide
 *
 */
p5.prototype.textWidth = function(theText) {
  if (theText.length === 0) {
    return 0;
  }
  return this._renderer.textWidth.apply(this._renderer, arguments);
};

/**
 * Returns the ascent of the current font at its current size. The ascent
 * represents the distance, in pixels, of the tallest character above
 * the baseline.
 *
 * @return {Number}
 * @example
 * <div>
 * <code>
 * var base = height * 0.75;
 * var scalar = 0.8; // Different for each font
 *
 * textSize(32);  // Set initial text size
 * var asc = textAscent() * scalar;  // Calc ascent
 * line(0, base - asc, width, base - asc);
 * text("dp", 0, base);  // Draw text on baseline
 *
 * textSize(64);  // Increase text size
 * asc = textAscent() * scalar;  // Recalc ascent
 * line(40, base - asc, width, base - asc);
 * text("dp", 40, base);  // Draw text on baseline
 * </code>
 * </div>
 */
p5.prototype.textAscent = function() {
  return this._renderer.textAscent();
};

/**
 * Returns the descent of the current font at its current size. The descent
 * represents the distance, in pixels, of the character with the longest
 * descender below the baseline.
 *
 * @return {Number}
 * @example
 * <div>
 * <code>
 * var base = height * 0.75;
 * var scalar = 0.8; // Different for each font
 *
 * textSize(32);  // Set initial text size
 * var desc = textDescent() * scalar;  // Calc ascent
 * line(0, base+desc, width, base+desc);
 * text("dp", 0, base);  // Draw text on baseline
 *
 * textSize(64);  // Increase text size
 * desc = textDescent() * scalar;  // Recalc ascent
 * line(40, base + desc, width, base + desc);
 * text("dp", 40, base);  // Draw text on baseline
 * </code>
 * </div>
 */
p5.prototype.textDescent = function() {
  return this._renderer.textDescent();
};

/**
 * Helper function to measure ascent and descent.
 */
p5.prototype._updateTextMetrics = function() {
  return this._renderer._updateTextMetrics();
};

module.exports = p5;

},{"../core/core":42}],76:[function(_dereq_,module,exports){
/**
 * @module Typography
 * @submodule Loading & Displaying
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');
var constants = _dereq_('../core/constants');

_dereq_('../core/error_helpers');


/**
 * Draws text to the screen. Displays the information specified in the first
 * parameter on the screen in the position specified by the additional
 * parameters. A default font will be used unless a font is set with the
 * textFont() function and a default size will be used unless a font is set
 * with textSize(). Change the color of the text with the fill() function.
 * Change the outline of the text with the stroke() and strokeWeight()
 * functions.
 * <br><br>
 * The text displays in relation to the textAlign() function, which gives the
 * option to draw to the left, right, and center of the coordinates.
 * <br><br>
 * The x2 and y2 parameters define a rectangular area to display within and
 * may only be used with string data. When these parameters are specified,
 * they are interpreted based on the current rectMode() setting. Text that
 * does not fit completely within the rectangle specified will not be drawn
 * to the screen.
 *
 * @method text
 * @param {String} str the alphanumeric symbols to be displayed
 * @param {Number} x   x-coordinate of text
 * @param {Number} y   y-coordinate of text
 * @param {Number} x2  by default, the width of the text box,
 *                     see rectMode() for more info
 * @param {Number} y2  by default, the height of the text box,
 *                     see rectMode() for more info
 * @return {Object} this
 * @example
 * <div>
 * <code>
 * textSize(32);
 * text("word", 10, 30);
 * fill(0, 102, 153);
 * text("word", 10, 60);
 * fill(0, 102, 153, 51);
 * text("word", 10, 90);
 * </code>
 * </div>
 * <div>
 * <code>
 * s = "The quick brown fox jumped over the lazy dog.";
 * fill(50);
 * text(s, 10, 10, 70, 80); // Text wraps within text box
 * </code>
 * </div>
 *
 * @alt
 *'word' displayed 3 times going from black, blue to translucent blue
 * The quick brown fox jumped over the lazy dog.
 *
 */
p5.prototype.text = function(str, x, y, maxWidth, maxHeight) {
  return (!(this._renderer._doFill || this._renderer._doStroke)) ? this :
    this._renderer.text.apply(this._renderer, arguments);
};

/**
 * Sets the current font that will be drawn with the text() function.
 *
 * @method textFont
 * @param {Object|String} f a font loaded via loadFont(), or a String
 * representing a <a href="https://mzl.la/2dOw8WD">web safe font</a> (a font
 * that is generally available across all systems)
 * @return {Object|String} the current font
 * @example
 * <div>
 * <code>
 * fill(0);
 * textSize(12);
 * textFont("Georgia");
 * text("Georgia", 12, 30);
 * textFont("Helvetica");
 * text("Helvetica", 12, 60);
 * </code>
 * </div>
 * <div>
 * <code>
 * var fontRegular, fontItalic, fontBold;
 * function preload() {
 *    fontRegular = loadFont("assets/Regular.otf");
 *    fontItalic = loadFont("assets/Italic.ttf");
 *    fontBold = loadFont("assets/Bold.ttf");
 * }
 * function setup() {
 *    background(210);
 *    fill(0).strokeWeight(0).textSize(10);
 *    textFont(fontRegular);
 *    text("Font Style Normal", 10, 30);
 *    textFont(fontItalic);
 *    text("Font Style Italic", 10, 50);
 *    textFont(fontBold);
 *    text("Font Style Bold", 10, 70);
 * }
 * </code>
 * </div>
 *
 * @alt
 *words Font Style Normal displayed normally, Italic in italic and bold in bold
 *
 */
p5.prototype.textFont = function(theFont, theSize) {

  if (arguments.length) {

    if (!theFont) {

      throw Error('null font passed to textFont');
    }

    this._renderer._setProperty('_textFont', theFont);

    if (theSize) {

      this._renderer._setProperty('_textSize', theSize);
      this._renderer._setProperty('_textLeading',
        theSize * constants._DEFAULT_LEADMULT);
    }

    return this._renderer._applyTextProperties();
  }

  return this._renderer._textFont;
};

module.exports = p5;

},{"../core/constants":41,"../core/core":42,"../core/error_helpers":45}],77:[function(_dereq_,module,exports){
/**
 * This module defines the p5.Font class and functions for
 * drawing text to the display canvas.
 * @module Typography
 * @submodule Font
 * @requires core
 * @requires constants
 */

'use strict';

var p5 = _dereq_('../core/core');
var constants = _dereq_('../core/constants');

/*
 * TODO:
 *
 * API:
 * -- textBounds()
 * -- getPath()
 * -- getPoints()
 *
 * ===========================================
 * -- PFont functions:
 *    PFont.list()
 *
 * -- kerning
 * -- alignment: justified?
 * -- integrate p5.dom? (later)
 */

/**
 * Base class for font handling
 * @class p5.Font
 * @constructor
 * @param {Object} [pInst] pointer to p5 instance
 */
p5.Font = function(p) {

  this.parent = p;

  this.cache = {};

  /**
   * Underlying opentype font implementation
   * @property font
   */
  this.font = undefined;
};

p5.Font.prototype.list = function() {

  // TODO
  throw 'not yet implemented';
};

/**
 * Returns a tight bounding box for the given text string using this
 * font (currently only supports single lines)
 *
 * @method textBounds
 * @param  {String} line     a line of text
 * @param  {Number} x        x-position
 * @param  {Number} y        y-position
 * @param  {Number} fontSize font size to use (optional)
 * @param  {Object} options opentype options (optional)
 *
 * @return {Object}          a rectangle object with properties: x, y, w, h
 *
 * @example
 * <div>
 * <code>
 * var font;
 * var textString = 'Lorem ipsum dolor sit amet.';
 * function preload() {
 *    font = loadFont('./assets/Regular.otf');
 * };
 * function setup() {
 *    background(210);
 *
 *    var bbox = font.textBounds(textString, 10, 30, 12);
 *    fill(255);
 *    stroke(0);
 *    rect(bbox.x, bbox.y, bbox.w, bbox.h);
 *    fill(0);
 *    noStroke();
 *
 *    textFont(font);
 *    textSize(12);
 *    text(textString, 10, 30);
 * };
 * </code>
 * </div>
 *
 * @alt
 *words Lorem ipsum dol go off canvas and contained by white bounding box
 *
 */
p5.Font.prototype.textBounds = function(str, x, y, fontSize, options) {

  x = x !== undefined ? x : 0;
  y = y !== undefined ? y : 0;
  fontSize = fontSize || this.parent._renderer._textSize;

  // Check cache for existing bounds. Take into consideration the text alignment
  // settings. Default alignment should match opentype's origin: left-aligned &
  // alphabetic baseline.
  var p = (options && options.renderer && options.renderer._pInst) ||
    this.parent,
    ctx = p._renderer.drawingContext,
    alignment = ctx.textAlign || constants.LEFT,
    baseline = ctx.textBaseline || constants.BASELINE;
  var result = this.cache[cacheKey('textBounds', str, x, y, fontSize, alignment,
    baseline)];

  if (!result) {

    var xCoords = [], yCoords = [], self = this,
      scale = this._scale(fontSize), minX, minY, maxX, maxY;

    this.font.forEachGlyph(str, x, y, fontSize, options,
      function(glyph, gX, gY, gFontSize) {

        xCoords.push(gX);
        yCoords.push(gY);

        var gm = glyph.getMetrics();

        if (glyph.name !== 'space' && glyph.unicode !== 32) {

          xCoords.push(gX + (gm.xMax * scale));
          yCoords.push(gY + (-gm.yMin * scale));
          yCoords.push(gY + (-gm.yMax * scale));

        } else { // NOTE: deals with broken metrics for spaces in opentype.js

          xCoords.push(gX + self.font.charToGlyph(' ').advanceWidth *
            self._scale(fontSize));
        }
      });

    // fix to #1409 (not sure why these max() functions were here)
    /*minX = Math.max(0, Math.min.apply(null, xCoords));
    minY = Math.max(0, Math.min.apply(null, yCoords));
    maxX = Math.max(0, Math.max.apply(null, xCoords));
    maxY = Math.max(0, Math.max.apply(null, yCoords));*/
    minX = Math.min.apply(null, xCoords);
    minY = Math.min.apply(null, yCoords);
    maxX = Math.max.apply(null, xCoords);
    maxY = Math.max.apply(null, yCoords);

    result = {
      x: minX,
      y: minY,
      h: maxY - minY,
      w: maxX - minX,
      advance: minX - x
    };

    // Bounds are now calculated, so shift the x & y to match alignment settings
    var textWidth = result.w + result.advance;
    var pos = this._handleAlignment(p, ctx, str, result.x, result.y, textWidth);
    result.x = pos.x;
    result.y = pos.y;

    this.cache[cacheKey('textBounds', str, x, y, fontSize, alignment,
      baseline)] = result;
  }
  //else console.log('cache-hit');

  return result;
};


/**
 * Computes an array of points following the path for specified text
 *
 * @param  {String} txt     a line of text
 * @param  {Number} x        x-position
 * @param  {Number} y        y-position
 * @param  {Number} fontSize font size to use (optional)
 * @param  {Object} options  an (optional) object that can contain:
 *
 * <br>sampleFactor - the ratio of path-length to number of samples
 * (default=.25); higher values yield more points and are therefore
 * more precise
 *
 * <br>simplifyThreshold - if set to a non-zero value, collinear points will be
 * be removed from the polygon; the value represents the threshold angle to use
 * when determining whether two edges are collinear
 *
 * @return {Array}  an array of points, each with x, y, alpha (the path angle)
 */
p5.Font.prototype.textToPoints = function(txt, x, y, fontSize, options) {

  var xoff = 0, result = [], glyphs = this._getGlyphs(txt);

  fontSize = fontSize || this.parent._renderer._textSize;

  for (var i = 0; i < glyphs.length; i++) {

    if (glyphs[i].name !== 'space') { // fix to #1817

      var gpath = glyphs[i].getPath(x, y, fontSize),
        paths = splitPaths(gpath.commands);

      for (var j = 0; j < paths.length; j++) {

        var pts = pathToPoints(paths[j], options);

        for (var k = 0; k < pts.length; k++) {
          pts[k].x += xoff;
          result.push(pts[k]);
        }
      }
    }

    xoff += glyphs[i].advanceWidth * this._scale(fontSize);
  }

  return result;
};

// ----------------------------- End API ------------------------------

/**
 * Returns the set of opentype glyphs for the supplied string.
 *
 * Note that there is not a strict one-to-one mapping between characters
 * and glyphs, so the list of returned glyphs can be larger or smaller
 *  than the length of the given string.
 *
 * @param  {String} str the string to be converted
 * @return {array}     the opentype glyphs
 */
p5.Font.prototype._getGlyphs = function(str) {

  return this.font.stringToGlyphs(str);
};

/**
 * Returns an opentype path for the supplied string and position.
 *
 * @param  {String} line     a line of text
 * @param  {Number} x        x-position
 * @param  {Number} y        y-position
 * @param  {Object} options opentype options (optional)
 * @return {Object}     the opentype path
 */
p5.Font.prototype._getPath = function(line, x, y, options) {

  var p = (options && options.renderer && options.renderer._pInst) ||
    this.parent,
    ctx = p._renderer.drawingContext,
    pos = this._handleAlignment(p, ctx, line, x, y);

  return this.font.getPath(line, pos.x, pos.y, p._renderer._textSize, options);
};

/*
 * Creates an SVG-formatted path-data string
 * (See http://www.w3.org/TR/SVG/paths.html#PathData)
 * from the given opentype path or string/position
 *
 * @param  {Object} path    an opentype path, OR the following:
 *
 * @param  {String} line     a line of text
 * @param  {Number} x        x-position
 * @param  {Number} y        y-position
 * @param  {Object} options opentype options (optional), set options.decimals
 * to set the decimal precision of the path-data
 *
 * @return {Object}     this p5.Font object
 */
p5.Font.prototype._getPathData = function(line, x, y, options) {

  var decimals = 3;

  // create path from string/position
  if (typeof line === 'string' && arguments.length > 2) {

    line = this._getPath(line, x, y, options);
  }
  // handle options specified in 2nd arg
  else if (typeof x === 'object') {

    options = x;
  }

  // handle svg arguments
  if (options && typeof options.decimals === 'number') {

    decimals = options.decimals;
  }

  return line.toPathData(decimals);
};

/*
 * Creates an SVG <path> element, as a string,
 * from the given opentype path or string/position
 *
 * @param  {Object} path    an opentype path, OR the following:
 *
 * @param  {String} line     a line of text
 * @param  {Number} x        x-position
 * @param  {Number} y        y-position
 * @param  {Object} options opentype options (optional), set options.decimals
 * to set the decimal precision of the path-data in the <path> element,
 *  options.fill to set the fill color for the <path> element,
 *  options.stroke to set the stroke color for the <path> element,
 *  options.strokeWidth to set the strokeWidth for the <path> element.
 *
 * @return {Object}     this p5.Font object
 */
p5.Font.prototype._getSVG = function(line, x, y, options) {

  var decimals = 3;

  // create path from string/position
  if (typeof line === 'string' && arguments.length > 2) {

    line = this._getPath(line, x, y, options);
  }
  // handle options specified in 2nd arg
  else if (typeof x === 'object') {

    options = x;
  }

  // handle svg arguments
  if (options) {
    if (typeof options.decimals === 'number') {
      decimals = options.decimals;
    }
    if (typeof options.strokeWidth === 'number') {
      line.strokeWidth = options.strokeWidth;
    }
    if (typeof options.fill !== 'undefined') {
      line.fill = options.fill;
    }
    if (typeof options.stroke !== 'undefined') {
      line.stroke = options.stroke;
    }
  }

  return line.toSVG(decimals);
};

/*
 * Renders an opentype path or string/position
 * to the current graphics context
 *
 * @param  {Object} path    an opentype path, OR the following:
 *
 * @param  {String} line     a line of text
 * @param  {Number} x        x-position
 * @param  {Number} y        y-position
 * @param  {Object} options opentype options (optional)
 *
 * @return {Object}     this p5.Font object
 */
p5.Font.prototype._renderPath = function(line, x, y, options) {

  var pdata, pg = (options && options.renderer) || this.parent._renderer,
    ctx = pg.drawingContext;

  if (typeof line === 'object' && line.commands) {

    pdata = line.commands;
  } else {

    //pos = handleAlignment(p, ctx, line, x, y);
    pdata = this._getPath(line, x, y, options).commands;
  }

  ctx.beginPath();
  for (var i = 0; i < pdata.length; i += 1) {

    var cmd = pdata[i];
    if (cmd.type === 'M') {
      ctx.moveTo(cmd.x, cmd.y);
    } else if (cmd.type === 'L') {
      ctx.lineTo(cmd.x, cmd.y);
    } else if (cmd.type === 'C') {
      ctx.bezierCurveTo(cmd.x1, cmd.y1, cmd.x2, cmd.y2, cmd.x, cmd.y);
    } else if (cmd.type === 'Q') {
      ctx.quadraticCurveTo(cmd.x1, cmd.y1, cmd.x, cmd.y);
    } else if (cmd.type === 'Z') {
      ctx.closePath();
    }
  }

  // only draw stroke if manually set by user
  if (pg._doStroke && pg._strokeSet) {

    ctx.stroke();
  }

  if (pg._doFill) {

    // if fill hasn't been set by user, use default-text-fill
    ctx.fillStyle = pg._fillSet ? ctx.fillStyle : constants._DEFAULT_TEXT_FILL;
    ctx.fill();
  }

  return this;
};

p5.Font.prototype._textWidth = function(str, fontSize) {

  if (str === ' ') { // special case for now

    return this.font.charToGlyph(' ').advanceWidth * this._scale(fontSize);
  }

  var bounds = this.textBounds(str, 0, 0, fontSize);
  return bounds.w + bounds.advance;
};

p5.Font.prototype._textAscent = function(fontSize) {

  return this.font.ascender * this._scale(fontSize);
};

p5.Font.prototype._textDescent = function(fontSize) {

  return -this.font.descender * this._scale(fontSize);
};

p5.Font.prototype._scale = function(fontSize) {

  return (1 / this.font.unitsPerEm) * (fontSize ||
    this.parent._renderer._textSize);
};

p5.Font.prototype._handleAlignment = function(p, ctx, line, x, y, textWidth) {
  var fontSize = p._renderer._textSize,
    textAscent = this._textAscent(fontSize),
    textDescent = this._textDescent(fontSize);

  textWidth = textWidth !== undefined ? textWidth :
    this._textWidth(line, fontSize);

  if (ctx.textAlign === constants.CENTER) {
    x -= textWidth / 2;
  } else if (ctx.textAlign === constants.RIGHT) {
    x -= textWidth;
  }

  if (ctx.textBaseline === constants.TOP) {
    y += textAscent;
  } else if (ctx.textBaseline === constants._CTX_MIDDLE) {
    y += textAscent / 2;
  } else if (ctx.textBaseline === constants.BOTTOM) {
    y -= textDescent;
  }

  return { x: x, y: y };
};

// path-utils

function pathToPoints(cmds, options) {

  var opts = parseOpts(options, {
    sampleFactor: 0.1,
    simplifyThreshold: 0,
  });

  var len = pointAtLength(cmds,0,1), // total-length
    t = len / (len * opts.sampleFactor),
    pts = [];

  for (var i = 0; i < len; i += t) {
    pts.push(pointAtLength(cmds, i));
  }

  if (opts.simplifyThreshold) {
    /*var count = */simplify(pts, opts.simplifyThreshold);
    //console.log('Simplify: removed ' + count + ' pts');
  }

  return pts;
}

function simplify(pts, angle) {

  angle = (typeof angle === 'undefined') ? 0 : angle;

  var num = 0;
  for (var i = pts.length - 1; pts.length > 3 && i >= 0; --i) {

    if (collinear(at(pts, i - 1), at(pts, i), at(pts, i + 1), angle)) {

      // Remove the middle point
      pts.splice(i % pts.length, 1);
      num++;
    }
  }
  return num;
}

function splitPaths(cmds) {

  var paths = [], current;
  for (var i = 0; i < cmds.length; i++) {
    if (cmds[i].type === 'M') {
      if (current) {
        paths.push(current);
      }
      current = [];
    }
    current.push(cmdToArr(cmds[i]));
  }
  paths.push(current);

  return paths;
}

function cmdToArr(cmd) {

  var arr = [ cmd.type ];
  if (cmd.type === 'M' || cmd.type === 'L') { // moveto or lineto
    arr.push(cmd.x, cmd.y);
  } else if (cmd.type === 'C') {
    arr.push(cmd.x1, cmd.y1, cmd.x2, cmd.y2, cmd.x, cmd.y);
  } else if (cmd.type === 'Q') {
    arr.push(cmd.x1, cmd.y1, cmd.x, cmd.y);
  }
  // else if (cmd.type === 'Z') { /* no-op */ }
  return arr;
}

function parseOpts(options, defaults) {

  if (typeof options !== 'object') {
    options = defaults;
  }
  else {
    for (var key in defaults) {
      if (typeof options[key] === 'undefined') {
        options[key] = defaults[key];
      }
    }
  }
  return options;
}

//////////////////////// Helpers ////////////////////////////

function at(v, i) {
  var s = v.length;
  return v[i < 0 ? i % s + s : i % s];
}

function collinear(a, b, c, thresholdAngle) {

  if (!thresholdAngle) {
    return areaTriangle(a, b, c) === 0;
  }

  if (typeof collinear.tmpPoint1 === 'undefined') {
    collinear.tmpPoint1 = [];
    collinear.tmpPoint2 = [];
  }

  var ab = collinear.tmpPoint1, bc = collinear.tmpPoint2;
  ab.x = b.x - a.x;
  ab.y = b.y - a.y;
  bc.x = c.x - b.x;
  bc.y = c.y - b.y;

  var dot = ab.x * bc.x + ab.y * bc.y,
    magA = Math.sqrt(ab.x * ab.x + ab.y * ab.y),
    magB = Math.sqrt(bc.x * bc.x + bc.y * bc.y),
    angle = Math.acos(dot / (magA * magB));

  return angle < thresholdAngle;
}

function areaTriangle(a, b, c) {
  return (((b[0] - a[0]) * (c[1] - a[1])) - ((c[0] - a[0]) * (b[1] - a[1])));
}

// Portions of below code copyright 2008 Dmitry Baranovskiy (via MIT license)

function findDotsAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t) {

  var t1 = 1 - t, t13 = Math.pow(t1, 3), t12 = Math.pow(t1, 2), t2 = t * t,
    t3 = t2 * t, x = t13 * p1x + t12 * 3 * t * c1x + t1 * 3 * t * t * c2x +
    t3 * p2x, y = t13 * p1y + t12 * 3 * t * c1y + t1 * 3 * t * t * c2y +
    t3 * p2y, mx = p1x + 2 * t * (c1x - p1x) + t2 * (c2x - 2 * c1x + p1x),
    my = p1y + 2 * t * (c1y - p1y) + t2 * (c2y - 2 * c1y + p1y),
    nx = c1x + 2 * t * (c2x - c1x) + t2 * (p2x - 2 * c2x + c1x),
    ny = c1y + 2 * t * (c2y - c1y) + t2 * (p2y - 2 * c2y + c1y),
    ax = t1 * p1x + t * c1x, ay = t1 * p1y + t * c1y,
    cx = t1 * c2x + t * p2x, cy = t1 * c2y + t * p2y,
    alpha = (90 - Math.atan2(mx - nx, my - ny) * 180 / Math.PI);

  if (mx > nx || my < ny) { alpha += 180; }

  return { x: x, y: y, m: { x: mx, y: my }, n: { x: nx, y: ny },
    start: { x: ax, y: ay }, end: { x: cx, y: cy }, alpha: alpha
  };
}

function getPointAtSegmentLength(p1x,p1y,c1x,c1y,c2x,c2y,p2x,p2y,length) {
  return (length == null) ? bezlen(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y) :
    findDotsAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y,
      getTatLen(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, length));
}

function pointAtLength(path, length, istotal) {
  path = path2curve(path);
  var x, y, p, l, sp = '', subpaths = {}, point, len = 0;
  for (var i = 0, ii = path.length; i < ii; i++) {
    p = path[i];
    if (p[0] === 'M') {
      x = +p[1];
      y = +p[2];
    } else {
      l = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6]);
      if (len + l > length) {
        if (!istotal) {
          point = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5],
            p[6], length - len);
          return { x: point.x, y: point.y, alpha: point.alpha };
        }
      }
      len += l;
      x = +p[5];
      y = +p[6];
    }
    sp += p.shift() + p;
  }
  subpaths.end = sp;

  point = istotal ? len : findDotsAtSegment
    (x, y, p[0], p[1], p[2], p[3], p[4], p[5], 1);

  if (point.alpha) {
    point = { x: point.x, y: point.y, alpha: point.alpha };
  }

  return point;
}

function pathToAbsolute(pathArray) {

  var res = [], x = 0, y = 0, mx = 0, my = 0, start = 0;
  if (pathArray[0][0] === 'M') {
    x = +pathArray[0][1];
    y = +pathArray[0][2];
    mx = x;
    my = y;
    start++;
    res[0] = ['M', x, y];
  }

  var dots,crz = pathArray.length===3 && pathArray[0][0]==='M' &&
    pathArray[1][0].toUpperCase()==='R' && pathArray[2][0].toUpperCase()==='Z';

  for (var r, pa, i = start, ii = pathArray.length; i < ii; i++) {
    res.push(r = []);
    pa = pathArray[i];
    if (pa[0] !== String.prototype.toUpperCase.call(pa[0])) {
      r[0] = String.prototype.toUpperCase.call(pa[0]);
      switch (r[0]) {
        case 'A':
          r[1] = pa[1];
          r[2] = pa[2];
          r[3] = pa[3];
          r[4] = pa[4];
          r[5] = pa[5];
          r[6] = +(pa[6] + x);
          r[7] = +(pa[7] + y);
          break;
        case 'V':
          r[1] = +pa[1] + y;
          break;
        case 'H':
          r[1] = +pa[1] + x;
          break;
        case 'R':
          dots = [x, y].concat(pa.slice(1));
          for (var j = 2, jj = dots.length; j < jj; j++) {
            dots[j] = +dots[j] + x;
            dots[++j] = +dots[j] + y;
          }
          res.pop();
          res = res.concat(catmullRom2bezier(dots, crz));
          break;
        case 'M':
          mx = +pa[1] + x;
          my = +pa[2] + y;
          break;
        default:
          for (j = 1, jj = pa.length; j < jj; j++) {
            r[j] = +pa[j] + ((j % 2) ? x : y);
          }
      }
    } else if (pa[0] === 'R') {
      dots = [x, y].concat(pa.slice(1));
      res.pop();
      res = res.concat(catmullRom2bezier(dots, crz));
      r = ['R'].concat(pa.slice(-2));
    } else {
      for (var k = 0, kk = pa.length; k < kk; k++) {
        r[k] = pa[k];
      }
    }
    switch (r[0]) {
      case 'Z':
        x = mx;
        y = my;
        break;
      case 'H':
        x = r[1];
        break;
      case 'V':
        y = r[1];
        break;
      case 'M':
        mx = r[r.length - 2];
        my = r[r.length - 1];
        break;
      default:
        x = r[r.length - 2];
        y = r[r.length - 1];
    }
  }
  return res;
}

function path2curve(path, path2) {

  var p = pathToAbsolute(path), p2 = path2 && pathToAbsolute(path2),
    attrs = { x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null },
    attrs2 = { x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null },

    processPath = function(path, d, pcom) {
      var nx, ny, tq = { T: 1, Q: 1 };
      if (!path) { return ['C', d.x, d.y, d.x, d.y, d.x, d.y]; }
      if (!(path[0] in tq)) { d.qx = d.qy = null; }
      switch (path[0]) {
        case 'M':
          d.X = path[1];
          d.Y = path[2];
          break;
        case 'A':
          path = ['C'].concat(a2c.apply(0, [d.x, d.y].concat(path.slice(1))));
          break;
        case 'S':
          if (pcom === 'C' || pcom === 'S') {
            nx = d.x * 2 - d.bx;
            ny = d.y * 2 - d.by;
          } else {
            nx = d.x;
            ny = d.y;
          }
          path = ['C', nx, ny].concat(path.slice(1));
          break;
        case 'T':
          if (pcom === 'Q' || pcom === 'T') {
            d.qx = d.x * 2 - d.qx;
            d.qy = d.y * 2 - d.qy;
          } else {
            d.qx = d.x;
            d.qy = d.y;
          }
          path = ['C'].concat(q2c(d.x, d.y, d.qx, d.qy, path[1], path[2]));
          break;
        case 'Q':
          d.qx = path[1];
          d.qy = path[2];
          path = ['C'].concat(q2c(d.x,d.y,path[1],path[2],path[3],path[4]));
          break;
        case 'L':
          path = ['C'].concat(l2c(d.x, d.y, path[1], path[2]));
          break;
        case 'H':
          path = ['C'].concat(l2c(d.x, d.y, path[1], d.y));
          break;
        case 'V':
          path = ['C'].concat(l2c(d.x, d.y, d.x, path[1]));
          break;
        case 'Z':
          path = ['C'].concat(l2c(d.x, d.y, d.X, d.Y));
          break;
      }
      return path;
    },

    fixArc = function(pp, i) {
      if (pp[i].length > 7) {
        pp[i].shift();
        var pi = pp[i];
        while (pi.length) {
          pcoms1[i] = 'A';
          if (p2) { pcoms2[i] = 'A'; }
          pp.splice(i++, 0, ['C'].concat(pi.splice(0, 6)));
        }
        pp.splice(i, 1);
        ii = Math.max(p.length, p2 && p2.length || 0);
      }
    },

    fixM = function(path1, path2, a1, a2, i) {
      if (path1 && path2 && path1[i][0] === 'M' && path2[i][0] !== 'M') {
        path2.splice(i, 0, ['M', a2.x, a2.y]);
        a1.bx = 0;
        a1.by = 0;
        a1.x = path1[i][1];
        a1.y = path1[i][2];
        ii = Math.max(p.length, p2 && p2.length || 0);
      }
    },

    pcoms1 = [], // path commands of original path p
    pcoms2 = [], // path commands of original path p2
    pfirst = '', // temporary holder for original path command
    pcom = ''; // holder for previous path command of original path

  for (var i = 0, ii = Math.max(p.length, p2 && p2.length || 0); i < ii; i++) {
    if (p[i]) { pfirst = p[i][0]; } // save current path command

    if (pfirst !== 'C') {
      pcoms1[i] = pfirst; // Save current path command
      if (i) { pcom = pcoms1[i - 1]; } // Get previous path command pcom
    }
    p[i] = processPath(p[i], attrs, pcom);

    if (pcoms1[i] !== 'A' && pfirst === 'C') { pcoms1[i] = 'C'; }

    fixArc(p, i); // fixArc adds also the right amount of A:s to pcoms1

    if (p2) { // the same procedures is done to p2
      if (p2[i]) { pfirst = p2[i][0]; }
      if (pfirst !== 'C') {
        pcoms2[i] = pfirst;
        if (i) { pcom = pcoms2[i - 1]; }
      }
      p2[i] = processPath(p2[i], attrs2, pcom);

      if (pcoms2[i] !== 'A' && pfirst === 'C') { pcoms2[i] = 'C'; }

      fixArc(p2, i);
    }
    fixM(p, p2, attrs, attrs2, i);
    fixM(p2, p, attrs2, attrs, i);
    var seg = p[i], seg2 = p2 && p2[i], seglen = seg.length,
      seg2len = p2 && seg2.length;
    attrs.x = seg[seglen - 2];
    attrs.y = seg[seglen - 1];
    attrs.bx = parseFloat(seg[seglen - 4]) || attrs.x;
    attrs.by = parseFloat(seg[seglen - 3]) || attrs.y;
    attrs2.bx = p2 && (parseFloat(seg2[seg2len - 4]) || attrs2.x);
    attrs2.by = p2 && (parseFloat(seg2[seg2len - 3]) || attrs2.y);
    attrs2.x = p2 && seg2[seg2len - 2];
    attrs2.y = p2 && seg2[seg2len - 1];
  }

  return p2 ? [p, p2] : p;
}

function a2c(x1, y1, rx, ry, angle, lac, sweep_flag, x2, y2, recursive) {
  // for more information of where this Math came from visit:
  // http://www.w3.org/TR/SVG11/implnote.html#ArcImplementationNotes
  var PI = Math.PI, _120 = PI * 120 / 180, f1, f2, cx, cy,
    rad = PI / 180 * (+angle || 0), res = [], xy,
    rotate = function (x, y, rad) {
      var X = x * Math.cos(rad) - y * Math.sin(rad),
        Y = x * Math.sin(rad) + y * Math.cos(rad);
      return { x: X, y: Y };
    };
  if (!recursive) {
    xy = rotate(x1, y1, -rad);
    x1 = xy.x;
    y1 = xy.y;
    xy = rotate(x2, y2, -rad);
    x2 = xy.x;
    y2 = xy.y;
    var x = (x1 - x2) / 2, y = (y1 - y2) / 2,
      h = (x * x) / (rx * rx) + (y * y) / (ry * ry);
    if (h > 1) {
      h = Math.sqrt(h);
      rx = h * rx;
      ry = h * ry;
    }
    var rx2 = rx * rx, ry2 = ry * ry,
      k = (lac === sweep_flag ? -1 : 1) * Math.sqrt(Math.abs
        ((rx2 * ry2 - rx2 * y * y - ry2 * x * x)/(rx2 * y * y + ry2 * x * x)));

    cx = k * rx * y / ry + (x1 + x2) / 2;
    cy = k * -ry * x / rx + (y1 + y2) / 2;
    f1 = Math.asin(((y1 - cy) / ry).toFixed(9));
    f2 = Math.asin(((y2 - cy) / ry).toFixed(9));

    f1 = x1 < cx ? PI - f1 : f1;
    f2 = x2 < cx ? PI - f2 : f2;

    if (f1 < 0) { f1 = PI * 2 + f1; }
    if (f2 < 0) { f2 = PI * 2 + f2; }

    if (sweep_flag && f1 > f2) {
      f1 = f1 - PI * 2;
    }
    if (!sweep_flag && f2 > f1) {
      f2 = f2 - PI * 2;
    }
  } else {
    f1 = recursive[0];
    f2 = recursive[1];
    cx = recursive[2];
    cy = recursive[3];
  }
  var df = f2 - f1;
  if (Math.abs(df) > _120) {
    var f2old = f2, x2old = x2, y2old = y2;
    f2 = f1 + _120 * (sweep_flag && f2 > f1 ? 1 : -1);
    x2 = cx + rx * Math.cos(f2);
    y2 = cy + ry * Math.sin(f2);
    res = a2c(x2, y2, rx, ry, angle, 0, sweep_flag, x2old, y2old,
      [f2, f2old, cx, cy]);
  }
  df = f2 - f1;
  var c1 = Math.cos(f1),
    s1 = Math.sin(f1),
    c2 = Math.cos(f2),
    s2 = Math.sin(f2),
    t = Math.tan(df / 4),
    hx = 4 / 3 * rx * t,
    hy = 4 / 3 * ry * t,
    m1 = [x1, y1],
    m2 = [x1 + hx * s1, y1 - hy * c1],
    m3 = [x2 + hx * s2, y2 - hy * c2],
    m4 = [x2, y2];
  m2[0] = 2 * m1[0] - m2[0];
  m2[1] = 2 * m1[1] - m2[1];
  if (recursive) {
    return [m2, m3, m4].concat(res);
  } else {
    res = [m2, m3, m4].concat(res).join().split(',');
    var newres = [];
    for (var i = 0, ii = res.length; i < ii; i++) {
      newres[i] = i % 2 ? rotate(res[i - 1], res[i], rad).y : rotate(res[i],
        res[i + 1], rad).x;
    }
    return newres;
  }
}

// http://schepers.cc/getting-to-the-point
function catmullRom2bezier(crp, z) {
  var d = [];
  for (var i = 0, iLen = crp.length; iLen - 2 * !z > i; i += 2) {
    var p = [{
      x: +crp[i - 2],
      y: +crp[i - 1]
    }, {
      x: +crp[i],
      y: +crp[i + 1]
    }, {
      x: +crp[i + 2],
      y: +crp[i + 3]
    }, {
      x: +crp[i + 4],
      y: +crp[i + 5]
    }];
    if (z) {
      if (!i) {
        p[0] = {
          x: +crp[iLen - 2],
          y: +crp[iLen - 1]
        };
      } else if (iLen - 4 === i) {
        p[3] = {
          x: +crp[0],
          y: +crp[1]
        };
      } else if (iLen - 2 === i) {
        p[2] = {
          x: +crp[0],
          y: +crp[1]
        };
        p[3] = {
          x: +crp[2],
          y: +crp[3]
        };
      }
    } else {
      if (iLen - 4 === i) {
        p[3] = p[2];
      } else if (!i) {
        p[0] = {
          x: +crp[i],
          y: +crp[i + 1]
        };
      }
    }
    d.push(['C', (-p[0].x + 6 * p[1].x + p[2].x) / 6, (-p[0].y + 6 * p[1].y +
      p[2].y) / 6, (p[1].x + 6 * p[2].x - p[3].x) / 6, (p[1].y + 6 * p[2].y -
      p[3].y) / 6, p[2].x, p[2].y ]);
  }

  return d;
}

function l2c(x1, y1, x2, y2) { return [x1, y1, x2, y2, x2, y2]; }

function q2c(x1, y1, ax, ay, x2, y2) {
  var _13 = 1 / 3, _23 = 2 / 3;
  return [
    _13 * x1 + _23 * ax, _13 * y1 + _23 * ay,
    _13 * x2 + _23 * ax, _13 * y2 + _23 * ay, x2, y2
  ];
}

function bezlen(x1, y1, x2, y2, x3, y3, x4, y4, z) {
  if (z == null) { z = 1; }
  z = z > 1 ? 1 : z < 0 ? 0 : z;
  var z2 = z / 2,
    n = 12, Tvalues = [-0.1252, 0.1252, -0.3678, 0.3678, -0.5873, 0.5873,
       -0.7699, 0.7699, -0.9041, 0.9041, -0.9816, 0.9816],
    sum = 0, Cvalues = [0.2491, 0.2491, 0.2335, 0.2335, 0.2032, 0.2032,
      0.1601, 0.1601, 0.1069, 0.1069, 0.0472, 0.0472 ];
  for (var i = 0; i < n; i++) {
    var ct = z2 * Tvalues[i] + z2,
      xbase = base3(ct, x1, x2, x3, x4),
      ybase = base3(ct, y1, y2, y3, y4),
      comb = xbase * xbase + ybase * ybase;
    sum += Cvalues[i] * Math.sqrt(comb);
  }
  return z2 * sum;
}

function getTatLen(x1, y1, x2, y2, x3, y3, x4, y4, ll) {
  if (ll < 0 || bezlen(x1, y1, x2, y2, x3, y3, x4, y4) < ll) {
    return;
  }
  var t = 1, step = t / 2, t2 = t - step, l, e = 0.01;
  l = bezlen(x1, y1, x2, y2, x3, y3, x4, y4, t2);
  while (Math.abs(l - ll) > e) {
    step /= 2;
    t2 += (l < ll ? 1 : -1) * step;
    l = bezlen(x1, y1, x2, y2, x3, y3, x4, y4, t2);
  }
  return t2;
}

function base3(t, p1, p2, p3, p4) {
  var t1 = -3 * p1 + 9 * p2 - 9 * p3 + 3 * p4,
    t2 = t * t1 + 6 * p1 - 12 * p2 + 6 * p3;
  return t * t2 - 3 * p1 + 3 * p2;
}

function cacheKey() {
  var args = new Array(arguments.length);
  for (var i = 0; i < args.length; ++i) {
    args[i] = arguments[i];
  }
  i = args.length;
  var hash = '';
  while (i--) {
    hash += (args[i] === Object(args[i])) ?
      JSON.stringify(args[i]) : args[i];
  }
  return hash;
}

module.exports = p5.Font;

},{"../core/constants":41,"../core/core":42}],78:[function(_dereq_,module,exports){
/**
 * @module Data
 * @submodule Array Functions
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');

/**
 * Adds a value to the end of an array. Extends the length of
 * the array by one. Maps to Array.push().
 *
 * @method append
 * @param {Array} array Array to append
 * @param {any} value to be added to the Array
 * @example
 * <div class = "norender"><code>
 * function setup() {
 *
 * var myArray = new Array("Mango", "Apple", "Papaya")
 * print(myArray) // ["Mango", "Apple", "Papaya"]
 *
 * append(myArray, "Peach")
 * print(myArray) // ["Mango", "Apple", "Papaya", "Peach"]
 *
 * }
 * </div></code>
 */
p5.prototype.append = function(array, value) {
  array.push(value);
  return array;
};

/**
 * Copies an array (or part of an array) to another array. The src array is
 * copied to the dst array, beginning at the position specified by
 * srcPosition and into the position specified by dstPosition. The number of
 * elements to copy is determined by length. Note that copying values
 * overwrites existing values in the destination array. To append values
 * instead of overwriting them, use concat().
 * <br><br>
 * The simplified version with only two arguments, arrayCopy(src, dst),
 * copies an entire array to another of the same size. It is equivalent to
 * arrayCopy(src, 0, dst, 0, src.length).
 * <br><br>
 * Using this function is far more efficient for copying array data than
 * iterating through a for() loop and copying each element individually.
 *
 * @method arrayCopy
 * @param {Array}  src           the source Array
 * @param {Number} [srcPosition] starting position in the source Array
 * @param {Array}  dst           the destination Array
 * @param {Number} [dstPosition] starting position in the destination Array
 * @param {Number} [length]      number of Array elements to be copied
 *
 * @example
 *  <div class="norender"><code>
 *  function setup() {
 *
 *    var src = new Array("A", "B", "C");
 *    var dst = new Array( 1 ,  2 ,  3 );
 *    var srcPosition = 1;
 *    var dstPosition = 0;
 *    var length = 2;
 *
 *    print(src); // ["A", "B", "C"]
 *    print(dst); // [ 1 ,  2 ,  3 ]
 *
 *    arrayCopy(src, srcPosition, dst, dstPosition, length);
 *    print(dst); // ["B", "C", 3]
 *
 *    }
 *  </div></code>
 */
p5.prototype.arrayCopy = function(
  src,
  srcPosition,
  dst,
  dstPosition,
  length) {

  // the index to begin splicing from dst array
  var start,
      end;

  if (typeof length !== 'undefined') {

    end = Math.min(length, src.length);
    start = dstPosition;
    src = src.slice(srcPosition, end + srcPosition);

  } else {

    if (typeof dst !== 'undefined') { // src, dst, length
      // rename  so we don't get confused
      end = dst;
      end = Math.min(end, src.length);
    } else { // src, dst
      end = src.length;
    }

    start = 0;
    // rename  so we don't get confused
    dst = srcPosition;
    src = src.slice(0, end);
  }

  // Since we are not returning the array and JavaScript is pass by reference
  // we must modify the actual values of the array
  // instead of reassigning arrays
  Array.prototype.splice.apply(dst, [start, end].concat(src));

};

/**
 * Concatenates two arrays, maps to Array.concat(). Does not modify the
 * input arrays.
 *
 * @method concat
 * @param {Array} a first Array to concatenate
 * @param {Array} b second Array to concatenate
 * @return {Array} concatenated array
 *
 * @example
 * <div class = "norender"><code>
 * function setup() {
 *   var arr1 = new Array("A", "B", "C");
 *   var arr2 = new Array( 1 ,  2 ,  3 );
 *
 *   print(arr1); // ["A","B","C"]
 *   print(arr2); // [1,2,3]
 *
 *   var arr3 = concat(arr1, arr2);
 *
 *   print(arr1); // ["A","B","C"]
 *   print(arr2); // [1,2,3]
 *   print(arr3); // ["A","B","C",1,2,3]
 *
 * }
 * </div></code>
 */
p5.prototype.concat = function(list0, list1) {
  return list0.concat(list1);
};

/**
 * Reverses the order of an array, maps to Array.reverse()
 *
 * @method reverse
 * @param {Array} list Array to reverse
 * @example
 * <div class="norender"><code>
 * function setup() {
 *   var myArray = new Array("A", "B", "C");
 *   print(myArray); // ["A","B","C"]
 *
 *   reverse(myArray);
 *   print(myArray); // ["C","B","A"]
 * }
 * </div></code>
 */
p5.prototype.reverse = function(list) {
  return list.reverse();
};

/**
 * Decreases an array by one element and returns the shortened array,
 * maps to Array.pop().
 *
 * @method shorten
 * @param  {Array} list Array to shorten
 * @return {Array} shortened Array
 * @example
 * <div class = "norender"><code>
 * function setup() {
 *   var myArray = new Array("A", "B", "C");
 *   print(myArray); // ["A","B","C"]
 *
 *   var newArray = shorten(myArray);
 *   print(myArray); // ["A","B","C"]
 *   print(newArray); // ["A","B"]
 * }
 * </div></code>
 */
p5.prototype.shorten = function(list) {
  list.pop();
  return list;
};

/**
 * Randomizes the order of the elements of an array. Implements
 * <a href="http://Bost.Ocks.org/mike/shuffle/" target=_blank>
 * Fisher-Yates Shuffle Algorithm</a>.
 *
 * @method shuffle
 * @param  {Array}   array  Array to shuffle
 * @param  {Boolean} [bool] modify passed array
 * @return {Array}   shuffled Array
 * @example
 * <div><code>
 * function setup() {
 *   var regularArr = ['ABC', 'def', createVector(), TAU, Math.E];
 *   print(regularArr);
 *   shuffle(regularArr, true); // force modifications to passed array
 *   print(regularArr);
 *
 *   // By default shuffle() returns a shuffled cloned array:
 *   var newArr = shuffle(regularArr);
 *   print(regularArr);
 *   print(newArr);
 * }
 * </code></div>
 */
p5.prototype.shuffle = function(arr, bool) {
  var isView = ArrayBuffer && ArrayBuffer.isView && ArrayBuffer.isView(arr);
  arr = bool || isView ? arr : arr.slice();

  var rnd, tmp, idx = arr.length;
  while (idx > 1) {
    rnd = Math.random()*idx | 0;

    tmp = arr[--idx];
    arr[idx] = arr[rnd];
    arr[rnd] = tmp;
  }

  return arr;
};

/**
 * Sorts an array of numbers from smallest to largest, or puts an array of
 * words in alphabetical order. The original array is not modified; a
 * re-ordered array is returned. The count parameter states the number of
 * elements to sort. For example, if there are 12 elements in an array and
 * count is set to 5, only the first 5 elements in the array will be sorted.
 *
 * @method sort
 * @param {Array} list Array to sort
 * @param {Number} [count] number of elements to sort, starting from 0
 *
 * @example
 * <div class = "norender"><code>
 * function setup() {
 *   var words = new Array("banana", "apple", "pear","lime");
 *   print(words); // ["banana", "apple", "pear", "lime"]
 *   var count = 4; // length of array
 *
 *   words = sort(words, count);
 *   print(words); // ["apple", "banana", "lime", "pear"]
 * }
 * </div></code>
 * <div class = "norender"><code>
 * function setup() {
 *   var numbers = new Array(2,6,1,5,14,9,8,12);
 *   print(numbers); // [2,6,1,5,14,9,8,12]
 *   var count = 5; // Less than the length of the array
 *
 *   numbers = sort(numbers, count);
 *   print(numbers); // [1,2,5,6,14,9,8,12]
 * }
 * </div></code>
 */
p5.prototype.sort = function(list, count) {
  var arr = count ? list.slice(0, Math.min(count, list.length)) : list;
  var rest = count ? list.slice(Math.min(count, list.length)) : [];
  if (typeof arr[0] === 'string') {
    arr = arr.sort();
  } else {
    arr = arr.sort(function(a,b){return a-b;});
  }
  return arr.concat(rest);
};

/**
 * Inserts a value or an array of values into an existing array. The first
 * parameter specifies the initial array to be modified, and the second
 * parameter defines the data to be inserted. The third parameter is an index
 * value which specifies the array position from which to insert data.
 * (Remember that array index numbering starts at zero, so the first position
 * is 0, the second position is 1, and so on.)
 *
 * @method splice
 * @param {Array}  list Array to splice into
 * @param {any}    value value to be spliced in
 * @param {Number} position in the array from which to insert data
 *
 * @example
 * <div class = "norender"><code>
 * function setup() {
 *   var myArray = new Array(0,1,2,3,4);
 *   var insArray = new Array("A","B","C");
 *   print(myArray); // [0,1,2,3,4]
 *   print(insArray); // ["A","B","C"]
 *
 *   splice(myArray, insArray, 3);
 *   print(myArray); // [0,1,2,"A","B","C",3,4]
 * }
 * </div></code>
 */
p5.prototype.splice = function(list, value, index) {

  // note that splice returns spliced elements and not an array
  Array.prototype.splice.apply(list, [index, 0].concat(value));

  return list;
};

/**
 * Extracts an array of elements from an existing array. The list parameter
 * defines the array from which the elements will be copied, and the start
 * and count parameters specify which elements to extract. If no count is
 * given, elements will be extracted from the start to the end of the array.
 * When specifying the start, remember that the first array element is 0.
 * This function does not change the source array.
 *
 * @method subset
 * @param  {Array}  list    Array to extract from
 * @param  {Number} start   position to begin
 * @param  {Number} [count] number of values to extract
 * @return {Array}          Array of extracted elements
 *
 * @example
 * <div class = "norender"><code>
 * function setup() {
 *   var myArray = new Array(1,2,3,4,5);
 *   print(myArray); // [1,2,3,4,5]
 *
 *   var sub1 = subset(myArray, 0, 3);
 *   var sub2 = subset(myArray, 2, 2);
 *   print(sub1); // [1,2,3]
 *   print(sub2); // [3,4]
 * }
 * </div></code>
 */
p5.prototype.subset = function(list, start, count) {
  if (typeof count !== 'undefined') {
    return list.slice(start, start + count);
  } else {
    return list.slice(start, list.length);
  }
};

module.exports = p5;

},{"../core/core":42}],79:[function(_dereq_,module,exports){
/**
 * @module Data
 * @submodule Conversion
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');

/**
 * Converts a string to its floating point representation. The contents of a
 * string must resemble a number, or NaN (not a number) will be returned.
 * For example, float("1234.56") evaluates to 1234.56, but float("giraffe")
 * will return NaN.
 *
 * When an array of values is passed in, then an array of floats of the same
 * length is returned.
 *
 * @method float
 * @param {String}  str float string to parse
 * @return {Number}     floating point representation of string
 * @example
 * <div><code>
 * var str = '20';
 * var diameter = float(str);
 * ellipse(width/2, height/2, diameter, diameter);
 * </code></div>
 *
 * @alt
 * 20 by 20 white ellipse in the center of the canvas
 *
 */
p5.prototype.float = function(str) {
  if (str instanceof Array) {
    return str.map(parseFloat);
  }
  return parseFloat(str);
};

/**
 * Converts a boolean, string, or float to its integer representation.
 * When an array of values is passed in, then an int array of the same length
 * is returned.
 *
 * @method int
 * @param {String|Boolean|Number|Array} n value to parse
 * @return {Number}                     integer representation of value
 * @example
 * <div class='norender'><code>
 * print(int("10")); // 10
 * print(int(10.31)); // 10
 * print(int(-10)); // -10
 * print(int(true)); // 1
 * print(int(false)); // 0
 * print(int([false, true, "10.3", 9.8])); // [0, 1, 10, 9]
 * </code></div>
 */
p5.prototype.int = function(n, radix) {
  radix = radix || 10;
  if (typeof n === 'string') {
    return parseInt(n, radix);
  } else if (typeof n === 'number') {
    return n | 0;
  } else if (typeof n === 'boolean') {
    return n ? 1 : 0;
  } else if (n instanceof Array) {
    return n.map(function(n) { return p5.prototype.int(n, radix); });
  }
};

/**
 * Converts a boolean, string or number to its string representation.
 * When an array of values is passed in, then an array of strings of the same
 * length is returned.
 *
 * @method str
 * @param {String|Boolean|Number|Array} n value to parse
 * @return {String}                     string representation of value
 * @example
 * <div class='norender'><code>
 * print(str("10"));  // "10"
 * print(str(10.31)); // "10.31"
 * print(str(-10));   // "-10"
 * print(str(true));  // "true"
 * print(str(false)); // "false"
 * print(str([true, "10.3", 9.8])); // [ "true", "10.3", "9.8" ]
 * </code></div>
 */
p5.prototype.str = function(n) {
  if (n instanceof Array) {
    return n.map(p5.prototype.str);
  } else {
    return String(n);
  }
};

/**
 * Converts a number or string to its boolean representation.
 * For a number, any non-zero value (positive or negative) evaluates to true,
 * while zero evaluates to false. For a string, the value "true" evaluates to
 * true, while any other value evaluates to false. When an array of number or
 * string values is passed in, then a array of booleans of the same length is
 * returned.
 *
 * @method boolean
 * @param {String|Boolean|Number|Array} n value to parse
 * @return {Boolean}                    boolean representation of value
 * @example
 * <div class='norender'><code>
 * print(boolean(0));               // false
 * print(boolean(1));               // true
 * print(boolean("true"));          // true
 * print(boolean("abcd"));          // false
 * print(boolean([0, 12, "true"])); // [false, true, false]
 * </code></div>
 */
p5.prototype.boolean = function(n) {
  if (typeof n === 'number') {
    return n !== 0;
  } else if (typeof n === 'string') {
    return n.toLowerCase() === 'true';
  } else if (typeof n === 'boolean') {
    return n;
  } else if (n instanceof Array) {
    return n.map(p5.prototype.boolean);
  }
};

/**
 * Converts a number, string or boolean to its byte representation.
 * A byte can be only a whole number between -128 and 127, so when a value
 * outside of this range is converted, it wraps around to the corresponding
 * byte representation. When an array of number, string or boolean values is
 * passed in, then an array of bytes the same length is returned.
 *
 * @method byte
 * @param {String|Boolean|Number|Array} n value to parse
 * @return {Number}                     byte representation of value
 * @example
 * <div class='norender'><code>
 * print(byte(127));               // 127
 * print(byte(128));               // -128
 * print(byte(23.4));              // 23
 * print(byte("23.4"));            // 23
 * print(byte(true));              // 1
 * print(byte([0, 255, "100"]));   // [0, -1, 100]
 * </code></div>
 */
p5.prototype.byte = function(n) {
  var nn = p5.prototype.int(n, 10);
  if (typeof nn === 'number') {
    return ((nn + 128) % 256) - 128;
  } else if (nn instanceof Array) {
    return nn.map(p5.prototype.byte);
  }
};

/**
 * Converts a number or string to its corresponding single-character
 * string representation. If a string parameter is provided, it is first
 * parsed as an integer and then translated into a single-character string.
 * When an array of number or string values is passed in, then an array of
 * single-character strings of the same length is returned.
 *
 * @method char
 * @param {String|Number|Array} n value to parse
 * @return {String}             string representation of value
 * @example
 * <div class='norender'><code>
 * print(char(65));                     // "A"
 * print(char("65"));                   // "A"
 * print(char([65, 66, 67]));           // [ "A", "B", "C" ]
 * print(join(char([65, 66, 67]), '')); // "ABC"
 * </code></div>
 */
p5.prototype.char = function(n) {
  if (typeof n === 'number' && !isNaN(n)) {
    return String.fromCharCode(n);
  } else if (n instanceof Array) {
    return n.map(p5.prototype.char);
  } else if (typeof n === 'string') {
    return p5.prototype.char(parseInt(n, 10));
  }
};

/**
 * Converts a single-character string to its corresponding integer
 * representation. When an array of single-character string values is passed
 * in, then an array of integers of the same length is returned.
 *
 * @method unchar
 * @param {String|Array} n value to parse
 * @return {Number}      integer representation of value
 * @example
 * <div class='norender'><code>
 * print(unchar("A"));               // 65
 * print(unchar(["A", "B", "C"]));   // [ 65, 66, 67 ]
 * print(unchar(split("ABC", "")));  // [ 65, 66, 67 ]
 * </code></div>
 */
p5.prototype.unchar = function(n) {
  if (typeof n === 'string' && n.length === 1) {
    return n.charCodeAt(0);
  } else if (n instanceof Array) {
    return n.map(p5.prototype.unchar);
  }
};

/**
 * Converts a number to a string in its equivalent hexadecimal notation. If a
 * second parameter is passed, it is used to set the number of characters to
 * generate in the hexadecimal notation. When an array is passed in, an
 * array of strings in hexadecimal notation of the same length is returned.
 *
 * @method hex
 * @param {Number|Array} n value to parse
 * @return {String}      hexadecimal string representation of value
 * @example
 * <div class='norender'><code>
 * print(hex(255));               // "000000FF"
 * print(hex(255, 6));            // "0000FF"
 * print(hex([0, 127, 255], 6));  // [ "000000", "00007F", "0000FF" ]
 * </code></div>
 */
p5.prototype.hex = function(n, digits) {
  digits = (digits === undefined || digits === null) ? digits = 8 : digits;
  if (n instanceof Array) {
    return n.map(function(n) { return p5.prototype.hex(n, digits); });
  } else if (typeof n === 'number') {
    if (n < 0) {
      n = 0xFFFFFFFF + n + 1;
    }
    var hex = Number(n).toString(16).toUpperCase();
    while (hex.length < digits) {
      hex = '0' + hex;
    }
    if (hex.length >= digits) {
      hex = hex.substring(hex.length - digits, hex.length);
    }
    return hex;
  }
};

/**
 * Converts a string representation of a hexadecimal number to its equivalent
 * integer value. When an array of strings in hexadecimal notation is passed
 * in, an array of integers of the same length is returned.
 *
 * @method unhex
 * @param {String|Array} n value to parse
 * @return {Number}      integer representation of hexadecimal value
 * @example
 * <div class='norender'><code>
 * print(unhex("A"));                // 10
 * print(unhex("FF"));               // 255
 * print(unhex(["FF", "AA", "00"])); // [ 255, 170, 0 ]
 * </code></div>
 */
p5.prototype.unhex = function(n) {
  if (n instanceof Array) {
    return n.map(p5.prototype.unhex);
  } else {
    return parseInt('0x' + n, 16);
  }
};

module.exports = p5;

},{"../core/core":42}],80:[function(_dereq_,module,exports){
/**
 * @module Data
 * @submodule String Functions
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');

//return p5; //LM is this a mistake?

/**
 * Combines an array of Strings into one String, each separated by the
 * character(s) used for the separator parameter. To join arrays of ints or
 * floats, it's necessary to first convert them to Strings using nf() or
 * nfs().
 *
 * @method join
 * @param  {Array}  list      array of Strings to be joined
 * @param  {String} separator String to be placed between each item
 * @return {String}           joined String
 * @example
 * <div>
 * <code>
 * var array = ["Hello", "world!"]
 * var separator = " "
 * var message = join(array, separator);
 * text(message, 5, 50);
 * </code>
 * </div>
 *
 * @alt
 * "hello world!" displayed middle left of canvas.
 *
 */
p5.prototype.join = function(list, separator) {
  return list.join(separator);
};

/**
 * This function is used to apply a regular expression to a piece of text,
 * and return matching groups (elements found inside parentheses) as a
 * String array. If there are no matches, a null value will be returned.
 * If no groups are specified in the regular expression, but the sequence
 * matches, an array of length 1 (with the matched text as the first element
 * of the array) will be returned.
 * <br><br>
 * To use the function, first check to see if the result is null. If the
 * result is null, then the sequence did not match at all. If the sequence
 * did match, an array is returned.
 * <br><br>
 * If there are groups (specified by sets of parentheses) in the regular
 * expression, then the contents of each will be returned in the array.
 * Element [0] of a regular expression match returns the entire matching
 * string, and the match groups start at element [1] (the first group is [1],
 * the second [2], and so on).
 *
 * @method match
 * @param  {String} str    the String to be searched
 * @param  {String} regexp the regexp to be used for matching
 * @return {Array}         Array of Strings found
 * @example
 * <div>
 * <code>
 * var string = "Hello p5js*!"
 * var regexp = "p5js\\*"
 * var match = match(string, regexp);
 * text(match, 5, 50);
 * </code>
 * </div>
 *
 * @alt
 * "p5js*" displayed middle left of canvas.
 *
 */
p5.prototype.match =  function(str, reg) {
  return str.match(reg);
};

/**
 * This function is used to apply a regular expression to a piece of text,
 * and return a list of matching groups (elements found inside parentheses)
 * as a two-dimensional String array. If there are no matches, a null value
 * will be returned. If no groups are specified in the regular expression,
 * but the sequence matches, a two dimensional array is still returned, but
 * the second dimension is only of length one.
 * <br><br>
 * To use the function, first check to see if the result is null. If the
 * result is null, then the sequence did not match at all. If the sequence
 * did match, a 2D array is returned.
 * <br><br>
 * If there are groups (specified by sets of parentheses) in the regular
 * expression, then the contents of each will be returned in the array.
 * Assuming a loop with counter variable i, element [i][0] of a regular
 * expression match returns the entire matching string, and the match groups
 * start at element [i][1] (the first group is [i][1], the second [i][2],
 * and so on).
 *
 * @method matchAll
 * @param  {String} str    the String to be searched
 * @param  {String} regexp the regexp to be used for matching
 * @return {Array}         2d Array of Strings found
 * @example
 * <div class="norender">
 * <code>
 * var string = "Hello p5js*! Hello world!"
 * var regexp = "Hello"
 * matchAll(string, regexp);
 * </code>
 * </div>

 */
p5.prototype.matchAll = function(str, reg) {
  var re = new RegExp(reg, 'g');
  var match = re.exec(str);
  var matches = [];
  while (match !== null) {
    matches.push(match);
    // matched text: match[0]
    // match start: match.index
    // capturing group n: match[n]
    match = re.exec(str);
  }
  return matches;
};

/**
 * Utility function for formatting numbers into strings. There are two
 * versions: one for formatting floats, and one for formatting ints.
 * The values for the digits, left, and right parameters should always
 * be positive integers.
 *
 * @method nf
 * @param {Number|Array} num      the Number to format
 * @param {Number}       [left]   number of digits to the left of the
 *                                decimal point
 * @param {Number}       [right]  number of digits to the right of the
 *                                decimal point
 * @return {String|Array}         formatted String
 * @example
 * <div>
 * <code>
 * function setup() {
 *   background(200);
 *   var num = 112.53106115;
 *
 *   noStroke();
 *   fill(0);
 *   textSize(14);
 *   // Draw formatted numbers
 *   text(nf(num, 5, 2), 10, 20);
 *
 *   text(nf(num, 4, 3), 10, 55);
 *
 *   text(nf(num, 3, 6), 10, 85);
 *
 *   // Draw dividing lines
 *   stroke(120);
 *   line(0, 30, width, 30);
 *   line(0, 65, width, 65);
 * }
 * </code>
 * </div>
 *
 * @alt
 * "0011253" top left, "0112.531" mid left, "112.531061" bottom left canvas
 *
 */
p5.prototype.nf = function () {
  if (arguments[0] instanceof Array) {
    var a = arguments[1];
    var b = arguments[2];
    return arguments[0].map(function (x) {
      return doNf(x, a, b);
    });
  }
  else{
    var typeOfFirst = Object.prototype.toString.call(arguments[0]);
    if(typeOfFirst === '[object Arguments]'){
      if(arguments[0].length===3){
        return this.nf(arguments[0][0],arguments[0][1],arguments[0][2]);
      }
      else if(arguments[0].length===2){
        return this.nf(arguments[0][0],arguments[0][1]);
      }
      else{
        return this.nf(arguments[0][0]);
      }
    }
    else {
      return doNf.apply(this, arguments);
    }
  }
};

function doNf() {
  var num = arguments[0];
  var neg = num < 0;
  var n = neg ? num.toString().substring(1) : num.toString();
  var decimalInd = n.indexOf('.');
  var intPart = decimalInd !== -1 ? n.substring(0, decimalInd) : n;
  var decPart = decimalInd !== -1 ? n.substring(decimalInd + 1) : '';
  var str = neg ? '-' : '';
  if (arguments.length === 3) {
    var decimal = '';
    if(decimalInd !== -1 || arguments[2] - decPart.length > 0){
      decimal = '.';
    }
    if (decPart.length > arguments[2]) {
      decPart = decPart.substring(0, arguments[2]);
    }
    for (var i = 0; i < arguments[1] - intPart.length; i++) {
      str += '0';
    }
    str += intPart;
    str += decimal;
    str += decPart;
    for (var j = 0; j < arguments[2] - decPart.length; j++) {
      str += '0';
    }
    return str;
  }
  else {
    for (var k = 0; k < Math.max(arguments[1] - intPart.length, 0); k++) {
      str += '0';
    }
    str += n;
    return str;
  }
}

/**
 * Utility function for formatting numbers into strings and placing
 * appropriate commas to mark units of 1000. There are two versions: one
 * for formatting ints, and one for formatting an array of ints. The value
 * for the right parameter should always be a positive integer.
 *
 * @method nfc
 * @param  {Number|Array}   num     the Number to format
 * @param  {Number}         [right] number of digits to the right of the
 *                                  decimal point
 * @return {String|Array}           formatted String
 * @example
 * <div>
 * <code>
 * function setup() {
 *   background(200);
 *   var num = 11253106.115;
 *   var numArr = new Array(1,1,2);
 *
 *   noStroke();
 *   fill(0);
 *   textSize(12);
 *
 *   // Draw formatted numbers
 *   text(nfc(num, 4, 2), 10, 30);
 *   text(nfc(numArr, 2, 1), 10, 80);
 *
 *   // Draw dividing line
 *   stroke(120);
 *   line(0, 50, width, 50);
 * }
 * </code>
 * </div>
 *
 * @alt
 * "11,253,106.115" top middle and "1.00,1.00,2.00" displayed bottom mid
 *
 */
p5.prototype.nfc = function () {
  if (arguments[0] instanceof Array) {
    var a = arguments[1];
    return arguments[0].map(function (x) {
      return doNfc(x, a);
    });
  } else {
    return doNfc.apply(this, arguments);
  }
};
function doNfc() {
  var num = arguments[0].toString();
  var dec = num.indexOf('.');
  var rem = dec !== -1 ? num.substring(dec) : '';
  var n = dec !== -1 ? num.substring(0, dec) : num;
  n = n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  if (arguments[1] === 0) {
    rem = '';
  }
  else if(arguments[1] !== undefined){
    if(arguments[1] > rem.length){
      rem+= dec === -1 ? '.' : '';
      var len = arguments[1] - rem.length + 1;
      for(var i =0; i< len; i++){
        rem += '0';
      }
    }
    else{
      rem = rem.substring(0, arguments[1] + 1);
    }
  }
  return n + rem;
}

/**
 * Utility function for formatting numbers into strings. Similar to nf() but
 * puts a "+" in front of positive numbers and a "-" in front of negative
 * numbers. There are two versions: one for formatting floats, and one for
 * formatting ints. The values for left, and right parameters
 * should always be positive integers.
 *
 * @method nfp
 * @param {Number|Array} num      the Number to format
 * @param {Number}       [left]   number of digits to the left of the decimal
 *                                point
 * @param {Number}       [right]  number of digits to the right of the
 *                                decimal point
 * @return {String|Array}         formatted String
 * @example
 * <div>
 * <code>
 * function setup() {
 *   background(200);
 *   var num1 = 11253106.115;
 *   var num2 = -11253106.115;
 *
 *   noStroke();
 *   fill(0);
 *   textSize(12);
 *
 *   // Draw formatted numbers
 *   text(nfp(num1, 4, 2), 10, 30);
 *   text(nfp(num2, 4, 2), 10, 80);
 *
 *   // Draw dividing line
 *   stroke(120);
 *   line(0, 50, width, 50);
 * }
 * </code>
 * </div>
 *
 * @alt
 * "+11253106.11" top middle and "-11253106.11" displayed bottom middle
 *
 */
p5.prototype.nfp = function() {
  var nfRes = this.nf.apply(this, arguments);
  if (nfRes instanceof Array) {
    return nfRes.map(addNfp);
  } else {
    return addNfp(nfRes);
  }
};

function addNfp() {
  return (
    parseFloat(arguments[0]) > 0) ?
    '+'+arguments[0].toString() :
    arguments[0].toString();
}

/**
 * Utility function for formatting numbers into strings. Similar to nf() but
 * puts a " " (space) in front of positive numbers and a "-" in front of
 * negative numbers. There are two versions: one for formatting floats, and
 * one for formatting ints. The values for the digits, left, and right
 * parameters should always be positive integers.
 *
 * @method nfs
 * @param {Number|Array} num      the Number to format
 * @param {Number}       [left]   number of digits to the left of the decimal
 *                                point
 * @param {Number}       [right]  number of digits to the right of the
 *                                decimal point
 * @return {String|Array}         formatted String
 * @example
 * <div>
 * <code>
 * function setup() {
 *   background(200);
 *   var num1 = 11253106.115;
 *   var num2 = -11253106.115;
 *
 *   noStroke();
 *   fill(0);
 *   textSize(12);
 *   // Draw formatted numbers
 *   text(nfs(num1, 4, 2), 10, 30);
 *
 *   text(nfs(num2, 4, 2), 10, 80);
 *
 *   // Draw dividing line
 *   stroke(120);
 *   line(0, 50, width, 50);
 * }
 * </code>
 * </div>
 *
 * @alt
 * "11253106.11" top middle and "-11253106.11" displayed bottom middle
 *
 */
p5.prototype.nfs = function() {
  var nfRes = this.nf.apply(this, arguments);
  if (nfRes instanceof Array) {
    return nfRes.map(addNfs);
  } else {
    return addNfs(nfRes);
  }
};

function addNfs() {
  return (
    parseFloat(arguments[0]) > 0) ?
    ' '+arguments[0].toString() :
    arguments[0].toString();
}

/**
 * The split() function maps to String.split(), it breaks a String into
 * pieces using a character or string as the delimiter. The delim parameter
 * specifies the character or characters that mark the boundaries between
 * each piece. A String[] array is returned that contains each of the pieces.
 *
 * The splitTokens() function works in a similar fashion, except that it
 * splits using a range of characters instead of a specific character or
 * sequence.
 *
 * @method split
 * @param  {String} value the String to be split
 * @param  {String} delim the String used to separate the data
 * @return {Array}  Array of Strings
 * @example
 * <div>
 * <code>
 * var names = "Pat,Xio,Alex"
 * var splitString = split(names, ",");
 * text(splitString[0], 5, 30);
 * text(splitString[1], 5, 50);
 * text(splitString[2], 5, 70);
 * </code>
 * </div>
 *
 * @alt
 * "pat" top left, "Xio" mid left and "Alex" displayed bottom left
 *
 */
p5.prototype.split = function(str, delim) {
  return str.split(delim);
};

/**
 * The splitTokens() function splits a String at one or many character
 * delimiters or "tokens." The delim parameter specifies the character or
 * characters to be used as a boundary.
 * <br><br>
 * If no delim characters are specified, any whitespace character is used to
 * split. Whitespace characters include tab (\t), line feed (\n), carriage
 * return (\r), form feed (\f), and space.
 *
 * @method splitTokens
 * @param  {String} value   the String to be split
 * @param  {String} [delim] list of individual Strings that will be used as
 *                          separators
 * @return {Array}          Array of Strings
 * @example
 * <div class = "norender">
 * <code>
 * function setup() {
 *   var myStr = "Mango, Banana, Lime";
 *   var myStrArr = splitTokens(myStr, ",");
 *
 *   print(myStrArr); // prints : ["Mango"," Banana"," Lime"]
 * }
 * </code>
 * </div>
 */
p5.prototype.splitTokens = function() {
  var d,sqo,sqc,str;
  str = arguments[1];
  if (arguments.length > 1) {
    sqc = /\]/g.exec(str);
    sqo = /\[/g.exec(str);
    if ( sqo && sqc ) {
      str = str.slice(0, sqc.index) + str.slice(sqc.index+1);
      sqo = /\[/g.exec(str);
      str = str.slice(0, sqo.index) + str.slice(sqo.index+1);
      d = new RegExp('[\\['+str+'\\]]','g');
    } else if ( sqc ) {
      str = str.slice(0, sqc.index) + str.slice(sqc.index+1);
      d = new RegExp('[' + str + '\\]]', 'g');
    } else if(sqo) {
      str = str.slice(0, sqo.index) + str.slice(sqo.index+1);
      d = new RegExp('[' + str + '\\[]', 'g');
    } else {
      d = new RegExp('[' + str + ']', 'g');
    }
  } else {
    d = /\s/g;
  }
  return arguments[0].split(d).filter(function(n){return n;});
};

/**
 * Removes whitespace characters from the beginning and end of a String. In
 * addition to standard whitespace characters such as space, carriage return,
 * and tab, this function also removes the Unicode "nbsp" character.
 *
 * @method trim
 * @param  {String|Array} str a String or Array of Strings to be trimmed
 * @return {String|Array}       a trimmed String or Array of Strings
 * @example
 * <div>
 * <code>
 * var string = trim("  No new lines\n   ");
 * text(string +" here", 2, 50);
 * </code>
 * </div>
 *
 * @alt
 * "No new lines here" displayed center canvas
 *
 */
p5.prototype.trim = function(str) {
  if (str instanceof Array) {
    return str.map(this.trim);
  } else {
    return str.trim();
  }
};

module.exports = p5;

},{"../core/core":42}],81:[function(_dereq_,module,exports){
/**
 * @module IO
 * @submodule Time & Date
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');

/**
 * p5.js communicates with the clock on your computer. The day() function
 * returns the current day as a value from 1 - 31.
 *
 * @method day
 * @return {Number} the current day
 * @example
 * <div>
 * <code>
 * var d = day();
 * text("Current day: \n" + d, 5, 50);
 * </code>
 * </div>
 *
 * @alt
 * Current day is displayed
 *
 */
p5.prototype.day = function() {
  return new Date().getDate();
};

/**
 * p5.js communicates with the clock on your computer. The hour() function
 * returns the current hour as a value from 0 - 23.
 *
 * @method hour
 * @return {Number} the current hour
 * @example
 * <div>
 * <code>
 * var h = hour();
 * text("Current hour:\n" + h, 5, 50);
 * </code>
 * </div>
 *
 * @alt
 * Current hour is displayed
 *
 */
p5.prototype.hour = function() {
  return new Date().getHours();
};

/**
 * p5.js communicates with the clock on your computer. The minute() function
 * returns the current minute as a value from 0 - 59.
 *
 * @method minute
 * @return {Number} the current minute
 * @example
 * <div>
 * <code>
 * var m = minute();
 * text("Current minute: \n" + m, 5, 50);
 * </code>
 * </div>
 *
 * @alt
 * Current minute is displayed
 *
 */
p5.prototype.minute = function() {
  return new Date().getMinutes();
};

/**
 * Returns the number of milliseconds (thousandths of a second) since
 * starting the program. This information is often used for timing events and
 * animation sequences.
 *
 * @method millis
 * @return {Number} the number of milliseconds since starting the program
 * @example
 * <div>
 * <code>
 * var millisecond = millis();
 * text("Milliseconds \nrunning: \n" + millisecond, 5, 40);
 * </code>
 * </div>
 *
 * @alt
 * number of milliseconds since program has started displayed
 *
 */
p5.prototype.millis = function() {
  return window.performance.now();
};

/**
 * p5.js communicates with the clock on your computer. The month() function
 * returns the current month as a value from 1 - 12.
 *
 * @method month
 * @return {Number} the current month
 * @example
 * <div>
 * <code>
 * var m = month();
 * text("Current month: \n" + m, 5, 50);
 * </code>
 * </div>
 *
 * @alt
 * Current month is displayed
 *
 */
p5.prototype.month = function() {
  return new Date().getMonth() + 1; //January is 0!
};

/**
 * p5.js communicates with the clock on your computer. The second() function
 * returns the current second as a value from 0 - 59.
 *
 * @method second
 * @return {Number} the current second
 * @example
 * <div>
 * <code>
 * var s = second();
 * text("Current second: \n" + s, 5, 50);
 * </code>
 * </div>
 *
 * @alt
 * Current second is displayed
 *
 */
p5.prototype.second = function() {
  return new Date().getSeconds();
};

/**
 * p5.js communicates with the clock on your computer. The year() function
 * returns the current year as an integer (2014, 2015, 2016, etc).
 *
 * @method year
 * @return {Number} the current year
 * @example
 * <div>
 * <code>
 * var y = year();
 * text("Current year: \n" + y, 5, 50);
 * </code>
 * </div>
 *
 * @alt
 * Current year is displayed
 *
 */
p5.prototype.year = function() {
  return new Date().getFullYear();
};

module.exports = p5;

},{"../core/core":42}],82:[function(_dereq_,module,exports){
/**
 * @module Lights, Camera
 * @submodule Camera
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');

/**
 * Sets camera position
 * @method camera
 * @param  {Number} x  camera position value on x axis
 * @param  {Number} y  camera position value on y axis
 * @param  {Number} z  camera position value on z axis
 * @return {p5}        the p5 object
 * @example
 * <div>
 * <code>
 * function setup(){
 *   createCanvas(100, 100, WEBGL);
 * }
 * function draw(){
 *  //move the camera away from the plane by a sin wave
 *  camera(0, 0, sin(frameCount * 0.01) * 100);
 *  plane(120, 120);
 * }
 * </code>
 * </div>
 *
 * @alt
 * blue square shrinks in size grows to fill canvas. disappears then loops.
 *
 */
p5.prototype.camera = function(x, y, z){
  //what it manipulates is the model view matrix
  this._renderer.translate(-x, -y, -z);
};

/**
 * Sets perspective camera
 * @method  perspective
 * @param  {Number} fovy   camera frustum vertical field of view,
 *                         from bottom to top of view, in degrees
 * @param  {Number} aspect camera frustum aspect ratio
 * @param  {Number} near   frustum near plane length
 * @param  {Number} far    frustum far plane length
 * @return {p5}            the p5 object
 * @example
 * <div>
 * <code>
 * //drag mouse to toggle the world!
 * //you will see there's a vanish point
 * function setup(){
 *   createCanvas(100, 100, WEBGL);
 *   var fov = 60 / 180 * PI;
 *   var cameraZ = (height/2.0) / tan(fov/2.0);
 *   perspective(60 / 180 * PI, width/height, cameraZ * 0.1, cameraZ * 10);
 * }
 * function draw(){
 *  background(200);
 *  orbitControl();
 *  for(var i = -1; i < 2; i++){
 *     for(var j = -2; j < 3; j++){
 *       push();
 *       translate(i*160, 0, j*160);
 *       box(40, 40, 40);
 *       pop();
 *     }
 *   }
 * }
 * </code>
 * </div>
 *
 * @alt
 * colored 3d boxes toggleable with mouse position
 *
 */
p5.prototype.perspective = function(fovy,aspect,near,far) {
  fovy = fovy || (60 / 180 * this.PI);
  aspect = aspect || (this.width/this.height);
  near = near || ((this.height/2.0) / this.tan(fovy/2.0) * 0.1);
  far = far || ((this.height/2.0) / this.tan(fovy/2.0) * 10);
  this._renderer.uPMatrix = p5.Matrix.identity();
  this._renderer.uPMatrix.perspective(fovy,aspect,near,far);
  this._renderer._curCamera = 'custom';
};

/**
 * Setup ortho camera
 * @method  ortho
 * @param  {Number} left   camera frustum left plane
 * @param  {Number} right  camera frustum right plane
 * @param  {Number} bottom camera frustum bottom plane
 * @param  {Number} top    camera frustum top plane
 * @param  {Number} near   camera frustum near plane
 * @param  {Number} far    camera frustum far plane
 * @return {p5}            the p5 object
 * @example
 * <div>
 * <code>
 * //drag mouse to toggle the world!
 * //there's no vanish point
 * function setup(){
 *   createCanvas(100, 100, WEBGL);
 *   ortho(-width/2, width/2, height/2, -height/2, 0, 500);
 * }
 * function draw(){
 *  background(200);
 *  orbitControl();
 *  for(var i = -1; i < 2; i++){
 *     for(var j = -2; j < 3; j++){
 *       push();
 *       translate(i*160, 0, j*160);
 *       box(40, 40, 40);
 *       pop();
 *     }
 *   }
 * }
 * </code>
 * </div>
 *
 * @alt
 * 3 3d boxes, reveal several more boxes on 3d plane when mouse used to toggle
 *
 */
p5.prototype.ortho = function(left,right,bottom,top,near,far) {
  left = left || (-this.width/2);
  right = right || (this.width/2);
  bottom = bottom || (-this.height/2);
  top = top || (this.height/2);
  near = near || 0;
  far = far || Math.max(this.width, this.height);
  this._renderer.uPMatrix = p5.Matrix.identity();
  this._renderer.uPMatrix.ortho(left,right,bottom,top,near,far);
  this._renderer._curCamera = 'custom';
};

module.exports = p5;

},{"../core/core":42}],83:[function(_dereq_,module,exports){
'use strict';

var p5 = _dereq_('../core/core');

//@TODO: implement full orbit controls including
//pan, zoom, quaternion rotation, etc.
p5.prototype.orbitControl = function(){
  if(this.mouseIsPressed){
    this.rotateY((this.mouseX - this.width / 2) / (this.width / 2));
    this.rotateX((this.mouseY - this.height / 2) / (this.width / 2));
  }
  return this;
};

module.exports = p5;
},{"../core/core":42}],84:[function(_dereq_,module,exports){
/**
 * @module Lights, Camera
 * @submodule Lights
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');

/**
 * Creates an ambient light with a color
 * @method  ambientLight
 * @param  {Number|Array|String|p5.Color} v1  gray value,
 * red or hue value (depending on the current color mode),
 * or color Array, or CSS color string
 * @param  {Number}            [v2] optional: green or saturation value
 * @param  {Number}            [v3] optional: blue or brightness value
 * @param  {Number}            [a]  optional: opacity
 * @return {p5}                the p5 object
 * @example
 * <div>
 * <code>
 * function setup(){
 *   createCanvas(100, 100, WEBGL);
 * }
 * function draw(){
 *   background(0);
 *   ambientLight(150);
 *   ambientMaterial(250);
 *   sphere(50);
 * }
 * </code>
 * </div>
 *
 * @alt
 * nothing displayed
 *
 */
p5.prototype.ambientLight = function(v1, v2, v3, a){
  var gl = this._renderer.GL;
  var shaderProgram = this._renderer._getShader(
    'lightVert', 'lightTextureFrag');

  gl.useProgram(shaderProgram);
  shaderProgram.uAmbientColor = gl.getUniformLocation(
    shaderProgram,
    'uAmbientColor[' + this._renderer.ambientLightCount + ']');

  var color = this._renderer._pInst.color.apply(
    this._renderer._pInst, arguments);
  var colors = color._array;

  gl.uniform3f( shaderProgram.uAmbientColor,
    colors[0], colors[1], colors[2]);

  //in case there's no material color for the geometry
  shaderProgram.uMaterialColor = gl.getUniformLocation(
    shaderProgram, 'uMaterialColor' );
  gl.uniform4f( shaderProgram.uMaterialColor, 1, 1, 1, 1);

  this._renderer.ambientLightCount ++;
  shaderProgram.uAmbientLightCount =
    gl.getUniformLocation(shaderProgram, 'uAmbientLightCount');
  gl.uniform1i(shaderProgram.uAmbientLightCount,
    this._renderer.ambientLightCount);

  return this;
};

/**
 * Creates a directional light with a color and a direction
 * @method  directionalLight
 * @param  {Number|Array|String|p5.Color} v1   gray value,
 * red or hue value (depending on the current color mode),
 * or color Array, or CSS color string
 * @param  {Number}          [v2] optional: green or saturation value
 * @param  {Number}          [v3] optional: blue or brightness value
 * @param  {Number}          [a]  optional: opacity
 * @param  {Number|p5.Vector} x   x axis direction or a p5.Vector
 * @param  {Number}          [y]  optional: y axis direction
 * @param  {Number}          [z]  optional: z axis direction
 * @return {p5}              the p5 object
 * @example
 * <div>
 * <code>
 * function setup(){
 *   createCanvas(100, 100, WEBGL);
 * }
 * function draw(){
 *   background(0);
 *   //move your mouse to change light direction
 *   var dirX = (mouseX / width - 0.5) *2;
 *   var dirY = (mouseY / height - 0.5) *(-2);
 *   directionalLight(250, 250, 250, dirX, dirY, 0.25);
 *   ambientMaterial(250);
 *   sphere(50);
 * }
 * </code>
 * </div>
 *
 * @alt
 * light source on canvas changeable with mouse position
 *
 */
p5.prototype.directionalLight = function(v1, v2, v3, a, x, y, z) {
  var gl = this._renderer.GL;
  var shaderProgram = this._renderer._getShader(
    'lightVert', 'lightTextureFrag');

  gl.useProgram(shaderProgram);
  shaderProgram.uDirectionalColor = gl.getUniformLocation(
    shaderProgram,
    'uDirectionalColor[' + this._renderer.directionalLightCount + ']');

  //@TODO: check parameters number
  var color = this._renderer._pInst.color.apply(
    this._renderer._pInst, [v1, v2, v3]);
  var colors = color._array;

  gl.uniform3f( shaderProgram.uDirectionalColor,
    colors[0], colors[1], colors[2]);

  var _x, _y, _z;

  var args = new Array(arguments.length);
  for (var i = 0; i < args.length; ++i) {
    args[i] = arguments[i];
  }
  if(typeof args[args.length-1] === 'number'){
    _x = args[args.length-3];
    _y = args[args.length-2];
    _z = args[args.length-1];

  }else{
    try{
      _x = args[args.length-1].x;
      _y = args[args.length-1].y;
      _z = args[args.length-1].z;
    }
    catch(error){
      throw error;
    }
  }

  shaderProgram.uLightingDirection = gl.getUniformLocation(
    shaderProgram,
    'uLightingDirection[' + this._renderer.directionalLightCount + ']');
  gl.uniform3f( shaderProgram.uLightingDirection, _x, _y, _z);

  //in case there's no material color for the geometry
  shaderProgram.uMaterialColor = gl.getUniformLocation(
    shaderProgram, 'uMaterialColor' );
  gl.uniform4f( shaderProgram.uMaterialColor, 1, 1, 1, 1);

  this._renderer.directionalLightCount ++;
  shaderProgram.uDirectionalLightCount =
    gl.getUniformLocation(shaderProgram, 'uDirectionalLightCount');
  gl.uniform1i(shaderProgram.uDirectionalLightCount,
    this._renderer.directionalLightCount);

  return this;
};

/**
 * Creates a point light with a color and a light position
 * @method  pointLight
 * @param  {Number|Array|String|p5.Color} v1   gray value,
 * red or hue value (depending on the current color mode),
 * or color Array, or CSS color string
 * @param  {Number}          [v2] optional: green or saturation value
 * @param  {Number}          [v3] optional: blue or brightness value
 * @param  {Number}          [a]  optional: opacity
 * @param  {Number|p5.Vector} x   x axis position or a p5.Vector
 * @param  {Number}          [y]  optional: y axis position
 * @param  {Number}          [z]  optional: z axis position
 * @return {p5}              the p5 object
 * @example
 * <div>
 * <code>
 * function setup(){
 *   createCanvas(100, 100, WEBGL);
 * }
 * function draw(){
 *   background(0);
 *   //move your mouse to change light position
 *   var locY = (mouseY / height - 0.5) *(-2);
 *   var locX = (mouseX / width - 0.5) *2;
 *   //to set the light position,
 *   //think of the world's coordinate as:
 *   // -1,1 -------- 1,1
 *   //   |            |
 *   //   |            |
 *   //   |            |
 *   // -1,-1---------1,-1
 *   pointLight(250, 250, 250, locX, locY, 0);
 *   ambientMaterial(250);
 *   sphere(50);
 * }
 * </code>
 * </div>
 *
 * @alt
 * spot light on canvas changes position with mouse
 *
 */
p5.prototype.pointLight = function(v1, v2, v3, a, x, y, z) {
  var gl = this._renderer.GL;
  var shaderProgram = this._renderer._getShader(
    'lightVert', 'lightTextureFrag');

  gl.useProgram(shaderProgram);
  shaderProgram.uPointLightColor = gl.getUniformLocation(
    shaderProgram,
    'uPointLightColor[' + this._renderer.pointLightCount + ']');

  //@TODO: check parameters number
  var color = this._renderer._pInst.color.apply(
    this._renderer._pInst, [v1, v2, v3]);
  var colors = color._array;

  gl.uniform3f( shaderProgram.uPointLightColor,
    colors[0], colors[1], colors[2]);

  var _x, _y, _z;

  var args = new Array(arguments.length);
  for (var i = 0; i < args.length; ++i) {
    args[i] = arguments[i];
  }
  if(typeof args[args.length-1] === 'number'){
    _x = args[args.length-3];
    _y = args[args.length-2];
    _z = args[args.length-1];

  }else{
    try{
      _x = args[args.length-1].x;
      _y = args[args.length-1].y;
      _z = args[args.length-1].z;
    }
    catch(error){
      throw error;
    }
  }

  shaderProgram.uPointLightLocation = gl.getUniformLocation(
    shaderProgram,
    'uPointLightLocation[' + this._renderer.pointLightCount + ']');
  gl.uniform3f( shaderProgram.uPointLightLocation, _x, _y, _z);

  //in case there's no material color for the geometry
  shaderProgram.uMaterialColor = gl.getUniformLocation(
    shaderProgram, 'uMaterialColor' );
  gl.uniform4f( shaderProgram.uMaterialColor, 1, 1, 1, 1);

  this._renderer.pointLightCount ++;
  shaderProgram.uPointLightCount =
    gl.getUniformLocation(shaderProgram, 'uPointLightCount');
  gl.uniform1i(shaderProgram.uPointLightCount,
    this._renderer.pointLightCount);

  return this;
};

module.exports = p5;

},{"../core/core":42}],85:[function(_dereq_,module,exports){
/**
 * @module Shape
 * @submodule 3D Models
 * @for p5
 * @requires core
 * @requires p5.Geometry3D
 */

'use strict';

var p5 = _dereq_('../core/core');
_dereq_('./p5.Geometry');

/**
 * Load a 3d model from an OBJ file.
 * <br><br>
 * One of the limitations of the OBJ format is that it doesn't have a built-in
 * sense of scale. This means that models exported from different programs might
 * be very different sizes. If your model isn't displaying, try calling
 * loadModel() with the normalized parameter set to true. This will resize the
 * model to a scale appropriate for p5. You can also make additional changes to
 * the final size of your model with the scale() function.
 *
 * @method loadModel
 * @param  {String} path Path of the model to be loaded
 * @param  {Boolean} [normalize] If true, scale the model to a
 *                                standardized size when loading
 * @param  {Function(p5.Geometry3D)} [successCallback] Function to be called
 *                                   once the model is loaded. Will be passed
 *                                   the 3D model object.
 * @param  {Function(Event)}    [failureCallback] called with event error if
 *                                the image fails to load.
 * @return {p5.Geometry} the p5.Geometry3D object
 * @example
 * <div>
 * <code>
 * //draw a spinning teapot
 * var teapot;
 *
 * function setup(){
 *   createCanvas(100, 100, WEBGL);
 *
 *   teapot = loadModel('assets/teapot.obj');
 * }
 *
 * function draw(){
 *   background(200);
 *   rotateX(frameCount * 0.01);
 *   rotateY(frameCount * 0.01);
 *   model(teapot);
 * }
 * </code>
 * </div>
 *
 * @alt
 * Vertically rotating 3-d teapot with red, green and blue gradient.
 *
 */
p5.prototype.loadModel = function () {
  var path = arguments[0];
  var normalize;
  var successCallback;
  var failureCallback;
  if(typeof arguments[1] === 'boolean') {
    normalize = arguments[1];
    successCallback = arguments[2];
    failureCallback = arguments[3];
  } else {
    normalize = false;
    successCallback = arguments[1];
    failureCallback = arguments[2];
  }

  var model = new p5.Geometry();
  model.gid = path + '|' + normalize;
  this.loadStrings(path, function(strings) {
    parseObj(model, strings);

    if (normalize) {
      model.normalize();
    }

    if (typeof successCallback === 'function') {
      successCallback(model);
    }
  }.bind(this), failureCallback);

  return model;
};

/**
 * Parse OBJ lines into model. For reference, this is what a simple model of a
 * square might look like:
 *
 * v -0.5 -0.5 0.5
 * v -0.5 -0.5 -0.5
 * v -0.5 0.5 -0.5
 * v -0.5 0.5 0.5
 *
 * f 4 3 2 1
 */
function parseObj( model, lines ) {
  // OBJ allows a face to specify an index for a vertex (in the above example),
  // but it also allows you to specify a custom combination of vertex, UV
  // coordinate, and vertex normal. So, "3/4/3" would mean, "use vertex 3 with
  // UV coordinate 4 and vertex normal 3". In WebGL, every vertex with different
  // parameters must be a different vertex, so loadedVerts is used to
  // temporarily store the parsed vertices, normals, etc., and indexedVerts is
  // used to map a specific combination (keyed on, for example, the string
  // "3/4/3"), to the actual index of the newly created vertex in the final
  // object.
  var loadedVerts = {'v' : [],
                    'vt' : [],
                    'vn' : []};
  var indexedVerts = {};

  for (var line = 0; line < lines.length; ++line) {
    // Each line is a separate object (vertex, face, vertex normal, etc)
    // For each line, split it into tokens on whitespace. The first token
    // describes the type.
    var tokens = lines[line].trim().split(/\b\s+/);

    if (tokens.length > 0) {
      if (tokens[0] === 'v' || tokens[0] === 'vn') {
        // Check if this line describes a vertex or vertex normal.
        // It will have three numeric parameters.
        var vertex = new p5.Vector(parseFloat(tokens[1]),
                                   parseFloat(tokens[2]),
                                   parseFloat(tokens[3]));
        loadedVerts[tokens[0]].push(vertex);
      } else if (tokens[0] === 'vt') {
        // Check if this line describes a texture coordinate.
        // It will have two numeric parameters.
        var texVertex = [parseFloat(tokens[1]), parseFloat(tokens[2])];
        loadedVerts[tokens[0]].push(texVertex);
      } else if (tokens[0] === 'f') {
        // Check if this line describes a face.
        // OBJ faces can have more than three points. Triangulate points.
        for (var tri = 3; tri < tokens.length; ++tri) {
          var face = [];

          var vertexTokens = [1, tri - 1, tri];

          for (var tokenInd = 0; tokenInd < vertexTokens.length; ++tokenInd) {
            // Now, convert the given token into an index
            var vertString = tokens[vertexTokens[tokenInd]];
            var vertIndex = 0;

            // TODO: Faces can technically use negative numbers to refer to the
            // previous nth vertex. I haven't seen this used in practice, but
            // it might be good to implement this in the future.

            if (indexedVerts[vertString] !== undefined) {
              vertIndex = indexedVerts[vertString];
            } else {
              var vertParts = vertString.split('/');
              for (var i = 0; i < vertParts.length; i++) {
                vertParts[i] = parseInt(vertParts[i]) - 1;
              }

              vertIndex = indexedVerts[vertString] = model.vertices.length;
              model.vertices.push(loadedVerts.v[vertParts[0]].copy());
              if (loadedVerts.vt[vertParts[1]]) {
                model.uvs.push(loadedVerts.vt[vertParts[1]].slice());
              } else {
                model.uvs.push([0, 0]);
              }

              if (loadedVerts.vn[vertParts[2]]) {
                model.vertexNormals.push(loadedVerts.vn[vertParts[2]].copy());
              }
            }

            face.push(vertIndex);
          }

          model.faces.push(face);
        }
      }
    }
  }

  // If the model doesn't have normals, compute the normals
  if(model.vertexNormals.length === 0) {
    model.computeNormals();
  }

  return model;
}

/**
 * Render a 3d model to the screen.
 *
 * @method model
 * @param  {p5.Geometry} model Loaded 3d model to be rendered
 * @example
 * <div>
 * <code>
 * //draw a spinning teapot
 * var teapot;
 *
 * function setup(){
 *   createCanvas(100, 100, WEBGL);
 *
 *   teapot = loadModel('assets/teapot.obj');
 * }
 *
 * function draw(){
 *   background(200);
 *   rotateX(frameCount * 0.01);
 *   rotateY(frameCount * 0.01);
 *   model(teapot);
 * }
 * </code>
 * </div>
 *
 * @alt
 * Vertically rotating 3-d teapot with red, green and blue gradient.
 *
 */
p5.prototype.model = function ( model ) {
  if (model.vertices.length > 0) {
    if (!this._renderer.geometryInHash(model.gid)) {
      this._renderer.createBuffers(model.gid, model);
    }

    this._renderer.drawBuffers(model.gid);
  }
};

module.exports = p5;

},{"../core/core":42,"./p5.Geometry":87}],86:[function(_dereq_,module,exports){
/**
 * @module Lights, Camera
 * @submodule Material
 * @for p5
 * @requires core
 */

'use strict';

var p5 = _dereq_('../core/core');
//require('./p5.Texture');

/**
 * Normal material for geometry. You can view all
 * possible materials in this
 * <a href="https://p5js.org/examples/3d-materials.html">example</a>.
 * @method normalMaterial
 * @return {p5}                the p5 object
 * @example
 * <div>
 * <code>
 * function setup(){
 *   createCanvas(100, 100, WEBGL);
 * }
 *
 * function draw(){
 *  background(200);
 *  normalMaterial();
 *  sphere(50);
 * }
 * </code>
 * </div>
 *
 * @alt
 * Red, green and blue gradient.
 *
 */
p5.prototype.normalMaterial = function(){
  this._renderer._getShader('normalVert', 'normalFrag');
  return this;
};

/**
 * Texture for geometry.  You can view other possible materials in this
 * <a href="https://p5js.org/examples/3d-materials.html">example</a>.
 * @method texture
 * @param {p5.Image | p5.MediaElement | p5.Graphics} tex 2-dimensional graphics
 *                    to render as texture
 * @return {p5}                the p5 object
 * @example
 * <div>
 * <code>
 * var img;
 * function setup(){
 *   createCanvas(100, 100, WEBGL);
 *   img = loadImage("assets/laDefense.jpg");
 * }
 *
 * function draw(){
 *   background(0);
 *   rotateZ(frameCount * 0.01);
 *   rotateX(frameCount * 0.01);
 *   rotateY(frameCount * 0.01);
 *   //pass image as texture
 *   texture(img);
 *   box(200, 200, 200);
 * }
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * var pg;
 * function setup(){
 *   createCanvas(100, 100, WEBGL);
 *   pg = createGraphics(200, 200);
 *   pg.textSize(100);
 * }
 *
 * function draw(){
 *   background(0);
 *   pg.background(255);
 *   pg.text('hello!', 0, 100);
 *   //pass image as texture
 *   texture(pg);
 *   plane(200);
 * }
 * </code>
 * </div>
 *
 * <div>
 * <code>
 * var vid;
 * function preload(){
 *   vid = createVideo("assets/fingers.mov");
 *   vid.hide();
 *   vid.loop();
 * }
 * function setup(){
 *   createCanvas(100, 100, WEBGL);
 * }
 *
 * function draw(){
 *   background(0);
 *   //pass video frame as texture
 *   texture(vid);
 *   plane(200);
 * }
 * </code>
 * </div>
 *
 * @alt
 * Rotating view of many images umbrella and grid roof on a 3d plane
 * black canvas
 * black canvas
 *
 */
p5.prototype.texture = function(){
  var args = new Array(arguments.length);
  for (var i = 0; i < args.length; ++i) {
    args[i] = arguments[i];
  }
  var gl = this._renderer.GL;
  this._renderer.drawMode = 'texture';
  var shaderProgram = this._renderer._getShader('lightVert',
    'lightTextureFrag');
  gl.useProgram(shaderProgram);
  var textureData;
  //if argument is not already a texture
  //create a new one
  if(!args[0].isTexture){
    if (args[0] instanceof p5.Image) {
      textureData = args[0].canvas;
    }
    //if param is a video
    else if (typeof p5.MediaElement !== 'undefined' &&
            args[0] instanceof p5.MediaElement){
      if(!args[0].loadedmetadata) {return;}
      textureData = args[0].elt;
    }
    //used with offscreen 2d graphics renderer
    else if(args[0] instanceof p5.Graphics){
      textureData = args[0].elt;
    }
    var tex = gl.createTexture();
    args[0]._setProperty('tex', tex);
    args[0]._setProperty('isTexture', true);
    this._renderer._bind.call(this, tex, textureData);
  }
  else {
    if(args[0] instanceof p5.Graphics ||
      (typeof p5.MediaElement !== 'undefined' &&
      args[0] instanceof p5.MediaElement)){
      textureData = args[0].elt;
    }
    else if(args[0] instanceof p5.Image){
      textureData = args[0].canvas;
    }
    this._renderer._bind.call(this, args[0].tex, textureData);
  }
  //this is where we'd activate multi textures
  //eg. gl.activeTexture(gl.TEXTURE0 + (unit || 0));
  //but for now we just have a single texture.
  //@TODO need to extend this functionality
  gl.activeTexture(gl.TEXTURE0);
  gl.bindTexture(gl.TEXTURE_2D, args[0].tex);
  gl.uniform1i(gl.getUniformLocation(shaderProgram, 'isTexture'), true);
  gl.uniform1i(gl.getUniformLocation(shaderProgram, 'uSampler'), 0);
  return this;
};

/**
 * Texture Util functions
 */
p5.RendererGL.prototype._bind = function(tex, data){
  var gl = this._renderer.GL;
  gl.bindTexture(gl.TEXTURE_2D, tex);
  gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
  gl.texImage2D(gl.TEXTURE_2D, 0,
    gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, data);
  gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
  gl.texParameteri(gl.TEXTURE_2D,
  gl.TEXTURE_MAG_FILTER, gl.LINEAR);
  gl.texParameteri(gl.TEXTURE_2D,
  gl.TEXTURE_MIN_FILTER, gl.LINEAR);
  gl.texParameteri(gl.TEXTURE_2D,
  gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_2D,
  gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
  gl.bindTexture(gl.TEXTURE_2D, null);
};

/**
 * Checks whether val is a pot
 * more info on power of 2 here:
 * https://www.opengl.org/wiki/NPOT_Texture
 * @param  {Number}  value
 * @return {Boolean}
 */
// function _isPowerOf2 (value){
//   return (value & (value - 1)) === 0;
// }

/**
 * returns the next highest power of 2 value
 * @param  {Number} value [description]
 * @return {Number}       [description]
 */
// function _nextHighestPOT (value){
//   --value;
//   for (var i = 1; i < 32; i <<= 1) {
//     value = value | value >> i;
//   }
//   return value + 1;

/**
 * Ambient material for geometry with a given color. You can view all
 * possible materials in this
 * <a href="https://p5js.org/examples/3d-materials.html">example</a>.
 * @method  ambientMaterial
 * @param  {Number|Array|String|p5.Color} v1  gray value,
 * red or hue value (depending on the current color mode),
 * or color Array, or CSS color string
 * @param  {Number}            [v2] optional: green or saturation value
 * @param  {Number}            [v3] optional: blue or brightness value
 * @param  {Number}            [a]  optional: opacity
* @return {p5}                 the p5 object
 * @example
 * <div>
 * <code>
 * function setup(){
 *   createCanvas(100, 100, WEBGL);
 * }
 * function draw(){
 *  background(0);
 *  ambientLight(100);
 *  pointLight(250, 250, 250, 100, 100, 0);
 *  ambientMaterial(250);
 *  sphere(50);
 * }
 * </code>
 * </div>
 *
 * @alt
 * radiating light source from top right of canvas
 *
 */
p5.prototype.ambientMaterial = function(v1, v2, v3, a) {
  var gl = this._renderer.GL;
  var shaderProgram =
    this._renderer._getShader('lightVert', 'lightTextureFrag');

  gl.useProgram(shaderProgram);
  shaderProgram.uMaterialColor = gl.getUniformLocation(
    shaderProgram, 'uMaterialColor' );
  var colors = this._renderer._applyColorBlend.apply(this._renderer, arguments);

  gl.uniform4f(shaderProgram.uMaterialColor,
    colors[0], colors[1], colors[2], colors[3]);

  shaderProgram.uSpecular = gl.getUniformLocation(
    shaderProgram, 'uSpecular' );
  gl.uniform1i(shaderProgram.uSpecular, false);

  gl.uniform1i(gl.getUniformLocation(shaderProgram, 'isTexture'), false);

  return this;
};

/**
 * Specular material for geometry with a given color. You can view all
 * possible materials in this
 * <a href="https://p5js.org/examples/3d-materials.html">example</a>.
 * @method specularMaterial
 * @param  {Number|Array|String|p5.Color} v1  gray value,
 * red or hue value (depending on the current color mode),
 * or color Array, or CSS color string
 * @param  {Number}            [v2] optional: green or saturation value
 * @param  {Number}            [v3] optional: blue or brightness value
 * @param  {Number}            [a]  optional: opacity
 * @return {p5}                the p5 object
 * @example
 * <div>
 * <code>
 * function setup(){
 *   createCanvas(100, 100, WEBGL);
 * }
 * function draw(){
 *  background(0);
 *  ambientLight(100);
 *  pointLight(250, 250, 250, 100, 100, 0);
 *  specularMaterial(250);
 *  sphere(50);
 * }
 * </code>
 * </div>
 *
 * @alt
 * diffused radiating light source from top right of canvas
 *
 */
p5.prototype.specularMaterial = function(v1, v2, v3, a) {
  var gl = this._renderer.GL;
  var shaderProgram =
    this._renderer._getShader('lightVert', 'lightTextureFrag');
  gl.useProgram(shaderProgram);
  gl.uniform1i(gl.getUniformLocation(shaderProgram, 'isTexture'), false);
  shaderProgram.uMaterialColor = gl.getUniformLocation(
    shaderProgram, 'uMaterialColor' );
  var colors = this._renderer._applyColorBlend.apply(this._renderer, arguments);
  gl.uniform4f(shaderProgram.uMaterialColor,
    colors[0], colors[1], colors[2], colors[3]);
  shaderProgram.uSpecular = gl.getUniformLocation(
    shaderProgram, 'uSpecular' );
  gl.uniform1i(shaderProgram.uSpecular, true);

  return this;
};

/**
 * @private blends colors according to color components.
 * If alpha value is less than 1, we need to enable blending
 * on our gl context.  Otherwise opaque objects need to a depthMask.
 * @param  {Number} v1 [description]
 * @param  {Number} v2 [description]
 * @param  {Number} v3 [description]
 * @param  {Number} a  [description]
 * @return {[Number]}  Normalized numbers array
 */
p5.RendererGL.prototype._applyColorBlend = function(v1,v2,v3,a){
  var gl = this.GL;
  var color = this._pInst.color.apply(
    this._pInst, arguments);
  var colors = color._array;
  if(colors[colors.length-1] < 1.0){
    gl.depthMask(false);
    gl.enable(gl.BLEND);
    gl.blendEquation( gl.FUNC_ADD );
    gl.blendFunc( gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA );
  } else {
    gl.depthMask(true);
    gl.disable(gl.BLEND);
  }
  return colors;
};

module.exports = p5;

},{"../core/core":42}],87:[function(_dereq_,module,exports){
//some of the functions are adjusted from Three.js(http://threejs.org)

'use strict';

var p5 = _dereq_('../core/core');

/**
 * p5 Geometry class
 * @constructor
 * @param  {Function | Object} vertData callback function or Object
 *                     containing routine(s) for vertex data generation
 * @param  {Number} [detailX] number of vertices on horizontal surface
 * @param  {Number} [detailY] number of vertices on horizontal surface
 * @param {Function} [callback] function to call upon object instantiation.
 *
 */
p5.Geometry = function
(detailX, detailY, callback){
  //an array containing every vertex
  //@type [p5.Vector]
  this.vertices = [];
  //an array containing 1 normal per vertex
  //@type [p5.Vector]
  //[p5.Vector, p5.Vector, p5.Vector,p5.Vector, p5.Vector, p5.Vector,...]
  this.vertexNormals = [];
  //an array containing each three vertex indices that form a face
  //[[0, 1, 2], [2, 1, 3], ...]
  this.faces = [];
  //a 2D array containing uvs for every vertex
  //[[0.0,0.0],[1.0,0.0], ...]
  this.uvs = [];
  this.detailX = (detailX !== undefined) ? detailX: 1;
  this.detailY = (detailY !== undefined) ? detailY: 1;
  if(callback instanceof Function){
    callback.call(this);
  }
  return this;
};

p5.Geometry.prototype.computeFaces = function(){
  var sliceCount = this.detailX + 1;
  var a, b, c, d;
  for (var i = 0; i < this.detailY; i++){
    for (var j = 0; j < this.detailX; j++){
      a = i * sliceCount + j;// + offset;
      b = i * sliceCount + j + 1;// + offset;
      c = (i + 1)* sliceCount + j + 1;// + offset;
      d = (i + 1)* sliceCount + j;// + offset;
      this.faces.push([a, b, d]);
      this.faces.push([d, b, c]);
    }
  }
  return this;
};

p5.Geometry.prototype._getFaceNormal = function(faceId,vertId){
  //This assumes that vA->vB->vC is a counter-clockwise ordering
  var face = this.faces[faceId];
  var vA = this.vertices[face[vertId%3]];
  var vB = this.vertices[face[(vertId+1)%3]];
  var vC = this.vertices[face[(vertId+2)%3]];
  var n = p5.Vector.cross(
    p5.Vector.sub(vB,vA),
    p5.Vector.sub(vC,vA));
  var sinAlpha = p5.Vector.mag(n) /
  (p5.Vector.mag(p5.Vector.sub(vB,vA))*
    p5.Vector.mag(p5.Vector.sub(vC,vA)));
  n = n.normalize();
  return n.mult(Math.asin(sinAlpha));
};
/**
 * computes smooth normals per vertex as an average of each
 * face.
 */
p5.Geometry.prototype.computeNormals = function (){
  for(var v=0; v < this.vertices.length; v++){
    var normal = new p5.Vector();
    for(var i=0; i < this.faces.length; i++){
      //if our face contains a given vertex
      //calculate an average of the normals
      //of the triangles adjacent to that vertex
      if(this.faces[i][0] === v ||
        this.faces[i][1] === v ||
        this.faces[i][2] === v)
      {
        normal = normal.add(this._getFaceNormal(i, v));
      }
    }
    normal = normal.normalize();
    this.vertexNormals.push(normal);
  }
  return this;
};

/**
 * Averages the vertex normals. Used in curved
 * surfaces
 * @return {p5.Geometry}
 */
p5.Geometry.prototype.averageNormals = function() {

  for(var i = 0; i <= this.detailY; i++){
    var offset = this.detailX + 1;
    var temp = p5.Vector
      .add(this.vertexNormals[i*offset],
        this.vertexNormals[i*offset + this.detailX]);
    temp = p5.Vector.div(temp, 2);
    this.vertexNormals[i*offset] = temp;
    this.vertexNormals[i*offset + this.detailX] = temp;
  }
  return this;
};

/**
 * Averages pole normals.  Used in spherical primitives
 * @return {p5.Geometry}
 */
p5.Geometry.prototype.averagePoleNormals = function() {

  //average the north pole
  var sum = new p5.Vector(0, 0, 0);
  for(var i = 0; i < this.detailX; i++){
    sum.add(this.vertexNormals[i]);
  }
  sum = p5.Vector.div(sum, this.detailX);

  for(i = 0; i < this.detailX; i++){
    this.vertexNormals[i] = sum;
  }

  //average the south pole
  sum = new p5.Vector(0, 0, 0);
  for(i = this.vertices.length - 1;
    i > this.vertices.length - 1 - this.detailX; i--){
    sum.add(this.vertexNormals[i]);
  }
  sum = p5.Vector.div(sum, this.detailX);

  for(i = this.vertices.length - 1;
    i > this.vertices.length - 1 - this.detailX; i--){
    this.vertexNormals[i] = sum;
  }
  return this;
};

/**
 * Modifies all vertices to be centered within the range -100 to 100.
 * @return {p5.Geometry}
 */
p5.Geometry.prototype.normalize = function() {
  if(this.vertices.length > 0) {
    // Find the corners of our bounding box
    var maxPosition = this.vertices[0].copy();
    var minPosition = this.vertices[0].copy();

    for(var i = 0; i < this.vertices.length; i++) {
      maxPosition.x = Math.max(maxPosition.x, this.vertices[i].x);
      minPosition.x = Math.min(minPosition.x, this.vertices[i].x);
      maxPosition.y = Math.max(maxPosition.y, this.vertices[i].y);
      minPosition.y = Math.min(minPosition.y, this.vertices[i].y);
      maxPosition.z = Math.max(maxPosition.z, this.vertices[i].z);
      minPosition.z = Math.min(minPosition.z, this.vertices[i].z);
    }

    var center = p5.Vector.lerp(maxPosition, minPosition, 0.5);
    var dist = p5.Vector.sub(maxPosition, minPosition);
    var longestDist = Math.max(Math.max(dist.x, dist.y), dist.z);
    var scale = 200 / longestDist;

    for(i = 0; i < this.vertices.length; i++) {
      this.vertices[i].sub(center);
      this.vertices[i].mult(scale);
    }
  }
  return this;
};

module.exports = p5.Geometry;

},{"../core/core":42}],88:[function(_dereq_,module,exports){
/**
* @requires constants
* @todo see methods below needing further implementation.
* future consideration: implement SIMD optimizations
* when browser compatibility becomes available
* https://developer.mozilla.org/en-US/docs/Web/JavaScript/
*   Reference/Global_Objects/SIMD
*/

'use strict';

var p5 = _dereq_('../core/core');
var polarGeometry = _dereq_('../math/polargeometry');
var constants = _dereq_('../core/constants');
var GLMAT_ARRAY_TYPE = (
    typeof Float32Array !== 'undefined') ?
  Float32Array : Array;

/**
 * A class to describe a 4x4 matrix
 * for model and view matrix manipulation in the p5js webgl renderer.
 * class p5.Matrix
 * @constructor
 * @param {Array} [mat4] array literal of our 4x4 matrix
 */
p5.Matrix = function() {
  var args = new Array(arguments.length);
  for (var i = 0; i < args.length; ++i) {
    args[i] = arguments[i];
  }
  // This is default behavior when object
  // instantiated using createMatrix()
  // @todo implement createMatrix() in core/math.js
  if(args[0] instanceof p5) {
    // save reference to p5 if passed in
    this.p5 = args[0];
    if(args[1] === 'mat3'){
      this.mat3 = args[2] || new GLMAT_ARRAY_TYPE([
        1, 0, 0,
        0, 1, 0,
        0, 0, 1
      ]);
    }
    else {
      this.mat4  = args[1] || new GLMAT_ARRAY_TYPE([
        1, 0, 0, 0,
        0, 1, 0, 0,
        0, 0, 1, 0,
        0, 0, 0, 1
      ]);
    }
    // default behavior when object
    // instantiated using new p5.Matrix()
  } else {
    if(args[0] === 'mat3'){
      this.mat3 = args[1] || new GLMAT_ARRAY_TYPE([
        1, 0, 0,
        0, 1, 0,
        0, 0, 1
      ]);
    }
    else {
      this.mat4 = args[0] || new GLMAT_ARRAY_TYPE([
        1, 0, 0, 0,
        0, 1, 0, 0,
        0, 0, 1, 0,
        0, 0, 0, 1
      ]);
    }
  }
  return this;
};

/**
 * Sets the x, y, and z component of the vector using two or three separate
 * variables, the data from a p5.Matrix, or the values from a float array.
 *
 * @param {p5.Matrix|Array} [inMatrix] the input p5.Matrix or
 *                                     an Array of length 16
 */
p5.Matrix.prototype.set = function (inMatrix) {
  if (inMatrix instanceof p5.Matrix) {
    this.mat4 = inMatrix.mat4;
    return this;
  }
  else if (inMatrix instanceof GLMAT_ARRAY_TYPE) {
    this.mat4 = inMatrix;
    return this;
  }
  return this;
};

/**
 * Gets a copy of the vector, returns a p5.Matrix object.
 *
 * @return {p5.Matrix} the copy of the p5.Matrix object
 */
p5.Matrix.prototype.get = function () {
  return new p5.Matrix(this.mat4);
};

/**
 * return a copy of a matrix
 * @return {p5.Matrix}   the result matrix
 */
p5.Matrix.prototype.copy = function(){
  var copied = new p5.Matrix();
  copied.mat4[0] = this.mat4[0];
  copied.mat4[1] = this.mat4[1];
  copied.mat4[2] = this.mat4[2];
  copied.mat4[3] = this.mat4[3];
  copied.mat4[4] = this.mat4[4];
  copied.mat4[5] = this.mat4[5];
  copied.mat4[6] = this.mat4[6];
  copied.mat4[7] = this.mat4[7];
  copied.mat4[8] = this.mat4[8];
  copied.mat4[9] = this.mat4[9];
  copied.mat4[10] = this.mat4[10];
  copied.mat4[11] = this.mat4[11];
  copied.mat4[12] = this.mat4[12];
  copied.mat4[13] = this.mat4[13];
  copied.mat4[14] = this.mat4[14];
  copied.mat4[15] = this.mat4[15];
  return copied;
};

/**
 * return an identity matrix
 * @return {p5.Matrix}   the result matrix
 */
p5.Matrix.identity = function(){
  return new p5.Matrix();
};

/**
 * transpose according to a given matrix
 * @param  {p5.Matrix | Typed Array} a  the matrix to be based on to transpose
 * @return {p5.Matrix}                  this
 */
p5.Matrix.prototype.transpose = function(a){
  var a01, a02, a03, a12, a13, a23;
  if(a instanceof p5.Matrix){
    a01 = a.mat4[1];
    a02 = a.mat4[2];
    a03 = a.mat4[3];
    a12 = a.mat4[6];
    a13 = a.mat4[7];
    a23 = a.mat4[11];

    this.mat4[0] = a.mat4[0];
    this.mat4[1] = a.mat4[4];
    this.mat4[2] = a.mat4[8];
    this.mat4[3] = a.mat4[12];
    this.mat4[4] = a01;
    this.mat4[5] = a.mat4[5];
    this.mat4[6] = a.mat4[9];
    this.mat4[7] = a.mat4[13];
    this.mat4[8] = a02;
    this.mat4[9] = a12;
    this.mat4[10] = a.mat4[10];
    this.mat4[11] = a.mat4[14];
    this.mat4[12] = a03;
    this.mat4[13] = a13;
    this.mat4[14] = a23;
    this.mat4[15] = a.mat4[15];

  }else if(a instanceof GLMAT_ARRAY_TYPE){
    a01 = a[1];
    a02 = a[2];
    a03 = a[3];
    a12 = a[6];
    a13 = a[7];
    a23 = a[11];

    this.mat4[0] = a[0];
    this.mat4[1] = a[4];
    this.mat4[2] = a[8];
    this.mat4[3] = a[12];
    this.mat4[4] = a01;
    this.mat4[5] = a[5];
    this.mat4[6] = a[9];
    this.mat4[7] = a[13];
    this.mat4[8] = a02;
    this.mat4[9] = a12;
    this.mat4[10] = a[10];
    this.mat4[11] = a[14];
    this.mat4[12] = a03;
    this.mat4[13] = a13;
    this.mat4[14] = a23;
    this.mat4[15] = a[15];
  }
  return this;
};

/**
 * invert  matrix according to a give matrix
 * @param  {p5.Matrix or Typed Array} a   the matrix to be based on to invert
 * @return {p5.Matrix}                    this
 */
p5.Matrix.prototype.invert = function(a){
  var a00, a01, a02, a03, a10, a11, a12, a13,
  a20, a21, a22, a23, a30, a31, a32, a33;
  if(a instanceof p5.Matrix){
    a00 = a.mat4[0];
    a01 = a.mat4[1];
    a02 = a.mat4[2];
    a03 = a.mat4[3];
    a10 = a.mat4[4];
    a11 = a.mat4[5];
    a12 = a.mat4[6];
    a13 = a.mat4[7];
    a20 = a.mat4[8];
    a21 = a.mat4[9];
    a22 = a.mat4[10];
    a23 = a.mat4[11];
    a30 = a.mat4[12];
    a31 = a.mat4[13];
    a32 = a.mat4[14];
    a33 = a.mat4[15];
  }else if(a instanceof GLMAT_ARRAY_TYPE){
    a00 = a[0];
    a01 = a[1];
    a02 = a[2];
    a03 = a[3];
    a10 = a[4];
    a11 = a[5];
    a12 = a[6];
    a13 = a[7];
    a20 = a[8];
    a21 = a[9];
    a22 = a[10];
    a23 = a[11];
    a30 = a[12];
    a31 = a[13];
    a32 = a[14];
    a33 = a[15];
  }
  var b00 = a00 * a11 - a01 * a10,
  b01 = a00 * a12 - a02 * a10,
  b02 = a00 * a13 - a03 * a10,
  b03 = a01 * a12 - a02 * a11,
  b04 = a01 * a13 - a03 * a11,
  b05 = a02 * a13 - a03 * a12,
  b06 = a20 * a31 - a21 * a30,
  b07 = a20 * a32 - a22 * a30,
  b08 = a20 * a33 - a23 * a30,
  b09 = a21 * a32 - a22 * a31,
  b10 = a21 * a33 - a23 * a31,
  b11 = a22 * a33 - a23 * a32,

  // Calculate the determinant
  det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 -
  b04 * b07 + b05 * b06;

  if (!det) {
    return null;
  }
  det = 1.0 / det;

  this.mat4[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
  this.mat4[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
  this.mat4[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
  this.mat4[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
  this.mat4[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
  this.mat4[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
  this.mat4[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
  this.mat4[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
  this.mat4[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
  this.mat4[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
  this.mat4[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
  this.mat4[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
  this.mat4[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
  this.mat4[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
  this.mat4[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
  this.mat4[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;

  return this;
};

/**
 * Inverts a 3x3 matrix
 * @return {[type]} [description]
 */
p5.Matrix.prototype.invert3x3 = function (){
  var a00 = this.mat3[0],
  a01 = this.mat3[1],
  a02 = this.mat3[2],
  a10 = this.mat3[3],
  a11 = this.mat3[4],
  a12 = this.mat3[5],
  a20 = this.mat3[6],
  a21 = this.mat3[7],
  a22 = this.mat3[8],
  b01 = a22 * a11 - a12 * a21,
  b11 = -a22 * a10 + a12 * a20,
  b21 = a21 * a10 - a11 * a20,

  // Calculate the determinant
  det = a00 * b01 + a01 * b11 + a02 * b21;
  if (!det) {
    return null;
  }
  det = 1.0 / det;
  this.mat3[0] = b01 * det;
  this.mat3[1] = (-a22 * a01 + a02 * a21) * det;
  this.mat3[2] = (a12 * a01 - a02 * a11) * det;
  this.mat3[3] = b11 * det;
  this.mat3[4] = (a22 * a00 - a02 * a20) * det;
  this.mat3[5] = (-a12 * a00 + a02 * a10) * det;
  this.mat3[6] = b21 * det;
  this.mat3[7] = (-a21 * a00 + a01 * a20) * det;
  this.mat3[8] = (a11 * a00 - a01 * a10) * det;
  return this;
};

/**
 * transposes a 3x3 p5.Matrix by a mat3
 * @param  {[Number]} mat3 1-dimensional array
 * @return {p5.Matrix} this
 */
p5.Matrix.prototype.transpose3x3 = function (mat3){
  var a01 = mat3[1], a02 = mat3[2], a12 = mat3[5];
  this.mat3[1] = mat3[3];
  this.mat3[2] = mat3[6];
  this.mat3[3] = a01;
  this.mat3[5] = mat3[7];
  this.mat3[6] = a02;
  this.mat3[7] = a12;
  return this;
};

/**
 * converts a 4x4 matrix to its 3x3 inverse tranform
 * commonly used in MVMatrix to NMatrix conversions.
 * @param  {p5.Matrix} mat4 the matrix to be based on to invert
 * @return {p5.Matrix} this with mat3
 * @todo  finish implementation
 */
p5.Matrix.prototype.inverseTranspose = function (matrix){
  if(this.mat3 === undefined){
    console.error('sorry, this function only works with mat3');
  }
  else {
    //convert mat4 -> mat3
    this.mat3[0] = matrix.mat4[0];
    this.mat3[1] = matrix.mat4[1];
    this.mat3[2] = matrix.mat4[2];
    this.mat3[3] = matrix.mat4[4];
    this.mat3[4] = matrix.mat4[5];
    this.mat3[5] = matrix.mat4[6];
    this.mat3[6] = matrix.mat4[8];
    this.mat3[7] = matrix.mat4[9];
    this.mat3[8] = matrix.mat4[10];
  }

  this.invert3x3().transpose3x3(this.mat3);
  return this;
};

/**
 * inspired by Toji's mat4 determinant
 * @return {Number} Determinant of our 4x4 matrix
 */
p5.Matrix.prototype.determinant = function(){
  var d00 = (this.mat4[0] * this.mat4[5]) - (this.mat4[1] * this.mat4[4]),
    d01 = (this.mat4[0] * this.mat4[6]) - (this.mat4[2] * this.mat4[4]),
    d02 = (this.mat4[0] * this.mat4[7]) - (this.mat4[3] * this.mat4[4]),
    d03 = (this.mat4[1] * this.mat4[6]) - (this.mat4[2] * this.mat4[5]),
    d04 = (this.mat4[1] * this.mat4[7]) - (this.mat4[3] * this.mat4[5]),
    d05 = (this.mat4[2] * this.mat4[7]) - (this.mat4[3] * this.mat4[6]),
    d06 = (this.mat4[8] * this.mat4[13]) - (this.mat4[9] * this.mat4[12]),
    d07 = (this.mat4[8] * this.mat4[14]) - (this.mat4[10] * this.mat4[12]),
    d08 = (this.mat4[8] * this.mat4[15]) - (this.mat4[11] * this.mat4[12]),
    d09 = (this.mat4[9] * this.mat4[14]) - (this.mat4[10] * this.mat4[13]),
    d10 = (this.mat4[9] * this.mat4[15]) - (this.mat4[11] * this.mat4[13]),
    d11 = (this.mat4[10] * this.mat4[15]) - (this.mat4[11] * this.mat4[14]);

  // Calculate the determinant
  return d00 * d11 - d01 * d10 + d02 * d09 +
    d03 * d08 - d04 * d07 + d05 * d06;
};

/**
 * multiply two mat4s
 * @param {p5.Matrix|Array}  multMatrix The matrix we want to multiply by
 * @return {p5.Matrix}         this
 */
p5.Matrix.prototype.mult = function(multMatrix){
  var _dest = new GLMAT_ARRAY_TYPE(16);
  var _src = new GLMAT_ARRAY_TYPE(16);

  if(multMatrix instanceof p5.Matrix) {
    _src = multMatrix.mat4;
  }
  else if(multMatrix instanceof GLMAT_ARRAY_TYPE){
    _src = multMatrix;
  }

  // each row is used for the multiplier
  var b0  = this.mat4[0], b1 = this.mat4[1],
    b2 = this.mat4[2], b3 = this.mat4[3];
  _dest[0] = b0*_src[0] + b1*_src[4] + b2*_src[8] + b3*_src[12];
  _dest[1] = b0*_src[1] + b1*_src[5] + b2*_src[9] + b3*_src[13];
  _dest[2] = b0*_src[2] + b1*_src[6] + b2*_src[10] + b3*_src[14];
  _dest[3] = b0*_src[3] + b1*_src[7] + b2*_src[11] + b3*_src[15];

  b0 = this.mat4[4];
  b1 = this.mat4[5];
  b2 = this.mat4[6];
  b3 = this.mat4[7];
  _dest[4] = b0*_src[0] + b1*_src[4] + b2*_src[8] + b3*_src[12];
  _dest[5] = b0*_src[1] + b1*_src[5] + b2*_src[9] + b3*_src[13];
  _dest[6] = b0*_src[2] + b1*_src[6] + b2*_src[10] + b3*_src[14];
  _dest[7] = b0*_src[3] + b1*_src[7] + b2*_src[11] + b3*_src[15];

  b0 = this.mat4[8];
  b1 = this.mat4[9];
  b2 = this.mat4[10];
  b3 = this.mat4[11];
  _dest[8] = b0*_src[0] + b1*_src[4] + b2*_src[8] + b3*_src[12];
  _dest[9] = b0*_src[1] + b1*_src[5] + b2*_src[9] + b3*_src[13];
  _dest[10] = b0*_src[2] + b1*_src[6] + b2*_src[10] + b3*_src[14];
  _dest[11] = b0*_src[3] + b1*_src[7] + b2*_src[11] + b3*_src[15];

  b0 = this.mat4[12];
  b1 = this.mat4[13];
  b2 = this.mat4[14];
  b3 = this.mat4[15];
  _dest[12] = b0*_src[0] + b1*_src[4] + b2*_src[8] + b3*_src[12];
  _dest[13] = b0*_src[1] + b1*_src[5] + b2*_src[9] + b3*_src[13];
  _dest[14] = b0*_src[2] + b1*_src[6] + b2*_src[10] + b3*_src[14];
  _dest[15] = b0*_src[3] + b1*_src[7] + b2*_src[11] + b3*_src[15];

  this.mat4 = _dest;

  return this;
};

/**
 * scales a p5.Matrix by scalars or a vector
 * @param  {p5.Vector|Array} s vector to scale by
 * @return {p5.Matrix}  this
 */
p5.Matrix.prototype.scale = function() {
  var x,y,z;
  var args = new Array(arguments.length);
  for (var i = 0; i < args.length; ++i) {
    args[i] = arguments[i];
  }
  //if our 1st arg is a type p5.Vector
  if (args[0] instanceof p5.Vector){
    x = args[0].x;
    y = args[0].y;
    z = args[0].z;
  }
  //otherwise if it's an array
  else if (args[0] instanceof Array){
    x = args[0][0];
    y = args[0][1];
    z = args[0][2];
  }
  var _dest = new GLMAT_ARRAY_TYPE(16);
  _dest[0] = this.mat4[0] * x;
  _dest[1] = this.mat4[1] * x;
  _dest[2] = this.mat4[2] * x;
  _dest[3] = this.mat4[3] * x;
  _dest[4] = this.mat4[4] * y;
  _dest[5] = this.mat4[5] * y;
  _dest[6] = this.mat4[6] * y;
  _dest[7] = this.mat4[7] * y;
  _dest[8] = this.mat4[8] * z;
  _dest[9] = this.mat4[9] * z;
  _dest[10] = this.mat4[10] * z;
  _dest[11] = this.mat4[11] * z;
  _dest[12] = this.mat4[12];
  _dest[13] = this.mat4[13];
  _dest[14] = this.mat4[14];
  _dest[15] = this.mat4[15];

  this.mat4 = _dest;
  return this;
};

/**
 * rotate our Matrix around an axis by the given angle.
 * @param  {Number} a The angle of rotation in radians
 * @param  {p5.Vector|Array} axis  the axis(es) to rotate around
 * @return {p5.Matrix}                    this
 * inspired by Toji's gl-matrix lib, mat4 rotation
 */
p5.Matrix.prototype.rotate = function(a, axis){
  var x, y, z, _a, len;

  if (this.p5) {
    if (this.p5._angleMode === constants.DEGREES) {
      _a = polarGeometry.degreesToRadians(a);
    }
  }
  else {
    _a = a;
  }
  if (axis instanceof p5.Vector) {
    x = axis.x;
    y = axis.y;
    z = axis.z;
  }
  else if (axis instanceof Array) {
    x = axis[0];
    y = axis[1];
    z = axis[2];
  }

  len = Math.sqrt(x * x + y * y + z * z);
  x *= (1/len);
  y *= (1/len);
  z *= (1/len);

  var a00 = this.mat4[0];
  var a01 = this.mat4[1];
  var a02 = this.mat4[2];
  var a03 = this.mat4[3];
  var a10 = this.mat4[4];
  var a11 = this.mat4[5];
  var a12 = this.mat4[6];
  var a13 = this.mat4[7];
  var a20 = this.mat4[8];
  var a21 = this.mat4[9];
  var a22 = this.mat4[10];
  var a23 = this.mat4[11];

  //sin,cos, and tan of respective angle
  var sA = Math.sin(_a);
  var cA = Math.cos(_a);
  var tA = 1 - cA;
  // Construct the elements of the rotation matrix
  var b00 = x * x * tA + cA;
  var b01 = y * x * tA + z * sA;
  var b02 = z * x * tA - y * sA;
  var b10 = x * y * tA - z * sA;
  var b11 = y * y * tA + cA;
  var b12 = z * y * tA + x * sA;
  var b20 = x * z * tA + y * sA;
  var b21 = y * z * tA - x * sA;
  var b22 = z * z * tA + cA;

  // rotation-specific matrix multiplication
  this.mat4[0] = a00 * b00 + a10 * b01 + a20 * b02;
  this.mat4[1] = a01 * b00 + a11 * b01 + a21 * b02;
  this.mat4[2] = a02 * b00 + a12 * b01 + a22 * b02;
  this.mat4[3] = a03 * b00 + a13 * b01 + a23 * b02;
  this.mat4[4] = a00 * b10 + a10 * b11 + a20 * b12;
  this.mat4[5] = a01 * b10 + a11 * b11 + a21 * b12;
  this.mat4[6] = a02 * b10 + a12 * b11 + a22 * b12;
  this.mat4[7] = a03 * b10 + a13 * b11 + a23 * b12;
  this.mat4[8] = a00 * b20 + a10 * b21 + a20 * b22;
  this.mat4[9] = a01 * b20 + a11 * b21 + a21 * b22;
  this.mat4[10] = a02 * b20 + a12 * b21 + a22 * b22;
  this.mat4[11] = a03 * b20 + a13 * b21 + a23 * b22;

  return this;
};

/**
 * @todo  finish implementing this method!
 * translates
 * @param  {Array} v vector to translate by
 * @return {p5.Matrix}                    this
 */
p5.Matrix.prototype.translate = function(v){
  var x = v[0],
    y = v[1],
    z = v[2] || 0;
  this.mat4[12] =
    this.mat4[0] * x +this.mat4[4] * y +this.mat4[8] * z +this.mat4[12];
  this.mat4[13] =
    this.mat4[1] * x +this.mat4[5] * y +this.mat4[9] * z +this.mat4[13];
  this.mat4[14] =
    this.mat4[2] * x +this.mat4[6] * y +this.mat4[10] * z +this.mat4[14];
  this.mat4[15] =
    this.mat4[3] * x +this.mat4[7] * y +this.mat4[11] * z +this.mat4[15];
};

p5.Matrix.prototype.rotateX = function(a){
  this.rotate(a, [1,0,0]);
};
p5.Matrix.prototype.rotateY = function(a){
  this.rotate(a, [0,1,0]);
};
p5.Matrix.prototype.rotateZ = function(a){
  this.rotate(a, [0,0,1]);
};

/**
 * sets the perspective matrix
 * @param  {Number} fovy   [description]
 * @param  {Number} aspect [description]
 * @param  {Number} near   near clipping plane
 * @param  {Number} far    far clipping plane
 * @return {void}
 */
p5.Matrix.prototype.perspective = function(fovy,aspect,near,far){

  var f = 1.0 / Math.tan(fovy / 2),
    nf = 1 / (near - far);

  this.mat4[0] = f / aspect;
  this.mat4[1] = 0;
  this.mat4[2] = 0;
  this.mat4[3] = 0;
  this.mat4[4] = 0;
  this.mat4[5] = f;
  this.mat4[6] = 0;
  this.mat4[7] = 0;
  this.mat4[8] = 0;
  this.mat4[9] = 0;
  this.mat4[10] = (far + near) * nf;
  this.mat4[11] = -1;
  this.mat4[12] = 0;
  this.mat4[13] = 0;
  this.mat4[14] = (2 * far * near) * nf;
  this.mat4[15] = 0;

  return this;

};

/**
 * sets the ortho matrix
 * @param  {Number} left   [description]
 * @param  {Number} right  [description]
 * @param  {Number} bottom [description]
 * @param  {Number} top    [description]
 * @param  {Number} near   near clipping plane
 * @param  {Number} far    far clipping plane
 * @return {void}
 */
p5.Matrix.prototype.ortho = function(left,right,bottom,top,near,far){

  var lr = 1 / (left - right),
    bt = 1 / (bottom - top),
    nf = 1 / (near - far);
  this.mat4[0] = -2 * lr;
  this.mat4[1] = 0;
  this.mat4[2] = 0;
  this.mat4[3] = 0;
  this.mat4[4] = 0;
  this.mat4[5] = -2 * bt;
  this.mat4[6] = 0;
  this.mat4[7] = 0;
  this.mat4[8] = 0;
  this.mat4[9] = 0;
  this.mat4[10] = 2 * nf;
  this.mat4[11] = 0;
  this.mat4[12] = (left + right) * lr;
  this.mat4[13] = (top + bottom) * bt;
  this.mat4[14] = (far + near) * nf;
  this.mat4[15] = 1;

  return this;
};

/**
 * PRIVATE
 */
// matrix methods adapted from:
// https://developer.mozilla.org/en-US/docs/Web/WebGL/
// gluPerspective
//
// function _makePerspective(fovy, aspect, znear, zfar){
//    var ymax = znear * Math.tan(fovy * Math.PI / 360.0);
//    var ymin = -ymax;
//    var xmin = ymin * aspect;
//    var xmax = ymax * aspect;
//    return _makeFrustum(xmin, xmax, ymin, ymax, znear, zfar);
//  }

////
//// glFrustum
////
//function _makeFrustum(left, right, bottom, top, znear, zfar){
//  var X = 2*znear/(right-left);
//  var Y = 2*znear/(top-bottom);
//  var A = (right+left)/(right-left);
//  var B = (top+bottom)/(top-bottom);
//  var C = -(zfar+znear)/(zfar-znear);
//  var D = -2*zfar*znear/(zfar-znear);
//  var frustrumMatrix =[
//  X, 0, A, 0,
//  0, Y, B, 0,
//  0, 0, C, D,
//  0, 0, -1, 0
//];
//return frustrumMatrix;
// }

// function _setMVPMatrices(){
////an identity matrix
////@TODO use the p5.Matrix class to abstract away our MV matrices and
///other math
//var _mvMatrix =
//[
//  1.0,0.0,0.0,0.0,
//  0.0,1.0,0.0,0.0,
//  0.0,0.0,1.0,0.0,
//  0.0,0.0,0.0,1.0
//];

module.exports = p5.Matrix;

},{"../core/constants":41,"../core/core":42,"../math/polargeometry":72}],89:[function(_dereq_,module,exports){
/**
 * Welcome to RendererGL Immediate Mode.
 * Immediate mode is used for drawing custom shapes
 * from a set of vertices.  Immediate Mode is activated
 * when you call beginShape() & de-activated when you call endShape().
 * Immediate mode is a style of programming borrowed
 * from OpenGL's (now-deprecated) immediate mode.
 * It differs from p5.js' default, Retained Mode, which caches
 * geometries and buffers on the CPU to reduce the number of webgl
 * draw calls. Retained mode is more efficient & performative,
 * however, Immediate Mode is useful for sketching quick
 * geometric ideas.
 */
'use strict';

var p5 = _dereq_('../core/core');
var constants = _dereq_('../core/constants');

/**
 * Begin shape drawing.  This is a helpful way of generating
 * custom shapes quickly.  However in WEBGL mode, application
 * performance will likely drop as a result of too many calls to
 * beginShape() / endShape().  As a high performance alternative,
 * please use p5.js geometry primitives.
 * @param  {Number} mode webgl primitives mode.  beginShape supports the
 *                       following modes:
 *                       POINTS,LINES,LINE_STRIP,LINE_LOOP,TRIANGLES,
 *                       TRIANGLE_STRIP,and TRIANGLE_FAN.
 * @return {[type]}      [description]
 */
p5.RendererGL.prototype.beginShape = function(mode){
  //default shape mode is line_strip
  this.immediateMode.shapeMode = (mode !== undefined ) ?
    mode : constants.LINE_STRIP;
  //if we haven't yet initialized our
  //immediateMode vertices & buffers, create them now!
  if(this.immediateMode.vertexPositions === undefined){
    this.immediateMode.vertexPositions = [];
    this.immediateMode.vertexColors = [];
    this.immediateMode.vertexBuffer = this.GL.createBuffer();
    this.immediateMode.colorBuffer = this.GL.createBuffer();
  } else {
    this.immediateMode.vertexPositions.length = 0;
    this.immediateMode.vertexColors.length = 0;
  }
  this.isImmediateDrawing = true;
  return this;
};
/**
 * adds a vertex to be drawn in a custom Shape.
 * @param  {Number} x x-coordinate of vertex
 * @param  {Number} y y-coordinate of vertex
 * @param  {Number} z z-coordinate of vertex
 * @return {p5.RendererGL}   [description]
 * @TODO implement handling of p5.Vector args
 */
p5.RendererGL.prototype.vertex = function(x, y, z){
  this.immediateMode.vertexPositions.push(x, y, z);
  var vertexColor = this.curFillColor || [0.5, 0.5, 0.5, 1.0];
  this.immediateMode.vertexColors.push(
    vertexColor[0],
    vertexColor[1],
    vertexColor[2],
    vertexColor[3]);
  return this;
};

/**
 * End shape drawing and render vertices to screen.
 * @return {p5.RendererGL} [description]
 */
p5.RendererGL.prototype.endShape =
function(mode, isCurve, isBezier,isQuadratic, isContour, shapeKind){
  var gl = this.GL;
  this._bindImmediateBuffers(
    this.immediateMode.vertexPositions,
    this.immediateMode.vertexColors);
  if(mode){
    if(this.drawMode === 'fill' || this.drawMode ==='texture'){
      switch(this.immediateMode.shapeMode){
        case constants.LINE_STRIP:
          this.immediateMode.shapeMode = constants.TRIANGLE_FAN;
          break;
        case constants.LINES:
          this.immediateMode.shapeMode = constants.TRIANGLE_FAN;
          break;
        case constants.TRIANGLES:
          this.immediateMode.shapeMode = constants.TRIANGLE_FAN;
          break;
      }
    } else {
      switch(this.immediateMode.shapeMode){
        case constants.LINE_STRIP:
          this.immediateMode.shapeMode = constants.LINE_LOOP;
          break;
        case constants.LINES:
          this.immediateMode.shapeMode = constants.LINE_LOOP;
          break;
      }
    }
  }
  //QUADS & QUAD_STRIP are not supported primitives modes
  //in webgl.
  if(this.immediateMode.shapeMode === constants.QUADS ||
    this.immediateMode.shapeMode === constants.QUAD_STRIP){
    throw new Error('sorry, ' + this.immediateMode.shapeMode+
      ' not yet implemented in webgl mode.');
  }
  else {
    gl.enable(gl.BLEND);
    gl.drawArrays(this.immediateMode.shapeMode, 0,
      this.immediateMode.vertexPositions.length / 3);
  }
  //clear out our vertexPositions & colors arrays
  //after rendering
  this.immediateMode.vertexPositions.length = 0;
  this.immediateMode.vertexColors.length = 0;
  this.isImmediateDrawing = false;
  return this;
};
/**
 * Bind immediateMode buffers to data,
 * then draw gl arrays
 * @param  {Array} vertices Numbers array representing
 *                          vertex positions
 * @return {p5.RendererGL}
 */
p5.RendererGL.prototype._bindImmediateBuffers = function(vertices, colors){
  this._setDefaultCamera();
  var gl = this.GL;
  var shaderKey = this._getCurShaderId();
  var shaderProgram = this.mHash[shaderKey];
  //vertex position Attribute
  shaderProgram.vertexPositionAttribute =
    gl.getAttribLocation(shaderProgram, 'aPosition');
  gl.enableVertexAttribArray(shaderProgram.vertexPositionAttribute);
  gl.bindBuffer(gl.ARRAY_BUFFER, this.immediateMode.vertexBuffer);
  gl.bufferData(
    gl.ARRAY_BUFFER, new Float32Array(vertices), gl.DYNAMIC_DRAW);
  gl.vertexAttribPointer(shaderProgram.vertexPositionAttribute,
    3, gl.FLOAT, false, 0, 0);

  shaderProgram.vertexColorAttribute =
    gl.getAttribLocation(shaderProgram, 'aVertexColor');
  gl.enableVertexAttribArray(shaderProgram.vertexColorAttribute);
  gl.bindBuffer(gl.ARRAY_BUFFER, this.immediateMode.colorBuffer);
  gl.bufferData(gl.ARRAY_BUFFER,
    new Float32Array(colors),gl.DYNAMIC_DRAW);
  gl.vertexAttribPointer(shaderProgram.vertexColorAttribute,
    4, gl.FLOAT, false, 0, 0);
  //matrix
  this._setMatrixUniforms(shaderKey);
  //@todo implement in all shaders (not just immediateVert)
  //set our default point size
  // this._setUniform1f(shaderKey,
  //   'uPointSize',
  //   this.pointSize);
  return this;
};

//////////////////////////////////////////////
// COLOR
//////////////////////////////////////////////

p5.RendererGL.prototype._getColorVertexShader = function(){
  var gl = this.GL;
  var mId = 'immediateVert|vertexColorFrag';
  var shaderProgram;

  if(!this.materialInHash(mId)){
    shaderProgram =
      this._initShaders('immediateVert', 'vertexColorFrag', true);
    this.mHash[mId] = shaderProgram;
    shaderProgram.vertexColorAttribute =
    gl.getAttribLocation(shaderProgram, 'aVertexColor');
    gl.enableVertexAttribArray(shaderProgram.vertexColorAttribute);
  }else{
    shaderProgram = this.mHash[mId];
  }
  return shaderProgram;
};

module.exports = p5.RendererGL;
},{"../core/constants":41,"../core/core":42}],90:[function(_dereq_,module,exports){
//Retained Mode. The default mode for rendering 3D primitives
//in WEBGL.
'use strict';

var p5 = _dereq_('../core/core');
var hashCount = 0;
/**
 * _initBufferDefaults
 * @description initializes buffer defaults. runs each time a new geometry is
 * registered
 * @param  {String} gId  key of the geometry object
 */
p5.RendererGL.prototype._initBufferDefaults = function(gId) {
  //@TODO remove this limit on hashes in gHash
  hashCount ++;
  if(hashCount > 1000){
    var key = Object.keys(this.gHash)[0];
    delete this.gHash[key];
    hashCount --;
  }

  var gl = this.GL;
  //create a new entry in our gHash
  this.gHash[gId] = {};
  this.gHash[gId].vertexBuffer = gl.createBuffer();
  this.gHash[gId].normalBuffer = gl.createBuffer();
  this.gHash[gId].uvBuffer = gl.createBuffer();
  this.gHash[gId].indexBuffer = gl.createBuffer();
};
/**
 * createBuffers description
 * @param  {String} gId    key of the geometry object
 * @param  {p5.Geometry}  obj contains geometry data
 */
p5.RendererGL.prototype.createBuffers = function(gId, obj) {
  var gl = this.GL;
  this._setDefaultCamera();
  //initialize the gl buffers for our geom groups
  this._initBufferDefaults(gId);
  //return the current shaderProgram from our material hash
  var shaderProgram = this.mHash[this._getCurShaderId()];
  //@todo rename "numberOfItems" property to something more descriptive
  //we mult the num geom faces by 3
  this.gHash[gId].numberOfItems = obj.faces.length * 3;
  gl.bindBuffer(gl.ARRAY_BUFFER, this.gHash[gId].vertexBuffer);
  gl.bufferData(
    gl.ARRAY_BUFFER,
    new Float32Array( vToNArray(obj.vertices) ),
    gl.STATIC_DRAW);
  //vertex position
  shaderProgram.vertexPositionAttribute =
    gl.getAttribLocation(shaderProgram, 'aPosition');
  gl.enableVertexAttribArray(shaderProgram.vertexPositionAttribute);

  gl.vertexAttribPointer(
    shaderProgram.vertexPositionAttribute,
    3, gl.FLOAT, false, 0, 0);

  gl.bindBuffer(gl.ARRAY_BUFFER, this.gHash[gId].normalBuffer);
  gl.bufferData(
    gl.ARRAY_BUFFER,
    new Float32Array( vToNArray(obj.vertexNormals) ),
    gl.STATIC_DRAW);
  //vertex normal
  shaderProgram.vertexNormalAttribute =
    gl.getAttribLocation(shaderProgram, 'aNormal');
  gl.enableVertexAttribArray(shaderProgram.vertexNormalAttribute);

  gl.vertexAttribPointer(
    shaderProgram.vertexNormalAttribute,
    3, gl.FLOAT, false, 0, 0);

  gl.bindBuffer(gl.ARRAY_BUFFER, this.gHash[gId].uvBuffer);
  gl.bufferData(
    gl.ARRAY_BUFFER,
    new Float32Array( flatten(obj.uvs) ),
    gl.STATIC_DRAW);
  //texture coordinate Attribute
  shaderProgram.textureCoordAttribute =
    gl.getAttribLocation(shaderProgram, 'aTexCoord');
  gl.enableVertexAttribArray(shaderProgram.textureCoordAttribute);
  gl.vertexAttribPointer(
    shaderProgram.textureCoordAttribute,
    2, gl.FLOAT, false, 0, 0);

  gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.gHash[gId].indexBuffer);
  gl.bufferData(
    gl.ELEMENT_ARRAY_BUFFER,
    new Uint16Array( flatten(obj.faces) ),
    gl.STATIC_DRAW);
};

/**
 * Draws buffers given a geometry key ID
 * @param  {String} gId     ID in our geom hash
 * @return {p5.RendererGL} this
 */
p5.RendererGL.prototype.drawBuffers = function(gId) {
  this._setDefaultCamera();
  var gl = this.GL;
  var shaderKey = this._getCurShaderId();
  var shaderProgram = this.mHash[shaderKey];
  //vertex position buffer
  gl.bindBuffer(gl.ARRAY_BUFFER, this.gHash[gId].vertexBuffer);
  gl.vertexAttribPointer(
    shaderProgram.vertexPositionAttribute,
    3, gl.FLOAT, false, 0, 0);
  //normal buffer
  gl.bindBuffer(gl.ARRAY_BUFFER, this.gHash[gId].normalBuffer);
  gl.vertexAttribPointer(
    shaderProgram.vertexNormalAttribute,
    3, gl.FLOAT, false, 0, 0);
  // uv buffer
  gl.bindBuffer(gl.ARRAY_BUFFER, this.gHash[gId].uvBuffer);
  gl.vertexAttribPointer(
    shaderProgram.textureCoordAttribute,
    2, gl.FLOAT, false, 0, 0);
  //vertex index buffer
  gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.gHash[gId].indexBuffer);
  this._setMatrixUniforms(shaderKey);
  gl.drawElements(
    gl.TRIANGLES, this.gHash[gId].numberOfItems,
    gl.UNSIGNED_SHORT, 0);
  return this;
};
///////////////////////////////
//// UTILITY FUNCTIONS
//////////////////////////////
/**
 * turn a two dimensional array into one dimensional array
 * @param  {Array} arr 2-dimensional array
 * @return {Array}     1-dimensional array
 * [[1, 2, 3],[4, 5, 6]] -> [1, 2, 3, 4, 5, 6]
 */
function flatten(arr){
  if (arr.length>0){
    return arr.reduce(function(a, b){
      return a.concat(b);
    });
  } else {
    return [];
  }
}

/**
 * turn a p5.Vector Array into a one dimensional number array
 * @param  {Array} arr  an array of p5.Vector
 * @return {Array]}     a one dimensional array of numbers
 * [p5.Vector(1, 2, 3), p5.Vector(4, 5, 6)] ->
 * [1, 2, 3, 4, 5, 6]
 */
function vToNArray(arr){
  return flatten(arr.map(function(item){
    return [item.x, item.y, item.z];
  }));
}
module.exports = p5.RendererGL;

},{"../core/core":42}],91:[function(_dereq_,module,exports){
'use strict';

var p5 = _dereq_('../core/core');
var shader = _dereq_('./shader');
_dereq_('../core/p5.Renderer');
_dereq_('./p5.Matrix');
var uMVMatrixStack = [];

//@TODO should implement public method
//to override these attributes
var attributes = {
  alpha: true,
  depth: true,
  stencil: true,
  antialias: false,
  premultipliedAlpha: false,
  preserveDrawingBuffer: false
};

/**
 * 3D graphics class
 * @class p5.RendererGL
 * @constructor
 * @extends p5.Renderer
 * @todo extend class to include public method for offscreen
 * rendering (FBO).
 *
 */
p5.RendererGL = function(elt, pInst, isMainCanvas) {
  p5.Renderer.call(this, elt, pInst, isMainCanvas);
  this._initContext();

  this.isP3D = true; //lets us know we're in 3d mode
  this.GL = this.drawingContext;
  //lights
  this.ambientLightCount = 0;
  this.directionalLightCount = 0;
  this.pointLightCount = 0;
  //camera
  this._curCamera = null;

  /**
   * model view, projection, & normal
   * matrices
   */
  this.uMVMatrix = new p5.Matrix();
  this.uPMatrix  = new p5.Matrix();
  this.uNMatrix = new p5.Matrix('mat3');
  //Geometry & Material hashes
  this.gHash = {};
  this.mHash = {};
  //Imediate Mode
  //default drawing is done in Retained Mode
  this.isImmediateDrawing = false;
  this.immediateMode = {};
  this.curFillColor = [0.5,0.5,0.5,1.0];
  this.curStrokeColor = [0.5,0.5,0.5,1.0];
  this.pointSize = 5.0;//default point/stroke
  return this;
};

p5.RendererGL.prototype = Object.create(p5.Renderer.prototype);

//////////////////////////////////////////////
// Setting
//////////////////////////////////////////////

p5.RendererGL.prototype._initContext = function() {
  try {
    this.drawingContext = this.canvas.getContext('webgl', attributes) ||
      this.canvas.getContext('experimental-webgl', attributes);
    if (this.drawingContext === null) {
      throw new Error('Error creating webgl context');
    } else {
      console.log('p5.RendererGL: enabled webgl context');
      var gl = this.drawingContext;
      gl.enable(gl.DEPTH_TEST);
      gl.depthFunc(gl.LEQUAL);
      gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
    }
  } catch (er) {
    throw new Error(er);
  }
};
//detect if user didn't set the camera
//then call this function below
p5.RendererGL.prototype._setDefaultCamera = function(){
  if(this._curCamera === null){
    var _w = this.width;
    var _h = this.height;
    this.uPMatrix = p5.Matrix.identity();
    var cameraZ = (this.height / 2) / Math.tan(Math.PI * 30 / 180);
    this.uPMatrix.perspective(60 / 180 * Math.PI, _w / _h,
                              cameraZ * 0.1, cameraZ * 10);
    this._curCamera = 'default';
  }
};

p5.RendererGL.prototype._update = function() {
  this.uMVMatrix = p5.Matrix.identity();
  this.translate(0, 0, -(this.height / 2) / Math.tan(Math.PI * 30 / 180));
  this.ambientLightCount = 0;
  this.directionalLightCount = 0;
  this.pointLightCount = 0;
};

/**
 * [background description]
 * @return {[type]} [description]
 */
p5.RendererGL.prototype.background = function() {
  var gl = this.GL;
  var _col = this._pInst.color.apply(this._pInst, arguments);
  var _r = (_col.levels[0]) / 255;
  var _g = (_col.levels[1]) / 255;
  var _b = (_col.levels[2]) / 255;
  var _a = (_col.levels[3]) / 255;
  gl.clearColor(_r, _g, _b, _a);
  gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
};

//@TODO implement this
// p5.RendererGL.prototype.clear = function() {
//@TODO
// };

//////////////////////////////////////////////
// SHADER
//////////////////////////////////////////////

/**
 * [_initShaders description]
 * @param  {string} vertId [description]
 * @param  {string} fragId [description]
 * @return {[type]}        [description]
 */
p5.RendererGL.prototype._initShaders =
function(vertId, fragId, isImmediateMode) {
  var gl = this.GL;
  //set up our default shaders by:
  // 1. create the shader,
  // 2. load the shader source,
  // 3. compile the shader
  var _vertShader = gl.createShader(gl.VERTEX_SHADER);
  //load in our default vertex shader
  gl.shaderSource(_vertShader, shader[vertId]);
  gl.compileShader(_vertShader);
  // if our vertex shader failed compilation?
  if (!gl.getShaderParameter(_vertShader, gl.COMPILE_STATUS)) {
    alert('Yikes! An error occurred compiling the shaders:' +
      gl.getShaderInfoLog(_vertShader));
    return null;
  }

  var _fragShader = gl.createShader(gl.FRAGMENT_SHADER);
  //load in our material frag shader
  gl.shaderSource(_fragShader, shader[fragId]);
  gl.compileShader(_fragShader);
  // if our frag shader failed compilation?
  if (!gl.getShaderParameter(_fragShader, gl.COMPILE_STATUS)) {
    alert('Darn! An error occurred compiling the shaders:' +
      gl.getShaderInfoLog(_fragShader));
    return null;
  }

  var shaderProgram = gl.createProgram();
  gl.attachShader(shaderProgram, _vertShader);
  gl.attachShader(shaderProgram, _fragShader);
  gl.linkProgram(shaderProgram);
  if (!gl.getProgramParameter(shaderProgram, gl.LINK_STATUS)) {
    alert('Snap! Error linking shader program');
  }
  //END SHADERS SETUP

  this._getLocation(shaderProgram, isImmediateMode);

  return shaderProgram;
};

p5.RendererGL.prototype._getLocation =
function(shaderProgram, isImmediateMode) {
  var gl = this.GL;
  gl.useProgram(shaderProgram);

  //projection Matrix uniform
  shaderProgram.uPMatrixUniform =
    gl.getUniformLocation(shaderProgram, 'uProjectionMatrix');
  //model view Matrix uniform
  shaderProgram.uMVMatrixUniform =
    gl.getUniformLocation(shaderProgram, 'uModelViewMatrix');

  //@TODO: figure out a better way instead of if statement
  if(isImmediateMode === undefined){
    //normal Matrix uniform
    shaderProgram.uNMatrixUniform =
    gl.getUniformLocation(shaderProgram, 'uNormalMatrix');

    shaderProgram.samplerUniform =
    gl.getUniformLocation(shaderProgram, 'uSampler');
  }
};

/**
 * Sets a shader uniform given a shaderProgram and uniform string
 * @param {String} shaderKey key to material Hash.
 * @param {String} uniform location in shader.
 * @param { Number} data data to bind uniform.  Float data type.
 * @todo currently this function sets uniform1f data.
 * Should generalize function to accept any uniform
 * data type.
 */
p5.RendererGL.prototype._setUniform1f = function(shaderKey,uniform,data)
{
  var gl = this.GL;
  var shaderProgram = this.mHash[shaderKey];
  gl.useProgram(shaderProgram);
  shaderProgram[uniform] = gl.getUniformLocation(shaderProgram, uniform);
  gl.uniform1f(shaderProgram[uniform], data);
  return this;
};

p5.RendererGL.prototype._setMatrixUniforms = function(shaderKey) {
  var gl = this.GL;
  var shaderProgram = this.mHash[shaderKey];

  gl.useProgram(shaderProgram);

  gl.uniformMatrix4fv(
    shaderProgram.uPMatrixUniform,
    false, this.uPMatrix.mat4);

  gl.uniformMatrix4fv(
    shaderProgram.uMVMatrixUniform,
    false, this.uMVMatrix.mat4);

  this.uNMatrix.inverseTranspose(this.uMVMatrix);

  gl.uniformMatrix3fv(
    shaderProgram.uNMatrixUniform,
    false, this.uNMatrix.mat3);
};
//////////////////////////////////////////////
// GET CURRENT | for shader and color
//////////////////////////////////////////////
p5.RendererGL.prototype._getShader = function(vertId, fragId, isImmediateMode) {
  var mId = vertId + '|' + fragId;
  //create it and put it into hashTable
  if(!this.materialInHash(mId)){
    var shaderProgram = this._initShaders(vertId, fragId, isImmediateMode);
    this.mHash[mId] = shaderProgram;
  }
  this.curShaderId = mId;

  return this.mHash[this.curShaderId];
};

p5.RendererGL.prototype._getCurShaderId = function(){
  //if the shader ID is not yet defined
  var mId, shaderProgram;
  if(this.drawMode !== 'fill' && this.curShaderId === undefined){
    //default shader: normalMaterial()
    mId = 'normalVert|normalFrag';
    shaderProgram = this._initShaders('normalVert', 'normalFrag');
    this.mHash[mId] = shaderProgram;
    this.curShaderId = mId;
  } else if(this.isImmediateDrawing && this.drawMode === 'fill'){
    mId = 'immediateVert|vertexColorFrag';
    shaderProgram = this._initShaders('immediateVert', 'vertexColorFrag');
    this.mHash[mId] = shaderProgram;
    this.curShaderId = mId;
  }
  return this.curShaderId;
};

//////////////////////////////////////////////
// COLOR
//////////////////////////////////////////////
/**
 * Basic fill material for geometry with a given color
 * @method  fill
 * @param  {Number|Array|String|p5.Color} v1  gray value,
 * red or hue value (depending on the current color mode),
 * or color Array, or CSS color string
 * @param  {Number}            [v2] optional: green or saturation value
 * @param  {Number}            [v3] optional: blue or brightness value
 * @param  {Number}            [a]  optional: opacity
 * @return {p5}                the p5 object
 * @example
 * <div>
 * <code>
 * function setup(){
 *   createCanvas(100, 100, WEBGL);
 * }
 *
 * function draw(){
 *  background(0);
 *  fill(250, 0, 0);
 *  rotateX(frameCount * 0.01);
 *  rotateY(frameCount * 0.01);
 *  rotateZ(frameCount * 0.01);
 *  box(200, 200, 200);
 * }
 * </code>
 * </div>
 *
 * @alt
 * red canvas
 *
 */
p5.RendererGL.prototype.fill = function(v1, v2, v3, a) {
  var gl = this.GL;
  var shaderProgram;
  //see material.js for more info on color blending in webgl
  var colors = this._applyColorBlend.apply(this, arguments);
  this.curFillColor = colors;
  this.drawMode = 'fill';
  if(this.isImmediateDrawing){
    shaderProgram =
    this._getShader('immediateVert','vertexColorFrag');
    gl.useProgram(shaderProgram);
  } else {
    shaderProgram =
    this._getShader('normalVert', 'basicFrag');
    gl.useProgram(shaderProgram);
    //RetainedMode uses a webgl uniform to pass color vals
    //in ImmediateMode, we want access to each vertex so therefore
    //we cannot use a uniform.
    shaderProgram.uMaterialColor = gl.getUniformLocation(
      shaderProgram, 'uMaterialColor' );
    gl.uniform4f( shaderProgram.uMaterialColor,
      colors[0],
      colors[1],
      colors[2],
      colors[3]);
  }
  return this;
};
p5.RendererGL.prototype.stroke = function(r, g, b, a) {
  var color = this._pInst.color.apply(this._pInst, arguments);
  var colorNormalized = color._array;
  this.curStrokeColor = colorNormalized;
  this.drawMode = 'stroke';
  return this;
};

//@TODO
p5.RendererGL.prototype._strokeCheck = function(){
  if(this.drawMode === 'stroke'){
    throw new Error(
      'stroke for shapes in 3D not yet implemented, use fill for now :('
    );
  }
};

/**
 * [strokeWeight description]
 * @param  {Number} pointSize stroke point size
 * @return {[type]}           [description]
 * @todo  strokeWeight currently works on points only.
 * implement on all wireframes and strokes.
 */
p5.RendererGL.prototype.strokeWeight = function(pointSize) {
  this.pointSize = pointSize;
  return this;
};
//////////////////////////////////////////////
// HASH | for material and geometry
//////////////////////////////////////////////

p5.RendererGL.prototype.geometryInHash = function(gId){
  return this.gHash[gId] !== undefined;
};

p5.RendererGL.prototype.materialInHash = function(mId){
  return this.mHash[mId] !== undefined;
};

/**
 * [resize description]
 * @param  {[type]} w [description]
 * @param  {[tyoe]} h [description]
 * @return {[type]}   [description]
 */
p5.RendererGL.prototype.resize = function(w,h) {
  var gl = this.GL;
  p5.Renderer.prototype.resize.call(this, w, h);
  gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
  // If we're using the default camera, update the aspect ratio
  if(this._curCamera === 'default') {
    this._curCamera = null;
    this._setDefaultCamera();
  }
};

/**
 * clears color and depth buffers
 * with r,g,b,a
 * @param {Number} r normalized red val.
 * @param {Number} g normalized green val.
 * @param {Number} b normalized blue val.
 * @param {Number} a normalized alpha val.
 */
p5.RendererGL.prototype.clear = function() {
  var gl = this.GL;
  gl.clearColor(arguments[0],
    arguments[1],
    arguments[2],
    arguments[3]);
  gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
};

/**
 * [translate description]
 * @param  {[type]} x [description]
 * @param  {[type]} y [description]
 * @param  {[type]} z [description]
 * @return {[type]}   [description]
 * @todo implement handle for components or vector as args
 */
p5.RendererGL.prototype.translate = function(x, y, z) {
  this.uMVMatrix.translate([x,-y,z]);
  return this;
};

/**
 * Scales the Model View Matrix by a vector
 * @param  {Number | p5.Vector | Array} x [description]
 * @param  {Number} [y] y-axis scalar
 * @param  {Number} [z] z-axis scalar
 * @return {this}   [description]
 */
p5.RendererGL.prototype.scale = function(x,y,z) {
  this.uMVMatrix.scale([x,y,z]);
  return this;
};

p5.RendererGL.prototype.rotate = function(rad, axis){
  this.uMVMatrix.rotate(rad, axis);
  return this;
};

p5.RendererGL.prototype.rotateX = function(rad) {
  this.rotate(rad, [1,0,0]);
  return this;
};

p5.RendererGL.prototype.rotateY = function(rad) {
  this.rotate(rad, [0,1,0]);
  return this;
};

p5.RendererGL.prototype.rotateZ = function(rad) {
  this.rotate(rad, [0,0,1]);
  return this;
};

/**
 * pushes a copy of the model view matrix onto the
 * MV Matrix stack.
 */
p5.RendererGL.prototype.push = function() {
  uMVMatrixStack.push(this.uMVMatrix.copy());
};

/**
 * [pop description]
 * @return {[type]} [description]
 */
p5.RendererGL.prototype.pop = function() {
  if (uMVMatrixStack.length === 0) {
    throw new Error('Invalid popMatrix!');
  }
  this.uMVMatrix = uMVMatrixStack.pop();
};

p5.RendererGL.prototype.resetMatrix = function() {
  this.uMVMatrix = p5.Matrix.identity();
  this.translate(0, 0, -800);
  return this;
};

// Text/Typography
// @TODO:
p5.RendererGL.prototype._applyTextProperties = function() {
  //@TODO finish implementation
  console.error('text commands not yet implemented in webgl');
};
module.exports = p5.RendererGL;

},{"../core/core":42,"../core/p5.Renderer":48,"./p5.Matrix":88,"./shader":93}],92:[function(_dereq_,module,exports){
/**
 * @module Shape
 * @submodule 3D Primitives
 * @for p5
 * @requires core
 * @requires p5.Geometry
 */

'use strict';

var p5 = _dereq_('../core/core');
_dereq_('./p5.Geometry');
/**
 * Draw a plane with given a width and height
 * @method plane
 * @param  {Number} width      width of the plane
 * @param  {Number} height     height of the plane
 * @param  {Number} [detailX]  Optional number of triangle
 *                             subdivisions in x-dimension
 * @param {Number} [detailY]   Optional number of triangle
 *                             subdivisions in y-dimension
 * @return {p5}                the p5 object
 * @example
 * <div>
 * <code>
 * //draw a plane with width 200 and height 200
 * function setup(){
 *   createCanvas(100, 100, WEBGL);
 * }
 *
 * function draw(){
 *   background(200);
 *   plane(50, 50);
 * }
 * </code>
 * </div>
 *
 * @alt
 * Nothing displayed on canvas
 * Rotating interior view of a box with sides that change color.
 * 3d red and green gradient.
 * Rotating interior view of a cylinder with sides that change color.
 * Rotating view of a cylinder with sides that change color.
 * 3d red and green gradient.
 * rotating view of a multi-colored cylinder with concave sides.
 */
p5.prototype.plane = function(){
  var args = new Array(arguments.length);
  for (var i = 0; i < args.length; ++i) {
    args[i] = arguments[i];
  }
  var width = args[0] || 50;
  var height = args[1] || width;
  var detailX = typeof args[2] === 'number' ? args[2] : 1;
  var detailY = typeof args[3] === 'number' ? args[3] : 1;

  var gId = 'plane|'+width+'|'+height+'|'+detailX+'|'+detailY;

  if(!this._renderer.geometryInHash(gId)){
    var _plane = function(){
      var u,v,p;
      for (var i = 0; i <= this.detailY; i++){
        v = i / this.detailY;
        for (var j = 0; j <= this.detailX; j++){
          u = j / this.detailX;
          p = new p5.Vector(width * u - width/2,
            height * v - height/2,
            0);
          this.vertices.push(p);
          this.uvs.push([u,v]);
        }
      }
    };
    var planeGeom =
    new p5.Geometry(detailX, detailY, _plane);
    planeGeom
      .computeFaces()
      .computeNormals();
    this._renderer.createBuffers(gId, planeGeom);
  }

  this._renderer.drawBuffers(gId);

};

/**
 * Draw a box with given width, height and depth
 * @method  box
 * @param  {Number} width     width of the box
 * @param  {Number} Height    height of the box
 * @param  {Number} depth     depth of the box
 * @param {Number} [detailX]  Optional number of triangle
 *                            subdivisions in x-dimension
 * @param {Number} [detailY]  Optional number of triangle
 *                            subdivisions in y-dimension
 * @return {p5}               the p5 object
 * @example
 * <div>
 * <code>
 * //draw a spinning box with width, height and depth 200
 * function setup(){
 *   createCanvas(100, 100, WEBGL);
 * }
 *
 * function draw(){
 *   background(200);
 *   rotateX(frameCount * 0.01);
 *   rotateY(frameCount * 0.01);
 *   box(200, 200, 200);
 * }
 * </code>
 * </div>
 */
p5.prototype.box = function(){
  var args = new Array(arguments.length);
  for (var i = 0; i < args.length; ++i) {
    args[i] = arguments[i];
  }
  var width = args[0] || 50;
  var height = args[1] || width;
  var depth = args[2] || width;

  var detailX = typeof args[3] === 'number' ? args[3] : 4;
  var detailY = typeof args[4] === 'number' ? args[4] : 4;
  var gId = 'box|'+width+'|'+height+'|'+depth+'|'+detailX+'|'+detailY;

  if(!this._renderer.geometryInHash(gId)){
    var _box = function(){
      var cubeIndices = [
        [0, 4, 2, 6],// -1, 0, 0],// -x
        [1, 3, 5, 7],// +1, 0, 0],// +x
        [0, 1, 4, 5],// 0, -1, 0],// -y
        [2, 6, 3, 7],// 0, +1, 0],// +y
        [0, 2, 1, 3],// 0, 0, -1],// -z
        [4, 5, 6, 7]// 0, 0, +1] // +z
      ];
      var id=0;
      for (var i = 0; i < cubeIndices.length; i++) {
        var cubeIndex = cubeIndices[i];
        var v = i * 4;
        for (var j = 0; j < 4; j++) {
          var d = cubeIndex[j];
          //inspired by lightgl:
          //https://github.com/evanw/lightgl.js
          //octants:https://en.wikipedia.org/wiki/Octant_(solid_geometry)
          var octant = new p5.Vector(
            ((d & 1) * 2 - 1)*width/2,
            ((d & 2) - 1) *height/2,
            ((d & 4) / 2 - 1) * depth/2);
          this.vertices.push( octant );
          this.uvs.push([j & 1, (j & 2) / 2]);
          id++;
        }
        this.faces.push([v, v + 1, v + 2]);
        this.faces.push([v + 2, v + 1, v + 3]);
      }
    };
    var boxGeom = new p5.Geometry(detailX,detailY, _box);
    boxGeom.computeNormals();
    //initialize our geometry buffer with
    //the key val pair:
    //geometry Id, Geom object
    this._renderer.createBuffers(gId, boxGeom);
  }
  this._renderer.drawBuffers(gId);

  return this;

};

/**
 * Draw a sphere with given radius
 * @method sphere
 * @param  {Number} radius            radius of circle
 * @param  {Number} [detailX]         optional: number of segments,
 *                                    the more segments the smoother geometry
 *                                    default is 24
 * @param  {Number} [detailY]         optional: number of segments,
 *                                    the more segments the smoother geometry
 *                                    default is 16
 * @return {p5}                       the p5 object
 * @example
 * <div>
 * <code>
 * // draw a sphere with radius 200
 * function setup(){
 *   createCanvas(100, 100, WEBGL);
 * }
 *
 * function draw(){
 *   background(200);
 *   sphere(50);
 * }
 * </code>
 * </div>
 */
p5.prototype.sphere = function(){
  var args = new Array(arguments.length);
  for (var i = 0; i < args.length; ++i) {
    args[i] = arguments[i];
  }
  var radius = args[0] || 50;
  var detailX = typeof args[1] === 'number' ? args[1] : 24;
  var detailY = typeof args[2] === 'number' ? args[2] : 16;
  var gId = 'sphere|'+radius+'|'+detailX+'|'+detailY;
  if(!this._renderer.geometryInHash(gId)){
    var _sphere = function(){
      var u,v,p;
      for (var i = 0; i <= this.detailY; i++){
        v = i / this.detailY;
        for (var j = 0; j <= this.detailX; j++){
          u = j / this.detailX;
          var theta = 2 * Math.PI * u;
          var phi = Math.PI * v - Math.PI / 2;
          p = new p5.Vector(radius * Math.cos(phi) * Math.sin(theta),
            radius * Math.sin(phi),
            radius * Math.cos(phi) * Math.cos(theta));
          this.vertices.push(p);
          this.uvs.push([u,v]);
        }
      }
    };
    var sphereGeom = new p5.Geometry(detailX, detailY, _sphere);
    sphereGeom
      .computeFaces()
      .computeNormals()
      .averageNormals()
      .averagePoleNormals();
    this._renderer.createBuffers(gId, sphereGeom);
  }
  this._renderer.drawBuffers(gId);

  return this;
};


/**
* @private
* helper function for creating both cones and cyllinders
*/
var _truncatedCone = function(
  bottomRadius,
  topRadius,
  height,
  detailX,
  detailY,
  topCap,
  bottomCap) {
  detailX = (detailX < 3) ? 3 : detailX;
  detailY = (detailY < 1) ? 1 : detailY;
  topCap = (topCap === undefined) ? true : topCap;
  bottomCap = (bottomCap === undefined) ? true : bottomCap;
  var extra = (topCap ? 2 : 0) + (bottomCap ? 2 : 0);
  var vertsAroundEdge = detailX + 1;

  // ensure constant slant
  var slant = Math.atan2(bottomRadius - topRadius, height);
  var start = topCap ? -2 : 0;
  var end = detailY + (bottomCap ? 2 : 0);
  var yy, ii;
  for (yy = start; yy <= end; ++yy) {
    var v = yy / detailY;
    var y = height * v;
    var ringRadius;
    if (yy < 0) {
      y = 0;
      v = 1;
      ringRadius = bottomRadius;
    } else if (yy > detailY) {
      y = height;
      v = 1;
      ringRadius = topRadius;
    } else {
      ringRadius = bottomRadius +
        (topRadius - bottomRadius) * (yy / detailY);
    }
    if (yy === -2 || yy === detailY + 2) {
      ringRadius = 0;
      v = 0;
    }
    y -= height / 2;
    for (ii = 0; ii < vertsAroundEdge; ++ii) {
      //VERTICES
      this.vertices.push(
        new p5.Vector(
          Math.sin(ii*Math.PI * 2 /detailX) * ringRadius,
          y,
          Math.cos(ii*Math.PI * 2 /detailX) * ringRadius)
        );
      //VERTEX NORMALS
      this.vertexNormals.push(
        new p5.Vector(
          (yy < 0 || yy > detailY) ? 0 :
          (Math.sin(ii * Math.PI * 2 / detailX) * Math.cos(slant)),
          (yy < 0) ? -1 : (yy > detailY ? 1 : Math.sin(slant)),
          (yy < 0 || yy > detailY) ? 0 :
          (Math.cos(ii * Math.PI * 2 / detailX) * Math.cos(slant)))
        );
      //UVs
      this.uvs.push([(ii / detailX), v]);
    }
  }
  for (yy = 0; yy < detailY + extra; ++yy) {
    for (ii = 0; ii < detailX; ++ii) {
      this.faces.push([vertsAroundEdge * (yy + 0) + 0 + ii,
        vertsAroundEdge * (yy + 0) + 1 + ii,
        vertsAroundEdge * (yy + 1) + 1 + ii]);
      this.faces.push([vertsAroundEdge * (yy + 0) + 0 + ii,
        vertsAroundEdge * (yy + 1) + 1 + ii,
        vertsAroundEdge * (yy + 1) + 0 + ii]);
    }
  }
};

/**
 * Draw a cylinder with given radius and height
 * @method  cylinder
 * @param  {Number} radius     radius of the surface
 * @param  {Number} height     height of the cylinder
 * @param  {Number} [detailX]  optional: number of segments,
 *                             the more segments the smoother geometry
 *                             default is 24
 * @param {Number} [detailY]   optional: number of segments in y-dimension,
 *                             the more segments the smoother geometry
 *                             default is 16
 * @return {p5}                the p5 object
 * @example
 * <div>
 * <code>
 * //draw a spinning cylinder with radius 200 and height 200
 * function setup(){
 *   createCanvas(100, 100, WEBGL);
 * }
 *
 * function draw(){
 *   background(200);
 *   rotateX(frameCount * 0.01);
 *   rotateZ(frameCount * 0.01);
 *   cylinder(200, 200);
 * }
 * </code>
 * </div>
 */
p5.prototype.cylinder = function(){
  var args = new Array(arguments.length);
  for (var i = 0; i < args.length; ++i) {
    args[i] = arguments[i];
  }
  var radius = args[0] || 50;
  var height = args[1] || radius;
  var detailX = typeof args[2] === 'number' ? args[2] : 24;
  var detailY = typeof args[3] === 'number' ? args[3] : 16;
  var gId = 'cylinder|'+radius+'|'+height+'|'+detailX+'|'+detailY;
  if(!this._renderer.geometryInHash(gId)){
    var cylinderGeom = new p5.Geometry(detailX, detailY);
    _truncatedCone.call(
      cylinderGeom,
      radius,
      radius,
      height,
      detailX,
      detailY,
      true,true);
    cylinderGeom.computeNormals();
    this._renderer.createBuffers(gId, cylinderGeom);
  }

  this._renderer.drawBuffers(gId);

  return this;
};


/**
 * Draw a cone with given radius and height
 * @method cone
 * @param  {Number} radius            radius of the bottom surface
 * @param  {Number} height            height of the cone
 * @param  {Number} [detailX]         optional: number of segments,
 *                                    the more segments the smoother geometry
 *                                    default is 24
 * @param  {Number} [detailY]         optional: number of segments,
 *                                    the more segments the smoother geometry
 *                                    default is 16
 * @return {p5}                       the p5 object
 * @example
 * <div>
 * <code>
 * //draw a spinning cone with radius 200 and height 200
 * function setup(){
 *   createCanvas(100, 100, WEBGL);
 * }
 *
 * function draw(){
 *   background(200);
 *   rotateX(frameCount * 0.01);
 *   rotateZ(frameCount * 0.01);
 *   cone(200, 200);
 * }
 * </code>
 * </div>
 */
p5.prototype.cone = function(){
  var args = new Array(arguments.length);
  for (var i = 0; i < args.length; ++i) {
    args[i] = arguments[i];
  }
  var baseRadius = args[0] || 50;
  var height = args[1] || baseRadius;
  var detailX = typeof args[2] === 'number' ? args[2] : 24;
  var detailY = typeof args[3] === 'number' ? args[3] : 16;
  var gId = 'cone|'+baseRadius+'|'+height+'|'+detailX+'|'+detailY;
  if(!this._renderer.geometryInHash(gId)){
    var coneGeom = new p5.Geometry(detailX, detailY);
    _truncatedCone.call(coneGeom,
      baseRadius,
      0,//top radius 0
      height,
      detailX,
      detailY,
      true,
      true);
    //for cones we need to average Normals
    coneGeom
      .computeNormals();
    this._renderer.createBuffers(gId, coneGeom);
  }

  this._renderer.drawBuffers(gId);

  return this;
};

/**
 * Draw an ellipsoid with given radius
 * @method ellipsoid
 * @param  {Number} radiusx           xradius of circle
 * @param  {Number} radiusy           yradius of circle
 * @param  {Number} radiusz           zradius of circle
 * @param  {Number} [detailX]         optional: number of segments,
 *                                    the more segments the smoother geometry
 *                                    default is 24. Avoid detail number above
 *                                    150, it may crash the browser.
 * @param  {Number} [detailY]         optional: number of segments,
 *                                    the more segments the smoother geometry
 *                                    default is 16. Avoid detail number above
 *                                    150, it may crash the browser.
 * @return {p5}                       the p5 object
 * @example
 * <div>
 * <code>
 * // draw an ellipsoid with radius 20, 30 and 40.
 * function setup(){
 *   createCanvas(100, 100, WEBGL);
 * }
 *
 * function draw(){
 *   background(200);
 *   ellipsoid(20, 30, 40);
 * }
 * </code>
 * </div>
 */
p5.prototype.ellipsoid = function(){
  var args = new Array(arguments.length);
  for (var i = 0; i < args.length; ++i) {
    args[i] = arguments[i];
  }
  var detailX = typeof args[3] === 'number' ? args[3] : 24;
  var detailY = typeof args[4] === 'number' ? args[4] : 24;
  var radiusX = args[0] || 50;
  var radiusY = args[1] || radiusX;
  var radiusZ = args[2] || radiusX;

  var gId = 'ellipsoid|'+radiusX+'|'+radiusY+
  '|'+radiusZ+'|'+detailX+'|'+detailY;


  if(!this._renderer.geometryInHash(gId)){
    var _ellipsoid = function(){
      var u,v,p;
      for (var i = 0; i <= this.detailY; i++){
        v = i / this.detailY;
        for (var j = 0; j <= this.detailX; j++){
          u = j / this.detailX;
          var theta = 2 * Math.PI * u;
          var phi = Math.PI * v - Math.PI / 2;
          p = new p5.Vector(radiusX * Math.cos(phi) * Math.sin(theta),
            radiusY * Math.sin(phi),
            radiusZ * Math.cos(phi) * Math.cos(theta));
          this.vertices.push(p);
          this.uvs.push([u,v]);
        }
      }
    };
    var ellipsoidGeom = new p5.Geometry(detailX, detailY,_ellipsoid);
    ellipsoidGeom
      .computeFaces()
      .computeNormals();
    this._renderer.createBuffers(gId, ellipsoidGeom);
  }

  this._renderer.drawBuffers(gId);

  return this;
};

/**
 * Draw a torus with given radius and tube radius
 * @method torus
 * @param  {Number} radius        radius of the whole ring
 * @param  {Number} tubeRadius    radius of the tube
 * @param  {Number} [detailX]     optional: number of segments in x-dimension,
 *                                the more segments the smoother geometry
 *                                default is 24
 * @param  {Number} [detailY]     optional: number of segments in y-dimension,
 *                                the more segments the smoother geometry
 *                                default is 16
 * @return {p5}                   the p5 object
 * @example
 * <div>
 * <code>
 * //draw a spinning torus with radius 200 and tube radius 60
 * function setup(){
 *   createCanvas(100, 100, WEBGL);
 * }
 *
 * function draw(){
 *   background(200);
 *   rotateX(frameCount * 0.01);
 *   rotateY(frameCount * 0.01);
 *   torus(200, 60);
 * }
 * </code>
 * </div>
 */
p5.prototype.torus = function(){
  var args = new Array(arguments.length);
  for (var i = 0; i < args.length; ++i) {
    args[i] = arguments[i];
  }
  var detailX = typeof args[2] === 'number' ? args[2] : 24;
  var detailY = typeof args[3] === 'number' ? args[3] : 16;

  var radius = args[0] || 50;
  var tubeRadius = args[1] || 10;

  var gId = 'torus|'+radius+'|'+tubeRadius+'|'+detailX+'|'+detailY;

  if(!this._renderer.geometryInHash(gId)){
    var _torus = function(){
      var u,v,p;
      for (var i = 0; i <= this.detailY; i++){
        v = i / this.detailY;
        for (var j = 0; j <= this.detailX; j++){
          u = j / this.detailX;
          var theta = 2 * Math.PI * u;
          var phi = 2 * Math.PI * v;
          p = new p5.Vector(
            (radius + tubeRadius * Math.cos(phi)) * Math.cos(theta),
            (radius + tubeRadius * Math.cos(phi)) * Math.sin(theta),
            tubeRadius * Math.sin(phi));
          this.vertices.push(p);
          this.uvs.push([u,v]);
        }
      }
    };
    var torusGeom = new p5.Geometry(detailX, detailY, _torus);
    torusGeom
      .computeFaces()
      .computeNormals()
      .averageNormals();
    this._renderer.createBuffers(gId, torusGeom);
  }

  this._renderer.drawBuffers(gId);

  return this;
};

///////////////////////
/// 2D primitives
/////////////////////////

//@TODO
p5.RendererGL.prototype.point = function(x, y, z){
  console.log('point not yet implemented in webgl');
  return this;
};

p5.RendererGL.prototype.triangle = function
(args){
  var x1=args[0], y1=args[1];
  var x2=args[2], y2=args[3];
  var x3=args[4], y3=args[5];
  var gId = 'tri|'+x1+'|'+y1+'|'+
  x2+'|'+y2+'|'+
  x3+'|'+y3;
  if(!this.geometryInHash(gId)){
    var _triangle = function(){
      var vertices = [];
      vertices.push(new p5.Vector(x1,y1,0));
      vertices.push(new p5.Vector(x2,y2,0));
      vertices.push(new p5.Vector(x3,y3,0));
      this.vertices = vertices;
      this.faces = [[0,1,2]];
      this.uvs = [[0,0],[0,1],[1,1]];
    };
    var triGeom = new p5.Geometry(1,1,_triangle);
    triGeom.computeNormals();
    this.createBuffers(gId, triGeom);
  }

  this.drawBuffers(gId);
  return this;
};

p5.RendererGL.prototype.ellipse = function
(args){
  var x = args[0];
  var y = args[1];
  var width = args[2];
  var height = args[3];
  //detailX and Y are optional 6th & 7th
  //arguments
  var detailX = args[4] || 24;
  var detailY = args[5] || 16;
  var gId = 'ellipse|'+args[0]+'|'+args[1]+'|'+args[2]+'|'+
  args[3];
  if(!this.geometryInHash(gId)){
    var _ellipse = function(){
      var u,v,p;
      var centerX = x+width*0.5;
      var centerY = y+height*0.5;
      for (var i = 0; i <= this.detailY; i++){
        v = i / this.detailY;
        for (var j = 0; j <= this.detailX; j++){
          u = j / this.detailX;
          var theta = 2 * Math.PI * u;
          if(v === 0){
            p = new p5.Vector(centerX, centerY, 0);
          }
          else{
            var _x = centerX + width*0.5 * Math.cos(theta);
            var _y = centerY + height*0.5 * Math.sin(theta);
            p = new p5.Vector(_x, _y, 0);
          }
          this.vertices.push(p);
          this.uvs.push([u,v]);
        }
      }
    };
    var ellipseGeom = new p5.Geometry(detailX,detailY,_ellipse);
    ellipseGeom
      .computeFaces()
      .computeNormals();
    this.createBuffers(gId, ellipseGeom);
  }
  this.drawBuffers(gId);
  return this;
};

p5.RendererGL.prototype.rect = function
(args){
  var gId = 'rect|'+args[0]+'|'+args[1]+'|'+args[2]+'|'+
  args[3];
  var x = args[0];
  var y = args[1];
  var width = args[2];
  var height = args[3];
  var detailX = args[4] || 24;
  var detailY = args[5] || 16;
  if(!this.geometryInHash(gId)){
    var _rect = function(){
      var u,v,p;
      for (var i = 0; i <= this.detailY; i++){
        v = i / this.detailY;
        for (var j = 0; j <= this.detailX; j++){
          u = j / this.detailX;
          // var _x = x-width/2;
          // var _y = y-height/2;
          p = new p5.Vector(
            x + (width*u),
            y + (height*v),
            0
          );
          this.vertices.push(p);
          this.uvs.push([u,v]);
        }
      }
    };
    var rectGeom = new p5.Geometry(detailX,detailY,_rect);
    rectGeom
      .computeFaces()
      .computeNormals();
    this.createBuffers(gId, rectGeom);
  }
  this.drawBuffers(gId);
  return this;
};

p5.RendererGL.prototype.quad = function(){
  var args = new Array(arguments.length);
  for (var i = 0; i < args.length; ++i) {
    args[i] = arguments[i];
  }
  var x1 = args[0],
    y1 = args[1],
    x2 = args[2],
    y2 = args[3],
    x3 = args[4],
    y3 = args[5],
    x4 = args[6],
    y4 = args[7];
  var gId = 'quad|'+x1+'|'+y1+'|'+
  x2+'|'+y2+'|'+
  x3+'|'+y3+'|'+
  x4+'|'+y4;
  if(!this.geometryInHash(gId)){
    var _quad = function(){
      this.vertices.push(new p5.Vector(x1,y1,0));
      this.vertices.push(new p5.Vector(x2,y2,0));
      this.vertices.push(new p5.Vector(x3,y3,0));
      this.vertices.push(new p5.Vector(x4,y4,0));
      this.uvs.push([0, 0], [1, 0], [1, 1], [0, 1]);
    };
    var quadGeom = new p5.Geometry(2,2,_quad);
    quadGeom.computeNormals();
    quadGeom.faces = [[0,1,2],[2,3,0]];
    this.createBuffers(gId, quadGeom);
  }
  this.drawBuffers(gId);
  return this;
};

//this implementation of bezier curve
//is based on Bernstein polynomial
p5.RendererGL.prototype.bezier = function
(args){
  var bezierDetail=args[12] || 20;//value of Bezier detail
  this.beginShape();
  var coeff=[0,0,0,0];//  Bernstein polynomial coeffecients
  var vertex=[0,0,0]; //(x,y,z) coordinates of points in bezier curve
  for(var i=0; i<=bezierDetail; i++){
    coeff[0]=Math.pow(1-(i/bezierDetail),3);
    coeff[1]=(3*(i/bezierDetail)) * (Math.pow(1-(i/bezierDetail),2));
    coeff[2]=(3*Math.pow(i/bezierDetail,2)) * (1-(i/bezierDetail));
    coeff[3]=Math.pow(i/bezierDetail,3);
    vertex[0]=args[0]*coeff[0] + args[3]*coeff[1] +
              args[6]*coeff[2] + args[9]*coeff[3];
    vertex[1]=args[1]*coeff[0] + args[4]*coeff[1] +
              args[7]*coeff[2] + args[10]*coeff[3];
    vertex[2]=args[2]*coeff[0] + args[5]*coeff[1] +
              args[8]*coeff[2] + args[11]*coeff[3];
    this.vertex(vertex[0],vertex[1],vertex[2]);
  }
  this.endShape();
  return this;
};

p5.RendererGL.prototype.curve=function
(args){
  var curveDetail=args[12];
  this.beginShape();
  var coeff=[0,0,0,0];//coeffecients of the equation
  var vertex=[0,0,0]; //(x,y,z) coordinates of points in bezier curve
  for(var i=0; i<=curveDetail; i++){
    coeff[0]=Math.pow((i/curveDetail),3) * 0.5;
    coeff[1]=Math.pow((i/curveDetail),2) * 0.5;
    coeff[2]=(i/curveDetail) * 0.5;
    coeff[3]=0.5;
    vertex[0]=coeff[0]*(-args[0] + (3*args[3]) - (3*args[6]) +args[9]) +
              coeff[1]*((2*args[0]) - (5*args[3]) + (4*args[6]) - args[9]) +
              coeff[2]*(-args[0] + args[6]) +
              coeff[3]*(2*args[3]);
    vertex[1]=coeff[0]*(-args[1] + (3*args[4]) - (3*args[7]) +args[10]) +
              coeff[1]*((2*args[1]) - (5*args[4]) + (4*args[7]) - args[10]) +
              coeff[2]*(-args[1] + args[7]) +
              coeff[3]*(2*args[4]);
    vertex[2]=coeff[0]*(-args[2] + (3*args[5]) - (3*args[8]) +args[11]) +
              coeff[1]*((2*args[2]) - (5*args[5]) + (4*args[8]) - args[11]) +
              coeff[2]*(-args[2] + args[8]) +
              coeff[3]*(2*args[5]);
    this.vertex(vertex[0],vertex[1],vertex[2]);
  }
  this.endShape();
  return this;
};

module.exports = p5;

},{"../core/core":42,"./p5.Geometry":87}],93:[function(_dereq_,module,exports){


module.exports = {
  immediateVert:
    "attribute vec3 aPosition;\nattribute vec4 aVertexColor;\n\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\nuniform float uResolution;\nuniform float uPointSize;\n\nvarying vec4 vColor;\nvoid main(void) {\n  vec4 positionVec4 = vec4(aPosition * vec3(1.0, -1.0, 1.0), 1.0);\n  gl_Position = uProjectionMatrix * uModelViewMatrix * positionVec4;\n  vColor = aVertexColor;\n  gl_PointSize = uPointSize;\n}\n",
  vertexColorVert:
    "attribute vec3 aPosition;\nattribute vec4 aVertexColor;\n\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\n\nvarying vec4 vColor;\n\nvoid main(void) {\n  vec4 positionVec4 = vec4(aPosition * vec3(1.0, -1.0, 1.0), 1.0);\n  gl_Position = uProjectionMatrix * uModelViewMatrix * positionVec4;\n  vColor = aVertexColor;\n}\n",
  vertexColorFrag:
    "precision mediump float;\nvarying vec4 vColor;\nvoid main(void) {\n  gl_FragColor = vColor;\n}",
  normalVert:
    "attribute vec3 aPosition;\nattribute vec3 aNormal;\nattribute vec2 aTexCoord;\n\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\nuniform mat3 uNormalMatrix;\n\nvarying vec3 vVertexNormal;\nvarying highp vec2 vVertTexCoord;\n\nvoid main(void) {\n  vec4 positionVec4 = vec4(aPosition * vec3(1.0, -1.0, 1.0), 1.0);\n  gl_Position = uProjectionMatrix * uModelViewMatrix * positionVec4;\n  vVertexNormal = vec3( uNormalMatrix * aNormal );\n  vVertTexCoord = aTexCoord;\n}\n",
  normalFrag:
    "precision mediump float;\nvarying vec3 vVertexNormal;\nvoid main(void) {\n  gl_FragColor = vec4(vVertexNormal, 1.0);\n}",
  basicFrag:
    "precision mediump float;\nvarying vec3 vVertexNormal;\nuniform vec4 uMaterialColor;\nvoid main(void) {\n  gl_FragColor = uMaterialColor;\n}",
  lightVert:
    "attribute vec3 aPosition;\nattribute vec3 aNormal;\nattribute vec2 aTexCoord;\n\nuniform mat4 uModelViewMatrix;\nuniform mat4 uProjectionMatrix;\nuniform mat3 uNormalMatrix;\nuniform int uAmbientLightCount;\nuniform int uDirectionalLightCount;\nuniform int uPointLightCount;\n\nuniform vec3 uAmbientColor[8];\nuniform vec3 uLightingDirection[8];\nuniform vec3 uDirectionalColor[8];\nuniform vec3 uPointLightLocation[8];\nuniform vec3 uPointLightColor[8];\nuniform bool uSpecular;\n\nvarying vec3 vVertexNormal;\nvarying vec2 vVertTexCoord;\nvarying vec3 vLightWeighting;\n\nvec3 ambientLightFactor = vec3(0.0, 0.0, 0.0);\nvec3 directionalLightFactor = vec3(0.0, 0.0, 0.0);\nvec3 pointLightFactor = vec3(0.0, 0.0, 0.0);\nvec3 pointLightFactor2 = vec3(0.0, 0.0, 0.0);\n\nvoid main(void){\n\n  vec4 positionVec4 = vec4(aPosition, 1.0);\n  gl_Position = uProjectionMatrix * uModelViewMatrix * positionVec4;\n\n  vec3 vertexNormal = vec3( uNormalMatrix * aNormal );\n  vVertexNormal = vertexNormal;\n  vVertTexCoord = aTexCoord;\n\n  vec4 mvPosition = uModelViewMatrix * vec4(aPosition, 1.0);\n  vec3 eyeDirection = normalize(-mvPosition.xyz);\n\n  float shininess = 32.0;\n  float specularFactor = 2.0;\n  float diffuseFactor = 0.3;\n\n  for(int i = 0; i < 8; i++){\n    if(uAmbientLightCount == i) break;\n    ambientLightFactor += uAmbientColor[i];\n  }\n\n  for(int j = 0; j < 8; j++){\n    if(uDirectionalLightCount == j) break;\n    vec3 dir = uLightingDirection[j];\n    float directionalLightWeighting = max(dot(vertexNormal, dir), 0.0);\n    directionalLightFactor += uDirectionalColor[j] * directionalLightWeighting;\n  }\n\n  for(int k = 0; k < 8; k++){\n    if(uPointLightCount == k) break;\n    vec3 loc = uPointLightLocation[k];\n    vec3 lightDirection = normalize(loc - mvPosition.xyz);\n\n    float directionalLightWeighting = max(dot(vertexNormal, lightDirection), 0.0);\n    pointLightFactor += uPointLightColor[k] * directionalLightWeighting;\n\n    //factor2 for specular\n    vec3 reflectionDirection = reflect(-lightDirection, vertexNormal);\n    float specularLightWeighting = pow(max(dot(reflectionDirection, eyeDirection), 0.0), shininess);\n\n    pointLightFactor2 += uPointLightColor[k] * (specularFactor * specularLightWeighting\n      +  directionalLightWeighting * diffuseFactor);\n  }\n\n  if(!uSpecular){\n    vLightWeighting =  ambientLightFactor + directionalLightFactor + pointLightFactor;\n  }else{\n    vLightWeighting = ambientLightFactor + directionalLightFactor + pointLightFactor2;\n  }\n\n}\n",
  lightTextureFrag:
    "precision mediump float;\n\nuniform vec4 uMaterialColor;\nuniform sampler2D uSampler;\nuniform bool isTexture;\n\nvarying vec3 vLightWeighting;\nvarying highp vec2 vVertTexCoord;\n\nvoid main(void) {\n  if(!isTexture){\n    gl_FragColor = vec4(vec3(uMaterialColor.rgb * vLightWeighting), uMaterialColor.a);\n  }else{\n    vec4 textureColor = texture2D(uSampler, vVertTexCoord);\n    if(vLightWeighting == vec3(0., 0., 0.)){\n      gl_FragColor = textureColor;\n    }else{\n      gl_FragColor = vec4(vec3(textureColor.rgb * vLightWeighting), textureColor.a);\n    }\n  }\n}"
};
},{}]},{},[33])(33)
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(151)))

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Country = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // Country class: creates a new particle system

var _ParticleSystem = __webpack_require__(70);

var _latlng = __webpack_require__(147);

var latlng = _interopRequireWildcard(_latlng);

var _tradeData = __webpack_require__(148);

var trade = _interopRequireWildcard(_tradeData);

var _index = __webpack_require__(6);

var _utils = __webpack_require__(12);

var _sounds = __webpack_require__(16);

var _tone = __webpack_require__(63);

var Tone = _interopRequireWildcard(_tone);

var _Timeline = __webpack_require__(28);

var _underscore = __webpack_require__(150);

var _ = _interopRequireWildcard(_underscore);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var colors = (0, _utils.colorPallet)();

var Country = function () {
  function Country() {
    var _this = this;

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _classCallCheck(this, Country);

    args = args[0];
    this.Country = args[0];
    this.tradeType = args[1];
    this.Elt = args[2];
    this.Color = colors();
    this.Opacity = 200;
    this.Trail = 2;
    this.id = this.Country + this.tradeType;

    this.system = new _ParticleSystem.ParticleSystem();
    this.trade = trade[this.Country][this.tradeType];
    this.origin = latlng[this.Country];
    //this.instrument = setCurrentInstrument(false);
    this.getInstrumentBasedOnAverageTrade();
    //this.soundType = soundTypes[this.instrument].sounds[0]; // Always the same sound.
    this.soundType = _index.p5Instance.random(_sounds.soundTypes[this.instrument].sounds); // Randoms sounds.
    this.showOriginName = function () {
      (0, _utils.showName)(_this.Country, _this.id, _index.map.latLngToPixel(_this.origin), _this.Color, true);
    };
    this.Start();
  }

  _createClass(Country, [{
    key: 'getInstrumentBasedOnAverageTrade',
    value: function getInstrumentBasedOnAverageTrade() {
      var sum = 0;
      for (var country in this.trade) {
        sum += parseInt(this.trade[country]);
      }
      var average = parseInt(sum / Object.keys(this.trade).length);

      if (this.tradeType == 'exports') {
        var avgToIndex = (0, _utils.getIndexFromAllExportsSorted)(average);
        this.average = parseInt(_index.p5Instance.map(avgToIndex, 0, 100, 1, 7));
      } else {
        var _avgToIndex = (0, _utils.getIndexFromAllImportsSorted)(average);
        this.average = parseInt(_index.p5Instance.map(_avgToIndex, 0, 100, 1, 7));
      };
      _.sortBy();
      this.instrument = (0, _sounds.setCurrentInstrument)(this.average);
      this.tempo = (0, _sounds.getTempo)();
    }
  }, {
    key: 'Start',
    value: function Start() {
      var _this2 = this;

      // Create a shuffle array with the names of the destination countries
      var destinationCountries = _index.p5Instance.shuffle(Object.keys(this.trade), true);
      var currentDestinationCountry = 0;
      _index.map.onChange(this.showOriginName);

      console.log(this.Country, this.average, this.instrument);

      (0, _Timeline.addCountryToTimeline)(this.Country, this.tradeType, this.Color);
      this.loop = new Tone.Loop(function (time) {
        var destinationName = destinationCountries[currentDestinationCountry];
        var destination = latlng[destinationName];
        if (latlng[destinationName]) {
          var size = (0, _utils.scale)(_this2.trade[destinationName]);
          size = _index.p5Instance.constrain(size, 2, 64);
          _this2.system.addParticle(_this2.origin, destination, _this2.Country, destinationName, size, _this2.Color, _this2.Opacity, _this2.Trail, _this2.tradeType, _this2.soundType);
        } else {
          if (currentDestinationCountry < destinationCountries.length) {
            console.warn(destinationName + " not found :(");
          }
        }
        if (currentDestinationCountry < destinationCountries.length) {
          currentDestinationCountry++;
        } else {
          _this2.Stop();
          (0, _Timeline.removeCountryFromTimeline)(_this2.Country, _this2.tradeType);
          // Check if this the lowMono (we only want one low mono playing at a time)
          // if (this.instrument == 'LowMono') {
          //   releaseLowMono();
          // }
        }
      }, _sounds.soundTypes[this.instrument].loop).start(_sounds.soundTypes[this.instrument].tempo);
    }
  }, {
    key: 'Stop',
    value: function Stop() {
      try {
        if (this.loop != null) {
          this.loop.dispose();
        };
        _index.map.removeOnChange(this.showOriginName);
        var name = document.getElementById(this.id);
        this.Elt.style.color = '#c7c7c7';
        name.parentNode.removeChild(name);
      } catch (error) {
        console.log(error);
      }
    }
  }]);

  return Country;
}();

exports.Country = Country;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Particle = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // Base Particle

var _index = __webpack_require__(6);

var _utils = __webpack_require__(12);

var _sounds = __webpack_require__(16);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Particle = function () {
  function Particle() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _classCallCheck(this, Particle);

    args = args[0];

    this.origin = args[0];
    this.destination = args[1];
    this.originName = args[2];
    this.destinationName = args[3];
    this.maxSize = args[4];
    this.color = args[5];
    this.opacity = args[6];
    this.trail = args[7];
    this.tradeType = args[8];
    this.soundType = args[9];

    this.id = this.originName + this.destinationName;
    this.amount = _index.p5Instance.createVector(0, 0);
    this.position = _index.p5Instance.createVector(0, 0);
    this.steps = 0.003;
    this.size = 0;
    this.reachSize = false;
    this.history = [];
  }

  _createClass(Particle, [{
    key: 'display',
    value: function display() {

      // Get latlng everytime since the map can change
      try {
        this.posOrigin = _index.map.latLngToPixel(this.origin.lat, this.origin.lng);
        this.posDestination = _index.map.latLngToPixel(this.destination.lat, this.destination.lng);

        // Handle the size
        this.size < this.maxSize && !this.reachSize && (this.size += 1);
        this.size >= this.maxSize && (this.reachSize = true);
        //(this.amount.x > 0.97 && this.reachSize) && (this.size -= 1);

        // Play sounds at start
        if (this.amount.x == 0) {
          (0, _sounds.playSound)(this.soundType);
        }

        // Calculate distance and path
        if (this.amount.x < 1) {
          this.tradeType == 'imports' ? this.position.x = _index.p5Instance.lerp(this.posDestination.x, this.posOrigin.x, this.amount.x) : this.position.x = _index.p5Instance.lerp(this.posOrigin.x, this.posDestination.x, this.amount.x);
          this.amount.x += this.steps;
        }
        if (this.amount.y < 1) {
          this.tradeType == 'imports' ? this.position.y = _index.p5Instance.lerp(this.posDestination.y, this.posOrigin.y, this.amount.y) : this.position.y = _index.p5Instance.lerp(this.posOrigin.y, this.posDestination.y, this.amount.y);
          this.amount.y += this.steps;
        }

        // Particle's trail
        this.history.push(this.position.copy());
        this.history.length > this.trail && this.history.splice(0, 1);
        for (var i = 0; i < this.history.length; i++) {
          var pos = this.history[i];
          _index.p5Instance.fill(this.color[0], this.color[1], this.color[2], this.opacity / 15 * i);
          _index.p5Instance.ellipse(pos.x, pos.y, this.size, this.size);
        }

        // Show Countries Name
        // Show partner country only when the particle is really close
        if (this.tradeType == 'imports') {
          this.amount.x < 0.1 && (0, _utils.showName)(this.destinationName, this.id, this.posDestination, this.color, false);
          this.amount.x > 0.1 && document.getElementById(this.id) && document.getElementById(this.id).remove(); // delete the dom text
        } else {
          this.amount.x > 0.9 && (0, _utils.showName)(this.destinationName, this.id, this.posDestination, this.color, false);
          this.amount.x > 0.99 && document.getElementById(this.id).remove(); // delete the dom text
        }

        // Actual Particle
        _index.p5Instance.fill(this.color[0], this.color[1], this.color[2], this.opacity);
        _index.p5Instance.ellipse(this.position.x, this.position.y, this.size, this.size);

        // If arrived, erase from particle array
        if (this.amount.x >= 1 && this.amount.y >= 1) {
          this.lifespan = -1;
        }
      } catch (error) {
        console.log('Error! :(', error);
      }
    }
  }, {
    key: 'isDead',


    // Erase once it has arrived
    value: function isDead() {
      if (this.lifespan < 0) {
        return true;
      } else {
        return false;
      }
    }
  }]);

  return Particle;
}();

exports.Particle = Particle;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ParticleSystem = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // Particle System

var _Particle = __webpack_require__(69);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ParticleSystem = function () {
  function ParticleSystem() {
    _classCallCheck(this, ParticleSystem);

    this.particles = [];
    this.ended = false;
    this.started = false;
  }

  _createClass(ParticleSystem, [{
    key: "addParticle",
    value: function addParticle() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      this.originName = args[2];
      this.particles.push(new _Particle.Particle(args));
    }
  }, {
    key: "run",
    value: function run() {
      for (var i = this.particles.length - 1; i >= 0; i--) {
        var p = this.particles[i];
        this.started = true;
        p.display();
        p.isDead() && this.particles.splice(i, 1);
      }

      if (this.particles.length == 0 && this.started) {
        var originName = document.getElementById("originName"); // delete this name once it has ended.
        originName && originName.remove();
        this.ended = true;
      }
    }
  }, {
    key: "currentParticles",
    value: function currentParticles() {
      return this.particles;
    }
  }]);

  return ParticleSystem;
}();

exports.ParticleSystem = ParticleSystem;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var validCountries = exports.validCountries = ['Colombia', 'Niger', 'Palau', 'Jordan', 'Bosnia Herzegovina', 'Belgium', 'Singapore', 'Albania', 'Benin', 'Indonesia', 'Australia', 'Armenia', 'Spain', 'Ireland', 'Botswana', 'Mauritania', 'Chile', 'Malaysia', 'Peru', 'Portugal', 'China', 'Israel', 'Paraguay', 'Antigua and Barbuda', 'Cyprus', 'Mauritius', 'Slovakia', 'Bahrain', 'Guyana', 'USA', 'Rep. of Moldova', 'Malta', 'Ecuador', 'France', 'Italy', 'Belarus', 'Ethiopia', 'Senegal', 'Solomon Isds', 'Bulgaria', 'Montenegro', 'Sri Lanka', 'Hungary', 'New Zealand', 'Samoa', 'Myanmar', 'South Africa', 'Uruguay', 'Germany', 'Togo', 'Poland', 'United Kingdom', 'Argentina', 'Brazil', 'Russian Federation', 'Rwanda', 'El Salvador', 'Switzerland', 'Latvia', 'Japan', 'Romania', 'Croatia', 'Madagascar', 'Barbados', 'Oman', 'Sweden', 'Maldives', 'India', 'Jamaica', 'Mexico', 'Zimbabwe', 'Lithuania', 'Denmark', 'Namibia', 'Costa Rica', 'Greece', 'Kazakhstan', 'Egypt', 'Estonia', 'Morocco', 'Luxembourg', 'TFYR of Macedonia', 'United Rep. of Tanzania', 'Belize', 'Georgia', 'Bermuda', 'Greenland', 'China, Hong Kong SAR', 'Norway', 'Sierra Leone', 'Philippines', 'Sao Tome and Principe', 'Kyrgyzstan', 'Czechia', 'Aruba', 'Turkey', 'Rep. of Korea', 'Serbia', 'Canada', 'Iceland'];

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pairs__ = __webpack_require__(35);


/* harmony default export */ __webpack_exports__["a"] = (function(values0, values1, reduce) {
  var n0 = values0.length,
      n1 = values1.length,
      values = new Array(n0 * n1),
      i0,
      i1,
      i,
      value0;

  if (reduce == null) reduce = __WEBPACK_IMPORTED_MODULE_0__pairs__["b" /* pair */];

  for (i0 = i = 0; i0 < n0; ++i0) {
    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
      values[i] = reduce(value0, values1[i1]);
    }
  }

  return values;
});


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisect__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extent__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__identity__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__range__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ticks__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__ = __webpack_require__(37);









/* harmony default export */ __webpack_exports__["a"] = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */],
      domain = __WEBPACK_IMPORTED_MODULE_3__extent__["a" /* default */],
      threshold = __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__["a" /* default */];

  function histogram(data) {
    var i,
        n = data.length,
        x,
        values = new Array(n);

    for (i = 0; i < n; ++i) {
      values[i] = value(data[i], i, data);
    }

    var xz = domain(values),
        x0 = xz[0],
        x1 = xz[1],
        tz = threshold(values, x0, x1);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      tz = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__ticks__["c" /* tickStep */])(x0, x1, tz);
      tz = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__range__["a" /* default */])(Math.ceil(x0 / tz) * tz, Math.floor(x1 / tz) * tz, tz); // exclusive
    }

    // Remove any thresholds outside the domain.
    var m = tz.length;
    while (tz[0] <= x0) tz.shift(), --m;
    while (tz[m - 1] > x1) tz.pop(), --m;

    var bins = new Array(m + 1),
        bin;

    // Initialize bins.
    for (i = 0; i <= m; ++i) {
      bin = bins[i] = [];
      bin.x0 = i > 0 ? tz[i - 1] : x0;
      bin.x1 = i < m ? tz[i] : x1;
    }

    // Assign data to bins by value, ignoring any outside the domain.
    for (i = 0; i < n; ++i) {
      x = values[i];
      if (x0 <= x && x <= x1) {
        bins[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__bisect__["a" /* default */])(tz, x, 0, m)].push(data[i]);
      }
    }

    return bins;
  }

  histogram.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : value;
  };

  histogram.domain = function(_) {
    return arguments.length ? (domain = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])([_[0], _[1]]), histogram) : domain;
  };

  histogram.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["b" /* slice */].call(_)) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : threshold;
  };

  return histogram;
});


/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  return max;
});


/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(7);


/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      m = n,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) sum += value;
      else --m;
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) sum += value;
      else --m;
    }
  }

  if (m) return sum / m;
});


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__number__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__quantile__ = __webpack_require__(17);




/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      numbers = [];

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(values[i]))) {
        numbers.push(value);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(valueof(values[i], i, values)))) {
        numbers.push(value);
      }
    }
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__quantile__["a" /* default */])(numbers.sort(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]), 0.5);
});


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(arrays) {
  var n = arrays.length,
      m,
      i = -1,
      j = 0,
      merged,
      array;

  while (++i < n) j += arrays[i].length;
  merged = new Array(j);

  while (--n >= 0) {
    array = arrays[n];
    m = array.length;
    while (--m >= 0) {
      merged[--j] = array[m];
    }
  }

  return merged;
});


/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(array, indexes) {
  var i = indexes.length, permutes = new Array(i);
  while (i--) permutes[i] = array[indexes[i]];
  return permutes;
});


/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(5);


/* harmony default export */ __webpack_exports__["a"] = (function(values, compare) {
  if (!(n = values.length)) return;
  var n,
      i = 0,
      j = 0,
      xi,
      xj = values[j];

  if (compare == null) compare = __WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */];

  while (++i < n) {
    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
      xj = xi, j = i;
    }
  }

  if (compare(xj, xj) === 0) return j;
});


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(array, i0, i1) {
  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m + i0];
    array[m + i0] = array[i + i0];
    array[i + i0] = t;
  }

  return array;
});


/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    }
  }

  else {
    while (++i < n) {
      if (value = +valueof(values[i], i, values)) sum += value;
    }
  }

  return sum;
});


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__quantile__ = __webpack_require__(17);





/* harmony default export */ __webpack_exports__["a"] = (function(values, min, max) {
  values = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(values, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]).sort(__WEBPACK_IMPORTED_MODULE_1__ascending__["a" /* default */]);
  return Math.ceil((max - min) / (2 * (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.75) - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.25)) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deviation__ = __webpack_require__(32);


/* harmony default export */ __webpack_exports__["a"] = (function(values, min, max) {
  return Math.ceil((max - min) / (3.5 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__deviation__["a" /* default */])(values) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transpose__ = __webpack_require__(39);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__transpose__["a" /* default */])(arguments);
});


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(map) {
  var entries = [];
  for (var key in map) entries.push({key: key, value: map[key]});
  return entries;
});


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(map) {
  var keys = [];
  for (var key in map) keys.push(key);
  return keys;
});


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(18);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  var keys = [],
      sortKeys = [],
      sortValues,
      rollup,
      nest;

  function apply(array, depth, createResult, setResult) {
    if (depth >= keys.length) {
      if (sortValues != null) array.sort(sortValues);
      return rollup != null ? rollup(array) : array;
    }

    var i = -1,
        n = array.length,
        key = keys[depth++],
        keyValue,
        value,
        valuesByKey = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])(),
        values,
        result = createResult();

    while (++i < n) {
      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
        values.push(value);
      } else {
        valuesByKey.set(keyValue, [value]);
      }
    }

    valuesByKey.each(function(values, key) {
      setResult(result, key, apply(values, depth, createResult, setResult));
    });

    return result;
  }

  function entries(map, depth) {
    if (++depth > keys.length) return map;
    var array, sortKey = sortKeys[depth - 1];
    if (rollup != null && depth >= keys.length) array = map.entries();
    else array = [], map.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
  }

  return nest = {
    object: function(array) { return apply(array, 0, createObject, setObject); },
    map: function(array) { return apply(array, 0, createMap, setMap); },
    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
    key: function(d) { keys.push(d); return nest; },
    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
    sortValues: function(order) { sortValues = order; return nest; },
    rollup: function(f) { rollup = f; return nest; }
  };
});

function createObject() {
  return {};
}

function setObject(object, key, value) {
  object[key] = value;
}

function createMap() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])();
}

function setMap(map, key, value) {
  map.set(key, value);
}


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(18);


function Set() {}

var proto = __WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */].prototype;

Set.prototype = set.prototype = {
  constructor: Set,
  has: proto.has,
  add: function(value) {
    value += "";
    this[__WEBPACK_IMPORTED_MODULE_0__map__["b" /* prefix */] + value] = value;
    return this;
  },
  remove: proto.remove,
  clear: proto.clear,
  values: proto.keys,
  size: proto.size,
  empty: proto.empty,
  each: proto.each
};

function set(object, f) {
  var set = new Set;

  // Copy constructor.
  if (object instanceof Set) object.each(function(value) { set.add(value); });

  // Otherwise, assume it’s an array.
  else if (object) {
    var i = -1, n = object.length;
    if (f == null) while (++i < n) set.add(object[i]);
    else while (++i < n) set.add(f(object[i], i, object));
  }

  return set;
}

/* harmony default export */ __webpack_exports__["a"] = (set);


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(map) {
  var values = [];
  for (var key in map) values.push(map[key]);
  return values;
});


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cubehelix;
/* unused harmony export Cubehelix */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(42);




var A = -0.14861,
    B = +1.78277,
    C = -0.29227,
    D = -0.90649,
    E = +1.97294,
    ED = E * D,
    EB = E * B,
    BC_DA = B * C - D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["a" /* Rgb */])) o = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["b" /* rgbConvert */])(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g - l) - C * bl) / D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
      h = s ? Math.atan2(k, bl) * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* rad2deg */] - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Cubehelix, cubehelix, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* Color */], {
  brighter: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["d" /* brighter */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["d" /* brighter */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["e" /* darker */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["e" /* darker */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* deg2rad */],
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["a" /* Rgb */](
      255 * (l + a * (A * cosh + B * sinh)),
      255 * (l + a * (C * cosh + D * sinh)),
      255 * (l + a * (E * cosh)),
      this.opacity
    );
  }
}));


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = lab;
/* unused harmony export Lab */
/* harmony export (immutable) */ __webpack_exports__["a"] = hcl;
/* unused harmony export Hcl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(42);




var Kn = 18,
    Xn = 0.950470, // D65 standard referent
    Yn = 1,
    Zn = 1.088830,
    t0 = 4 / 29,
    t1 = 6 / 29,
    t2 = 3 * t1 * t1,
    t3 = t1 * t1 * t1;

function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) {
    var h = o.h * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* deg2rad */];
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
  }
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["a" /* Rgb */])) o = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["b" /* rgbConvert */])(o);
  var b = rgb2xyz(o.r),
      a = rgb2xyz(o.g),
      l = rgb2xyz(o.b),
      x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
      y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
      z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}

function lab(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}

function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Lab, lab, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* Color */], {
  brighter: function(k) {
    return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker: function(k) {
    return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
    y = Yn * lab2xyz(y);
    x = Xn * lab2xyz(x);
    z = Zn * lab2xyz(z);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["a" /* Rgb */](
      xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
      xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
      xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z),
      this.opacity
    );
  }
}));

function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}

function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}

function xyz2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}

function rgb2xyz(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  var h = Math.atan2(o.b, o.a) * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* rad2deg */];
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}

function hcl(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hcl, hcl, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* Color */], {
  brighter: function(k) {
    return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
  },
  darker: function(k) {
    return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
  },
  rgb: function() {
    return labConvert(this).rgb();
  }
}));


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return format; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatPrefix; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__(47);


var locale;
var format;
var formatPrefix;

defaultLocale({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});

function defaultLocale(definition) {
  locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* default */])(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}


/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  x = x.toPrecision(p);

  out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (x[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      case "e": break out;
      default: if (i0 > 0) i0 = 0; break;
    }
  }

  return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
});


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
});


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
});


/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(21);


/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
});


/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(13);


/* harmony default export */ __webpack_exports__["a"] = (function(step) {
  return Math.max(0, -__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(13);


/* harmony default export */ __webpack_exports__["a"] = (function(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(value) / 3))) * 3 - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(13);


/* harmony default export */ __webpack_exports__["a"] = (function(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(max) - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(step)) + 1;
});


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cubehelixLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(9);



function cubehelix(hue) {
  return (function cubehelixGamma(y) {
    y = +y;

    function cubehelix(start, end) {
      var h = hue((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(start)).h, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(end)).h),
          s = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
          l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
          opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
      return function(t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix.gamma = cubehelixGamma;

    return cubehelix;
  })(1);
}

/* unused harmony default export */ var _unused_webpack_default_export = (cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["b" /* hue */]));
var cubehelixLong = cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hclLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(9);



function hcl(hue) {
  return function(start, end) {
    var h = hue((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* hcl */])(start)).h, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* hcl */])(end)).h),
        c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.c, end.c),
        l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (hcl(__WEBPACK_IMPORTED_MODULE_1__color__["b" /* hue */]));
var hclLong = hcl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hslLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(9);



function hsl(hue) {
  return function(start, end) {
    var h = hue((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* hsl */])(start)).h, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* hsl */])(end)).h),
        s = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
        l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (hsl(__WEBPACK_IMPORTED_MODULE_1__color__["b" /* hue */]));
var hslLong = hsl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(9);



function lab(start, end) {
  var l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* lab */])(start)).l, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* lab */])(end)).l),
      a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.a, end.a),
      b = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.b, end.b),
      opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
  return function(t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + "";
  };
}


/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
  return samples;
});


/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return Math.round(a + b * t);
  };
});


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return identity; });
var degrees = 180 / Math.PI;

var identity = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

/* harmony default export */ __webpack_exports__["b"] = (function(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
});


/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export interpolateTransformCss */
/* unused harmony export interpolateTransformSvg */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse__ = __webpack_require__(112);



function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["a" /* parseCss */], "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["b" /* parseSvg */], ", ", ")", ")");


/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseCss;
/* harmony export (immutable) */ __webpack_exports__["b"] = parseSvg;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__decompose__ = __webpack_require__(110);


var cssNode,
    cssRoot,
    cssView,
    svgNode;

function parseCss(value) {
  if (value === "none") return __WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* identity */];
  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
  cssNode.style.transform = value;
  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
  cssRoot.removeChild(cssNode);
  value = value.slice(7, -1).split(",");
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* default */])(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}

function parseSvg(value) {
  if (value == null) return __WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* identity */];
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return __WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* identity */];
  value = value.matrix;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* default */])(value.a, value.b, value.c, value.d, value.e, value.f);
}


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var rho = Math.SQRT2,
    rho2 = 2,
    rho4 = 4,
    epsilon2 = 1e-12;

function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}

function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}

function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

// p0 = [ux0, uy0, w0]
// p1 = [ux1, uy1, w1]
/* unused harmony default export */ var _unused_webpack_default_export = (function(p0, p1) {
  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
      dx = ux1 - ux0,
      dy = uy1 - uy0,
      d2 = dx * dx + dy * dy,
      i,
      S;

  // Special case for u0 ≅ u1.
  if (d2 < epsilon2) {
    S = Math.log(w1 / w0) / rho;
    i = function(t) {
      return [
        ux0 + t * dx,
        uy0 + t * dy,
        w0 * Math.exp(rho * t * S)
      ];
    }
  }

  // General case.
  else {
    var d1 = Math.sqrt(d2),
        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
    S = (r1 - r0) / rho;
    i = function(t) {
      var s = t * S,
          coshr0 = cosh(r0),
          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
      return [
        ux0 + u * dx,
        uy0 + u * dy,
        w0 * coshr0 / cosh(rho * s + r0)
      ];
    }
  }

  i.duration = S * 1000;

  return i;
});


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_band__ = __webpack_require__(115);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleBand", function() { return __WEBPACK_IMPORTED_MODULE_0__src_band__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scalePoint", function() { return __WEBPACK_IMPORTED_MODULE_0__src_band__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_identity__ = __webpack_require__(121);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleIdentity", function() { return __WEBPACK_IMPORTED_MODULE_1__src_identity__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_linear__ = __webpack_require__(11);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleLinear", function() { return __WEBPACK_IMPORTED_MODULE_2__src_linear__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_log__ = __webpack_require__(122);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleLog", function() { return __WEBPACK_IMPORTED_MODULE_3__src_log__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_ordinal__ = __webpack_require__(57);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleOrdinal", function() { return __WEBPACK_IMPORTED_MODULE_4__src_ordinal__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleImplicit", function() { return __WEBPACK_IMPORTED_MODULE_4__src_ordinal__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_pow__ = __webpack_require__(123);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scalePow", function() { return __WEBPACK_IMPORTED_MODULE_5__src_pow__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleSqrt", function() { return __WEBPACK_IMPORTED_MODULE_5__src_pow__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_quantile__ = __webpack_require__(124);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleQuantile", function() { return __WEBPACK_IMPORTED_MODULE_6__src_quantile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_quantize__ = __webpack_require__(125);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleQuantize", function() { return __WEBPACK_IMPORTED_MODULE_7__src_quantize__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_threshold__ = __webpack_require__(128);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleThreshold", function() { return __WEBPACK_IMPORTED_MODULE_8__src_threshold__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_time__ = __webpack_require__(58);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleTime", function() { return __WEBPACK_IMPORTED_MODULE_9__src_time__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_utcTime__ = __webpack_require__(130);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleUtc", function() { return __WEBPACK_IMPORTED_MODULE_10__src_utcTime__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_category10__ = __webpack_require__(116);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeCategory10", function() { return __WEBPACK_IMPORTED_MODULE_11__src_category10__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_category20b__ = __webpack_require__(118);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeCategory20b", function() { return __WEBPACK_IMPORTED_MODULE_12__src_category20b__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_category20c__ = __webpack_require__(119);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeCategory20c", function() { return __WEBPACK_IMPORTED_MODULE_13__src_category20c__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_category20__ = __webpack_require__(117);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "schemeCategory20", function() { return __WEBPACK_IMPORTED_MODULE_14__src_category20__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__ = __webpack_require__(120);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateCubehelixDefault", function() { return __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_rainbow__ = __webpack_require__(126);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRainbow", function() { return __WEBPACK_IMPORTED_MODULE_16__src_rainbow__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateWarm", function() { return __WEBPACK_IMPORTED_MODULE_16__src_rainbow__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateCool", function() { return __WEBPACK_IMPORTED_MODULE_16__src_rainbow__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_viridis__ = __webpack_require__(131);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateViridis", function() { return __WEBPACK_IMPORTED_MODULE_17__src_viridis__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateMagma", function() { return __WEBPACK_IMPORTED_MODULE_17__src_viridis__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateInferno", function() { return __WEBPACK_IMPORTED_MODULE_17__src_viridis__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolatePlasma", function() { return __WEBPACK_IMPORTED_MODULE_17__src_viridis__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_sequential__ = __webpack_require__(127);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleSequential", function() { return __WEBPACK_IMPORTED_MODULE_18__src_sequential__["a"]; });







































/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = band;
/* harmony export (immutable) */ __webpack_exports__["b"] = point;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ordinal__ = __webpack_require__(57);



function band() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ordinal__["a" /* default */])().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      range = [0, 1],
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = range[1] < range[0],
        start = range[reverse - 0],
        stop = range[1 - reverse];
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["range"])(n).map(function(i) { return start + step * i; });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function(_) {
    return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = [+_[0], +_[1]], round = true, rescale();
  };

  scale.bandwidth = function() {
    return bandwidth;
  };

  scale.step = function() {
    return step;
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function(_) {
    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
  };

  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function() {
    return band()
        .domain(domain())
        .range(range)
        .round(round)
        .paddingInner(paddingInner)
        .paddingOuter(paddingOuter)
        .align(align);
  };

  return rescale();
}

function pointish(scale) {
  var copy = scale.copy;

  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;

  scale.copy = function() {
    return pointish(copy());
  };

  return scale;
}

function point() {
  return pointish(band().paddingInner(1));
}


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"));


/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5"));


/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6"));


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9"));


/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["d" /* interpolateCubehelixLong */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(300, 0.5, 0.0), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(-240, 0.5, 1.0)));


/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = identity;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(56);




function identity() {
  var domain = [0, 1];

  function scale(x) {
    return +x;
  }

  scale.invert = scale;

  scale.domain = scale.range = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]), scale) : domain.slice();
  };

  scale.copy = function() {
    return identity().domain(domain);
  };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = log;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nice__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__continuous__ = __webpack_require__(15);






function deinterpolate(a, b) {
  return (b = Math.log(b / a))
      ? function(x) { return Math.log(x / a) / b; }
      : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(b);
}

function reinterpolate(a, b) {
  return a < 0
      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
}

function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}

function powp(base) {
  return base === 10 ? pow10
      : base === Math.E ? Math.exp
      : function(x) { return Math.pow(base, x); };
}

function logp(base) {
  return base === Math.E ? Math.log
      : base === 10 && Math.log10
      || base === 2 && Math.log2
      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
}

function reflect(f) {
  return function(x) {
    return -f(-x);
  };
}

function log() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__continuous__["a" /* default */])(deinterpolate, reinterpolate).domain([1, 10]),
      domain = scale.domain,
      base = 10,
      logs = logp(10),
      pows = powp(10);

  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
    return scale;
  }

  scale.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.ticks = function(count) {
    var d = domain(),
        u = d[0],
        v = d[d.length - 1],
        r;

    if (r = v < u) i = u, u = v, v = i;

    var i = logs(u),
        j = logs(v),
        p,
        k,
        t,
        n = count == null ? 10 : +count,
        z = [];

    if (!(base % 1) && j - i < n) {
      i = Math.round(i) - 1, j = Math.round(j) + 1;
      if (u > 0) for (; i < j; ++i) {
        for (k = 1, p = pows(i); k < base; ++k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      } else for (; i < j; ++i) {
        for (k = base - 1, p = pows(i); k >= 1; --k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
    } else {
      z = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["ticks"])(i, j, Math.min(j - i, n)).map(pows);
    }

    return r ? z.reverse() : z;
  };

  scale.tickFormat = function(count, specifier) {
    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
    if (typeof specifier !== "function") specifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["f" /* format */])(specifier);
    if (count === Infinity) return specifier;
    if (count == null) count = 10;
    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
    return function(d) {
      var i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };

  scale.nice = function() {
    return domain(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__nice__["a" /* default */])(domain(), {
      floor: function(x) { return pows(Math.floor(logs(x))); },
      ceil: function(x) { return pows(Math.ceil(logs(x))); }
    }));
  };

  scale.copy = function() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__continuous__["c" /* copy */])(scale, log().base(base));
  };

  return scale;
}


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pow;
/* harmony export (immutable) */ __webpack_exports__["b"] = sqrt;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(15);




function raise(x, exponent) {
  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
}

function pow() {
  var exponent = 1,
      scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* default */])(deinterpolate, reinterpolate),
      domain = scale.domain;

  function deinterpolate(a, b) {
    return (b = raise(b, exponent) - (a = raise(a, exponent)))
        ? function(x) { return (raise(x, exponent) - a) / b; }
        : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(b);
  }

  function reinterpolate(a, b) {
    b = raise(b, exponent) - (a = raise(a, exponent));
    return function(t) { return raise(a + b * t, 1 / exponent); };
  }

  scale.exponent = function(_) {
    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
  };

  scale.copy = function() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__continuous__["c" /* copy */])(scale, pow().exponent(exponent));
  };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__linear__["b" /* linearish */])(scale);
}

function sqrt() {
  return pow().exponent(0.5);
}


/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quantile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(4);



function quantile() {
  var domain = [],
      range = [],
      thresholds = [];

  function rescale() {
    var i = 0, n = Math.max(1, range.length);
    thresholds = new Array(n - 1);
    while (++i < n) thresholds[i - 1] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["quantile"])(domain, i / n);
    return scale;
  }

  function scale(x) {
    if (!isNaN(x = +x)) return range[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["bisect"])(thresholds, x)];
  }

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : [
      i > 0 ? thresholds[i - 1] : domain[0],
      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
    ];
  };

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(__WEBPACK_IMPORTED_MODULE_0_d3_array__["ascending"]);
    return rescale();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.quantiles = function() {
    return thresholds.slice();
  };

  scale.copy = function() {
    return quantile()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quantize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linear__ = __webpack_require__(11);




function quantize() {
  var x0 = 0,
      x1 = 1,
      n = 1,
      domain = [0.5],
      range = [0, 1];

  function scale(x) {
    if (x <= x) return range[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["bisect"])(domain, x, 0, n)];
  }

  function rescale() {
    var i = -1;
    domain = new Array(n);
    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
    return scale;
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
  };

  scale.range = function(_) {
    return arguments.length ? (n = (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_)).length - 1, rescale()) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN]
        : i < 1 ? [x0, domain[0]]
        : i >= n ? [domain[n - 1], x1]
        : [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return quantize()
        .domain([x0, x1])
        .range(range);
  };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return warm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cool; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(8);



var warm = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["d" /* interpolateCubehelixLong */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(-100, 0.75, 0.35), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(80, 1.50, 0.8));

var cool = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["d" /* interpolateCubehelixLong */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(260, 0.75, 0.35), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(80, 1.50, 0.8));

var rainbow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])();

/* harmony default export */ __webpack_exports__["a"] = (function(t) {
  if (t < 0 || t > 1) t -= Math.floor(t);
  var ts = Math.abs(t - 0.5);
  rainbow.h = 360 * t - 100;
  rainbow.s = 1.5 - 1.5 * ts;
  rainbow.l = 0.8 - 0.9 * ts;
  return rainbow + "";
});


/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sequential;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(11);


function sequential(interpolator) {
  var x0 = 0,
      x1 = 1,
      clamp = false;

  function scale(x) {
    var t = (x - x0) / (x1 - x0);
    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.copy = function() {
    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
  };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = threshold;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(4);



function threshold() {
  var domain = [0.5],
      range = [0, 1],
      n = 1;

  function scale(x) {
    if (x <= x) return range[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["bisect"])(domain, x, 0, n)];
  }

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return threshold()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = (function(domain, count, specifier) {
  var start = domain[0],
      stop = domain[domain.length - 1],
      step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["tickStep"])(start, stop, count == null ? 10 : count),
      precision;
  specifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* formatSpecifier */])(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["b" /* precisionPrefix */])(step, value))) specifier.precision = precision;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["c" /* formatPrefix */])(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["d" /* precisionRound */])(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["e" /* precisionFixed */])(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["f" /* format */])(specifier);
});


/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__time__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_time_format__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(26);




/* harmony default export */ __webpack_exports__["a"] = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__time__["b" /* calendar */])(__WEBPACK_IMPORTED_MODULE_2_d3_time__["a" /* utcYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["b" /* utcMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["c" /* utcWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["d" /* utcDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["e" /* utcHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["f" /* utcMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["g" /* utcSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["h" /* utcMillisecond */], __WEBPACK_IMPORTED_MODULE_1_d3_time_format__["a" /* utcFormat */]).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
});


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return magma; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return inferno; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return plasma; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(10);


function ramp(range) {
  var n = range.length;
  return function(t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (ramp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725")));

var magma = ramp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));

var inferno = ramp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));

var plasma = ramp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isoFormat__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultLocale__ = __webpack_require__(25);



function parseIsoNative(string) {
  var date = new Date(string);
  return isNaN(date) ? null : date;
}

var parseIso = +new Date("2000-01-01T00:00:00.000Z")
    ? parseIsoNative
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__defaultLocale__["b" /* utcParse */])(__WEBPACK_IMPORTED_MODULE_0__isoFormat__["a" /* isoSpecifier */]);

/* unused harmony default export */ var _unused_webpack_default_export = (parseIso);


/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export days */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(2);



var day = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setDate(date.getDate() + step);
}, function(start, end) {
  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationDay */];
}, function(date) {
  return date.getDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (day);
var days = day.range;


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(2);



var hour = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  var offset = date.getTimezoneOffset() * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */] % __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */];
  if (offset < 0) offset += __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */];
  date.setTime(Math.floor((+date - offset) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */] + offset);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */];
}, function(date) {
  return date.getHours();
});

/* harmony default export */ __webpack_exports__["a"] = (hour);
var hours = hour.range;


/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export milliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);


var millisecond = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function() {
  // noop
}, function(date, step) {
  date.setTime(+date + step);
}, function(start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond.every = function(k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setTime(Math.floor(date / k) * k);
  }, function(date, step) {
    date.setTime(+date + step * k);
  }, function(start, end) {
    return (end - start) / k;
  });
};

/* harmony default export */ __webpack_exports__["a"] = (millisecond);
var milliseconds = millisecond.range;


/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export minutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(2);



var minute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setTime(Math.floor(date / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */];
}, function(date) {
  return date.getMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (minute);
var minutes = minute.range;


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export months */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);


var month = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setMonth(date.getMonth() + step);
}, function(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
  return date.getMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (month);
var months = month.range;


/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export seconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(2);



var second = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setTime(Math.floor(date / __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationSecond */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationSecond */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationSecond */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationSecond */];
}, function(date) {
  return date.getUTCSeconds();
});

/* harmony default export */ __webpack_exports__["a"] = (second);
var seconds = second.range;


/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(2);



var utcDay = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationDay */];
}, function(date) {
  return date.getUTCDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (utcDay);
var utcDays = utcDay.range;


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(2);



var utcHour = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationHour */];
}, function(date) {
  return date.getUTCHours();
});

/* harmony default export */ __webpack_exports__["a"] = (utcHour);
var utcHours = utcHour.range;


/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(2);



var utcMinute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCSeconds(0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */];
}, function(date) {
  return date.getUTCMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMinute);
var utcMinutes = utcMinute.range;


/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);


var utcMonth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
  return date.getUTCMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMonth);
var utcMonths = utcMonth.range;


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return utcSunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcMonday; });
/* unused harmony export utcTuesday */
/* unused harmony export utcWednesday */
/* unused harmony export utcThursday */
/* unused harmony export utcFriday */
/* unused harmony export utcSaturday */
/* unused harmony export utcSundays */
/* unused harmony export utcMondays */
/* unused harmony export utcTuesdays */
/* unused harmony export utcWednesdays */
/* unused harmony export utcThursdays */
/* unused harmony export utcFridays */
/* unused harmony export utcSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(2);



function utcWeekday(i) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["a" /* durationWeek */];
  });
}

var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);

var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);


var utcYear = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (utcYear);
var utcYears = utcYear.range;


/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return monday; });
/* unused harmony export tuesday */
/* unused harmony export wednesday */
/* unused harmony export thursday */
/* unused harmony export friday */
/* unused harmony export saturday */
/* unused harmony export sundays */
/* unused harmony export mondays */
/* unused harmony export tuesdays */
/* unused harmony export wednesdays */
/* unused harmony export thursdays */
/* unused harmony export fridays */
/* unused harmony export saturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(2);



function weekday(i) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration__["a" /* durationWeek */];
  });
}

var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);

var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export years */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(0);


var year = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (year);
var years = year.range;


/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports = {
	"Solomon Isds": {
		"lat": -9.480696,
		"lng": 160.153028
	},
	"Lebanon": {
		"lat": 33.854721,
		"lng": 35.862285
	},
	"Bonaire": {
		"lat": 12.2018902,
		"lng": -68.26238219999999
	},
	"Gibraltar": {
		"lat": 36.140751,
		"lng": -5.353585
	},
	"Ghana": {
		"lat": 7.946527,
		"lng": -1.023194
	},
	"Lesotho": {
		"lat": -29.609988,
		"lng": 28.233608
	},
	"Qatar": {
		"lat": 25.354826,
		"lng": 51.183884
	},
	"Dem. Rep. of the Congo": {
		"lat": -4.038333,
		"lng": 21.758664
	},
	"Dem. People's Rep. of Korea": {
		"lat": 40.339852,
		"lng": 127.510093
	},
	"Cameroon": {
		"lat": 7.369721999999999,
		"lng": 12.354722
	},
	"South Africa": {
		"lat": -30.559482,
		"lng": 22.937506
	},
	"Montserrat": {
		"lat": 16.742498,
		"lng": -62.187366
	},
	"Panama": {
		"lat": 8.537981,
		"lng": -80.782127
	},
	"Colombia": {
		"lat": 4.570868,
		"lng": -74.297333
	},
	"Niger": {
		"lat": 17.607789,
		"lng": 8.081666
	},
	"Palau": {
		"lat": 7.514979999999999,
		"lng": 134.58252
	},
	"Tonga": {
		"lat": -21.178986,
		"lng": -175.198242
	},
	"Jordan": {
		"lat": 30.585164,
		"lng": 36.238414
	},
	"Fr. South Antarctic Terr.": {
		"lat": -49.280366,
		"lng": 69.348557
	},
	"Uzbekistan": {
		"lat": 41.377491,
		"lng": 64.585262
	},
	"Iraq": {
		"lat": 33.223191,
		"lng": 43.679291
	},
	"Tuvalu": {
		"lat": -7.4784205,
		"lng": 178.679924
	},
	"Guam": {
		"lat": 13.444304,
		"lng": 144.793731
	},
	"Bosnia Herzegovina": {
		"lat": 43.915886,
		"lng": 17.679076
	},
	"Vanuatu": {
		"lat": -15.376706,
		"lng": 166.959158
	},
	"Belgium": {
		"lat": 50.503887,
		"lng": 4.469936
	},
	"Azerbaijan": {
		"lat": 40.143105,
		"lng": 47.576927
	},
	"Pitcairn": {
		"lat": -24.3767537,
		"lng": -128.3242376
	},
	"Armenia": {
		"lat": 40.069099,
		"lng": 45.038189
	},
	"Togo": {
		"lat": 8.619543,
		"lng": 0.824782
	},
	"Singapore": {
		"lat": 1.352083,
		"lng": 103.819836
	},
	"Albania": {
		"lat": 41.153332,
		"lng": 20.168331
	},
	"Benin": {
		"lat": 9.30769,
		"lng": 2.315834
	},
	"Antarctica": {
		"lat": -82.86275189999999,
		"lng": 135
	},
	"FS Micronesia": {
		"lat": 6.8874581,
		"lng": 158.2225229
	},
	"Indonesia": {
		"lat": -0.789275,
		"lng": 113.921327
	},
	"Cuba": {
		"lat": 21.521757,
		"lng": -77.781167
	},
	"American Samoa": {
		"lat": -14.3016396,
		"lng": -170.6961815
	},
	"Saint Vincent and the Grenadines": {
		"lat": 13.2528179,
		"lng": -61.1970774
	},
	"Curaçao": {
		"lat": 12.16957,
		"lng": -68.99002
	},
	"Australia": {
		"lat": -25.274398,
		"lng": 133.775136
	},
	"Kiribati": {
		"lat": 1.8709422,
		"lng": -157.3628595
	},
	"Jamaica": {
		"lat": 18.109581,
		"lng": -77.297508
	},
	"Br. Virgin Isds": {
		"lat": 18.420695,
		"lng": -64.639968
	},
	"Spain": {
		"lat": 40.46366700000001,
		"lng": -3.74922
	},
	"Tajikistan": {
		"lat": 38.861034,
		"lng": 71.276093
	},
	"Kenya": {
		"lat": -0.023559,
		"lng": 37.906193
	},
	"Botswana": {
		"lat": -22.328474,
		"lng": 24.684866
	},
	"Côte d'Ivoire": {
		"lat": 7.539988999999999,
		"lng": -5.547079999999999
	},
	"Norfolk Isds": {
		"lat": 33.474357,
		"lng": -101.8995581
	},
	"Mauritania": {
		"lat": 21.00789,
		"lng": -10.940835
	},
	"Christmas Isds": {
		"lat": 32.9395672,
		"lng": -97.1140041
	},
	"Honduras": {
		"lat": 15.199999,
		"lng": -86.241905
	},
	"Saint Barthélemy": {
		"lat": 17.9,
		"lng": -62.833333
	},
	"Holy See (Vatican City State)": {
		"lat": 41.902916,
		"lng": 12.453389
	},
	"Ireland": {
		"lat": 53.1423672,
		"lng": -7.692053599999999
	},
	"Chile": {
		"lat": -35.675147,
		"lng": -71.542969
	},
	"Sudan": {
		"lat": 12.862807,
		"lng": 30.217636
	},
	"Gambia": {
		"lat": 13.443182,
		"lng": -15.310139
	},
	"China, Macao SAR": {
		"lat": 22.198745,
		"lng": 113.543873
	},
	"Dominica": {
		"lat": 15.414999,
		"lng": -61.37097600000001
	},
	"Malaysia": {
		"lat": 4.210484,
		"lng": 101.975766
	},
	"Fiji": {
		"lat": -17.713371,
		"lng": 178.065032
	},
	"Somalia": {
		"lat": 5.152149,
		"lng": 46.199616
	},
	"Falkland Isds (Malvinas)": {
		"lat": -51.796253,
		"lng": -59.523613
	},
	"Nepal": {
		"lat": 28.394857,
		"lng": 84.12400799999999
	},
	"China": {
		"lat": 35.86166,
		"lng": 104.195397
	},
	"Comoros": {
		"lat": -11.6455,
		"lng": 43.3333
	},
	"Guinea-Bissau": {
		"lat": 11.803749,
		"lng": -15.180413
	},
	"Saint Maarten": {
		"lat": 18.04248,
		"lng": -63.05483
	},
	"Mali": {
		"lat": 17.570692,
		"lng": -3.996166
	},
	"Trinidad and Tobago": {
		"lat": 10.691803,
		"lng": -61.222503
	},
	"Israel": {
		"lat": 31.046051,
		"lng": 34.851612
	},
	"Burkina Faso": {
		"lat": 12.238333,
		"lng": -1.561593
	},
	"Kazakhstan": {
		"lat": 48.019573,
		"lng": 66.923684
	},
	"Paraguay": {
		"lat": -23.442503,
		"lng": -58.443832
	},
	"French Polynesia": {
		"lat": -17.679742,
		"lng": -149.406843
	},
	"Bangladesh": {
		"lat": 23.684994,
		"lng": 90.356331
	},
	"Antigua and Barbuda": {
		"lat": 17.060816,
		"lng": -61.796428
	},
	"Gabon": {
		"lat": -0.803689,
		"lng": 11.609444
	},
	"Cyprus": {
		"lat": 35.126413,
		"lng": 33.429859
	},
	"Yemen": {
		"lat": 15.552727,
		"lng": 48.516388
	},
	"Mauritius": {
		"lat": -20.348404,
		"lng": 57.55215200000001
	},
	"Slovakia": {
		"lat": 48.669026,
		"lng": 19.699024
	},
	"Faeroe Isds": {
		"lat": 61.89263500000001,
		"lng": -6.911805999999999
	},
	"Turkmenistan": {
		"lat": 38.969719,
		"lng": 59.556278
	},
	"Bahrain": {
		"lat": 26.0667,
		"lng": 50.5577
	},
	"South Sudan": {
		"lat": 6.876991899999999,
		"lng": 31.3069788
	},
	"Guyana": {
		"lat": 4.860416,
		"lng": -58.93018
	},
	"Saint Pierre and Miquelon": {
		"lat": 46.8852,
		"lng": -56.3159
	},
	"Algeria": {
		"lat": 28.033886,
		"lng": 1.659626
	},
	"USA": {
		"lat": 37.09024,
		"lng": -95.712891
	},
	"Cambodia": {
		"lat": 12.565679,
		"lng": 104.990963
	},
	"Rep. of Moldova": {
		"lat": 47.411631,
		"lng": 28.369885
	},
	"Zambia": {
		"lat": -13.133897,
		"lng": 27.849332
	},
	"Malta": {
		"lat": 35.937496,
		"lng": 14.375416
	},
	"Ecuador": {
		"lat": -1.831239,
		"lng": -78.18340599999999
	},
	"Grenada": {
		"lat": 12.1165,
		"lng": -61.67899999999999
	},
	"Portugal": {
		"lat": 39.39987199999999,
		"lng": -8.224454
	},
	"France": {
		"lat": 46.227638,
		"lng": 2.213749
	},
	"New Caledonia": {
		"lat": -20.904305,
		"lng": 165.618042
	},
	"Niue": {
		"lat": -19.054445,
		"lng": -169.867233
	},
	"Seychelles": {
		"lat": -4.679574,
		"lng": 55.491977
	},
	"Oceania, nes": {
		"lat": 36.81691259999999,
		"lng": -76.0070803
	},
	"Italy": {
		"lat": 41.87194,
		"lng": 12.56738
	},
	"Saint Lucia": {
		"lat": 13.909444,
		"lng": -60.978893
	},
	"State of Palestine": {
		"lat": 31.952162,
		"lng": 35.233154
	},
	"Rwanda": {
		"lat": -1.940278,
		"lng": 29.873888
	},
	"Belarus": {
		"lat": 53.709807,
		"lng": 27.953389
	},
	"Ethiopia": {
		"lat": 9.145000000000001,
		"lng": 40.489673
	},
	"Namibia": {
		"lat": -22.95764,
		"lng": 18.49041
	},
	"Congo": {
		"lat": -4.038333,
		"lng": 21.758664
	},
	"Senegal": {
		"lat": 14.497401,
		"lng": -14.452362
	},
	"Bulgaria": {
		"lat": 42.733883,
		"lng": 25.48583
	},
	"Montenegro": {
		"lat": 42.708678,
		"lng": 19.37439
	},
	"Sri Lanka": {
		"lat": 7.873053999999999,
		"lng": 80.77179699999999
	},
	"Hungary": {
		"lat": 47.162494,
		"lng": 19.503304
	},
	"Angola": {
		"lat": -11.202692,
		"lng": 17.873887
	},
	"N. Mariana Isds": {
		"lat": 15.0979,
		"lng": 145.6739
	},
	"Samoa": {
		"lat": -13.759029,
		"lng": -172.104629
	},
	"Myanmar": {
		"lat": 21.916221,
		"lng": 95.955974
	},
	"Iran": {
		"lat": 32.427908,
		"lng": 53.688046
	},
	"Sao Tome and Principe": {
		"lat": 0.18636,
		"lng": 6.613080999999999
	},
	"Uruguay": {
		"lat": -32.522779,
		"lng": -55.765835
	},
	"Andorra": {
		"lat": 42.506285,
		"lng": 1.521801
	},
	"Cabo Verde": {
		"lat": 15.120142,
		"lng": -23.6051868
	},
	"Germany": {
		"lat": 51.165691,
		"lng": 10.451526
	},
	"Timor-Leste": {
		"lat": -8.874217,
		"lng": 125.727539
	},
	"Poland": {
		"lat": 51.919438,
		"lng": 19.145136
	},
	"Bouvet Island": {
		"lat": -54.4207915,
		"lng": 3.3464497
	},
	"Thailand": {
		"lat": 15.870032,
		"lng": 100.992541
	},
	"Argentina": {
		"lat": -38.416097,
		"lng": -63.61667199999999
	},
	"Brazil": {
		"lat": -14.235004,
		"lng": -51.92528
	},
	"Brunei Darussalam": {
		"lat": 4.535277,
		"lng": 114.727669
	},
	"Mongolia": {
		"lat": 46.862496,
		"lng": 103.846656
	},
	"Saudi Arabia": {
		"lat": 23.885942,
		"lng": 45.079162
	},
	"Syria": {
		"lat": 34.80207499999999,
		"lng": 38.996815
	},
	"Russian Federation": {
		"lat": 61.52401,
		"lng": 105.318756
	},
	"Cayman Isds": {
		"lat": 19.3133,
		"lng": -81.2546
	},
	"United Arab Emirates": {
		"lat": 23.424076,
		"lng": 53.847818
	},
	"Nicaragua": {
		"lat": 12.865416,
		"lng": -85.207229
	},
	"Libya": {
		"lat": 26.3351,
		"lng": 17.228331
	},
	"Malawi": {
		"lat": -13.254308,
		"lng": 34.301525
	},
	"Switzerland": {
		"lat": 46.818188,
		"lng": 8.227511999999999
	},
	"El Salvador": {
		"lat": 13.794185,
		"lng": -88.89653
	},
	"United States Minor Outlying Islands": {
		"lat": 19.2823192,
		"lng": 166.647047
	},
	"Aruba": {
		"lat": 12.52111,
		"lng": -69.968338
	},
	"Latvia": {
		"lat": 56.879635,
		"lng": 24.603189
	},
	"Japan": {
		"lat": 36.204824,
		"lng": 138.252924
	},
	"Guinea": {
		"lat": 9.945587,
		"lng": -9.696645
	},
	"Uganda": {
		"lat": 1.373333,
		"lng": 32.290275
	},
	"Romania": {
		"lat": 45.943161,
		"lng": 24.96676
	},
	"Croatia": {
		"lat": 45.1,
		"lng": 15.2
	},
	"Liberia": {
		"lat": 6.428055,
		"lng": -9.429499000000002
	},
	"Mozambique": {
		"lat": -18.665695,
		"lng": 35.529562
	},
	"Madagascar": {
		"lat": -18.766947,
		"lng": 46.869107
	},
	"Bolivia (Plurinational State of)": {
		"lat": -16.290154,
		"lng": -63.58865299999999
	},
	"Barbados": {
		"lat": 13.193887,
		"lng": -59.543198
	},
	"Saint Kitts and Nevis": {
		"lat": 17.357822,
		"lng": -62.782998
	},
	"Bahamas": {
		"lat": 25.03428,
		"lng": -77.39627999999999
	},
	"Tunisia": {
		"lat": 33.886917,
		"lng": 9.537499
	},
	"Chad": {
		"lat": 15.454166,
		"lng": 18.732207
	},
	"Viet Nam": {
		"lat": 14.058324,
		"lng": 108.277199
	},
	"Haiti": {
		"lat": 18.971187,
		"lng": -72.285215
	},
	"Tokelau": {
		"lat": -9.200199999999999,
		"lng": -171.8484
	},
	"South Georgia and the South Sandwich Islands": {
		"lat": -54.429579,
		"lng": -36.587909
	},
	"Oman": {
		"lat": 21.4735329,
		"lng": 55.975413
	},
	"Sweden": {
		"lat": 60.12816100000001,
		"lng": 18.643501
	},
	"Maldives": {
		"lat": 1.9772276,
		"lng": 73.536101
	},
	"India": {
		"lat": 20.593684,
		"lng": 78.96288
	},
	"Mexico": {
		"lat": 23.634501,
		"lng": -102.552784
	},
	"Austria": {
		"lat": 47.516231,
		"lng": 14.550072
	},
	"Eritrea": {
		"lat": 15.179384,
		"lng": 39.782334
	},
	"Zimbabwe": {
		"lat": -19.015438,
		"lng": 29.154857
	},
	"Pakistan": {
		"lat": 30.375321,
		"lng": 69.34511599999999
	},
	"Swaziland": {
		"lat": -26.522503,
		"lng": 31.465866
	},
	"Lithuania": {
		"lat": 55.169438,
		"lng": 23.881275
	},
	"United Kingdom": {
		"lat": 55.378051,
		"lng": -3.435973
	},
	"Denmark": {
		"lat": 56.26392,
		"lng": 9.501785
	},
	"Peru": {
		"lat": -9.189967,
		"lng": -75.015152
	},
	"Central African Rep.": {
		"lat": 6.611110999999999,
		"lng": 20.939444
	},
	"Netherlands": {
		"lat": 52.132633,
		"lng": 5.291265999999999
	},
	"Costa Rica": {
		"lat": 9.748916999999999,
		"lng": -83.753428
	},
	"Equatorial Guinea": {
		"lat": 1.650801,
		"lng": 10.267895
	},
	"Greece": {
		"lat": 39.074208,
		"lng": 21.824312
	},
	"Papua New Guinea": {
		"lat": -6.314992999999999,
		"lng": 143.95555
	},
	"Slovenia": {
		"lat": 46.151241,
		"lng": 14.995463
	},
	"Afghanistan": {
		"lat": 33.93911,
		"lng": 67.709953
	},
	"Saint Helena": {
		"lat": 38.5052429,
		"lng": -122.4703868
	},
	"Egypt": {
		"lat": 26.820553,
		"lng": 30.802498
	},
	"Nauru": {
		"lat": -0.522778,
		"lng": 166.931503
	},
	"Anguilla": {
		"lat": 18.220554,
		"lng": -63.06861499999999
	},
	"Estonia": {
		"lat": 58.595272,
		"lng": 25.013607
	},
	"Morocco": {
		"lat": 31.791702,
		"lng": -7.092619999999999
	},
	"Luxembourg": {
		"lat": 49.815273,
		"lng": 6.129582999999999
	},
	"TFYR of Macedonia": {
		"lat": 41.608635,
		"lng": 21.745275
	},
	"Heard Island and McDonald Islands": {
		"lat": -53.08181,
		"lng": 73.50415799999999
	},
	"Western Sahara": {
		"lat": 24.215527,
		"lng": -12.885834
	},
	"United Rep. of Tanzania": {
		"lat": -6.369028,
		"lng": 34.888822
	},
	"Finland": {
		"lat": 61.92410999999999,
		"lng": 25.748151
	},
	"Belize": {
		"lat": 17.189877,
		"lng": -88.49765
	},
	"Georgia": {
		"lat": 32.1656221,
		"lng": -82.9000751
	},
	"Ukraine": {
		"lat": 48.379433,
		"lng": 31.16558
	},
	"Bermuda": {
		"lat": 32.3078,
		"lng": -64.7505
	},
	"Djibouti": {
		"lat": 11.825138,
		"lng": 42.590275
	},
	"Greenland": {
		"lat": 71.706936,
		"lng": -42.604303
	},
	"China, Hong Kong SAR": {
		"lat": 22.396428,
		"lng": 114.109497
	},
	"Suriname": {
		"lat": 3.919305,
		"lng": -56.027783
	},
	"Nigeria": {
		"lat": 9.081999,
		"lng": 8.675277
	},
	"Venezuela": {
		"lat": 6.42375,
		"lng": -66.58973
	},
	"Kuwait": {
		"lat": 29.31166,
		"lng": 47.481766
	},
	"New Zealand": {
		"lat": -40.900557,
		"lng": 174.885971
	},
	"Norway": {
		"lat": 60.47202399999999,
		"lng": 8.468945999999999
	},
	"Sierra Leone": {
		"lat": 8.460555,
		"lng": -11.779889
	},
	"Marshall Isds": {
		"lat": 32.5280414,
		"lng": -94.35328469999999
	},
	"Philippines": {
		"lat": 12.879721,
		"lng": 121.774017
	},
	"Dominican Rep.": {
		"lat": 18.735693,
		"lng": -70.162651
	},
	"Kyrgyzstan": {
		"lat": 41.20438,
		"lng": 74.766098
	},
	"Czechia": {
		"lat": 49.81749199999999,
		"lng": 15.472962
	},
	"Br. Indian Ocean Terr.": {
		"lat": -7.3346232,
		"lng": 72.4242508
	},
	"Guatemala": {
		"lat": 15.783471,
		"lng": -90.23075899999999
	},
	"Lao People's Dem. Rep.": {
		"lat": 19.85627,
		"lng": 102.495496
	},
	"Turkey": {
		"lat": 38.963745,
		"lng": 35.243322
	},
	"San Marino": {
		"lat": 43.94236,
		"lng": 12.457777
	},
	"Rep. of Korea": {
		"lat": 37.500813,
		"lng": 127.123262
	},
	"Serbia": {
		"lat": 44.016521,
		"lng": 21.005859
	},
	"Burundi": {
		"lat": -3.373056,
		"lng": 29.918886
	},
	"Bhutan": {
		"lat": 27.514162,
		"lng": 90.433601
	},
	"Cook Isds": {
		"lat": 47.7566454,
		"lng": -90.334098
	},
	"Canada": {
		"lat": 56.130366,
		"lng": -106.346771
	},
	"Iceland": {
		"lat": 64.963051,
		"lng": -19.020835
	}
};

/***/ }),
/* 148 */
/***/ (function(module, exports) {

module.exports = {
	"Lebanon": {
		"imports": {},
		"exports": {}
	},
	"Bonaire": {
		"imports": {},
		"exports": {}
	},
	"Gibraltar": {
		"imports": {},
		"exports": {}
	},
	"Ghana": {
		"imports": {},
		"exports": {}
	},
	"Lesotho": {
		"imports": {},
		"exports": {}
	},
	"Qatar": {
		"imports": {},
		"exports": {}
	},
	"Dem. Rep. of the Congo": {
		"imports": {},
		"exports": {}
	},
	"Dem. People's Rep. of Korea": {
		"imports": {},
		"exports": {}
	},
	"Cameroon": {
		"imports": {},
		"exports": {}
	},
	"South Africa": {
		"imports": {
			"Lebanon": "1281660",
			"Gibraltar": "3",
			"Ghana": "94300",
			"Lesotho": "1795447",
			"Qatar": "6355",
			"Dem. Rep. of the Congo": "1980338",
			"Dem. People's Rep. of Korea": "3482",
			"Cameroon": "1574",
			"South Africa": "899735",
			"Montserrat": "19",
			"Panama": "306",
			"Colombia": "10507",
			"Niger": "374",
			"Tonga": "373",
			"Jordan": "465",
			"Fr. South Antarctic Terr.": "208",
			"Uzbekistan": "3",
			"Iraq": "13245",
			"Tuvalu": "17451",
			"Guam": "10",
			"Bosnia Herzegovina": "23",
			"Pakistan": "825",
			"Belgium": "159743",
			"Azerbaijan": "37",
			"Australia": "105365",
			"Germany": "88997548",
			"Singapore": "59329",
			"Albania": "1017",
			"Benin": "1227",
			"Antarctica": "13265",
			"Indonesia": "609885",
			"Cuba": "1740733",
			"American Samoa": "7",
			"Saint Vincent and the Grenadines": "897",
			"Curaçao": "184",
			"Armenia": "735",
			"Kiribati": "21",
			"Jamaica": "246247",
			"Kenya": "7581",
			"Spain": "267826",
			"Tajikistan": "7769",
			"Ireland": "41872312",
			"Botswana": "213004",
			"Côte d'Ivoire": "14635065",
			"French Polynesia": "23",
			"Mauritania": "78",
			"Christmas Isds": "832",
			"Honduras": "24564",
			"Saint Barthélemy": "398",
			"Holy See (Vatican City State)": "41",
			"Eritrea": "153",
			"Austria": "15796120",
			"Chile": "4604",
			"Sudan": "21",
			"Gambia": "417766",
			"Liberia": "8791",
			"Dominica": "115",
			"Malaysia": "9818",
			"Fiji": "73389",
			"Somalia": "5",
			"Falkland Isds (Malvinas)": "1113936",
			"Nepal": "129",
			"China": "62793166",
			"Comoros": "179009",
			"Guinea-Bissau": "5",
			"Mali": "1482",
			"Trinidad and Tobago": "91",
			"Israel": "232552",
			"Burkina Faso": "46",
			"Cambodia": "523057",
			"Norfolk Isds": "1",
			"Bangladesh": "3656",
			"Antigua and Barbuda": "1103",
			"Gabon": "24",
			"Cyprus": "50500",
			"Yemen": "1166",
			"Mauritius": "5306",
			"Slovakia": "1748",
			"Faeroe Isds": "547",
			"Turkmenistan": "44182",
			"Bahrain": "217874",
			"South Sudan": "213",
			"Guyana": "22340",
			"Saint Pierre and Miquelon": "721",
			"Algeria": "20",
			"USA": "40729645",
			"Saint Kitts and Nevis": "71646",
			"Rep. of Moldova": "39",
			"Zambia": "1853816",
			"Malta": "1956",
			"Ecuador": "150320",
			"Grenada": "14546",
			"Dominican Rep.": "1188",
			"France": "424757033",
			"New Caledonia": "159",
			"Niue": "117",
			"Seychelles": "2995",
			"Br. Virgin Isds": "2232606",
			"Italy": "22314006",
			"Saint Lucia": "4079",
			"Uganda": "3336504",
			"Belarus": "208433",
			"Ethiopia": "210617",
			"Namibia": "1069921",
			"Congo": "24",
			"Senegal": "15580",
			"Bulgaria": "96022",
			"Montenegro": "1676",
			"Sri Lanka": "1359",
			"Hungary": "3731",
			"Angola": "11965",
			"New Zealand": "180255",
			"N. Mariana Isds": "50",
			"Samoa": "240",
			"Myanmar": "218511",
			"Malawi": "304",
			"Papua New Guinea": "36",
			"Sao Tome and Principe": "5394",
			"Lao People's Dem. Rep.": "1150",
			"Uruguay": "6122793",
			"Andorra": "5765",
			"Cabo Verde": "24282",
			"Togo": "2511",
			"Timor-Leste": "33866",
			"Poland": "22743603",
			"Thailand": "3529128",
			"Argentina": "1044",
			"Brazil": "13771",
			"Brunei Darussalam": "204326",
			"Mongolia": "143",
			"Saudi Arabia": "816",
			"Syria": "2",
			"Russian Federation": "1653615",
			"Cayman Isds": "17533012",
			"United Arab Emirates": "213606666",
			"Rwanda": "5",
			"Portugal": "778795",
			"Kazakhstan": "5",
			"Switzerland": "166655",
			"El Salvador": "1880",
			"United States Minor Outlying Islands": "32",
			"Sierra Leone": "22",
			"Latvia": "16",
			"Japan": "225971",
			"Guinea": "3061",
			"Romania": "67681179",
			"Slovenia": "79608",
			"China, Macao SAR": "123",
			"Guatemala": "336538",
			"Madagascar": "374",
			"Bolivia (Plurinational State of)": "1979",
			"Nigeria": "98",
			"Bahamas": "2917",
			"Tunisia": "132",
			"Chad": "1224",
			"Viet Nam": "84083",
			"Haiti": "1",
			"Tokelau": "18117",
			"South Georgia and the South Sandwich Islands": "1309",
			"Oman": "3698",
			"Sweden": "61485",
			"Maldives": "429530",
			"India": "1981359",
			"Mexico": "25002838",
			"Nicaragua": "81",
			"Bouvet Island": "23",
			"Zimbabwe": "80937",
			"Vanuatu": "75",
			"Swaziland": "20006",
			"Lithuania": "58",
			"United Kingdom": "7904837",
			"Denmark": "2721822",
			"Peru": "516962",
			"Central African Rep.": "236",
			"Netherlands": "19446",
			"Costa Rica": "53",
			"Equatorial Guinea": "2356469",
			"Greece": "56628",
			"Croatia": "74075",
			"Afghanistan": "3928",
			"Saint Helena": "28438",
			"Egypt": "40295",
			"Nauru": "593",
			"Anguilla": "37",
			"Estonia": "1300",
			"Morocco": "5253",
			"Luxembourg": "408",
			"TFYR of Macedonia": "10",
			"United Rep. of Tanzania": "3498134",
			"Finland": "5649353",
			"Belize": "1545",
			"Georgia": "2965",
			"Ukraine": "10098872",
			"Bermuda": "147",
			"Djibouti": "6",
			"Greenland": "50",
			"China, Hong Kong SAR": "3451841",
			"Suriname": "25053",
			"Barbados": "1835704",
			"Iran": "864",
			"Venezuela": "3709",
			"Kuwait": "25",
			"Norway": "482095",
			"Pitcairn": "290",
			"Marshall Isds": "2398",
			"Philippines": "359",
			"Libya": "3",
			"Kyrgyzstan": "7585",
			"Czechia": "1916",
			"Paraguay": "10643",
			"Br. Indian Ocean Terr.": "596",
			"Mozambique": "255",
			"Aruba": "5",
			"Turkey": "139",
			"San Marino": "36",
			"Rep. of Korea": "254720794",
			"Serbia": "1845",
			"Burundi": "14",
			"Bhutan": "909",
			"Cook Isds": "148",
			"Canada": "254219",
			"Iceland": "46053"
		},
		"exports": {
			"Lebanon": "2400",
			"Gibraltar": "14337752",
			"Ghana": "43732757",
			"Lesotho": "21364759",
			"Qatar": "20919074",
			"Dem. Rep. of the Congo": "30302891",
			"Dem. People's Rep. of Korea": "12688",
			"Cameroon": "191061",
			"Iran": "10541",
			"Montserrat": "17",
			"Panama": "2957",
			"Colombia": "62071",
			"Niger": "91380",
			"Tonga": "82099",
			"Jordan": "9962136",
			"Uzbekistan": "7106",
			"Iraq": "113316",
			"Tuvalu": "273041",
			"Guam": "14472",
			"Bosnia Herzegovina": "8860459",
			"Pakistan": "5755835",
			"Belgium": "464340",
			"Azerbaijan": "39",
			"Australia": "8047554",
			"Germany": "348880691",
			"Singapore": "767301",
			"Albania": "258074",
			"Benin": "3247670",
			"Antarctica": "3913143",
			"FS Micronesia": "10215",
			"Indonesia": "155510",
			"Cuba": "20",
			"Saint Vincent and the Grenadines": "17695",
			"Curaçao": "1207930",
			"Armenia": "29548",
			"Kiribati": "92056",
			"Jamaica": "2364029",
			"Kenya": "14519652",
			"Spain": "55913",
			"Tajikistan": "12834",
			"Ireland": "7656630",
			"Botswana": "4268404",
			"South Sudan": "202358",
			"French Polynesia": "200099",
			"Mauritania": "673",
			"Honduras": "3625636",
			"Holy See (Vatican City State)": "49850",
			"Austria": "59264",
			"Chile": "27157",
			"Sudan": "319872",
			"Gambia": "301234",
			"Liberia": "18004",
			"Dominica": "430158",
			"Malaysia": "19763152",
			"Fiji": "12241",
			"Somalia": "676814",
			"Falkland Isds (Malvinas)": "118141",
			"Nepal": "36",
			"China": "6149568",
			"Comoros": "337327",
			"Guinea-Bissau": "374879",
			"Saint Maarten": "4630",
			"Djibouti": "1942954",
			"Trinidad and Tobago": "10693592",
			"Israel": "1239293",
			"Burkina Faso": "4635",
			"Cambodia": "3400",
			"Norfolk Isds": "14594",
			"Bangladesh": "6353",
			"Antigua and Barbuda": "5479",
			"Gabon": "10724855",
			"Cyprus": "1512684",
			"Yemen": "5489240",
			"Mauritius": "6319949",
			"Slovakia": "4",
			"Faeroe Isds": "154",
			"Turkmenistan": "46009",
			"Bahrain": "48621",
			"Côte d'Ivoire": "163457",
			"Guyana": "48669",
			"Saint Pierre and Miquelon": "4353",
			"Algeria": "207101",
			"USA": "7103046",
			"Namibia": "168436581",
			"Rep. of Moldova": "163750",
			"Zambia": "2744018",
			"Malta": "43525",
			"Ecuador": "2384022",
			"Grenada": "62083",
			"Dominican Rep.": "8510027",
			"France": "257610936",
			"New Caledonia": "492918",
			"Niue": "81650",
			"Seychelles": "8381249",
			"Br. Virgin Isds": "49021495",
			"Italy": "26611746",
			"Saint Lucia": "103899",
			"Uganda": "395932",
			"Belarus": "61190",
			"Ethiopia": "15968694",
			"Congo": "1112700",
			"Senegal": "15818",
			"Bulgaria": "11411",
			"Montenegro": "493168",
			"Sri Lanka": "167361",
			"Hungary": "34273367",
			"Angola": "1133361",
			"New Zealand": "23310065",
			"Samoa": "3817",
			"Myanmar": "126303",
			"Papua New Guinea": "6461",
			"Sao Tome and Principe": "35363",
			"Uruguay": "17275",
			"Andorra": "16494",
			"Cabo Verde": "265656",
			"Togo": "8168",
			"Timor-Leste": "55493",
			"Poland": "3400",
			"Thailand": "3556447",
			"Argentina": "82026",
			"Brazil": "344829",
			"Brunei Darussalam": "19555",
			"Mongolia": "106637",
			"Saudi Arabia": "10417638",
			"Syria": "6427",
			"Russian Federation": "2866826",
			"Cayman Isds": "25485",
			"United Arab Emirates": "98473076",
			"Rwanda": "187320",
			"Portugal": "230684",
			"Malawi": "7269830",
			"Switzerland": "25508",
			"El Salvador": "585625",
			"United States Minor Outlying Islands": "81293",
			"Aruba": "167194",
			"Latvia": "42766",
			"Japan": "8265336",
			"Guinea": "2977459",
			"Romania": "12009169",
			"Slovenia": "3751466",
			"China, Macao SAR": "47198",
			"Guatemala": "2371613",
			"Madagascar": "1287293",
			"Bolivia (Plurinational State of)": "2806690",
			"Nigeria": "62298",
			"Saint Kitts and Nevis": "166",
			"Bahamas": "238",
			"Tunisia": "388199",
			"Chad": "165",
			"Viet Nam": "814627",
			"Haiti": "16599",
			"Tokelau": "3135",
			"Oman": "2188958",
			"Sweden": "228170",
			"Maldives": "2024671",
			"India": "49710",
			"Mexico": "4583072",
			"Nicaragua": "1206231",
			"Eritrea": "164472",
			"Zimbabwe": "2549813",
			"Vanuatu": "5897",
			"Swaziland": "2435492",
			"Lithuania": "211339",
			"United Kingdom": "3193182",
			"Denmark": "7515061",
			"Peru": "326",
			"Central African Rep.": "44205",
			"Netherlands": "551918",
			"Costa Rica": "3619698",
			"Equatorial Guinea": "195",
			"Greece": "17677071",
			"Kazakhstan": "25181",
			"Afghanistan": "5737",
			"Croatia": "286",
			"Saint Helena": "353563",
			"Egypt": "49113",
			"Estonia": "13600076",
			"Morocco": "77525",
			"Luxembourg": "1088",
			"TFYR of Macedonia": "56632",
			"United Rep. of Tanzania": "305852",
			"Finland": "10075778",
			"Belize": "806074",
			"Georgia": "1597399",
			"Ukraine": "35416",
			"Bermuda": "598548",
			"Mali": "385134",
			"China, Hong Kong SAR": "24470",
			"Suriname": "2448209",
			"Barbados": "549772",
			"Venezuela": "7",
			"Kuwait": "4405127",
			"Norway": "472381",
			"Sierra Leone": "79470",
			"Marshall Isds": "5441",
			"Philippines": "2695410",
			"Libya": "3186475",
			"Kyrgyzstan": "2644",
			"Czechia": "7764316",
			"Paraguay": "130274",
			"Mozambique": "9363900",
			"Lao People's Dem. Rep.": "116967",
			"Turkey": "89258456",
			"San Marino": "26612",
			"Rep. of Korea": "170618904",
			"Serbia": "952",
			"Burundi": "87571",
			"Bhutan": "17790",
			"Cook Isds": "5631",
			"Canada": "2325345",
			"Iceland": "5587150"
		}
	},
	"Montserrat": {
		"imports": {},
		"exports": {}
	},
	"Panama": {
		"imports": {},
		"exports": {}
	},
	"Colombia": {
		"imports": {
			"Lebanon": "220",
			"Gibraltar": "224",
			"Ghana": "4354",
			"Lesotho": "44",
			"Qatar": "338",
			"Dem. People's Rep. of Korea": "16771",
			"Cameroon": "7728",
			"South Africa": "2820",
			"Montserrat": "290",
			"Indonesia": "7821471",
			"Niger": "899",
			"Palau": "16316",
			"Jordan": "11847",
			"Uzbekistan": "356",
			"Iraq": "287994",
			"Tuvalu": "1263",
			"Lao People's Dem. Rep.": "43011",
			"Bosnia Herzegovina": "8563",
			"Pakistan": "31175",
			"Belgium": "350934",
			"Azerbaijan": "10644",
			"Australia": "7036",
			"United Kingdom": "535368",
			"Singapore": "8266",
			"Albania": "51718",
			"Benin": "2418250",
			"FS Micronesia": "324",
			"Panama": "7555",
			"Cuba": "387378",
			"American Samoa": "2297153",
			"Saint Vincent and the Grenadines": "3336",
			"Curaçao": "905",
			"Armenia": "443",
			"Bahrain": "937",
			"Mexico": "368447",
			"Kenya": "3684",
			"Spain": "778266",
			"Tajikistan": "1630",
			"Ireland": "344605",
			"French Polynesia": "31898",
			"Honduras": "8921167",
			"Chile": "43308",
			"Gambia": "726",
			"China, Macao SAR": "22358",
			"Brunei Darussalam": "4984",
			"Malaysia": "534507",
			"Swaziland": "1358",
			"Portugal": "68821",
			"Saint Kitts and Nevis": "6110",
			"Nepal": "249",
			"China": "38292353",
			"Comoros": "2770",
			"Guinea-Bissau": "23461",
			"Mali": "343",
			"Trinidad and Tobago": "3418918",
			"Israel": "14301331",
			"Burkina Faso": "48",
			"Paraguay": "200195",
			"Bangladesh": "36663",
			"Antigua and Barbuda": "801",
			"Cyprus": "7736",
			"Yemen": "9",
			"Mauritius": "1080",
			"Slovakia": "3343",
			"Turkmenistan": "20144",
			"Syria": "263694",
			"Côte d'Ivoire": "5",
			"Guyana": "114000",
			"Algeria": "101",
			"USA": "10455822",
			"Namibia": "590",
			"Rep. of Moldova": "154",
			"Zambia": "8864",
			"Malta": "22430",
			"Ecuador": "13587",
			"Grenada": "7436",
			"Dominican Rep.": "10849",
			"France": "810590",
			"New Caledonia": "136",
			"Niue": "1195",
			"Seychelles": "507",
			"Br. Virgin Isds": "22595",
			"Italy": "3277186",
			"Saint Lucia": "635",
			"State of Palestine": "2227",
			"Uganda": "1596",
			"Belarus": "569",
			"Ethiopia": "9753",
			"Pitcairn": "19",
			"Senegal": "4110528",
			"Bulgaria": "732500",
			"Sri Lanka": "8163",
			"Hungary": "51",
			"Angola": "40027",
			"New Zealand": "467170",
			"N. Mariana Isds": "2",
			"Samoa": "2543647",
			"Myanmar": "3093",
			"Iran": "6470",
			"Sao Tome and Principe": "28340",
			"Uruguay": "6495",
			"Andorra": "94",
			"Cabo Verde": "26",
			"Germany": "12631378",
			"Poland": "3011750",
			"Thailand": "6728035",
			"Argentina": "102000",
			"Brazil": "1423176",
			"Dominica": "4538",
			"Mongolia": "3072",
			"Saudi Arabia": "863",
			"Greece": "4365182",
			"Russian Federation": "14789905",
			"United Arab Emirates": "41926",
			"Nicaragua": "7213442",
			"Malawi": "61334",
			"Switzerland": "123955",
			"El Salvador": "5803424",
			"Latvia": "35956",
			"Japan": "25685627",
			"Romania": "2715",
			"Slovenia": "139978",
			"Liberia": "6100000",
			"Guatemala": "7099",
			"Madagascar": "1330",
			"Bolivia (Plurinational State of)": "42084561",
			"Barbados": "87444",
			"Bahamas": "9477",
			"San Marino": "211",
			"Chad": "3383",
			"Viet Nam": "191293",
			"Haiti": "3263",
			"Tokelau": "848",
			"Oman": "10875",
			"Sweden": "17931707",
			"Maldives": "5737",
			"India": "4375186",
			"Jamaica": "16072",
			"Austria": "3733098",
			"Eritrea": "523",
			"Congo": "512",
			"Zimbabwe": "184100",
			"Vanuatu": "60255",
			"Fiji": "3714",
			"Lithuania": "689854",
			"Cambodia": "160011",
			"Denmark": "20204",
			"Peru": "694285",
			"Central African Rep.": "2929",
			"Netherlands": "27964",
			"Costa Rica": "511",
			"Equatorial Guinea": "671",
			"Sudan": "50550",
			"Kazakhstan": "2460398",
			"Afghanistan": "667",
			"Croatia": "4913",
			"Egypt": "284347",
			"Nauru": "393",
			"Estonia": "800",
			"Morocco": "1631249",
			"Luxembourg": "49568",
			"TFYR of Macedonia": "35588",
			"Somalia": "5105",
			"United Rep. of Tanzania": "22000",
			"Finland": "55801",
			"Belize": "2100",
			"Georgia": "7398",
			"Ukraine": "302700",
			"Bermuda": "80",
			"Djibouti": "12173",
			"Greenland": "120",
			"China, Hong Kong SAR": "97184",
			"Suriname": "101173",
			"Nigeria": "4925",
			"Venezuela": "4447",
			"Kuwait": "23608",
			"Norway": "1539548",
			"Sierra Leone": "226",
			"Marshall Isds": "157074",
			"Philippines": "39897",
			"Libya": "27",
			"Kyrgyzstan": "13",
			"Czechia": "41604",
			"Mozambique": "32318",
			"Aruba": "17682300",
			"Turkey": "2188357",
			"Tunisia": "23952",
			"Rep. of Korea": "22143766",
			"Serbia": "100522",
			"Burundi": "5922",
			"Bhutan": "4324",
			"Cook Isds": "1456",
			"Canada": "151153",
			"Iceland": "145016"
		},
		"exports": {
			"Lebanon": "2084207",
			"Bonaire": "79337",
			"Gibraltar": "167098488",
			"Ghana": "139620",
			"Cuba": "119",
			"Dem. Rep. of the Congo": "1046784",
			"Dem. People's Rep. of Korea": "103445",
			"Cameroon": "21192",
			"South Africa": "20766211",
			"Indonesia": "129975",
			"Niger": "137473",
			"Tonga": "131359",
			"Jordan": "419668",
			"Uzbekistan": "29396",
			"Iraq": "1906",
			"Guam": "1198",
			"Vanuatu": "64561",
			"Belgium": "740897",
			"Azerbaijan": "37284",
			"Rwanda": "2039",
			"Australia": "4821718",
			"United Kingdom": "31648",
			"Singapore": "98900",
			"Albania": "62659",
			"Benin": "579151",
			"Panama": "65363",
			"Qatar": "18872",
			"Saint Vincent and the Grenadines": "440434",
			"Curaçao": "924",
			"Armenia": "57809",
			"Mexico": "31590",
			"Kenya": "75",
			"Spain": "3267",
			"Tajikistan": "103737",
			"Ireland": "29368",
			"Norfolk Isds": "981269",
			"Honduras": "4380",
			"Chile": "2129173",
			"China, Macao SAR": "56447",
			"Brunei Darussalam": "21798",
			"Malaysia": "80",
			"Fiji": "185305",
			"Portugal": "1200",
			"Nepal": "3860",
			"China": "22312",
			"Comoros": "324027",
			"Mali": "151938",
			"Trinidad and Tobago": "8102",
			"Israel": "3500",
			"Burkina Faso": "263720",
			"Paraguay": "150981",
			"Bangladesh": "22612",
			"Antigua and Barbuda": "144725",
			"Gabon": "8238977",
			"Cyprus": "7857",
			"Yemen": "947102",
			"Mauritius": "29328",
			"Slovakia": "18880",
			"Turkmenistan": "1258",
			"Bahrain": "40445",
			"Côte d'Ivoire": "648",
			"Guyana": "923",
			"Algeria": "1291",
			"USA": "1705825",
			"Cambodia": "13661",
			"Rep. of Moldova": "527",
			"Zambia": "116473",
			"Malta": "630067",
			"Ecuador": "5580339",
			"Grenada": "146208",
			"Dominican Rep.": "221000",
			"France": "2709",
			"New Caledonia": "41221",
			"Seychelles": "10425",
			"Br. Virgin Isds": "83448",
			"Italy": "28704",
			"Saint Lucia": "66759955",
			"State of Palestine": "361776",
			"Uganda": "4291",
			"Syria": "1477117",
			"Belarus": "394958",
			"Ethiopia": "21200",
			"Congo": "1092016",
			"Senegal": "2830",
			"Bulgaria": "970918",
			"Montenegro": "44868",
			"Sri Lanka": "39338",
			"Hungary": "279994",
			"Angola": "1137283",
			"New Zealand": "61374",
			"Lao People's Dem. Rep.": "1355",
			"Myanmar": "66910",
			"Papua New Guinea": "1169",
			"Sao Tome and Principe": "42",
			"Uruguay": "3895",
			"Andorra": "213152",
			"Cabo Verde": "300150",
			"Germany": "2192",
			"Timor-Leste": "1720",
			"Poland": "528000",
			"Thailand": "16905780",
			"Argentina": "10791",
			"Brazil": "1966",
			"Dominica": "531161",
			"Saudi Arabia": "437429",
			"Greece": "163841",
			"Russian Federation": "5346122",
			"Cayman Isds": "18371",
			"United Arab Emirates": "756712",
			"Nicaragua": "1688",
			"Switzerland": "29980",
			"El Salvador": "9197",
			"Latvia": "3832",
			"Japan": "11681",
			"Guinea": "5115097",
			"Romania": "857421",
			"Slovenia": "14007051",
			"Liberia": "414758",
			"Guatemala": "325",
			"Madagascar": "4361",
			"Bolivia (Plurinational State of)": "89479",
			"Barbados": "633",
			"Bahamas": "101700",
			"Tunisia": "85405",
			"Chad": "6932",
			"Viet Nam": "623679",
			"Haiti": "50080",
			"Oman": "207663",
			"Sweden": "5038338",
			"Maldives": "8638",
			"India": "81112678",
			"Jamaica": "22005",
			"Austria": "12312",
			"Pakistan": "107539",
			"Lithuania": "398943",
			"Saint Kitts and Nevis": "92861",
			"Denmark": "1472010",
			"Peru": "461822",
			"Netherlands": "151",
			"Costa Rica": "589764",
			"Equatorial Guinea": "167253",
			"Sudan": "14621",
			"Kazakhstan": "671334",
			"Afghanistan": "4340",
			"Croatia": "346334",
			"Egypt": "56986",
			"Anguilla": "2839",
			"Estonia": "938680",
			"Morocco": "1344503",
			"Luxembourg": "1250",
			"TFYR of Macedonia": "204",
			"United Rep. of Tanzania": "1691134",
			"Finland": "5692364",
			"Belize": "543974",
			"Georgia": "2462845",
			"Ukraine": "346080",
			"Bermuda": "92358",
			"Djibouti": "357977",
			"China, Hong Kong SAR": "2637371",
			"Suriname": "4231024",
			"Nigeria": "8988",
			"Iran": "70758",
			"Venezuela": "52776",
			"Kuwait": "35426",
			"Norway": "58793",
			"Sierra Leone": "453513",
			"Philippines": "100",
			"Libya": "1096970",
			"Kyrgyzstan": "9690",
			"Czechia": "54702",
			"Mozambique": "346028",
			"Togo": "1653037",
			"Aruba": "18585",
			"Turkey": "727926681",
			"Rep. of Korea": "2160957",
			"Serbia": "72361",
			"Burundi": "5144",
			"Canada": "265801",
			"Iceland": "459281"
		}
	},
	"Niger": {
		"imports": {
			"Lebanon": "221669",
			"Ghana": "507505",
			"Philippines": "4305",
			"Switzerland": "520642",
			"Cabo Verde": "4308",
			"Germany": "2718418",
			"Poland": "474559",
			"Cuba": "10801",
			"Dem. Rep. of the Congo": "8815",
			"Thailand": "13756",
			"Dem. People's Rep. of Korea": "135451",
			"Argentina": "4389882",
			"Brazil": "15819777",
			"Cameroon": "135123",
			"Brunei Darussalam": "2185",
			"Iran": "92374",
			"Saudi Arabia": "2536",
			"Panama": "41358",
			"Sudan": "5879",
			"Russian Federation": "7486",
			"Cayman Isds": "3662",
			"United Arab Emirates": "309774",
			"Nicaragua": "533",
			"Italy": "62935",
			"Malawi": "557",
			"Andorra": "14135",
			"Mauritius": "96951",
			"United States Minor Outlying Islands": "565",
			"Ukraine": "97857",
			"Japan": "2982",
			"Guinea": "33836",
			"Romania": "17473",
			"Pakistan": "29462",
			"Belgium": "26198626",
			"Croatia": "28002",
			"Liberia": "13438",
			"Mozambique": "23483",
			"Madagascar": "302197",
			"Singapore": "361064",
			"Nigeria": "477216",
			"Albania": "138248",
			"Benin": "13544",
			"Maldives": "143",
			"Tunisia": "2686211",
			"Chad": "1462",
			"Viet Nam": "67787",
			"Haiti": "29158",
			"South Africa": "130722",
			"Indonesia": "1098116",
			"Qatar": "67401",
			"American Samoa": "8705",
			"Sweden": "33594",
			"Australia": "2707000",
			"India": "362146",
			"Jamaica": "2520",
			"Mexico": "45280",
			"Kenya": "36213",
			"Spain": "252",
			"Ireland": "81193",
			"Botswana": "541775",
			"Zimbabwe": "22",
			"China, Hong Kong SAR": "1106",
			"Austria": "490978",
			"Mauritania": "34878",
			"Namibia": "151",
			"Denmark": "1983831",
			"Portugal": "1348",
			"Honduras": "33",
			"Netherlands": "932284",
			"United Kingdom": "140805",
			"Costa Rica": "2336",
			"Turkey": "965589",
			"Greece": "999725",
			"Chile": "1844568",
			"Azerbaijan": "9974",
			"China, Macao SAR": "54",
			"Nepal": "2688",
			"Afghanistan": "361",
			"Malaysia": "51078956",
			"Swaziland": "27396",
			"Peru": "146931",
			"Falkland Isds (Malvinas)": "4628",
			"Jordan": "17500",
			"China": "7786471",
			"Egypt": "868159",
			"Nauru": "672",
			"Morocco": "610249",
			"Mali": "75310",
			"Trinidad and Tobago": "369",
			"Israel": "1798",
			"Venezuela": "2617",
			"Burkina Faso": "20665",
			"Bangladesh": "19257",
			"Gabon": "8631",
			"Finland": "100",
			"Cyprus": "275448",
			"Belize": "1944",
			"United Rep. of Tanzania": "2217",
			"Slovakia": "409",
			"Bermuda": "22",
			"Djibouti": "6",
			"Bahrain": "2890390",
			"Côte d'Ivoire": "1804642",
			"Algeria": "9556610",
			"USA": "2490894",
			"Cambodia": "445937",
			"Guinea-Bissau": "39004",
			"Kuwait": "1220",
			"Malta": "3170",
			"Norway": "3050",
			"Ecuador": "48105",
			"Sierra Leone": "30",
			"France": "17882257",
			"New Caledonia": "31",
			"Luxembourg": "55047",
			"Libya": "23457",
			"Czechia": "55082",
			"Rwanda": "4535",
			"Syria": "33594",
			"Guatemala": "326407",
			"Ethiopia": "43589",
			"Slovenia": "96907",
			"Togo": "3971465",
			"Congo": "10109",
			"Senegal": "41508",
			"Bulgaria": "503045",
			"Sri Lanka": "7248",
			"Rep. of Korea": "49402",
			"Hungary": "37435",
			"Burundi": "36392",
			"Bhutan": "1646",
			"New Zealand": "197280",
			"Canada": "3229043",
			"Iceland": "1744",
			"Lao People's Dem. Rep.": "608"
		},
		"exports": {
			"Lebanon": "1414689",
			"Ghana": "59543",
			"Andorra": "17765",
			"Germany": "3346",
			"Poland": "16730",
			"Thailand": "172660",
			"Dem. People's Rep. of Korea": "1722",
			"Brazil": "5555607",
			"Cameroon": "33906",
			"Brunei Darussalam": "2928",
			"South Africa": "1790",
			"Saudi Arabia": "1338",
			"Panama": "5019",
			"Russian Federation": "15532",
			"United Arab Emirates": "156026",
			"Nicaragua": "48184",
			"Jordan": "1673",
			"Switzerland": "137509",
			"United States Minor Outlying Islands": "1673",
			"Slovakia": "9998",
			"Japan": "1506",
			"Guinea": "20411",
			"Pakistan": "11438",
			"Belgium": "827766",
			"Italy": "335",
			"Togo": "69097",
			"Singapore": "6175580",
			"Nigeria": "116360",
			"Benin": "2812",
			"Tunisia": "745158",
			"Chad": "13623",
			"Viet Nam": "1755487",
			"Haiti": "50191",
			"Indonesia": "933469",
			"Sweden": "730",
			"Australia": "32995",
			"India": "2912127",
			"Jamaica": "2578",
			"Mexico": "903",
			"Kenya": "2510",
			"Spain": "1724754",
			"Eritrea": "17748",
			"Ireland": "23331",
			"China, Hong Kong SAR": "455097",
			"Norfolk Isds": "31537",
			"Mauritania": "4417",
			"Namibia": "294",
			"Denmark": "17216",
			"Netherlands": "555742",
			"United Kingdom": "25409",
			"Costa Rica": "25207",
			"Bulgaria": "27910",
			"Chile": "12754",
			"Malaysia": "102060370",
			"Swaziland": "1004",
			"Portugal": "117768",
			"China": "2739185",
			"Egypt": "1472882",
			"Morocco": "502",
			"Mali": "301933",
			"Venezuela": "400",
			"Burkina Faso": "17392",
			"Gabon": "5280",
			"Finland": "2510",
			"Belize": "19240",
			"Hungary": "3167",
			"Luxembourg": "99",
			"Madagascar": "22185",
			"Bahrain": "1179932",
			"Côte d'Ivoire": "71915",
			"Algeria": "2032020",
			"USA": "349335",
			"Kuwait": "1468",
			"Norway": "9462",
			"Ecuador": "1673",
			"France": "14394",
			"New Caledonia": "25723",
			"Libya": "22218",
			"Ethiopia": "6692",
			"Senegal": "31764",
			"Turkey": "384595",
			"Rep. of Korea": "2510",
			"Serbia": "49187",
			"New Zealand": "27724",
			"Canada": "21151",
			"Iceland": "4183",
			"Ukraine": "11286"
		}
	},
	"Palau": {
		"imports": {
			"Slovakia": "10983",
			"South Africa": "18",
			"Andorra": "6875",
			"Germany": "655",
			"Timor-Leste": "2879",
			"Poland": "53",
			"Thailand": "31095",
			"Brazil": "52",
			"Cameroon": "2556",
			"Brunei Darussalam": "3",
			"Mongolia": "2294",
			"Saudi Arabia": "20",
			"Panama": "1065",
			"Colombia": "60",
			"Niger": "2288",
			"United Arab Emirates": "85",
			"Nicaragua": "592",
			"Switzerland": "92913",
			"Ukraine": "6006",
			"Japan": "4825177",
			"Guam": "385587",
			"Pakistan": "68",
			"Belgium": "173468",
			"Azerbaijan": "3481",
			"United Kingdom": "33845",
			"Singapore": "30585",
			"Viet Nam": "246",
			"FS Micronesia": "32501",
			"Indonesia": "70741",
			"Tuvalu": "510",
			"Sweden": "114",
			"Australia": "2209",
			"India": "2470",
			"Jamaica": "22670",
			"Mexico": "4234",
			"Kenya": "65",
			"Austria": "214",
			"Côte d'Ivoire": "15921",
			"French Polynesia": "50",
			"Mauritania": "80",
			"Namibia": "2",
			"Denmark": "14925",
			"Peru": "108",
			"Honduras": "412",
			"Netherlands": "1499",
			"Costa Rica": "26161",
			"Bulgaria": "53",
			"Greece": "1500",
			"Slovenia": "116",
			"Gambia": "4759",
			"China, Macao SAR": "26418",
			"Malaysia": "48398",
			"Fiji": "1934",
			"Portugal": "68",
			"Nepal": "32",
			"China": "917763",
			"Nauru": "3064",
			"Estonia": "52",
			"Morocco": "10",
			"Mali": "3346",
			"Israel": "1650",
			"Bangladesh": "13384",
			"Antigua and Barbuda": "40",
			"Gabon": "58",
			"Finland": "33083",
			"Belize": "47",
			"Hungary": "151",
			"Djibouti": "10",
			"Bahrain": "455",
			"China, Hong Kong SAR": "204559",
			"Guyana": "1",
			"Russian Federation": "468",
			"USA": "3141892",
			"Cambodia": "2500",
			"Guinea-Bissau": "395",
			"Kuwait": "15",
			"Spain": "5293",
			"Malta": "20",
			"Norway": "1800",
			"Ecuador": "385",
			"Sierra Leone": "53",
			"Dominican Rep.": "384",
			"Marshall Isds": "15",
			"New Caledonia": "26",
			"Philippines": "710998",
			"Seychelles": "244",
			"Italy": "37745",
			"Kyrgyzstan": "6",
			"Czechia": "1307",
			"Uganda": "10",
			"Senegal": "66",
			"Turkey": "621",
			"Sri Lanka": "185",
			"Rep. of Korea": "583964",
			"France": "4223",
			"Holy See (Vatican City State)": "52",
			"Cook Isds": "515",
			"N. Mariana Isds": "2731",
			"Canada": "17416",
			"Iceland": "39745",
			"Lao People's Dem. Rep.": "135",
			"New Zealand": "166755"
		},
		"exports": {
			"USA": "6650",
			"Papua New Guinea": "3660",
			"Switzerland": "350",
			"Germany": "3675",
			"Singapore": "31625",
			"Andorra": "84800",
			"Poland": "11480",
			"Rep. of Korea": "1300",
			"China": "3637",
			"Japan": "20000",
			"Guam": "107698",
			"FS Micronesia": "47318",
			"Panama": "151",
			"Morocco": "17122"
		}
	},
	"Tonga": {
		"imports": {},
		"exports": {}
	},
	"Jordan": {
		"imports": {
			"Lebanon": "18005060",
			"Côte d'Ivoire": "692407",
			"Iran": "39313",
			"Niger": "1025",
			"Uruguay": "36908",
			"Mongolia": "1266",
			"Germany": "136015838",
			"Poland": "24123525",
			"Cuba": "67168",
			"Thailand": "31067760",
			"Argentina": "4294",
			"Brazil": "160311698",
			"Cameroon": "5052",
			"South Africa": "629420",
			"Uzbekistan": "185348",
			"Saudi Arabia": "295111555",
			"Panama": "17746",
			"Colombia": "23604767",
			"Sudan": "2393",
			"Russian Federation": "6163211",
			"United Arab Emirates": "66738034",
			"Lao People's Dem. Rep.": "6310",
			"Tajikistan": "6528",
			"Angola": "57731",
			"Kazakhstan": "92000",
			"Switzerland": "5143772",
			"El Salvador": "128458",
			"Iraq": "1309572",
			"Slovakia": "1239600",
			"Latvia": "859157",
			"Japan": "563231",
			"Guatemala": "8548062",
			"Guinea": "525647",
			"Bosnia Herzegovina": "103387",
			"Pakistan": "387471",
			"Belgium": "468373",
			"Croatia": "17117",
			"Australia": "16030465",
			"United Kingdom": "31142436",
			"Singapore": "1927179",
			"Nigeria": "3606",
			"Albania": "3006",
			"Benin": "26369",
			"Tunisia": "1083",
			"Mozambique": "1408",
			"Viet Nam": "12485503",
			"Haiti": "2955",
			"Indonesia": "10654",
			"Qatar": "491475",
			"Saint Vincent and the Grenadines": "33037314",
			"Oman": "6215128",
			"Sweden": "3023274",
			"Armenia": "8592",
			"Bahrain": "175463",
			"India": "37813995",
			"Jamaica": "14485",
			"Mexico": "1610947",
			"Kenya": "57963",
			"Austria": "2046",
			"Romania": "1379641",
			"Ireland": "85225",
			"Zimbabwe": "3003629",
			"South Sudan": "357321",
			"Spain": "28408045",
			"Mauritania": "18323",
			"Lithuania": "407996",
			"Nicaragua": "3297",
			"Namibia": "104344",
			"Denmark": "34042",
			"Peru": "50175",
			"Honduras": "3379",
			"China, Hong Kong SAR": "2867522",
			"Netherlands": "62783936",
			"Eritrea": "2928",
			"Costa Rica": "160762",
			"Papua New Guinea": "3127413",
			"Turkey": "66707630",
			"Greece": "51366",
			"Chile": "1213475",
			"Azerbaijan": "22968",
			"Malawi": "871790",
			"Somalia": "1105637",
			"Libya": "414535",
			"Afghanistan": "7989",
			"Mali": "6197",
			"Malaysia": "3281665",
			"Portugal": "4381681",
			"United Rep. of Tanzania": "67706",
			"Nepal": "58046",
			"China": "12899597",
			"Egypt": "27093039",
			"Guinea-Bissau": "1239135",
			"Estonia": "55137",
			"Morocco": "17052423",
			"Djibouti": "293147",
			"Israel": "8730",
			"Venezuela": "755668",
			"Burkina Faso": "117320",
			"Paraguay": "1339586",
			"Bangladesh": "18574990",
			"Gabon": "43546",
			"Finland": "1095134",
			"Cyprus": "29439",
			"Yemen": "2939943",
			"Georgia": "8569",
			"Ukraine": "145434",
			"Luxembourg": "2580632",
			"Madagascar": "30156",
			"Turkmenistan": "7896",
			"Syria": "873476",
			"Zambia": "4225",
			"Bolivia (Plurinational State of)": "18715",
			"Ghana": "7042",
			"Mauritius": "17852",
			"Algeria": "53130724",
			"USA": "123077712",
			"Cambodia": "2358",
			"Rep. of Moldova": "3219736",
			"TFYR of Macedonia": "167918",
			"Kuwait": "10886767",
			"Malta": "1090983",
			"Norway": "4095337",
			"Ecuador": "37566",
			"Serbia": "132356",
			"Sierra Leone": "111417",
			"Dominican Rep.": "6749",
			"France": "10142757",
			"Philippines": "416859",
			"Italy": "28900909",
			"Kyrgyzstan": "476651",
			"State of Palestine": "48120",
			"Uganda": "53097",
			"Belarus": "78716",
			"Ethiopia": "328623",
			"Slovenia": "2266739",
			"Togo": "22721",
			"Congo": "274706",
			"Senegal": "3521",
			"Aruba": "903188",
			"Bulgaria": "5811587",
			"Sri Lanka": "2408809",
			"Rep. of Korea": "3274396",
			"Hungary": "6208863",
			"New Zealand": "46424593",
			"Canada": "206442",
			"Iceland": "308",
			"Czechia": "305840",
			"Myanmar": "474162"
		},
		"exports": {
			"Lebanon": "8980558",
			"Slovakia": "1224257",
			"Ghana": "38013",
			"Philippines": "123347",
			"Niger": "24239",
			"Uruguay": "12896",
			"Peru": "2918",
			"Germany": "154351",
			"Poland": "125611",
			"Qatar": "13175815",
			"Bolivia (Plurinational State of)": "76497",
			"Thailand": "90987",
			"Argentina": "286830",
			"Brazil": "279162",
			"Azerbaijan": "303356",
			"Cameroon": "25975",
			"Brunei Darussalam": "37196",
			"Iran": "33554",
			"Mongolia": "59703",
			"Saudi Arabia": "60700183",
			"Panama": "23104",
			"Colombia": "704",
			"Syria": "210065",
			"Russian Federation": "464040",
			"United Arab Emirates": "7380751",
			"Gabon": "43269",
			"Tajikistan": "106621",
			"Libya": "6457870",
			"Malawi": "6411",
			"Switzerland": "156451",
			"El Salvador": "50497",
			"Togo": "41531",
			"Ukraine": "38913",
			"Iraq": "222459",
			"Czechia": "50285",
			"Guatemala": "9859",
			"Guinea": "5492",
			"Uganda": "83676",
			"Bosnia Herzegovina": "76932",
			"Pakistan": "544987",
			"Belgium": "5108",
			"Japan": "39275",
			"Croatia": "226187",
			"Rwanda": "51169",
			"Australia": "1233061",
			"United Kingdom": "1261024",
			"Singapore": "1419357",
			"Nigeria": "52366",
			"Albania": "66877",
			"Benin": "108118",
			"Maldives": "2483",
			"Tunisia": "128945",
			"Chad": "54503",
			"Viet Nam": "58773",
			"Haiti": "53685",
			"South Africa": "3015785",
			"Indonesia": "146438",
			"Oman": "3695766",
			"Uzbekistan": "7330",
			"Sweden": "21900",
			"Armenia": "86918",
			"India": "317465",
			"Jamaica": "255392",
			"Mexico": "2421386",
			"Kenya": "287876",
			"Austria": "84989",
			"Eritrea": "430",
			"Ireland": "1358",
			"Côte d'Ivoire": "71316",
			"Spain": "2611313",
			"Mauritania": "98534",
			"Mozambique": "3521",
			"Lithuania": "87423",
			"Cambodia": "12135",
			"Denmark": "76500",
			"Somalia": "434306",
			"Honduras": "467238",
			"Netherlands": "2836544",
			"Venezuela": "24490",
			"Bulgaria": "48749",
			"Greece": "12190",
			"Chile": "42023",
			"Kazakhstan": "2935",
			"Sudan": "37613054",
			"Gambia": "9199",
			"Liberia": "554744",
			"Afghanistan": "30775",
			"South Sudan": "394945",
			"Malaysia": "362849",
			"Portugal": "55744",
			"Nepal": "640004",
			"China": "1665807",
			"Egypt": "2686846",
			"Guinea-Bissau": "32394",
			"Estonia": "7292",
			"Morocco": "2133099",
			"Djibouti": "889918",
			"Israel": "1769110",
			"TFYR of Macedonia": "21097",
			"Burkina Faso": "91794",
			"Paraguay": "466811",
			"Bangladesh": "1486",
			"United Rep. of Tanzania": "137066",
			"Finland": "43131",
			"Cyprus": "171285",
			"Yemen": "7630028",
			"Georgia": "118873",
			"Serbia": "61849",
			"Mali": "600606",
			"Madagascar": "22542",
			"Turkmenistan": "602873",
			"Bahrain": "438247",
			"Zambia": "51739",
			"China, Hong Kong SAR": "2880215",
			"Angola": "14170",
			"Algeria": "1691355",
			"USA": "9011782",
			"Rep. of Moldova": "296093",
			"Romania": "377261",
			"Kuwait": "51888125",
			"Malta": "2946",
			"Norway": "223937",
			"Ecuador": "1699",
			"Sierra Leone": "521",
			"Dominican Rep.": "199827",
			"France": "4993",
			"Luxembourg": "1587",
			"Latvia": "7869",
			"Italy": "96939",
			"Kyrgyzstan": "121904",
			"State of Palestine": "2705594",
			"Nicaragua": "5634",
			"Belarus": "4699",
			"Ethiopia": "1426524",
			"Slovenia": "162528",
			"Mauritius": "45655",
			"Congo": "201585",
			"Senegal": "205178",
			"Aruba": "5841",
			"Turkey": "962458",
			"Sri Lanka": "15669",
			"Rep. of Korea": "897",
			"Hungary": "2789",
			"Burundi": "3237",
			"New Zealand": "139817",
			"Canada": "29459",
			"Iceland": "22711",
			"Lao People's Dem. Rep.": "1408",
			"Myanmar": "704"
		}
	},
	"Fr. South Antarctic Terr.": {
		"imports": {},
		"exports": {}
	},
	"Uzbekistan": {
		"imports": {},
		"exports": {}
	},
	"Iraq": {
		"imports": {},
		"exports": {}
	},
	"Tuvalu": {
		"imports": {},
		"exports": {}
	},
	"Guam": {
		"imports": {},
		"exports": {}
	},
	"Bosnia Herzegovina": {
		"imports": {
			"Lebanon": "797",
			"Ghana": "5194323",
			"Lesotho": "5243",
			"Qatar": "8313",
			"Dem. Rep. of the Congo": "124",
			"Dem. People's Rep. of Korea": "13260",
			"Cameroon": "199186",
			"South Africa": "932157",
			"Montserrat": "45",
			"Indonesia": "108127",
			"Colombia": "16249040",
			"Niger": "73",
			"Jordan": "83961",
			"Fr. South Antarctic Terr.": "1",
			"Uzbekistan": "277",
			"Iraq": "17260",
			"Tuvalu": "144",
			"Pakistan": "22",
			"Belgium": "74098156",
			"Azerbaijan": "18361",
			"Rwanda": "604",
			"Armenia": "8027",
			"Germany": "1119824325",
			"Singapore": "404097",
			"Albania": "8938059",
			"Panama": "24867",
			"Cuba": "124958",
			"Saint Vincent and the Grenadines": "90",
			"Curaçao": "96",
			"Australia": "30987077",
			"Kiribati": "27333",
			"Kenya": "18794",
			"Spain": "2272740",
			"Tajikistan": "213",
			"Ireland": "635600",
			"Botswana": "374",
			"French Polynesia": "10879",
			"Mauritania": "5159",
			"Christmas Isds": "249",
			"Honduras": "140723",
			"Saint Barthélemy": "580",
			"Holy See (Vatican City State)": "291",
			"United Kingdom": "335950",
			"Chile": "2367432",
			"Sudan": "17",
			"China, Macao SAR": "251",
			"Dominica": "123",
			"Malaysia": "125",
			"Fiji": "5001",
			"Somalia": "1630",
			"Falkland Isds (Malvinas)": "374798",
			"Nepal": "32",
			"China": "617444441",
			"Comoros": "2644",
			"Djibouti": "28",
			"Trinidad and Tobago": "5061",
			"Israel": "66",
			"Burkina Faso": "153",
			"Paraguay": "1758",
			"Bangladesh": "22274250",
			"Gabon": "19338",
			"Cyprus": "1807781",
			"Yemen": "4580",
			"Mauritius": "128899",
			"Slovakia": "19756",
			"Faeroe Isds": "1730",
			"Turkmenistan": "33680",
			"Bahrain": "122904",
			"Côte d'Ivoire": "92283",
			"Guyana": "535",
			"Algeria": "819122",
			"USA": "1493808",
			"Cambodia": "5089941",
			"Rep. of Moldova": "70525",
			"Zambia": "223772",
			"Malta": "114",
			"Ecuador": "12897826",
			"Grenada": "4652",
			"Dominican Rep.": "1922207",
			"France": "200047521",
			"New Caledonia": "9",
			"Niue": "61",
			"Seychelles": "45200",
			"Br. Virgin Isds": "23836",
			"Italy": "1059099",
			"State of Palestine": "503",
			"Uganda": "4375",
			"Belarus": "4699911",
			"Ethiopia": "191100",
			"Namibia": "17528",
			"Congo": "5972",
			"Senegal": "380",
			"Bulgaria": "77775005",
			"Montenegro": "6225475",
			"Sri Lanka": "1313731",
			"Hungary": "229052638",
			"New Zealand": "39",
			"Lao People's Dem. Rep.": "127",
			"Myanmar": "665832",
			"Iran": "332",
			"Sao Tome and Principe": "802",
			"Uruguay": "39315",
			"Switzerland": "111373",
			"Cabo Verde": "418",
			"Togo": "65132",
			"Timor-Leste": "2766",
			"Poland": "25232",
			"Thailand": "334756",
			"Argentina": "10703372",
			"Brazil": "119924426",
			"Brunei Darussalam": "366",
			"Mongolia": "3284",
			"Saudi Arabia": "3323",
			"Syria": "76",
			"Russian Federation": "2659506",
			"United Arab Emirates": "3",
			"Nicaragua": "265",
			"Portugal": "5204",
			"Malawi": "13252",
			"Andorra": "21788",
			"El Salvador": "5972",
			"United States Minor Outlying Islands": "516",
			"Sierra Leone": "14903",
			"Latvia": "44594",
			"Japan": "1021926",
			"Romania": "1366773",
			"Slovenia": "741192",
			"Mozambique": "13889",
			"Madagascar": "38893",
			"Bolivia (Plurinational State of)": "195583",
			"Nigeria": "3731",
			"Bahamas": "3455",
			"Tunisia": "40170",
			"Chad": "210",
			"Viet Nam": "2138916",
			"Haiti": "19075",
			"Tokelau": "12",
			"South Georgia and the South Sandwich Islands": "3834",
			"Oman": "405",
			"Sweden": "5881850",
			"Maldives": "1504",
			"India": "15331436",
			"Mexico": "2185",
			"Austria": "311361708",
			"Zimbabwe": "23",
			"Swaziland": "13",
			"Lithuania": "56929",
			"Saint Kitts and Nevis": "12530",
			"Denmark": "16731186",
			"Peru": "18104",
			"Central African Rep.": "1352",
			"Netherlands": "27464",
			"Costa Rica": "8016514",
			"Greece": "102727255",
			"Kazakhstan": "291021",
			"Afghanistan": "5307",
			"Croatia": "908065937",
			"Saint Helena": "105",
			"Egypt": "76402",
			"Estonia": "1866041",
			"Morocco": "247634",
			"Luxembourg": "21304",
			"TFYR of Macedonia": "688",
			"United Rep. of Tanzania": "2014",
			"Finland": "8484751",
			"Belize": "32431",
			"Georgia": "96398",
			"Ukraine": "14334",
			"Bermuda": "118",
			"Mali": "46",
			"China, Hong Kong SAR": "3713283",
			"Suriname": "118",
			"Barbados": "19554",
			"Venezuela": "25883",
			"Kuwait": "2392",
			"Norway": "13369",
			"Pitcairn": "709",
			"Philippines": "124532",
			"Libya": "1835",
			"Kyrgyzstan": "589832",
			"Czechia": "150525426",
			"Br. Indian Ocean Terr.": "795",
			"Guatemala": "576273",
			"Turkey": "15157315",
			"San Marino": "12011",
			"Rep. of Korea": "9498",
			"Serbia": "17666700",
			"Bhutan": "80",
			"Cook Isds": "43",
			"Canada": "7031696",
			"Iceland": "265688"
		},
		"exports": {
			"Lebanon": "11",
			"Iran": "46707",
			"Philippines": "537",
			"Dominican Rep.": "216057",
			"United Kingdom": "703385",
			"Timor-Leste": "93",
			"Poland": "24205",
			"Qatar": "406",
			"Dem. Rep. of the Congo": "1867",
			"Thailand": "10179",
			"Argentina": "165341",
			"Brazil": "786424",
			"Azerbaijan": "435542",
			"Cameroon": "17994",
			"South Africa": "2268",
			"Mongolia": "9864",
			"Saudi Arabia": "75674",
			"Indonesia": "1812",
			"Colombia": "728",
			"Syria": "112186",
			"Russian Federation": "226554",
			"United Arab Emirates": "83555",
			"Rwanda": "17267",
			"Libya": "33543",
			"Switzerland": "234309",
			"El Salvador": "55",
			"Slovakia": "178805",
			"Latvia": "14361",
			"Japan": "27",
			"Iraq": "25748",
			"Romania": "65228",
			"Pakistan": "59",
			"Belgium": "27499115",
			"Slovenia": "1654278",
			"Armenia": "46282",
			"Germany": "835519725",
			"Singapore": "839125",
			"Nigeria": "44999",
			"Albania": "25677618",
			"Benin": "2213",
			"Tunisia": "8042",
			"Viet Nam": "109494",
			"Haiti": "8121",
			"Panama": "1217",
			"Cuba": "23640",
			"Oman": "20468",
			"Sweden": "267970",
			"Australia": "1304252",
			"India": "420971",
			"Mexico": "5709",
			"Kenya": "14599",
			"Spain": "147",
			"Tajikistan": "166",
			"Ireland": "33",
			"Zimbabwe": "45424",
			"China, Hong Kong SAR": "702870",
			"Austria": "412098762",
			"Mauritania": "7783",
			"Lithuania": "47267",
			"Saint Kitts and Nevis": "57",
			"Denmark": "8179012",
			"Somalia": "46943",
			"Netherlands": "6169248",
			"Costa Rica": "22982",
			"Bulgaria": "44899381",
			"Sudan": "2431",
			"Chile": "29701",
			"Kazakhstan": "36360",
			"Liberia": "67267",
			"Afghanistan": "6882",
			"Croatia": "555862873",
			"Montenegro": "9315",
			"China": "14715145",
			"Malaysia": "33",
			"Peru": "26882",
			"Greece": "6379420",
			"Egypt": "21189",
			"Estonia": "2799565",
			"Morocco": "942",
			"Mali": "19474",
			"Israel": "240841",
			"TFYR of Macedonia": "301704",
			"Burkina Faso": "180",
			"French Polynesia": "996",
			"Bangladesh": "53104",
			"United Rep. of Tanzania": "615",
			"Finland": "1003918",
			"Cyprus": "1321476",
			"Yemen": "131569",
			"Georgia": "214563",
			"Hungary": "451481",
			"Luxembourg": "269",
			"Bahrain": "86169",
			"Côte d'Ivoire": "42302",
			"Ghana": "77732",
			"Suriname": "16288",
			"Algeria": "253181",
			"USA": "10279",
			"Namibia": "15",
			"Rep. of Moldova": "209",
			"Kuwait": "76737",
			"Malta": "1048",
			"Norway": "169672",
			"Ecuador": "4698",
			"Sierra Leone": "93568",
			"Portugal": "33",
			"France": "89776344",
			"New Caledonia": "2112",
			"Sao Tome and Principe": "144",
			"Seychelles": "1981775",
			"Br. Virgin Isds": "21922",
			"Italy": "8076",
			"Czechia": "80146925",
			"Uganda": "553",
			"Belarus": "1131600",
			"Ethiopia": "160147",
			"Congo": "58129",
			"Senegal": "1130",
			"Turkey": "2819500",
			"San Marino": "32304",
			"Sri Lanka": "58898",
			"Rep. of Korea": "113",
			"Serbia": "4555896",
			"Angola": "347852",
			"Jordan": "235890",
			"Canada": "6766373",
			"Iceland": "1357",
			"Lao People's Dem. Rep.": "19663",
			"Ukraine": "427",
			"New Zealand": "39990"
		}
	},
	"Vanuatu": {
		"imports": {},
		"exports": {}
	},
	"Belgium": {
		"imports": {
			"Lebanon": "1482",
			"Bonaire": "263",
			"Gibraltar": "454",
			"Ghana": "4398968",
			"Lesotho": "69",
			"Cuba": "6249352",
			"Dem. Rep. of the Congo": "5543",
			"Dem. People's Rep. of Korea": "298",
			"Cameroon": "108792",
			"Papua New Guinea": "3945027",
			"Montserrat": "2",
			"Indonesia": "125699",
			"Colombia": "261257",
			"Niger": "114",
			"Tonga": "901",
			"Angola": "583",
			"Fr. South Antarctic Terr.": "1",
			"Uzbekistan": "40",
			"Iraq": "1982",
			"Tuvalu": "530",
			"Guam": "166",
			"Bosnia Herzegovina": "1115845",
			"Pakistan": "3196",
			"Azerbaijan": "831",
			"Armenia": "42183597",
			"Togo": "196632",
			"Singapore": "1332",
			"Albania": "250048",
			"Benin": "650",
			"South Africa": "60241",
			"FS Micronesia": "150",
			"Panama": "4896",
			"Qatar": "3060",
			"American Samoa": "31",
			"Saint Vincent and the Grenadines": "3279",
			"Curaçao": "153",
			"Australia": "13246",
			"Mexico": "41174750",
			"Br. Virgin Isds": "36000",
			"Spain": "8222857",
			"Tajikistan": "1793",
			"Ireland": "22268",
			"Botswana": "8893",
			"South Sudan": "4267",
			"French Polynesia": "370",
			"Mauritania": "885",
			"Christmas Isds": "28",
			"Honduras": "2586106",
			"Saint Barthélemy": "326526",
			"Holy See (Vatican City State)": "404",
			"United Kingdom": "13974957",
			"Chile": "23820",
			"Gambia": "83",
			"Liberia": "12",
			"Dominica": "431",
			"Malaysia": "48553",
			"Fiji": "155",
			"Portugal": "8272575",
			"Falkland Isds (Malvinas)": "5107",
			"Nepal": "80036",
			"China": "901375539",
			"Comoros": "114",
			"Guinea-Bissau": "30992",
			"Saint Maarten": "314",
			"Mali": "65448",
			"Trinidad and Tobago": "113",
			"Israel": "11320",
			"Burkina Faso": "2010",
			"Paraguay": "114156",
			"Norfolk Isds": "158105",
			"Bangladesh": "1137159042",
			"Antigua and Barbuda": "3737",
			"Gabon": "2010",
			"Cyprus": "3994208",
			"Yemen": "583800",
			"Mauritius": "664",
			"Slovakia": "6918230",
			"Faeroe Isds": "122",
			"Turkmenistan": "336",
			"Bahrain": "82272441",
			"Côte d'Ivoire": "3484",
			"Guyana": "1674300",
			"Saint Pierre and Miquelon": "2634",
			"Algeria": "27869654",
			"USA": "539572785",
			"Namibia": "397346",
			"Rep. of Moldova": "17267",
			"Zambia": "468845",
			"Malta": "1395",
			"Ecuador": "12997668",
			"Grenada": "150232",
			"Dominican Rep.": "50693272",
			"France": "266440934",
			"New Caledonia": "184822",
			"Seychelles": "3693442",
			"Italy": "60769978",
			"Saint Lucia": "9143",
			"State of Palestine": "320036",
			"Rwanda": "34375",
			"Syria": "31",
			"Belarus": "1461007",
			"Ethiopia": "6343",
			"Slovenia": "546374",
			"Congo": "2180",
			"Senegal": "8202",
			"Bulgaria": "17281946",
			"Montenegro": "9962",
			"Sri Lanka": "120226525",
			"Hungary": "3472151",
			"Jordan": "16375",
			"N. Mariana Isds": "95",
			"Lao People's Dem. Rep.": "553",
			"Myanmar": "9818083",
			"Iran": "143043",
			"Sao Tome and Principe": "2482404",
			"Uruguay": "1702310",
			"Andorra": "22800",
			"Cabo Verde": "547",
			"Germany": "244165949",
			"Timor-Leste": "3101082",
			"Poland": "3977501",
			"Thailand": "28801273",
			"Argentina": "156187",
			"Brazil": "394936",
			"Brunei Darussalam": "992",
			"Mongolia": "154",
			"Saudi Arabia": "34371405",
			"Sudan": "300",
			"Russian Federation": "33866",
			"Cayman Isds": "52",
			"United Arab Emirates": "1785873",
			"Nicaragua": "687784",
			"Malawi": "18340",
			"Switzerland": "1173727",
			"El Salvador": "339",
			"United States Minor Outlying Islands": "11325",
			"Latvia": "2528",
			"Japan": "99160820",
			"Guinea": "3108",
			"Uganda": "14132797",
			"Romania": "3582009",
			"Croatia": "4062143",
			"China, Macao SAR": "63",
			"Guatemala": "797",
			"Madagascar": "4427",
			"Bolivia (Plurinational State of)": "161404",
			"Barbados": "199",
			"Saint Kitts and Nevis": "146",
			"Bahamas": "8131634",
			"San Marino": "144245",
			"Chad": "3010",
			"Viet Nam": "329218",
			"Haiti": "871",
			"Tokelau": "35092",
			"Oman": "28686",
			"Sweden": "2164402",
			"Maldives": "577836",
			"India": "2681885",
			"Jamaica": "62497",
			"Austria": "2475710",
			"Eritrea": "29",
			"Zimbabwe": "345546",
			"Vanuatu": "1648",
			"Swaziland": "130884",
			"Lithuania": "2495544",
			"Cambodia": "260318296",
			"Denmark": "210479729",
			"Peru": "5147083",
			"Central African Rep.": "1626",
			"Netherlands": "184631352",
			"Costa Rica": "7588513",
			"Equatorial Guinea": "294",
			"Greece": "9558",
			"Kazakhstan": "17710",
			"Kenya": "6180088",
			"Afghanistan": "1336",
			"Saint Helena": "524",
			"Egypt": "386",
			"Estonia": "1531",
			"Morocco": "3874",
			"Antarctica": "4823",
			"TFYR of Macedonia": "137007812",
			"United Rep. of Tanzania": "17931",
			"Finland": "2601782",
			"Belize": "19716",
			"Georgia": "34570",
			"Ukraine": "10847",
			"Bermuda": "2607",
			"Djibouti": "59",
			"Greenland": "1439",
			"China, Hong Kong SAR": "225782",
			"Suriname": "51185",
			"Nigeria": "55693",
			"Samoa": "1150",
			"Venezuela": "27",
			"Kuwait": "387",
			"New Zealand": "320588",
			"Norway": "87484",
			"Sierra Leone": "4689",
			"Marshall Isds": "10",
			"Philippines": "1711111",
			"Libya": "1084",
			"Kyrgyzstan": "496822",
			"Czechia": "235981518",
			"Br. Indian Ocean Terr.": "603",
			"Mozambique": "822529",
			"Aruba": "3784",
			"Turkey": "451536",
			"Tunisia": "282510",
			"Rep. of Korea": "6773297",
			"Serbia": "283662",
			"Burundi": "207",
			"Bhutan": "779926",
			"Cook Isds": "8285",
			"Canada": "9200165",
			"Iceland": "58921456",
			"Luxembourg": "508157"
		},
		"exports": {
			"Lebanon": "95354",
			"Bonaire": "122088",
			"Gibraltar": "29829",
			"Ghana": "245212",
			"Lesotho": "302188",
			"Cuba": "827635",
			"Dem. Rep. of the Congo": "31921835",
			"Dem. People's Rep. of Korea": "33697",
			"Cameroon": "3396378",
			"Papua New Guinea": "1882",
			"Montserrat": "2024",
			"Panama": "103012",
			"Colombia": "158238269",
			"Niger": "2734",
			"Palau": "4649",
			"Tonga": "18870",
			"Angola": "95457",
			"Fr. South Antarctic Terr.": "129",
			"Uzbekistan": "2413",
			"Iraq": "3068",
			"Guam": "654636",
			"Bosnia Herzegovina": "1564377",
			"Vanuatu": "10392",
			"Azerbaijan": "1526523",
			"Armenia": "1958037",
			"Togo": "46605",
			"Singapore": "170510",
			"Albania": "1126075",
			"Benin": "1544580",
			"South Africa": "442634",
			"Indonesia": "1330098",
			"Qatar": "40726",
			"American Samoa": "47969",
			"Saint Vincent and the Grenadines": "2214",
			"Curaçao": "68435",
			"Australia": "2633858",
			"Kiribati": "22711",
			"Jamaica": "55",
			"Br. Virgin Isds": "6337",
			"Spain": "63493711",
			"Tajikistan": "553",
			"Ireland": "2385389",
			"Botswana": "2700",
			"South Sudan": "24317",
			"French Polynesia": "61600",
			"Mauritania": "24382",
			"Honduras": "50134",
			"Saint Barthélemy": "569776",
			"Holy See (Vatican City State)": "4842",
			"United Kingdom": "78969743",
			"Chile": "53815290",
			"Sudan": "913",
			"Gambia": "21722",
			"Liberia": "3746",
			"Brunei Darussalam": "46020",
			"Malaysia": "119484",
			"Fiji": "1662392",
			"Portugal": "10424422",
			"Falkland Isds (Malvinas)": "31541",
			"Nepal": "2684",
			"China": "963052286",
			"Comoros": "134215",
			"Guinea-Bissau": "248157",
			"Pakistan": "1340",
			"Mali": "27043",
			"Trinidad and Tobago": "40443",
			"Israel": "748083",
			"Burkina Faso": "5885",
			"Paraguay": "75239",
			"Norfolk Isds": "1384",
			"Bangladesh": "1157634",
			"Antigua and Barbuda": "163315",
			"Gabon": "698659",
			"Cyprus": "18785181",
			"Yemen": "24036",
			"Mauritius": "173017",
			"Slovakia": "3923919",
			"Faeroe Isds": "1807",
			"Turkmenistan": "246844",
			"Bahrain": "1251875",
			"Côte d'Ivoire": "417381",
			"Guyana": "1453149",
			"Saint Pierre and Miquelon": "77869",
			"Algeria": "10792911",
			"USA": "7711581",
			"Namibia": "164592",
			"Rep. of Moldova": "1827074",
			"Zambia": "96002",
			"Malta": "840512",
			"Ecuador": "255417",
			"Grenada": "204113",
			"Dominican Rep.": "3074",
			"France": "348124462",
			"New Caledonia": "5581",
			"Seychelles": "5859",
			"Italy": "113670948",
			"Saint Lucia": "802",
			"State of Palestine": "16930",
			"Nicaragua": "443",
			"Syria": "308204",
			"Belarus": "643369",
			"Ethiopia": "767841",
			"Slovenia": "6464671",
			"Congo": "1839228",
			"Senegal": "91147",
			"Bulgaria": "14843765",
			"Montenegro": "19318",
			"Sri Lanka": "7566874",
			"Hungary": "5508521",
			"Jordan": "1375",
			"N. Mariana Isds": "3985",
			"Lao People's Dem. Rep.": "408412",
			"Myanmar": "302096",
			"Iran": "339973",
			"Philippines": "89",
			"Uruguay": "46280",
			"Andorra": "83",
			"Cabo Verde": "1397549",
			"Germany": "429217678",
			"Timor-Leste": "354199",
			"Poland": "31517275",
			"Thailand": "76797",
			"Argentina": "21818897",
			"Brazil": "88805984",
			"Dominica": "35267",
			"Mongolia": "12342",
			"Saudi Arabia": "2126285",
			"Greece": "7908486",
			"Russian Federation": "1367098",
			"Cayman Isds": "27112",
			"United Arab Emirates": "460605",
			"Rwanda": "15565",
			"Malawi": "26067",
			"Switzerland": "13794269",
			"El Salvador": "45287",
			"United States Minor Outlying Islands": "16342",
			"Latvia": "4084973",
			"Japan": "670536",
			"Guinea": "274445",
			"Uganda": "6165",
			"Romania": "2882264",
			"Croatia": "28199231",
			"China, Macao SAR": "705",
			"Guatemala": "26557",
			"Madagascar": "68017",
			"Bolivia (Plurinational State of)": "147846",
			"Barbados": "40815",
			"Saint Kitts and Nevis": "188390",
			"Bahamas": "17710",
			"Tunisia": "166",
			"Chad": "1117150",
			"Viet Nam": "686183",
			"Haiti": "8",
			"Tokelau": "2639",
			"Oman": "159248",
			"Sweden": "56347898",
			"Maldives": "11357",
			"India": "24687",
			"Mexico": "8917",
			"Austria": "29283380",
			"Eritrea": "14963",
			"Zimbabwe": "80049",
			"Saint Maarten": "55344",
			"Swaziland": "1055055",
			"Lithuania": "1225349",
			"Cambodia": "93985",
			"Denmark": "280891215",
			"Peru": "553",
			"Central African Rep.": "3128020",
			"Netherlands": "87495380",
			"Costa Rica": "2328569",
			"Equatorial Guinea": "145597",
			"South Georgia and the South Sandwich Islands": "92221",
			"Kazakhstan": "189874",
			"Kenya": "3055",
			"Afghanistan": "16060",
			"Egypt": "135843",
			"Anguilla": "178579",
			"Estonia": "1028148",
			"Morocco": "541101",
			"Antarctica": "15240",
			"TFYR of Macedonia": "3123",
			"Somalia": "7195",
			"Sao Tome and Principe": "3210",
			"Heard Island and McDonald Islands": "5534",
			"Western Sahara": "14611",
			"United Rep. of Tanzania": "1151",
			"Finland": "6387400",
			"Belize": "771777",
			"Georgia": "348914",
			"Ukraine": "84773",
			"Bermuda": "1116486",
			"Djibouti": "82431",
			"Greenland": "76278",
			"China, Hong Kong SAR": "90444",
			"Suriname": "28668",
			"Nigeria": "112849",
			"Samoa": "20110",
			"Venezuela": "777149",
			"Kuwait": "156004",
			"New Zealand": "1493437",
			"Norway": "2128275",
			"Sierra Leone": "22556",
			"Marshall Isds": "7048",
			"Luxembourg": "6782606",
			"Libya": "5855",
			"Kyrgyzstan": "50",
			"Czechia": "269574491",
			"Br. Indian Ocean Terr.": "1000",
			"Mozambique": "674512",
			"Aruba": "277",
			"Turkey": "3802635",
			"San Marino": "46655",
			"Rep. of Korea": "13152",
			"Serbia": "233278",
			"Burundi": "162338",
			"Bhutan": "1243420",
			"Cook Isds": "31187",
			"Canada": "662905774",
			"Iceland": "58030"
		}
	},
	"Azerbaijan": {
		"imports": {},
		"exports": {}
	},
	"Pitcairn": {
		"imports": {},
		"exports": {}
	},
	"Armenia": {
		"imports": {
			"Lebanon": "41117",
			"Gibraltar": "66",
			"South Africa": "5100",
			"Lesotho": "969",
			"Andorra": "26",
			"Togo": "934353",
			"Poland": "170446",
			"Qatar": "15",
			"Bolivia (Plurinational State of)": "8624",
			"Thailand": "4820",
			"Dem. People's Rep. of Korea": "2542",
			"Argentina": "1942",
			"Brazil": "12514877",
			"Germany": "14335",
			"Cameroon": "26455",
			"Comoros": "4231",
			"United Rep. of Tanzania": "17",
			"Barbados": "6399",
			"Saudi Arabia": "4410929",
			"Indonesia": "1299",
			"Colombia": "3129",
			"Syria": "105074",
			"Niger": "405",
			"United Arab Emirates": "12609",
			"Nicaragua": "7719",
			"Jordan": "1447",
			"Azerbaijan": "2076012",
			"Malawi": "4202278",
			"Switzerland": "6966",
			"El Salvador": "898",
			"Cambodia": "47659",
			"Uruguay": "6331",
			"Ukraine": "1749",
			"Latvia": "12432",
			"Japan": "2570915",
			"Hungary": "7207",
			"Greece": "33171",
			"Iraq": "110186",
			"Uganda": "23",
			"Romania": "355197",
			"Pakistan": "1383",
			"Belgium": "1089",
			"Slovenia": "227259",
			"Georgia": "155003",
			"Guatemala": "5587",
			"Madagascar": "76021",
			"Singapore": "649",
			"Nigeria": "301",
			"Iran": "1000",
			"Benin": "454",
			"American Samoa": "1525",
			"Bahamas": "773",
			"Tunisia": "436",
			"Viet Nam": "129",
			"Haiti": "2981",
			"Greenland": "1404",
			"Gabon": "1645",
			"Panama": "72055",
			"Cuba": "3608",
			"Dominican Rep.": "2568",
			"Oman": "13355",
			"Sweden": "106183",
			"Australia": "280",
			"India": "59228",
			"Mexico": "29893",
			"Jamaica": "3029",
			"Kenya": "8073",
			"Spain": "317686",
			"Bosnia Herzegovina": "597",
			"Ireland": "1657212",
			"Botswana": "177",
			"Zimbabwe": "394",
			"China, Hong Kong SAR": "680",
			"Austria": "480",
			"Suriname": "273",
			"Fiji": "2553",
			"Lithuania": "62",
			"Saint Kitts and Nevis": "515",
			"Denmark": "6",
			"Somalia": "1000",
			"Honduras": "579",
			"Saint Barthélemy": "881",
			"Netherlands": "450972",
			"United Kingdom": "31956",
			"Costa Rica": "486209",
			"Bulgaria": "6380",
			"Sudan": "71",
			"Chile": "130933",
			"Kazakhstan": "12",
			"China, Macao SAR": "3252",
			"Afghanistan": "1337",
			"Croatia": "23154",
			"Montenegro": "945",
			"Dominica": "379",
			"Malaysia": "132",
			"Swaziland": "2412",
			"Peru": "85352",
			"Nepal": "60033",
			"China": "1276281",
			"Egypt": "240",
			"Nauru": "633",
			"Anguilla": "20274",
			"Estonia": "86797",
			"Morocco": "119",
			"Mali": "4948",
			"Trinidad and Tobago": "25964",
			"Israel": "269",
			"TFYR of Macedonia": "485",
			"Burkina Faso": "33",
			"Paraguay": "216513",
			"Angola": "28718",
			"Bangladesh": "6040",
			"Guinea": "231",
			"Mauritania": "1216",
			"Finland": "843",
			"Cyprus": "143741",
			"Yemen": "126",
			"Mauritius": "102",
			"Slovakia": "131",
			"Luxembourg": "3370",
			"Faeroe Isds": "7101",
			"Turkmenistan": "5422748",
			"Uzbekistan": "326963",
			"Zambia": "3214",
			"Côte d'Ivoire": "1080",
			"Ghana": "37",
			"Burundi": "799",
			"Guyana": "636",
			"Russian Federation": "15152938",
			"USA": "2349675",
			"Namibia": "137719",
			"Rep. of Moldova": "12994",
			"Venezuela": "137",
			"Kuwait": "2668",
			"Albania": "333",
			"Malta": "6",
			"Norway": "298",
			"Ecuador": "105018",
			"State of Palestine": "64067",
			"Sierra Leone": "114",
			"Portugal": "884",
			"France": "253222",
			"Philippines": "81905",
			"Niue": "103",
			"Italy": "142502",
			"Kyrgyzstan": "3000",
			"Czechia": "224621",
			"Rwanda": "225",
			"Belarus": "9685",
			"Ethiopia": "95",
			"Grenada": "8710",
			"Senegal": "179",
			"Turkey": "479835",
			"San Marino": "408",
			"Sri Lanka": "3580",
			"Rep. of Korea": "57012",
			"Serbia": "261915",
			"Dem. Rep. of the Congo": "494",
			"Holy See (Vatican City State)": "1140",
			"New Zealand": "69854",
			"Canada": "14818",
			"Iceland": "182668",
			"Lao People's Dem. Rep.": "5564",
			"Myanmar": "10971"
		},
		"exports": {
			"Lebanon": "3022",
			"Iran": "4450",
			"United Kingdom": "57721",
			"Poland": "286380",
			"Qatar": "4082",
			"Thailand": "2",
			"Argentina": "1600",
			"Brazil": "1592",
			"Azerbaijan": "2263804",
			"Cameroon": "16200",
			"South Africa": "2005",
			"Mongolia": "100",
			"Saudi Arabia": "110664",
			"Syria": "172939",
			"Russian Federation": "32439",
			"United Arab Emirates": "7420612",
			"Rwanda": "5000",
			"Belize": "39046",
			"Libya": "23537",
			"Malawi": "9300",
			"Switzerland": "1453706",
			"Uzbekistan": "1477844",
			"Latvia": "1037",
			"Japan": "188259",
			"Greece": "241664",
			"Iraq": "2626714",
			"Romania": "26533596",
			"Pakistan": "13087",
			"Belgium": "396596",
			"Slovenia": "1001",
			"Australia": "27979",
			"Germany": "1343209",
			"Singapore": "14627",
			"Nigeria": "11",
			"Albania": "3137",
			"Benin": "51",
			"Viet Nam": "22388",
			"Oman": "8422",
			"Sweden": "68724",
			"Maldives": "5",
			"India": "200",
			"Mexico": "13202",
			"Br. Virgin Isds": "120804",
			"Spain": "6871",
			"Tajikistan": "250249",
			"Ireland": "10013",
			"Austria": "38725",
			"Gabon": "202222",
			"Lithuania": "7161",
			"Namibia": "9111",
			"Denmark": "175058",
			"Netherlands": "476",
			"Bulgaria": "106352",
			"Sudan": "1000",
			"Kazakhstan": "621953",
			"Croatia": "125131",
			"Malaysia": "206970",
			"Portugal": "49",
			"Nepal": "500",
			"China": "321808",
			"Egypt": "5089",
			"Estonia": "415248",
			"Luxembourg": "887131",
			"Trinidad and Tobago": "10",
			"Israel": "524224",
			"TFYR of Macedonia": "4",
			"United Rep. of Tanzania": "950",
			"Finland": "625",
			"Cyprus": "2278",
			"Yemen": "188725",
			"Georgia": "66922",
			"Slovakia": "27313",
			"Turkmenistan": "462147",
			"China, Hong Kong SAR": "12392",
			"Algeria": "107565",
			"USA": "9320820",
			"Rep. of Moldova": "18100",
			"Kuwait": "59938",
			"Malta": "23460",
			"Norway": "1500",
			"Serbia": "240",
			"State of Palestine": "870",
			"France": "443579",
			"Philippines": "50",
			"Italy": "787559",
			"Kyrgyzstan": "100878",
			"Czechia": "968975",
			"Nicaragua": "2995",
			"Belarus": "6171285",
			"Congo": "28619",
			"Turkey": "290",
			"Rep. of Korea": "409161",
			"Hungary": "112188",
			"Jordan": "3177",
			"Canada": "171194",
			"Ukraine": "827987",
			"New Zealand": "14908"
		}
	},
	"Togo": {
		"imports": {
			"Lebanon": "1050173",
			"Gibraltar": "5921",
			"Ghana": "37708",
			"Uruguay": "6397",
			"Andorra": "18938",
			"Germany": "132990",
			"Poland": "299",
			"United Rep. of Tanzania": "13990",
			"Dem. Rep. of the Congo": "330414",
			"Thailand": "16404262",
			"Dem. People's Rep. of Korea": "514472",
			"Argentina": "84540",
			"Brazil": "9413208",
			"Cameroon": "37576",
			"South Africa": "52667",
			"Saudi Arabia": "17340",
			"Panama": "6734",
			"Colombia": "782590",
			"Syria": "5611",
			"Russian Federation": "766",
			"United Arab Emirates": "27405219",
			"Nicaragua": "237069",
			"Angola": "199147",
			"Switzerland": "22202392",
			"Mauritius": "5610",
			"Slovakia": "2979",
			"Latvia": "67845",
			"Japan": "72136868",
			"Guinea": "3628",
			"Bosnia Herzegovina": "9972",
			"Pakistan": "6151",
			"Belgium": "124912",
			"Croatia": "758",
			"Rwanda": "1175",
			"Mozambique": "2780511",
			"United Kingdom": "4088022",
			"Singapore": "823",
			"Nigeria": "4627788",
			"Albania": "932",
			"Benin": "35374",
			"Tunisia": "2894845",
			"Chad": "629",
			"Viet Nam": "11036",
			"Indonesia": "545292",
			"Qatar": "153",
			"Oman": "491",
			"Sweden": "6029796",
			"Australia": "22754",
			"India": "402233",
			"Jamaica": "2162",
			"Mexico": "2024",
			"Kenya": "305965",
			"Spain": "88362",
			"Romania": "47122",
			"Ireland": "2889472",
			"Zimbabwe": "10798",
			"China, Hong Kong SAR": "3788",
			"Austria": "683603",
			"Mauritania": "11785",
			"Lithuania": "351606",
			"Cambodia": "3820",
			"Denmark": "10101",
			"Peru": "34295",
			"Honduras": "2721",
			"Netherlands": "20132278",
			"Turkey": "25346866",
			"Costa Rica": "44789",
			"Equatorial Guinea": "226139",
			"Greece": "40141",
			"Chile": "30914",
			"Slovenia": "3171",
			"Sudan": "2324",
			"Gambia": "11785",
			"Liberia": "341753",
			"Libya": "20202",
			"Afghanistan": "1010",
			"Malaysia": "290237",
			"Swaziland": "7639",
			"Portugal": "28852",
			"China": "35154017",
			"Egypt": "4082246",
			"Guinea-Bissau": "3744644",
			"Estonia": "69613",
			"Morocco": "18494",
			"Mali": "92562",
			"Israel": "1062879",
			"Venezuela": "6397",
			"Burkina Faso": "538638",
			"Paraguay": "18447",
			"Norfolk Isds": "1010",
			"Bangladesh": "22800",
			"Antigua and Barbuda": "118",
			"Gabon": "320",
			"Finland": "185",
			"Cyprus": "32379",
			"Georgia": "3104",
			"Ukraine": "23474495",
			"Luxembourg": "7576",
			"Madagascar": "464",
			"Bahrain": "537548",
			"Côte d'Ivoire": "10633140",
			"Niger": "48037",
			"Algeria": "39412",
			"USA": "11428666",
			"Namibia": "1139",
			"Iran": "49752",
			"Kuwait": "1465868",
			"Suriname": "341",
			"Malta": "5732",
			"Norway": "81671",
			"Ecuador": "127",
			"France": "28673",
			"New Caledonia": "1588",
			"Philippines": "465",
			"Italy": "5314899",
			"Czechia": "4209",
			"Uganda": "20026",
			"Guatemala": "1797412",
			"Ethiopia": "75",
			"Congo": "231",
			"Senegal": "5051",
			"Bulgaria": "2806",
			"Sri Lanka": "9093",
			"Rep. of Korea": "2392740",
			"Hungary": "15175",
			"Jordan": "6740",
			"Canada": "26475",
			"Iceland": "1684",
			"New Zealand": "121861"
		},
		"exports": {
			"Lebanon": "301242",
			"Ghana": "964134",
			"Uruguay": "4981",
			"Andorra": "2126",
			"Germany": "1058300",
			"Poland": "1824",
			"Gabon": "27252",
			"Dem. Rep. of the Congo": "2302567",
			"Thailand": "682409",
			"Cameroon": "98271",
			"South Africa": "2278",
			"Panama": "13534",
			"Sudan": "171274",
			"Russian Federation": "43582",
			"United Arab Emirates": "17663078",
			"Rwanda": "25342",
			"Jordan": "17247",
			"Malawi": "49767",
			"Switzerland": "1793284",
			"Japan": "47908",
			"Guinea": "21995",
			"Pakistan": "4377973",
			"Belgium": "508",
			"Madagascar": "15652",
			"Singapore": "81508",
			"Nigeria": "82541",
			"Benin": "858768",
			"Tunisia": "159875",
			"Chad": "6623",
			"Viet Nam": "327899",
			"Indonesia": "6767158",
			"Turkey": "17973",
			"Sweden": "46334",
			"Australia": "6198930",
			"India": "41660",
			"Kenya": "26660",
			"Spain": "372748",
			"Côte d'Ivoire": "5562569",
			"Mauritania": "94275",
			"Namibia": "17649",
			"Denmark": "131159",
			"Somalia": "38014",
			"Central African Rep.": "46024",
			"Netherlands": "4863829",
			"United Kingdom": "254175",
			"Equatorial Guinea": "31417",
			"Greece": "329409",
			"Gambia": "74737",
			"Liberia": "150466",
			"Malaysia": "16447188",
			"Swaziland": "72602",
			"Portugal": "9592",
			"Egypt": "1687",
			"China": "319288",
			"Comoros": "8120",
			"Guinea-Bissau": "19410",
			"Morocco": "147177",
			"Mali": "604610",
			"Israel": "177563",
			"Burkina Faso": "133856",
			"Bangladesh": "8128060",
			"United Rep. of Tanzania": "38036",
			"Finland": "615",
			"Cyprus": "1235",
			"Ukraine": "142865",
			"Djibouti": "14329",
			"China, Hong Kong SAR": "777994",
			"Niger": "4656234",
			"USA": "118394",
			"Cambodia": "4229",
			"Zambia": "29877",
			"Malta": "88774",
			"Norway": "8466",
			"Sierra Leone": "14528",
			"Marshall Isds": "1397",
			"Sao Tome and Principe": "29958",
			"Italy": "1390435",
			"Uganda": "1080327",
			"Mozambique": "30054",
			"Congo": "1523",
			"Senegal": "60941",
			"Bulgaria": "9290",
			"Rep. of Korea": "4248742",
			"France": "846",
			"Angola": "32512",
			"Canada": "274849"
		}
	},
	"Singapore": {
		"imports": {
			"Lebanon": "47285",
			"Gibraltar": "5004",
			"Ghana": "566315",
			"Lesotho": "4118",
			"Cuba": "5479",
			"Dem. Rep. of the Congo": "4624",
			"Dem. People's Rep. of Korea": "127612",
			"Cameroon": "148754",
			"Papua New Guinea": "13766",
			"Montserrat": "122",
			"Panama": "1683865",
			"Colombia": "164840",
			"Niger": "51165",
			"Palau": "7174",
			"Tonga": "2692",
			"Angola": "105658",
			"Fr. South Antarctic Terr.": "28719",
			"Uzbekistan": "29",
			"Iraq": "185198",
			"Tuvalu": "3046",
			"Guam": "55029",
			"Bosnia Herzegovina": "880454",
			"Pakistan": "376969",
			"Belgium": "133952",
			"Azerbaijan": "19746",
			"Armenia": "767",
			"Togo": "884",
			"Albania": "14808",
			"Benin": "3542",
			"South Africa": "8769733",
			"FS Micronesia": "25253",
			"Indonesia": "5943422",
			"Qatar": "4912636",
			"American Samoa": "330",
			"Saint Vincent and the Grenadines": "598",
			"Curaçao": "18108",
			"Australia": "3212556",
			"Kiribati": "679",
			"Mexico": "495281",
			"Kenya": "640284",
			"Spain": "19576208",
			"Tajikistan": "2887",
			"Ireland": "634",
			"Botswana": "28886",
			"South Sudan": "132077",
			"French Polynesia": "6368",
			"Mauritania": "13269",
			"Christmas Isds": "4100",
			"Honduras": "201",
			"Holy See (Vatican City State)": "21",
			"United Kingdom": "114496677",
			"Chile": "30850",
			"Gambia": "5331",
			"China, Macao SAR": "772101",
			"Dominica": "32072",
			"Malaysia": "2770841",
			"Fiji": "1760673",
			"Portugal": "6287640",
			"Falkland Isds (Malvinas)": "1239447",
			"Nepal": "721",
			"China": "36107304",
			"Comoros": "4156590",
			"Guinea-Bissau": "549744",
			"Djibouti": "181",
			"Trinidad and Tobago": "993",
			"Israel": "31565",
			"Burkina Faso": "869",
			"Paraguay": "59839",
			"Norfolk Isds": "101",
			"Bangladesh": "204908",
			"Antigua and Barbuda": "16046",
			"Gabon": "269888",
			"Cyprus": "121948",
			"Yemen": "76992",
			"Mauritius": "878081",
			"Slovakia": "787929",
			"Faeroe Isds": "661",
			"Turkmenistan": "6321",
			"Bahrain": "66906",
			"Côte d'Ivoire": "41",
			"Guyana": "11144",
			"Algeria": "35606",
			"USA": "565226566",
			"Saint Kitts and Nevis": "35896",
			"Rep. of Moldova": "23265",
			"Zambia": "1189",
			"Malta": "182013",
			"Ecuador": "130923",
			"Grenada": "6349",
			"Dominican Rep.": "97502",
			"France": "9288034",
			"New Caledonia": "13647",
			"Niue": "1173",
			"Seychelles": "103426",
			"Br. Virgin Isds": "3822",
			"Italy": "24212594",
			"Saint Lucia": "2574",
			"Rwanda": "19036",
			"Syria": "6073",
			"Belarus": "10860",
			"Ethiopia": "1875",
			"Namibia": "417848",
			"Congo": "12951",
			"Senegal": "23626",
			"Bulgaria": "15886",
			"Montenegro": "15405",
			"Sri Lanka": "5414",
			"Hungary": "3726",
			"Jordan": "120409",
			"N. Mariana Isds": "4717",
			"Lao People's Dem. Rep.": "18887",
			"Myanmar": "29902",
			"Iran": "912373",
			"Sao Tome and Principe": "28849",
			"Uruguay": "8644",
			"Switzerland": "1452587099",
			"Cabo Verde": "62074",
			"Germany": "14107442",
			"Timor-Leste": "200",
			"Poland": "19997355",
			"Thailand": "379597470",
			"Argentina": "5113498",
			"Brazil": "178693",
			"Brunei Darussalam": "64801",
			"Mongolia": "16407",
			"Saudi Arabia": "114047",
			"Sudan": "139892",
			"Russian Federation": "326250",
			"Cayman Isds": "3761",
			"United Arab Emirates": "122502070",
			"Nicaragua": "22163",
			"Malawi": "8",
			"Andorra": "3769",
			"El Salvador": "24",
			"United States Minor Outlying Islands": "742",
			"Sierra Leone": "18920",
			"Latvia": "1638",
			"Japan": "34493984",
			"Guinea": "367",
			"Uganda": "389523",
			"Romania": "2657524",
			"Croatia": "16505",
			"Liberia": "1301",
			"Guatemala": "1594361",
			"Madagascar": "6484",
			"Bolivia (Plurinational State of)": "1119",
			"Barbados": "23587",
			"Bahamas": "27",
			"San Marino": "18730",
			"Chad": "3663",
			"Viet Nam": "70832735",
			"Haiti": "2474",
			"Tokelau": "17206",
			"Slovenia": "2774674",
			"Oman": "929307",
			"Sweden": "4948232",
			"Maldives": "8757",
			"India": "343206652",
			"Jamaica": "167222",
			"Austria": "7116812",
			"Eritrea": "50846",
			"Zimbabwe": "1424",
			"Vanuatu": "30",
			"Swaziland": "408063",
			"Lithuania": "7952",
			"Cambodia": "213377",
			"Denmark": "78731",
			"Peru": "5800",
			"Central African Rep.": "1828",
			"Netherlands": "2991732",
			"Costa Rica": "343",
			"Equatorial Guinea": "47606924",
			"Greece": "13203",
			"Kazakhstan": "15541",
			"Afghanistan": "46",
			"Saint Helena": "6107",
			"Egypt": "2615847",
			"Nauru": "28365",
			"Anguilla": "2584",
			"Estonia": "20138",
			"Morocco": "5013",
			"Luxembourg": "32538",
			"TFYR of Macedonia": "498",
			"Somalia": "114",
			"United Rep. of Tanzania": "45068",
			"Finland": "199",
			"Belize": "242645",
			"Georgia": "85088",
			"Ukraine": "162897",
			"Bermuda": "711",
			"Mali": "7360",
			"Greenland": "166396",
			"China, Hong Kong SAR": "1000658",
			"Suriname": "1586",
			"Nigeria": "2312",
			"Samoa": "27",
			"Venezuela": "10959",
			"Kuwait": "240",
			"New Zealand": "3163242",
			"Norway": "6205858",
			"Pitcairn": "4755",
			"Marshall Isds": "241",
			"Philippines": "30058709",
			"Libya": "134623013",
			"Kyrgyzstan": "250",
			"Czechia": "1437597",
			"Br. Indian Ocean Terr.": "13900",
			"Mozambique": "119225",
			"Aruba": "69",
			"Turkey": "29540943",
			"Tunisia": "6194",
			"Rep. of Korea": "90188",
			"Serbia": "987448",
			"Burundi": "94",
			"Bhutan": "20949",
			"Cook Isds": "5400",
			"Canada": "499027",
			"Iceland": "132399"
		},
		"exports": {
			"Lebanon": "9506201",
			"Gibraltar": "833",
			"Ghana": "887",
			"Lesotho": "263055",
			"Cuba": "472",
			"Dem. Rep. of the Congo": "333190",
			"Dem. People's Rep. of Korea": "298898",
			"Cameroon": "181",
			"Papua New Guinea": "2977187",
			"Montserrat": "4387",
			"Indonesia": "46017135",
			"Colombia": "126299",
			"Niger": "104681",
			"Palau": "42595",
			"Tonga": "412948",
			"Angola": "6023",
			"Uzbekistan": "78698",
			"Iraq": "585389",
			"Tuvalu": "109552",
			"Guam": "6475164",
			"Bosnia Herzegovina": "85662",
			"Pakistan": "8363669",
			"Belgium": "47494",
			"Azerbaijan": "21809",
			"Armenia": "16860",
			"Togo": "775876",
			"Albania": "44733",
			"Benin": "2021",
			"South Africa": "8569653",
			"FS Micronesia": "143886",
			"Panama": "1279806",
			"Qatar": "11421733",
			"American Samoa": "2245",
			"Saint Vincent and the Grenadines": "19861",
			"Curaçao": "1116",
			"Australia": "15505784",
			"Kiribati": "340741",
			"Jamaica": "15029",
			"Kenya": "824068",
			"Spain": "9543215",
			"Tajikistan": "15449",
			"Ireland": "53234",
			"Botswana": "1261",
			"South Sudan": "593",
			"French Polynesia": "5159406",
			"Mauritania": "1438361",
			"Christmas Isds": "3695",
			"Honduras": "29537",
			"United Kingdom": "176270791",
			"Chile": "5715334",
			"Gambia": "14720",
			"Liberia": "424325",
			"Dominica": "15084",
			"Malaysia": "22310789",
			"Fiji": "5723",
			"Portugal": "9346246",
			"Nepal": "37833",
			"China": "30357902",
			"Comoros": "2759",
			"Guinea-Bissau": "98300",
			"Mali": "30213",
			"Trinidad and Tobago": "172652",
			"Israel": "1834",
			"Burkina Faso": "67205",
			"Paraguay": "4508",
			"Norfolk Isds": "28566",
			"Bangladesh": "5951",
			"Antigua and Barbuda": "1191193",
			"Gabon": "329197",
			"Cyprus": "29403",
			"Yemen": "272",
			"Mauritius": "6078544",
			"Slovakia": "3188753",
			"Faeroe Isds": "3911",
			"Turkmenistan": "172595",
			"Bahrain": "23544",
			"Côte d'Ivoire": "76",
			"Guyana": "699673",
			"Algeria": "2549",
			"USA": "575276013",
			"Saint Kitts and Nevis": "36432",
			"Rep. of Moldova": "31418",
			"Zambia": "101631",
			"Malta": "35293",
			"Ecuador": "471",
			"Grenada": "616",
			"Dominican Rep.": "729",
			"France": "473719",
			"New Caledonia": "722963",
			"Niue": "28873",
			"Seychelles": "1840312",
			"Br. Virgin Isds": "212727",
			"Italy": "535247",
			"Saint Lucia": "56962",
			"Rwanda": "20278",
			"Syria": "631",
			"Belarus": "1008",
			"Ethiopia": "53048",
			"Namibia": "15938",
			"Congo": "924",
			"Senegal": "5194001",
			"Bulgaria": "10",
			"Montenegro": "197657",
			"Sri Lanka": "259024",
			"Hungary": "20149",
			"Jordan": "14851",
			"N. Mariana Isds": "86809",
			"Lao People's Dem. Rep.": "5792406",
			"Myanmar": "1105074",
			"Iran": "43104",
			"Philippines": "58350872",
			"Uruguay": "423294",
			"Switzerland": "421985500",
			"Cabo Verde": "55686",
			"Germany": "1358314",
			"Timor-Leste": "1318183",
			"Poland": "8186758",
			"Thailand": "375184809",
			"Argentina": "1348912",
			"Brazil": "102208",
			"Brunei Darussalam": "611405",
			"Mongolia": "22307",
			"Saudi Arabia": "14270402",
			"Sudan": "22178",
			"Russian Federation": "2692807",
			"Cayman Isds": "869",
			"United Arab Emirates": "889121053",
			"Nicaragua": "937",
			"Malawi": "42372",
			"Andorra": "9545",
			"El Salvador": "55510",
			"United States Minor Outlying Islands": "81996",
			"Latvia": "6111",
			"Japan": "3320353",
			"Guinea": "78280",
			"Uganda": "11085",
			"Romania": "375481",
			"Croatia": "304132",
			"China, Macao SAR": "27699",
			"Mozambique": "81586",
			"Madagascar": "43811",
			"Bolivia (Plurinational State of)": "23868",
			"Barbados": "8081",
			"Bahamas": "27156",
			"San Marino": "843",
			"Chad": "5382",
			"Viet Nam": "146033286",
			"Haiti": "717",
			"Tokelau": "2941",
			"Slovenia": "84455",
			"Oman": "4786181",
			"Sweden": "661283",
			"Maldives": "206169",
			"India": "192079850",
			"Mexico": "12145",
			"Austria": "496",
			"Eritrea": "30010",
			"Zimbabwe": "889591",
			"Vanuatu": "330170",
			"Swaziland": "71547",
			"Lithuania": "3348",
			"Cambodia": "144964",
			"Denmark": "54222",
			"Peru": "1027539",
			"Central African Rep.": "1580",
			"Netherlands": "3022197",
			"Costa Rica": "217014",
			"Equatorial Guinea": "171903",
			"Greece": "559",
			"Kazakhstan": "743213",
			"Afghanistan": "29880",
			"Egypt": "1130370",
			"Nauru": "321776",
			"Anguilla": "111065",
			"Estonia": "3616",
			"Morocco": "143700",
			"Luxembourg": "4827601",
			"TFYR of Macedonia": "34915",
			"Somalia": "37877",
			"United Rep. of Tanzania": "868043",
			"Finland": "16549",
			"Belize": "211982",
			"Georgia": "543",
			"Ukraine": "119398",
			"Bermuda": "1",
			"Djibouti": "123",
			"Greenland": "90932",
			"China, Hong Kong SAR": "11955337",
			"Suriname": "13273",
			"Nigeria": "6955218",
			"Samoa": "774658",
			"Venezuela": "1502",
			"Kuwait": "13072",
			"New Zealand": "17452276",
			"Norway": "7883132",
			"Sierra Leone": "57790",
			"Marshall Isds": "146513",
			"Sao Tome and Principe": "1652",
			"Libya": "195720",
			"Kyrgyzstan": "1638",
			"Czechia": "5904",
			"Br. Indian Ocean Terr.": "840",
			"Guatemala": "1985",
			"Aruba": "9845",
			"Turkey": "5298261",
			"Tunisia": "105427",
			"Rep. of Korea": "30603507",
			"Serbia": "380589",
			"Burundi": "10233",
			"Bhutan": "59766",
			"Cook Isds": "137745",
			"Canada": "11505",
			"Iceland": "893"
		}
	},
	"Albania": {
		"imports": {
			"Lebanon": "104720",
			"Gibraltar": "7",
			"Ghana": "177184",
			"Cuba": "26261",
			"Dem. People's Rep. of Korea": "21587",
			"Cameroon": "163833",
			"South Africa": "773201",
			"Indonesia": "159120",
			"Colombia": "2099513",
			"Niger": "3873",
			"Jordan": "456591",
			"Uzbekistan": "53917",
			"Iraq": "491087",
			"Tuvalu": "1361",
			"Guam": "4824",
			"Bosnia Herzegovina": "8508",
			"Pakistan": "31463",
			"Belgium": "671864",
			"Azerbaijan": "65468",
			"Armenia": "4173",
			"United Kingdom": "38988",
			"Singapore": "112463",
			"Benin": "1413",
			"Panama": "682203",
			"Qatar": "2602521",
			"American Samoa": "481",
			"Saint Vincent and the Grenadines": "4021",
			"Australia": "330",
			"Jamaica": "1782",
			"Kenya": "144335",
			"Spain": "7418900",
			"Ireland": "312071",
			"Mauritania": "48701",
			"Honduras": "93562",
			"Chile": "16937",
			"China, Macao SAR": "3832",
			"Dominica": "24635",
			"Malaysia": "734648",
			"Swaziland": "43669",
			"Portugal": "255332",
			"Falkland Isds (Malvinas)": "248035",
			"Nepal": "40550",
			"China": "4490283",
			"Mali": "2343",
			"Trinidad and Tobago": "2566",
			"Israel": "2348205",
			"Burkina Faso": "153",
			"Paraguay": "319295",
			"Bangladesh": "384942",
			"Antigua and Barbuda": "8591",
			"Gabon": "289708",
			"Cyprus": "25832",
			"Mauritius": "3377",
			"Slovakia": "456745",
			"Turkmenistan": "691040",
			"Bahrain": "85404",
			"Côte d'Ivoire": "175023",
			"Guyana": "1663",
			"Algeria": "2381941",
			"USA": "6554411",
			"Saint Kitts and Nevis": "869",
			"Rep. of Moldova": "10202",
			"Malta": "807",
			"Ecuador": "14446389",
			"Grenada": "1267",
			"Dominican Rep.": "70301",
			"France": "810016",
			"New Caledonia": "242",
			"Br. Virgin Isds": "4092",
			"Italy": "143490654",
			"Uganda": "240464",
			"Belarus": "275666",
			"Ethiopia": "91060",
			"Namibia": "3348",
			"Congo": "63892",
			"Slovenia": "221269",
			"Bulgaria": "451102",
			"Montenegro": "30651",
			"Sri Lanka": "4999",
			"Hungary": "167506",
			"New Zealand": "569487",
			"Lao People's Dem. Rep.": "7738",
			"Myanmar": "13062",
			"Iran": "192454",
			"Uruguay": "211080",
			"Andorra": "28980",
			"Cabo Verde": "162392",
			"Germany": "3573510",
			"Poland": "507212",
			"Thailand": "198962",
			"Argentina": "1686315",
			"Brazil": "47646",
			"Brunei Darussalam": "1627",
			"Saudi Arabia": "1151829",
			"Syria": "16415",
			"Russian Federation": "17565557",
			"United Arab Emirates": "12647",
			"Nicaragua": "30644",
			"Switzerland": "18201201",
			"El Salvador": "130992",
			"United States Minor Outlying Islands": "15178",
			"Latvia": "256913",
			"Japan": "1264011",
			"Guinea": "9447",
			"Romania": "7523239",
			"Croatia": "4580498",
			"Liberia": "274",
			"Madagascar": "12406",
			"Bolivia (Plurinational State of)": "17389",
			"Barbados": "2724",
			"Bahamas": "5759",
			"Tunisia": "72086",
			"Viet Nam": "6556214",
			"Tokelau": "373",
			"Oman": "18395",
			"Sweden": "75496",
			"Maldives": "661",
			"India": "5308024",
			"Mexico": "425227",
			"Austria": "104291",
			"Bouvet Island": "1946",
			"Zimbabwe": "317",
			"Senegal": "46794",
			"Fiji": "325",
			"Lithuania": "239402",
			"Cambodia": "481962",
			"Denmark": "20821",
			"Peru": "5002",
			"Netherlands": "1111498",
			"Costa Rica": "52684",
			"Sudan": "1945",
			"Papua New Guinea": "1575",
			"Kazakhstan": "12194",
			"Afghanistan": "556",
			"Saint Helena": "6791",
			"Greece": "45269550",
			"Egypt": "21205172",
			"Anguilla": "11730",
			"Estonia": "2799876",
			"Morocco": "1608",
			"Luxembourg": "15531",
			"TFYR of Macedonia": "27406",
			"United Rep. of Tanzania": "142911",
			"Finland": "552472",
			"Belize": "4477",
			"Georgia": "4194",
			"Ukraine": "3297",
			"Bermuda": "8077",
			"Djibouti": "1380",
			"Greenland": "1090207",
			"China, Hong Kong SAR": "93941",
			"Suriname": "25611",
			"Nigeria": "28117",
			"Venezuela": "135746",
			"Kuwait": "27025",
			"Norway": "3271",
			"Sierra Leone": "10779",
			"Marshall Isds": "6380",
			"Philippines": "335213",
			"Libya": "10924092",
			"Kyrgyzstan": "63788",
			"Czechia": "8448918",
			"Br. Indian Ocean Terr.": "144",
			"Guatemala": "43832",
			"Aruba": "292",
			"Turkey": "1069752",
			"San Marino": "39241",
			"Rep. of Korea": "4795",
			"Serbia": "41638003",
			"Burundi": "89",
			"Cook Isds": "1835",
			"Canada": "76511",
			"Iceland": "77112"
		},
		"exports": {
			"Lebanon": "123030",
			"Ghana": "12134",
			"Switzerland": "8396258",
			"Marshall Isds": "2375599",
			"Germany": "2550545",
			"Poland": "316848",
			"Qatar": "17135",
			"Thailand": "127315",
			"Argentina": "26301",
			"Brazil": "129973",
			"Cameroon": "278847",
			"Iran": "119194",
			"Saudi Arabia": "374501",
			"Colombia": "58073",
			"Sudan": "18928",
			"Russian Federation": "116041",
			"Cayman Isds": "4940371",
			"United Arab Emirates": "549235",
			"Jordan": "22868",
			"Andorra": "4250",
			"Georgia": "31117",
			"Slovakia": "23530",
			"Iraq": "1617683",
			"Japan": "3126124",
			"Guinea": "19420",
			"Bosnia Herzegovina": "122642",
			"Pakistan": "12159",
			"Belgium": "14735",
			"Croatia": "1490439",
			"China, Macao SAR": "16788",
			"Italy": "1377631",
			"Armenia": "557",
			"Togo": "28032",
			"Singapore": "734043",
			"Nigeria": "18844",
			"Benin": "12548",
			"Tunisia": "266172",
			"Chad": "66343",
			"Viet Nam": "332",
			"South Africa": "1141106",
			"Indonesia": "49296",
			"Oman": "25171",
			"Sweden": "141183",
			"Australia": "161505",
			"India": "274007",
			"Mexico": "184615",
			"Kenya": "11309",
			"Austria": "7800",
			"Romania": "992211",
			"Ireland": "182936",
			"Botswana": "689",
			"Côte d'Ivoire": "347638",
			"Spain": "136231",
			"Lithuania": "358535",
			"United Kingdom": "1723",
			"Denmark": "6266008",
			"Peru": "57485",
			"Netherlands": "1158669",
			"Turkey": "24996",
			"Equatorial Guinea": "34775",
			"Greece": "1734635",
			"Chile": "231229",
			"Azerbaijan": "64539",
			"Liberia": "1177",
			"Afghanistan": "167",
			"Malaysia": "8198",
			"Swaziland": "3054",
			"Portugal": "126012",
			"China": "2453491",
			"Egypt": "88242",
			"Estonia": "886604",
			"Morocco": "110132",
			"Djibouti": "6201",
			"Israel": "163236",
			"TFYR of Macedonia": "136497",
			"Bangladesh": "42943",
			"United Rep. of Tanzania": "1645",
			"Finland": "101422",
			"Cyprus": "233900",
			"Yemen": "5641",
			"Mauritius": "4155",
			"Hungary": "124720",
			"Luxembourg": "71271",
			"Turkmenistan": "664202",
			"Bahrain": "5766",
			"China, Hong Kong SAR": "183115",
			"Niger": "36127",
			"Algeria": "12918",
			"USA": "210037",
			"Rep. of Moldova": "23395",
			"Kuwait": "240673",
			"Malta": "119868",
			"Norway": "43894",
			"France": "51115",
			"Latvia": "210833",
			"Br. Virgin Isds": "84686",
			"Libya": "855934",
			"Kyrgyzstan": "12363",
			"Czechia": "6672",
			"Uganda": "9",
			"Syria": "5359",
			"Belarus": "7842",
			"Ethiopia": "1613",
			"Slovenia": "9787811",
			"Congo": "22087",
			"Senegal": "24540",
			"Bulgaria": "120760",
			"Montenegro": "2822976",
			"Sri Lanka": "36456",
			"Rep. of Korea": "101830",
			"Serbia": "13993442",
			"New Zealand": "533",
			"Canada": "8324",
			"Ukraine": "1455843"
		}
	},
	"Benin": {
		"imports": {
			"Lebanon": "2361168",
			"Gibraltar": "186955",
			"Ghana": "19768826",
			"Philippines": "10849",
			"Uruguay": "1146414",
			"Switzerland": "7461",
			"Cabo Verde": "4546",
			"Peru": "320114",
			"Germany": "52012427",
			"Timor-Leste": "4125",
			"Poland": "18703589",
			"Qatar": "157038",
			"Dem. Rep. of the Congo": "1685",
			"Thailand": "86970",
			"Dem. People's Rep. of Korea": "18440",
			"Argentina": "885987",
			"Brazil": "46792061",
			"Cameroon": "1955",
			"Iran": "1025422",
			"Saudi Arabia": "14628",
			"Indonesia": "12214313",
			"Colombia": "23250",
			"Sudan": "161",
			"Russian Federation": "4286",
			"United Arab Emirates": "1089381",
			"Rwanda": "138773",
			"Angola": "20579",
			"Andorra": "8563",
			"Georgia": "35729",
			"United States Minor Outlying Islands": "2484",
			"Sierra Leone": "2022",
			"Slovakia": "379323",
			"Latvia": "86369",
			"Japan": "4812757",
			"Guinea": "1495859",
			"Romania": "549529",
			"Pakistan": "38261",
			"Belgium": "105976",
			"Sweden": "6012050",
			"Liberia": "51101",
			"Bolivia (Plurinational State of)": "568",
			"Armenia": "10682",
			"Togo": "140207",
			"Singapore": "424779",
			"Nigeria": "2129634",
			"Albania": "347",
			"Benin": "1286",
			"Tunisia": "80849",
			"Chad": "10333",
			"Viet Nam": "119350",
			"Haiti": "3370",
			"South Africa": "890119",
			"Tokelau": "2032",
			"Panama": "16848",
			"Saint Vincent and the Grenadines": "31940",
			"Marshall Isds": "173380",
			"Turkey": "263607",
			"Curaçao": "7799",
			"Australia": "451271",
			"Kiribati": "4212",
			"India": "1120129",
			"Mexico": "101091",
			"Jamaica": "1214",
			"Kenya": "157",
			"Spain": "655491",
			"Bosnia Herzegovina": "136371",
			"Ireland": "2694262",
			"Botswana": "2298",
			"Zimbabwe": "1516",
			"Côte d'Ivoire": "12710033",
			"Norfolk Isds": "3133",
			"Mauritania": "35861871",
			"Lithuania": "1762489",
			"Saint Kitts and Nevis": "421",
			"Denmark": "47353",
			"Somalia": "34",
			"Honduras": "47853",
			"Netherlands": "65406",
			"United Kingdom": "10377870",
			"Austria": "982",
			"Equatorial Guinea": "3033",
			"Greece": "2361853",
			"Chile": "368670",
			"Croatia": "85546",
			"Gambia": "17816",
			"China, Macao SAR": "111",
			"Libya": "231013",
			"Afghanistan": "12131",
			"Malaysia": "51171385",
			"Swaziland": "14090",
			"Portugal": "13640430",
			"United Rep. of Tanzania": "8424",
			"Nepal": "2022",
			"China": "34919690",
			"Egypt": "47660",
			"Guinea-Bissau": "568853",
			"Estonia": "96655",
			"Morocco": "16862320",
			"Mali": "92",
			"Trinidad and Tobago": "3645713",
			"Israel": "67509",
			"Venezuela": "2779710",
			"Burkina Faso": "14508",
			"Paraguay": "33696",
			"Bangladesh": "55752",
			"Antigua and Barbuda": "9491",
			"Gabon": "827912",
			"Finland": "1503271",
			"Cyprus": "26283",
			"Yemen": "50544",
			"Mauritius": "72",
			"Ukraine": "407",
			"Djibouti": "453170",
			"Madagascar": "199056",
			"Turkmenistan": "1218",
			"Bahrain": "94757",
			"Zambia": "1685",
			"China, Hong Kong SAR": "10009484",
			"Guyana": "761",
			"Niger": "17055",
			"Algeria": "737286",
			"USA": "5078467",
			"Namibia": "9198433",
			"Rep. of Moldova": "6846",
			"Kuwait": "11739",
			"Malta": "28884",
			"Norway": "5739",
			"Ecuador": "16848",
			"Serbia": "44822",
			"Pitcairn": "4351",
			"Dominican Rep.": "3134",
			"France": "264930962",
			"Luxembourg": "17949",
			"Seychelles": "73669",
			"Italy": "25820034",
			"Kyrgyzstan": "6244",
			"Czechia": "104115",
			"Uganda": "168",
			"Ethiopia": "1591015",
			"Slovenia": "18294",
			"Congo": "505",
			"Senegal": "3512802",
			"Bulgaria": "26167",
			"Sri Lanka": "418682",
			"Rep. of Korea": "768950",
			"Hungary": "535594",
			"Burundi": "245",
			"Jordan": "824",
			"Canada": "15050",
			"Iceland": "1638950",
			"New Zealand": "152189"
		},
		"exports": {
			"Lebanon": "1692",
			"Ghana": "4851499",
			"Germany": "1135762",
			"Poland": "4060",
			"United Rep. of Tanzania": "2030",
			"Dem. Rep. of the Congo": "4060",
			"Thailand": "2099591",
			"Dem. People's Rep. of Korea": "169",
			"Argentina": "2876",
			"Brazil": "846",
			"Cameroon": "16917",
			"South Africa": "8569",
			"Saudi Arabia": "537246",
			"Colombia": "6217",
			"Sudan": "17534",
			"Niger": "14050",
			"United Arab Emirates": "1393",
			"Angola": "1156201",
			"Switzerland": "508",
			"Iraq": "11097",
			"Japan": "10150",
			"Guinea": "1954407",
			"Pakistan": "846",
			"Belgium": "846",
			"Madagascar": "3468",
			"Singapore": "2726960",
			"Nigeria": "8893",
			"Albania": "8905356",
			"Tunisia": "86277",
			"Chad": "364",
			"Viet Nam": "26487",
			"Haiti": "3468",
			"Indonesia": "4541944",
			"Sweden": "7489",
			"Australia": "5433",
			"India": "8459",
			"Mexico": "846",
			"Kenya": "29190",
			"Spain": "32688",
			"Ireland": "7443",
			"Zimbabwe": "8074",
			"China, Hong Kong SAR": "1265903",
			"Austria": "11389",
			"Mauritania": "403619",
			"Lithuania": "14921",
			"Namibia": "22174",
			"Denmark": "8385038",
			"United Kingdom": "16627",
			"Central African Rep.": "2896",
			"Netherlands": "1353",
			"Turkey": "15190",
			"Costa Rica": "846",
			"Equatorial Guinea": "3891",
			"Greece": "8805",
			"Gambia": "38721",
			"Liberia": "2774",
			"Libya": "7902",
			"Malaysia": "1221030",
			"Portugal": "26914",
			"Egypt": "13503180",
			"China": "10235",
			"Comoros": "178",
			"Morocco": "164018",
			"Mali": "175843",
			"Trinidad and Tobago": "194423",
			"Burkina Faso": "3383",
			"Bangladesh": "65444",
			"Gabon": "1129589",
			"Finland": "6825",
			"Zambia": "10331",
			"Mauritius": "666428",
			"Ukraine": "6112612",
			"Djibouti": "38369",
			"Bahrain": "10564",
			"Côte d'Ivoire": "10840432",
			"Russian Federation": "225773",
			"USA": "598567",
			"Kuwait": "856",
			"Sierra Leone": "10891",
			"France": "8404050",
			"New Caledonia": "1692",
			"Italy": "2996711",
			"Czechia": "25",
			"Uganda": "9643",
			"Syria": "25376",
			"Ethiopia": "20384",
			"Togo": "758714",
			"Congo": "677",
			"Senegal": "176356",
			"Bulgaria": "7613",
			"Sri Lanka": "287553",
			"Rep. of Korea": "1746892",
			"Serbia": "204",
			"Canada": "71",
			"Myanmar": "310436"
		}
	},
	"Antarctica": {
		"imports": {},
		"exports": {}
	},
	"FS Micronesia": {
		"imports": {},
		"exports": {}
	},
	"Wallis and Futuna Isds": {
		"imports": {},
		"exports": {}
	},
	"Indonesia": {
		"imports": {
			"Lebanon": "8857",
			"Ghana": "501",
			"Lesotho": "151849",
			"Cuba": "96000",
			"Dem. Rep. of the Congo": "6805049",
			"Dem. People's Rep. of Korea": "1142",
			"Cameroon": "3304",
			"Papua New Guinea": "3914",
			"Montserrat": "3061",
			"Indonesia": "2942670",
			"Colombia": "5316730",
			"Niger": "13995",
			"Palau": "271",
			"Tonga": "9",
			"Angola": "915599",
			"Uzbekistan": "7310716",
			"Iraq": "287",
			"Guam": "429",
			"Bosnia Herzegovina": "227",
			"Pakistan": "9167131",
			"Belgium": "5045452",
			"Azerbaijan": "2209",
			"Armenia": "7371",
			"United Kingdom": "1451419",
			"Singapore": "3808098226",
			"Albania": "71550",
			"Benin": "18750018",
			"South Africa": "290806599",
			"FS Micronesia": "9767130",
			"Panama": "34502554",
			"Qatar": "742841146",
			"American Samoa": "558000",
			"Saint Vincent and the Grenadines": "296502",
			"Curaçao": "15990",
			"Australia": "18076784",
			"Kiribati": "45367",
			"Jamaica": "24366",
			"Kenya": "21965",
			"Spain": "484060870",
			"Tajikistan": "5683",
			"Ireland": "2715744",
			"Botswana": "178",
			"French Polynesia": "4135",
			"Mauritania": "530681",
			"Christmas Isds": "3342750",
			"Honduras": "464142",
			"Jordan": "345090",
			"Chile": "55593232",
			"Gambia": "31",
			"China, Macao SAR": "9868817",
			"Brunei Darussalam": "136383",
			"Malaysia": "84185",
			"Fiji": "1238742",
			"Peru": "83610",
			"Nepal": "4135",
			"China": "12839500036",
			"Comoros": "1702639",
			"Mali": "26707933",
			"Trinidad and Tobago": "2851311",
			"Israel": "558907",
			"Burkina Faso": "28085320",
			"Paraguay": "394257",
			"Norfolk Isds": "164190",
			"Bangladesh": "6093",
			"Antigua and Barbuda": "184",
			"Gabon": "43",
			"Cyprus": "4087106",
			"Yemen": "1006",
			"Mauritius": "991163",
			"Slovakia": "3730691",
			"Faeroe Isds": "166260",
			"Turkmenistan": "2231982",
			"Bahrain": "1970",
			"Côte d'Ivoire": "77",
			"Guyana": "3329",
			"Algeria": "51184",
			"USA": "157959283",
			"Namibia": "3333620",
			"Rep. of Moldova": "13839232",
			"Zambia": "503",
			"Malta": "29214624",
			"Ecuador": "91789",
			"Grenada": "750",
			"Dominican Rep.": "10382390",
			"France": "26145911",
			"New Caledonia": "29370",
			"Niue": "1208",
			"Seychelles": "4248491",
			"Br. Virgin Isds": "4421",
			"Italy": "1810198",
			"Saint Lucia": "51624",
			"State of Palestine": "2750",
			"Rwanda": "320",
			"Syria": "1401950",
			"Belarus": "19273050",
			"Ethiopia": "23669429",
			"Slovenia": "4367083",
			"Congo": "2266544",
			"Senegal": "1562890",
			"Bulgaria": "9833",
			"Montenegro": "17483",
			"Sri Lanka": "9463323",
			"Hungary": "511460",
			"New Zealand": "4264729",
			"N. Mariana Isds": "582973",
			"Lao People's Dem. Rep.": "4088679",
			"Myanmar": "6407721",
			"Iran": "59396",
			"Sao Tome and Principe": "767",
			"Uruguay": "25087803",
			"Andorra": "295",
			"Cabo Verde": "9983",
			"Germany": "163541040",
			"Timor-Leste": "197987",
			"Poland": "2482634",
			"Thailand": "8666933266",
			"Argentina": "1116075",
			"Brazil": "24100000",
			"Dominica": "954900",
			"Mongolia": "11779068",
			"Saudi Arabia": "767592",
			"Sudan": "1665986",
			"Russian Federation": "202",
			"Cayman Isds": "22073",
			"United Arab Emirates": "1316222642",
			"Nicaragua": "116",
			"Malawi": "7748089",
			"Switzerland": "723751196",
			"El Salvador": "155623",
			"United States Minor Outlying Islands": "591",
			"Sierra Leone": "7742",
			"Latvia": "311643",
			"Japan": "2609095",
			"Guinea": "990",
			"Uganda": "15727351",
			"Romania": "42218",
			"Croatia": "3158448",
			"Liberia": "2926",
			"Guatemala": "27738",
			"Luxembourg": "6403375",
			"Bolivia (Plurinational State of)": "9190",
			"Barbados": "967",
			"Bahamas": "2214",
			"San Marino": "553",
			"Chad": "2500",
			"Viet Nam": "1105241458",
			"Haiti": "138225",
			"Tokelau": "26308",
			"Oman": "1807124",
			"Sweden": "526178474",
			"Maldives": "112568",
			"India": "210895175",
			"Mexico": "176954296",
			"Austria": "589587",
			"Eritrea": "924",
			"Zimbabwe": "32206100",
			"Vanuatu": "302",
			"Swaziland": "1138735",
			"Lithuania": "8913723",
			"Cambodia": "2581438",
			"Denmark": "20181265",
			"Portugal": "628248",
			"Central African Rep.": "21",
			"Netherlands": "125184599",
			"Costa Rica": "4165919",
			"Equatorial Guinea": "688",
			"Greece": "526261",
			"Kazakhstan": "723",
			"Afghanistan": "346",
			"Saint Helena": "474",
			"Egypt": "13486537",
			"Nauru": "11690",
			"Anguilla": "109",
			"Estonia": "4511927",
			"Morocco": "62334039",
			"Antarctica": "1913",
			"TFYR of Macedonia": "1467446",
			"United Rep. of Tanzania": "68895591",
			"Finland": "1118385",
			"Belize": "48448",
			"Georgia": "1468",
			"Ukraine": "562308424",
			"Bermuda": "995",
			"Djibouti": "325",
			"Madagascar": "5900494",
			"Greenland": "240962",
			"China, Hong Kong SAR": "891025",
			"Nigeria": "2709",
			"Samoa": "55",
			"Venezuela": "913",
			"Kuwait": "156721774",
			"Norway": "807007",
			"Pitcairn": "1570",
			"Marshall Isds": "3100701",
			"Philippines": "105595822",
			"Libya": "88248",
			"Kyrgyzstan": "2208",
			"Czechia": "1532246",
			"Mozambique": "9405200",
			"Togo": "10221124",
			"Aruba": "250",
			"Turkey": "311154336",
			"Tunisia": "22752291",
			"Rep. of Korea": "125472",
			"Serbia": "669706",
			"Bhutan": "1069",
			"Cook Isds": "1394",
			"Canada": "7080741",
			"Iceland": "457351"
		},
		"exports": {
			"Lebanon": "27909277",
			"Gibraltar": "55753",
			"Ghana": "24539037",
			"Lesotho": "30680",
			"Cuba": "7324",
			"Dem. Rep. of the Congo": "3084021",
			"Dem. People's Rep. of Korea": "5117696",
			"Cameroon": "2660248",
			"Papua New Guinea": "70115183",
			"Colombia": "48893895",
			"Niger": "284550",
			"Palau": "135645",
			"Tonga": "3088902",
			"Angola": "6134324",
			"Uzbekistan": "571473",
			"Iraq": "8456797",
			"Tuvalu": "122688",
			"Guam": "222640",
			"Bosnia Herzegovina": "770085",
			"Vanuatu": "1765",
			"Belgium": "500",
			"Azerbaijan": "50",
			"Pitcairn": "22366",
			"Armenia": "70340",
			"United Kingdom": "72138268",
			"Singapore": "3149969595",
			"Albania": "1978954",
			"Benin": "8975946",
			"South Africa": "727879981",
			"FS Micronesia": "156177",
			"Panama": "219840",
			"Qatar": "1927135",
			"American Samoa": "851772",
			"Saint Vincent and the Grenadines": "31945",
			"Curaçao": "9493",
			"Australia": "5929943",
			"Kiribati": "395880",
			"Jamaica": "2953",
			"Br. Virgin Isds": "4466",
			"Spain": "1579275490",
			"Tajikistan": "1159661",
			"Ireland": "27820",
			"Botswana": "21257",
			"French Polynesia": "847715",
			"Mauritania": "71029674",
			"Christmas Isds": "54",
			"Honduras": "293297",
			"Holy See (Vatican City State)": "45358",
			"Chile": "25415292",
			"Sudan": "72372035",
			"Gambia": "1855625",
			"Liberia": "1086262",
			"Brunei Darussalam": "3361720",
			"Malaysia": "3713111",
			"Fiji": "695178",
			"Peru": "1319367",
			"Saint Kitts and Nevis": "513437",
			"Nepal": "349511",
			"China": "6685882537",
			"Comoros": "108992",
			"Guinea-Bissau": "742851",
			"Mali": "5570496",
			"Trinidad and Tobago": "17248753",
			"Israel": "287535",
			"Burkina Faso": "1318814",
			"Paraguay": "1502461",
			"Norfolk Isds": "5113996",
			"Bangladesh": "67815468",
			"Antigua and Barbuda": "73983",
			"Gabon": "5566834",
			"Cyprus": "2900",
			"Yemen": "15799368",
			"Mauritius": "49686319",
			"Slovakia": "238478",
			"Turkmenistan": "7465272",
			"Bahrain": "3977736",
			"Côte d'Ivoire": "1162454",
			"Guyana": "159202",
			"Saint Pierre and Miquelon": "1962",
			"Algeria": "34070552",
			"USA": "1214962748",
			"Namibia": "152",
			"Rep. of Moldova": "416229",
			"Zambia": "19872",
			"Malta": "12320279",
			"Ecuador": "7730567",
			"Grenada": "171602",
			"Dominican Rep.": "51826655",
			"France": "171435563",
			"New Caledonia": "38290",
			"Niue": "699",
			"Seychelles": "410902",
			"Italy": "80823706",
			"Saint Lucia": "209155",
			"State of Palestine": "43721",
			"Rwanda": "325",
			"Belarus": "1671053",
			"Ethiopia": "3146510",
			"Slovenia": "13376027",
			"Congo": "5695098",
			"Senegal": "3225411",
			"Bulgaria": "13326483",
			"Montenegro": "3692680",
			"Sri Lanka": "136904013",
			"Hungary": "1152043",
			"Jordan": "8090526",
			"N. Mariana Isds": "284912",
			"Lao People's Dem. Rep.": "3035064",
			"Myanmar": "27056723",
			"Iran": "12966591",
			"Sao Tome and Principe": "31330",
			"Uruguay": "698315",
			"Switzerland": "2199902333",
			"Cabo Verde": "61237",
			"Germany": "1107150842",
			"Timor-Leste": "1370625",
			"Poland": "11518663",
			"Thailand": "5392399348",
			"Argentina": "7043659",
			"Brazil": "6965237",
			"Dominica": "639668",
			"Mongolia": "5672415",
			"Saudi Arabia": "16273927",
			"Syria": "25888876",
			"Russian Federation": "4213213",
			"Cayman Isds": "2066",
			"United Arab Emirates": "1612105635",
			"Nicaragua": "6176317",
			"Malawi": "1916",
			"Andorra": "11721",
			"El Salvador": "125858",
			"Latvia": "319863",
			"Japan": "227421966",
			"Guinea": "478382",
			"Uganda": "6382245",
			"Romania": "21155",
			"Croatia": "4376",
			"China, Macao SAR": "34640",
			"Guatemala": "149708",
			"Madagascar": "705",
			"Bolivia (Plurinational State of)": "485775",
			"Barbados": "558970",
			"Bahamas": "39187",
			"Tunisia": "37994155",
			"Chad": "1690990",
			"Viet Nam": "1306510695",
			"Haiti": "1778630",
			"Tokelau": "115596",
			"Oman": "112222493",
			"Sweden": "144692970",
			"Maldives": "74493",
			"India": "18934134",
			"Mexico": "815126411",
			"Austria": "400",
			"Eritrea": "310344",
			"Zimbabwe": "3128723",
			"Pakistan": "4495492",
			"Swaziland": "1631914",
			"Lithuania": "2817",
			"Cambodia": "4690902",
			"Denmark": "23727080",
			"Portugal": "12983050",
			"Central African Rep.": "114060",
			"Netherlands": "56171779",
			"Costa Rica": "11055382",
			"Equatorial Guinea": "2773937",
			"Greece": "5245349",
			"Kazakhstan": "437226",
			"Kenya": "326257",
			"Afghanistan": "914607",
			"Saint Helena": "9000",
			"Egypt": "676677434",
			"Nauru": "34746",
			"Anguilla": "147",
			"Estonia": "71170",
			"Morocco": "95614814",
			"Antarctica": "1326",
			"Venezuela": "190065",
			"Somalia": "42437030",
			"United Rep. of Tanzania": "114214610",
			"Finland": "28147415",
			"Belize": "17978",
			"Georgia": "31348152",
			"Ukraine": "255076321",
			"Bermuda": "143241",
			"Djibouti": "141556708",
			"Greenland": "101",
			"China, Hong Kong SAR": "174178469",
			"Suriname": "5076992",
			"Nigeria": "9715657",
			"Samoa": "1425593",
			"TFYR of Macedonia": "66550",
			"Kuwait": "23990",
			"New Zealand": "500324",
			"Norway": "36539827",
			"Sierra Leone": "791850",
			"Marshall Isds": "123720",
			"Philippines": "671489877",
			"Libya": "3114180",
			"Kyrgyzstan": "388855",
			"Czechia": "3738516",
			"Br. Indian Ocean Terr.": "474",
			"Mozambique": "11341342",
			"Togo": "52146448",
			"Aruba": "660",
			"Turkey": "1024069768",
			"San Marino": "18360",
			"Rep. of Korea": "9607675",
			"Serbia": "574598",
			"Burundi": "77305",
			"Bhutan": "33271",
			"Cook Isds": "57449",
			"Canada": "15",
			"Iceland": "228206",
			"Luxembourg": "4579"
		}
	},
	"Cuba": {
		"imports": {},
		"exports": {}
	},
	"American Samoa": {
		"imports": {},
		"exports": {}
	},
	"Saint Vincent and the Grenadines": {
		"imports": {},
		"exports": {}
	},
	"Curaçao": {
		"imports": {},
		"exports": {}
	},
	"Australia": {
		"imports": {
			"Lebanon": "75880",
			"Gibraltar": "1990",
			"Ghana": "17598",
			"Lesotho": "34133",
			"Qatar": "4475",
			"Dem. Rep. of the Congo": "123942",
			"Cameroon": "30579",
			"South Africa": "3407",
			"Montserrat": "4216",
			"Indonesia": "672448749",
			"Colombia": "1918738",
			"Niger": "51806",
			"Palau": "1542",
			"Tonga": "617629",
			"Jordan": "567998",
			"Uzbekistan": "2808",
			"Iraq": "1864",
			"Tuvalu": "1077",
			"Guam": "4467",
			"Bosnia Herzegovina": "427621",
			"Vanuatu": "45493",
			"Belgium": "1876259",
			"Azerbaijan": "115161",
			"Pitcairn": "10047",
			"Rwanda": "1756",
			"Armenia": "9427",
			"United Kingdom": "210107",
			"Singapore": "78386",
			"Albania": "1926",
			"Benin": "6181",
			"Antarctica": "12239",
			"FS Micronesia": "10106",
			"Panama": "166585",
			"Cuba": "3425189",
			"American Samoa": "21029",
			"Saint Vincent and the Grenadines": "4361",
			"Curaçao": "151666",
			"Australia": "50562222",
			"Kiribati": "147739",
			"Bahrain": "16668",
			"Mexico": "5367",
			"Kenya": "854540",
			"Spain": "873217",
			"Tajikistan": "10176",
			"Ireland": "575133",
			"Botswana": "1404",
			"Côte d'Ivoire": "844",
			"French Polynesia": "1273",
			"Mauritania": "49311",
			"Christmas Isds": "2983",
			"Honduras": "26618",
			"Cambodia": "1378273",
			"Chile": "4844",
			"Gambia": "4128",
			"China, Macao SAR": "51358",
			"Brunei Darussalam": "228677891",
			"Malaysia": "1838715810",
			"Swaziland": "2051837",
			"Portugal": "2716",
			"Falkland Isds (Malvinas)": "1074",
			"Nepal": "3431",
			"China": "22308191",
			"Comoros": "1809",
			"Mali": "97239",
			"Trinidad and Tobago": "3079798",
			"Israel": "1245252",
			"Burkina Faso": "1056",
			"Paraguay": "129662",
			"Norfolk Isds": "2610",
			"Bangladesh": "451152",
			"Antigua and Barbuda": "342298",
			"Gabon": "438049059",
			"Cyprus": "19594",
			"Yemen": "15497",
			"Mauritius": "1026918",
			"Slovakia": "212152",
			"Turkmenistan": "1589610",
			"Syria": "587581",
			"South Sudan": "4371",
			"Guyana": "110803",
			"Saint Pierre and Miquelon": "22168",
			"Algeria": "236231447",
			"USA": "40390018",
			"Saint Kitts and Nevis": "10714",
			"Rep. of Moldova": "79363",
			"Zambia": "55934",
			"Malta": "217204",
			"Ecuador": "1687",
			"Grenada": "64625",
			"Dominican Rep.": "19643116",
			"France": "32751",
			"New Caledonia": "7601",
			"Niue": "3915",
			"Seychelles": "65741",
			"Br. Virgin Isds": "8122",
			"Italy": "62673170",
			"Saint Lucia": "3273",
			"Uganda": "1449383",
			"Belarus": "13658",
			"Ethiopia": "1167",
			"Congo": "200161353",
			"Senegal": "1293442",
			"Bulgaria": "11993",
			"Montenegro": "50482",
			"Sri Lanka": "46873",
			"Hungary": "202642",
			"Angola": "9684485",
			"New Zealand": "432110064",
			"N. Mariana Isds": "1167",
			"Samoa": "37028",
			"Myanmar": "5590307",
			"Iran": "4636",
			"Sao Tome and Principe": "10387",
			"Uruguay": "14916",
			"Cabo Verde": "55131",
			"Germany": "1716487",
			"Timor-Leste": "372893",
			"Poland": "17540",
			"Thailand": "19062",
			"Argentina": "103760610",
			"Brazil": "72678",
			"Dominica": "34336",
			"Mongolia": "6042",
			"Saudi Arabia": "1181756",
			"Greece": "516670",
			"Russian Federation": "93092261",
			"Cayman Isds": "23582",
			"United Arab Emirates": "1099249880",
			"Nicaragua": "140322",
			"Malawi": "26411",
			"Switzerland": "14073",
			"El Salvador": "2437619",
			"United States Minor Outlying Islands": "8061",
			"Latvia": "1365653",
			"Japan": "1117693",
			"Guinea": "32232",
			"Romania": "2195",
			"Slovenia": "2747314",
			"Liberia": "5210",
			"Guatemala": "1161875",
			"Madagascar": "123236",
			"Bolivia (Plurinational State of)": "679762",
			"Nigeria": "315793",
			"Bahamas": "339094",
			"Tunisia": "9268",
			"Chad": "826",
			"Viet Nam": "154234234",
			"Haiti": "1374",
			"Oman": "711691",
			"Sweden": "2785899",
			"Maldives": "138821",
			"India": "540493",
			"Jamaica": "1452673",
			"Austria": "120268",
			"Eritrea": "6371",
			"Zimbabwe": "30451",
			"Pakistan": "56025732",
			"Fiji": "12899",
			"Lithuania": "841871",
			"Namibia": "495150",
			"Denmark": "355703",
			"Peru": "7457758",
			"Central African Rep.": "2826",
			"Netherlands": "3914666",
			"Costa Rica": "3610",
			"Equatorial Guinea": "64607196",
			"Sudan": "34801",
			"Papua New Guinea": "417216831",
			"Kazakhstan": "22680",
			"Afghanistan": "1141",
			"Croatia": "6533042",
			"Saint Helena": "1730956",
			"Egypt": "48074",
			"Nauru": "89493",
			"Anguilla": "979",
			"Estonia": "160682",
			"Morocco": "3874324",
			"Luxembourg": "549832",
			"TFYR of Macedonia": "3944873",
			"Somalia": "30505",
			"Western Sahara": "7733",
			"United Rep. of Tanzania": "1559242",
			"Finland": "340265",
			"Belize": "9534",
			"Georgia": "853",
			"Ukraine": "2609842",
			"Bermuda": "216199",
			"Djibouti": "8722",
			"China, Hong Kong SAR": "62607",
			"Suriname": "20857",
			"Barbados": "918501",
			"Venezuela": "326837",
			"Kuwait": "278906",
			"Norway": "108601",
			"Sierra Leone": "2970",
			"Marshall Isds": "113572",
			"Philippines": "5597",
			"Libya": "2088",
			"Kyrgyzstan": "6201",
			"Czechia": "9735",
			"Br. Indian Ocean Terr.": "9434",
			"Mozambique": "802",
			"Togo": "2673",
			"Lao People's Dem. Rep.": "48932",
			"Turkey": "4540129",
			"Rep. of Korea": "56787",
			"Serbia": "167814",
			"Burundi": "363964",
			"Bhutan": "820",
			"Cook Isds": "374762",
			"Canada": "1546146",
			"Iceland": "3739"
		},
		"exports": {
			"Lebanon": "208656",
			"Gibraltar": "8326",
			"Ghana": "26034",
			"Lesotho": "7675",
			"Qatar": "1909967",
			"Dem. Rep. of the Congo": "149",
			"Cameroon": "4476",
			"South Africa": "121463215",
			"Indonesia": "675303530",
			"Colombia": "2033",
			"Niger": "35302",
			"Palau": "437272",
			"Tonga": "37751",
			"Jordan": "6566971",
			"Uzbekistan": "8544",
			"Iraq": "44757",
			"Tuvalu": "4177",
			"Guam": "3384",
			"Bosnia Herzegovina": "2729",
			"Vanuatu": "2190569",
			"Belgium": "3087",
			"Azerbaijan": "55235",
			"Pitcairn": "17050",
			"Rwanda": "1539940",
			"United Kingdom": "119500397",
			"Singapore": "621929359",
			"Albania": "298349",
			"Benin": "448",
			"Antarctica": "165080",
			"FS Micronesia": "2133",
			"Panama": "2738966",
			"Cuba": "47057",
			"American Samoa": "3730",
			"Saint Vincent and the Grenadines": "57",
			"Curaçao": "82055",
			"Armenia": "12467",
			"Kiribati": "156582",
			"Bahrain": "1433161",
			"Mexico": "131011020",
			"Kenya": "954",
			"Spain": "124793117",
			"Tajikistan": "5411",
			"Ireland": "79788",
			"Botswana": "28095",
			"Côte d'Ivoire": "287",
			"French Polynesia": "1392504",
			"Mauritania": "821",
			"Christmas Isds": "89622",
			"Honduras": "22565",
			"Chile": "1261",
			"Gambia": "149",
			"China, Macao SAR": "692",
			"Brunei Darussalam": "398",
			"Malaysia": "760776359",
			"Swaziland": "11060",
			"Portugal": "118645",
			"Falkland Isds (Malvinas)": "23",
			"Nepal": "3730",
			"China": "91204956",
			"Guinea-Bissau": "23392",
			"Mali": "6401",
			"Trinidad and Tobago": "31479",
			"Israel": "91384",
			"Burkina Faso": "1442",
			"Paraguay": "7160",
			"Norfolk Isds": "4017",
			"Bangladesh": "199909",
			"Antigua and Barbuda": "4262",
			"Gabon": "954956",
			"Cyprus": "41383",
			"Yemen": "1680810",
			"Mauritius": "2882",
			"Slovakia": "60945",
			"Turkmenistan": "18139",
			"Syria": "373",
			"South Sudan": "22912",
			"Guyana": "164624",
			"Algeria": "4646",
			"USA": "112170860",
			"Namibia": "2083",
			"Rep. of Moldova": "2024",
			"Zambia": "4252722",
			"Malta": "51",
			"Ecuador": "26033",
			"Grenada": "2933",
			"Dominican Rep.": "5968",
			"France": "417396798",
			"New Caledonia": "71951296",
			"Niue": "50028",
			"Seychelles": "564081",
			"Br. Virgin Isds": "895147",
			"Italy": "88609907",
			"Saint Lucia": "438116",
			"Uganda": "39540",
			"Belarus": "21754",
			"Ethiopia": "865068",
			"Congo": "4874",
			"Senegal": "616531",
			"Bulgaria": "107726",
			"Montenegro": "2632",
			"Sri Lanka": "43509",
			"Hungary": "3126",
			"Angola": "2002031",
			"New Zealand": "69232758",
			"N. Mariana Isds": "9794",
			"Samoa": "34064",
			"Myanmar": "1268532",
			"Iran": "10475080",
			"Uruguay": "74690",
			"Cabo Verde": "58346",
			"Germany": "72716675",
			"Timor-Leste": "281058",
			"Poland": "160770052",
			"Thailand": "705815987",
			"Argentina": "1609595",
			"Brazil": "318",
			"Dominica": "6441",
			"Mongolia": "83269",
			"Saudi Arabia": "7460",
			"Greece": "1119",
			"Russian Federation": "277",
			"Cayman Isds": "223380",
			"United Arab Emirates": "2435397",
			"Nicaragua": "4477",
			"Malawi": "13593890",
			"Switzerland": "98769",
			"El Salvador": "91618",
			"Latvia": "77335",
			"Japan": "8862722466",
			"Guinea": "1343",
			"Romania": "5265404",
			"Slovenia": "32543864",
			"Liberia": "11376",
			"Guatemala": "98385",
			"Madagascar": "134878",
			"Bolivia (Plurinational State of)": "101845",
			"Nigeria": "56432",
			"Saint Kitts and Nevis": "376160",
			"Bahamas": "6952",
			"Tunisia": "868495",
			"Chad": "327",
			"Viet Nam": "287044535",
			"Haiti": "1230117",
			"Oman": "831905",
			"Sweden": "142742114",
			"Maldives": "139172",
			"India": "4518638433",
			"Jamaica": "8154284",
			"Austria": "1196207",
			"Eritrea": "702228",
			"Zimbabwe": "99958",
			"Pakistan": "21339",
			"Fiji": "11310025",
			"Lithuania": "160600",
			"Cambodia": "36726",
			"Denmark": "3211414",
			"Peru": "7460",
			"Central African Rep.": "10806",
			"Netherlands": "960826668",
			"Costa Rica": "224872",
			"Equatorial Guinea": "10203",
			"Sudan": "11656",
			"Papua New Guinea": "112427524",
			"Kazakhstan": "42960",
			"Afghanistan": "51144",
			"Croatia": "8817968",
			"Saint Helena": "414746",
			"Egypt": "6632683",
			"Nauru": "158193",
			"Estonia": "33705",
			"Morocco": "93245",
			"Luxembourg": "903613",
			"TFYR of Macedonia": "19395",
			"Somalia": "2948",
			"United Rep. of Tanzania": "22162",
			"Finland": "5857502",
			"Belize": "250268",
			"Georgia": "4557",
			"Ukraine": "27482984",
			"Bermuda": "3635",
			"Djibouti": "395069",
			"China, Hong Kong SAR": "22896974",
			"Suriname": "52068",
			"Barbados": "24395",
			"Venezuela": "4343069",
			"Kuwait": "11617484",
			"Norway": "421",
			"Sierra Leone": "1567",
			"Marshall Isds": "63960",
			"Philippines": "94012226",
			"Libya": "15155",
			"Kyrgyzstan": "2633",
			"Czechia": "21726",
			"Mozambique": "4597524",
			"Togo": "1567",
			"Lao People's Dem. Rep.": "48618",
			"Turkey": "155281298",
			"Rep. of Korea": "3890507355",
			"Serbia": "56744",
			"Burundi": "8951",
			"Bhutan": "53134",
			"Cook Isds": "2166",
			"Canada": "6067",
			"Iceland": "56498"
		}
	},
	"Kiribati": {
		"imports": {},
		"exports": {}
	},
	"Jamaica": {
		"imports": {
			"Lebanon": "49249",
			"Bonaire": "27286",
			"Côte d'Ivoire": "20724",
			"South Africa": "76772",
			"Uruguay": "93",
			"Andorra": "432",
			"Germany": "2350526",
			"Poland": "61400",
			"Cuba": "76497",
			"Thailand": "1067455",
			"Argentina": "36820",
			"Brazil": "465583",
			"Dominica": "13826",
			"Ghana": "9816",
			"Saudi Arabia": "38909",
			"Panama": "22020001",
			"Colombia": "3262105",
			"Sudan": "3013",
			"Russian Federation": "82",
			"Cayman Isds": "75227",
			"United Arab Emirates": "117881",
			"Nicaragua": "8066",
			"Switzerland": "4449733",
			"El Salvador": "5790643",
			"Latvia": "2103",
			"Japan": "171",
			"Romania": "160",
			"Pakistan": "34579",
			"Belgium": "3582046",
			"Sweden": "154918",
			"Armenia": "283",
			"United Kingdom": "577573",
			"Singapore": "241850",
			"Barbados": "9694288",
			"Albania": "63945",
			"Bahamas": "179",
			"Tunisia": "212",
			"Viet Nam": "206703",
			"Haiti": "36697",
			"Indonesia": "2976983",
			"Qatar": "115503",
			"Saint Vincent and the Grenadines": "400",
			"Curaçao": "9694",
			"Australia": "398207",
			"India": "25343153",
			"Mexico": "22820352",
			"Jamaica": "4141",
			"Br. Virgin Isds": "14260",
			"Austria": "49563",
			"Ireland": "2856681",
			"Saint Maarten": "21020",
			"Spain": "1563070",
			"Lithuania": "2772",
			"Cambodia": "55470",
			"Denmark": "2793617",
			"Peru": "3339586",
			"Honduras": "3408481",
			"China, Hong Kong SAR": "607523",
			"Netherlands": "50561",
			"Costa Rica": "2181192",
			"Turkey": "1358569",
			"Greece": "5317",
			"Chile": "13573",
			"Slovenia": "721305",
			"Kenya": "10150",
			"Afghanistan": "5315",
			"Malaysia": "1644390",
			"Portugal": "1032611",
			"China": "36163082",
			"Egypt": "120",
			"Estonia": "11378",
			"Morocco": "12837",
			"Luxembourg": "1754",
			"Trinidad and Tobago": "15875107",
			"Israel": "295168",
			"Venezuela": "15918",
			"Somalia": "1859",
			"Montserrat": "8886",
			"Bangladesh": "92062",
			"Antigua and Barbuda": "11602",
			"Finland": "1522",
			"Cyprus": "5754",
			"Belize": "60616",
			"Mauritius": "5509",
			"Slovakia": "1690",
			"Bermuda": "12511",
			"Faeroe Isds": "35246",
			"Bahrain": "1019",
			"Bolivia (Plurinational State of)": "3010",
			"Guyana": "27323032",
			"Suriname": "485867",
			"USA": "15533121",
			"Saint Kitts and Nevis": "5468",
			"Iran": "500",
			"Malta": "2531",
			"Norway": "61301",
			"Ecuador": "775912",
			"Grenada": "1307",
			"Dominican Rep.": "18507102",
			"France": "14870266",
			"Philippines": "1591",
			"Seychelles": "22177",
			"Italy": "3653578",
			"Saint Lucia": "15956",
			"Czechia": "96066",
			"Nigeria": "4187",
			"Guatemala": "16752087",
			"Ethiopia": "271",
			"Senegal": "204",
			"Aruba": "807",
			"Bulgaria": "25329",
			"Sri Lanka": "463",
			"Rep. of Korea": "397277",
			"Hungary": "73517",
			"New Zealand": "11628",
			"Canada": "2503457",
			"Iceland": "9971",
			"Samoa": "70134",
			"Madagascar": "18592",
			"Myanmar": "7833"
		},
		"exports": {
			"Lebanon": "10",
			"Bonaire": "241",
			"Côte d'Ivoire": "132476",
			"Ghana": "4",
			"Uruguay": "4480",
			"Cabo Verde": "162",
			"Germany": "1516074",
			"Poland": "2059",
			"Cuba": "4875",
			"Thailand": "339063",
			"Argentina": "10",
			"Brazil": "102",
			"Cameroon": "22541744",
			"Dominica": "1142967",
			"South Africa": "308",
			"Montserrat": "355110",
			"Panama": "106369",
			"Colombia": "790787",
			"Sudan": "31905",
			"Russian Federation": "70567156",
			"Cayman Isds": "147747",
			"United Arab Emirates": "2054",
			"Switzerland": "3333",
			"El Salvador": "26551",
			"Latvia": "7932481",
			"Japan": "18616667",
			"Guam": "75144",
			"Guinea": "30473",
			"Romania": "30338",
			"Pakistan": "7624",
			"Belgium": "15",
			"Nigeria": "273",
			"Maldives": "8259",
			"United Kingdom": "6230862",
			"Singapore": "710",
			"Barbados": "3451711",
			"Bahamas": "19264",
			"Viet Nam": "193929",
			"Haiti": "187257",
			"Indonesia": "75152",
			"Saint Vincent and the Grenadines": "280565",
			"Curaçao": "5925",
			"Australia": "6488",
			"India": "16",
			"Mexico": "588",
			"Br. Virgin Isds": "7407",
			"Austria": "4233",
			"Ireland": "362",
			"Saint Maarten": "627903",
			"Spain": "49",
			"Saint Kitts and Nevis": "81995",
			"Denmark": "53076",
			"Portugal": "19375",
			"Honduras": "36107",
			"Netherlands": "33614",
			"Costa Rica": "2548523",
			"Turkey": "44964",
			"Greece": "280",
			"Chile": "28955",
			"Slovenia": "731",
			"Gambia": "724",
			"China, Macao SAR": "2805",
			"Sweden": "240",
			"Malaysia": "50",
			"Fiji": "60",
			"Peru": "55",
			"China": "76170",
			"Egypt": "5867",
			"Anguilla": "2730",
			"Luxembourg": "12",
			"Trinidad and Tobago": "3156090",
			"Israel": "916",
			"Venezuela": "1463",
			"Saudi Arabia": "482",
			"Paraguay": "424",
			"Bangladesh": "1525",
			"Antigua and Barbuda": "6324",
			"Finland": "62127",
			"Cyprus": "52",
			"Belize": "1181",
			"Georgia": "13676",
			"Bermuda": "852",
			"Papua New Guinea": "107",
			"China, Hong Kong SAR": "71730",
			"Guyana": "4449374",
			"Suriname": "916",
			"USA": "33271786",
			"Cambodia": "2833",
			"Zambia": "4650",
			"Malta": "283",
			"Norway": "29786",
			"Ecuador": "12992",
			"Grenada": "1669063",
			"Dominican Rep.": "235976",
			"France": "827216",
			"Philippines": "7977",
			"Italy": "2016341",
			"Saint Lucia": "229627",
			"Czechia": "1140",
			"Uganda": "1517",
			"Guatemala": "55413",
			"Congo": "41",
			"Aruba": "821",
			"Bulgaria": "75177",
			"Sri Lanka": "203",
			"Rep. of Korea": "290951",
			"Hungary": "10",
			"New Zealand": "622",
			"Canada": "39267",
			"Iceland": "23839324",
			"Myanmar": "7770"
		}
	},
	"Kenya": {
		"imports": {},
		"exports": {}
	},
	"Spain": {
		"imports": {
			"Lebanon": "937",
			"Bonaire": "75",
			"Gibraltar": "826441",
			"Ghana": "1075025",
			"Lesotho": "329",
			"Cuba": "5629231",
			"Dem. Rep. of the Congo": "178",
			"Dem. People's Rep. of Korea": "263714",
			"Cameroon": "1062",
			"Papua New Guinea": "36157951",
			"Montserrat": "260",
			"Indonesia": "11867609",
			"Colombia": "519927",
			"Niger": "5140",
			"Palau": "137",
			"Angola": "3432",
			"Fr. South Antarctic Terr.": "78939",
			"Uzbekistan": "402414",
			"Iraq": "74",
			"Tuvalu": "24857",
			"Guam": "92289",
			"Bosnia Herzegovina": "14466",
			"Pakistan": "1529",
			"Belgium": "26586154",
			"Azerbaijan": "105",
			"Australia": "31095",
			"Togo": "133",
			"Singapore": "124047",
			"Albania": "411",
			"Benin": "5069077",
			"South Africa": "95129",
			"Panama": "121648",
			"Qatar": "863",
			"American Samoa": "5",
			"Saint Vincent and the Grenadines": "1788",
			"Curaçao": "13240",
			"Armenia": "8818",
			"Jamaica": "9570",
			"Br. Virgin Isds": "33851",
			"Tajikistan": "63",
			"Ireland": "87505",
			"Botswana": "27146",
			"French Polynesia": "386",
			"Mauritania": "3232",
			"Christmas Isds": "374029",
			"Honduras": "198343",
			"Saint Barthélemy": "2810210",
			"Holy See (Vatican City State)": "12162",
			"United Kingdom": "53651998",
			"Chile": "62288",
			"Gambia": "241901",
			"Liberia": "11087",
			"Dominica": "121",
			"Malaysia": "3650",
			"Fiji": "378148",
			"Portugal": "116544318",
			"Falkland Isds (Malvinas)": "22473",
			"Nepal": "95",
			"China": "107483148",
			"Comoros": "507",
			"Guinea-Bissau": "35620",
			"Saint Maarten": "181273",
			"Mali": "1663",
			"Trinidad and Tobago": "89359262",
			"Israel": "92943",
			"Burkina Faso": "3100",
			"Paraguay": "26796",
			"Norfolk Isds": "12313",
			"Bangladesh": "1251029",
			"Antigua and Barbuda": "12453",
			"Gabon": "67",
			"Cyprus": "220969",
			"Yemen": "1733079",
			"Mauritius": "74792823",
			"Slovakia": "2223",
			"Faeroe Isds": "12686008",
			"Turkmenistan": "3599297",
			"Bahrain": "46",
			"Côte d'Ivoire": "8090655",
			"Guyana": "15499",
			"Saint Pierre and Miquelon": "790",
			"Algeria": "2471",
			"USA": "39508180",
			"Saint Kitts and Nevis": "9079",
			"Rep. of Moldova": "639872",
			"Zambia": "1",
			"Malta": "3269755",
			"Ecuador": "111393",
			"Grenada": "53996",
			"Dominican Rep.": "10991",
			"France": "112594124",
			"New Caledonia": "7422",
			"Niue": "4100",
			"Seychelles": "788",
			"Italy": "121956098",
			"Saint Lucia": "136",
			"State of Palestine": "7265",
			"Rwanda": "26725",
			"Syria": "20651531",
			"Belarus": "2994",
			"Ethiopia": "288",
			"Namibia": "3764",
			"Congo": "150",
			"Senegal": "93317",
			"Bulgaria": "840799",
			"Montenegro": "125791",
			"Sri Lanka": "19882",
			"Hungary": "1223868",
			"Jordan": "177",
			"N. Mariana Isds": "4257",
			"Lao People's Dem. Rep.": "29001",
			"Myanmar": "533",
			"Iran": "947545",
			"Sao Tome and Principe": "1981653",
			"Uruguay": "642",
			"Switzerland": "2704251",
			"Cabo Verde": "7749",
			"Germany": "76245643",
			"Timor-Leste": "103",
			"Poland": "9114077",
			"Bouvet Island": "212827",
			"Thailand": "78028322",
			"Argentina": "17115",
			"Brazil": "295555",
			"Brunei Darussalam": "25565",
			"Mongolia": "598",
			"Saudi Arabia": "21097",
			"Sudan": "304015",
			"Russian Federation": "128402",
			"Cayman Isds": "502912",
			"United Arab Emirates": "1093274",
			"Nicaragua": "2657616",
			"Malawi": "86",
			"Andorra": "422385",
			"El Salvador": "1",
			"United States Minor Outlying Islands": "87",
			"Sierra Leone": "67962",
			"Latvia": "42851",
			"Japan": "131328795",
			"Guinea": "886",
			"Uganda": "6076445",
			"Romania": "5394536",
			"Croatia": "1084155",
			"China, Macao SAR": "104",
			"Mozambique": "642",
			"Madagascar": "9639656",
			"Bolivia (Plurinational State of)": "1257",
			"Barbados": "9440",
			"Bahamas": "46728",
			"San Marino": "4849",
			"Chad": "127",
			"Viet Nam": "13945316",
			"Haiti": "440",
			"Tokelau": "38",
			"Slovenia": "2882614",
			"Oman": "85",
			"Sweden": "4819066",
			"Maldives": "486447",
			"India": "2244159",
			"Mexico": "1017841",
			"Austria": "36524842",
			"Eritrea": "250003",
			"Zimbabwe": "2373375",
			"Vanuatu": "12178",
			"Swaziland": "13805",
			"Lithuania": "1183503",
			"Cambodia": "1187414",
			"Denmark": "2731798",
			"Peru": "5458",
			"Central African Rep.": "304",
			"Netherlands": "39807620",
			"Costa Rica": "36094",
			"Equatorial Guinea": "6839307",
			"Greece": "114063",
			"Kazakhstan": "362",
			"Kenya": "14259007",
			"Afghanistan": "2049",
			"Saint Helena": "446190",
			"Egypt": "149620",
			"Nauru": "55844",
			"Anguilla": "3046",
			"Estonia": "5278",
			"Morocco": "198284",
			"Antarctica": "1309",
			"TFYR of Macedonia": "18739",
			"Somalia": "31",
			"United Rep. of Tanzania": "9662100",
			"Finland": "942580",
			"Belize": "4982",
			"Georgia": "5867",
			"Ukraine": "122616",
			"Bermuda": "13388",
			"Djibouti": "6257513",
			"Greenland": "1491044",
			"China, Hong Kong SAR": "835991",
			"Suriname": "927524",
			"Nigeria": "111",
			"Samoa": "45682",
			"Venezuela": "6966",
			"Kuwait": "511189",
			"New Zealand": "578709",
			"Norway": "777027",
			"Pitcairn": "65",
			"Marshall Isds": "23322",
			"Philippines": "508114",
			"Libya": "3635470",
			"Kyrgyzstan": "394",
			"Czechia": "67517",
			"Guatemala": "2611",
			"Aruba": "322",
			"Turkey": "2005822",
			"Tunisia": "735912",
			"Rep. of Korea": "3551821",
			"Serbia": "13617",
			"Burundi": "36667",
			"Bhutan": "263660",
			"Cook Isds": "503",
			"Canada": "3276002",
			"Iceland": "75466386",
			"Luxembourg": "2258440"
		},
		"exports": {
			"Lebanon": "45157",
			"Bonaire": "11965",
			"Gibraltar": "20362312",
			"Ghana": "30966",
			"Lesotho": "4565",
			"Cuba": "1180211",
			"Dem. Rep. of the Congo": "9770",
			"Dem. People's Rep. of Korea": "12826",
			"Cameroon": "3382",
			"Papua New Guinea": "353159",
			"Montserrat": "19927",
			"Panama": "620626",
			"Colombia": "1093433",
			"Niger": "105611",
			"Palau": "722",
			"Tonga": "2577",
			"Angola": "684298",
			"Fr. South Antarctic Terr.": "15941",
			"Uzbekistan": "50198118",
			"Iraq": "157865",
			"Tuvalu": "213",
			"Guam": "210",
			"Bosnia Herzegovina": "69229",
			"Pakistan": "830",
			"Belgium": "10297637",
			"Azerbaijan": "457",
			"Armenia": "2983044",
			"Togo": "6453",
			"Singapore": "770066",
			"Albania": "6403",
			"Benin": "25147883",
			"South Africa": "183810",
			"FS Micronesia": "11435",
			"Indonesia": "442816",
			"Qatar": "172950",
			"American Samoa": "46839",
			"Saint Vincent and the Grenadines": "3566",
			"Curaçao": "2768",
			"Australia": "3310470",
			"Kiribati": "6245",
			"Jamaica": "6460",
			"Br. Virgin Isds": "146420",
			"Tajikistan": "181539",
			"Ireland": "913188",
			"Botswana": "2",
			"South Sudan": "2851869",
			"Norfolk Isds": "1399",
			"Mauritania": "159690",
			"Honduras": "76614",
			"Saint Barthélemy": "258",
			"Holy See (Vatican City State)": "11",
			"United Kingdom": "27929734",
			"Chile": "1673360",
			"Gambia": "68094",
			"Liberia": "1771",
			"Dominica": "90486",
			"Malaysia": "636813",
			"Fiji": "324",
			"Portugal": "55245478",
			"Falkland Isds (Malvinas)": "24109",
			"Nepal": "1409681",
			"China": "1389537",
			"Comoros": "2759671",
			"Guinea-Bissau": "2126",
			"Saint Maarten": "69933",
			"Mali": "51980",
			"Trinidad and Tobago": "1731046",
			"Israel": "6432463",
			"Burkina Faso": "764",
			"Paraguay": "354308",
			"French Polynesia": "47514",
			"Bangladesh": "560895",
			"Antigua and Barbuda": "91863",
			"Gabon": "4758",
			"Cyprus": "873289",
			"Yemen": "373739",
			"Mauritius": "197201",
			"Slovakia": "338620",
			"Faeroe Isds": "10587",
			"Turkmenistan": "9324",
			"Bahrain": "97411",
			"Côte d'Ivoire": "1989",
			"Guyana": "139967",
			"Saint Pierre and Miquelon": "8225",
			"Algeria": "1182886",
			"USA": "27816441",
			"Namibia": "11662",
			"Rep. of Moldova": "649382",
			"Zambia": "193429",
			"Malta": "3211106",
			"Ecuador": "364535",
			"Grenada": "26111",
			"Dominican Rep.": "139841",
			"France": "102403048",
			"New Caledonia": "187026",
			"Niue": "5158",
			"Seychelles": "278354",
			"Italy": "35153659",
			"Saint Lucia": "107273",
			"State of Palestine": "6071680",
			"Rwanda": "32658",
			"Syria": "180414",
			"Belarus": "59045",
			"Ethiopia": "191371",
			"Slovenia": "312829",
			"Congo": "7",
			"Senegal": "341992",
			"Bulgaria": "2534776",
			"Montenegro": "143462",
			"Sri Lanka": "217006",
			"Hungary": "1443031",
			"Jordan": "195128",
			"N. Mariana Isds": "359",
			"Lao People's Dem. Rep.": "74575",
			"Myanmar": "86236",
			"Iran": "202266",
			"Sao Tome and Principe": "41957",
			"Uruguay": "698965",
			"Switzerland": "5676672",
			"Cabo Verde": "33270",
			"Germany": "32341765",
			"Timor-Leste": "38536",
			"Poland": "3668495",
			"Thailand": "577598",
			"Argentina": "521595",
			"Brazil": "1300421",
			"Brunei Darussalam": "128541",
			"Mongolia": "1432",
			"Saudi Arabia": "778481",
			"Sudan": "788443",
			"Russian Federation": "251976",
			"Cayman Isds": "1547477",
			"United Arab Emirates": "1221893",
			"Nicaragua": "41733",
			"Malawi": "393",
			"Andorra": "6997857",
			"El Salvador": "257791",
			"United States Minor Outlying Islands": "1018",
			"Latvia": "166436",
			"Japan": "4211282",
			"Guinea": "9165",
			"Uganda": "14400",
			"Romania": "962546",
			"Croatia": "783877",
			"China, Macao SAR": "1048616",
			"Guatemala": "379346",
			"Madagascar": "165",
			"Bolivia (Plurinational State of)": "315591",
			"Barbados": "284461",
			"Saint Kitts and Nevis": "106870",
			"Bahamas": "2292",
			"San Marino": "17",
			"Chad": "216",
			"Viet Nam": "351676",
			"Haiti": "9053",
			"Tokelau": "11782",
			"Oman": "43269",
			"Sweden": "2607712",
			"Maldives": "78040",
			"India": "805406",
			"Mexico": "2155190",
			"Austria": "8909820",
			"Eritrea": "3334",
			"Zimbabwe": "72511",
			"Vanuatu": "14711",
			"Swaziland": "76774",
			"Lithuania": "139956",
			"Cambodia": "5535",
			"Denmark": "727755",
			"Peru": "394144",
			"Central African Rep.": "2878",
			"Netherlands": "4670054",
			"Costa Rica": "436991",
			"Equatorial Guinea": "245360",
			"Greece": "487556",
			"Kazakhstan": "380140",
			"Kenya": "4428",
			"Afghanistan": "63233",
			"Saint Helena": "67",
			"Egypt": "26906352",
			"Nauru": "31770",
			"Anguilla": "18812",
			"Estonia": "291170",
			"Morocco": "4075223",
			"Antarctica": "80677",
			"TFYR of Macedonia": "18077",
			"Somalia": "6791594",
			"Heard Island and McDonald Islands": "342",
			"Western Sahara": "37761",
			"United Rep. of Tanzania": "97166",
			"Finland": "1796831",
			"Belize": "24543",
			"Georgia": "240095",
			"Ukraine": "204756",
			"Bermuda": "77641",
			"Djibouti": "23370453",
			"Greenland": "9871",
			"China, Hong Kong SAR": "1031122",
			"Suriname": "195088",
			"Nigeria": "16360",
			"Samoa": "10748",
			"Venezuela": "89809",
			"Kuwait": "470467",
			"New Zealand": "1018931",
			"Norway": "3801109",
			"Sierra Leone": "899",
			"Marshall Isds": "12414",
			"Philippines": "106777",
			"Libya": "760884",
			"Kyrgyzstan": "755590",
			"Czechia": "1713856",
			"Br. Indian Ocean Terr.": "2",
			"Mozambique": "11049",
			"Aruba": "2977",
			"Turkey": "2940221",
			"Tunisia": "62095",
			"Rep. of Korea": "1306373",
			"Serbia": "134803",
			"Burundi": "36591",
			"Bhutan": "38033",
			"Cook Isds": "10475",
			"Canada": "3517664",
			"Iceland": "124412",
			"Luxembourg": "114850"
		}
	},
	"Tajikistan": {
		"imports": {},
		"exports": {}
	},
	"Ireland": {
		"imports": {
			"Lebanon": "34259",
			"Bonaire": "5413",
			"Gibraltar": "2302",
			"Ghana": "211788",
			"Lesotho": "1050",
			"Cuba": "460",
			"Dem. Rep. of the Congo": "2986",
			"Dem. People's Rep. of Korea": "20004",
			"Cameroon": "780428",
			"South Africa": "45372",
			"Montserrat": "64920",
			"Panama": "2181359",
			"Colombia": "148855",
			"Niger": "196",
			"Tonga": "71",
			"Jordan": "437",
			"Fr. South Antarctic Terr.": "97825",
			"Uzbekistan": "711",
			"Iraq": "17404",
			"Tuvalu": "231791",
			"Guam": "28416",
			"Bosnia Herzegovina": "188784",
			"Pakistan": "111",
			"Belgium": "30304598",
			"Azerbaijan": "70821899",
			"Armenia": "2537",
			"United Kingdom": "519638098",
			"Singapore": "487",
			"Albania": "2445",
			"Benin": "20111",
			"FS Micronesia": "5882",
			"Indonesia": "126528",
			"Qatar": "269528",
			"American Samoa": "11061",
			"Saint Vincent and the Grenadines": "41",
			"Curaçao": "14143",
			"Australia": "128670",
			"Kiribati": "354",
			"Mexico": "9143",
			"Br. Virgin Isds": "800",
			"Spain": "226949",
			"Tajikistan": "806",
			"Kenya": "16034280",
			"Botswana": "2091",
			"South Sudan": "4831",
			"Norfolk Isds": "1736",
			"Mauritania": "2702",
			"Christmas Isds": "24408",
			"Honduras": "10263",
			"Saint Barthélemy": "10342",
			"Holy See (Vatican City State)": "44",
			"Chile": "31840",
			"Sudan": "6830",
			"Gambia": "1222",
			"Liberia": "67",
			"Dominica": "1279",
			"Malaysia": "1377",
			"Fiji": "217570",
			"Peru": "19450826",
			"Falkland Isds (Malvinas)": "14194",
			"Nepal": "4027",
			"China": "43454133",
			"Comoros": "6827",
			"Saint Maarten": "363",
			"Mali": "3355",
			"Trinidad and Tobago": "204",
			"Israel": "5670",
			"Burkina Faso": "35497",
			"Paraguay": "15023090",
			"Bangladesh": "792355",
			"Antigua and Barbuda": "12901",
			"Gabon": "255416",
			"Cyprus": "14274",
			"Yemen": "2439",
			"Mauritius": "5821",
			"Slovakia": "1501",
			"Faeroe Isds": "6968",
			"Turkmenistan": "766694",
			"Bahrain": "2856",
			"Côte d'Ivoire": "2780811",
			"Guyana": "822",
			"Algeria": "24716636",
			"USA": "15199862",
			"Namibia": "122907",
			"Rep. of Moldova": "449",
			"Zambia": "23370",
			"Malta": "11782",
			"Ecuador": "669344",
			"Grenada": "1097",
			"Dominican Rep.": "6878614",
			"France": "6860132234",
			"New Caledonia": "56",
			"Niue": "3428",
			"Seychelles": "3084",
			"Italy": "147909906",
			"Saint Lucia": "2558",
			"State of Palestine": "7720",
			"Rwanda": "2235",
			"Syria": "236",
			"Belarus": "589118",
			"Ethiopia": "636897",
			"Slovenia": "33000",
			"Congo": "123",
			"Senegal": "907",
			"Bulgaria": "405",
			"Montenegro": "6932",
			"Sri Lanka": "169506",
			"Hungary": "41365801",
			"Angola": "780",
			"New Zealand": "34959",
			"Lao People's Dem. Rep.": "116",
			"Myanmar": "209116",
			"Iran": "978287",
			"Sao Tome and Principe": "1028977",
			"Uruguay": "689467",
			"Andorra": "4928",
			"Cabo Verde": "7335",
			"Germany": "1781373468",
			"Timor-Leste": "97",
			"Poland": "254593",
			"Thailand": "7532820",
			"Argentina": "13066",
			"Brazil": "140298920",
			"Brunei Darussalam": "46",
			"Mongolia": "10894",
			"Saudi Arabia": "98303",
			"Greece": "1972549",
			"Russian Federation": "128",
			"Cayman Isds": "38",
			"United Arab Emirates": "16563",
			"Nicaragua": "2201959",
			"Malawi": "274",
			"Switzerland": "57165",
			"El Salvador": "43109",
			"United States Minor Outlying Islands": "832",
			"Sierra Leone": "2853",
			"Latvia": "8164",
			"Japan": "35869465",
			"Guinea": "1080",
			"Uganda": "180936",
			"Romania": "375431",
			"Croatia": "8297",
			"China, Macao SAR": "1568068",
			"Guatemala": "1597801",
			"Madagascar": "28635",
			"Bolivia (Plurinational State of)": "136739",
			"Barbados": "173",
			"Saint Kitts and Nevis": "443",
			"Bahamas": "22",
			"San Marino": "1637",
			"Chad": "3027",
			"Viet Nam": "32122",
			"Haiti": "47578",
			"Tokelau": "1770",
			"Oman": "195",
			"Sweden": "6228627",
			"Maldives": "5806315",
			"India": "9264",
			"Jamaica": "85740",
			"Austria": "1077732",
			"Eritrea": "263",
			"Zimbabwe": "560737",
			"Vanuatu": "107",
			"Swaziland": "18414",
			"Lithuania": "6020",
			"Cambodia": "3694498",
			"Denmark": "2290588",
			"Portugal": "252834",
			"Central African Rep.": "1087149",
			"Netherlands": "3408028",
			"Costa Rica": "31638321",
			"Equatorial Guinea": "226",
			"South Georgia and the South Sandwich Islands": "11172",
			"Papua New Guinea": "367909",
			"Kazakhstan": "1",
			"Afghanistan": "28120",
			"Saint Helena": "1482",
			"Egypt": "8186263",
			"Nauru": "217",
			"Estonia": "2601",
			"Morocco": "551",
			"Luxembourg": "1662403",
			"TFYR of Macedonia": "70822",
			"Somalia": "3206",
			"Western Sahara": "25165",
			"United Rep. of Tanzania": "35553",
			"Finland": "1571714",
			"Belize": "13474813",
			"Georgia": "198565",
			"Ukraine": "493896",
			"Bermuda": "2544",
			"Djibouti": "22784",
			"Greenland": "10148",
			"China, Hong Kong SAR": "1647",
			"Suriname": "26129",
			"Nigeria": "496",
			"Venezuela": "499",
			"Kuwait": "171",
			"Norway": "54321",
			"Pitcairn": "418",
			"Marshall Isds": "296",
			"Philippines": "4250022",
			"Libya": "8991",
			"Kyrgyzstan": "797",
			"Czechia": "5825601",
			"Br. Indian Ocean Terr.": "5054",
			"Mozambique": "1799",
			"Togo": "9",
			"Aruba": "387859",
			"Turkey": "2146",
			"Tunisia": "51167",
			"Rep. of Korea": "14214",
			"Serbia": "103162",
			"Burundi": "13321",
			"Cook Isds": "944",
			"Canada": "190123878",
			"Iceland": "48342"
		},
		"exports": {
			"Lebanon": "44242",
			"Gibraltar": "74986",
			"Ghana": "140881",
			"Lesotho": "20254",
			"Cuba": "23",
			"Dem. Rep. of the Congo": "10934912",
			"Cameroon": "55524",
			"Papua New Guinea": "1866535",
			"Montserrat": "41919",
			"Indonesia": "867860",
			"Colombia": "36175",
			"Niger": "14102",
			"Angola": "16969",
			"Fr. South Antarctic Terr.": "106596",
			"Uzbekistan": "21457",
			"Iraq": "1380",
			"Guam": "54082",
			"Bosnia Herzegovina": "2767",
			"Pakistan": "102863",
			"Belgium": "28299631",
			"Azerbaijan": "1429",
			"Armenia": "193655",
			"United Kingdom": "282698608",
			"Singapore": "105039",
			"Albania": "107",
			"Benin": "32407",
			"FS Micronesia": "49",
			"Panama": "18783939",
			"Qatar": "553",
			"Saint Vincent and the Grenadines": "26466",
			"Curaçao": "21097",
			"Australia": "1151319",
			"Jamaica": "1968514",
			"Br. Virgin Isds": "3318",
			"Spain": "65679",
			"Tajikistan": "278",
			"Kenya": "92621",
			"Botswana": "885",
			"South Sudan": "113",
			"French Polynesia": "74360",
			"Mauritania": "151520",
			"Christmas Isds": "4883",
			"Honduras": "295234",
			"Jordan": "39361",
			"Chile": "30",
			"Gambia": "17144",
			"Liberia": "1661832",
			"Brunei Darussalam": "49772",
			"Malaysia": "8919",
			"Fiji": "332",
			"Peru": "2828933",
			"Falkland Isds (Malvinas)": "81494",
			"Nepal": "10",
			"China": "481984",
			"Comoros": "1900",
			"Saint Maarten": "9523",
			"Mali": "595040",
			"Trinidad and Tobago": "187518",
			"Israel": "17317",
			"Burkina Faso": "50",
			"Paraguay": "2102",
			"Bangladesh": "21357",
			"Antigua and Barbuda": "55",
			"Gabon": "1806",
			"Cyprus": "72819",
			"Yemen": "1700340",
			"Mauritius": "111",
			"Slovakia": "995",
			"Faeroe Isds": "6641",
			"Turkmenistan": "731198",
			"Bahrain": "11061",
			"Côte d'Ivoire": "25439",
			"Guyana": "6893",
			"Algeria": "2666061",
			"USA": "3411104",
			"Namibia": "82069",
			"Rep. of Moldova": "15667",
			"Zambia": "49551",
			"Malta": "275121",
			"Ecuador": "23574",
			"Grenada": "128657",
			"Dominican Rep.": "124953",
			"France": "208367444",
			"New Caledonia": "421",
			"Seychelles": "63267",
			"Italy": "2681974",
			"Saint Lucia": "14142",
			"State of Palestine": "760004",
			"Nicaragua": "111",
			"Syria": "377367",
			"Belarus": "17",
			"Ethiopia": "55",
			"Slovenia": "597438",
			"Congo": "3871",
			"Senegal": "27651",
			"Bulgaria": "9623",
			"Montenegro": "54697",
			"Sri Lanka": "6705",
			"Hungary": "10763",
			"New Zealand": "940",
			"N. Mariana Isds": "1164",
			"Lao People's Dem. Rep.": "92",
			"Myanmar": "677054",
			"South Africa": "609",
			"Uruguay": "66725",
			"Andorra": "499719",
			"Cabo Verde": "1061",
			"Germany": "721552965",
			"Timor-Leste": "66",
			"Poland": "31744",
			"Thailand": "3659297",
			"Argentina": "16779",
			"Brazil": "30559",
			"Dominica": "1051",
			"Mongolia": "421",
			"Saudi Arabia": "28038",
			"Sudan": "18029",
			"Russian Federation": "7157",
			"Cayman Isds": "27983",
			"United Arab Emirates": "12333",
			"Rwanda": "104147",
			"Malawi": "106624",
			"Switzerland": "4431",
			"El Salvador": "152",
			"United States Minor Outlying Islands": "257433",
			"Latvia": "28204",
			"Japan": "47509686",
			"Guinea": "830",
			"Uganda": "1745",
			"Romania": "15350422",
			"Croatia": "2744552",
			"China, Macao SAR": "3921220",
			"Mozambique": "8572",
			"Madagascar": "99845",
			"Bolivia (Plurinational State of)": "30232",
			"Barbados": "34493",
			"Saint Kitts and Nevis": "24936",
			"Bahamas": "55",
			"Tunisia": "513",
			"Chad": "1949055",
			"Viet Nam": "2189632",
			"Haiti": "1244257",
			"Tokelau": "19356",
			"Oman": "1089",
			"Sweden": "2238",
			"Maldives": "34739",
			"India": "10572",
			"Mexico": "1714",
			"Austria": "69764",
			"Eritrea": "8364",
			"Zimbabwe": "5309",
			"Vanuatu": "18069",
			"Swaziland": "2267",
			"Lithuania": "577",
			"Cambodia": "15533",
			"Denmark": "1397612",
			"Portugal": "4022",
			"Central African Rep.": "25470",
			"Netherlands": "445104",
			"Costa Rica": "1669249",
			"Equatorial Guinea": "2765",
			"Greece": "120836",
			"Kazakhstan": "805534",
			"Afghanistan": "64348",
			"Saint Helena": "35961",
			"Egypt": "4540203",
			"Nauru": "111",
			"Anguilla": "48796",
			"Estonia": "6500406",
			"Morocco": "33",
			"Luxembourg": "75149",
			"TFYR of Macedonia": "11954",
			"Somalia": "9135",
			"Western Sahara": "1030",
			"United Rep. of Tanzania": "23841",
			"Finland": "145256",
			"Belize": "9881",
			"Georgia": "267886",
			"Ukraine": "923616",
			"Bermuda": "221",
			"Djibouti": "66",
			"Greenland": "9521",
			"China, Hong Kong SAR": "108393",
			"Suriname": "531",
			"Nigeria": "2832948",
			"Iran": "2123625",
			"Venezuela": "1082",
			"Kuwait": "5976",
			"Norway": "326058",
			"Sierra Leone": "5973",
			"Marshall Isds": "14653",
			"Philippines": "540",
			"Libya": "346593",
			"Kyrgyzstan": "3369",
			"Czechia": "518",
			"Guatemala": "1510295",
			"Togo": "13826",
			"Aruba": "4895",
			"Turkey": "14010",
			"San Marino": "3060",
			"Rep. of Korea": "8275",
			"Serbia": "2838",
			"Burundi": "144",
			"Bhutan": "773",
			"Canada": "11160837",
			"Iceland": "28936267"
		}
	},
	"Botswana": {
		"imports": {
			"Lebanon": "30755",
			"Ghana": "429",
			"Lesotho": "5756",
			"Andorra": "23931",
			"Peru": "53",
			"Germany": "1030788",
			"Poland": "35998",
			"Cuba": "480",
			"Dem. Rep. of the Congo": "10",
			"Thailand": "115678",
			"Equatorial Guinea": "20",
			"Argentina": "1559",
			"Brazil": "69797",
			"Cameroon": "978",
			"Iran": "1877",
			"Saudi Arabia": "13",
			"Panama": "12721",
			"Colombia": "583",
			"Syria": "65",
			"Russian Federation": "397",
			"Cayman Isds": "604",
			"United Arab Emirates": "9167229",
			"Rwanda": "934",
			"Belize": "32",
			"Angola": "6789",
			"Malawi": "72999",
			"Switzerland": "2255140",
			"Mauritius": "233548",
			"United States Minor Outlying Islands": "762",
			"Uruguay": "137455",
			"Slovakia": "59",
			"Latvia": "24",
			"Japan": "37765037",
			"Guinea": "5781",
			"Bosnia Herzegovina": "99",
			"Pakistan": "24282",
			"Belgium": "187335",
			"Croatia": "334",
			"China, Macao SAR": "1366",
			"Mozambique": "52501",
			"United Kingdom": "81249452",
			"Singapore": "86321",
			"Nigeria": "31911",
			"Albania": "989",
			"Benin": "641",
			"Maldives": "255",
			"Tunisia": "39742",
			"Viet Nam": "1454",
			"South Africa": "672814376",
			"Indonesia": "67536",
			"Qatar": "1672",
			"American Samoa": "14001",
			"Oman": "1358",
			"Sweden": "1057592",
			"Australia": "1004999",
			"India": "19168",
			"Mexico": "56572",
			"Jamaica": "1503",
			"Kenya": "1603549",
			"Austria": "20",
			"Romania": "14403",
			"Ireland": "78252",
			"Zimbabwe": "8951373",
			"Côte d'Ivoire": "39742",
			"Spain": "638962",
			"Mauritania": "503",
			"Fiji": "166",
			"Lithuania": "220",
			"Namibia": "154281",
			"Denmark": "7745",
			"Curaçao": "471",
			"Central African Rep.": "401",
			"Netherlands": "1363632",
			"Costa Rica": "7873",
			"Turkey": "1072673",
			"Greece": "154",
			"Chile": "559",
			"Slovenia": "2971",
			"Gambia": "405",
			"Liberia": "74",
			"Afghanistan": "351",
			"Saint Kitts and Nevis": "98",
			"Malaysia": "237258",
			"Swaziland": "6304318",
			"Portugal": "1054",
			"United Rep. of Tanzania": "1765",
			"Jordan": "1031",
			"China": "1538539",
			"Egypt": "36735",
			"Estonia": "501",
			"Morocco": "27",
			"Luxembourg": "6534",
			"Trinidad and Tobago": "250",
			"Israel": "215",
			"Venezuela": "227",
			"Bangladesh": "54",
			"Yemen": "27",
			"Gabon": "60",
			"Finland": "765139",
			"Cyprus": "1226",
			"Kuwait": "423",
			"Georgia": "1362",
			"Ukraine": "1510700",
			"Bermuda": "94",
			"Mali": "4927",
			"Madagascar": "144",
			"China, Hong Kong SAR": "128416",
			"Guyana": "426",
			"Niger": "21",
			"Algeria": "591",
			"USA": "18535039",
			"Cambodia": "1023",
			"Zambia": "1868632",
			"Suriname": "510",
			"Malta": "86",
			"Norway": "2153",
			"Ecuador": "150",
			"Serbia": "97228",
			"Sierra Leone": "472",
			"France": "59268",
			"Philippines": "213531",
			"Seychelles": "212",
			"Italy": "13607",
			"Czechia": "152",
			"Uganda": "41296",
			"Belarus": "71",
			"Ethiopia": "14997",
			"Togo": "142",
			"Congo": "4459",
			"Senegal": "1837",
			"Aruba": "394",
			"Bulgaria": "9115",
			"Sri Lanka": "449",
			"Rep. of Korea": "49639522",
			"Hungary": "5535",
			"New Zealand": "12642",
			"Canada": "60111",
			"Iceland": "134",
			"Lao People's Dem. Rep.": "127"
		},
		"exports": {
			"Lebanon": "14016",
			"Ghana": "2502",
			"Lesotho": "14678",
			"Andorra": "40625",
			"Germany": "1179",
			"Poland": "30",
			"Cuba": "777",
			"Dem. Rep. of the Congo": "78873",
			"Thailand": "18894",
			"Dem. People's Rep. of Korea": "7313",
			"Argentina": "114",
			"Brazil": "13026",
			"Cameroon": "1341",
			"South Africa": "167509141",
			"Saudi Arabia": "1947",
			"Sudan": "4758",
			"Niger": "87",
			"United Arab Emirates": "686867351",
			"Rwanda": "554",
			"Angola": "1539907",
			"Malawi": "6348",
			"Switzerland": "41844316",
			"Mauritius": "2635",
			"Slovakia": "482",
			"Japan": "12193151",
			"Guinea": "677",
			"Bosnia Herzegovina": "48",
			"Pakistan": "453",
			"Belgium": "91416",
			"Slovenia": "48",
			"United Kingdom": "638738",
			"Singapore": "240",
			"Nigeria": "57",
			"Benin": "191",
			"Bahamas": "8",
			"Viet Nam": "30040607",
			"Indonesia": "4",
			"Qatar": "105",
			"Oman": "33",
			"Sweden": "56141",
			"Australia": "432277",
			"Bahrain": "3739",
			"India": "2412",
			"Mexico": "9020",
			"Jamaica": "639",
			"Kenya": "1262993",
			"Austria": "1841",
			"Eritrea": "300413",
			"Ireland": "4949",
			"Zimbabwe": "12625222",
			"Côte d'Ivoire": "51",
			"Spain": "15",
			"Mauritania": "31603",
			"Cambodia": "84503",
			"Denmark": "383",
			"Portugal": "1149",
			"Netherlands": "415543",
			"Costa Rica": "241",
			"Turkey": "212212",
			"Greece": "6182933",
			"Kazakhstan": "902",
			"Gambia": "11454",
			"Libya": "4",
			"Malaysia": "2",
			"Swaziland": "428249",
			"Peru": "5484",
			"China": "4405",
			"Egypt": "444",
			"Bolivia (Plurinational State of)": "239",
			"Mali": "92518",
			"Israel": "3465",
			"Heard Island and McDonald Islands": "915",
			"Antigua and Barbuda": "173",
			"United Rep. of Tanzania": "941512",
			"Finland": "70405",
			"Cyprus": "370479",
			"Kuwait": "29008",
			"Georgia": "359",
			"Serbia": "32180",
			"Bermuda": "2364",
			"Luxembourg": "10688",
			"Madagascar": "294",
			"Nicaragua": "46",
			"China, Hong Kong SAR": "1279",
			"Guyana": "679",
			"Russian Federation": "11846",
			"Algeria": "8",
			"USA": "803855",
			"Namibia": "1193866",
			"Iran": "398000",
			"Romania": "398",
			"Zambia": "5262875",
			"Malta": "568439",
			"Norway": "823",
			"France": "863568",
			"Philippines": "1424",
			"Seychelles": "32179",
			"Italy": "8420212",
			"Czechia": "1623",
			"Uganda": "87465",
			"Mozambique": "76510",
			"Ethiopia": "5245",
			"Togo": "912",
			"Congo": "50532",
			"Senegal": "48073",
			"Bulgaria": "2",
			"Sri Lanka": "13432",
			"Rep. of Korea": "1420077",
			"Hungary": "8879",
			"New Zealand": "4528",
			"Canada": "21",
			"Ukraine": "177"
		}
	},
	"Côte d'Ivoire": {
		"imports": {},
		"exports": {}
	},
	"Norfolk Isds": {
		"imports": {},
		"exports": {}
	},
	"Mauritania": {
		"imports": {
			"Lebanon": "95321",
			"Ghana": "6601",
			"Philippines": "2568",
			"Uruguay": "196852",
			"Switzerland": "30577",
			"Cabo Verde": "209",
			"Germany": "973161",
			"Timor-Leste": "174540",
			"Poland": "412538",
			"Qatar": "304",
			"Dem. Rep. of the Congo": "652",
			"Thailand": "24138",
			"Dem. People's Rep. of Korea": "67668",
			"Argentina": "4293",
			"Brazil": "9024339",
			"Cameroon": "346",
			"Brunei Darussalam": "15988",
			"South Africa": "3304",
			"Saudi Arabia": "12740",
			"Panama": "149581",
			"Colombia": "104",
			"Syria": "975",
			"Niger": "60145",
			"United Arab Emirates": "14389049",
			"Palau": "6015",
			"Angola": "154374",
			"Andorra": "13200552",
			"Mauritius": "3234",
			"Lesotho": "185",
			"Slovakia": "316867",
			"Latvia": "12069",
			"Japan": "12908323",
			"Guinea": "6691",
			"Romania": "337",
			"Pakistan": "268",
			"Belgium": "83472",
			"Slovenia": "13042014",
			"China, Macao SAR": "6527",
			"Armenia": "2406",
			"United Kingdom": "1462872",
			"Singapore": "1868104",
			"Nigeria": "2024",
			"Albania": "3225",
			"Benin": "7179",
			"Tunisia": "609545",
			"Viet Nam": "6114",
			"Antarctica": "17370",
			"Tokelau": "2489",
			"Indonesia": "2764",
			"American Samoa": "5850",
			"Oman": "42973",
			"Sweden": "157757",
			"Australia": "66266",
			"India": "7627",
			"Mexico": "63532",
			"Jamaica": "3454",
			"Kenya": "85423",
			"Austria": "9358",
			"Gabon": "3263",
			"Ireland": "50",
			"Botswana": "2327",
			"China, Hong Kong SAR": "27433",
			"Spain": "17717",
			"Suriname": "1290573",
			"Swaziland": "2272",
			"Lithuania": "16799",
			"Namibia": "7951",
			"Denmark": "155120",
			"Peru": "8427",
			"Central African Rep.": "5874",
			"Saint Barthélemy": "20230",
			"Netherlands": "19580",
			"Costa Rica": "1847",
			"Turkey": "49515",
			"Greece": "10911",
			"Chile": "14622",
			"Kazakhstan": "300",
			"Sudan": "698",
			"Gambia": "48289",
			"Liberia": "43940",
			"Libya": "28869",
			"Vanuatu": "108054223",
			"Saint Helena": "21627",
			"Malaysia": "1210017",
			"Fiji": "2193",
			"Portugal": "5344",
			"Nepal": "403",
			"China": "2326768",
			"Egypt": "19580",
			"Guinea-Bissau": "53235",
			"Anguilla": "166061",
			"Morocco": "62176",
			"Mali": "1455",
			"Israel": "46",
			"Venezuela": "176867",
			"Burkina Faso": "567",
			"Paraguay": "688062",
			"Bangladesh": "55824",
			"Antigua and Barbuda": "6815",
			"United Rep. of Tanzania": "7680",
			"Finland": "8980",
			"Bosnia Herzegovina": "57767",
			"Belize": "2594",
			"Georgia": "25282",
			"Ukraine": "4694",
			"Djibouti": "1570",
			"Malta": "8292",
			"Bahrain": "3686",
			"Zambia": "25350",
			"Côte d'Ivoire": "547457",
			"Russian Federation": "229288",
			"Algeria": "6240",
			"USA": "218",
			"Cambodia": "10",
			"Iran": "116",
			"Kuwait": "33045",
			"New Zealand": "1945",
			"Norway": "1930303",
			"Ecuador": "12297",
			"Sierra Leone": "3491",
			"France": "2162",
			"Luxembourg": "4414",
			"Italy": "44693666",
			"Czechia": "8553",
			"Uganda": "2321",
			"Togo": "898",
			"Senegal": "104479",
			"Bulgaria": "70490",
			"Sri Lanka": "149222",
			"Rep. of Korea": "262600",
			"Hungary": "8799",
			"Holy See (Vatican City State)": "589",
			"Jordan": "22986",
			"Canada": "191912",
			"Iceland": "5646374",
			"Lao People's Dem. Rep.": "1842"
		},
		"exports": {
			"Lebanon": "481147",
			"Iran": "29",
			"Uruguay": "1159",
			"Germany": "41565111",
			"Gabon": "1455",
			"Dem. Rep. of the Congo": "1745",
			"Thailand": "143138",
			"Dem. People's Rep. of Korea": "256685",
			"Brazil": "1891",
			"Cameroon": "2909",
			"South Africa": "3552368",
			"Saudi Arabia": "291",
			"Sudan": "1947",
			"Russian Federation": "70019834",
			"United Arab Emirates": "8640",
			"Rwanda": "1455",
			"Jordan": "12332",
			"Fr. South Antarctic Terr.": "291",
			"Switzerland": "145",
			"Iraq": "454",
			"Japan": "46253",
			"Latvia": "1198055",
			"Belgium": "320",
			"Slovenia": "145",
			"Belarus": "1016325",
			"Madagascar": "1455",
			"Nigeria": "332973",
			"Benin": "1455",
			"Tunisia": "34985",
			"Chad": "1140",
			"Viet Nam": "229011",
			"Guinea": "145",
			"Indonesia": "49937",
			"Djibouti": "291",
			"Sweden": "3037358",
			"Australia": "34058",
			"India": "1184806",
			"Spain": "28700",
			"Ireland": "2702",
			"Côte d'Ivoire": "2967650",
			"Austria": "145",
			"Lithuania": "217160",
			"United Kingdom": "495576",
			"Denmark": "5691673",
			"Peru": "1022147",
			"Netherlands": "601527",
			"Turkey": "409453",
			"Equatorial Guinea": "17489",
			"Greece": "378699",
			"Kazakhstan": "4834",
			"Gambia": "17291",
			"Liberia": "355920",
			"Libya": "12593",
			"Malaysia": "231167",
			"Portugal": "11753",
			"China": "152048",
			"Egypt": "130929",
			"Guinea-Bissau": "145",
			"Anguilla": "87",
			"Estonia": "1498",
			"Morocco": "1686",
			"Mali": "188940",
			"Venezuela": "620256",
			"Burkina Faso": "3318",
			"United Rep. of Tanzania": "60121",
			"Finland": "3054",
			"Cyprus": "66492",
			"Ukraine": "1434830",
			"Luxembourg": "1100",
			"China, Hong Kong SAR": "1250",
			"Ghana": "47177",
			"Niger": "1164",
			"Algeria": "2508",
			"USA": "22692",
			"Namibia": "22614",
			"Malta": "775633",
			"Norway": "362347",
			"Ecuador": "14997",
			"France": "7925838",
			"Italy": "114",
			"Mozambique": "56782",
			"Togo": "1504322",
			"Congo": "29",
			"Senegal": "1597574",
			"Bulgaria": "17205",
			"Rep. of Korea": "21326175",
			"Angola": "69098",
			"Canada": "727"
		}
	},
	"Christmas Isds": {
		"imports": {},
		"exports": {}
	},
	"Honduras": {
		"imports": {},
		"exports": {}
	},
	"Saint Barthélemy": {
		"imports": {},
		"exports": {}
	},
	"Holy See (Vatican City State)": {
		"imports": {},
		"exports": {}
	},
	"Eritrea": {
		"imports": {},
		"exports": {}
	},
	"Chile": {
		"imports": {
			"Lebanon": "3463",
			"Gibraltar": "54",
			"Ghana": "4803",
			"Lesotho": "404",
			"Cuba": "3510581",
			"Dem. People's Rep. of Korea": "281910",
			"Cameroon": "919",
			"South Africa": "65531",
			"Montserrat": "2601",
			"Panama": "4883429",
			"Colombia": "352201",
			"Jordan": "160456",
			"Fr. South Antarctic Terr.": "7681",
			"Uzbekistan": "88439",
			"Iraq": "78974",
			"Guam": "912",
			"Bosnia Herzegovina": "4287",
			"Pakistan": "49",
			"Belgium": "14344356",
			"Azerbaijan": "181",
			"Rwanda": "20814",
			"Armenia": "161",
			"United Kingdom": "16234",
			"Singapore": "7581",
			"Albania": "116",
			"Benin": "112",
			"FS Micronesia": "807",
			"Indonesia": "1824917",
			"Qatar": "15781868",
			"Saint Vincent and the Grenadines": "561845",
			"Curaçao": "8762",
			"Australia": "3412209",
			"Mexico": "245928242",
			"Kenya": "1201",
			"Spain": "142498725",
			"Tajikistan": "123",
			"Ireland": "14052",
			"Botswana": "120",
			"French Polynesia": "3288",
			"Mauritania": "2826",
			"Honduras": "108875",
			"Saint Barthélemy": "53",
			"Chile": "114702",
			"Gambia": "157",
			"Liberia": "4666",
			"Brunei Darussalam": "58",
			"Malaysia": "131380",
			"Swaziland": "555",
			"Portugal": "4949566",
			"Nepal": "259",
			"China": "312658135",
			"Comoros": "70",
			"Mali": "17966",
			"Trinidad and Tobago": "573131252",
			"Israel": "75349",
			"Kazakhstan": "3271999",
			"Paraguay": "3076245",
			"Bangladesh": "15481535",
			"Gabon": "1054",
			"Cyprus": "143",
			"Mauritius": "263557",
			"Slovakia": "164750",
			"Turkmenistan": "1529",
			"Bahrain": "1027",
			"Côte d'Ivoire": "45319",
			"Guyana": "25837",
			"Algeria": "57",
			"USA": "154031076",
			"Cambodia": "4636378",
			"Rep. of Moldova": "635835",
			"Zambia": "294",
			"Malta": "1489717",
			"Ecuador": "15994",
			"Grenada": "11720",
			"Dominican Rep.": "160786",
			"France": "22265949",
			"New Caledonia": "141",
			"Seychelles": "271500",
			"Br. Virgin Isds": "94",
			"Italy": "14959277",
			"Saint Lucia": "1249",
			"Uganda": "410",
			"Syria": "90070",
			"Belarus": "3133",
			"Ethiopia": "340788",
			"Congo": "9136",
			"Senegal": "526",
			"Bulgaria": "442557",
			"Sri Lanka": "243695",
			"Hungary": "244113",
			"Angola": "2536333",
			"Lao People's Dem. Rep.": "3422",
			"Myanmar": "113413",
			"Iran": "674568",
			"Uruguay": "35718",
			"Andorra": "155",
			"Cabo Verde": "55587",
			"Germany": "61948203",
			"Poland": "767843",
			"Thailand": "22619",
			"Argentina": "166028417",
			"Brazil": "480396479",
			"Dominica": "2872",
			"Saudi Arabia": "30",
			"Sudan": "6387",
			"Russian Federation": "24456",
			"Cayman Isds": "109",
			"United Arab Emirates": "280382",
			"Nicaragua": "19",
			"Malawi": "171975",
			"Switzerland": "1097",
			"El Salvador": "430283",
			"Latvia": "2860",
			"Japan": "271087368",
			"Romania": "4363957",
			"Croatia": "5682260",
			"China, Macao SAR": "127246",
			"Guatemala": "73052358",
			"Madagascar": "12039",
			"Bolivia (Plurinational State of)": "395061",
			"Nigeria": "3668",
			"Bahamas": "1463141",
			"San Marino": "2675",
			"Chad": "3063",
			"Viet Nam": "12420223",
			"Haiti": "801",
			"Oman": "58",
			"Sweden": "5488",
			"India": "29581711",
			"Jamaica": "74811",
			"Austria": "2376271",
			"Zimbabwe": "6487",
			"Vanuatu": "4831",
			"Fiji": "11818",
			"Lithuania": "17917",
			"Namibia": "100",
			"Denmark": "414789",
			"Peru": "2846529",
			"Central African Rep.": "1013",
			"Netherlands": "112705100",
			"Costa Rica": "7295",
			"Equatorial Guinea": "13882377",
			"Greece": "1049427",
			"Slovenia": "21678",
			"Afghanistan": "9220",
			"Egypt": "150",
			"Nauru": "241",
			"Anguilla": "1020",
			"Estonia": "539",
			"Morocco": "6750280",
			"Luxembourg": "3330641",
			"Venezuela": "6006",
			"United Rep. of Tanzania": "479157",
			"Finland": "708527",
			"Georgia": "285752",
			"Ukraine": "5596",
			"Bermuda": "5888",
			"Djibouti": "101",
			"China, Hong Kong SAR": "11273",
			"Suriname": "530",
			"Barbados": "112",
			"Samoa": "206251",
			"TFYR of Macedonia": "15389",
			"Kuwait": "267909",
			"New Zealand": "351819",
			"Norway": "20468432",
			"Sierra Leone": "38000",
			"Marshall Isds": "115",
			"Philippines": "638",
			"Libya": "5866",
			"Kyrgyzstan": "3",
			"Czechia": "21005",
			"Mozambique": "745",
			"Aruba": "105923",
			"Turkey": "33248",
			"Tunisia": "395395",
			"Rep. of Korea": "225470808",
			"Burundi": "8379",
			"Canada": "5496846",
			"Iceland": "216435"
		},
		"exports": {
			"Lebanon": "1695",
			"Ghana": "1931112",
			"Cuba": "99866",
			"Dem. People's Rep. of Korea": "6271600",
			"Cameroon": "381983",
			"South Africa": "1602620",
			"Indonesia": "7331331",
			"Colombia": "1768092",
			"Niger": "35682",
			"Tonga": "580349",
			"Jordan": "4945397",
			"Fr. South Antarctic Terr.": "254371",
			"Uzbekistan": "15280",
			"Iraq": "1464588",
			"Guam": "32030",
			"Bosnia Herzegovina": "65264",
			"Pakistan": "250156",
			"Belgium": "2937750",
			"Azerbaijan": "21646",
			"Australia": "1700526",
			"Germany": "177510986",
			"Singapore": "6108868",
			"Albania": "9173",
			"Benin": "2202147",
			"FS Micronesia": "83441",
			"Panama": "2367337",
			"Qatar": "3767742",
			"Saint Vincent and the Grenadines": "64145",
			"Curaçao": "3041302",
			"Armenia": "31190",
			"Mexico": "7809147",
			"Kenya": "106724",
			"Spain": "61295",
			"Br. Virgin Isds": "95358",
			"Botswana": "5234",
			"French Polynesia": "1022092",
			"Mauritania": "120442",
			"Honduras": "4762429",
			"United Kingdom": "8505",
			"Ireland": "17643",
			"China, Macao SAR": "30",
			"Malaysia": "35785",
			"Swaziland": "34241",
			"Portugal": "213735",
			"Nepal": "207824",
			"China": "4500",
			"Mali": "19119",
			"Trinidad and Tobago": "781147",
			"Israel": "3623434",
			"Burkina Faso": "127167",
			"Paraguay": "7123909",
			"Bangladesh": "573100",
			"Antigua and Barbuda": "895727",
			"Gabon": "378582",
			"Cyprus": "2226610",
			"Mauritius": "439356",
			"Slovakia": "749703",
			"Bahrain": "222181",
			"Côte d'Ivoire": "16550",
			"Guyana": "35752",
			"Algeria": "1649800",
			"USA": "1347932",
			"Saint Kitts and Nevis": "84161",
			"Rep. of Moldova": "813817",
			"Zambia": "6686",
			"Malta": "3273463",
			"Ecuador": "30022926",
			"Grenada": "287436",
			"Dominican Rep.": "126312",
			"France": "124066514",
			"New Caledonia": "12",
			"Seychelles": "152921",
			"Italy": "4036",
			"Saint Lucia": "49011",
			"Belarus": "1242832",
			"Ethiopia": "164259",
			"Slovenia": "1106049",
			"Congo": "120896",
			"Senegal": "30210",
			"Bulgaria": "1833638",
			"Sri Lanka": "8877048",
			"Hungary": "1451459",
			"Angola": "2477029",
			"New Zealand": "8889929",
			"N. Mariana Isds": "237931",
			"Lao People's Dem. Rep.": "1620",
			"Myanmar": "162607",
			"Iran": "86062",
			"Uruguay": "26508",
			"Switzerland": "2771",
			"Cabo Verde": "100000",
			"Togo": "90638",
			"Poland": "251600",
			"Thailand": "3395266",
			"Argentina": "3276135",
			"Brazil": "24619",
			"Dominica": "223561",
			"Mongolia": "208643",
			"Saudi Arabia": "999247",
			"Syria": "19100",
			"Russian Federation": "90553320",
			"Cayman Isds": "8604",
			"United Arab Emirates": "4332",
			"Nicaragua": "3575",
			"Andorra": "47109",
			"El Salvador": "16710814",
			"Cambodia": "1131839",
			"Latvia": "43759",
			"Japan": "62706",
			"Guinea": "28423",
			"Romania": "108750",
			"Croatia": "837117",
			"Liberia": "221540",
			"Guatemala": "744238",
			"Madagascar": "524",
			"Bolivia (Plurinational State of)": "206944426",
			"Barbados": "1416030",
			"Bahamas": "925508",
			"San Marino": "28873",
			"Viet Nam": "7859910",
			"Haiti": "2034751",
			"Oman": "60028703",
			"Sweden": "390",
			"Maldives": "277519",
			"India": "1033166",
			"Jamaica": "2465016",
			"Austria": "10835",
			"Vanuatu": "40085",
			"Fiji": "595802",
			"Lithuania": "108375",
			"Namibia": "45983475",
			"Denmark": "41620",
			"Peru": "46594364",
			"Central African Rep.": "974",
			"Netherlands": "478505",
			"Costa Rica": "261976",
			"Equatorial Guinea": "470518",
			"Sudan": "590409",
			"Papua New Guinea": "94982",
			"Kazakhstan": "3400",
			"Greece": "4188510",
			"Egypt": "49477",
			"Anguilla": "91953",
			"Estonia": "4663920",
			"Morocco": "3521644",
			"Luxembourg": "38042",
			"Venezuela": "32050",
			"Somalia": "81047",
			"United Rep. of Tanzania": "242847",
			"Finland": "28618062",
			"Belize": "654890",
			"Georgia": "1288565",
			"Ukraine": "687750",
			"Bermuda": "312137",
			"Djibouti": "27000",
			"China, Hong Kong SAR": "45438759",
			"Suriname": "3400",
			"Nigeria": "3885681",
			"Samoa": "207236",
			"TFYR of Macedonia": "857943",
			"Kuwait": "31130",
			"Norway": "4435",
			"Sierra Leone": "15435",
			"Marshall Isds": "51",
			"Philippines": "20271368",
			"Libya": "3007487",
			"Kyrgyzstan": "51870",
			"Czechia": "7150475",
			"Mozambique": "5227160",
			"Aruba": "30897",
			"Turkey": "14588",
			"Tunisia": "1319992",
			"Rep. of Korea": "30000",
			"Serbia": "37272",
			"Cook Isds": "11772",
			"Canada": "953721",
			"Iceland": "130764"
		}
	},
	"Sudan": {
		"imports": {},
		"exports": {}
	},
	"Gambia": {
		"imports": {},
		"exports": {}
	},
	"China, Macao SAR": {
		"imports": {},
		"exports": {}
	},
	"Dominica": {
		"imports": {},
		"exports": {}
	},
	"Malaysia": {
		"imports": {
			"Lebanon": "63693",
			"Ghana": "64",
			"Lesotho": "30335",
			"Qatar": "9845",
			"Dem. Rep. of the Congo": "54147668",
			"Dem. People's Rep. of Korea": "20614",
			"Cameroon": "1827497",
			"South Africa": "252921",
			"Indonesia": "133751901",
			"Colombia": "13219",
			"Niger": "226705",
			"Tonga": "461",
			"Jordan": "218650",
			"Uzbekistan": "195628",
			"Iraq": "87264",
			"Tuvalu": "2737",
			"Guam": "1463",
			"Bosnia Herzegovina": "13437",
			"Pakistan": "3242",
			"Belgium": "689929",
			"Azerbaijan": "169592",
			"Rwanda": "41145",
			"Armenia": "20789",
			"United Kingdom": "975792",
			"Singapore": "12046",
			"Albania": "5702",
			"Benin": "27036",
			"FS Micronesia": "8233",
			"Panama": "7322316",
			"Cuba": "58733",
			"American Samoa": "131545",
			"Curaçao": "15233",
			"Australia": "260741482",
			"Kiribati": "887844",
			"Bahrain": "77221554",
			"Jamaica": "193308",
			"Kenya": "4838065",
			"Spain": "1319902",
			"Tajikistan": "1893",
			"Ireland": "52449",
			"Botswana": "5811",
			"Norfolk Isds": "48480",
			"Mauritania": "65180",
			"Christmas Isds": "7889532",
			"Honduras": "248705",
			"Chile": "13078328",
			"China, Macao SAR": "257415",
			"Dominica": "1677",
			"Malaysia": "575441",
			"Swaziland": "10301",
			"Portugal": "5134",
			"Falkland Isds (Malvinas)": "107465",
			"Nepal": "36710",
			"China": "837342095",
			"Comoros": "168108",
			"Mali": "2295",
			"Trinidad and Tobago": "149096",
			"Burkina Faso": "97005",
			"Paraguay": "110091",
			"Bangladesh": "364779",
			"Antigua and Barbuda": "1326",
			"Gabon": "1543",
			"Cyprus": "620480",
			"Yemen": "187522",
			"Mauritius": "44397",
			"Slovakia": "7499",
			"Faeroe Isds": "36310",
			"Turkmenistan": "197064",
			"Syria": "122424",
			"Côte d'Ivoire": "112614640",
			"Guyana": "7911",
			"Algeria": "287405",
			"USA": "11661270",
			"Namibia": "256069",
			"Rep. of Moldova": "771718",
			"Zambia": "6337080",
			"Malta": "9268990",
			"Ecuador": "268259",
			"Grenada": "14839",
			"Dominican Rep.": "2424407",
			"France": "27912344",
			"New Caledonia": "2489",
			"Seychelles": "89959",
			"Br. Virgin Isds": "52514",
			"Italy": "496863",
			"State of Palestine": "223749",
			"Uganda": "61299",
			"Belarus": "3148",
			"Ethiopia": "472567",
			"Slovenia": "5947",
			"Congo": "26428483",
			"Senegal": "984676",
			"Bulgaria": "6354",
			"Montenegro": "2753",
			"Sri Lanka": "5647262",
			"Hungary": "3695",
			"Angola": "241579",
			"New Zealand": "33961",
			"N. Mariana Isds": "708",
			"Samoa": "160584",
			"Myanmar": "432027",
			"Papua New Guinea": "126761",
			"Lao People's Dem. Rep.": "4034",
			"Uruguay": "37822",
			"Andorra": "860",
			"Germany": "7255706",
			"Timor-Leste": "15603",
			"Poland": "6704",
			"Thailand": "39623198",
			"Argentina": "24800975",
			"Brazil": "57161559",
			"Brunei Darussalam": "2029",
			"Mongolia": "1531",
			"Saudi Arabia": "1052",
			"Greece": "89053",
			"Russian Federation": "4391",
			"Cayman Isds": "1241",
			"United Arab Emirates": "205945",
			"Nicaragua": "249430",
			"Malawi": "1684578",
			"Switzerland": "3972517",
			"El Salvador": "763662",
			"Latvia": "29836",
			"Japan": "46642969",
			"Guinea": "2670459",
			"Romania": "38812",
			"Croatia": "5488",
			"Liberia": "9089322",
			"Guatemala": "2038473",
			"Madagascar": "3902363",
			"Bolivia (Plurinational State of)": "160088",
			"Nigeria": "103673",
			"Bahamas": "6167574",
			"Tunisia": "14274056",
			"Viet Nam": "18677661",
			"Haiti": "8627",
			"Tokelau": "14860",
			"Oman": "26309754",
			"Sweden": "21671",
			"Maldives": "1182375",
			"India": "29782",
			"Mexico": "547331",
			"Austria": "139888",
			"Zimbabwe": "65333",
			"Vanuatu": "512895",
			"Fiji": "1556",
			"Lithuania": "314564",
			"Cambodia": "756478",
			"Denmark": "8377",
			"Peru": "315327",
			"Central African Rep.": "311197",
			"Netherlands": "1729512",
			"Costa Rica": "30128",
			"Equatorial Guinea": "4422",
			"Sudan": "11395",
			"Kazakhstan": "41598",
			"Afghanistan": "131309",
			"Egypt": "1733",
			"Anguilla": "25510",
			"Estonia": "164659",
			"Morocco": "7642943",
			"Luxembourg": "7359892",
			"Venezuela": "1205",
			"Heard Island and McDonald Islands": "356",
			"United Rep. of Tanzania": "1057512",
			"Finland": "78668",
			"Belize": "230110",
			"Georgia": "83296",
			"Ukraine": "637780",
			"Bermuda": "1660",
			"Djibouti": "124058",
			"Greenland": "97270",
			"China, Hong Kong SAR": "372563",
			"Suriname": "45553",
			"Barbados": "15595",
			"Iran": "14963486",
			"TFYR of Macedonia": "6424",
			"Kuwait": "56",
			"Norway": "6913",
			"Sierra Leone": "2239",
			"Marshall Isds": "1207573",
			"Philippines": "396132",
			"Libya": "13198",
			"Kyrgyzstan": "9096",
			"Czechia": "7296687",
			"Mozambique": "21965",
			"Togo": "1156626",
			"Aruba": "1474",
			"Turkey": "21810",
			"San Marino": "322",
			"Rep. of Korea": "4738317",
			"Serbia": "167038",
			"Bhutan": "3803",
			"Canada": "538563",
			"Iceland": "244"
		},
		"exports": {
			"Lebanon": "6656",
			"Gibraltar": "1741",
			"Ghana": "31942",
			"Lesotho": "581835",
			"Cuba": "735356",
			"Dem. Rep. of the Congo": "487537",
			"Dem. People's Rep. of Korea": "10983",
			"Samoa": "41758",
			"Cameroon": "79492",
			"Papua New Guinea": "260953",
			"Indonesia": "15735301",
			"Colombia": "22171",
			"Niger": "19184",
			"Palau": "14430",
			"Tonga": "12432",
			"Jordan": "1646",
			"Fr. South Antarctic Terr.": "1205",
			"Uzbekistan": "441983",
			"Iraq": "39640",
			"Tuvalu": "2076",
			"Guam": "12061",
			"Bosnia Herzegovina": "59475",
			"Pakistan": "37401",
			"Belgium": "271762",
			"Azerbaijan": "145591",
			"Armenia": "1564",
			"Togo": "38902",
			"Singapore": "2639839",
			"Albania": "540168",
			"Benin": "265761145",
			"South Africa": "76020",
			"FS Micronesia": "257129",
			"Panama": "4223",
			"Qatar": "53990",
			"American Samoa": "143508",
			"Saint Vincent and the Grenadines": "525929",
			"Curaçao": "91771",
			"Australia": "59841",
			"Kiribati": "44950",
			"Jamaica": "591353",
			"Br. Virgin Isds": "1155704",
			"Spain": "81933",
			"Tajikistan": "316857",
			"Ireland": "154249",
			"Botswana": "101589",
			"South Sudan": "4247",
			"French Polynesia": "365016",
			"Mauritania": "360100",
			"Christmas Isds": "21388",
			"Honduras": "1135069",
			"Holy See (Vatican City State)": "55929",
			"United Kingdom": "292152",
			"Chile": "153414",
			"Sudan": "14856",
			"Gambia": "372435",
			"China, Macao SAR": "178470",
			"Antarctica": "1265",
			"Dominica": "78177",
			"Swaziland": "79578",
			"Portugal": "912116",
			"Nepal": "1585776",
			"China": "68345990",
			"Comoros": "1986700",
			"Guinea-Bissau": "27698",
			"Mali": "116728",
			"Trinidad and Tobago": "1441",
			"Burkina Faso": "1114577",
			"Paraguay": "4606661",
			"Norfolk Isds": "57882",
			"Bangladesh": "1536479",
			"Antigua and Barbuda": "10312",
			"Gabon": "795430",
			"Cyprus": "163122",
			"Yemen": "32472801",
			"Mauritius": "6582",
			"Slovakia": "43104",
			"Turkmenistan": "2385",
			"Bahrain": "23174",
			"Côte d'Ivoire": "19538",
			"Guyana": "61302",
			"Algeria": "25779324",
			"USA": "353858",
			"Saint Kitts and Nevis": "1387",
			"Rep. of Moldova": "155468",
			"Zambia": "2374",
			"Malta": "2525",
			"Ecuador": "2851",
			"Grenada": "183712",
			"Dominican Rep.": "22367",
			"France": "19513",
			"New Caledonia": "2167389",
			"Seychelles": "5751",
			"Italy": "3020161",
			"Saint Lucia": "122119",
			"State of Palestine": "101547",
			"Rwanda": "144544",
			"Syria": "1040626",
			"Belarus": "78646",
			"Ethiopia": "1365875",
			"Namibia": "31752",
			"Congo": "319706",
			"Senegal": "6044946",
			"Bulgaria": "133143",
			"Montenegro": "126353",
			"Sri Lanka": "8201663",
			"Hungary": "29802",
			"Netherlands": "456520",
			"New Zealand": "102375",
			"N. Mariana Isds": "13014",
			"Lao People's Dem. Rep.": "1687",
			"Myanmar": "1800183",
			"Iran": "10671",
			"Philippines": "8923597",
			"Uruguay": "1359192",
			"Andorra": "17873",
			"Cabo Verde": "791072",
			"Germany": "29268",
			"Timor-Leste": "18075",
			"Poland": "1018688",
			"Thailand": "3011228",
			"Argentina": "72998",
			"Brazil": "625348",
			"Brunei Darussalam": "790394",
			"Mongolia": "3332394",
			"Saudi Arabia": "22920",
			"Greece": "156625",
			"Russian Federation": "4362",
			"Cayman Isds": "6135",
			"United Arab Emirates": "18972",
			"Nicaragua": "39470",
			"Malawi": "558470",
			"Switzerland": "2970",
			"El Salvador": "2454041",
			"United States Minor Outlying Islands": "93631",
			"Latvia": "1214112",
			"Japan": "4748830821",
			"Guinea": "1897218",
			"Uganda": "166198",
			"Romania": "6398749",
			"Croatia": "5354",
			"Liberia": "521",
			"Guatemala": "10447",
			"Madagascar": "12156",
			"Bolivia (Plurinational State of)": "135109",
			"Nigeria": "15213801",
			"Bahamas": "49168",
			"Tunisia": "1066",
			"Chad": "74820",
			"Viet Nam": "153194",
			"Haiti": "406611",
			"Oman": "1435",
			"Sweden": "178476",
			"Maldives": "741449",
			"India": "111104",
			"Mexico": "29979",
			"Austria": "9036",
			"Eritrea": "50503",
			"Zimbabwe": "332230",
			"Saint Maarten": "20502",
			"Fiji": "4844",
			"Lithuania": "23634",
			"Cambodia": "34658807",
			"Denmark": "38031022",
			"Peru": "1250",
			"Central African Rep.": "1647991",
			"Slovenia": "1115353",
			"Costa Rica": "2777237",
			"Equatorial Guinea": "7263",
			"South Georgia and the South Sandwich Islands": "38045",
			"Kazakhstan": "4998",
			"Kenya": "6069",
			"Afghanistan": "347422",
			"Egypt": "192636518",
			"Nauru": "324810",
			"Anguilla": "4341",
			"Estonia": "56235",
			"Morocco": "22184",
			"Luxembourg": "52280",
			"TFYR of Macedonia": "1923",
			"Somalia": "4153021",
			"Angola": "798050",
			"United Rep. of Tanzania": "948895",
			"Finland": "8500303",
			"Belize": "238193",
			"Georgia": "14593",
			"Ukraine": "4311486",
			"Bermuda": "35239",
			"Djibouti": "10776849",
			"China, Hong Kong SAR": "310837",
			"Suriname": "4820",
			"Barbados": "164868",
			"Vanuatu": "445973",
			"Venezuela": "20283",
			"Kuwait": "266758",
			"Norway": "2651",
			"Sierra Leone": "29236",
			"Marshall Isds": "159286",
			"Sao Tome and Principe": "39491",
			"Libya": "19502",
			"Kyrgyzstan": "1336",
			"Czechia": "14649",
			"Br. Indian Ocean Terr.": "651",
			"Mozambique": "25607",
			"Aruba": "26215",
			"Turkey": "892505",
			"Rep. of Korea": "1384656634",
			"Serbia": "65596",
			"Burundi": "75801",
			"Bhutan": "129936",
			"Cook Isds": "3344",
			"Canada": "1501742",
			"Iceland": "349993"
		}
	},
	"Fiji": {
		"imports": {},
		"exports": {}
	},
	"Somalia": {
		"imports": {},
		"exports": {}
	},
	"Falkland Isds (Malvinas)": {
		"imports": {},
		"exports": {}
	},
	"Nepal": {
		"imports": {},
		"exports": {}
	},
	"China": {
		"imports": {
			"Lebanon": "212230",
			"Gibraltar": "160",
			"Ghana": "24956",
			"Lesotho": "367",
			"Cuba": "3857971",
			"Dem. Rep. of the Congo": "4259",
			"Dem. People's Rep. of Korea": "4271794",
			"Cameroon": "133646947",
			"Papua New Guinea": "11056278",
			"Montserrat": "1549",
			"Panama": "8909",
			"Colombia": "246058",
			"Niger": "124761998",
			"Palau": "65",
			"Tonga": "24088",
			"Angola": "13774200618",
			"Uzbekistan": "412380",
			"Iraq": "2141",
			"Tuvalu": "25525",
			"Bosnia Herzegovina": "360",
			"Pakistan": "4364",
			"Belgium": "944628",
			"Azerbaijan": "375326687",
			"Armenia": "3082",
			"Togo": "9388",
			"Singapore": "123233",
			"Albania": "8171651",
			"Benin": "128",
			"South Africa": "80709",
			"FS Micronesia": "6883720",
			"Indonesia": "1194558",
			"Qatar": "2861801370",
			"Saint Vincent and the Grenadines": "62266",
			"Curaçao": "10715",
			"Australia": "6704367184",
			"Kiribati": "9491914",
			"Mexico": "18990976",
			"Br. Virgin Isds": "2967",
			"Spain": "1325821",
			"Tajikistan": "60962",
			"Ireland": "159223",
			"Botswana": "539",
			"South Sudan": "1455877868",
			"French Polynesia": "2678577",
			"Mauritania": "1619039",
			"Honduras": "2822218",
			"Holy See (Vatican City State)": "20876",
			"United Kingdom": "2868457",
			"Chile": "2218819",
			"Gambia": "268179",
			"Liberia": "562",
			"Dominica": "66308",
			"Malaysia": "20143",
			"Fiji": "6947639",
			"Portugal": "754713",
			"Nepal": "25836",
			"Comoros": "12601",
			"Guinea-Bissau": "1106",
			"Mali": "85530909",
			"Trinidad and Tobago": "20818",
			"Israel": "872686",
			"Burkina Faso": "129909",
			"Paraguay": "5263",
			"Bangladesh": "262",
			"Antigua and Barbuda": "54",
			"Gabon": "59784",
			"Cyprus": "9559233",
			"Yemen": "423666",
			"Mauritius": "4718740",
			"Slovakia": "52764",
			"Faeroe Isds": "11546967",
			"Turkmenistan": "78312",
			"Bahrain": "6029725",
			"Côte d'Ivoire": "310776",
			"Guyana": "1681098",
			"Algeria": "143476468",
			"USA": "102794593",
			"Saint Kitts and Nevis": "387",
			"Rep. of Moldova": "8456178",
			"Zambia": "45280",
			"Malta": "141020",
			"Ecuador": "3593684",
			"Grenada": "3350",
			"Dominican Rep.": "27680",
			"France": "188356955",
			"New Caledonia": "122",
			"Seychelles": "10244",
			"Italy": "35371590",
			"Saint Lucia": "34",
			"State of Palestine": "30",
			"Rwanda": "144",
			"Syria": "31715",
			"Belarus": "1943789",
			"Ethiopia": "135370",
			"Namibia": "3232",
			"Congo": "1045",
			"Slovenia": "1781644",
			"Bulgaria": "4473",
			"Montenegro": "1149075",
			"Sri Lanka": "15205215",
			"Hungary": "228615",
			"Jordan": "20000",
			"Lao People's Dem. Rep.": "11063603",
			"Myanmar": "1327253880",
			"Iran": "6067186",
			"Philippines": "175245",
			"Uruguay": "3725",
			"Switzerland": "16143174",
			"Cabo Verde": "126",
			"Germany": "321716356",
			"Timor-Leste": "441",
			"Poland": "2514564",
			"Thailand": "52243744",
			"Argentina": "483938139",
			"Brazil": "5992429744",
			"Brunei Darussalam": "132269304",
			"Mongolia": "2542896",
			"Saudi Arabia": "1122",
			"Sudan": "7476765",
			"Russian Federation": "975461",
			"Cayman Isds": "917",
			"United Arab Emirates": "2925",
			"Nicaragua": "46682",
			"Malawi": "840",
			"Andorra": "35237",
			"El Salvador": "2829",
			"Latvia": "1707055",
			"Japan": "71260979",
			"Guinea": "46251",
			"Uganda": "374738",
			"Romania": "293",
			"Croatia": "3641590",
			"China, Macao SAR": "1618258",
			"Mozambique": "37727967",
			"Madagascar": "250341",
			"Bolivia (Plurinational State of)": "753",
			"Barbados": "489946",
			"Bahamas": "32074341",
			"San Marino": "49391",
			"Chad": "2440",
			"Viet Nam": "2671057",
			"Haiti": "396",
			"Oman": "2062517",
			"Sweden": "96440",
			"Maldives": "468",
			"India": "2987086",
			"Jamaica": "588820",
			"Austria": "7497967",
			"Eritrea": "663",
			"Zimbabwe": "4333017",
			"Vanuatu": "2085834",
			"Senegal": "5324120",
			"Swaziland": "42",
			"Lithuania": "2801",
			"Cambodia": "1959302",
			"Denmark": "932553119",
			"Peru": "50257881",
			"Central African Rep.": "17226",
			"Netherlands": "3362903",
			"Costa Rica": "1744923",
			"Equatorial Guinea": "86",
			"Greece": "112390",
			"Kazakhstan": "4491506",
			"Kenya": "849315",
			"Afghanistan": "1214",
			"Egypt": "1914",
			"Nauru": "1330",
			"Estonia": "3505895",
			"Morocco": "8516524",
			"Luxembourg": "916561",
			"TFYR of Macedonia": "1764029",
			"Somalia": "5758767",
			"United Rep. of Tanzania": "3363",
			"Finland": "260865",
			"Belize": "57355",
			"Georgia": "12524893",
			"Ukraine": "455170",
			"Bermuda": "300",
			"Djibouti": "2541",
			"Greenland": "58777939",
			"China, Hong Kong SAR": "127720465",
			"Suriname": "317613",
			"Nigeria": "13581",
			"Samoa": "777458",
			"Venezuela": "5264",
			"Kuwait": "1364",
			"New Zealand": "8448015",
			"Norway": "426099",
			"Sierra Leone": "211",
			"Marshall Isds": "19796481",
			"Sao Tome and Principe": "14889",
			"Libya": "304379",
			"Kyrgyzstan": "363732",
			"Czechia": "5737601",
			"Guatemala": "9395084",
			"Aruba": "3395",
			"Turkey": "810996",
			"Tunisia": "105723",
			"Rep. of Korea": "919709",
			"Serbia": "584358",
			"Burundi": "1089533",
			"Bhutan": "650",
			"Cook Isds": "9309",
			"Canada": "529871933",
			"Iceland": "71262882"
		},
		"exports": {
			"Lebanon": "36173095",
			"Bonaire": "4717",
			"Gibraltar": "10300",
			"Ghana": "991697",
			"Lesotho": "16407",
			"Cuba": "87327671",
			"Dem. Rep. of the Congo": "90820312",
			"Dem. People's Rep. of Korea": "32609101",
			"Cameroon": "37851379",
			"Papua New Guinea": "3633120",
			"Montserrat": "780",
			"Indonesia": "227332620",
			"Colombia": "1674676461",
			"Niger": "535032",
			"Palau": "4685783",
			"Tonga": "239759",
			"Angola": "5654078",
			"Uzbekistan": "2853823",
			"Iraq": "70959209",
			"Tuvalu": "188091",
			"Bosnia Herzegovina": "543244",
			"Pakistan": "44833006",
			"Belgium": "133740",
			"Azerbaijan": "2122649",
			"Armenia": "740694",
			"Togo": "227363739",
			"Singapore": "50797382",
			"Albania": "3267745",
			"Benin": "120232034",
			"South Africa": "36289298",
			"FS Micronesia": "93894",
			"Panama": "33434883",
			"Qatar": "3322223",
			"Saint Vincent and the Grenadines": "21566",
			"Curaçao": "85798",
			"Australia": "34397867",
			"Kiribati": "4170488",
			"Mexico": "380020394",
			"Br. Virgin Isds": "322261",
			"Spain": "115663135",
			"Tajikistan": "3211078",
			"Ireland": "2809276",
			"Botswana": "601887",
			"South Sudan": "353673",
			"French Polynesia": "4696810",
			"Mauritania": "3847740",
			"Honduras": "21263",
			"Holy See (Vatican City State)": "10",
			"United Kingdom": "181806804",
			"Chile": "2030803216",
			"Gambia": "81165",
			"China, Macao SAR": "2506628",
			"Dominica": "223156",
			"Malaysia": "103898385",
			"Fiji": "37881",
			"Portugal": "8183706",
			"Nepal": "4955963",
			"Comoros": "6979139",
			"Guinea-Bissau": "511419",
			"Djibouti": "60590",
			"Trinidad and Tobago": "997789",
			"Israel": "56336903",
			"Burkina Faso": "22967012",
			"Paraguay": "73067340",
			"Bangladesh": "55104",
			"Antigua and Barbuda": "128162",
			"Gabon": "77311",
			"Cyprus": "5503824",
			"Yemen": "20791247",
			"Mauritius": "7425004",
			"Slovakia": "1350305",
			"Faeroe Isds": "337400",
			"Turkmenistan": "6242324",
			"Bahrain": "4844118",
			"Côte d'Ivoire": "32958695",
			"Guyana": "630",
			"Saint Pierre and Miquelon": "40",
			"Algeria": "52389473",
			"USA": "2160753608",
			"Saint Kitts and Nevis": "13418",
			"Rep. of Moldova": "349568",
			"Zambia": "3157176",
			"Malta": "3308242",
			"Ecuador": "10734920",
			"Grenada": "210186",
			"Dominican Rep.": "37413155",
			"France": "306839",
			"New Caledonia": "1268058",
			"Seychelles": "202828",
			"Oceania, nes": "909",
			"Italy": "143926572",
			"Saint Lucia": "382977",
			"State of Palestine": "12149",
			"Rwanda": "617776",
			"Syria": "7214866",
			"Belarus": "2940067",
			"Ethiopia": "1973543",
			"Namibia": "354170",
			"Congo": "112240622",
			"Senegal": "31200932",
			"Bulgaria": "5466049",
			"Montenegro": "317134",
			"Sri Lanka": "695939212",
			"Hungary": "10083109",
			"Jordan": "8001588",
			"Lao People's Dem. Rep.": "9165732",
			"Myanmar": "468394",
			"Iran": "125763249",
			"Philippines": "493445633",
			"Uruguay": "30564647",
			"Switzerland": "48773683",
			"Cabo Verde": "375338",
			"Germany": "15245016",
			"Timor-Leste": "1033486",
			"Poland": "50872839",
			"Thailand": "136339466",
			"Argentina": "3427",
			"Brazil": "27375207",
			"Brunei Darussalam": "697229",
			"Mongolia": "11489190",
			"Saudi Arabia": "127253076",
			"Sudan": "44958251",
			"Russian Federation": "183462747",
			"Cayman Isds": "15086",
			"United Arab Emirates": "204228056",
			"Nicaragua": "25732981",
			"Malawi": "1602290",
			"Andorra": "264982",
			"El Salvador": "5025392",
			"Latvia": "6275224",
			"Japan": "736182496",
			"Guinea": "237047",
			"Uganda": "3106769",
			"Romania": "7858019",
			"Croatia": "65683641",
			"Liberia": "1728033",
			"Guatemala": "83201",
			"Madagascar": "10828705",
			"Bolivia (Plurinational State of)": "24755841",
			"Barbados": "256051",
			"Bahamas": "373114",
			"San Marino": "1400",
			"Chad": "10847477",
			"Viet Nam": "158460651",
			"Haiti": "2450",
			"Slovenia": "13589288",
			"Oman": "10822634",
			"Sweden": "80446901",
			"Maldives": "2846633",
			"India": "79305420",
			"Jamaica": "3735592",
			"Austria": "12296638",
			"Eritrea": "16452",
			"Zimbabwe": "4877353",
			"Vanuatu": "418790",
			"Swaziland": "82250",
			"Lithuania": "4394269",
			"Cambodia": "11690689",
			"Denmark": "74554839",
			"Peru": "165353767",
			"Central African Rep.": "36825",
			"Netherlands": "306745507",
			"Costa Rica": "65281358",
			"Equatorial Guinea": "2342339",
			"Greece": "864003",
			"Kazakhstan": "37004287",
			"Kenya": "45185328",
			"Afghanistan": "56843054",
			"Egypt": "107714255",
			"Nauru": "117452",
			"Estonia": "5561335",
			"Morocco": "55570226",
			"Luxembourg": "2450844",
			"TFYR of Macedonia": "1210731",
			"Somalia": "3324774",
			"Western Sahara": "31047",
			"United Rep. of Tanzania": "68700475",
			"Finland": "120981",
			"Belize": "2419098",
			"Georgia": "97565",
			"Ukraine": "33911778",
			"Bermuda": "644095",
			"Mali": "57071814",
			"Greenland": "9566",
			"China, Hong Kong SAR": "941850155",
			"Suriname": "1073373",
			"Nigeria": "96190621",
			"Samoa": "239045",
			"Venezuela": "40989538",
			"Kuwait": "7298690",
			"New Zealand": "39611061",
			"Norway": "54233140",
			"Sierra Leone": "688339",
			"Marshall Isds": "91062",
			"Sao Tome and Principe": "725165",
			"Libya": "4580461",
			"Kyrgyzstan": "5866117",
			"Czechia": "25940540",
			"Mozambique": "7950368",
			"Aruba": "423851",
			"Turkey": "143019791",
			"Tunisia": "16523463",
			"Rep. of Korea": "232986461",
			"Serbia": "3237659",
			"Burundi": "292850",
			"Bhutan": "5081",
			"Cook Isds": "51461",
			"Canada": "57541",
			"Iceland": "1959339"
		}
	},
	"Comoros": {
		"imports": {},
		"exports": {}
	},
	"Guinea-Bissau": {
		"imports": {},
		"exports": {}
	},
	"Saint Maarten": {
		"imports": {},
		"exports": {}
	},
	"Mali": {
		"imports": {},
		"exports": {}
	},
	"Trinidad and Tobago": {
		"imports": {},
		"exports": {}
	},
	"Israel": {
		"imports": {
			"Slovakia": "498000",
			"Gibraltar": "74000",
			"Ghana": "275000",
			"Niger": "5000",
			"Uruguay": "1000",
			"Andorra": "11000",
			"Cabo Verde": "4000",
			"Peru": "2020000",
			"Germany": "298343000",
			"Poland": "43834000",
			"Cuba": "106000",
			"Bolivia (Plurinational State of)": "3206000",
			"Thailand": "69609000",
			"Equatorial Guinea": "1000",
			"Argentina": "12222000",
			"Brazil": "50646000",
			"Cameroon": "43000",
			"Brunei Darussalam": "14000",
			"South Africa": "280000",
			"Mongolia": "1000",
			"Panama": "2286000",
			"Colombia": "8000",
			"Russian Federation": "33643000",
			"Nicaragua": "301000",
			"Tajikistan": "672000",
			"Jordan": "2000",
			"Malawi": "879000",
			"Switzerland": "4618000",
			"El Salvador": "83000",
			"Lesotho": "12000",
			"Togo": "7000",
			"Denmark": "150000",
			"Latvia": "7249000",
			"Japan": "110325000",
			"Guam": "1000",
			"Tunisia": "883000",
			"Guatemala": "1743000",
			"Guinea": "5000",
			"Uganda": "3089000",
			"Romania": "3819000",
			"Pakistan": "138000",
			"Belgium": "165708000",
			"Azerbaijan": "3000",
			"Armenia": "2000",
			"United Kingdom": "15185000",
			"Singapore": "826000",
			"Barbados": "20000",
			"Albania": "154000",
			"Benin": "1000",
			"Maldives": "2000",
			"Bahamas": "1000",
			"San Marino": "2000",
			"Mozambique": "124000",
			"Viet Nam": "47129000",
			"Haiti": "22000",
			"Mali": "3000",
			"Indonesia": "2788000",
			"Saint Vincent and the Grenadines": "4000",
			"Djibouti": "1000",
			"Sweden": "39599000",
			"Australia": "3000",
			"India": "1060000",
			"Jamaica": "43000",
			"Mexico": "8989000",
			"Kenya": "6772000",
			"Spain": "100134000",
			"Bosnia Herzegovina": "209000",
			"Ireland": "68000",
			"Botswana": "14000",
			"Zimbabwe": "188000",
			"China, Hong Kong SAR": "1553000",
			"Austria": "11588000",
			"Mauritania": "21000",
			"Swaziland": "1000",
			"Lithuania": "9476000",
			"Cambodia": "3183000",
			"Eritrea": "1000",
			"Curaçao": "134000",
			"Honduras": "106000",
			"Slovenia": "2211000",
			"Costa Rica": "1570000",
			"Papua New Guinea": "175000",
			"Turkey": "33532000",
			"Samoa": "43000",
			"Greece": "1420000",
			"Chile": "3542000",
			"Kazakhstan": "411000",
			"Gambia": "1039000",
			"China, Macao SAR": "970000",
			"Afghanistan": "1000",
			"Croatia": "34000",
			"Dominica": "34000",
			"Malaysia": "1056000",
			"Fiji": "2000",
			"Portugal": "3232000",
			"United Rep. of Tanzania": "8544000",
			"Nepal": "8000",
			"China": "137484000",
			"Egypt": "7598000",
			"Nauru": "1000",
			"Anguilla": "46000",
			"Estonia": "21000",
			"Morocco": "1000",
			"Luxembourg": "1000",
			"Trinidad and Tobago": "14000",
			"Venezuela": "50000",
			"Burkina Faso": "1000",
			"Paraguay": "99063000",
			"French Polynesia": "1000",
			"Bangladesh": "34931000",
			"Nigeria": "9000",
			"Gabon": "1000",
			"Finland": "453000",
			"Cyprus": "1338000",
			"Belize": "40000",
			"Georgia": "814000",
			"Ukraine": "24033000",
			"Antarctica": "24000",
			"Faeroe Isds": "1000",
			"Turkmenistan": "3285000",
			"Uzbekistan": "36000",
			"Côte d'Ivoire": "1000",
			"Burundi": "1000",
			"Guyana": "17000",
			"Angola": "2000",
			"Algeria": "1346000",
			"USA": "445468000",
			"Namibia": "125000",
			"Rep. of Moldova": "1536000",
			"TFYR of Macedonia": "2251000",
			"Zambia": "93000",
			"Suriname": "1000",
			"Malta": "9000",
			"Norway": "45000",
			"Ecuador": "766000",
			"Serbia": "701000",
			"State of Palestine": "1000",
			"Sierra Leone": "1000",
			"Dominican Rep.": "2567000",
			"France": "108800000",
			"Philippines": "15645000",
			"Niue": "10000",
			"Seychelles": "71000",
			"Br. Virgin Isds": "76000",
			"Italy": "84538000",
			"Kyrgyzstan": "148000",
			"Czechia": "1457000",
			"Rwanda": "3000",
			"Br. Indian Ocean Terr.": "11000",
			"Belarus": "212000",
			"Ethiopia": "352000",
			"Mauritius": "345000",
			"Congo": "5000",
			"Senegal": "16000",
			"Aruba": "24000",
			"Bulgaria": "516000",
			"Montenegro": "187000",
			"Sri Lanka": "6932000",
			"Rep. of Korea": "34000",
			"Hungary": "17000",
			"Dem. Rep. of the Congo": "15000",
			"Netherlands": "158632000",
			"Bhutan": "1000",
			"New Zealand": "2000",
			"Canada": "448000",
			"Iceland": "674000",
			"Lao People's Dem. Rep.": "148000",
			"Madagascar": "7000",
			"Myanmar": "52000"
		},
		"exports": {
			"Gibraltar": "24000",
			"Ghana": "154000",
			"Uruguay": "255000",
			"Germany": "908000",
			"Poland": "9951000",
			"Cuba": "19000",
			"Dem. Rep. of the Congo": "1000",
			"Thailand": "17294000",
			"Equatorial Guinea": "41000",
			"Argentina": "660000",
			"Brazil": "1725000",
			"Azerbaijan": "31637000",
			"Cameroon": "103000",
			"Dominica": "9000",
			"Papua New Guinea": "101000",
			"Saudi Arabia": "49000",
			"Panama": "713000",
			"Colombia": "8892000",
			"Russian Federation": "20000",
			"United Arab Emirates": "2000",
			"Nicaragua": "1122000",
			"Portugal": "733000",
			"Jordan": "10547000",
			"Switzerland": "1643000",
			"El Salvador": "191000",
			"Slovakia": "288000",
			"Latvia": "1000",
			"Japan": "95000",
			"Guinea": "20000",
			"Uganda": "12000",
			"Romania": "9000",
			"Pakistan": "3000",
			"Belgium": "27000",
			"Ireland": "9000",
			"Croatia": "9101000",
			"Belarus": "175000",
			"United Kingdom": "275000",
			"Bolivia (Plurinational State of)": "138000",
			"Barbados": "17000",
			"Albania": "2000",
			"Benin": "432000",
			"Bahamas": "14000",
			"Chad": "32000",
			"Viet Nam": "2226000",
			"Haiti": "71000",
			"South Africa": "76000",
			"Indonesia": "211000",
			"Qatar": "18000",
			"Sweden": "17000",
			"Australia": "5000",
			"India": "39000",
			"Jamaica": "4000",
			"Mexico": "4401000",
			"Br. Virgin Isds": "22000",
			"Austria": "88000",
			"Bosnia Herzegovina": "2000",
			"Kenya": "7000",
			"Botswana": "30000",
			"Zimbabwe": "64000",
			"China, Hong Kong SAR": "148000",
			"Spain": "3647000",
			"Lithuania": "745000",
			"Namibia": "20000",
			"Denmark": "852000",
			"USA": "1694000",
			"Curaçao": "4000",
			"Central African Rep.": "5000",
			"Honduras": "89000",
			"Slovenia": "243000",
			"Eritrea": "10000",
			"Costa Rica": "1000",
			"Turkey": "321000",
			"Greece": "83000",
			"Chile": "17254000",
			"Kazakhstan": "15171000",
			"Liberia": "2000",
			"Nepal": "25000",
			"Malaysia": "173000",
			"Fiji": "53000",
			"Peru": "8000",
			"United Rep. of Tanzania": "112000",
			"Armenia": "36000",
			"China": "257000",
			"Egypt": "701000",
			"Anguilla": "1000",
			"Estonia": "1649000",
			"Morocco": "1349000",
			"Luxembourg": "13000",
			"Trinidad and Tobago": "64000",
			"TFYR of Macedonia": "3000",
			"Singapore": "213000",
			"Paraguay": "199000",
			"Bangladesh": "20000",
			"Gabon": "15000",
			"Finland": "6910000",
			"Cyprus": "126000",
			"Georgia": "95000",
			"Ukraine": "4076000",
			"Madagascar": "915000",
			"Turkmenistan": "135000",
			"Uzbekistan": "1664000",
			"Côte d'Ivoire": "282000",
			"Angola": "115000",
			"Nigeria": "41000",
			"Rep. of Moldova": "125000",
			"Venezuela": "25000",
			"Zambia": "11000",
			"Malta": "1229000",
			"Norway": "1559000",
			"Ecuador": "2122000",
			"Serbia": "4000",
			"Dominican Rep.": "969000",
			"France": "310000",
			"Philippines": "3231000",
			"Seychelles": "5000",
			"Italy": "217000",
			"Czechia": "1477000",
			"Rwanda": "10000",
			"Guatemala": "2308000",
			"Ethiopia": "55000",
			"Mauritius": "4000",
			"Congo": "12000",
			"Senegal": "1000",
			"Bulgaria": "218000",
			"Sri Lanka": "13000",
			"Rep. of Korea": "8623000",
			"Hungary": "1303000",
			"Netherlands": "186000",
			"New Zealand": "1409000",
			"Canada": "7300000",
			"Iceland": "168000",
			"Lao People's Dem. Rep.": "350000",
			"Myanmar": "1419000"
		}
	},
	"Burkina Faso": {
		"imports": {},
		"exports": {}
	},
	"Kazakhstan": {
		"imports": {
			"Lebanon": "63434",
			"TFYR of Macedonia": "6830",
			"Gibraltar": "8414",
			"Ghana": "26997",
			"Niger": "2439",
			"Lesotho": "1784",
			"Switzerland": "17795122",
			"Germany": "496130668",
			"Poland": "33078767",
			"Cuba": "63844",
			"Dem. Rep. of the Congo": "10767488",
			"Thailand": "1324466",
			"Dem. People's Rep. of Korea": "5097",
			"Argentina": "919438",
			"Brazil": "75181",
			"Cameroon": "46",
			"Dominica": "3858",
			"Iran": "16259817",
			"Mongolia": "18314",
			"Saudi Arabia": "12309",
			"Panama": "4031",
			"Colombia": "22113",
			"Syria": "692",
			"Russian Federation": "80555043",
			"United Arab Emirates": "384426",
			"Nicaragua": "2169",
			"Tajikistan": "186026",
			"Angola": "160945",
			"Malawi": "1392088",
			"Andorra": "1951",
			"El Salvador": "1730",
			"Iraq": "1858",
			"Uruguay": "160321",
			"Slovakia": "9102",
			"Latvia": "334052",
			"Japan": "1048836",
			"Tunisia": "77931",
			"Guinea": "38",
			"Uganda": "500",
			"Bosnia Herzegovina": "56164",
			"Pakistan": "11761057",
			"Belgium": "3607079",
			"Croatia": "2512",
			"China, Macao SAR": "18",
			"Belarus": "23009058",
			"Madagascar": "12093",
			"Bolivia (Plurinational State of)": "16133",
			"Barbados": "273",
			"Albania": "18274",
			"Benin": "98",
			"Bahamas": "45",
			"San Marino": "166804",
			"Mozambique": "120753",
			"Viet Nam": "5868532",
			"Haiti": "2276",
			"South Africa": "865227",
			"Marshall Isds": "277",
			"Indonesia": "4929853",
			"Qatar": "112",
			"American Samoa": "68630",
			"Oman": "40",
			"Sweden": "5516798",
			"Australia": "1419147",
			"India": "40286697",
			"Mexico": "290584",
			"Jamaica": "12219",
			"Br. Virgin Isds": "112",
			"Austria": "113680",
			"Bouvet Island": "3789",
			"Ireland": "78792975",
			"Zimbabwe": "41288",
			"Côte d'Ivoire": "15634",
			"Spain": "8957133",
			"Suriname": "69",
			"Lithuania": "35201",
			"Cambodia": "363905",
			"Denmark": "12165",
			"Peru": "324907",
			"Central African Rep.": "87",
			"Honduras": "317",
			"Zambia": "1951",
			"Netherlands": "3836492",
			"United Kingdom": "64712",
			"Costa Rica": "331641",
			"Venezuela": "14",
			"Turkey": "49703",
			"Greece": "3333319",
			"Chile": "4550",
			"Azerbaijan": "5443200",
			"Kenya": "2877",
			"Nepal": "32994",
			"Afghanistan": "41910",
			"Mali": "1013",
			"Saint Helena": "746",
			"Malaysia": "9530",
			"Swaziland": "8092",
			"Portugal": "52692",
			"Armenia": "374232",
			"China": "80555454",
			"Comoros": "9360",
			"Nauru": "50",
			"Anguilla": "161",
			"Estonia": "6806495",
			"Czechia": "335077",
			"Djibouti": "600",
			"Trinidad and Tobago": "15023",
			"Israel": "10429503",
			"Uzbekistan": "10853697",
			"Somalia": "3000",
			"Singapore": "44213",
			"Paraguay": "79500",
			"Bangladesh": "3821167",
			"Western Sahara": "26",
			"Nigeria": "1259",
			"United Rep. of Tanzania": "108",
			"Finland": "48322424",
			"Morocco": "622410",
			"Cyprus": "476197",
			"Belize": "1000",
			"Georgia": "1554484",
			"Serbia": "46954",
			"Bermuda": "1603",
			"Luxembourg": "172862",
			"Papua New Guinea": "405",
			"Turkmenistan": "3644",
			"Bahrain": "51",
			"Yemen": "54",
			"China, Hong Kong SAR": "865035",
			"Guyana": "1506",
			"Mauritius": "64",
			"Algeria": "2235",
			"USA": "1348912",
			"New Zealand": "262",
			"Namibia": "596",
			"Rep. of Moldova": "413987",
			"Romania": "153",
			"Kuwait": "7355",
			"Malta": "30219",
			"Norway": "888957",
			"Ecuador": "179540",
			"Grenada": "146",
			"Dominican Rep.": "58346",
			"France": "117120288",
			"Philippines": "371318",
			"Niue": "789",
			"Seychelles": "80761",
			"Italy": "53375221",
			"Kyrgyzstan": "7462117",
			"State of Palestine": "149",
			"Rwanda": "2705492",
			"Egypt": "387171",
			"Guatemala": "6675",
			"Ethiopia": "427",
			"Slovenia": "28727984",
			"Sierra Leone": "182",
			"Senegal": "154",
			"Bulgaria": "59755",
			"Montenegro": "424155",
			"Sri Lanka": "6250",
			"Rep. of Korea": "5351672",
			"Hungary": "10112579",
			"Burundi": "10875",
			"Jordan": "3545",
			"Canada": "20062530",
			"Iceland": "4683",
			"Lao People's Dem. Rep.": "51302",
			"Ukraine": "50193",
			"Myanmar": "22893"
		},
		"exports": {
			"Lebanon": "8875595",
			"Gibraltar": "661098",
			"Ghana": "7940",
			"Uruguay": "8204",
			"Germany": "163389309",
			"Poland": "1024483",
			"Cuba": "201",
			"Dem. Rep. of the Congo": "1459",
			"Thailand": "216",
			"Argentina": "3717",
			"Brazil": "1627",
			"Cameroon": "1221",
			"Brunei Darussalam": "383",
			"Iran": "409766714",
			"Mongolia": "442675",
			"Saudi Arabia": "9428",
			"Panama": "924",
			"Colombia": "38",
			"Syria": "323478",
			"Russian Federation": "33842690",
			"United Arab Emirates": "1130",
			"Angola": "3001",
			"Switzerland": "140949",
			"Slovakia": "661",
			"Iraq": "4644994",
			"Japan": "3934",
			"Latvia": "517297",
			"Romania": "11",
			"Pakistan": "834968",
			"Belgium": "19854",
			"Croatia": "92465",
			"Armenia": "32196",
			"United Kingdom": "75",
			"Bolivia (Plurinational State of)": "2077",
			"Nigeria": "7500",
			"Albania": "1224218",
			"Benin": "2457291",
			"Tunisia": "21",
			"Mozambique": "145",
			"Viet Nam": "170",
			"South Africa": "21",
			"Indonesia": "1061343",
			"Qatar": "304",
			"Oman": "891",
			"Sweden": "161",
			"Australia": "1810000",
			"India": "180",
			"Mexico": "1140",
			"Kenya": "1418",
			"Austria": "722414",
			"Tajikistan": "23473825",
			"Ireland": "35729",
			"Côte d'Ivoire": "9817",
			"Spain": "3053",
			"Mauritania": "11412",
			"Lithuania": "16380",
			"Cambodia": "4",
			"Denmark": "50",
			"Peru": "1356",
			"Central African Rep.": "4377",
			"Slovenia": "53945",
			"Venezuela": "21",
			"Turkey": "122",
			"Greece": "81589069",
			"Papua New Guinea": "1312",
			"Azerbaijan": "21404222",
			"Libya": "15",
			"Afghanistan": "360000",
			"Malaysia": "84",
			"Portugal": "6660",
			"United Rep. of Tanzania": "6776",
			"Jordan": "6740",
			"China": "1503682",
			"Egypt": "234",
			"Estonia": "6933135",
			"Morocco": "23401571",
			"Luxembourg": "1797",
			"Trinidad and Tobago": "1607",
			"Israel": "10120215",
			"Uzbekistan": "47",
			"Somalia": "375",
			"Singapore": "271",
			"Bangladesh": "557785",
			"Gabon": "3937",
			"Finland": "1260886",
			"Cyprus": "220905",
			"Georgia": "4857807",
			"Hungary": "116939",
			"Turkmenistan": "16014872",
			"Bahrain": "785",
			"China, Hong Kong SAR": "9585833",
			"Algeria": "723",
			"USA": "5780",
			"Namibia": "297495",
			"Rep. of Moldova": "6188",
			"TFYR of Macedonia": "269335",
			"Kuwait": "689",
			"Malta": "187984600",
			"Norway": "19662",
			"Ecuador": "261278",
			"Dominican Rep.": "211610",
			"France": "210240648",
			"Philippines": "37",
			"Br. Virgin Isds": "250000",
			"Italy": "215851",
			"Kyrgyzstan": "3103259",
			"Czechia": "10003",
			"Belarus": "24797",
			"Ethiopia": "398152",
			"Congo": "43",
			"Senegal": "47",
			"Bulgaria": "8864723",
			"Montenegro": "10323188",
			"Sri Lanka": "1210108",
			"Rep. of Korea": "12585",
			"Serbia": "26000",
			"Netherlands": "302858",
			"New Zealand": "101",
			"Canada": "21644",
			"Ukraine": "255"
		}
	},
	"Paraguay": {
		"imports": {
			"Lebanon": "15045",
			"Gibraltar": "124",
			"South Africa": "433603",
			"Lesotho": "166",
			"Andorra": "644",
			"United Kingdom": "174160",
			"Poland": "377881",
			"Qatar": "919766",
			"Bolivia (Plurinational State of)": "26307093",
			"Thailand": "364281",
			"Dem. People's Rep. of Korea": "14903",
			"Argentina": "358735",
			"Brazil": "11551",
			"Germany": "1364287",
			"Dominica": "872342",
			"Iran": "24068",
			"Mongolia": "13079",
			"Montserrat": "991",
			"Indonesia": "113369",
			"Colombia": "747",
			"Syria": "377892",
			"Russian Federation": "296",
			"United Arab Emirates": "143",
			"Nicaragua": "950",
			"Belize": "378",
			"Jordan": "6741",
			"Malawi": "37",
			"Switzerland": "1680",
			"Georgia": "979",
			"Uruguay": "69206",
			"Ukraine": "185004",
			"Latvia": "469",
			"Japan": "1958031",
			"Hungary": "24",
			"Iraq": "126039",
			"Romania": "87046",
			"Pakistan": "5330",
			"Belgium": "823",
			"Curaçao": "37076",
			"Liberia": "20579",
			"Belarus": "24196102",
			"Madagascar": "12171",
			"Singapore": "22860",
			"Albania": "7535",
			"Benin": "226",
			"Tunisia": "3702",
			"Viet Nam": "155498",
			"Haiti": "2336",
			"Panama": "252",
			"Cuba": "579697",
			"American Samoa": "272",
			"Oman": "9838239",
			"Sweden": "983353",
			"Australia": "8370",
			"Kiribati": "124",
			"Equatorial Guinea": "276",
			"India": "7080",
			"Mexico": "119319",
			"Jamaica": "584",
			"Kenya": "541",
			"Spain": "377178",
			"Bosnia Herzegovina": "4753",
			"Ireland": "545540",
			"Zimbabwe": "6078477",
			"China, Hong Kong SAR": "20160",
			"Austria": "343411",
			"Peru": "38",
			"Lithuania": "56418",
			"Cambodia": "195950",
			"Denmark": "1108",
			"Somalia": "4151",
			"Honduras": "27",
			"Slovenia": "10769",
			"Costa Rica": "50556",
			"Bulgaria": "2959",
			"Holy See (Vatican City State)": "70",
			"Sudan": "8055",
			"Chile": "12822",
			"Kazakhstan": "1942",
			"Gambia": "16532",
			"China, Macao SAR": "12365",
			"Afghanistan": "15114",
			"Croatia": "1364",
			"China": "3160",
			"Malaysia": "99920",
			"Swaziland": "653",
			"Portugal": "552",
			"Falkland Isds (Malvinas)": "1485275",
			"Nepal": "3697",
			"Greece": "19207",
			"Egypt": "66299",
			"Estonia": "7036",
			"Morocco": "39393",
			"Luxembourg": "50808",
			"Trinidad and Tobago": "749",
			"Israel": "3105406",
			"Venezuela": "5852",
			"Saudi Arabia": "159",
			"French Polynesia": "1894",
			"Bangladesh": "213687",
			"United Rep. of Tanzania": "1879669",
			"Finland": "3215",
			"Cyprus": "5312",
			"Gabon": "942",
			"Mauritius": "21333",
			"Slovakia": "999276",
			"Bermuda": "4801",
			"Djibouti": "510840",
			"Bahrain": "239890",
			"Côte d'Ivoire": "898",
			"Saint Pierre and Miquelon": "25045",
			"USA": "11",
			"TFYR of Macedonia": "127",
			"Kuwait": "3813336",
			"Malta": "1422",
			"Norway": "1711421",
			"Ecuador": "636634",
			"Dominican Rep.": "854293",
			"France": "5800",
			"New Caledonia": "66",
			"Philippines": "174025",
			"Br. Virgin Isds": "12388",
			"Italy": "57293",
			"Czechia": "132152",
			"Guatemala": "93789",
			"Senegal": "80",
			"Turkey": "243562",
			"San Marino": "699",
			"Sri Lanka": "29673",
			"Rep. of Korea": "2549794",
			"Serbia": "26117",
			"Netherlands": "52216",
			"Bhutan": "1961",
			"New Zealand": "20951",
			"Canada": "475001",
			"Iceland": "46130",
			"El Salvador": "345",
			"Lao People's Dem. Rep.": "2752",
			"Myanmar": "50898"
		},
		"exports": {
			"Lebanon": "1075468",
			"Gibraltar": "28599",
			"South Africa": "82767207",
			"Uruguay": "964983",
			"Cabo Verde": "819033",
			"Togo": "12256",
			"Poland": "229362",
			"Qatar": "75616",
			"Bolivia (Plurinational State of)": "165026",
			"Thailand": "325167",
			"Argentina": "11254005",
			"Brazil": "1522546",
			"Azerbaijan": "6500",
			"Dominica": "16000",
			"Ghana": "18882",
			"Saudi Arabia": "1747642",
			"Indonesia": "96016",
			"Colombia": "40157",
			"Greece": "28012314",
			"Russian Federation": "214851",
			"United Arab Emirates": "309330",
			"Nicaragua": "303975",
			"Portugal": "75927",
			"Libya": "5187983",
			"Switzerland": "6633",
			"El Salvador": "2646755",
			"Iraq": "15452462",
			"Ukraine": "34400",
			"Latvia": "15048",
			"Japan": "21132",
			"Hungary": "4154",
			"Guinea": "6138",
			"Romania": "275815",
			"Pakistan": "5418303",
			"Belgium": "350",
			"Slovenia": "251750",
			"Georgia": "6500",
			"Mozambique": "176169",
			"Germany": "817",
			"Singapore": "396",
			"Nigeria": "1560",
			"Albania": "509772",
			"Afghanistan": "225502",
			"Tunisia": "175000",
			"Viet Nam": "26852064",
			"Haiti": "6244",
			"Panama": "594",
			"Cuba": "266676",
			"Oman": "9127",
			"Belarus": "112936",
			"Sweden": "11827468",
			"Australia": "145051",
			"Bahrain": "1830",
			"India": "22278",
			"Mexico": "2603",
			"Dem. Rep. of the Congo": "7395",
			"Spain": "2307942",
			"Bosnia Herzegovina": "264491",
			"Ireland": "6558",
			"Zimbabwe": "113238",
			"China, Hong Kong SAR": "291830",
			"Austria": "48890",
			"Lithuania": "1794",
			"United Kingdom": "4848601",
			"Denmark": "47292293",
			"Somalia": "210467",
			"Honduras": "231813",
			"Netherlands": "62755",
			"Costa Rica": "150576",
			"Equatorial Guinea": "2130",
			"Sudan": "100152",
			"Chile": "1341",
			"Kazakhstan": "4510357",
			"Gambia": "3743643",
			"Liberia": "81215",
			"Armenia": "151805",
			"Malaysia": "96425",
			"Peru": "530810",
			"Nepal": "2936400",
			"China": "2625",
			"Egypt": "4588",
			"Guinea-Bissau": "765356",
			"Estonia": "113000",
			"Morocco": "4536041",
			"Trinidad and Tobago": "931509",
			"Israel": "2116046",
			"TFYR of Macedonia": "44358",
			"Bangladesh": "119342234",
			"Gabon": "5250",
			"Cyprus": "7539",
			"Belize": "857212",
			"Mauritius": "2868766",
			"Slovakia": "12162",
			"Madagascar": "114",
			"Turkmenistan": "195561",
			"Syria": "95050",
			"Côte d'Ivoire": "226255",
			"Guyana": "10000",
			"Suriname": "47316",
			"Algeria": "8394916",
			"USA": "1521551",
			"Iran": "12294929",
			"Venezuela": "13050",
			"Kuwait": "1862739",
			"Malta": "10144",
			"Norway": "9475",
			"Ecuador": "62835",
			"State of Palestine": "13151",
			"Sierra Leone": "2221575",
			"Dominican Rep.": "43485",
			"France": "92646",
			"Philippines": "69000",
			"Comoros": "190206",
			"Seychelles": "57734",
			"Italy": "244293",
			"Czechia": "52652",
			"Curaçao": "683731",
			"Guatemala": "62536",
			"Bulgaria": "4708",
			"Congo": "103418",
			"Senegal": "213798",
			"Aruba": "315",
			"Turkey": "667576",
			"Montenegro": "257398",
			"Sri Lanka": "1606",
			"Rep. of Korea": "119252",
			"Serbia": "3461177",
			"Angola": "31410",
			"Jordan": "51381",
			"Canada": "86705",
			"Iceland": "6700",
			"Myanmar": "270180",
			"New Zealand": "109738"
		}
	},
	"French Polynesia": {
		"imports": {},
		"exports": {}
	},
	"Bangladesh": {
		"imports": {},
		"exports": {}
	},
	"Antigua and Barbuda": {
		"imports": {
			"Lebanon": "1348",
			"Gibraltar": "100",
			"South Africa": "759312",
			"Uruguay": "48329",
			"Togo": "1943",
			"Poland": "59578",
			"El Salvador": "18871",
			"Thailand": "4050849",
			"Dem. People's Rep. of Korea": "542923",
			"Argentina": "139031",
			"Brazil": "905",
			"Dominica": "461",
			"Ghana": "74",
			"Barbados": "354",
			"Montserrat": "1787",
			"Panama": "3917",
			"Marshall Isds": "94",
			"Syria": "336",
			"Niger": "54870",
			"Cayman Isds": "7303",
			"United Arab Emirates": "736",
			"Nicaragua": "28930",
			"Jordan": "3390",
			"Switzerland": "468",
			"Mauritius": "19649",
			"Kyrgyzstan": "34",
			"United States Minor Outlying Islands": "22",
			"Ukraine": "682",
			"Japan": "2482305",
			"Guam": "812",
			"Romania": "5029",
			"Pakistan": "4902",
			"Belgium": "186100",
			"Russian Federation": "71",
			"Slovenia": "5931",
			"Germany": "275760",
			"Singapore": "12487",
			"Nigeria": "250",
			"Albania": "69",
			"Bahamas": "8817",
			"Tunisia": "82",
			"Viet Nam": "161",
			"Haiti": "467",
			"Indonesia": "87702",
			"Cuba": "92727",
			"Saint Vincent and the Grenadines": "2355788",
			"Sweden": "55445",
			"Australia": "88877",
			"Christmas Isds": "8",
			"India": "102819",
			"Mexico": "3495",
			"Jamaica": "43308",
			"Kenya": "4074",
			"Spain": "184718",
			"Tajikistan": "60",
			"Ireland": "4751",
			"Zimbabwe": "225",
			"Austria": "493",
			"Fiji": "81",
			"Lithuania": "30648",
			"Namibia": "2661",
			"Denmark": "41066",
			"Portugal": "7263",
			"Honduras": "21451",
			"Holy See (Vatican City State)": "59",
			"United Kingdom": "318549",
			"Costa Rica": "97818",
			"Bouvet Island": "102",
			"Bulgaria": "2005",
			"Greece": "66764",
			"Chile": "931433",
			"Croatia": "108",
			"Afghanistan": "1756",
			"China": "208364",
			"Malaysia": "103385",
			"Swaziland": "23",
			"Peru": "156757",
			"Nepal": "219",
			"Curaçao": "18890",
			"Egypt": "112",
			"Anguilla": "278",
			"Estonia": "15565",
			"Morocco": "1214",
			"Luxembourg": "106",
			"Trinidad and Tobago": "112914",
			"Israel": "49",
			"Venezuela": "12178",
			"Saudi Arabia": "24737",
			"Cambodia": "19479",
			"Bangladesh": "83",
			"Gabon": "1608",
			"Finland": "932252",
			"Cyprus": "54621",
			"Belize": "94354",
			"Georgia": "11351",
			"Slovakia": "149",
			"Colombia": "117908",
			"Madagascar": "2341",
			"Bahrain": "51",
			"China, Hong Kong SAR": "2259",
			"Guyana": "374816",
			"Suriname": "99268",
			"USA": "12681911",
			"Saint Kitts and Nevis": "2537",
			"Malta": "144",
			"Norway": "1050",
			"Ecuador": "23760",
			"Grenada": "736699",
			"Dominican Rep.": "8648",
			"France": "306464",
			"Philippines": "21054",
			"Br. Virgin Isds": "58442",
			"Italy": "100583",
			"Saint Lucia": "595835",
			"Czechia": "34",
			"Uganda": "130",
			"Guatemala": "372944",
			"Turkey": "17911",
			"Sri Lanka": "1849",
			"Rep. of Korea": "1376143",
			"Hungary": "525687",
			"Netherlands": "7117",
			"New Zealand": "16308",
			"Canada": "12697",
			"Iceland": "68",
			"Myanmar": "754"
		},
		"exports": {
			"Greece": "4463",
			"Germany": "1852",
			"Cuba": "1000",
			"China": "29630",
			"Thailand": "22222",
			"Swaziland": "147001",
			"Argentina": "17636",
			"Dominica": "3984",
			"Comoros": "444",
			"Barbados": "56",
			"Anguilla": "1509",
			"Panama": "527615",
			"Trinidad and Tobago": "1907",
			"Israel": "38862",
			"Cayman Isds": "89684",
			"United Arab Emirates": "7407",
			"Montserrat": "111",
			"Switzerland": "4095",
			"Saint Vincent and the Grenadines": "15094",
			"Belize": "89",
			"Bermuda": "1481",
			"Malta": "21623",
			"China, Hong Kong SAR": "2900",
			"Guyana": "259",
			"Curaçao": "687",
			"USA": "2711375",
			"United Kingdom": "24635716",
			"Nigeria": "4352",
			"Norway": "50313",
			"Grenada": "2852",
			"Dominican Rep.": "609",
			"France": "339233",
			"Seychelles": "11111",
			"Indonesia": "18519",
			"Italy": "805007",
			"Saint Lucia": "12963",
			"Sweden": "10015",
			"Australia": "9817",
			"Mexico": "7254",
			"Jamaica": "594",
			"Br. Virgin Isds": "3286",
			"Spain": "3966799",
			"Ireland": "7245",
			"Malaysia": "91",
			"Pakistan": "3704",
			"Rep. of Korea": "30370",
			"Saint Kitts and Nevis": "31338",
			"Canada": "2222220",
			"Netherlands": "34213"
		}
	},
	"Gabon": {
		"imports": {},
		"exports": {}
	},
	"Cyprus": {
		"imports": {
			"Lebanon": "11147",
			"Gibraltar": "1248",
			"Côte d'Ivoire": "33732",
			"Ghana": "2314",
			"Uruguay": "942855",
			"Andorra": "792",
			"Australia": "8685",
			"Germany": "625446097",
			"Poland": "7590",
			"Cuba": "502042",
			"Dem. Rep. of the Congo": "217",
			"Thailand": "151007",
			"Dem. People's Rep. of Korea": "101",
			"Argentina": "620220",
			"Brazil": "6860692",
			"Azerbaijan": "8866",
			"Cameroon": "160",
			"Brunei Darussalam": "3966",
			"Iran": "331468",
			"Barbados": "10240",
			"Saudi Arabia": "222",
			"Panama": "354633",
			"Colombia": "15141115",
			"Georgia": "125081",
			"Russian Federation": "7073",
			"United Arab Emirates": "1221492",
			"Nicaragua": "41370",
			"Jordan": "1995",
			"Switzerland": "554",
			"El Salvador": "8974",
			"Slovakia": "33549",
			"Iraq": "276",
			"Japan": "584281",
			"Tunisia": "9677223",
			"Latvia": "3045",
			"Romania": "16841",
			"Pakistan": "408",
			"Belgium": "521916",
			"Croatia": "7915919",
			"Liberia": "58",
			"Italy": "5496342",
			"Rwanda": "1084",
			"Mozambique": "27479",
			"Madagascar": "130106",
			"Singapore": "11082",
			"Nigeria": "619579",
			"Uzbekistan": "851",
			"Afghanistan": "182",
			"Bahamas": "9290",
			"San Marino": "145340",
			"Viet Nam": "127105",
			"Haiti": "2901",
			"South Africa": "1881",
			"Tokelau": "319",
			"Indonesia": "17103",
			"Qatar": "5676",
			"Oman": "332",
			"Belarus": "309",
			"Sweden": "80524",
			"Maldives": "186",
			"Bahrain": "9404",
			"India": "7056",
			"Mexico": "383",
			"Jamaica": "3340",
			"Kenya": "44329",
			"Spain": "106012",
			"Bosnia Herzegovina": "678",
			"Ireland": "137676",
			"Botswana": "424017",
			"Zimbabwe": "66",
			"Saint Maarten": "11544",
			"Austria": "18751755",
			"Mauritania": "251562",
			"Lithuania": "332469",
			"Namibia": "1250192",
			"Denmark": "109966",
			"Peru": "49873",
			"Central African Rep.": "38664",
			"Honduras": "34",
			"Netherlands": "1191635",
			"United Kingdom": "567385",
			"Costa Rica": "17137",
			"Bulgaria": "13094",
			"Greece": "1588706",
			"Chile": "2009262",
			"Kazakhstan": "2057309",
			"Sudan": "1688",
			"China, Macao SAR": "3317",
			"Vanuatu": "95",
			"Saint Helena": "5774",
			"Malaysia": "569082",
			"Swaziland": "946",
			"Portugal": "19689",
			"Nepal": "23",
			"China": "1553841",
			"Egypt": "452",
			"Estonia": "110140",
			"Morocco": "462093",
			"Djibouti": "219620",
			"Trinidad and Tobago": "612",
			"Israel": "8075",
			"TFYR of Macedonia": "943",
			"Paraguay": "163616",
			"Bangladesh": "24",
			"Antigua and Barbuda": "31069",
			"United Rep. of Tanzania": "28849",
			"Finland": "2775007",
			"Zambia": "233",
			"Mauritius": "18873",
			"Hungary": "3427",
			"Luxembourg": "738",
			"Syria": "45",
			"China, Hong Kong SAR": "11277",
			"Suriname": "4079",
			"Algeria": "5265303",
			"USA": "7515709",
			"Cambodia": "398041",
			"Rep. of Moldova": "13930",
			"Venezuela": "109",
			"Kuwait": "4369",
			"Albania": "15526",
			"Malta": "55731",
			"Norway": "3823",
			"Ecuador": "15295",
			"State of Palestine": "62726",
			"Pitcairn": "669",
			"Dominican Rep.": "45258",
			"France": "572139",
			"New Caledonia": "263",
			"Philippines": "6218",
			"Seychelles": "59844",
			"Br. Virgin Isds": "22344503",
			"Libya": "7074626",
			"Kyrgyzstan": "243",
			"Czechia": "1880",
			"Uganda": "10003",
			"Guatemala": "702",
			"Ethiopia": "46372",
			"Slovenia": "219226",
			"Togo": "66",
			"Congo": "128344",
			"Senegal": "6379",
			"Turkey": "55411",
			"Montenegro": "1415",
			"Sri Lanka": "39914",
			"Rep. of Korea": "4056",
			"Serbia": "48507",
			"Angola": "853",
			"Armenia": "2403",
			"New Zealand": "119557",
			"Canada": "1353",
			"Iceland": "2327",
			"Lao People's Dem. Rep.": "11235",
			"Ukraine": "5541",
			"Myanmar": "22610"
		},
		"exports": {
			"Lebanon": "123101",
			"Gibraltar": "1980",
			"Ghana": "255918",
			"Lesotho": "4990",
			"Cuba": "45920",
			"Dem. Rep. of the Congo": "167023",
			"Dem. People's Rep. of Korea": "3982",
			"Cameroon": "3318",
			"South Africa": "1327",
			"Indonesia": "1977",
			"Colombia": "54613",
			"Niger": "30626",
			"Jordan": "53303",
			"Fr. South Antarctic Terr.": "1106",
			"Uzbekistan": "45596",
			"Iraq": "1600",
			"Guam": "4811",
			"Bosnia Herzegovina": "1236143",
			"Pakistan": "11",
			"Belgium": "592030",
			"Azerbaijan": "420417",
			"Australia": "136828",
			"United Kingdom": "335915",
			"Singapore": "276",
			"Albania": "11834",
			"Benin": "22436",
			"Panama": "66",
			"Qatar": "252073",
			"Saint Vincent and the Grenadines": "60276",
			"Curaçao": "608",
			"Armenia": "38512",
			"Mexico": "8410",
			"Kenya": "147",
			"Spain": "223417",
			"Ireland": "1228573",
			"Botswana": "1792840",
			"South Sudan": "521951",
			"French Polynesia": "5695",
			"Mauritania": "99002",
			"Honduras": "907",
			"Chile": "2035",
			"Gambia": "20865",
			"China, Macao SAR": "98379",
			"Brunei Darussalam": "129783",
			"Malaysia": "342285",
			"Swaziland": "664",
			"Peru": "114214",
			"Nepal": "15724",
			"China": "44",
			"Comoros": "30831",
			"Saint Maarten": "108573",
			"Mali": "10698",
			"Trinidad and Tobago": "162797",
			"Israel": "289985",
			"Burkina Faso": "17540",
			"Paraguay": "2232",
			"Bangladesh": "469465",
			"Antigua and Barbuda": "354124",
			"Gabon": "63952",
			"Yemen": "69803",
			"Mauritius": "22202",
			"Slovakia": "608029",
			"Turkmenistan": "175747",
			"Bahrain": "1907501",
			"Côte d'Ivoire": "332",
			"Algeria": "3917780",
			"USA": "64659",
			"Namibia": "52707",
			"Rep. of Moldova": "5529",
			"Zambia": "221",
			"Malta": "54707",
			"Ecuador": "5972",
			"Grenada": "36879",
			"Dominican Rep.": "45820",
			"France": "292601",
			"New Caledonia": "443",
			"Seychelles": "683383",
			"Br. Virgin Isds": "11392",
			"Italy": "356342",
			"Saint Lucia": "12887",
			"Uganda": "66353",
			"Syria": "179465",
			"Belarus": "83728",
			"Ethiopia": "55294",
			"Slovenia": "15074081",
			"Congo": "27386",
			"Senegal": "226",
			"Bulgaria": "382936",
			"Montenegro": "310",
			"Sri Lanka": "671336",
			"Hungary": "174507",
			"Angola": "59317",
			"New Zealand": "307735",
			"Lao People's Dem. Rep.": "3318",
			"Myanmar": "10578",
			"Iran": "276",
			"Philippines": "1731",
			"Uruguay": "57721",
			"Andorra": "174",
			"Cabo Verde": "9936",
			"Germany": "13462402",
			"Timor-Leste": "68907",
			"Poland": "27171",
			"Thailand": "1468",
			"Argentina": "2212",
			"Brazil": "332",
			"Dominica": "70832",
			"Mongolia": "1834",
			"Saudi Arabia": "34282",
			"Sudan": "866983",
			"Russian Federation": "10",
			"Cayman Isds": "88972",
			"United Arab Emirates": "403",
			"Rwanda": "69193",
			"Malawi": "32527",
			"Switzerland": "1095",
			"El Salvador": "678",
			"Cambodia": "497416",
			"Latvia": "6802",
			"Japan": "114",
			"Guinea": "885",
			"Romania": "835",
			"Croatia": "49198",
			"Liberia": "8847",
			"Mozambique": "597",
			"Madagascar": "101154",
			"Bolivia (Plurinational State of)": "8084",
			"Barbados": "445467",
			"Bahamas": "71664",
			"Tunisia": "1468851",
			"Chad": "4278",
			"Viet Nam": "21586",
			"Haiti": "41096",
			"Oman": "237327",
			"Sweden": "2097845",
			"Maldives": "2581",
			"India": "5529",
			"Jamaica": "5529",
			"Austria": "6615709",
			"Eritrea": "278531",
			"Zimbabwe": "1034483",
			"Vanuatu": "20325",
			"Fiji": "62679",
			"Lithuania": "274048",
			"Saint Kitts and Nevis": "79044",
			"Denmark": "5953812",
			"Portugal": "85076",
			"Central African Rep.": "137497",
			"Netherlands": "111802",
			"Costa Rica": "30364",
			"Greece": "55111",
			"Papua New Guinea": "167427",
			"Kazakhstan": "21255",
			"Afghanistan": "174938",
			"Saint Helena": "348",
			"Egypt": "576129",
			"Estonia": "119805",
			"Morocco": "1040",
			"Luxembourg": "60374",
			"TFYR of Macedonia": "22118",
			"Somalia": "853638",
			"United Rep. of Tanzania": "18247",
			"Finland": "3527023",
			"Belize": "100082",
			"Georgia": "64968",
			"Ukraine": "553",
			"Bermuda": "568",
			"Djibouti": "22257",
			"China, Hong Kong SAR": "377444",
			"Nigeria": "12165",
			"Venezuela": "10306",
			"Kuwait": "671791",
			"Norway": "90865",
			"Sierra Leone": "51461",
			"Marshall Isds": "899",
			"Sao Tome and Principe": "21012",
			"Libya": "2791187",
			"Kyrgyzstan": "27171",
			"Czechia": "14978",
			"Guatemala": "1345",
			"Togo": "1266",
			"Aruba": "80073",
			"Turkey": "63047",
			"Rep. of Korea": "434795",
			"Serbia": "171478",
			"Burundi": "32567",
			"Canada": "519133",
			"Iceland": "79670"
		}
	},
	"Yemen": {
		"imports": {},
		"exports": {}
	},
	"Mauritius": {
		"imports": {
			"Lebanon": "6015",
			"Ghana": "176",
			"Lesotho": "710695",
			"Cuba": "7710",
			"Dem. Rep. of the Congo": "40906",
			"Dem. People's Rep. of Korea": "189",
			"Cameroon": "559",
			"South Africa": "1236533",
			"Indonesia": "135294",
			"Colombia": "74126",
			"Niger": "525",
			"Jordan": "3136",
			"Fr. South Antarctic Terr.": "4932",
			"Guam": "992",
			"Bosnia Herzegovina": "55",
			"Pakistan": "1194388",
			"Belgium": "728",
			"Rwanda": "2211",
			"United Kingdom": "421027",
			"Singapore": "3148",
			"Albania": "2754",
			"Benin": "12293",
			"Panama": "11162",
			"Qatar": "279",
			"American Samoa": "7434",
			"Curaçao": "114",
			"Australia": "1036",
			"Kiribati": "741625",
			"Mexico": "20249",
			"Kenya": "230",
			"Spain": "28036",
			"Ireland": "228187",
			"Botswana": "43200",
			"French Polynesia": "77",
			"Mauritania": "13784",
			"Honduras": "31219",
			"Chile": "593557",
			"Gambia": "7534",
			"Liberia": "74674",
			"Brunei Darussalam": "13515",
			"Malaysia": "4079",
			"Swaziland": "5146",
			"Portugal": "141614",
			"Nepal": "46",
			"China": "7176879",
			"Comoros": "2987953",
			"Mali": "1010479",
			"Trinidad and Tobago": "15136",
			"Israel": "99689",
			"Burkina Faso": "1096",
			"Paraguay": "293",
			"Bangladesh": "9125",
			"Antigua and Barbuda": "66432",
			"Gabon": "854",
			"Cyprus": "277733",
			"Slovakia": "1068",
			"Faeroe Isds": "156",
			"Bahrain": "6897685",
			"Côte d'Ivoire": "74",
			"Guyana": "278",
			"Algeria": "2518",
			"USA": "1633256",
			"Cambodia": "8841",
			"Rep. of Moldova": "45411",
			"Zambia": "9342",
			"Malta": "12890",
			"Ecuador": "5663",
			"Dominican Rep.": "65309",
			"France": "1189566",
			"New Caledonia": "143",
			"Seychelles": "290622",
			"Italy": "128899",
			"Saint Lucia": "230",
			"Uganda": "1797",
			"Syria": "137",
			"Belarus": "51",
			"Ethiopia": "49672",
			"Congo": "2954",
			"Senegal": "860",
			"Bulgaria": "1078426",
			"Sri Lanka": "60",
			"Hungary": "111",
			"Angola": "1337",
			"New Zealand": "133",
			"N. Mariana Isds": "265",
			"Lao People's Dem. Rep.": "131411",
			"Myanmar": "6513",
			"Iran": "54447",
			"Uruguay": "4262",
			"Andorra": "239",
			"Cabo Verde": "2685",
			"Germany": "62552",
			"Poland": "44711",
			"Thailand": "623474",
			"Argentina": "99317",
			"Brazil": "2117",
			"Dominica": "1171",
			"Mongolia": "13725",
			"Saudi Arabia": "18705243",
			"Greece": "5163",
			"Russian Federation": "2806344",
			"United Arab Emirates": "3435",
			"Nicaragua": "4142",
			"Malawi": "86370",
			"Switzerland": "31071",
			"El Salvador": "68",
			"United States Minor Outlying Islands": "284",
			"Latvia": "16968",
			"Japan": "2408337",
			"Guinea": "226",
			"Romania": "201",
			"Croatia": "14688",
			"China, Macao SAR": "234",
			"Mozambique": "3164607",
			"Madagascar": "145694",
			"Bolivia (Plurinational State of)": "3719",
			"Barbados": "1459",
			"Bahamas": "420",
			"San Marino": "52568",
			"Chad": "293",
			"Viet Nam": "68992",
			"Haiti": "1347",
			"Tokelau": "10859",
			"Oman": "39447",
			"Sweden": "45582",
			"Maldives": "828",
			"India": "1932143",
			"Jamaica": "402",
			"Austria": "27845",
			"Eritrea": "106",
			"Zimbabwe": "201061",
			"Vanuatu": "157",
			"Fiji": "238",
			"Lithuania": "15094",
			"Namibia": "578",
			"Denmark": "189",
			"Peru": "53398",
			"Central African Rep.": "744",
			"Netherlands": "669306",
			"Costa Rica": "3363",
			"Equatorial Guinea": "1043",
			"Sudan": "13100",
			"Papua New Guinea": "800",
			"Slovenia": "32898",
			"Afghanistan": "394",
			"Egypt": "9427146",
			"Estonia": "3224",
			"Morocco": "14314",
			"Luxembourg": "661",
			"TFYR of Macedonia": "34531",
			"Somalia": "2621",
			"United Rep. of Tanzania": "182",
			"Finland": "42255",
			"Belize": "1733",
			"Georgia": "53",
			"Ukraine": "92771",
			"Bermuda": "88",
			"Djibouti": "679",
			"Greenland": "134",
			"China, Hong Kong SAR": "49945",
			"Suriname": "189",
			"Nigeria": "93604",
			"Venezuela": "76805",
			"Kuwait": "13528",
			"Norway": "76",
			"Sierra Leone": "6055482",
			"Marshall Isds": "12788",
			"Philippines": "800",
			"Libya": "1252",
			"Czechia": "107925",
			"Guatemala": "171155",
			"Togo": "90",
			"Aruba": "127",
			"Turkey": "28161",
			"Tunisia": "27053",
			"Rep. of Korea": "16909",
			"Serbia": "1391",
			"Burundi": "496",
			"Cook Isds": "1669909",
			"Canada": "46",
			"Iceland": "734"
		},
		"exports": {
			"Lebanon": "31393",
			"South Africa": "616044",
			"Lesotho": "18294",
			"Cabo Verde": "1643",
			"Germany": "6960283",
			"Poland": "3647",
			"Cuba": "701",
			"Thailand": "12680",
			"United Rep. of Tanzania": "7036",
			"Brazil": "151447",
			"Burkina Faso": "6868",
			"Ghana": "32169",
			"Barbados": "503355",
			"Saudi Arabia": "892417",
			"Panama": "5662",
			"Sudan": "11516",
			"Russian Federation": "2238121",
			"United Arab Emirates": "4656",
			"Rwanda": "3513",
			"Jordan": "15889",
			"Malawi": "9896",
			"Switzerland": "14664334",
			"El Salvador": "94133",
			"Ukraine": "125784",
			"Latvia": "80489",
			"Japan": "233052",
			"Hungary": "278909",
			"Iraq": "32177",
			"Uganda": "35895",
			"Romania": "1659268",
			"Vanuatu": "181975",
			"Belgium": "8975",
			"Croatia": "148555",
			"China, Macao SAR": "7569",
			"Australia": "783",
			"Madagascar": "493315",
			"Singapore": "1699749",
			"Nigeria": "6733",
			"Albania": "32691",
			"Benin": "1339",
			"Tunisia": "55774",
			"Chad": "648",
			"Viet Nam": "231111",
			"Guinea": "125",
			"Cameroon": "25113",
			"Indonesia": "71841",
			"Qatar": "3386",
			"American Samoa": "170",
			"Oman": "428713",
			"Sweden": "481277",
			"Maldives": "282342",
			"Kiribati": "61588",
			"Bahrain": "229",
			"India": "96168",
			"Jamaica": "1043",
			"Mexico": "3754873",
			"Kenya": "1537910",
			"Spain": "9376",
			"Iran": "658",
			"Ireland": "562763",
			"Botswana": "68727",
			"Zimbabwe": "2495",
			"Pakistan": "4107",
			"French Polynesia": "1984",
			"Mauritania": "263",
			"Swaziland": "41999",
			"Lithuania": "1924",
			"Namibia": "2243",
			"Denmark": "634",
			"Portugal": "554",
			"Slovenia": "133",
			"United Kingdom": "533",
			"Austria": "175171",
			"Bulgaria": "1629505",
			"Greece": "300",
			"Chile": "748",
			"Kazakhstan": "15261",
			"Liberia": "1019944",
			"Afghanistan": "96857",
			"Mali": "7860",
			"Malaysia": "260628",
			"Fiji": "131",
			"Peru": "9530",
			"Egypt": "250903",
			"China": "7478",
			"Comoros": "1149732",
			"Morocco": "210982",
			"Djibouti": "58979",
			"Trinidad and Tobago": "2685",
			"Israel": "1486970",
			"TFYR of Macedonia": "48013",
			"Somalia": "65294",
			"Cambodia": "9440",
			"Angola": "192021",
			"Bangladesh": "307193",
			"Antigua and Barbuda": "137",
			"Gabon": "2655",
			"Finland": "5718",
			"Bosnia Herzegovina": "150892",
			"Cyprus": "35816",
			"Zambia": "55605",
			"Slovakia": "29",
			"Bermuda": "2127798",
			"Luxembourg": "39",
			"Papua New Guinea": "27271",
			"Turkmenistan": "2503",
			"Syria": "5066",
			"Côte d'Ivoire": "158",
			"Burundi": "35316",
			"Guyana": "18646",
			"Niger": "584",
			"Algeria": "400650",
			"USA": "206",
			"Saint Kitts and Nevis": "668",
			"Rep. of Moldova": "22408",
			"Kuwait": "83232",
			"Suriname": "511",
			"Malta": "113",
			"Norway": "28485",
			"Serbia": "2234",
			"Sierra Leone": "2064",
			"Marshall Isds": "1956171",
			"Tuvalu": "21898",
			"New Caledonia": "1119",
			"Philippines": "34539",
			"Canada": "872276",
			"Seychelles": "206495",
			"Italy": "112",
			"Saint Lucia": "20986",
			"Czechia": "466261",
			"Curaçao": "2624",
			"Mozambique": "27532",
			"Ethiopia": "555",
			"Togo": "184398",
			"Congo": "4267",
			"Senegal": "1894",
			"Turkey": "209357",
			"Sri Lanka": "1158591",
			"Rep. of Korea": "100",
			"France": "35246",
			"Netherlands": "806436",
			"Argentina": "1156",
			"Cook Isds": "129",
			"China, Hong Kong SAR": "2516878",
			"Iceland": "41037",
			"Myanmar": "1266671",
			"Samoa": "299628",
			"New Zealand": "108"
		}
	},
	"Slovakia": {
		"imports": {
			"Lebanon": "696",
			"Bonaire": "65",
			"Gibraltar": "97",
			"Ghana": "506218",
			"Lesotho": "35",
			"Cuba": "527466",
			"Dem. Rep. of the Congo": "1466",
			"Dem. People's Rep. of Korea": "51274",
			"Cameroon": "584",
			"Papua New Guinea": "38828",
			"Montserrat": "232",
			"Panama": "42219",
			"Colombia": "17",
			"Niger": "2025",
			"Tonga": "1693",
			"Jordan": "10378",
			"Uzbekistan": "101724",
			"Iraq": "65",
			"Tuvalu": "3306",
			"Guam": "91180",
			"Bosnia Herzegovina": "630053",
			"Pakistan": "4719",
			"Belgium": "83539",
			"Azerbaijan": "31501",
			"Armenia": "593304",
			"Togo": "29365",
			"Singapore": "1330",
			"Albania": "1259471",
			"Benin": "73",
			"South Africa": "219",
			"FS Micronesia": "672",
			"Indonesia": "380554",
			"Qatar": "443",
			"American Samoa": "1288",
			"Saint Vincent and the Grenadines": "2318",
			"Curaçao": "739",
			"Australia": "555035",
			"Bahrain": "394",
			"Jamaica": "74092",
			"Kenya": "16317",
			"Spain": "143172",
			"Tajikistan": "13080",
			"Ireland": "45256",
			"Slovenia": "5093997",
			"South Sudan": "14768",
			"Norfolk Isds": "434",
			"Mauritania": "5620",
			"Christmas Isds": "6964",
			"Honduras": "36769",
			"Holy See (Vatican City State)": "635",
			"United Kingdom": "73769",
			"Chile": "1551996",
			"Gambia": "258",
			"China, Macao SAR": "31562",
			"Antarctica": "34",
			"Brunei Darussalam": "7477",
			"Malaysia": "829532",
			"Swaziland": "15653",
			"Somalia": "105815",
			"Falkland Isds (Malvinas)": "1957",
			"Nepal": "809",
			"China": "3445708",
			"Comoros": "7917",
			"Guinea-Bissau": "4029",
			"Saint Maarten": "6853",
			"Mali": "640",
			"Trinidad and Tobago": "64015",
			"Israel": "6397",
			"Burkina Faso": "84796",
			"Paraguay": "177",
			"French Polynesia": "2207",
			"Bangladesh": "25882",
			"Antigua and Barbuda": "23373",
			"Gabon": "464",
			"Cyprus": "3891532",
			"Mauritius": "105097",
			"Slovakia": "11059315",
			"Faeroe Isds": "691",
			"Turkmenistan": "25139",
			"Syria": "16804",
			"Côte d'Ivoire": "49853",
			"Guyana": "79268",
			"Saint Pierre and Miquelon": "10448",
			"Algeria": "1649609",
			"USA": "3262294",
			"Cambodia": "830891",
			"Rep. of Moldova": "109734",
			"Zambia": "17910",
			"Malta": "288",
			"Ecuador": "3363714",
			"Grenada": "2922",
			"Dominican Rep.": "213003",
			"France": "745905",
			"New Caledonia": "1915",
			"Niue": "1694",
			"Seychelles": "4231",
			"Br. Virgin Isds": "20522",
			"Italy": "3380011",
			"Saint Lucia": "6101",
			"State of Palestine": "1256",
			"Rwanda": "199",
			"Belarus": "756",
			"Ethiopia": "2145953",
			"Namibia": "30522",
			"Pitcairn": "61280",
			"Senegal": "102534",
			"Bulgaria": "36507",
			"Montenegro": "910",
			"Sri Lanka": "136715",
			"Hungary": "26323692",
			"Angola": "51217",
			"New Zealand": "56093",
			"N. Mariana Isds": "1193",
			"Lao People's Dem. Rep.": "4455",
			"Myanmar": "30390",
			"Iran": "15675",
			"Philippines": "137676",
			"Uruguay": "599086",
			"Andorra": "3984",
			"Cabo Verde": "871",
			"Germany": "11565895",
			"Poland": "2670319",
			"Thailand": "1702278",
			"Argentina": "34",
			"Brazil": "30",
			"Dominica": "282",
			"Mongolia": "206918",
			"Saudi Arabia": "152",
			"Greece": "87129",
			"Russian Federation": "5355887",
			"Cayman Isds": "152",
			"United Arab Emirates": "116",
			"Nicaragua": "14949",
			"Malawi": "788",
			"Switzerland": "60396",
			"El Salvador": "226551",
			"United States Minor Outlying Islands": "10",
			"Latvia": "665345",
			"Japan": "160",
			"Guinea": "9",
			"Uganda": "16863",
			"Romania": "5195315",
			"Croatia": "57548",
			"Liberia": "29883",
			"Guatemala": "1095",
			"Madagascar": "46640",
			"Bolivia (Plurinational State of)": "2654",
			"Nigeria": "85918",
			"Bahamas": "1269",
			"San Marino": "7346",
			"Chad": "2211",
			"Viet Nam": "436",
			"Haiti": "12520",
			"Tokelau": "64",
			"Oman": "3320",
			"Sweden": "117139",
			"Maldives": "168277",
			"India": "3247",
			"Mexico": "83444",
			"Austria": "3706620",
			"Eritrea": "32700",
			"Congo": "740",
			"Zimbabwe": "6154",
			"Vanuatu": "115",
			"Peru": "104742",
			"Fiji": "458",
			"Lithuania": "59958",
			"Saint Kitts and Nevis": "18",
			"Denmark": "3817",
			"Portugal": "2590916",
			"Central African Rep.": "310",
			"Netherlands": "11166679",
			"Costa Rica": "1233530",
			"Equatorial Guinea": "10638",
			"Sudan": "300",
			"Kazakhstan": "3595580",
			"Afghanistan": "11948",
			"Saint Helena": "6312",
			"Egypt": "361501",
			"Nauru": "706",
			"Anguilla": "64275",
			"Estonia": "139024",
			"Morocco": "293",
			"Luxembourg": "598",
			"TFYR of Macedonia": "42",
			"Heard Island and McDonald Islands": "6403",
			"United Rep. of Tanzania": "8472",
			"Finland": "107952",
			"Belize": "406",
			"Georgia": "716",
			"Ukraine": "357035",
			"Bermuda": "9632",
			"Djibouti": "36779",
			"Greenland": "65629",
			"China, Hong Kong SAR": "3999",
			"Suriname": "66902",
			"Barbados": "86652",
			"Venezuela": "330034",
			"Kuwait": "22136",
			"Norway": "74520",
			"Sierra Leone": "884",
			"Marshall Isds": "194",
			"Botswana": "65487",
			"Sao Tome and Principe": "3701",
			"Libya": "2406",
			"Kyrgyzstan": "507832",
			"Czechia": "3121958",
			"Br. Indian Ocean Terr.": "38",
			"Mozambique": "2334",
			"Aruba": "43",
			"Turkey": "20815310",
			"Tunisia": "1032",
			"Rep. of Korea": "9972",
			"Serbia": "195920",
			"Burundi": "77",
			"Bhutan": "940",
			"Cook Isds": "149",
			"Canada": "349034",
			"Iceland": "17255"
		},
		"exports": {
			"Lebanon": "23781",
			"Bonaire": "354",
			"Gibraltar": "177388",
			"Ghana": "13283",
			"Cuba": "268351",
			"Dem. Rep. of the Congo": "861239",
			"Cameroon": "80854",
			"Papua New Guinea": "2092",
			"Indonesia": "1240",
			"Colombia": "89975",
			"Niger": "3",
			"Palau": "241",
			"Jordan": "33326",
			"Fr. South Antarctic Terr.": "156",
			"Uzbekistan": "8486",
			"Iraq": "130742",
			"Guam": "83",
			"Bosnia Herzegovina": "4455",
			"Pakistan": "195044",
			"Belgium": "845834",
			"Azerbaijan": "524",
			"Rwanda": "5437",
			"Armenia": "128",
			"United Kingdom": "1159732",
			"Singapore": "2204",
			"Albania": "14500",
			"Benin": "11180",
			"South Africa": "1180",
			"FS Micronesia": "87307",
			"Panama": "1738",
			"Qatar": "201456",
			"Curaçao": "2334",
			"Australia": "230988",
			"Bahrain": "66",
			"Jamaica": "30",
			"Kenya": "691",
			"Spain": "256882",
			"Tajikistan": "31484",
			"Ireland": "1439965",
			"Botswana": "8583",
			"South Sudan": "12097",
			"French Polynesia": "13086",
			"Mauritania": "3210",
			"Honduras": "9186",
			"Saint Barthélemy": "283",
			"Chile": "7300",
			"Sudan": "553",
			"Gambia": "25229",
			"China, Macao SAR": "299",
			"Brunei Darussalam": "1567",
			"Malaysia": "2358",
			"Swaziland": "182392",
			"Portugal": "9905",
			"Falkland Isds (Malvinas)": "213",
			"Nepal": "1063",
			"China": "44085",
			"Comoros": "8804",
			"Guinea-Bissau": "768",
			"Saint Maarten": "5763",
			"Mali": "29915",
			"Trinidad and Tobago": "66",
			"Israel": "14075",
			"Burkina Faso": "12065",
			"Paraguay": "99400",
			"Bangladesh": "848",
			"Antigua and Barbuda": "864",
			"Gabon": "91914",
			"Cyprus": "28315",
			"Yemen": "8855",
			"Mauritius": "60",
			"Faeroe Isds": "21882",
			"Turkmenistan": "168056",
			"Syria": "39915",
			"Côte d'Ivoire": "12806",
			"Guyana": "1704",
			"Saint Pierre and Miquelon": "1",
			"Algeria": "803",
			"USA": "1637528",
			"Namibia": "90",
			"Rep. of Moldova": "640397",
			"Zambia": "100",
			"Malta": "30693",
			"Ecuador": "548",
			"Dominican Rep.": "9802",
			"France": "3342966",
			"New Caledonia": "116765",
			"Seychelles": "50256",
			"Br. Virgin Isds": "28",
			"Italy": "6320815",
			"Saint Lucia": "33742",
			"State of Palestine": "296141",
			"Uganda": "273097",
			"Belarus": "67521",
			"Ethiopia": "66",
			"Slovenia": "879859",
			"Congo": "85050",
			"Senegal": "5424",
			"Bulgaria": "37724",
			"Montenegro": "61202",
			"Sri Lanka": "476",
			"Hungary": "59291887",
			"Angola": "698",
			"New Zealand": "79015",
			"Lao People's Dem. Rep.": "13527",
			"Myanmar": "1849",
			"Iran": "479152",
			"Uruguay": "3989",
			"Andorra": "1729",
			"Cabo Verde": "46816",
			"Germany": "11178737",
			"Poland": "118516417",
			"Thailand": "9474",
			"Argentina": "33",
			"Brazil": "66813",
			"Dominica": "1429",
			"Mongolia": "29665",
			"Saudi Arabia": "2839",
			"South Georgia and the South Sandwich Islands": "14975",
			"Russian Federation": "149814",
			"Cayman Isds": "244010",
			"United Arab Emirates": "3654",
			"Nicaragua": "2003450",
			"Malawi": "11",
			"Switzerland": "202857",
			"El Salvador": "321",
			"United States Minor Outlying Islands": "27673",
			"Latvia": "632297",
			"Japan": "100",
			"Guinea": "22138",
			"Romania": "6346787",
			"Croatia": "200832",
			"Liberia": "479",
			"Guatemala": "33",
			"Madagascar": "46",
			"Bolivia (Plurinational State of)": "380",
			"Nigeria": "1644748",
			"Bahamas": "4738",
			"Tunisia": "183",
			"Chad": "6343",
			"Viet Nam": "2574",
			"Haiti": "199522",
			"Oman": "73513",
			"Sweden": "349645",
			"Maldives": "1044",
			"India": "12176",
			"Mexico": "199",
			"Austria": "1536558",
			"Zimbabwe": "13798",
			"Vanuatu": "1065",
			"Fiji": "71009",
			"Lithuania": "3365781",
			"Cambodia": "161141",
			"Denmark": "162758",
			"Peru": "199",
			"Central African Rep.": "25709",
			"Netherlands": "7136395",
			"Costa Rica": "66",
			"Equatorial Guinea": "22109",
			"Greece": "1099226",
			"Kazakhstan": "24125",
			"Afghanistan": "857731",
			"Egypt": "4428",
			"Anguilla": "50220",
			"Estonia": "110119",
			"Morocco": "83202",
			"Luxembourg": "274898",
			"TFYR of Macedonia": "753918",
			"Somalia": "12742",
			"United Rep. of Tanzania": "137",
			"Finland": "4069",
			"Georgia": "95736",
			"Ukraine": "431023",
			"Bermuda": "26921",
			"Djibouti": "47153",
			"Greenland": "56",
			"China, Hong Kong SAR": "40124",
			"Suriname": "70",
			"Barbados": "1085",
			"Samoa": "493",
			"Venezuela": "6034",
			"Kuwait": "4",
			"Norway": "55472",
			"Sierra Leone": "46417",
			"Philippines": "3232",
			"Libya": "691",
			"Kyrgyzstan": "5402",
			"Czechia": "16706331",
			"Mozambique": "3228",
			"Togo": "1352",
			"Aruba": "3068",
			"Turkey": "6531",
			"San Marino": "105659",
			"Rep. of Korea": "165368",
			"Serbia": "25431820",
			"Burundi": "145",
			"Bhutan": "713428",
			"Cook Isds": "9720",
			"Canada": "3074",
			"Iceland": "500873"
		}
	},
	"Faeroe Isds": {
		"imports": {},
		"exports": {}
	},
	"Turkmenistan": {
		"imports": {},
		"exports": {}
	},
	"Bahrain": {
		"imports": {
			"Lebanon": "269",
			"Gibraltar": "66",
			"Ghana": "181474",
			"Lesotho": "32693",
			"Cuba": "49323",
			"Dem. Rep. of the Congo": "106",
			"Cameroon": "5037",
			"South Africa": "129773",
			"Montserrat": "5641",
			"Panama": "10803",
			"Colombia": "879",
			"Niger": "684",
			"Palau": "1123",
			"Tonga": "343",
			"Jordan": "392321",
			"Fr. South Antarctic Terr.": "519",
			"Uzbekistan": "62",
			"Iraq": "5780",
			"Tuvalu": "654",
			"Guam": "91550",
			"Bosnia Herzegovina": "4745",
			"Pakistan": "14660290",
			"Belgium": "1093965",
			"Azerbaijan": "6032",
			"Pitcairn": "368",
			"Rwanda": "760",
			"Armenia": "5466",
			"United Kingdom": "530481",
			"Singapore": "1315637",
			"Albania": "12381",
			"FS Micronesia": "13245",
			"Indonesia": "4151",
			"Qatar": "140806",
			"American Samoa": "2338",
			"Saint Vincent and the Grenadines": "11002546",
			"Djibouti": "2888",
			"Curaçao": "257",
			"Australia": "27130978",
			"Jamaica": "792",
			"Kenya": "212219",
			"Spain": "1329325",
			"Tajikistan": "402",
			"Ireland": "192125",
			"French Polynesia": "111",
			"Mauritania": "1770",
			"Christmas Isds": "443",
			"Honduras": "1213",
			"Holy See (Vatican City State)": "496",
			"Chile": "6357",
			"Sudan": "867848",
			"Gambia": "757",
			"Liberia": "5750",
			"Dominica": "15588",
			"Malaysia": "2325651",
			"Fiji": "71070",
			"Portugal": "83078",
			"Saint Kitts and Nevis": "15",
			"Nepal": "108",
			"China": "136049",
			"Comoros": "456214",
			"Mali": "2647",
			"Trinidad and Tobago": "508",
			"Burkina Faso": "1157",
			"Kazakhstan": "3418",
			"Paraguay": "3178356",
			"Bangladesh": "1506027",
			"Antigua and Barbuda": "38643",
			"Gabon": "2443",
			"Cyprus": "451653",
			"Yemen": "22",
			"Mauritius": "129289",
			"Slovakia": "7862",
			"Turkmenistan": "51286",
			"Syria": "8292",
			"Côte d'Ivoire": "160",
			"Guyana": "3360",
			"Saint Pierre and Miquelon": "90",
			"Algeria": "53699",
			"USA": "1305800",
			"Namibia": "1502",
			"Rep. of Moldova": "153",
			"Zambia": "53995",
			"Malta": "263805",
			"Ecuador": "188988",
			"Grenada": "240",
			"Dominican Rep.": "243388",
			"France": "1793287",
			"New Caledonia": "1531",
			"Niue": "15",
			"Seychelles": "87544",
			"Italy": "40283",
			"State of Palestine": "14029",
			"Uganda": "1896",
			"Belarus": "38",
			"Ethiopia": "60248",
			"Congo": "97192",
			"Senegal": "7146",
			"Bulgaria": "1901",
			"Montenegro": "176",
			"Sri Lanka": "2945854",
			"Hungary": "3925255",
			"New Zealand": "43592120",
			"Lao People's Dem. Rep.": "8767",
			"Myanmar": "4051846",
			"Iran": "171424",
			"Sao Tome and Principe": "26670",
			"Uruguay": "152659",
			"Andorra": "127210",
			"Cabo Verde": "315",
			"Germany": "179393",
			"Timor-Leste": "405",
			"Poland": "4237083",
			"Thailand": "481108",
			"Argentina": "2056678",
			"Brazil": "231810",
			"Brunei Darussalam": "1260",
			"Mongolia": "228",
			"Saudi Arabia": "17545239",
			"Greece": "471629",
			"Russian Federation": "1019",
			"Cayman Isds": "1280",
			"United Arab Emirates": "8770398",
			"Nicaragua": "467",
			"Malawi": "35026",
			"Switzerland": "69672",
			"El Salvador": "27",
			"Latvia": "230688",
			"Japan": "570",
			"Guinea": "3504",
			"Romania": "1598096",
			"Croatia": "32495",
			"China, Macao SAR": "206632",
			"Guatemala": "85",
			"Madagascar": "1030289",
			"Bolivia (Plurinational State of)": "44667",
			"Barbados": "50",
			"Bahamas": "7310",
			"Tunisia": "69059",
			"Chad": "2929585",
			"Viet Nam": "39811",
			"Haiti": "97",
			"Tokelau": "26044",
			"Oman": "17648804",
			"Sweden": "38238",
			"Maldives": "1244",
			"India": "6231917",
			"Mexico": "2013800",
			"Austria": "95929",
			"Eritrea": "9362",
			"Zimbabwe": "6891",
			"Vanuatu": "3628",
			"Lithuania": "18171",
			"Cambodia": "3473",
			"Denmark": "3024",
			"Peru": "566941",
			"Central African Rep.": "10556",
			"Netherlands": "40535691",
			"Costa Rica": "323490",
			"South Georgia and the South Sandwich Islands": "232",
			"Papua New Guinea": "127",
			"Slovenia": "912722",
			"Afghanistan": "228599",
			"Saint Helena": "85021",
			"Egypt": "121233",
			"Nauru": "841",
			"Anguilla": "1382",
			"Estonia": "593574",
			"Morocco": "2145397",
			"Luxembourg": "26670",
			"TFYR of Macedonia": "119975",
			"Somalia": "13727",
			"Heard Island and McDonald Islands": "12",
			"Western Sahara": "24",
			"United Rep. of Tanzania": "1358",
			"Finland": "23603",
			"Belize": "1595",
			"Georgia": "3252",
			"Ukraine": "6992",
			"Bermuda": "1583",
			"Antarctica": "906",
			"Greenland": "1267",
			"China, Hong Kong SAR": "7120",
			"Suriname": "565",
			"Nigeria": "2188",
			"Samoa": "164",
			"Venezuela": "39597",
			"Kuwait": "844",
			"Norway": "495986",
			"Sierra Leone": "2942",
			"Marshall Isds": "210",
			"Philippines": "599954",
			"Libya": "17898",
			"Kyrgyzstan": "894",
			"Czechia": "2428",
			"Br. Indian Ocean Terr.": "126",
			"Mozambique": "217432",
			"Togo": "3301",
			"Aruba": "317",
			"Turkey": "1393347",
			"San Marino": "11620",
			"Rep. of Korea": "2419407",
			"Serbia": "157132",
			"Burundi": "1684",
			"Bhutan": "300",
			"Cook Isds": "118",
			"Canada": "48234",
			"Iceland": "40691"
		},
		"exports": {
			"Lebanon": "1264407",
			"Gibraltar": "991",
			"Côte d'Ivoire": "683000",
			"Ghana": "26635",
			"Uruguay": "20240",
			"Tokelau": "158940",
			"Germany": "318",
			"Poland": "5279837",
			"Cuba": "835368",
			"Dem. Rep. of the Congo": "75577",
			"Thailand": "8124",
			"Argentina": "279504",
			"Brazil": "17400",
			"Azerbaijan": "23826",
			"Cameroon": "3707699",
			"Brunei Darussalam": "3007",
			"Iran": "9220",
			"Saudi Arabia": "1056552",
			"Panama": "67512",
			"Marshall Isds": "83137",
			"Sudan": "180889",
			"Russian Federation": "392513",
			"Cayman Isds": "3939",
			"United Arab Emirates": "646036",
			"Angola": "278883",
			"Switzerland": "100352",
			"Mauritius": "514178",
			"Uzbekistan": "15116",
			"Iraq": "199",
			"Japan": "696291256",
			"Latvia": "532",
			"Romania": "602996",
			"Pakistan": "1535339",
			"Belgium": "12337",
			"Croatia": "1272971",
			"China, Macao SAR": "56953",
			"Italy": "2090553",
			"Mozambique": "65926",
			"United Kingdom": "749824",
			"Singapore": "405",
			"Nigeria": "3944444",
			"Benin": "40435",
			"Maldives": "45429",
			"Bahamas": "8975",
			"Tunisia": "238445",
			"Viet Nam": "3656045",
			"South Africa": "9722638",
			"Guinea": "8748",
			"Indonesia": "900000",
			"Qatar": "163571",
			"Saint Vincent and the Grenadines": "160",
			"Oman": "4847840",
			"Sweden": "3028",
			"Australia": "78937392",
			"India": "2342",
			"Mexico": "5319",
			"Kenya": "7434",
			"Austria": "11273",
			"Ireland": "113476",
			"Vanuatu": "100143",
			"Spain": "38843",
			"Mauritania": "24240",
			"Lithuania": "10",
			"Cambodia": "274226",
			"Denmark": "359608",
			"Portugal": "223662",
			"Netherlands": "4716",
			"Costa Rica": "3989",
			"Turkey": "2225",
			"Greece": "991",
			"Chile": "113582",
			"Kazakhstan": "34436",
			"Gambia": "44559",
			"Liberia": "6413",
			"Afghanistan": "253934",
			"Malaysia": "208299924",
			"Peru": "16179",
			"United Rep. of Tanzania": "310735",
			"Nepal": "87785",
			"China": "364213305",
			"Egypt": "3274",
			"Estonia": "383479",
			"Czechia": "49263",
			"Djibouti": "345030",
			"Trinidad and Tobago": "48177",
			"Venezuela": "96990",
			"Somalia": "321626",
			"Paraguay": "135558",
			"Bangladesh": "1077672",
			"Antigua and Barbuda": "14201",
			"Gabon": "583932",
			"Finland": "37504",
			"Morocco": "1377270",
			"Cyprus": "2214",
			"Yemen": "74686",
			"Georgia": "504426",
			"Slovakia": "132",
			"Luxembourg": "2309",
			"Faeroe Isds": "165",
			"Turkmenistan": "3727697",
			"Syria": "4309",
			"China, Hong Kong SAR": "603076",
			"Guyana": "22948",
			"Algeria": "2332028",
			"USA": "3521",
			"Namibia": "798",
			"Kuwait": "2269898",
			"Malta": "48522",
			"Norway": "30481",
			"Ecuador": "294849",
			"Serbia": "213",
			"Sierra Leone": "9120",
			"Dominican Rep.": "149595",
			"France": "187391",
			"Tuvalu": "2850",
			"Philippines": "582010",
			"Seychelles": "15484",
			"Libya": "769824",
			"State of Palestine": "1720492",
			"Uganda": "217669",
			"Belarus": "996",
			"Ethiopia": "608803",
			"Slovenia": "2705688",
			"Togo": "483774",
			"Senegal": "394177",
			"Colombia": "75914",
			"Bulgaria": "15894",
			"Montenegro": "190479",
			"Sri Lanka": "11",
			"Rep. of Korea": "12498977",
			"Hungary": "2414481",
			"Jordan": "346450",
			"Canada": "23090",
			"Samoa": "148356",
			"Madagascar": "26395",
			"New Zealand": "30965647"
		}
	},
	"South Sudan": {
		"imports": {},
		"exports": {}
	},
	"Guyana": {
		"imports": {
			"Gibraltar": "30000",
			"South Africa": "32358",
			"Uruguay": "130835",
			"Switzerland": "43163",
			"Cabo Verde": "352275",
			"United Kingdom": "3670187",
			"Poland": "2664140",
			"Cuba": "8551789",
			"Dem. Rep. of the Congo": "16176",
			"Thailand": "1611823",
			"Dem. People's Rep. of Korea": "24166",
			"Argentina": "630",
			"Brazil": "624182",
			"Cameroon": "67",
			"Dominica": "5784",
			"Ghana": "48319",
			"Mongolia": "15477",
			"Saudi Arabia": "67638",
			"Panama": "113339",
			"Colombia": "1268934",
			"Syria": "19809",
			"Russian Federation": "2300600",
			"Cayman Isds": "2777",
			"United Arab Emirates": "130962",
			"Nicaragua": "143",
			"Yemen": "387",
			"Jordan": "24543",
			"Andorra": "437",
			"El Salvador": "3201",
			"United States Minor Outlying Islands": "106",
			"Sierra Leone": "504",
			"Slovakia": "96612",
			"Iraq": "7656",
			"Japan": "6348",
			"Guam": "880",
			"Latvia": "263",
			"Bosnia Herzegovina": "1066",
			"Pakistan": "1360",
			"Belgium": "2915",
			"Sweden": "275898",
			"Belarus": "71604",
			"Germany": "635253",
			"Singapore": "440257",
			"Barbados": "7642",
			"Albania": "171",
			"Bahamas": "589",
			"Tunisia": "12340",
			"Viet Nam": "123500",
			"Indonesia": "421434",
			"Saint Vincent and the Grenadines": "100797",
			"Oman": "30240",
			"Curaçao": "193458",
			"Australia": "38688",
			"India": "209830",
			"Jamaica": "1112109",
			"Mexico": "2596040",
			"Kenya": "3359",
			"Austria": "38360",
			"Romania": "152050",
			"Ireland": "13498",
			"Botswana": "5416",
			"Spain": "74433",
			"Lithuania": "1925",
			"Saint Kitts and Nevis": "17030",
			"Christmas Isds": "7091",
			"Portugal": "1230",
			"Honduras": "17018",
			"Netherlands": "423630",
			"Costa Rica": "96911",
			"Turkey": "1051344",
			"Greece": "4408",
			"Chile": "1364517",
			"Croatia": "589",
			"Gambia": "13208",
			"Samoa": "34377",
			"Malaysia": "117865",
			"Swaziland": "13570",
			"Peru": "1381063",
			"Egypt": "38092",
			"China": "18039396",
			"Comoros": "9345",
			"Anguilla": "356",
			"Estonia": "1196",
			"Bolivia (Plurinational State of)": "169049",
			"Luxembourg": "10183",
			"Trinidad and Tobago": "43929924",
			"Israel": "107140",
			"Venezuela": "114896",
			"Cambodia": "2763",
			"Bangladesh": "2665",
			"Antigua and Barbuda": "12610",
			"Gabon": "473",
			"Finland": "3534",
			"Morocco": "162933",
			"Cyprus": "29026",
			"Belize": "125447",
			"Georgia": "4425",
			"Ukraine": "17288",
			"Bermuda": "451",
			"Malta": "5",
			"Cook Isds": "248",
			"Greenland": "766",
			"Bahrain": "23024",
			"China, Hong Kong SAR": "1019502",
			"Suriname": "6682596",
			"Algeria": "713",
			"USA": "33507265",
			"Namibia": "223",
			"Iran": "4415",
			"Denmark": "333901",
			"Norway": "709",
			"Ecuador": "206201",
			"Serbia": "7489",
			"Grenada": "464400",
			"Dominican Rep.": "58865",
			"France": "2787",
			"New Caledonia": "632",
			"Philippines": "987",
			"Br. Virgin Isds": "1186",
			"Italy": "20225",
			"Saint Lucia": "1687824",
			"Czechia": "6450",
			"Paraguay": "10415",
			"Br. Indian Ocean Terr.": "33",
			"Guatemala": "178336",
			"Ethiopia": "2167",
			"Slovenia": "516",
			"Mauritius": "16929",
			"Congo": "15755",
			"Aruba": "9000",
			"Bulgaria": "11695",
			"Sri Lanka": "208362",
			"Rep. of Korea": "34035",
			"Hungary": "419",
			"New Zealand": "9883583",
			"Canada": "3455819",
			"Iceland": "107402",
			"Lao People's Dem. Rep.": "784",
			"Madagascar": "12987"
		},
		"exports": {
			"Lebanon": "88420",
			"Ghana": "11830",
			"Uruguay": "49191",
			"Germany": "60",
			"Poland": "1",
			"Cuba": "2154",
			"Thailand": "425771",
			"Dem. People's Rep. of Korea": "65700",
			"Argentina": "1",
			"Brazil": "26810",
			"Cameroon": "69421",
			"Dominica": "1778740",
			"Papua New Guinea": "2000",
			"Barbados": "39088",
			"Saudi Arabia": "29041",
			"Indonesia": "694",
			"Colombia": "2517",
			"Niger": "21599",
			"Cayman Isds": "1861976",
			"United Arab Emirates": "486",
			"Nicaragua": "6877812",
			"Jordan": "53262",
			"Fr. South Antarctic Terr.": "19500",
			"Switzerland": "18942872",
			"Georgia": "17300",
			"United States Minor Outlying Islands": "79737",
			"Ukraine": "22032",
			"Japan": "85",
			"Bosnia Herzegovina": "28443",
			"Pakistan": "48210",
			"Belgium": "800",
			"Croatia": "10763",
			"Maldives": "114300",
			"United Kingdom": "5742873",
			"Singapore": "2713",
			"Nigeria": "12624",
			"Bahamas": "33932",
			"Viet Nam": "614974",
			"Haiti": "8700537",
			"South Africa": "20",
			"Panama": "442046",
			"Saint Vincent and the Grenadines": "298678",
			"Curaçao": "115886",
			"Australia": "1299",
			"India": "3346935",
			"Mexico": "5930882",
			"Jamaica": "333599",
			"Br. Virgin Isds": "484",
			"Austria": "812",
			"Bouvet Island": "59200",
			"Ireland": "8179507",
			"Spain": "2163002",
			"Saint Kitts and Nevis": "573680",
			"Denmark": "49021",
			"Honduras": "259271",
			"Holy See (Vatican City State)": "493641",
			"Costa Rica": "52598",
			"Turkey": "17500",
			"Greece": "1982635",
			"Chile": "12149",
			"Suriname": "1473229",
			"Malaysia": "427",
			"Swaziland": "11593698",
			"Portugal": "232584",
			"Nepal": "3974",
			"China": "67662",
			"Anguilla": "12842",
			"Luxembourg": "626",
			"Trinidad and Tobago": "6278704",
			"Israel": "5845676",
			"Venezuela": "2134822",
			"Montserrat": "12785",
			"French Polynesia": "645743",
			"Bangladesh": "59171",
			"Antigua and Barbuda": "199964",
			"Finland": "1000",
			"Belize": "637772",
			"Mauritius": "48260",
			"Slovakia": "23273",
			"Bermuda": "631801",
			"Greenland": "2993",
			"Bahrain": "8178",
			"China, Hong Kong SAR": "6945453",
			"Russian Federation": "21",
			"USA": "17133702",
			"Kuwait": "7450",
			"Ecuador": "5010",
			"Grenada": "95678",
			"Dominican Rep.": "5862398",
			"France": "6446132",
			"Philippines": "639081",
			"Italy": "7748",
			"Saint Lucia": "290878",
			"Czechia": "4000",
			"Rwanda": "60",
			"Guatemala": "500",
			"Congo": "30501",
			"Aruba": "1937",
			"Bulgaria": "511833",
			"Rep. of Korea": "253000",
			"Netherlands": "5811",
			"New Zealand": "1736742",
			"Canada": "30314"
		}
	},
	"Saint Pierre and Miquelon": {
		"imports": {},
		"exports": {}
	},
	"Algeria": {
		"imports": {},
		"exports": {}
	},
	"USA": {
		"imports": {
			"Lebanon": "45555",
			"Gibraltar": "8634",
			"Ghana": "2856",
			"Lesotho": "13902457",
			"Qatar": "21895399",
			"Dem. Rep. of the Congo": "12375313",
			"Cameroon": "20228632",
			"Papua New Guinea": "79819",
			"Montserrat": "7357",
			"Panama": "134597",
			"Colombia": "60299401",
			"Niger": "18081",
			"Palau": "374015",
			"Tonga": "3268057",
			"Jordan": "4964",
			"Fr. South Antarctic Terr.": "3259",
			"Uzbekistan": "3075341",
			"Iraq": "91893",
			"Tuvalu": "40332",
			"Bosnia Herzegovina": "245526",
			"Pakistan": "31718",
			"Belgium": "97458344",
			"Azerbaijan": "7800",
			"Armenia": "5959",
			"Togo": "1407912",
			"Singapore": "12563",
			"Albania": "799675",
			"Benin": "12857",
			"South Africa": "2913875",
			"FS Micronesia": "3845",
			"Indonesia": "21541143",
			"Saint Vincent and the Grenadines": "89910",
			"Curaçao": "20100",
			"Australia": "111183505",
			"Kiribati": "2503838",
			"Bahrain": "80940",
			"Jamaica": "10315",
			"Kenya": "24773526",
			"Spain": "1340152",
			"Tajikistan": "75484",
			"Ireland": "2741522",
			"Botswana": "509064",
			"South Sudan": "6505",
			"Norfolk Isds": "244200",
			"Mauritania": "377046",
			"Christmas Isds": "5088",
			"Honduras": "139065440",
			"Holy See (Vatican City State)": "28607",
			"United Kingdom": "380503812",
			"Chile": "54799075",
			"Gambia": "93282",
			"China, Macao SAR": "960589",
			"Dominica": "129395",
			"Malaysia": "14644669",
			"Fiji": "200599694",
			"Somalia": "4607",
			"Falkland Isds (Malvinas)": "19563517",
			"Nepal": "1069820",
			"China": "173004922",
			"Comoros": "509128",
			"Guinea-Bissau": "90522",
			"Saint Maarten": "11900",
			"Mali": "2271",
			"Trinidad and Tobago": "68400",
			"Israel": "1275238",
			"Burkina Faso": "2137514",
			"Paraguay": "2282600",
			"French Polynesia": "6700",
			"Bangladesh": "282059",
			"Antigua and Barbuda": "14277",
			"Gabon": "2617",
			"Cyprus": "8070354",
			"Yemen": "88017",
			"Mauritius": "43091115",
			"Slovakia": "331744",
			"Faeroe Isds": "46162851",
			"Turkmenistan": "386402",
			"Syria": "2964666",
			"Côte d'Ivoire": "561363",
			"Guyana": "38835",
			"Saint Pierre and Miquelon": "20035",
			"Algeria": "20874366",
			"Cambodia": "19237",
			"Rep. of Moldova": "14623746",
			"Zambia": "25091",
			"Malta": "4150",
			"Ecuador": "42346159",
			"Grenada": "3309",
			"Dominican Rep.": "1526876",
			"France": "218972951",
			"New Caledonia": "410958",
			"Niue": "132671",
			"Seychelles": "2348673",
			"Br. Virgin Isds": "53765",
			"Italy": "504579891",
			"Saint Lucia": "403693",
			"State of Palestine": "2435844",
			"Rwanda": "31791",
			"Belarus": "19216",
			"Ethiopia": "1128770",
			"Namibia": "2968",
			"Pitcairn": "5748",
			"Senegal": "1653407",
			"Bulgaria": "104461",
			"Montenegro": "370577",
			"Sri Lanka": "33552776",
			"Hungary": "111670",
			"Angola": "260678",
			"New Zealand": "8840011",
			"Lao People's Dem. Rep.": "104527",
			"Myanmar": "182325",
			"Iran": "510385",
			"Philippines": "328773",
			"Uruguay": "43073100",
			"Andorra": "25246",
			"Cabo Verde": "14272",
			"Germany": "253957779",
			"Timor-Leste": "178333",
			"Poland": "25139259",
			"Thailand": "14319034",
			"Argentina": "138083967",
			"Brazil": "299073950",
			"Brunei Darussalam": "250196",
			"Mongolia": "17314",
			"Saudi Arabia": "16627042969",
			"Greece": "50543",
			"Russian Federation": "688845887",
			"Cayman Isds": "3850",
			"United Arab Emirates": "5193346",
			"Nicaragua": "96001",
			"Malawi": "11196120",
			"Switzerland": "288713143",
			"El Salvador": "2185531",
			"Latvia": "166018121",
			"Japan": "1418009755",
			"Guinea": "487212",
			"Uganda": "422949",
			"Romania": "4934",
			"Croatia": "11779458",
			"Liberia": "695395",
			"Guatemala": "298540",
			"Madagascar": "532202",
			"Bolivia (Plurinational State of)": "188142",
			"Nigeria": "2500",
			"Bahamas": "41895776",
			"San Marino": "21938",
			"Chad": "946184681",
			"Viet Nam": "61250254",
			"Haiti": "6343929",
			"Tokelau": "69981",
			"Slovenia": "3878398",
			"Oman": "35780",
			"Sweden": "172312430",
			"Maldives": "2823273",
			"India": "244508",
			"Mexico": "745778802",
			"Austria": "581065448",
			"Eritrea": "34468",
			"Congo": "39488768",
			"Zimbabwe": "23834",
			"Vanuatu": "772690",
			"Peru": "32722953",
			"Swaziland": "994541",
			"Lithuania": "109694",
			"Saint Kitts and Nevis": "710341",
			"Denmark": "59315320",
			"Portugal": "2183388",
			"Central African Rep.": "41274",
			"Netherlands": "33243046",
			"Costa Rica": "9729",
			"Equatorial Guinea": "27744661",
			"Sudan": "4507189",
			"Kazakhstan": "3131407",
			"Afghanistan": "210240",
			"Saint Helena": "12676350",
			"Egypt": "34713175",
			"Nauru": "26731",
			"Anguilla": "41573",
			"Estonia": "1916743",
			"Morocco": "114297850",
			"Luxembourg": "642764",
			"TFYR of Macedonia": "155540935",
			"Heard Island and McDonald Islands": "7814",
			"Western Sahara": "35535",
			"United Rep. of Tanzania": "5598026",
			"Finland": "21459370",
			"Belize": "5268700",
			"Georgia": "494703",
			"Ukraine": "24865639",
			"Bermuda": "95600",
			"Djibouti": "88026",
			"Greenland": "615124",
			"China, Hong Kong SAR": "23404907",
			"Suriname": "913184",
			"Barbados": "3312520",
			"Samoa": "1088358",
			"Venezuela": "1027501",
			"Kuwait": "5355",
			"Norway": "617485341",
			"Sierra Leone": "120077",
			"Marshall Isds": "4237855",
			"Sao Tome and Principe": "59098",
			"Libya": "228251",
			"Kyrgyzstan": "15561",
			"Czechia": "2784534",
			"Br. Indian Ocean Terr.": "5201",
			"Mozambique": "1305003",
			"Aruba": "336183",
			"Turkey": "45955718",
			"Tunisia": "20077506",
			"Rep. of Korea": "7039484",
			"Serbia": "19272",
			"Burundi": "26243",
			"Bhutan": "150094",
			"Cook Isds": "46360",
			"Canada": "1990598376",
			"Iceland": "217104266"
		},
		"exports": {
			"Lebanon": "3513559",
			"Gibraltar": "2844947",
			"Ghana": "1202873",
			"Lesotho": "3574",
			"Cuba": "13501",
			"Dem. Rep. of the Congo": "824880",
			"Dem. People's Rep. of Korea": "115844",
			"Cameroon": "5086603",
			"Papua New Guinea": "19145",
			"Montserrat": "14500",
			"Panama": "49014739",
			"Colombia": "139101814",
			"Niger": "15000",
			"Palau": "160694",
			"Tonga": "35582",
			"Jordan": "2011393",
			"Fr. South Antarctic Terr.": "6461",
			"Uzbekistan": "296457",
			"Iraq": "217356",
			"Tuvalu": "521802",
			"Bosnia Herzegovina": "913906",
			"Pakistan": "120600",
			"Belgium": "5257366",
			"Azerbaijan": "6372972",
			"Armenia": "30238",
			"Togo": "165578",
			"Singapore": "185659061",
			"Albania": "329600",
			"Benin": "6000",
			"South Africa": "61706533",
			"FS Micronesia": "950254",
			"Indonesia": "3805309",
			"Qatar": "13025954",
			"Saint Vincent and the Grenadines": "8076637",
			"Curaçao": "1910847",
			"Australia": "1403276491",
			"Kiribati": "9567",
			"Bahrain": "799597",
			"Jamaica": "2043783",
			"Kenya": "397779",
			"Spain": "166228050",
			"Tajikistan": "122134",
			"Ireland": "1380426",
			"Botswana": "1584979",
			"South Sudan": "2778",
			"Norfolk Isds": "16163",
			"Mauritania": "811204",
			"Christmas Isds": "11472",
			"Honduras": "2992635",
			"Holy See (Vatican City State)": "15500",
			"United Kingdom": "114346581",
			"Chile": "36644934",
			"Gambia": "58786",
			"China, Macao SAR": "3944",
			"Dominica": "1471482",
			"Malaysia": "19975251",
			"Fiji": "16981",
			"Somalia": "10000",
			"Falkland Isds (Malvinas)": "5000",
			"Nepal": "81086",
			"China": "575305127",
			"Comoros": "304176",
			"Guinea-Bissau": "2067790",
			"Saint Maarten": "11186609",
			"Mali": "20100",
			"Trinidad and Tobago": "12741462",
			"Israel": "15269943",
			"Burkina Faso": "1325991",
			"Paraguay": "3420785",
			"French Polynesia": "2665486",
			"Bangladesh": "21225274",
			"Antigua and Barbuda": "5165698",
			"Gabon": "67927",
			"Cyprus": "2039159",
			"Yemen": "8914904",
			"Mauritius": "412968",
			"Slovakia": "41140",
			"Faeroe Isds": "45144",
			"Turkmenistan": "763000",
			"Syria": "43950",
			"Côte d'Ivoire": "547891",
			"Guyana": "819689",
			"Saint Pierre and Miquelon": "16517",
			"Algeria": "1134474",
			"Cambodia": "5925694",
			"Rep. of Moldova": "2575",
			"Zambia": "11914710",
			"Malta": "2860254",
			"Ecuador": "1936171682",
			"Grenada": "487128",
			"Dominican Rep.": "1396205574",
			"France": "42819527",
			"New Caledonia": "739808",
			"Niue": "30717",
			"Seychelles": "304695",
			"Br. Virgin Isds": "854301",
			"Italy": "47553213",
			"Saint Lucia": "1912455",
			"State of Palestine": "274507",
			"Rwanda": "9319",
			"Belarus": "629815",
			"Ethiopia": "170546",
			"Namibia": "86327",
			"Pitcairn": "43913",
			"Senegal": "907176",
			"Bulgaria": "1086773",
			"Montenegro": "3748181",
			"Sri Lanka": "31199151",
			"Hungary": "1390674",
			"Angola": "762057",
			"New Zealand": "45703458",
			"Lao People's Dem. Rep.": "5400",
			"Myanmar": "22710831",
			"Iran": "10285924",
			"Philippines": "7192329",
			"Uruguay": "5535068",
			"Andorra": "83138",
			"Cabo Verde": "18400",
			"Germany": "100039391",
			"Timor-Leste": "40063",
			"Poland": "23268315",
			"Thailand": "85643329",
			"Argentina": "67514014",
			"Brazil": "38228037",
			"Brunei Darussalam": "410677",
			"Mongolia": "158924",
			"Saudi Arabia": "583548",
			"Sudan": "454647",
			"Russian Federation": "26200",
			"Cayman Isds": "6485306",
			"United Arab Emirates": "411183379",
			"Nicaragua": "1434035",
			"Malawi": "3000",
			"Switzerland": "84156981",
			"El Salvador": "570440256",
			"Latvia": "539109",
			"Japan": "203638913",
			"Guinea": "46906",
			"Uganda": "574835",
			"Romania": "19669024",
			"Croatia": "118033",
			"Liberia": "70249",
			"Guatemala": "7205349",
			"Madagascar": "106710",
			"Bolivia (Plurinational State of)": "1435150",
			"Nigeria": "1796397",
			"Bahamas": "9619516",
			"San Marino": "630707",
			"Chad": "4804",
			"Viet Nam": "352024",
			"Haiti": "323959",
			"Tokelau": "182160",
			"Slovenia": "347222",
			"Oman": "2129863",
			"Sweden": "20896217",
			"Maldives": "1728443",
			"India": "329788326",
			"Mexico": "231630976",
			"Austria": "79439220",
			"Eritrea": "296873",
			"Congo": "12548",
			"Zimbabwe": "650721",
			"Vanuatu": "8030",
			"Peru": "137275997",
			"Swaziland": "9800",
			"Lithuania": "11871801",
			"Saint Kitts and Nevis": "13846",
			"Denmark": "70860740",
			"Portugal": "3077760",
			"Central African Rep.": "39500",
			"Netherlands": "41510549",
			"Costa Rica": "1181926253",
			"Equatorial Guinea": "1122793",
			"Greece": "6247404",
			"Kazakhstan": "117568",
			"Afghanistan": "49373",
			"Saint Helena": "51156",
			"Egypt": "50252049",
			"Nauru": "53993",
			"Anguilla": "22403",
			"Estonia": "299972",
			"Morocco": "6334940",
			"Luxembourg": "199904",
			"TFYR of Macedonia": "2821",
			"Heard Island and McDonald Islands": "5780",
			"Western Sahara": "18165",
			"United Rep. of Tanzania": "163845",
			"Finland": "13572329",
			"Belize": "1262093",
			"Georgia": "558740",
			"Ukraine": "30013616",
			"Bermuda": "3885021",
			"Djibouti": "85550",
			"Greenland": "968677",
			"China, Hong Kong SAR": "34855256",
			"Suriname": "4233977",
			"Barbados": "1836963",
			"Samoa": "206000",
			"Venezuela": "35500574",
			"Kuwait": "11619921",
			"Norway": "9641025",
			"Sierra Leone": "71169",
			"Marshall Isds": "72890322",
			"Sao Tome and Principe": "53564",
			"Libya": "136540",
			"Kyrgyzstan": "26000",
			"Czechia": "1584238",
			"Br. Indian Ocean Terr.": "394505",
			"Mozambique": "170998",
			"Aruba": "1541304",
			"Turkey": "197510963",
			"Tunisia": "3571652",
			"Rep. of Korea": "34967988",
			"Serbia": "111741",
			"Burundi": "662887",
			"Bhutan": "4547",
			"Cook Isds": "2306029",
			"Canada": "1421479000",
			"Iceland": "1973869"
		}
	},
	"Cambodia": {
		"imports": {},
		"exports": {}
	},
	"Rep. of Moldova": {
		"imports": {
			"Lebanon": "2458",
			"Gibraltar": "17030",
			"Fr. South Antarctic Terr.": "79",
			"Ghana": "1611427",
			"Sao Tome and Principe": "204",
			"Niger": "467",
			"Lesotho": "2814",
			"Andorra": "4",
			"United Kingdom": "942133",
			"Barbados": "23704",
			"Poland": "26670",
			"Cuba": "24566",
			"Dem. Rep. of the Congo": "151",
			"Thailand": "504162",
			"Dem. People's Rep. of Korea": "338",
			"Argentina": "2555300",
			"Brazil": "1166760",
			"Germany": "270316",
			"Dominica": "261",
			"Iran": "62939",
			"Mongolia": "8",
			"Montserrat": "47",
			"Panama": "30568",
			"Colombia": "100255",
			"Sudan": "2519",
			"Russian Federation": "5900",
			"United Arab Emirates": "18229",
			"Nicaragua": "300",
			"Tajikistan": "253",
			"Jordan": "816885",
			"Azerbaijan": "16658",
			"Malawi": "72",
			"Switzerland": "2026",
			"El Salvador": "1222",
			"Uruguay": "1007424",
			"Uzbekistan": "19544",
			"Latvia": "5493",
			"Japan": "189659",
			"Tunisia": "1972",
			"Bosnia Herzegovina": "10113",
			"Pakistan": "1840",
			"Belgium": "6729",
			"Croatia": "1055",
			"Belarus": "21285",
			"Madagascar": "10974",
			"Bolivia (Plurinational State of)": "196",
			"Nigeria": "1324",
			"Albania": "8978",
			"Afghanistan": "32",
			"Bahamas": "70838",
			"San Marino": "521054",
			"Mozambique": "289",
			"Viet Nam": "119",
			"Haiti": "4775",
			"South Africa": "104541",
			"Tokelau": "117",
			"Indonesia": "2050",
			"Qatar": "269942",
			"American Samoa": "681",
			"Oman": "5519",
			"Curaçao": "378",
			"Australia": "54",
			"Bahrain": "24",
			"India": "10345",
			"Mexico": "183574",
			"Jamaica": "211566",
			"Kenya": "1105",
			"Spain": "950729",
			"Romania": "24294",
			"Ireland": "286",
			"Sweden": "23162",
			"Zimbabwe": "9255",
			"Côte d'Ivoire": "17711",
			"Austria": "28091",
			"Mauritania": "40",
			"Lithuania": "132710",
			"Cambodia": "38826",
			"Denmark": "487",
			"Portugal": "104075",
			"Central African Rep.": "308",
			"Honduras": "2151",
			"Netherlands": "3853",
			"Costa Rica": "1193677",
			"Turkey": "25",
			"Greece": "2004",
			"Chile": "511828",
			"Kazakhstan": "1788335",
			"Turkmenistan": "11754",
			"China, Macao SAR": "11",
			"Nepal": "3861",
			"Armenia": "28341",
			"Saint Helena": "4203",
			"Malaysia": "7",
			"Swaziland": "8897",
			"Peru": "9413",
			"Falkland Isds (Malvinas)": "18062",
			"Egypt": "42421",
			"China": "1588291",
			"Comoros": "315",
			"Estonia": "938",
			"Morocco": "462024",
			"Luxembourg": "936",
			"Trinidad and Tobago": "59400",
			"Israel": "9876",
			"TFYR of Macedonia": "1476643",
			"Burkina Faso": "186",
			"Saudi Arabia": "3658",
			"Singapore": "269",
			"Paraguay": "26",
			"Czechia": "51625",
			"Antigua and Barbuda": "34",
			"United Rep. of Tanzania": "5840",
			"Finland": "12080",
			"Cyprus": "62353",
			"Belize": "222",
			"Georgia": "609000",
			"Slovakia": "11863",
			"Mali": "827",
			"Faeroe Isds": "1172723",
			"Greenland": "84372",
			"Syria": "14505",
			"Zambia": "21",
			"China, Hong Kong SAR": "84",
			"Guyana": "36270",
			"Mauritius": "37562",
			"Algeria": "602",
			"USA": "10132",
			"Namibia": "139",
			"Venezuela": "4755",
			"Kuwait": "16042",
			"Suriname": "841",
			"Malta": "764",
			"Norway": "206",
			"Ecuador": "901007",
			"Serbia": "343",
			"Sierra Leone": "11801",
			"Dominican Rep.": "212",
			"France": "705",
			"New Caledonia": "7",
			"Philippines": "1144",
			"Niue": "61",
			"Italy": "5114",
			"Kyrgyzstan": "540",
			"State of Palestine": "177",
			"Uganda": "760",
			"Guatemala": "24306",
			"Ethiopia": "83",
			"Slovenia": "23663",
			"Senegal": "67717",
			"Bulgaria": "2626175",
			"Montenegro": "32382",
			"Sri Lanka": "2369",
			"Rep. of Korea": "14534",
			"Bangladesh": "17848",
			"Hungary": "7936",
			"Burundi": "88",
			"New Zealand": "1104",
			"Canada": "1628810",
			"Iceland": "6512646",
			"Lao People's Dem. Rep.": "16311",
			"Ukraine": "35110",
			"Myanmar": "1680"
		},
		"exports": {
			"Lebanon": "6748242",
			"Gibraltar": "418781",
			"Ghana": "485670",
			"Andorra": "16870",
			"Cabo Verde": "50099",
			"Germany": "1046949",
			"Poland": "7836216",
			"Cuba": "6",
			"Dem. Rep. of the Congo": "21996",
			"Thailand": "438716",
			"United Rep. of Tanzania": "567",
			"Brazil": "16553",
			"Azerbaijan": "787085",
			"Burkina Faso": "62421",
			"Iran": "5025",
			"Mongolia": "180078",
			"Saudi Arabia": "39439",
			"Panama": "405274",
			"Colombia": "1367",
			"Sudan": "154395",
			"Niger": "16137",
			"United Arab Emirates": "43313",
			"Nicaragua": "39",
			"Tajikistan": "17347",
			"Jordan": "114030",
			"Switzerland": "29193612",
			"Uzbekistan": "781140",
			"Iraq": "22000599",
			"Japan": "292983",
			"Latvia": "181158",
			"Uganda": "5020",
			"Bosnia Herzegovina": "674708",
			"Pakistan": "80002",
			"Belgium": "17056",
			"Croatia": "182260",
			"Italy": "413595",
			"Australia": "121009",
			"United Kingdom": "8",
			"Singapore": "42743",
			"Nigeria": "674540",
			"Albania": "34066",
			"Benin": "21916",
			"Afghanistan": "5144",
			"Tunisia": "2683",
			"Viet Nam": "93951",
			"South Africa": "25401",
			"Indonesia": "3627801",
			"Qatar": "3413",
			"Oman": "429936",
			"Sweden": "14646",
			"Maldives": "28406",
			"Bahrain": "15640",
			"India": "147997",
			"Mexico": "19008",
			"Kenya": "41164",
			"Spain": "241117",
			"Romania": "280326",
			"Ireland": "97965",
			"Zimbabwe": "79648",
			"Côte d'Ivoire": "495162",
			"Austria": "6878251",
			"Lithuania": "1916015",
			"Namibia": "753",
			"Denmark": "4832",
			"Portugal": "33598",
			"Netherlands": "147563",
			"Turkey": "23266913",
			"Greece": "1169",
			"Chile": "20595",
			"Kazakhstan": "6720",
			"Armenia": "138698",
			"Malaysia": "10233911",
			"Swaziland": "118150",
			"Peru": "566",
			"Nepal": "66711",
			"China": "9999711",
			"Egypt": "130536",
			"Estonia": "2318211",
			"Morocco": "6308",
			"Mali": "26180",
			"Israel": "3634",
			"TFYR of Macedonia": "29746",
			"Somalia": "50133",
			"Bangladesh": "553799",
			"Yemen": "50363",
			"Gabon": "13654",
			"Finland": "17755",
			"Cyprus": "129786",
			"Belize": "338680",
			"Georgia": "8721225",
			"Hungary": "337058",
			"Luxembourg": "76652",
			"Cook Isds": "212",
			"Turkmenistan": "131267",
			"Syria": "4654934",
			"China, Hong Kong SAR": "43330",
			"Russian Federation": "60123",
			"USA": "13035409",
			"Cambodia": "100774",
			"Kuwait": "5591",
			"Malta": "24",
			"Norway": "46707",
			"Ecuador": "977",
			"France": "57125",
			"Philippines": "246439",
			"Seychelles": "14606",
			"Br. Virgin Isds": "36303",
			"Libya": "828143",
			"Kyrgyzstan": "931",
			"Czechia": "10513768",
			"Rwanda": "4314",
			"Belarus": "38123745",
			"Slovenia": "7580",
			"Congo": "2335",
			"Senegal": "268013",
			"Bulgaria": "17252369",
			"Montenegro": "40458",
			"Rep. of Korea": "175358",
			"Serbia": "126605",
			"Slovakia": "109893",
			"Argentina": "7225",
			"New Zealand": "734",
			"Canada": "842224",
			"Iceland": "13353",
			"Ukraine": "10957",
			"Myanmar": "4617493"
		}
	},
	"Zambia": {
		"imports": {},
		"exports": {}
	},
	"Malta": {
		"imports": {
			"Lebanon": "327825",
			"Gibraltar": "2717978",
			"Iran": "175066",
			"Sao Tome and Principe": "2",
			"Uruguay": "107472",
			"Marshall Isds": "27710888",
			"United Kingdom": "2186075",
			"Poland": "1806784",
			"Qatar": "10731",
			"Bolivia (Plurinational State of)": "405",
			"Thailand": "3000325",
			"Argentina": "1571",
			"Brazil": "518745",
			"Azerbaijan": "7067035",
			"Cameroon": "561294",
			"Ghana": "54",
			"Mongolia": "2061",
			"Saudi Arabia": "22204",
			"Panama": "908",
			"Colombia": "6017",
			"Syria": "78",
			"Russian Federation": "589",
			"Cayman Isds": "237",
			"United Arab Emirates": "133352",
			"Nicaragua": "157",
			"Tonga": "5489",
			"Angola": "43060",
			"Kazakhstan": "636",
			"Switzerland": "782960",
			"Georgia": "24064",
			"Slovakia": "70083",
			"Latvia": "202529",
			"Japan": "1554422",
			"Hungary": "3017",
			"Iraq": "520",
			"Uganda": "52342",
			"Bosnia Herzegovina": "45912",
			"Pakistan": "2707078",
			"Belgium": "6668046",
			"Croatia": "13601",
			"Italy": "69342225",
			"Armenia": "23998",
			"Germany": "20713",
			"Singapore": "80191",
			"Nigeria": "1247",
			"Albania": "25081",
			"Bahamas": "2102154",
			"Tunisia": "29278",
			"Viet Nam": "529036",
			"South Africa": "955222",
			"Tokelau": "235",
			"Indonesia": "202472",
			"Cuba": "67875",
			"American Samoa": "96",
			"Oman": "488",
			"Jordan": "217",
			"Sweden": "2045475",
			"Maldives": "45",
			"India": "254632",
			"Jamaica": "2434",
			"Mexico": "187085",
			"Kenya": "7903",
			"Spain": "26567322",
			"Romania": "2251808",
			"Ireland": "3191",
			"Botswana": "476529",
			"Zimbabwe": "60",
			"Côte d'Ivoire": "108110",
			"French Polynesia": "163",
			"Mauritania": "3209",
			"Lithuania": "43911",
			"Cambodia": "454602",
			"Eritrea": "618",
			"Peru": "7061",
			"Honduras": "64",
			"Netherlands": "2183984",
			"Costa Rica": "14789",
			"Austria": "81221",
			"Bulgaria": "159602",
			"Greece": "43836",
			"Chile": "2178911",
			"Slovenia": "3891103",
			"Sudan": "45",
			"China, Macao SAR": "12224",
			"Afghanistan": "113",
			"Montenegro": "1646067",
			"Saint Helena": "316",
			"Malaysia": "4295",
			"Swaziland": "14360",
			"Portugal": "593046",
			"United Rep. of Tanzania": "225603",
			"Nepal": "4543",
			"China": "450791",
			"Egypt": "16633134",
			"Estonia": "15583",
			"Morocco": "9450838",
			"Djibouti": "84414",
			"Belarus": "21382",
			"Israel": "1290685",
			"Venezuela": "258",
			"Paraguay": "13505",
			"Bangladesh": "267102",
			"Antigua and Barbuda": "82",
			"Gabon": "67666",
			"Finland": "64194",
			"Cyprus": "923",
			"Zambia": "1695",
			"Mauritius": "964",
			"Ukraine": "101594",
			"Bermuda": "2311",
			"Luxembourg": "84113",
			"Madagascar": "60",
			"Turkmenistan": "62607",
			"Bahrain": "924",
			"China, Hong Kong SAR": "13667888",
			"Niger": "365",
			"Algeria": "849",
			"USA": "68397927",
			"Namibia": "813399",
			"Rep. of Moldova": "68436",
			"TFYR of Macedonia": "9556",
			"Kuwait": "1358",
			"Suriname": "257246",
			"Vanuatu": "28",
			"Denmark": "3466366",
			"Norway": "58707",
			"Ecuador": "67",
			"Bouvet Island": "2559",
			"Sierra Leone": "78",
			"Dominican Rep.": "35658",
			"France": "1910269",
			"Tuvalu": "243",
			"Australia": "80666",
			"Philippines": "110838",
			"Seychelles": "219586",
			"Br. Virgin Isds": "50",
			"Libya": "3548",
			"Czechia": "2414",
			"Curaçao": "3658",
			"Mozambique": "4770948",
			"Ethiopia": "166",
			"Togo": "88710",
			"Congo": "207",
			"Senegal": "123",
			"Aruba": "174",
			"Turkey": "14872938",
			"San Marino": "183042",
			"Sri Lanka": "94169",
			"Rep. of Korea": "110415",
			"Serbia": "133897",
			"New Zealand": "165285",
			"Canada": "676700",
			"Iceland": "2255368",
			"Trinidad and Tobago": "68276",
			"Myanmar": "17041"
		},
		"exports": {
			"Lebanon": "63183",
			"Gibraltar": "132928",
			"Malawi": "1",
			"Ghana": "42376",
			"Sao Tome and Principe": "87511",
			"Niger": "515",
			"Lesotho": "1170507",
			"Marshall Isds": "18720",
			"Cabo Verde": "7265",
			"Germany": "30303585",
			"Poland": "913840",
			"Qatar": "1082862",
			"Dem. Rep. of the Congo": "1526",
			"Thailand": "99501",
			"Argentina": "13621",
			"Brazil": "133",
			"Cameroon": "3756475",
			"Brunei Darussalam": "133",
			"Iran": "262421",
			"Mongolia": "975",
			"Montserrat": "9970",
			"Panama": "183894",
			"Colombia": "147193",
			"Sudan": "1259710",
			"Russian Federation": "800",
			"Cayman Isds": "756718",
			"United Arab Emirates": "10596182",
			"Rwanda": "763060",
			"Yemen": "3701773",
			"Tonga": "3700",
			"Libya": "90764",
			"Kazakhstan": "506231",
			"Switzerland": "15238",
			"Mauritius": "113162",
			"Uruguay": "166",
			"Slovakia": "4324077",
			"Iraq": "24910",
			"Japan": "16157362",
			"Guinea": "2800271",
			"Bosnia Herzegovina": "35239",
			"Pakistan": "6903",
			"Belgium": "346224",
			"Azerbaijan": "20268",
			"China, Macao SAR": "8638",
			"Belarus": "3877",
			"Faeroe Isds": "21938",
			"United Kingdom": "4243834",
			"Singapore": "101428",
			"Barbados": "111",
			"Albania": "70085",
			"Benin": "1662",
			"Maldives": "151",
			"Bahamas": "983",
			"Tunisia": "11216",
			"Chad": "10656",
			"Viet Nam": "17794",
			"Haiti": "19614",
			"Mozambique": "462",
			"Indonesia": "31884492",
			"Oman": "5033378",
			"Uzbekistan": "383",
			"Curaçao": "1108",
			"Armenia": "1999",
			"India": "5039",
			"Jamaica": "2081493",
			"Mexico": "67224",
			"Kenya": "399507",
			"Austria": "7732",
			"Romania": "16380009",
			"Ireland": "113995",
			"Côte d'Ivoire": "16616",
			"Spain": "1339543",
			"Mauritania": "70801",
			"Swaziland": "8662",
			"Lithuania": "39878",
			"Cambodia": "983",
			"Denmark": "5948214",
			"Portugal": "71263",
			"Central African Rep.": "7324",
			"Netherlands": "4019809",
			"Costa Rica": "2575",
			"Burkina Faso": "9970",
			"Bulgaria": "26041",
			"Greece": "4159417",
			"Chile": "38780",
			"Australia": "75782",
			"Gambia": "1329",
			"Liberia": "90020",
			"Nepal": "312487",
			"Afghanistan": "1761",
			"Croatia": "1137501",
			"South Sudan": "599278",
			"Malaysia": "270984",
			"Fiji": "7",
			"Peru": "20094",
			"United Rep. of Tanzania": "1994",
			"Egypt": "3822",
			"China": "28658",
			"Comoros": "6336",
			"Guinea-Bissau": "210592",
			"Estonia": "17008",
			"Morocco": "2416053",
			"Djibouti": "288",
			"Trinidad and Tobago": "109638",
			"Israel": "789578",
			"TFYR of Macedonia": "61102",
			"Somalia": "1049526",
			"Saudi Arabia": "7703152",
			"Paraguay": "3431",
			"French Polynesia": "90",
			"Bangladesh": "4058",
			"Antigua and Barbuda": "53053",
			"Gabon": "13708",
			"Finland": "3539231",
			"San Marino": "10749",
			"Cyprus": "140713",
			"Belize": "2690",
			"Georgia": "27568",
			"Hungary": "5284936",
			"Bermuda": "455",
			"Mali": "2638",
			"South Africa": "35448",
			"Madagascar": "5118",
			"Aruba": "2019",
			"Turkmenistan": "15508",
			"Bahrain": "111",
			"Zambia": "1",
			"China, Hong Kong SAR": "10634",
			"Guyana": "75507",
			"Sweden": "4103108",
			"Algeria": "4224029",
			"USA": "350032",
			"Namibia": "318",
			"Rep. of Moldova": "172807",
			"Venezuela": "11640978",
			"Kuwait": "54279",
			"New Zealand": "5042",
			"Norway": "128879",
			"Serbia": "306581",
			"Sierra Leone": "13418",
			"Dominican Rep.": "44745",
			"France": "1273",
			"New Caledonia": "4915",
			"Philippines": "19009",
			"Latvia": "1060",
			"Seychelles": "48861",
			"Italy": "1077",
			"Kyrgyzstan": "111",
			"State of Palestine": "65578",
			"Uganda": "1505",
			"Nigeria": "2097",
			"Guatemala": "230",
			"Ethiopia": "824",
			"Slovenia": "1812772",
			"Togo": "138099",
			"Congo": "843",
			"Senegal": "3341010",
			"Lao People's Dem. Rep.": "4089",
			"Turkey": "33571",
			"Montenegro": "3822",
			"Sri Lanka": "222",
			"Rep. of Korea": "5865110",
			"Jordan": "9637",
			"Holy See (Vatican City State)": "8556",
			"Angola": "13",
			"Canada": "1812931",
			"Iceland": "543120",
			"Czechia": "6547041",
			"Ukraine": "14335",
			"Luxembourg": "1521",
			"Myanmar": "25707"
		}
	},
	"Ecuador": {
		"imports": {
			"Lebanon": "14518",
			"Gibraltar": "59207",
			"Ghana": "4655",
			"Lesotho": "3475",
			"Cuba": "18",
			"Dem. People's Rep. of Korea": "29960",
			"Cameroon": "1602",
			"South Africa": "3118",
			"Panama": "4491032",
			"Colombia": "55972672",
			"Niger": "143",
			"Angola": "694",
			"Uzbekistan": "88",
			"Guam": "150",
			"Bosnia Herzegovina": "50136",
			"Vanuatu": "10116",
			"Belgium": "92024",
			"Armenia": "248",
			"United Kingdom": "3434305",
			"Singapore": "3345653",
			"Albania": "47682",
			"Indonesia": "12717161",
			"Qatar": "148",
			"American Samoa": "31970",
			"Curaçao": "186997",
			"Australia": "25284",
			"Kiribati": "114653",
			"Mexico": "37621516",
			"Br. Virgin Isds": "24467",
			"Spain": "16339014",
			"Ireland": "2541803",
			"Mauritania": "7625",
			"Christmas Isds": "904",
			"Honduras": "20989",
			"Saint Barthélemy": "52",
			"Holy See (Vatican City State)": "468",
			"Chile": "1352633",
			"Liberia": "1",
			"Dominica": "520",
			"Malaysia": "374635",
			"Swaziland": "68245",
			"Portugal": "149222",
			"Nepal": "12703",
			"China": "271083009",
			"Comoros": "118",
			"Mali": "8194",
			"Trinidad and Tobago": "112",
			"Israel": "70593",
			"Paraguay": "12724",
			"Bangladesh": "5960407",
			"Antigua and Barbuda": "43",
			"Gabon": "2496",
			"Cyprus": "13953",
			"Mauritius": "2972",
			"Slovakia": "800",
			"Turkmenistan": "64289",
			"Bahrain": "883",
			"Côte d'Ivoire": "23818",
			"Guyana": "1521599",
			"USA": "38520541",
			"Saint Kitts and Nevis": "348",
			"Rep. of Moldova": "5",
			"Malta": "9205",
			"Dominican Rep.": "28734",
			"France": "5334551",
			"New Caledonia": "32",
			"Seychelles": "198",
			"Italy": "3538264",
			"Saint Lucia": "48",
			"State of Palestine": "397",
			"Rwanda": "79",
			"Belarus": "20527",
			"Ethiopia": "3312",
			"Namibia": "29",
			"Congo": "1034",
			"Slovenia": "4174189",
			"Bulgaria": "360322",
			"Montenegro": "147",
			"Sri Lanka": "1098140",
			"Hungary": "175305",
			"Jordan": "316774",
			"N. Mariana Isds": "707",
			"Lao People's Dem. Rep.": "59986",
			"Myanmar": "271063",
			"Iran": "99",
			"Philippines": "20",
			"Uruguay": "7003893",
			"Andorra": "16584",
			"Cabo Verde": "254",
			"Germany": "5009138",
			"Timor-Leste": "30",
			"Poland": "1935633",
			"Thailand": "115220",
			"Argentina": "836592",
			"Brazil": "21095721",
			"Brunei Darussalam": "14520",
			"Mongolia": "3690",
			"Saudi Arabia": "148",
			"Syria": "489280",
			"Russian Federation": "2378852",
			"United Arab Emirates": "88748",
			"Nicaragua": "27839",
			"Malawi": "10861",
			"Switzerland": "5403842",
			"El Salvador": "68733",
			"United States Minor Outlying Islands": "103",
			"Latvia": "2240",
			"Japan": "738880",
			"Romania": "4147",
			"Croatia": "65384",
			"China, Macao SAR": "497",
			"Guatemala": "105221",
			"Madagascar": "208",
			"Bolivia (Plurinational State of)": "180453",
			"Barbados": "13133",
			"Bahamas": "175401",
			"San Marino": "28497",
			"Viet Nam": "162313",
			"Haiti": "2134",
			"Tokelau": "37178",
			"Oman": "36",
			"Sweden": "55910",
			"Maldives": "3028",
			"India": "254165",
			"Jamaica": "1689",
			"Austria": "320567",
			"Eritrea": "83",
			"Pakistan": "486881",
			"Senegal": "56",
			"Fiji": "47246",
			"Lithuania": "4237",
			"Cambodia": "5027228",
			"Denmark": "593186",
			"Peru": "43295763",
			"Netherlands": "9641319",
			"Costa Rica": "150966",
			"Equatorial Guinea": "17779",
			"Sudan": "47394",
			"Papua New Guinea": "22318",
			"Kazakhstan": "4613",
			"Kenya": "2622",
			"Afghanistan": "779",
			"Greece": "35657",
			"Egypt": "205",
			"Nauru": "19119",
			"Estonia": "1934",
			"Morocco": "256958",
			"Luxembourg": "276465",
			"Venezuela": "2111678",
			"Somalia": "149",
			"Western Sahara": "5286",
			"United Rep. of Tanzania": "22",
			"Finland": "146683",
			"Belize": "5800",
			"Georgia": "2626",
			"Ukraine": "5598",
			"Bermuda": "168",
			"China, Hong Kong SAR": "1025852",
			"Suriname": "62483",
			"Nigeria": "62",
			"Samoa": "211350",
			"TFYR of Macedonia": "9273",
			"Kuwait": "18247",
			"New Zealand": "2841",
			"Norway": "155915",
			"Sierra Leone": "1051",
			"Sao Tome and Principe": "240",
			"Kyrgyzstan": "682",
			"Czechia": "311527",
			"Br. Indian Ocean Terr.": "14531",
			"Mozambique": "33",
			"Aruba": "32850",
			"Turkey": "323123",
			"Tunisia": "37896",
			"Rep. of Korea": "1887947",
			"Serbia": "2952",
			"Burundi": "135",
			"Cook Isds": "181",
			"Canada": "471821",
			"Iceland": "4165"
		},
		"exports": {
			"Lebanon": "665039",
			"Ghana": "122272",
			"Uruguay": "6666113",
			"Marshall Isds": "122900",
			"Cabo Verde": "140400",
			"Germany": "1376790",
			"Poland": "18760947",
			"Cuba": "165646",
			"Thailand": "166346",
			"Dem. People's Rep. of Korea": "228",
			"Argentina": "101361",
			"Brazil": "97001",
			"Azerbaijan": "10",
			"Cameroon": "1370",
			"Brunei Darussalam": "473",
			"Iran": "28480",
			"Mongolia": "18107",
			"Saudi Arabia": "1674674",
			"Indonesia": "3729",
			"Colombia": "23100546",
			"Sudan": "150",
			"Russian Federation": "58781517",
			"Cayman Isds": "63400",
			"United Arab Emirates": "2309705",
			"Nicaragua": "1047441",
			"Tajikistan": "180244",
			"Angola": "204600",
			"Switzerland": "31901",
			"El Salvador": "104110",
			"Saint Lucia": "211",
			"Slovakia": "629444",
			"Iraq": "27953",
			"Japan": "1838536",
			"Guam": "310370",
			"Latvia": "141218",
			"Bosnia Herzegovina": "90",
			"Pakistan": "17825",
			"Belgium": "249980",
			"Croatia": "60725",
			"Belarus": "2464285",
			"United Kingdom": "32723727",
			"Bolivia (Plurinational State of)": "1088540",
			"Barbados": "111632",
			"Albania": "27640",
			"Benin": "213294",
			"Maldives": "137478",
			"Bahamas": "67918",
			"Tunisia": "12170",
			"Mozambique": "102300",
			"Viet Nam": "38716769",
			"Haiti": "31383",
			"South Africa": "376748",
			"Panama": "5527796",
			"Qatar": "5702",
			"American Samoa": "178370",
			"Saint Vincent and the Grenadines": "9268",
			"Oman": "86577",
			"Uzbekistan": "712327",
			"Curaçao": "100839",
			"Australia": "271271",
			"Kiribati": "163350",
			"India": "47434",
			"Mexico": "42596277",
			"Jamaica": "101694",
			"Kenya": "7318",
			"Spain": "236163653",
			"Romania": "2604217",
			"Ireland": "2625",
			"Côte d'Ivoire": "15418",
			"Austria": "29579",
			"Suriname": "10963",
			"Lithuania": "538622",
			"Cambodia": "14000",
			"Denmark": "6793",
			"Portugal": "11352215",
			"Syria": "799696",
			"Honduras": "73395",
			"Netherlands": "139381728",
			"Costa Rica": "339889",
			"Papua New Guinea": "703",
			"Turkey": "2184543",
			"Greece": "85580",
			"Chile": "4968596",
			"Kazakhstan": "7612767",
			"Gambia": "35866",
			"China, Macao SAR": "2618",
			"Libya": "607339",
			"Afghanistan": "1800",
			"Mali": "150",
			"Dominica": "6232",
			"Malaysia": "21461",
			"Peru": "36043436",
			"United Rep. of Tanzania": "85050",
			"Armenia": "9698",
			"China": "35371",
			"Egypt": "32000",
			"Guinea-Bissau": "21000",
			"Saint Maarten": "976",
			"Estonia": "227",
			"Morocco": "726724",
			"Djibouti": "2867",
			"Trinidad and Tobago": "1082312",
			"Israel": "21380",
			"Venezuela": "16127792",
			"Singapore": "11479",
			"Paraguay": "627608",
			"French Polynesia": "49028",
			"Bangladesh": "1481690",
			"Yemen": "73342",
			"Antigua and Barbuda": "10953",
			"Gabon": "15947",
			"Finland": "51136",
			"Cyprus": "47837",
			"Belize": "5506",
			"Georgia": "1827815",
			"Serbia": "356588",
			"Luxembourg": "1991",
			"Malta": "613018",
			"Madagascar": "16064",
			"Turkmenistan": "2113",
			"Bahrain": "5616",
			"China, Hong Kong SAR": "157435",
			"Guyana": "2295",
			"Sweden": "787866",
			"Algeria": "303062",
			"USA": "279770112",
			"Saint Kitts and Nevis": "22519",
			"Rep. of Moldova": "569520",
			"TFYR of Macedonia": "146900",
			"Kuwait": "258341",
			"New Zealand": "325205",
			"Norway": "10979529",
			"Grenada": "60462",
			"Dominican Rep.": "1120413",
			"France": "1340903",
			"New Caledonia": "1196",
			"Philippines": "171113",
			"Seychelles": "3246",
			"Italy": "365571",
			"Kyrgyzstan": "2088041",
			"Czechia": "27265",
			"Uganda": "500",
			"Nigeria": "92962",
			"Guatemala": "653657",
			"Ethiopia": "17172",
			"Slovenia": "48862",
			"Mauritius": "34875",
			"Congo": "25639",
			"Senegal": "112375",
			"Aruba": "98966",
			"Bulgaria": "52",
			"Montenegro": "10163485",
			"Sri Lanka": "62204",
			"Rep. of Korea": "1240608",
			"Hungary": "7479",
			"Jordan": "98820",
			"N. Mariana Isds": "19456",
			"Canada": "336596",
			"Iceland": "168",
			"Ukraine": "7888398"
		}
	},
	"Grenada": {
		"imports": {},
		"exports": {}
	},
	"Portugal": {
		"imports": {
			"Lebanon": "13400",
			"Gibraltar": "443478",
			"Ghana": "3369544",
			"Qatar": "72537",
			"Dem. Rep. of the Congo": "6771",
			"Cameroon": "58612",
			"South Africa": "6963842",
			"Indonesia": "804399",
			"Colombia": "5258",
			"Saint Pierre and Miquelon": "881357",
			"Jordan": "197",
			"Uzbekistan": "29056",
			"Iraq": "208177805",
			"Bosnia Herzegovina": "658287",
			"Pakistan": "1891657",
			"Belgium": "6850511",
			"Azerbaijan": "308",
			"Rwanda": "1025",
			"Armenia": "62",
			"United Kingdom": "20469702",
			"Singapore": "3721",
			"Albania": "17434",
			"Benin": "1442654",
			"Panama": "16404",
			"Cuba": "4417567",
			"American Samoa": "482488",
			"Curaçao": "515",
			"Australia": "19045",
			"Mexico": "2415",
			"Kenya": "621",
			"Spain": "674143413",
			"Tajikistan": "2307",
			"Ireland": "27172059",
			"Botswana": "943",
			"French Polynesia": "3933",
			"Mauritania": "384299",
			"Honduras": "4139977",
			"Saint Barthélemy": "19",
			"Chile": "328975",
			"Gambia": "434056",
			"China, Macao SAR": "1034",
			"Brunei Darussalam": "163",
			"Malaysia": "7240",
			"Swaziland": "884659",
			"Peru": "1234681",
			"Falkland Isds (Malvinas)": "36010",
			"Nepal": "49",
			"China": "4257656",
			"Comoros": "4428",
			"Guinea-Bissau": "8029",
			"Mali": "131230",
			"Trinidad and Tobago": "190",
			"Israel": "2031",
			"Burkina Faso": "179",
			"Paraguay": "95501686",
			"Bangladesh": "225725",
			"Antigua and Barbuda": "77483",
			"Gabon": "41113805",
			"Cyprus": "2101005",
			"Mauritius": "12028941",
			"Slovakia": "473730",
			"Faeroe Isds": "74977",
			"Turkmenistan": "1441",
			"Bahrain": "2365",
			"Côte d'Ivoire": "7220",
			"Guyana": "31323063",
			"Algeria": "387",
			"USA": "4313520",
			"Cambodia": "5911096",
			"Rep. of Moldova": "5151931",
			"Zambia": "2787499",
			"Malta": "1950",
			"Ecuador": "11132751",
			"Dominican Rep.": "16427",
			"France": "12858391",
			"New Caledonia": "14943",
			"Seychelles": "277",
			"Br. Virgin Isds": "157",
			"Italy": "10781819",
			"State of Palestine": "1046",
			"Uganda": "3585646",
			"Belarus": "1003",
			"Ethiopia": "3768439",
			"Congo": "2600013",
			"Senegal": "1066597",
			"Bulgaria": "63772",
			"Montenegro": "13066",
			"Sri Lanka": "25",
			"Hungary": "710",
			"Angola": "115397",
			"New Zealand": "23833",
			"Lao People's Dem. Rep.": "1685279",
			"Myanmar": "1426456",
			"Iran": "2892",
			"Sao Tome and Principe": "13283",
			"Uruguay": "7980155",
			"Andorra": "9470",
			"Cabo Verde": "85462",
			"Germany": "20021894",
			"Timor-Leste": "937548",
			"Poland": "10977402",
			"Thailand": "1793",
			"Argentina": "9171982",
			"Brazil": "294187",
			"Dominica": "392",
			"Mongolia": "174",
			"Saudi Arabia": "481808817",
			"Syria": "744",
			"Russian Federation": "662",
			"Cayman Isds": "179",
			"United Arab Emirates": "25539",
			"Nicaragua": "12139376",
			"Malawi": "1751",
			"Switzerland": "57285",
			"El Salvador": "971833",
			"United States Minor Outlying Islands": "4765",
			"Latvia": "475",
			"Japan": "970155",
			"Guinea": "7",
			"Romania": "28338266",
			"Slovenia": "174928",
			"Liberia": "47578",
			"Guatemala": "166507",
			"Madagascar": "114935",
			"Bolivia (Plurinational State of)": "97057",
			"Nigeria": "389859",
			"Bahamas": "2320",
			"Tunisia": "9373",
			"Chad": "624241",
			"Viet Nam": "41306",
			"Haiti": "3509",
			"Tokelau": "18",
			"Oman": "2124",
			"Sweden": "12510",
			"Maldives": "5578",
			"India": "164",
			"Jamaica": "1042",
			"Austria": "7247073",
			"Zimbabwe": "2735614",
			"Saint Maarten": "1854",
			"Fiji": "439988",
			"Lithuania": "581569",
			"Namibia": "784535",
			"Denmark": "4255",
			"Central African Rep.": "24183",
			"Netherlands": "7837726",
			"Costa Rica": "193656",
			"Equatorial Guinea": "42835",
			"Greece": "326686",
			"Papua New Guinea": "173599",
			"Kazakhstan": "333949450",
			"Afghanistan": "16755",
			"Croatia": "16460",
			"Saint Helena": "128157",
			"Egypt": "4032",
			"Estonia": "7759",
			"Morocco": "4583",
			"Luxembourg": "1234",
			"TFYR of Macedonia": "60743",
			"United Rep. of Tanzania": "7181303",
			"Finland": "523221",
			"Belize": "1082476",
			"Georgia": "48427",
			"Ukraine": "2930",
			"Bermuda": "593",
			"Djibouti": "60346",
			"Greenland": "520041",
			"China, Hong Kong SAR": "9947",
			"Suriname": "1317237",
			"Barbados": "1216",
			"Venezuela": "7957",
			"Kuwait": "3155",
			"Norway": "46147",
			"Sierra Leone": "369953",
			"Marshall Isds": "3504",
			"Philippines": "25150",
			"Libya": "221",
			"Kyrgyzstan": "94767",
			"Czechia": "63212",
			"Mozambique": "5397",
			"Togo": "97171",
			"Aruba": "729",
			"Turkey": "513991",
			"San Marino": "18586",
			"Rep. of Korea": "381044",
			"Serbia": "1",
			"Burundi": "386",
			"Bhutan": "3689",
			"Cook Isds": "210",
			"Canada": "168393",
			"Iceland": "55"
		},
		"exports": {
			"Lebanon": "12431",
			"Bonaire": "4645",
			"Gibraltar": "291374",
			"Ghana": "2324",
			"Lesotho": "57934",
			"Qatar": "58393",
			"Dem. Rep. of the Congo": "118236",
			"Dem. People's Rep. of Korea": "21001",
			"Cameroon": "270086",
			"South Africa": "76389",
			"Montserrat": "1970",
			"Indonesia": "98779",
			"Colombia": "36349",
			"Niger": "24536",
			"Jordan": "224",
			"Fr. South Antarctic Terr.": "11612",
			"Uzbekistan": "88486",
			"Iraq": "138828",
			"Tuvalu": "41",
			"Guam": "470",
			"Bosnia Herzegovina": "603263",
			"Pakistan": "1238",
			"Belgium": "7771697",
			"Azerbaijan": "31055",
			"Rwanda": "111",
			"Armenia": "329239",
			"United Kingdom": "1755",
			"Singapore": "4792",
			"Albania": "110135",
			"Benin": "11068",
			"Panama": "22470",
			"Cuba": "876839",
			"Saint Vincent and the Grenadines": "35978",
			"Curaçao": "312",
			"Australia": "268039",
			"Kiribati": "211",
			"Bahrain": "266925",
			"Mexico": "63676",
			"Kenya": "2699476",
			"Spain": "1892628",
			"Tajikistan": "80",
			"Ireland": "225899",
			"Botswana": "2157",
			"South Sudan": "3104",
			"French Polynesia": "22689",
			"Mauritania": "1317797",
			"Honduras": "274",
			"Saint Barthélemy": "51144",
			"Cambodia": "17063",
			"Holy See (Vatican City State)": "7839",
			"Chile": "79893",
			"Gambia": "113134",
			"China, Macao SAR": "13278",
			"Brunei Darussalam": "41",
			"Malaysia": "42",
			"Swaziland": "2205216",
			"Somalia": "18039",
			"Falkland Isds (Malvinas)": "188",
			"Nepal": "20938",
			"China": "363748",
			"Comoros": "37122",
			"Guinea-Bissau": "27523",
			"Saint Maarten": "146321",
			"Mali": "134",
			"Trinidad and Tobago": "57475",
			"Israel": "80007",
			"Burkina Faso": "115503",
			"Paraguay": "122800",
			"Bangladesh": "95",
			"Antigua and Barbuda": "16185",
			"Gabon": "998",
			"Cyprus": "453114",
			"Yemen": "67679",
			"Mauritius": "93079",
			"Slovakia": "24695",
			"Faeroe Isds": "662",
			"Turkmenistan": "956527",
			"Syria": "3320",
			"Côte d'Ivoire": "61758",
			"Guyana": "44271",
			"Saint Pierre and Miquelon": "6524",
			"Algeria": "63086",
			"USA": "1071099",
			"Saint Kitts and Nevis": "13405",
			"Rep. of Moldova": "16602",
			"Zambia": "55780",
			"Malta": "33544",
			"Ecuador": "5938",
			"Grenada": "1111",
			"Dominican Rep.": "458",
			"France": "77452049",
			"New Caledonia": "12446",
			"Seychelles": "24",
			"Br. Virgin Isds": "4269",
			"Italy": "21414546",
			"Saint Lucia": "51",
			"State of Palestine": "215693",
			"Uganda": "1709",
			"Belarus": "15439",
			"Ethiopia": "1189026",
			"Congo": "350167",
			"Senegal": "2780860",
			"Bulgaria": "65832",
			"Montenegro": "2713",
			"Sri Lanka": "61800",
			"Hungary": "7492282",
			"Angola": "2396461",
			"New Zealand": "332",
			"N. Mariana Isds": "858",
			"Lao People's Dem. Rep.": "256",
			"Myanmar": "15907",
			"Iran": "5143",
			"Sao Tome and Principe": "856671",
			"Uruguay": "100996",
			"Andorra": "13026",
			"Cabo Verde": "221287",
			"Germany": "8936508",
			"Timor-Leste": "918",
			"Poland": "56207",
			"Thailand": "18815",
			"Argentina": "38516",
			"Brazil": "908458",
			"Dominica": "84392",
			"Mongolia": "130568",
			"Saudi Arabia": "4066186",
			"Greece": "172405",
			"Russian Federation": "559",
			"Cayman Isds": "30755",
			"United Arab Emirates": "321337",
			"Nicaragua": "52503",
			"Malawi": "53",
			"Switzerland": "175",
			"El Salvador": "404347",
			"United States Minor Outlying Islands": "5977",
			"Latvia": "5763",
			"Japan": "448191",
			"Guinea": "321",
			"Romania": "4641",
			"Slovenia": "49889",
			"Liberia": "39309",
			"Mozambique": "27512",
			"Madagascar": "9518",
			"Bolivia (Plurinational State of)": "1335",
			"Nigeria": "102887",
			"Bahamas": "311",
			"Tunisia": "2351359",
			"Chad": "22279",
			"Viet Nam": "2235943",
			"Haiti": "7747",
			"Oman": "5171",
			"Sweden": "946646",
			"Maldives": "69468",
			"India": "1214",
			"Jamaica": "204",
			"Austria": "455341",
			"Zimbabwe": "587695",
			"Vanuatu": "249",
			"Fiji": "2609",
			"Lithuania": "69894",
			"Namibia": "34052",
			"Denmark": "741609",
			"Peru": "111",
			"Central African Rep.": "282",
			"Netherlands": "756406",
			"Costa Rica": "726642",
			"Equatorial Guinea": "3542",
			"Sudan": "4469",
			"Papua New Guinea": "6190",
			"Kazakhstan": "277100",
			"Afghanistan": "340490",
			"Croatia": "22619",
			"Egypt": "314817",
			"Nauru": "33",
			"Anguilla": "30",
			"Estonia": "117797",
			"Morocco": "4520487",
			"Luxembourg": "37007",
			"TFYR of Macedonia": "35417",
			"United Rep. of Tanzania": "804036",
			"Finland": "190039",
			"Belize": "3248",
			"Georgia": "66",
			"Ukraine": "3984",
			"Bermuda": "15827",
			"Djibouti": "17088867",
			"Greenland": "108464",
			"China, Hong Kong SAR": "46858",
			"Suriname": "76152",
			"Barbados": "15434",
			"Venezuela": "14754",
			"Kuwait": "20586",
			"Norway": "138",
			"Sierra Leone": "50854",
			"Marshall Isds": "20926",
			"Philippines": "277",
			"Libya": "11312",
			"Kyrgyzstan": "51779",
			"Czechia": "224396",
			"Guatemala": "442708",
			"Togo": "53595",
			"Aruba": "5400",
			"Turkey": "511882",
			"San Marino": "152",
			"Rep. of Korea": "183617",
			"Serbia": "46650",
			"Burundi": "15495",
			"Canada": "237306",
			"Iceland": "28806"
		}
	},
	"France": {
		"imports": {
			"Lebanon": "463",
			"Bonaire": "2775801",
			"Gibraltar": "47480",
			"Ghana": "10871",
			"Lesotho": "3419",
			"Cuba": "5128252",
			"Dem. Rep. of the Congo": "1437",
			"Dem. People's Rep. of Korea": "1136",
			"Cameroon": "52680105",
			"Papua New Guinea": "6938092",
			"Montserrat": "314",
			"Panama": "1125565",
			"Colombia": "356001",
			"Niger": "64274",
			"Palau": "6878",
			"Tonga": "285881",
			"Angola": "7176",
			"Fr. South Antarctic Terr.": "7642323",
			"Uzbekistan": "316347",
			"Iraq": "1945",
			"Tuvalu": "5244",
			"Guam": "21983",
			"Bosnia Herzegovina": "71593",
			"Pakistan": "901",
			"Belgium": "664655906",
			"Azerbaijan": "8533",
			"Armenia": "1181",
			"Togo": "10946",
			"Singapore": "82285",
			"Albania": "1743",
			"Benin": "3100327",
			"United Kingdom": "97841286",
			"South Africa": "10311850",
			"FS Micronesia": "2524",
			"Indonesia": "1796",
			"Qatar": "423",
			"American Samoa": "732007",
			"Saint Vincent and the Grenadines": "8072429",
			"Curaçao": "34399",
			"Australia": "2024087",
			"Kiribati": "1673",
			"Mexico": "4370344",
			"Br. Virgin Isds": "3818280",
			"Spain": "22552158",
			"Tajikistan": "15018",
			"Ireland": "316300",
			"Botswana": "68210",
			"South Sudan": "162",
			"French Polynesia": "1008408",
			"Mauritania": "1477",
			"Christmas Isds": "94",
			"Honduras": "10273661",
			"Saint Barthélemy": "22262",
			"Holy See (Vatican City State)": "4339",
			"Eritrea": "189",
			"Chile": "244915",
			"Sudan": "436990",
			"Gambia": "59216",
			"Liberia": "9323",
			"Dominica": "867313",
			"Malaysia": "8679",
			"Fiji": "758850",
			"Peru": "32023755",
			"Falkland Isds (Malvinas)": "178605",
			"Nepal": "250",
			"China": "1581315648",
			"Comoros": "11880",
			"Guinea-Bissau": "6883",
			"Saint Maarten": "141862",
			"Mali": "367",
			"Trinidad and Tobago": "73434",
			"Israel": "60944",
			"Burkina Faso": "1527",
			"Paraguay": "140268",
			"Norfolk Isds": "80",
			"Bangladesh": "29340576",
			"Antigua and Barbuda": "157",
			"Gabon": "6458",
			"Cyprus": "11144853",
			"Yemen": "716146",
			"Mauritius": "6459",
			"Slovakia": "1894660",
			"Faeroe Isds": "17587159",
			"Turkmenistan": "149",
			"Bahrain": "135453",
			"Côte d'Ivoire": "166",
			"Guyana": "3700297",
			"Saint Pierre and Miquelon": "33754",
			"Algeria": "656528",
			"USA": "88641749",
			"Namibia": "2049107",
			"Rep. of Moldova": "618157",
			"Zambia": "26291",
			"Malta": "4428453",
			"Ecuador": "276336805",
			"Grenada": "987",
			"Dominican Rep.": "79938833",
			"New Caledonia": "439754",
			"Niue": "905",
			"Seychelles": "463718",
			"Italy": "397657701",
			"Saint Lucia": "29717",
			"State of Palestine": "410282",
			"Rwanda": "609852",
			"Syria": "245",
			"Belarus": "2312967",
			"Ethiopia": "743503",
			"Slovenia": "1353260",
			"Congo": "437259",
			"Senegal": "3254",
			"Bulgaria": "6096574",
			"Montenegro": "1591",
			"Sri Lanka": "46632040",
			"Hungary": "6309606",
			"Jordan": "598",
			"N. Mariana Isds": "12470",
			"Lao People's Dem. Rep.": "1539",
			"Myanmar": "27073",
			"Iran": "2042536",
			"Sao Tome and Principe": "14144",
			"Uruguay": "657",
			"Switzerland": "19131131",
			"Cabo Verde": "46333",
			"Germany": "10969801635",
			"Timor-Leste": "497",
			"Poland": "64004029",
			"Thailand": "88975871",
			"Argentina": "27752891",
			"Brazil": "14196941",
			"Brunei Darussalam": "73262",
			"Mongolia": "33332",
			"Saudi Arabia": "1112686",
			"Greece": "1693",
			"Russian Federation": "136080",
			"Cayman Isds": "6083285",
			"United Arab Emirates": "144748",
			"Nicaragua": "158973",
			"Malawi": "8868",
			"Andorra": "17395",
			"El Salvador": "2054190",
			"United States Minor Outlying Islands": "456",
			"Sierra Leone": "39091",
			"Latvia": "88526",
			"Japan": "448478261",
			"Guinea": "141700",
			"Uganda": "1314872",
			"Romania": "27232886",
			"Croatia": "31510144",
			"China, Macao SAR": "6108",
			"Mozambique": "3945",
			"Madagascar": "17341",
			"Bolivia (Plurinational State of)": "395805",
			"Barbados": "30648",
			"Saint Kitts and Nevis": "295",
			"Bahamas": "26432624",
			"San Marino": "629445",
			"Chad": "7976",
			"Viet Nam": "1879926",
			"Haiti": "336259",
			"Tokelau": "43437",
			"Oman": "86528",
			"Sweden": "8014559",
			"Maldives": "13127998",
			"India": "16356644",
			"Jamaica": "55329",
			"Austria": "22527391",
			"Bouvet Island": "2318",
			"Zimbabwe": "103571",
			"Vanuatu": "995913",
			"Swaziland": "4640092",
			"Lithuania": "1410939",
			"Cambodia": "6508",
			"Denmark": "69920278",
			"Portugal": "90353125",
			"Central African Rep.": "6254",
			"Netherlands": "114866804",
			"Costa Rica": "641143",
			"Equatorial Guinea": "398",
			"South Georgia and the South Sandwich Islands": "131",
			"Kazakhstan": "2550054",
			"Kenya": "89",
			"Afghanistan": "2029264",
			"Saint Helena": "1176",
			"Egypt": "39839",
			"Nauru": "27694",
			"Anguilla": "15035",
			"Estonia": "8145789",
			"Morocco": "56841",
			"Antarctica": "2990",
			"TFYR of Macedonia": "2384909",
			"Somalia": "9843",
			"Western Sahara": "225",
			"United Rep. of Tanzania": "859",
			"Finland": "52641248",
			"Belize": "248972",
			"Georgia": "9786560",
			"Ukraine": "1452183",
			"Bermuda": "220029",
			"Djibouti": "315",
			"Greenland": "669641",
			"China, Hong Kong SAR": "57003151",
			"Suriname": "3009",
			"Nigeria": "326356733",
			"Samoa": "517",
			"Venezuela": "4695",
			"Kuwait": "2948",
			"New Zealand": "353633",
			"Norway": "1517313",
			"Pitcairn": "74",
			"Marshall Isds": "706264",
			"Philippines": "2985876",
			"Libya": "155",
			"Kyrgyzstan": "1938",
			"Czechia": "5364864",
			"Br. Indian Ocean Terr.": "9503",
			"Guatemala": "3402623",
			"Aruba": "153",
			"Turkey": "12291245",
			"Tunisia": "15176491",
			"Rep. of Korea": "679648",
			"Serbia": "112922",
			"Burundi": "133452",
			"Bhutan": "711133",
			"Cook Isds": "102",
			"Canada": "22508715",
			"Iceland": "475885",
			"Luxembourg": "8931532"
		},
		"exports": {
			"Lebanon": "1596748",
			"Bonaire": "2355",
			"Gibraltar": "510685",
			"Ghana": "14129628",
			"Lesotho": "3486",
			"Cuba": "8427298",
			"Dem. Rep. of the Congo": "3897735",
			"Dem. People's Rep. of Korea": "437004",
			"Cameroon": "35552278",
			"Papua New Guinea": "65402914",
			"Montserrat": "40107",
			"Panama": "6609745",
			"Colombia": "93383344",
			"Niger": "1802",
			"Palau": "440",
			"Tonga": "4780",
			"Angola": "46945530",
			"Fr. South Antarctic Terr.": "55782",
			"Uzbekistan": "1160",
			"Iraq": "5611321",
			"Tuvalu": "120",
			"Guam": "1163550",
			"Bosnia Herzegovina": "139721",
			"Vanuatu": "88693",
			"Belgium": "714953575",
			"Azerbaijan": "349847",
			"Australia": "6520786",
			"Togo": "174804",
			"Singapore": "5087302",
			"Albania": "193876",
			"Benin": "1579728",
			"South Africa": "4441162",
			"FS Micronesia": "26528",
			"Indonesia": "12618414",
			"Qatar": "275277",
			"American Samoa": "109686",
			"Saint Vincent and the Grenadines": "179847",
			"Curaçao": "38735",
			"Armenia": "84320",
			"Kiribati": "279",
			"Mexico": "1386226",
			"Br. Virgin Isds": "20182",
			"Spain": "149655016",
			"Tajikistan": "27668",
			"Ireland": "6032458",
			"Botswana": "470157",
			"South Sudan": "1019857",
			"French Polynesia": "92007929",
			"Mauritania": "44566",
			"Honduras": "21308",
			"Saint Barthélemy": "2896241",
			"Holy See (Vatican City State)": "45677",
			"United Kingdom": "195029700",
			"Chile": "95225210",
			"Sudan": "8739",
			"Gambia": "816001",
			"China, Macao SAR": "3799",
			"Dominica": "85100",
			"Malaysia": "2268033",
			"Fiji": "370468",
			"Peru": "2099541",
			"Falkland Isds (Malvinas)": "10473",
			"Nepal": "9554",
			"China": "2417349654",
			"Comoros": "902473",
			"Guinea-Bissau": "6021",
			"Saint Maarten": "1214756",
			"Mali": "364931",
			"Trinidad and Tobago": "99072",
			"Israel": "4442187",
			"Burkina Faso": "60571",
			"Paraguay": "1372",
			"Norfolk Isds": "5178",
			"Bangladesh": "7908041",
			"Antigua and Barbuda": "31034",
			"Gabon": "102242102",
			"Cyprus": "37626063",
			"Yemen": "9241",
			"Mauritius": "5255669",
			"Slovakia": "1955565",
			"Faeroe Isds": "9860",
			"Turkmenistan": "836721",
			"Bahrain": "592341",
			"Côte d'Ivoire": "3562968",
			"Guyana": "4427",
			"Saint Pierre and Miquelon": "199234",
			"Algeria": "96580501",
			"USA": "318520829",
			"Namibia": "106",
			"Rep. of Moldova": "2470",
			"Zambia": "2148",
			"Malta": "20176902",
			"Ecuador": "251319",
			"Grenada": "671766",
			"Dominican Rep.": "552880",
			"New Caledonia": "3589976",
			"Seychelles": "4478557",
			"Italy": "241643468",
			"Saint Lucia": "3382162",
			"State of Palestine": "972321",
			"Rwanda": "332",
			"Syria": "4717",
			"Belarus": "357843",
			"Ethiopia": "21247616",
			"Slovenia": "2888832",
			"Congo": "15584717",
			"Senegal": "590298",
			"Bulgaria": "16342426",
			"Montenegro": "5917626",
			"Sri Lanka": "35491122",
			"Hungary": "89090601",
			"Jordan": "21933",
			"N. Mariana Isds": "10349",
			"Lao People's Dem. Rep.": "3874",
			"Myanmar": "47401",
			"Iran": "1074299",
			"Sao Tome and Principe": "71065",
			"Uruguay": "532663",
			"Switzerland": "39095920",
			"Cabo Verde": "393451",
			"Germany": "15463184307",
			"Timor-Leste": "114895",
			"Poland": "14971203",
			"Thailand": "2582544",
			"Argentina": "575686",
			"Brazil": "15353780",
			"Brunei Darussalam": "4610",
			"Mongolia": "23359",
			"Saudi Arabia": "143234",
			"Greece": "257773396",
			"Russian Federation": "7572325",
			"Cayman Isds": "6424056",
			"United Arab Emirates": "5885520",
			"Nicaragua": "92633",
			"Malawi": "378411",
			"Andorra": "279826",
			"El Salvador": "716181",
			"United States Minor Outlying Islands": "6640",
			"Sierra Leone": "93689",
			"Latvia": "80850",
			"Japan": "9924931",
			"Guinea": "2360281",
			"Uganda": "79391",
			"Romania": "1693457",
			"Croatia": "58930777",
			"Liberia": "47368",
			"Mozambique": "1371",
			"Madagascar": "407170",
			"Bolivia (Plurinational State of)": "379837",
			"Barbados": "145291",
			"Saint Kitts and Nevis": "830993",
			"Bahamas": "577569",
			"San Marino": "15816",
			"Chad": "22102736",
			"Viet Nam": "307309",
			"Haiti": "948765",
			"Tokelau": "10907",
			"Oman": "334815",
			"Sweden": "23134424",
			"Maldives": "369033",
			"India": "411325",
			"Jamaica": "10363",
			"Austria": "14267071",
			"Eritrea": "100284",
			"Zimbabwe": "13046",
			"Pakistan": "27348",
			"Swaziland": "1049",
			"Lithuania": "491690",
			"Cambodia": "2720602",
			"Denmark": "51257499",
			"Portugal": "20275852",
			"Central African Rep.": "4701180",
			"Netherlands": "52975796",
			"Costa Rica": "1561870",
			"Equatorial Guinea": "13413524",
			"South Georgia and the South Sandwich Islands": "7481",
			"Kazakhstan": "949569",
			"Kenya": "18295",
			"Afghanistan": "1574446",
			"Saint Helena": "12431",
			"Egypt": "544370",
			"Nauru": "12259",
			"Anguilla": "1017281",
			"Estonia": "47967638",
			"Morocco": "4626271",
			"Antarctica": "55872",
			"TFYR of Macedonia": "6852",
			"Somalia": "8342",
			"Western Sahara": "17265",
			"United Rep. of Tanzania": "17519",
			"Finland": "136182736",
			"Belize": "56281",
			"Georgia": "16562877",
			"Ukraine": "459359",
			"Bermuda": "166",
			"Djibouti": "16471580",
			"Greenland": "1648",
			"China, Hong Kong SAR": "1586549582",
			"Suriname": "1439",
			"Nigeria": "460352",
			"Samoa": "120",
			"Venezuela": "144578541",
			"Kuwait": "744078",
			"New Zealand": "5074699",
			"Norway": "19117637",
			"Pitcairn": "15095",
			"Marshall Isds": "6396537",
			"Philippines": "1513615",
			"Libya": "14994",
			"Kyrgyzstan": "17512",
			"Czechia": "77807806",
			"Guatemala": "3176325",
			"Aruba": "1872865",
			"Turkey": "73929278",
			"Tunisia": "7592753",
			"Rep. of Korea": "3350988",
			"Serbia": "25066",
			"Burundi": "251429",
			"Bhutan": "19685",
			"Cook Isds": "332017",
			"Canada": "8472460",
			"Iceland": "6220081",
			"Luxembourg": "4336890"
		}
	},
	"New Caledonia": {
		"imports": {},
		"exports": {}
	},
	"Niue": {
		"imports": {},
		"exports": {}
	},
	"Seychelles": {
		"imports": {},
		"exports": {}
	},
	"Oceania, nes": {
		"imports": {},
		"exports": {}
	},
	"Br. Virgin Isds": {
		"imports": {},
		"exports": {}
	},
	"Italy": {
		"imports": {
			"Lebanon": "130708",
			"Gibraltar": "498027",
			"Ghana": "25233",
			"Lesotho": "33090",
			"Cuba": "4868055",
			"Dem. Rep. of the Congo": "1712271",
			"Dem. People's Rep. of Korea": "100603",
			"Cameroon": "3575751",
			"Papua New Guinea": "11384675",
			"Montserrat": "4717",
			"Indonesia": "374837",
			"Colombia": "1565871",
			"Niger": "2614",
			"Palau": "1513",
			"Tonga": "222033",
			"Jordan": "29137",
			"Uzbekistan": "37477",
			"Iraq": "23818",
			"Guam": "7256",
			"Bosnia Herzegovina": "10946",
			"Pakistan": "18804",
			"Belgium": "104447317",
			"Azerbaijan": "112886",
			"Rwanda": "1262",
			"Armenia": "45075",
			"United Kingdom": "54903695",
			"Singapore": "83985",
			"Albania": "47834",
			"Benin": "1912494",
			"South Africa": "240584",
			"Panama": "26122",
			"Qatar": "4426906",
			"American Samoa": "2023",
			"Saint Vincent and the Grenadines": "426090",
			"Australia": "1124574",
			"Bahrain": "1420",
			"Mexico": "34927",
			"Kenya": "6130755",
			"Spain": "26456243",
			"Tajikistan": "267104",
			"Ireland": "70664",
			"Botswana": "9339445",
			"French Polynesia": "2823",
			"Mauritania": "4412014",
			"Christmas Isds": "14833",
			"Honduras": "100069",
			"Cambodia": "1705733",
			"Holy See (Vatican City State)": "15484",
			"Chile": "429760",
			"Gambia": "48569",
			"Liberia": "2656",
			"Brunei Darussalam": "54935",
			"Malaysia": "90648",
			"Swaziland": "199086",
			"Portugal": "21021743",
			"Nepal": "2569",
			"China": "118327286",
			"Comoros": "53266",
			"Guinea-Bissau": "65259",
			"Mali": "154676",
			"Trinidad and Tobago": "8900",
			"Israel": "18324",
			"Burkina Faso": "4453",
			"Paraguay": "2696901",
			"Bangladesh": "1747233",
			"Antigua and Barbuda": "1328",
			"Gabon": "335529988",
			"Cyprus": "234869",
			"Yemen": "989702",
			"Mauritius": "127180263",
			"Slovakia": "518176",
			"Faeroe Isds": "28764",
			"Turkmenistan": "195435",
			"Syria": "19921",
			"Côte d'Ivoire": "35792",
			"Guyana": "82501",
			"Saint Pierre and Miquelon": "7692",
			"Algeria": "120889",
			"USA": "38781931",
			"Saint Kitts and Nevis": "50763",
			"Rep. of Moldova": "9633",
			"Zambia": "14735880",
			"Malta": "147",
			"Ecuador": "6999",
			"Grenada": "28881",
			"Dominican Rep.": "14639",
			"France": "196363677",
			"New Caledonia": "20357",
			"Seychelles": "52446335",
			"Br. Virgin Isds": "7260126",
			"Saint Lucia": "67762",
			"State of Palestine": "189410",
			"Uganda": "9060316",
			"Belarus": "1546397",
			"Ethiopia": "38186078",
			"Congo": "7642313",
			"Senegal": "7162258",
			"Bulgaria": "2033050",
			"Montenegro": "265614",
			"Sri Lanka": "538094",
			"Hungary": "3056175",
			"Netherlands": "65454402",
			"New Zealand": "166338",
			"N. Mariana Isds": "1656",
			"Samoa": "1439",
			"Myanmar": "4767193",
			"Iran": "119463",
			"Sao Tome and Principe": "71590",
			"Lao People's Dem. Rep.": "268531",
			"Uruguay": "20864",
			"Andorra": "4862",
			"Cabo Verde": "2213",
			"Germany": "206723654",
			"Timor-Leste": "54774",
			"Poland": "6972753",
			"Thailand": "19618079",
			"Argentina": "35156",
			"Brazil": "3894064",
			"Dominica": "11471",
			"Mongolia": "5705",
			"Saudi Arabia": "1007952",
			"Sudan": "7492084",
			"Russian Federation": "449023",
			"Cayman Isds": "31261703",
			"United Arab Emirates": "747459",
			"Nicaragua": "2277454",
			"Malawi": "11849865",
			"Switzerland": "4020263",
			"El Salvador": "221899",
			"United States Minor Outlying Islands": "2091",
			"Latvia": "94072",
			"Japan": "1339146",
			"Guinea": "127493",
			"Romania": "2748731",
			"Croatia": "2060258",
			"China, Macao SAR": "1817",
			"Guatemala": "11128",
			"Madagascar": "6912324",
			"Bolivia (Plurinational State of)": "1146538",
			"Nigeria": "17455948",
			"Bahamas": "1323",
			"Tunisia": "12463008",
			"Chad": "3320",
			"Viet Nam": "59539368",
			"Haiti": "2241351",
			"Tokelau": "1699",
			"Oman": "3939494",
			"Sweden": "1948927",
			"Maldives": "8607922",
			"India": "2465711",
			"Jamaica": "1883553",
			"Austria": "62604433",
			"Eritrea": "11067",
			"Zimbabwe": "283699",
			"Vanuatu": "1462",
			"Fiji": "7832",
			"Lithuania": "31915",
			"Namibia": "38562917",
			"Denmark": "2832597",
			"Peru": "3366",
			"Central African Rep.": "2733",
			"Slovenia": "2868070",
			"Costa Rica": "10960199",
			"Equatorial Guinea": "4945879",
			"Greece": "432804",
			"Kazakhstan": "6795808",
			"Afghanistan": "88425",
			"Saint Helena": "59819",
			"Egypt": "70018",
			"Nauru": "7211",
			"Estonia": "265265",
			"Morocco": "24995716",
			"Luxembourg": "471759",
			"Venezuela": "2143",
			"Somalia": "8079",
			"Angola": "13281",
			"United Rep. of Tanzania": "7260277",
			"Finland": "28209465",
			"Belize": "1328072",
			"Georgia": "9627",
			"Ukraine": "100232",
			"Bermuda": "20084",
			"Djibouti": "764322",
			"Greenland": "75483",
			"China, Hong Kong SAR": "74673",
			"Suriname": "1649276",
			"Barbados": "73178",
			"TFYR of Macedonia": "1042623",
			"Kuwait": "431623",
			"Norway": "318285",
			"Sierra Leone": "232413",
			"Marshall Isds": "23103",
			"Philippines": "634897",
			"Libya": "52508888",
			"Kyrgyzstan": "1234",
			"Czechia": "4368100",
			"Mozambique": "310414",
			"Togo": "13281",
			"Aruba": "28758",
			"Turkey": "11030653",
			"Rep. of Korea": "832142",
			"Serbia": "113661",
			"Burundi": "943980",
			"Bhutan": "2545",
			"Cook Isds": "2759",
			"Canada": "86402",
			"Iceland": "1596264"
		},
		"exports": {
			"Lebanon": "14562819",
			"Gibraltar": "1697153",
			"Ghana": "1704401",
			"Lesotho": "1138",
			"Cuba": "2931480",
			"Dem. Rep. of the Congo": "37123",
			"Dem. People's Rep. of Korea": "120411",
			"Cameroon": "119784",
			"Papua New Guinea": "1835",
			"Montserrat": "985649",
			"Indonesia": "2765864",
			"Colombia": "7635071",
			"Niger": "1346728",
			"Palau": "34117",
			"Tonga": "23198",
			"Jordan": "111112",
			"Fr. South Antarctic Terr.": "12095",
			"Uzbekistan": "3014127",
			"Iraq": "16130",
			"Tuvalu": "39128",
			"Guam": "3298",
			"Bosnia Herzegovina": "785554",
			"Pakistan": "53769",
			"Belgium": "43155290",
			"Azerbaijan": "105924",
			"Rwanda": "162658",
			"Armenia": "45907",
			"Togo": "10070",
			"Singapore": "16448066",
			"Albania": "2874882",
			"Benin": "25353",
			"South Africa": "7616863",
			"FS Micronesia": "4316",
			"Panama": "17583919",
			"Qatar": "10809170",
			"American Samoa": "89518",
			"Saint Vincent and the Grenadines": "215767",
			"Australia": "49795239",
			"Kiribati": "2480",
			"Bahrain": "20030256",
			"Jamaica": "91343",
			"Kenya": "187456",
			"Spain": "199911981",
			"Tajikistan": "70474",
			"Ireland": "43049",
			"Botswana": "2495",
			"South Sudan": "1019978",
			"French Polynesia": "687836",
			"Mauritania": "311070",
			"Honduras": "12826",
			"Holy See (Vatican City State)": "18691299",
			"United Kingdom": "170837924",
			"Chile": "2649784",
			"Gambia": "5533",
			"Liberia": "222829",
			"Antarctica": "13749",
			"Brunei Darussalam": "7381",
			"Malaysia": "2993297",
			"Swaziland": "14241",
			"Portugal": "18632325",
			"Falkland Isds (Malvinas)": "3428",
			"Nepal": "231983",
			"China": "20212311",
			"Comoros": "14337",
			"Guinea-Bissau": "7784",
			"Saint Maarten": "4927235",
			"Mali": "43688",
			"Trinidad and Tobago": "43072",
			"Israel": "1035696",
			"Bulgaria": "3170458",
			"Burkina Faso": "1284",
			"Paraguay": "84249",
			"Norfolk Isds": "23072",
			"Bangladesh": "1552754",
			"Antigua and Barbuda": "15026",
			"Gabon": "71879",
			"Cyprus": "1849123",
			"Yemen": "415770",
			"Mauritius": "76253",
			"Slovakia": "14247647",
			"Faeroe Isds": "33181",
			"Turkmenistan": "25117271",
			"Syria": "739181",
			"Côte d'Ivoire": "58413",
			"Guyana": "576872",
			"Saint Pierre and Miquelon": "53752",
			"Algeria": "1344560",
			"USA": "588971195",
			"Saint Kitts and Nevis": "139986",
			"Rep. of Moldova": "1484",
			"Zambia": "3431",
			"Malta": "61240550",
			"Ecuador": "397964",
			"Grenada": "178548",
			"Dominican Rep.": "316928",
			"France": "689100221",
			"New Caledonia": "389416",
			"Seychelles": "361101",
			"Br. Virgin Isds": "150423217",
			"Saint Lucia": "369485",
			"State of Palestine": "284375",
			"Uganda": "4426",
			"Belarus": "342326",
			"Ethiopia": "18308",
			"Pitcairn": "41731",
			"Senegal": "1241311",
			"Angola": "93044",
			"Montenegro": "7697859",
			"Sri Lanka": "68326",
			"Hungary": "2385909",
			"Netherlands": "59519834",
			"New Zealand": "14645117",
			"N. Mariana Isds": "6051",
			"Lao People's Dem. Rep.": "708366",
			"Myanmar": "12826",
			"Iran": "2249695",
			"Sao Tome and Principe": "68768",
			"Uruguay": "1413667",
			"Andorra": "107417",
			"Cabo Verde": "143432",
			"Germany": "272571019",
			"Timor-Leste": "1826",
			"Poland": "21446007",
			"Thailand": "4780873",
			"Argentina": "16029058",
			"Brazil": "4667054",
			"Dominica": "6933015",
			"Mongolia": "52576",
			"Saudi Arabia": "2392776",
			"Greece": "2150616",
			"Russian Federation": "5803613",
			"Cayman Isds": "188282607",
			"United Arab Emirates": "33388749",
			"Nicaragua": "4980",
			"Malawi": "41087",
			"Switzerland": "98421870",
			"El Salvador": "19703",
			"Cambodia": "73914",
			"Latvia": "44778",
			"Japan": "461377",
			"Guinea": "264168",
			"Romania": "2859168",
			"Croatia": "25400699",
			"China, Macao SAR": "49698",
			"Guatemala": "454087",
			"Madagascar": "124154",
			"Bolivia (Plurinational State of)": "464209",
			"Nigeria": "368262",
			"Bahamas": "339989",
			"Tunisia": "749195",
			"Chad": "98342",
			"Viet Nam": "3116408",
			"Haiti": "3842",
			"Tokelau": "61590",
			"Oman": "32478",
			"Sweden": "20317706",
			"Maldives": "18497",
			"India": "1319887",
			"Mexico": "12259008",
			"Austria": "64680171",
			"Eritrea": "4072",
			"Congo": "4503515",
			"Zimbabwe": "1120124",
			"Vanuatu": "91900",
			"Fiji": "7991",
			"Lithuania": "561722",
			"Namibia": "204725",
			"Denmark": "10364461",
			"Peru": "719219",
			"Central African Rep.": "2616",
			"Slovenia": "17953116",
			"Costa Rica": "1572702",
			"Equatorial Guinea": "25928",
			"Sudan": "29303",
			"Kazakhstan": "85917",
			"Afghanistan": "22686",
			"Saint Helena": "13595",
			"Egypt": "7891057",
			"Nauru": "82938",
			"Anguilla": "180203",
			"Estonia": "2732188",
			"Morocco": "1597055",
			"Luxembourg": "135495",
			"TFYR of Macedonia": "1260257",
			"Somalia": "1145",
			"Heard Island and McDonald Islands": "17011",
			"United Rep. of Tanzania": "2806367",
			"Finland": "11203179",
			"Belize": "3901106",
			"Georgia": "113135",
			"Ukraine": "806948",
			"Bermuda": "1418524",
			"Djibouti": "14832",
			"Greenland": "24059",
			"China, Hong Kong SAR": "2203740",
			"Suriname": "1712702",
			"Barbados": "1275",
			"Samoa": "8999",
			"Venezuela": "24930",
			"Kuwait": "384014",
			"Norway": "10949716",
			"Sierra Leone": "2545",
			"Marshall Isds": "24809449",
			"Philippines": "1181312",
			"Libya": "131196",
			"Kyrgyzstan": "2820",
			"Czechia": "24524223",
			"Br. Indian Ocean Terr.": "1137",
			"Mozambique": "1975",
			"Aruba": "1483",
			"Turkey": "44984721",
			"San Marino": "22378812",
			"Rep. of Korea": "3825799",
			"Serbia": "2015320",
			"Burundi": "39262",
			"Bhutan": "45800",
			"Cook Isds": "24339178",
			"Canada": "58202187",
			"Iceland": "14612"
		}
	},
	"Saint Lucia": {
		"imports": {},
		"exports": {}
	},
	"State of Palestine": {
		"imports": {},
		"exports": {}
	},
	"Rwanda": {
		"imports": {
			"Lebanon": "35356",
			"Slovakia": "163",
			"Ghana": "1558",
			"Lesotho": "122",
			"Andorra": "31658",
			"Cabo Verde": "307",
			"Germany": "13407",
			"Poland": "48",
			"Cuba": "2262",
			"Dem. Rep. of the Congo": "42",
			"Thailand": "6014681",
			"Dem. People's Rep. of Korea": "180",
			"Argentina": "940",
			"Brazil": "296825",
			"Azerbaijan": "488",
			"Gabon": "233",
			"Dominica": "314",
			"South Africa": "185622",
			"Saudi Arabia": "611",
			"Colombia": "82",
			"Syria": "6462",
			"Russian Federation": "641",
			"United Arab Emirates": "110140",
			"Nicaragua": "59",
			"Yemen": "37094",
			"Jordan": "240",
			"Malawi": "218",
			"Switzerland": "145",
			"Mauritius": "3955",
			"Uruguay": "1021255",
			"Ukraine": "51591",
			"Latvia": "1428770",
			"Japan": "971091",
			"Guam": "16269",
			"Guinea": "1947",
			"Romania": "90990",
			"Pakistan": "18999896",
			"Belgium": "23212",
			"Croatia": "679",
			"Guatemala": "91534",
			"Togo": "370",
			"Singapore": "12446",
			"Nigeria": "83",
			"Albania": "200",
			"Benin": "2871",
			"Afghanistan": "294",
			"Bahamas": "6",
			"Tunisia": "41113",
			"Chad": "24",
			"Viet Nam": "87905",
			"Haiti": "12847",
			"Antarctica": "202",
			"Tokelau": "201425",
			"Cameroon": "184",
			"Indonesia": "27895",
			"Qatar": "1224",
			"American Samoa": "4",
			"Saint Vincent and the Grenadines": "861",
			"Oman": "110538",
			"Belarus": "356158",
			"Sweden": "2575",
			"Australia": "23672",
			"India": "7420568",
			"Djibouti": "192",
			"Jamaica": "5376",
			"Kenya": "14241",
			"Spain": "604",
			"Eritrea": "1396",
			"Ireland": "21961",
			"Botswana": "14871",
			"Zimbabwe": "364630",
			"China, Hong Kong SAR": "15",
			"Austria": "173",
			"Mauritania": "32",
			"Lithuania": "1151413",
			"Namibia": "64",
			"Denmark": "4793",
			"Curaçao": "261413",
			"Central African Rep.": "1947",
			"Honduras": "433",
			"Saint Barthélemy": "313",
			"Netherlands": "1348",
			"United Kingdom": "22531",
			"Costa Rica": "277",
			"Bhutan": "5397",
			"Turkey": "296",
			"Greece": "450",
			"Chile": "8292",
			"Kazakhstan": "2715",
			"Sudan": "170",
			"Liberia": "149",
			"Vanuatu": "7248",
			"South Sudan": "122",
			"Malaysia": "211",
			"Swaziland": "216",
			"Portugal": "6412",
			"Saint Kitts and Nevis": "49",
			"Nepal": "9356",
			"China": "632284",
			"Egypt": "12",
			"Estonia": "4375",
			"Morocco": "30",
			"Luxembourg": "43096",
			"Trinidad and Tobago": "612",
			"Israel": "62935",
			"TFYR of Macedonia": "905",
			"Burkina Faso": "5359",
			"Cambodia": "23084",
			"Angola": "340",
			"Bangladesh": "166541",
			"United Rep. of Tanzania": "41879",
			"Finland": "4736",
			"Bosnia Herzegovina": "836",
			"Cyprus": "6020",
			"Kuwait": "31",
			"Georgia": "4716",
			"Hungary": "5886",
			"Mali": "30",
			"Saint Helena": "104",
			"Madagascar": "95",
			"Bahrain": "638762",
			"Côte d'Ivoire": "29797",
			"Niger": "471",
			"Algeria": "13249",
			"USA": "344878",
			"Mexico": "14954",
			"Iran": "4035",
			"Zambia": "62218",
			"Suriname": "27165",
			"Malta": "21215",
			"Norway": "860",
			"Ecuador": "24905",
			"Sierra Leone": "194",
			"France": "42130",
			"New Caledonia": "6136",
			"Philippines": "487",
			"Seychelles": "17475",
			"Br. Virgin Isds": "513421",
			"Italy": "16136",
			"Czechia": "12810",
			"Uganda": "22128",
			"Mozambique": "262",
			"Ethiopia": "22",
			"Slovenia": "2949",
			"Congo": "138",
			"Senegal": "3031",
			"Bulgaria": "37676",
			"Montenegro": "601",
			"Sri Lanka": "42",
			"Rep. of Korea": "831",
			"Serbia": "7759",
			"Burundi": "1320",
			"Armenia": "30118",
			"New Zealand": "36170",
			"Canada": "633",
			"Iceland": "4652"
		},
		"exports": {
			"Lebanon": "1546",
			"Ghana": "6068",
			"Togo": "97323",
			"Poland": "1551",
			"Gabon": "20459",
			"Dem. Rep. of the Congo": "20296",
			"Thailand": "2076",
			"Dem. People's Rep. of Korea": "7983",
			"Azerbaijan": "601",
			"Cameroon": "10933",
			"South Africa": "11946",
			"Saudi Arabia": "1998",
			"Panama": "42210",
			"Sudan": "66005",
			"Niger": "1091",
			"United Arab Emirates": "1983",
			"Nicaragua": "833",
			"Tajikistan": "1039",
			"Angola": "8165",
			"Malawi": "10445",
			"Switzerland": "6907",
			"Slovakia": "3842",
			"Iraq": "2116",
			"Japan": "10",
			"Guinea": "539",
			"Romania": "154346",
			"Vanuatu": "873",
			"Belgium": "25497",
			"Croatia": "3698",
			"Belarus": "480",
			"Germany": "20269",
			"Singapore": "12112",
			"Nigeria": "3825",
			"Benin": "88",
			"Tunisia": "1",
			"Chad": "1575",
			"Viet Nam": "170834",
			"Haiti": "37164",
			"Indonesia": "28514",
			"Qatar": "21265",
			"Oman": "52",
			"Sweden": "3956",
			"Australia": "929002",
			"India": "984",
			"Jamaica": "4592",
			"Mexico": "1202",
			"Kenya": "5344",
			"Spain": "27151",
			"Eritrea": "143",
			"Ireland": "100",
			"Botswana": "5029",
			"Zimbabwe": "4127",
			"Pakistan": "486",
			"Austria": "970",
			"Lithuania": "207",
			"United Kingdom": "104207",
			"Denmark": "185937",
			"Central African Rep.": "1602",
			"Netherlands": "4717",
			"Bulgaria": "728",
			"Greece": "1040",
			"Kazakhstan": "28891",
			"Liberia": "5335",
			"Afghanistan": "5366",
			"Mali": "50",
			"South Sudan": "19203",
			"Malaysia": "18372",
			"Swaziland": "10339",
			"Portugal": "13333",
			"Nepal": "84742",
			"China": "66541",
			"Egypt": "2014",
			"Morocco": "400978",
			"Luxembourg": "39",
			"Israel": "25486",
			"Burkina Faso": "1478",
			"United Rep. of Tanzania": "2133",
			"Finland": "2072373",
			"Bosnia Herzegovina": "7383",
			"Cyprus": "10",
			"Mauritius": "15467",
			"Ukraine": "1643",
			"Djibouti": "4934",
			"Madagascar": "7150",
			"Côte d'Ivoire": "16592",
			"Russian Federation": "16612",
			"Algeria": "2010",
			"USA": "331801",
			"Cambodia": "5848",
			"Zambia": "372",
			"Norway": "382604",
			"Ecuador": "19134",
			"Sierra Leone": "10603",
			"France": "47",
			"Philippines": "3143",
			"Canada": "240",
			"Br. Virgin Isds": "303495",
			"Italy": "174",
			"Czechia": "100678",
			"Uganda": "78190",
			"Mozambique": "1731",
			"Ethiopia": "15328",
			"Slovenia": "468",
			"Congo": "327",
			"Senegal": "2213",
			"Turkey": "449000",
			"Sri Lanka": "8834",
			"Rep. of Korea": "4620",
			"Hungary": "519",
			"Burundi": "116756",
			"Bhutan": "14901",
			"New Zealand": "317624",
			"China, Hong Kong SAR": "139160",
			"Lao People's Dem. Rep.": "11956",
			"Myanmar": "197"
		}
	},
	"Belarus": {
		"imports": {
			"Lebanon": "28315200",
			"Gibraltar": "15100",
			"Ghana": "939100",
			"Qatar": "100",
			"Dem. Rep. of the Congo": "954100",
			"Dem. People's Rep. of Korea": "1200",
			"Cameroon": "28666900",
			"Papua New Guinea": "4100",
			"Indonesia": "57100",
			"Colombia": "70300",
			"Niger": "200",
			"Jordan": "300",
			"Uzbekistan": "28300",
			"Bosnia Herzegovina": "100",
			"Pakistan": "60400",
			"Belgium": "12800",
			"Azerbaijan": "346000",
			"Rwanda": "63000",
			"Armenia": "5699700",
			"Germany": "357900",
			"Singapore": "121300",
			"Albania": "129100",
			"Benin": "34805400",
			"South Africa": "94200",
			"Panama": "2600800",
			"Cuba": "254800",
			"Saint Vincent and the Grenadines": "27100",
			"Australia": "2200",
			"Jamaica": "201900",
			"Kenya": "208100",
			"Spain": "11800",
			"Tajikistan": "19600",
			"Ireland": "9800",
			"Mauritania": "100",
			"Honduras": "9900",
			"Saint Barthélemy": "3600",
			"Chile": "3288200",
			"Liberia": "17806600",
			"Dominica": "100",
			"Malaysia": "73900",
			"Swaziland": "116000",
			"Portugal": "20800",
			"Nepal": "1500",
			"China": "4943900",
			"Comoros": "16600",
			"Guinea-Bissau": "33362700",
			"Mali": "24548000",
			"Trinidad and Tobago": "154200",
			"Israel": "10100",
			"Burkina Faso": "400",
			"Paraguay": "55600",
			"Bangladesh": "6300",
			"Antigua and Barbuda": "100",
			"Cyprus": "39100",
			"Yemen": "2278100",
			"Mauritius": "5200",
			"Slovakia": "270200",
			"Faeroe Isds": "3929400",
			"Turkmenistan": "386100",
			"Bahrain": "1900",
			"Côte d'Ivoire": "3129900",
			"Guyana": "5200",
			"Algeria": "100",
			"USA": "583200",
			"Namibia": "200",
			"Rep. of Moldova": "30000",
			"Zambia": "500",
			"Malta": "388600",
			"Ecuador": "989700",
			"Grenada": "1100",
			"Dominican Rep.": "126100",
			"France": "12100",
			"New Caledonia": "200",
			"Seychelles": "60700",
			"Italy": "126500",
			"State of Palestine": "4700",
			"Uganda": "101800",
			"Syria": "83500",
			"Ethiopia": "200",
			"Congo": "14300",
			"Senegal": "113500",
			"Bulgaria": "900",
			"Montenegro": "300",
			"Sri Lanka": "64700",
			"Hungary": "11700",
			"New Zealand": "181100",
			"Lao People's Dem. Rep.": "2300",
			"Myanmar": "1500",
			"Iran": "42400",
			"Uruguay": "957600",
			"Switzerland": "62700",
			"United Kingdom": "26900",
			"Timor-Leste": "300",
			"Poland": "500400",
			"Thailand": "48400",
			"Argentina": "2881600",
			"Brazil": "7900",
			"Brunei Darussalam": "3300",
			"Mongolia": "28100",
			"Saudi Arabia": "300",
			"Greece": "2560800",
			"Russian Federation": "4408900",
			"United Arab Emirates": "1701200",
			"Nicaragua": "7600",
			"Malawi": "25500",
			"Andorra": "1500",
			"El Salvador": "3000",
			"Cambodia": "74500",
			"Latvia": "2400",
			"Japan": "1251900",
			"Guinea": "40649700",
			"Romania": "1560800",
			"Slovenia": "11900",
			"China, Macao SAR": "100",
			"Mozambique": "478300",
			"Madagascar": "1936700",
			"Bolivia (Plurinational State of)": "378500",
			"Nigeria": "7610800",
			"Bahamas": "199500",
			"Tunisia": "213300",
			"Viet Nam": "2600",
			"Haiti": "300",
			"Tokelau": "100",
			"Oman": "13600",
			"Sweden": "30700",
			"India": "15100",
			"Mexico": "46800",
			"Austria": "47000",
			"Eritrea": "1100",
			"Zimbabwe": "400",
			"Lithuania": "116300",
			"Saint Kitts and Nevis": "1700",
			"Denmark": "900",
			"Peru": "600",
			"Central African Rep.": "600",
			"Netherlands": "36400",
			"Costa Rica": "11405100",
			"Equatorial Guinea": "2080200",
			"Sudan": "11900",
			"Kazakhstan": "214000",
			"Afghanistan": "10886500",
			"Croatia": "92800",
			"Saint Helena": "6700",
			"Egypt": "900",
			"Nauru": "100",
			"Estonia": "113300",
			"Morocco": "77900",
			"Luxembourg": "28700",
			"TFYR of Macedonia": "11409000",
			"Somalia": "13675400",
			"United Rep. of Tanzania": "1300",
			"Finland": "1515700",
			"Georgia": "10300",
			"Ukraine": "290700",
			"Bermuda": "1800",
			"Greenland": "106100",
			"China, Hong Kong SAR": "3400",
			"Suriname": "510200",
			"Barbados": "28900",
			"Venezuela": "400",
			"Kuwait": "1546600",
			"Norway": "400",
			"Sierra Leone": "11700",
			"Philippines": "600",
			"Libya": "41000",
			"Kyrgyzstan": "68500",
			"Czechia": "58300",
			"Guatemala": "11800",
			"Turkey": "705100",
			"San Marino": "91200",
			"Rep. of Korea": "400",
			"Serbia": "22916200",
			"Burundi": "2545400",
			"Canada": "28800",
			"Iceland": "35616600"
		},
		"exports": {
			"Lebanon": "2000",
			"Gibraltar": "3800",
			"Ghana": "44200",
			"Lesotho": "2100",
			"Andorra": "5700",
			"Cabo Verde": "4900",
			"Togo": "75800",
			"Timor-Leste": "30800",
			"Poland": "12500",
			"Qatar": "100",
			"Dem. Rep. of the Congo": "16000",
			"Thailand": "1400",
			"Dem. People's Rep. of Korea": "70200",
			"Argentina": "198100",
			"Brazil": "200",
			"Germany": "35200",
			"Cameroon": "52800",
			"Gabon": "160000",
			"Papua New Guinea": "500",
			"Mongolia": "5181300",
			"Saudi Arabia": "2300",
			"Panama": "10800",
			"Colombia": "53000",
			"Sudan": "746400",
			"Russian Federation": "1829600",
			"Cayman Isds": "1400",
			"United Arab Emirates": "1200",
			"Nicaragua": "669200",
			"Belize": "632500",
			"Libya": "129300",
			"Azerbaijan": "14208900",
			"Malawi": "8200",
			"Switzerland": "17000",
			"Georgia": "21425400",
			"Uruguay": "66600",
			"Paraguay": "4600",
			"Slovakia": "86500",
			"Latvia": "21100",
			"Japan": "800",
			"Tunisia": "28900",
			"Iraq": "94200",
			"Uganda": "155800",
			"Romania": "870200",
			"Pakistan": "1104000",
			"Belgium": "76400",
			"Slovenia": "5400",
			"Bolivia (Plurinational State of)": "154800",
			"Guatemala": "3900",
			"United Kingdom": "6000",
			"Singapore": "21200",
			"Nigeria": "10900",
			"Uzbekistan": "213900",
			"Benin": "161500",
			"San Marino": "1800",
			"Chad": "101000",
			"Viet Nam": "2486200",
			"Haiti": "1000",
			"South Africa": "20700",
			"Guinea": "46600",
			"Indonesia": "27940000",
			"Cuba": "5393000",
			"Dominican Rep.": "11300",
			"Oman": "159000",
			"Sweden": "142600",
			"Australia": "54500",
			"Bahrain": "46700",
			"India": "27800",
			"Mexico": "1800",
			"Kenya": "800",
			"Spain": "2900",
			"Tajikistan": "82800",
			"Ireland": "1700",
			"Botswana": "100",
			"Zimbabwe": "221300",
			"Côte d'Ivoire": "48800",
			"French Polynesia": "100",
			"Mauritania": "51500",
			"Lithuania": "50200",
			"Cambodia": "269400",
			"Denmark": "190700",
			"Somalia": "127600",
			"Honduras": "267600",
			"Netherlands": "5800",
			"Costa Rica": "300",
			"Austria": "20500",
			"Equatorial Guinea": "1300",
			"Greece": "73600",
			"Chile": "13100",
			"Kazakhstan": "347200",
			"Liberia": "64300",
			"Afghanistan": "262000",
			"Croatia": "2300",
			"Malaysia": "27000",
			"Fiji": "154900",
			"Peru": "222400",
			"Armenia": "8700",
			"China": "1780000",
			"Egypt": "744000",
			"Estonia": "88400",
			"Morocco": "934100",
			"Mali": "74800",
			"Trinidad and Tobago": "17000",
			"Israel": "2391800",
			"TFYR of Macedonia": "64800",
			"Burkina Faso": "87200",
			"Rep. of Moldova": "29400",
			"Bangladesh": "200",
			"United Rep. of Tanzania": "7300",
			"Finland": "42200",
			"Bosnia Herzegovina": "4118900",
			"Cyprus": "900",
			"Yemen": "179600",
			"Mauritius": "3900",
			"Hungary": "3817900",
			"Luxembourg": "3000",
			"Turkmenistan": "55200",
			"Syria": "3911000",
			"Zambia": "123900",
			"China, Hong Kong SAR": "468400",
			"Guyana": "1265900",
			"Suriname": "132000",
			"Algeria": "2700",
			"USA": "1300",
			"Iran": "1254200",
			"Venezuela": "3300",
			"Kuwait": "618700",
			"Albania": "14700",
			"Malta": "18800",
			"Norway": "7940800",
			"Ecuador": "1500",
			"Sierra Leone": "764000",
			"Portugal": "900",
			"France": "273100",
			"Philippines": "316000",
			"Seychelles": "1200",
			"Br. Virgin Isds": "25900",
			"Italy": "794100",
			"Kyrgyzstan": "14988300",
			"Czechia": "9000",
			"Rwanda": "2000",
			"Mozambique": "100",
			"Ethiopia": "1633200",
			"Bulgaria": "3313400",
			"Congo": "316300",
			"Senegal": "5800",
			"Turkey": "626000",
			"Montenegro": "14000",
			"Sri Lanka": "100",
			"Rep. of Korea": "114500",
			"Serbia": "6746400",
			"Angola": "6462700",
			"Jordan": "1370300",
			"Canada": "100",
			"Iceland": "100",
			"Myanmar": "1500",
			"Lao People's Dem. Rep.": "2274800",
			"Ukraine": "291500",
			"New Zealand": "2300"
		}
	},
	"Ethiopia": {
		"imports": {
			"Lebanon": "107062",
			"Nepal": "4551",
			"Ghana": "10366",
			"Niger": "3538",
			"Lesotho": "291",
			"Switzerland": "165750",
			"Cabo Verde": "82",
			"Germany": "158165143",
			"Timor-Leste": "311",
			"Poland": "11617",
			"Cuba": "26660",
			"Dem. Rep. of the Congo": "1722",
			"Thailand": "62879",
			"Dem. People's Rep. of Korea": "24476",
			"Argentina": "88085",
			"Brazil": "3076890",
			"Cameroon": "10151",
			"Iran": "14472",
			"Mongolia": "49458",
			"Saudi Arabia": "99710",
			"Holy See (Vatican City State)": "8690",
			"Colombia": "1142335",
			"Syria": "118818",
			"Russian Federation": "123717637",
			"United Arab Emirates": "10682",
			"Rwanda": "752",
			"Yemen": "92212",
			"Tonga": "6774",
			"Angola": "35463",
			"Uzbekistan": "7158871",
			"Malawi": "45",
			"Andorra": "13711",
			"El Salvador": "122044",
			"Uruguay": "71027",
			"Ukraine": "99410211",
			"Iraq": "35996",
			"Japan": "2527526",
			"Guinea": "57581",
			"Uganda": "371942",
			"Bosnia Herzegovina": "852",
			"Pakistan": "717647",
			"Belgium": "10289301",
			"Croatia": "10630",
			"Belarus": "272",
			"Madagascar": "15752",
			"Singapore": "11297249",
			"Nigeria": "976",
			"Albania": "15176",
			"South Africa": "10189669",
			"Tunisia": "45023",
			"Chad": "6078",
			"Viet Nam": "7834729",
			"Haiti": "539",
			"Mozambique": "958",
			"Indonesia": "77224691",
			"Qatar": "3524",
			"Somalia": "3727",
			"Oman": "184047",
			"Jordan": "2092859",
			"Sweden": "463658",
			"Australia": "871874",
			"India": "194405475",
			"Mexico": "155688",
			"Jamaica": "495",
			"Kenya": "15372094",
			"Austria": "1879294",
			"Romania": "153694",
			"Ireland": "30409",
			"Botswana": "3786",
			"Zimbabwe": "4544",
			"Côte d'Ivoire": "8642",
			"French Polynesia": "17",
			"Suriname": "669",
			"Swaziland": "318559",
			"Lithuania": "2145839",
			"Cambodia": "78590",
			"Christmas Isds": "2791",
			"Portugal": "1278",
			"Netherlands": "5073101",
			"United Kingdom": "250337999",
			"Costa Rica": "6234",
			"Turkey": "8321",
			"Greece": "16872970",
			"Chile": "116949",
			"Azerbaijan": "10603",
			"Sudan": "5459190",
			"Liberia": "346",
			"Libya": "108",
			"Afghanistan": "340",
			"Mali": "308410",
			"Malaysia": "4241",
			"USA": "412449926",
			"Peru": "7283897",
			"United Rep. of Tanzania": "38146",
			"Armenia": "8679",
			"China": "5509629",
			"Comoros": "136",
			"Guinea-Bissau": "4429",
			"Estonia": "879077",
			"Morocco": "234741466",
			"Luxembourg": "445",
			"Trinidad and Tobago": "586",
			"Israel": "1260106",
			"TFYR of Macedonia": "6833",
			"Burkina Faso": "33019",
			"Kazakhstan": "10093",
			"Bangladesh": "565783",
			"Antigua and Barbuda": "1804",
			"Gabon": "163",
			"Finland": "11798487",
			"Tajikistan": "749",
			"Cyprus": "5642865",
			"Belize": "349",
			"Georgia": "223382",
			"Slovakia": "3338989",
			"Bermuda": "296326",
			"Djibouti": "707",
			"Malta": "814688",
			"Turkmenistan": "373",
			"Bahrain": "538",
			"Zambia": "12472",
			"China, Hong Kong SAR": "1556724",
			"Mauritius": "735",
			"Algeria": "29818",
			"Barbados": "277",
			"Namibia": "339",
			"Kuwait": "8507",
			"Spain": "37139117",
			"Denmark": "36939546",
			"Norway": "240969",
			"Ecuador": "994421",
			"Benin": "244",
			"Sierra Leone": "29",
			"Dominican Rep.": "6736",
			"France": "250998006",
			"Philippines": "28042",
			"Latvia": "191065",
			"Seychelles": "225",
			"Italy": "5970618",
			"Kyrgyzstan": "35",
			"Czechia": "371266",
			"Nicaragua": "12",
			"Egypt": "206646158",
			"Guatemala": "8356",
			"Ethiopia": "1545837",
			"Slovenia": "1577807",
			"Togo": "3524",
			"Congo": "9856",
			"Senegal": "130045",
			"Bulgaria": "234",
			"Sri Lanka": "26156",
			"Rep. of Korea": "37033854",
			"Hungary": "7388530",
			"Panama": "569",
			"Burundi": "1022",
			"New Zealand": "69526",
			"Canada": "289",
			"Iceland": "345685",
			"Myanmar": "2686"
		},
		"exports": {
			"Lebanon": "67782",
			"Ghana": "10423",
			"Sao Tome and Principe": "12651",
			"Lesotho": "1675",
			"Switzerland": "162512",
			"Cabo Verde": "11265",
			"Germany": "3914055",
			"Poland": "313853",
			"United Rep. of Tanzania": "23320",
			"Thailand": "1042",
			"Dem. People's Rep. of Korea": "416",
			"Argentina": "13910",
			"Brazil": "812",
			"Cameroon": "2087",
			"Iran": "1982477",
			"Saudi Arabia": "4598",
			"Panama": "115",
			"Colombia": "17972",
			"Sudan": "902887",
			"Niger": "643310",
			"United Arab Emirates": "240405",
			"Nicaragua": "311077",
			"Tonga": "296304",
			"Angola": "3870",
			"Malawi": "517",
			"Andorra": "95",
			"El Salvador": "851825",
			"Slovakia": "72005",
			"Iraq": "36963",
			"Japan": "2068936",
			"Guinea": "2628",
			"Bosnia Herzegovina": "40891",
			"Pakistan": "75996657",
			"Belgium": "368",
			"Russian Federation": "218898",
			"Croatia": "2331",
			"Rwanda": "2895",
			"Belarus": "456",
			"Togo": "96",
			"Singapore": "28941",
			"Nigeria": "13510",
			"Albania": "56974",
			"Benin": "1142869",
			"Maldives": "148",
			"Bahamas": "2289",
			"Tunisia": "59",
			"Chad": "124635",
			"Viet Nam": "5941174",
			"South Africa": "407295",
			"Indonesia": "1947609",
			"Qatar": "100473",
			"Oman": "584",
			"Turkey": "837",
			"Sweden": "130",
			"Australia": "38682",
			"India": "143476",
			"Jamaica": "59089",
			"Mexico": "1263008",
			"Kenya": "6721211",
			"Austria": "14",
			"Romania": "122569",
			"Ireland": "21753",
			"Botswana": "1048",
			"Zimbabwe": "108730",
			"Côte d'Ivoire": "1286",
			"Spain": "203143",
			"Peru": "166685",
			"Mozambique": "87743",
			"Lithuania": "390601",
			"Cambodia": "28778",
			"Denmark": "1772639",
			"Portugal": "5980804",
			"Central African Rep.": "8353",
			"Netherlands": "5491",
			"United Kingdom": "33884706",
			"Equatorial Guinea": "12631",
			"Greece": "13060",
			"Chile": "120003",
			"Azerbaijan": "1051",
			"Gambia": "22364",
			"Liberia": "181",
			"Nepal": "74072",
			"Afghanistan": "5907",
			"Mali": "37564",
			"Malaysia": "20381",
			"Swaziland": "2699",
			"Somalia": "57281",
			"Jordan": "19480",
			"China": "7115365",
			"Comoros": "3673",
			"Guinea-Bissau": "1439",
			"Estonia": "682197",
			"Morocco": "455570",
			"Djibouti": "4656797",
			"Israel": "198845",
			"TFYR of Macedonia": "2790",
			"Burkina Faso": "82023",
			"Syria": "16225",
			"Bangladesh": "274",
			"Gabon": "893",
			"Finland": "3912277",
			"Cyprus": "2010",
			"Yemen": "7898157",
			"Georgia": "73217",
			"Ukraine": "853317",
			"Luxembourg": "51",
			"Madagascar": "2381",
			"Bahrain": "1526712",
			"Zambia": "2817",
			"China, Hong Kong SAR": "2229089",
			"Mauritius": "231",
			"Algeria": "3136",
			"USA": "2542455",
			"Namibia": "33891887",
			"Rep. of Moldova": "7205",
			"Venezuela": "51843",
			"Kuwait": "224733",
			"Malta": "9026",
			"Norway": "544",
			"Sierra Leone": "13018",
			"France": "681274",
			"Philippines": "48300",
			"Latvia": "497",
			"Seychelles": "9545",
			"Italy": "5912105",
			"Czechia": "1045",
			"Uganda": "865209",
			"Egypt": "4309124",
			"Guatemala": "210",
			"Slovenia": "91480",
			"Congo": "692",
			"Senegal": "1233",
			"Bulgaria": "410688",
			"Sri Lanka": "363",
			"Rep. of Korea": "2796",
			"Hungary": "23423",
			"Burundi": "716",
			"New Zealand": "5213544",
			"Canada": "56079",
			"Lao People's Dem. Rep.": "2932",
			"Myanmar": "194"
		}
	},
	"Namibia": {
		"imports": {
			"Lebanon": "25465",
			"Gibraltar": "1",
			"South Africa": "4910400",
			"Lesotho": "238219",
			"Andorra": "38",
			"United Kingdom": "133",
			"Timor-Leste": "13",
			"Poland": "9940633",
			"Cuba": "1150",
			"Dem. Rep. of the Congo": "135115",
			"Thailand": "520770",
			"Argentina": "500040",
			"Brazil": "1807544",
			"Cameroon": "1",
			"Dominica": "6263",
			"Ghana": "4556",
			"Saudi Arabia": "17644",
			"Panama": "10269675",
			"Colombia": "1358",
			"Sudan": "1970",
			"Russian Federation": "328",
			"Cayman Isds": "596",
			"United Arab Emirates": "467662",
			"Nicaragua": "638",
			"Yemen": "264",
			"Angola": "359734",
			"Malawi": "115914",
			"Switzerland": "2813",
			"El Salvador": "421",
			"Uruguay": "236595",
			"Paraguay": "1900",
			"Slovakia": "3188",
			"Latvia": "446",
			"Japan": "221",
			"Guinea": "3",
			"Bosnia Herzegovina": "930",
			"Pakistan": "2",
			"Belgium": "682687",
			"Croatia": "2178",
			"Guatemala": "305",
			"Germany": "552206",
			"Singapore": "55228",
			"Barbados": "12",
			"Albania": "90664",
			"Benin": "101284",
			"Bahamas": "18612529",
			"San Marino": "14",
			"Viet Nam": "21478",
			"Tokelau": "1262",
			"Indonesia": "9013",
			"Qatar": "6",
			"Saint Vincent and the Grenadines": "1",
			"Oman": "19661797",
			"Sweden": "128791",
			"Australia": "157809",
			"India": "53779",
			"Mexico": "40957",
			"Jamaica": "213",
			"Kenya": "1027",
			"Austria": "1410890",
			"Gabon": "29",
			"Br. Virgin Isds": "99955",
			"Botswana": "866971",
			"Zimbabwe": "118",
			"Côte d'Ivoire": "9793038",
			"Spain": "14166",
			"Mauritania": "557",
			"Lithuania": "10267",
			"Cambodia": "20709",
			"Denmark": "761915",
			"Peru": "84359300",
			"Honduras": "274",
			"Netherlands": "27864",
			"Turkey": "7864",
			"Costa Rica": "2",
			"Venezuela": "17",
			"Papua New Guinea": "167",
			"Ireland": "1259642",
			"Greece": "90010",
			"Chile": "8579",
			"Azerbaijan": "68",
			"Turkmenistan": "1087",
			"Liberia": "11",
			"Libya": "7",
			"Vanuatu": "146",
			"Saint Helena": "46753",
			"Malaysia": "293",
			"Swaziland": "73526",
			"Portugal": "441",
			"Falkland Isds (Malvinas)": "24388242",
			"Jordan": "273",
			"China": "40977",
			"Egypt": "3",
			"Nauru": "1303",
			"Estonia": "5522858",
			"Morocco": "21",
			"Mali": "685",
			"Trinidad and Tobago": "173",
			"Israel": "1546682",
			"TFYR of Macedonia": "33153",
			"Burkina Faso": "5",
			"Kazakhstan": "2",
			"Rep. of Moldova": "187",
			"Bangladesh": "5830",
			"Nigeria": "8",
			"United Rep. of Tanzania": "41",
			"Finland": "18517",
			"Cyprus": "980",
			"Belize": "7687911",
			"Mauritius": "146587",
			"Ukraine": "12091",
			"Bermuda": "416",
			"Luxembourg": "3923",
			"Madagascar": "41",
			"Marshall Isds": "15564297",
			"Bahrain": "123",
			"China, Hong Kong SAR": "21",
			"Niger": "114",
			"Algeria": "17",
			"USA": "5102",
			"Iran": "43351",
			"Romania": "3318",
			"Zambia": "3444539",
			"Suriname": "14634",
			"Malta": "127906",
			"Norway": "201",
			"Ecuador": "598",
			"Serbia": "4262",
			"Grenada": "850",
			"Dominican Rep.": "45",
			"France": "5440",
			"New Caledonia": "82665",
			"Philippines": "95",
			"Seychelles": "12",
			"Italy": "39",
			"Czechia": "304245",
			"Uganda": "20",
			"Mozambique": "194272",
			"Ethiopia": "52371",
			"Kuwait": "3620",
			"Slovenia": "7016",
			"Togo": "1",
			"Congo": "302",
			"Senegal": "323889",
			"Bulgaria": "851",
			"Tunisia": "90316",
			"Sri Lanka": "116",
			"Rep. of Korea": "9102890",
			"Hungary": "354056",
			"Holy See (Vatican City State)": "222387",
			"Bhutan": "945",
			"New Zealand": "739066",
			"Canada": "541",
			"Iceland": "190645"
		},
		"exports": {
			"Lebanon": "3",
			"Gibraltar": "212868",
			"South Africa": "1786161",
			"Lesotho": "26838",
			"Marshall Isds": "880206",
			"Cabo Verde": "3394",
			"Germany": "4629146",
			"Andorra": "1892",
			"Poland": "1425",
			"Cuba": "8419",
			"Dem. Rep. of the Congo": "196936",
			"Thailand": "10",
			"Dem. People's Rep. of Korea": "31",
			"Argentina": "7",
			"Brazil": "385",
			"Cameroon": "115",
			"Brunei Darussalam": "1",
			"Ghana": "6",
			"Saudi Arabia": "4190",
			"Panama": "11036",
			"Colombia": "3944",
			"Georgia": "9077",
			"Russian Federation": "2157",
			"Cayman Isds": "905",
			"United Arab Emirates": "6",
			"Gabon": "2769",
			"Tonga": "34",
			"Angola": "9732200",
			"Pakistan": "1395",
			"Malawi": "412336",
			"Switzerland": "653",
			"Belarus": "1222",
			"Uruguay": "1181",
			"Sierra Leone": "198",
			"Slovakia": "19115",
			"Iraq": "29",
			"Japan": "4042319",
			"Guinea": "24",
			"Uganda": "18370",
			"Romania": "27542",
			"Vanuatu": "854117",
			"Belgium": "3334175",
			"Croatia": "3",
			"China, Macao SAR": "77560",
			"Australia": "5499493",
			"Togo": "22221",
			"Singapore": "4045",
			"Nigeria": "13",
			"Albania": "3390",
			"Benin": "2001988",
			"Bahamas": "68006",
			"Chad": "1",
			"Viet Nam": "15534",
			"Haiti": "466732",
			"Indonesia": "217296",
			"Qatar": "13184",
			"Saint Vincent and the Grenadines": "368011",
			"Oman": "20730",
			"Sweden": "14979",
			"Armenia": "120",
			"Kiribati": "66",
			"Bahrain": "136",
			"India": "1",
			"Jamaica": "665",
			"Mexico": "5944",
			"Kenya": "36657",
			"Austria": "63032",
			"Eritrea": "1",
			"Ireland": "260701",
			"Botswana": "6981150",
			"Zimbabwe": "2398446",
			"China, Hong Kong SAR": "1767153",
			"Spain": "33325330",
			"Mauritania": "68",
			"Lithuania": "5562",
			"United Kingdom": "166",
			"Denmark": "1162715",
			"Peru": "10",
			"Central African Rep.": "4647",
			"Honduras": "673",
			"Netherlands": "12",
			"Turkey": "478",
			"Costa Rica": "3380",
			"Burkina Faso": "41",
			"Equatorial Guinea": "5202",
			"Greece": "994",
			"Chile": "189",
			"Kazakhstan": "443",
			"Sudan": "100625",
			"Gambia": "14",
			"Liberia": "450141",
			"Nepal": "27827",
			"Mali": "33935",
			"Curaçao": "2327",
			"Saint Helena": "8",
			"Malaysia": "263662",
			"Swaziland": "68",
			"Portugal": "102812",
			"Falkland Isds (Malvinas)": "285361",
			"Jordan": "10",
			"China": "814524",
			"Comoros": "1150",
			"Anguilla": "129",
			"Estonia": "46603",
			"Morocco": "15",
			"Luxembourg": "1035470",
			"Trinidad and Tobago": "265",
			"Israel": "354474",
			"Venezuela": "501",
			"Somalia": "754",
			"Paraguay": "1787",
			"Bangladesh": "679",
			"Antigua and Barbuda": "245712",
			"United Rep. of Tanzania": "1729",
			"Finland": "17778",
			"Cyprus": "928",
			"Belize": "142380",
			"Mauritius": "831065",
			"Ukraine": "89",
			"Djibouti": "23516",
			"Faeroe Isds": "183",
			"Cook Isds": "17780",
			"Nicaragua": "3606",
			"Côte d'Ivoire": "30677",
			"Niger": "507701",
			"Algeria": "580093",
			"USA": "10",
			"Saint Kitts and Nevis": "130929",
			"Iran": "20",
			"Zambia": "792",
			"Suriname": "2889",
			"Malta": "58977",
			"Norway": "68",
			"Ecuador": "85",
			"Serbia": "14",
			"Grenada": "44714",
			"Dominican Rep.": "271",
			"France": "49259",
			"New Caledonia": "832",
			"Philippines": "86",
			"Latvia": "39839",
			"Seychelles": "441358",
			"Italy": "31466",
			"Czechia": "1154",
			"Rwanda": "3",
			"Egypt": "163",
			"Mozambique": "568014",
			"Ethiopia": "12",
			"Kuwait": "82585",
			"Slovenia": "1895",
			"Congo": "1",
			"Senegal": "138",
			"Bulgaria": "4901",
			"Sri Lanka": "2047",
			"Rep. of Korea": "14",
			"Hungary": "14870",
			"Burundi": "1",
			"Bhutan": "122167",
			"New Zealand": "1680",
			"Canada": "491837",
			"Iceland": "355",
			"El Salvador": "109792",
			"Lao People's Dem. Rep.": "1948",
			"Madagascar": "7610"
		}
	},
	"Congo": {
		"imports": {},
		"exports": {}
	},
	"Senegal": {
		"imports": {
			"Lebanon": "804009",
			"Gibraltar": "3999",
			"Ghana": "185120",
			"Uruguay": "3894162",
			"Andorra": "600034",
			"Cabo Verde": "66761",
			"Germany": "117746",
			"Timor-Leste": "12619",
			"Poland": "4666488",
			"Qatar": "336",
			"Dem. Rep. of the Congo": "1787",
			"Thailand": "382413",
			"Dem. People's Rep. of Korea": "1865",
			"Argentina": "10590",
			"Brazil": "566",
			"Azerbaijan": "8107",
			"Cameroon": "51149",
			"Brunei Darussalam": "14261",
			"Papua New Guinea": "9226",
			"Saudi Arabia": "37791",
			"Panama": "2588",
			"Colombia": "40359",
			"Sudan": "70307",
			"Russian Federation": "221480",
			"United Arab Emirates": "1787524",
			"Nicaragua": "899",
			"Libya": "1574089",
			"Malawi": "293155",
			"Switzerland": "2497363",
			"Georgia": "927726",
			"Ukraine": "167732",
			"Iraq": "11523",
			"Japan": "7427210",
			"Hungary": "1257",
			"Latvia": "431",
			"Romania": "198036",
			"Pakistan": "19611",
			"Belgium": "293097",
			"Slovenia": "873",
			"Liberia": "2072492",
			"Bolivia (Plurinational State of)": "2186779",
			"Guatemala": "16183772",
			"Madagascar": "23607",
			"Singapore": "16894",
			"Nigeria": "2353513",
			"Albania": "3536",
			"Benin": "11693",
			"Tunisia": "1328167",
			"Viet Nam": "148659",
			"Haiti": "8710",
			"South Africa": "637116",
			"Guinea": "556611",
			"Indonesia": "12165",
			"Cuba": "1304",
			"Saint Vincent and the Grenadines": "5097",
			"Oman": "19948",
			"Belarus": "4142",
			"Curaçao": "117659",
			"Australia": "4947",
			"Equatorial Guinea": "3790",
			"India": "11608827",
			"Mexico": "39094",
			"Jamaica": "4352",
			"Kenya": "121676",
			"Spain": "4648105",
			"Gabon": "1397453",
			"China": "5584718",
			"Ireland": "2064606",
			"Zimbabwe": "1838",
			"Côte d'Ivoire": "78759",
			"Austria": "5423",
			"Mauritania": "8558",
			"Lithuania": "23701",
			"Namibia": "2029",
			"Denmark": "39016",
			"Portugal": "4307868",
			"Central African Rep.": "5294",
			"Honduras": "8340",
			"Netherlands": "6202",
			"United Kingdom": "2088266",
			"Costa Rica": "25363",
			"Bulgaria": "1484",
			"Greece": "28113",
			"Chile": "2354",
			"Kazakhstan": "4064575",
			"Gambia": "3377",
			"China, Macao SAR": "7934",
			"Guinea-Bissau": "7159",
			"Afghanistan": "373",
			"Croatia": "2209",
			"Sweden": "1257357",
			"Malaysia": "7969628",
			"Swaziland": "2115311",
			"Peru": "2623",
			"Falkland Isds (Malvinas)": "1765",
			"Armenia": "1562",
			"Saint Helena": "5320",
			"Egypt": "2375962",
			"Nauru": "23733",
			"Estonia": "11617",
			"Morocco": "9135593",
			"Mali": "3060121",
			"Trinidad and Tobago": "2423740",
			"Israel": "27948",
			"Venezuela": "59149",
			"Burkina Faso": "59",
			"Paraguay": "917",
			"Angola": "272",
			"Bangladesh": "40102",
			"Antigua and Barbuda": "3950",
			"United Rep. of Tanzania": "18575",
			"Finland": "5238",
			"Bosnia Herzegovina": "49",
			"Cyprus": "12507",
			"Zambia": "24243",
			"Mauritius": "7520",
			"Slovakia": "112044",
			"Greenland": "170",
			"Bahrain": "511",
			"China, Hong Kong SAR": "285",
			"Burundi": "27387",
			"Niger": "7057",
			"Algeria": "3408442",
			"USA": "3892138",
			"Cambodia": "30318",
			"Iran": "3522781",
			"Kuwait": "288102",
			"Suriname": "63296",
			"Malta": "2303799",
			"Norway": "1791",
			"Ecuador": "17993",
			"Sierra Leone": "40389",
			"Dominican Rep.": "33861",
			"France": "224",
			"Philippines": "112519",
			"Seychelles": "6291",
			"Italy": "3913",
			"Czechia": "5929",
			"Uganda": "1130",
			"Mozambique": "249033",
			"Ethiopia": "3838",
			"Togo": "249360",
			"Congo": "782879",
			"Aruba": "1191374",
			"Turkey": "3633171",
			"Montenegro": "1486672",
			"Sri Lanka": "45945",
			"Rep. of Korea": "189",
			"Serbia": "601",
			"Holy See (Vatican City State)": "1889",
			"Jordan": "11283",
			"Saint Pierre and Miquelon": "9097",
			"Canada": "11928",
			"Iceland": "50459",
			"El Salvador": "7672",
			"New Zealand": "5179"
		},
		"exports": {
			"Lebanon": "666961",
			"Gibraltar": "748547",
			"Ghana": "129053",
			"Uruguay": "99",
			"Andorra": "33455",
			"Cabo Verde": "189714",
			"Togo": "5026020",
			"Barbados": "117202",
			"Poland": "11901",
			"Qatar": "1",
			"Dem. Rep. of the Congo": "209900",
			"Thailand": "2113955",
			"Dem. People's Rep. of Korea": "486109",
			"Argentina": "26290",
			"Brazil": "878",
			"Azerbaijan": "4250",
			"Cameroon": "32643",
			"Brunei Darussalam": "1702",
			"Papua New Guinea": "10212",
			"Mongolia": "95937",
			"Saudi Arabia": "4480",
			"Panama": "1838",
			"Colombia": "100659",
			"Sudan": "423537",
			"Russian Federation": "5869",
			"United Arab Emirates": "27450",
			"Nicaragua": "3033",
			"Libya": "28817",
			"Malawi": "10489",
			"Switzerland": "3684",
			"Georgia": "149315",
			"Ukraine": "210286",
			"Latvia": "34609",
			"Japan": "812205",
			"Hungary": "980335",
			"Iraq": "440",
			"Uganda": "74044",
			"Romania": "42169",
			"Pakistan": "2624",
			"Belgium": "1609",
			"Slovenia": "4719",
			"Liberia": "43570",
			"Bolivia (Plurinational State of)": "7226",
			"Mozambique": "201563",
			"Germany": "27452",
			"Singapore": "6346",
			"Nigeria": "2298",
			"Albania": "88928",
			"Benin": "37869",
			"Tunisia": "219",
			"Chad": "378",
			"Viet Nam": "15488",
			"Haiti": "3006",
			"South Africa": "13249",
			"Guinea": "3574",
			"Indonesia": "18164",
			"Saint Vincent and the Grenadines": "7024",
			"Sweden": "44804",
			"Maldives": "704",
			"India": "511",
			"Mexico": "7710791",
			"Kenya": "224",
			"Spain": "3048",
			"Gabon": "437703",
			"Ireland": "2151667",
			"Botswana": "42",
			"Zimbabwe": "128",
			"Côte d'Ivoire": "596",
			"Austria": "726",
			"Mauritania": "509153",
			"Lithuania": "9907",
			"Namibia": "76073",
			"Denmark": "334344",
			"Somalia": "51",
			"Central African Rep.": "753208",
			"Netherlands": "81564",
			"United Kingdom": "1093265",
			"Costa Rica": "3865",
			"Bulgaria": "471977",
			"Greece": "1290092",
			"Chile": "126612",
			"Kazakhstan": "23713",
			"Gambia": "12806",
			"China, Macao SAR": "685",
			"Afghanistan": "28634",
			"Croatia": "6570",
			"Equatorial Guinea": "171039",
			"Malaysia": "116555",
			"Portugal": "3662791",
			"Comoros": "5587",
			"China": "5122686",
			"Egypt": "17180",
			"Guinea-Bissau": "826870",
			"Morocco": "810217",
			"Mali": "934235",
			"Trinidad and Tobago": "528214",
			"Israel": "1278106",
			"Burkina Faso": "21787274",
			"Angola": "71892",
			"Bangladesh": "2451",
			"Antigua and Barbuda": "135232",
			"United Rep. of Tanzania": "185452",
			"Finland": "504",
			"Bosnia Herzegovina": "5841",
			"Cyprus": "13288",
			"Zambia": "170",
			"Mauritius": "1399",
			"Slovakia": "3",
			"Bermuda": "1942",
			"Djibouti": "851",
			"Madagascar": "4912",
			"Syria": "13856",
			"China, Hong Kong SAR": "377045",
			"Burundi": "2431",
			"Niger": "98739",
			"Algeria": "456941",
			"USA": "1713660",
			"Cambodia": "18251",
			"Iran": "24529",
			"Kuwait": "340",
			"Malta": "105243",
			"Norway": "13767621",
			"Ecuador": "256248",
			"Sierra Leone": "6126670",
			"France": "24887",
			"Australia": "51",
			"Seychelles": "4",
			"Italy": "7489",
			"Rwanda": "14358",
			"Guatemala": "1956",
			"Ethiopia": "403",
			"Congo": "74135",
			"Turkey": "200",
			"Montenegro": "238134",
			"Rep. of Korea": "42465468",
			"Serbia": "15042",
			"Holy See (Vatican City State)": "31040",
			"Armenia": "4783",
			"Jordan": "3641",
			"Saint Pierre and Miquelon": "10952",
			"Canada": "112910",
			"Iceland": "8490",
			"New Zealand": "8170"
		}
	},
	"Solomon Isds": {
		"imports": {
			"Papua New Guinea": "5187148",
			"Niger": "1074",
			"United Kingdom": "87012",
			"Timor-Leste": "1253",
			"Cuba": "488",
			"Thailand": "1711023",
			"Dem. People's Rep. of Korea": "51927",
			"Argentina": "37310",
			"Brazil": "78088",
			"Cameroon": "721",
			"Mongolia": "482",
			"Indonesia": "3128127",
			"Colombia": "47",
			"Russian Federation": "83",
			"United Arab Emirates": "4580",
			"Angola": "49",
			"Switzerland": "2231",
			"Ukraine": "3474",
			"Japan": "42994",
			"Romania": "18",
			"Pakistan": "39",
			"Belgium": "267",
			"Slovenia": "167",
			"Germany": "52792",
			"Singapore": "1145241",
			"Barbados": "1371",
			"San Marino": "2104",
			"Viet Nam": "27522580",
			"Haiti": "8584",
			"FS Micronesia": "1237",
			"Panama": "31",
			"American Samoa": "621",
			"Saint Vincent and the Grenadines": "993",
			"Oman": "113",
			"Sweden": "5407",
			"Australia": "26812700",
			"Kiribati": "167",
			"India": "537569",
			"Jamaica": "5664",
			"Mexico": "22135",
			"Kenya": "24",
			"Austria": "30991",
			"Bosnia Herzegovina": "17",
			"Ireland": "6496",
			"Vanuatu": "941076",
			"Spain": "104",
			"Mauritania": "92",
			"Fiji": "2537669",
			"Cambodia": "6444",
			"Denmark": "482881",
			"Netherlands": "325",
			"Costa Rica": "99",
			"Croatia": "15276",
			"Malaysia": "5147649",
			"Swaziland": "69",
			"Egypt": "7595",
			"China": "6026614",
			"Comoros": "7",
			"Nauru": "91",
			"Anguilla": "299",
			"Morocco": "972",
			"Mali": "48422",
			"Trinidad and Tobago": "292",
			"Israel": "12303",
			"TFYR of Macedonia": "11",
			"Bangladesh": "4062",
			"Antigua and Barbuda": "19073",
			"Gabon": "305",
			"Finland": "2660",
			"Cyprus": "10911",
			"Yemen": "2461",
			"Georgia": "1481",
			"Slovakia": "163",
			"Luxembourg": "680",
			"China, Hong Kong SAR": "1164629",
			"Guyana": "3671",
			"Suriname": "205",
			"USA": "58812",
			"Namibia": "3164",
			"Malta": "104",
			"Norway": "818",
			"Sierra Leone": "593",
			"Marshall Isds": "580",
			"New Caledonia": "368",
			"Philippines": "983394",
			"Italy": "1912",
			"Czechia": "20483",
			"Mozambique": "2733",
			"Senegal": "525",
			"Turkey": "8",
			"Sri Lanka": "10046",
			"Rep. of Korea": "18261",
			"France": "22045",
			"New Zealand": "6161404",
			"Canada": "590",
			"Iceland": "308",
			"Samoa": "3975",
			"Myanmar": "185623"
		},
		"exports": {
			"Lebanon": "5675",
			"Denmark": "5690",
			"Papua New Guinea": "416416",
			"Greece": "112014",
			"United Kingdom": "19306480",
			"Qatar": "962",
			"Thailand": "3695227",
			"Dem. People's Rep. of Korea": "261235",
			"Nepal": "882",
			"China": "5085",
			"Nauru": "169790",
			"Pakistan": "1361",
			"Russian Federation": "4234",
			"United Arab Emirates": "309592",
			"France": "352831",
			"Bangladesh": "2651",
			"Italy": "5452535",
			"Switzerland": "14532238",
			"Finland": "3",
			"Ukraine": "1215",
			"Japan": "548120",
			"Cook Isds": "5192",
			"Vanuatu": "1195472",
			"Belgium": "54611",
			"USA": "838434",
			"Rep. of Moldova": "3036",
			"Australia": "1618",
			"Kuwait": "22892",
			"Germany": "94333",
			"Singapore": "902527",
			"New Zealand": "218777",
			"Marshall Isds": "63",
			"Viet Nam": "2388",
			"New Caledonia": "55",
			"Philippines": "11125007",
			"Niue": "3024",
			"Indonesia": "236032",
			"American Samoa": "118",
			"Oman": "970",
			"Maldives": "315",
			"Kiribati": "292931",
			"India": "4029",
			"Spain": "289206",
			"Turkey": "3015",
			"Malaysia": "173472",
			"China, Hong Kong SAR": "26193",
			"Rep. of Korea": "546",
			"Tonga": "145",
			"Fiji": "851835",
			"Jordan": "11499",
			"Canada": "40355",
			"Netherlands": "3027991"
		}
	},
	"Cocos Isds": {
		"imports": {},
		"exports": {}
	},
	"Bulgaria": {
		"imports": {
			"Lebanon": "31729942",
			"Gibraltar": "75676",
			"Iran": "61496",
			"Uruguay": "5000",
			"Switzerland": "92643314",
			"Germany": "22496385",
			"Barbados": "87",
			"Poland": "402376",
			"Cuba": "4310",
			"Bahrain": "4185",
			"Dem. Rep. of the Congo": "66407",
			"Thailand": "4440225",
			"Dem. People's Rep. of Korea": "1630",
			"Argentina": "1980380",
			"Brazil": "6853269",
			"Azerbaijan": "3716",
			"Cameroon": "166",
			"Dominica": "31",
			"Ghana": "34626048",
			"Mongolia": "55",
			"Saudi Arabia": "2060",
			"Panama": "151259",
			"Colombia": "297488",
			"Syria": "8037",
			"Russian Federation": "9348",
			"Cayman Isds": "1087",
			"United Arab Emirates": "788520",
			"Rwanda": "1716",
			"Tajikistan": "82330",
			"Jordan": "1471",
			"Malawi": "1370551",
			"Andorra": "6708",
			"El Salvador": "4193",
			"United States Minor Outlying Islands": "65323",
			"Slovakia": "76502264",
			"Iraq": "11492",
			"Japan": "175445",
			"Latvia": "3104",
			"Uganda": "254",
			"Bosnia Herzegovina": "55135",
			"Pakistan": "10412256",
			"Belgium": "9217379",
			"Croatia": "131679",
			"Liberia": "2668",
			"Belarus": "105953",
			"Madagascar": "21072",
			"Bolivia (Plurinational State of)": "117285",
			"Nigeria": "38150",
			"Albania": "4531909",
			"Benin": "1006190",
			"Maldives": "232",
			"Bahamas": "938",
			"Tunisia": "42962",
			"Mozambique": "119",
			"Viet Nam": "1215183",
			"South Africa": "195587",
			"Guinea": "84895",
			"Indonesia": "6343576",
			"Qatar": "1471280",
			"San Marino": "280472",
			"Sweden": "11141226",
			"Australia": "13204",
			"Saint Maarten": "216",
			"India": "2904922",
			"Mexico": "13018051",
			"Jamaica": "326",
			"Kenya": "10124",
			"Austria": "4958707",
			"Eritrea": "9621020",
			"Ireland": "39095",
			"Botswana": "115",
			"Zimbabwe": "1049524",
			"Côte d'Ivoire": "72935",
			"Spain": "25548429",
			"Mauritania": "57904",
			"Lithuania": "1655",
			"Cambodia": "4123",
			"Denmark": "1539157",
			"Portugal": "26799489",
			"Central African Rep.": "248",
			"Honduras": "6552267",
			"Netherlands": "1437157",
			"United Kingdom": "3850593",
			"Costa Rica": "26563",
			"Venezuela": "436",
			"Equatorial Guinea": "467133",
			"Greece": "17127980",
			"Chile": "132635",
			"Kazakhstan": "18495525",
			"Sudan": "7500",
			"China, Macao SAR": "979603",
			"Libya": "4094834",
			"Afghanistan": "1075",
			"Mali": "165",
			"Curaçao": "8699",
			"South Sudan": "30236",
			"Malaysia": "781",
			"Peru": "18536644",
			"Falkland Isds (Malvinas)": "34140",
			"Oman": "9654",
			"Nepal": "994",
			"China": "217067",
			"Egypt": "34736",
			"Anguilla": "20647",
			"Estonia": "235270",
			"Morocco": "105062",
			"Luxembourg": "59767",
			"Trinidad and Tobago": "151",
			"Israel": "15206",
			"TFYR of Macedonia": "3477549",
			"Burkina Faso": "22",
			"Brunei Darussalam": "682",
			"Singapore": "13252999",
			"Paraguay": "283015",
			"Angola": "602",
			"Bangladesh": "31630",
			"Yemen": "1155387",
			"Gabon": "57693",
			"Finland": "7890",
			"Cyprus": "215165",
			"Belize": "138237",
			"Georgia": "22122",
			"Serbia": "27374",
			"Djibouti": "1073",
			"Faeroe Isds": "894914",
			"Turkmenistan": "3595",
			"Uzbekistan": "44",
			"Zambia": "172",
			"China, Hong Kong SAR": "128806",
			"Guyana": "683",
			"Mauritius": "436",
			"Algeria": "63585",
			"USA": "9268575",
			"Namibia": "61879",
			"Rep. of Moldova": "36097",
			"Romania": "1083337",
			"Kuwait": "295350",
			"Suriname": "9581",
			"Malta": "3104558",
			"Norway": "933",
			"Ecuador": "4210",
			"State of Palestine": "387",
			"Sierra Leone": "25094",
			"Dominican Rep.": "490814",
			"France": "13178807",
			"New Caledonia": "12773",
			"Philippines": "265",
			"Seychelles": "9098",
			"Br. Virgin Isds": "53",
			"Italy": "4279719",
			"Kyrgyzstan": "3985035",
			"Czechia": "4389187",
			"Nicaragua": "1267524",
			"Guatemala": "41315",
			"Ethiopia": "3484306",
			"Slovenia": "9780245",
			"Congo": "7118",
			"Senegal": "664",
			"Aruba": "1111",
			"Turkey": "73971794",
			"Montenegro": "56608",
			"Sri Lanka": "290545",
			"Rep. of Korea": "230929",
			"Hungary": "10726315",
			"United Rep. of Tanzania": "13313",
			"Armenia": "4256",
			"New Zealand": "3824557",
			"Canada": "7546976",
			"Iceland": "11421",
			"Ukraine": "2741407",
			"Myanmar": "160684"
		},
		"exports": {
			"Lebanon": "20725",
			"Gibraltar": "13779",
			"Ghana": "126484",
			"Lesotho": "792",
			"Cuba": "1231",
			"Dem. Rep. of the Congo": "20940",
			"Dem. People's Rep. of Korea": "519339",
			"Cameroon": "12289",
			"South Africa": "1474325",
			"Indonesia": "358258",
			"Colombia": "321",
			"Niger": "95108",
			"Jordan": "5080321",
			"Fr. South Antarctic Terr.": "19756",
			"Uzbekistan": "3595",
			"Iraq": "43709",
			"Tuvalu": "625",
			"Guam": "96",
			"Bosnia Herzegovina": "2748275",
			"Pakistan": "6099682",
			"Belgium": "3615033",
			"Azerbaijan": "3017",
			"Armenia": "3824",
			"United Kingdom": "58678395",
			"Singapore": "557911",
			"Albania": "630326",
			"Benin": "766351",
			"Panama": "660437",
			"Qatar": "1180",
			"Saint Vincent and the Grenadines": "11280",
			"Curaçao": "44669",
			"Australia": "81844",
			"Mexico": "23290",
			"Kenya": "152851",
			"Spain": "125477882",
			"Tajikistan": "235907",
			"Br. Virgin Isds": "57",
			"Botswana": "1123710",
			"French Polynesia": "19549",
			"Mauritania": "4679733",
			"Honduras": "480",
			"Holy See (Vatican City State)": "417",
			"Ireland": "355627",
			"Chile": "1003751",
			"Gambia": "21777",
			"China, Macao SAR": "2108",
			"Dominica": "36760",
			"Malaysia": "3487",
			"Fiji": "807",
			"Peru": "1713",
			"Nepal": "1103285",
			"China": "881369",
			"Comoros": "14912",
			"Guinea-Bissau": "1419",
			"Djibouti": "23015",
			"Trinidad and Tobago": "313",
			"Israel": "63178",
			"Burkina Faso": "10809",
			"Paraguay": "594",
			"Bangladesh": "82545",
			"Antigua and Barbuda": "1383",
			"Gabon": "3530",
			"Cyprus": "1193788",
			"Yemen": "51716",
			"Mauritius": "82354",
			"Slovakia": "51258814",
			"Turkmenistan": "30733",
			"Bahrain": "398",
			"Côte d'Ivoire": "11153",
			"Guyana": "66587",
			"Algeria": "363460",
			"USA": "1789295",
			"Saint Kitts and Nevis": "3521",
			"Rep. of Moldova": "3098",
			"Zambia": "3925",
			"Malta": "48123",
			"Ecuador": "1240",
			"Grenada": "238",
			"Dominican Rep.": "8717",
			"France": "9759445",
			"New Caledonia": "12580",
			"Seychelles": "172210",
			"Italy": "10622792",
			"Saint Lucia": "5924",
			"State of Palestine": "22100",
			"Rwanda": "160244",
			"Syria": "7587172",
			"Belarus": "3983",
			"Ethiopia": "924",
			"Namibia": "48153",
			"Congo": "297469",
			"Senegal": "236860",
			"Montenegro": "73665",
			"Sri Lanka": "1271762",
			"Hungary": "2408551",
			"Netherlands": "6232181",
			"New Zealand": "2194",
			"N. Mariana Isds": "65",
			"Lao People's Dem. Rep.": "105256",
			"Myanmar": "161943",
			"Iran": "239",
			"Uruguay": "1077",
			"Andorra": "10865",
			"Cabo Verde": "1878",
			"Germany": "8504449",
			"Poland": "2883782",
			"Thailand": "2204133",
			"Argentina": "161444",
			"Brazil": "10775",
			"Brunei Darussalam": "319",
			"Mongolia": "2314",
			"Saudi Arabia": "7358",
			"Greece": "107450070",
			"Russian Federation": "103626",
			"Cayman Isds": "291",
			"United Arab Emirates": "122475408",
			"Nicaragua": "20386",
			"Malawi": "1141",
			"Switzerland": "16936980",
			"El Salvador": "7347",
			"United States Minor Outlying Islands": "26102",
			"Latvia": "190175",
			"Japan": "67340",
			"Guinea": "1135805",
			"Uganda": "2317",
			"Romania": "4273662",
			"Croatia": "3647293",
			"Liberia": "2667",
			"Guatemala": "39179",
			"Madagascar": "84892",
			"Bolivia (Plurinational State of)": "5050",
			"Nigeria": "463",
			"Bahamas": "576",
			"Tunisia": "17056",
			"Chad": "18047",
			"Viet Nam": "722773",
			"Haiti": "188156",
			"Oman": "1849969",
			"Sweden": "38663370",
			"Maldives": "1130",
			"India": "123487",
			"Jamaica": "21796",
			"Austria": "7435438",
			"Eritrea": "1812",
			"Zimbabwe": "65811",
			"Saint Maarten": "253699",
			"Lithuania": "938990",
			"Cambodia": "7331",
			"Denmark": "594085",
			"Portugal": "63204189",
			"Central African Rep.": "189919",
			"Slovenia": "15412265",
			"Costa Rica": "30371",
			"Equatorial Guinea": "2504",
			"Sudan": "95798",
			"Papua New Guinea": "259",
			"Kazakhstan": "1237",
			"Afghanistan": "13658",
			"Egypt": "1993815",
			"Nauru": "13677",
			"Estonia": "62539",
			"Morocco": "16279814",
			"Luxembourg": "122975",
			"TFYR of Macedonia": "5075580",
			"Somalia": "6650",
			"Angola": "21788",
			"United Rep. of Tanzania": "136272",
			"Finland": "40663",
			"Belize": "6465",
			"Georgia": "69392",
			"Ukraine": "306689",
			"Bermuda": "304",
			"Mali": "19144",
			"China, Hong Kong SAR": "5052",
			"Suriname": "49490",
			"Barbados": "2748",
			"Venezuela": "513",
			"Kuwait": "2024",
			"Norway": "6946",
			"Sierra Leone": "4323",
			"Marshall Isds": "4521",
			"Philippines": "941",
			"Libya": "65167062",
			"Kyrgyzstan": "1611236",
			"Czechia": "1327824",
			"Mozambique": "7781",
			"Togo": "244640",
			"Aruba": "16991",
			"Turkey": "8835840",
			"San Marino": "5024",
			"Rep. of Korea": "37247",
			"Serbia": "654391",
			"Burundi": "328",
			"Cook Isds": "3166",
			"Canada": "16649",
			"Iceland": "51676"
		}
	},
	"Montenegro": {
		"imports": {
			"Lebanon": "11865",
			"Gibraltar": "1849",
			"Ghana": "10895",
			"Qatar": "714",
			"Dem. People's Rep. of Korea": "3952",
			"Cameroon": "72124",
			"South Africa": "30288",
			"Montserrat": "1",
			"Panama": "36882",
			"Colombia": "72236",
			"Saint Pierre and Miquelon": "905",
			"Palau": "449",
			"Jordan": "1018",
			"Fr. South Antarctic Terr.": "200",
			"Uzbekistan": "556",
			"Iraq": "60",
			"Tuvalu": "77",
			"Bosnia Herzegovina": "12180",
			"Pakistan": "225",
			"Belgium": "10579",
			"Azerbaijan": "5767",
			"Australia": "68880",
			"Germany": "1306837",
			"Singapore": "1125",
			"Albania": "20389",
			"Benin": "1387",
			"FS Micronesia": "952",
			"Indonesia": "17039",
			"Cuba": "67512",
			"Saint Vincent and the Grenadines": "133",
			"Curaçao": "334",
			"Armenia": "4217",
			"Jamaica": "5106",
			"Kenya": "10609",
			"Spain": "2081388",
			"Tajikistan": "2987",
			"Ireland": "358003",
			"French Polynesia": "106",
			"Mauritania": "5655",
			"Christmas Isds": "139",
			"Honduras": "31911",
			"Holy See (Vatican City State)": "640",
			"Chile": "172765",
			"Sudan": "246",
			"Gambia": "243",
			"Liberia": "78",
			"Malaysia": "18120",
			"Fiji": "305",
			"Portugal": "461856",
			"Falkland Isds (Malvinas)": "37425",
			"Nepal": "39",
			"China": "691394",
			"Comoros": "132",
			"Guinea-Bissau": "134",
			"Trinidad and Tobago": "201",
			"Israel": "9923",
			"Paraguay": "139797",
			"Bangladesh": "4366",
			"Gabon": "166319",
			"Cyprus": "220296",
			"Mauritius": "10317",
			"Slovakia": "500777",
			"Faeroe Isds": "40011",
			"Turkmenistan": "315",
			"Bahrain": "546",
			"Côte d'Ivoire": "3116",
			"Algeria": "2360",
			"USA": "1819050",
			"Cambodia": "20644",
			"Rep. of Moldova": "16727",
			"Zambia": "945",
			"Malta": "45",
			"Ecuador": "1063",
			"Grenada": "2624",
			"France": "272778",
			"Niue": "2465",
			"Br. Virgin Isds": "18113",
			"Italy": "867536",
			"Uganda": "4",
			"Belarus": "43975",
			"Ethiopia": "14180",
			"Senegal": "688",
			"Bulgaria": "25620",
			"Sri Lanka": "6564",
			"Hungary": "6980",
			"New Zealand": "185",
			"Lao People's Dem. Rep.": "12520",
			"Myanmar": "14921",
			"Papua New Guinea": "1151",
			"Uruguay": "29",
			"Andorra": "67",
			"Cabo Verde": "4470",
			"United Kingdom": "2605057",
			"Timor-Leste": "721",
			"Poland": "1673775",
			"Thailand": "104728",
			"Argentina": "715834",
			"Brazil": "42578",
			"Dominica": "22974",
			"Mongolia": "44",
			"Saudi Arabia": "38",
			"Syria": "899",
			"Russian Federation": "472333",
			"Cayman Isds": "914",
			"United Arab Emirates": "56705",
			"Nicaragua": "346",
			"Malawi": "16",
			"Switzerland": "1703659",
			"El Salvador": "1040",
			"United States Minor Outlying Islands": "389",
			"Latvia": "264389",
			"Japan": "850075",
			"Guinea": "32",
			"Romania": "1075983",
			"Slovenia": "9491071",
			"China, Macao SAR": "798",
			"Madagascar": "8080",
			"Bolivia (Plurinational State of)": "3273",
			"Nigeria": "576",
			"Bahamas": "75",
			"San Marino": "1822",
			"Chad": "921",
			"Viet Nam": "165901",
			"Haiti": "581",
			"Tokelau": "1098",
			"Oman": "681",
			"Sweden": "982656",
			"Maldives": "64",
			"India": "90353",
			"Mexico": "57523",
			"Austria": "126300",
			"Zimbabwe": "401",
			"Vanuatu": "671",
			"Swaziland": "159",
			"Lithuania": "46342",
			"Namibia": "38883",
			"Denmark": "957",
			"Peru": "68977",
			"Central African Rep.": "11",
			"Netherlands": "298835",
			"Costa Rica": "53",
			"Equatorial Guinea": "45",
			"Greece": "7517",
			"Kazakhstan": "552",
			"Afghanistan": "5551",
			"Croatia": "232786",
			"Saint Helena": "620",
			"Egypt": "85529",
			"Nauru": "10",
			"Estonia": "56145",
			"Morocco": "11667",
			"Luxembourg": "358087",
			"TFYR of Macedonia": "3140663",
			"Heard Island and McDonald Islands": "268",
			"United Rep. of Tanzania": "14",
			"Finland": "12138",
			"Belize": "1124",
			"Georgia": "405",
			"Ukraine": "443743",
			"Bermuda": "1722",
			"Antarctica": "25",
			"Greenland": "1750",
			"China, Hong Kong SAR": "1850",
			"Suriname": "386",
			"Barbados": "6317",
			"Iran": "34700",
			"Venezuela": "6683",
			"Kuwait": "3035",
			"Norway": "11777",
			"Sierra Leone": "165",
			"Philippines": "9697",
			"Libya": "166",
			"Kyrgyzstan": "2634",
			"Czechia": "22606",
			"Guatemala": "2862",
			"Aruba": "209",
			"Turkey": "7074139",
			"Tunisia": "214755",
			"Rep. of Korea": "1042",
			"Serbia": "3687146",
			"Burundi": "43",
			"Canada": "160747",
			"Iceland": "171382"
		},
		"exports": {
			"Denmark": "756740",
			"Bulgaria": "25421",
			"South Africa": "14108",
			"Greece": "5771",
			"Croatia": "18790",
			"Kazakhstan": "72948",
			"Liberia": "2706",
			"United Kingdom": "68192",
			"Cayman Isds": "90",
			"Poland": "278627",
			"Equatorial Guinea": "63126",
			"Malaysia": "221387",
			"Swaziland": "5264",
			"Portugal": "8576",
			"Azerbaijan": "111",
			"China": "1481240",
			"Egypt": "39857",
			"Saudi Arabia": "1040986",
			"Czechia": "5370439",
			"Luxembourg": "18",
			"Russian Federation": "1843565",
			"TFYR of Macedonia": "161958",
			"United Arab Emirates": "1168914",
			"Bangladesh": "831",
			"Italy": "320644",
			"Switzerland": "99",
			"Belarus": "4075",
			"Finland": "17520",
			"Cyprus": "5552",
			"Georgia": "22",
			"Slovakia": "91185",
			"Latvia": "6980",
			"Japan": "7502",
			"Hungary": "45031",
			"Bermuda": "785",
			"Uzbekistan": "79076",
			"Romania": "221",
			"Pakistan": "153222",
			"Belgium": "9947",
			"Slovenia": "67515",
			"Algeria": "70461",
			"Malta": "260",
			"Indonesia": "287169",
			"Rep. of Moldova": "40895",
			"Venezuela": "66692",
			"Kuwait": "10293",
			"Germany": "3295273",
			"Singapore": "15659",
			"Nigeria": "12490",
			"Albania": "48989",
			"Norway": "111",
			"France": "9947",
			"USA": "221",
			"Panama": "7861",
			"Libya": "376796",
			"Oman": "1273",
			"Sweden": "3187",
			"Australia": "52525",
			"Ethiopia": "97855",
			"India": "1658",
			"Mexico": "398658",
			"Br. Virgin Isds": "4865",
			"Spain": "525",
			"Bosnia Herzegovina": "154050",
			"Turkey": "194",
			"Thailand": "88298",
			"Sri Lanka": "4863",
			"China, Hong Kong SAR": "2462815",
			"Rep. of Korea": "41",
			"Austria": "284",
			"Serbia": "89849",
			"Lithuania": "4421",
			"Argentina": "332",
			"Jordan": "15198",
			"Canada": "217641",
			"Israel": "2271",
			"Ukraine": "546714",
			"Netherlands": "15193"
		}
	},
	"Sri Lanka": {
		"imports": {
			"Lebanon": "173",
			"Gibraltar": "5820",
			"Ghana": "83343",
			"Cuba": "28",
			"Dem. People's Rep. of Korea": "1384",
			"Cameroon": "142818",
			"Papua New Guinea": "34",
			"Panama": "110698",
			"Colombia": "12180",
			"Niger": "621",
			"Jordan": "18985",
			"Uzbekistan": "12",
			"Iraq": "17",
			"Bosnia Herzegovina": "179099",
			"Pakistan": "672",
			"Belgium": "69752067",
			"Azerbaijan": "73",
			"Armenia": "683",
			"United Kingdom": "298831",
			"Singapore": "8715",
			"Albania": "104868",
			"Benin": "5846",
			"Indonesia": "20",
			"Qatar": "2478",
			"American Samoa": "14",
			"Saint Vincent and the Grenadines": "7367",
			"Australia": "196280228",
			"Mexico": "91268",
			"Br. Virgin Isds": "7638",
			"Spain": "29534",
			"Tajikistan": "60383",
			"Ireland": "107281",
			"Botswana": "21",
			"Mauritania": "33780",
			"Eritrea": "137",
			"Honduras": "55",
			"Holy See (Vatican City State)": "9693",
			"Chile": "336",
			"Liberia": "1",
			"Dominica": "2564",
			"Malaysia": "3650541",
			"Fiji": "6545",
			"Portugal": "78602",
			"Nepal": "10333",
			"China": "5824350",
			"Comoros": "7436",
			"Mali": "72",
			"Trinidad and Tobago": "451",
			"Israel": "1373763",
			"Paraguay": "26851",
			"Bangladesh": "29351156",
			"Antigua and Barbuda": "5737",
			"Gabon": "2578",
			"Cyprus": "1081",
			"Yemen": "4789364",
			"Mauritius": "1582438",
			"Slovakia": "202",
			"Turkmenistan": "2480",
			"Bahrain": "14008815",
			"Côte d'Ivoire": "2766434",
			"Guyana": "454",
			"Algeria": "7",
			"USA": "1017358",
			"Saint Kitts and Nevis": "34",
			"Rep. of Moldova": "41",
			"Zambia": "2243",
			"Malta": "48795",
			"Ecuador": "15507",
			"Grenada": "483",
			"Dominican Rep.": "30172",
			"France": "450689",
			"New Caledonia": "137",
			"Niue": "227",
			"Seychelles": "31202",
			"Italy": "14252",
			"Rwanda": "34",
			"Syria": "4",
			"Belarus": "19315879",
			"Ethiopia": "420194",
			"Namibia": "14",
			"Pitcairn": "38126",
			"Senegal": "199970",
			"Bulgaria": "6230291",
			"Montenegro": "4658",
			"Hungary": "248715",
			"Netherlands": "61026",
			"New Zealand": "177267191",
			"Lao People's Dem. Rep.": "7508590",
			"Myanmar": "31872802",
			"South Africa": "31691",
			"Philippines": "5039090",
			"Uruguay": "184737",
			"Switzerland": "4335",
			"Cabo Verde": "85",
			"Germany": "56188",
			"Timor-Leste": "11756",
			"Poland": "3616",
			"Thailand": "2275067",
			"Argentina": "5918141",
			"Brazil": "193154502",
			"Brunei Darussalam": "138939",
			"Mongolia": "791",
			"Saudi Arabia": "118882",
			"Sudan": "17910",
			"Russian Federation": "254",
			"United Arab Emirates": "66771",
			"Nicaragua": "87110",
			"Malawi": "20140",
			"Andorra": "63454",
			"El Salvador": "4089",
			"United States Minor Outlying Islands": "5765",
			"Latvia": "7187",
			"Japan": "2946822",
			"Guinea": "44",
			"Uganda": "52014",
			"Romania": "23467",
			"Croatia": "2145",
			"China, Macao SAR": "405004",
			"Mozambique": "39415",
			"Madagascar": "264",
			"Bolivia (Plurinational State of)": "272403",
			"Barbados": "918",
			"Bahamas": "918",
			"San Marino": "301922",
			"Viet Nam": "73476",
			"Haiti": "18",
			"Tokelau": "221",
			"Christmas Isds": "34",
			"Oman": "1223231",
			"Sweden": "2051",
			"Maldives": "323",
			"India": "214944891",
			"Jamaica": "586",
			"Austria": "99981657",
			"Bouvet Island": "44359",
			"Congo": "913",
			"Zimbabwe": "2834",
			"Vanuatu": "57451",
			"Swaziland": "172",
			"Lithuania": "137016",
			"Cambodia": "6803725",
			"Denmark": "28",
			"Peru": "779",
			"Central African Rep.": "2220",
			"Slovenia": "5257",
			"Costa Rica": "3836",
			"Greece": "50",
			"Kazakhstan": "93",
			"Kenya": "191327",
			"Afghanistan": "208",
			"Saint Helena": "7",
			"Egypt": "837316",
			"Nauru": "1859",
			"Anguilla": "55",
			"Estonia": "3576",
			"Morocco": "19039",
			"Luxembourg": "359142",
			"TFYR of Macedonia": "52986",
			"Somalia": "67",
			"United Rep. of Tanzania": "2158",
			"Finland": "119943",
			"Belize": "430342",
			"Georgia": "17",
			"Ukraine": "277",
			"Bermuda": "21911",
			"Djibouti": "516492",
			"Greenland": "41",
			"China, Hong Kong SAR": "1458",
			"Suriname": "1475",
			"Nigeria": "43",
			"Samoa": "275",
			"Iran": "1832",
			"Venezuela": "1868",
			"Kuwait": "7543",
			"Norway": "1688",
			"Sierra Leone": "375",
			"Sao Tome and Principe": "18",
			"Libya": "254",
			"Kyrgyzstan": "192",
			"Czechia": "960",
			"Br. Indian Ocean Terr.": "275",
			"Guatemala": "9910",
			"Togo": "172",
			"Aruba": "208",
			"Turkey": "75101",
			"Tunisia": "43",
			"Rep. of Korea": "23280",
			"Serbia": "343",
			"Bhutan": "790",
			"Cook Isds": "41",
			"Canada": "192319",
			"Iceland": "22582"
		},
		"exports": {
			"Lebanon": "16",
			"Gibraltar": "32956",
			"Ghana": "111341",
			"Lesotho": "3134",
			"Cuba": "1281",
			"Dem. People's Rep. of Korea": "1869047",
			"Cameroon": "430992",
			"Papua New Guinea": "227096",
			"Panama": "19621",
			"Colombia": "78419",
			"Niger": "373321",
			"Angola": "65",
			"Uzbekistan": "5942",
			"Iraq": "97766",
			"Bosnia Herzegovina": "3633069",
			"Pakistan": "674",
			"Belgium": "338186920",
			"Azerbaijan": "46498653",
			"Armenia": "1388116",
			"United Kingdom": "7812572",
			"Singapore": "25386514",
			"Albania": "29139",
			"Benin": "684",
			"South Africa": "487576",
			"Indonesia": "319872",
			"Qatar": "5002660",
			"American Samoa": "810",
			"Curaçao": "14408",
			"Australia": "165930165",
			"Kiribati": "72399",
			"Jamaica": "1910307",
			"Br. Virgin Isds": "26119",
			"Spain": "53",
			"Tajikistan": "462967",
			"Ireland": "597282",
			"Botswana": "351267",
			"French Polynesia": "356568",
			"Mauritania": "861786",
			"Honduras": "1426642",
			"Holy See (Vatican City State)": "53666",
			"Chile": "245814",
			"Gambia": "2866",
			"Liberia": "448",
			"Dominica": "55975",
			"Malaysia": "65587",
			"Swaziland": "28",
			"Peru": "9707",
			"Nepal": "20836",
			"China": "192836",
			"Comoros": "723763",
			"Guinea-Bissau": "53208",
			"Mali": "305027",
			"Trinidad and Tobago": "1173154",
			"Israel": "985928",
			"Burkina Faso": "52",
			"Paraguay": "26339",
			"Bangladesh": "118865812",
			"Antigua and Barbuda": "818",
			"Gabon": "58807",
			"Cyprus": "39356",
			"Yemen": "28066",
			"Mauritius": "83470",
			"Slovakia": "120949",
			"Turkmenistan": "19990",
			"Bahrain": "10987536",
			"Côte d'Ivoire": "125652",
			"Guyana": "41142",
			"Algeria": "3717",
			"USA": "42631",
			"Cambodia": "6063095",
			"Rep. of Moldova": "7018",
			"Zambia": "82",
			"Malta": "93983",
			"Ecuador": "910654",
			"Dominican Rep.": "994",
			"France": "75208",
			"New Caledonia": "79723",
			"Seychelles": "1263",
			"Italy": "730414",
			"Saint Lucia": "4526",
			"Nicaragua": "1910275",
			"Syria": "54087437",
			"Belarus": "2744416",
			"Ethiopia": "1665",
			"Slovenia": "48364",
			"Congo": "19",
			"Senegal": "41042",
			"Bulgaria": "1956623",
			"Montenegro": "2526",
			"Hungary": "71008",
			"Jordan": "1031063",
			"N. Mariana Isds": "30649",
			"Lao People's Dem. Rep.": "177",
			"Myanmar": "1527516",
			"Iran": "506776",
			"Uruguay": "6120",
			"Cabo Verde": "23456",
			"Germany": "2045940",
			"Timor-Leste": "93014",
			"Poland": "4992954",
			"Thailand": "48",
			"Argentina": "9515360",
			"Brazil": "44510986",
			"Brunei Darussalam": "106359",
			"Mongolia": "15882",
			"Saudi Arabia": "16225",
			"Sudan": "5970",
			"Russian Federation": "1130032",
			"Cayman Isds": "85",
			"United Arab Emirates": "1143107",
			"Rwanda": "99201",
			"Malawi": "42",
			"Switzerland": "1603",
			"El Salvador": "178072",
			"United States Minor Outlying Islands": "8973",
			"Latvia": "30729",
			"Japan": "51436",
			"Guinea": "2465205",
			"Uganda": "2199",
			"Romania": "3129",
			"Croatia": "164552",
			"China, Macao SAR": "5199",
			"Mozambique": "102",
			"Madagascar": "41",
			"Bolivia (Plurinational State of)": "6568961",
			"Barbados": "123093",
			"Bahamas": "10834",
			"Tunisia": "3741",
			"Viet Nam": "2021",
			"Haiti": "727",
			"Tokelau": "727",
			"Oman": "33106",
			"Sweden": "177814",
			"Maldives": "100547",
			"India": "18898326",
			"Mexico": "55306",
			"Austria": "26693169",
			"Bouvet Island": "46863",
			"Zimbabwe": "86",
			"Vanuatu": "4104",
			"Fiji": "2670",
			"Lithuania": "3514372",
			"Namibia": "1066",
			"Denmark": "6253",
			"Portugal": "171842",
			"Central African Rep.": "3625",
			"Netherlands": "7399600",
			"Costa Rica": "34",
			"Equatorial Guinea": "4577",
			"Greece": "467007",
			"Kazakhstan": "56612",
			"Kenya": "55",
			"Afghanistan": "42283",
			"Egypt": "532281",
			"Nauru": "1903",
			"Estonia": "17181",
			"Morocco": "507084",
			"Luxembourg": "35967",
			"TFYR of Macedonia": "594174",
			"Somalia": "40253",
			"United Rep. of Tanzania": "41",
			"Finland": "1211901",
			"Belize": "537079",
			"Georgia": "22128",
			"Ukraine": "313119",
			"Bermuda": "22864",
			"Djibouti": "4782",
			"China, Hong Kong SAR": "26534531",
			"Suriname": "240757",
			"Nigeria": "100539",
			"Samoa": "27857",
			"Venezuela": "166748",
			"Kuwait": "775730",
			"New Zealand": "245311",
			"Norway": "50809",
			"Sierra Leone": "492863",
			"Philippines": "732816",
			"Libya": "11677",
			"Kyrgyzstan": "6832",
			"Czechia": "82611",
			"Guatemala": "100357",
			"Togo": "114352",
			"Aruba": "1897",
			"Turkey": "3985635",
			"Rep. of Korea": "71179",
			"Serbia": "5072",
			"Burundi": "7749",
			"Bhutan": "42914",
			"Canada": "71694",
			"Iceland": "17433"
		}
	},
	"Hungary": {
		"imports": {
			"Lebanon": "12",
			"Gibraltar": "118",
			"Ghana": "8412",
			"Cuba": "11421947",
			"Dem. Rep. of the Congo": "5713",
			"Cameroon": "317",
			"South Africa": "6",
			"Montserrat": "170",
			"Indonesia": "48563",
			"Colombia": "49061",
			"Angola": "438",
			"Fr. South Antarctic Terr.": "1089",
			"Uzbekistan": "3769",
			"Iraq": "193389648",
			"Bosnia Herzegovina": "61512",
			"Pakistan": "655",
			"Belgium": "33660",
			"Azerbaijan": "15387529",
			"Rwanda": "447",
			"Armenia": "100273",
			"United Kingdom": "55528",
			"Singapore": "2009",
			"Albania": "70024",
			"Benin": "5",
			"Panama": "245",
			"Qatar": "9212",
			"American Samoa": "16912",
			"Australia": "6324955",
			"Jamaica": "2146",
			"Kenya": "13979",
			"Spain": "25883",
			"Tajikistan": "1352735",
			"Ireland": "3228",
			"Botswana": "18387",
			"French Polynesia": "111",
			"Honduras": "20616",
			"Saint Barthélemy": "10837",
			"Jordan": "224",
			"Chile": "63",
			"China, Macao SAR": "3749",
			"Malaysia": "270",
			"Fiji": "2769",
			"Portugal": "3087",
			"Falkland Isds (Malvinas)": "810",
			"Nepal": "5909",
			"China": "564564",
			"Saint Maarten": "29203",
			"Mali": "4135",
			"Trinidad and Tobago": "325",
			"Israel": "135398",
			"Paraguay": "100",
			"Bangladesh": "689729",
			"Gabon": "300",
			"Cyprus": "622",
			"Mauritius": "246400",
			"Slovakia": "1492388",
			"Faeroe Isds": "10",
			"Turkmenistan": "137543",
			"Bahrain": "2240",
			"Côte d'Ivoire": "275",
			"Algeria": "163",
			"USA": "56944959",
			"Saint Kitts and Nevis": "806",
			"Rep. of Moldova": "433413",
			"Zambia": "149",
			"Malta": "413619",
			"Ecuador": "292566",
			"Dominican Rep.": "193345",
			"France": "6609938",
			"New Caledonia": "50",
			"Seychelles": "109895",
			"Italy": "502883",
			"Saint Lucia": "40",
			"State of Palestine": "757",
			"Uganda": "7889",
			"Syria": "495",
			"Belarus": "15867",
			"Ethiopia": "1221",
			"Namibia": "235",
			"Congo": "380",
			"Slovenia": "370781",
			"Bulgaria": "8505",
			"Montenegro": "7164",
			"Sri Lanka": "69278",
			"New Zealand": "396779",
			"Lao People's Dem. Rep.": "58",
			"Myanmar": "44339",
			"Iran": "45199956",
			"Uruguay": "1426",
			"Andorra": "131",
			"Germany": "5450728",
			"Poland": "11933298",
			"Thailand": "148",
			"Argentina": "4780352",
			"Brazil": "3014179",
			"Dominica": "1188",
			"Mongolia": "91897",
			"Saudi Arabia": "55644286",
			"Greece": "4358",
			"Russian Federation": "2115327603",
			"Cayman Isds": "2246679",
			"United Arab Emirates": "11918",
			"Nicaragua": "3355",
			"Malawi": "224",
			"Switzerland": "296284",
			"El Salvador": "17174",
			"Latvia": "875538",
			"Japan": "6259386",
			"Guinea": "500",
			"Romania": "227802",
			"Croatia": "3826681",
			"Liberia": "8147",
			"Guatemala": "60078",
			"Madagascar": "110",
			"Bolivia (Plurinational State of)": "5571",
			"Barbados": "2677",
			"Bahamas": "4560",
			"Tunisia": "334",
			"Viet Nam": "1321",
			"Haiti": "6714",
			"Tokelau": "459",
			"Oman": "635",
			"Sweden": "14708",
			"Maldives": "106",
			"India": "4264",
			"Mexico": "1306143",
			"Austria": "442856742",
			"Zimbabwe": "5",
			"Vanuatu": "3488",
			"Lithuania": "926474",
			"Cambodia": "10512",
			"Denmark": "273413",
			"Peru": "60267",
			"Netherlands": "545412",
			"Costa Rica": "320",
			"Sudan": "150",
			"Papua New Guinea": "100",
			"Kazakhstan": "55977267",
			"Afghanistan": "1040",
			"Saint Helena": "37771",
			"Egypt": "224",
			"Estonia": "458894",
			"Morocco": "1230773",
			"Luxembourg": "1532",
			"TFYR of Macedonia": "30549",
			"Somalia": "3600",
			"United Rep. of Tanzania": "83",
			"Finland": "4122",
			"Belize": "65630",
			"Georgia": "238764",
			"Ukraine": "223568591",
			"Bermuda": "67884",
			"China, Hong Kong SAR": "39406",
			"Suriname": "417",
			"Nigeria": "1138",
			"Venezuela": "8684",
			"Kuwait": "138",
			"Norway": "63541",
			"Marshall Isds": "7137",
			"Philippines": "1251798",
			"Libya": "50",
			"Kyrgyzstan": "168445",
			"Czechia": "51864740",
			"Mozambique": "13855",
			"Togo": "12251",
			"Samoa": "799",
			"Turkey": "24",
			"San Marino": "60813",
			"Rep. of Korea": "150",
			"Serbia": "560",
			"Bhutan": "10",
			"Canada": "15928759",
			"Iceland": "12917"
		},
		"exports": {
			"Lebanon": "23676",
			"Gibraltar": "249993",
			"Ghana": "440",
			"Lesotho": "1554",
			"Cuba": "7",
			"Dem. Rep. of the Congo": "91",
			"Dem. People's Rep. of Korea": "513",
			"Cameroon": "102202",
			"Papua New Guinea": "42435",
			"Indonesia": "710871",
			"Colombia": "1243736",
			"Niger": "1100",
			"Palau": "56253",
			"Angola": "36720",
			"Fr. South Antarctic Terr.": "6",
			"Uzbekistan": "66746",
			"Iraq": "260",
			"Guam": "48019",
			"Bosnia Herzegovina": "516253",
			"Pakistan": "113487",
			"Belgium": "6650",
			"Azerbaijan": "140828",
			"Armenia": "745",
			"Togo": "11134",
			"Singapore": "3200",
			"Albania": "7102155",
			"Benin": "125379",
			"South Africa": "2824",
			"Panama": "937",
			"Qatar": "17436",
			"American Samoa": "17179",
			"Saint Vincent and the Grenadines": "45472",
			"Curaçao": "180149",
			"Australia": "45505",
			"Jamaica": "3767235",
			"Br. Virgin Isds": "1358",
			"Spain": "4349",
			"Tajikistan": "4459",
			"Ireland": "270",
			"Botswana": "179",
			"French Polynesia": "400333",
			"Mauritania": "13848",
			"Christmas Isds": "4248",
			"Honduras": "546581",
			"Saint Barthélemy": "480639",
			"Holy See (Vatican City State)": "1689",
			"United Kingdom": "11582",
			"Jordan": "49733",
			"Chile": "1192",
			"Sudan": "57724",
			"Gambia": "41796",
			"Liberia": "66813",
			"Brunei Darussalam": "1888",
			"Malaysia": "1401682",
			"Fiji": "23661",
			"Peru": "2750",
			"Nepal": "50001",
			"China": "1655115",
			"Guinea-Bissau": "15291",
			"Saint Maarten": "8418",
			"Mali": "33778",
			"Trinidad and Tobago": "146008",
			"Israel": "715878",
			"Burkina Faso": "6008",
			"Paraguay": "18899",
			"Bangladesh": "14067",
			"Antigua and Barbuda": "619177",
			"Gabon": "45894",
			"Cyprus": "273",
			"Yemen": "26310",
			"Mauritius": "35974",
			"Slovakia": "31625947",
			"Faeroe Isds": "163",
			"Turkmenistan": "14079",
			"Bahrain": "7333",
			"Côte d'Ivoire": "2641",
			"Guyana": "31800",
			"Algeria": "13035812",
			"USA": "184170",
			"Saint Kitts and Nevis": "541808",
			"Rep. of Moldova": "1180",
			"Zambia": "390",
			"Malta": "28198",
			"Ecuador": "1268",
			"Grenada": "303028",
			"Dominican Rep.": "371707",
			"France": "155709",
			"New Caledonia": "51944",
			"Seychelles": "103",
			"Italy": "1432301",
			"Saint Lucia": "717248",
			"State of Palestine": "1823237",
			"Rwanda": "8263",
			"Syria": "40134",
			"Belarus": "25718",
			"Ethiopia": "1239",
			"Namibia": "890",
			"Congo": "1407671",
			"Slovenia": "701112",
			"Bulgaria": "17943",
			"Montenegro": "2310",
			"Sri Lanka": "882664",
			"New Zealand": "816157",
			"Lao People's Dem. Rep.": "36100",
			"Myanmar": "167",
			"Iran": "902236",
			"Uruguay": "1592",
			"Switzerland": "994834",
			"Cabo Verde": "892",
			"Germany": "647790",
			"Poland": "22837",
			"Thailand": "16023",
			"Argentina": "3999603",
			"Brazil": "1364",
			"Dominica": "170",
			"Mongolia": "113",
			"Saudi Arabia": "2500",
			"Greece": "1537",
			"Russian Federation": "10378",
			"Cayman Isds": "42742",
			"United Arab Emirates": "158364",
			"Nicaragua": "77",
			"Malawi": "10841",
			"Andorra": "13381",
			"El Salvador": "12918",
			"United States Minor Outlying Islands": "7061",
			"Latvia": "1236",
			"Japan": "755317",
			"Guinea": "33623",
			"Uganda": "203285",
			"Romania": "5496627",
			"Croatia": "171939",
			"China, Macao SAR": "1510",
			"Guatemala": "53643",
			"Madagascar": "30810",
			"Bolivia (Plurinational State of)": "766",
			"Barbados": "20749",
			"Bahamas": "136117",
			"San Marino": "14172",
			"Chad": "232960",
			"Viet Nam": "3117703",
			"Haiti": "1847942",
			"Oman": "14745",
			"Sweden": "4150",
			"Maldives": "63580",
			"India": "163728",
			"Mexico": "1150",
			"Austria": "14938120",
			"Eritrea": "282864",
			"Zimbabwe": "166",
			"Vanuatu": "43523",
			"Senegal": "36554",
			"Swaziland": "3795",
			"Lithuania": "386",
			"Cambodia": "445",
			"Denmark": "1271",
			"Portugal": "4161",
			"Netherlands": "12348",
			"Costa Rica": "39481",
			"Equatorial Guinea": "6223",
			"South Georgia and the South Sandwich Islands": "1533",
			"Kazakhstan": "703225",
			"Kenya": "1416",
			"Afghanistan": "31489",
			"Egypt": "32032",
			"Anguilla": "24215",
			"Estonia": "1068",
			"Morocco": "941377",
			"Luxembourg": "260",
			"TFYR of Macedonia": "253969",
			"Somalia": "75338",
			"United Rep. of Tanzania": "5344",
			"Finland": "313",
			"Belize": "2672",
			"Georgia": "11501",
			"Ukraine": "74509303",
			"Bermuda": "77193",
			"Djibouti": "144648",
			"Greenland": "941",
			"China, Hong Kong SAR": "6156",
			"Suriname": "50966",
			"Nigeria": "56262",
			"Venezuela": "43794",
			"Kuwait": "1794",
			"Norway": "155752",
			"Sierra Leone": "7150",
			"Philippines": "207242",
			"Libya": "20670",
			"Kyrgyzstan": "230566",
			"Czechia": "8742509",
			"Mozambique": "2606",
			"Aruba": "97415",
			"Turkey": "150835",
			"Tunisia": "204045",
			"Rep. of Korea": "2826",
			"Serbia": "577037",
			"Burundi": "52482",
			"Bhutan": "1192",
			"Cook Isds": "8344",
			"Canada": "35353",
			"Iceland": "244793"
		}
	},
	"Angola": {
		"imports": {},
		"exports": {}
	},
	"N. Mariana Isds": {
		"imports": {},
		"exports": {}
	},
	"Samoa": {
		"imports": {
			"Costa Rica": "2212",
			"Lebanon": "58",
			"Bulgaria": "2311",
			"Papua New Guinea": "65440",
			"Greece": "25171",
			"Chile": "133835",
			"Slovenia": "293985",
			"Austria": "77572",
			"Cameroon": "63",
			"United Kingdom": "14774",
			"Afghanistan": "261",
			"Niue": "88149",
			"Brunei Darussalam": "312",
			"Thailand": "3970664",
			"Dem. People's Rep. of Korea": "155498",
			"Brazil": "2739",
			"Egypt": "1972",
			"China": "3178495",
			"South Africa": "18",
			"Mongolia": "2151",
			"Pakistan": "116711",
			"Luxembourg": "277",
			"Trinidad and Tobago": "3116",
			"Israel": "1105",
			"United Arab Emirates": "77",
			"Panama": "262",
			"Tonga": "2",
			"American Samoa": "17148",
			"Switzerland": "2303",
			"Finland": "542",
			"Slovakia": "94093",
			"Japan": "10401",
			"Cook Isds": "2766",
			"China, Hong Kong SAR": "1473051",
			"Belgium": "942",
			"Niger": "941",
			"USA": "268842",
			"Cambodia": "263",
			"Germany": "17868",
			"Singapore": "154837",
			"New Zealand": "1600919",
			"Ecuador": "46788",
			"France": "432",
			"Viet Nam": "1832968",
			"New Caledonia": "121",
			"Philippines": "342194",
			"Tokelau": "1733",
			"Indonesia": "1228667",
			"Bangladesh": "10322",
			"Italy": "3311",
			"Czechia": "1534",
			"Sweden": "14282",
			"Australia": "4387860",
			"India": "192506",
			"Jamaica": "1564",
			"Mexico": "6037",
			"Spain": "17867",
			"Ireland": "10741",
			"Malaysia": "11376",
			"Sri Lanka": "646",
			"Vanuatu": "121",
			"Rep. of Korea": "10118",
			"French Polynesia": "6919",
			"Poland": "1088",
			"Fiji": "2544251",
			"Lithuania": "507",
			"Namibia": "1482",
			"Denmark": "1751",
			"Canada": "5431",
			"Honduras": "141",
			"Netherlands": "150144",
			"Turkey": "123707"
		},
		"exports": {
			"USA": "3341834",
			"Papua New Guinea": "15",
			"Sudan": "6808",
			"United Kingdom": "129",
			"Singapore": "39",
			"New Zealand": "842608",
			"Germany": "195",
			"Niue": "975",
			"Malaysia": "39",
			"Fiji": "16005",
			"Viet Nam": "6",
			"New Caledonia": "84591",
			"Philippines": "40",
			"Tokelau": "48608",
			"China": "19",
			"Ghana": "10",
			"Panama": "156",
			"Saudi Arabia": "349",
			"American Samoa": "36565",
			"Indonesia": "8",
			"Tuvalu": "9",
			"Dem. People's Rep. of Korea": "21449",
			"Australia": "4056",
			"Kiribati": "9",
			"United Arab Emirates": "28391",
			"India": "8",
			"Kenya": "25",
			"Tonga": "21",
			"Turkey": "2",
			"Switzerland": "9500",
			"Thailand": "8",
			"Nauru": "398",
			"China, Hong Kong SAR": "10",
			"Rep. of Korea": "12",
			"French Polynesia": "19",
			"France": "78",
			"Japan": "1633107",
			"Cook Isds": "8188",
			"Canada": "8",
			"Vanuatu": "39"
		}
	},
	"Myanmar": {
		"imports": {
			"Lebanon": "1057101",
			"Iran": "50889",
			"Sao Tome and Principe": "43872",
			"Niger": "174",
			"Uruguay": "143000",
			"Marshall Isds": "26",
			"Cabo Verde": "35193",
			"Germany": "593077",
			"Timor-Leste": "96",
			"Poland": "960",
			"Cuba": "24502",
			"Dem. Rep. of the Congo": "2744",
			"Thailand": "18858429",
			"Dem. People's Rep. of Korea": "51355",
			"Argentina": "292429",
			"Brazil": "25714497",
			"Cameroon": "13717",
			"Brunei Darussalam": "82147",
			"South Africa": "1193",
			"Mongolia": "23737",
			"Saudi Arabia": "7517",
			"Panama": "513512",
			"Colombia": "72589",
			"Sudan": "130",
			"Russian Federation": "984",
			"Cayman Isds": "99000",
			"United Arab Emirates": "178527",
			"Nicaragua": "1090",
			"Palau": "24110",
			"Tajikistan": "51283",
			"Jordan": "210385",
			"Switzerland": "205134",
			"El Salvador": "146037",
			"Slovakia": "2249",
			"Latvia": "622",
			"Japan": "643416841",
			"Guam": "49160",
			"Bosnia Herzegovina": "261",
			"Pakistan": "19184",
			"Belgium": "14909661",
			"Curaçao": "40",
			"China, Macao SAR": "160389",
			"Guatemala": "631128",
			"United Kingdom": "251165",
			"Bolivia (Plurinational State of)": "2573149",
			"Nigeria": "708748",
			"Albania": "85734",
			"Benin": "248170",
			"Tunisia": "1793",
			"Chad": "18589",
			"Viet Nam": "11164223",
			"Haiti": "395",
			"Tokelau": "29800",
			"South Georgia and the South Sandwich Islands": "2750",
			"Indonesia": "67514",
			"Qatar": "95",
			"American Samoa": "1604969",
			"Saint Vincent and the Grenadines": "21564",
			"Oman": "7800",
			"Uzbekistan": "39293",
			"Sweden": "5979",
			"Australia": "4091974",
			"Kiribati": "125",
			"India": "3870187",
			"Jamaica": "37024",
			"Mexico": "79",
			"Kenya": "8077",
			"Spain": "26995",
			"Romania": "8594",
			"Ireland": "933600",
			"Zimbabwe": "422382",
			"Vanuatu": "29216",
			"Austria": "69138",
			"Mauritania": "5041",
			"Swaziland": "3314",
			"Lithuania": "177580",
			"Cambodia": "12634",
			"Denmark": "34873910",
			"Peru": "135",
			"Central African Rep.": "62054",
			"United Rep. of Tanzania": "312",
			"Netherlands": "2757166",
			"Eritrea": "103785",
			"Costa Rica": "138124",
			"Burkina Faso": "1500",
			"Turkey": "143135",
			"Greece": "1230455",
			"Chile": "1220212",
			"Kazakhstan": "3578",
			"Gambia": "1221026",
			"Liberia": "10130",
			"Nepal": "558",
			"Afghanistan": "9600",
			"Dominica": "117617",
			"Malaysia": "68593121",
			"Fiji": "9794",
			"Portugal": "3235",
			"Saint Kitts and Nevis": "581",
			"Egypt": "93130",
			"China": "5403104136",
			"Comoros": "46238",
			"Nauru": "49808",
			"Estonia": "115949",
			"Morocco": "80112",
			"Mali": "13939",
			"Israel": "48173",
			"Venezuela": "9104",
			"Saint Helena": "42",
			"Singapore": "8023476",
			"Paraguay": "5988896",
			"Bangladesh": "37219",
			"Yemen": "15207",
			"Antigua and Barbuda": "138000",
			"Gabon": "86550",
			"Finland": "416494",
			"Cyprus": "560637",
			"Belize": "29319042",
			"Mauritius": "63844",
			"Ukraine": "2036780",
			"Luxembourg": "66",
			"Malta": "570",
			"Papua New Guinea": "886407",
			"Turkmenistan": "35000",
			"Bahrain": "1050",
			"China, Hong Kong SAR": "4509",
			"Ghana": "19225",
			"Suriname": "8856",
			"USA": "3278999",
			"Namibia": "60228",
			"Rep. of Moldova": "3309299",
			"Kuwait": "59667",
			"Christmas Isds": "54178",
			"Norway": "139289",
			"Ecuador": "276114",
			"Serbia": "72982",
			"Grenada": "199201",
			"Dominican Rep.": "9565",
			"France": "24532868",
			"New Caledonia": "715",
			"Philippines": "28687",
			"Seychelles": "12512",
			"Italy": "15838269",
			"Kyrgyzstan": "39650",
			"Czechia": "1981947",
			"Uganda": "958567",
			"Belarus": "910372",
			"Ethiopia": "25880",
			"Slovenia": "110186",
			"Togo": "5243",
			"Sierra Leone": "35984",
			"Senegal": "2",
			"Aruba": "8265",
			"Bulgaria": "1639420",
			"Montenegro": "427",
			"Sri Lanka": "123671",
			"Rep. of Korea": "370018",
			"Hungary": "57819",
			"Holy See (Vatican City State)": "432",
			"New Zealand": "3603558",
			"Canada": "1326",
			"Iceland": "42211",
			"Lao People's Dem. Rep.": "540",
			"Myanmar": "40082"
		},
		"exports": {
			"Lebanon": "700",
			"Gibraltar": "34",
			"Iran": "1331866",
			"Niger": "6954",
			"Uruguay": "138346",
			"Andorra": "44136",
			"Germany": "2740229",
			"Poland": "21464197",
			"Cuba": "45128",
			"Dem. Rep. of the Congo": "14540",
			"Thailand": "9697492",
			"Dem. People's Rep. of Korea": "60000",
			"Argentina": "480",
			"Brazil": "219439",
			"Cameroon": "228803",
			"Brunei Darussalam": "22217",
			"South Africa": "1457456",
			"Mongolia": "383455",
			"Saudi Arabia": "189078",
			"Panama": "80640",
			"Colombia": "1853478",
			"Sudan": "4682",
			"Russian Federation": "4101455",
			"United Arab Emirates": "8087682",
			"Nicaragua": "533",
			"Portugal": "18141",
			"Yemen": "520340",
			"Jordan": "11848",
			"Malawi": "80865",
			"Switzerland": "2478703",
			"El Salvador": "589137",
			"Slovakia": "923076",
			"Iraq": "1814594",
			"Japan": "14684060",
			"Guatemala": "70000",
			"Guinea": "1935950",
			"Palau": "1478",
			"Bosnia Herzegovina": "26831",
			"Pakistan": "250648",
			"Belgium": "1634051",
			"Croatia": "809633",
			"Senegal": "271475",
			"Liberia": "58125",
			"Armenia": "9246",
			"United Kingdom": "13560784",
			"Singapore": "73775426",
			"Albania": "755",
			"Maldives": "4270",
			"Tunisia": "7204",
			"Chad": "27440",
			"Viet Nam": "1066630",
			"Haiti": "121",
			"Indonesia": "6184725",
			"Qatar": "164723",
			"Oman": "470506",
			"Sweden": "10551170",
			"Australia": "110920",
			"Kiribati": "52839",
			"India": "8195919",
			"Jamaica": "392836",
			"Mexico": "524200",
			"Kenya": "85567",
			"Austria": "9600",
			"Eritrea": "139098",
			"Br. Virgin Isds": "249433",
			"Botswana": "106000",
			"Zimbabwe": "47568",
			"Côte d'Ivoire": "8275000",
			"Norfolk Isds": "200259",
			"Swaziland": "555690",
			"Lithuania": "90375",
			"Cambodia": "6863",
			"Christmas Isds": "370",
			"Curaçao": "51918",
			"Grenada": "32130",
			"Honduras": "896770",
			"Netherlands": "3653350",
			"Turkey": "205166",
			"Costa Rica": "173153",
			"Venezuela": "1212357",
			"Papua New Guinea": "219808",
			"Ireland": "275180",
			"Samoa": "2681815",
			"Greece": "214287",
			"Chile": "5073350",
			"Kazakhstan": "153784",
			"Gambia": "31000",
			"China, Macao SAR": "3640",
			"Afghanistan": "864",
			"Dominica": "663643",
			"Malaysia": "3799710",
			"Fiji": "34375",
			"Peru": "11434",
			"Saint Kitts and Nevis": "46610",
			"Nepal": "60750",
			"China": "4766680649",
			"Egypt": "358040",
			"Nauru": "54900",
			"Anguilla": "14264",
			"Estonia": "382631",
			"Morocco": "47430",
			"Djibouti": "3600",
			"Trinidad and Tobago": "847337",
			"Israel": "105000",
			"TFYR of Macedonia": "600000",
			"Saint Helena": "7294",
			"Paraguay": "41193",
			"French Polynesia": "77461",
			"Bangladesh": "13526119",
			"United Rep. of Tanzania": "2340",
			"Finland": "234214",
			"Cyprus": "71964",
			"Belize": "34560",
			"Mauritius": "20488",
			"Ukraine": "597467",
			"Bermuda": "78828",
			"Luxembourg": "1569",
			"Malta": "14742",
			"Faeroe Isds": "154080",
			"Greenland": "71327",
			"Bahrain": "586033",
			"Zambia": "15633",
			"China, Hong Kong SAR": "18350",
			"Ghana": "31981",
			"Guyana": "43200",
			"Suriname": "275419",
			"USA": "19503266",
			"Vanuatu": "33570",
			"Romania": "137148",
			"Kuwait": "1595993",
			"Spain": "49938947",
			"Denmark": "17031658",
			"Norway": "22065",
			"Ecuador": "9157469",
			"Serbia": "278281",
			"Sierra Leone": "2796",
			"Dominican Rep.": "121016",
			"France": "7741503",
			"New Caledonia": "1590",
			"Philippines": "952033",
			"Latvia": "160750",
			"Seychelles": "1363",
			"Italy": "572500",
			"Czechia": "5712101",
			"Uganda": "33892",
			"Syria": "179300",
			"Belarus": "15840",
			"Namibia": "1138",
			"Togo": "140000",
			"Congo": "6303",
			"Slovenia": "3866089",
			"Aruba": "149440",
			"Bulgaria": "94000",
			"Montenegro": "15909",
			"Sri Lanka": "6376443",
			"Rep. of Korea": "19789946",
			"Hungary": "546830",
			"Burundi": "107800",
			"New Zealand": "60750",
			"N. Mariana Isds": "102820",
			"Canada": "23199957",
			"Iceland": "206817",
			"Lao People's Dem. Rep.": "27000",
			"Madagascar": "353600"
		}
	},
	"Iran": {
		"imports": {},
		"exports": {}
	},
	"Sao Tome and Principe": {
		"imports": {
			"Lebanon": "45039",
			"Ireland": "3120",
			"Ghana": "810",
			"Greece": "2790",
			"Switzerland": "199",
			"Cabo Verde": "170176",
			"Togo": "519",
			"Timor-Leste": "858",
			"Saint Helena": "33",
			"Malaysia": "115600",
			"Equatorial Guinea": "765",
			"Portugal": "267160",
			"Brazil": "947397",
			"Cameroon": "3421",
			"China": "1921176",
			"South Africa": "43330",
			"Guinea-Bissau": "8159",
			"Saudi Arabia": "1160",
			"Luxembourg": "5581",
			"United Arab Emirates": "2738",
			"Nicaragua": "260",
			"Bangladesh": "4514",
			"Jordan": "27193",
			"Andorra": "1447",
			"Gabon": "14233",
			"Cyprus": "15126",
			"Denmark": "66494",
			"Japan": "16",
			"Egypt": "1230",
			"Romania": "129",
			"China, Hong Kong SAR": "4095",
			"Belgium": "10011",
			"USA": "9625",
			"Zambia": "380",
			"Germany": "5030",
			"Singapore": "63252",
			"Nigeria": "6912",
			"Ecuador": "168",
			"Bahamas": "1504783",
			"Tunisia": "4353",
			"France": "28368",
			"Indonesia": "45",
			"Italy": "4795",
			"Paraguay": "126",
			"Dem. People's Rep. of Korea": "82044",
			"Australia": "23",
			"India": "53385",
			"Congo": "6580",
			"Spain": "1585983",
			"Turkey": "2839",
			"Thailand": "324373",
			"Pakistan": "4125",
			"Rep. of Korea": "76481",
			"Hungary": "46994",
			"Netherlands": "399194",
			"United Kingdom": "32",
			"Angola": "210208",
			"Canada": "72",
			"Ukraine": "22111",
			"Holy See (Vatican City State)": "113"
		},
		"exports": {
			"France": "882",
			"Portugal": "94",
			"Japan": "10398",
			"Togo": "203",
			"Switzerland": "32634",
			"Angola": "13082",
			"Cabo Verde": "3427",
			"Germany": "424942",
			"Gabon": "2304",
			"Netherlands": "251584",
			"Timor-Leste": "432"
		}
	},
	"Uruguay": {
		"imports": {
			"Lebanon": "1519",
			"Gibraltar": "399",
			"Ghana": "1233837",
			"Niger": "26",
			"Uruguay": "9980",
			"Andorra": "1521",
			"Cabo Verde": "377",
			"Germany": "81697584",
			"Poland": "14289",
			"Cuba": "28003",
			"Dem. Rep. of the Congo": "436",
			"Thailand": "4289563",
			"Dem. People's Rep. of Korea": "9815",
			"Argentina": "48575245",
			"Brazil": "104986725",
			"Cameroon": "128",
			"Brunei Darussalam": "37",
			"Iran": "244",
			"Barbados": "517312",
			"Saudi Arabia": "19160940",
			"Panama": "2108722",
			"Colombia": "17630",
			"Syria": "263171",
			"Russian Federation": "169021",
			"United Arab Emirates": "53564",
			"Nicaragua": "39340",
			"Tajikistan": "835",
			"Tonga": "533",
			"Angola": "226117355",
			"Malawi": "299780",
			"Switzerland": "440898",
			"El Salvador": "76435",
			"Lesotho": "133",
			"Sierra Leone": "745",
			"Slovakia": "135001",
			"Latvia": "32024",
			"Japan": "16998435",
			"Bosnia Herzegovina": "96207",
			"Pakistan": "5844558",
			"Belgium": "75653",
			"Croatia": "429",
			"China, Macao SAR": "1942",
			"Bolivia (Plurinational State of)": "2070095",
			"Belarus": "14629",
			"Madagascar": "15680",
			"Singapore": "2388",
			"Nigeria": "236836698",
			"Albania": "230",
			"Benin": "4492",
			"Bahamas": "9765",
			"Tunisia": "221404",
			"Turkey": "702221",
			"Viet Nam": "2990397",
			"Haiti": "21144",
			"South Africa": "371227",
			"Indonesia": "603085",
			"Qatar": "4961167",
			"American Samoa": "137",
			"Oman": "8872334",
			"Uzbekistan": "4748",
			"Sweden": "402672",
			"Australia": "149749",
			"India": "223681",
			"Jamaica": "396",
			"Mexico": "9810351",
			"Br. Virgin Isds": "584635",
			"Austria": "1764645",
			"Romania": "154347",
			"Ireland": "1697054",
			"Côte d'Ivoire": "183848",
			"Spain": "16100890",
			"Mauritania": "5674",
			"Lithuania": "32812",
			"Cambodia": "297505",
			"Denmark": "163969020",
			"Portugal": "75130",
			"Honduras": "67099",
			"Netherlands": "53260959",
			"United Kingdom": "17085515",
			"Costa Rica": "37833",
			"Equatorial Guinea": "6816867",
			"Greece": "2812738",
			"Chile": "341170",
			"Slovenia": "264799",
			"Nepal": "35561",
			"Libya": "970626",
			"Afghanistan": "10052",
			"Dominica": "856",
			"Malaysia": "1903774",
			"Fiji": "4007",
			"Peru": "791385",
			"United Rep. of Tanzania": "55923",
			"Jordan": "45480",
			"China": "25811416",
			"Egypt": "673364",
			"Estonia": "142469",
			"Morocco": "25499",
			"Luxembourg": "37190",
			"Trinidad and Tobago": "45400",
			"Israel": "4728958",
			"TFYR of Macedonia": "13875",
			"Burkina Faso": "580",
			"Kazakhstan": "303",
			"Paraguay": "3603188",
			"Bangladesh": "21331",
			"Western Sahara": "305",
			"Gabon": "69568",
			"Finland": "9344803",
			"Cyprus": "85450",
			"Belize": "1100",
			"Georgia": "482562",
			"Serbia": "4289",
			"Kenya": "1288",
			"Faeroe Isds": "31328",
			"Turkmenistan": "170",
			"Bahrain": "298000",
			"China, Hong Kong SAR": "1001979",
			"Guyana": "22975",
			"Mauritius": "56567",
			"Algeria": "5737233",
			"USA": "18474405",
			"Namibia": "31292",
			"Rep. of Moldova": "4285",
			"Venezuela": "7607",
			"Zambia": "42",
			"Malta": "8021",
			"Norway": "78950",
			"Ecuador": "208062",
			"Grenada": "65437",
			"Dominican Rep.": "859207",
			"France": "25318250",
			"Philippines": "311594",
			"Seychelles": "28908",
			"Italy": "8447796",
			"Czechia": "8022694",
			"Guatemala": "36207",
			"Ethiopia": "3734",
			"Togo": "4953",
			"Congo": "568",
			"Senegal": "317314",
			"Bulgaria": "50888",
			"San Marino": "398",
			"Sri Lanka": "522308",
			"Rep. of Korea": "7338650",
			"Hungary": "2594981",
			"Burundi": "3097",
			"Armenia": "791",
			"New Zealand": "19681168",
			"Canada": "80396",
			"Iceland": "48547",
			"Lao People's Dem. Rep.": "15280",
			"Ukraine": "84785",
			"Myanmar": "11013"
		},
		"exports": {
			"Lebanon": "136286",
			"TFYR of Macedonia": "35203",
			"Nepal": "394122",
			"Ghana": "343728",
			"Cabo Verde": "75177",
			"Germany": "108188121",
			"Poland": "105357",
			"Cuba": "2558764",
			"Thailand": "591214",
			"Argentina": "17342",
			"Brazil": "6308471",
			"Cameroon": "15354",
			"Dominica": "2887",
			"Iran": "1563882",
			"Mongolia": "1320",
			"Saudi Arabia": "1343050",
			"Panama": "10361890",
			"Colombia": "130063",
			"Sudan": "752114",
			"Russian Federation": "80989162",
			"United Arab Emirates": "1719171",
			"Nicaragua": "109449",
			"Yemen": "1544505",
			"Angola": "377703",
			"Switzerland": "19043304",
			"El Salvador": "160211",
			"Sierra Leone": "14116170",
			"Ukraine": "1325963",
			"Iraq": "217265",
			"Japan": "5154087",
			"Guinea": "188",
			"Bosnia Herzegovina": "115760",
			"Pakistan": "11534",
			"Belgium": "782519",
			"Azerbaijan": "9800",
			"Guatemala": "881909",
			"United Kingdom": "35540451",
			"Bolivia (Plurinational State of)": "157400",
			"Barbados": "7563",
			"Albania": "172962",
			"Benin": "5315586",
			"Maldives": "8918",
			"Bahamas": "2928",
			"Tajikistan": "136944",
			"Mozambique": "22126",
			"Viet Nam": "13135554",
			"Haiti": "331999",
			"South Africa": "4944262",
			"Indonesia": "2905",
			"Qatar": "1243728",
			"Saint Vincent and the Grenadines": "605570",
			"Oman": "441502",
			"Curaçao": "1804308",
			"Australia": "25913",
			"India": "328080",
			"Jamaica": "273242",
			"Mexico": "66416328",
			"Kenya": "321439",
			"Spain": "40971675",
			"Bouvet Island": "38004",
			"Ireland": "80688",
			"Botswana": "128762",
			"Zimbabwe": "281178",
			"Côte d'Ivoire": "849624",
			"French Polynesia": "5041256",
			"Mauritania": "357500",
			"Lithuania": "994439",
			"Namibia": "190693",
			"Denmark": "4782013",
			"Portugal": "1218104",
			"Central African Rep.": "29949",
			"Honduras": "936895",
			"Netherlands": "238553695",
			"Turkey": "913986",
			"Costa Rica": "5707862",
			"Austria": "11",
			"Equatorial Guinea": "787046",
			"Greece": "1042",
			"Chile": "5662",
			"Kazakhstan": "1466",
			"Liberia": "17824",
			"Libya": "95000",
			"Afghanistan": "699564",
			"Brunei Darussalam": "30354",
			"Malaysia": "5577740",
			"Peru": "5952408",
			"Sweden": "9067611",
			"Jordan": "151330",
			"China": "3702764",
			"Egypt": "1187671",
			"Guinea-Bissau": "2622648",
			"Estonia": "204724",
			"Morocco": "5173046",
			"Luxembourg": "3621",
			"Trinidad and Tobago": "11057956",
			"Israel": "106575",
			"Venezuela": "20558017",
			"Burkina Faso": "290002",
			"Syria": "70540",
			"Singapore": "3997175",
			"Paraguay": "351716",
			"Bangladesh": "789719",
			"Antigua and Barbuda": "16400",
			"Gabon": "4579833",
			"Finland": "2529301",
			"Cyprus": "893340",
			"Belize": "8214",
			"Georgia": "884037",
			"Slovakia": "272530",
			"Mali": "547400",
			"Madagascar": "45366",
			"Bahrain": "41140",
			"Zambia": "171808",
			"China, Hong Kong SAR": "5306",
			"Guyana": "1336350",
			"Mauritius": "96237",
			"Algeria": "218934",
			"USA": "258411283",
			"Cambodia": "15474",
			"Rep. of Moldova": "261179",
			"Romania": "5447605",
			"Kuwait": "3343400",
			"Suriname": "48900",
			"Vanuatu": "122414",
			"Malta": "3289",
			"Norway": "208194",
			"Ecuador": "5612236",
			"Serbia": "318385",
			"Grenada": "105514",
			"Dominican Rep.": "1352595",
			"France": "13313370",
			"Philippines": "1959504",
			"Latvia": "47250",
			"Br. Virgin Isds": "73645",
			"Italy": "38811429",
			"Saint Lucia": "1068",
			"Czechia": "4521104",
			"Nigeria": "6918956",
			"Belarus": "116466",
			"Ethiopia": "56880",
			"Slovenia": "75399",
			"Togo": "237596",
			"Congo": "3044",
			"Senegal": "3581951",
			"Aruba": "1496931",
			"Bulgaria": "354982",
			"Sri Lanka": "165145",
			"Rep. of Korea": "17628327",
			"Hungary": "3712610",
			"New Zealand": "4392",
			"Canada": "4432675",
			"Iceland": "12600",
			"Myanmar": "345749"
		}
	},
	"Andorra": {
		"imports": {},
		"exports": {}
	},
	"Cabo Verde": {
		"imports": {},
		"exports": {}
	},
	"Germany": {
		"imports": {
			"Lebanon": "347983",
			"Bonaire": "54110",
			"Gibraltar": "59677",
			"Ghana": "30086124",
			"Lesotho": "323916",
			"Cuba": "69979",
			"Dem. Rep. of the Congo": "3354",
			"Dem. People's Rep. of Korea": "12268",
			"Samoa": "267844",
			"Cameroon": "650",
			"Papua New Guinea": "140650",
			"Indonesia": "15184685",
			"Colombia": "684102691",
			"Niger": "1345",
			"Palau": "25679",
			"Tonga": "11313",
			"Angola": "31123399",
			"Fr. South Antarctic Terr.": "82524",
			"Uzbekistan": "794223",
			"Iraq": "641908244",
			"Guam": "1427",
			"Bosnia Herzegovina": "4426",
			"Pakistan": "27647",
			"Belgium": "44347260",
			"Azerbaijan": "1751118891",
			"Armenia": "320226",
			"Togo": "989",
			"Singapore": "75511097",
			"Albania": "701204",
			"Benin": "1557",
			"South Africa": "119307785",
			"FS Micronesia": "53965",
			"Panama": "2927421",
			"Qatar": "81331",
			"American Samoa": "33",
			"Saint Vincent and the Grenadines": "19585",
			"Curaçao": "1842915",
			"Australia": "236236",
			"Kiribati": "58796",
			"Jamaica": "24672364",
			"Br. Virgin Isds": "330839",
			"Spain": "1491933315",
			"Tajikistan": "607019",
			"Ireland": "8009976",
			"Botswana": "102382",
			"South Sudan": "1636",
			"French Polynesia": "2026908",
			"Mauritania": "17344",
			"Eritrea": "554",
			"Honduras": "360265480",
			"Saint Barthélemy": "14440",
			"Holy See (Vatican City State)": "1809",
			"Chile": "1866",
			"Sudan": "4952",
			"Gambia": "202615",
			"Liberia": "41869409",
			"Brunei Darussalam": "84480",
			"Malaysia": "127567211",
			"Fiji": "105169",
			"Portugal": "731915225",
			"Falkland Isds (Malvinas)": "2992644",
			"Nepal": "33035833",
			"China": "176034415",
			"Comoros": "160502",
			"Slovenia": "680194881",
			"Mali": "882257",
			"Trinidad and Tobago": "9664007",
			"Israel": "835641",
			"Burkina Faso": "7226721",
			"Paraguay": "47661",
			"Bangladesh": "16728442",
			"Antigua and Barbuda": "7766",
			"Gabon": "112175",
			"Cyprus": "412203",
			"Yemen": "371878",
			"Mauritius": "25077",
			"Slovakia": "6833889623",
			"Faeroe Isds": "578924",
			"Turkmenistan": "653591",
			"Bahrain": "1514",
			"Côte d'Ivoire": "151900242",
			"Guyana": "5120792",
			"Algeria": "16618",
			"USA": "907271982",
			"Saint Kitts and Nevis": "55488",
			"Rep. of Moldova": "64261351",
			"Zambia": "841984",
			"Malta": "2069712",
			"Ecuador": "924",
			"Grenada": "2610049",
			"Dominican Rep.": "25153",
			"France": "1153817",
			"New Caledonia": "21055",
			"Niue": "345",
			"Seychelles": "12846",
			"Italy": "53706847",
			"Saint Lucia": "19572",
			"State of Palestine": "64618",
			"Rwanda": "4887",
			"Belarus": "1323",
			"Ethiopia": "1031630",
			"Namibia": "132118807",
			"Congo": "5408482",
			"Senegal": "334448",
			"Bulgaria": "80425295",
			"Montenegro": "9013835",
			"Sri Lanka": "5395186",
			"Hungary": "565086170",
			"Jordan": "505340",
			"Lao People's Dem. Rep.": "77338",
			"Myanmar": "3533",
			"Iran": "4680928",
			"Sao Tome and Principe": "515",
			"Uruguay": "202443159",
			"Switzerland": "21402040296",
			"Cabo Verde": "1309",
			"United Kingdom": "98907326",
			"Timor-Leste": "593",
			"Poland": "3179801319",
			"Thailand": "2136104",
			"Argentina": "963",
			"Brazil": "178659",
			"Dominica": "3176",
			"Mongolia": "1742549",
			"Saudi Arabia": "201588",
			"Syria": "45140",
			"Russian Federation": "171266594",
			"Cayman Isds": "89734846",
			"United Arab Emirates": "22960744",
			"Nicaragua": "6921",
			"Malawi": "9636",
			"Andorra": "2103",
			"El Salvador": "27612",
			"United States Minor Outlying Islands": "27429",
			"Latvia": "27227353",
			"Japan": "22717",
			"Guinea": "16597",
			"Uganda": "203884",
			"Romania": "1000312596",
			"Croatia": "39806109",
			"China, Macao SAR": "1877787",
			"Guatemala": "6127",
			"Madagascar": "161194",
			"Bolivia (Plurinational State of)": "8292638",
			"Barbados": "4137",
			"Bahamas": "998",
			"San Marino": "37833",
			"Chad": "27914",
			"Viet Nam": "176010181",
			"Haiti": "243698",
			"Tokelau": "111",
			"Christmas Isds": "677",
			"Oman": "23799643",
			"Sweden": "15935572239",
			"Maldives": "390589",
			"India": "892116468",
			"Mexico": "19770730",
			"Austria": "172733845",
			"Bouvet Island": "160440",
			"Zimbabwe": "6604",
			"Saint Maarten": "133513",
			"Swaziland": "2748507",
			"Lithuania": "17307737",
			"Cambodia": "157927743",
			"Denmark": "166318807",
			"Peru": "1358546",
			"Central African Rep.": "2877",
			"Netherlands": "92488677850",
			"Costa Rica": "26294828",
			"Equatorial Guinea": "83026347",
			"Greece": "11485063",
			"Kazakhstan": "2901923568",
			"Kenya": "96481",
			"Afghanistan": "9246",
			"Saint Helena": "30940",
			"Egypt": "130905836",
			"Nauru": "6046",
			"Anguilla": "13076",
			"Estonia": "5867906",
			"Morocco": "160474923",
			"Antarctica": "277555",
			"TFYR of Macedonia": "8156884",
			"Somalia": "143186",
			"Western Sahara": "66389",
			"United Rep. of Tanzania": "2821083",
			"Finland": "705532",
			"Belize": "31258",
			"Georgia": "100296064",
			"Ukraine": "181002909",
			"Bermuda": "81765",
			"Djibouti": "1061367",
			"Greenland": "20309826",
			"China, Hong Kong SAR": "105640869",
			"Suriname": "209599",
			"Nigeria": "217741277",
			"Vanuatu": "581",
			"Guinea-Bissau": "38920",
			"Venezuela": "5352095",
			"Kuwait": "583734",
			"New Zealand": "55713140",
			"Norway": "88005188",
			"Sierra Leone": "389553",
			"Marshall Isds": "2705",
			"Philippines": "4132322",
			"Libya": "586184438",
			"Kyrgyzstan": "3434854",
			"Czechia": "37353722",
			"Br. Indian Ocean Terr.": "5130",
			"Mozambique": "99941815",
			"Aruba": "921650",
			"Turkey": "234744076",
			"Tunisia": "13063881",
			"Rep. of Korea": "2170873398",
			"Serbia": "45452190",
			"Burundi": "12275670",
			"Bhutan": "72553",
			"Cook Isds": "110649",
			"Canada": "2852823",
			"Iceland": "68600688",
			"Luxembourg": "1122"
		},
		"exports": {
			"Lebanon": "662981",
			"Bonaire": "369898",
			"Gibraltar": "2527",
			"Ghana": "2340720",
			"Lesotho": "57341",
			"Cuba": "8925000",
			"Dem. Rep. of the Congo": "8589844",
			"Dem. People's Rep. of Korea": "22570",
			"Samoa": "12803",
			"Cameroon": "107997",
			"Papua New Guinea": "9743679",
			"Montserrat": "4580",
			"Indonesia": "26565",
			"Colombia": "12160681",
			"Niger": "832006",
			"Palau": "26431",
			"Tonga": "37845",
			"Angola": "670",
			"Fr. South Antarctic Terr.": "2380244",
			"Uzbekistan": "5483672",
			"Iraq": "32428600",
			"Tuvalu": "42494",
			"Guam": "89137",
			"Bosnia Herzegovina": "361205",
			"Pakistan": "76586632",
			"Belgium": "111665478",
			"Azerbaijan": "285500",
			"Armenia": "29464",
			"United Kingdom": "404155362",
			"Singapore": "1343044178",
			"Albania": "343391",
			"Benin": "1232643",
			"South Africa": "1153979092",
			"FS Micronesia": "244505",
			"Panama": "15677801",
			"Qatar": "40015549",
			"American Samoa": "10011",
			"Saint Vincent and the Grenadines": "205556",
			"Curaçao": "27429549",
			"Australia": "52474025",
			"Kiribati": "335",
			"Jamaica": "2841165",
			"Br. Virgin Isds": "183224656",
			"Spain": "4093565012",
			"Tajikistan": "13549168",
			"Ireland": "91537",
			"Botswana": "2103",
			"South Sudan": "722927",
			"French Polynesia": "2844500",
			"Mauritania": "17643225",
			"Bouvet Island": "6626436",
			"Honduras": "12120684",
			"Saint Barthélemy": "99256",
			"Holy See (Vatican City State)": "167709",
			"Chile": "12537584",
			"Sudan": "7072082",
			"Gambia": "9591696",
			"Liberia": "187564829",
			"Dominica": "3031",
			"Malaysia": "82733",
			"Fiji": "1057776",
			"Portugal": "284130225",
			"Falkland Isds (Malvinas)": "64756",
			"Nepal": "34330549",
			"China": "86591058",
			"Comoros": "358477",
			"Guinea-Bissau": "42731",
			"Mali": "1608929",
			"Trinidad and Tobago": "226427",
			"Israel": "211553",
			"Burkina Faso": "4749",
			"Paraguay": "1217766",
			"Norfolk Isds": "1203",
			"Bangladesh": "1306048",
			"Antigua and Barbuda": "2214",
			"Gabon": "44537585",
			"Cyprus": "983292",
			"Yemen": "1185840",
			"Mauritius": "114188",
			"Slovakia": "3352411467",
			"Faeroe Isds": "9249153",
			"Turkmenistan": "6280672",
			"Bahrain": "1536647",
			"Côte d'Ivoire": "6623619",
			"Guyana": "102551",
			"Saint Pierre and Miquelon": "5947",
			"Algeria": "11301491",
			"USA": "69895221",
			"Namibia": "83146278",
			"Rep. of Moldova": "89628799",
			"Zambia": "2755257",
			"Malta": "62330",
			"Ecuador": "3314726",
			"Grenada": "4206",
			"Dominican Rep.": "3295131",
			"France": "40708685",
			"New Caledonia": "19419802",
			"Niue": "3321",
			"Seychelles": "1686886",
			"Italy": "25381080",
			"Saint Lucia": "284301",
			"State of Palestine": "8516315",
			"Rwanda": "797257",
			"Syria": "17969495",
			"Belarus": "435701",
			"Ethiopia": "42130449",
			"Slovenia": "567297929",
			"Congo": "5651028",
			"Senegal": "4955822",
			"Bulgaria": "3224243",
			"Montenegro": "14814345",
			"Sri Lanka": "7189",
			"Hungary": "3061793",
			"Jordan": "57647",
			"N. Mariana Isds": "2038486",
			"Lao People's Dem. Rep.": "9119983",
			"Myanmar": "22209572",
			"Iran": "243170",
			"Sao Tome and Principe": "6309",
			"Uruguay": "14076220",
			"Switzerland": "17268728338",
			"Cabo Verde": "7885",
			"Togo": "6854704",
			"Timor-Leste": "4929",
			"Poland": "3419439104",
			"Thailand": "30778321",
			"Argentina": "29140756",
			"Brazil": "2819221",
			"Brunei Darussalam": "237181",
			"Mongolia": "12061055",
			"Saudi Arabia": "252551576",
			"Greece": "3349789",
			"Russian Federation": "630958379",
			"Cayman Isds": "819804828",
			"United Arab Emirates": "35807714",
			"Nicaragua": "3340570",
			"Malawi": "50527",
			"Andorra": "183469",
			"El Salvador": "76632",
			"United States Minor Outlying Islands": "73771",
			"Sierra Leone": "4791879",
			"Latvia": "32901",
			"Japan": "2772815",
			"Guinea": "2307368",
			"Uganda": "36347754",
			"Romania": "471843731",
			"Croatia": "2561546",
			"China, Macao SAR": "8281205",
			"Guatemala": "906346",
			"Madagascar": "61071",
			"Bolivia (Plurinational State of)": "837694",
			"Barbados": "6982",
			"Saint Kitts and Nevis": "51938",
			"Bahamas": "13901",
			"San Marino": "338955",
			"Chad": "3922",
			"Viet Nam": "291738155",
			"Haiti": "3890408",
			"Tokelau": "20256",
			"Oman": "168091314",
			"Sweden": "27937425246",
			"Maldives": "24372",
			"India": "1209023539",
			"Mexico": "11221058",
			"Austria": "221276797",
			"Eritrea": "1528433",
			"Zimbabwe": "3235556",
			"Saint Maarten": "6333457",
			"Swaziland": "8024671",
			"Lithuania": "26571",
			"Cambodia": "316408",
			"Denmark": "4856547",
			"Peru": "1895452",
			"Central African Rep.": "1388709",
			"Netherlands": "86835884230",
			"Costa Rica": "40434",
			"Equatorial Guinea": "1475154",
			"South Georgia and the South Sandwich Islands": "630",
			"Kazakhstan": "288232",
			"Kenya": "8341",
			"Afghanistan": "10325",
			"Saint Helena": "1468",
			"Egypt": "2226493",
			"Nauru": "17448",
			"Anguilla": "8507",
			"Estonia": "11500",
			"Morocco": "528118860",
			"Antarctica": "12563",
			"TFYR of Macedonia": "1687672",
			"Somalia": "881905",
			"Western Sahara": "8752",
			"United Rep. of Tanzania": "35245",
			"Finland": "26512",
			"Belize": "11267",
			"Georgia": "1990",
			"Ukraine": "3845832",
			"Bermuda": "174223",
			"Djibouti": "24684749",
			"Greenland": "29654",
			"China, Hong Kong SAR": "48859",
			"Suriname": "222488",
			"Nigeria": "3515008",
			"Vanuatu": "401844",
			"Venezuela": "191151",
			"Kuwait": "267917",
			"New Zealand": "381457091",
			"Norway": "587556448",
			"Pitcairn": "4112",
			"Marshall Isds": "151208561",
			"Philippines": "4055421",
			"Libya": "99972",
			"Kyrgyzstan": "8110589",
			"Czechia": "6355777",
			"Br. Indian Ocean Terr.": "4679",
			"Mozambique": "13633060",
			"Aruba": "11529443",
			"Turkey": "202332026",
			"Tunisia": "14189060",
			"Rep. of Korea": "95213",
			"Serbia": "123128419",
			"Burundi": "3221",
			"Bhutan": "1096",
			"Cook Isds": "17233",
			"Canada": "29954395",
			"Iceland": "33108395",
			"Luxembourg": "1718981"
		}
	},
	"Timor-Leste": {
		"imports": {},
		"exports": {}
	},
	"Poland": {
		"imports": {
			"Lebanon": "99561",
			"Bonaire": "105",
			"Gibraltar": "56017942",
			"Ghana": "2342170",
			"Lesotho": "24040",
			"Cuba": "17641",
			"Dem. Rep. of the Congo": "12378",
			"Dem. People's Rep. of Korea": "230719",
			"Cameroon": "73532",
			"South Africa": "1155300",
			"Montserrat": "562",
			"Indonesia": "1241072",
			"Colombia": "3864346",
			"Niger": "62761",
			"Jordan": "29",
			"Fr. South Antarctic Terr.": "4729",
			"Uzbekistan": "197202",
			"Iraq": "403402538",
			"Tuvalu": "1204",
			"Guam": "5463",
			"Bosnia Herzegovina": "187763",
			"Pakistan": "1366523",
			"Belgium": "4134712",
			"Azerbaijan": "31315794",
			"Rwanda": "33076",
			"Armenia": "2769",
			"United Kingdom": "4312609",
			"Singapore": "268",
			"Albania": "10055",
			"Benin": "26536",
			"Antarctica": "212",
			"Panama": "23702991",
			"Qatar": "5003",
			"American Samoa": "12595",
			"Saint Vincent and the Grenadines": "8369160",
			"Curaçao": "434",
			"Australia": "201837",
			"Bahrain": "7171",
			"Mexico": "59500",
			"Kenya": "170866",
			"Spain": "127575",
			"Tajikistan": "284",
			"Ireland": "95868",
			"Botswana": "423",
			"French Polynesia": "28561",
			"Mauritania": "83",
			"Christmas Isds": "43083",
			"Honduras": "5282007",
			"Saint Barthélemy": "195981",
			"Cambodia": "44040",
			"Holy See (Vatican City State)": "33",
			"Chile": "4630",
			"Sudan": "3748",
			"Gambia": "126",
			"China, Macao SAR": "4244",
			"Brunei Darussalam": "453",
			"Malaysia": "25345",
			"Swaziland": "135451",
			"Portugal": "12340156",
			"Falkland Isds (Malvinas)": "74076",
			"Nepal": "8923",
			"China": "14741547",
			"Comoros": "932567",
			"Guinea-Bissau": "3361",
			"Saint Maarten": "74528",
			"Mali": "813163",
			"Trinidad and Tobago": "95273",
			"Israel": "7355",
			"Burkina Faso": "18173",
			"Paraguay": "736822",
			"Bangladesh": "606422",
			"Antigua and Barbuda": "143902583",
			"Gabon": "6550577",
			"Cyprus": "41856362",
			"Yemen": "47",
			"Mauritius": "635800",
			"Slovakia": "890455",
			"Faeroe Isds": "32631258",
			"Turkmenistan": "667",
			"Syria": "493964",
			"Côte d'Ivoire": "22214",
			"Guyana": "440755",
			"Saint Pierre and Miquelon": "20",
			"Algeria": "36447",
			"USA": "16419511",
			"Saint Kitts and Nevis": "8951960",
			"Rep. of Moldova": "19494969",
			"Zambia": "2051",
			"Malta": "121231",
			"Ecuador": "7532870",
			"Grenada": "146093",
			"Dominican Rep.": "6576530",
			"France": "8204815",
			"New Caledonia": "3781",
			"Niue": "4506",
			"Seychelles": "364975",
			"Br. Virgin Isds": "38243",
			"Italy": "16644178",
			"Saint Lucia": "623",
			"State of Palestine": "13",
			"Uganda": "166468",
			"Belarus": "201236",
			"Ethiopia": "2755639",
			"Pitcairn": "43317",
			"Senegal": "4542",
			"Bulgaria": "2480126",
			"Montenegro": "61998",
			"Sri Lanka": "5223",
			"Hungary": "86508",
			"Netherlands": "940429",
			"New Zealand": "1564963",
			"N. Mariana Isds": "146",
			"Samoa": "23832",
			"Myanmar": "744",
			"Iran": "41711",
			"Sao Tome and Principe": "3948942",
			"Lao People's Dem. Rep.": "61310",
			"Uruguay": "450291",
			"Andorra": "1144",
			"Cabo Verde": "183",
			"Germany": "17089990",
			"Timor-Leste": "60615",
			"Bouvet Island": "79",
			"Thailand": "4051340",
			"Argentina": "5711",
			"Brazil": "740",
			"Dominica": "19800000",
			"Mongolia": "5063",
			"Saudi Arabia": "476938466",
			"South Georgia and the South Sandwich Islands": "61035",
			"Russian Federation": "6053183758",
			"Cayman Isds": "66559",
			"United Arab Emirates": "2486",
			"Nicaragua": "66368",
			"Malawi": "12125",
			"Switzerland": "80267",
			"El Salvador": "105227",
			"United States Minor Outlying Islands": "1316",
			"Latvia": "8985314",
			"Japan": "21111364",
			"Guinea": "55124",
			"Angola": "2079946",
			"Romania": "7494868",
			"Croatia": "52393",
			"Liberia": "176697753",
			"Mozambique": "14883948",
			"Madagascar": "513856",
			"Bolivia (Plurinational State of)": "139456",
			"Nigeria": "24110882",
			"Bahamas": "270344190",
			"Tunisia": "770",
			"Chad": "7402",
			"Viet Nam": "67892",
			"Haiti": "5624",
			"Tokelau": "2298",
			"Oman": "354",
			"Sweden": "9274",
			"Maldives": "526450",
			"India": "3142602",
			"Jamaica": "1782",
			"Austria": "5245803",
			"Eritrea": "281",
			"Congo": "1463135",
			"Zimbabwe": "8752",
			"Vanuatu": "5537113",
			"Fiji": "29",
			"Lithuania": "30970",
			"Namibia": "399321",
			"Denmark": "280520815",
			"Peru": "2386509",
			"Central African Rep.": "70806",
			"Slovenia": "1983",
			"Costa Rica": "928176",
			"Equatorial Guinea": "5087",
			"Greece": "98509117",
			"Papua New Guinea": "229551",
			"Kazakhstan": "119762776",
			"Afghanistan": "5135",
			"Saint Helena": "141",
			"Egypt": "48376",
			"Nauru": "16178",
			"Anguilla": "28662",
			"Estonia": "1328870",
			"Morocco": "16176956",
			"Luxembourg": "89839",
			"TFYR of Macedonia": "61455",
			"Somalia": "6",
			"Heard Island and McDonald Islands": "166",
			"United Rep. of Tanzania": "108727",
			"Finland": "193100",
			"Belize": "18634",
			"Georgia": "82",
			"Ukraine": "2041227",
			"Bermuda": "5802",
			"Djibouti": "36127",
			"Greenland": "10498065",
			"China, Hong Kong SAR": "165659",
			"Suriname": "5163",
			"Barbados": "5412",
			"Venezuela": "5949",
			"Kuwait": "62",
			"Norway": "31098140",
			"Sierra Leone": "740",
			"Marshall Isds": "10033574",
			"Philippines": "204488",
			"Libya": "114",
			"Kyrgyzstan": "500117",
			"Czechia": "106307576",
			"Br. Indian Ocean Terr.": "62781",
			"Guatemala": "1250060",
			"Togo": "655513",
			"Aruba": "1092",
			"Turkey": "36195",
			"San Marino": "49399",
			"Rep. of Korea": "268528",
			"Serbia": "202036",
			"Burundi": "1709911",
			"Bhutan": "2532",
			"Cook Isds": "1209734",
			"Canada": "4663402",
			"Iceland": "494"
		},
		"exports": {
			"Lebanon": "788175",
			"Bonaire": "178164",
			"Gibraltar": "1555841",
			"Ghana": "405",
			"Lesotho": "30",
			"Cuba": "19071868",
			"Dem. Rep. of the Congo": "224480",
			"Dem. People's Rep. of Korea": "3172",
			"Cameroon": "2105353",
			"South Africa": "9783",
			"Indonesia": "33094",
			"Colombia": "227",
			"Niger": "21320",
			"Palau": "3024",
			"Tonga": "2199",
			"Jordan": "25726",
			"Fr. South Antarctic Terr.": "92029",
			"Uzbekistan": "75178",
			"Iraq": "46639",
			"Tuvalu": "330",
			"Guam": "433",
			"Bosnia Herzegovina": "16274",
			"Pakistan": "261281",
			"Belgium": "8072904",
			"Azerbaijan": "80219",
			"Rwanda": "92",
			"Australia": "4751535",
			"United Kingdom": "20358106",
			"Singapore": "638533",
			"Albania": "258",
			"Benin": "73047",
			"Antarctica": "21209",
			"FS Micronesia": "321",
			"Panama": "136767",
			"Qatar": "109857",
			"American Samoa": "90",
			"Saint Vincent and the Grenadines": "3860699",
			"Curaçao": "4422707",
			"Armenia": "62497",
			"Bahrain": "17736",
			"Mexico": "647",
			"Kenya": "2809",
			"Spain": "16114035",
			"Tajikistan": "250756",
			"Ireland": "676420",
			"Botswana": "20",
			"South Sudan": "5574",
			"French Polynesia": "80828",
			"Mauritania": "289591",
			"Honduras": "29764",
			"Saint Barthélemy": "250",
			"Cambodia": "368",
			"Holy See (Vatican City State)": "40970",
			"Chile": "8049",
			"Gambia": "2262",
			"China, Macao SAR": "1021483",
			"Brunei Darussalam": "13",
			"Malaysia": "674670",
			"Swaziland": "2200",
			"Portugal": "1337",
			"Falkland Isds (Malvinas)": "80",
			"Nepal": "63994",
			"China": "4771074",
			"Comoros": "11673",
			"Guinea-Bissau": "140",
			"Saint Maarten": "791920",
			"Mali": "127682",
			"Trinidad and Tobago": "1440",
			"Israel": "1260756",
			"Burkina Faso": "500573",
			"Paraguay": "1497072",
			"Bangladesh": "2571414",
			"Antigua and Barbuda": "249",
			"Gabon": "22426",
			"Cyprus": "898",
			"Yemen": "169344",
			"Mauritius": "131765",
			"Slovakia": "54819579",
			"Faeroe Isds": "33197262",
			"Turkmenistan": "6229927",
			"Syria": "2773101",
			"Côte d'Ivoire": "19854",
			"Guyana": "315356",
			"Saint Pierre and Miquelon": "518",
			"Algeria": "1146133",
			"USA": "32198428",
			"Saint Kitts and Nevis": "3613789",
			"Rep. of Moldova": "6092",
			"Zambia": "439",
			"Malta": "1392484",
			"Ecuador": "29046",
			"Grenada": "757",
			"Dominican Rep.": "188879",
			"France": "71379239",
			"New Caledonia": "273460",
			"Seychelles": "69499",
			"Br. Virgin Isds": "5984500",
			"Italy": "8162120",
			"Saint Lucia": "13406",
			"State of Palestine": "85",
			"Uganda": "8920",
			"Belarus": "167009",
			"Ethiopia": "8067213",
			"Congo": "1571107",
			"Senegal": "345420",
			"Bulgaria": "667897",
			"Montenegro": "397556",
			"Sri Lanka": "17869",
			"Hungary": "2871348",
			"Netherlands": "8820849",
			"New Zealand": "384066",
			"N. Mariana Isds": "63546",
			"Samoa": "1239",
			"Myanmar": "3137",
			"Iran": "131621",
			"Sao Tome and Principe": "15092",
			"Lao People's Dem. Rep.": "38558",
			"Uruguay": "23073",
			"Andorra": "81",
			"Cabo Verde": "276975",
			"Germany": "147415204",
			"Timor-Leste": "46",
			"Thailand": "602602",
			"Argentina": "558547",
			"Brazil": "431933",
			"Dominica": "130000",
			"Mongolia": "193663",
			"Saudi Arabia": "98683",
			"Greece": "245951",
			"Russian Federation": "43844",
			"Cayman Isds": "1600",
			"United Arab Emirates": "722218",
			"Nicaragua": "20056",
			"Malawi": "913759",
			"Switzerland": "11869455",
			"El Salvador": "538159",
			"United States Minor Outlying Islands": "6116",
			"Latvia": "1848808",
			"Japan": "1512406",
			"Guinea": "56113",
			"Romania": "4765054",
			"Croatia": "6569100",
			"Liberia": "172780552",
			"Mozambique": "2660548",
			"Madagascar": "49499",
			"Bolivia (Plurinational State of)": "6219",
			"Nigeria": "2026377",
			"Bahamas": "96591",
			"Tunisia": "16423509",
			"Chad": "219191",
			"Viet Nam": "256591",
			"Haiti": "2634974",
			"Tokelau": "68",
			"Oman": "30626",
			"Sweden": "21043679",
			"Maldives": "519",
			"India": "135348",
			"Jamaica": "111361",
			"Austria": "5507323",
			"Eritrea": "1343",
			"Zimbabwe": "746",
			"Vanuatu": "6000448",
			"Fiji": "46",
			"Lithuania": "1879228",
			"Namibia": "3290",
			"Denmark": "6440184",
			"Peru": "977024",
			"Central African Rep.": "25195",
			"Slovenia": "223481",
			"Costa Rica": "1315",
			"Equatorial Guinea": "7410",
			"Sudan": "801428",
			"Papua New Guinea": "630",
			"Kazakhstan": "885195",
			"Afghanistan": "10255",
			"Saint Helena": "92",
			"Egypt": "101750",
			"Anguilla": "6697",
			"Estonia": "1304648",
			"Morocco": "18128953",
			"Luxembourg": "1361774",
			"TFYR of Macedonia": "1679676",
			"Somalia": "6564",
			"Angola": "360112",
			"Western Sahara": "31196",
			"United Rep. of Tanzania": "2544",
			"Finland": "19911685",
			"Belize": "49520",
			"Georgia": "95134",
			"Ukraine": "6479034",
			"Bermuda": "7156",
			"Djibouti": "6434",
			"Greenland": "363159",
			"China, Hong Kong SAR": "3143575",
			"Suriname": "194",
			"Barbados": "3327274",
			"Venezuela": "79879",
			"Kuwait": "665552",
			"Norway": "3504926",
			"Sierra Leone": "138219",
			"Marshall Isds": "763966",
			"Philippines": "2814",
			"Libya": "540",
			"Kyrgyzstan": "27550",
			"Czechia": "17681745",
			"Guatemala": "14371",
			"Togo": "1771",
			"Aruba": "15000",
			"Turkey": "6586889",
			"San Marino": "1504",
			"Rep. of Korea": "827441",
			"Serbia": "11633",
			"Burundi": "1780",
			"Bhutan": "2111",
			"Cook Isds": "1495043",
			"Canada": "1113143",
			"Iceland": "679502"
		}
	},
	"Thailand": {
		"imports": {},
		"exports": {}
	},
	"Argentina": {
		"imports": {
			"Lebanon": "114678",
			"Gibraltar": "11",
			"Ghana": "316",
			"Cuba": "20",
			"Dem. Rep. of the Congo": "11919",
			"Cameroon": "306314",
			"South Africa": "2429",
			"Indonesia": "6744106",
			"Colombia": "201009797",
			"Niger": "101",
			"Palau": "48",
			"Angola": "10851739",
			"Uzbekistan": "12860",
			"Iraq": "253",
			"Bosnia Herzegovina": "777457",
			"Pakistan": "40783",
			"Belgium": "312473649",
			"Rwanda": "2654",
			"Armenia": "24192",
			"United Kingdom": "4025755",
			"Singapore": "805574",
			"Albania": "7649",
			"Panama": "5784",
			"Qatar": "221480064",
			"American Samoa": "1756",
			"Curaçao": "3060",
			"Australia": "17928274",
			"Mexico": "24303973",
			"Kenya": "589",
			"Spain": "1136604",
			"Tajikistan": "98",
			"Ireland": "3409178",
			"Mauritania": "80",
			"Honduras": "348338",
			"Holy See (Vatican City State)": "154",
			"Chile": "689450899",
			"Gambia": "57",
			"China, Macao SAR": "1276",
			"Dominica": "2773",
			"Malaysia": "3234272",
			"Swaziland": "57",
			"Portugal": "7633",
			"Nepal": "91",
			"China": "10467476060",
			"Comoros": "23406",
			"Mali": "211",
			"Trinidad and Tobago": "290669170",
			"Israel": "231381",
			"Burkina Faso": "42",
			"Kazakhstan": "463677",
			"Paraguay": "3408094",
			"Bangladesh": "4244",
			"Antigua and Barbuda": "657",
			"Gabon": "1007276",
			"Cyprus": "133535",
			"Mauritius": "71",
			"Slovakia": "1456778",
			"Turkmenistan": "364",
			"Bahrain": "46",
			"Côte d'Ivoire": "9576",
			"Guyana": "250",
			"Algeria": "49122624",
			"USA": "681550031",
			"Namibia": "264",
			"Rep. of Moldova": "12902",
			"Zambia": "68",
			"Malta": "8",
			"Ecuador": "3298189",
			"Grenada": "309527",
			"Dominican Rep.": "370947",
			"France": "260104227",
			"Seychelles": "42910",
			"Italy": "15624580",
			"Saint Lucia": "1071",
			"Uganda": "14",
			"Belarus": "6977628",
			"Ethiopia": "27742",
			"Congo": "23553",
			"Senegal": "89",
			"Bulgaria": "15139791",
			"Montenegro": "134",
			"Sri Lanka": "11125686",
			"Hungary": "140414",
			"Jordan": "239455",
			"N. Mariana Isds": "702",
			"Lao People's Dem. Rep.": "75048",
			"Myanmar": "10868335",
			"Iran": "116889",
			"Uruguay": "41865",
			"Andorra": "70",
			"Cabo Verde": "1222",
			"Germany": "280063470",
			"Poland": "1997683",
			"Thailand": "314",
			"Argentina": "332469",
			"Brazil": "13597452017",
			"Brunei Darussalam": "2854",
			"Mongolia": "2607",
			"Saudi Arabia": "46",
			"Syria": "9860",
			"Russian Federation": "423810",
			"United Arab Emirates": "63",
			"Nicaragua": "44490",
			"Malawi": "367",
			"Switzerland": "505128",
			"El Salvador": "145683",
			"Latvia": "49825",
			"Japan": "240701",
			"Guinea": "36628",
			"Romania": "18387",
			"Croatia": "920270",
			"Guatemala": "73636",
			"Madagascar": "373612",
			"Bolivia (Plurinational State of)": "708709040",
			"Barbados": "1454",
			"Bahamas": "17655",
			"Tunisia": "73462",
			"Chad": "71",
			"Viet Nam": "624",
			"Haiti": "7274",
			"Oman": "75642",
			"Sweden": "326279",
			"India": "6278",
			"Jamaica": "262",
			"Austria": "10757025",
			"Zimbabwe": "5892",
			"Fiji": "3300",
			"Lithuania": "244674",
			"Cambodia": "14769966",
			"Denmark": "39014821",
			"Peru": "4536863",
			"Netherlands": "25027866",
			"Costa Rica": "4091650",
			"Equatorial Guinea": "13088759",
			"Sudan": "2287",
			"Papua New Guinea": "2098",
			"Slovenia": "26293",
			"Afghanistan": "10700",
			"Greece": "1541383",
			"Egypt": "232",
			"Nauru": "104",
			"Estonia": "495",
			"Morocco": "156430",
			"Luxembourg": "21368",
			"TFYR of Macedonia": "133",
			"Somalia": "21",
			"United Rep. of Tanzania": "29",
			"Finland": "3022256",
			"Belize": "128",
			"Georgia": "148533",
			"Ukraine": "8",
			"Djibouti": "118650",
			"China, Hong Kong SAR": "6055",
			"Suriname": "224",
			"Nigeria": "1812",
			"Venezuela": "28398",
			"Kuwait": "14817700",
			"New Zealand": "21242",
			"Norway": "86379",
			"Sierra Leone": "10341",
			"Philippines": "513942",
			"Libya": "37",
			"Kyrgyzstan": "500",
			"Czechia": "1580883",
			"Mozambique": "241",
			"Turkey": "10426143",
			"San Marino": "46050",
			"Rep. of Korea": "758648",
			"Serbia": "52144",
			"Burundi": "4954",
			"Canada": "345259569",
			"Iceland": "49144"
		},
		"exports": {
			"Lebanon": "7143273",
			"Gibraltar": "149939",
			"Ghana": "26271",
			"Lesotho": "121718",
			"Cuba": "3548935",
			"Dem. Rep. of the Congo": "11080630",
			"Cameroon": "25146118",
			"South Africa": "379897",
			"Indonesia": "1136336",
			"Colombia": "509773374",
			"Niger": "4584125",
			"Angola": "451",
			"Uzbekistan": "54952",
			"Iraq": "16791807",
			"Bosnia Herzegovina": "3690962",
			"Pakistan": "128245",
			"Belgium": "378984703",
			"Azerbaijan": "56651",
			"Armenia": "8100676",
			"United Kingdom": "57695",
			"Singapore": "25704022",
			"Albania": "101066",
			"Benin": "456920",
			"Panama": "21740023",
			"Qatar": "6484765",
			"Saint Vincent and the Grenadines": "130221",
			"Curaçao": "4201514",
			"Australia": "126054271",
			"Bahrain": "41132",
			"Jamaica": "2287488",
			"Kenya": "3833919",
			"Spain": "1124697",
			"Tajikistan": "34838",
			"Ireland": "10230977",
			"Botswana": "141024",
			"South Sudan": "29577",
			"Mauritania": "322389",
			"Honduras": "4102037",
			"Holy See (Vatican City State)": "1400",
			"Jordan": "5968700",
			"Chile": "2297396936",
			"Gambia": "2738459",
			"Liberia": "389548",
			"Dominica": "13852",
			"Malaysia": "4117225",
			"Swaziland": "39950",
			"Portugal": "11315663",
			"Nepal": "515464",
			"China": "4425229904",
			"Comoros": "2096070",
			"Djibouti": "36909",
			"Trinidad and Tobago": "1254600",
			"Israel": "155445722",
			"Burkina Faso": "853730",
			"Paraguay": "145831345",
			"Bangladesh": "489732449",
			"Antigua and Barbuda": "270564",
			"Gabon": "399988",
			"Cyprus": "2994",
			"Yemen": "5129570",
			"Mauritius": "320861",
			"Slovakia": "2006644",
			"Turkmenistan": "45150",
			"Syria": "48263",
			"Côte d'Ivoire": "1718599",
			"Guyana": "2193282",
			"Algeria": "1842853",
			"USA": "408891798",
			"Saint Kitts and Nevis": "65231",
			"Rep. of Moldova": "2522533",
			"Zambia": "10475",
			"Malta": "816713",
			"Ecuador": "33463160",
			"Grenada": "4587",
			"Dominican Rep.": "15083672",
			"France": "207649",
			"Seychelles": "277654",
			"Italy": "87252734",
			"Saint Lucia": "669061",
			"State of Palestine": "117882",
			"Rwanda": "1478000",
			"Belarus": "20022235",
			"Ethiopia": "54864",
			"Namibia": "692829",
			"Congo": "12751465",
			"Slovenia": "1496049",
			"Bulgaria": "38307689",
			"Montenegro": "308553",
			"Sri Lanka": "3816940",
			"Hungary": "7561087",
			"New Zealand": "11948058",
			"Lao People's Dem. Rep.": "109684",
			"Myanmar": "7515389",
			"Iran": "30900",
			"Uruguay": "58186678",
			"Cabo Verde": "2033870",
			"Germany": "1793621",
			"Poland": "180695",
			"Thailand": "354740",
			"Brazil": "9027619164",
			"Brunei Darussalam": "6974886",
			"Mongolia": "637772",
			"Saudi Arabia": "115924",
			"Greece": "14657722",
			"Russian Federation": "212644903",
			"United Arab Emirates": "20590",
			"Nicaragua": "3305305",
			"Malawi": "5162000",
			"Switzerland": "74214",
			"El Salvador": "1597021",
			"Latvia": "1782903",
			"Japan": "81610161",
			"Guinea": "380715",
			"Uganda": "9814160",
			"Romania": "1539769",
			"Croatia": "89460",
			"China, Macao SAR": "7929",
			"Guatemala": "15622094",
			"Madagascar": "385109",
			"Bolivia (Plurinational State of)": "559654646",
			"Barbados": "762573",
			"Bahamas": "480",
			"Tunisia": "6703958",
			"Chad": "134554",
			"Viet Nam": "44389",
			"Haiti": "1016708",
			"Oman": "6013681",
			"Sweden": "46200",
			"Maldives": "563822",
			"India": "1277939",
			"Mexico": "51600657",
			"Austria": "1115775",
			"Eritrea": "68478",
			"Zimbabwe": "4272",
			"Vanuatu": "14366",
			"Senegal": "9165567",
			"Fiji": "9417",
			"Lithuania": "7853585",
			"Cambodia": "17125766",
			"Denmark": "36621",
			"Peru": "3077562",
			"Central African Rep.": "695390",
			"Netherlands": "337719559",
			"Costa Rica": "2600256",
			"Equatorial Guinea": "372010",
			"Sudan": "471982",
			"Papua New Guinea": "12404",
			"Kazakhstan": "181262",
			"Afghanistan": "1646376",
			"Egypt": "2200",
			"Estonia": "1",
			"Morocco": "13492969",
			"Luxembourg": "698424",
			"Venezuela": "295120",
			"Somalia": "523222",
			"United Rep. of Tanzania": "133014",
			"Finland": "114459",
			"Belize": "320723",
			"Georgia": "1133196",
			"Ukraine": "3100",
			"Mali": "572134",
			"China, Hong Kong SAR": "112599206",
			"Suriname": "1860490",
			"Nigeria": "6668480",
			"TFYR of Macedonia": "4813565",
			"Kuwait": "781074",
			"Norway": "5576470",
			"Sierra Leone": "647938",
			"Philippines": "184008",
			"Libya": "1681520",
			"Kyrgyzstan": "117466",
			"Czechia": "86",
			"Mozambique": "594493",
			"Togo": "150583",
			"Aruba": "1479249",
			"Turkey": "42173290",
			"Rep. of Korea": "33448713",
			"Serbia": "4446580",
			"Burundi": "356000",
			"Canada": "1147783719",
			"Iceland": "1146522"
		}
	},
	"Brazil": {
		"imports": {
			"Lebanon": "133089",
			"Gibraltar": "157",
			"Ghana": "2625587",
			"Lesotho": "1471",
			"Qatar": "196113355",
			"Dem. Rep. of the Congo": "5989034",
			"Dem. People's Rep. of Korea": "45892",
			"Cameroon": "864855",
			"Papua New Guinea": "14983",
			"Montserrat": "228",
			"Indonesia": "1900",
			"Colombia": "1832293",
			"Niger": "985",
			"Palau": "35",
			"Jordan": "79804",
			"Uzbekistan": "2380",
			"Iraq": "114595553",
			"Tuvalu": "31",
			"Bosnia Herzegovina": "3137",
			"Pakistan": "132392",
			"Belgium": "43804585",
			"Azerbaijan": "178816",
			"Rwanda": "679",
			"Armenia": "5200",
			"United Kingdom": "1731913",
			"Singapore": "2534",
			"Albania": "81099",
			"Benin": "416",
			"South Africa": "27030",
			"FS Micronesia": "1181",
			"Panama": "153",
			"Cuba": "84994",
			"American Samoa": "484",
			"Curaçao": "30790021",
			"Australia": "9911472",
			"Kiribati": "13",
			"Jamaica": "948676",
			"Kenya": "1106",
			"Spain": "2080074",
			"Tajikistan": "799",
			"Ireland": "14041",
			"Botswana": "223",
			"French Polynesia": "158",
			"Mauritania": "364384",
			"Bouvet Island": "19267",
			"Honduras": "644851",
			"Chile": "72702628",
			"Gambia": "14011",
			"China, Macao SAR": "146978",
			"Brunei Darussalam": "28251",
			"Malaysia": "52",
			"Swaziland": "62407",
			"Portugal": "73040",
			"Falkland Isds (Malvinas)": "101219",
			"Nepal": "182",
			"China": "12280986",
			"Comoros": "41325",
			"Guinea-Bissau": "1291847",
			"Saint Maarten": "62771",
			"Mali": "9195",
			"Trinidad and Tobago": "70523391",
			"Israel": "6560",
			"Paraguay": "63578",
			"Norfolk Isds": "31011",
			"Bangladesh": "38564",
			"Antigua and Barbuda": "1253",
			"Gabon": "8016",
			"Cyprus": "34878",
			"Yemen": "6014",
			"Mauritius": "36759",
			"Slovakia": "6691767",
			"Faeroe Isds": "32",
			"Turkmenistan": "366",
			"Bahrain": "81160",
			"Côte d'Ivoire": "9735435",
			"Guyana": "791556",
			"Algeria": "8102884",
			"USA": "37401587",
			"Cambodia": "853",
			"Rep. of Moldova": "67460",
			"Zambia": "636",
			"Malta": "19960352",
			"Ecuador": "52034753",
			"Grenada": "1181",
			"Dominican Rep.": "192145",
			"France": "541793",
			"New Caledonia": "70307",
			"Seychelles": "224",
			"Br. Virgin Isds": "63572",
			"Italy": "8739941",
			"Saint Lucia": "25",
			"State of Palestine": "137918",
			"Uganda": "273",
			"Syria": "1095464",
			"Belarus": "573073",
			"Ethiopia": "37306",
			"Namibia": "13815",
			"Pitcairn": "229",
			"Senegal": "20300",
			"Bulgaria": "2008118",
			"Montenegro": "958",
			"Sri Lanka": "7408373",
			"Hungary": "32217006",
			"Angola": "6210",
			"N. Mariana Isds": "485",
			"Lao People's Dem. Rep.": "5289",
			"Myanmar": "718960",
			"Iran": "1436489",
			"Uruguay": "171652609",
			"Andorra": "35272",
			"Cabo Verde": "18797",
			"Germany": "212811823",
			"Timor-Leste": "14",
			"Poland": "961741",
			"Thailand": "200210",
			"Argentina": "1432484896",
			"Dominica": "41116",
			"Mongolia": "2745",
			"Saudi Arabia": "884898846",
			"Greece": "2187",
			"Russian Federation": "1181",
			"Cayman Isds": "391",
			"United Arab Emirates": "3827",
			"Nicaragua": "87890",
			"Malawi": "46658",
			"Switzerland": "3004666",
			"El Salvador": "2053060",
			"United States Minor Outlying Islands": "4",
			"Latvia": "84159",
			"Japan": "130061451",
			"Guinea": "19",
			"Romania": "399927",
			"Slovenia": "63408",
			"Liberia": "23109",
			"Guatemala": "101748",
			"Madagascar": "50608",
			"Bolivia (Plurinational State of)": "641825",
			"Barbados": "10122",
			"Bahamas": "23443",
			"Tunisia": "1916941",
			"Viet Nam": "80235",
			"Haiti": "67539",
			"Tokelau": "3",
			"Oman": "15474734",
			"Sweden": "152217",
			"Maldives": "590",
			"India": "23962",
			"Mexico": "594258576",
			"Austria": "220706",
			"Eritrea": "251",
			"Congo": "65213",
			"Zimbabwe": "254",
			"Vanuatu": "268",
			"Fiji": "1306",
			"Lithuania": "726887",
			"Saint Kitts and Nevis": "414588",
			"Denmark": "6589",
			"Peru": "158814820",
			"Central African Rep.": "177148",
			"Netherlands": "1526039",
			"Costa Rica": "1118927",
			"Equatorial Guinea": "35834619",
			"Sudan": "38",
			"Kazakhstan": "3849208",
			"Afghanistan": "38894",
			"Croatia": "2114",
			"Saint Helena": "5305",
			"Egypt": "51600",
			"Nauru": "2991",
			"Anguilla": "19",
			"Estonia": "27145",
			"Morocco": "42778914",
			"Luxembourg": "2697",
			"TFYR of Macedonia": "579474",
			"Somalia": "6091",
			"Western Sahara": "396",
			"United Rep. of Tanzania": "1269",
			"Finland": "2223",
			"Belize": "384",
			"Georgia": "359572",
			"Ukraine": "475896",
			"Bermuda": "127",
			"Djibouti": "7827",
			"Greenland": "55",
			"China, Hong Kong SAR": "164732",
			"Suriname": "4446",
			"Nigeria": "280516229",
			"Venezuela": "2843",
			"Kuwait": "244933227",
			"New Zealand": "85484",
			"Norway": "65468903",
			"Sierra Leone": "22283",
			"Marshall Isds": "97676",
			"Philippines": "1543",
			"Libya": "26797651",
			"Kyrgyzstan": "188",
			"Czechia": "18005125",
			"Mozambique": "21613727",
			"Togo": "137",
			"Samoa": "3017",
			"Turkey": "867942",
			"San Marino": "20659",
			"Rep. of Korea": "118656301",
			"Serbia": "39553",
			"Bhutan": "3256",
			"Canada": "12579043",
			"Iceland": "35997"
		},
		"exports": {
			"Lebanon": "30208",
			"Bonaire": "287770",
			"Gibraltar": "454",
			"Ghana": "81453",
			"Lesotho": "30482",
			"Cuba": "37747",
			"Dem. Rep. of the Congo": "32791812",
			"Dem. People's Rep. of Korea": "970192",
			"Cameroon": "15734589",
			"South Africa": "512789",
			"Montserrat": "67518",
			"Indonesia": "65924448",
			"Colombia": "122582100",
			"Niger": "246557",
			"Palau": "1093742",
			"Tonga": "70429",
			"Angola": "38125",
			"Uzbekistan": "11814342",
			"Iraq": "301000095",
			"Tuvalu": "2338",
			"Guam": "2299",
			"Bosnia Herzegovina": "40313",
			"Pakistan": "4500",
			"Belgium": "1013631",
			"Azerbaijan": "107130",
			"Armenia": "11399075",
			"Togo": "236563",
			"Singapore": "67408",
			"Albania": "778656",
			"Benin": "7901",
			"FS Micronesia": "221021",
			"Panama": "1087300",
			"Qatar": "495681",
			"American Samoa": "26790",
			"Saint Vincent and the Grenadines": "791377",
			"Curaçao": "458315",
			"Australia": "197873",
			"Kiribati": "66500",
			"Jamaica": "41400",
			"Kenya": "6963208",
			"Spain": "58044",
			"Tajikistan": "1591106",
			"Ireland": "42680",
			"Slovenia": "9960409",
			"South Sudan": "244080",
			"French Polynesia": "278129",
			"Mauritania": "402847",
			"Honduras": "468604",
			"Saint Barthélemy": "562",
			"United Kingdom": "15272009",
			"Jordan": "526073",
			"Chile": "133217363",
			"Gambia": "79127016",
			"China, Macao SAR": "2337",
			"Dominica": "1634147",
			"Malaysia": "2088",
			"Fiji": "320202",
			"Portugal": "35779390",
			"Nepal": "345913",
			"China": "38926",
			"Comoros": "1898068",
			"Guinea-Bissau": "588",
			"Saint Maarten": "95858",
			"Mali": "43330291",
			"Trinidad and Tobago": "591225",
			"Israel": "27878",
			"Burkina Faso": "62186",
			"Paraguay": "35368751",
			"Bangladesh": "719208614",
			"Antigua and Barbuda": "4914928",
			"Gabon": "62960",
			"Cyprus": "966912",
			"Yemen": "65001628",
			"Mauritius": "39749",
			"Slovakia": "2640058",
			"Faeroe Isds": "26544",
			"Turkmenistan": "423610",
			"Bahrain": "46292116",
			"Côte d'Ivoire": "1911526",
			"Guyana": "31738",
			"Algeria": "94701609",
			"USA": "262646132",
			"Saint Kitts and Nevis": "108836",
			"Rep. of Moldova": "25250",
			"Zambia": "14918",
			"Malta": "65000",
			"Ecuador": "5164320",
			"Grenada": "7082",
			"Dominican Rep.": "114609",
			"France": "858405",
			"New Caledonia": "3203070",
			"Niue": "27",
			"Seychelles": "17",
			"Br. Virgin Isds": "169965",
			"Italy": "728954",
			"Saint Lucia": "364623544",
			"State of Palestine": "26877484",
			"Rwanda": "178429",
			"Syria": "26325",
			"Belarus": "567408",
			"Ethiopia": "812771",
			"Namibia": "20267416",
			"Congo": "600",
			"Senegal": "234125",
			"Bulgaria": "14062169",
			"Montenegro": "13272174",
			"Sri Lanka": "261519",
			"Hungary": "32556",
			"New Zealand": "31031",
			"Lao People's Dem. Rep.": "48399",
			"Myanmar": "159483288",
			"Iran": "20015163",
			"Philippines": "1100",
			"Uruguay": "24073765",
			"Andorra": "407",
			"Cabo Verde": "15605253",
			"Germany": "4616753",
			"Timor-Leste": "6599995",
			"Poland": "34458",
			"Thailand": "631499",
			"Argentina": "3357110397",
			"Brunei Darussalam": "263777",
			"Mongolia": "10236",
			"Saudi Arabia": "1067",
			"Greece": "373",
			"Russian Federation": "15961",
			"Cayman Isds": "26144",
			"United Arab Emirates": "239936787",
			"Nicaragua": "238380",
			"Malawi": "2153",
			"Switzerland": "2976171",
			"El Salvador": "234130",
			"United States Minor Outlying Islands": "221676",
			"Latvia": "138045",
			"Japan": "2734771",
			"Guinea": "37440",
			"Uganda": "3300",
			"Romania": "514",
			"Croatia": "39783",
			"Liberia": "175428",
			"Mozambique": "242",
			"Madagascar": "246518",
			"Bolivia (Plurinational State of)": "18064802",
			"Barbados": "2393887",
			"Bahamas": "4195940",
			"San Marino": "22725",
			"Chad": "336088",
			"Viet Nam": "880",
			"Haiti": "189880",
			"Tokelau": "288263",
			"Oman": "437169",
			"Sweden": "2177254",
			"Maldives": "14192676",
			"India": "17587",
			"Mexico": "288482242",
			"Austria": "133023",
			"Eritrea": "22365830",
			"Zimbabwe": "1291",
			"Vanuatu": "31280",
			"Swaziland": "12030",
			"Lithuania": "58733",
			"Cambodia": "215460",
			"Denmark": "56421",
			"Peru": "1492262",
			"Central African Rep.": "704669",
			"Netherlands": "1383695",
			"Costa Rica": "4571821",
			"Equatorial Guinea": "13475575",
			"Sudan": "124200",
			"Papua New Guinea": "5640",
			"Kazakhstan": "45215",
			"Afghanistan": "8546403",
			"Saint Helena": "1",
			"Egypt": "310140608",
			"Nauru": "697",
			"Anguilla": "200000",
			"Estonia": "1606758",
			"Morocco": "7130",
			"Luxembourg": "7954",
			"TFYR of Macedonia": "211895",
			"Somalia": "52375814",
			"United Rep. of Tanzania": "3625931",
			"Finland": "3228439",
			"Belize": "709980",
			"Georgia": "23551105",
			"Ukraine": "6337000",
			"Bermuda": "1303156",
			"Djibouti": "88561190",
			"Greenland": "189",
			"China, Hong Kong SAR": "20000000",
			"Suriname": "105614",
			"Nigeria": "722615",
			"Samoa": "14096",
			"Venezuela": "99295262",
			"Kuwait": "3060",
			"Norway": "45203",
			"Sierra Leone": "118841",
			"Marshall Isds": "2655521",
			"Botswana": "185070",
			"Sao Tome and Principe": "815088",
			"Libya": "25",
			"Kyrgyzstan": "2243147",
			"Czechia": "106481",
			"Guatemala": "712346",
			"Aruba": "1154568",
			"Turkey": "158600",
			"Tunisia": "118852838",
			"Rep. of Korea": "343905",
			"Serbia": "37106",
			"Burundi": "75288",
			"Bhutan": "43321",
			"Canada": "119392",
			"Iceland": "36321"
		}
	},
	"Brunei Darussalam": {
		"imports": {},
		"exports": {}
	},
	"Mongolia": {
		"imports": {},
		"exports": {}
	},
	"Saudi Arabia": {
		"imports": {},
		"exports": {}
	},
	"Syria": {
		"imports": {},
		"exports": {}
	},
	"Russian Federation": {
		"imports": {
			"Lebanon": "677113",
			"Gibraltar": "9470",
			"Ghana": "46351997",
			"Lesotho": "1093",
			"Cuba": "23665665",
			"Dem. Rep. of the Congo": "55745",
			"Dem. People's Rep. of Korea": "2817360",
			"Cameroon": "1703827",
			"Papua New Guinea": "342",
			"Montserrat": "1316",
			"Panama": "10972",
			"Colombia": "5827137",
			"Niger": "1042",
			"Palau": "3573",
			"Tonga": "64",
			"Angola": "6077",
			"Fr. South Antarctic Terr.": "1106",
			"Uzbekistan": "87580442",
			"Iraq": "9",
			"Guam": "40",
			"Bosnia Herzegovina": "366479",
			"Pakistan": "17555935",
			"Belgium": "20322420",
			"Azerbaijan": "2048986",
			"Australia": "2126325",
			"United Kingdom": "3470568",
			"Singapore": "15960254",
			"Albania": "1771779",
			"Benin": "13884",
			"South Africa": "3311014",
			"Indonesia": "560815",
			"Qatar": "685",
			"American Samoa": "680",
			"Saint Vincent and the Grenadines": "57",
			"Curaçao": "2401532",
			"Armenia": "14656",
			"Kiribati": "14",
			"Mexico": "1478",
			"Br. Virgin Isds": "95",
			"Spain": "108328819",
			"Tajikistan": "171319",
			"Ireland": "19808",
			"Botswana": "1419",
			"South Sudan": "345",
			"French Polynesia": "700",
			"Mauritania": "7462674",
			"Christmas Isds": "13",
			"Honduras": "155492",
			"Saint Barthélemy": "1271",
			"Holy See (Vatican City State)": "112",
			"Chile": "9631918",
			"Gambia": "8",
			"Liberia": "219844",
			"Dominica": "1067",
			"Malaysia": "176025",
			"Fiji": "9021",
			"Peru": "11182922",
			"Falkland Isds (Malvinas)": "44569",
			"Nepal": "215266",
			"China": "243275906",
			"Comoros": "663857",
			"Guinea-Bissau": "16",
			"Saint Maarten": "50",
			"Mali": "2117",
			"Trinidad and Tobago": "273032",
			"Israel": "1596196",
			"Burkina Faso": "772",
			"Paraguay": "261161493",
			"Bangladesh": "29680",
			"Antigua and Barbuda": "302",
			"Gabon": "47996",
			"Cyprus": "38950000",
			"Yemen": "171986",
			"Mauritius": "649464",
			"Slovakia": "5408302",
			"Faeroe Isds": "55773",
			"Turkmenistan": "65474",
			"Bahrain": "292549",
			"Côte d'Ivoire": "1467",
			"Guyana": "14860",
			"Algeria": "163540",
			"USA": "38185710",
			"Namibia": "985426",
			"Rep. of Moldova": "130897",
			"Zambia": "5715",
			"Malta": "5354",
			"Ecuador": "306937",
			"Grenada": "5340",
			"Dominican Rep.": "1",
			"France": "26663481",
			"New Caledonia": "368",
			"Niue": "22",
			"Seychelles": "387099",
			"Italy": "127600475",
			"Saint Lucia": "70858",
			"State of Palestine": "11957",
			"Rwanda": "896464",
			"Syria": "172721",
			"Belarus": "623586220",
			"Ethiopia": "10971808",
			"Congo": "54662",
			"Senegal": "5648938",
			"Bulgaria": "955544",
			"Montenegro": "1452252",
			"Sri Lanka": "219601",
			"Hungary": "252060",
			"Jordan": "237667",
			"N. Mariana Isds": "3279",
			"Lao People's Dem. Rep.": "205558",
			"Myanmar": "1164514",
			"Iran": "523956",
			"Sao Tome and Principe": "228",
			"Uruguay": "17497702",
			"Switzerland": "42527",
			"Cabo Verde": "363",
			"Germany": "396494870",
			"Timor-Leste": "11665",
			"Poland": "98512205",
			"Bouvet Island": "4",
			"Thailand": "9921608",
			"Argentina": "7400",
			"Brazil": "18366332",
			"Brunei Darussalam": "8",
			"Mongolia": "474136",
			"Saudi Arabia": "77400",
			"Sudan": "27333",
			"Cayman Isds": "619",
			"United Arab Emirates": "102000",
			"Nicaragua": "86439",
			"Malawi": "1025",
			"Andorra": "279715",
			"El Salvador": "165728",
			"United States Minor Outlying Islands": "12153",
			"Sierra Leone": "28354",
			"Latvia": "2035344",
			"Japan": "149948874",
			"Guinea": "1984",
			"Uganda": "1444",
			"Romania": "37014641",
			"Slovenia": "2554876",
			"China, Macao SAR": "9865",
			"Mozambique": "577507",
			"Madagascar": "5240692",
			"Bolivia (Plurinational State of)": "1371",
			"Barbados": "9843",
			"Saint Kitts and Nevis": "28768",
			"Bahamas": "384",
			"San Marino": "1268",
			"Chad": "4470",
			"Viet Nam": "28826701",
			"Haiti": "6229",
			"Tokelau": "31",
			"Oman": "1046624",
			"Sweden": "149078565",
			"Maldives": "2062",
			"India": "4128276",
			"Jamaica": "269850",
			"Austria": "8619026",
			"Eritrea": "49404",
			"Zimbabwe": "2359947",
			"Vanuatu": "24843",
			"Swaziland": "27072",
			"Lithuania": "4824739",
			"Cambodia": "5545",
			"Denmark": "16140191",
			"Portugal": "5437602",
			"Central African Rep.": "196",
			"Netherlands": "287542154",
			"Costa Rica": "12557",
			"Greece": "8794740",
			"Kazakhstan": "9462988",
			"Kenya": "348508",
			"Afghanistan": "404",
			"Croatia": "1329",
			"Saint Helena": "552",
			"Egypt": "65845",
			"Nauru": "123",
			"Estonia": "31655659",
			"Morocco": "12318514",
			"Luxembourg": "2401",
			"TFYR of Macedonia": "1320437",
			"Somalia": "2953",
			"Western Sahara": "56348",
			"United Rep. of Tanzania": "445",
			"Finland": "92075657",
			"Belize": "38",
			"Georgia": "93286",
			"Ukraine": "1079198",
			"Bermuda": "46705",
			"Djibouti": "62",
			"Greenland": "183",
			"China, Hong Kong SAR": "47289",
			"Suriname": "44915",
			"Nigeria": "14759",
			"Venezuela": "7989",
			"Kuwait": "592",
			"New Zealand": "2916",
			"Norway": "145223897",
			"Pitcairn": "98",
			"Marshall Isds": "402",
			"Philippines": "2583392",
			"Libya": "32",
			"Kyrgyzstan": "29426",
			"Czechia": "10353701",
			"Br. Indian Ocean Terr.": "518",
			"Guatemala": "465630",
			"Togo": "4514",
			"Turkey": "43863",
			"Tunisia": "1636",
			"Rep. of Korea": "522394374",
			"Serbia": "2748599",
			"Burundi": "1181010",
			"Cook Isds": "13",
			"Canada": "8050963",
			"Iceland": "707149"
		},
		"exports": {
			"Lebanon": "1831566",
			"Bonaire": "45718389",
			"Gibraltar": "193285931",
			"Ghana": "28500",
			"Lesotho": "46799",
			"Cuba": "63564298",
			"Dem. Rep. of the Congo": "354702",
			"Dem. People's Rep. of Korea": "91987",
			"Cameroon": "72450",
			"Papua New Guinea": "1330",
			"Panama": "260271",
			"Colombia": "78526",
			"Niger": "29373",
			"Palau": "1080",
			"Jordan": "1818851",
			"Uzbekistan": "2750728",
			"Iraq": "320000",
			"Guam": "12515",
			"Bosnia Herzegovina": "722056",
			"Pakistan": "1049319",
			"Belgium": "8479743",
			"Azerbaijan": "33538299",
			"Australia": "4461",
			"United Kingdom": "81047",
			"Singapore": "547780",
			"Albania": "6769853",
			"Benin": "706403",
			"South Africa": "141323",
			"Indonesia": "35000",
			"Qatar": "3618",
			"Saint Vincent and the Grenadines": "610575",
			"Curaçao": "929",
			"Armenia": "32778208",
			"Jamaica": "2016",
			"Kenya": "121028",
			"Spain": "51079",
			"Tajikistan": "110751",
			"Ireland": "170",
			"Botswana": "118",
			"South Sudan": "100",
			"French Polynesia": "128",
			"Mauritania": "816",
			"Honduras": "580150",
			"Holy See (Vatican City State)": "58",
			"Chile": "298070",
			"Gambia": "2985542",
			"China, Macao SAR": "34672",
			"Dominica": "398531",
			"Malaysia": "1460",
			"Fiji": "1228553",
			"Peru": "421180",
			"Falkland Isds (Malvinas)": "15094",
			"Nepal": "41950",
			"China": "139703522",
			"Guinea-Bissau": "64620",
			"Mali": "75678",
			"Trinidad and Tobago": "1500",
			"Israel": "12243",
			"Burkina Faso": "34679",
			"Kazakhstan": "155976737",
			"Paraguay": "690375",
			"Bangladesh": "4649004",
			"Antigua and Barbuda": "6027",
			"Gabon": "94",
			"Cyprus": "53890632",
			"Yemen": "1327292",
			"Mauritius": "1701890",
			"Slovakia": "894341",
			"Faeroe Isds": "38947108",
			"Turkmenistan": "267346",
			"Bahrain": "3300",
			"Côte d'Ivoire": "3273",
			"Guyana": "60333",
			"Algeria": "84202867",
			"USA": "2676988",
			"Namibia": "3638565",
			"Rep. of Moldova": "3119860",
			"Zambia": "11645",
			"Malta": "1323198",
			"Ecuador": "53163",
			"Dominican Rep.": "2144141",
			"France": "1139718",
			"New Caledonia": "280982",
			"Seychelles": "3087160",
			"Br. Virgin Isds": "36845",
			"Italy": "2221687",
			"Saint Lucia": "9176",
			"State of Palestine": "966738",
			"Rwanda": "551669",
			"Syria": "251993",
			"Belarus": "43532806",
			"Ethiopia": "7855620",
			"Congo": "240288",
			"Senegal": "4000",
			"Bulgaria": "16286746",
			"Montenegro": "45357",
			"Sri Lanka": "925",
			"Hungary": "184970",
			"Angola": "35170694",
			"New Zealand": "14129",
			"N. Mariana Isds": "11940",
			"Lao People's Dem. Rep.": "1793748",
			"Myanmar": "4478033",
			"Iran": "142146214",
			"Sao Tome and Principe": "6412",
			"Uruguay": "436",
			"Andorra": "62",
			"Cabo Verde": "897500",
			"Germany": "7234285",
			"Poland": "4104429",
			"Thailand": "517",
			"Argentina": "668448",
			"Brazil": "600771",
			"Brunei Darussalam": "49308",
			"Mongolia": "1875925",
			"Saudi Arabia": "25865",
			"Greece": "750000",
			"Cayman Isds": "9055543",
			"United Arab Emirates": "65496",
			"Nicaragua": "2756697",
			"Malawi": "9896831",
			"Switzerland": "78088",
			"El Salvador": "5586441",
			"Latvia": "7206556",
			"Japan": "191340137",
			"Guinea": "496805",
			"Uganda": "883820",
			"Romania": "1263812",
			"Croatia": "514392",
			"Liberia": "441040",
			"Mozambique": "83117",
			"Madagascar": "726750",
			"Bolivia (Plurinational State of)": "887795",
			"Barbados": "29",
			"Bahamas": "4710",
			"San Marino": "3553",
			"Chad": "283",
			"Viet Nam": "73230099",
			"Haiti": "31043",
			"Oman": "2708",
			"Sweden": "114466",
			"Maldives": "119308",
			"India": "3785501",
			"Mexico": "5138280",
			"Austria": "55744",
			"Zimbabwe": "29783",
			"Saint Maarten": "16201",
			"Lithuania": "16661312",
			"Cambodia": "320231",
			"Denmark": "242799",
			"Portugal": "36018000",
			"Central African Rep.": "23",
			"Netherlands": "21036806",
			"Costa Rica": "305",
			"Equatorial Guinea": "2683",
			"Sudan": "44948",
			"Slovenia": "80763",
			"Afghanistan": "164805",
			"Egypt": "4100",
			"Estonia": "32123360",
			"Morocco": "435419",
			"Luxembourg": "737",
			"TFYR of Macedonia": "131129",
			"Somalia": "237",
			"Western Sahara": "92",
			"United Rep. of Tanzania": "97535",
			"Finland": "1574964",
			"Belize": "39",
			"Georgia": "13024448",
			"Ukraine": "718585",
			"Bermuda": "66",
			"Djibouti": "7107377",
			"Greenland": "12064",
			"China, Hong Kong SAR": "185601",
			"Suriname": "1688853",
			"Nigeria": "53964",
			"Venezuela": "694323",
			"Kuwait": "59000",
			"Norway": "13349433",
			"Sierra Leone": "340136",
			"Marshall Isds": "324981",
			"Philippines": "192428",
			"Libya": "121498",
			"Kyrgyzstan": "6739107",
			"Czechia": "844813",
			"Guatemala": "145022",
			"Togo": "79895",
			"Aruba": "74130",
			"Turkey": "19742",
			"Tunisia": "17238",
			"Rep. of Korea": "22518048",
			"Serbia": "86197008",
			"Burundi": "6332744",
			"Bhutan": "329",
			"Cook Isds": "1312",
			"Canada": "33840",
			"Iceland": "650263"
		}
	},
	"Cayman Isds": {
		"imports": {},
		"exports": {}
	},
	"United Arab Emirates": {
		"imports": {},
		"exports": {}
	},
	"Nicaragua": {
		"imports": {},
		"exports": {}
	},
	"Libya": {
		"imports": {},
		"exports": {}
	},
	"Malawi": {
		"imports": {},
		"exports": {}
	},
	"Switzerland": {
		"imports": {
			"Lebanon": "1589",
			"Gibraltar": "415",
			"Ghana": "74270329",
			"Lesotho": "14370",
			"Qatar": "59612",
			"Dem. Rep. of the Congo": "8768",
			"Dem. People's Rep. of Korea": "37831",
			"Cameroon": "69996",
			"South Africa": "100387",
			"Indonesia": "6708917",
			"Colombia": "3592",
			"Niger": "309284",
			"Jordan": "856",
			"Uzbekistan": "1784",
			"Iraq": "40699904",
			"Guam": "29927",
			"Bosnia Herzegovina": "6744",
			"Pakistan": "2670699",
			"Belgium": "1166665",
			"Azerbaijan": "10378",
			"Rwanda": "993",
			"Armenia": "125279",
			"United Kingdom": "27589728",
			"Singapore": "18377",
			"Albania": "163",
			"Benin": "17825",
			"Panama": "2071",
			"Cuba": "13415",
			"Saint Vincent and the Grenadines": "4311025",
			"Curaçao": "1451",
			"Australia": "417310",
			"Bahrain": "295509",
			"Mexico": "14928106",
			"Kenya": "16289665",
			"Spain": "3724892",
			"Tajikistan": "15939",
			"Ireland": "72331",
			"Botswana": "88230",
			"Côte d'Ivoire": "4828157",
			"French Polynesia": "36265",
			"Mauritania": "121",
			"Honduras": "18018965",
			"Saint Barthélemy": "3673",
			"Holy See (Vatican City State)": "1404",
			"Chile": "141207",
			"China, Macao SAR": "163",
			"Malaysia": "3124",
			"Swaziland": "137347",
			"Portugal": "68",
			"Saint Kitts and Nevis": "36454",
			"Nepal": "367376",
			"China": "62473887",
			"Comoros": "7496",
			"Mali": "733",
			"Trinidad and Tobago": "259852",
			"Israel": "103236",
			"Burkina Faso": "14939",
			"Paraguay": "10423",
			"Bangladesh": "545526",
			"Antigua and Barbuda": "437",
			"Gabon": "1378212",
			"Cyprus": "868221",
			"Yemen": "9430",
			"Mauritius": "104743",
			"Slovakia": "118683",
			"Faeroe Isds": "3792515",
			"Turkmenistan": "181",
			"Syria": "116196",
			"South Sudan": "157712",
			"Guyana": "41329",
			"Algeria": "664200",
			"USA": "100015355",
			"Namibia": "34665",
			"Rep. of Moldova": "39497",
			"Zambia": "225",
			"Malta": "1022",
			"Ecuador": "7493260",
			"Grenada": "54211",
			"Dominican Rep.": "162",
			"France": "35798007",
			"Seychelles": "18972",
			"Br. Virgin Isds": "8512798",
			"Italy": "75279260",
			"Saint Lucia": "15217",
			"State of Palestine": "2534",
			"Uganda": "855",
			"Belarus": "34703",
			"Ethiopia": "185152",
			"Congo": "11288",
			"Senegal": "176",
			"Bulgaria": "6552814",
			"Montenegro": "11050",
			"Sri Lanka": "54156",
			"Hungary": "1912159",
			"Angola": "921",
			"New Zealand": "22874",
			"Samoa": "13787",
			"Myanmar": "72365",
			"Iran": "2218",
			"Sao Tome and Principe": "323723",
			"Lao People's Dem. Rep.": "91378",
			"Uruguay": "23453166",
			"Germany": "205742271",
			"Poland": "438183",
			"Thailand": "15420129",
			"Argentina": "99187",
			"Brazil": "95875",
			"Brunei Darussalam": "3247",
			"Mongolia": "651",
			"Saudi Arabia": "5021",
			"Greece": "196314",
			"Russian Federation": "80159545",
			"Cayman Isds": "16329",
			"United Arab Emirates": "856458",
			"Nicaragua": "346",
			"Malawi": "5039",
			"Andorra": "18105",
			"El Salvador": "4738",
			"Latvia": "176950",
			"Japan": "7926002",
			"Guinea": "12148",
			"Romania": "13910",
			"Slovenia": "3118802",
			"Liberia": "476",
			"Mozambique": "1301",
			"Madagascar": "13706863",
			"Bolivia (Plurinational State of)": "272408",
			"Nigeria": "327291136",
			"Bahamas": "70032",
			"Tunisia": "109328",
			"Chad": "8777",
			"Viet Nam": "3067926",
			"Haiti": "4721",
			"Oman": "224",
			"Sweden": "4663264",
			"Maldives": "6670094",
			"India": "2517465",
			"Jamaica": "1924948",
			"Austria": "37986652",
			"Eritrea": "4148",
			"Zimbabwe": "963262",
			"Saint Maarten": "125471",
			"Fiji": "8043",
			"Lithuania": "87127",
			"Cambodia": "5609835",
			"Denmark": "2943444",
			"Peru": "27006",
			"Central African Rep.": "314",
			"Netherlands": "126769540",
			"Costa Rica": "2210790",
			"Equatorial Guinea": "913",
			"Sudan": "346807",
			"Papua New Guinea": "118135",
			"Kazakhstan": "2765",
			"Afghanistan": "1077",
			"Croatia": "27570",
			"Egypt": "30185",
			"Estonia": "17910",
			"Morocco": "3227011",
			"Luxembourg": "143555",
			"TFYR of Macedonia": "1175",
			"Somalia": "8159",
			"Western Sahara": "785864",
			"United Rep. of Tanzania": "1786",
			"Finland": "3876558",
			"Belize": "49432",
			"Georgia": "1202864",
			"Ukraine": "54196",
			"Bermuda": "31864",
			"Djibouti": "724",
			"Greenland": "29741",
			"China, Hong Kong SAR": "176510",
			"Suriname": "182942",
			"Barbados": "116164",
			"Venezuela": "378543",
			"Kuwait": "12262",
			"Norway": "397116",
			"Sierra Leone": "13033",
			"Marshall Isds": "4087",
			"Philippines": "250734",
			"Libya": "21623767",
			"Kyrgyzstan": "111186",
			"Czechia": "2787387",
			"Guatemala": "39929580",
			"Togo": "23107",
			"Aruba": "7980",
			"Turkey": "814932",
			"San Marino": "33938508",
			"Rep. of Korea": "26886",
			"Serbia": "60600",
			"Burundi": "359",
			"Bhutan": "3887",
			"Canada": "523745",
			"Iceland": "1359016"
		},
		"exports": {
			"Lebanon": "32757",
			"Bonaire": "4600",
			"Gibraltar": "51",
			"Ghana": "537400",
			"Lesotho": "920",
			"Qatar": "26937",
			"Dem. Rep. of the Congo": "6032",
			"Dem. People's Rep. of Korea": "160682",
			"Cameroon": "9340",
			"South Africa": "1743921",
			"Montserrat": "44060",
			"Indonesia": "449679",
			"Colombia": "2508",
			"Niger": "1814",
			"Palau": "87395",
			"Tonga": "14115",
			"Jordan": "41509",
			"Fr. South Antarctic Terr.": "1166",
			"Uzbekistan": "94",
			"Iraq": "452340",
			"Tuvalu": "20",
			"Guam": "126168",
			"Bosnia Herzegovina": "56823",
			"Pakistan": "6143",
			"Belgium": "1875364",
			"Azerbaijan": "7780",
			"Rwanda": "359111",
			"Armenia": "13756",
			"United Kingdom": "1897546",
			"Singapore": "21477",
			"Albania": "59323",
			"Benin": "9277",
			"FS Micronesia": "7878",
			"Panama": "15122",
			"Cuba": "1826",
			"American Samoa": "27646",
			"Saint Vincent and the Grenadines": "19511844",
			"Curaçao": "8086",
			"Australia": "905020",
			"Kiribati": "5",
			"Bahrain": "17062",
			"Mexico": "287146",
			"Kenya": "1285",
			"Spain": "2753873",
			"Tajikistan": "920",
			"Ireland": "227165",
			"Botswana": "1185",
			"South Sudan": "405624",
			"French Polynesia": "1431",
			"Mauritania": "315",
			"Christmas Isds": "134",
			"Honduras": "119",
			"Saint Barthélemy": "1466",
			"Cambodia": "22223",
			"Holy See (Vatican City State)": "7925",
			"Chile": "58771",
			"Sudan": "307",
			"Gambia": "275421",
			"China, Macao SAR": "53",
			"Brunei Darussalam": "7296",
			"Malaysia": "170",
			"Swaziland": "1544",
			"Portugal": "580744",
			"Falkland Isds (Malvinas)": "328",
			"Nepal": "1888247",
			"China": "4461469",
			"Comoros": "920",
			"Guinea-Bissau": "8077",
			"Saint Maarten": "56158",
			"Mali": "10",
			"Trinidad and Tobago": "642",
			"Israel": "83595",
			"Burkina Faso": "74009",
			"Paraguay": "7377",
			"Bangladesh": "2993",
			"Antigua and Barbuda": "51",
			"Gabon": "5109",
			"Cyprus": "74039",
			"Yemen": "61097",
			"Mauritius": "3932",
			"Slovakia": "106434",
			"Faeroe Isds": "6171",
			"Turkmenistan": "6008",
			"Syria": "3894",
			"Côte d'Ivoire": "445303",
			"Guyana": "261",
			"Algeria": "30153",
			"USA": "6951452",
			"Saint Kitts and Nevis": "26046",
			"Rep. of Moldova": "4087",
			"Zambia": "1430",
			"Malta": "246",
			"Ecuador": "4694",
			"Grenada": "128",
			"Dominican Rep.": "17012",
			"France": "14577952",
			"New Caledonia": "5505",
			"Niue": "19734",
			"Seychelles": "44492",
			"Br. Virgin Isds": "167208",
			"Italy": "143302910",
			"Saint Lucia": "402",
			"State of Palestine": "11638",
			"Uganda": "102",
			"Belarus": "67958",
			"Ethiopia": "199750",
			"Pitcairn": "6086",
			"Senegal": "211401",
			"Bulgaria": "154683",
			"Montenegro": "1595",
			"Sri Lanka": "1139",
			"Hungary": "196958",
			"Angola": "756",
			"New Zealand": "620401",
			"N. Mariana Isds": "1001",
			"Samoa": "20435",
			"Myanmar": "932848",
			"Iran": "97208",
			"Sao Tome and Principe": "36802",
			"Lao People's Dem. Rep.": "3065",
			"Uruguay": "1738",
			"Cabo Verde": "31904",
			"Germany": "64584245",
			"Timor-Leste": "114769",
			"Poland": "902",
			"Thailand": "235001",
			"Argentina": "94816",
			"Brazil": "1430",
			"Dominica": "8375",
			"Mongolia": "318693",
			"Saudi Arabia": "4628",
			"South Georgia and the South Sandwich Islands": "2380",
			"Russian Federation": "174",
			"Cayman Isds": "87",
			"United Arab Emirates": "420375",
			"Nicaragua": "2554",
			"Malawi": "105560",
			"Andorra": "76419",
			"El Salvador": "2419",
			"United States Minor Outlying Islands": "123",
			"Latvia": "32993",
			"Japan": "15192",
			"Guinea": "40333",
			"Romania": "82257",
			"Slovenia": "281076",
			"Liberia": "736",
			"Mozambique": "204",
			"Madagascar": "38741",
			"Bolivia (Plurinational State of)": "18391",
			"Nigeria": "368",
			"Bahamas": "187",
			"Tunisia": "766",
			"Chad": "237070",
			"Viet Nam": "45490",
			"Haiti": "82",
			"Oman": "5981",
			"Sweden": "588639",
			"Maldives": "478",
			"India": "26689",
			"Jamaica": "126722",
			"Austria": "9165963",
			"Eritrea": "32575",
			"Congo": "10769",
			"Zimbabwe": "4087",
			"Vanuatu": "40252",
			"Fiji": "670195",
			"Lithuania": "1619",
			"Namibia": "362",
			"Denmark": "457593",
			"Peru": "12772",
			"Central African Rep.": "21490",
			"Netherlands": "1354",
			"Costa Rica": "9921",
			"Equatorial Guinea": "21753",
			"Greece": "58746",
			"Papua New Guinea": "20531",
			"Kazakhstan": "495",
			"Afghanistan": "2759",
			"Croatia": "39781",
			"Egypt": "1052",
			"Anguilla": "79593",
			"Estonia": "4240",
			"Morocco": "10604",
			"Luxembourg": "22438",
			"TFYR of Macedonia": "65580",
			"Somalia": "715",
			"United Rep. of Tanzania": "66883",
			"Finland": "646616",
			"Belize": "919473",
			"Georgia": "16923",
			"Ukraine": "233684",
			"Bermuda": "409",
			"Djibouti": "146109",
			"Greenland": "4332",
			"China, Hong Kong SAR": "241557",
			"Suriname": "664",
			"Barbados": "9380",
			"Venezuela": "5882",
			"Kuwait": "113922",
			"Norway": "1599165",
			"Sierra Leone": "4097",
			"Marshall Isds": "460964",
			"Philippines": "91971",
			"Libya": "12603",
			"Kyrgyzstan": "561",
			"Czechia": "927932",
			"Br. Indian Ocean Terr.": "38009",
			"Guatemala": "967",
			"Togo": "59504",
			"Aruba": "45996",
			"Turkey": "359379",
			"San Marino": "14304",
			"Rep. of Korea": "429",
			"Serbia": "694074",
			"Burundi": "409",
			"Bhutan": "277284",
			"Cook Isds": "4496",
			"Canada": "77467",
			"Iceland": "217698"
		}
	},
	"El Salvador": {
		"imports": {
			"Lebanon": "12127",
			"Iran": "1105",
			"Uruguay": "4925",
			"Andorra": "10040",
			"Cabo Verde": "193",
			"United Kingdom": "7124",
			"Poland": "45757",
			"Qatar": "450931",
			"Bolivia (Plurinational State of)": "16",
			"Thailand": "1779672",
			"Dem. People's Rep. of Korea": "28299",
			"Argentina": "669241",
			"Brazil": "656833",
			"Germany": "220272",
			"Cameroon": "390160",
			"Dominica": "19120",
			"Papua New Guinea": "538921",
			"Barbados": "1425",
			"Saudi Arabia": "4671",
			"Indonesia": "145291",
			"Colombia": "3158",
			"Greece": "32399",
			"Russian Federation": "1941",
			"Cayman Isds": "174",
			"United Arab Emirates": "15027",
			"Nicaragua": "2810",
			"Jordan": "18166",
			"Switzerland": "798168",
			"Uzbekistan": "273",
			"Latvia": "21658",
			"Japan": "1278880",
			"Guam": "43",
			"Romania": "23330",
			"Pakistan": "1088",
			"Belgium": "135",
			"Slovenia": "6363",
			"Belarus": "24342",
			"Madagascar": "196",
			"Singapore": "58088",
			"Nigeria": "427155",
			"Albania": "347",
			"Bahamas": "168",
			"Tunisia": "6055",
			"Viet Nam": "371521",
			"Haiti": "463",
			"South Africa": "46270",
			"Tokelau": "159",
			"Panama": "4313850",
			"Cuba": "13298",
			"Saint Vincent and the Grenadines": "201",
			"Oman": "774",
			"Sweden": "6639827",
			"Australia": "3924861",
			"India": "2262284",
			"Mexico": "38939",
			"Jamaica": "40146",
			"Kenya": "294",
			"Spain": "6021",
			"Bosnia Herzegovina": "69",
			"Ireland": "3143480",
			"Zimbabwe": "95217",
			"Austria": "174696",
			"Peru": "213513",
			"Fiji": "7445",
			"Lithuania": "80",
			"Cambodia": "94189",
			"Denmark": "5860",
			"Somalia": "19",
			"Central African Rep.": "861",
			"Honduras": "724",
			"Netherlands": "1250500",
			"Costa Rica": "1046",
			"Bulgaria": "401",
			"Sudan": "60",
			"Chile": "17945205",
			"Croatia": "15",
			"Gambia": "950",
			"China, Macao SAR": "65944",
			"Afghanistan": "270",
			"Curaçao": "440",
			"Brunei Darussalam": "21945",
			"Malaysia": "1320",
			"Swaziland": "65840",
			"Portugal": "41713",
			"Nepal": "359879",
			"China": "26304540",
			"Egypt": "20325",
			"Estonia": "300",
			"Morocco": "695404",
			"Luxembourg": "31841",
			"Trinidad and Tobago": "386",
			"Israel": "713893",
			"Venezuela": "101306",
			"Paraguay": "66137",
			"Bangladesh": "242405",
			"Finland": "469910",
			"Cyprus": "52171",
			"Belize": "99",
			"Georgia": "180",
			"Slovakia": "10925",
			"Bermuda": "58",
			"Mali": "148793",
			"Turkmenistan": "5250",
			"Bahrain": "435",
			"China, Hong Kong SAR": "940",
			"Guyana": "5667",
			"Algeria": "160",
			"USA": "12002636",
			"Rep. of Moldova": "365",
			"Norway": "43238",
			"Ecuador": "1591476",
			"Serbia": "1471",
			"Pitcairn": "7025",
			"Dominican Rep.": "1835951",
			"France": "31317",
			"Philippines": "1040",
			"Seychelles": "8",
			"Br. Virgin Isds": "70",
			"Italy": "147526",
			"Kyrgyzstan": "481",
			"Czechia": "662",
			"Rwanda": "192",
			"Guatemala": "1799",
			"Ethiopia": "1171267",
			"Senegal": "6",
			"Aruba": "2673792",
			"Turkey": "346359",
			"Sri Lanka": "105",
			"Rep. of Korea": "1700",
			"Hungary": "8530",
			"New Zealand": "106225",
			"Canada": "22073",
			"Iceland": "167",
			"Lao People's Dem. Rep.": "33617",
			"Ukraine": "67324",
			"Myanmar": "2115"
		},
		"exports": {
			"Lebanon": "115913",
			"Iran": "2941",
			"Lesotho": "4793",
			"Cabo Verde": "21870",
			"Togo": "456",
			"Barbados": "92028",
			"Poland": "9000",
			"Qatar": "2000",
			"Bolivia (Plurinational State of)": "40088",
			"Thailand": "10155",
			"Dem. People's Rep. of Korea": "9029",
			"Argentina": "11704",
			"Brazil": "1837242",
			"Germany": "1609",
			"Dominica": "9285",
			"South Africa": "862861",
			"Mongolia": "353",
			"Saudi Arabia": "9238",
			"Panama": "78569",
			"Colombia": "16500",
			"Syria": "26074",
			"Russian Federation": "18270",
			"Cayman Isds": "2169",
			"United Arab Emirates": "27949",
			"Nicaragua": "2318438",
			"Belize": "6349",
			"Jordan": "2507377",
			"Malawi": "1782",
			"Switzerland": "13260",
			"Uruguay": "51065",
			"Ukraine": "112666",
			"Japan": "197613",
			"Romania": "2484",
			"Pakistan": "68000",
			"Belgium": "348",
			"Slovenia": "5925",
			"Liberia": "540",
			"United Kingdom": "15798758",
			"Singapore": "216268",
			"Nigeria": "1236",
			"Bahamas": "140674",
			"Tunisia": "46132",
			"Viet Nam": "325442",
			"Haiti": "658044",
			"Indonesia": "22817575",
			"Cuba": "556",
			"Saint Vincent and the Grenadines": "145476",
			"Oman": "41626",
			"Sweden": "96938",
			"Australia": "1232054",
			"India": "1039824",
			"Mexico": "209092",
			"Jamaica": "5458717",
			"Kenya": "1246",
			"Spain": "111706",
			"Gabon": "835",
			"Ireland": "3054",
			"Zimbabwe": "10350",
			"China, Hong Kong SAR": "50",
			"French Polynesia": "8290",
			"Fiji": "2427",
			"Lithuania": "79061",
			"Saint Kitts and Nevis": "5720",
			"Denmark": "148656",
			"Curaçao": "53083",
			"Honduras": "3478",
			"Netherlands": "123944",
			"Costa Rica": "1745",
			"Austria": "5046",
			"Bulgaria": "272",
			"Greece": "324664",
			"Chile": "466491",
			"Gambia": "113626",
			"China, Macao SAR": "17600",
			"Malaysia": "1028854",
			"Swaziland": "1000",
			"Peru": "16930",
			"Nepal": "711",
			"China": "36720",
			"Egypt": "8332",
			"Guinea-Bissau": "22524",
			"Morocco": "203278",
			"Mali": "791",
			"Trinidad and Tobago": "255096",
			"Israel": "13584",
			"TFYR of Macedonia": "3780",
			"Paraguay": "684",
			"Bangladesh": "9133",
			"United Rep. of Tanzania": "1510",
			"Finland": "1220412",
			"Cyprus": "5135",
			"Kuwait": "25210",
			"Georgia": "800",
			"Slovakia": "4617",
			"Bermuda": "1210",
			"Luxembourg": "15391",
			"Côte d'Ivoire": "3740087",
			"Ghana": "10866",
			"Guyana": "1708684",
			"Suriname": "3982",
			"Algeria": "178225",
			"USA": "71660877",
			"Venezuela": "7937",
			"Zambia": "925",
			"Malta": "7148",
			"Norway": "759625",
			"Ecuador": "249568",
			"Grenada": "23107",
			"Portugal": "20170",
			"France": "3215",
			"Philippines": "2000",
			"Seychelles": "4450",
			"Br. Virgin Isds": "5018",
			"Italy": "23024139",
			"Saint Lucia": "107698",
			"Czechia": "22782",
			"Guatemala": "774",
			"Ethiopia": "2492",
			"Aruba": "8987",
			"Turkey": "24275",
			"Dominican Rep.": "64867",
			"Sri Lanka": "3065",
			"Rep. of Korea": "36614",
			"Hungary": "25000",
			"Angola": "22174",
			"New Zealand": "636214",
			"Canada": "1200",
			"Myanmar": "3905809"
		}
	},
	"United States Minor Outlying Islands": {
		"imports": {},
		"exports": {}
	},
	"Aruba": {
		"imports": {
			"Curaçao": "293802",
			"Venezuela": "8391",
			"USA": "32773",
			"Netherlands": "966",
			"Mexico": "456161",
			"United Kingdom": "1920",
			"Rep. of Korea": "175103",
			"Paraguay": "6737643",
			"Brazil": "670017",
			"China": "30146",
			"Panama": "58933",
			"China, Hong Kong SAR": "4099",
			"Colombia": "400868",
			"Japan": "8020937"
		},
		"exports": {
			"Curaçao": "6796",
			"Venezuela": "86371",
			"USA": "103",
			"Netherlands": "1315884",
			"Mexico": "1145311",
			"Suriname": "1143403",
			"Belgium": "24960",
			"China": "24498",
			"Canada": "80",
			"Panama": "1664",
			"Colombia": "279",
			"Paraguay": "8500"
		}
	},
	"Latvia": {
		"imports": {
			"Lebanon": "74",
			"Gibraltar": "48",
			"Ghana": "71835",
			"Switzerland": "453999",
			"Uruguay": "4522",
			"Marshall Isds": "49804",
			"Germany": "6889043",
			"Poland": "1588603",
			"Cuba": "126894",
			"Thailand": "1282",
			"Argentina": "320124",
			"Brazil": "1307219",
			"Azerbaijan": "1187770",
			"Dominica": "50",
			"Iran": "498",
			"Mongolia": "5267",
			"Belarus": "47710",
			"Panama": "11148",
			"Colombia": "23201",
			"Syria": "15544",
			"Russian Federation": "3952305",
			"United Arab Emirates": "175",
			"Nicaragua": "38311",
			"Tajikistan": "137216",
			"Jordan": "7763",
			"Andorra": "5702",
			"El Salvador": "2209",
			"Slovakia": "312108",
			"Iraq": "9251",
			"Japan": "2337202",
			"Tunisia": "93",
			"Guinea": "53894",
			"Uganda": "206779",
			"Bosnia Herzegovina": "418432",
			"Pakistan": "212306",
			"Belgium": "2803938",
			"Croatia": "343597",
			"Australia": "812",
			"Madagascar": "27",
			"Bolivia (Plurinational State of)": "148760",
			"Nigeria": "51",
			"Albania": "100598",
			"Benin": "111",
			"Maldives": "7",
			"San Marino": "1304",
			"Chad": "2421",
			"Viet Nam": "34",
			"Haiti": "44",
			"South Africa": "488189",
			"Indonesia": "78258",
			"Qatar": "55",
			"American Samoa": "2751",
			"Saint Vincent and the Grenadines": "122",
			"Uzbekistan": "153",
			"Curaçao": "251",
			"Armenia": "32157",
			"India": "3432",
			"Mexico": "6288",
			"Kenya": "2114",
			"Austria": "1762122",
			"Romania": "7509",
			"Ireland": "26610",
			"Sweden": "9160705",
			"Zimbabwe": "550",
			"Saint Maarten": "6",
			"Spain": "4924",
			"Mauritania": "238660",
			"Lithuania": "7282860",
			"Namibia": "2390",
			"Denmark": "351805",
			"Portugal": "86566",
			"Honduras": "360",
			"Netherlands": "186927",
			"United Kingdom": "12249230",
			"Costa Rica": "9",
			"Turkey": "1078",
			"Greece": "8451",
			"Chile": "16582",
			"Kazakhstan": "3719968",
			"China, Macao SAR": "155",
			"Afghanistan": "433",
			"South Sudan": "130",
			"Malaysia": "233109",
			"Swaziland": "202",
			"Peru": "1872",
			"Falkland Isds (Malvinas)": "3085",
			"Nepal": "947",
			"China": "1071771",
			"Comoros": "52682",
			"Anguilla": "1049",
			"Estonia": "2174807",
			"Morocco": "2755",
			"Luxembourg": "235",
			"Trinidad and Tobago": "248",
			"Israel": "434",
			"TFYR of Macedonia": "78296",
			"Burkina Faso": "417341",
			"Saudi Arabia": "467",
			"Singapore": "110887",
			"Paraguay": "26460",
			"Bangladesh": "477414",
			"Antigua and Barbuda": "218",
			"United Rep. of Tanzania": "112045",
			"Finland": "221221",
			"Cyprus": "896692",
			"Belize": "64325",
			"Georgia": "6",
			"Serbia": "304560",
			"Bermuda": "18974261",
			"Faeroe Isds": "339910",
			"Greenland": "639658",
			"Bahrain": "10141",
			"Zambia": "100",
			"Côte d'Ivoire": "263920",
			"Mauritius": "110186",
			"USA": "1286622",
			"Cambodia": "1878348",
			"Rep. of Moldova": "185703",
			"Kuwait": "1897",
			"Malta": "173073",
			"Norway": "680397",
			"Ecuador": "576",
			"Dominican Rep.": "2589",
			"France": "112134",
			"Philippines": "120396",
			"Canada": "1920",
			"Seychelles": "740029",
			"Italy": "1340933",
			"Kyrgyzstan": "85035",
			"Czechia": "325168",
			"Rwanda": "2286",
			"Egypt": "17925",
			"Guatemala": "89",
			"Ethiopia": "24",
			"Slovenia": "1583226",
			"Senegal": "59256",
			"Bulgaria": "25513",
			"Montenegro": "652",
			"Sri Lanka": "112",
			"Rep. of Korea": "1525",
			"Hungary": "133107",
			"New Zealand": "1787",
			"China, Hong Kong SAR": "65501",
			"Iceland": "1292",
			"Lao People's Dem. Rep.": "132219",
			"Ukraine": "20814",
			"Myanmar": "72131"
		},
		"exports": {
			"Lebanon": "11011",
			"Gibraltar": "43397139",
			"Ghana": "9",
			"Cuba": "1770",
			"Dem. Rep. of the Congo": "82325",
			"Cameroon": "131392",
			"Iran": "85231",
			"Panama": "553",
			"Colombia": "414649",
			"Niger": "219496",
			"Angola": "6625724",
			"Fr. South Antarctic Terr.": "2",
			"Uzbekistan": "299778",
			"Iraq": "38683",
			"Guam": "69",
			"Bosnia Herzegovina": "110100",
			"Pakistan": "45809",
			"Belgium": "160437",
			"Azerbaijan": "57175",
			"Australia": "4761",
			"Togo": "49690",
			"Singapore": "1040130",
			"Albania": "94542",
			"Benin": "8852",
			"South Africa": "205609",
			"Indonesia": "1929",
			"Qatar": "6098",
			"American Samoa": "758",
			"Saint Vincent and the Grenadines": "77",
			"Curaçao": "109264",
			"Armenia": "28770",
			"Jamaica": "4425",
			"Kenya": "23645143",
			"Spain": "1532348",
			"Tajikistan": "299264",
			"Ireland": "3110",
			"Botswana": "64437",
			"South Sudan": "4227",
			"French Polynesia": "319",
			"Mauritania": "4660719",
			"Honduras": "267818",
			"United Kingdom": "126789",
			"Jordan": "34137",
			"Chile": "1177681",
			"Gambia": "8017",
			"China, Macao SAR": "6298",
			"Dominica": "3440",
			"Malaysia": "15553",
			"Portugal": "7495852",
			"Falkland Isds (Malvinas)": "3183",
			"Nepal": "7622",
			"China": "190711",
			"Guinea-Bissau": "22923",
			"Mali": "1808",
			"Trinidad and Tobago": "17352",
			"Israel": "280701",
			"Burkina Faso": "340242",
			"Paraguay": "87382",
			"Bangladesh": "131038",
			"Antigua and Barbuda": "2556",
			"Gabon": "33228",
			"Cyprus": "130227",
			"Yemen": "1057",
			"Mauritius": "38614",
			"Slovakia": "325229",
			"Faeroe Isds": "804978",
			"Turkmenistan": "2844",
			"Bahrain": "136358",
			"Côte d'Ivoire": "3523",
			"Guyana": "7246",
			"Algeria": "59526958",
			"USA": "18811",
			"Saint Kitts and Nevis": "259",
			"Rep. of Moldova": "2681",
			"Zambia": "108",
			"Malta": "152745",
			"Ecuador": "250784",
			"Dominican Rep.": "204354",
			"France": "26929",
			"New Caledonia": "56",
			"Niue": "83",
			"Seychelles": "103",
			"Br. Virgin Isds": "435055",
			"Italy": "8028",
			"State of Palestine": "3513",
			"Rwanda": "513520",
			"Syria": "49710",
			"Belarus": "51955",
			"Ethiopia": "9979327",
			"Namibia": "59",
			"Congo": "147053",
			"Slovenia": "247646",
			"Bulgaria": "18744",
			"Montenegro": "10038",
			"Sri Lanka": "196233",
			"Hungary": "134",
			"New Zealand": "252321",
			"Lao People's Dem. Rep.": "4006",
			"Myanmar": "242999",
			"Papua New Guinea": "51791",
			"Philippines": "2820338",
			"Uruguay": "80376",
			"Cabo Verde": "1568",
			"Germany": "402568",
			"Poland": "14545928",
			"Thailand": "79456",
			"Argentina": "8445",
			"Brazil": "1988109",
			"Brunei Darussalam": "48",
			"Mongolia": "562927",
			"Saudi Arabia": "71150",
			"Greece": "112015",
			"Russian Federation": "257341",
			"Cayman Isds": "1028",
			"United Arab Emirates": "8078",
			"Nicaragua": "13669",
			"Malawi": "3043",
			"Switzerland": "1136202",
			"El Salvador": "55840",
			"Japan": "32",
			"Guinea": "63025",
			"Uganda": "6433412",
			"Romania": "257160",
			"Croatia": "20543",
			"Liberia": "22",
			"Mozambique": "52",
			"Madagascar": "664",
			"Bolivia (Plurinational State of)": "69712",
			"Barbados": "1648",
			"Bahamas": "101620",
			"San Marino": "10",
			"Chad": "1317",
			"Viet Nam": "36680",
			"Haiti": "7175",
			"Oman": "21024",
			"Sweden": "1361199",
			"Maldives": "22888",
			"India": "119852",
			"Mexico": "65285",
			"Austria": "5982",
			"Zimbabwe": "33487",
			"Saint Maarten": "60066",
			"Senegal": "93120",
			"Lithuania": "21275807",
			"Cambodia": "156476",
			"Denmark": "846669",
			"Peru": "13589",
			"Central African Rep.": "18596",
			"Netherlands": "17868",
			"Costa Rica": "450277",
			"Equatorial Guinea": "56739",
			"Sudan": "927",
			"Kazakhstan": "3053633",
			"Afghanistan": "48715",
			"Egypt": "60859",
			"Estonia": "2108137",
			"Morocco": "6992",
			"Luxembourg": "144182",
			"TFYR of Macedonia": "106028",
			"Somalia": "2337",
			"United Rep. of Tanzania": "285187",
			"Finland": "590071",
			"Belize": "9288",
			"Georgia": "197970",
			"Ukraine": "310781",
			"Bermuda": "2793974",
			"Djibouti": "9773510",
			"Greenland": "69840",
			"China, Hong Kong SAR": "12466",
			"Suriname": "22916",
			"Nigeria": "1129",
			"Vanuatu": "581",
			"Venezuela": "12398",
			"Kuwait": "34151",
			"Norway": "5605",
			"Sierra Leone": "214209",
			"Marshall Isds": "11",
			"Sao Tome and Principe": "31",
			"Libya": "114959",
			"Kyrgyzstan": "38476",
			"Czechia": "1493643",
			"Guatemala": "333383",
			"Turkey": "351825",
			"Tunisia": "61652",
			"Rep. of Korea": "502401",
			"Serbia": "60638",
			"Burundi": "26256",
			"Bhutan": "23",
			"Cook Isds": "100",
			"Canada": "498",
			"Iceland": "913"
		}
	},
	"Japan": {
		"imports": {
			"Lebanon": "212614",
			"Gibraltar": "151645",
			"Ghana": "14824673",
			"Lesotho": "92323",
			"Cuba": "4098838",
			"Dem. Rep. of the Congo": "254098",
			"Cameroon": "5667",
			"South Africa": "51809443",
			"Montserrat": "2282",
			"Indonesia": "247780884",
			"Colombia": "66857",
			"Niger": "32053",
			"Palau": "44446",
			"Tonga": "2823538",
			"Jordan": "77051",
			"Uzbekistan": "2502",
			"Iraq": "1078337235",
			"Tuvalu": "6900",
			"Guam": "65238",
			"Bosnia Herzegovina": "10415",
			"Pakistan": "95506",
			"Belgium": "2742",
			"Azerbaijan": "72147",
			"Armenia": "83638",
			"Togo": "7001",
			"Singapore": "20513408",
			"Albania": "2199",
			"Benin": "22237",
			"FS Micronesia": "5981040",
			"Panama": "303258673",
			"Qatar": "4703557869",
			"American Samoa": "983951",
			"Saint Vincent and the Grenadines": "4832629",
			"Curaçao": "24058",
			"Australia": "10012770529",
			"Kiribati": "54455",
			"Bahrain": "5529582",
			"Jamaica": "20079467",
			"Kenya": "5068896",
			"Spain": "754316",
			"Tajikistan": "3652",
			"Ireland": "834228",
			"Botswana": "14794",
			"South Sudan": "414603",
			"French Polynesia": "92056",
			"Mauritania": "111465983",
			"Honduras": "800887",
			"United Kingdom": "2960565",
			"Chile": "23914289",
			"China, Macao SAR": "9918",
			"Dominica": "9881",
			"Malaysia": "550575550",
			"Swaziland": "66452",
			"Somalia": "5693279",
			"Falkland Isds (Malvinas)": "337598",
			"Nepal": "4434",
			"China": "467239609",
			"Comoros": "7682",
			"Mali": "24343",
			"Trinidad and Tobago": "48724484",
			"Israel": "2694479",
			"Burkina Faso": "162869",
			"Paraguay": "1210503",
			"Bangladesh": "33505872",
			"Antigua and Barbuda": "2475",
			"Gabon": "28414546",
			"Cyprus": "2318",
			"Yemen": "821827",
			"Mauritius": "20461",
			"Slovakia": "11509040",
			"Turkmenistan": "31860",
			"Syria": "192116",
			"Côte d'Ivoire": "6063676",
			"Guyana": "30057",
			"Algeria": "49420021",
			"USA": "3310803049",
			"Cambodia": "24251",
			"Rep. of Moldova": "425348",
			"Zambia": "162419",
			"Malta": "120893997",
			"Ecuador": "7107684",
			"Grenada": "11574",
			"Dominican Rep.": "25907",
			"France": "199649162",
			"New Caledonia": "133512",
			"Niue": "13221",
			"Seychelles": "4858",
			"Oceania, nes": "7838",
			"Br. Virgin Isds": "3698",
			"Italy": "9735987",
			"Saint Lucia": "4940",
			"State of Palestine": "447024",
			"Rwanda": "8225",
			"Belarus": "21271",
			"Ethiopia": "6744",
			"Namibia": "2723",
			"Congo": "4646",
			"Slovenia": "7833011",
			"Bulgaria": "36083",
			"Montenegro": "3349",
			"Sri Lanka": "35926",
			"Hungary": "637199",
			"Angola": "16764937",
			"New Zealand": "58703446",
			"N. Mariana Isds": "36377",
			"Lao People's Dem. Rep.": "16860453",
			"Myanmar": "1865973",
			"Iran": "15520559",
			"Philippines": "32697",
			"Uruguay": "65707",
			"Andorra": "2732",
			"Cabo Verde": "54097",
			"Germany": "16465916",
			"Timor-Leste": "1969",
			"Poland": "2279444",
			"Thailand": "2951318",
			"Argentina": "78293",
			"Brazil": "43645",
			"Brunei Darussalam": "71756401",
			"Mongolia": "46000",
			"Saudi Arabia": "404493188",
			"Greece": "45301",
			"Russian Federation": "509992833",
			"Cayman Isds": "10948",
			"United Arab Emirates": "2438830938",
			"Nicaragua": "2558548",
			"Malawi": "308737",
			"Switzerland": "4722319",
			"El Salvador": "15791926",
			"Latvia": "136741",
			"Guinea": "56093",
			"Uganda": "94135",
			"Romania": "3532673",
			"Croatia": "37380",
			"Liberia": "175142",
			"Guatemala": "24800553",
			"Madagascar": "2576",
			"Bolivia (Plurinational State of)": "80068",
			"Nigeria": "727502839",
			"Bahamas": "26446065",
			"Tunisia": "205622",
			"Chad": "69587652",
			"Viet Nam": "9252485",
			"Haiti": "421052",
			"Tokelau": "1987",
			"Oman": "642228078",
			"Sweden": "649150",
			"Maldives": "3514273",
			"India": "61135",
			"Mexico": "14675871",
			"Austria": "44214457",
			"Eritrea": "5750",
			"Zimbabwe": "857707",
			"Vanuatu": "70734316",
			"Senegal": "4275590",
			"Peru": "2089407",
			"Fiji": "3680",
			"Lithuania": "1735544",
			"Saint Kitts and Nevis": "11427",
			"Denmark": "81954",
			"Portugal": "1746105",
			"Central African Rep.": "451716",
			"Netherlands": "91506357",
			"Costa Rica": "61815",
			"Equatorial Guinea": "118991425",
			"Sudan": "5069",
			"Papua New Guinea": "420159",
			"Kazakhstan": "142419894",
			"Afghanistan": "4591",
			"Saint Helena": "3823276",
			"Egypt": "23273447",
			"Nauru": "7590",
			"Anguilla": "3634",
			"Estonia": "657301",
			"Morocco": "1874888",
			"Luxembourg": "184591",
			"TFYR of Macedonia": "54345",
			"Western Sahara": "152685",
			"United Rep. of Tanzania": "568355",
			"Finland": "6647127",
			"Belize": "390038",
			"Georgia": "536384",
			"Ukraine": "10507",
			"Bermuda": "9936",
			"Djibouti": "319731",
			"Greenland": "18384247",
			"China, Hong Kong SAR": "130021876",
			"Suriname": "3351918",
			"Barbados": "3367",
			"Venezuela": "2999",
			"Kuwait": "3118103430",
			"Norway": "1865293",
			"Sierra Leone": "1923",
			"Marshall Isds": "6689494",
			"Sao Tome and Principe": "50251",
			"Libya": "11980094",
			"Kyrgyzstan": "133963",
			"Czechia": "9964",
			"Br. Indian Ocean Terr.": "18584",
			"Mozambique": "9649801",
			"Samoa": "592358",
			"Turkey": "27320571",
			"Rep. of Korea": "118998914",
			"Serbia": "3212822",
			"Burundi": "27103",
			"Bhutan": "195318",
			"Cook Isds": "192162",
			"Canada": "107156536",
			"Iceland": "1253008"
		},
		"exports": {
			"Lebanon": "200286",
			"Gibraltar": "45073397",
			"Ghana": "341179",
			"Lesotho": "2801561",
			"Cuba": "866843",
			"Dem. Rep. of the Congo": "11555325",
			"Cameroon": "1327618",
			"South Africa": "1911182",
			"Montserrat": "146308",
			"Indonesia": "2084985",
			"Colombia": "214816",
			"Niger": "619697",
			"Palau": "12219",
			"Tonga": "2109",
			"Jordan": "32468",
			"Uzbekistan": "58126801",
			"Iraq": "148748",
			"Tuvalu": "112717",
			"Guam": "197542",
			"Bosnia Herzegovina": "700996",
			"Pakistan": "10212",
			"Belgium": "26328501",
			"Azerbaijan": "74061",
			"Armenia": "1984267",
			"Togo": "3729",
			"Singapore": "21173087",
			"Albania": "2138227",
			"Benin": "10147",
			"FS Micronesia": "724817",
			"Panama": "10964864",
			"Qatar": "105755",
			"American Samoa": "839467",
			"Saint Vincent and the Grenadines": "3849",
			"Curaçao": "1642250",
			"Australia": "1077431486",
			"Kiribati": "13660752",
			"Bahrain": "81087874",
			"Jamaica": "158964149",
			"Kenya": "326658379",
			"Spain": "658657",
			"Tajikistan": "30286",
			"Ireland": "292155",
			"Botswana": "5665710",
			"South Sudan": "432238",
			"French Polynesia": "28637",
			"Mauritania": "2466377",
			"Honduras": "29300809",
			"United Kingdom": "81201235",
			"Chile": "24972",
			"Gambia": "703169",
			"China, Macao SAR": "196068",
			"Dominica": "230498",
			"Malaysia": "2385096",
			"Swaziland": "159742",
			"Somalia": "634126",
			"Falkland Isds (Malvinas)": "19374",
			"Nepal": "146483",
			"China": "491383377",
			"Comoros": "32311",
			"Guinea-Bissau": "316649",
			"Mali": "1061779",
			"Trinidad and Tobago": "53287",
			"Israel": "19521",
			"Burkina Faso": "6168345",
			"Paraguay": "1199450",
			"Bangladesh": "85263269",
			"Antigua and Barbuda": "2088669",
			"Gabon": "4641",
			"Cyprus": "748758",
			"Yemen": "10699265",
			"Mauritius": "8978",
			"Slovakia": "2403",
			"Turkmenistan": "32440",
			"Syria": "12393402",
			"Côte d'Ivoire": "8702",
			"Guyana": "15221",
			"Algeria": "5744255",
			"USA": "924047043",
			"Cambodia": "4351500",
			"Rep. of Moldova": "83757",
			"Zambia": "7678439",
			"Malta": "10718",
			"Ecuador": "9024",
			"Grenada": "8564",
			"Dominican Rep.": "14553424",
			"France": "1800611",
			"New Caledonia": "2419295",
			"Niue": "5462100",
			"Seychelles": "708178",
			"Oceania, nes": "468132",
			"Br. Virgin Isds": "49411",
			"Italy": "2352969",
			"Saint Lucia": "143711",
			"State of Palestine": "2431",
			"Rwanda": "4659",
			"Belarus": "3656",
			"Ethiopia": "2311",
			"Namibia": "235498",
			"Congo": "409006",
			"Slovenia": "271124",
			"Bulgaria": "9696",
			"Montenegro": "9475",
			"Sri Lanka": "34788",
			"Hungary": "11805",
			"Angola": "3913212",
			"New Zealand": "460415",
			"N. Mariana Isds": "44696",
			"Lao People's Dem. Rep.": "49666233",
			"Myanmar": "366742320",
			"Iran": "983961",
			"Philippines": "3683",
			"Uruguay": "784274",
			"Andorra": "11906",
			"Cabo Verde": "2789904",
			"Germany": "13214858",
			"Timor-Leste": "68094",
			"Poland": "95691",
			"Thailand": "75868325",
			"Argentina": "5244743",
			"Brazil": "328104",
			"Brunei Darussalam": "4966040",
			"Mongolia": "6860",
			"Saudi Arabia": "1418796",
			"Greece": "2459",
			"Russian Federation": "3478515",
			"Cayman Isds": "238083254",
			"United Arab Emirates": "1348778",
			"Nicaragua": "4186766",
			"Malawi": "1448087",
			"Switzerland": "298923",
			"El Salvador": "223601",
			"Latvia": "4716740",
			"Guinea": "307284",
			"Uganda": "53315",
			"Romania": "2247",
			"Croatia": "13628782",
			"Liberia": "870002",
			"Guatemala": "206934",
			"Madagascar": "1168345",
			"Bolivia (Plurinational State of)": "47227517",
			"Nigeria": "10558049",
			"Bahamas": "746822344",
			"Tunisia": "365977",
			"Chad": "2431",
			"Viet Nam": "27721460",
			"Haiti": "7993109",
			"Oman": "9239234",
			"Sweden": "55654",
			"Maldives": "26722",
			"India": "116001603",
			"Mexico": "173278",
			"Austria": "2574286",
			"Eritrea": "3140",
			"Zimbabwe": "1002921",
			"Vanuatu": "257229",
			"Senegal": "3986085",
			"Peru": "7297067",
			"Fiji": "14217",
			"Lithuania": "3987",
			"Saint Kitts and Nevis": "101658",
			"Denmark": "29448",
			"Portugal": "231962",
			"Central African Rep.": "25792",
			"Netherlands": "8480089",
			"Costa Rica": "4512",
			"Equatorial Guinea": "8453",
			"Sudan": "6789055",
			"Papua New Guinea": "5728694",
			"Kazakhstan": "121617819",
			"Afghanistan": "5221372",
			"Saint Helena": "44088",
			"Egypt": "140267",
			"Nauru": "63987",
			"Anguilla": "173196",
			"Estonia": "17716",
			"Morocco": "4909438",
			"Luxembourg": "176501",
			"TFYR of Macedonia": "9687",
			"Western Sahara": "53573",
			"United Rep. of Tanzania": "59521",
			"Finland": "14088",
			"Belize": "8456498",
			"Georgia": "332266",
			"Ukraine": "7919",
			"Bermuda": "271328701",
			"Djibouti": "3131",
			"Greenland": "10497",
			"China, Hong Kong SAR": "44675266",
			"Suriname": "2166486",
			"Barbados": "7445465",
			"Venezuela": "33466774",
			"Kuwait": "89171",
			"Norway": "6786",
			"Sierra Leone": "1137424",
			"Marshall Isds": "171888",
			"Sao Tome and Principe": "13518",
			"Libya": "328785",
			"Kyrgyzstan": "92081",
			"Czechia": "900425",
			"Br. Indian Ocean Terr.": "5516",
			"Mozambique": "34236",
			"Samoa": "3021074",
			"Turkey": "4056739",
			"Rep. of Korea": "8401700",
			"Serbia": "198269",
			"Burundi": "1234348",
			"Bhutan": "969136",
			"Cook Isds": "851401",
			"Canada": "62581781",
			"Iceland": "69908"
		}
	},
	"Guinea": {
		"imports": {},
		"exports": {}
	},
	"Uganda": {
		"imports": {},
		"exports": {}
	},
	"Romania": {
		"imports": {
			"Lebanon": "3119056",
			"Gibraltar": "231000",
			"Ghana": "120485",
			"Niger": "24763",
			"Lesotho": "17",
			"Switzerland": "1171982",
			"Cabo Verde": "187389",
			"Tokelau": "313",
			"Germany": "4350842993",
			"Poland": "36287947",
			"Cuba": "18800108",
			"Dem. Rep. of the Congo": "937954",
			"Thailand": "4934402",
			"Dem. People's Rep. of Korea": "198",
			"Argentina": "426739",
			"Brazil": "39299167",
			"Azerbaijan": "704",
			"Cameroon": "13",
			"Dominica": "531",
			"Iran": "187774",
			"Mongolia": "171",
			"Saudi Arabia": "109006",
			"Panama": "150000",
			"Colombia": "5846",
			"Sudan": "9152067",
			"Russian Federation": "1279856",
			"Swaziland": "9253761",
			"United Arab Emirates": "72858",
			"Nicaragua": "134641",
			"Yemen": "563",
			"Angola": "12498",
			"Uzbekistan": "41406",
			"Malawi": "2676780",
			"Andorra": "38551",
			"El Salvador": "20316",
			"Iraq": "5217",
			"Uruguay": "2491061",
			"Slovakia": "4382807",
			"Latvia": "21867746",
			"Japan": "38830730",
			"Guam": "242",
			"Tunisia": "8668",
			"Guinea": "6",
			"Uganda": "731825",
			"Bosnia Herzegovina": "33000",
			"Pakistan": "24645",
			"Belgium": "251137538",
			"Croatia": "22557420",
			"China, Macao SAR": "46013",
			"Italy": "654497421",
			"Rwanda": "228065",
			"Belarus": "110362",
			"Madagascar": "2195317",
			"Bolivia (Plurinational State of)": "8638963",
			"Barbados": "82962",
			"Albania": "503",
			"Benin": "1035",
			"Bahamas": "6799",
			"San Marino": "790",
			"Chad": "559",
			"Viet Nam": "1250",
			"Haiti": "10221",
			"South Africa": "9827716",
			"Greenland": "392502",
			"Indonesia": "2053651",
			"Qatar": "6158",
			"Oman": "135",
			"Turkey": "65078451",
			"Sweden": "53175709",
			"Australia": "1403530",
			"India": "2730",
			"Mexico": "307898",
			"Kenya": "1558848",
			"Austria": "341563538",
			"Tajikistan": "33140",
			"Ireland": "6129466",
			"Botswana": "16",
			"Zimbabwe": "13068866",
			"China, Hong Kong SAR": "9289723",
			"French Polynesia": "189",
			"Mozambique": "15080469",
			"Lithuania": "88699949",
			"Cambodia": "1246715",
			"Denmark": "186657",
			"USA": "8260650",
			"Peru": "112977",
			"Honduras": "90147",
			"Netherlands": "36272935",
			"United Kingdom": "9236175",
			"Costa Rica": "393814",
			"Equatorial Guinea": "36123",
			"Greece": "361600004",
			"Chile": "4203957",
			"Kazakhstan": "1040",
			"Nepal": "5460",
			"Afghanistan": "63",
			"Malaysia": "239433",
			"Fiji": "752",
			"Portugal": "92900493",
			"Falkland Isds (Malvinas)": "41055",
			"Armenia": "585",
			"China": "13040966",
			"Egypt": "84995",
			"Saint Maarten": "107188",
			"Estonia": "205",
			"Morocco": "2136",
			"Djibouti": "30",
			"Trinidad and Tobago": "10016",
			"Israel": "1876722",
			"TFYR of Macedonia": "19403",
			"Somalia": "2152",
			"Singapore": "1250",
			"Paraguay": "161783",
			"Bangladesh": "5181304",
			"Antigua and Barbuda": "11185",
			"Gabon": "438093",
			"Finland": "9528",
			"Cyprus": "6159112",
			"Zambia": "23946",
			"Georgia": "106202",
			"Serbia": "1320297",
			"Luxembourg": "229905",
			"Faeroe Isds": "102093",
			"Turkmenistan": "108032",
			"Bahrain": "18191",
			"Côte d'Ivoire": "8261894",
			"Guyana": "257",
			"Mauritius": "1514849",
			"Algeria": "1218",
			"Nigeria": "23274",
			"New Zealand": "18179",
			"Namibia": "3411",
			"Rep. of Moldova": "7804392",
			"Venezuela": "303",
			"Kuwait": "93",
			"Spain": "118454300",
			"Malta": "56306",
			"Norway": "133147",
			"Ecuador": "3582735",
			"State of Palestine": "6310",
			"Sierra Leone": "60099158",
			"Dominican Rep.": "34204",
			"France": "23442742",
			"New Caledonia": "71",
			"Philippines": "876",
			"United Rep. of Tanzania": "374",
			"Br. Virgin Isds": "336",
			"Libya": "1774760",
			"Kyrgyzstan": "334707",
			"Czechia": "157518812",
			"Curaçao": "1",
			"Syria": "318498",
			"Guatemala": "112869",
			"Ethiopia": "1052392",
			"Slovenia": "575167",
			"Congo": "594243",
			"Aruba": "424",
			"Bulgaria": "64278063",
			"Montenegro": "314174",
			"Sri Lanka": "9997181",
			"Rep. of Korea": "82486540",
			"Hungary": "1040129409",
			"Burundi": "108299",
			"Jordan": "14068",
			"Canada": "50742",
			"Iceland": "324961",
			"Lao People's Dem. Rep.": "3001908",
			"Ukraine": "1420908",
			"Myanmar": "472"
		},
		"exports": {
			"Lebanon": "217781565",
			"Gibraltar": "3813405",
			"Ghana": "1179022",
			"Cuba": "15009",
			"Dem. Rep. of the Congo": "3724",
			"Cameroon": "4",
			"South Africa": "19704444",
			"Montserrat": "22315",
			"Indonesia": "2258893",
			"Colombia": "14967",
			"Niger": "15125",
			"Palau": "49021",
			"Angola": "373882",
			"Uzbekistan": "11884622",
			"Iraq": "2334792",
			"Guam": "48",
			"Bosnia Herzegovina": "3999540",
			"Pakistan": "214143",
			"Belgium": "4044878",
			"Azerbaijan": "20697946",
			"Armenia": "790346",
			"Togo": "1447388",
			"Singapore": "1338",
			"Albania": "8404922",
			"Benin": "76719",
			"Panama": "2304521",
			"Qatar": "1026599",
			"American Samoa": "4699",
			"Saint Vincent and the Grenadines": "92349",
			"Curaçao": "17912",
			"Australia": "10869312",
			"Jamaica": "2641",
			"Br. Virgin Isds": "28647",
			"Spain": "10359317",
			"Tajikistan": "44990",
			"Ireland": "18770834",
			"Botswana": "23363",
			"French Polynesia": "498",
			"Mauritania": "2058027",
			"Honduras": "26640",
			"United Kingdom": "40315274",
			"Jordan": "422001",
			"Chile": "39975708",
			"Sudan": "861434",
			"Gambia": "23789",
			"Liberia": "380259",
			"Brunei Darussalam": "509",
			"Malaysia": "8443139",
			"Fiji": "24288",
			"Peru": "10000",
			"Saint Kitts and Nevis": "5150",
			"Nepal": "93141",
			"China": "37308",
			"Comoros": "79",
			"Guinea-Bissau": "11988",
			"Mali": "3663290",
			"Trinidad and Tobago": "19",
			"Israel": "6321249",
			"Burkina Faso": "8645",
			"Paraguay": "174",
			"Bangladesh": "465870",
			"Antigua and Barbuda": "16140",
			"Gabon": "306999",
			"Cyprus": "18732573",
			"Yemen": "44000",
			"Mauritius": "1560923",
			"Slovakia": "2483598",
			"Faeroe Isds": "64092",
			"Turkmenistan": "656951",
			"Bahrain": "15253",
			"Côte d'Ivoire": "4478",
			"Guyana": "9384656",
			"Saint Pierre and Miquelon": "64617",
			"Algeria": "10777264",
			"USA": "66801",
			"Namibia": "218438",
			"Rep. of Moldova": "3383181",
			"Zambia": "1552",
			"Malta": "663821",
			"Ecuador": "4003",
			"Grenada": "651",
			"Dominican Rep.": "19831",
			"France": "10845487",
			"New Caledonia": "6135540",
			"Seychelles": "470",
			"Italy": "1975312788",
			"State of Palestine": "93497",
			"Rwanda": "619",
			"Syria": "6375",
			"Belarus": "3453",
			"Ethiopia": "78230188",
			"Slovenia": "38260",
			"Congo": "3279",
			"Senegal": "74879",
			"Bulgaria": "20355833",
			"Montenegro": "9632",
			"Sri Lanka": "2537148",
			"Hungary": "495246361",
			"New Zealand": "121",
			"N. Mariana Isds": "5007",
			"Lao People's Dem. Rep.": "537",
			"Myanmar": "28918",
			"Iran": "59416148",
			"Uruguay": "285",
			"Andorra": "9409",
			"Cabo Verde": "3935",
			"Germany": "2220928926",
			"Poland": "5922275",
			"Thailand": "289652",
			"Argentina": "3542319",
			"Brazil": "1294082",
			"Dominica": "5600",
			"Mongolia": "1294902",
			"Saudi Arabia": "2083546",
			"Greece": "306246280",
			"Russian Federation": "5637370",
			"Cayman Isds": "1336",
			"United Arab Emirates": "330989",
			"Nicaragua": "99510",
			"Malawi": "1354",
			"Switzerland": "14715359",
			"El Salvador": "286600",
			"Latvia": "20260346",
			"Japan": "9715525",
			"Guinea": "57777",
			"Uganda": "78165",
			"Croatia": "49210578",
			"China, Macao SAR": "23166",
			"Guatemala": "942837",
			"Madagascar": "4045608",
			"Bolivia (Plurinational State of)": "230817",
			"Barbados": "43354",
			"Bahamas": "46009",
			"San Marino": "9339",
			"Chad": "105453",
			"Viet Nam": "78398",
			"Haiti": "6568",
			"Oman": "220",
			"Sweden": "2063561",
			"Maldives": "31102",
			"India": "488000",
			"Mexico": "65906",
			"Austria": "187845050",
			"Eritrea": "1985000",
			"Zimbabwe": "1613576",
			"Saint Maarten": "208",
			"Lithuania": "793957",
			"Cambodia": "879",
			"Denmark": "8147",
			"Portugal": "223664",
			"Central African Rep.": "133070",
			"Netherlands": "115502802",
			"Costa Rica": "167955",
			"Equatorial Guinea": "84527",
			"South Georgia and the South Sandwich Islands": "2883",
			"Papua New Guinea": "11719",
			"Kazakhstan": "18799791",
			"Kenya": "152338",
			"Afghanistan": "3116345",
			"Egypt": "50177",
			"Estonia": "2466194",
			"Morocco": "162",
			"Luxembourg": "1341142",
			"TFYR of Macedonia": "26232",
			"Somalia": "210322",
			"Western Sahara": "95710",
			"United Rep. of Tanzania": "27967",
			"Finland": "152614",
			"Belize": "496",
			"Georgia": "2159549",
			"Ukraine": "2057395",
			"Bermuda": "30",
			"Djibouti": "11794",
			"Greenland": "95",
			"China, Hong Kong SAR": "22735195",
			"Suriname": "19720",
			"Nigeria": "5382",
			"Vanuatu": "541684",
			"Venezuela": "1028500",
			"Kuwait": "8211078",
			"Norway": "115703354",
			"Sierra Leone": "3805",
			"Marshall Isds": "575690479",
			"Philippines": "20755",
			"Libya": "211185440",
			"Kyrgyzstan": "3610495",
			"Czechia": "1581461",
			"Mozambique": "80906",
			"Aruba": "1994",
			"Turkey": "1312837",
			"Tunisia": "60956",
			"Rep. of Korea": "47101369",
			"Serbia": "1050267",
			"Burundi": "11191",
			"Bhutan": "401",
			"Cook Isds": "1127",
			"Canada": "17950",
			"Iceland": "707863"
		}
	},
	"Croatia": {
		"imports": {
			"Lebanon": "804",
			"Gibraltar": "330",
			"Ghana": "59350",
			"Uruguay": "52",
			"Andorra": "1978",
			"Cabo Verde": "390",
			"Germany": "19040387",
			"Barbados": "40",
			"Poland": "2331277",
			"Qatar": "1197",
			"Bolivia (Plurinational State of)": "83626",
			"Thailand": "351243",
			"Dem. People's Rep. of Korea": "3838",
			"United Rep. of Tanzania": "12935",
			"Brazil": "3547856",
			"Azerbaijan": "242270821",
			"Cameroon": "157649",
			"Comoros": "711",
			"Papua New Guinea": "128592",
			"Mongolia": "54",
			"Saudi Arabia": "53980448",
			"Panama": "334",
			"Colombia": "8467",
			"Sudan": "15592467",
			"Russian Federation": "106589",
			"United Arab Emirates": "23",
			"Nicaragua": "11596",
			"Jordan": "8659",
			"Malawi": "1",
			"Switzerland": "67787",
			"El Salvador": "173",
			"Cambodia": "188609",
			"Slovakia": "86420",
			"Iraq": "11",
			"Japan": "6366381",
			"Guam": "57",
			"Tunisia": "168",
			"Guinea": "101",
			"Uganda": "13556",
			"Romania": "431420",
			"Pakistan": "2168",
			"Belgium": "1455097",
			"Slovenia": "8580020",
			"China, Macao SAR": "208",
			"Italy": "14353753",
			"Guatemala": "52836",
			"Madagascar": "206",
			"Singapore": "42107",
			"Nigeria": "82228",
			"Uzbekistan": "70307",
			"Afghanistan": "121",
			"Bahamas": "18281",
			"San Marino": "2476",
			"Chad": "360",
			"Viet Nam": "11606",
			"Haiti": "137",
			"South Africa": "714328",
			"Tokelau": "380",
			"Indonesia": "178040",
			"Cuba": "9678873",
			"Saint Vincent and the Grenadines": "198993",
			"Oman": "21208",
			"Belarus": "124337",
			"Sweden": "463521",
			"Maldives": "4789",
			"Kiribati": "2684",
			"Bahrain": "18002",
			"India": "8853",
			"Mexico": "21003",
			"Kenya": "338",
			"Spain": "490765",
			"Eritrea": "10",
			"Ireland": "2609899",
			"Zimbabwe": "7523",
			"Saint Maarten": "532",
			"Austria": "10331333",
			"Mauritania": "24434",
			"Lithuania": "13979",
			"Namibia": "444",
			"Denmark": "21848",
			"Portugal": "2187623",
			"Central African Rep.": "2897",
			"Honduras": "280168",
			"Netherlands": "4136832",
			"United Kingdom": "107174",
			"Costa Rica": "108731",
			"Bouvet Island": "28",
			"Bulgaria": "160481",
			"Greece": "767962",
			"Chile": "1019496",
			"Kazakhstan": "669778",
			"Liberia": "168",
			"Armenia": "6090",
			"Malaysia": "3151052",
			"Swaziland": "54",
			"Peru": "9599",
			"Falkland Isds (Malvinas)": "39578",
			"Nepal": "84",
			"China": "3962129",
			"Egypt": "240477",
			"Estonia": "38279",
			"Morocco": "874861",
			"Mali": "1038",
			"Trinidad and Tobago": "16",
			"Israel": "1305244",
			"TFYR of Macedonia": "2089965",
			"Rep. of Moldova": "7921",
			"Czechia": "1863352",
			"Antigua and Barbuda": "8906",
			"Albania": "4905",
			"Gabon": "37",
			"Finland": "122907",
			"Bosnia Herzegovina": "29109",
			"Cyprus": "83723",
			"Zambia": "620",
			"Georgia": "214",
			"Serbia": "314691",
			"Bermuda": "6364",
			"Luxembourg": "582849",
			"Canada": "48092",
			"Syria": "3741",
			"Côte d'Ivoire": "8052",
			"Guyana": "649",
			"Mauritius": "354953",
			"Algeria": "1100",
			"USA": "17455699",
			"Saint Kitts and Nevis": "10013",
			"Iran": "754",
			"Venezuela": "8365",
			"Kuwait": "3353",
			"Suriname": "112",
			"Malta": "1448117",
			"Norway": "257868",
			"Ecuador": "760572",
			"Grenada": "867",
			"Dominican Rep.": "84128",
			"France": "33680720",
			"Australia": "65095",
			"Philippines": "113934",
			"Latvia": "26938",
			"Br. Virgin Isds": "273217",
			"Libya": "87963843",
			"Kyrgyzstan": "114155",
			"State of Palestine": "61",
			"Paraguay": "88",
			"Mozambique": "1069793",
			"Ethiopia": "361143",
			"Togo": "780",
			"Congo": "9365",
			"Senegal": "620",
			"Samoa": "469",
			"Turkey": "611209",
			"Montenegro": "242009",
			"Sri Lanka": "98181",
			"Rep. of Korea": "1112",
			"Bangladesh": "369078",
			"Hungary": "1716230",
			"Angola": "4512",
			"Argentina": "3979277",
			"New Zealand": "28747",
			"China, Hong Kong SAR": "227109",
			"Iceland": "2820",
			"Lao People's Dem. Rep.": "15655",
			"Ukraine": "98186",
			"Myanmar": "115051"
		},
		"exports": {
			"Lebanon": "734870",
			"Gibraltar": "54631",
			"Ghana": "37555",
			"Qatar": "8658",
			"Dem. Rep. of the Congo": "339057",
			"Cameroon": "80968",
			"South Africa": "51757",
			"Indonesia": "3259",
			"Colombia": "2978",
			"Niger": "1878",
			"Tonga": "1446",
			"Jordan": "346894",
			"Uzbekistan": "14792",
			"Iraq": "35698",
			"Bosnia Herzegovina": "1150123",
			"Pakistan": "18203",
			"Belgium": "360799",
			"Azerbaijan": "118820",
			"Armenia": "15549",
			"Togo": "350",
			"Singapore": "131350",
			"Albania": "20677",
			"Benin": "684",
			"Panama": "620687",
			"Cuba": "124182",
			"Saint Vincent and the Grenadines": "76489",
			"Curaçao": "124",
			"Australia": "825223",
			"Bahrain": "3173",
			"Mexico": "64588",
			"Kenya": "898105",
			"Spain": "720717",
			"Tajikistan": "11791",
			"Ireland": "49124",
			"Côte d'Ivoire": "339789",
			"French Polynesia": "6828",
			"Mauritania": "1625",
			"Saint Barthélemy": "135",
			"United Kingdom": "224301",
			"Chile": "795844",
			"China, Macao SAR": "46",
			"Brunei Darussalam": "1889",
			"Malaysia": "561951",
			"Portugal": "16598",
			"Nepal": "38612",
			"China": "226",
			"Mali": "33991",
			"Trinidad and Tobago": "1216639",
			"Israel": "158427",
			"Burkina Faso": "449",
			"Paraguay": "6598",
			"Bangladesh": "714517",
			"Antigua and Barbuda": "8979",
			"Gabon": "237480",
			"Cyprus": "7623237",
			"Yemen": "53118",
			"Mauritius": "43476",
			"Slovakia": "8864",
			"Faeroe Isds": "4501",
			"Turkmenistan": "2026007",
			"Syria": "14069",
			"South Sudan": "5159",
			"Algeria": "6105",
			"USA": "1378",
			"Rep. of Moldova": "62269",
			"Zambia": "380",
			"Malta": "1181779",
			"Ecuador": "85490",
			"Dominican Rep.": "32537",
			"France": "306661",
			"New Caledonia": "27",
			"Seychelles": "27901",
			"Br. Virgin Isds": "25499",
			"Italy": "4125058",
			"Saint Lucia": "3",
			"State of Palestine": "112514",
			"Uganda": "15315",
			"Belarus": "72806",
			"Ethiopia": "3342",
			"Congo": "9534",
			"Senegal": "1914",
			"Bulgaria": "2241904",
			"Montenegro": "4654387",
			"Sri Lanka": "3506",
			"Hungary": "708462",
			"Angola": "3238",
			"Lao People's Dem. Rep.": "27570",
			"Myanmar": "261813",
			"Papua New Guinea": "5",
			"Uruguay": "43",
			"Cabo Verde": "401541",
			"Germany": "1975702",
			"Poland": "501967",
			"Thailand": "45454",
			"Argentina": "3407",
			"Brazil": "2977",
			"Dominica": "9297",
			"Mongolia": "19502",
			"Saudi Arabia": "809768",
			"Greece": "499684",
			"Russian Federation": "485048",
			"Cayman Isds": "46530",
			"United Arab Emirates": "299559",
			"Rwanda": "413",
			"Switzerland": "501076",
			"El Salvador": "112127",
			"Latvia": "33654",
			"Japan": "294532",
			"Guinea": "65419",
			"Romania": "274606",
			"Slovenia": "5577647",
			"Liberia": "28000000",
			"Guatemala": "182",
			"Bolivia (Plurinational State of)": "6",
			"Nigeria": "15980",
			"Bahamas": "1180",
			"Tunisia": "128823",
			"Chad": "1711",
			"Viet Nam": "196701",
			"Haiti": "129636",
			"Oman": "10516",
			"Sweden": "1371388",
			"Maldives": "95027",
			"India": "34316",
			"Jamaica": "3531",
			"Austria": "2407597",
			"Eritrea": "502890",
			"Saint Maarten": "360",
			"Lithuania": "400668",
			"Namibia": "2133",
			"Denmark": "440542",
			"Peru": "287666",
			"Central African Rep.": "4138",
			"Netherlands": "72706",
			"Costa Rica": "14305",
			"Equatorial Guinea": "8569",
			"Sudan": "6680",
			"Kazakhstan": "21611",
			"Afghanistan": "86589",
			"Egypt": "5498",
			"Estonia": "198239",
			"Morocco": "54",
			"Luxembourg": "146",
			"TFYR of Macedonia": "3066861",
			"Somalia": "1373711",
			"United Rep. of Tanzania": "177352",
			"Finland": "1052",
			"Georgia": "43",
			"Ukraine": "283078",
			"Bermuda": "11544",
			"Djibouti": "40888",
			"China, Hong Kong SAR": "7592",
			"Suriname": "657",
			"Iran": "10610",
			"Venezuela": "1927978",
			"Kuwait": "33377",
			"New Zealand": "87356",
			"Norway": "473500",
			"Sierra Leone": "2535",
			"Marshall Isds": "312977",
			"Philippines": "36605",
			"Libya": "12764",
			"Kyrgyzstan": "237977",
			"Czechia": "55958",
			"Br. Indian Ocean Terr.": "97",
			"Mozambique": "319613",
			"Turkey": "711745",
			"San Marino": "21504",
			"Rep. of Korea": "854646",
			"Serbia": "469024",
			"Burundi": "14643",
			"Bhutan": "5670",
			"Canada": "1820",
			"Iceland": "930"
		}
	},
	"Liberia": {
		"imports": {},
		"exports": {}
	},
	"Mozambique": {
		"imports": {},
		"exports": {}
	},
	"Madagascar": {
		"imports": {
			"Lebanon": "1331",
			"Côte d'Ivoire": "162538",
			"South Africa": "2092176",
			"Lesotho": "63422",
			"Switzerland": "738457",
			"United Kingdom": "8625",
			"Poland": "199552",
			"El Salvador": "71",
			"Dem. Rep. of the Congo": "1460",
			"Thailand": "318412",
			"Dem. People's Rep. of Korea": "68",
			"Argentina": "390881",
			"Brazil": "98007",
			"Azerbaijan": "677",
			"Cameroon": "778",
			"Iran": "9876",
			"Saudi Arabia": "11175",
			"Panama": "208769",
			"Colombia": "129005",
			"Syria": "28",
			"Russian Federation": "51152",
			"United Arab Emirates": "8887",
			"Nicaragua": "1208",
			"Jordan": "1748",
			"Kazakhstan": "80",
			"Andorra": "3548",
			"Georgia": "118571",
			"Uruguay": "12474",
			"Slovakia": "51280",
			"Latvia": "34275",
			"Japan": "89239",
			"Guinea": "73920",
			"Romania": "266808",
			"Pakistan": "49838",
			"Belgium": "51607",
			"Croatia": "69236",
			"Rwanda": "27332",
			"Mozambique": "25532",
			"Germany": "71632095",
			"Bolivia (Plurinational State of)": "1952",
			"Barbados": "60",
			"Albania": "1557",
			"Benin": "11566",
			"Tunisia": "15651",
			"Viet Nam": "170478",
			"Haiti": "259275",
			"Tokelau": "354",
			"Indonesia": "9782715",
			"Qatar": "2538",
			"Djibouti": "7771",
			"Belarus": "44418",
			"Sweden": "32668",
			"Australia": "3710",
			"Libya": "212",
			"India": "1127077",
			"Jamaica": "90",
			"Mexico": "2679",
			"Kenya": "273322",
			"Austria": "216333",
			"Bosnia Herzegovina": "384",
			"Ireland": "175561",
			"Zimbabwe": "1424789",
			"China, Hong Kong SAR": "3738843",
			"Spain": "1756681",
			"Mauritania": "118778",
			"Lithuania": "1546",
			"Cambodia": "650",
			"Denmark": "78171",
			"Peru": "7991",
			"Central African Rep.": "404",
			"Honduras": "24440",
			"Saint Barthélemy": "892",
			"Netherlands": "96678",
			"Eritrea": "5816",
			"Costa Rica": "6682",
			"Turkey": "90474",
			"Greece": "1978933",
			"Chile": "64999",
			"Slovenia": "66646",
			"Sudan": "54433",
			"Malawi": "657",
			"China, Macao SAR": "6022",
			"Nepal": "31869",
			"Afghanistan": "260",
			"Equatorial Guinea": "2022",
			"Malaysia": "5544997",
			"Swaziland": "44796",
			"Portugal": "17701",
			"United Rep. of Tanzania": "224",
			"Oman": "796",
			"Egypt": "14944",
			"China": "9848306",
			"Comoros": "284",
			"Nauru": "1292",
			"Estonia": "674564",
			"Morocco": "270014",
			"Mali": "42688",
			"Trinidad and Tobago": "726",
			"Israel": "191288",
			"Venezuela": "300",
			"Burkina Faso": "2785",
			"Paraguay": "5468",
			"French Polynesia": "270920",
			"Bangladesh": "163739",
			"Nigeria": "159924",
			"Gabon": "53279",
			"Finland": "1087390",
			"Cyprus": "54703",
			"Belize": "528",
			"Mauritius": "12076946",
			"Ukraine": "403695",
			"Luxembourg": "8218",
			"Papua New Guinea": "3430",
			"Turkmenistan": "14591",
			"Bahrain": "23133315",
			"Zambia": "184273",
			"Singapore": "15920",
			"Ghana": "62871",
			"Guyana": "151",
			"Niger": "45184",
			"Algeria": "20",
			"USA": "1382169",
			"Rep. of Moldova": "40",
			"TFYR of Macedonia": "1247",
			"Kuwait": "152",
			"Suriname": "3316",
			"Malta": "540519",
			"Norway": "3804",
			"Ecuador": "5603",
			"Serbia": "21",
			"Sierra Leone": "138",
			"Dominican Rep.": "1084",
			"France": "205399699",
			"New Caledonia": "2259",
			"Philippines": "21159",
			"Niue": "38",
			"Seychelles": "2052",
			"Italy": "5255878",
			"Czechia": "169",
			"Uganda": "3032",
			"Guatemala": "740",
			"Ethiopia": "839",
			"Togo": "1790",
			"Congo": "734",
			"Senegal": "29",
			"Bulgaria": "15466",
			"San Marino": "9539",
			"Sri Lanka": "535",
			"Rep. of Korea": "116853",
			"Hungary": "359946",
			"New Zealand": "848",
			"Canada": "6725",
			"Iceland": "228",
			"Lao People's Dem. Rep.": "144",
			"Myanmar": "436486"
		},
		"exports": {
			"Lebanon": "14286",
			"Fr. South Antarctic Terr.": "786",
			"South Africa": "14927057",
			"Uruguay": "3146",
			"Marshall Isds": "16950",
			"United Kingdom": "1125562",
			"Poland": "9058",
			"Gabon": "132048",
			"Dem. Rep. of the Congo": "4618",
			"Thailand": "1727",
			"Dem. People's Rep. of Korea": "2912",
			"Argentina": "22463",
			"Brazil": "34184",
			"Cameroon": "4796",
			"Ghana": "1843627",
			"Saudi Arabia": "2445599",
			"Panama": "26847",
			"Colombia": "3157",
			"Sudan": "381704",
			"Niger": "54104",
			"United Arab Emirates": "7819094",
			"Rwanda": "240",
			"Yemen": "2989908",
			"Jordan": "42563",
			"Malawi": "3764",
			"Switzerland": "6171",
			"Mauritius": "759133",
			"Ukraine": "111391",
			"Iraq": "292344",
			"Japan": "474379",
			"Guinea": "85855",
			"Romania": "28467",
			"Pakistan": "5737714",
			"Belgium": "17534",
			"Slovenia": "26055",
			"Mozambique": "363758",
			"Germany": "189598687",
			"Singapore": "1274",
			"Nigeria": "88539",
			"Uzbekistan": "32532",
			"Benin": "11366",
			"Maldives": "10081",
			"Tunisia": "277524",
			"Chad": "11657",
			"Viet Nam": "31838690",
			"Haiti": "233594",
			"Indonesia": "24459",
			"Qatar": "190845",
			"Oman": "103854",
			"Sweden": "24204",
			"Australia": "21864",
			"India": "67735823",
			"Jamaica": "8331",
			"Mexico": "122463",
			"Kenya": "1270",
			"Austria": "2307",
			"Ireland": "389159",
			"Botswana": "696",
			"Zimbabwe": "40722",
			"Côte d'Ivoire": "2701",
			"Spain": "79190",
			"Lithuania": "1021",
			"Cambodia": "18723",
			"Denmark": "134767",
			"Peru": "1042752",
			"Netherlands": "22875",
			"Costa Rica": "42694",
			"Turkey": "1538328",
			"Greece": "1445469",
			"Chile": "21309",
			"Croatia": "38880",
			"Liberia": "10327",
			"Afghanistan": "5907",
			"Mali": "21426",
			"Malaysia": "69648",
			"Swaziland": "506",
			"Portugal": "7394651",
			"Saint Kitts and Nevis": "21286",
			"Nepal": "14231",
			"China": "924914",
			"Comoros": "20970",
			"Estonia": "411950",
			"Morocco": "627890",
			"Luxembourg": "54096",
			"Israel": "2621",
			"TFYR of Macedonia": "8056",
			"Burkina Faso": "159",
			"Kazakhstan": "1011",
			"Bangladesh": "959669",
			"United Rep. of Tanzania": "1666",
			"Finland": "4161524",
			"Cyprus": "69829",
			"Zambia": "1233",
			"Georgia": "393",
			"Slovakia": "5519",
			"Djibouti": "9839",
			"Bahrain": "11015",
			"China, Hong Kong SAR": "9301055",
			"Guyana": "7383",
			"Russian Federation": "2212358",
			"Algeria": "7948",
			"USA": "6452913",
			"Namibia": "9441",
			"Iran": "133021",
			"Venezuela": "6544",
			"Kuwait": "511",
			"Cook Isds": "6551",
			"Norway": "83804",
			"France": "537657135",
			"New Caledonia": "96533",
			"Philippines": "53871",
			"Latvia": "426860",
			"Seychelles": "1595292",
			"Italy": "5603229",
			"Czechia": "28329",
			"Uganda": "26",
			"Egypt": "1994305",
			"Guatemala": "65742",
			"Ethiopia": "674",
			"Togo": "881",
			"Congo": "15730",
			"Senegal": "299",
			"Bulgaria": "21226",
			"Sri Lanka": "2029",
			"Rep. of Korea": "32663",
			"Hungary": "43826",
			"Burundi": "412021",
			"New Zealand": "232164",
			"Canada": "30293",
			"Iceland": "13800",
			"Myanmar": "52495"
		}
	},
	"Bolivia (Plurinational State of)": {
		"imports": {},
		"exports": {}
	},
	"Barbados": {
		"imports": {
			"Lebanon": "2525",
			"Iran": "67",
			"Sao Tome and Principe": "45",
			"Lesotho": "431",
			"Switzerland": "1450",
			"Cabo Verde": "5399",
			"Germany": "227841",
			"Poland": "54865",
			"Cuba": "11721",
			"Thailand": "8721596",
			"Dem. People's Rep. of Korea": "1274",
			"Argentina": "14000",
			"Brazil": "1307474",
			"Cameroon": "52",
			"Brunei Darussalam": "1536",
			"South Africa": "405639",
			"Mongolia": "10100",
			"Montserrat": "126",
			"Panama": "676",
			"Colombia": "156146",
			"Sudan": "2971",
			"Niger": "664",
			"Cayman Isds": "18700",
			"United Arab Emirates": "26006",
			"Nicaragua": "90384",
			"Yemen": "90",
			"Angola": "7580",
			"Andorra": "873",
			"El Salvador": "669294",
			"United States Minor Outlying Islands": "22",
			"Uruguay": "3258235",
			"Sierra Leone": "1421",
			"Slovakia": "51",
			"Latvia": "110347",
			"Japan": "8028121",
			"Guam": "265",
			"Tunisia": "373",
			"Guinea": "98",
			"Bosnia Herzegovina": "1341",
			"Pakistan": "607",
			"Belgium": "850",
			"Russian Federation": "31890",
			"Croatia": "6928",
			"Pitcairn": "41",
			"Guatemala": "1318673",
			"Madagascar": "9462",
			"Bolivia (Plurinational State of)": "5669",
			"Nigeria": "710",
			"Albania": "9371",
			"Bahamas": "3648",
			"San Marino": "438",
			"Chad": "380",
			"Viet Nam": "11913",
			"Haiti": "146",
			"Mozambique": "27",
			"Tokelau": "17254",
			"Indonesia": "20803",
			"Qatar": "1050",
			"American Samoa": "8",
			"Saint Vincent and the Grenadines": "2663",
			"Oman": "67973",
			"Jordan": "7190",
			"Curaçao": "116",
			"Australia": "478",
			"India": "328361",
			"Jamaica": "215952",
			"Mexico": "74353",
			"Kenya": "264",
			"Austria": "161869",
			"Eritrea": "5728",
			"Ireland": "59123",
			"Botswana": "373",
			"Zimbabwe": "1272",
			"Côte d'Ivoire": "1248",
			"Spain": "11311",
			"Mauritania": "12137",
			"Lithuania": "336553",
			"Cambodia": "3363",
			"Denmark": "4",
			"Portugal": "23239",
			"Venezuela": "75",
			"Honduras": "185113",
			"Netherlands": "186003",
			"United Kingdom": "12475",
			"Costa Rica": "5349036",
			"Bouvet Island": "800",
			"Turkey": "24150",
			"Samoa": "762",
			"Greece": "12889",
			"Chile": "1779383",
			"Slovenia": "22",
			"Gambia": "896",
			"China, Macao SAR": "2046",
			"Nepal": "80",
			"Afghanistan": "7695",
			"Dominica": "44",
			"Malaysia": "1902",
			"Swaziland": "2367",
			"Peru": "295041",
			"United Rep. of Tanzania": "3021",
			"Sweden": "3446",
			"Egypt": "14022",
			"China": "536639",
			"Comoros": "83",
			"Nauru": "4790",
			"Saint Maarten": "16351",
			"Estonia": "12452",
			"Morocco": "114",
			"Luxembourg": "205",
			"Trinidad and Tobago": "4564783",
			"Israel": "14669",
			"TFYR of Macedonia": "700",
			"Senegal": "327",
			"Anguilla": "19",
			"Singapore": "117905",
			"Paraguay": "425",
			"Bangladesh": "26910",
			"Antigua and Barbuda": "31181",
			"Gabon": "144",
			"Finland": "140000",
			"Cyprus": "698",
			"Belize": "95819",
			"Georgia": "165",
			"Ukraine": "230",
			"Bermuda": "379",
			"Turkmenistan": "1629",
			"Bahrain": "100",
			"China, Hong Kong SAR": "56056",
			"Ghana": "68857",
			"Guyana": "48045",
			"Suriname": "225",
			"USA": "4406719",
			"New Zealand": "15987330",
			"Saint Kitts and Nevis": "25276",
			"Rep. of Moldova": "50",
			"Romania": "2007",
			"Vanuatu": "3809",
			"Malta": "143",
			"Norway": "70146",
			"Ecuador": "185752",
			"Serbia": "217",
			"Grenada": "63036",
			"Dominican Rep.": "736552",
			"France": "573",
			"Tuvalu": "39",
			"New Caledonia": "837",
			"Philippines": "182427",
			"Br. Virgin Isds": "307",
			"Italy": "4268",
			"Saint Lucia": "18",
			"Czechia": "940",
			"Uganda": "4368",
			"Belarus": "3291",
			"Ethiopia": "1384",
			"Namibia": "26891",
			"Mauritius": "9585",
			"Congo": "100",
			"Saudi Arabia": "4303",
			"Aruba": "1818",
			"Bulgaria": "941",
			"Montenegro": "238",
			"Sri Lanka": "47917",
			"Rep. of Korea": "815230",
			"Hungary": "19485",
			"Holy See (Vatican City State)": "170",
			"Bhutan": "594",
			"Cook Isds": "18",
			"Canada": "24903",
			"Iceland": "2278",
			"Lao People's Dem. Rep.": "466",
			"Myanmar": "2098"
		},
		"exports": {
			"Bonaire": "16941",
			"Ghana": "45",
			"Uruguay": "161",
			"Switzerland": "2284",
			"Cabo Verde": "14263",
			"Germany": "581442",
			"Poland": "250",
			"Cuba": "4051892",
			"Bolivia (Plurinational State of)": "1650",
			"Thailand": "25600",
			"Dem. People's Rep. of Korea": "22",
			"Argentina": "12500",
			"Brazil": "2979",
			"Dominica": "136693",
			"Iran": "228",
			"Mongolia": "12",
			"Montserrat": "48639",
			"Indonesia": "866",
			"Colombia": "39202",
			"Sudan": "27116",
			"Niger": "25",
			"Cayman Isds": "295336",
			"United Arab Emirates": "25",
			"Nicaragua": "20",
			"Tonga": "221",
			"Jordan": "19300",
			"Malawi": "100",
			"Andorra": "1",
			"Georgia": "120",
			"Ukraine": "10002",
			"Iraq": "18750",
			"Japan": "22500",
			"Latvia": "1381",
			"Bosnia Herzegovina": "3015",
			"Vanuatu": "158418",
			"Belgium": "86420",
			"Russian Federation": "15",
			"Sweden": "712",
			"Liberia": "22",
			"Armenia": "6124",
			"United Kingdom": "1214838",
			"Singapore": "5109",
			"Nigeria": "433",
			"Benin": "50",
			"Bahamas": "3388552",
			"Viet Nam": "140675",
			"Haiti": "16",
			"South Africa": "98",
			"Tokelau": "62",
			"Panama": "183556",
			"Qatar": "30000",
			"Saint Vincent and the Grenadines": "62823",
			"Curaçao": "1040123",
			"Australia": "4625",
			"India": "1",
			"Jamaica": "126135",
			"Mexico": "92",
			"Br. Virgin Isds": "1940763",
			"Austria": "335",
			"Bouvet Island": "50",
			"Ireland": "17727",
			"Zimbabwe": "28000",
			"Saint Maarten": "100087",
			"Spain": "1165995",
			"Swaziland": "1250",
			"Lithuania": "30",
			"Saint Kitts and Nevis": "241",
			"Denmark": "50512",
			"Portugal": "217",
			"Central African Rep.": "10",
			"Honduras": "3902",
			"Netherlands": "2435624",
			"Costa Rica": "1023",
			"Turkey": "26",
			"Greece": "40",
			"Chile": "3582",
			"Slovenia": "337",
			"Gambia": "20000",
			"Kenya": "85",
			"Libya": "576",
			"Afghanistan": "181",
			"Saint Helena": "4570",
			"Malaysia": "11432",
			"Fiji": "10",
			"Peru": "10",
			"China": "28800",
			"Anguilla": "811925",
			"Pakistan": "2011",
			"Trinidad and Tobago": "3072",
			"Israel": "4678",
			"Venezuela": "787",
			"Saudi Arabia": "8000",
			"Bangladesh": "2",
			"Antigua and Barbuda": "42000",
			"Gabon": "52",
			"Finland": "120",
			"Cyprus": "4",
			"Belize": "408966",
			"Mauritius": "10",
			"Slovakia": "215788",
			"Bermuda": "143634",
			"Papua New Guinea": "100",
			"Bahrain": "4001",
			"China, Hong Kong SAR": "4526",
			"Guyana": "24700",
			"Suriname": "16003",
			"USA": "808",
			"Namibia": "551",
			"Romania": "200",
			"Kuwait": "130",
			"Malta": "8",
			"Norway": "1",
			"Ecuador": "17234",
			"Grenada": "937",
			"Dominican Rep.": "25512",
			"France": "23450",
			"New Caledonia": "1",
			"Philippines": "1200",
			"Seychelles": "375",
			"Italy": "149506",
			"Saint Lucia": "38639",
			"Czechia": "700",
			"Uganda": "5",
			"Syria": "60",
			"Guatemala": "277",
			"Sierra Leone": "70",
			"Aruba": "73013",
			"Bulgaria": "1095",
			"Sri Lanka": "8030",
			"Rep. of Korea": "99",
			"Serbia": "50",
			"Holy See (Vatican City State)": "52",
			"New Zealand": "118",
			"Canada": "19138",
			"Iceland": "1127",
			"El Salvador": "592"
		}
	},
	"Saint Kitts and Nevis": {
		"imports": {},
		"exports": {}
	},
	"Bahamas": {
		"imports": {},
		"exports": {}
	},
	"Tunisia": {
		"imports": {},
		"exports": {}
	},
	"Chad": {
		"imports": {},
		"exports": {}
	},
	"Viet Nam": {
		"imports": {},
		"exports": {}
	},
	"Haiti": {
		"imports": {},
		"exports": {}
	},
	"Tokelau": {
		"imports": {},
		"exports": {}
	},
	"South Georgia and the South Sandwich Islands": {
		"imports": {},
		"exports": {}
	},
	"Oman": {
		"imports": {
			"Lebanon": "2082393",
			"South Africa": "828482",
			"Uruguay": "25355",
			"United Kingdom": "15196773",
			"Poland": "531414",
			"Qatar": "584582",
			"Thailand": "6494681",
			"Argentina": "7027",
			"Brazil": "286309",
			"Brunei Darussalam": "8759",
			"Iran": "3350",
			"Uzbekistan": "49",
			"Saudi Arabia": "139002978",
			"Panama": "6354",
			"Colombia": "32372",
			"Sudan": "316421",
			"Russian Federation": "876",
			"United Arab Emirates": "1090455915",
			"Rwanda": "437",
			"Tajikistan": "151",
			"Jordan": "223123",
			"Switzerland": "2400999",
			"Belarus": "122",
			"Slovakia": "463",
			"Iraq": "1046",
			"Japan": "6005148",
			"Latvia": "5121",
			"Bosnia Herzegovina": "112",
			"Pakistan": "40233591",
			"Belgium": "40539",
			"Croatia": "264496",
			"Georgia": "13264",
			"Mozambique": "276931",
			"Germany": "392414",
			"Bolivia (Plurinational State of)": "390",
			"Barbados": "4125",
			"Albania": "91",
			"Benin": "5488",
			"Maldives": "8957",
			"Tunisia": "51662",
			"Viet Nam": "967573",
			"Haiti": "988",
			"Guinea": "13574",
			"Indonesia": "234889",
			"Cuba": "103283",
			"Sweden": "167039",
			"Australia": "5654",
			"India": "95262414",
			"Mexico": "95561",
			"Kenya": "18437",
			"Spain": "8598117",
			"Romania": "250",
			"Ireland": "4390",
			"Zimbabwe": "775",
			"Austria": "10981",
			"Peru": "17649",
			"Lithuania": "26141",
			"Cambodia": "180142",
			"Denmark": "6994",
			"Portugal": "22845",
			"Honduras": "2965",
			"Netherlands": "32492614",
			"Costa Rica": "62",
			"Turkey": "11701821",
			"Greece": "56466",
			"Chile": "63959",
			"Kazakhstan": "52",
			"Nepal": "364",
			"Mali": "24624",
			"Malaysia": "5790647",
			"USA": "7891891",
			"Somalia": "7981717",
			"United Rep. of Tanzania": "39488",
			"Armenia": "17527",
			"China": "133229",
			"Egypt": "68490221",
			"Estonia": "1134",
			"Morocco": "331729",
			"Djibouti": "770308",
			"Trinidad and Tobago": "778",
			"TFYR of Macedonia": "229",
			"Singapore": "16023352",
			"Paraguay": "425366",
			"Bangladesh": "476136",
			"Mauritania": "24385",
			"Finland": "770",
			"Cyprus": "5417",
			"Yemen": "7260614",
			"Mauritius": "406",
			"Ukraine": "8744155",
			"Luxembourg": "1659",
			"Madagascar": "28398",
			"Bahrain": "98256",
			"Zambia": "130",
			"China, Hong Kong SAR": "3613",
			"Ghana": "403",
			"Suriname": "79696",
			"Algeria": "1995",
			"Nigeria": "41030",
			"Rep. of Moldova": "8151",
			"Venezuela": "112",
			"Kuwait": "3004",
			"Malta": "24437",
			"Norway": "78659",
			"Ecuador": "533",
			"Serbia": "804",
			"Dominican Rep.": "17717",
			"France": "7545",
			"Philippines": "658481",
			"Italy": "23503",
			"State of Palestine": "14538",
			"Uganda": "98256",
			"Syria": "632052",
			"Guatemala": "73753",
			"Ethiopia": "5891",
			"Slovenia": "3594",
			"Congo": "207518",
			"Senegal": "101",
			"Bulgaria": "15251",
			"San Marino": "648",
			"Sri Lanka": "131340",
			"Rep. of Korea": "1293",
			"Hungary": "5449",
			"New Zealand": "4864997",
			"Canada": "62960",
			"Iceland": "12221",
			"El Salvador": "9618",
			"Czechia": "7124",
			"Myanmar": "755881"
		},
		"exports": {
			"Lebanon": "19007",
			"Iran": "36281",
			"Niger": "92901",
			"Uruguay": "602894",
			"Peru": "1676699",
			"Germany": "866",
			"Poland": "5548",
			"Qatar": "26662694",
			"Bolivia (Plurinational State of)": "120297",
			"Thailand": "1890215",
			"United Rep. of Tanzania": "3510903",
			"Brazil": "18060917",
			"Cameroon": "130",
			"Brunei Darussalam": "1599",
			"South Africa": "960754",
			"Saudi Arabia": "153613097",
			"Panama": "130",
			"Colombia": "20661",
			"Sudan": "2639427",
			"Russian Federation": "10778",
			"United Arab Emirates": "202382558",
			"Nicaragua": "84099",
			"Belize": "12809",
			"Jordan": "325425",
			"Malawi": "9659",
			"Switzerland": "41769",
			"Belarus": "1430",
			"Saint Lucia": "76385",
			"Slovakia": "20630",
			"Iraq": "55072",
			"Japan": "780",
			"Guinea": "23613",
			"Romania": "80747",
			"Pakistan": "3095501",
			"Belgium": "390",
			"Eritrea": "260",
			"Azerbaijan": "5090",
			"Liberia": "576717",
			"Italy": "135062",
			"Rwanda": "172542",
			"Australia": "289",
			"Madagascar": "14564",
			"Singapore": "1008044",
			"Nigeria": "2489145",
			"Uzbekistan": "700",
			"Benin": "75504",
			"Tunisia": "304473",
			"Chad": "56362",
			"Viet Nam": "63842379",
			"Indonesia": "447369",
			"Cuba": "788",
			"Turkey": "905918",
			"Sweden": "101",
			"Maldives": "7524637",
			"India": "3896136",
			"Mexico": "11365",
			"Jamaica": "231731",
			"Kenya": "1706",
			"Spain": "39",
			"Bosnia Herzegovina": "49",
			"Ireland": "780",
			"Botswana": "284650",
			"Zimbabwe": "2265",
			"Côte d'Ivoire": "172899",
			"Austria": "33709",
			"Mauritania": "257406",
			"Lithuania": "3818",
			"Namibia": "83408",
			"Denmark": "7766",
			"Portugal": "289",
			"Netherlands": "748924",
			"United Kingdom": "218634",
			"Costa Rica": "9212",
			"Equatorial Guinea": "21040",
			"Greece": "2903871",
			"Chile": "35121",
			"Croatia": "181302",
			"Nepal": "24825",
			"Mali": "22320",
			"South Sudan": "51987",
			"Malaysia": "1382593",
			"Fiji": "35758",
			"Somalia": "61363330",
			"Egypt": "557859",
			"China": "1865710",
			"Comoros": "493185",
			"Guinea-Bissau": "25160",
			"Estonia": "10403",
			"Morocco": "509510",
			"Djibouti": "25599966",
			"Trinidad and Tobago": "175863",
			"Venezuela": "42102",
			"Kazakhstan": "26",
			"Bangladesh": "1691331",
			"Gabon": "130",
			"Finland": "109",
			"Cyprus": "260",
			"Yemen": "56201098",
			"Georgia": "61101",
			"Ukraine": "503322",
			"Luxembourg": "4108031",
			"Papua New Guinea": "154383",
			"Turkmenistan": "947",
			"Bahrain": "1682946",
			"Zambia": "17342",
			"China, Hong Kong SAR": "3099433",
			"Ghana": "251851",
			"Burundi": "101",
			"Mauritius": "650364",
			"Algeria": "15121",
			"USA": "998187",
			"Cambodia": "5202",
			"Kuwait": "59275",
			"Malta": "14713",
			"Norway": "49",
			"Ecuador": "240293",
			"Serbia": "8936",
			"Sierra Leone": "53007",
			"Dominican Rep.": "433413",
			"France": "3004",
			"Philippines": "89574",
			"Seychelles": "182743",
			"Libya": "2495187",
			"Kyrgyzstan": "525",
			"State of Palestine": "46060",
			"Uganda": "260",
			"Syria": "3707599",
			"Mozambique": "1886542",
			"Ethiopia": "489",
			"Togo": "14520",
			"Congo": "49392",
			"Senegal": "154246",
			"Samoa": "26962",
			"Bulgaria": "14632",
			"Sri Lanka": "5048439",
			"Rep. of Korea": "139559",
			"Hungary": "46185",
			"Dem. Rep. of the Congo": "5886",
			"Angola": "3046",
			"Argentina": "34138",
			"New Zealand": "966538",
			"Canada": "187",
			"Iceland": "2263",
			"El Salvador": "2746822",
			"Czechia": "15457",
			"Myanmar": "10662986"
		}
	},
	"Sweden": {
		"imports": {
			"Lebanon": "16478",
			"Gibraltar": "3272",
			"Ghana": "117",
			"Lesotho": "117",
			"Qatar": "31320",
			"Dem. Rep. of the Congo": "195398",
			"Dem. People's Rep. of Korea": "9232",
			"Cameroon": "10050",
			"Papua New Guinea": "697800",
			"Panama": "209071",
			"Colombia": "5259",
			"Niger": "467",
			"Tonga": "701",
			"Jordan": "3230847",
			"Fr. South Antarctic Terr.": "6895",
			"Uzbekistan": "584",
			"Iraq": "19283",
			"Tuvalu": "818",
			"Guam": "351",
			"Bosnia Herzegovina": "24892",
			"Pakistan": "4077065",
			"Belgium": "43020654",
			"Azerbaijan": "62523",
			"Australia": "148302",
			"United Kingdom": "238352254",
			"Singapore": "2402742",
			"Albania": "3266958",
			"Benin": "8999",
			"South Africa": "47196704",
			"Indonesia": "2283072",
			"Cuba": "12154",
			"American Samoa": "234",
			"Saint Vincent and the Grenadines": "2104",
			"Curaçao": "16010",
			"Armenia": "37630",
			"Mexico": "5025",
			"Kenya": "351",
			"Spain": "208486379",
			"Tajikistan": "62406",
			"Ireland": "165696066",
			"Botswana": "10284",
			"South Sudan": "33657",
			"French Polynesia": "107516",
			"Mauritania": "2454",
			"Bouvet Island": "584",
			"Honduras": "351",
			"Saint Barthélemy": "26295",
			"Holy See (Vatican City State)": "5610",
			"Chile": "235716",
			"Sudan": "117",
			"Gambia": "701",
			"Liberia": "2805",
			"Antarctica": "33423",
			"Dominica": "5610",
			"Malaysia": "47447",
			"Fiji": "2688",
			"Peru": "1098530",
			"Falkland Isds (Malvinas)": "234",
			"Nepal": "56329",
			"China": "48727166",
			"Comoros": "228821",
			"Guinea-Bissau": "9115",
			"Saint Maarten": "1753",
			"Mali": "98400",
			"Trinidad and Tobago": "10635",
			"Israel": "9837219",
			"Burkina Faso": "9583",
			"Paraguay": "701",
			"Bangladesh": "2897899",
			"Antigua and Barbuda": "29684",
			"Gabon": "8127836",
			"Cyprus": "8765",
			"Yemen": "117",
			"Mauritius": "6833674",
			"Slovakia": "46106238",
			"Faeroe Isds": "9934",
			"Turkmenistan": "16127",
			"Bahrain": "117",
			"Côte d'Ivoire": "44299857",
			"Guyana": "701",
			"Saint Pierre and Miquelon": "117",
			"Algeria": "59601",
			"USA": "42813336",
			"Namibia": "35410",
			"Rep. of Moldova": "286670",
			"Zambia": "3155",
			"Malta": "202059",
			"Ecuador": "8882",
			"Grenada": "117",
			"Dominican Rep.": "58426952",
			"France": "17000452",
			"New Caledonia": "351",
			"Seychelles": "34358",
			"Br. Virgin Isds": "549966",
			"Italy": "552247492",
			"Saint Lucia": "351",
			"State of Palestine": "16244",
			"Rwanda": "5726",
			"Belarus": "141290",
			"Ethiopia": "3038",
			"Slovenia": "3834805",
			"Congo": "117",
			"Senegal": "117",
			"Bulgaria": "476458",
			"Montenegro": "2220",
			"Sri Lanka": "15192",
			"Hungary": "29338697",
			"Angola": "117",
			"New Zealand": "38418865",
			"Lao People's Dem. Rep.": "221108",
			"Myanmar": "1184309",
			"Iran": "1570430",
			"Sao Tome and Principe": "285968",
			"Uruguay": "2220",
			"Andorra": "20919",
			"Cabo Verde": "935",
			"Germany": "100524841",
			"Timor-Leste": "1286",
			"Poland": "236929774",
			"Thailand": "84193323",
			"Argentina": "8181",
			"Brazil": "68950",
			"Brunei Darussalam": "51421",
			"Mongolia": "234",
			"Saudi Arabia": "641822",
			"Syria": "2133485",
			"Russian Federation": "266569",
			"Cayman Isds": "234",
			"United Arab Emirates": "81572",
			"Nicaragua": "117",
			"Malawi": "1552784",
			"Switzerland": "78393786",
			"El Salvador": "234",
			"United States Minor Outlying Islands": "467",
			"Sierra Leone": "56679",
			"Latvia": "84616959",
			"Japan": "1336350",
			"Guinea": "818",
			"Uganda": "1519",
			"Romania": "7636069",
			"Croatia": "728302",
			"China, Macao SAR": "21341749",
			"Guatemala": "17062",
			"Madagascar": "21036",
			"Bolivia (Plurinational State of)": "78884",
			"Nigeria": "7129",
			"Saint Kitts and Nevis": "34826",
			"Bahamas": "351",
			"San Marino": "9466",
			"Viet Nam": "9969276",
			"Haiti": "29801",
			"Tokelau": "1402",
			"Oman": "234",
			"Maldives": "117",
			"India": "13932749",
			"Jamaica": "803212",
			"Austria": "9680036",
			"Eritrea": "14725",
			"Zimbabwe": "234",
			"Vanuatu": "351",
			"Swaziland": "935",
			"Lithuania": "77085951",
			"Cambodia": "4796719",
			"Denmark": "4911948",
			"Portugal": "37395830",
			"Central African Rep.": "351",
			"Netherlands": "891847864",
			"Costa Rica": "31097046",
			"Equatorial Guinea": "24892",
			"Greece": "55068139",
			"Kazakhstan": "8759140",
			"Afghanistan": "50953",
			"Egypt": "3760478",
			"Nauru": "7830",
			"Anguilla": "15660",
			"Estonia": "11743402",
			"Morocco": "351",
			"Luxembourg": "21854",
			"TFYR of Macedonia": "3386394",
			"Somalia": "1870",
			"Heard Island and McDonald Islands": "61237",
			"United Rep. of Tanzania": "701",
			"Finland": "101307135",
			"Belize": "5376",
			"Georgia": "1636",
			"Ukraine": "156599",
			"Bermuda": "1988339",
			"Djibouti": "117",
			"Greenland": "467",
			"China, Hong Kong SAR": "2038591",
			"Suriname": "1402",
			"Barbados": "87649",
			"Samoa": "81689",
			"Venezuela": "351",
			"Kuwait": "117",
			"Norway": "840036165",
			"Pitcairn": "234",
			"Marshall Isds": "134278",
			"Philippines": "4063860",
			"Libya": "3740",
			"Kyrgyzstan": "14842",
			"Czechia": "1636",
			"Br. Indian Ocean Terr.": "8181",
			"Mozambique": "276035",
			"Togo": "117",
			"Aruba": "3506",
			"Turkey": "316236",
			"Tunisia": "10750401",
			"Rep. of Korea": "1215161",
			"Serbia": "4030319",
			"Burundi": "935",
			"Bhutan": "117",
			"Cook Isds": "71404",
			"Canada": "309809",
			"Iceland": "11805925"
		},
		"exports": {
			"Lebanon": "25844",
			"Bonaire": "68176",
			"Gibraltar": "121856515",
			"Ghana": "713800",
			"Lesotho": "1286",
			"Qatar": "568327",
			"Dem. Rep. of the Congo": "468",
			"Dem. People's Rep. of Korea": "234",
			"Cameroon": "631240",
			"South Africa": "5436993",
			"Montserrat": "208153",
			"Panama": "952006",
			"Colombia": "1052",
			"Niger": "21400",
			"Palau": "117",
			"Tonga": "3274",
			"Jordan": "68176",
			"Fr. South Antarctic Terr.": "162663",
			"Uzbekistan": "1100753",
			"Iraq": "3006285",
			"Tuvalu": "17658",
			"Guam": "6198",
			"Bosnia Herzegovina": "5730",
			"Pakistan": "192366",
			"Belgium": "2282428",
			"Azerbaijan": "32743",
			"Armenia": "21985",
			"United Kingdom": "1285931993",
			"Singapore": "6869738",
			"Albania": "3859",
			"Benin": "15787",
			"Antarctica": "41280",
			"FS Micronesia": "117",
			"Indonesia": "152255",
			"Cuba": "1520",
			"American Samoa": "21400",
			"Saint Vincent and the Grenadines": "117",
			"Curaçao": "74724",
			"Australia": "809456",
			"Kiribati": "1754",
			"Mexico": "711578",
			"Br. Virgin Isds": "8663826",
			"Spain": "66651051",
			"Tajikistan": "585",
			"Kenya": "720114",
			"Botswana": "234",
			"South Sudan": "702",
			"French Polynesia": "1346093",
			"Mauritania": "35055707",
			"Christmas Isds": "936",
			"Honduras": "636269",
			"Saint Barthélemy": "3508",
			"Holy See (Vatican City State)": "585",
			"Ireland": "11011507",
			"Chile": "11811",
			"Gambia": "230137",
			"China, Macao SAR": "19763",
			"Dominica": "287905",
			"Malaysia": "350468",
			"Fiji": "2339",
			"Peru": "2234834",
			"Falkland Isds (Malvinas)": "7484",
			"Nepal": "639543",
			"China": "693101",
			"Comoros": "4327",
			"Guinea-Bissau": "354561",
			"Mali": "12746",
			"Trinidad and Tobago": "15202",
			"Israel": "7436311",
			"Burkina Faso": "11811",
			"Paraguay": "870265",
			"Bangladesh": "542132",
			"Antigua and Barbuda": "92499",
			"Gabon": "5262",
			"Cyprus": "62797",
			"Yemen": "171784",
			"Mauritius": "117",
			"Slovakia": "10838670",
			"Faeroe Isds": "40110",
			"Turkmenistan": "1169",
			"Bahrain": "585",
			"Côte d'Ivoire": "697662",
			"Guyana": "910726",
			"Saint Pierre and Miquelon": "234",
			"Algeria": "7414443",
			"USA": "77504339",
			"Namibia": "138340",
			"Rep. of Moldova": "6198",
			"Zambia": "220080",
			"Malta": "50976575",
			"Ecuador": "702",
			"Grenada": "377130",
			"Dominican Rep.": "16138",
			"France": "15903093",
			"New Caledonia": "581892",
			"Niue": "117",
			"Seychelles": "117",
			"Italy": "65224153",
			"Saint Lucia": "181841",
			"State of Palestine": "112964",
			"Nicaragua": "23622",
			"Syria": "1973591",
			"Belarus": "117",
			"Ethiopia": "4093",
			"Slovenia": "2988627",
			"Congo": "1754",
			"Senegal": "533713",
			"Bulgaria": "514885",
			"Montenegro": "3742",
			"Sri Lanka": "936",
			"Hungary": "9298341",
			"Angola": "468",
			"N. Mariana Isds": "117",
			"Lao People's Dem. Rep.": "219964",
			"Myanmar": "2131342",
			"Iran": "1015855",
			"Sao Tome and Principe": "6315",
			"Uruguay": "595691",
			"Andorra": "28650",
			"Cabo Verde": "1520",
			"Germany": "32860047",
			"Timor-Leste": "234",
			"Poland": "175137737",
			"Bouvet Island": "166054",
			"Thailand": "2474093",
			"Argentina": "79168",
			"Brazil": "47010",
			"Brunei Darussalam": "49816",
			"Mongolia": "936",
			"Saudi Arabia": "5714608",
			"Sudan": "144304",
			"Russian Federation": "47984556",
			"Cayman Isds": "240311",
			"United Arab Emirates": "44088711",
			"Rwanda": "117",
			"Malawi": "1548398",
			"Switzerland": "29203344",
			"El Salvador": "1286",
			"United States Minor Outlying Islands": "2105",
			"Latvia": "34294897",
			"Japan": "1209390",
			"Guinea": "107234",
			"Uganda": "153893",
			"Romania": "19850860",
			"Croatia": "38239",
			"Liberia": "34029",
			"Mozambique": "960309",
			"Madagascar": "107701",
			"Bolivia (Plurinational State of)": "27364",
			"Barbados": "819",
			"Saint Kitts and Nevis": "67357",
			"Bahamas": "585",
			"Tunisia": "87120",
			"Chad": "233762",
			"Viet Nam": "439225",
			"Haiti": "95072",
			"Tokelau": "18476",
			"Afghanistan": "594054",
			"Oman": "32743",
			"Maldives": "3443406",
			"India": "3519767",
			"Jamaica": "4444",
			"Austria": "859273",
			"Eritrea": "117",
			"Zimbabwe": "107117",
			"Saint Maarten": "358069",
			"Swaziland": "2222",
			"Lithuania": "76903620",
			"Cambodia": "223706",
			"Denmark": "13528633",
			"Portugal": "12380169",
			"Central African Rep.": "16138",
			"Netherlands": "89367401",
			"Costa Rica": "3040",
			"Equatorial Guinea": "184999",
			"Greece": "21785393",
			"Papua New Guinea": "3040",
			"Kazakhstan": "31340",
			"Vanuatu": "3859",
			"Saint Helena": "181256",
			"Egypt": "218443",
			"Nauru": "819",
			"Anguilla": "117",
			"Estonia": "277030",
			"Morocco": "78561941",
			"Luxembourg": "7601",
			"TFYR of Macedonia": "52389",
			"Somalia": "117",
			"Heard Island and McDonald Islands": "234",
			"Western Sahara": "12980",
			"United Rep. of Tanzania": "30287",
			"Finland": "22283205",
			"Belize": "256098",
			"Georgia": "117",
			"Ukraine": "2393287",
			"Bermuda": "1871",
			"Djibouti": "1520",
			"Greenland": "85600",
			"China, Hong Kong SAR": "15485151",
			"Suriname": "213181",
			"Nigeria": "4521823",
			"Samoa": "206983",
			"Venezuela": "90745",
			"Kuwait": "45840",
			"New Zealand": "9782003",
			"Norway": "642260032",
			"Sierra Leone": "113899",
			"Marshall Isds": "4210",
			"Philippines": "3620452",
			"Libya": "130154",
			"Kyrgyzstan": "43618",
			"Czechia": "211310",
			"Guatemala": "256683",
			"Togo": "30053",
			"Aruba": "350117",
			"Turkey": "6763907",
			"San Marino": "117",
			"Rep. of Korea": "1037138",
			"Serbia": "1248214",
			"Burundi": "75777",
			"Bhutan": "9823",
			"Cook Isds": "936",
			"Canada": "927215",
			"Iceland": "17675431"
		}
	},
	"Maldives": {
		"imports": {
			"Lebanon": "6",
			"Ghana": "1932",
			"Uruguay": "211055",
			"Germany": "331916",
			"Poland": "9129837",
			"Cuba": "11912",
			"Thailand": "645804",
			"Argentina": "10688",
			"Brazil": "46221",
			"Brunei Darussalam": "538",
			"Iran": "476",
			"Saudi Arabia": "1144906",
			"Panama": "219863",
			"Colombia": "13413",
			"Russian Federation": "494404",
			"United Arab Emirates": "170322150",
			"Nicaragua": "542",
			"Jordan": "21591",
			"Switzerland": "355379",
			"Slovakia": "5070",
			"Latvia": "9309",
			"Japan": "7733725",
			"Romania": "69051",
			"Pakistan": "54080",
			"Belgium": "104527",
			"Slovenia": "2823",
			"Mozambique": "1832",
			"United Kingdom": "212660",
			"Singapore": "24796915",
			"Barbados": "1050",
			"Bahamas": "48635",
			"Tunisia": "110596",
			"Viet Nam": "3413443",
			"South Africa": "4271770",
			"Indonesia": "1241058",
			"Qatar": "4835390",
			"Oman": "2091010",
			"Sweden": "149457",
			"Australia": "578822",
			"India": "40223779",
			"Jamaica": "46379",
			"Mexico": "15",
			"Kenya": "103",
			"Austria": "43383",
			"Tajikistan": "339",
			"Ireland": "6",
			"China, Hong Kong SAR": "44935",
			"Spain": "1563902",
			"Swaziland": "2039",
			"Lithuania": "9270",
			"Cambodia": "91139",
			"Denmark": "525",
			"Peru": "4884",
			"Netherlands": "234047",
			"Costa Rica": "7599",
			"Turkey": "2793",
			"Greece": "11404",
			"Chile": "1041",
			"Croatia": "3344",
			"Gambia": "391",
			"Liberia": "3800",
			"Afghanistan": "3421",
			"Malaysia": "296901",
			"Fiji": "35131",
			"Portugal": "502788",
			"Falkland Isds (Malvinas)": "132",
			"Nepal": "16888",
			"China": "2231486",
			"Egypt": "2706058",
			"Anguilla": "18",
			"Estonia": "937",
			"Morocco": "3069",
			"Mali": "113",
			"Israel": "2700",
			"Paraguay": "79727",
			"Bangladesh": "43749",
			"United Rep. of Tanzania": "26099",
			"Finland": "4805",
			"Cyprus": "1172970",
			"Zambia": "220",
			"Mauritius": "5531",
			"Ukraine": "642461",
			"Bermuda": "1581",
			"Luxembourg": "381",
			"Bahrain": "5415",
			"Côte d'Ivoire": "50",
			"Guyana": "180975",
			"USA": "695244",
			"Rep. of Moldova": "74",
			"Kuwait": "2800",
			"Malta": "498",
			"Norway": "3216",
			"Ecuador": "8683",
			"Serbia": "2009",
			"Sierra Leone": "2488",
			"Dominican Rep.": "674",
			"France": "78433",
			"Philippines": "225006",
			"Seychelles": "2977",
			"Italy": "40066",
			"Czechia": "235",
			"Uganda": "154",
			"Guatemala": "548",
			"Ethiopia": "414",
			"Bulgaria": "304",
			"Sri Lanka": "431154",
			"Rep. of Korea": "30813",
			"Hungary": "464",
			"New Zealand": "524340",
			"Canada": "90594",
			"Iceland": "170",
			"Lao People's Dem. Rep.": "73013",
			"Myanmar": "322"
		},
		"exports": {
			"USA": "1014903",
			"Greece": "679",
			"United Kingdom": "259157",
			"Singapore": "39259",
			"Germany": "262608",
			"Norway": "37291",
			"Poland": "234882",
			"Qatar": "3301",
			"Viet Nam": "306401",
			"Seychelles": "3278",
			"Malaysia": "2035",
			"France": "5134721",
			"Portugal": "33202",
			"Sri Lanka": "691919",
			"Philippines": "304277",
			"China": "376",
			"Indonesia": "112159",
			"Saudi Arabia": "449",
			"Italy": "750565",
			"Czechia": "23370",
			"Australia": "500848",
			"United Arab Emirates": "577196",
			"India": "1558397",
			"Bangladesh": "43742",
			"Ireland": "62964",
			"Switzerland": "4190205",
			"Thailand": "48044011",
			"Finland": "240465",
			"Rep. of Korea": "355953",
			"Spain": "1930949",
			"Ukraine": "151",
			"Netherlands": "231675",
			"Denmark": "5275",
			"Canada": "237973",
			"Bahrain": "3345",
			"China, Hong Kong SAR": "1539352",
			"Belgium": "46808",
			"Japan": "2670848"
		}
	},
	"India": {
		"imports": {
			"Lebanon": "166499",
			"Ghana": "2648",
			"Lesotho": "67348",
			"Qatar": "1711855648",
			"Dem. Rep. of the Congo": "462216",
			"Dem. People's Rep. of Korea": "4499",
			"Cameroon": "1020",
			"South Africa": "65709055",
			"Montserrat": "41",
			"Panama": "26925",
			"Colombia": "21255361",
			"Niger": "13995",
			"Tonga": "49521",
			"Angola": "109374975",
			"Uzbekistan": "18134595",
			"Iraq": "16529852",
			"Tuvalu": "76667",
			"Bosnia Herzegovina": "2997",
			"Pakistan": "1650845",
			"Belgium": "60489",
			"Azerbaijan": "274663605",
			"Rwanda": "432214",
			"Armenia": "162",
			"United Kingdom": "1436096",
			"Singapore": "2449",
			"Albania": "27752",
			"Benin": "7434366",
			"Antarctica": "494612",
			"Indonesia": "313871",
			"Cuba": "608421",
			"Dominican Rep.": "11929784",
			"Curaçao": "101059871",
			"Australia": "34580",
			"Bahrain": "10299448",
			"Jamaica": "11319",
			"Kenya": "797358",
			"Spain": "4273614",
			"Tajikistan": "7871",
			"Ireland": "22425",
			"Botswana": "2684",
			"South Sudan": "48673",
			"French Polynesia": "4359",
			"Mauritania": "390",
			"Christmas Isds": "17564",
			"Honduras": "10588835",
			"Cambodia": "2019455",
			"Holy See (Vatican City State)": "62",
			"Chile": "85",
			"Gambia": "39435817",
			"China, Macao SAR": "199638",
			"Dominica": "2923",
			"Malaysia": "3807612",
			"Swaziland": "7235",
			"Somalia": "16243379",
			"Nepal": "104889309",
			"China": "33725892",
			"Comoros": "22955719",
			"Guinea-Bissau": "209389647",
			"Mali": "1884910",
			"Trinidad and Tobago": "139336586",
			"Israel": "8940",
			"Burkina Faso": "37847903",
			"Paraguay": "152188895",
			"Norfolk Isds": "7562",
			"Bangladesh": "6680751",
			"Antigua and Barbuda": "1590",
			"Gabon": "52812",
			"Cyprus": "54565690",
			"Yemen": "120639",
			"Mauritius": "1603",
			"Slovakia": "386334",
			"Faeroe Isds": "2266",
			"Turkmenistan": "3231927",
			"Syria": "15971590",
			"Côte d'Ivoire": "412505",
			"Guyana": "80339",
			"Algeria": "56890154",
			"USA": "13807005",
			"Saint Kitts and Nevis": "7308",
			"Rep. of Moldova": "1556882",
			"Zambia": "823",
			"Malta": "490983",
			"Ecuador": "107616",
			"Portugal": "371905",
			"France": "131439",
			"New Caledonia": "220",
			"Seychelles": "1028",
			"Br. Virgin Isds": "1513",
			"Italy": "1957650",
			"Saint Lucia": "361055",
			"Uganda": "2071",
			"Belarus": "1641126",
			"Ethiopia": "290",
			"Pitcairn": "2825",
			"Senegal": "51130307",
			"Bulgaria": "40",
			"Montenegro": "15760",
			"Sri Lanka": "9321050",
			"Hungary": "78500",
			"Jordan": "14824",
			"N. Mariana Isds": "29273",
			"Lao People's Dem. Rep.": "761",
			"Myanmar": "21493",
			"Iran": "2195",
			"Philippines": "12055",
			"Uruguay": "31900",
			"Andorra": "6",
			"Cabo Verde": "6817",
			"Germany": "1520881",
			"Timor-Leste": "31191",
			"Poland": "35451",
			"Thailand": "2454387",
			"Argentina": "1503416",
			"Brazil": "27606",
			"Brunei Darussalam": "90466",
			"Mongolia": "2213",
			"Saudi Arabia": "12113291768",
			"Greece": "188022",
			"Russian Federation": "373249682",
			"Cayman Isds": "278",
			"United Arab Emirates": "1169185965",
			"Nicaragua": "21818",
			"Malawi": "12155",
			"Switzerland": "4187206",
			"El Salvador": "292",
			"United States Minor Outlying Islands": "16474",
			"Latvia": "55",
			"Japan": "9267760",
			"Guinea": "65098",
			"Romania": "829",
			"Slovenia": "2022",
			"Liberia": "45109",
			"Guatemala": "46084",
			"Madagascar": "87895942",
			"Bolivia (Plurinational State of)": "542969",
			"Nigeria": "6605762919",
			"Bahamas": "35781",
			"Tunisia": "2065919",
			"Chad": "23467",
			"Viet Nam": "1346035",
			"Haiti": "143414",
			"Tokelau": "463",
			"Oman": "119105904",
			"Sweden": "1651071",
			"Maldives": "3529037",
			"Mexico": "1479609717",
			"Austria": "164968",
			"Eritrea": "1873399",
			"Congo": "511092",
			"Zimbabwe": "271269",
			"Vanuatu": "248130",
			"Fiji": "152",
			"Lithuania": "294",
			"Namibia": "10394",
			"Denmark": "152269",
			"Peru": "20268350",
			"Central African Rep.": "34877",
			"Netherlands": "94495914",
			"Costa Rica": "451",
			"Equatorial Guinea": "361297133",
			"Sudan": "91730531",
			"Papua New Guinea": "2555751",
			"Kazakhstan": "888233",
			"Afghanistan": "204315144",
			"Croatia": "7986598",
			"American Samoa": "86",
			"Egypt": "5393",
			"Nauru": "127",
			"Anguilla": "1140",
			"Estonia": "4213",
			"Morocco": "441997",
			"Luxembourg": "14240",
			"TFYR of Macedonia": "17916",
			"Heard Island and McDonald Islands": "285",
			"United Rep. of Tanzania": "13313",
			"Finland": "19577162",
			"Belize": "128859",
			"Georgia": "211413",
			"Ukraine": "126",
			"Bermuda": "1813",
			"Djibouti": "116349",
			"Greenland": "5089",
			"China, Hong Kong SAR": "34883",
			"Suriname": "77863",
			"Barbados": "57810",
			"Samoa": "31309",
			"Venezuela": "206229",
			"Kuwait": "26870437",
			"New Zealand": "42456605",
			"Norway": "95620",
			"Sierra Leone": "260106",
			"Marshall Isds": "8538445",
			"Sao Tome and Principe": "20671",
			"Libya": "339",
			"Kyrgyzstan": "1312423",
			"Czechia": "3226",
			"Mozambique": "238209533",
			"Togo": "8694392",
			"Aruba": "3175248",
			"Turkey": "2701",
			"San Marino": "16202",
			"Rep. of Korea": "1851873",
			"Serbia": "72965",
			"Burundi": "5712",
			"Bhutan": "495144",
			"Canada": "24532",
			"Iceland": "181173"
		},
		"exports": {
			"Lebanon": "868802",
			"Gibraltar": "98400",
			"Ghana": "4145458",
			"Lesotho": "368",
			"Qatar": "6332",
			"Dem. Rep. of the Congo": "23088899",
			"Dem. People's Rep. of Korea": "2280047",
			"Cameroon": "1288484",
			"South Africa": "168314",
			"Montserrat": "1950",
			"Indonesia": "2891641",
			"Colombia": "190151787",
			"Niger": "623047",
			"Palau": "20882",
			"Tonga": "292521",
			"Jordan": "84619",
			"Uzbekistan": "1519010",
			"Iraq": "563753",
			"Tuvalu": "78281",
			"Guam": "65114",
			"Bosnia Herzegovina": "362279",
			"Pakistan": "14564",
			"Belgium": "9729392",
			"Azerbaijan": "38817",
			"Armenia": "50336",
			"Togo": "573",
			"Singapore": "157798570",
			"Albania": "3570923",
			"Benin": "1276556",
			"FS Micronesia": "6760",
			"Panama": "894005",
			"Cuba": "27470",
			"American Samoa": "10218",
			"Saint Vincent and the Grenadines": "36513",
			"Curaçao": "3474",
			"Australia": "8067463",
			"Kiribati": "7386",
			"Jamaica": "210863",
			"Kenya": "42299342",
			"Spain": "23912",
			"Tajikistan": "922520",
			"Ireland": "6802",
			"Botswana": "109002",
			"South Sudan": "5308",
			"French Polynesia": "46336",
			"Mauritania": "295",
			"Nicaragua": "7408385",
			"Honduras": "12155996",
			"Cambodia": "1230123",
			"United Kingdom": "25913615",
			"Chile": "5233993",
			"Gambia": "16004",
			"China, Macao SAR": "19017",
			"Brunei Darussalam": "87",
			"Malaysia": "456247",
			"Swaziland": "26176797",
			"Portugal": "645123",
			"Nepal": "21429060",
			"China": "1654457",
			"Comoros": "1838",
			"Guinea-Bissau": "234185",
			"Mali": "2481497",
			"Trinidad and Tobago": "4135",
			"Israel": "895914",
			"Burkina Faso": "5419581",
			"Paraguay": "1935289",
			"Norfolk Isds": "253334",
			"Bangladesh": "160364334",
			"Antigua and Barbuda": "216966",
			"Gabon": "218",
			"Cyprus": "110269",
			"Yemen": "216239",
			"Mauritius": "19272780",
			"Slovakia": "196",
			"Faeroe Isds": "19267",
			"Turkmenistan": "11432",
			"Bahrain": "360230",
			"Côte d'Ivoire": "1078519",
			"Guyana": "315645",
			"Algeria": "57092",
			"USA": "8059323",
			"Saint Kitts and Nevis": "1029472",
			"Rep. of Moldova": "293813",
			"Zambia": "3525917",
			"Malta": "2250",
			"Ecuador": "8164333",
			"Grenada": "1058726",
			"Dominican Rep.": "7980904",
			"France": "13412071",
			"New Caledonia": "29968",
			"Seychelles": "170152",
			"Br. Virgin Isds": "249688",
			"Italy": "2156700",
			"Saint Lucia": "1",
			"Uganda": "38682327",
			"Syria": "1619072",
			"Belarus": "50670",
			"Ethiopia": "29408737",
			"Sierra Leone": "9095152",
			"Senegal": "545400",
			"Bulgaria": "1015872",
			"Montenegro": "150785",
			"Sri Lanka": "208729400",
			"Hungary": "22",
			"Angola": "367493",
			"New Zealand": "1001262",
			"N. Mariana Isds": "216",
			"Lao People's Dem. Rep.": "412981",
			"Myanmar": "3575424",
			"Papua New Guinea": "4145",
			"Sao Tome and Principe": "212464",
			"Uruguay": "773679",
			"Andorra": "2182",
			"Cabo Verde": "2441",
			"Germany": "9363904",
			"Timor-Leste": "130692",
			"Poland": "2347224",
			"Thailand": "2620978",
			"Argentina": "39673529",
			"Brazil": "893639",
			"Dominica": "25408",
			"Mongolia": "68139",
			"Saudi Arabia": "300537",
			"Greece": "314276",
			"Russian Federation": "960600",
			"Cayman Isds": "23",
			"United Arab Emirates": "13832024",
			"Rwanda": "5310349",
			"Malawi": "1912774",
			"Switzerland": "513",
			"El Salvador": "5795483",
			"United States Minor Outlying Islands": "78725",
			"Latvia": "5809",
			"Japan": "7050967",
			"Guinea": "26534463",
			"Romania": "32034",
			"Slovenia": "269",
			"Liberia": "6239275",
			"Guatemala": "48090790",
			"Madagascar": "130808",
			"Bolivia (Plurinational State of)": "2367202",
			"Nigeria": "6691",
			"Bahamas": "12239",
			"Tunisia": "18136220",
			"Chad": "363601",
			"Viet Nam": "2503683",
			"Haiti": "778263",
			"Tokelau": "5278",
			"Oman": "9724",
			"Sweden": "104",
			"Maldives": "210808",
			"Mexico": "364104",
			"Austria": "26531650",
			"Eritrea": "12916",
			"Congo": "3013891",
			"Zimbabwe": "66466131",
			"Vanuatu": "17058",
			"Peru": "22719084",
			"Fiji": "135906",
			"Lithuania": "458",
			"Namibia": "4835242",
			"Denmark": "8345",
			"Somalia": "16854637",
			"Central African Rep.": "5418",
			"Netherlands": "260647",
			"Costa Rica": "4743898",
			"Equatorial Guinea": "169588",
			"Sudan": "115433",
			"Kazakhstan": "29240",
			"Afghanistan": "18765",
			"Croatia": "3739",
			"Saint Helena": "826",
			"Egypt": "18708395",
			"Nauru": "2996",
			"Anguilla": "11031",
			"Estonia": "1575366",
			"Morocco": "1224772",
			"Luxembourg": "2085",
			"TFYR of Macedonia": "30290",
			"Western Sahara": "1148",
			"United Rep. of Tanzania": "16860400",
			"Finland": "42298",
			"Belize": "1776",
			"Georgia": "5338",
			"Ukraine": "436615",
			"Bermuda": "60024",
			"Djibouti": "307540",
			"Greenland": "33",
			"China, Hong Kong SAR": "119139",
			"Suriname": "1760906",
			"Barbados": "43",
			"Samoa": "15985",
			"Iran": "48306884",
			"Venezuela": "4275",
			"Kuwait": "223006",
			"Norway": "8969",
			"Pitcairn": "5158",
			"Marshall Isds": "9739",
			"Philippines": "2082",
			"Libya": "7016565",
			"Kyrgyzstan": "972",
			"Czechia": "1274",
			"Mozambique": "6299467",
			"Aruba": "26351",
			"Turkey": "18283615",
			"San Marino": "5129",
			"Rep. of Korea": "1272039",
			"Serbia": "239",
			"Burundi": "1174530",
			"Bhutan": "621638",
			"Cook Isds": "89897",
			"Canada": "121374",
			"Iceland": "20070"
		}
	},
	"Mexico": {
		"imports": {
			"Lebanon": "17969",
			"Gibraltar": "54",
			"Ghana": "296164",
			"Lesotho": "190797",
			"Cuba": "220",
			"Dem. Rep. of the Congo": "3194",
			"Dem. People's Rep. of Korea": "170405",
			"Cameroon": "925",
			"South Africa": "360530",
			"Montserrat": "442",
			"Indonesia": "16",
			"Colombia": "5307235",
			"Niger": "50",
			"Palau": "46705",
			"Tonga": "4579",
			"Jordan": "221125",
			"Fr. South Antarctic Terr.": "334",
			"Uzbekistan": "3813",
			"Iraq": "142",
			"Tuvalu": "46",
			"Guam": "73",
			"Bosnia Herzegovina": "157888",
			"Pakistan": "488518",
			"Belgium": "5536848",
			"Azerbaijan": "560",
			"Rwanda": "296326",
			"Australia": "3057",
			"United Kingdom": "1792551",
			"Singapore": "3519712",
			"Albania": "10976",
			"Benin": "615",
			"FS Micronesia": "525",
			"Panama": "38642",
			"Qatar": "353",
			"Saint Vincent and the Grenadines": "359",
			"Curaçao": "42869",
			"Armenia": "12279",
			"Kiribati": "4820688",
			"Br. Virgin Isds": "2409",
			"Spain": "1498992",
			"Tajikistan": "10",
			"Ireland": "2925",
			"Botswana": "6525",
			"French Polynesia": "478",
			"Mauritania": "812",
			"Christmas Isds": "2573",
			"Honduras": "457526",
			"Holy See (Vatican City State)": "37",
			"Chile": "2081387",
			"Sudan": "9263170",
			"Gambia": "6965",
			"Liberia": "1898586",
			"Brunei Darussalam": "66",
			"Malaysia": "147232",
			"Fiji": "13623",
			"Portugal": "1896903",
			"Falkland Isds (Malvinas)": "8",
			"Nepal": "542005",
			"China": "35952698",
			"Comoros": "309630",
			"Guinea-Bissau": "143",
			"Mali": "1049917",
			"Trinidad and Tobago": "1",
			"Israel": "164234",
			"Burkina Faso": "415",
			"Kazakhstan": "557",
			"Paraguay": "23",
			"Norfolk Isds": "50",
			"Bangladesh": "1440656",
			"Antigua and Barbuda": "471",
			"Gabon": "7826624",
			"Cyprus": "179615",
			"Yemen": "55834",
			"Mauritius": "221072",
			"Slovakia": "90419",
			"Turkmenistan": "725",
			"Bahrain": "2100780",
			"Côte d'Ivoire": "494488",
			"Guyana": "2627082",
			"Saint Pierre and Miquelon": "6",
			"Algeria": "578722",
			"USA": "95233343",
			"Namibia": "23231956",
			"Rep. of Moldova": "41473",
			"Zambia": "724",
			"Malta": "408",
			"Ecuador": "28162",
			"Grenada": "451",
			"Dominican Rep.": "5367405",
			"France": "53464703",
			"New Caledonia": "49471",
			"Niue": "34",
			"Seychelles": "225631",
			"Italy": "2705",
			"Saint Lucia": "6872",
			"State of Palestine": "220",
			"Uganda": "1628",
			"Belarus": "28520",
			"Ethiopia": "30",
			"Congo": "3599371",
			"Senegal": "9745637",
			"Bulgaria": "3936",
			"Montenegro": "16235",
			"Sri Lanka": "444",
			"Hungary": "171393",
			"Angola": "1147",
			"New Zealand": "190554",
			"N. Mariana Isds": "756",
			"Lao People's Dem. Rep.": "320184",
			"Myanmar": "12005",
			"Iran": "990",
			"Sao Tome and Principe": "823",
			"Uruguay": "52593",
			"Andorra": "78655",
			"Cabo Verde": "34",
			"Germany": "12540",
			"Timor-Leste": "12",
			"Poland": "24952527",
			"Thailand": "8365138",
			"Argentina": "226333162",
			"Brazil": "259124601",
			"Dominica": "52248",
			"Mongolia": "2611",
			"Saudi Arabia": "711598",
			"Syria": "2131",
			"Russian Federation": "16622024",
			"Cayman Isds": "88412",
			"United Arab Emirates": "19943",
			"Nicaragua": "6855",
			"Malawi": "118868",
			"Switzerland": "67875",
			"El Salvador": "107",
			"Sierra Leone": "7214291",
			"Latvia": "3882111",
			"Japan": "265",
			"Guinea": "716",
			"Romania": "46045",
			"Croatia": "64280",
			"China, Macao SAR": "60",
			"Mozambique": "113",
			"Madagascar": "647928",
			"Bolivia (Plurinational State of)": "45260",
			"Barbados": "18638",
			"Saint Kitts and Nevis": "2833",
			"Bahamas": "4758",
			"Tunisia": "230",
			"Chad": "63",
			"Viet Nam": "202716",
			"Haiti": "53723",
			"Tokelau": "5787",
			"Oman": "361",
			"Sweden": "27924",
			"Maldives": "1035",
			"India": "5854307",
			"Jamaica": "6856",
			"Austria": "5850152",
			"Eritrea": "68",
			"Zimbabwe": "255532",
			"Vanuatu": "8",
			"Swaziland": "14702",
			"Lithuania": "134421",
			"Cambodia": "505559",
			"Denmark": "556631",
			"Peru": "3524504",
			"Central African Rep.": "669",
			"Netherlands": "1547072",
			"Costa Rica": "482",
			"Equatorial Guinea": "22283142",
			"Greece": "7230367",
			"Papua New Guinea": "573",
			"Slovenia": "980909",
			"Kenya": "4",
			"Afghanistan": "79014",
			"Saint Helena": "3457",
			"Egypt": "618929",
			"Nauru": "7188",
			"Anguilla": "21791",
			"Estonia": "2169342",
			"Morocco": "113113",
			"Luxembourg": "965865",
			"TFYR of Macedonia": "49108",
			"Somalia": "316754",
			"Heard Island and McDonald Islands": "146",
			"Western Sahara": "18537",
			"United Rep. of Tanzania": "586",
			"Finland": "10477364",
			"Belize": "11509",
			"Georgia": "549",
			"Ukraine": "8417",
			"Bermuda": "14231",
			"Djibouti": "400325",
			"China, Hong Kong SAR": "75086",
			"Suriname": "1166",
			"Nigeria": "58646",
			"Samoa": "587",
			"Venezuela": "7075",
			"Kuwait": "141",
			"Norway": "360",
			"Pitcairn": "8099",
			"Marshall Isds": "936",
			"Philippines": "85506689",
			"Libya": "14072",
			"Kyrgyzstan": "10909",
			"Czechia": "356954",
			"Br. Indian Ocean Terr.": "2878",
			"Guatemala": "997160",
			"Togo": "60",
			"Aruba": "255149",
			"Turkey": "923",
			"San Marino": "5967",
			"Rep. of Korea": "8566",
			"Serbia": "4233",
			"Burundi": "1129",
			"Bhutan": "23",
			"Cook Isds": "13910",
			"Canada": "74984405",
			"Iceland": "240"
		},
		"exports": {
			"Lebanon": "95467",
			"Gibraltar": "35577",
			"Ghana": "95469",
			"Cuba": "1149288",
			"Dem. Rep. of the Congo": "595",
			"Dem. People's Rep. of Korea": "274",
			"Cameroon": "1107327",
			"Papua New Guinea": "152",
			"Montserrat": "16324",
			"Indonesia": "74420",
			"Colombia": "119978500",
			"Niger": "35400",
			"Tonga": "464",
			"Angola": "8999",
			"Uzbekistan": "563",
			"Iraq": "468",
			"Guam": "186886",
			"Bosnia Herzegovina": "2118",
			"Pakistan": "3957",
			"Belgium": "17744975",
			"Azerbaijan": "68834",
			"Pitcairn": "3290",
			"Armenia": "12054",
			"United Kingdom": "59014",
			"Singapore": "3089863",
			"Albania": "15288",
			"Benin": "176022",
			"FS Micronesia": "157094",
			"Panama": "64056165",
			"Qatar": "1163240",
			"Saint Vincent and the Grenadines": "703825",
			"Curaçao": "1411238",
			"Australia": "18605143",
			"Slovenia": "591147",
			"Br. Virgin Isds": "60340",
			"Spain": "140530",
			"Tajikistan": "27897",
			"Ireland": "271",
			"Botswana": "2",
			"French Polynesia": "255080",
			"Mauritania": "97551",
			"Honduras": "32206178",
			"Holy See (Vatican City State)": "100",
			"Jordan": "349743",
			"Chile": "231844959",
			"Gambia": "194318",
			"Liberia": "1138102",
			"Brunei Darussalam": "2017",
			"Malaysia": "24606",
			"Fiji": "147727",
			"Portugal": "111680559",
			"Nepal": "85752",
			"China": "21762677",
			"Comoros": "347",
			"Guinea-Bissau": "88018",
			"Mali": "70162",
			"Trinidad and Tobago": "3442791",
			"Israel": "23039073",
			"Burkina Faso": "7332",
			"Paraguay": "4424711",
			"Norfolk Isds": "126",
			"Bangladesh": "258",
			"Antigua and Barbuda": "10000",
			"Gabon": "16660",
			"Cyprus": "291437",
			"Yemen": "12549",
			"Mauritius": "4499",
			"Slovakia": "24231",
			"Turkmenistan": "258717",
			"Bahrain": "477680",
			"Côte d'Ivoire": "2055157",
			"Guyana": "67499",
			"Saint Pierre and Miquelon": "4192",
			"Algeria": "234160",
			"USA": "389526019",
			"Saint Kitts and Nevis": "769599",
			"Rep. of Moldova": "88828",
			"Zambia": "95460",
			"Malta": "9416",
			"Ecuador": "1433486",
			"Grenada": "18463",
			"Dominican Rep.": "42114063",
			"France": "433501322",
			"New Caledonia": "18197",
			"Seychelles": "42366",
			"Italy": "553923225",
			"Saint Lucia": "248854",
			"State of Palestine": "345463",
			"Rwanda": "4357",
			"Syria": "11121",
			"Belarus": "16238",
			"Ethiopia": "32",
			"Namibia": "281791",
			"Congo": "885181",
			"Senegal": "438910",
			"Bulgaria": "27848",
			"Montenegro": "9953",
			"Sri Lanka": "169663",
			"Hungary": "33295",
			"New Zealand": "21746335",
			"N. Mariana Isds": "1459",
			"Lao People's Dem. Rep.": "27642",
			"Myanmar": "994905",
			"South Africa": "1238441",
			"Sao Tome and Principe": "2239",
			"Uruguay": "248824",
			"Andorra": "1824",
			"Cabo Verde": "275",
			"Germany": "8039123",
			"Poland": "27909991",
			"Thailand": "2058612",
			"Argentina": "77575295",
			"Brazil": "18560721",
			"Dominica": "2647196",
			"Mongolia": "74640",
			"Saudi Arabia": "1945224",
			"Sudan": "77749",
			"Russian Federation": "2766401",
			"Cayman Isds": "26",
			"United Arab Emirates": "2446549",
			"Nicaragua": "74331280",
			"Malawi": "764597",
			"Switzerland": "23847",
			"El Salvador": "21058931",
			"Latvia": "345549",
			"Japan": "1258188902",
			"Guinea": "179760",
			"Uganda": "202917",
			"Romania": "155",
			"Croatia": "828767",
			"China, Macao SAR": "9902",
			"Mozambique": "473756",
			"Madagascar": "51397",
			"Bolivia (Plurinational State of)": "11466277",
			"Barbados": "130351",
			"Bahamas": "376873",
			"Tunisia": "5635",
			"Chad": "49073",
			"Viet Nam": "175576",
			"Haiti": "1379046",
			"Oman": "10975118",
			"Sweden": "106025",
			"Maldives": "195740",
			"India": "232501",
			"Jamaica": "105766220",
			"Austria": "295049",
			"Eritrea": "147136",
			"Zimbabwe": "56953372",
			"Vanuatu": "5",
			"Swaziland": "41999",
			"Lithuania": "179",
			"Cambodia": "199",
			"Denmark": "61607",
			"Peru": "2314",
			"Central African Rep.": "140840",
			"Netherlands": "152296213",
			"Costa Rica": "63536098",
			"Equatorial Guinea": "188265",
			"Greece": "173350",
			"Kazakhstan": "975",
			"Kenya": "6203",
			"Afghanistan": "1199",
			"Saint Helena": "1",
			"Egypt": "231627",
			"Anguilla": "49151",
			"Estonia": "373265",
			"Morocco": "81931",
			"Luxembourg": "69021",
			"Venezuela": "22744",
			"Somalia": "253100",
			"United Rep. of Tanzania": "4824444",
			"Finland": "3475174",
			"Belize": "3481286",
			"Georgia": "792",
			"Ukraine": "1878356",
			"Bermuda": "7200",
			"Djibouti": "22186",
			"China, Hong Kong SAR": "34042",
			"Suriname": "140239",
			"Nigeria": "50580",
			"Samoa": "9132",
			"Iran": "380",
			"TFYR of Macedonia": "357623",
			"Kuwait": "2802592",
			"Norway": "186717",
			"Sierra Leone": "267658",
			"Marshall Isds": "325693",
			"Philippines": "34884",
			"Libya": "476588",
			"Czechia": "171712",
			"Guatemala": "463565",
			"Togo": "36239",
			"Aruba": "626751",
			"Turkey": "1211518",
			"Rep. of Korea": "971465660",
			"Serbia": "1795974",
			"Bhutan": "56077",
			"Canada": "1284554888",
			"Iceland": "5081"
		}
	},
	"Austria": {
		"imports": {},
		"exports": {}
	},
	"Bouvet Island": {
		"imports": {},
		"exports": {}
	},
	"Zimbabwe": {
		"imports": {
			"Lebanon": "169",
			"Ghana": "74",
			"Philippines": "1371",
			"Lesotho": "940250",
			"Switzerland": "41",
			"Germany": "33304",
			"Timor-Leste": "1736",
			"Poland": "40",
			"Qatar": "15339",
			"Dem. Rep. of the Congo": "384",
			"Thailand": "32411697",
			"Dem. People's Rep. of Korea": "48",
			"Argentina": "275",
			"Brazil": "1323497",
			"Cameroon": "2190",
			"Iran": "1413",
			"Saudi Arabia": "135579",
			"Panama": "1233101",
			"Colombia": "40",
			"Sudan": "664",
			"Niger": "29782",
			"Cayman Isds": "82",
			"United Arab Emirates": "5447",
			"Rwanda": "512",
			"Yemen": "92",
			"Angola": "117",
			"Malawi": "968",
			"Andorra": "50615",
			"Mauritius": "5411419",
			"Uruguay": "125312",
			"Ukraine": "3536755",
			"Iraq": "50",
			"Japan": "1624",
			"Guinea": "61",
			"Bosnia Herzegovina": "776",
			"Pakistan": "14150180",
			"Belgium": "69",
			"Azerbaijan": "49",
			"China, Macao SAR": "8276",
			"Mozambique": "33745749",
			"Madagascar": "32176",
			"Bolivia (Plurinational State of)": "22",
			"Barbados": "6118",
			"Tunisia": "33252",
			"Viet Nam": "43047",
			"United Kingdom": "31687",
			"South Africa": "152569019",
			"Tokelau": "711",
			"Indonesia": "33390",
			"American Samoa": "135",
			"Somalia": "440",
			"Oman": "556",
			"Curaçao": "77047",
			"Australia": "7782572",
			"India": "4577696",
			"Jamaica": "2259",
			"Mexico": "3227",
			"Kenya": "2609526",
			"Austria": "198",
			"Romania": "468",
			"Br. Virgin Isds": "157268",
			"Botswana": "1333",
			"Côte d'Ivoire": "68110",
			"Spain": "1458",
			"Mauritania": "300",
			"Swaziland": "5685029",
			"Lithuania": "6139412",
			"Namibia": "9511",
			"Denmark": "10247",
			"USA": "88090",
			"Peru": "636708",
			"Syria": "998",
			"Netherlands": "331218",
			"Turkey": "58634",
			"Equatorial Guinea": "183",
			"Greece": "952",
			"Kazakhstan": "1479",
			"Gambia": "43268",
			"Liberia": "31",
			"Nepal": "9416",
			"Afghanistan": "1695",
			"Sweden": "6581",
			"Malaysia": "20",
			"Fiji": "1540",
			"Portugal": "3145",
			"United Rep. of Tanzania": "258",
			"Jordan": "4291",
			"China": "2788",
			"Egypt": "6815620",
			"Estonia": "32",
			"Morocco": "14",
			"Mali": "58",
			"Israel": "303199",
			"Venezuela": "229",
			"Saint Helena": "77",
			"Singapore": "483363",
			"Paraguay": "443286",
			"Bangladesh": "18048",
			"Antigua and Barbuda": "22",
			"Gabon": "57336",
			"Finland": "1499385",
			"Cyprus": "324662",
			"Zambia": "7599",
			"Georgia": "80",
			"Slovakia": "3105",
			"Bermuda": "84",
			"Djibouti": "102",
			"Bahrain": "12031",
			"China, Hong Kong SAR": "1632858",
			"Russian Federation": "12947",
			"Algeria": "3226",
			"Ireland": "4430",
			"Cambodia": "34",
			"Rep. of Moldova": "235",
			"Kuwait": "2899",
			"Malta": "103",
			"Norway": "173496",
			"Ecuador": "60",
			"Serbia": "198",
			"Sierra Leone": "54",
			"France": "1045133",
			"New Caledonia": "17296",
			"Luxembourg": "96",
			"Latvia": "19808",
			"Seychelles": "11635",
			"Italy": "2394",
			"Czechia": "260",
			"Uganda": "259",
			"Nigeria": "333199",
			"Belarus": "5400",
			"Ethiopia": "29",
			"Slovenia": "241",
			"Congo": "1661",
			"Senegal": "230",
			"Aruba": "18013",
			"Bulgaria": "65422",
			"Sri Lanka": "70415",
			"Rep. of Korea": "13529",
			"Hungary": "47069",
			"Burundi": "90",
			"Bhutan": "147",
			"New Zealand": "282098",
			"Canada": "3581214",
			"Iceland": "13",
			"Lao People's Dem. Rep.": "17096"
		},
		"exports": {
			"Lebanon": "6853",
			"Ghana": "910",
			"Lesotho": "15",
			"Germany": "1755710",
			"Poland": "26450",
			"Dem. Rep. of the Congo": "20350",
			"Thailand": "420",
			"Argentina": "24770",
			"Brazil": "1826",
			"Iran": "12",
			"Saudi Arabia": "36890",
			"Panama": "1650",
			"Colombia": "138546",
			"Sudan": "334153",
			"Russian Federation": "147547",
			"United Arab Emirates": "12877",
			"Rwanda": "40773",
			"Italy": "76",
			"Malawi": "777752",
			"Switzerland": "36300",
			"Iraq": "86093",
			"Japan": "918",
			"Bosnia Herzegovina": "680",
			"Pakistan": "10200",
			"Belgium": "159",
			"Madagascar": "24150",
			"Singapore": "965239",
			"Nigeria": "41738",
			"Benin": "60247",
			"Tunisia": "797680",
			"Chad": "1151",
			"Viet Nam": "17",
			"Haiti": "550",
			"South Africa": "6379571",
			"Indonesia": "52",
			"Sweden": "4239",
			"Australia": "2000",
			"India": "3819",
			"Jamaica": "1905",
			"Kenya": "367",
			"Spain": "77450",
			"Ireland": "91211",
			"Botswana": "392531",
			"Côte d'Ivoire": "5",
			"Austria": "175856",
			"United Kingdom": "7764",
			"Denmark": "14",
			"Netherlands": "60",
			"Turkey": "38212",
			"Greece": "7",
			"Chile": "4",
			"Afghanistan": "23985",
			"Swaziland": "145510",
			"Somalia": "8",
			"China": "1",
			"Egypt": "155900",
			"Morocco": "16036",
			"Mali": "6392",
			"Israel": "1160224",
			"Paraguay": "1",
			"Bangladesh": "750",
			"Western Sahara": "8288",
			"United Rep. of Tanzania": "12306",
			"Cyprus": "10000",
			"Mauritius": "129086",
			"Ukraine": "45217",
			"Bermuda": "825",
			"China, Hong Kong SAR": "500",
			"USA": "12659",
			"Namibia": "6475880",
			"Zambia": "3768",
			"Malta": "12",
			"Norway": "24498",
			"Sierra Leone": "26443",
			"France": "9160",
			"Philippines": "96",
			"Libya": "31027",
			"Kyrgyzstan": "66",
			"Czechia": "14300",
			"Uganda": "23174",
			"Mozambique": "695174",
			"Ethiopia": "26732",
			"Congo": "20222",
			"Senegal": "8112",
			"Bulgaria": "24300",
			"Rep. of Korea": "28",
			"Hungary": "47450",
			"Burundi": "7270",
			"New Zealand": "17890",
			"Canada": "330"
		}
	},
	"Pakistan": {
		"imports": {},
		"exports": {}
	},
	"Swaziland": {
		"imports": {},
		"exports": {}
	},
	"Lithuania": {
		"imports": {
			"Lebanon": "2393",
			"Gibraltar": "143",
			"Ghana": "26099",
			"Uruguay": "756528",
			"Andorra": "711",
			"Germany": "10889429",
			"Barbados": "6",
			"Poland": "2440018",
			"Qatar": "9365",
			"Dem. Rep. of the Congo": "11894",
			"Thailand": "128423",
			"United Rep. of Tanzania": "9345",
			"Brazil": "329995",
			"Azerbaijan": "176937",
			"Cameroon": "1259",
			"Comoros": "210",
			"Iran": "13125",
			"Mongolia": "6928",
			"Saudi Arabia": "1056898",
			"Panama": "1452",
			"Colombia": "182918",
			"Sudan": "35155",
			"Russian Federation": "13451",
			"United Arab Emirates": "262797",
			"Nicaragua": "7359",
			"Libya": "11984",
			"Malawi": "695816",
			"Switzerland": "2227",
			"Mauritius": "17",
			"Kyrgyzstan": "5337",
			"Cambodia": "1659139",
			"Cook Isds": "2262",
			"Slovakia": "48140",
			"Iraq": "122",
			"Japan": "23129",
			"Tunisia": "34493",
			"Latvia": "1977811",
			"Uganda": "1682",
			"Romania": "202369",
			"Pakistan": "98704",
			"Belgium": "1100454",
			"Slovenia": "40518",
			"Liberia": "24067",
			"Bolivia (Plurinational State of)": "19912",
			"Guatemala": "198",
			"Madagascar": "85",
			"Singapore": "6842",
			"Nigeria": "297",
			"Albania": "2",
			"Benin": "736010",
			"Armenia": "1838952",
			"Bahamas": "1301",
			"San Marino": "10219",
			"Viet Nam": "269085",
			"Haiti": "13",
			"South Africa": "187",
			"Guinea": "56574",
			"Indonesia": "144720",
			"Cuba": "295",
			"Oman": "5507",
			"Jordan": "75077",
			"Curaçao": "70",
			"Australia": "1865",
			"Bahrain": "1688",
			"India": "336",
			"Jamaica": "71",
			"Mexico": "3110",
			"Kenya": "2138",
			"Spain": "299042",
			"Tajikistan": "4518",
			"Ireland": "15063",
			"Botswana": "266",
			"Zimbabwe": "175247",
			"China, Hong Kong SAR": "24953",
			"French Polynesia": "2654",
			"Mauritania": "279304",
			"Saint Kitts and Nevis": "7170",
			"Denmark": "8469807",
			"Portugal": "48837",
			"Honduras": "855",
			"Netherlands": "641365",
			"United Kingdom": "2021634",
			"Costa Rica": "102898",
			"Austria": "401022",
			"Bulgaria": "752542",
			"Greece": "18683",
			"Chile": "22203",
			"Kazakhstan": "13569",
			"Turkmenistan": "263911",
			"China, Macao SAR": "8",
			"Afghanistan": "1293",
			"Croatia": "497484",
			"Sweden": "353938",
			"Malaysia": "3627",
			"Peru": "146872",
			"Nepal": "2226",
			"China": "883969",
			"Egypt": "171776",
			"Estonia": "4366307",
			"Morocco": "3668",
			"Luxembourg": "8424",
			"Belarus": "78394",
			"Israel": "2098",
			"TFYR of Macedonia": "126009",
			"Burkina Faso": "2336",
			"Paraguay": "2117",
			"France": "2137091",
			"Bangladesh": "122",
			"Antigua and Barbuda": "13",
			"Gabon": "8",
			"Finland": "2840465",
			"Bosnia Herzegovina": "25594",
			"Cyprus": "658099",
			"Yemen": "2",
			"Georgia": "13960023",
			"Hungary": "1726733",
			"Bermuda": "213",
			"Faeroe Isds": "4428609",
			"Greenland": "42679",
			"Uzbekistan": "3154",
			"Côte d'Ivoire": "280",
			"Burundi": "496",
			"Guyana": "268",
			"Niger": "184",
			"Algeria": "2",
			"USA": "61522710",
			"Namibia": "169471",
			"Rep. of Moldova": "2044991",
			"Venezuela": "1533",
			"Kuwait": "215",
			"Suriname": "50",
			"Malta": "28182",
			"Norway": "38154",
			"Ecuador": "213546",
			"Sierra Leone": "106",
			"Dominican Rep.": "7267",
			"Marshall Isds": "4944",
			"New Caledonia": "8306",
			"Philippines": "27711",
			"Niue": "40900",
			"Br. Virgin Isds": "15878",
			"Italy": "731027",
			"Saint Lucia": "8529",
			"Czechia": "706196",
			"Rwanda": "721",
			"Mozambique": "8855904",
			"Ethiopia": "344967",
			"Congo": "150",
			"Senegal": "297",
			"Turkey": "72977",
			"Montenegro": "61983",
			"Sri Lanka": "88498",
			"Rep. of Korea": "80",
			"Serbia": "233203",
			"Angola": "1380",
			"Argentina": "4861866",
			"New Zealand": "30305",
			"Canada": "22248",
			"Iceland": "1596",
			"El Salvador": "80337",
			"Lao People's Dem. Rep.": "163",
			"Ukraine": "954869",
			"Myanmar": "1172507"
		},
		"exports": {
			"Lebanon": "69697",
			"Bonaire": "912",
			"Gibraltar": "594278",
			"Ghana": "141835",
			"Lesotho": "1846",
			"Qatar": "8851",
			"Dem. Rep. of the Congo": "24949",
			"Cameroon": "1029",
			"South Africa": "11886785",
			"Indonesia": "3569501",
			"Colombia": "687",
			"Niger": "4450",
			"Palau": "6839",
			"Jordan": "13304",
			"Fr. South Antarctic Terr.": "94",
			"Uzbekistan": "160516",
			"Iraq": "173412",
			"Tuvalu": "252",
			"Bosnia Herzegovina": "111963",
			"Vanuatu": "5348",
			"Belgium": "335588",
			"Azerbaijan": "1189",
			"Rwanda": "7597",
			"Armenia": "187597",
			"United Kingdom": "780321",
			"Singapore": "75343",
			"Albania": "45823",
			"Benin": "14427",
			"FS Micronesia": "1832",
			"Panama": "59484",
			"Cuba": "1122487",
			"Saint Vincent and the Grenadines": "8590",
			"Curaçao": "156",
			"Australia": "8270",
			"Bahrain": "17794",
			"Mexico": "2268",
			"Kenya": "6908",
			"Spain": "373550",
			"Tajikistan": "14395",
			"Ireland": "28781",
			"Botswana": "262",
			"French Polynesia": "226",
			"Mauritania": "10810",
			"Honduras": "8787",
			"Saint Barthélemy": "2873",
			"Chile": "539693",
			"Gambia": "20804",
			"Liberia": "153876",
			"Brunei Darussalam": "155",
			"Malaysia": "1743",
			"Fiji": "206",
			"Portugal": "465501",
			"Saint Kitts and Nevis": "1125",
			"Nepal": "79",
			"China": "21118",
			"Comoros": "895",
			"Guinea-Bissau": "5537",
			"Djibouti": "8722",
			"Trinidad and Tobago": "56",
			"Israel": "2929622",
			"Burkina Faso": "94436",
			"Paraguay": "6869",
			"Bangladesh": "8061",
			"Antigua and Barbuda": "37",
			"Gabon": "25867",
			"Cyprus": "214",
			"Yemen": "90824",
			"Mauritius": "94055",
			"Slovakia": "2168",
			"Faeroe Isds": "218",
			"Turkmenistan": "168529",
			"Syria": "22875",
			"Côte d'Ivoire": "78041",
			"Guyana": "10785",
			"Algeria": "704",
			"USA": "145663",
			"Namibia": "2034",
			"Rep. of Moldova": "562",
			"Zambia": "2484220",
			"Malta": "19069",
			"Ecuador": "48826",
			"Grenada": "98438",
			"Dominican Rep.": "206984",
			"France": "10145241",
			"New Caledonia": "8527",
			"Seychelles": "35453",
			"Br. Virgin Isds": "1352",
			"Italy": "12336571",
			"Saint Lucia": "15991",
			"State of Palestine": "161047",
			"Uganda": "190354",
			"Belarus": "762634",
			"Ethiopia": "30625",
			"Congo": "8998268",
			"Senegal": "15230",
			"Bulgaria": "14804",
			"Montenegro": "4348",
			"Sri Lanka": "254",
			"Hungary": "598339",
			"Angola": "2629248",
			"New Zealand": "1392",
			"Lao People's Dem. Rep.": "1593",
			"Myanmar": "3165",
			"Papua New Guinea": "22615",
			"Uruguay": "4554",
			"Andorra": "22014",
			"Cabo Verde": "32445",
			"Germany": "49969312",
			"Timor-Leste": "89",
			"Poland": "1138171",
			"Thailand": "224",
			"Argentina": "16506",
			"Brazil": "324",
			"Dominica": "1079991",
			"Mongolia": "26972",
			"Saudi Arabia": "1140156",
			"Greece": "34324",
			"Russian Federation": "1599390",
			"Cayman Isds": "2982",
			"United Arab Emirates": "31269646",
			"Nicaragua": "2726",
			"Malawi": "1231858",
			"Switzerland": "81976",
			"El Salvador": "143",
			"Latvia": "3924998",
			"Japan": "146881",
			"Guinea": "4710",
			"Romania": "14847",
			"Slovenia": "17124",
			"China, Macao SAR": "17107",
			"Mozambique": "7771366",
			"Madagascar": "2594",
			"Bolivia (Plurinational State of)": "433314",
			"Nigeria": "313519",
			"Bahamas": "111522",
			"Tunisia": "20035",
			"Chad": "8945",
			"Viet Nam": "8293626",
			"Haiti": "4506",
			"Oman": "181217",
			"Sweden": "5499416",
			"Maldives": "17",
			"India": "11935100",
			"Jamaica": "21724",
			"Austria": "20100",
			"Eritrea": "3418",
			"Zimbabwe": "925249",
			"Saint Maarten": "220844",
			"Cambodia": "4950",
			"Denmark": "3394449",
			"Peru": "63123",
			"Netherlands": "16503283",
			"Costa Rica": "282391",
			"Equatorial Guinea": "148",
			"Sudan": "1384",
			"Kazakhstan": "1295394",
			"Afghanistan": "38070",
			"Croatia": "1232694",
			"Egypt": "1196033",
			"Estonia": "3821424",
			"Pakistan": "131580",
			"Luxembourg": "80198",
			"TFYR of Macedonia": "49186",
			"Somalia": "2358",
			"United Rep. of Tanzania": "132077",
			"Finland": "4636303",
			"Morocco": "2099",
			"Belize": "58778",
			"Georgia": "7808",
			"Ukraine": "1472634",
			"Bermuda": "1134",
			"Mali": "19300",
			"Greenland": "20747",
			"China, Hong Kong SAR": "496",
			"Suriname": "42330",
			"Barbados": "2258",
			"Iran": "12790487",
			"Venezuela": "397",
			"Kuwait": "560228",
			"Norway": "6228590",
			"Sierra Leone": "30556",
			"Marshall Isds": "135",
			"Philippines": "2596166",
			"Libya": "205163",
			"Kyrgyzstan": "37877",
			"Czechia": "250547",
			"Guatemala": "70442",
			"Togo": "6632",
			"Aruba": "1712",
			"Turkey": "60071086",
			"San Marino": "30463",
			"Rep. of Korea": "2973",
			"Serbia": "1087651",
			"Burundi": "1997",
			"Cook Isds": "370",
			"Canada": "4661",
			"Iceland": "170935"
		}
	},
	"United Kingdom": {
		"imports": {
			"Lebanon": "12104",
			"Bonaire": "1128",
			"Gibraltar": "22591",
			"Ghana": "70031401",
			"Lesotho": "264597",
			"Cuba": "559239",
			"Dem. Rep. of the Congo": "54072",
			"Dem. People's Rep. of Korea": "4440",
			"Cameroon": "18261",
			"Papua New Guinea": "6880153",
			"Montserrat": "2086",
			"Indonesia": "116301",
			"Colombia": "28450510",
			"Niger": "1800",
			"Palau": "1344",
			"Tonga": "14947",
			"Angola": "29935",
			"Uzbekistan": "190314",
			"Iraq": "6213353",
			"Guam": "5254",
			"Bosnia Herzegovina": "12551",
			"Pakistan": "45327",
			"Belgium": "932663760",
			"Azerbaijan": "135452773",
			"Armenia": "71996",
			"Togo": "40330",
			"Singapore": "158638",
			"Albania": "24010",
			"Benin": "1228",
			"South Africa": "2955244",
			"FS Micronesia": "74296",
			"Panama": "2916178",
			"Qatar": "27892",
			"American Samoa": "1412",
			"Saint Vincent and the Grenadines": "13257",
			"Curaçao": "9425",
			"Australia": "3352276",
			"Kiribati": "7938",
			"Bahrain": "1700",
			"Jamaica": "24177650",
			"Kenya": "1655",
			"Spain": "18919651",
			"Tajikistan": "232688",
			"Ireland": "59596586",
			"Slovenia": "11603504",
			"South Sudan": "80537",
			"French Polynesia": "19747",
			"Mauritania": "143698",
			"Christmas Isds": "1352",
			"Honduras": "10995",
			"Holy See (Vatican City State)": "8464",
			"United Kingdom": "31164759",
			"Chile": "1216751",
			"Gambia": "12737",
			"China, Macao SAR": "78194",
			"Antarctica": "27",
			"Brunei Darussalam": "17155467",
			"Malaysia": "8699",
			"Fiji": "429",
			"Portugal": "6201172",
			"Falkland Isds (Malvinas)": "16134",
			"Nepal": "454543",
			"China": "98330288",
			"Comoros": "3548",
			"Guinea-Bissau": "18929",
			"Saint Maarten": "44749",
			"Mali": "128041",
			"Trinidad and Tobago": "15828315",
			"Israel": "10333",
			"Burkina Faso": "1935889",
			"Paraguay": "6732733",
			"Bangladesh": "37154944",
			"Antigua and Barbuda": "2962",
			"Gabon": "101388908",
			"Cyprus": "7115299",
			"Yemen": "101052",
			"Mauritius": "87680675",
			"Slovakia": "873",
			"Faeroe Isds": "301316056",
			"Turkmenistan": "1531",
			"Syria": "274972",
			"Côte d'Ivoire": "24775672",
			"Guyana": "7220421",
			"Algeria": "40669058",
			"USA": "61873838",
			"Saint Kitts and Nevis": "82446",
			"Rep. of Moldova": "2276911",
			"Zambia": "1063",
			"Malta": "2081933",
			"Ecuador": "4899728",
			"Grenada": "108167",
			"Dominican Rep.": "84082",
			"France": "363399251",
			"New Caledonia": "73540",
			"Niue": "6910",
			"Seychelles": "78104888",
			"Br. Virgin Isds": "21771",
			"Italy": "62537",
			"Saint Lucia": "3049",
			"State of Palestine": "1066358",
			"Rwanda": "37693",
			"Belarus": "1023779",
			"Ethiopia": "3230688",
			"Namibia": "6616358",
			"Pitcairn": "37347",
			"Senegal": "228743",
			"Bulgaria": "13856224",
			"Montenegro": "7722",
			"Sri Lanka": "9010",
			"Hungary": "5869",
			"Jordan": "2869239",
			"N. Mariana Isds": "7285",
			"Lao People's Dem. Rep.": "1378567",
			"Myanmar": "26193",
			"Iran": "12338",
			"Philippines": "22044307",
			"Uruguay": "677587",
			"Andorra": "1232",
			"Cabo Verde": "10583",
			"Germany": "227387093",
			"Timor-Leste": "1148",
			"Poland": "2074450",
			"Bouvet Island": "1387",
			"Thailand": "181230417",
			"Argentina": "59542",
			"Brazil": "153792093",
			"Dominica": "190300",
			"Mongolia": "252601",
			"Saudi Arabia": "5276",
			"Sudan": "36302",
			"Russian Federation": "52923",
			"Cayman Isds": "12847",
			"United Arab Emirates": "592178",
			"Nicaragua": "2972852",
			"Malawi": "691281",
			"Switzerland": "829877",
			"El Salvador": "15237038",
			"United States Minor Outlying Islands": "2035",
			"Latvia": "5095389",
			"Japan": "6451",
			"Guinea": "20059",
			"Uganda": "26623",
			"Romania": "3057735",
			"Croatia": "57436",
			"Liberia": "1221",
			"Guatemala": "10004437",
			"Madagascar": "1740970",
			"Bolivia (Plurinational State of)": "762360",
			"Nigeria": "1555",
			"Bahamas": "180638",
			"San Marino": "1330",
			"Chad": "1044",
			"Viet Nam": "13286336",
			"Haiti": "6219120",
			"Oman": "38126",
			"Sweden": "9145942",
			"Maldives": "7283299",
			"India": "13287051",
			"Mexico": "40097",
			"Austria": "102257384",
			"Eritrea": "10576",
			"Congo": "1144",
			"Zimbabwe": "94060",
			"Vanuatu": "276809",
			"Swaziland": "8498341",
			"Lithuania": "544991",
			"Cambodia": "93595671",
			"Denmark": "4414582",
			"Peru": "11187413",
			"Central African Rep.": "1741",
			"Netherlands": "357614239",
			"Costa Rica": "1347",
			"Equatorial Guinea": "173262066",
			"Greece": "23310857",
			"Kazakhstan": "18522644",
			"Afghanistan": "2169",
			"Saint Helena": "25587",
			"Egypt": "12206351",
			"Nauru": "3177",
			"Anguilla": "1723",
			"Estonia": "387",
			"Morocco": "6893",
			"Luxembourg": "120174",
			"TFYR of Macedonia": "1648217",
			"Somalia": "34117",
			"Heard Island and McDonald Islands": "2390",
			"United Rep. of Tanzania": "31445",
			"Finland": "11895538",
			"Belize": "1216",
			"Georgia": "725206",
			"Ukraine": "1131715",
			"Bermuda": "770687",
			"Djibouti": "514693",
			"Greenland": "7429614",
			"China, Hong Kong SAR": "801458",
			"Suriname": "13494",
			"Barbados": "6475",
			"Samoa": "54615",
			"Venezuela": "647154",
			"Kuwait": "20986",
			"New Zealand": "4282113",
			"Norway": "1233390",
			"Sierra Leone": "12546",
			"Marshall Isds": "5512",
			"Botswana": "258233",
			"Sao Tome and Principe": "3388",
			"Libya": "320883706",
			"Kyrgyzstan": "8837",
			"Czechia": "1496588",
			"Br. Indian Ocean Terr.": "1652",
			"Mozambique": "320902",
			"Aruba": "4166",
			"Turkey": "4025352",
			"Tunisia": "34281592",
			"Rep. of Korea": "143764",
			"Serbia": "10657",
			"Burundi": "803737",
			"Bhutan": "30196",
			"Cook Isds": "38044",
			"Canada": "378971217",
			"Iceland": "338556729"
		},
		"exports": {
			"Lebanon": "10316",
			"Bonaire": "70175",
			"Gibraltar": "593134",
			"Ghana": "1553016",
			"Lesotho": "38581",
			"Cuba": "162224",
			"Dem. Rep. of the Congo": "484723",
			"Dem. People's Rep. of Korea": "42277",
			"Cameroon": "780515",
			"Papua New Guinea": "167617",
			"Montserrat": "171635",
			"Indonesia": "12414",
			"Colombia": "65797",
			"Niger": "2283",
			"Palau": "6344",
			"Tonga": "10261",
			"Angola": "16948",
			"Fr. South Antarctic Terr.": "19386",
			"Uzbekistan": "1201",
			"Iraq": "4747",
			"Tuvalu": "1240",
			"Guam": "9577",
			"Bosnia Herzegovina": "72306",
			"Pakistan": "561766",
			"Belgium": "192867846",
			"Azerbaijan": "96737",
			"Armenia": "40288",
			"Togo": "21429",
			"Singapore": "16801031",
			"Albania": "7046202",
			"Benin": "46662",
			"South Africa": "3172738",
			"FS Micronesia": "1669",
			"Panama": "391110",
			"Qatar": "762085",
			"American Samoa": "3895",
			"Saint Vincent and the Grenadines": "472745",
			"Curaçao": "207264",
			"Australia": "50507274",
			"Kiribati": "14358",
			"Jamaica": "38781",
			"Kenya": "945755",
			"Spain": "83618031",
			"Tajikistan": "3617",
			"Ireland": "407118215",
			"Slovenia": "471493",
			"South Sudan": "29414",
			"French Polynesia": "61181",
			"Mauritania": "71142",
			"Bouvet Island": "400421",
			"Honduras": "556091",
			"Holy See (Vatican City State)": "252590",
			"Chile": "3575981",
			"Gambia": "14762",
			"China, Macao SAR": "1139767",
			"Brunei Darussalam": "50620",
			"Malaysia": "80362",
			"Fiji": "1402624",
			"Portugal": "2108166",
			"Falkland Isds (Malvinas)": "189236",
			"Nepal": "71592",
			"China": "4216634",
			"Comoros": "20385",
			"Guinea-Bissau": "532277",
			"Saint Maarten": "6321",
			"Mali": "6847829",
			"Trinidad and Tobago": "218534",
			"Israel": "14989",
			"Burkina Faso": "222234",
			"Paraguay": "67616",
			"Bangladesh": "560407",
			"Antigua and Barbuda": "150884",
			"Gabon": "31735",
			"Cyprus": "5790784",
			"Yemen": "62724",
			"Mauritius": "146525",
			"Slovakia": "223762",
			"Faeroe Isds": "91762",
			"Turkmenistan": "18857",
			"Bahrain": "158421",
			"Côte d'Ivoire": "19206",
			"Guyana": "82713",
			"Saint Pierre and Miquelon": "12172",
			"Algeria": "11875",
			"USA": "229281439",
			"Saint Kitts and Nevis": "622972",
			"Rep. of Moldova": "1651",
			"Zambia": "7127",
			"Malta": "1838529",
			"Ecuador": "64857",
			"Grenada": "141969",
			"Dominican Rep.": "1104",
			"France": "262604653",
			"New Caledonia": "7036",
			"Niue": "1079",
			"Seychelles": "62921",
			"Br. Virgin Isds": "47074181",
			"Italy": "449710033",
			"Saint Lucia": "1181730",
			"State of Palestine": "160968",
			"Rwanda": "3619",
			"Syria": "30103",
			"Belarus": "16471",
			"Ethiopia": "1022725",
			"Namibia": "3626",
			"Congo": "7904839",
			"Senegal": "14447",
			"Bulgaria": "5204734",
			"Montenegro": "5517078",
			"Sri Lanka": "8567239",
			"Hungary": "4279",
			"Jordan": "4973",
			"N. Mariana Isds": "101298",
			"Lao People's Dem. Rep.": "3132",
			"Myanmar": "19068787",
			"Iran": "61928",
			"Sao Tome and Principe": "26915",
			"Uruguay": "378909",
			"Andorra": "13457",
			"Cabo Verde": "89783",
			"Germany": "160557060",
			"Timor-Leste": "97869",
			"Poland": "7606173",
			"Thailand": "1149680",
			"Argentina": "721765",
			"Brazil": "911736",
			"Dominica": "4275",
			"Mongolia": "279807",
			"Saudi Arabia": "8714188",
			"Sudan": "132685",
			"Russian Federation": "2833362",
			"Cayman Isds": "480300",
			"United Arab Emirates": "12669099",
			"Nicaragua": "52924",
			"Malawi": "15467",
			"Switzerland": "37782128",
			"El Salvador": "89788",
			"United States Minor Outlying Islands": "8865",
			"Sierra Leone": "76067",
			"Latvia": "18791",
			"Japan": "326706",
			"Guinea": "193724",
			"Uganda": "9437",
			"Romania": "375014",
			"Croatia": "386475",
			"Liberia": "95754",
			"Guatemala": "5093",
			"Madagascar": "1676",
			"Bolivia (Plurinational State of)": "20133",
			"Barbados": "2073877",
			"Bahamas": "16434",
			"San Marino": "358560",
			"Chad": "4605",
			"Viet Nam": "32623",
			"Haiti": "2415",
			"Oman": "933644",
			"Sweden": "20825579",
			"Maldives": "5239",
			"India": "1944559",
			"Mexico": "9714075",
			"Austria": "24011033",
			"Eritrea": "337723",
			"Zimbabwe": "4520",
			"Vanuatu": "189823",
			"Swaziland": "34210",
			"Lithuania": "17844",
			"Cambodia": "598567",
			"Denmark": "11786223",
			"Peru": "1060553",
			"Central African Rep.": "31997",
			"Netherlands": "50007834",
			"Costa Rica": "82385",
			"Equatorial Guinea": "16322",
			"Greece": "95649",
			"Kazakhstan": "15737",
			"Afghanistan": "48910",
			"Saint Helena": "124043",
			"Egypt": "11998041",
			"Nauru": "43735",
			"Anguilla": "247198",
			"Estonia": "5342257",
			"Morocco": "1615698",
			"Antarctica": "109128",
			"TFYR of Macedonia": "33627",
			"Somalia": "2063959",
			"Heard Island and McDonald Islands": "1082",
			"Western Sahara": "2381",
			"United Rep. of Tanzania": "467213",
			"Finland": "5293892",
			"Belize": "1437",
			"Georgia": "542633",
			"Ukraine": "221024",
			"Bermuda": "71288",
			"Djibouti": "93326",
			"Greenland": "2757",
			"China, Hong Kong SAR": "359512",
			"Suriname": "53699",
			"Nigeria": "5754385",
			"Samoa": "30129",
			"Venezuela": "14767",
			"Kuwait": "87238",
			"New Zealand": "37741609",
			"Norway": "5844068",
			"Pitcairn": "5451",
			"Marshall Isds": "5193",
			"Botswana": "1353042",
			"Philippines": "139969",
			"Libya": "15049",
			"Kyrgyzstan": "2532",
			"Czechia": "13831366",
			"Br. Indian Ocean Terr.": "16790",
			"Mozambique": "2257",
			"Aruba": "1053",
			"Turkey": "31309146",
			"Tunisia": "48188",
			"Rep. of Korea": "1109324765",
			"Serbia": "31502",
			"Burundi": "1156499",
			"Bhutan": "28046",
			"Cook Isds": "8209",
			"Canada": "16900095",
			"Iceland": "5430",
			"Luxembourg": "1408"
		}
	},
	"Denmark": {
		"imports": {
			"Lebanon": "351510",
			"Bonaire": "187",
			"Gibraltar": "15",
			"Ghana": "153",
			"Cuba": "88500",
			"Dem. Rep. of the Congo": "101",
			"Dem. People's Rep. of Korea": "493",
			"Cameroon": "230",
			"Papua New Guinea": "520831",
			"Montserrat": "772",
			"Indonesia": "11558",
			"Colombia": "300907",
			"Niger": "1017",
			"Palau": "206",
			"Jordan": "159",
			"Fr. South Antarctic Terr.": "7608",
			"Uzbekistan": "637",
			"Iraq": "510",
			"Guam": "16248",
			"Bosnia Herzegovina": "529893",
			"Pakistan": "2057295",
			"Belgium": "45312924",
			"Azerbaijan": "2937",
			"Armenia": "100110",
			"Togo": "733",
			"Singapore": "18487",
			"Albania": "14758",
			"Benin": "55",
			"South Africa": "2793",
			"Panama": "176632168",
			"Qatar": "932",
			"American Samoa": "824",
			"Saint Vincent and the Grenadines": "107",
			"Curaçao": "83419",
			"Australia": "5054",
			"Kiribati": "3550",
			"Jamaica": "59993",
			"Br. Virgin Isds": "27525022",
			"Spain": "476269",
			"Tajikistan": "235",
			"Ireland": "14669015",
			"Botswana": "450",
			"South Sudan": "102",
			"French Polynesia": "202651",
			"Mauritania": "5296384",
			"Christmas Isds": "2896",
			"Honduras": "4225754",
			"Holy See (Vatican City State)": "82",
			"United Kingdom": "2551869",
			"Chile": "2659",
			"Gambia": "1353",
			"Liberia": "1143",
			"Brunei Darussalam": "41737",
			"Malaysia": "8561",
			"Fiji": "4218",
			"Portugal": "48820",
			"Falkland Isds (Malvinas)": "196498",
			"Nepal": "20",
			"China": "3644013",
			"Guinea-Bissau": "107",
			"Mali": "36786",
			"Trinidad and Tobago": "654",
			"Israel": "52657",
			"Burkina Faso": "1532",
			"Paraguay": "50172347",
			"Norfolk Isds": "5117",
			"Bangladesh": "87",
			"Antigua and Barbuda": "2494",
			"Gabon": "1930",
			"Cyprus": "42755",
			"Mauritius": "3089943",
			"Slovakia": "3969",
			"Faeroe Isds": "279793",
			"Turkmenistan": "39",
			"Bahrain": "118551",
			"Côte d'Ivoire": "117075",
			"Guyana": "4726",
			"Saint Pierre and Miquelon": "7023",
			"Algeria": "34095820",
			"USA": "5337468",
			"Saint Kitts and Nevis": "44514",
			"Rep. of Moldova": "4252",
			"Zambia": "1892",
			"Malta": "334751",
			"Ecuador": "6375",
			"Grenada": "1922",
			"Dominican Rep.": "104742",
			"France": "81570326",
			"New Caledonia": "60364",
			"Seychelles": "7713124",
			"Italy": "150585844",
			"Saint Lucia": "77886",
			"State of Palestine": "24707",
			"Rwanda": "356006",
			"Syria": "20692",
			"Belarus": "2725011",
			"Ethiopia": "1894",
			"Namibia": "436949",
			"Congo": "149568",
			"Senegal": "294",
			"Bulgaria": "1683409",
			"Montenegro": "790",
			"Sri Lanka": "725392",
			"Hungary": "2306489",
			"Angola": "796",
			"New Zealand": "50339",
			"Lao People's Dem. Rep.": "327066",
			"Myanmar": "18",
			"Iran": "4681786",
			"Philippines": "409777",
			"Uruguay": "1551",
			"Andorra": "29843",
			"Cabo Verde": "11",
			"Germany": "614767473",
			"Timor-Leste": "986",
			"Poland": "2104273",
			"Thailand": "6173837",
			"Argentina": "1069406",
			"Brazil": "1008126",
			"Dominica": "119",
			"Mongolia": "9051",
			"Saudi Arabia": "315976",
			"Sudan": "215",
			"Russian Federation": "208818431",
			"Cayman Isds": "668355",
			"United Arab Emirates": "354202",
			"Nicaragua": "855795",
			"Malawi": "48659",
			"Switzerland": "342160",
			"El Salvador": "2151",
			"United States Minor Outlying Islands": "3613",
			"Latvia": "6252353",
			"Japan": "36704103",
			"Guinea": "12731",
			"Uganda": "1160",
			"Romania": "8935",
			"Croatia": "16127",
			"China, Macao SAR": "106",
			"Mozambique": "158408",
			"Madagascar": "97239",
			"Bolivia (Plurinational State of)": "540263",
			"Barbados": "684096",
			"Bahamas": "3164",
			"San Marino": "163520",
			"Chad": "4918",
			"Viet Nam": "603820",
			"Haiti": "618",
			"Tokelau": "1104",
			"Slovenia": "1140",
			"Oman": "5769",
			"Sweden": "15756492",
			"Maldives": "18746",
			"India": "14367",
			"Mexico": "673715",
			"Austria": "20105581",
			"Eritrea": "26",
			"Zimbabwe": "59029",
			"Saint Maarten": "267",
			"Swaziland": "3215",
			"Lithuania": "12984188",
			"Cambodia": "10325",
			"Peru": "3058933",
			"Central African Rep.": "1595",
			"Netherlands": "53743850",
			"Costa Rica": "74295",
			"Equatorial Guinea": "8623",
			"Greece": "18743",
			"Kazakhstan": "12924153",
			"Kenya": "1836",
			"Afghanistan": "26912",
			"Egypt": "858880",
			"Anguilla": "2547",
			"Estonia": "3104120",
			"Morocco": "3092886",
			"Luxembourg": "3845508",
			"TFYR of Macedonia": "262991",
			"United Rep. of Tanzania": "10133",
			"Finland": "17157951",
			"Belize": "35299",
			"Georgia": "63097",
			"Ukraine": "192028",
			"Bermuda": "2874",
			"Djibouti": "99560",
			"Greenland": "13406",
			"China, Hong Kong SAR": "1067201",
			"Suriname": "63381",
			"Nigeria": "48315337",
			"Samoa": "11424",
			"Venezuela": "2847",
			"Kuwait": "276",
			"Norway": "995212437",
			"Sierra Leone": "5004",
			"Marshall Isds": "13295",
			"Sao Tome and Principe": "16344",
			"Libya": "4106",
			"Kyrgyzstan": "68303",
			"Czechia": "1766768",
			"Guatemala": "235378",
			"Aruba": "91",
			"Turkey": "352880",
			"Tunisia": "1054327",
			"Rep. of Korea": "158928",
			"Serbia": "64706",
			"Burundi": "88",
			"Bhutan": "201",
			"Cook Isds": "371",
			"Canada": "3759155",
			"Iceland": "100895"
		},
		"exports": {
			"Lebanon": "149890",
			"Bonaire": "21251",
			"Gibraltar": "598",
			"Ghana": "810980",
			"Lesotho": "29573",
			"Cuba": "69164",
			"Dem. Rep. of the Congo": "291708",
			"Dem. People's Rep. of Korea": "54",
			"Cameroon": "5155",
			"Papua New Guinea": "7588766",
			"Indonesia": "22893253",
			"Colombia": "407537",
			"Niger": "541999",
			"Palau": "11688",
			"Tonga": "83689",
			"Angola": "319513",
			"Fr. South Antarctic Terr.": "262295",
			"Uzbekistan": "285406",
			"Iraq": "92746",
			"Guam": "5092563",
			"Bosnia Herzegovina": "811635",
			"Pakistan": "7887",
			"Belgium": "7624979",
			"Azerbaijan": "2125118",
			"Armenia": "202940",
			"Togo": "5808",
			"Singapore": "90489",
			"Albania": "180308",
			"Benin": "305318",
			"South Africa": "698318",
			"FS Micronesia": "6577",
			"Panama": "6144904",
			"Qatar": "208581",
			"American Samoa": "148",
			"Saint Vincent and the Grenadines": "778670",
			"Curaçao": "9571844",
			"Australia": "9378756",
			"Kiribati": "874783",
			"Jamaica": "7430",
			"Br. Virgin Isds": "1687348",
			"Spain": "4592517",
			"Tajikistan": "13380",
			"Ireland": "104853577",
			"Botswana": "216622",
			"South Sudan": "63710",
			"French Polynesia": "1410",
			"Mauritania": "224101",
			"Honduras": "802700",
			"Saint Barthélemy": "732",
			"United Kingdom": "8463527",
			"Chile": "2976907",
			"Gambia": "70278",
			"Liberia": "15210",
			"Antarctica": "28253",
			"Brunei Darussalam": "37004",
			"Malaysia": "238986",
			"Fiji": "13559",
			"Portugal": "1104",
			"Falkland Isds (Malvinas)": "2293",
			"Nepal": "611726",
			"China": "44175271",
			"Comoros": "69",
			"Guinea-Bissau": "160445",
			"Saint Maarten": "185407",
			"Mali": "79708",
			"Trinidad and Tobago": "5884",
			"Israel": "265278",
			"Burkina Faso": "8379",
			"Paraguay": "4272",
			"Bangladesh": "15385833",
			"Antigua and Barbuda": "18807",
			"Gabon": "1436386",
			"Cyprus": "1055435",
			"Yemen": "19125697",
			"Mauritius": "81275",
			"Slovakia": "91",
			"Faeroe Isds": "23182938",
			"Turkmenistan": "892279",
			"Bahrain": "3252003",
			"Côte d'Ivoire": "4280",
			"Guyana": "83399",
			"Saint Pierre and Miquelon": "4271",
			"Algeria": "1057790",
			"USA": "9068989",
			"Saint Kitts and Nevis": "440560",
			"Rep. of Moldova": "383506",
			"Zambia": "21009",
			"Malta": "13829957",
			"Ecuador": "43741",
			"Grenada": "12677",
			"Dominican Rep.": "23219",
			"France": "8876666",
			"New Caledonia": "6189995",
			"Seychelles": "441",
			"Italy": "4723542",
			"Saint Lucia": "388134",
			"State of Palestine": "3187126",
			"Rwanda": "8860",
			"Syria": "34022",
			"Belarus": "78532",
			"Ethiopia": "18203",
			"Namibia": "334593",
			"Congo": "161891",
			"Senegal": "431",
			"Bulgaria": "686950",
			"Montenegro": "107792",
			"Sri Lanka": "99247",
			"Hungary": "1568605",
			"Jordan": "1309870",
			"N. Mariana Isds": "147984",
			"Lao People's Dem. Rep.": "59977",
			"Myanmar": "97530",
			"Iran": "11106812",
			"Philippines": "55005",
			"Uruguay": "653521",
			"Andorra": "2650",
			"Cabo Verde": "123",
			"Germany": "66565464",
			"Timor-Leste": "12388",
			"Poland": "78816",
			"Thailand": "4460",
			"Argentina": "1900687",
			"Brazil": "1559937",
			"Dominica": "12265",
			"Mongolia": "166944",
			"Saudi Arabia": "394269",
			"Sudan": "478514",
			"Russian Federation": "24477769",
			"Cayman Isds": "1074600",
			"United Arab Emirates": "1853854",
			"Nicaragua": "256",
			"Malawi": "40675",
			"Switzerland": "3440646",
			"El Salvador": "48648",
			"United States Minor Outlying Islands": "88482",
			"Latvia": "10020003",
			"Japan": "17861136",
			"Guinea": "1442",
			"Uganda": "67",
			"Romania": "5",
			"Croatia": "941715",
			"China, Macao SAR": "60697",
			"Guatemala": "866",
			"Madagascar": "617744",
			"Bolivia (Plurinational State of)": "770580",
			"Barbados": "15941",
			"Bahamas": "3153",
			"San Marino": "174449",
			"Chad": "318742",
			"Viet Nam": "7433",
			"Haiti": "14960",
			"Tokelau": "7513",
			"Slovenia": "240582",
			"Oman": "83252",
			"Sweden": "19607507",
			"Maldives": "2337595",
			"India": "49165",
			"Mexico": "12809",
			"Austria": "2696551",
			"Eritrea": "129",
			"Zimbabwe": "227415",
			"Vanuatu": "2870",
			"Swaziland": "71724",
			"Lithuania": "31704934",
			"Cambodia": "4169297",
			"Peru": "34",
			"Central African Rep.": "508945",
			"Netherlands": "28367412",
			"Costa Rica": "1512048",
			"Equatorial Guinea": "3455",
			"Greece": "10664306",
			"Kazakhstan": "60069",
			"Kenya": "2126",
			"Afghanistan": "388278",
			"Saint Helena": "5032",
			"Egypt": "53483",
			"Nauru": "32598",
			"Anguilla": "169109",
			"Estonia": "17339519",
			"Morocco": "57122",
			"Luxembourg": "1169790",
			"TFYR of Macedonia": "251348",
			"Somalia": "847",
			"Western Sahara": "49259",
			"United Rep. of Tanzania": "10459",
			"Finland": "13867994",
			"Belize": "543937",
			"Georgia": "378635",
			"Ukraine": "41947",
			"Bermuda": "37706",
			"Djibouti": "31040",
			"Greenland": "7526006",
			"China, Hong Kong SAR": "110013",
			"Suriname": "172248",
			"Nigeria": "2973",
			"Samoa": "921",
			"Venezuela": "62023",
			"Kuwait": "87063",
			"New Zealand": "254982",
			"Norway": "57442178",
			"Sierra Leone": "12553",
			"Marshall Isds": "208131",
			"Sao Tome and Principe": "71736",
			"Libya": "57365",
			"Kyrgyzstan": "5526163",
			"Czechia": "4485120",
			"Br. Indian Ocean Terr.": "20213",
			"Mozambique": "72953",
			"Aruba": "259971",
			"Turkey": "194571",
			"Tunisia": "5964",
			"Rep. of Korea": "725836",
			"Serbia": "1745",
			"Burundi": "1005529",
			"Bhutan": "47720",
			"Cook Isds": "507",
			"Canada": "2568566",
			"Iceland": "9698857"
		}
	},
	"Peru": {
		"imports": {
			"Lebanon": "447",
			"Gibraltar": "6983",
			"Ghana": "145",
			"Lesotho": "47",
			"Cuba": "10953755",
			"Dem. Rep. of the Congo": "94",
			"Dem. People's Rep. of Korea": "14231",
			"Cameroon": "2141",
			"South Africa": "7397813",
			"Montserrat": "1274",
			"Indonesia": "28346766",
			"Colombia": "194759311",
			"Niger": "2594",
			"Angola": "2531018",
			"Uzbekistan": "2096706",
			"Iraq": "8362",
			"Tuvalu": "42",
			"Guam": "211",
			"Bosnia Herzegovina": "4751",
			"Pakistan": "58940",
			"Belgium": "77167",
			"Azerbaijan": "199",
			"Pitcairn": "2998",
			"Armenia": "862",
			"United Kingdom": "29797",
			"Singapore": "36740446",
			"Albania": "1461",
			"Panama": "79485523",
			"Qatar": "19589133",
			"American Samoa": "1726",
			"Curaçao": "90",
			"Australia": "4741",
			"Kiribati": "4024",
			"Jamaica": "61",
			"Br. Virgin Isds": "2813",
			"Spain": "254924356",
			"Ireland": "18834005",
			"Botswana": "15447",
			"French Polynesia": "167",
			"Mauritania": "6294",
			"Honduras": "373828",
			"Holy See (Vatican City State)": "1959",
			"Jordan": "4640",
			"Chile": "150901",
			"Sudan": "1161",
			"Gambia": "2489",
			"China, Macao SAR": "3815",
			"Dominica": "4155",
			"Malaysia": "8414730",
			"Fiji": "908",
			"Portugal": "9119412",
			"Saint Kitts and Nevis": "15",
			"Nepal": "118977",
			"China": "149853216",
			"Comoros": "95",
			"Guinea-Bissau": "25",
			"Mali": "36001",
			"Trinidad and Tobago": "221903815",
			"Israel": "19521753",
			"Burkina Faso": "100409",
			"Paraguay": "662",
			"Bangladesh": "7231",
			"Antigua and Barbuda": "47",
			"Gabon": "37",
			"Cyprus": "2416",
			"Mauritius": "41452",
			"Slovakia": "263281",
			"Faeroe Isds": "256",
			"Bahrain": "40288",
			"Côte d'Ivoire": "1529",
			"Guyana": "10680",
			"Algeria": "55",
			"USA": "167598029",
			"Cambodia": "78805",
			"Rep. of Moldova": "259",
			"Malta": "27",
			"Ecuador": "779243136",
			"Dominican Rep.": "7362517",
			"France": "46634915",
			"New Caledonia": "163",
			"Niue": "1010",
			"Seychelles": "2548",
			"Italy": "124135330",
			"Saint Lucia": "107",
			"Rwanda": "23899",
			"Belarus": "5416",
			"Ethiopia": "32026",
			"Congo": "2470",
			"Senegal": "44",
			"Bulgaria": "41600",
			"Montenegro": "48359",
			"Sri Lanka": "14080138",
			"Hungary": "16099136",
			"Netherlands": "445123",
			"New Zealand": "112913",
			"N. Mariana Isds": "365",
			"Lao People's Dem. Rep.": "15336",
			"Myanmar": "553",
			"Iran": "63357",
			"Philippines": "478277",
			"Uruguay": "160019243",
			"Andorra": "150",
			"Cabo Verde": "4485",
			"Germany": "106169",
			"Timor-Leste": "311",
			"Poland": "900308",
			"Thailand": "152758942",
			"Argentina": "150447",
			"Brazil": "94271714",
			"Brunei Darussalam": "588",
			"Mongolia": "25127",
			"Saudi Arabia": "43638542",
			"Greece": "456988",
			"Russian Federation": "248335297",
			"Cayman Isds": "14685",
			"United Arab Emirates": "100845",
			"Nicaragua": "1825",
			"Malawi": "10",
			"Switzerland": "37504560",
			"El Salvador": "377139",
			"United States Minor Outlying Islands": "354",
			"Latvia": "1796659",
			"Japan": "7705617",
			"Guinea": "536",
			"Uganda": "67255",
			"Romania": "5659192",
			"Croatia": "31172",
			"Guatemala": "993221",
			"Madagascar": "1648266",
			"Bolivia (Plurinational State of)": "23570537",
			"Barbados": "2827",
			"Bahamas": "28865912",
			"San Marino": "13155",
			"Chad": "502",
			"Viet Nam": "94217862",
			"Haiti": "45",
			"Tokelau": "1639",
			"Oman": "233",
			"Sweden": "69639538",
			"Maldives": "134792",
			"India": "383012809",
			"Mexico": "23496676",
			"Austria": "1909187",
			"Bouvet Island": "109",
			"Swaziland": "17826",
			"Lithuania": "190984",
			"Namibia": "219",
			"Denmark": "8068811",
			"Somalia": "2452",
			"Central African Rep.": "19460",
			"Slovenia": "216197",
			"Costa Rica": "893982",
			"South Georgia and the South Sandwich Islands": "6",
			"Papua New Guinea": "63",
			"Kazakhstan": "13386",
			"Kenya": "22",
			"Afghanistan": "32240",
			"Saint Helena": "173",
			"Egypt": "19462",
			"Nauru": "14806",
			"Estonia": "885856",
			"Morocco": "28235",
			"Luxembourg": "1123897",
			"Venezuela": "2260783",
			"United Rep. of Tanzania": "1267",
			"Finland": "18523916",
			"Belize": "482",
			"Georgia": "2375010",
			"Ukraine": "449574",
			"Bermuda": "878",
			"Djibouti": "574",
			"Greenland": "3791",
			"China, Hong Kong SAR": "2894939",
			"Suriname": "71710",
			"Nigeria": "47587048",
			"Samoa": "112",
			"TFYR of Macedonia": "6947",
			"Kuwait": "58412",
			"Norway": "558143",
			"Sierra Leone": "183989",
			"Marshall Isds": "7931",
			"Sao Tome and Principe": "284",
			"Kyrgyzstan": "49021",
			"Czechia": "3606488",
			"Br. Indian Ocean Terr.": "556",
			"Mozambique": "826",
			"Aruba": "308",
			"Turkey": "1177361",
			"Tunisia": "181806",
			"Rep. of Korea": "6397",
			"Serbia": "918232",
			"Bhutan": "52136",
			"Canada": "338766",
			"Iceland": "187958"
		},
		"exports": {
			"Lebanon": "2642372",
			"Nepal": "37358",
			"Ghana": "880",
			"Philippines": "156951026",
			"Niger": "12736",
			"Uruguay": "31076200",
			"Cabo Verde": "531616",
			"Germany": "1500",
			"Poland": "101060",
			"Cuba": "6295",
			"Dem. Rep. of the Congo": "83552",
			"Thailand": "5766",
			"Dem. People's Rep. of Korea": "63615",
			"Argentina": "1779013",
			"Brazil": "2659353",
			"Cameroon": "33091",
			"Brunei Darussalam": "5660",
			"Iran": "1709907",
			"Saudi Arabia": "1519236",
			"Indonesia": "1341753",
			"Colombia": "7085",
			"Sudan": "250211",
			"Russian Federation": "39907747",
			"Cayman Isds": "72084",
			"United Arab Emirates": "122277",
			"Nicaragua": "684372",
			"Yemen": "292357",
			"Angola": "59581",
			"Malawi": "14522",
			"Switzerland": "478379",
			"El Salvador": "535967",
			"Kyrgyzstan": "1935",
			"Sierra Leone": "742488",
			"Ukraine": "316329",
			"Iraq": "6204",
			"Japan": "1467687",
			"Latvia": "266036",
			"Togo": "38",
			"Bolivia (Plurinational State of)": "771596",
			"Pakistan": "49833",
			"Belgium": "37009050",
			"Slovenia": "6634",
			"Liberia": "1283407",
			"Mauritania": "1208764",
			"Guatemala": "42872",
			"United Kingdom": "600",
			"Singapore": "1092863",
			"Barbados": "31700",
			"Albania": "71034",
			"Benin": "605",
			"Bahamas": "14812",
			"Tunisia": "73851",
			"Mozambique": "293420",
			"Viet Nam": "235515",
			"Haiti": "33558",
			"South Africa": "486510",
			"Guinea": "24342",
			"FS Micronesia": "150087",
			"Panama": "7180334",
			"Qatar": "4",
			"American Samoa": "736173",
			"Saint Vincent and the Grenadines": "289863",
			"Oman": "12524221",
			"Curaçao": "4561856",
			"Australia": "11075642",
			"Kiribati": "29117",
			"India": "50243",
			"Mexico": "2685375",
			"Jamaica": "30",
			"Kenya": "82255",
			"Austria": "83205",
			"Romania": "1141386",
			"Ireland": "1718724",
			"Côte d'Ivoire": "307",
			"Spain": "67440285",
			"Suriname": "1003220",
			"Lithuania": "3311",
			"Cambodia": "5",
			"Denmark": "1862107",
			"Syria": "445910",
			"Honduras": "73950",
			"United Rep. of Tanzania": "214579",
			"Netherlands": "2059",
			"Turkey": "1800",
			"Costa Rica": "12779",
			"Papua New Guinea": "7200",
			"Equatorial Guinea": "1255148",
			"Greece": "430",
			"Chile": "498421",
			"Croatia": "6500",
			"Gambia": "225",
			"China, Macao SAR": "14894",
			"Libya": "62786",
			"Mali": "85657",
			"Dominica": "102015",
			"Malaysia": "27825",
			"Swaziland": "27488",
			"Portugal": "1438450",
			"Saint Kitts and Nevis": "2961",
			"Armenia": "80242",
			"China": "45852821",
			"Egypt": "142320",
			"Guinea-Bissau": "41",
			"Anguilla": "16996",
			"Estonia": "201808",
			"Morocco": "87774",
			"Antarctica": "879",
			"Trinidad and Tobago": "52098",
			"Israel": "1122985",
			"Venezuela": "1017636",
			"Burkina Faso": "276017",
			"Montserrat": "13101",
			"Kazakhstan": "4518",
			"Paraguay": "110720",
			"French Polynesia": "72500",
			"Bangladesh": "29553",
			"Antigua and Barbuda": "50439",
			"Gabon": "1376",
			"Finland": "83763",
			"Cyprus": "336293",
			"Belize": "23883",
			"Georgia": "11313498",
			"Serbia": "56899",
			"Djibouti": "2919902",
			"Madagascar": "108570",
			"Turkmenistan": "529",
			"Bahrain": "138941",
			"Zambia": "1101304",
			"China, Hong Kong SAR": "4488254",
			"Guyana": "180530",
			"Sweden": "296045",
			"Algeria": "310697",
			"USA": "16911302",
			"New Zealand": "80",
			"Namibia": "51548314",
			"Kuwait": "1232719",
			"Malta": "13373",
			"Norway": "29546607",
			"Ecuador": "1592267",
			"Grenada": "32230",
			"Dominican Rep.": "6367617",
			"France": "499510",
			"New Caledonia": "1349203",
			"Luxembourg": "9344",
			"Uganda": "979",
			"Br. Virgin Isds": "91101",
			"Italy": "289132789",
			"Saint Lucia": "96268",
			"Czechia": "232314",
			"Rwanda": "33396",
			"Nigeria": "4320114",
			"Belarus": "63476",
			"Mauritius": "3400",
			"Congo": "1547",
			"Senegal": "613810",
			"Aruba": "1800",
			"Bulgaria": "25000",
			"Sri Lanka": "92600",
			"Rep. of Korea": "4749849",
			"Hungary": "5767",
			"Slovakia": "17091",
			"Jordan": "2284",
			"Canada": "7950",
			"Iceland": "64278",
			"Myanmar": "20"
		}
	},
	"Central African Rep.": {
		"imports": {},
		"exports": {}
	},
	"Netherlands": {
		"imports": {},
		"exports": {}
	},
	"Costa Rica": {
		"imports": {
			"Lebanon": "348",
			"Gibraltar": "1798",
			"Ghana": "127",
			"Lesotho": "14559",
			"Cuba": "746",
			"Dem. Rep. of the Congo": "2735",
			"Dem. People's Rep. of Korea": "228954",
			"Cameroon": "821",
			"Iran": "2",
			"Montserrat": "5",
			"Indonesia": "34920290",
			"Colombia": "647924",
			"Niger": "222",
			"Palau": "237",
			"Angola": "374",
			"Fr. South Antarctic Terr.": "607",
			"Iraq": "155",
			"Guam": "174",
			"Bosnia Herzegovina": "32419",
			"Pakistan": "966",
			"Belgium": "205991",
			"Azerbaijan": "13619",
			"Armenia": "359",
			"United Kingdom": "222756",
			"Singapore": "712",
			"Albania": "38430",
			"Benin": "62",
			"FS Micronesia": "567",
			"Panama": "2487911",
			"Qatar": "20",
			"American Samoa": "141",
			"Djibouti": "72012",
			"Curaçao": "12",
			"Australia": "1338",
			"Kiribati": "818",
			"Mexico": "44077482",
			"Kenya": "162",
			"Spain": "2600154",
			"Tajikistan": "17264",
			"Ireland": "226",
			"Botswana": "1031",
			"French Polynesia": "141",
			"Mauritania": "233",
			"Honduras": "82973",
			"Holy See (Vatican City State)": "6786",
			"Chile": "39670",
			"Gambia": "48",
			"Liberia": "44",
			"Dominica": "105",
			"Malaysia": "35638",
			"Fiji": "94783",
			"Portugal": "3558",
			"Nepal": "982",
			"China": "55374300",
			"Comoros": "4477",
			"Guinea-Bissau": "986",
			"Mali": "101",
			"Trinidad and Tobago": "1801",
			"Israel": "61",
			"Burkina Faso": "19",
			"Paraguay": "89350",
			"Bangladesh": "1117",
			"Gabon": "611",
			"Cyprus": "1500",
			"Mauritius": "5170",
			"Slovakia": "4735849",
			"Turkmenistan": "38",
			"Bahrain": "30979",
			"Côte d'Ivoire": "3897",
			"Guyana": "249",
			"Algeria": "193",
			"USA": "68372",
			"Namibia": "250",
			"Rep. of Moldova": "137",
			"Zambia": "37",
			"Malta": "60691",
			"Ecuador": "784",
			"Grenada": "9",
			"Dominican Rep.": "565",
			"France": "6554875",
			"New Caledonia": "25",
			"Seychelles": "2766",
			"Br. Virgin Isds": "20884",
			"Italy": "3592501",
			"Saint Lucia": "274",
			"State of Palestine": "419",
			"Rwanda": "53",
			"Syria": "26",
			"Belarus": "754",
			"Ethiopia": "21",
			"Slovenia": "530571",
			"Congo": "464",
			"Senegal": "126",
			"Bulgaria": "659375",
			"Montenegro": "5",
			"Sri Lanka": "36",
			"Hungary": "31396196",
			"Jordan": "228630",
			"N. Mariana Isds": "287",
			"Lao People's Dem. Rep.": "917",
			"Myanmar": "188595",
			"South Africa": "381",
			"Uruguay": "4569",
			"Andorra": "40478",
			"Germany": "47075586",
			"Poland": "2950",
			"Thailand": "1753724",
			"Argentina": "5101",
			"Brazil": "3162068",
			"Brunei Darussalam": "5",
			"Saudi Arabia": "4156",
			"Sudan": "4390",
			"Russian Federation": "5482",
			"Cayman Isds": "2025",
			"United Arab Emirates": "311",
			"Nicaragua": "139813",
			"Malawi": "6397",
			"Switzerland": "543764",
			"El Salvador": "30251",
			"Sierra Leone": "110",
			"Latvia": "46350",
			"Japan": "177104894",
			"Guinea": "22",
			"Uganda": "3938",
			"Romania": "485284",
			"Croatia": "994",
			"China, Macao SAR": "1680",
			"Guatemala": "54686",
			"Madagascar": "153",
			"Bolivia (Plurinational State of)": "30",
			"Barbados": "61",
			"Bahamas": "30887",
			"San Marino": "344",
			"Chad": "10",
			"Viet Nam": "163135",
			"Haiti": "26938",
			"Oman": "570",
			"Sweden": "19847",
			"Maldives": "548",
			"India": "76415822",
			"Jamaica": "2923",
			"Austria": "2192452",
			"Bouvet Island": "1171",
			"Zimbabwe": "1075",
			"Vanuatu": "3103",
			"Swaziland": "465",
			"Lithuania": "30401",
			"Cambodia": "30971",
			"Denmark": "38",
			"Peru": "75571",
			"Central African Rep.": "1781",
			"Netherlands": "113981",
			"Greece": "11709",
			"Kazakhstan": "172",
			"Afghanistan": "1753",
			"Egypt": "186017",
			"Nauru": "1607",
			"Anguilla": "93",
			"Estonia": "15975",
			"Morocco": "382354",
			"Antarctica": "84",
			"Venezuela": "1946",
			"Somalia": "700",
			"Heard Island and McDonald Islands": "1349",
			"United Rep. of Tanzania": "109",
			"Finland": "24766",
			"Belize": "35825",
			"Georgia": "209",
			"Ukraine": "10257",
			"Bermuda": "3131",
			"Luxembourg": "1500",
			"Greenland": "38235",
			"China, Hong Kong SAR": "61722",
			"Suriname": "82",
			"Nigeria": "61",
			"Samoa": "383963",
			"TFYR of Macedonia": "8768",
			"Kuwait": "54",
			"New Zealand": "1204",
			"Norway": "753",
			"Pitcairn": "92",
			"Marshall Isds": "3221",
			"Philippines": "971",
			"Kyrgyzstan": "317",
			"Czechia": "4447",
			"Br. Indian Ocean Terr.": "1834",
			"Mozambique": "210",
			"Togo": "23",
			"Aruba": "748",
			"Turkey": "139",
			"Tunisia": "5392",
			"Rep. of Korea": "153259553",
			"Serbia": "230",
			"Burundi": "5193",
			"Canada": "196006",
			"Iceland": "2657"
		},
		"exports": {
			"Lebanon": "31381",
			"Iran": "1602",
			"Uruguay": "28243",
			"Germany": "450",
			"Poland": "178",
			"Cuba": "720",
			"Thailand": "109430",
			"Dem. People's Rep. of Korea": "7679",
			"Argentina": "110",
			"Brazil": "260",
			"Cameroon": "3225956",
			"Dominica": "2650",
			"Ghana": "12500",
			"Saudi Arabia": "1700",
			"Indonesia": "182685",
			"Colombia": "4007",
			"Syria": "23840",
			"Russian Federation": "10000",
			"Cayman Isds": "35",
			"United Arab Emirates": "234599",
			"Nicaragua": "20534",
			"Tajikistan": "15411",
			"Jordan": "14300",
			"Switzerland": "324",
			"El Salvador": "1055",
			"Saint Lucia": "254898",
			"United States Minor Outlying Islands": "2303",
			"Togo": "26685",
			"Slovakia": "107827",
			"Iraq": "15000",
			"Japan": "10000",
			"Guam": "1906",
			"Latvia": "1028",
			"Bosnia Herzegovina": "40",
			"Pakistan": "8000",
			"Belgium": "335",
			"Croatia": "108731",
			"Belarus": "3",
			"United Kingdom": "433",
			"Bolivia (Plurinational State of)": "60",
			"Barbados": "183478",
			"Albania": "82561",
			"Bahamas": "4907271",
			"Ukraine": "19",
			"Tunisia": "1003",
			"Mozambique": "7950",
			"Viet Nam": "70",
			"Haiti": "619344",
			"South Africa": "138958",
			"Guinea": "1650",
			"Panama": "12250",
			"Qatar": "200",
			"Saint Vincent and the Grenadines": "59489",
			"Oman": "12000",
			"Curaçao": "16853",
			"Australia": "708",
			"India": "228695",
			"Jamaica": "20000",
			"Mexico": "211251",
			"Kenya": "3335",
			"Spain": "796",
			"Romania": "2305",
			"Ireland": "140985",
			"Côte d'Ivoire": "8150",
			"Austria": "201",
			"Mauritania": "6470",
			"Lithuania": "7",
			"Saint Kitts and Nevis": "7755",
			"Denmark": "16000",
			"Peru": "1000",
			"Honduras": "4012",
			"Netherlands": "54000",
			"Turkey": "226285",
			"Greece": "477",
			"Chile": "269",
			"Kazakhstan": "2",
			"China, Macao SAR": "10000",
			"Libya": "285589",
			"Saint Helena": "2648",
			"Malaysia": "30",
			"Fiji": "9477",
			"Portugal": "60",
			"United Rep. of Tanzania": "86",
			"China": "80",
			"Egypt": "20",
			"Saint Maarten": "11516",
			"Estonia": "61983",
			"Morocco": "1798381",
			"Luxembourg": "3740",
			"Trinidad and Tobago": "6777127",
			"Israel": "49028",
			"Venezuela": "20",
			"Burkina Faso": "783",
			"Anguilla": "3600",
			"Singapore": "159917",
			"Paraguay": "90693",
			"French Polynesia": "1112",
			"Bangladesh": "42328",
			"Antigua and Barbuda": "171650",
			"Gabon": "30950",
			"Finland": "1170",
			"Cyprus": "3790",
			"Belize": "1360",
			"Georgia": "340",
			"Hungary": "72436",
			"Bermuda": "243235",
			"Madagascar": "1000",
			"Bahrain": "1360",
			"Zambia": "43112",
			"China, Hong Kong SAR": "352500",
			"Guyana": "1914429",
			"Sweden": "1000",
			"Algeria": "16001",
			"USA": "467269",
			"Kuwait": "10501",
			"Suriname": "546652",
			"Malta": "256362",
			"Norway": "180152",
			"Ecuador": "24000",
			"Grenada": "1980",
			"Dominican Rep.": "20000",
			"France": "1000",
			"New Caledonia": "31012",
			"Philippines": "90",
			"Br. Virgin Isds": "25",
			"Italy": "40835",
			"Kyrgyzstan": "15411",
			"Czechia": "30",
			"Uganda": "3000",
			"Nigeria": "65362",
			"Guatemala": "28651",
			"Ethiopia": "3300",
			"Slovenia": "2",
			"Mauritius": "480",
			"Sierra Leone": "2138",
			"Aruba": "14000",
			"Bulgaria": "4750",
			"Montenegro": "1798589",
			"Sri Lanka": "34836",
			"Rep. of Korea": "50",
			"Serbia": "160",
			"New Zealand": "74103",
			"Canada": "3065",
			"Lao People's Dem. Rep.": "6782",
			"Heard Island and McDonald Islands": "3062",
			"Myanmar": "123336"
		}
	},
	"Equatorial Guinea": {
		"imports": {},
		"exports": {}
	},
	"Greece": {
		"imports": {
			"Lebanon": "3021",
			"Gibraltar": "3034269",
			"Ghana": "76850",
			"Qatar": "1142782",
			"Dem. Rep. of the Congo": "3072",
			"Cameroon": "117698",
			"South Africa": "10360922",
			"Indonesia": "3708602",
			"Colombia": "46797913",
			"Niger": "7414",
			"Palau": "7403221",
			"Jordan": "556",
			"Uzbekistan": "1321",
			"Iraq": "2617605886",
			"Guam": "1610",
			"Bosnia Herzegovina": "66816",
			"Vanuatu": "2767",
			"Belgium": "24542",
			"Azerbaijan": "193634",
			"Rwanda": "139842",
			"Armenia": "241403",
			"United Kingdom": "6395117",
			"Singapore": "5713",
			"Albania": "267783",
			"Benin": "44844",
			"Panama": "1236879",
			"Cuba": "10047923",
			"Saint Vincent and the Grenadines": "22881928",
			"Curaçao": "8001",
			"Australia": "27531",
			"Kiribati": "1347",
			"Mexico": "105596",
			"Kenya": "151196",
			"Spain": "68177607",
			"Tajikistan": "17788",
			"Ireland": "2345",
			"Botswana": "3900894",
			"French Polynesia": "361175",
			"Mauritania": "912040",
			"Christmas Isds": "1640",
			"Honduras": "115087",
			"Saint Barthélemy": "101",
			"Chile": "4340072",
			"China, Macao SAR": "7840",
			"Malaysia": "10997",
			"Swaziland": "14115",
			"Portugal": "525715",
			"Saint Kitts and Nevis": "354",
			"Nepal": "17387",
			"China": "378115",
			"Comoros": "357126",
			"Djibouti": "177",
			"Trinidad and Tobago": "6770496",
			"Israel": "31215",
			"Burkina Faso": "721585",
			"Paraguay": "37014504",
			"Bangladesh": "87648",
			"Antigua and Barbuda": "49896",
			"Gabon": "273738",
			"Cyprus": "23731",
			"Yemen": "2454939",
			"Mauritius": "272",
			"Slovakia": "2434644",
			"Faeroe Isds": "397138",
			"Turkmenistan": "33329684",
			"Bahrain": "354",
			"Côte d'Ivoire": "52667",
			"Algeria": "144169783",
			"USA": "34880687",
			"Cambodia": "88594",
			"Rep. of Moldova": "1252530",
			"Zambia": "17816",
			"Malta": "2047",
			"Ecuador": "1261040",
			"Dominican Rep.": "354967",
			"France": "3050",
			"New Caledonia": "387",
			"Seychelles": "445",
			"Br. Virgin Isds": "976287",
			"Italy": "332452",
			"Saint Lucia": "776",
			"State of Palestine": "17691",
			"Uganda": "636357",
			"Belarus": "3928",
			"Ethiopia": "160497",
			"Congo": "198745",
			"Senegal": "9398865",
			"Bulgaria": "10222861",
			"Montenegro": "2209",
			"Sri Lanka": "372423",
			"Hungary": "59757",
			"Angola": "111",
			"Myanmar": "717455",
			"Papua New Guinea": "10552",
			"Uruguay": "953966",
			"Switzerland": "57034",
			"Germany": "3521459",
			"Poland": "3788611",
			"Thailand": "536966",
			"Argentina": "59228",
			"Brazil": "4792",
			"Dominica": "11806",
			"Mongolia": "852",
			"Saudi Arabia": "707898252",
			"Syria": "298577",
			"Russian Federation": "110356",
			"Cayman Isds": "8853",
			"United Arab Emirates": "60640",
			"Nicaragua": "2446146",
			"Malawi": "83261",
			"Andorra": "13788",
			"El Salvador": "345131",
			"United States Minor Outlying Islands": "2329",
			"Latvia": "419237",
			"Japan": "12703768",
			"Guinea": "7838",
			"Romania": "11976093",
			"Slovenia": "6191678",
			"Liberia": "442744",
			"Guatemala": "34984",
			"Madagascar": "117607",
			"Bolivia (Plurinational State of)": "320578",
			"Nigeria": "847443",
			"Bahamas": "775",
			"San Marino": "56724",
			"Chad": "218679",
			"Viet Nam": "12539187",
			"Haiti": "672",
			"Oman": "221",
			"Sweden": "9872092",
			"Maldives": "1079",
			"India": "43124177",
			"Jamaica": "1992",
			"Austria": "54210",
			"Zimbabwe": "18640",
			"Pakistan": "9808",
			"Fiji": "1177",
			"Lithuania": "825551",
			"Namibia": "2627047",
			"Denmark": "80173",
			"Peru": "52311",
			"Netherlands": "973382",
			"Costa Rica": "510811",
			"Equatorial Guinea": "175495",
			"Sudan": "6001",
			"Kazakhstan": "1236821086",
			"Afghanistan": "2017",
			"Croatia": "15769",
			"Egypt": "21314925",
			"Estonia": "1075260",
			"Morocco": "1168580",
			"Luxembourg": "6793",
			"TFYR of Macedonia": "2738416",
			"Somalia": "120669",
			"United Rep. of Tanzania": "133853",
			"Finland": "288646",
			"Belize": "1145",
			"Georgia": "24223",
			"Ukraine": "9941713",
			"Bermuda": "33",
			"China, Hong Kong SAR": "30586",
			"Suriname": "191",
			"Barbados": "4304",
			"Iran": "792370743",
			"Venezuela": "332",
			"Kuwait": "11959125",
			"New Zealand": "758",
			"Norway": "569310",
			"Sierra Leone": "303085",
			"Marshall Isds": "6304468",
			"Philippines": "669",
			"Libya": "136889683",
			"Kyrgyzstan": "286271",
			"Czechia": "6758",
			"Br. Indian Ocean Terr.": "11302",
			"Mozambique": "879054",
			"Togo": "521705",
			"Turkey": "41735180",
			"Tunisia": "780367",
			"Rep. of Korea": "188522",
			"Serbia": "4268572",
			"Cook Isds": "1122103",
			"Canada": "533146",
			"Iceland": "696447"
		},
		"exports": {
			"Lebanon": "5581",
			"Bonaire": "8757",
			"Gibraltar": "1107",
			"Ghana": "111",
			"Lesotho": "4155",
			"Qatar": "186128",
			"Dem. Rep. of the Congo": "8819",
			"Dem. People's Rep. of Korea": "22466",
			"Cameroon": "7082",
			"South Africa": "431494",
			"Montserrat": "864",
			"Indonesia": "798967",
			"Colombia": "3917898",
			"Niger": "433",
			"Palau": "6772",
			"Tonga": "123",
			"Jordan": "7361",
			"Fr. South Antarctic Terr.": "1439",
			"Uzbekistan": "36052",
			"Iraq": "55331",
			"Tuvalu": "293075",
			"Guam": "120",
			"Bosnia Herzegovina": "97382",
			"Pakistan": "1165795",
			"Belgium": "367705",
			"Azerbaijan": "8853",
			"Rwanda": "5201",
			"Armenia": "29727",
			"United Kingdom": "125244513",
			"Singapore": "900289",
			"Albania": "145773",
			"Benin": "12919",
			"Antarctica": "13938465",
			"Panama": "160",
			"Cuba": "607939",
			"Saint Vincent and the Grenadines": "9469",
			"Curaçao": "14466668",
			"Australia": "665541",
			"Kiribati": "16971",
			"Mexico": "2331",
			"Kenya": "63196",
			"Spain": "125675345",
			"Tajikistan": "22522",
			"Ireland": "24124",
			"Botswana": "245",
			"Côte d'Ivoire": "1660",
			"French Polynesia": "1215",
			"Mauritania": "158951",
			"Honduras": "70951",
			"Saint Barthélemy": "27307",
			"Cambodia": "784709",
			"Holy See (Vatican City State)": "5760",
			"Chile": "14231",
			"Gambia": "17706",
			"China, Macao SAR": "3010",
			"Brunei Darussalam": "844",
			"Malaysia": "7044",
			"Swaziland": "1942",
			"Portugal": "49194130",
			"Falkland Isds (Malvinas)": "7925886",
			"Nepal": "33301",
			"China": "157",
			"Comoros": "2546",
			"Guinea-Bissau": "179244",
			"Saint Maarten": "2709",
			"Mali": "4478229",
			"Trinidad and Tobago": "585172",
			"Israel": "31378",
			"Burkina Faso": "3483376",
			"Paraguay": "3646006",
			"Bangladesh": "71402",
			"Antigua and Barbuda": "7746",
			"Gabon": "111346",
			"Cyprus": "160717",
			"Yemen": "1413773",
			"Mauritius": "489448",
			"Slovakia": "12693671",
			"Faeroe Isds": "8492",
			"Turkmenistan": "1956",
			"Bahrain": "118407",
			"South Sudan": "830",
			"Guyana": "6520",
			"Algeria": "3179",
			"USA": "45466765",
			"Saint Kitts and Nevis": "5743",
			"Rep. of Moldova": "79123",
			"Zambia": "34894",
			"Malta": "247",
			"Ecuador": "602307",
			"Grenada": "90973",
			"Dominican Rep.": "591412",
			"France": "752539",
			"New Caledonia": "23535",
			"Niue": "60782",
			"Seychelles": "16803",
			"Br. Virgin Isds": "4813754",
			"Italy": "30553399",
			"Saint Lucia": "7787",
			"State of Palestine": "122629",
			"Uganda": "1195",
			"Belarus": "434676",
			"Ethiopia": "383300",
			"Pitcairn": "2414",
			"Senegal": "775",
			"Bulgaria": "815562",
			"Montenegro": "27665",
			"Sri Lanka": "183042",
			"Hungary": "45549",
			"Angola": "475451",
			"New Zealand": "64482",
			"Lao People's Dem. Rep.": "5266",
			"Myanmar": "65864",
			"Iran": "14851",
			"Sao Tome and Principe": "1171",
			"Uruguay": "14635",
			"Andorra": "121942",
			"Cabo Verde": "3326",
			"Germany": "357",
			"Poland": "118568",
			"Thailand": "1321639",
			"Argentina": "21417",
			"Brazil": "60075",
			"Dominica": "8272",
			"Mongolia": "25244",
			"Saudi Arabia": "5293386",
			"Syria": "55618",
			"Russian Federation": "8478",
			"Cayman Isds": "85209",
			"United Arab Emirates": "7892535",
			"Nicaragua": "885",
			"Malawi": "18640",
			"Switzerland": "9939699",
			"El Salvador": "31113",
			"United States Minor Outlying Islands": "926",
			"Latvia": "18109",
			"Japan": "5843",
			"Guinea": "40234",
			"Romania": "123219150",
			"Slovenia": "5077422",
			"Liberia": "492",
			"Guatemala": "587123",
			"Madagascar": "2014",
			"Bolivia (Plurinational State of)": "9821",
			"Nigeria": "111734",
			"Bahamas": "40766",
			"Tunisia": "3221982",
			"Chad": "9296",
			"Viet Nam": "124736",
			"Haiti": "46846",
			"Oman": "108749",
			"Sweden": "14073110",
			"Maldives": "11161",
			"India": "3545546",
			"Jamaica": "1351",
			"Austria": "71478",
			"Congo": "4227",
			"Zimbabwe": "5360",
			"Vanuatu": "2124",
			"Fiji": "32511",
			"Lithuania": "16913",
			"Namibia": "2213",
			"Denmark": "267363",
			"Peru": "3735098",
			"Central African Rep.": "160669",
			"Netherlands": "1995",
			"Costa Rica": "10291",
			"Equatorial Guinea": "29939",
			"Sudan": "25814",
			"Papua New Guinea": "515",
			"Kazakhstan": "11325",
			"Afghanistan": "134896",
			"Croatia": "94384",
			"Saint Helena": "2200138",
			"Egypt": "24408283",
			"Anguilla": "4789",
			"Estonia": "42759",
			"Morocco": "19918980",
			"Luxembourg": "56644",
			"TFYR of Macedonia": "23639071",
			"Somalia": "27878",
			"United Rep. of Tanzania": "41147",
			"Finland": "22314",
			"Belize": "4938",
			"Georgia": "4648",
			"Ukraine": "16266335",
			"Bermuda": "2484",
			"Djibouti": "109886",
			"Greenland": "1636",
			"China, Hong Kong SAR": "13268",
			"Suriname": "51263",
			"Barbados": "7152",
			"Venezuela": "22",
			"Kuwait": "30432",
			"Norway": "664662",
			"Sierra Leone": "100907",
			"Marshall Isds": "511469",
			"Philippines": "3287",
			"Libya": "4533",
			"Kyrgyzstan": "16864",
			"Czechia": "109615",
			"Mozambique": "553",
			"Togo": "9457",
			"Aruba": "12892",
			"Turkey": "13122739",
			"San Marino": "32306",
			"Rep. of Korea": "4702",
			"Serbia": "43156432",
			"Burundi": "78825",
			"Bhutan": "1948",
			"Cook Isds": "5106",
			"Canada": "257856",
			"Iceland": "308109"
		}
	},
	"Papua New Guinea": {
		"imports": {},
		"exports": {}
	},
	"Slovenia": {
		"imports": {},
		"exports": {}
	},
	"Afghanistan": {
		"imports": {},
		"exports": {}
	},
	"Saint Helena": {
		"imports": {},
		"exports": {}
	},
	"Egypt": {
		"imports": {
			"Lebanon": "11035205",
			"Gibraltar": "11236",
			"Malawi": "102",
			"Ghana": "2375825",
			"Philippines": "6114566",
			"Niger": "100631",
			"Lesotho": "986",
			"Switzerland": "365726982",
			"Germany": "1548754077",
			"Poland": "4279420",
			"Cuba": "110695",
			"Dem. Rep. of the Congo": "1834257",
			"Thailand": "184748782",
			"Dem. People's Rep. of Korea": "701254",
			"Argentina": "3067",
			"Brazil": "2812051",
			"Cameroon": "224",
			"Brunei Darussalam": "38441",
			"Iran": "204512",
			"Mongolia": "102868",
			"Saudi Arabia": "842144",
			"Panama": "68951",
			"Colombia": "7085920",
			"Sudan": "5815",
			"Russian Federation": "791366596",
			"United Arab Emirates": "4197411",
			"Nicaragua": "28788",
			"Tajikistan": "81",
			"Angola": "163",
			"Kazakhstan": "44536",
			"Andorra": "71",
			"El Salvador": "12488",
			"Uruguay": "6752837",
			"Sierra Leone": "203",
			"Uzbekistan": "169764",
			"Iraq": "31",
			"Japan": "44855",
			"Latvia": "86987",
			"Uganda": "149193",
			"Bosnia Herzegovina": "6052",
			"Pakistan": "92565840",
			"Belgium": "2363352",
			"Croatia": "80774002",
			"Italy": "18682175",
			"Belarus": "699209",
			"United Kingdom": "89550095",
			"Bolivia (Plurinational State of)": "152779",
			"Nigeria": "322784132",
			"Albania": "10324",
			"Benin": "14452810",
			"Maldives": "111092",
			"Tunisia": "36597174",
			"Chad": "122026",
			"Viet Nam": "7105990",
			"Haiti": "8042",
			"South Africa": "246080",
			"Guinea": "5494",
			"Indonesia": "6035049",
			"Qatar": "163908",
			"Oman": "48481340",
			"Sweden": "936746",
			"Australia": "2598760",
			"India": "10216275",
			"Jamaica": "3355",
			"Mexico": "59211748",
			"Br. Virgin Isds": "16748",
			"Austria": "10372482",
			"Eritrea": "3446",
			"Ireland": "98571851",
			"Botswana": "258",
			"Zimbabwe": "577",
			"Côte d'Ivoire": "313873",
			"Egypt": "141749",
			"Spain": "6245522",
			"Mauritania": "1946369",
			"Mozambique": "2147",
			"Lithuania": "14452",
			"Cambodia": "220091",
			"Denmark": "188266189",
			"Peru": "5627",
			"Central African Rep.": "8583",
			"Honduras": "2468",
			"Netherlands": "819123950",
			"Turkey": "56715845",
			"Costa Rica": "691231",
			"Venezuela": "26785679",
			"Burkina Faso": "24637910",
			"Equatorial Guinea": "32356929",
			"Greece": "211281730",
			"Chile": "991297",
			"Azerbaijan": "51",
			"Gambia": "163",
			"Kenya": "250957684",
			"Afghanistan": "137196",
			"Mali": "24906",
			"Dominica": "3187",
			"Malaysia": "6661715",
			"Swaziland": "7020",
			"Portugal": "5140725",
			"United Rep. of Tanzania": "686507",
			"Nepal": "46176",
			"China": "7554202562",
			"Comoros": "390209",
			"Guinea-Bissau": "95720",
			"Estonia": "1544447",
			"Morocco": "374735839",
			"Djibouti": "68542",
			"Trinidad and Tobago": "250",
			"Israel": "9255",
			"TFYR of Macedonia": "760",
			"Somalia": "1017",
			"Montserrat": "48",
			"Singapore": "286407",
			"Paraguay": "32097",
			"Bangladesh": "1677470",
			"Yemen": "15385",
			"Antigua and Barbuda": "4205",
			"Gabon": "573806",
			"Finland": "135467",
			"San Marino": "1389",
			"Cyprus": "80319703",
			"Belize": "1192164",
			"Georgia": "81011",
			"Ukraine": "67396210",
			"Luxembourg": "383343",
			"Saint Helena": "43",
			"Papua New Guinea": "48470",
			"Turkmenistan": "1602778",
			"Bahrain": "207217",
			"Zambia": "114742702",
			"China, Hong Kong SAR": "439236",
			"Mauritius": "2557124",
			"Algeria": "209431794",
			"USA": "5105487",
			"Namibia": "1173102",
			"Rep. of Moldova": "4221493",
			"Romania": "234453760",
			"Kuwait": "285494",
			"Suriname": "968",
			"Malta": "532818323",
			"Norway": "155012394",
			"Ecuador": "11849344",
			"Serbia": "56818",
			"State of Palestine": "4934",
			"Grenada": "49257",
			"Dominican Rep.": "1011356",
			"Marshall Isds": "7550848",
			"France": "13289948",
			"Seychelles": "17603",
			"Libya": "6159919",
			"Czechia": "559811082",
			"Rwanda": "34147",
			"Syria": "4100243",
			"Guatemala": "40124",
			"Ethiopia": "336",
			"Slovenia": "375402",
			"Congo": "2314812",
			"Senegal": "26480",
			"Bulgaria": "1960",
			"Montenegro": "2887103",
			"Sri Lanka": "7299",
			"Rep. of Korea": "162736362",
			"Hungary": "111474522",
			"Jordan": "1973467",
			"Canada": "10523",
			"Iceland": "3678",
			"New Zealand": "293575558"
		},
		"exports": {
			"Lebanon": "724713",
			"Ghana": "28226130",
			"Cuba": "236965",
			"Dem. Rep. of the Congo": "8855833",
			"Dem. People's Rep. of Korea": "1548",
			"Cameroon": "10076086",
			"South Africa": "1177668",
			"Montserrat": "170396",
			"Indonesia": "526756",
			"Colombia": "7451580",
			"Niger": "7865322",
			"Angola": "1719522",
			"Uzbekistan": "178820",
			"Iraq": "49334204",
			"Bosnia Herzegovina": "10694",
			"Pakistan": "122497123",
			"Belgium": "17040879",
			"Azerbaijan": "65511",
			"Armenia": "318783",
			"Togo": "1080953",
			"Singapore": "410305",
			"Albania": "76811",
			"Benin": "7610647",
			"Panama": "2104",
			"Qatar": "446396",
			"Curaçao": "26235",
			"Australia": "984506",
			"Mexico": "56566159",
			"Kenya": "625597",
			"Spain": "13406311",
			"Tajikistan": "344",
			"Ireland": "78389",
			"Botswana": "22",
			"Mauritania": "10369201",
			"Honduras": "155391",
			"United Kingdom": "132020703",
			"Chile": "5654599",
			"Gambia": "352962",
			"China, Macao SAR": "1443",
			"Brunei Darussalam": "69725",
			"Malaysia": "322",
			"Swaziland": "855",
			"Peru": "625541",
			"Nepal": "14640608",
			"China": "495031169",
			"Comoros": "855749",
			"Guinea-Bissau": "37915",
			"Djibouti": "959749",
			"Trinidad and Tobago": "50087",
			"Israel": "15442959",
			"Burkina Faso": "6346",
			"Paraguay": "712918",
			"Bangladesh": "161109",
			"Antigua and Barbuda": "1449",
			"Gabon": "10274861",
			"Cyprus": "57793564",
			"Yemen": "2218739",
			"Mauritius": "21232204",
			"Slovakia": "141641",
			"Turkmenistan": "2067328",
			"Bahrain": "316955",
			"Côte d'Ivoire": "186368",
			"Algeria": "6948",
			"USA": "2077",
			"Namibia": "356859",
			"Rep. of Moldova": "1012355",
			"Zambia": "8459",
			"Malta": "88837137",
			"Ecuador": "108776",
			"Grenada": "58980",
			"Portugal": "4356991",
			"France": "22535403",
			"Seychelles": "177",
			"Oceania, nes": "111830",
			"Br. Virgin Isds": "11142",
			"Italy": "70429350",
			"Saint Lucia": "13749",
			"State of Palestine": "40465817",
			"Nicaragua": "881",
			"Syria": "47072124",
			"Belarus": "266803",
			"Ethiopia": "865455",
			"Slovenia": "607491",
			"Congo": "18833286",
			"Senegal": "278798",
			"Bulgaria": "471494",
			"Dominican Rep.": "489520",
			"Sri Lanka": "2870289",
			"Hungary": "12310298",
			"Jordan": "1694619",
			"Samoa": "14693",
			"Iran": "30952",
			"Uruguay": "20436",
			"Andorra": "21005",
			"Cabo Verde": "174298",
			"Germany": "294344153",
			"Poland": "326639",
			"Thailand": "519151",
			"Argentina": "89165",
			"Brazil": "21685316",
			"Dominica": "516821",
			"Mongolia": "74967",
			"Saudi Arabia": "60359262",
			"Greece": "100801369",
			"Russian Federation": "150270",
			"United Arab Emirates": "21851706",
			"Rwanda": "10938998",
			"Malawi": "59879",
			"Switzerland": "2453015",
			"El Salvador": "13791",
			"Latvia": "920132",
			"Japan": "8161",
			"Guinea": "409823",
			"Uganda": "3257432",
			"Romania": "54843",
			"Croatia": "17108953",
			"Liberia": "36907",
			"Guatemala": "164175",
			"Bolivia (Plurinational State of)": "7385",
			"Barbados": "58420",
			"Tunisia": "17400975",
			"Chad": "1438143",
			"Viet Nam": "726782",
			"Haiti": "124009",
			"Oman": "159032193",
			"Sweden": "599455",
			"Maldives": "1406383",
			"India": "1828156",
			"Jamaica": "211671",
			"Austria": "5269",
			"Eritrea": "208318",
			"Zimbabwe": "375343",
			"Lithuania": "49744",
			"Cambodia": "402757",
			"Denmark": "11106203",
			"Somalia": "543065",
			"Central African Rep.": "8",
			"Netherlands": "331199389",
			"Costa Rica": "1057762",
			"Sudan": "340129",
			"Papua New Guinea": "34",
			"Kazakhstan": "1427026",
			"Afghanistan": "470912",
			"Montenegro": "530627",
			"Estonia": "486081",
			"Morocco": "328309781",
			"Luxembourg": "82236",
			"TFYR of Macedonia": "66477",
			"United Rep. of Tanzania": "78655",
			"Finland": "5016824",
			"Georgia": "1130124",
			"Ukraine": "195623",
			"Bermuda": "6992",
			"Mali": "18683409",
			"China, Hong Kong SAR": "14015",
			"Suriname": "3276",
			"Nigeria": "88264891",
			"Venezuela": "6501",
			"Kuwait": "1930482",
			"New Zealand": "4686689",
			"Norway": "10264115",
			"Sierra Leone": "129720",
			"Philippines": "6137",
			"Libya": "3003475",
			"Czechia": "76393987",
			"Mozambique": "10789536",
			"Turkey": "18471752",
			"San Marino": "290924",
			"Rep. of Korea": "138861",
			"Serbia": "4641",
			"Burundi": "292604",
			"Canada": "65748",
			"Iceland": "1130916"
		}
	},
	"Nauru": {
		"imports": {},
		"exports": {}
	},
	"Anguilla": {
		"imports": {},
		"exports": {}
	},
	"Estonia": {
		"imports": {
			"Lebanon": "12",
			"Iran": "14870",
			"Lesotho": "16699",
			"Comoros": "568",
			"Germany": "6442872",
			"Poland": "774408",
			"Cuba": "1856",
			"Dem. Rep. of the Congo": "171401",
			"Thailand": "428426",
			"Dem. People's Rep. of Korea": "255813",
			"Argentina": "3714416",
			"Brazil": "1879628",
			"Azerbaijan": "407109",
			"Cameroon": "10417",
			"Dominica": "3794",
			"Ghana": "56056773",
			"Mongolia": "2163",
			"Saudi Arabia": "163564",
			"Panama": "4897",
			"Colombia": "2562934",
			"Syria": "212801",
			"Niger": "3023",
			"United Arab Emirates": "16053",
			"Nicaragua": "20000",
			"Palau": "52",
			"Tajikistan": "56334",
			"Jordan": "55085",
			"Malawi": "301",
			"Switzerland": "56469",
			"El Salvador": "11300",
			"Saint Lucia": "1601",
			"Uruguay": "100",
			"Sierra Leone": "8882",
			"Slovakia": "1677",
			"Latvia": "130850",
			"Japan": "2003451",
			"Guam": "481",
			"Tunisia": "159332",
			"Guinea": "3229737",
			"Bosnia Herzegovina": "18490",
			"Pakistan": "408",
			"Belgium": "3364138",
			"Russian Federation": "42743",
			"Belize": "1702",
			"Croatia": "225025",
			"Rwanda": "338",
			"Australia": "9768",
			"Madagascar": "1032945",
			"Bolivia (Plurinational State of)": "830",
			"Barbados": "227",
			"Albania": "339",
			"South Africa": "9965",
			"Bahamas": "562",
			"San Marino": "9709",
			"Chad": "998",
			"Viet Nam": "28102",
			"Haiti": "16037",
			"Mozambique": "1342",
			"Tokelau": "116",
			"USA": "690007",
			"Indonesia": "108731",
			"Qatar": "15",
			"Oman": "9932",
			"Curaçao": "1233",
			"Armenia": "664",
			"Bahrain": "298069",
			"India": "42877",
			"Jamaica": "2573",
			"Mexico": "524347",
			"Kenya": "7894",
			"Austria": "7523520",
			"Eritrea": "1160",
			"Ireland": "7497",
			"Botswana": "5",
			"Zimbabwe": "192255",
			"Côte d'Ivoire": "8",
			"Norfolk Isds": "16",
			"Mauritania": "4376",
			"Swaziland": "2532",
			"Lithuania": "194676",
			"Namibia": "2511",
			"Denmark": "54463167",
			"United Kingdom": "1518162",
			"Peru": "301288",
			"Central African Rep.": "807",
			"Honduras": "378491",
			"Saint Barthélemy": "2356",
			"Netherlands": "290905",
			"Turkey": "4",
			"Costa Rica": "429",
			"Venezuela": "11543",
			"Papua New Guinea": "3602",
			"Guatemala": "20582",
			"Greece": "33943",
			"Chile": "354",
			"Kazakhstan": "8537",
			"Turkmenistan": "2427",
			"China, Macao SAR": "1127",
			"Afghanistan": "2258",
			"Sweden": "109364",
			"Malaysia": "558",
			"Fiji": "5403",
			"Portugal": "4807",
			"Nepal": "34351",
			"China": "515075",
			"Egypt": "314",
			"Anguilla": "72",
			"Estonia": "1372",
			"Morocco": "17606",
			"Luxembourg": "61192",
			"Trinidad and Tobago": "83970",
			"Israel": "1920",
			"TFYR of Macedonia": "321228",
			"Burkina Faso": "2531",
			"Singapore": "351",
			"Paraguay": "716692",
			"French Polynesia": "282796",
			"Bangladesh": "435010",
			"United Rep. of Tanzania": "360",
			"Finland": "349654930",
			"Cyprus": "854904",
			"Zambia": "430",
			"Georgia": "13895",
			"Serbia": "137506",
			"Mali": "15747",
			"Faeroe Isds": "166",
			"Greenland": "456560",
			"Suriname": "712193",
			"Uzbekistan": "726107",
			"China, Hong Kong SAR": "1709",
			"Guyana": "14306",
			"Mauritius": "21354",
			"Algeria": "6366",
			"Nigeria": "11904687",
			"Cambodia": "45857",
			"Rep. of Moldova": "47701",
			"Romania": "362",
			"Kuwait": "6165",
			"Spain": "30519",
			"Malta": "10908",
			"Norway": "38637",
			"Ecuador": "8653468",
			"Grenada": "229",
			"Dominican Rep.": "155610",
			"France": "62233220",
			"Philippines": "8661753",
			"Seychelles": "9065",
			"Br. Virgin Isds": "12541",
			"Italy": "1084440",
			"Kyrgyzstan": "45899",
			"Czechia": "29608102",
			"Uganda": "7100",
			"Br. Indian Ocean Terr.": "80",
			"Belarus": "55721",
			"Ethiopia": "41303",
			"Slovenia": "31",
			"Togo": "1316987",
			"Congo": "99378",
			"Senegal": "94690",
			"Bulgaria": "1486755",
			"Montenegro": "11436",
			"Sri Lanka": "46003",
			"Rep. of Korea": "15196",
			"Hungary": "47121",
			"Bhutan": "42",
			"New Zealand": "332159",
			"Canada": "63245",
			"Iceland": "121253",
			"Lao People's Dem. Rep.": "456",
			"Ukraine": "115218",
			"Myanmar": "969"
		},
		"exports": {
			"Lebanon": "1550",
			"Bonaire": "21207399",
			"Gibraltar": "1356",
			"Ghana": "25809",
			"Cuba": "14557",
			"Dem. Rep. of the Congo": "10443",
			"Dem. People's Rep. of Korea": "15662",
			"Cameroon": "68083",
			"South Africa": "3894",
			"Indonesia": "3650",
			"Colombia": "11",
			"Palau": "12511",
			"Jordan": "203520",
			"Fr. South Antarctic Terr.": "118859",
			"Uzbekistan": "469504",
			"Iraq": "3769",
			"Tuvalu": "26531",
			"Bosnia Herzegovina": "262356",
			"Pakistan": "391",
			"Belgium": "2381138",
			"Azerbaijan": "743426",
			"Rwanda": "16137",
			"Australia": "41218",
			"United Kingdom": "1698110",
			"Singapore": "20185",
			"Albania": "23302",
			"Benin": "19206",
			"Panama": "42377",
			"Qatar": "87497",
			"Saint Vincent and the Grenadines": "4264",
			"Curaçao": "913",
			"Armenia": "88891",
			"Jamaica": "897",
			"Kenya": "393238",
			"Spain": "415560",
			"Tajikistan": "42734",
			"Br. Virgin Isds": "1783",
			"South Sudan": "3910",
			"French Polynesia": "206833",
			"Mauritania": "6129",
			"Honduras": "61991",
			"Ireland": "6555",
			"Chile": "49182",
			"Sudan": "766533",
			"Gambia": "454",
			"Liberia": "28505",
			"Dominica": "111629",
			"Malaysia": "942",
			"Peru": "17381",
			"Nepal": "6352",
			"China": "5314",
			"Comoros": "20",
			"Mali": "14095",
			"Trinidad and Tobago": "105",
			"Israel": "26035",
			"Burkina Faso": "1134",
			"Paraguay": "48519",
			"Bangladesh": "25820",
			"Antigua and Barbuda": "14107",
			"Gabon": "23133",
			"Cyprus": "976067",
			"Yemen": "224",
			"Mauritius": "2139",
			"Slovakia": "163481",
			"Faeroe Isds": "3",
			"Turkmenistan": "45918",
			"Bahrain": "5978",
			"Côte d'Ivoire": "354",
			"Guyana": "1",
			"Algeria": "4813900",
			"USA": "1974766",
			"Saint Kitts and Nevis": "4118",
			"Rep. of Moldova": "6531",
			"Zambia": "3066",
			"Malta": "19378",
			"Ecuador": "135481",
			"Dominican Rep.": "127",
			"France": "33761058",
			"New Caledonia": "24348",
			"Seychelles": "11636",
			"Italy": "246461",
			"State of Palestine": "13222",
			"Uganda": "16327",
			"Belarus": "436697",
			"Ethiopia": "26983",
			"Namibia": "155",
			"Congo": "93",
			"Slovenia": "4899",
			"Bulgaria": "388696",
			"Montenegro": "5745",
			"Sri Lanka": "493",
			"Hungary": "9659",
			"Angola": "14521",
			"New Zealand": "70130",
			"Lao People's Dem. Rep.": "1645",
			"Iran": "22377",
			"Uruguay": "82617",
			"Andorra": "8963",
			"Germany": "20393759",
			"Poland": "41997",
			"Thailand": "545002",
			"Argentina": "72",
			"Brazil": "13844",
			"Brunei Darussalam": "1608",
			"Mongolia": "4483",
			"Saudi Arabia": "755158",
			"Syria": "119748",
			"Russian Federation": "6416021",
			"United Arab Emirates": "39864",
			"Nicaragua": "59659",
			"Malawi": "17103",
			"Switzerland": "8610",
			"El Salvador": "15856",
			"Latvia": "1692693",
			"Japan": "694035",
			"Guinea": "44",
			"Romania": "4664",
			"Croatia": "226449",
			"China, Macao SAR": "8654",
			"Mozambique": "24211",
			"Madagascar": "3766",
			"Bolivia (Plurinational State of)": "123540",
			"Barbados": "1",
			"Bahamas": "89576",
			"Tunisia": "26512",
			"Viet Nam": "1694",
			"Oman": "203420",
			"Sweden": "12675685",
			"Maldives": "40928",
			"India": "29",
			"Mexico": "2007870",
			"Austria": "1568273",
			"Zimbabwe": "50640",
			"Saint Maarten": "300",
			"Senegal": "452",
			"Lithuania": "931948",
			"Cambodia": "50733",
			"Denmark": "38228656",
			"Portugal": "68080",
			"Netherlands": "4708",
			"Costa Rica": "144223",
			"South Georgia and the South Sandwich Islands": "2274",
			"Papua New Guinea": "432",
			"Kazakhstan": "3882",
			"Afghanistan": "147330",
			"Greece": "99089",
			"Egypt": "16129",
			"Morocco": "2650876",
			"Luxembourg": "4161",
			"TFYR of Macedonia": "16605",
			"United Rep. of Tanzania": "4901",
			"Finland": "366095460",
			"Belize": "247657",
			"Georgia": "21395",
			"Ukraine": "25373",
			"Greenland": "910",
			"China, Hong Kong SAR": "1937",
			"Suriname": "19032",
			"Nigeria": "88747",
			"Venezuela": "29756",
			"Kuwait": "21918",
			"Norway": "1845787",
			"Sierra Leone": "337373",
			"Marshall Isds": "4729",
			"Philippines": "4563",
			"Libya": "50388",
			"Kyrgyzstan": "16605",
			"Czechia": "11068605",
			"Br. Indian Ocean Terr.": "58129",
			"Guatemala": "31506",
			"Togo": "19463695",
			"Aruba": "5782",
			"Turkey": "18293",
			"San Marino": "6024",
			"Rep. of Korea": "415397",
			"Serbia": "50921",
			"Bhutan": "7542",
			"Canada": "69054",
			"Iceland": "8056"
		}
	},
	"Morocco": {
		"imports": {
			"Lebanon": "77",
			"Gibraltar": "908",
			"Ghana": "1076254",
			"Lesotho": "120",
			"Qatar": "62",
			"Dem. Rep. of the Congo": "6114654",
			"Dem. People's Rep. of Korea": "3917",
			"Cameroon": "3166",
			"Papua New Guinea": "889",
			"Indonesia": "45519",
			"Colombia": "224074",
			"Niger": "104302",
			"Angola": "35496",
			"Uzbekistan": "2037956",
			"Iraq": "523",
			"Bosnia Herzegovina": "3751",
			"Pakistan": "460",
			"Belgium": "21062255",
			"Azerbaijan": "192",
			"Rwanda": "58970",
			"Australia": "2208921",
			"United Kingdom": "257145",
			"Singapore": "155",
			"Albania": "20280",
			"Benin": "37",
			"FS Micronesia": "1",
			"Panama": "721",
			"Cuba": "1694790",
			"American Samoa": "58810",
			"Armenia": "1147",
			"Mexico": "2614911",
			"Br. Virgin Isds": "26431",
			"Spain": "1759075",
			"Tajikistan": "20055",
			"Ireland": "34",
			"Mauritania": "34443",
			"Honduras": "34195",
			"Jordan": "1303371",
			"Chile": "201980",
			"Gambia": "10311",
			"China, Macao SAR": "9254",
			"Brunei Darussalam": "11",
			"Malaysia": "149502",
			"Swaziland": "22143",
			"Peru": "4705698",
			"Falkland Isds (Malvinas)": "250905",
			"Nepal": "1890",
			"China": "78922539",
			"Guinea-Bissau": "112011",
			"Djibouti": "1",
			"Trinidad and Tobago": "2300182",
			"Burkina Faso": "930894",
			"Paraguay": "1590",
			"Bangladesh": "4756964",
			"Gabon": "13675280",
			"Cyprus": "331152",
			"Mauritius": "276205",
			"Slovakia": "1042",
			"Faeroe Isds": "880291",
			"Turkmenistan": "3237",
			"Bahrain": "460251",
			"Côte d'Ivoire": "967",
			"Guyana": "947",
			"Algeria": "1054433",
			"USA": "13448640",
			"Namibia": "5625",
			"Rep. of Moldova": "3062",
			"Zambia": "2237",
			"Malta": "9128",
			"Ecuador": "4807",
			"Dominican Rep.": "44814",
			"France": "1418763644",
			"New Caledonia": "29",
			"Italy": "4038653",
			"State of Palestine": "66050",
			"Uganda": "6707091",
			"Syria": "135941",
			"Belarus": "138500",
			"Ethiopia": "61534",
			"Slovenia": "559657",
			"Sierra Leone": "216224",
			"Senegal": "41620",
			"Bulgaria": "1723279",
			"Montenegro": "164",
			"Sri Lanka": "704246",
			"Hungary": "1830515",
			"New Zealand": "3346163",
			"Lao People's Dem. Rep.": "487351",
			"Myanmar": "15341",
			"South Africa": "3933529",
			"Uruguay": "8534307",
			"Switzerland": "45442",
			"Cabo Verde": "193",
			"Germany": "632070112",
			"Poland": "3964109",
			"Thailand": "883354",
			"Argentina": "713712",
			"Brazil": "1439885",
			"Dominica": "29000",
			"Mongolia": "944",
			"Saudi Arabia": "12491",
			"Greece": "16735092",
			"Russian Federation": "22370",
			"United Arab Emirates": "995",
			"Nicaragua": "6335",
			"Andorra": "956",
			"El Salvador": "43473",
			"United States Minor Outlying Islands": "1063",
			"Latvia": "4821365",
			"Japan": "5969597",
			"Guinea": "82619",
			"Romania": "40191",
			"Croatia": "20962",
			"Mozambique": "222",
			"Madagascar": "2197988",
			"Bolivia (Plurinational State of)": "381",
			"Nigeria": "918",
			"Bahamas": "1136",
			"Tunisia": "4736",
			"Chad": "582",
			"Viet Nam": "151860",
			"Haiti": "3924",
			"Tokelau": "2015",
			"Oman": "627745",
			"Sweden": "275",
			"Maldives": "195",
			"India": "11940",
			"Jamaica": "3525",
			"Austria": "6307642",
			"Eritrea": "3291",
			"Congo": "3649",
			"Zimbabwe": "25",
			"Vanuatu": "29",
			"Lithuania": "3885650",
			"Cambodia": "720601",
			"Denmark": "21035172",
			"Portugal": "1182207",
			"Central African Rep.": "224",
			"Netherlands": "452935",
			"Costa Rica": "48209",
			"Equatorial Guinea": "312722",
			"Sudan": "1700233",
			"Kazakhstan": "2398",
			"Kenya": "352",
			"Egypt": "156",
			"Estonia": "11762327",
			"Luxembourg": "83644",
			"TFYR of Macedonia": "6158",
			"Somalia": "178025",
			"United Rep. of Tanzania": "101632",
			"Finland": "134631102",
			"Belize": "189",
			"Georgia": "1489341",
			"Ukraine": "190081931",
			"Bermuda": "2831",
			"Mali": "7505",
			"Greenland": "13492078",
			"China, Hong Kong SAR": "793030",
			"Suriname": "193",
			"Barbados": "1747",
			"Iran": "14267",
			"Venezuela": "4547",
			"Kuwait": "57136",
			"Norway": "551",
			"Pitcairn": "58",
			"Marshall Isds": "479",
			"Philippines": "32069",
			"Libya": "10906",
			"Kyrgyzstan": "7",
			"Czechia": "32833047",
			"Guatemala": "114588",
			"Togo": "8644840",
			"Turkey": "97279",
			"Rep. of Korea": "102585",
			"Serbia": "663",
			"Burundi": "50028",
			"Bhutan": "145787",
			"Canada": "3010815",
			"Iceland": "677"
		},
		"exports": {
			"Lebanon": "1378910",
			"Gibraltar": "26197",
			"Ghana": "28737548",
			"Cuba": "47291",
			"Dem. Rep. of the Congo": "42812",
			"Dem. People's Rep. of Korea": "104",
			"Cameroon": "966990",
			"Iran": "11850",
			"Indonesia": "26424",
			"Colombia": "86347",
			"Niger": "6958",
			"Angola": "4340",
			"Uzbekistan": "12973",
			"Iraq": "2277347",
			"Nicaragua": "51",
			"Bosnia Herzegovina": "3163",
			"Pakistan": "45817",
			"Belgium": "6260095",
			"Azerbaijan": "2024",
			"Armenia": "2143",
			"United Kingdom": "443",
			"Singapore": "1",
			"Albania": "19349",
			"Benin": "25876855",
			"Panama": "106761",
			"Qatar": "165192",
			"Saint Vincent and the Grenadines": "41471",
			"Curaçao": "117289",
			"Australia": "55334",
			"Mexico": "12520",
			"Kenya": "232",
			"Spain": "109356",
			"Ireland": "85586901",
			"Botswana": "549",
			"French Polynesia": "605858",
			"Mauritania": "11132",
			"Honduras": "293707",
			"Jordan": "875513",
			"Chile": "32731",
			"Gambia": "6073613",
			"China, Macao SAR": "392",
			"Malaysia": "30588",
			"Swaziland": "2724",
			"Peru": "25525122",
			"Nepal": "1613",
			"China": "1649442",
			"Comoros": "307299",
			"Guinea-Bissau": "27131",
			"Mali": "71",
			"Trinidad and Tobago": "587",
			"Burkina Faso": "238135",
			"Paraguay": "729047",
			"Bangladesh": "134381370",
			"Antigua and Barbuda": "1888",
			"Gabon": "13806088",
			"Cyprus": "157599",
			"Yemen": "939",
			"Mauritius": "52409",
			"Slovakia": "300646",
			"Turkmenistan": "129544",
			"Bahrain": "85549",
			"Côte d'Ivoire": "2735561",
			"Guyana": "58220",
			"Algeria": "31988871",
			"USA": "2755",
			"Saint Kitts and Nevis": "19945",
			"Rep. of Moldova": "681",
			"Zambia": "7349",
			"Malta": "1510",
			"Ecuador": "2029",
			"Grenada": "45678",
			"Dominican Rep.": "22182",
			"France": "902968818",
			"New Caledonia": "3010",
			"Seychelles": "27121",
			"Italy": "64076",
			"Saint Lucia": "106635",
			"State of Palestine": "154437",
			"Uganda": "617",
			"Syria": "7",
			"Belarus": "15403",
			"Ethiopia": "76039633",
			"Namibia": "73",
			"Congo": "350432",
			"Slovenia": "956",
			"Bulgaria": "72994",
			"Montenegro": "35087",
			"Sri Lanka": "37",
			"Hungary": "713094",
			"New Zealand": "1250",
			"Myanmar": "16970",
			"South Africa": "459",
			"Uruguay": "22612",
			"Andorra": "745728",
			"Cabo Verde": "13732",
			"Germany": "73067611",
			"Poland": "472045",
			"Thailand": "36254",
			"Argentina": "34403",
			"Brazil": "376203",
			"Dominica": "504329",
			"Mongolia": "44924",
			"Saudi Arabia": "30025",
			"Greece": "13328176",
			"Russian Federation": "118670",
			"United Arab Emirates": "292157",
			"Rwanda": "113",
			"Switzerland": "2659618",
			"El Salvador": "606",
			"Latvia": "2133",
			"Japan": "336259",
			"Guinea": "11002441",
			"Romania": "6977",
			"Croatia": "44691",
			"Liberia": "12622",
			"Guatemala": "42715",
			"Madagascar": "20032",
			"Bolivia (Plurinational State of)": "309",
			"Nigeria": "17848",
			"Bahamas": "4362",
			"Tunisia": "1127736",
			"Chad": "132710",
			"Viet Nam": "29795",
			"Haiti": "649569",
			"Oman": "44882",
			"Sweden": "1218294",
			"Maldives": "16304",
			"India": "949",
			"Jamaica": "70165",
			"Austria": "62448382",
			"Zimbabwe": "656",
			"Senegal": "12485",
			"Fiji": "1648",
			"Lithuania": "69617",
			"Cambodia": "2143",
			"Denmark": "1011720",
			"Portugal": "387",
			"Central African Rep.": "16476",
			"Netherlands": "868",
			"Costa Rica": "988",
			"Equatorial Guinea": "4897267",
			"Sudan": "1868",
			"Kazakhstan": "1025",
			"Afghanistan": "10",
			"Egypt": "835",
			"Estonia": "146102",
			"Luxembourg": "55512",
			"TFYR of Macedonia": "6550",
			"Somalia": "8757",
			"United Rep. of Tanzania": "12093",
			"Finland": "521778",
			"Belize": "3818",
			"Georgia": "32",
			"Ukraine": "8557",
			"Djibouti": "73646971",
			"China, Hong Kong SAR": "168747",
			"Suriname": "20652",
			"Barbados": "11809",
			"Venezuela": "2449",
			"Kuwait": "312486",
			"Norway": "11805381",
			"Sierra Leone": "4903",
			"Marshall Isds": "6051",
			"Philippines": "2011",
			"Libya": "3052050",
			"Kyrgyzstan": "975",
			"Czechia": "596321",
			"Mozambique": "3538",
			"Togo": "6750",
			"Aruba": "124",
			"Turkey": "1715421",
			"Rep. of Korea": "626863",
			"Serbia": "112918",
			"Burundi": "134316",
			"Canada": "626092",
			"Iceland": "1812"
		}
	},
	"Luxembourg": {
		"imports": {
			"Lebanon": "162753",
			"Gibraltar": "1351",
			"Ghana": "5",
			"Lesotho": "53",
			"Qatar": "200",
			"Dem. Rep. of the Congo": "29019",
			"Dem. People's Rep. of Korea": "1179173",
			"Cameroon": "49691",
			"South Africa": "78598",
			"Panama": "15258",
			"Colombia": "91204",
			"Niger": "2271",
			"Tonga": "217",
			"Angola": "2254",
			"Uzbekistan": "2169",
			"Iraq": "134",
			"Tuvalu": "1736",
			"Bosnia Herzegovina": "34428",
			"Pakistan": "740",
			"Belgium": "387475840",
			"Azerbaijan": "6522",
			"Rwanda": "941",
			"Australia": "54037",
			"United Kingdom": "114108",
			"Singapore": "1927",
			"Albania": "298616",
			"Benin": "4599",
			"Indonesia": "1735765",
			"Cuba": "25937",
			"American Samoa": "5667",
			"Saint Vincent and the Grenadines": "3151",
			"Armenia": "888314",
			"Mexico": "32353",
			"Br. Virgin Isds": "17235",
			"Spain": "1711",
			"Tajikistan": "2926",
			"Ireland": "81507",
			"Botswana": "15",
			"South Sudan": "99",
			"French Polynesia": "3873",
			"Mauritania": "598",
			"Christmas Isds": "769",
			"Honduras": "9",
			"Saint Barthélemy": "13618",
			"Holy See (Vatican City State)": "29",
			"Chile": "15260",
			"Gambia": "208",
			"Liberia": "5318",
			"Dominica": "177",
			"Malaysia": "31",
			"Fiji": "1745",
			"Peru": "43426",
			"Saint Kitts and Nevis": "91",
			"Nepal": "16930",
			"China": "106192081",
			"Comoros": "419",
			"Djibouti": "18125",
			"Trinidad and Tobago": "551",
			"Israel": "104272",
			"Burkina Faso": "253",
			"Paraguay": "170699",
			"Bangladesh": "5786258",
			"Antigua and Barbuda": "2598",
			"Gabon": "5544",
			"Cyprus": "483988",
			"Yemen": "49849",
			"Mauritius": "325",
			"Slovakia": "84323",
			"Faeroe Isds": "297",
			"Turkmenistan": "1939",
			"Bahrain": "444",
			"Côte d'Ivoire": "88741",
			"Guyana": "57",
			"Algeria": "23443",
			"USA": "3930016",
			"Namibia": "124",
			"Rep. of Moldova": "220607",
			"Zambia": "370657",
			"Malta": "16789",
			"Ecuador": "728117",
			"Dominican Rep.": "369636",
			"France": "73864017",
			"New Caledonia": "123",
			"Niue": "216",
			"Seychelles": "108",
			"Italy": "56587227",
			"State of Palestine": "402",
			"Uganda": "465",
			"Belarus": "10",
			"Ethiopia": "2127",
			"Congo": "5999",
			"Senegal": "185421",
			"Bulgaria": "116478",
			"Montenegro": "6165",
			"Sri Lanka": "2425849",
			"Hungary": "9243708",
			"Netherlands": "4173862",
			"Jordan": "8322",
			"Lao People's Dem. Rep.": "123871",
			"Myanmar": "3025",
			"Iran": "16018",
			"Philippines": "13398",
			"Uruguay": "154765",
			"Andorra": "45637",
			"Cabo Verde": "171",
			"Germany": "174084672",
			"Poland": "1435126",
			"Thailand": "203983",
			"Argentina": "65737",
			"Brazil": "390008",
			"Brunei Darussalam": "242",
			"Mongolia": "1983",
			"Saudi Arabia": "4991",
			"Syria": "671",
			"Russian Federation": "59",
			"Cayman Isds": "30",
			"United Arab Emirates": "4621",
			"Nicaragua": "45149",
			"Malawi": "1475597",
			"Switzerland": "284958",
			"El Salvador": "5110",
			"United States Minor Outlying Islands": "42",
			"Sierra Leone": "1543",
			"Latvia": "6314003",
			"Japan": "1726884",
			"Guinea": "56",
			"Romania": "17167",
			"Croatia": "926712",
			"China, Macao SAR": "9706",
			"Mozambique": "235",
			"Madagascar": "157185",
			"Bolivia (Plurinational State of)": "47941",
			"Barbados": "69524",
			"Bahamas": "10",
			"Tunisia": "14411",
			"Chad": "4172",
			"Viet Nam": "5590792",
			"Haiti": "7",
			"Tokelau": "10137",
			"Oman": "45790",
			"Sweden": "495",
			"Maldives": "26534",
			"India": "2115537",
			"Jamaica": "190",
			"Austria": "1152847",
			"Bouvet Island": "19048",
			"Zimbabwe": "1503",
			"Vanuatu": "471",
			"Swaziland": "2166",
			"Lithuania": "41642",
			"Cambodia": "1591",
			"Denmark": "879777",
			"Portugal": "2159",
			"Central African Rep.": "803",
			"Slovenia": "9084",
			"Costa Rica": "29095",
			"Equatorial Guinea": "50",
			"Greece": "42604",
			"Papua New Guinea": "65",
			"Kazakhstan": "115",
			"Kenya": "1260220",
			"Afghanistan": "19079",
			"Saint Helena": "69",
			"Egypt": "183641",
			"Nauru": "9392",
			"Estonia": "610",
			"Morocco": "243",
			"Antarctica": "2607",
			"TFYR of Macedonia": "6413",
			"Somalia": "41",
			"Sao Tome and Principe": "213",
			"United Rep. of Tanzania": "43945",
			"Finland": "302",
			"Belize": "1882",
			"Georgia": "409",
			"Ukraine": "72704",
			"Bermuda": "1368",
			"Mali": "101",
			"Greenland": "136",
			"China, Hong Kong SAR": "437482",
			"Suriname": "1207",
			"Nigeria": "19053",
			"Venezuela": "379467",
			"Kuwait": "2961",
			"New Zealand": "11978",
			"Norway": "71525",
			"Pitcairn": "2079",
			"Marshall Isds": "358",
			"Luxembourg": "257",
			"Kyrgyzstan": "40",
			"Czechia": "47874",
			"Br. Indian Ocean Terr.": "2351",
			"Guatemala": "10",
			"Togo": "1494",
			"Turkey": "496227",
			"San Marino": "3621",
			"Rep. of Korea": "88383085",
			"Serbia": "7983",
			"Burundi": "41",
			"Bhutan": "20",
			"Cook Isds": "4863",
			"Canada": "940588",
			"Iceland": "665833"
		},
		"exports": {
			"Lebanon": "2641173",
			"Gibraltar": "931521",
			"Ghana": "440963",
			"Lesotho": "350",
			"Cuba": "128764",
			"Dem. Rep. of the Congo": "336669",
			"Dem. People's Rep. of Korea": "14571",
			"Cameroon": "8893",
			"Papua New Guinea": "274821",
			"Indonesia": "12184116",
			"Colombia": "54276",
			"Niger": "6467",
			"Tonga": "6",
			"Angola": "2181531",
			"Fr. South Antarctic Terr.": "27896",
			"Uzbekistan": "18",
			"Iraq": "1270783",
			"Guam": "10740",
			"Bosnia Herzegovina": "115417",
			"Pakistan": "2637067",
			"Belgium": "205162669",
			"Azerbaijan": "12856364",
			"Armenia": "87",
			"United Kingdom": "14668190",
			"Singapore": "29874",
			"Albania": "98928",
			"Benin": "581027",
			"South Africa": "216",
			"Panama": "1170698",
			"Qatar": "4",
			"Saint Vincent and the Grenadines": "8109",
			"Curaçao": "84",
			"Australia": "9454588",
			"Mexico": "127",
			"Br. Virgin Isds": "31",
			"Spain": "219425",
			"Tajikistan": "1626",
			"Ireland": "4283306",
			"Botswana": "34031",
			"French Polynesia": "11778",
			"Mauritania": "48590",
			"Honduras": "1007746",
			"Jordan": "69423",
			"Chile": "950979",
			"Gambia": "26559",
			"Liberia": "797996",
			"Malaysia": "638",
			"Swaziland": "50",
			"Peru": "6365",
			"Nepal": "285",
			"China": "908203",
			"Comoros": "3",
			"Guinea-Bissau": "14389",
			"Djibouti": "1107",
			"Trinidad and Tobago": "15179",
			"Israel": "1951251",
			"Burkina Faso": "10228",
			"Paraguay": "65950",
			"Bangladesh": "7592208",
			"Antigua and Barbuda": "168782",
			"Gabon": "11302",
			"Cyprus": "10775249",
			"Yemen": "139",
			"Mauritius": "10274",
			"Slovakia": "2767754",
			"Faeroe Isds": "385",
			"Turkmenistan": "55",
			"Bahrain": "1009",
			"Côte d'Ivoire": "15797",
			"Guyana": "647829",
			"Saint Pierre and Miquelon": "8265",
			"Algeria": "21937951",
			"USA": "1107",
			"Namibia": "257337",
			"Rep. of Moldova": "55",
			"Zambia": "721",
			"Malta": "63293",
			"Ecuador": "155675",
			"Dominican Rep.": "435184",
			"France": "208599647",
			"New Caledonia": "53981",
			"Seychelles": "19853",
			"Italy": "29958884",
			"Nicaragua": "77",
			"Syria": "146",
			"Belarus": "248337",
			"Ethiopia": "2897067",
			"Slovenia": "3417",
			"Congo": "1381",
			"Senegal": "122",
			"Bulgaria": "1089258",
			"Montenegro": "18484",
			"Sri Lanka": "3305",
			"Hungary": "20182679",
			"New Zealand": "11655",
			"Lao People's Dem. Rep.": "42455",
			"Myanmar": "4068",
			"Iran": "3487527",
			"Uruguay": "25",
			"Switzerland": "5030",
			"Cabo Verde": "2366",
			"Germany": "59698",
			"Timor-Leste": "4209",
			"Poland": "53072",
			"Thailand": "1937",
			"Argentina": "4792205",
			"Brazil": "51397",
			"Brunei Darussalam": "14947",
			"Mongolia": "8393",
			"Saudi Arabia": "2245",
			"Greece": "13019",
			"Russian Federation": "11939",
			"Cayman Isds": "584",
			"United Arab Emirates": "44112",
			"Rwanda": "2645",
			"Malawi": "13943",
			"Andorra": "2266923",
			"El Salvador": "9134",
			"Latvia": "43362",
			"Japan": "3140592",
			"Guinea": "1107512",
			"Uganda": "2420",
			"Romania": "1207015",
			"Croatia": "165941",
			"China, Macao SAR": "409",
			"Guatemala": "177428",
			"Madagascar": "28190",
			"Bolivia (Plurinational State of)": "106",
			"Barbados": "795641",
			"Bahamas": "558",
			"San Marino": "148",
			"Chad": "603706",
			"Viet Nam": "915",
			"Haiti": "148964",
			"Oman": "876562",
			"Sweden": "28026",
			"Maldives": "165943",
			"India": "1207",
			"Jamaica": "120651",
			"Austria": "2109863",
			"Eritrea": "14503",
			"Zimbabwe": "4",
			"Saint Maarten": "33",
			"Fiji": "44728",
			"Lithuania": "5208545",
			"Cambodia": "2927143",
			"Denmark": "8500",
			"Portugal": "41391",
			"Central African Rep.": "3118",
			"Netherlands": "6299221",
			"Costa Rica": "204",
			"Equatorial Guinea": "10835",
			"Sudan": "36140",
			"Kazakhstan": "291872",
			"Kenya": "3717907",
			"Afghanistan": "1145019",
			"Egypt": "121",
			"Anguilla": "33814",
			"Estonia": "166078",
			"Morocco": "928523",
			"TFYR of Macedonia": "14149",
			"United Rep. of Tanzania": "111",
			"Finland": "10847",
			"Belize": "40584",
			"Georgia": "564699",
			"Ukraine": "70716",
			"Bermuda": "187",
			"Mali": "1012",
			"Greenland": "102",
			"China, Hong Kong SAR": "14628824",
			"Suriname": "61693",
			"Nigeria": "2288262",
			"Venezuela": "12850",
			"Kuwait": "8054430",
			"Norway": "464",
			"Sierra Leone": "138",
			"Philippines": "976",
			"Libya": "11965",
			"Kyrgyzstan": "789082",
			"Czechia": "280",
			"Mozambique": "46102",
			"Togo": "35396",
			"Aruba": "10",
			"Turkey": "3076",
			"Tunisia": "10431",
			"Rep. of Korea": "61058507",
			"Serbia": "16514",
			"Burundi": "3",
			"Bhutan": "3",
			"Cook Isds": "581",
			"Canada": "1141583",
			"Iceland": "501583"
		}
	},
	"TFYR of Macedonia": {
		"imports": {
			"Lebanon": "2067",
			"Ghana": "2888",
			"Qatar": "3380",
			"Dem. People's Rep. of Korea": "1479",
			"Cameroon": "65299",
			"South Africa": "835",
			"Montserrat": "353",
			"Indonesia": "9287",
			"Colombia": "123210",
			"Niger": "322",
			"Jordan": "5300",
			"Uzbekistan": "14095",
			"Iraq": "321416",
			"Tuvalu": "281",
			"Bosnia Herzegovina": "27068",
			"Pakistan": "286",
			"Belgium": "2005",
			"Azerbaijan": "416",
			"Germany": "971196",
			"Singapore": "1944",
			"Albania": "453",
			"Panama": "4638",
			"Cuba": "22185",
			"Saint Vincent and the Grenadines": "27",
			"Australia": "536",
			"Jamaica": "1357",
			"Kenya": "1169",
			"Spain": "13092116",
			"Tajikistan": "263",
			"Ireland": "331",
			"Botswana": "1390",
			"French Polynesia": "1433",
			"Mauritania": "31",
			"Honduras": "2832",
			"Holy See (Vatican City State)": "99",
			"United Kingdom": "479774",
			"Chile": "138718",
			"Sudan": "45178",
			"Gambia": "114",
			"Liberia": "80",
			"Brunei Darussalam": "102",
			"Malaysia": "2422",
			"Fiji": "1291",
			"Portugal": "1160937",
			"Falkland Isds (Malvinas)": "562",
			"China": "1920488",
			"Trinidad and Tobago": "4",
			"Israel": "1886083",
			"Burkina Faso": "619",
			"Paraguay": "1285",
			"Bangladesh": "12992",
			"Gabon": "49962",
			"Cyprus": "33",
			"Yemen": "9770",
			"Mauritius": "56631",
			"Slovakia": "43620",
			"Faeroe Isds": "53684",
			"Turkmenistan": "19140",
			"Bahrain": "327",
			"Côte d'Ivoire": "2340716",
			"Algeria": "3027768",
			"USA": "43234",
			"Cambodia": "80873",
			"Rep. of Moldova": "787",
			"Malta": "809",
			"Ecuador": "147059",
			"Dominican Rep.": "600",
			"France": "136175",
			"New Caledonia": "120",
			"Niue": "6",
			"Seychelles": "13966",
			"Br. Virgin Isds": "3145",
			"Italy": "1572619",
			"Uganda": "472388",
			"Belarus": "285524",
			"Ethiopia": "67",
			"Congo": "1327",
			"Senegal": "23290",
			"Bulgaria": "158098",
			"Montenegro": "5300",
			"Sri Lanka": "2219",
			"Hungary": "39896",
			"New Zealand": "5058",
			"Lao People's Dem. Rep.": "832",
			"Myanmar": "935",
			"Iran": "154271",
			"Sao Tome and Principe": "145",
			"Uruguay": "215108",
			"Switzerland": "1052804",
			"Cabo Verde": "317",
			"Togo": "45061",
			"Poland": "4423883",
			"Thailand": "5110306",
			"Argentina": "20664",
			"Brazil": "29694198",
			"Dominica": "1073",
			"Mongolia": "105",
			"Saudi Arabia": "71",
			"Syria": "9759",
			"Russian Federation": "127068",
			"Cayman Isds": "222221",
			"United Arab Emirates": "88942",
			"Nicaragua": "117",
			"Malawi": "37729",
			"Andorra": "292",
			"El Salvador": "9056",
			"Latvia": "1089",
			"Japan": "700173",
			"Guinea": "133",
			"Romania": "4920706",
			"Slovenia": "15718768",
			"China, Macao SAR": "1297",
			"Madagascar": "17932",
			"Bolivia (Plurinational State of)": "1538",
			"Barbados": "16152",
			"Bahamas": "300",
			"Tunisia": "702039",
			"Chad": "1018",
			"Viet Nam": "394258",
			"Haiti": "1138",
			"Oman": "36",
			"Sweden": "2271455",
			"Maldives": "3680",
			"India": "4905364",
			"Mexico": "5129",
			"Austria": "84383",
			"Zimbabwe": "860",
			"Lithuania": "144882",
			"Saint Kitts and Nevis": "645",
			"Denmark": "8354",
			"Peru": "42798",
			"Central African Rep.": "851",
			"Netherlands": "55879",
			"Costa Rica": "213",
			"Greece": "27667",
			"Kazakhstan": "387073",
			"Afghanistan": "320",
			"Croatia": "38351",
			"Saint Helena": "5",
			"Egypt": "75830",
			"Nauru": "3947",
			"Estonia": "20037",
			"Morocco": "125408",
			"Luxembourg": "584",
			"Venezuela": "5844",
			"United Rep. of Tanzania": "52763",
			"Finland": "386466",
			"Belize": "2164",
			"Georgia": "15",
			"Ukraine": "3522707",
			"Bermuda": "1589",
			"Antarctica": "199",
			"Greenland": "1229",
			"China, Hong Kong SAR": "889",
			"Suriname": "169",
			"Nigeria": "77163",
			"Kuwait": "2358",
			"Norway": "278725",
			"Sierra Leone": "39",
			"Marshall Isds": "439",
			"Philippines": "51217",
			"Libya": "433297",
			"Kyrgyzstan": "2156078",
			"Czechia": "32991",
			"Guatemala": "931",
			"Turkey": "11676095",
			"San Marino": "1481",
			"Rep. of Korea": "826",
			"Serbia": "14533060",
			"Burundi": "939",
			"Cook Isds": "42",
			"Canada": "73892",
			"Iceland": "57068"
		},
		"exports": {
			"Lebanon": "38463",
			"Iran": "21608",
			"Uruguay": "12012",
			"Andorra": "3949",
			"United Kingdom": "1733",
			"Poland": "142461",
			"Qatar": "6",
			"Thailand": "5982",
			"Dem. People's Rep. of Korea": "1114",
			"Argentina": "1747",
			"Brazil": "4624",
			"Azerbaijan": "109927",
			"Brunei Darussalam": "2579",
			"South Africa": "18758",
			"Mongolia": "4051",
			"Saudi Arabia": "1458",
			"Panama": "211565",
			"Colombia": "2",
			"Greece": "29583",
			"Russian Federation": "159755",
			"United Arab Emirates": "195159",
			"Gabon": "7260",
			"Libya": "26921",
			"Switzerland": "2840017",
			"Georgia": "165697",
			"Slovakia": "1688502",
			"Iraq": "623429",
			"Japan": "81",
			"Guam": "535",
			"Latvia": "902679",
			"Romania": "510113",
			"Pakistan": "515785",
			"Belgium": "139139800",
			"Slovenia": "8381215",
			"Australia": "10586",
			"Germany": "115894",
			"Singapore": "1806",
			"Nigeria": "3550",
			"Albania": "454",
			"Benin": "370",
			"Tunisia": "7985",
			"Chad": "3025",
			"Viet Nam": "26790",
			"Indonesia": "206322",
			"Oman": "223304",
			"Sweden": "3107881",
			"Maldives": "2",
			"Bahrain": "8717",
			"India": "129",
			"Mexico": "31432",
			"Kenya": "20516",
			"Spain": "1295161",
			"Tajikistan": "3093",
			"Ireland": "3418",
			"China, Hong Kong SAR": "147538",
			"French Polynesia": "55",
			"Mauritania": "35870",
			"Lithuania": "730287",
			"Namibia": "30268",
			"Denmark": "239943",
			"Central African Rep.": "2196",
			"Honduras": "185",
			"Holy See (Vatican City State)": "458",
			"Costa Rica": "8170",
			"Austria": "2903019",
			"Equatorial Guinea": "251",
			"Sudan": "28282",
			"Chile": "16014",
			"Kazakhstan": "67422",
			"Afghanistan": "39460",
			"Croatia": "1789379",
			"Malaysia": "459",
			"Portugal": "36958",
			"Armenia": "443257",
			"China": "1785010",
			"Egypt": "6",
			"Estonia": "15650",
			"Morocco": "26421",
			"Mali": "28134",
			"Israel": "10160",
			"Venezuela": "4633",
			"Burkina Faso": "31096",
			"Paraguay": "769",
			"Czechia": "1329778",
			"United Rep. of Tanzania": "2550",
			"Finland": "17840",
			"Bosnia Herzegovina": "586754",
			"Cyprus": "988",
			"Yemen": "71078",
			"Mauritius": "1266",
			"Hungary": "30175",
			"Bermuda": "12075",
			"Luxembourg": "558264",
			"Turkmenistan": "13111",
			"Syria": "54334",
			"Côte d'Ivoire": "56446",
			"Ghana": "1405",
			"Suriname": "3575",
			"Algeria": "337619",
			"USA": "309704",
			"Rep. of Moldova": "609627",
			"Kuwait": "10301",
			"Malta": "21702",
			"Norway": "322818",
			"France": "2234475",
			"Philippines": "29017",
			"Seychelles": "50",
			"Italy": "1445092",
			"Kyrgyzstan": "8593",
			"State of Palestine": "177086",
			"Uganda": "11873",
			"Belarus": "2059451",
			"Ethiopia": "7",
			"Bulgaria": "133",
			"Congo": "1872",
			"Senegal": "21041",
			"Turkey": "1132917",
			"Montenegro": "69507",
			"Sri Lanka": "15844",
			"Rep. of Korea": "16295",
			"Bangladesh": "40721",
			"Serbia": "1271359",
			"Netherlands": "218259",
			"Jordan": "283490",
			"Canada": "2298540",
			"Iceland": "8304",
			"Ukraine": "926046",
			"New Zealand": "4578"
		}
	},
	"Heard Island and McDonald Islands": {
		"imports": {},
		"exports": {}
	},
	"Western Sahara": {
		"imports": {},
		"exports": {}
	},
	"United Rep. of Tanzania": {
		"imports": {
			"Lebanon": "3522280",
			"Gibraltar": "75530",
			"Ghana": "320",
			"Lesotho": "334",
			"Cuba": "10611",
			"Dem. Rep. of the Congo": "174",
			"Dem. People's Rep. of Korea": "557375",
			"Cameroon": "2394",
			"South Africa": "257007",
			"Indonesia": "951437",
			"Colombia": "222936",
			"Niger": "24288",
			"Angola": "854",
			"Fr. South Antarctic Terr.": "698",
			"Iraq": "1011",
			"Bosnia Herzegovina": "73",
			"Pakistan": "892",
			"Belgium": "11108",
			"Azerbaijan": "1190",
			"Armenia": "176",
			"United Kingdom": "40297025",
			"Singapore": "176263",
			"Albania": "135",
			"Benin": "643",
			"Panama": "165817",
			"Qatar": "48",
			"American Samoa": "332",
			"Saint Vincent and the Grenadines": "157",
			"Curaçao": "64",
			"Australia": "36983",
			"Mexico": "149132",
			"Kenya": "14569013",
			"Spain": "1349653",
			"Tajikistan": "14326",
			"Ireland": "924633",
			"Botswana": "29212",
			"Mauritania": "5102",
			"Honduras": "142",
			"Chile": "92482",
			"Liberia": "7403",
			"Brunei Darussalam": "60",
			"Malaysia": "3392533",
			"Fiji": "23",
			"Peru": "350",
			"Nepal": "4795",
			"China": "14832292",
			"Comoros": "9002",
			"Djibouti": "801",
			"Trinidad and Tobago": "687",
			"Israel": "63381",
			"Burkina Faso": "12770",
			"Kazakhstan": "316",
			"Bangladesh": "3432",
			"Antigua and Barbuda": "1303131",
			"Gabon": "1116",
			"Cyprus": "1466",
			"Yemen": "255342",
			"Mauritius": "1667091",
			"Slovakia": "16184",
			"Turkmenistan": "13664",
			"Bahrain": "93",
			"Côte d'Ivoire": "30961",
			"Algeria": "7773689",
			"USA": "10349644",
			"Namibia": "410",
			"Zambia": "430842",
			"Malta": "450",
			"Ecuador": "2470",
			"Dominican Rep.": "15258",
			"France": "4713849",
			"New Caledonia": "844",
			"Seychelles": "10",
			"Br. Virgin Isds": "81346",
			"Italy": "1356431",
			"Nicaragua": "147",
			"Belarus": "48227",
			"Ethiopia": "70",
			"Congo": "83613",
			"Senegal": "56",
			"Bulgaria": "16632",
			"Sri Lanka": "2221",
			"Hungary": "263",
			"Jordan": "40581",
			"Samoa": "27726",
			"Myanmar": "179",
			"Iran": "8201",
			"Philippines": "12067",
			"Uruguay": "33",
			"Andorra": "17679",
			"Cabo Verde": "145566",
			"Germany": "1796220",
			"Poland": "76",
			"Thailand": "1442988",
			"Argentina": "1164524",
			"Brazil": "244",
			"Dominica": "802",
			"Mongolia": "865",
			"Saudi Arabia": "800",
			"Syria": "12035",
			"Russian Federation": "142",
			"United Arab Emirates": "4107676",
			"Rwanda": "241",
			"Malawi": "217879",
			"Switzerland": "348736",
			"El Salvador": "1004",
			"United States Minor Outlying Islands": "14775",
			"Latvia": "51054",
			"Japan": "75155278",
			"Guinea": "28665",
			"Uganda": "33147",
			"Romania": "7275",
			"Croatia": "163537",
			"Mozambique": "3863",
			"Madagascar": "132631",
			"Bolivia (Plurinational State of)": "5",
			"Barbados": "124",
			"Bahamas": "806",
			"Tunisia": "182",
			"Chad": "52",
			"Viet Nam": "102",
			"Haiti": "412",
			"Tokelau": "45",
			"Oman": "151365",
			"Sweden": "8718767",
			"Maldives": "918",
			"India": "18065935",
			"Jamaica": "1505",
			"Austria": "90",
			"Eritrea": "50",
			"Zimbabwe": "215",
			"Swaziland": "2787",
			"Lithuania": "266269",
			"Cambodia": "1214",
			"Denmark": "210007",
			"Portugal": "122331",
			"Netherlands": "84330",
			"Costa Rica": "140723",
			"Equatorial Guinea": "3109",
			"Sudan": "8903",
			"Slovenia": "38969",
			"Afghanistan": "108",
			"Greece": "465",
			"Egypt": "10260699",
			"Nauru": "186966",
			"Estonia": "70",
			"Morocco": "70155",
			"Antarctica": "219",
			"TFYR of Macedonia": "20169",
			"Finland": "350",
			"Georgia": "14219",
			"Ukraine": "2126",
			"Bermuda": "1862",
			"Mali": "177",
			"Greenland": "94",
			"China, Hong Kong SAR": "75206",
			"Suriname": "3704",
			"Nigeria": "32",
			"Venezuela": "402",
			"Kuwait": "3930",
			"New Zealand": "46",
			"Norway": "4103",
			"Sierra Leone": "10",
			"Marshall Isds": "4805845",
			"Sao Tome and Principe": "223",
			"Czechia": "430",
			"Br. Indian Ocean Terr.": "130",
			"Guatemala": "147",
			"Togo": "23523",
			"Aruba": "611",
			"Turkey": "8556922",
			"San Marino": "388",
			"Rep. of Korea": "63048982",
			"Serbia": "3103",
			"Burundi": "29041",
			"Canada": "24536",
			"Iceland": "18",
			"Luxembourg": "94954"
		},
		"exports": {
			"Lebanon": "6801",
			"Gibraltar": "101643",
			"Fr. South Antarctic Terr.": "276",
			"Ghana": "342758",
			"Uruguay": "54398",
			"Switzerland": "21484",
			"Peru": "39",
			"Germany": "4699488",
			"Tokelau": "10938",
			"Poland": "5514",
			"Qatar": "9721",
			"Dem. Rep. of the Congo": "5870979",
			"Thailand": "7637",
			"Dem. People's Rep. of Korea": "532749",
			"Argentina": "598",
			"Brazil": "798",
			"Cameroon": "1",
			"Brunei Darussalam": "146803",
			"South Africa": "3532",
			"Saudi Arabia": "760",
			"Panama": "46",
			"Colombia": "466701",
			"Sudan": "464",
			"Russian Federation": "75588",
			"United Arab Emirates": "53979",
			"Rwanda": "45475",
			"Yemen": "27874",
			"Angola": "40594",
			"Malawi": "5504417",
			"Andorra": "134311",
			"Paraguay": "2739290",
			"Slovakia": "36100",
			"Iraq": "2359901",
			"Japan": "28717",
			"Latvia": "195199",
			"Singapore": "414",
			"Pakistan": "623",
			"Belgium": "735220",
			"Croatia": "36525",
			"Mozambique": "756920",
			"United Kingdom": "1055",
			"Bolivia (Plurinational State of)": "112",
			"Nigeria": "359",
			"Benin": "127946",
			"Maldives": "28004",
			"Tunisia": "101",
			"Chad": "498",
			"Viet Nam": "249",
			"Haiti": "1296",
			"Guinea": "7320",
			"Indonesia": "80573",
			"American Samoa": "978530",
			"Somalia": "274553",
			"Oman": "1661",
			"Sweden": "673",
			"Australia": "207",
			"India": "469",
			"Mexico": "365",
			"Jamaica": "300",
			"Kenya": "7364558",
			"Austria": "11",
			"Eritrea": "63264",
			"Ireland": "299012",
			"Botswana": "3",
			"Zimbabwe": "38",
			"Côte d'Ivoire": "2583",
			"Spain": "348",
			"Mauritania": "12",
			"Swaziland": "70554",
			"Lithuania": "599",
			"Nicaragua": "2558",
			"Namibia": "1691",
			"Denmark": "125825",
			"Curaçao": "73504",
			"Central African Rep.": "929490",
			"Honduras": "99",
			"Netherlands": "1672",
			"Turkey": "45130",
			"Costa Rica": "596",
			"Guatemala": "954",
			"Greece": "3394328",
			"Chile": "2947",
			"Azerbaijan": "97",
			"Gambia": "239",
			"Liberia": "6470",
			"Nepal": "24",
			"Afghanistan": "109",
			"Mali": "3732",
			"Dominica": "82566",
			"Malaysia": "166947",
			"Fiji": "797",
			"Portugal": "2994",
			"Egypt": "546",
			"China": "6623187",
			"Comoros": "22248457",
			"Estonia": "7064",
			"Morocco": "1326",
			"Antarctica": "484",
			"Trinidad and Tobago": "10519",
			"Israel": "7978177",
			"Uzbekistan": "349",
			"Burkina Faso": "3642",
			"Kazakhstan": "40",
			"Rep. of Moldova": "62947",
			"Bangladesh": "90",
			"Western Sahara": "898",
			"Antigua and Barbuda": "3435",
			"Gabon": "1196",
			"Finland": "26293",
			"Cyprus": "2039642",
			"Zambia": "272370",
			"Mauritius": "31",
			"Ukraine": "40",
			"Djibouti": "481",
			"Malta": "88",
			"Papua New Guinea": "2575",
			"Bahrain": "4555",
			"China, Hong Kong SAR": "12144717",
			"Niger": "1891",
			"Algeria": "63883",
			"USA": "144",
			"Iran": "19",
			"Romania": "404",
			"Kuwait": "734342",
			"Suriname": "1494",
			"New Zealand": "273",
			"Norway": "60",
			"Serbia": "3049",
			"Sierra Leone": "80",
			"Dominican Rep.": "71674",
			"France": "139114",
			"Philippines": "25",
			"Seychelles": "6186",
			"Br. Virgin Isds": "2696336",
			"Italy": "8903957",
			"Kyrgyzstan": "4535",
			"Czechia": "86835",
			"Uganda": "986452",
			"Belarus": "540558",
			"Ethiopia": "5475",
			"Slovenia": "99",
			"Togo": "149",
			"Congo": "8564",
			"Senegal": "1",
			"Bulgaria": "18881",
			"Sri Lanka": "14966",
			"Luxembourg": "7964",
			"Rep. of Korea": "5707",
			"Hungary": "2903",
			"Burundi": "2952537",
			"Armenia": "126717",
			"Jordan": "13829",
			"Canada": "106075",
			"Iceland": "80",
			"Madagascar": "2288",
			"Myanmar": "669"
		}
	},
	"Finland": {
		"imports": {},
		"exports": {}
	},
	"Belize": {
		"imports": {
			"Lebanon": "19112",
			"Gibraltar": "816006",
			"South Africa": "15328",
			"Uruguay": "2416",
			"Germany": "1433",
			"Poland": "1695",
			"Cuba": "7885",
			"Bolivia (Plurinational State of)": "3652",
			"Thailand": "630663",
			"Dem. People's Rep. of Korea": "2000",
			"Argentina": "24",
			"Brazil": "474",
			"Dominica": "554303",
			"Ghana": "2724",
			"Saudi Arabia": "3953",
			"Indonesia": "636",
			"Colombia": "620687",
			"Russian Federation": "1301",
			"Cayman Isds": "956",
			"United Arab Emirates": "1409",
			"Nicaragua": "611",
			"Switzerland": "201",
			"El Salvador": "98",
			"Ukraine": "444",
			"Latvia": "10652",
			"Japan": "158898",
			"Hungary": "42244",
			"Romania": "863",
			"Pakistan": "190",
			"Belgium": "66612",
			"Croatia": "441",
			"Guatemala": "1195026",
			"United Kingdom": "1910859",
			"Singapore": "316490",
			"Barbados": "7601",
			"Bahamas": "1426",
			"Viet Nam": "3524140",
			"Haiti": "13559",
			"Panama": "2369245",
			"Saint Vincent and the Grenadines": "1675855",
			"Sweden": "59889",
			"Australia": "754",
			"India": "4996",
			"Jamaica": "86294",
			"Mexico": "13912737",
			"Kenya": "465",
			"Austria": "693",
			"Ireland": "103",
			"Spain": "228952",
			"Peru": "362190",
			"Lithuania": "11103",
			"Cambodia": "67476",
			"Denmark": "917375",
			"Curaçao": "1074",
			"Honduras": "743",
			"Netherlands": "4107870",
			"Costa Rica": "49500",
			"Turkey": "96475",
			"Greece": "18699",
			"Chile": "115866",
			"Slovenia": "67",
			"Equatorial Guinea": "18000",
			"Malaysia": "1289412",
			"Swaziland": "79",
			"Portugal": "5725",
			"China": "196733",
			"Anguilla": "292",
			"Estonia": "2472",
			"Morocco": "956",
			"Mali": "399",
			"Trinidad and Tobago": "585709",
			"Israel": "126",
			"Venezuela": "770",
			"Montserrat": "25",
			"Paraguay": "3654",
			"Bangladesh": "288",
			"Antigua and Barbuda": "656",
			"Gabon": "2036",
			"Finland": "817",
			"Slovakia": "18",
			"Bermuda": "653",
			"China, Hong Kong SAR": "10796472",
			"Guyana": "1193",
			"Suriname": "14249",
			"USA": "44711530",
			"Saint Kitts and Nevis": "558565",
			"Malta": "34053",
			"Norway": "2018",
			"Ecuador": "50",
			"Grenada": "1632761",
			"Dominican Rep.": "187766",
			"Marshall Isds": "168",
			"New Caledonia": "154",
			"Philippines": "983864",
			"Br. Virgin Isds": "1705",
			"Italy": "7006",
			"Saint Lucia": "1562109",
			"Czechia": "23201",
			"Nigeria": "27",
			"Mozambique": "188",
			"Togo": "13",
			"Bulgaria": "241",
			"Sri Lanka": "122920",
			"Rep. of Korea": "338",
			"France": "36949",
			"New Zealand": "402544",
			"Canada": "1101635",
			"Iceland": "40",
			"Lao People's Dem. Rep.": "205557"
		},
		"exports": {
			"Costa Rica": "632",
			"Venezuela": "82391",
			"Ireland": "11280906",
			"Ghana": "401",
			"Chile": "2335",
			"Germany": "15668",
			"Poland": "5481",
			"Cuba": "102763",
			"Dominica": "8883",
			"Thailand": "6748",
			"Swaziland": "7156",
			"Portugal": "184112",
			"Brazil": "40000",
			"China": "980657",
			"Egypt": "359083",
			"Saudi Arabia": "170417",
			"Trinidad and Tobago": "7746387",
			"Israel": "346446",
			"Cayman Isds": "1513",
			"United Arab Emirates": "751714",
			"Nicaragua": "5539",
			"Antigua and Barbuda": "76084",
			"Switzerland": "51456",
			"El Salvador": "100",
			"Finland": "7238",
			"Saint Vincent and the Grenadines": "632726",
			"Japan": "920119",
			"Pakistan": "450022",
			"Belgium": "1009",
			"Guyana": "14763",
			"Suriname": "88770",
			"USA": "23331400",
			"Australia": "254931",
			"Kuwait": "57024",
			"United Kingdom": "166192",
			"Singapore": "251",
			"Barbados": "297404",
			"Bahamas": "6355",
			"Grenada": "49667",
			"Dominican Rep.": "32140",
			"France": "71635",
			"Viet Nam": "16950",
			"Haiti": "170521",
			"Philippines": "1513",
			"Canada": "34061",
			"Panama": "404461",
			"Italy": "42708",
			"Saint Lucia": "113535",
			"Paraguay": "1312888",
			"Curaçao": "6261",
			"Guatemala": "117389",
			"Saint Maarten": "30320",
			"India": "31433",
			"Jamaica": "8912135",
			"Mexico": "304331",
			"Br. Virgin Isds": "5988311",
			"Spain": "354",
			"Turkey": "68263",
			"Sri Lanka": "210368",
			"China, Hong Kong SAR": "693773",
			"Rep. of Korea": "12612",
			"Lithuania": "12694",
			"Saint Kitts and Nevis": "98318",
			"Peru": "1989",
			"Honduras": "49875",
			"Anguilla": "908",
			"Netherlands": "7088745"
		}
	},
	"Georgia": {
		"imports": {
			"Lebanon": "1009",
			"Iran": "204779",
			"Uruguay": "771223",
			"Germany": "699172",
			"Poland": "78355",
			"Qatar": "84",
			"Thailand": "3987",
			"Argentina": "616639",
			"Brazil": "7460",
			"Azerbaijan": "17251",
			"Cameroon": "1195",
			"South Africa": "6273",
			"Mongolia": "3532",
			"Saudi Arabia": "2948",
			"Indonesia": "574367",
			"Colombia": "2180140",
			"Sudan": "22250",
			"Russian Federation": "134066",
			"Cayman Isds": "12992",
			"United Arab Emirates": "238013",
			"Belize": "416",
			"Jordan": "3",
			"Malawi": "27034",
			"Switzerland": "42608",
			"Uzbekistan": "4716",
			"Iraq": "16079",
			"Japan": "374082",
			"Latvia": "242971",
			"Romania": "121",
			"Pakistan": "11458",
			"Belgium": "234949",
			"Ireland": "54",
			"Slovenia": "86631",
			"Armenia": "74166",
			"Madagascar": "764",
			"Singapore": "1754481",
			"Nigeria": "356",
			"Albania": "14190",
			"Benin": "20",
			"San Marino": "497",
			"Viet Nam": "1700891",
			"Panama": "83389",
			"Cuba": "74907",
			"Oman": "677",
			"Sweden": "198",
			"Australia": "23636",
			"Bahrain": "100",
			"India": "10517",
			"Mexico": "251398",
			"Br. Virgin Isds": "559",
			"Spain": "16058",
			"Tajikistan": "5040",
			"Kenya": "1000",
			"Austria": "93336",
			"Lithuania": "5141",
			"Cambodia": "4323",
			"Denmark": "8959",
			"Portugal": "355681",
			"Netherlands": "302111",
			"United Kingdom": "24521",
			"Costa Rica": "305701",
			"Bulgaria": "31140",
			"Greece": "16659",
			"Chile": "296055",
			"Kazakhstan": "3613",
			"Afghanistan": "1315",
			"Croatia": "50094",
			"Malaysia": "261229",
			"Peru": "11047040",
			"Nepal": "531",
			"China": "1931478",
			"Egypt": "128105",
			"Estonia": "1004",
			"Morocco": "52046",
			"Luxembourg": "3084",
			"Israel": "421",
			"TFYR of Macedonia": "17",
			"Paraguay": "51458",
			"France": "24081",
			"Bangladesh": "579909",
			"United Rep. of Tanzania": "12672",
			"Finland": "96525",
			"Bosnia Herzegovina": "12927",
			"Cyprus": "89",
			"Gabon": "5937563",
			"Hungary": "423400",
			"Faeroe Isds": "359284",
			"Turkmenistan": "1539707",
			"Syria": "234000",
			"China, Hong Kong SAR": "115418",
			"Suriname": "75",
			"Algeria": "3732",
			"USA": "819328",
			"Rep. of Moldova": "66",
			"Kuwait": "1620",
			"Malta": "158122",
			"Norway": "117512",
			"Ecuador": "488630",
			"Marshall Isds": "158750",
			"Philippines": "44029",
			"Seychelles": "69143",
			"Italy": "186903",
			"Kyrgyzstan": "1",
			"Czechia": "72866",
			"Belarus": "101",
			"Ethiopia": "2176",
			"Congo": "64747",
			"Turkey": "478056",
			"Tunisia": "105",
			"Sri Lanka": "30138",
			"Rep. of Korea": "1463",
			"Serbia": "100",
			"Slovakia": "234886",
			"New Zealand": "3663",
			"Canada": "94132",
			"Iceland": "6003819",
			"Ukraine": "143370",
			"Myanmar": "144"
		},
		"exports": {
			"Lebanon": "796264",
			"Gibraltar": "4841213",
			"Ghana": "19152",
			"Uruguay": "317581",
			"Germany": "24560",
			"Poland": "58505",
			"Qatar": "409200",
			"Thailand": "154171",
			"Brazil": "72200",
			"Azerbaijan": "1298958",
			"Cameroon": "3",
			"Iran": "176961",
			"Mongolia": "3200",
			"Saudi Arabia": "11600",
			"Panama": "2408",
			"Colombia": "30",
			"Sudan": "21070",
			"Russian Federation": "610314",
			"United Arab Emirates": "220066",
			"Belize": "43134",
			"Libya": "17100",
			"Switzerland": "36",
			"Uzbekistan": "10389",
			"Iraq": "80",
			"Japan": "15",
			"Latvia": "2",
			"Romania": "2167",
			"Pakistan": "57294",
			"Belgium": "40",
			"Slovenia": "12745",
			"Guatemala": "10",
			"United Kingdom": "13",
			"Singapore": "43350",
			"Nigeria": "3",
			"Albania": "78167",
			"Tunisia": "266000",
			"Mozambique": "2264544",
			"Viet Nam": "504861",
			"South Africa": "150",
			"Indonesia": "520",
			"Cuba": "3420",
			"Oman": "175",
			"Sweden": "35815",
			"Australia": "950329",
			"Bahrain": "3059",
			"India": "229068",
			"Mexico": "436900",
			"Jamaica": "5557",
			"Kenya": "153478",
			"Spain": "17000",
			"Tajikistan": "1415063",
			"Ireland": "112927",
			"Zimbabwe": "454400",
			"China, Hong Kong SAR": "2492848",
			"Austria": "4996",
			"Lithuania": "13918489",
			"Cambodia": "339",
			"Denmark": "2372",
			"Portugal": "7758",
			"Netherlands": "47757",
			"Costa Rica": "28440",
			"Turkey": "400000",
			"Greece": "27545",
			"Chile": "584922",
			"Kazakhstan": "7717",
			"Afghanistan": "1693",
			"Croatia": "234800",
			"Malaysia": "127",
			"Peru": "601654",
			"Armenia": "37981",
			"China": "15428711",
			"Egypt": "3500385",
			"Estonia": "1769163",
			"Morocco": "165",
			"Luxembourg": "217",
			"Israel": "1608399",
			"TFYR of Macedonia": "8580",
			"Bangladesh": "3412",
			"United Rep. of Tanzania": "1210650",
			"Finland": "11139",
			"Cyprus": "395059",
			"Gabon": "1",
			"Mauritius": "35",
			"Hungary": "240831",
			"Djibouti": "70",
			"Turkmenistan": "31388",
			"Syria": "544929",
			"Côte d'Ivoire": "6302",
			"Angola": "2076141",
			"Algeria": "633878",
			"USA": "164",
			"Rep. of Moldova": "23197",
			"Kuwait": "27237",
			"Malta": "1278909",
			"Norway": "2018",
			"Sierra Leone": "10500",
			"France": "121",
			"Philippines": "45",
			"Italy": "1398950",
			"Kyrgyzstan": "5850",
			"Czechia": "648494",
			"Uganda": "25600",
			"Belarus": "9700",
			"Ethiopia": "1855",
			"Congo": "1",
			"Bulgaria": "13",
			"Sri Lanka": "1",
			"Rep. of Korea": "87776",
			"Serbia": "7125",
			"Slovakia": "127380",
			"Jordan": "286400",
			"Canada": "1150376",
			"Iceland": "7",
			"Ukraine": "8016"
		}
	},
	"Ukraine": {
		"imports": {},
		"exports": {}
	},
	"Bermuda": {
		"imports": {
			"Lebanon": "1040",
			"Ghana": "7668",
			"Uruguay": "227",
			"Cabo Verde": "122",
			"Germany": "623078",
			"Poland": "75417",
			"Cuba": "40278",
			"Dem. Rep. of the Congo": "4150",
			"Thailand": "669105",
			"Dem. People's Rep. of Korea": "223941",
			"Argentina": "486123",
			"Brazil": "50313",
			"Cameroon": "8",
			"Brunei Darussalam": "1175",
			"Iran": "379",
			"Mongolia": "756",
			"Saudi Arabia": "379",
			"Holy See (Vatican City State)": "21353",
			"Colombia": "124588",
			"Syria": "39900",
			"Russian Federation": "3770",
			"Cayman Isds": "110",
			"United Arab Emirates": "2616",
			"Nicaragua": "8114",
			"Angola": "131",
			"Uzbekistan": "296",
			"Switzerland": "330",
			"El Salvador": "6959",
			"United States Minor Outlying Islands": "703",
			"Lesotho": "6847",
			"Ukraine": "116",
			"Latvia": "559",
			"Japan": "957251",
			"Bosnia Herzegovina": "9667",
			"Pakistan": "30314",
			"Belgium": "119163",
			"Croatia": "14659",
			"Pitcairn": "75609",
			"China, Macao SAR": "10",
			"Armenia": "10",
			"United Kingdom": "991489",
			"Bolivia (Plurinational State of)": "1037",
			"Barbados": "12140",
			"Albania": "1053",
			"Bahamas": "1397707",
			"Tunisia": "38317",
			"Viet Nam": "15299",
			"Haiti": "6763",
			"South Africa": "1574",
			"Indonesia": "183621",
			"Qatar": "10",
			"American Samoa": "340",
			"Saint Vincent and the Grenadines": "13013",
			"Oman": "260",
			"Jordan": "4503",
			"Curaçao": "100",
			"Australia": "91993",
			"India": "65002",
			"Jamaica": "690",
			"Mexico": "1426184",
			"Kenya": "61",
			"Austria": "264134",
			"Romania": "10259",
			"Ireland": "105362",
			"Botswana": "10",
			"Nigeria": "56",
			"Côte d'Ivoire": "1037",
			"French Polynesia": "393",
			"Lithuania": "22437",
			"Cambodia": "134927",
			"Denmark": "164706",
			"Portugal": "591",
			"Honduras": "4125",
			"Netherlands": "363512",
			"Costa Rica": "8523",
			"Turkey": "1881",
			"Greece": "121",
			"Chile": "58",
			"Suriname": "80",
			"Liberia": "1",
			"Nepal": "287",
			"Afghanistan": "2193",
			"Dominica": "35",
			"Malaysia": "168513",
			"Fiji": "44438",
			"Peru": "118995",
			"United Rep. of Tanzania": "6430",
			"Egypt": "690",
			"China": "3877299",
			"Comoros": "105",
			"Nauru": "262",
			"Anguilla": "875",
			"Estonia": "474",
			"Morocco": "1103",
			"Luxembourg": "50",
			"Trinidad and Tobago": "29",
			"Israel": "1958",
			"TFYR of Macedonia": "7311",
			"Montserrat": "150",
			"Singapore": "2163",
			"Paraguay": "21",
			"Bangladesh": "528338",
			"Antigua and Barbuda": "3970798",
			"Gabon": "957",
			"Finland": "2255",
			"Cyprus": "802",
			"Belize": "770",
			"Georgia": "1087",
			"Slovakia": "2016",
			"Malta": "432",
			"Madagascar": "16621",
			"Bahrain": "114",
			"China, Hong Kong SAR": "120420",
			"Guyana": "620229",
			"Sweden": "15406",
			"Algeria": "26",
			"USA": "5138688",
			"Saint Kitts and Nevis": "13424",
			"Rep. of Moldova": "2677",
			"Venezuela": "276",
			"Kuwait": "20",
			"Spain": "12184",
			"Christmas Isds": "1271",
			"Norway": "146591",
			"Ecuador": "2090",
			"Serbia": "34",
			"Grenada": "471",
			"Dominican Rep.": "1693221",
			"France": "133672",
			"Tuvalu": "3427",
			"New Caledonia": "906",
			"Philippines": "455",
			"Niue": "86",
			"Br. Virgin Isds": "8095",
			"Italy": "118947",
			"Saint Lucia": "190",
			"State of Palestine": "65821",
			"Uganda": "13",
			"Br. Indian Ocean Terr.": "2841",
			"Guatemala": "1859",
			"Ethiopia": "143",
			"Slovenia": "6211",
			"Mauritius": "5895",
			"Sierra Leone": "4690",
			"Senegal": "43",
			"Lao People's Dem. Rep.": "2801",
			"Bulgaria": "67432",
			"Sri Lanka": "123033",
			"Rep. of Korea": "288622",
			"Hungary": "383",
			"Panama": "4029348",
			"Burundi": "40",
			"New Zealand": "189191",
			"Canada": "7127164",
			"Iceland": "1017",
			"Czechia": "28524",
			"Myanmar": "11523"
		},
		"exports": {
			"Sweden": "390",
			"USA": "119466",
			"India": "69590",
			"Greece": "5848",
			"Austria": "1434",
			"Germany": "27",
			"United Kingdom": "47301",
			"Norway": "422",
			"Thailand": "3048",
			"France": "1074",
			"China": "8930",
			"Canada": "26134",
			"Belgium": "1143"
		}
	},
	"Djibouti": {
		"imports": {},
		"exports": {}
	},
	"Greenland": {
		"imports": {
			"Fr. South Antarctic Terr.": "152",
			"Iran": "7987",
			"Sao Tome and Principe": "3649",
			"Uruguay": "593",
			"Marshall Isds": "3032",
			"Germany": "589899",
			"Poland": "1700279",
			"Cuba": "1926",
			"Dem. Rep. of the Congo": "418",
			"Thailand": "135445",
			"Dem. People's Rep. of Korea": "544",
			"Argentina": "7242",
			"Brazil": "63112",
			"Cameroon": "982",
			"South Africa": "202083",
			"Panama": "329",
			"Colombia": "6328",
			"Russian Federation": "4316",
			"United Arab Emirates": "50120",
			"Nicaragua": "297",
			"Tonga": "770",
			"Jordan": "81",
			"Malawi": "183",
			"Switzerland": "6207",
			"El Salvador": "15",
			"United States Minor Outlying Islands": "80",
			"Ukraine": "18488",
			"Latvia": "90883",
			"Japan": "2834",
			"Guam": "2499",
			"Bosnia Herzegovina": "440",
			"Pakistan": "15767",
			"Belgium": "193140",
			"Croatia": "3751",
			"Bolivia (Plurinational State of)": "5038",
			"Madagascar": "4748",
			"Singapore": "1817",
			"Barbados": "195",
			"Saint Kitts and Nevis": "6",
			"Bahamas": "24779",
			"Tunisia": "2461",
			"Viet Nam": "19441",
			"Indonesia": "6962",
			"Tuvalu": "3639",
			"Sweden": "273093",
			"Australia": "364",
			"Kiribati": "398",
			"India": "19302",
			"Jamaica": "129",
			"Mexico": "74840",
			"Kenya": "11878",
			"Austria": "2916",
			"Romania": "2055",
			"Ireland": "97",
			"Zimbabwe": "3408",
			"Côte d'Ivoire": "299",
			"Spain": "651012",
			"Lithuania": "504874",
			"Cambodia": "2573",
			"Denmark": "18397458",
			"Portugal": "256800",
			"Honduras": "3645",
			"Slovenia": "6502",
			"United Kingdom": "1111984",
			"Costa Rica": "59514",
			"Bulgaria": "3732",
			"Samoa": "239",
			"Greece": "44030",
			"Chile": "214953",
			"Azerbaijan": "363",
			"China, Macao SAR": "598",
			"Afghanistan": "5669",
			"Mali": "48",
			"Malaysia": "242766",
			"Fiji": "139",
			"Peru": "37793",
			"Falkland Isds (Malvinas)": "134",
			"Nepal": "674",
			"China": "175315",
			"Egypt": "322",
			"Estonia": "1879",
			"Morocco": "1556",
			"Djibouti": "134",
			"Israel": "59457",
			"TFYR of Macedonia": "1876",
			"Burkina Faso": "1301",
			"Kazakhstan": "60",
			"Paraguay": "580",
			"Bangladesh": "1120",
			"United Rep. of Tanzania": "283",
			"Finland": "1554",
			"Cyprus": "23496",
			"Georgia": "1899",
			"Slovakia": "715",
			"Bermuda": "86",
			"Luxembourg": "208315",
			"Faeroe Isds": "109206",
			"Turkmenistan": "2391",
			"China, Hong Kong SAR": "12625",
			"Mauritius": "19011",
			"Algeria": "83",
			"USA": "531076",
			"Namibia": "988",
			"Rep. of Moldova": "132",
			"Venezuela": "1029",
			"Zambia": "4836",
			"Norway": "393425",
			"Ecuador": "859",
			"Serbia": "6225",
			"Grenada": "155",
			"Dominican Rep.": "956",
			"France": "175169",
			"Philippines": "15258",
			"Italy": "370418",
			"State of Palestine": "1263",
			"Uganda": "18",
			"Guatemala": "729",
			"Sierra Leone": "12787",
			"Lao People's Dem. Rep.": "34351",
			"Turkey": "66474",
			"Sri Lanka": "6661",
			"Rep. of Korea": "427929",
			"Hungary": "29734",
			"Netherlands": "2802264",
			"Bhutan": "92",
			"New Zealand": "2015802",
			"Canada": "9011",
			"Iceland": "654535",
			"Czechia": "2702",
			"Myanmar": "19224"
		},
		"exports": {
			"Russian Federation": "1704357",
			"USA": "3760",
			"Greece": "357",
			"Denmark": "144997136",
			"Germany": "262150",
			"Norway": "2658880",
			"Rep. of Korea": "2786",
			"France": "85",
			"Portugal": "44042945",
			"Faeroe Isds": "1273013",
			"Canada": "2033",
			"Iceland": "284091",
			"Estonia": "445148"
		}
	},
	"China, Hong Kong SAR": {
		"imports": {
			"Lebanon": "295111",
			"Gibraltar": "2610",
			"Ghana": "182701",
			"Lesotho": "41863",
			"Cuba": "134271",
			"Dem. Rep. of the Congo": "8018",
			"Dem. People's Rep. of Korea": "16684",
			"Cameroon": "216008",
			"South Africa": "410133",
			"Indonesia": "466840144",
			"Colombia": "1213769",
			"Niger": "1417",
			"Tonga": "35768",
			"Jordan": "2628",
			"Uzbekistan": "7863",
			"Iraq": "5536",
			"Tuvalu": "1904",
			"Guam": "6132",
			"Bosnia Herzegovina": "36878",
			"Pakistan": "3660668",
			"Belgium": "1472737",
			"Azerbaijan": "87022",
			"Rwanda": "42044",
			"Armenia": "14107",
			"United Kingdom": "24740668",
			"Singapore": "1129458",
			"Albania": "28687",
			"Benin": "420530",
			"FS Micronesia": "526744",
			"Panama": "822947",
			"Qatar": "27539425",
			"American Samoa": "4633",
			"Australia": "1204823",
			"Kiribati": "50",
			"Bahrain": "853970",
			"Jamaica": "90824",
			"Kenya": "924342",
			"Spain": "9662",
			"Tajikistan": "122549",
			"Ireland": "109840",
			"Botswana": "178034598",
			"South Sudan": "2049",
			"Mauritania": "3209559",
			"Honduras": "695",
			"Holy See (Vatican City State)": "194320",
			"Chile": "283798",
			"Gambia": "97255",
			"China, Macao SAR": "580",
			"Malaysia": "651647",
			"Swaziland": "222353",
			"Portugal": "239462",
			"Nepal": "150830",
			"China": "1096216208",
			"Comoros": "2863",
			"Guinea-Bissau": "46",
			"Mali": "293910",
			"Trinidad and Tobago": "483729",
			"Israel": "13302",
			"Burkina Faso": "2484",
			"Paraguay": "8352759",
			"Bangladesh": "791872",
			"Gabon": "145554",
			"Cyprus": "430319",
			"Yemen": "17373268",
			"Mauritius": "381783",
			"Slovakia": "20827",
			"Turkmenistan": "5029",
			"Syria": "9670",
			"Côte d'Ivoire": "73690",
			"Guyana": "25100",
			"Algeria": "5239327",
			"USA": "13307",
			"Namibia": "88892",
			"Rep. of Moldova": "9503",
			"Zambia": "6201519",
			"Malta": "61027",
			"Ecuador": "150",
			"Grenada": "116204",
			"Dominican Rep.": "30367",
			"France": "23957289",
			"Seychelles": "103",
			"Oceania, nes": "85929",
			"Italy": "152701455",
			"Uganda": "1145083",
			"Belarus": "211538",
			"Ethiopia": "1019974",
			"Slovenia": "91649",
			"Pitcairn": "5772",
			"Senegal": "1863412",
			"Bulgaria": "1837777",
			"Montenegro": "10370",
			"Sri Lanka": "2054907",
			"Hungary": "6218",
			"Angola": "47325827",
			"New Zealand": "1296222",
			"N. Mariana Isds": "3086",
			"Lao People's Dem. Rep.": "4612",
			"Myanmar": "3494",
			"Iran": "21063",
			"Philippines": "103109",
			"Uruguay": "40701316",
			"Andorra": "87959",
			"Cabo Verde": "3782",
			"Germany": "67991",
			"Poland": "399081",
			"Thailand": "3825533",
			"Argentina": "3656",
			"Brazil": "206321",
			"Brunei Darussalam": "27949",
			"Mongolia": "85319",
			"Saudi Arabia": "657028",
			"Greece": "8327507",
			"Russian Federation": "86062088",
			"United Arab Emirates": "60507",
			"Nicaragua": "419253",
			"Malawi": "6089",
			"Switzerland": "570273",
			"El Salvador": "613117",
			"United States Minor Outlying Islands": "2",
			"Latvia": "7252",
			"Japan": "53541809",
			"Guinea": "2044081",
			"Romania": "2331812",
			"Croatia": "8739",
			"Liberia": "14330",
			"Guatemala": "622855",
			"Madagascar": "144399",
			"Bolivia (Plurinational State of)": "94863",
			"Nigeria": "511003",
			"Bahamas": "33026",
			"Tunisia": "378082",
			"Chad": "3424",
			"Viet Nam": "311709",
			"Haiti": "601747",
			"Tokelau": "7990",
			"Oman": "1559",
			"Sweden": "140713",
			"Maldives": "10824",
			"India": "258587",
			"Mexico": "20272",
			"Austria": "5452043",
			"Congo": "460434",
			"Zimbabwe": "6126660",
			"Vanuatu": "30805",
			"Fiji": "92417",
			"Lithuania": "3809",
			"Cambodia": "26303",
			"Denmark": "19962",
			"Peru": "753725",
			"Central African Rep.": "271",
			"Netherlands": "141548",
			"Costa Rica": "53063",
			"Equatorial Guinea": "25",
			"Sudan": "149658",
			"Papua New Guinea": "91201",
			"Kazakhstan": "7493",
			"Afghanistan": "91316",
			"Egypt": "4303",
			"Nauru": "37986",
			"Estonia": "38058",
			"Morocco": "402665",
			"Luxembourg": "121260",
			"TFYR of Macedonia": "91275",
			"Somalia": "311846",
			"United Rep. of Tanzania": "19821109",
			"Finland": "135725",
			"Belize": "35208",
			"Georgia": "10281",
			"Ukraine": "12292",
			"Djibouti": "23862",
			"Greenland": "671013",
			"China, Hong Kong SAR": "16748",
			"Suriname": "3988280",
			"Barbados": "32997",
			"Samoa": "109629",
			"Venezuela": "6441",
			"Kuwait": "9066561",
			"Norway": "33951497",
			"Sierra Leone": "2929",
			"Marshall Isds": "56945",
			"Sao Tome and Principe": "8064",
			"Libya": "1511",
			"Kyrgyzstan": "47150",
			"Czechia": "238213",
			"Mozambique": "72908",
			"Togo": "5243359",
			"Aruba": "1157163",
			"Turkey": "5884546",
			"San Marino": "183400",
			"Rep. of Korea": "198838",
			"Serbia": "2283640",
			"Burundi": "5241",
			"Bhutan": "3942",
			"Canada": "3811862",
			"Iceland": "12292"
		},
		"exports": {
			"Lebanon": "11924",
			"Gibraltar": "8145",
			"Ghana": "50436",
			"Lesotho": "195323",
			"Cuba": "24349",
			"Dem. Rep. of the Congo": "224",
			"Dem. People's Rep. of Korea": "89766",
			"Cameroon": "132",
			"South Africa": "5554",
			"Indonesia": "1360",
			"Colombia": "262235",
			"Niger": "483",
			"Tonga": "42847",
			"Angola": "3603",
			"Uzbekistan": "395839",
			"Iraq": "126052",
			"Tuvalu": "58188",
			"Guam": "6290",
			"Bosnia Herzegovina": "4515",
			"Vanuatu": "43004",
			"Belgium": "119059",
			"Azerbaijan": "254298",
			"Rwanda": "2041",
			"Armenia": "2949",
			"Togo": "114945",
			"Singapore": "1757",
			"Albania": "2512",
			"Benin": "756905",
			"FS Micronesia": "153505",
			"Panama": "1040270",
			"Qatar": "17200",
			"American Samoa": "2709477",
			"Australia": "185513",
			"Kiribati": "34491",
			"Jamaica": "41556",
			"Kenya": "65960",
			"Spain": "29968",
			"Tajikistan": "53457",
			"Ireland": "1940",
			"Botswana": "285149",
			"Côte d'Ivoire": "73413",
			"Mauritania": "47294",
			"Honduras": "6245",
			"Holy See (Vatican City State)": "9893",
			"United Kingdom": "609189",
			"Jordan": "17179",
			"Chile": "1182",
			"Gambia": "3865",
			"China, Macao SAR": "19955",
			"Malaysia": "685422",
			"Swaziland": "5423",
			"Portugal": "203006",
			"Nepal": "4059",
			"China": "27062",
			"Comoros": "10059",
			"Guinea-Bissau": "1431",
			"Mali": "22396",
			"Trinidad and Tobago": "1401501",
			"Israel": "97489",
			"Burkina Faso": "1569",
			"Paraguay": "14975",
			"Bangladesh": "2389",
			"Gabon": "8317",
			"Cyprus": "1416",
			"Yemen": "37724",
			"Mauritius": "9548926",
			"Slovakia": "5404",
			"Turkmenistan": "6673",
			"Bahrain": "4409",
			"South Sudan": "10387",
			"Guyana": "446249",
			"Algeria": "9546527",
			"USA": "10347662",
			"Namibia": "185537",
			"Rep. of Moldova": "72261",
			"Zambia": "4123",
			"Malta": "3059985",
			"Ecuador": "2613",
			"Grenada": "606733",
			"Dominican Rep.": "2085",
			"France": "335306",
			"Seychelles": "4854",
			"Oceania, nes": "865480",
			"Italy": "2194862",
			"Uganda": "103360",
			"Syria": "30947",
			"Belarus": "786152",
			"Ethiopia": "5382",
			"Slovenia": "2293",
			"Pitcairn": "942",
			"Senegal": "119882",
			"Bulgaria": "3634223",
			"Montenegro": "1119182",
			"Sri Lanka": "9824",
			"Hungary": "237",
			"New Zealand": "3174",
			"N. Mariana Isds": "227744",
			"Lao People's Dem. Rep.": "5184",
			"Myanmar": "75481",
			"Iran": "108694",
			"Philippines": "577895",
			"Uruguay": "5686",
			"Andorra": "88365",
			"Cabo Verde": "775",
			"Germany": "217010",
			"Poland": "13303",
			"Thailand": "207170",
			"Argentina": "16250",
			"Brazil": "175418",
			"Brunei Darussalam": "2560080",
			"Mongolia": "10740",
			"Saudi Arabia": "301",
			"Greece": "999713",
			"Russian Federation": "189",
			"United Arab Emirates": "76468",
			"Nicaragua": "2012937",
			"Malawi": "111190",
			"Switzerland": "22963",
			"El Salvador": "4244325",
			"United States Minor Outlying Islands": "1968",
			"Latvia": "68402",
			"Japan": "11555892",
			"Guinea": "89858",
			"Romania": "5751",
			"Croatia": "3186",
			"Liberia": "10213",
			"Guatemala": "30552",
			"Madagascar": "81654",
			"Bolivia (Plurinational State of)": "3573",
			"Nigeria": "38004",
			"Bahamas": "7465914",
			"Tunisia": "8957",
			"Chad": "62381",
			"Viet Nam": "315574",
			"Haiti": "267746",
			"Tokelau": "2351",
			"Oman": "1065299",
			"Sweden": "9024",
			"Maldives": "17322",
			"India": "5905",
			"Mexico": "5570",
			"Austria": "235424",
			"Congo": "14471",
			"Zimbabwe": "90747",
			"Pakistan": "2782",
			"Fiji": "7034",
			"Lithuania": "1009684",
			"Cambodia": "38400",
			"Denmark": "1146",
			"Peru": "9515",
			"Central African Rep.": "2504",
			"Netherlands": "630",
			"Costa Rica": "7123",
			"Equatorial Guinea": "234",
			"Sudan": "114412",
			"Papua New Guinea": "134",
			"Kazakhstan": "2939319",
			"Afghanistan": "21965",
			"Egypt": "28987",
			"Nauru": "729",
			"Estonia": "234437",
			"Morocco": "39154",
			"Luxembourg": "876426",
			"TFYR of Macedonia": "38411",
			"Somalia": "85357",
			"United Rep. of Tanzania": "1395",
			"Finland": "11595",
			"Belize": "33112",
			"Georgia": "2344496",
			"Ukraine": "67442",
			"Djibouti": "718839",
			"Greenland": "281",
			"Suriname": "1021571",
			"Barbados": "4251",
			"Samoa": "14579",
			"Venezuela": "419659",
			"Kuwait": "11450",
			"Norway": "100465",
			"Sierra Leone": "1227099",
			"Marshall Isds": "11866",
			"Sao Tome and Principe": "1897",
			"Libya": "12883",
			"Kyrgyzstan": "333338",
			"Czechia": "3055",
			"Mozambique": "1306",
			"Aruba": "127098",
			"Turkey": "219009",
			"San Marino": "50878",
			"Rep. of Korea": "17360",
			"Serbia": "4250",
			"Burundi": "9359",
			"Bhutan": "4477",
			"Canada": "807360",
			"Iceland": "5681"
		}
	},
	"Suriname": {
		"imports": {},
		"exports": {}
	},
	"Nigeria": {
		"imports": {},
		"exports": {}
	},
	"Venezuela": {
		"imports": {},
		"exports": {}
	},
	"Kuwait": {
		"imports": {},
		"exports": {}
	},
	"New Zealand": {
		"imports": {
			"Lebanon": "6485",
			"Gibraltar": "4508",
			"Ghana": "4605",
			"Lesotho": "204",
			"Cuba": "304206",
			"Dem. Rep. of the Congo": "116827",
			"Cameroon": "23646",
			"Papua New Guinea": "92457",
			"Montserrat": "1604",
			"Indonesia": "162671390",
			"Colombia": "7510006",
			"Niger": "21130",
			"Palau": "804",
			"Tonga": "279532",
			"Jordan": "21652",
			"Uzbekistan": "55",
			"Iraq": "718",
			"Tuvalu": "16241",
			"Guam": "1202",
			"Bosnia Herzegovina": "68732",
			"Pakistan": "3528582",
			"Belgium": "1789292",
			"Azerbaijan": "106304",
			"Rwanda": "283890",
			"Australia": "102875780",
			"Togo": "981",
			"Singapore": "677439",
			"Albania": "60",
			"South Africa": "3814094",
			"FS Micronesia": "480",
			"Panama": "33508",
			"Qatar": "152175184",
			"American Samoa": "1775",
			"Saint Vincent and the Grenadines": "36520",
			"Curaçao": "21056",
			"Armenia": "30040",
			"Kiribati": "245",
			"Bahrain": "3143353",
			"Mexico": "17924",
			"Kenya": "9636",
			"Spain": "4284502",
			"Tajikistan": "166",
			"Ireland": "1832299",
			"Botswana": "10551",
			"South Sudan": "18",
			"French Polynesia": "249095",
			"Mauritania": "28565",
			"Christmas Isds": "2251347",
			"Honduras": "600197",
			"Cambodia": "1850",
			"United Kingdom": "37482920",
			"Chile": "1760",
			"Sudan": "27707",
			"Gambia": "4999",
			"Liberia": "24",
			"Antarctica": "71",
			"Brunei Darussalam": "161596775",
			"Malaysia": "202354996",
			"Swaziland": "205808",
			"Portugal": "1137687",
			"Falkland Isds (Malvinas)": "62",
			"Nepal": "361",
			"China": "41711",
			"Comoros": "409",
			"Guinea-Bissau": "2372",
			"Saint Maarten": "254699",
			"Mali": "1430",
			"Trinidad and Tobago": "861918",
			"Israel": "141867",
			"Burkina Faso": "2459",
			"Paraguay": "23764",
			"Norfolk Isds": "1072",
			"Bangladesh": "2603",
			"Antigua and Barbuda": "658",
			"Gabon": "182",
			"Cyprus": "7022",
			"Yemen": "1771",
			"Mauritius": "1024",
			"Slovakia": "131",
			"Faeroe Isds": "11296",
			"Turkmenistan": "27",
			"Syria": "335",
			"Côte d'Ivoire": "300806",
			"Guyana": "63344",
			"Algeria": "75209",
			"USA": "59450071",
			"Saint Kitts and Nevis": "8904",
			"Rep. of Moldova": "3671",
			"Zambia": "90571",
			"Malta": "2753",
			"Ecuador": "948",
			"Grenada": "2539",
			"Dominican Rep.": "25110",
			"France": "915795",
			"New Caledonia": "189356",
			"Niue": "23066",
			"Seychelles": "2094",
			"Br. Virgin Isds": "16628",
			"Italy": "20074",
			"Saint Lucia": "1783",
			"State of Palestine": "425",
			"Uganda": "32",
			"Belarus": "11755",
			"Ethiopia": "1807",
			"Slovenia": "922",
			"Pitcairn": "534",
			"Senegal": "627116",
			"Bulgaria": "1444",
			"Montenegro": "604",
			"Sri Lanka": "951",
			"Hungary": "3674",
			"Angola": "2881",
			"New Zealand": "11806",
			"N. Mariana Isds": "110",
			"Lao People's Dem. Rep.": "24574",
			"Myanmar": "686462",
			"Iran": "2592492",
			"Sao Tome and Principe": "42",
			"Uruguay": "2445508",
			"Andorra": "1352",
			"Cabo Verde": "81",
			"Germany": "346728",
			"Timor-Leste": "187287",
			"Poland": "2862097",
			"Thailand": "269379",
			"Argentina": "607988",
			"Brazil": "28976",
			"Dominica": "121",
			"Mongolia": "88080",
			"Saudi Arabia": "295287",
			"South Georgia and the South Sandwich Islands": "63",
			"Russian Federation": "75247046",
			"Cayman Isds": "23041",
			"United Arab Emirates": "3865",
			"Nicaragua": "576876",
			"Malawi": "22042",
			"Switzerland": "145476",
			"El Salvador": "681625",
			"United States Minor Outlying Islands": "9512",
			"Latvia": "218719",
			"Japan": "320164056",
			"Guinea": "654524",
			"Romania": "176452",
			"Croatia": "454021",
			"China, Macao SAR": "30322",
			"Guatemala": "107100",
			"Madagascar": "160161",
			"Bolivia (Plurinational State of)": "547818",
			"Nigeria": "756",
			"Bahamas": "13889",
			"Tunisia": "465097",
			"Chad": "294",
			"Viet Nam": "6765225",
			"Haiti": "168",
			"Tokelau": "599",
			"Oman": "38171123",
			"Sweden": "8246789",
			"Maldives": "50",
			"India": "437022",
			"Jamaica": "305819",
			"Austria": "1861479",
			"Eritrea": "172",
			"Congo": "48",
			"Zimbabwe": "2233",
			"Vanuatu": "6663",
			"Fiji": "15",
			"Lithuania": "174338",
			"Namibia": "89664",
			"Denmark": "62272",
			"Peru": "16357",
			"Central African Rep.": "1386",
			"Netherlands": "625507",
			"Costa Rica": "2377663",
			"Greece": "2045",
			"Kazakhstan": "3961",
			"Afghanistan": "31",
			"Saint Helena": "28",
			"Egypt": "3903491",
			"Nauru": "4420",
			"Anguilla": "118",
			"Estonia": "115322",
			"Morocco": "836248",
			"Luxembourg": "254",
			"TFYR of Macedonia": "5023",
			"Somalia": "327",
			"Western Sahara": "572",
			"United Rep. of Tanzania": "32101",
			"Finland": "8451",
			"Belize": "161860",
			"Georgia": "6393",
			"Ukraine": "498517",
			"Bermuda": "4279",
			"Djibouti": "644778",
			"Greenland": "11",
			"China, Hong Kong SAR": "334396",
			"Suriname": "1816",
			"Barbados": "87547",
			"Samoa": "4215",
			"Venezuela": "48500",
			"Kuwait": "3947",
			"Norway": "22891270",
			"Sierra Leone": "9344",
			"Marshall Isds": "590",
			"Philippines": "27815",
			"Libya": "66",
			"Kyrgyzstan": "1017",
			"Czechia": "66008",
			"Br. Indian Ocean Terr.": "69",
			"Mozambique": "609",
			"Aruba": "6",
			"Turkey": "2310",
			"San Marino": "915",
			"Rep. of Korea": "20699673",
			"Serbia": "34702",
			"Burundi": "36948",
			"Bhutan": "769",
			"Cook Isds": "17649",
			"Canada": "78315",
			"Iceland": "175"
		},
		"exports": {
			"Lebanon": "1105",
			"Gibraltar": "777171",
			"Ghana": "349",
			"Cuba": "26542695",
			"Dem. Rep. of the Congo": "9343753",
			"Cameroon": "13658632",
			"Papua New Guinea": "13486",
			"Indonesia": "168710",
			"Colombia": "167261",
			"Niger": "38549",
			"Palau": "33666",
			"Tonga": "926241",
			"Jordan": "313159",
			"Uzbekistan": "2267204",
			"Iraq": "3077770",
			"Tuvalu": "20331",
			"Guam": "2400949",
			"Bosnia Herzegovina": "121977",
			"Pakistan": "30783",
			"Belgium": "1301434",
			"Azerbaijan": "36645264",
			"Rwanda": "256875",
			"Armenia": "10769580",
			"United Kingdom": "1796855",
			"Singapore": "204549",
			"Albania": "125395",
			"Benin": "542037",
			"South Africa": "336827",
			"FS Micronesia": "56051",
			"Panama": "428403",
			"Qatar": "1567",
			"American Samoa": "5636",
			"Saint Vincent and the Grenadines": "849287",
			"Curaçao": "382813",
			"Australia": "336791742",
			"Kiribati": "398337",
			"Bahrain": "2304",
			"Mexico": "7824691",
			"Kenya": "235985",
			"Spain": "275147",
			"Ireland": "596",
			"Botswana": "12201",
			"South Sudan": "940",
			"French Polynesia": "119179",
			"Mauritania": "1498290",
			"Christmas Isds": "16512",
			"Honduras": "44157",
			"Chile": "68159",
			"Gambia": "670889",
			"Liberia": "1188278",
			"Antarctica": "55305",
			"Malaysia": "1732170",
			"Swaziland": "2138",
			"Portugal": "12658",
			"Falkland Isds (Malvinas)": "15933",
			"Nepal": "536350",
			"China": "386384",
			"Comoros": "27947",
			"Guinea-Bissau": "57811",
			"Saint Maarten": "578401",
			"Mali": "4937571",
			"Trinidad and Tobago": "11237",
			"Israel": "2055090",
			"Burkina Faso": "1471379",
			"Paraguay": "59238",
			"Norfolk Isds": "3399",
			"Bangladesh": "2459499",
			"Antigua and Barbuda": "397669",
			"Gabon": "1275897",
			"Cyprus": "743351",
			"Yemen": "3736484",
			"Mauritius": "42854368",
			"Slovakia": "50045",
			"Faeroe Isds": "3114403",
			"Syria": "9355885",
			"Côte d'Ivoire": "422467",
			"Guyana": "20100",
			"Algeria": "43455515",
			"USA": "8580375",
			"Saint Kitts and Nevis": "80461",
			"Rep. of Moldova": "201566",
			"Zambia": "1095704",
			"Malta": "3211771",
			"Ecuador": "6117",
			"Grenada": "57886",
			"Dominican Rep.": "1519386",
			"France": "10476656",
			"New Caledonia": "33627",
			"Niue": "1163",
			"Seychelles": "37336",
			"Br. Virgin Isds": "61",
			"Italy": "9057",
			"Saint Lucia": "2411561",
			"State of Palestine": "5456",
			"Uganda": "170659",
			"Belarus": "7513",
			"Ethiopia": "39903",
			"Slovenia": "10039",
			"Pitcairn": "12103",
			"Senegal": "12805908",
			"Bulgaria": "84436",
			"Montenegro": "80990",
			"Sri Lanka": "2274745",
			"Hungary": "12551",
			"Angola": "8197515",
			"N. Mariana Isds": "1145646",
			"Samoa": "263954",
			"Myanmar": "118190",
			"Iran": "2843",
			"Lao People's Dem. Rep.": "16",
			"Uruguay": "80648",
			"Cabo Verde": "9512",
			"Germany": "14464",
			"Timor-Leste": "14441",
			"Poland": "1352686",
			"Thailand": "123948",
			"Argentina": "2032571",
			"Brazil": "242318",
			"Brunei Darussalam": "8736",
			"Mongolia": "5317296",
			"Saudi Arabia": "4763",
			"Sudan": "42831395",
			"Russian Federation": "2795",
			"Cayman Isds": "699",
			"United Arab Emirates": "2717",
			"Nicaragua": "16898474",
			"Malawi": "145416",
			"Switzerland": "18875",
			"El Salvador": "259360",
			"Cambodia": "499467",
			"Latvia": "2655",
			"Japan": "551054",
			"Guinea": "1986189",
			"Romania": "24345",
			"Croatia": "271673",
			"China, Macao SAR": "2494451",
			"Guatemala": "1709053",
			"Madagascar": "1495832",
			"Bolivia (Plurinational State of)": "24752",
			"Nigeria": "273619",
			"Bahamas": "759153",
			"Tunisia": "2007892",
			"Chad": "279781",
			"Viet Nam": "164285",
			"Haiti": "116849",
			"Tokelau": "3127",
			"Oman": "6602",
			"Sweden": "209386",
			"Maldives": "1340132",
			"India": "1349",
			"Jamaica": "718167",
			"Austria": "11412",
			"Eritrea": "21746",
			"Congo": "3177801",
			"Zimbabwe": "772992",
			"Vanuatu": "20615",
			"Fiji": "37834",
			"Lithuania": "2903",
			"Namibia": "30832",
			"Denmark": "142513",
			"Peru": "27014491",
			"Netherlands": "3879",
			"Costa Rica": "357120",
			"Equatorial Guinea": "417842",
			"Greece": "7060",
			"Kazakhstan": "1557045",
			"Afghanistan": "405693",
			"Egypt": "224410183",
			"Nauru": "76859",
			"Anguilla": "36892",
			"Estonia": "55769",
			"Morocco": "39768283",
			"Luxembourg": "10375",
			"Venezuela": "52213249",
			"Somalia": "29845",
			"United Rep. of Tanzania": "1607",
			"Finland": "217336",
			"Belize": "292114",
			"Georgia": "1681277",
			"Ukraine": "6230654",
			"Bermuda": "2418",
			"Djibouti": "1790380",
			"Greenland": "1272",
			"China, Hong Kong SAR": "27009",
			"Suriname": "10662",
			"Barbados": "81677",
			"TFYR of Macedonia": "21331",
			"Kuwait": "7115",
			"Norway": "412",
			"Sierra Leone": "2367015",
			"Marshall Isds": "363",
			"Philippines": "7222",
			"Libya": "34524671",
			"Kyrgyzstan": "2071",
			"Czechia": "5290",
			"Mozambique": "3948864",
			"Togo": "406711",
			"Aruba": "518723",
			"Turkey": "8349135",
			"San Marino": "823",
			"Rep. of Korea": "11839141",
			"Serbia": "197016",
			"Bhutan": "28283",
			"Cook Isds": "31036",
			"Canada": "1141025",
			"Iceland": "840927"
		}
	},
	"Norway": {
		"imports": {
			"Lebanon": "393",
			"Bonaire": "429",
			"Gibraltar": "574",
			"Ghana": "105034",
			"Lesotho": "575",
			"Qatar": "762",
			"Dem. Rep. of the Congo": "829",
			"Cameroon": "4626",
			"South Africa": "601540",
			"Indonesia": "1233218",
			"Colombia": "5542061",
			"Niger": "1893",
			"Jordan": "1158",
			"Uzbekistan": "14678",
			"Iraq": "345",
			"Tuvalu": "1513",
			"Lao People's Dem. Rep.": "8070",
			"Bosnia Herzegovina": "583",
			"Pakistan": "6172",
			"Belgium": "2855625",
			"Azerbaijan": "1481",
			"Rwanda": "98024",
			"Armenia": "378023",
			"United Kingdom": "25051956",
			"Singapore": "9126",
			"Albania": "70042",
			"Benin": "184",
			"Panama": "8847673",
			"Cuba": "1111256",
			"Saint Vincent and the Grenadines": "610",
			"Curaçao": "999",
			"Australia": "72751",
			"Bahrain": "3415",
			"Mexico": "1032",
			"Kenya": "667857",
			"Spain": "5417",
			"Tajikistan": "159",
			"Ireland": "209104",
			"Botswana": "23993636",
			"Côte d'Ivoire": "2126450",
			"French Polynesia": "9564",
			"Mauritania": "972",
			"Honduras": "1882316",
			"Cambodia": "2844640",
			"Holy See (Vatican City State)": "197",
			"Chile": "3375",
			"Gambia": "6642",
			"China, Macao SAR": "1293",
			"Brunei Darussalam": "2337",
			"Malaysia": "3603",
			"Fiji": "210",
			"Portugal": "4263827",
			"Falkland Isds (Malvinas)": "1682",
			"Nepal": "674",
			"China": "67603419",
			"Comoros": "53591",
			"Mali": "160482",
			"Trinidad and Tobago": "50829",
			"Israel": "170371",
			"Burkina Faso": "410",
			"Paraguay": "13791",
			"Bangladesh": "251933",
			"Antigua and Barbuda": "1342",
			"Gabon": "899001",
			"Cyprus": "316467",
			"Yemen": "7335",
			"Mauritius": "81869",
			"Slovakia": "156",
			"Faeroe Isds": "8840495",
			"Turkmenistan": "19663",
			"Syria": "89612",
			"South Sudan": "11278",
			"Guyana": "8497",
			"Algeria": "14948",
			"USA": "1242057",
			"Saint Kitts and Nevis": "5539",
			"Rep. of Moldova": "54761",
			"Zambia": "469676",
			"Malta": "104458",
			"Ecuador": "6212459",
			"Grenada": "82104",
			"Dominican Rep.": "176",
			"France": "63558",
			"Niue": "1834",
			"Seychelles": "6700",
			"Br. Virgin Isds": "4419",
			"Italy": "2470",
			"State of Palestine": "118266",
			"Uganda": "1266",
			"Belarus": "10843",
			"Ethiopia": "1095913",
			"Congo": "34914",
			"Senegal": "1501",
			"Bulgaria": "1622972",
			"Montenegro": "12181",
			"Sri Lanka": "112676",
			"Hungary": "951852",
			"Angola": "23901599",
			"New Zealand": "390860",
			"Samoa": "422",
			"Myanmar": "16542",
			"Papua New Guinea": "26886",
			"Uruguay": "15621",
			"Andorra": "155",
			"Cabo Verde": "724",
			"Germany": "329144",
			"Timor-Leste": "312",
			"Poland": "11754",
			"Thailand": "7303974",
			"Argentina": "298",
			"Brazil": "33491",
			"Dominica": "10543",
			"Mongolia": "33751",
			"Saudi Arabia": "917",
			"Greece": "6322",
			"Russian Federation": "73827663",
			"United Arab Emirates": "129",
			"Nicaragua": "110112",
			"Malawi": "2636",
			"Switzerland": "1165385",
			"El Salvador": "297",
			"United States Minor Outlying Islands": "259",
			"Latvia": "2173634",
			"Japan": "66809159",
			"Guinea": "11769",
			"Romania": "451",
			"Slovenia": "8886486",
			"Liberia": "2221",
			"Mozambique": "1044904",
			"Madagascar": "717",
			"Bolivia (Plurinational State of)": "31231",
			"Nigeria": "10591126",
			"Bahamas": "313103",
			"Tunisia": "1029441",
			"Chad": "1129",
			"Viet Nam": "2435",
			"Haiti": "247",
			"Tokelau": "391",
			"Oman": "13499",
			"Sweden": "3063570",
			"Maldives": "441127",
			"India": "1645",
			"Jamaica": "167",
			"Austria": "7885582",
			"Eritrea": "3703",
			"Zimbabwe": "2222",
			"Saint Maarten": "2696",
			"Swaziland": "3964381",
			"Lithuania": "334167",
			"Namibia": "65342",
			"Denmark": "48353411",
			"Peru": "691510",
			"Central African Rep.": "3106",
			"Netherlands": "1307498",
			"Costa Rica": "938927",
			"Equatorial Guinea": "307",
			"Sudan": "1719",
			"Kazakhstan": "19478",
			"Afghanistan": "4806",
			"Croatia": "730532",
			"Saint Helena": "22329",
			"Egypt": "14335",
			"Nauru": "123",
			"Estonia": "7473437",
			"Morocco": "143696",
			"Luxembourg": "13635",
			"TFYR of Macedonia": "4030",
			"Somalia": "2701",
			"United Rep. of Tanzania": "50585",
			"Finland": "970455",
			"Belize": "14479",
			"Georgia": "57459",
			"Ukraine": "3624642",
			"Bermuda": "18048098",
			"Greenland": "8291610",
			"China, Hong Kong SAR": "1625886",
			"Suriname": "39798",
			"Barbados": "25699",
			"Iran": "15653",
			"Venezuela": "36690",
			"Kuwait": "2181",
			"Marshall Isds": "13214232",
			"Philippines": "2627",
			"Libya": "17676",
			"Kyrgyzstan": "22633",
			"Czechia": "5850785",
			"Guatemala": "428096",
			"Togo": "4972",
			"Aruba": "11405",
			"Turkey": "105292",
			"San Marino": "6324",
			"Rep. of Korea": "15777",
			"Serbia": "122549",
			"Burundi": "204",
			"Cook Isds": "566",
			"Canada": "6990487",
			"Iceland": "26003"
		},
		"exports": {
			"Lebanon": "7395",
			"Bonaire": "2190",
			"Gibraltar": "31627",
			"Ghana": "12739",
			"Qatar": "973607",
			"Dem. Rep. of the Congo": "41909",
			"Dem. People's Rep. of Korea": "30536",
			"Cameroon": "6477",
			"South Africa": "97849614",
			"Indonesia": "105232213",
			"Colombia": "2229808",
			"Niger": "18225",
			"Palau": "335",
			"Tonga": "27517",
			"Jordan": "88469",
			"Uzbekistan": "1362939",
			"Iraq": "119",
			"Guam": "248010",
			"Bosnia Herzegovina": "8975",
			"Vanuatu": "300",
			"Belgium": "206876",
			"Azerbaijan": "272583",
			"Pitcairn": "11642",
			"Rwanda": "126938",
			"Armenia": "171012",
			"United Kingdom": "14795318448",
			"Singapore": "2952231",
			"Albania": "2025",
			"Benin": "5487",
			"FS Micronesia": "516",
			"Panama": "305",
			"Cuba": "239",
			"American Samoa": "16337",
			"Saint Vincent and the Grenadines": "1411",
			"Curaçao": "357758",
			"Australia": "950922",
			"Bahrain": "572262",
			"Mexico": "5527",
			"Kenya": "847",
			"Spain": "340888613",
			"Tajikistan": "10611",
			"Ireland": "927436923",
			"Botswana": "56910",
			"Côte d'Ivoire": "2028",
			"French Polynesia": "40061",
			"Mauritania": "73212",
			"Honduras": "56418",
			"Chile": "4019",
			"Gambia": "12477",
			"China, Macao SAR": "1551",
			"Brunei Darussalam": "248193",
			"Malaysia": "241896",
			"Swaziland": "1242",
			"Portugal": "48569954",
			"Falkland Isds (Malvinas)": "6102",
			"Nepal": "91641",
			"China": "3885953",
			"Comoros": "581404",
			"Guinea-Bissau": "5440",
			"Mali": "9878",
			"Trinidad and Tobago": "376215",
			"Israel": "9733",
			"Burkina Faso": "1074",
			"Paraguay": "2386",
			"Bangladesh": "19340",
			"Antigua and Barbuda": "18949",
			"Gabon": "1725373",
			"Cyprus": "16236513",
			"Yemen": "28628",
			"Mauritius": "469",
			"Slovakia": "9868",
			"Faeroe Isds": "9797",
			"Turkmenistan": "171567",
			"Syria": "167",
			"South Sudan": "2936",
			"Guyana": "652599",
			"Algeria": "23856",
			"USA": "612202513",
			"Cambodia": "11482",
			"Rep. of Moldova": "11928",
			"Zambia": "6871",
			"Malta": "9993",
			"Ecuador": "2983",
			"Grenada": "246031",
			"Dominican Rep.": "446",
			"France": "4046437020",
			"New Caledonia": "1485",
			"Seychelles": "70096",
			"Br. Virgin Isds": "17177",
			"Italy": "148175837",
			"Saint Lucia": "937",
			"State of Palestine": "129137",
			"Uganda": "20268",
			"Belarus": "81207",
			"Ethiopia": "3278",
			"Congo": "239",
			"Senegal": "364",
			"Bulgaria": "132",
			"Montenegro": "6143",
			"Sri Lanka": "1026",
			"Hungary": "127975",
			"Angola": "7033191",
			"New Zealand": "1506",
			"N. Mariana Isds": "25458",
			"Samoa": "18452",
			"Myanmar": "9361",
			"Papua New Guinea": "5777",
			"Sao Tome and Principe": "536",
			"Lao People's Dem. Rep.": "44871",
			"Uruguay": "51462",
			"Andorra": "1347",
			"Cabo Verde": "6227",
			"Germany": "9077954611",
			"Timor-Leste": "4619",
			"Poland": "32732088",
			"Thailand": "35595",
			"Argentina": "21886459",
			"Brazil": "1227897",
			"Dominica": "16893",
			"Mongolia": "976",
			"Saudi Arabia": "8296",
			"Greece": "100515",
			"Russian Federation": "31906",
			"Cayman Isds": "432683050",
			"United Arab Emirates": "43296",
			"Nicaragua": "68499",
			"Malawi": "3351",
			"Switzerland": "843679",
			"El Salvador": "104243",
			"United States Minor Outlying Islands": "6971",
			"Latvia": "329719",
			"Japan": "55865",
			"Guinea": "2541",
			"Romania": "3233",
			"Slovenia": "25804",
			"Liberia": "2432",
			"Guatemala": "601405",
			"Madagascar": "119",
			"Bolivia (Plurinational State of)": "2061665",
			"Nigeria": "1754233",
			"Bahamas": "72726182",
			"Tunisia": "1062880",
			"Chad": "151",
			"Viet Nam": "26259",
			"Haiti": "1289612",
			"Oman": "27951",
			"Sweden": "1242191907",
			"Maldives": "9911",
			"India": "22293555",
			"Jamaica": "18786960",
			"Austria": "144357",
			"Eritrea": "4027",
			"Zimbabwe": "157996",
			"Saint Maarten": "2519",
			"Fiji": "1118",
			"Lithuania": "45824",
			"Namibia": "65904259",
			"Denmark": "851024424",
			"Peru": "8356",
			"Central African Rep.": "432",
			"Netherlands": "5215350760",
			"Costa Rica": "300192",
			"Equatorial Guinea": "618250",
			"Sudan": "20687",
			"Kazakhstan": "254627",
			"Afghanistan": "264875",
			"Croatia": "40877",
			"Saint Helena": "2699",
			"Egypt": "229083",
			"Anguilla": "31361",
			"Estonia": "620849",
			"Pakistan": "5964",
			"Luxembourg": "3808",
			"TFYR of Macedonia": "86835",
			"Somalia": "441",
			"United Rep. of Tanzania": "1968",
			"Finland": "243640416",
			"Morocco": "3197029",
			"Belize": "32481",
			"Georgia": "2469",
			"Ukraine": "33089",
			"Bermuda": "44898222",
			"Djibouti": "61975",
			"Greenland": "320879",
			"China, Hong Kong SAR": "81683",
			"Suriname": "28498",
			"Barbados": "80349",
			"Iran": "32056",
			"Venezuela": "423764",
			"Kuwait": "12390525",
			"Sierra Leone": "1372",
			"Marshall Isds": "2386",
			"Philippines": "1145",
			"Libya": "211744",
			"Kyrgyzstan": "33034",
			"Czechia": "87075",
			"Mozambique": "1944",
			"Togo": "17057",
			"Aruba": "78482",
			"Turkey": "703433",
			"San Marino": "352838",
			"Rep. of Korea": "199889",
			"Serbia": "274",
			"Burundi": "2982",
			"Bhutan": "907",
			"Cook Isds": "345918",
			"Canada": "736012",
			"Iceland": "14334"
		}
	},
	"Sierra Leone": {
		"imports": {
			"Lebanon": "157757",
			"Gibraltar": "76179",
			"South Africa": "168586",
			"Uruguay": "21403836",
			"Cabo Verde": "1002682",
			"Togo": "10039",
			"Poland": "365375",
			"Qatar": "2099821",
			"Bolivia (Plurinational State of)": "459",
			"Thailand": "43737",
			"Dem. People's Rep. of Korea": "86500",
			"Argentina": "51026",
			"Brazil": "81022",
			"Azerbaijan": "42747",
			"Cameroon": "31700",
			"Ghana": "141",
			"Barbados": "11151",
			"Saudi Arabia": "499",
			"Colombia": "28076",
			"Greece": "141285",
			"Niger": "172457",
			"United Arab Emirates": "5280141",
			"Nicaragua": "20946",
			"Jordan": "389787",
			"Malawi": "31953",
			"Switzerland": "1205",
			"Mauritius": "34119",
			"United States Minor Outlying Islands": "2641",
			"Ukraine": "80852",
			"Latvia": "114530",
			"Japan": "1291742",
			"Guinea": "35063",
			"Romania": "61814",
			"Pakistan": "37176972",
			"Belgium": "95676",
			"Croatia": "1101",
			"Mozambique": "799",
			"Germany": "26757",
			"Singapore": "334186",
			"Nigeria": "2354",
			"Bahamas": "55",
			"Tunisia": "720308",
			"Viet Nam": "223297",
			"Indonesia": "137348",
			"Oman": "65236",
			"Belarus": "15483",
			"Sweden": "249",
			"Australia": "44315",
			"India": "716649",
			"Jamaica": "7271",
			"Mexico": "204979",
			"Kenya": "2132",
			"Spain": "3320",
			"Eritrea": "289",
			"Ireland": "858",
			"Zimbabwe": "2874",
			"Côte d'Ivoire": "1654",
			"Austria": "2708",
			"Gabon": "5109",
			"Lithuania": "308284",
			"United Kingdom": "150897",
			"Denmark": "328272",
			"Honduras": "496099",
			"Cambodia": "3799",
			"Netherlands": "26250",
			"Costa Rica": "2524",
			"Bulgaria": "6518",
			"Sudan": "254",
			"Chile": "872",
			"Slovenia": "7555",
			"Gambia": "81",
			"Liberia": "201031",
			"Malaysia": "959314",
			"Swaziland": "128",
			"Portugal": "35597",
			"China": "1648430",
			"Egypt": "813446",
			"Estonia": "147942",
			"Morocco": "2624723",
			"Luxembourg": "62903",
			"Israel": "2583",
			"Paraguay": "609986",
			"Bangladesh": "167176",
			"United Rep. of Tanzania": "33",
			"Finland": "2456",
			"Cyprus": "130518",
			"Kuwait": "1041",
			"Georgia": "183",
			"Slovakia": "2964",
			"Bahrain": "15191",
			"China, Hong Kong SAR": "2026",
			"Russian Federation": "30455",
			"Algeria": "447070",
			"USA": "349399",
			"Namibia": "143067",
			"Rep. of Moldova": "9663",
			"Zambia": "6244",
			"Malta": "489",
			"Norway": "941",
			"Serbia": "37206",
			"Iran": "56",
			"France": "35882",
			"Philippines": "25916",
			"Italy": "73447",
			"Czechia": "2425",
			"Uganda": "13383",
			"Br. Indian Ocean Terr.": "3895",
			"Guatemala": "3996210",
			"Ethiopia": "20240",
			"Senegal": "1164259",
			"Turkey": "180916",
			"Sri Lanka": "82361",
			"Rep. of Korea": "33411",
			"Hungary": "33",
			"Angola": "7117",
			"Bhutan": "490",
			"New Zealand": "187848",
			"N. Mariana Isds": "31919",
			"Canada": "7903",
			"Iceland": "60",
			"El Salvador": "2003"
		},
		"exports": {
			"Lebanon": "368",
			"Ghana": "590728",
			"Gambia": "22174",
			"Liberia": "161364",
			"United Kingdom": "15340",
			"Congo": "56163",
			"Malaysia": "12746",
			"USA": "60210",
			"Portugal": "3970",
			"Brazil": "334",
			"Germany": "57713",
			"Egypt": "279228",
			"China": "24509439",
			"South Africa": "4193",
			"Guinea-Bissau": "12589",
			"Morocco": "112230",
			"Mali": "35",
			"Niger": "311",
			"Burkina Faso": "63821",
			"United Arab Emirates": "12520",
			"Bangladesh": "9",
			"Malawi": "336",
			"Switzerland": "129670",
			"United Rep. of Tanzania": "17521",
			"Finland": "9",
			"Slovakia": "3185",
			"Japan": "4647",
			"Guinea": "40431",
			"Côte d'Ivoire": "2542402",
			"Belgium": "461",
			"Azerbaijan": "17",
			"Malta": "24143",
			"Iran": "87",
			"Zambia": "94",
			"Togo": "125270",
			"Bolivia (Plurinational State of)": "25408",
			"Nigeria": "27",
			"Benin": "22873",
			"France": "17",
			"Viet Nam": "204401",
			"Cameroon": "1596",
			"Italy": "55803",
			"Czechia": "87",
			"Australia": "1114",
			"India": "5904",
			"Pakistan": "63626",
			"Kenya": "977",
			"Senegal": "270",
			"Ireland": "200476",
			"Thailand": "95",
			"Sri Lanka": "6020",
			"China, Hong Kong SAR": "16826",
			"Rep. of Korea": "2296675",
			"Spain": "15932",
			"Mauritania": "20760",
			"Dem. People's Rep. of Korea": "73183",
			"Netherlands": "1613"
		}
	},
	"Marshall Isds": {
		"imports": {},
		"exports": {}
	},
	"Philippines": {
		"imports": {
			"Lebanon": "1891",
			"Ghana": "631000",
			"Lesotho": "1090",
			"Qatar": "93082477",
			"Dem. People's Rep. of Korea": "104210",
			"Cameroon": "4195",
			"South Africa": "46890",
			"Indonesia": "880364779",
			"Colombia": "3552665",
			"Niger": "45",
			"Palau": "12600",
			"Tonga": "257488",
			"Jordan": "19736",
			"Fr. South Antarctic Terr.": "312",
			"Uzbekistan": "907948",
			"Iraq": "3336",
			"Guam": "1300409",
			"Bosnia Herzegovina": "1135397",
			"Pakistan": "19277",
			"Belgium": "2509497",
			"Azerbaijan": "1014051",
			"Armenia": "41485",
			"United Kingdom": "142497",
			"Singapore": "2500708",
			"Albania": "1913377",
			"FS Micronesia": "418872",
			"Panama": "34277431",
			"Cuba": "387982",
			"American Samoa": "559698",
			"Saint Vincent and the Grenadines": "29050",
			"Curaçao": "62674",
			"Australia": "105775347",
			"Kiribati": "2389540",
			"Mexico": "95399",
			"Br. Virgin Isds": "8210000",
			"Spain": "52009",
			"Tajikistan": "213",
			"Ireland": "21767959",
			"Botswana": "887",
			"French Polynesia": "6673347",
			"Christmas Isds": "10136",
			"Honduras": "65841",
			"Holy See (Vatican City State)": "485",
			"Chile": "6781698",
			"Gambia": "311",
			"Liberia": "206",
			"Dominica": "690",
			"Malaysia": "204498699",
			"Fiji": "22335",
			"Peru": "29261",
			"Nepal": "12730",
			"China": "137590",
			"Comoros": "42",
			"Mali": "29",
			"Trinidad and Tobago": "580429",
			"Israel": "103256",
			"Burkina Faso": "2389",
			"Paraguay": "82499",
			"Norfolk Isds": "3635",
			"Bangladesh": "61038",
			"Antigua and Barbuda": "2412024",
			"Gabon": "22729",
			"Cyprus": "104",
			"Yemen": "168084",
			"Mauritius": "127966",
			"Slovakia": "19905",
			"Faeroe Isds": "3748",
			"Bahrain": "2114246",
			"Côte d'Ivoire": "1536",
			"Guyana": "312250",
			"Algeria": "1987376",
			"USA": "33258",
			"Saint Kitts and Nevis": "762",
			"Rep. of Moldova": "1588",
			"Zambia": "83",
			"Malta": "130013",
			"Ecuador": "66643",
			"Grenada": "13582",
			"Dominican Rep.": "6294",
			"France": "369762770",
			"New Caledonia": "3610",
			"Seychelles": "1979773",
			"Italy": "586240",
			"Uganda": "20641",
			"Syria": "611",
			"Belarus": "50516",
			"Ethiopia": "610",
			"Slovenia": "2267",
			"Congo": "36697",
			"Senegal": "46698",
			"Bulgaria": "1275982",
			"Sri Lanka": "1139675",
			"Hungary": "29819",
			"Angola": "78942",
			"N. Mariana Isds": "5411",
			"Lao People's Dem. Rep.": "225196",
			"Myanmar": "22516",
			"Iran": "26894",
			"Uruguay": "4359417",
			"Andorra": "3347",
			"Cabo Verde": "34",
			"Germany": "194682",
			"Timor-Leste": "981",
			"Poland": "691",
			"Thailand": "125806795",
			"Argentina": "44969626",
			"Brazil": "9298",
			"Brunei Darussalam": "13560007",
			"Mongolia": "46",
			"Saudi Arabia": "978370256",
			"Sudan": "360145",
			"Russian Federation": "87856129",
			"Cayman Isds": "65146129",
			"United Arab Emirates": "404670570",
			"Nicaragua": "101437",
			"Malawi": "14624",
			"Switzerland": "2969",
			"El Salvador": "5349",
			"United States Minor Outlying Islands": "502",
			"Latvia": "11373",
			"Japan": "13691",
			"Guinea": "89",
			"Romania": "214203",
			"Croatia": "157",
			"China, Macao SAR": "351",
			"Mozambique": "14809",
			"Madagascar": "7726",
			"Bolivia (Plurinational State of)": "874804",
			"Nigeria": "24045416",
			"Bahamas": "3004721",
			"San Marino": "223070",
			"Chad": "22964",
			"Viet Nam": "15340575",
			"Haiti": "2582",
			"Tokelau": "262",
			"Oman": "20028147",
			"Sweden": "2276695",
			"Maldives": "51503",
			"India": "102724290",
			"Jamaica": "114487",
			"Austria": "1350752",
			"Zimbabwe": "1801099",
			"Vanuatu": "13524381",
			"Swaziland": "3593",
			"Lithuania": "199331",
			"Cambodia": "9395382",
			"Denmark": "3264",
			"Portugal": "548860",
			"Central African Rep.": "95080",
			"Netherlands": "59737",
			"Costa Rica": "239048",
			"Equatorial Guinea": "1866",
			"Greece": "522856",
			"Papua New Guinea": "991106",
			"Kazakhstan": "37104",
			"Kenya": "21654",
			"Afghanistan": "59848",
			"Saint Helena": "1119",
			"Egypt": "10891",
			"Nauru": "225307",
			"Anguilla": "5553",
			"Estonia": "7232",
			"Morocco": "927197",
			"Luxembourg": "333",
			"TFYR of Macedonia": "30967",
			"Somalia": "1422",
			"United Rep. of Tanzania": "56",
			"Finland": "13392",
			"Georgia": "121163",
			"Ukraine": "5440",
			"Bermuda": "55",
			"Djibouti": "10039",
			"China, Hong Kong SAR": "4389681",
			"Suriname": "979",
			"Barbados": "72218",
			"Samoa": "67",
			"Venezuela": "1542",
			"Kuwait": "977304516",
			"New Zealand": "98909",
			"Norway": "519450",
			"Sierra Leone": "17718",
			"Marshall Isds": "5757148",
			"Sao Tome and Principe": "1835",
			"Libya": "14597",
			"Kyrgyzstan": "1558",
			"Czechia": "1851",
			"Br. Indian Ocean Terr.": "1249",
			"Guatemala": "131255",
			"Togo": "105",
			"Aruba": "2333",
			"Turkey": "173163",
			"Tunisia": "6061",
			"Rep. of Korea": "148130803",
			"Serbia": "6538",
			"Canada": "1860978",
			"Iceland": "330047"
		},
		"exports": {
			"Lebanon": "3563716",
			"Gibraltar": "2770",
			"Ghana": "835297",
			"Cuba": "2072415",
			"Dem. People's Rep. of Korea": "865413",
			"Cameroon": "2175074",
			"Iran": "428415",
			"Indonesia": "68330",
			"Colombia": "1008",
			"Niger": "13790",
			"Palau": "2073",
			"Tonga": "195547",
			"Angola": "361640",
			"Uzbekistan": "1131",
			"Iraq": "902807",
			"Tuvalu": "21240",
			"Guam": "10066456",
			"Bosnia Herzegovina": "44677",
			"Pakistan": "8964",
			"Belgium": "223135982",
			"Azerbaijan": "81527",
			"Australia": "13221841",
			"Togo": "13225",
			"Singapore": "12437108",
			"Albania": "9261",
			"Benin": "100",
			"South Africa": "833105",
			"FS Micronesia": "20097",
			"Panama": "176039",
			"Qatar": "2283",
			"American Samoa": "2570536",
			"Curaçao": "94952",
			"Armenia": "166690",
			"Kiribati": "33100",
			"Jamaica": "203478",
			"Br. Virgin Isds": "8864740",
			"Spain": "181980",
			"Tajikistan": "40",
			"Ireland": "4211666",
			"Botswana": "131419",
			"Norfolk Isds": "3492418",
			"Mauritania": "2465",
			"Honduras": "37576",
			"United Kingdom": "19901839",
			"Chile": "532561",
			"Gambia": "70956",
			"China, Macao SAR": "295509",
			"Dominica": "25020",
			"Malaysia": "77771",
			"Fiji": "360141",
			"Portugal": "3131801",
			"Nepal": "51006",
			"China": "305139827",
			"Guinea-Bissau": "10161",
			"Djibouti": "1324",
			"Trinidad and Tobago": "222274",
			"Israel": "100000",
			"Burkina Faso": "14074",
			"Paraguay": "12701",
			"French Polynesia": "1431594",
			"Bangladesh": "2380000",
			"Antigua and Barbuda": "16162",
			"Gabon": "100",
			"Cyprus": "2419577",
			"Yemen": "2043725",
			"Mauritius": "1121864",
			"Slovakia": "326302",
			"Faeroe Isds": "36575",
			"Turkmenistan": "5260",
			"Bahrain": "144045",
			"Côte d'Ivoire": "707893",
			"Guyana": "25461",
			"Algeria": "2432460",
			"USA": "151818",
			"Saint Kitts and Nevis": "228",
			"Rep. of Moldova": "500",
			"Zambia": "560000",
			"Malta": "160000000",
			"Ecuador": "253264",
			"Grenada": "10388",
			"Dominican Rep.": "93191",
			"France": "24407",
			"New Caledonia": "297201",
			"Seychelles": "3555",
			"Oceania, nes": "100",
			"Italy": "207828",
			"Saint Lucia": "431",
			"Rwanda": "3432",
			"Syria": "90",
			"Belarus": "309445",
			"Ethiopia": "38525",
			"Namibia": "166",
			"Pitcairn": "872",
			"Slovenia": "438216",
			"Bulgaria": "75981",
			"Montenegro": "50",
			"Sri Lanka": "7985574",
			"Hungary": "853483",
			"Jordan": "406713",
			"N. Mariana Isds": "1278980",
			"Lao People's Dem. Rep.": "7085",
			"Myanmar": "1059938",
			"Papua New Guinea": "525929",
			"Uruguay": "104084",
			"Switzerland": "49470",
			"Cabo Verde": "385",
			"Germany": "910",
			"Timor-Leste": "128222",
			"Poland": "161817",
			"Thailand": "107917099",
			"Argentina": "428803",
			"Brazil": "11103273",
			"Brunei Darussalam": "5307397",
			"Mongolia": "830024",
			"Saudi Arabia": "5800",
			"Sudan": "572048",
			"Russian Federation": "89867",
			"Cayman Isds": "88860",
			"United Arab Emirates": "377128",
			"Nicaragua": "268",
			"Malawi": "2000",
			"Andorra": "1050",
			"El Salvador": "221250",
			"United States Minor Outlying Islands": "39875",
			"Latvia": "618585",
			"Japan": "3495234",
			"Guinea": "593394",
			"Uganda": "270375",
			"Romania": "13680",
			"Croatia": "554749",
			"Liberia": "81610000",
			"Guatemala": "144954",
			"Madagascar": "2027",
			"Bolivia (Plurinational State of)": "715992",
			"Barbados": "103221",
			"Bahamas": "664300",
			"Tunisia": "140",
			"Chad": "30",
			"Viet Nam": "44618",
			"Haiti": "65",
			"Tokelau": "51707",
			"Oman": "2600",
			"Sweden": "104894",
			"Maldives": "1243181",
			"India": "1925000",
			"Mexico": "1622145",
			"Austria": "65141",
			"Congo": "90545",
			"Zimbabwe": "16961",
			"Vanuatu": "195287",
			"Senegal": "68",
			"Swaziland": "56873",
			"Lithuania": "716185",
			"Cambodia": "1772719",
			"Denmark": "943418",
			"Peru": "2523065",
			"Central African Rep.": "4814",
			"Netherlands": "2485421",
			"Costa Rica": "67016",
			"Greece": "2839354",
			"Kazakhstan": "500",
			"Kenya": "229488",
			"Afghanistan": "7370376",
			"Egypt": "1967595",
			"Anguilla": "383",
			"Estonia": "180867",
			"Morocco": "79438",
			"Luxembourg": "5114",
			"TFYR of Macedonia": "59681",
			"Somalia": "479550",
			"United Rep. of Tanzania": "10636",
			"Finland": "1990333",
			"Belize": "123258",
			"Georgia": "13674",
			"Ukraine": "52092",
			"Bermuda": "47352",
			"Mali": "6200",
			"Greenland": "1127",
			"China, Hong Kong SAR": "6484673",
			"Suriname": "25587",
			"Nigeria": "1299762",
			"Samoa": "868509",
			"Venezuela": "449406",
			"Kuwait": "35",
			"New Zealand": "5134",
			"Norway": "1665236",
			"Sierra Leone": "46987",
			"Marshall Isds": "1165685",
			"Libya": "400000",
			"Kyrgyzstan": "34583",
			"Czechia": "92453",
			"Br. Indian Ocean Terr.": "300",
			"Mozambique": "932",
			"Aruba": "227557",
			"Turkey": "775118",
			"Rep. of Korea": "84194565",
			"Serbia": "23400",
			"Burundi": "80997",
			"Bhutan": "149588",
			"Cook Isds": "13527",
			"Canada": "55064",
			"Iceland": "451572"
		}
	},
	"Dominican Rep.": {
		"imports": {},
		"exports": {}
	},
	"Kyrgyzstan": {
		"imports": {
			"Lebanon": "152",
			"South Africa": "49",
			"Uruguay": "171",
			"United Kingdom": "1119",
			"Barbados": "350",
			"Poland": "40",
			"Cuba": "2209",
			"Thailand": "145591",
			"Dem. People's Rep. of Korea": "410",
			"Argentina": "9181",
			"Brazil": "450",
			"Cameroon": "581",
			"Dominica": "1225",
			"Ghana": "356",
			"Mongolia": "14140",
			"Saudi Arabia": "1600",
			"Indonesia": "767",
			"Colombia": "17070",
			"Syria": "909",
			"Russian Federation": "2113112",
			"United Arab Emirates": "17454",
			"Nicaragua": "268",
			"Jordan": "13037",
			"Switzerland": "641",
			"El Salvador": "420",
			"Uzbekistan": "169700",
			"Latvia": "170",
			"Japan": "39517",
			"Hungary": "222691",
			"Guatemala": "1961",
			"Iraq": "48",
			"Bosnia Herzegovina": "24",
			"Pakistan": "3309",
			"Belgium": "6721",
			"Azerbaijan": "4475565",
			"Australia": "4540",
			"Germany": "75938",
			"Singapore": "11565",
			"Nigeria": "1558",
			"Albania": "404",
			"Bahamas": "2913",
			"San Marino": "13417",
			"Viet Nam": "2214",
			"Panama": "123229",
			"American Samoa": "46800",
			"Oman": "75",
			"Sweden": "375833",
			"Armenia": "239676",
			"India": "3766",
			"Jamaica": "1908",
			"Mexico": "7173",
			"Br. Virgin Isds": "305",
			"Austria": "120",
			"Romania": "1558531",
			"Ireland": "726",
			"Zimbabwe": "52",
			"China, Hong Kong SAR": "700",
			"Spain": "131536",
			"Lithuania": "18937",
			"Cambodia": "4288",
			"Tajikistan": "4667",
			"Peru": "158",
			"Honduras": "441",
			"Slovenia": "585976",
			"Costa Rica": "194",
			"Denmark": "5467540",
			"Turkey": "1041",
			"Greece": "4551",
			"Chile": "83463",
			"Kazakhstan": "3598",
			"Gambia": "463",
			"Kenya": "1682160",
			"Afghanistan": "23306",
			"Croatia": "940",
			"Malaysia": "23864",
			"Portugal": "53210",
			"China": "2230118",
			"Egypt": "192",
			"Anguilla": "79",
			"Estonia": "2800",
			"Morocco": "222384",
			"Luxembourg": "360",
			"Trinidad and Tobago": "4993",
			"Israel": "55026",
			"TFYR of Macedonia": "371728",
			"Bangladesh": "921",
			"United Rep. of Tanzania": "57",
			"Finland": "29727",
			"Cyprus": "344049",
			"Yemen": "202",
			"Mauritius": "1051",
			"Slovakia": "9374",
			"Madagascar": "172",
			"Turkmenistan": "7498",
			"Georgia": "1632357",
			"Guyana": "524",
			"USA": "26802",
			"Saint Kitts and Nevis": "2077",
			"Rep. of Moldova": "921",
			"Zambia": "21",
			"Malta": "295986",
			"Norway": "1682119",
			"Ecuador": "136851",
			"Iran": "90",
			"Dominican Rep.": "935",
			"France": "3352966",
			"Philippines": "240616",
			"Italy": "12557",
			"Czechia": "11527",
			"Rwanda": "8",
			"Belarus": "15317090",
			"Ethiopia": "559",
			"Kuwait": "626",
			"Congo": "30582",
			"Bulgaria": "233308",
			"Tunisia": "1355",
			"Sri Lanka": "374",
			"Rep. of Korea": "57468",
			"Serbia": "819",
			"Netherlands": "21468",
			"New Zealand": "2154",
			"Canada": "55062",
			"Iceland": "21638",
			"Ukraine": "44000",
			"Myanmar": "425"
		},
		"exports": {
			"Costa Rica": "1",
			"Bulgaria": "4335964",
			"Papua New Guinea": "2200",
			"Sudan": "30",
			"Croatia": "8964",
			"Kazakhstan": "133816",
			"United Kingdom": "26367",
			"Afghanistan": "588541",
			"Poland": "551617",
			"Qatar": "5000",
			"Thailand": "120",
			"Portugal": "246",
			"Azerbaijan": "59860",
			"Egypt": "2124",
			"China": "1906887",
			"South Africa": "13671",
			"Mongolia": "886052",
			"Saudi Arabia": "1000",
			"Estonia": "40",
			"Czechia": "1000",
			"Djibouti": "231050",
			"Greece": "2675",
			"Russian Federation": "22670",
			"TFYR of Macedonia": "2064737",
			"United Arab Emirates": "8436100",
			"Iraq": "125911",
			"France": "2774",
			"Bangladesh": "13693",
			"Ireland": "18",
			"Switzerland": "91096",
			"Belarus": "71021",
			"Finland": "200",
			"Bosnia Herzegovina": "374192",
			"Cyprus": "598",
			"Georgia": "340000",
			"Montenegro": "599270",
			"Latvia": "8172",
			"Japan": "300",
			"Hungary": "200",
			"Turkmenistan": "556168",
			"Uzbekistan": "120",
			"Romania": "2053944",
			"Pakistan": "138741",
			"Belgium": "1796",
			"Slovenia": "57230",
			"USA": "75",
			"Cambodia": "38125",
			"Rep. of Moldova": "54324",
			"Australia": "4392",
			"Kuwait": "6147",
			"Germany": "1244",
			"Singapore": "584",
			"Benin": "2640",
			"Dominican Rep.": "400",
			"Chad": "225513",
			"Viet Nam": "3200",
			"Philippines": "481490",
			"Indonesia": "31305",
			"Italy": "6",
			"Oman": "1",
			"Jordan": "1097",
			"Sweden": "333",
			"Mozambique": "45000",
			"Iran": "6000000",
			"Bahrain": "200",
			"India": "1734",
			"Mexico": "14715",
			"Spain": "398",
			"Tajikistan": "160747",
			"Turkey": "25532150",
			"Malaysia": "72",
			"China, Hong Kong SAR": "3849",
			"Rep. of Korea": "132732",
			"Austria": "319",
			"Serbia": "153032",
			"Lithuania": "3587",
			"Slovakia": "800",
			"Armenia": "6620",
			"Denmark": "8111",
			"Canada": "347",
			"Israel": "648",
			"Ukraine": "259307",
			"Netherlands": "40",
			"Myanmar": "1"
		}
	},
	"Czechia": {
		"imports": {
			"Lebanon": "167702",
			"Bonaire": "206",
			"Gibraltar": "470",
			"Ghana": "46654",
			"Lesotho": "44576",
			"Cuba": "3953590",
			"Dem. Rep. of the Congo": "196",
			"Dem. People's Rep. of Korea": "74",
			"Cameroon": "2400987",
			"South Africa": "5128",
			"Montserrat": "955",
			"Indonesia": "1351837",
			"Colombia": "1610464",
			"Niger": "14808",
			"Palau": "3211",
			"Tonga": "319",
			"Jordan": "21068",
			"Fr. South Antarctic Terr.": "85284",
			"Uzbekistan": "19616",
			"Iraq": "84",
			"Tuvalu": "48",
			"Guam": "47",
			"Bosnia Herzegovina": "365828",
			"Pakistan": "843926",
			"Belgium": "27647",
			"Azerbaijan": "623148411",
			"Australia": "76",
			"Togo": "217",
			"Singapore": "11691",
			"Albania": "2625788",
			"Benin": "21366",
			"Antarctica": "134",
			"FS Micronesia": "885",
			"Panama": "208580",
			"Qatar": "54",
			"American Samoa": "6751",
			"Saint Vincent and the Grenadines": "750",
			"Curaçao": "110871",
			"Armenia": "137075",
			"Kiribati": "546",
			"Bahrain": "74",
			"Mexico": "694704",
			"Kenya": "138",
			"Spain": "1198466",
			"Tajikistan": "159606",
			"Ireland": "3276",
			"Botswana": "1028",
			"South Sudan": "1117",
			"French Polynesia": "853",
			"Mauritania": "26603",
			"Christmas Isds": "4646",
			"Honduras": "60897",
			"Saint Barthélemy": "64188",
			"Holy See (Vatican City State)": "1198",
			"United Kingdom": "2976632",
			"Chile": "9731",
			"Sudan": "34334",
			"Gambia": "2007",
			"Liberia": "879",
			"Brunei Darussalam": "1861",
			"Malaysia": "11228",
			"Swaziland": "9862",
			"Portugal": "1458661",
			"Falkland Isds (Malvinas)": "4089",
			"Nepal": "463444",
			"China": "5804973",
			"Comoros": "10975",
			"Saint Maarten": "103895",
			"Mali": "976",
			"Trinidad and Tobago": "76601",
			"Israel": "338451",
			"Burkina Faso": "60575",
			"Paraguay": "30447",
			"Norfolk Isds": "85",
			"Bangladesh": "65810",
			"Antigua and Barbuda": "21903",
			"Gabon": "1324",
			"Cyprus": "22978",
			"Yemen": "2758",
			"Mauritius": "2953235",
			"Slovakia": "5411081",
			"Faeroe Isds": "16808",
			"Turkmenistan": "113065",
			"Syria": "31854",
			"Côte d'Ivoire": "63868",
			"Guyana": "677561",
			"Saint Pierre and Miquelon": "2788",
			"Algeria": "62072",
			"USA": "17299590",
			"Cambodia": "6596899",
			"Rep. of Moldova": "11058671",
			"Zambia": "1823",
			"Malta": "5440",
			"Ecuador": "3200",
			"Grenada": "652",
			"Dominican Rep.": "5564",
			"France": "243494023",
			"New Caledonia": "499",
			"Niue": "32",
			"Seychelles": "57760",
			"Br. Virgin Isds": "2314",
			"Italy": "158585569",
			"Saint Lucia": "12593",
			"State of Palestine": "10291",
			"Rwanda": "17965",
			"Belarus": "9742",
			"Ethiopia": "857",
			"Pitcairn": "4370",
			"Senegal": "62271",
			"Bulgaria": "1012894",
			"Montenegro": "45959",
			"Sri Lanka": "218851",
			"Hungary": "18378503",
			"Netherlands": "6288685",
			"New Zealand": "8911",
			"N. Mariana Isds": "167",
			"Lao People's Dem. Rep.": "12282",
			"Myanmar": "31875",
			"Iran": "32609",
			"Sao Tome and Principe": "6107",
			"Uruguay": "1133032",
			"Andorra": "1483",
			"Cabo Verde": "2234",
			"Germany": "1407011751",
			"Poland": "4466717",
			"Thailand": "4485425",
			"Argentina": "21469",
			"Brazil": "56302",
			"Dominica": "7291",
			"Mongolia": "2094",
			"Saudi Arabia": "2403",
			"South Georgia and the South Sandwich Islands": "712",
			"Russian Federation": "249378",
			"Cayman Isds": "16316",
			"United Arab Emirates": "362",
			"Nicaragua": "202622",
			"Malawi": "1880",
			"Switzerland": "189852",
			"El Salvador": "1637",
			"United States Minor Outlying Islands": "35616",
			"Latvia": "763085",
			"Japan": "29353317",
			"Guinea": "8253",
			"Uganda": "130736",
			"Romania": "2860110",
			"Croatia": "322143",
			"China, Macao SAR": "1450",
			"Guatemala": "2886619",
			"Madagascar": "46964",
			"Bolivia (Plurinational State of)": "77072",
			"Nigeria": "3917",
			"Saint Kitts and Nevis": "455",
			"Bahamas": "105",
			"San Marino": "108375",
			"Chad": "901751",
			"Viet Nam": "751711",
			"Haiti": "7237",
			"Tokelau": "3735",
			"Oman": "613884",
			"Sweden": "460934",
			"Maldives": "264979",
			"India": "757074",
			"Jamaica": "976852",
			"Austria": "260706",
			"Congo": "4734",
			"Zimbabwe": "8861",
			"Vanuatu": "476",
			"Fiji": "12812",
			"Lithuania": "966136",
			"Namibia": "5617",
			"Denmark": "458598",
			"Peru": "588018",
			"Central African Rep.": "133088",
			"Slovenia": "434552",
			"Costa Rica": "27404",
			"Equatorial Guinea": "10431",
			"Greece": "56267",
			"Papua New Guinea": "341",
			"Kazakhstan": "579555",
			"Afghanistan": "7996",
			"Egypt": "1789693",
			"Nauru": "251",
			"Anguilla": "71413",
			"Estonia": "316446",
			"Morocco": "5335468",
			"Luxembourg": "32113",
			"TFYR of Macedonia": "1494080",
			"Somalia": "1375",
			"Angola": "40",
			"Western Sahara": "25815",
			"United Rep. of Tanzania": "320935",
			"Finland": "334985",
			"Belize": "2669",
			"Georgia": "1320314",
			"Ukraine": "389534",
			"Bermuda": "2607",
			"Djibouti": "9104",
			"Greenland": "70944",
			"China, Hong Kong SAR": "202078",
			"Suriname": "154881",
			"Barbados": "403893",
			"Samoa": "676",
			"Venezuela": "3025294",
			"Kuwait": "29832",
			"Norway": "70301",
			"Sierra Leone": "132",
			"Philippines": "232414",
			"Libya": "68242",
			"Kyrgyzstan": "1458",
			"Czechia": "190",
			"Br. Indian Ocean Terr.": "79",
			"Mozambique": "194",
			"Aruba": "2109",
			"Turkey": "612640",
			"Tunisia": "23498",
			"Rep. of Korea": "175963",
			"Serbia": "14456",
			"Burundi": "30946",
			"Bhutan": "70",
			"Cook Isds": "5140",
			"Canada": "27867973",
			"Iceland": "3252614"
		},
		"exports": {
			"Lebanon": "64149",
			"Gibraltar": "124",
			"Ghana": "151675",
			"Lesotho": "1436425",
			"Cuba": "1496096",
			"Dem. Rep. of the Congo": "11695",
			"Dem. People's Rep. of Korea": "4459",
			"Cameroon": "46005",
			"South Africa": "19741",
			"Montserrat": "2994",
			"Indonesia": "3418904",
			"Colombia": "1315",
			"Niger": "3852",
			"Palau": "298",
			"Tonga": "1387",
			"Jordan": "26967557",
			"Fr. South Antarctic Terr.": "543159",
			"Uzbekistan": "296348",
			"Iraq": "24374232",
			"Guam": "149",
			"Bosnia Herzegovina": "840291",
			"Pakistan": "7915",
			"Belgium": "200",
			"Azerbaijan": "4804444",
			"Rwanda": "151041",
			"Australia": "858321",
			"Togo": "682999",
			"Singapore": "109783",
			"Albania": "29132",
			"Benin": "7469",
			"Antarctica": "128",
			"Panama": "6587",
			"Qatar": "4794277",
			"Saint Vincent and the Grenadines": "278",
			"Curaçao": "364",
			"Armenia": "93400",
			"Bahrain": "218",
			"Mexico": "354527",
			"Kenya": "191608",
			"Spain": "2108065",
			"Tajikistan": "33075",
			"Ireland": "110593",
			"Botswana": "3219",
			"South Sudan": "25690",
			"French Polynesia": "118207",
			"Mauritania": "2503",
			"Honduras": "339",
			"Saint Barthélemy": "34",
			"Holy See (Vatican City State)": "33",
			"United Kingdom": "4189468",
			"Chile": "20376",
			"Gambia": "15159",
			"China, Macao SAR": "27",
			"Brunei Darussalam": "1094",
			"Malaysia": "28291",
			"Swaziland": "9508",
			"Portugal": "342283",
			"Falkland Isds (Malvinas)": "219",
			"Nepal": "768",
			"China": "1628421",
			"Guinea-Bissau": "7228",
			"Saint Maarten": "22712",
			"Mali": "160111",
			"Trinidad and Tobago": "130074",
			"Israel": "4544510",
			"Burkina Faso": "16101",
			"Paraguay": "126188",
			"Norfolk Isds": "63",
			"Bangladesh": "94",
			"Antigua and Barbuda": "14500",
			"Gabon": "180619",
			"Cyprus": "112872",
			"Yemen": "3839",
			"Mauritius": "276",
			"Slovakia": "22710282",
			"Faeroe Isds": "4504",
			"Turkmenistan": "216308",
			"Syria": "26170",
			"Côte d'Ivoire": "93724",
			"Guyana": "29644",
			"Algeria": "7734",
			"USA": "7025572",
			"Cambodia": "33840",
			"Rep. of Moldova": "158846",
			"Zambia": "16239",
			"Malta": "127478",
			"Ecuador": "520350",
			"Grenada": "964",
			"Dominican Rep.": "2116",
			"France": "1086863723",
			"New Caledonia": "858101",
			"Seychelles": "64493",
			"Br. Virgin Isds": "24364",
			"Italy": "71377227",
			"Saint Lucia": "15131",
			"State of Palestine": "15109017",
			"Uganda": "86264",
			"Belarus": "1011663",
			"Ethiopia": "10736",
			"Congo": "964",
			"Senegal": "19996",
			"Bulgaria": "9343835",
			"Montenegro": "65685",
			"Sri Lanka": "555",
			"Hungary": "50019976",
			"Netherlands": "37331164",
			"New Zealand": "142622",
			"Lao People's Dem. Rep.": "528195",
			"Myanmar": "3332",
			"Iran": "154028",
			"Sao Tome and Principe": "65892",
			"Uruguay": "21425",
			"Andorra": "3489",
			"Cabo Verde": "19163",
			"Germany": "4622969081",
			"Timor-Leste": "552",
			"Poland": "8743150",
			"Thailand": "14071",
			"Argentina": "11529",
			"Brazil": "19554767",
			"Dominica": "279",
			"Mongolia": "136370",
			"Saudi Arabia": "190606",
			"Greece": "54970802",
			"Russian Federation": "1006493",
			"Cayman Isds": "100474",
			"United Arab Emirates": "216743",
			"Nicaragua": "42947",
			"Malawi": "1207",
			"Switzerland": "2543858",
			"El Salvador": "22077",
			"United States Minor Outlying Islands": "140",
			"Latvia": "14096869",
			"Japan": "476404",
			"Guinea": "11542",
			"Romania": "1056745",
			"Croatia": "6251463",
			"Liberia": "157",
			"Mozambique": "15623",
			"Madagascar": "21695",
			"Bolivia (Plurinational State of)": "15067",
			"Nigeria": "465",
			"Saint Kitts and Nevis": "70",
			"Bahamas": "1078",
			"Tunisia": "5165",
			"Chad": "774",
			"Viet Nam": "148720",
			"Haiti": "176653",
			"Oman": "1991",
			"Sweden": "1963206",
			"Maldives": "1325",
			"India": "19434",
			"Jamaica": "175369",
			"Austria": "86594310",
			"Eritrea": "2584",
			"Zimbabwe": "34554",
			"Vanuatu": "8923",
			"Fiji": "70999",
			"Lithuania": "10985930",
			"Namibia": "330584",
			"Denmark": "9369107",
			"Peru": "118117",
			"Central African Rep.": "1151911",
			"Slovenia": "1035024",
			"Costa Rica": "166883",
			"Equatorial Guinea": "27740",
			"Sudan": "922664",
			"Papua New Guinea": "153",
			"Kazakhstan": "1266718",
			"Afghanistan": "590246",
			"Egypt": "18",
			"Nauru": "9210",
			"Anguilla": "207",
			"Estonia": "8534344",
			"Morocco": "4570",
			"Luxembourg": "166119",
			"TFYR of Macedonia": "20247",
			"Somalia": "2710718",
			"Angola": "590",
			"United Rep. of Tanzania": "189363",
			"Finland": "208449942",
			"Belize": "67177",
			"Georgia": "7172838",
			"Ukraine": "569156",
			"Bermuda": "1670",
			"Djibouti": "21323",
			"Greenland": "258727",
			"China, Hong Kong SAR": "171448",
			"Suriname": "128481",
			"Barbados": "430",
			"Samoa": "4334",
			"Venezuela": "94457",
			"Kuwait": "79958",
			"Norway": "4908341",
			"Sierra Leone": "20148",
			"Marshall Isds": "59394",
			"Philippines": "44",
			"Libya": "10999",
			"Kyrgyzstan": "30473",
			"Br. Indian Ocean Terr.": "167737",
			"Guatemala": "303800",
			"Aruba": "968",
			"Turkey": "1895430",
			"San Marino": "119530",
			"Rep. of Korea": "146040",
			"Serbia": "26239",
			"Burundi": "112539",
			"Bhutan": "155",
			"Canada": "55337",
			"Iceland": "3621403"
		}
	},
	"Turks and Caicos Isds": {
		"imports": {},
		"exports": {}
	},
	"Br. Indian Ocean Terr.": {
		"imports": {},
		"exports": {}
	},
	"Guatemala": {
		"imports": {},
		"exports": {}
	},
	"Lao People's Dem. Rep.": {
		"imports": {},
		"exports": {}
	},
	"Turkey": {
		"imports": {
			"Lebanon": "139551",
			"Gibraltar": "7574",
			"Ghana": "230393",
			"Lesotho": "284",
			"Qatar": "36952",
			"Dem. Rep. of the Congo": "1553153",
			"Dem. People's Rep. of Korea": "19849",
			"Cameroon": "137",
			"South Africa": "161789980",
			"Indonesia": "20240992",
			"Colombia": "24534189",
			"Niger": "931",
			"Palau": "361205",
			"Angola": "3715829",
			"Uzbekistan": "394000",
			"Iraq": "2349",
			"Bosnia Herzegovina": "3136801",
			"Pakistan": "2112419",
			"Belgium": "148994009",
			"Azerbaijan": "47174548",
			"Rwanda": "90934",
			"Armenia": "232",
			"Togo": "2323114",
			"Singapore": "1407961",
			"Albania": "1272838",
			"Benin": "680",
			"FS Micronesia": "471",
			"Panama": "3277000",
			"Cuba": "11865361",
			"American Samoa": "3855",
			"Saint Vincent and the Grenadines": "190759",
			"Curaçao": "3246489",
			"Australia": "52078",
			"Kiribati": "756",
			"Jamaica": "33537",
			"Kenya": "217095",
			"Spain": "11023",
			"Tajikistan": "100434",
			"Ireland": "2795456",
			"Botswana": "2438",
			"French Polynesia": "223",
			"Mauritania": "104117",
			"Christmas Isds": "25390",
			"Honduras": "154557",
			"Cambodia": "712454",
			"Holy See (Vatican City State)": "421",
			"United Kingdom": "39135",
			"Jordan": "599",
			"Chile": "3865727",
			"Gambia": "1479",
			"China, Macao SAR": "497",
			"Malaysia": "1461",
			"Swaziland": "174",
			"Portugal": "9255404",
			"Falkland Isds (Malvinas)": "671",
			"Nepal": "20713",
			"China": "29863045",
			"Comoros": "45942",
			"Guinea-Bissau": "1587892",
			"Mali": "250061",
			"Trinidad and Tobago": "28326",
			"Israel": "10109",
			"Burkina Faso": "264779",
			"Paraguay": "685841",
			"Norfolk Isds": "7574",
			"Bangladesh": "4235",
			"Antigua and Barbuda": "164",
			"Gabon": "481",
			"Cyprus": "40647",
			"Yemen": "11369",
			"Mauritius": "218431",
			"Slovakia": "15866",
			"Faeroe Isds": "127638",
			"Turkmenistan": "127106",
			"Bahrain": "19741969",
			"Côte d'Ivoire": "171698142",
			"Guyana": "3980",
			"Saint Pierre and Miquelon": "478",
			"Algeria": "424127296",
			"USA": "18230155",
			"Saint Kitts and Nevis": "2140",
			"Rep. of Moldova": "138460",
			"Zambia": "100",
			"Malta": "5522",
			"Ecuador": "970296",
			"Grenada": "1139",
			"Dominican Rep.": "418130",
			"France": "22762372",
			"New Caledonia": "16006",
			"Niue": "195",
			"Seychelles": "5105033",
			"Br. Virgin Isds": "706",
			"Italy": "10018606",
			"Saint Lucia": "760",
			"State of Palestine": "3281051",
			"Uganda": "63115",
			"Syria": "3339196",
			"Belarus": "1019700",
			"Ethiopia": "538333",
			"Pitcairn": "1065",
			"Senegal": "989683",
			"Bulgaria": "646061153",
			"Montenegro": "445",
			"Sri Lanka": "103849",
			"Hungary": "128379",
			"New Zealand": "29675",
			"N. Mariana Isds": "16888",
			"Lao People's Dem. Rep.": "124882",
			"Myanmar": "8208117",
			"Iran": "36175",
			"Philippines": "1600",
			"Uruguay": "145000",
			"Andorra": "180",
			"Cabo Verde": "2634337",
			"Germany": "14947979",
			"Poland": "556329668",
			"Thailand": "13996220",
			"Argentina": "12019374",
			"Brazil": "5926",
			"Brunei Darussalam": "2744",
			"Mongolia": "200",
			"Saudi Arabia": "2075",
			"Greece": "134026",
			"Russian Federation": "1004682004",
			"Cayman Isds": "62798",
			"United Arab Emirates": "122770",
			"Nicaragua": "1595",
			"Malawi": "2843",
			"Switzerland": "369322",
			"El Salvador": "149059",
			"United States Minor Outlying Islands": "1159",
			"Latvia": "28632624",
			"Japan": "39985389",
			"Guinea": "6199014",
			"Romania": "31314",
			"Slovenia": "772851",
			"Liberia": "231",
			"Guatemala": "1475300",
			"Madagascar": "46615",
			"Bolivia (Plurinational State of)": "17072762",
			"Nigeria": "20781255",
			"Bahamas": "6609",
			"Tunisia": "747",
			"Chad": "1105",
			"Viet Nam": "10676416",
			"Haiti": "123139",
			"Tokelau": "359",
			"Oman": "291365",
			"Sweden": "658142",
			"Maldives": "500517",
			"India": "52644",
			"Mexico": "195272173",
			"Austria": "1777583",
			"Eritrea": "2303464",
			"Congo": "547654",
			"Zimbabwe": "194",
			"Vanuatu": "1884",
			"Fiji": "1501",
			"Lithuania": "86461709",
			"Namibia": "407727",
			"Denmark": "656276",
			"Peru": "259699",
			"Central African Rep.": "261",
			"Netherlands": "2196714",
			"Costa Rica": "118057",
			"Equatorial Guinea": "27256",
			"Sudan": "18620",
			"Papua New Guinea": "60888",
			"Kazakhstan": "20219690",
			"Afghanistan": "69612",
			"Croatia": "2024",
			"Saint Helena": "145",
			"Egypt": "103030",
			"Nauru": "40181",
			"Anguilla": "3507",
			"Estonia": "4701",
			"Morocco": "367515160",
			"Luxembourg": "213412",
			"TFYR of Macedonia": "497661",
			"Somalia": "704855",
			"United Rep. of Tanzania": "43173",
			"Finland": "754527",
			"Belize": "1004",
			"Georgia": "9462924",
			"Ukraine": "12467199",
			"Bermuda": "6842",
			"Djibouti": "617",
			"Greenland": "1071",
			"China, Hong Kong SAR": "10131",
			"Suriname": "2571",
			"Barbados": "1600",
			"Venezuela": "10909",
			"Kuwait": "32428",
			"Norway": "626765",
			"Sierra Leone": "679800",
			"Marshall Isds": "2100",
			"Sao Tome and Principe": "2878",
			"Libya": "1206089",
			"Kyrgyzstan": "2060",
			"Czechia": "649217464",
			"Br. Indian Ocean Terr.": "41945",
			"Mozambique": "17915434",
			"Aruba": "6656",
			"San Marino": "59912",
			"Rep. of Korea": "1170601",
			"Serbia": "70028",
			"Burundi": "282",
			"Bhutan": "195260",
			"Cook Isds": "3439",
			"Canada": "8306278",
			"Iceland": "13655027"
		},
		"exports": {
			"Lebanon": "67611",
			"Gibraltar": "244159",
			"Ghana": "3634",
			"Lesotho": "23670",
			"Qatar": "1596195",
			"Dem. Rep. of the Congo": "4358",
			"Dem. People's Rep. of Korea": "203105",
			"Cameroon": "506624",
			"South Africa": "150",
			"Montserrat": "1234",
			"Indonesia": "18273",
			"Colombia": "199066",
			"Niger": "280986",
			"Palau": "359163",
			"Tonga": "30846",
			"Angola": "1548044",
			"Fr. South Antarctic Terr.": "20305",
			"Uzbekistan": "4367",
			"Iraq": "2979393",
			"Tuvalu": "39185",
			"Guam": "6713",
			"Bosnia Herzegovina": "823405",
			"Pakistan": "7125",
			"Belgium": "21723976",
			"Azerbaijan": "11912702",
			"Armenia": "1122",
			"Togo": "714",
			"Singapore": "154",
			"Albania": "580878",
			"Benin": "574",
			"FS Micronesia": "1220",
			"Panama": "105379",
			"Cuba": "194673",
			"American Samoa": "37700",
			"Saint Vincent and the Grenadines": "21995",
			"Curaçao": "701",
			"Australia": "19911",
			"Kiribati": "19855",
			"Jamaica": "439480",
			"Kenya": "220533",
			"Spain": "2232615",
			"Tajikistan": "114",
			"Ireland": "40102",
			"Botswana": "15060",
			"South Sudan": "60429",
			"French Polynesia": "605102",
			"Mauritania": "121",
			"Bouvet Island": "1015",
			"Honduras": "211727",
			"Holy See (Vatican City State)": "625",
			"United Kingdom": "16168806",
			"Jordan": "92198",
			"Chile": "429978",
			"Gambia": "2747",
			"China, Macao SAR": "124",
			"Brunei Darussalam": "46084",
			"Malaysia": "3050",
			"Swaziland": "34248",
			"Portugal": "132425976",
			"Nepal": "2213263",
			"China": "1923174",
			"Comoros": "173",
			"Guinea-Bissau": "25749",
			"Mali": "44100",
			"Trinidad and Tobago": "3203628",
			"Israel": "360769",
			"Burkina Faso": "11900",
			"Paraguay": "470358",
			"Bangladesh": "617218",
			"Antigua and Barbuda": "2657188",
			"Gabon": "11345",
			"Cyprus": "7118",
			"Yemen": "82924457",
			"Mauritius": "445106",
			"Slovakia": "11100707",
			"Faeroe Isds": "1504",
			"Turkmenistan": "145005",
			"Bahrain": "1357281",
			"Côte d'Ivoire": "970574",
			"Guyana": "330000",
			"Saint Pierre and Miquelon": "6662",
			"Algeria": "16967193",
			"USA": "25650544",
			"Saint Kitts and Nevis": "1230000",
			"Rep. of Moldova": "87615",
			"Zambia": "2496",
			"Malta": "4363071",
			"Ecuador": "120",
			"Grenada": "1833",
			"Dominican Rep.": "487387",
			"France": "10123466",
			"New Caledonia": "1078175",
			"Seychelles": "1506",
			"Br. Virgin Isds": "10191919",
			"Italy": "5670504",
			"Saint Lucia": "35822",
			"State of Palestine": "790",
			"Rwanda": "3017",
			"Syria": "200522",
			"Belarus": "135286",
			"Ethiopia": "6709",
			"Namibia": "55840",
			"Congo": "221726",
			"Senegal": "8590",
			"Bulgaria": "9654648",
			"Montenegro": "2209482",
			"Sri Lanka": "97527",
			"Hungary": "13315",
			"New Zealand": "2427747",
			"N. Mariana Isds": "262",
			"Lao People's Dem. Rep.": "172061",
			"Myanmar": "64584",
			"Iran": "162846",
			"Philippines": "297859",
			"Uruguay": "851495",
			"Andorra": "130094",
			"Cabo Verde": "271015",
			"Germany": "1919453",
			"Timor-Leste": "51475",
			"Poland": "268425661",
			"Thailand": "758429",
			"Argentina": "129557",
			"Brazil": "87779",
			"Dominica": "55108",
			"Mongolia": "122044",
			"Saudi Arabia": "18432",
			"Greece": "2120671",
			"Russian Federation": "122355",
			"Cayman Isds": "16658679",
			"United Arab Emirates": "2179984",
			"Nicaragua": "149604",
			"Malawi": "94000",
			"Switzerland": "740793",
			"El Salvador": "2298",
			"United States Minor Outlying Islands": "5103",
			"Latvia": "284",
			"Japan": "611376",
			"Guinea": "940",
			"Uganda": "296787",
			"Romania": "186676",
			"Slovenia": "455761712",
			"Liberia": "23977",
			"Guatemala": "8469",
			"Madagascar": "271826",
			"Bolivia (Plurinational State of)": "39925",
			"Barbados": "206265",
			"Bahamas": "3186531",
			"San Marino": "4656",
			"Chad": "173272",
			"Viet Nam": "9843033",
			"Haiti": "201",
			"Oman": "761143",
			"Sweden": "3688262",
			"Maldives": "249608",
			"India": "4052",
			"Mexico": "57298951",
			"Austria": "1211583",
			"Eritrea": "874",
			"Zimbabwe": "1351",
			"Vanuatu": "28704",
			"Fiji": "246",
			"Lithuania": "54196",
			"Cambodia": "217444",
			"Denmark": "387387",
			"Peru": "7486",
			"Central African Rep.": "157",
			"Netherlands": "211910562",
			"Costa Rica": "2071293",
			"Equatorial Guinea": "223",
			"Sudan": "27007",
			"Papua New Guinea": "12626",
			"Kazakhstan": "30876",
			"Afghanistan": "1004748",
			"Croatia": "32922418",
			"Egypt": "176772",
			"Anguilla": "2772",
			"Estonia": "28404111",
			"Morocco": "114497373",
			"Luxembourg": "27516468",
			"TFYR of Macedonia": "28706",
			"Somalia": "43778",
			"United Rep. of Tanzania": "10989",
			"Finland": "4814374",
			"Belize": "2133561",
			"Georgia": "597234",
			"Ukraine": "66886",
			"Bermuda": "273329",
			"Djibouti": "603743",
			"Greenland": "51131197",
			"China, Hong Kong SAR": "7400030",
			"Suriname": "419789",
			"Nigeria": "6621",
			"Samoa": "36419",
			"Venezuela": "870000",
			"Kuwait": "57685",
			"Norway": "31946555",
			"Sierra Leone": "158022",
			"Marshall Isds": "12180615",
			"Sao Tome and Principe": "455243",
			"Libya": "41292",
			"Kyrgyzstan": "986",
			"Czechia": "68902633",
			"Br. Indian Ocean Terr.": "529326",
			"Mozambique": "109291",
			"Aruba": "339039",
			"Tunisia": "10500",
			"Rep. of Korea": "259025",
			"Serbia": "224456",
			"Burundi": "168",
			"Bhutan": "97540",
			"Cook Isds": "2480902",
			"Canada": "5243686",
			"Iceland": "4376"
		}
	},
	"San Marino": {
		"imports": {},
		"exports": {}
	},
	"Rep. of Korea": {
		"imports": {
			"Lebanon": "43302",
			"Bonaire": "2709",
			"Gibraltar": "4396",
			"Ghana": "919690",
			"Lesotho": "33",
			"Qatar": "91692875",
			"Dem. Rep. of the Congo": "7000",
			"Cameroon": "25600",
			"South Africa": "70760",
			"Montserrat": "10496",
			"Indonesia": "1261",
			"Colombia": "2286911",
			"Niger": "457",
			"Palau": "9989",
			"Tonga": "104091",
			"Angola": "271900",
			"Fr. South Antarctic Terr.": "239",
			"Uzbekistan": "11085",
			"Iraq": "25394",
			"Tuvalu": "142",
			"Guam": "370",
			"Bosnia Herzegovina": "30331",
			"Pakistan": "16365378",
			"Belgium": "28975284",
			"Azerbaijan": "337",
			"Pitcairn": "2750",
			"Rwanda": "5840",
			"Armenia": "1857",
			"United Kingdom": "11782891",
			"Singapore": "21389",
			"Albania": "2915464",
			"Benin": "52310",
			"FS Micronesia": "464372",
			"Panama": "9680",
			"Cuba": "8255",
			"American Samoa": "3044155",
			"Saint Vincent and the Grenadines": "376725",
			"Curaçao": "5533",
			"Australia": "753022563",
			"Kiribati": "1233954",
			"Mexico": "4567917",
			"Br. Virgin Isds": "5",
			"Spain": "2311249",
			"Tajikistan": "16",
			"Ireland": "535569",
			"Botswana": "384",
			"South Sudan": "2260",
			"French Polynesia": "196032",
			"Mauritania": "6814615",
			"Christmas Isds": "879",
			"Honduras": "1466",
			"Saint Barthélemy": "507",
			"Holy See (Vatican City State)": "14172",
			"Chile": "10816563",
			"Gambia": "1872365",
			"Liberia": "800",
			"Mali": "14",
			"Dominica": "10355",
			"Malaysia": "82054",
			"Swaziland": "40281",
			"Portugal": "397422",
			"Falkland Isds (Malvinas)": "1447047",
			"Nepal": "58333",
			"China": "112434237",
			"Comoros": "2146",
			"Guinea-Bissau": "1435067",
			"Djibouti": "538864",
			"Trinidad and Tobago": "18482",
			"Israel": "162631",
			"Burkina Faso": "2272807",
			"Paraguay": "151727",
			"Bangladesh": "384",
			"Antigua and Barbuda": "3361566",
			"Gabon": "14",
			"Cyprus": "541508",
			"Yemen": "361",
			"Mauritius": "205491",
			"Slovakia": "86785",
			"Faeroe Isds": "954672",
			"Turkmenistan": "53523",
			"Bahrain": "62717",
			"Côte d'Ivoire": "12429",
			"Guyana": "104429",
			"Saint Pierre and Miquelon": "114",
			"Algeria": "897",
			"USA": "62289360",
			"Namibia": "3963",
			"Rep. of Moldova": "175000",
			"Zambia": "34",
			"Malta": "2337",
			"Ecuador": "44000",
			"Grenada": "4694",
			"Dominican Rep.": "2",
			"France": "721148175",
			"New Caledonia": "78",
			"Niue": "160429",
			"Seychelles": "5097947",
			"Italy": "34891313",
			"Saint Lucia": "1182",
			"State of Palestine": "415999",
			"Uganda": "915",
			"Syria": "366",
			"Belarus": "98",
			"Ethiopia": "29",
			"Slovenia": "1469629",
			"Congo": "163473",
			"Senegal": "2000",
			"Bulgaria": "199520",
			"Montenegro": "1103",
			"Sri Lanka": "5492129",
			"Hungary": "21924",
			"Jordan": "2496",
			"N. Mariana Isds": "63",
			"Lao People's Dem. Rep.": "251325",
			"Myanmar": "88395",
			"Iran": "24793",
			"Sao Tome and Principe": "3841",
			"Uruguay": "12656003",
			"Switzerland": "151793",
			"Cabo Verde": "374",
			"Germany": "413384403",
			"Timor-Leste": "511",
			"Poland": "852910",
			"Thailand": "12761472",
			"Argentina": "113490081",
			"Brazil": "10708930",
			"Brunei Darussalam": "2",
			"Mongolia": "134552",
			"Saudi Arabia": "3298",
			"Greece": "62444",
			"Russian Federation": "149324",
			"Cayman Isds": "17",
			"United Arab Emirates": "2242",
			"Nicaragua": "7654",
			"Malawi": "463731",
			"Andorra": "87",
			"El Salvador": "3912481",
			"United States Minor Outlying Islands": "425",
			"Latvia": "656",
			"Japan": "376531261",
			"Guinea": "23713593",
			"Romania": "19",
			"Croatia": "685",
			"China, Macao SAR": "38",
			"Guatemala": "28678",
			"Madagascar": "277625",
			"Bolivia (Plurinational State of)": "21",
			"Barbados": "17",
			"Saint Kitts and Nevis": "11623",
			"Bahamas": "3059",
			"Tunisia": "2771281",
			"Chad": "19777136",
			"Viet Nam": "18393463",
			"Haiti": "109",
			"Tokelau": "8383",
			"South Georgia and the South Sandwich Islands": "667",
			"Oman": "7500",
			"Sweden": "170275",
			"Maldives": "248071",
			"India": "2204370",
			"Jamaica": "75699",
			"Austria": "2124098",
			"Eritrea": "6764341",
			"Zimbabwe": "8730",
			"Vanuatu": "8600000",
			"Fiji": "1539632",
			"Lithuania": "3426",
			"Cambodia": "63208",
			"Denmark": "780190",
			"Peru": "43827261",
			"Central African Rep.": "987078",
			"Netherlands": "203894",
			"Costa Rica": "28",
			"Equatorial Guinea": "45656436",
			"Sudan": "3997",
			"Papua New Guinea": "46609582",
			"Kazakhstan": "7062",
			"Kenya": "109",
			"Afghanistan": "185",
			"Saint Helena": "7",
			"Egypt": "145588",
			"Nauru": "52",
			"Anguilla": "101",
			"Estonia": "42727",
			"Morocco": "130065",
			"Antarctica": "91",
			"TFYR of Macedonia": "44217",
			"Somalia": "91943",
			"Heard Island and McDonald Islands": "2564",
			"United Rep. of Tanzania": "396050",
			"Finland": "2449269",
			"Belize": "36",
			"Georgia": "150556",
			"Ukraine": "122483",
			"Bermuda": "34",
			"Luxembourg": "1508",
			"Greenland": "15916",
			"China, Hong Kong SAR": "18672257",
			"Suriname": "172989",
			"Nigeria": "308097209",
			"Samoa": "669992",
			"Venezuela": "10001528",
			"Kuwait": "226303014",
			"New Zealand": "307289",
			"Norway": "108621",
			"Sierra Leone": "13102813",
			"Marshall Isds": "132477206",
			"Philippines": "9294",
			"Libya": "4483183",
			"Kyrgyzstan": "137249",
			"Czechia": "968325",
			"Br. Indian Ocean Terr.": "316",
			"Mozambique": "1244535",
			"Togo": "31688",
			"Aruba": "798",
			"Turkey": "340219",
			"San Marino": "40574",
			"Serbia": "1107182",
			"Burundi": "310038",
			"Bhutan": "33",
			"Cook Isds": "380",
			"Canada": "115857972",
			"Iceland": "1960"
		},
		"exports": {
			"Lebanon": "6636295",
			"Gibraltar": "15489",
			"Ghana": "23497051",
			"Lesotho": "39331",
			"Cuba": "934506",
			"Dem. Rep. of the Congo": "252634",
			"Cameroon": "2957",
			"Papua New Guinea": "5254152",
			"Montserrat": "15782",
			"Indonesia": "66879300",
			"Colombia": "88",
			"Niger": "23929",
			"Palau": "385",
			"Tonga": "120",
			"Angola": "2232032",
			"Uzbekistan": "81494",
			"Iraq": "81258339",
			"Tuvalu": "135647",
			"Guam": "731821",
			"Bosnia Herzegovina": "38486",
			"Pakistan": "13534",
			"Belgium": "159409",
			"Azerbaijan": "17627",
			"Australia": "6695792",
			"Togo": "11838",
			"Singapore": "95306",
			"Albania": "90732",
			"Benin": "1366317",
			"South Africa": "70831",
			"FS Micronesia": "21940",
			"Panama": "1126723896",
			"Qatar": "9935401",
			"American Samoa": "7918345",
			"Saint Vincent and the Grenadines": "51090",
			"Djibouti": "10203502",
			"Curaçao": "558448",
			"Armenia": "3715978",
			"Kiribati": "90362",
			"Jamaica": "1407385",
			"Kenya": "7482368",
			"Spain": "2877819",
			"Tajikistan": "25704",
			"Br. Virgin Isds": "17522168",
			"Botswana": "21222",
			"South Sudan": "3688",
			"French Polynesia": "1538944",
			"Mauritania": "205897",
			"Eritrea": "49890",
			"Honduras": "14921068",
			"Saint Barthélemy": "16541",
			"United Kingdom": "1964048",
			"Ireland": "121923",
			"Chile": "300568",
			"Gambia": "23388",
			"China, Macao SAR": "358392",
			"Dominica": "1382898",
			"Malaysia": "220601",
			"Fiji": "3005032",
			"Portugal": "422335",
			"Falkland Isds (Malvinas)": "167",
			"Nepal": "6679",
			"China": "17409363",
			"Comoros": "10017",
			"Guinea-Bissau": "361",
			"Mali": "432",
			"Trinidad and Tobago": "8518677",
			"Israel": "2357490",
			"Burkina Faso": "300",
			"Paraguay": "8956364",
			"Norfolk Isds": "4500",
			"Bangladesh": "74675",
			"Antigua and Barbuda": "78376",
			"Gabon": "3968953",
			"Cyprus": "760050450",
			"Yemen": "8660202",
			"Mauritius": "1575",
			"Slovakia": "61853",
			"Faeroe Isds": "6418",
			"Turkmenistan": "540",
			"Bahrain": "53409",
			"Côte d'Ivoire": "6765974",
			"Guyana": "184817",
			"Algeria": "96368",
			"USA": "5822241",
			"Saint Kitts and Nevis": "12057151",
			"Rep. of Moldova": "74637",
			"Zambia": "404",
			"Malta": "177063",
			"Ecuador": "1523925",
			"Grenada": "129901",
			"Dominican Rep.": "25267153",
			"France": "251493458",
			"New Caledonia": "25228",
			"Seychelles": "1995027",
			"Italy": "1075668",
			"Saint Lucia": "258356",
			"State of Palestine": "8311906",
			"Rwanda": "25",
			"Syria": "27229332",
			"Belarus": "395700",
			"Ethiopia": "3787470",
			"Namibia": "5990",
			"Congo": "342",
			"Senegal": "14448",
			"Bulgaria": "3329",
			"Montenegro": "59196",
			"Sri Lanka": "2065117",
			"Hungary": "42674",
			"Jordan": "101862837",
			"N. Mariana Isds": "13558",
			"Lao People's Dem. Rep.": "35007001",
			"Myanmar": "113320",
			"Iran": "2835147",
			"Philippines": "333783",
			"Uruguay": "8901312",
			"Switzerland": "44417",
			"Cabo Verde": "100",
			"Germany": "210930066",
			"Timor-Leste": "36697",
			"Poland": "284382",
			"Thailand": "1056473",
			"Argentina": "8174",
			"Brazil": "533589",
			"Brunei Darussalam": "3278",
			"Mongolia": "14978",
			"Saudi Arabia": "206157452",
			"Sudan": "6219",
			"Russian Federation": "26978",
			"Cayman Isds": "134550",
			"United Arab Emirates": "66866",
			"Nicaragua": "150",
			"Malawi": "45",
			"Andorra": "3838",
			"El Salvador": "16037830",
			"Latvia": "38078",
			"Japan": "64759500",
			"Guinea": "953299",
			"Uganda": "65405",
			"Romania": "7349",
			"Croatia": "228408",
			"Liberia": "1982",
			"Guatemala": "27298145",
			"Madagascar": "11063",
			"Bolivia (Plurinational State of)": "1545",
			"Barbados": "76839",
			"Bahamas": "1000",
			"Tunisia": "9310795",
			"Chad": "50419",
			"Viet Nam": "893549",
			"Haiti": "626424",
			"Tokelau": "500",
			"South Georgia and the South Sandwich Islands": "340731",
			"Slovenia": "16310",
			"Oman": "8400",
			"Sweden": "95",
			"Maldives": "73432",
			"India": "2418798",
			"Mexico": "1110",
			"Austria": "30149",
			"Bouvet Island": "113362",
			"Zimbabwe": "464402",
			"Vanuatu": "2500",
			"Swaziland": "156116",
			"Lithuania": "859187",
			"Cambodia": "188577",
			"Denmark": "136704",
			"Peru": "70278973",
			"Central African Rep.": "112261",
			"Netherlands": "7403",
			"Costa Rica": "19058281",
			"Equatorial Guinea": "143560",
			"Greece": "2414655701",
			"Kazakhstan": "8231351",
			"Afghanistan": "14317130",
			"Saint Helena": "1094",
			"Egypt": "2166",
			"Nauru": "124",
			"Anguilla": "301",
			"Estonia": "1505709",
			"Morocco": "56880",
			"Luxembourg": "48",
			"TFYR of Macedonia": "43159",
			"Somalia": "5700",
			"Western Sahara": "7950",
			"United Rep. of Tanzania": "52567",
			"Finland": "30196",
			"Belize": "3167521",
			"Georgia": "600373",
			"Ukraine": "563843",
			"Bermuda": "3426",
			"Antarctica": "46",
			"Greenland": "309",
			"China, Hong Kong SAR": "1901937396",
			"Suriname": "131670",
			"Nigeria": "1378873",
			"Samoa": "112472",
			"Venezuela": "910",
			"Kuwait": "179729013",
			"New Zealand": "166207",
			"Norway": "119263",
			"Sierra Leone": "1000",
			"Marshall Isds": "6549864296",
			"Sao Tome and Principe": "705",
			"Libya": "21024",
			"Kyrgyzstan": "4747727",
			"Czechia": "198188",
			"Mozambique": "55530",
			"Aruba": "2403388",
			"Turkey": "1395504",
			"San Marino": "29900",
			"Serbia": "6068",
			"Burundi": "222128",
			"Bhutan": "1814",
			"Cook Isds": "24673",
			"Canada": "2250277",
			"Iceland": "330000"
		}
	},
	"Serbia": {
		"imports": {
			"Lebanon": "803",
			"Ghana": "190",
			"Lesotho": "15568",
			"Cuba": "19930",
			"Dem. Rep. of the Congo": "19",
			"Dem. People's Rep. of Korea": "2409",
			"Cameroon": "102",
			"South Africa": "64377",
			"Montserrat": "149",
			"Panama": "38637",
			"Colombia": "19225",
			"Niger": "6353",
			"Jordan": "11104",
			"Uzbekistan": "12802",
			"Iraq": "271",
			"Tuvalu": "183",
			"Guam": "365",
			"Bosnia Herzegovina": "33898297",
			"Pakistan": "504072",
			"Belgium": "8614863",
			"Azerbaijan": "151",
			"Armenia": "5315",
			"United Kingdom": "886252",
			"Singapore": "3804",
			"Albania": "322426",
			"Benin": "200",
			"FS Micronesia": "62",
			"Indonesia": "676090",
			"Qatar": "388",
			"Australia": "57366",
			"Kiribati": "940",
			"Mexico": "665293",
			"Br. Virgin Isds": "39776",
			"Spain": "32760017",
			"Tajikistan": "372",
			"Ireland": "10756471",
			"Botswana": "209",
			"Mauritania": "2705",
			"Christmas Isds": "313",
			"Honduras": "53221",
			"Saint Barthélemy": "58",
			"Holy See (Vatican City State)": "559",
			"Chile": "310276",
			"Gambia": "103",
			"Liberia": "1105",
			"Dominica": "1003",
			"Malaysia": "24618",
			"Fiji": "4847",
			"Peru": "275438",
			"Falkland Isds (Malvinas)": "91759",
			"Nepal": "2819",
			"China": "2994283",
			"Comoros": "261",
			"Mali": "2987",
			"Trinidad and Tobago": "5083",
			"Israel": "257030",
			"Burkina Faso": "3385",
			"Bangladesh": "14254425",
			"Antigua and Barbuda": "66",
			"Gabon": "186146",
			"Cyprus": "686493",
			"Yemen": "3106",
			"Mauritius": "99211",
			"Slovakia": "2670847",
			"Turkmenistan": "33056",
			"Bahrain": "4",
			"Côte d'Ivoire": "34009",
			"Guyana": "922",
			"Algeria": "49686",
			"USA": "1221005",
			"Saint Kitts and Nevis": "23",
			"Rep. of Moldova": "281462",
			"Zambia": "736",
			"Malta": "4104108",
			"Ecuador": "199688",
			"Grenada": "1040",
			"Dominican Rep.": "23035",
			"France": "60474552",
			"New Caledonia": "80",
			"Niue": "25",
			"Seychelles": "8679",
			"Italy": "12883035",
			"Rwanda": "66604",
			"Syria": "2178",
			"Belarus": "933127",
			"Ethiopia": "239",
			"Namibia": "44278",
			"Sierra Leone": "419",
			"Slovenia": "15228491",
			"Bulgaria": "15689544",
			"Montenegro": "15896055",
			"Sri Lanka": "21391",
			"Hungary": "2902940",
			"New Zealand": "67525",
			"N. Mariana Isds": "25",
			"Lao People's Dem. Rep.": "1472",
			"Myanmar": "6913",
			"Iran": "1164750",
			"Sao Tome and Principe": "449",
			"Uruguay": "13739",
			"Andorra": "132",
			"Cabo Verde": "68",
			"Germany": "25210463",
			"Timor-Leste": "1647",
			"Poland": "44924922",
			"Thailand": "7314813",
			"Argentina": "3342153",
			"Brazil": "9922661",
			"Brunei Darussalam": "27",
			"Mongolia": "44",
			"Saudi Arabia": "511210",
			"Sudan": "47",
			"Russian Federation": "9784437",
			"United Arab Emirates": "489506",
			"Nicaragua": "46549",
			"Malawi": "1569",
			"Switzerland": "1045379",
			"El Salvador": "2",
			"Latvia": "45196",
			"Japan": "9497",
			"Guinea": "237",
			"Uganda": "36399",
			"Romania": "22090861",
			"Croatia": "45889154",
			"China, Macao SAR": "3954",
			"Guatemala": "14042",
			"Madagascar": "57463",
			"Bolivia (Plurinational State of)": "189",
			"Barbados": "4249",
			"Bahamas": "681",
			"San Marino": "32750",
			"Chad": "1053",
			"Viet Nam": "3810380",
			"Haiti": "86741",
			"Tokelau": "7",
			"Oman": "650",
			"Sweden": "3783287",
			"Maldives": "3053",
			"India": "705725",
			"Jamaica": "4245",
			"Austria": "25602304",
			"Eritrea": "398",
			"Congo": "65613",
			"Zimbabwe": "135748",
			"Saint Maarten": "2",
			"Senegal": "2781",
			"Swaziland": "25994",
			"Lithuania": "78618",
			"Cambodia": "1467929",
			"Denmark": "1747746",
			"Portugal": "497742",
			"Central African Rep.": "44495",
			"Netherlands": "17872796",
			"Costa Rica": "70861",
			"Greece": "18989974",
			"Papua New Guinea": "5762",
			"Kazakhstan": "31700",
			"Kenya": "44381",
			"Afghanistan": "29",
			"Saint Helena": "207",
			"Egypt": "30042",
			"Nauru": "528",
			"Estonia": "340537",
			"Morocco": "611953",
			"Antarctica": "9650",
			"TFYR of Macedonia": "45681445",
			"Somalia": "347",
			"United Rep. of Tanzania": "2077",
			"Finland": "14845967",
			"Belize": "9355",
			"Georgia": "671703",
			"Ukraine": "61923",
			"Bermuda": "7825",
			"Luxembourg": "1867010",
			"China, Hong Kong SAR": "1035648",
			"Suriname": "36158",
			"Nigeria": "815559",
			"Samoa": "107",
			"Venezuela": "4786",
			"Kuwait": "429",
			"Norway": "3590170",
			"Pitcairn": "3021",
			"Marshall Isds": "13190",
			"Philippines": "358989",
			"Libya": "100",
			"Kyrgyzstan": "3189174",
			"Czechia": "7583707",
			"Mozambique": "78127",
			"Togo": "8126",
			"Aruba": "700",
			"Turkey": "7369544",
			"Tunisia": "389284",
			"Rep. of Korea": "15",
			"Burundi": "442",
			"Cook Isds": "34",
			"Canada": "1728188",
			"Iceland": "1144303"
		},
		"exports": {
			"Lebanon": "1562076",
			"Gibraltar": "61",
			"Malawi": "79434",
			"Ghana": "7689",
			"Sao Tome and Principe": "18132",
			"Uruguay": "730",
			"Switzerland": "5180193",
			"Peru": "5298",
			"Germany": "81796231",
			"Poland": "6476652",
			"Cuba": "96742",
			"Dem. Rep. of the Congo": "614",
			"Thailand": "124549",
			"Argentina": "21877",
			"Brazil": "1574",
			"Azerbaijan": "65522",
			"Cameroon": "65",
			"Iran": "152854",
			"Mongolia": "20089",
			"Belarus": "2298822",
			"Indonesia": "584174",
			"Colombia": "8125",
			"Sudan": "65790",
			"Russian Federation": "45239780",
			"Cayman Isds": "1310",
			"United Arab Emirates": "223931",
			"Nicaragua": "99",
			"Tajikistan": "11596",
			"Angola": "214431",
			"Fr. South Antarctic Terr.": "35994",
			"Andorra": "5167",
			"Mauritius": "31463",
			"Ukraine": "2731392",
			"Iraq": "32061",
			"Japan": "1529270",
			"Tunisia": "19454439",
			"Latvia": "54114",
			"Uganda": "6987",
			"Bosnia Herzegovina": "215086824",
			"Pakistan": "36391",
			"Belgium": "822178",
			"Croatia": "70287952",
			"Liberia": "130535",
			"Italy": "23694200",
			"Australia": "2952748",
			"Turkmenistan": "69517",
			"United Kingdom": "8000794",
			"Bolivia (Plurinational State of)": "288",
			"Nigeria": "35929",
			"Albania": "11041272",
			"Benin": "11599",
			"Maldives": "5541",
			"Bahamas": "35921",
			"San Marino": "25",
			"Mozambique": "155",
			"Viet Nam": "727306",
			"Haiti": "24722",
			"South Africa": "37",
			"Guinea": "11542",
			"Panama": "662",
			"Qatar": "34122",
			"Oman": "388",
			"Uzbekistan": "190526",
			"Sweden": "3332774",
			"Armenia": "154764",
			"India": "1454",
			"Jamaica": "42018",
			"Mexico": "665048",
			"Br. Virgin Isds": "764",
			"Austria": "16182154",
			"Romania": "26328762",
			"Ireland": "81028",
			"Botswana": "3316",
			"Zimbabwe": "4223",
			"Côte d'Ivoire": "402",
			"French Polynesia": "425653",
			"Mauritania": "15071459",
			"Swaziland": "559",
			"Lithuania": "243054",
			"Namibia": "5",
			"Denmark": "3330602",
			"Curaçao": "6365",
			"Central African Rep.": "1605",
			"United Rep. of Tanzania": "1623",
			"Netherlands": "15403950",
			"Turkey": "695717",
			"Costa Rica": "2840",
			"Papua New Guinea": "301",
			"Equatorial Guinea": "2410434",
			"China, Macao SAR": "11998",
			"Greece": "3916961",
			"Chile": "71869",
			"Kazakhstan": "28951",
			"Gambia": "57309",
			"Kenya": "64",
			"Nepal": "40121",
			"Afghanistan": "17257655",
			"Malaysia": "136586",
			"Fiji": "91478",
			"Portugal": "335763",
			"Saint Kitts and Nevis": "148",
			"Egypt": "1023072",
			"China": "914624",
			"Comoros": "3348",
			"Estonia": "1060117",
			"Morocco": "173422",
			"Luxembourg": "1058",
			"Trinidad and Tobago": "8612",
			"Israel": "616957",
			"TFYR of Macedonia": "107551911",
			"Somalia": "253505",
			"Saudi Arabia": "110335",
			"Singapore": "31277",
			"Paraguay": "31605",
			"Burkina Faso": "44986",
			"Bangladesh": "17490",
			"Yemen": "132094",
			"Gabon": "37273",
			"Finland": "3693810",
			"Cyprus": "8732856",
			"Belize": "2038725",
			"Georgia": "998847",
			"Slovakia": "9734678",
			"Mali": "61871",
			"Faeroe Isds": "371653",
			"Greenland": "45266",
			"Suriname": "298",
			"Bahrain": "1882",
			"Zambia": "168",
			"China, Hong Kong SAR": "50982548",
			"Niger": "32819",
			"Algeria": "76200",
			"USA": "13595",
			"Cambodia": "41",
			"Rep. of Moldova": "243019",
			"Venezuela": "68546",
			"Kuwait": "10039",
			"Spain": "5122982",
			"Malta": "172200",
			"Norway": "374454",
			"Ecuador": "484966",
			"Sierra Leone": "32524",
			"Dominican Rep.": "312",
			"France": "42881452",
			"New Caledonia": "281",
			"Philippines": "200179",
			"Seychelles": "285075",
			"Libya": "100843",
			"Kyrgyzstan": "9054771",
			"State of Palestine": "124723",
			"Rwanda": "1056",
			"Syria": "7692",
			"Guatemala": "22795",
			"Ethiopia": "405572",
			"Slovenia": "16316792",
			"Togo": "109674",
			"Congo": "12584",
			"Senegal": "26299",
			"Bulgaria": "65535070",
			"Montenegro": "154703047",
			"Sri Lanka": "19089",
			"Rep. of Korea": "898632",
			"Hungary": "9857765",
			"Holy See (Vatican City State)": "5207",
			"Jordan": "9293995",
			"Canada": "2073785",
			"Iceland": "74674",
			"Myanmar": "790",
			"Czechia": "7036246",
			"Madagascar": "929",
			"New Zealand": "17921"
		}
	},
	"Burundi": {
		"imports": {},
		"exports": {}
	},
	"Bhutan": {
		"imports": {},
		"exports": {}
	},
	"Cook Isds": {
		"imports": {},
		"exports": {}
	},
	"Canada": {
		"imports": {
			"Lebanon": "3422",
			"Bonaire": "419",
			"Gibraltar": "416",
			"Ghana": "11149015",
			"Lesotho": "620616",
			"Cuba": "18730",
			"Dem. Rep. of the Congo": "143",
			"Dem. People's Rep. of Korea": "207",
			"Cameroon": "96273",
			"Papua New Guinea": "11945",
			"Montserrat": "3084",
			"Indonesia": "63",
			"Colombia": "507989",
			"Niger": "373",
			"Tonga": "1608",
			"Jordan": "178",
			"Fr. South Antarctic Terr.": "1230",
			"Uzbekistan": "28667",
			"Iraq": "124318",
			"Guam": "84",
			"Bosnia Herzegovina": "391",
			"Pakistan": "361",
			"Belgium": "47251006",
			"Azerbaijan": "166738",
			"Rwanda": "207107",
			"Australia": "31081",
			"Togo": "2660",
			"Singapore": "333666",
			"Albania": "10",
			"Benin": "609",
			"South Africa": "18930",
			"Panama": "2825",
			"Qatar": "1",
			"American Samoa": "2314",
			"Saint Vincent and the Grenadines": "50629",
			"Curaçao": "13",
			"Armenia": "15",
			"Kiribati": "310",
			"Bahrain": "251",
			"Jamaica": "18944209",
			"Kenya": "252751",
			"Spain": "89218396",
			"Tajikistan": "10",
			"Ireland": "315523",
			"Botswana": "10163",
			"South Sudan": "122",
			"French Polynesia": "180",
			"Mauritania": "68059",
			"Christmas Isds": "49",
			"Honduras": "133371",
			"Cambodia": "12791923",
			"United Kingdom": "63220912",
			"Chile": "163",
			"Gambia": "292",
			"Liberia": "9437",
			"Antarctica": "2",
			"Brunei Darussalam": "480632",
			"Malaysia": "684831",
			"Swaziland": "15569",
			"Portugal": "705805",
			"Falkland Isds (Malvinas)": "874004",
			"Nepal": "10307",
			"China": "187005536",
			"Comoros": "7552",
			"Guinea-Bissau": "2280",
			"Saint Maarten": "15396",
			"Mali": "540309",
			"Trinidad and Tobago": "125197",
			"Israel": "70378",
			"Burkina Faso": "1807",
			"Paraguay": "151291",
			"Norfolk Isds": "70",
			"Bangladesh": "387784",
			"Antigua and Barbuda": "988",
			"Gabon": "32408",
			"Cyprus": "15",
			"Yemen": "75745",
			"Mauritius": "94786",
			"Slovakia": "103890",
			"Faeroe Isds": "1340914",
			"Turkmenistan": "1763",
			"Syria": "23170",
			"Côte d'Ivoire": "1204",
			"Guyana": "6033359",
			"Saint Pierre and Miquelon": "10",
			"Algeria": "1376618289",
			"USA": "16613289831",
			"Saint Kitts and Nevis": "191736",
			"Rep. of Moldova": "1188444",
			"Zambia": "8",
			"Malta": "54",
			"Ecuador": "7600",
			"Grenada": "39610",
			"Dominican Rep.": "4029",
			"France": "202205676",
			"New Caledonia": "13484",
			"Niue": "487",
			"Seychelles": "65698",
			"Br. Virgin Isds": "48910",
			"Italy": "25944225",
			"Saint Lucia": "85",
			"Uganda": "4012836",
			"Belarus": "789",
			"Ethiopia": "33094",
			"Slovenia": "125882",
			"Pitcairn": "955",
			"Senegal": "196762",
			"Bulgaria": "38816",
			"Montenegro": "210933",
			"Sri Lanka": "39694",
			"Hungary": "113574",
			"Angola": "560",
			"New Zealand": "421833",
			"Lao People's Dem. Rep.": "8662",
			"Myanmar": "586",
			"Iran": "417",
			"Philippines": "172308",
			"Uruguay": "3316",
			"Andorra": "94",
			"Cabo Verde": "159",
			"Germany": "235861869",
			"Timor-Leste": "2394527",
			"Poland": "901191",
			"Bouvet Island": "237",
			"Thailand": "24093053",
			"Argentina": "711551",
			"Brazil": "52334",
			"Dominica": "19119",
			"Mongolia": "8621",
			"Saudi Arabia": "8168",
			"Greece": "627",
			"Russian Federation": "688950",
			"Cayman Isds": "20932",
			"United Arab Emirates": "31173",
			"Nicaragua": "2822762",
			"Malawi": "31035",
			"Switzerland": "49005932",
			"El Salvador": "39800",
			"United States Minor Outlying Islands": "215",
			"Latvia": "43837",
			"Japan": "169667972",
			"Guinea": "3161",
			"Romania": "63851",
			"Croatia": "38919",
			"China, Macao SAR": "300439",
			"Guatemala": "6898601",
			"Madagascar": "369282",
			"Bolivia (Plurinational State of)": "495",
			"Nigeria": "819868",
			"Bahamas": "6839",
			"Tunisia": "308",
			"Chad": "230",
			"Viet Nam": "3400028",
			"Haiti": "484063",
			"Oman": "252444",
			"Sweden": "141797012",
			"Maldives": "25924",
			"India": "166765",
			"Mexico": "105124271",
			"Austria": "10070716",
			"Eritrea": "8",
			"Congo": "208",
			"Zimbabwe": "146",
			"Vanuatu": "27",
			"Fiji": "67448",
			"Lithuania": "977185",
			"Namibia": "490",
			"Denmark": "11271924",
			"Peru": "5",
			"Central African Rep.": "162",
			"Netherlands": "864723",
			"Costa Rica": "45110",
			"Equatorial Guinea": "40777204",
			"Sudan": "191",
			"Kazakhstan": "2579614",
			"Afghanistan": "33747",
			"Saint Helena": "748582",
			"Egypt": "149717",
			"Nauru": "92733",
			"Anguilla": "82",
			"Estonia": "296904",
			"Morocco": "8114460",
			"Luxembourg": "1416330",
			"TFYR of Macedonia": "1195",
			"Somalia": "293",
			"Heard Island and McDonald Islands": "3263",
			"Western Sahara": "57",
			"United Rep. of Tanzania": "2451915",
			"Finland": "28493731",
			"Belize": "59663",
			"Georgia": "3354",
			"Ukraine": "21733134",
			"Bermuda": "4090",
			"Djibouti": "35030",
			"Greenland": "104250",
			"China, Hong Kong SAR": "1079",
			"Suriname": "2147",
			"Barbados": "11391",
			"Samoa": "3323",
			"Venezuela": "951",
			"Kuwait": "32882",
			"Norway": "593444",
			"Sierra Leone": "17416",
			"Sao Tome and Principe": "4245",
			"Libya": "19",
			"Kyrgyzstan": "181",
			"Czechia": "474306",
			"Br. Indian Ocean Terr.": "450",
			"Mozambique": "92341",
			"Aruba": "685",
			"Turkey": "61681773",
			"Rep. of Korea": "204002",
			"Serbia": "1217",
			"Burundi": "10346",
			"Bhutan": "193",
			"Cook Isds": "8105",
			"Canada": "3691829",
			"Iceland": "127839"
		},
		"exports": {
			"Lebanon": "796408",
			"Bonaire": "37280",
			"Gibraltar": "29429",
			"Ghana": "620174",
			"Lesotho": "29126",
			"Cuba": "1738831",
			"Dem. Rep. of the Congo": "5803",
			"Cameroon": "2731823",
			"Papua New Guinea": "625687",
			"Montserrat": "105",
			"Indonesia": "4366",
			"Colombia": "162668",
			"Niger": "35847",
			"Tonga": "56730",
			"Jordan": "40218",
			"Fr. South Antarctic Terr.": "18965",
			"Uzbekistan": "63940",
			"Iraq": "2748",
			"Guam": "64812",
			"Bosnia Herzegovina": "189106",
			"Pakistan": "1530113",
			"Belgium": "5676625",
			"Azerbaijan": "803363",
			"Rwanda": "72",
			"Australia": "14997665",
			"United Kingdom": "313989948",
			"Singapore": "3024118",
			"Albania": "2003449",
			"Benin": "20836",
			"South Africa": "293484",
			"Panama": "112823",
			"Qatar": "203071",
			"American Samoa": "24630",
			"Saint Vincent and the Grenadines": "1887",
			"Curaçao": "626",
			"Armenia": "168522",
			"Kiribati": "50907",
			"Bahrain": "2631599",
			"Jamaica": "69893",
			"Kenya": "728",
			"Spain": "740383",
			"Tajikistan": "3078719",
			"Ireland": "138064",
			"Botswana": "44712",
			"South Sudan": "33594",
			"French Polynesia": "11171",
			"Mauritania": "3905",
			"Christmas Isds": "10485",
			"Honduras": "159704",
			"Cambodia": "3566161",
			"Chile": "278771",
			"Gambia": "13589",
			"Liberia": "1458",
			"Antarctica": "79",
			"Brunei Darussalam": "5639",
			"Malaysia": "292920",
			"Swaziland": "189",
			"Portugal": "101258",
			"Falkland Isds (Malvinas)": "1744",
			"Nepal": "4754",
			"China": "4052634",
			"Comoros": "10524",
			"Guinea-Bissau": "11035",
			"Saint Maarten": "207107",
			"Mali": "15627",
			"Trinidad and Tobago": "784631",
			"Israel": "118963",
			"Burkina Faso": "635865",
			"Paraguay": "33368",
			"Norfolk Isds": "534",
			"Bangladesh": "79267",
			"Antigua and Barbuda": "56945",
			"Gabon": "13019",
			"Cyprus": "1327",
			"Yemen": "36214",
			"Mauritius": "1517099",
			"Slovakia": "259370",
			"Faeroe Isds": "164222",
			"Turkmenistan": "68948",
			"Syria": "8349",
			"Côte d'Ivoire": "185033",
			"Guyana": "7967",
			"Saint Pierre and Miquelon": "135003",
			"Algeria": "1282592",
			"USA": "6103918975",
			"Saint Kitts and Nevis": "15221",
			"Rep. of Moldova": "3045",
			"Zambia": "204",
			"Malta": "6712",
			"Ecuador": "148996",
			"Grenada": "32530",
			"Dominican Rep.": "534667",
			"France": "94389391",
			"New Caledonia": "1850684",
			"Niue": "1997",
			"Seychelles": "1510",
			"Br. Virgin Isds": "168949",
			"Italy": "1482831",
			"Saint Lucia": "14876",
			"Uganda": "38501",
			"Belarus": "978649",
			"Ethiopia": "35324799",
			"Slovenia": "1041982",
			"Pitcairn": "32731",
			"Senegal": "33611",
			"Bulgaria": "1167197",
			"Montenegro": "24701",
			"Sri Lanka": "39105",
			"Hungary": "58361",
			"Angola": "624582",
			"New Zealand": "4584555",
			"Lao People's Dem. Rep.": "84209",
			"Myanmar": "888653",
			"Iran": "87735",
			"Sao Tome and Principe": "1341",
			"Uruguay": "61185",
			"Andorra": "2152",
			"Cabo Verde": "37255",
			"Germany": "146861282",
			"Timor-Leste": "1736",
			"Poland": "1116439",
			"Bouvet Island": "10606",
			"Thailand": "2691090",
			"Argentina": "313207",
			"Brazil": "162728",
			"Dominica": "63280",
			"Mongolia": "755",
			"Saudi Arabia": "6750093",
			"Greece": "23",
			"Russian Federation": "1565336",
			"Cayman Isds": "257313",
			"United Arab Emirates": "327290046",
			"Nicaragua": "11663",
			"Malawi": "82",
			"Switzerland": "3347773",
			"El Salvador": "12046",
			"United States Minor Outlying Islands": "61856",
			"Latvia": "12015",
			"Japan": "11068299",
			"Guinea": "688",
			"Romania": "202182",
			"Croatia": "3020",
			"China, Macao SAR": "243901",
			"Guatemala": "187744",
			"Madagascar": "77483",
			"Bolivia (Plurinational State of)": "127435",
			"Nigeria": "24242",
			"Bahamas": "925241",
			"Tunisia": "32387300",
			"Chad": "32687",
			"Viet Nam": "100153",
			"Haiti": "478366",
			"Oman": "73565",
			"Sweden": "7841734",
			"Maldives": "3001151",
			"India": "62770",
			"Mexico": "1434850",
			"Austria": "571724",
			"Eritrea": "151",
			"Congo": "21006",
			"Zimbabwe": "339",
			"Vanuatu": "124311",
			"Fiji": "51335",
			"Lithuania": "18507",
			"Namibia": "8606",
			"Denmark": "11821522",
			"Peru": "3992",
			"Central African Rep.": "13458",
			"Netherlands": "1058216",
			"Costa Rica": "357593",
			"Equatorial Guinea": "368771",
			"Sudan": "6417",
			"Kazakhstan": "154800",
			"Afghanistan": "28913",
			"Saint Helena": "4001",
			"Egypt": "57756",
			"Anguilla": "302",
			"Estonia": "179737",
			"Morocco": "121720",
			"Luxembourg": "23606",
			"TFYR of Macedonia": "55718",
			"Somalia": "11701",
			"Heard Island and McDonald Islands": "1963",
			"Western Sahara": "1739",
			"United Rep. of Tanzania": "23106472",
			"Finland": "118659963",
			"Belize": "25350",
			"Georgia": "536",
			"Ukraine": "16724106",
			"Bermuda": "2265",
			"Djibouti": "106029",
			"Greenland": "2415",
			"China, Hong Kong SAR": "830060",
			"Suriname": "5321",
			"Barbados": "76648",
			"Samoa": "22698",
			"Venezuela": "5216863",
			"Kuwait": "309848",
			"Norway": "655906",
			"Sierra Leone": "11004",
			"Philippines": "55209",
			"Libya": "5499",
			"Kyrgyzstan": "12509",
			"Czechia": "29969439",
			"Br. Indian Ocean Terr.": "234761",
			"Mozambique": "6039",
			"Togo": "1690593",
			"Aruba": "5058",
			"Turkey": "968469",
			"Rep. of Korea": "3133455",
			"Serbia": "88956",
			"Burundi": "161462",
			"Bhutan": "7502",
			"Cook Isds": "335863",
			"Iceland": "98"
		}
	},
	"Iceland": {
		"imports": {
			"Lebanon": "13582",
			"Ghana": "3322",
			"Uruguay": "1152",
			"Andorra": "963",
			"Comoros": "42",
			"Australia": "397",
			"Togo": "15334",
			"Barbados": "4154",
			"Poland": "7068160",
			"Qatar": "30275724",
			"Bolivia (Plurinational State of)": "52346",
			"Thailand": "4897628",
			"Argentina": "1002939",
			"Brazil": "403",
			"Germany": "12396",
			"Cameroon": "31677",
			"Gabon": "430",
			"Papua New Guinea": "8794",
			"Mongolia": "23807",
			"Montserrat": "7",
			"Panama": "2616",
			"Colombia": "357297",
			"Sudan": "259343",
			"Russian Federation": "754269",
			"United Arab Emirates": "1352",
			"Nicaragua": "23",
			"Libya": "58",
			"Azerbaijan": "19",
			"Malawi": "9570",
			"Switzerland": "6333755",
			"El Salvador": "23531",
			"Paraguay": "3726",
			"Slovakia": "544927",
			"Latvia": "28869",
			"Japan": "1043582",
			"Tunisia": "399",
			"Guinea": "163",
			"Uganda": "11378",
			"Romania": "563240",
			"Pakistan": "30282",
			"Belgium": "81134",
			"Slovenia": "575789",
			"Liberia": "958",
			"Mozambique": "1008",
			"Madagascar": "3364",
			"Singapore": "99791",
			"Nigeria": "829",
			"Uzbekistan": "33079",
			"Bahamas": "19",
			"San Marino": "4790",
			"Viet Nam": "822403",
			"Haiti": "46",
			"South Africa": "15250",
			"Turkmenistan": "825",
			"South Georgia and the South Sandwich Islands": "101",
			"Indonesia": "381",
			"Cuba": "69042",
			"American Samoa": "3786",
			"Oman": "2947",
			"Jordan": "29",
			"Sweden": "14525890",
			"Maldives": "50928",
			"Kiribati": "681",
			"India": "605100",
			"Mexico": "37593",
			"Jamaica": "5154",
			"Kenya": "20245",
			"Spain": "2811112",
			"Bosnia Herzegovina": "5846",
			"Ireland": "26368",
			"Botswana": "128",
			"Zimbabwe": "3859",
			"Côte d'Ivoire": "9249",
			"French Polynesia": "4778",
			"Mauritania": "183",
			"Fiji": "7354",
			"Lithuania": "80963",
			"Namibia": "766",
			"Denmark": "62931",
			"Portugal": "168952",
			"Honduras": "2783",
			"Netherlands": "48399628",
			"United Kingdom": "2038951",
			"Costa Rica": "112363",
			"Austria": "938369",
			"Bulgaria": "171735",
			"Greece": "838851",
			"Chile": "2290300",
			"Kazakhstan": "12005",
			"China, Macao SAR": "623",
			"Afghanistan": "4775",
			"Croatia": "647",
			"Malaysia": "11561529",
			"Swaziland": "5985",
			"Peru": "63026",
			"Falkland Isds (Malvinas)": "20079",
			"Nepal": "450",
			"China": "229",
			"Egypt": "9755",
			"Estonia": "20119",
			"Morocco": "558829",
			"Mali": "1438",
			"Trinidad and Tobago": "6883",
			"Israel": "122",
			"TFYR of Macedonia": "1820",
			"Burkina Faso": "42672",
			"Saudi Arabia": "2605",
			"Rep. of Moldova": "44",
			"Belarus": "723",
			"Bangladesh": "4671",
			"United Rep. of Tanzania": "1001",
			"Finland": "92315",
			"Cyprus": "47447",
			"Zambia": "2682",
			"Mauritius": "299760",
			"Hungary": "40090",
			"Bermuda": "99893297",
			"Luxembourg": "44616",
			"Faeroe Isds": "621",
			"Greenland": "7251",
			"Syria": "1196",
			"China, Hong Kong SAR": "6541",
			"Algeria": "2296",
			"USA": "42862603",
			"Cambodia": "235362",
			"Iran": "8109",
			"Venezuela": "14845",
			"Kuwait": "865",
			"Albania": "51",
			"Malta": "1051",
			"Norway": "227322595",
			"Ecuador": "42979",
			"Sierra Leone": "843",
			"Dominican Rep.": "780",
			"France": "2037",
			"New Caledonia": "430",
			"Philippines": "24087",
			"Seychelles": "957152",
			"Br. Virgin Isds": "219",
			"Italy": "28622",
			"Kyrgyzstan": "430",
			"Czechia": "157013",
			"Rwanda": "5509",
			"Guatemala": "14762",
			"Ethiopia": "36",
			"Georgia": "48",
			"Senegal": "45022",
			"Samoa": "18857",
			"Turkey": "518952",
			"Montenegro": "1802",
			"Sri Lanka": "17357",
			"Rep. of Korea": "156303",
			"Serbia": "129478",
			"Armenia": "4712",
			"New Zealand": "22131348",
			"N. Mariana Isds": "2084",
			"Canada": "687521",
			"Lao People's Dem. Rep.": "192",
			"Ukraine": "48",
			"Myanmar": "254"
		},
		"exports": {
			"Lebanon": "65",
			"Gibraltar": "1024652",
			"South Africa": "282759",
			"Uruguay": "99633",
			"Cabo Verde": "37428",
			"Togo": "51544",
			"Barbados": "32698",
			"Poland": "750412",
			"Qatar": "195",
			"Dem. Rep. of the Congo": "19845",
			"Thailand": "6703966",
			"Argentina": "150",
			"Brazil": "3778004",
			"Germany": "98",
			"Cameroon": "46774",
			"Brunei Darussalam": "158",
			"Ghana": "1342738",
			"Mongolia": "1088",
			"Montserrat": "1874",
			"Panama": "148439",
			"Colombia": "23563",
			"Sudan": "6223",
			"Russian Federation": "1339",
			"Cayman Isds": "14",
			"United Arab Emirates": "1362309",
			"Nicaragua": "432",
			"Azerbaijan": "1112779",
			"Switzerland": "13411678",
			"Georgia": "2304844",
			"Cambodia": "291",
			"Slovakia": "271129",
			"Latvia": "2574897",
			"Japan": "70982213",
			"Guam": "23",
			"Romania": "136",
			"Pakistan": "2107",
			"Belgium": "90570",
			"Curaçao": "1212",
			"Liberia": "102336",
			"Bolivia (Plurinational State of)": "157",
			"Australia": "767693",
			"Madagascar": "8396",
			"Singapore": "19344",
			"Nigeria": "2045878",
			"Benin": "805351",
			"Bahamas": "2947118",
			"San Marino": "57709",
			"Viet Nam": "394594",
			"FS Micronesia": "2948",
			"Indonesia": "23",
			"Cuba": "1547977",
			"Saint Vincent and the Grenadines": "44637",
			"Oman": "7439",
			"Sweden": "13540745",
			"Maldives": "2145",
			"India": "819",
			"Mexico": "5654",
			"Kenya": "19370",
			"Spain": "557132",
			"Bosnia Herzegovina": "106311",
			"Ireland": "3995948",
			"Côte d'Ivoire": "22",
			"French Polynesia": "159",
			"Mauritania": "1894",
			"Lithuania": "4798",
			"United Kingdom": "1793265",
			"Denmark": "115053",
			"Portugal": "5492",
			"Slovenia": "46141",
			"Costa Rica": "14500",
			"Austria": "148420",
			"Bulgaria": "720018",
			"Chile": "19720",
			"Greece": "4108153",
			"Papua New Guinea": "107718",
			"Kazakhstan": "2010921",
			"Gambia": "228147",
			"China, Macao SAR": "16139",
			"Afghanistan": "47",
			"Croatia": "713222",
			"Malaysia": "2437",
			"Peru": "2025",
			"Falkland Isds (Malvinas)": "12380",
			"China": "65284330",
			"Egypt": "1719194",
			"Guinea-Bissau": "15599",
			"Estonia": "1026669",
			"Morocco": "28284",
			"Luxembourg": "113743",
			"Trinidad and Tobago": "32783",
			"Israel": "566953",
			"TFYR of Macedonia": "52773",
			"Saudi Arabia": "1313",
			"Rep. of Moldova": "197263",
			"France": "1905",
			"Bangladesh": "5425",
			"Antigua and Barbuda": "2806",
			"Gabon": "33655",
			"Finland": "3956447",
			"Cyprus": "1003401",
			"Belize": "29",
			"Mauritius": "11595",
			"Hungary": "72485",
			"Bermuda": "157",
			"Faeroe Isds": "9035945",
			"Greenland": "199",
			"Bahrain": "945",
			"China, Hong Kong SAR": "10477485",
			"Algeria": "837",
			"USA": "4566764",
			"Namibia": "68515",
			"Iran": "152288",
			"Venezuela": "2718",
			"Kuwait": "276693",
			"Malta": "361345",
			"Norway": "1447729",
			"Ecuador": "586",
			"Grenada": "20303",
			"Marshall Isds": "349665",
			"Philippines": "1338",
			"Seychelles": "45062",
			"Br. Virgin Isds": "48873",
			"Italy": "10296306",
			"Czechia": "806527",
			"Paraguay": "2146",
			"Belarus": "21568773",
			"Congo": "1347",
			"Senegal": "2643",
			"Aruba": "7445",
			"Turkey": "11059904",
			"Tunisia": "9237",
			"Sri Lanka": "23",
			"Rep. of Korea": "13130135",
			"Serbia": "5653",
			"Netherlands": "1068458",
			"New Zealand": "298764",
			"Canada": "2717",
			"Ukraine": "16721274"
		}
	}
};

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 *  StartAudioContext.js
 *  @author Yotam Mann
 *  @license http://opensource.org/licenses/MIT MIT License
 *  @copyright 2016 Yotam Mann
 */
(function (root, factory) {
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	 } else if (typeof module === "object" && module.exports) {
        module.exports = factory()
	} else {
		root.StartAudioContext = factory()
  }
}(this, function () {

	//TAP LISTENER/////////////////////////////////////////////////////////////

	/**
	 * @class  Listens for non-dragging tap ends on the given element
	 * @param {Element} element
	 * @internal
	 */
	var TapListener = function(element, context){

		this._dragged = false

		this._element = element

		this._bindedMove = this._moved.bind(this)
		this._bindedEnd = this._ended.bind(this, context)

		element.addEventListener("touchstart", this._bindedEnd)
		element.addEventListener("touchmove", this._bindedMove)
		element.addEventListener("touchend", this._bindedEnd)
		element.addEventListener("mouseup", this._bindedEnd)
	}

	/**
	 * drag move event
	 */
	TapListener.prototype._moved = function(e){
		this._dragged = true
	};

	/**
	 * tap ended listener
	 */
	TapListener.prototype._ended = function(context){
		if (!this._dragged){
			startContext(context)
		}
		this._dragged = false
	};

	/**
	 * remove all the bound events
	 */
	TapListener.prototype.dispose = function(){
		this._element.removeEventListener("touchstart", this._bindedEnd)
		this._element.removeEventListener("touchmove", this._bindedMove)
		this._element.removeEventListener("touchend", this._bindedEnd)
		this._element.removeEventListener("mouseup", this._bindedEnd)
		this._bindedMove = null
		this._bindedEnd = null
		this._element = null
	};

	//END TAP LISTENER/////////////////////////////////////////////////////////

	/**
	 * Plays a silent sound and also invoke the "resume" method
	 * @param {AudioContext} context
	 * @private
	 */
	function startContext(context){
		// this accomplishes the iOS specific requirement
		var buffer = context.createBuffer(1, 1, context.sampleRate)
		var source = context.createBufferSource()
		source.buffer = buffer
		source.connect(context.destination)
		source.start(0)

		// resume the audio context
		if (context.resume){
			context.resume()
		}
	}

	/**
	 * Returns true if the audio context is started
	 * @param  {AudioContext}  context
	 * @return {Boolean}
	 * @private
	 */
	function isStarted(context){
		 return context.state === "running"
	}

	/**
	 * Invokes the callback as soon as the AudioContext
	 * is started
	 * @param  {AudioContext}   context
	 * @param  {Function} callback
	 */
	function onStarted(context, callback){

		function checkLoop(){
			if (isStarted(context)){
				callback()
			} else {
				requestAnimationFrame(checkLoop)
				if (context.resume){
					context.resume()
				}
			}
		}

		if (isStarted(context)){
			callback()
		} else {
			checkLoop()
		}
	}

	/**
	 * Add a tap listener to the audio context
	 * @param  {Array|Element|String|jQuery} element
	 * @param {Array} tapListeners
	 */
	function bindTapListener(element, tapListeners, context){
		if (Array.isArray(element) || (NodeList && element instanceof NodeList)){
			for (var i = 0; i < element.length; i++){
				bindTapListener(element[i], tapListeners, context)
			}
		} else if (typeof element === "string"){
			bindTapListener(document.querySelectorAll(element), tapListeners, context)
		} else if (element.jquery && typeof element.toArray === "function"){
			bindTapListener(element.toArray(), tapListeners, context)
		} else if (Element && element instanceof Element){
			//if it's an element, create a TapListener
			var tap = new TapListener(element, context)
			tapListeners.push(tap)
		} 
	}

	/**
	 * @param {AudioContext} context The AudioContext to start.
	 * @param {Array|String|Element|jQuery=} elements For iOS, the list of elements
	 *                                               to bind tap event listeners
	 *                                               which will start the AudioContext. If
	 *                                               no elements are given, it will bind
	 *                                               to the document.body.
	 * @param {Function=} callback The callback to invoke when the AudioContext is started.
	 * @return {Promise} The promise is invoked when the AudioContext
	 *                       is started.
	 */
	function StartAudioContext(context, elements, callback){

		//the promise is invoked when the AudioContext is started
		var promise = new Promise(function(success) {
			onStarted(context, success)
		})

		// The TapListeners bound to the elements
		var tapListeners = []

		// add all the tap listeners
		if (!elements){
			elements = document.body
		}
		bindTapListener(elements, tapListeners, context)

		//dispose all these tap listeners when the context is started
		promise.then(function(){
			for (var i = 0; i < tapListeners.length; i++){
				tapListeners[i].dispose()
			}
			tapListeners = null

			if (callback){
				callback()
			}
		})

		return promise
	}

	return StartAudioContext
}))

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
//     http://underscorejs.org
//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` in the browser, or `exports` on the server.
  var root = this;

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;

  // Create quick reference variables for speed access to core prototypes.
  var
    push             = ArrayProto.push,
    slice            = ArrayProto.slice,
    toString         = ObjProto.toString,
    hasOwnProperty   = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var
    nativeIsArray      = Array.isArray,
    nativeKeys         = Object.keys,
    nativeBind         = FuncProto.bind,
    nativeCreate       = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for the old `require()` API. If we're in
  // the browser, add `_` as a global object.
  if (true) {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.8.3';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      case 2: return function(value, other) {
        return func.call(context, value, other);
      };
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  // A mostly-internal function to generate callbacks that can be applied
  // to each element in a collection, returning the desired result — either
  // identity, an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value)) return _.matcher(value);
    return _.property(value);
  };
  _.iteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, undefinedOnly) {
    return function(obj) {
      var length = arguments.length;
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var property = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = property('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  function createReduce(dir) {
    // Optimized iterator function as using arguments.length
    // in the main function will deoptimize the, see #1991.
    function iterator(obj, iteratee, memo, keys, index, length) {
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    }

    return function(obj, iteratee, memo, context) {
      iteratee = optimizeCb(iteratee, context, 4);
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      // Determine the initial value if none is provided.
      if (arguments.length < 3) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      return iterator(obj, iteratee, memo, keys, index, length);
    };
  }

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var key;
    if (isArrayLike(obj)) {
      key = _.findIndex(obj, predicate, context);
    } else {
      key = _.findKey(obj, predicate, context);
    }
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = function(obj, method) {
    var args = slice.call(arguments, 2);
    var isFunc = _.isFunction(method);
    return _.map(obj, function(value) {
      var func = isFunc ? method : value[method];
      return func == null ? func : func.apply(value, args);
    });
  };

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection, using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  _.shuffle = function(obj) {
    var set = isArrayLike(obj) ? obj : _.values(obj);
    var length = set.length;
    var shuffled = Array(length);
    for (var index = 0, rand; index < length; index++) {
      rand = _.random(0, index);
      if (rand !== index) shuffled[index] = shuffled[rand];
      shuffled[rand] = set[index];
    }
    return shuffled;
  };

  // Sample **n** random values from a collection.
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    return _.shuffle(obj).slice(0, Math.max(0, n));
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, index, list) {
      return {
        value: value,
        index: index,
        criteria: iteratee(value, index, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior) {
    return function(obj, iteratee, context) {
      var result = {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key]++; else result[key] = 1;
  });

  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var pass = [], fail = [];
    _.each(obj, function(value, key, obj) {
      (predicate(value, key, obj) ? pass : fail).push(value);
    });
    return [pass, fail];
  };

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, _.identity);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, startIndex) {
    var output = [], idx = 0;
    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        //flatten current level of array or arguments object
        if (!shallow) value = flatten(value, shallow, strict);
        var j = 0, len = value.length;
        output.length += len;
        while (j < len) {
          output[idx++] = value[j++];
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = function(array) {
    return _.difference(array, slice.call(arguments, 1));
  };

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = function() {
    return _.uniq(flatten(arguments, true, true));
  };

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      for (var j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = function(array) {
    var rest = flatten(arguments, true, true, 1);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = function() {
    return _.unzip(arguments);
  };

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions
  function createPredicateIndexFinder(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  }

  // Returns the first index on an array-like that passes a predicate test
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions
  function createIndexFinder(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
            i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  }

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    step = step || 1;

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = function(func, context) {
    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var args = slice.call(arguments, 2);
    var bound = function() {
      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
    };
    return bound;
  };

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder, allowing any combination of arguments to be pre-filled.
  _.partial = function(func) {
    var boundArgs = slice.call(arguments, 1);
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  };

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = function(obj) {
    var i, length = arguments.length, key;
    if (length <= 1) throw new Error('bindAll must be passed function names');
    for (i = 1; i < length; i++) {
      key = arguments[i];
      obj[key] = _.bind(obj[key], obj);
    }
    return obj;
  };

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = function(func, wait) {
    var args = slice.call(arguments, 2);
    return setTimeout(function(){
      return func.apply(null, args);
    }, wait);
  };

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    return function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function() {
      var last = _.now() - timestamp;

      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        }
      }
    };

    return function() {
      context = this;
      args = arguments;
      timestamp = _.now();
      var callNow = immediate && !timeout;
      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  function collectNonEnumProps(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  }

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (_.has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object
  // In contrast to _.map it returns an object
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys =  _.keys(obj),
          length = keys.length,
          results = {},
          currentKey;
      for (var index = 0; index < length; index++) {
        currentKey = keys[index];
        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
      }
      return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s)
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = function(object, oiteratee, context) {
    var result = {}, obj = object, iteratee, keys;
    if (obj == null) return result;
    if (_.isFunction(oiteratee)) {
      keys = _.allKeys(obj);
      iteratee = optimizeCb(oiteratee, context);
    } else {
      keys = flatten(arguments, false, false, 1);
      iteratee = function(value, key, obj) { return key in obj; };
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  };

   // Return a copy of the object without the blacklisted properties.
  _.omit = function(obj, iteratee, context) {
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
    } else {
      var keys = _.map(flatten(arguments, false, false, 1), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  };

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // A strict comparison is necessary because `null == undefined`.
    if (a == null || b == null) return a === b;
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return _.has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), and in Safari 8 (#1929).
  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
  _.isNaN = function(obj) {
    return _.isNumber(obj) && obj !== +obj;
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  _.property = property;

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    return obj == null ? function(){} : function(key) {
      return obj[key];
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

   // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // If the value of the named `property` is a function then invoke it with the
  // `object` as context; otherwise, return it.
  _.result = function(object, property, fallback) {
    var value = object == null ? void 0 : object[property];
    if (value === void 0) {
      value = fallback;
    }
    return _.isFunction(value) ? value.call(object) : value;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate    : /<%([\s\S]+?)%>/g,
    interpolate : /<%=([\s\S]+?)%>/g,
    escape      : /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'":      "'",
    '\\':     '\\',
    '\r':     'r',
    '\n':     'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escaper, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offest.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    try {
      var render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var result = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return result(this, func.apply(_, args));
      };
    });
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return result(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return result(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return '' + this._wrapped;
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}.call(this));


/***/ }),
/* 151 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 152 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// bundle.min.js